
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
// TODO: remove these vars from top-level scope.
// index.ts
// index.ts
var $d659463d34172173$export$e3a1ee0e9945697f = 63710088e-1;
var $d659463d34172173$export$f929e47acbed771a = {
    centimeters: $d659463d34172173$export$e3a1ee0e9945697f * 100,
    centimetres: $d659463d34172173$export$e3a1ee0e9945697f * 100,
    degrees: 360 / (2 * Math.PI),
    feet: $d659463d34172173$export$e3a1ee0e9945697f * 3.28084,
    inches: $d659463d34172173$export$e3a1ee0e9945697f * 39.37,
    kilometers: $d659463d34172173$export$e3a1ee0e9945697f / 1e3,
    kilometres: $d659463d34172173$export$e3a1ee0e9945697f / 1e3,
    meters: $d659463d34172173$export$e3a1ee0e9945697f,
    metres: $d659463d34172173$export$e3a1ee0e9945697f,
    miles: $d659463d34172173$export$e3a1ee0e9945697f / 1609.344,
    millimeters: $d659463d34172173$export$e3a1ee0e9945697f * 1e3,
    millimetres: $d659463d34172173$export$e3a1ee0e9945697f * 1e3,
    nauticalmiles: $d659463d34172173$export$e3a1ee0e9945697f / 1852,
    radians: 1,
    yards: $d659463d34172173$export$e3a1ee0e9945697f * 1.0936
};
var $d659463d34172173$export$44665ce4f7f4c82b = {
    acres: 247105e-9,
    centimeters: 1e4,
    centimetres: 1e4,
    feet: 10.763910417,
    hectares: 1e-4,
    inches: 1550.003100006,
    kilometers: 1e-6,
    kilometres: 1e-6,
    meters: 1,
    metres: 1,
    miles: 386e-9,
    nauticalmiles: 29155334959812285e-23,
    millimeters: 1e6,
    millimetres: 1e6,
    yards: 1.195990046
};
function $d659463d34172173$export$ced6ed16dfd6a264(geom, properties, options = {}) {
    const feat = {
        type: "Feature"
    };
    if (options.id === 0 || options.id) feat.id = options.id;
    if (options.bbox) feat.bbox = options.bbox;
    feat.properties = properties || {};
    feat.geometry = geom;
    return feat;
}
function $d659463d34172173$export$42a7622cbf932bb(type, coordinates, _options = {}) {
    switch(type){
        case "Point":
            return $d659463d34172173$export$105684a3041cb6f3(coordinates).geometry;
        case "LineString":
            return $d659463d34172173$export$98ec381bb06902c3(coordinates).geometry;
        case "Polygon":
            return $d659463d34172173$export$b7b19aa0ee06c73(coordinates).geometry;
        case "MultiPoint":
            return $d659463d34172173$export$335fc20ed6b6dbb6(coordinates).geometry;
        case "MultiLineString":
            return $d659463d34172173$export$bd735230309493da(coordinates).geometry;
        case "MultiPolygon":
            return $d659463d34172173$export$79bd594da96638d3(coordinates).geometry;
        default:
            throw new Error(type + " is invalid");
    }
}
function $d659463d34172173$export$105684a3041cb6f3(coordinates, properties, options = {}) {
    if (!coordinates) throw new Error("coordinates is required");
    if (!Array.isArray(coordinates)) throw new Error("coordinates must be an Array");
    if (coordinates.length < 2) throw new Error("coordinates must be at least 2 numbers long");
    if (!$d659463d34172173$export$7e4aa119212bc614(coordinates[0]) || !$d659463d34172173$export$7e4aa119212bc614(coordinates[1])) throw new Error("coordinates must contain numbers");
    const geom = {
        type: "Point",
        coordinates: coordinates
    };
    return $d659463d34172173$export$ced6ed16dfd6a264(geom, properties, options);
}
function $d659463d34172173$export$9f048bf86ee2e9d2(coordinates, properties, options = {}) {
    return $d659463d34172173$export$4717c67ac3e5e04d(coordinates.map((coords)=>{
        return $d659463d34172173$export$105684a3041cb6f3(coords, properties);
    }), options);
}
function $d659463d34172173$export$b7b19aa0ee06c73(coordinates, properties, options = {}) {
    for (const ring of coordinates){
        if (ring.length < 4) throw new Error("Each LinearRing of a Polygon must have 4 or more Positions.");
        if (ring[ring.length - 1].length !== ring[0].length) throw new Error("First and last Position are not equivalent.");
        for(let j = 0; j < ring[ring.length - 1].length; j++){
            if (ring[ring.length - 1][j] !== ring[0][j]) throw new Error("First and last Position are not equivalent.");
        }
    }
    const geom = {
        type: "Polygon",
        coordinates: coordinates
    };
    return $d659463d34172173$export$ced6ed16dfd6a264(geom, properties, options);
}
function $d659463d34172173$export$8869eb68a940f9c2(coordinates, properties, options = {}) {
    return $d659463d34172173$export$4717c67ac3e5e04d(coordinates.map((coords)=>{
        return $d659463d34172173$export$b7b19aa0ee06c73(coords, properties);
    }), options);
}
function $d659463d34172173$export$98ec381bb06902c3(coordinates, properties, options = {}) {
    if (coordinates.length < 2) throw new Error("coordinates must be an array of two or more positions");
    const geom = {
        type: "LineString",
        coordinates: coordinates
    };
    return $d659463d34172173$export$ced6ed16dfd6a264(geom, properties, options);
}
function $d659463d34172173$export$74f7306c35db993f(coordinates, properties, options = {}) {
    return $d659463d34172173$export$4717c67ac3e5e04d(coordinates.map((coords)=>{
        return $d659463d34172173$export$98ec381bb06902c3(coords, properties);
    }), options);
}
function $d659463d34172173$export$4717c67ac3e5e04d(features, options = {}) {
    const fc = {
        type: "FeatureCollection"
    };
    if (options.id) fc.id = options.id;
    if (options.bbox) fc.bbox = options.bbox;
    fc.features = features;
    return fc;
}
function $d659463d34172173$export$bd735230309493da(coordinates, properties, options = {}) {
    const geom = {
        type: "MultiLineString",
        coordinates: coordinates
    };
    return $d659463d34172173$export$ced6ed16dfd6a264(geom, properties, options);
}
function $d659463d34172173$export$335fc20ed6b6dbb6(coordinates, properties, options = {}) {
    const geom = {
        type: "MultiPoint",
        coordinates: coordinates
    };
    return $d659463d34172173$export$ced6ed16dfd6a264(geom, properties, options);
}
function $d659463d34172173$export$79bd594da96638d3(coordinates, properties, options = {}) {
    const geom = {
        type: "MultiPolygon",
        coordinates: coordinates
    };
    return $d659463d34172173$export$ced6ed16dfd6a264(geom, properties, options);
}
function $d659463d34172173$export$9242f1e18250422a(geometries, properties, options = {}) {
    const geom = {
        type: "GeometryCollection",
        geometries: geometries
    };
    return $d659463d34172173$export$ced6ed16dfd6a264(geom, properties, options);
}
function $d659463d34172173$export$2077e0241d6afd3c(num, precision = 0) {
    if (precision && !(precision >= 0)) throw new Error("precision must be a positive number");
    const multiplier = Math.pow(10, precision || 0);
    return Math.round(num * multiplier) / multiplier;
}
function $d659463d34172173$export$f234631d6a2eedf8(radians, units = "kilometers") {
    const factor = $d659463d34172173$export$f929e47acbed771a[units];
    if (!factor) throw new Error(units + " units is invalid");
    return radians * factor;
}
function $d659463d34172173$export$a2280f7debae8f10(distance, units = "kilometers") {
    const factor = $d659463d34172173$export$f929e47acbed771a[units];
    if (!factor) throw new Error(units + " units is invalid");
    return distance / factor;
}
function $d659463d34172173$export$c7a138e00a89bd01(distance, units) {
    return $d659463d34172173$export$c41dd2a8460d3196($d659463d34172173$export$a2280f7debae8f10(distance, units));
}
function $d659463d34172173$export$f2077d29c73b33ec(bearing) {
    let angle = bearing % 360;
    if (angle < 0) angle += 360;
    return angle;
}
function $d659463d34172173$export$b4c4eb04cfe49fab(angle) {
    angle = angle % 360;
    if (angle > 180) return angle - 360;
    else if (angle < -180) return angle + 360;
    return angle;
}
function $d659463d34172173$export$c41dd2a8460d3196(radians) {
    const normalisedRadians = radians % (2 * Math.PI);
    return normalisedRadians * 180 / Math.PI;
}
function $d659463d34172173$export$c9fcf1a7df975d78(degrees) {
    const normalisedDegrees = degrees % 360;
    return normalisedDegrees * Math.PI / 180;
}
function $d659463d34172173$export$ea1536a749e80563(length, originalUnit = "kilometers", finalUnit = "kilometers") {
    if (!(length >= 0)) throw new Error("length must be a positive number");
    return $d659463d34172173$export$f234631d6a2eedf8($d659463d34172173$export$a2280f7debae8f10(length, originalUnit), finalUnit);
}
function $d659463d34172173$export$2e65e2c759f7e341(area, originalUnit = "meters", finalUnit = "kilometers") {
    if (!(area >= 0)) throw new Error("area must be a positive number");
    const startFactor = $d659463d34172173$export$44665ce4f7f4c82b[originalUnit];
    if (!startFactor) throw new Error("invalid original units");
    const finalFactor = $d659463d34172173$export$44665ce4f7f4c82b[finalUnit];
    if (!finalFactor) throw new Error("invalid final units");
    return area / startFactor * finalFactor;
}
function $d659463d34172173$export$7e4aa119212bc614(num) {
    return !isNaN(num) && num !== null && !Array.isArray(num);
}
function $d659463d34172173$export$a6cdc56e425d0d0a(input) {
    return input !== null && typeof input === "object" && !Array.isArray(input);
}
function $d659463d34172173$export$28ac7bb8f5309bea(bbox) {
    if (!bbox) throw new Error("bbox is required");
    if (!Array.isArray(bbox)) throw new Error("bbox must be an Array");
    if (bbox.length !== 4 && bbox.length !== 6) throw new Error("bbox must be an Array of 4 or 6 numbers");
    bbox.forEach((num)=>{
        if (!$d659463d34172173$export$7e4aa119212bc614(num)) throw new Error("bbox must only contain numbers");
    });
}
function $d659463d34172173$export$f35f128fd59ea256(id) {
    if (!id) throw new Error("id is required");
    if ([
        "string",
        "number"
    ].indexOf(typeof id) === -1) throw new Error("id must be a number or a string");
}


// index.ts

function $7306fa62fb11a7a6$export$b4663c6e64a770bc(coord) {
    if (!coord) throw new Error("coord is required");
    if (!Array.isArray(coord)) {
        if (coord.type === "Feature" && coord.geometry !== null && coord.geometry.type === "Point") return [
            ...coord.geometry.coordinates
        ];
        if (coord.type === "Point") return [
            ...coord.coordinates
        ];
    }
    if (Array.isArray(coord) && coord.length >= 2 && !Array.isArray(coord[0]) && !Array.isArray(coord[1])) return [
        ...coord
    ];
    throw new Error("coord must be GeoJSON Point or an Array of numbers");
}
function $7306fa62fb11a7a6$export$39e042fd83f1b62e(coords) {
    if (Array.isArray(coords)) return coords;
    if (coords.type === "Feature") {
        if (coords.geometry !== null) return coords.geometry.coordinates;
    } else {
        if (coords.coordinates) return coords.coordinates;
    }
    throw new Error("coords must be GeoJSON Feature, Geometry Object or an Array");
}
function $7306fa62fb11a7a6$export$ab82360ed81b09b9(coordinates) {
    if (coordinates.length > 1 && (0, $d659463d34172173$export$7e4aa119212bc614)(coordinates[0]) && (0, $d659463d34172173$export$7e4aa119212bc614)(coordinates[1])) return true;
    if (Array.isArray(coordinates[0]) && coordinates[0].length) return $7306fa62fb11a7a6$export$ab82360ed81b09b9(coordinates[0]);
    throw new Error("coordinates must only contain numbers");
}
function $7306fa62fb11a7a6$export$329ecc560bd873a7(value, type, name) {
    if (!type || !name) throw new Error("type and name required");
    if (!value || value.type !== type) throw new Error("Invalid input to " + name + ": must be a " + type + ", given " + value.type);
}
function $7306fa62fb11a7a6$export$8b96d9ca92084402(feature, type, name) {
    if (!feature) throw new Error("No feature passed");
    if (!name) throw new Error(".featureOf() requires a name");
    if (!feature || feature.type !== "Feature" || !feature.geometry) throw new Error("Invalid input to " + name + ", Feature with geometry required");
    if (!feature.geometry || feature.geometry.type !== type) throw new Error("Invalid input to " + name + ": must be a " + type + ", given " + feature.geometry.type);
}
function $7306fa62fb11a7a6$export$bcf04c9d01e728b6(featureCollection, type, name) {
    if (!featureCollection) throw new Error("No featureCollection passed");
    if (!name) throw new Error(".collectionOf() requires a name");
    if (!featureCollection || featureCollection.type !== "FeatureCollection") throw new Error("Invalid input to " + name + ", FeatureCollection required");
    for (const feature of featureCollection.features){
        if (!feature || feature.type !== "Feature" || !feature.geometry) throw new Error("Invalid input to " + name + ", Feature with geometry required");
        if (!feature.geometry || feature.geometry.type !== type) throw new Error("Invalid input to " + name + ": must be a " + type + ", given " + feature.geometry.type);
    }
}
function $7306fa62fb11a7a6$export$b8f320eb9549c8fd(geojson) {
    if (geojson.type === "Feature") return geojson.geometry;
    return geojson;
}
function $7306fa62fb11a7a6$export$e2b5c5db9e2009fd(geojson, _name) {
    if (geojson.type === "FeatureCollection") return "FeatureCollection";
    if (geojson.type === "GeometryCollection") return "GeometryCollection";
    if (geojson.type === "Feature" && geojson.geometry !== null) return geojson.geometry.type;
    return geojson.type;
}


function $a2188ae690a3be48$export$ff318d6e318fce97(start, end, options = {}) {
    if (options.final === true) return $a2188ae690a3be48$var$calculateFinalBearing(start, end);
    const coordinates1 = (0, $7306fa62fb11a7a6$export$b4663c6e64a770bc)(start);
    const coordinates2 = (0, $7306fa62fb11a7a6$export$b4663c6e64a770bc)(end);
    const lon1 = (0, $d659463d34172173$export$c9fcf1a7df975d78)(coordinates1[0]);
    const lon2 = (0, $d659463d34172173$export$c9fcf1a7df975d78)(coordinates2[0]);
    const lat1 = (0, $d659463d34172173$export$c9fcf1a7df975d78)(coordinates1[1]);
    const lat2 = (0, $d659463d34172173$export$c9fcf1a7df975d78)(coordinates2[1]);
    const a = Math.sin(lon2 - lon1) * Math.cos(lat2);
    const b = Math.cos(lat1) * Math.sin(lat2) - Math.sin(lat1) * Math.cos(lat2) * Math.cos(lon2 - lon1);
    return (0, $d659463d34172173$export$c41dd2a8460d3196)(Math.atan2(a, b));
}
function $a2188ae690a3be48$var$calculateFinalBearing(start, end) {
    let bear = $a2188ae690a3be48$export$ff318d6e318fce97(end, start);
    bear = (bear + 180) % 360;
    return bear;
}
var $a2188ae690a3be48$export$2e2bcd8739ae039 = $a2188ae690a3be48$export$ff318d6e318fce97;



let $cade000a6c8a1b2e$var$streetview;
let $cade000a6c8a1b2e$var$panorama;
async function $cade000a6c8a1b2e$export$6ff3b2c795cc1f8f() {
    $cade000a6c8a1b2e$var$panorama = new google.maps.StreetViewPanorama(document.getElementById("streetview"));
    $cade000a6c8a1b2e$var$streetview = new google.maps.StreetViewService();
}
function $cade000a6c8a1b2e$export$c8e0d6368aa03249([lng, lat]) {
    // Hide the "about" panel after user clicks on the map.
    const aboutEl = document.getElementById("about");
    if (aboutEl) aboutEl.style.display = "none";
    const streetviewEl = document.getElementById("streetview");
    if (streetviewEl) streetviewEl.style.display = "block";
    $cade000a6c8a1b2e$var$streetview.getPanorama({
        location: {
            lng: parseFloat(lng),
            lat: parseFloat(lat)
        },
        sources: [
            google.maps.StreetViewSource.OUTDOOR
        ],
        radius: 50
    }, (panoData)=>{
        const lat1 = panoData?.location?.latLng?.lat() || 0;
        const lng1 = panoData?.location?.latLng?.lng() || 0;
        const lat2 = lat;
        const lng2 = lng;
        const heading = (0, $a2188ae690a3be48$export$ff318d6e318fce97)((0, $d659463d34172173$export$105684a3041cb6f3)([
            lng1,
            lat1
        ]), (0, $d659463d34172173$export$105684a3041cb6f3)([
            lng2,
            lat2
        ]));
        console.log("heading: ", heading);
        panoData?.location?.pano && $cade000a6c8a1b2e$var$panorama.setPano(panoData.location.pano);
        $cade000a6c8a1b2e$var$panorama.setPov({
            heading: heading,
            pitch: 0
        });
    });
}


var $0a06c4d6833722ed$exports = {};
/**
 * MapLibre GL JS
 * @license 3-Clause BSD. Full text of license: https://github.com/maplibre/maplibre-gl-js/blob/v5.24.0/LICENSE.txt
 */ (function(global, factory) {
    $0a06c4d6833722ed$exports = factory();
})($0a06c4d6833722ed$exports, function() {
    'use strict';
    /* eslint-disable */ var maplibregl = {};
    var modules = {};
    function define(moduleName, _dependencies, moduleFactory) {
        modules[moduleName] = moduleFactory;
        // to get the list of modules see generated dist/maplibre-gl-dev.js file (look for `define(` calls)
        if (moduleName !== 'index') return;
        // we assume that when an index module is initializing then other modules are loaded already
        var workerBundleString = 'var sharedModule = {}; (' + modules.shared + ')(sharedModule); (' + modules.worker + ')(sharedModule);';
        var sharedModule = {};
        // the order of arguments of a module factory depends on rollup (it decides who is whose dependency)
        // to check the correct order, see dist/maplibre-gl-dev.js file (look for `define(` calls)
        // we assume that for our 3 chunks it will generate 3 modules and their order is predefined like the following
        modules.shared(sharedModule);
        modules.index(maplibregl, sharedModule);
        if (typeof window !== 'undefined') maplibregl.setWorkerUrl(window.URL.createObjectURL(new Blob([
            workerBundleString
        ], {
            type: 'text/javascript'
        })));
        return maplibregl;
    }
    define("shared", [
        "exports"
    ], function(t) {
        "use strict";
        function e1(t, e1, n, r) {
            return new (n || (n = Promise))(function(i, s) {
                function o(t) {
                    try {
                        l(r.next(t));
                    } catch (t) {
                        s(t);
                    }
                }
                function a(t) {
                    try {
                        l(r.throw(t));
                    } catch (t) {
                        s(t);
                    }
                }
                function l(t) {
                    var e1;
                    t.done ? i(t.value) : (e1 = t.value, e1 instanceof n ? e1 : new n(function(t) {
                        t(e1);
                    })).then(o, a);
                }
                l((r = r.apply(t, e1 || [])).next());
            });
        }
        function n(t, e1) {
            this.x = t, this.y = e1;
        }
        function r(t) {
            return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
        }
        var i, s;
        "function" == typeof SuppressedError && SuppressedError, n.prototype = {
            clone () {
                return new n(this.x, this.y);
            },
            add (t) {
                return this.clone()._add(t);
            },
            sub (t) {
                return this.clone()._sub(t);
            },
            multByPoint (t) {
                return this.clone()._multByPoint(t);
            },
            divByPoint (t) {
                return this.clone()._divByPoint(t);
            },
            mult (t) {
                return this.clone()._mult(t);
            },
            div (t) {
                return this.clone()._div(t);
            },
            rotate (t) {
                return this.clone()._rotate(t);
            },
            rotateAround (t, e1) {
                return this.clone()._rotateAround(t, e1);
            },
            matMult (t) {
                return this.clone()._matMult(t);
            },
            unit () {
                return this.clone()._unit();
            },
            perp () {
                return this.clone()._perp();
            },
            round () {
                return this.clone()._round();
            },
            mag () {
                return Math.sqrt(this.x * this.x + this.y * this.y);
            },
            equals (t) {
                return this.x === t.x && this.y === t.y;
            },
            dist (t) {
                return Math.sqrt(this.distSqr(t));
            },
            distSqr (t) {
                const e1 = t.x - this.x, n = t.y - this.y;
                return e1 * e1 + n * n;
            },
            angle () {
                return Math.atan2(this.y, this.x);
            },
            angleTo (t) {
                return Math.atan2(this.y - t.y, this.x - t.x);
            },
            angleWith (t) {
                return this.angleWithSep(t.x, t.y);
            },
            angleWithSep (t, e1) {
                return Math.atan2(this.x * e1 - this.y * t, this.x * t + this.y * e1);
            },
            _matMult (t) {
                const e1 = t[2] * this.x + t[3] * this.y;
                return this.x = t[0] * this.x + t[1] * this.y, this.y = e1, this;
            },
            _add (t) {
                return this.x += t.x, this.y += t.y, this;
            },
            _sub (t) {
                return this.x -= t.x, this.y -= t.y, this;
            },
            _mult (t) {
                return this.x *= t, this.y *= t, this;
            },
            _div (t) {
                return this.x /= t, this.y /= t, this;
            },
            _multByPoint (t) {
                return this.x *= t.x, this.y *= t.y, this;
            },
            _divByPoint (t) {
                return this.x /= t.x, this.y /= t.y, this;
            },
            _unit () {
                return this._div(this.mag()), this;
            },
            _perp () {
                const t = this.y;
                return this.y = this.x, this.x = -t, this;
            },
            _rotate (t) {
                const e1 = Math.cos(t), n = Math.sin(t), r = n * this.x + e1 * this.y;
                return this.x = e1 * this.x - n * this.y, this.y = r, this;
            },
            _rotateAround (t, e1) {
                const n = Math.cos(t), r = Math.sin(t), i = e1.y + r * (this.x - e1.x) + n * (this.y - e1.y);
                return this.x = e1.x + n * (this.x - e1.x) - r * (this.y - e1.y), this.y = i, this;
            },
            _round () {
                return this.x = Math.round(this.x), this.y = Math.round(this.y), this;
            },
            constructor: n
        }, n.convert = function(t) {
            if (t instanceof n) return t;
            if (Array.isArray(t)) return new n(+t[0], +t[1]);
            if (void 0 !== t.x && void 0 !== t.y) return new n(+t.x, +t.y);
            throw new Error("Expected [x, y] or {x, y} point format");
        };
        var o = function() {
            if (s) return i;
            function t(t, e1, n, r) {
                this.cx = 3 * t, this.bx = 3 * (n - t) - this.cx, this.ax = 1 - this.cx - this.bx, this.cy = 3 * e1, this.by = 3 * (r - e1) - this.cy, this.ay = 1 - this.cy - this.by, this.p1x = t, this.p1y = e1, this.p2x = n, this.p2y = r;
            }
            return s = 1, i = t, t.prototype = {
                sampleCurveX: function(t) {
                    return ((this.ax * t + this.bx) * t + this.cx) * t;
                },
                sampleCurveY: function(t) {
                    return ((this.ay * t + this.by) * t + this.cy) * t;
                },
                sampleCurveDerivativeX: function(t) {
                    return (3 * this.ax * t + 2 * this.bx) * t + this.cx;
                },
                solveCurveX: function(t, e1) {
                    if (void 0 === e1 && (e1 = 1e-6), t < 0) return 0;
                    if (t > 1) return 1;
                    for(var n = t, r = 0; r < 8; r++){
                        var i = this.sampleCurveX(n) - t;
                        if (Math.abs(i) < e1) return n;
                        var s = this.sampleCurveDerivativeX(n);
                        if (Math.abs(s) < 1e-6) break;
                        n -= i / s;
                    }
                    var o = 0, a = 1;
                    for(n = t, r = 0; r < 20 && (i = this.sampleCurveX(n), !(Math.abs(i - t) < e1)); r++)t > i ? o = n : a = n, n = .5 * (a - o) + o;
                    return n;
                },
                solve: function(t, e1) {
                    return this.sampleCurveY(this.solveCurveX(t, e1));
                }
            }, i;
        }(), a = r(o);
        let l, u;
        function c() {
            return null != l || (l = "undefined" != typeof OffscreenCanvas && new OffscreenCanvas(1, 1).getContext("2d") && "function" == typeof createImageBitmap), l;
        }
        function h() {
            if (null == u && (u = !1, c())) {
                const t = 5, e1 = new OffscreenCanvas(t, t).getContext("2d", {
                    willReadFrequently: !0
                });
                if (e1) {
                    for(let n = 0; n < t * t; n++){
                        const r = 4 * n;
                        e1.fillStyle = `rgb(${r},${r + 1},${r + 2})`, e1.fillRect(n % t, Math.floor(n / t), 1, 1);
                    }
                    const n = e1.getImageData(0, 0, t, t).data;
                    for(let e1 = 0; e1 < t * t * 4; e1++)if (e1 % 4 != 3 && n[e1] !== e1) {
                        u = !0;
                        break;
                    }
                }
            }
            return u || !1;
        }
        var p = 1e-6, f = "undefined" != typeof Float32Array ? Float32Array : Array;
        function d() {
            var t = new f(9);
            return f != Float32Array && (t[1] = 0, t[2] = 0, t[3] = 0, t[5] = 0, t[6] = 0, t[7] = 0), t[0] = 1, t[4] = 1, t[8] = 1, t;
        }
        function y(t) {
            return t[0] = 1, t[1] = 0, t[2] = 0, t[3] = 0, t[4] = 0, t[5] = 1, t[6] = 0, t[7] = 0, t[8] = 0, t[9] = 0, t[10] = 1, t[11] = 0, t[12] = 0, t[13] = 0, t[14] = 0, t[15] = 1, t;
        }
        function m() {
            var t = new f(3);
            return f != Float32Array && (t[0] = 0, t[1] = 0, t[2] = 0), t;
        }
        function g(t) {
            var e1 = t[0], n = t[1], r = t[2];
            return Math.sqrt(e1 * e1 + n * n + r * r);
        }
        function x(t, e1, n) {
            var r = new f(3);
            return r[0] = t, r[1] = e1, r[2] = n, r;
        }
        function v(t, e1, n) {
            return t[0] = e1[0] + n[0], t[1] = e1[1] + n[1], t[2] = e1[2] + n[2], t;
        }
        function b(t, e1, n) {
            return t[0] = e1[0] * n, t[1] = e1[1] * n, t[2] = e1[2] * n, t;
        }
        function w(t, e1, n) {
            var r = e1[0], i = e1[1], s = e1[2], o = n[0], a = n[1], l = n[2];
            return t[0] = i * l - s * a, t[1] = s * o - r * l, t[2] = r * a - i * o, t;
        }
        var _, S = g;
        function A(t, e1, n) {
            var r = e1[0], i = e1[1], s = e1[2], o = e1[3];
            return t[0] = n[0] * r + n[4] * i + n[8] * s + n[12] * o, t[1] = n[1] * r + n[5] * i + n[9] * s + n[13] * o, t[2] = n[2] * r + n[6] * i + n[10] * s + n[14] * o, t[3] = n[3] * r + n[7] * i + n[11] * s + n[15] * o, t;
        }
        function M() {
            var t = new f(4);
            return f != Float32Array && (t[0] = 0, t[1] = 0, t[2] = 0), t[3] = 1, t;
        }
        function k(t, e1, n, r) {
            var i = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : "zyx", s = Math.PI / 360;
            e1 *= s, r *= s, n *= s;
            var o = Math.sin(e1), a = Math.cos(e1), l = Math.sin(n), u = Math.cos(n), c = Math.sin(r), h = Math.cos(r);
            switch(i){
                case "xyz":
                    t[0] = o * u * h + a * l * c, t[1] = a * l * h - o * u * c, t[2] = a * u * c + o * l * h, t[3] = a * u * h - o * l * c;
                    break;
                case "xzy":
                    t[0] = o * u * h - a * l * c, t[1] = a * l * h - o * u * c, t[2] = a * u * c + o * l * h, t[3] = a * u * h + o * l * c;
                    break;
                case "yxz":
                    t[0] = o * u * h + a * l * c, t[1] = a * l * h - o * u * c, t[2] = a * u * c - o * l * h, t[3] = a * u * h + o * l * c;
                    break;
                case "yzx":
                    t[0] = o * u * h + a * l * c, t[1] = a * l * h + o * u * c, t[2] = a * u * c - o * l * h, t[3] = a * u * h - o * l * c;
                    break;
                case "zxy":
                    t[0] = o * u * h - a * l * c, t[1] = a * l * h + o * u * c, t[2] = a * u * c + o * l * h, t[3] = a * u * h - o * l * c;
                    break;
                case "zyx":
                    t[0] = o * u * h - a * l * c, t[1] = a * l * h + o * u * c, t[2] = a * u * c - o * l * h, t[3] = a * u * h + o * l * c;
                    break;
                default:
                    throw new Error("Unknown angle order " + i);
            }
            return t;
        }
        function I() {
            var t = new f(2);
            return f != Float32Array && (t[0] = 0, t[1] = 0), t;
        }
        function E(t, e1) {
            var n = new f(2);
            return n[0] = t, n[1] = e1, n;
        }
        m(), _ = new f(4), f != Float32Array && (_[0] = 0, _[1] = 0, _[2] = 0, _[3] = 0), m(), x(1, 0, 0), x(0, 1, 0), M(), M(), d(), I();
        const T = 8192;
        function F(t, e1, n) {
            return e1 * (T / (t.tileSize * Math.pow(2, n - t.tileID.overscaledZ)));
        }
        function P(t) {
            return t instanceof Error ? t : new Error("string" == typeof t ? t : String(t));
        }
        function D(t, e1) {
            return (t % e1 + e1) % e1;
        }
        function z(t, e1, n) {
            return t * (1 - n) + e1 * n;
        }
        function B(t) {
            if (t <= 0) return 0;
            if (t >= 1) return 1;
            const e1 = t * t, n = e1 * t;
            return 4 * (t < .5 ? n : 3 * (t - e1) + n - .75);
        }
        function C(t, e1, n, r) {
            const i = new a(t, e1, n, r);
            return (t)=>i.solve(t);
        }
        const V = C(.25, .1, .25, 1);
        function L(t, e1, n) {
            return Math.min(n, Math.max(e1, t));
        }
        function O(t, e1, n) {
            const r = n - e1, i = ((t - e1) % r + r) % r + e1;
            return i === e1 ? n : i;
        }
        function $(t, ...e1) {
            for (const n of e1)for(const e1 in n)t[e1] = n[e1];
            return t;
        }
        let R = 1;
        function N(t, e1, n) {
            const r = {};
            for(const n in t)r[n] = e1.call(this, t[n], n, t);
            return r;
        }
        function U(t, e1, n) {
            const r = {};
            for(const n in t)e1.call(this, t[n], n, t) && (r[n] = t[n]);
            return r;
        }
        function j(t) {
            return Array.isArray(t) ? t.map(j) : "object" == typeof t && t ? N(t, j) : t;
        }
        const q = {};
        function G(t) {
            q[t] || ("undefined" != typeof console && console.warn(t), q[t] = !0);
        }
        function X(t, e1, n) {
            return (n.y - t.y) * (e1.x - t.x) > (e1.y - t.y) * (n.x - t.x);
        }
        function Y(t) {
            return "undefined" != typeof WorkerGlobalScope && void 0 !== t && t instanceof WorkerGlobalScope;
        }
        let Z = null;
        function H(t) {
            return "undefined" != typeof ImageBitmap && t instanceof ImageBitmap;
        }
        const W = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAAC0lEQVQYV2NgAAIAAAUAAarVyFEAAAAASUVORK5CYII=";
        function K(t, n, r, i, s) {
            return e1(this, void 0, void 0, function*() {
                if ("undefined" == typeof VideoFrame) throw new Error("VideoFrame not supported");
                const e1 = new VideoFrame(t, {
                    timestamp: 0
                });
                try {
                    const o = null == e1 ? void 0 : e1.format;
                    if (!o || !o.startsWith("BGR") && !o.startsWith("RGB")) throw new Error(`Unrecognized format ${o}`);
                    const a = o.startsWith("BGR"), l = new Uint8ClampedArray(i * s * 4);
                    if (yield e1.copyTo(l, function(t, e1, n, r, i) {
                        const s = 4 * Math.max(-e1, 0), o = (Math.max(0, n) - n) * r * 4 + s, a = 4 * r, l = Math.max(0, e1), u = Math.max(0, n);
                        return {
                            rect: {
                                x: l,
                                y: u,
                                width: Math.min(t.width, e1 + r) - l,
                                height: Math.min(t.height, n + i) - u
                            },
                            layout: [
                                {
                                    offset: o,
                                    stride: a
                                }
                            ]
                        };
                    }(t, n, r, i, s)), a) for(let t = 0; t < l.length; t += 4){
                        const e1 = l[t];
                        l[t] = l[t + 2], l[t + 2] = e1;
                    }
                    return l;
                } finally{
                    e1.close();
                }
            });
        }
        let J, Q;
        function tt(t, e1, n, r) {
            return t.addEventListener(e1, n, r), {
                unsubscribe: ()=>{
                    t.removeEventListener(e1, n, r);
                }
            };
        }
        function et(t) {
            return t * Math.PI / 180;
        }
        function nt(t) {
            return t / Math.PI * 180;
        }
        const rt = {
            touchstart: !0,
            touchmove: !0,
            touchmoveWindow: !0,
            touchend: !0,
            touchcancel: !0
        }, it = {
            dblclick: !0,
            click: !0,
            mouseover: !0,
            mouseout: !0,
            mousedown: !0,
            mousemove: !0,
            mousemoveWindow: !0,
            mouseup: !0,
            mouseupWindow: !0,
            contextmenu: !0,
            wheel: !0
        }, st = "AbortError";
        class ot extends Error {
            constructor(t = st){
                super(t instanceof Error ? t.message : t), this.name = st, t instanceof Error && t.stack && (this.stack = t.stack);
            }
        }
        function at(t) {
            return t instanceof Error && t.name === st;
        }
        function lt(t) {
            if (t.aborted) throw new ot(t.reason);
        }
        const ut = {
            MAX_PARALLEL_IMAGE_REQUESTS: 16,
            MAX_PARALLEL_IMAGE_REQUESTS_PER_FRAME: 8,
            MAX_TILE_CACHE_ZOOM_LEVELS: 5,
            REGISTERED_PROTOCOLS: {},
            WORKER_URL: ""
        };
        function ct(t) {
            return ut.REGISTERED_PROTOCOLS[t.substring(0, t.indexOf("://"))];
        }
        const ht = "global-dispatcher";
        class pt extends Error {
            constructor(t, e1, n, r){
                super(`AJAXError: ${e1} (${t}): ${n}`), this.status = t, this.statusText = e1, this.url = n, this.body = r;
            }
        }
        const ft = ()=>{
            var t;
            return Y(self) ? null === (t = self.worker) || void 0 === t ? void 0 : t.referrer : ("blob:" === window.location.protocol ? window.parent : window).location.href;
        }, dt = function(t, n) {
            return e1(this, void 0, void 0, function*() {
                var r, i;
                if (t.url.includes("://") && !/^https?:|^file:/.test(t.url)) {
                    const e1 = ct(t.url);
                    if (e1) {
                        const r = yield e1(t, n);
                        return r.data || "arrayBuffer" !== t.type ? r : $(r, {
                            data: new ArrayBuffer(0)
                        });
                    }
                    if (Y(self) && (null === (r = self.worker) || void 0 === r ? void 0 : r.actor)) return self.worker.actor.sendAsync({
                        type: "GR",
                        data: t,
                        targetMapId: ht
                    }, n);
                }
                if (!((t)=>{
                    var e1;
                    return t.startsWith("file:") || (null === (e1 = ft()) || void 0 === e1 ? void 0 : e1.startsWith("file:")) && !/^\w+:/.test(t);
                })(t.url)) {
                    if (fetch && Request && AbortController && Object.hasOwn(Request.prototype, "signal")) return function(t, n) {
                        return e1(this, void 0, void 0, function*() {
                            const e1 = new Request(t.url, {
                                method: t.method || "GET",
                                body: t.body,
                                credentials: t.credentials,
                                headers: t.headers,
                                cache: t.cache,
                                referrer: ft(),
                                referrerPolicy: t.referrerPolicy,
                                signal: n.signal
                            });
                            let r, i;
                            "json" !== t.type || e1.headers.has("Accept") || e1.headers.set("Accept", "application/json");
                            try {
                                r = yield fetch(e1);
                            } catch (e1) {
                                if (at(e1)) throw e1;
                                throw new pt(0, P(e1).message, t.url, new Blob);
                            }
                            if (!r.ok) {
                                const e1 = yield r.blob();
                                throw new pt(r.status, r.statusText, t.url, e1);
                            }
                            i = "arrayBuffer" === t.type || "image" === t.type ? r.arrayBuffer() : "json" === t.type ? r.json() : r.text();
                            const s = yield i;
                            return lt(n.signal), {
                                data: s,
                                cacheControl: r.headers.get("Cache-Control"),
                                expires: r.headers.get("Expires"),
                                etag: r.headers.get("ETag")
                            };
                        });
                    }(t, n);
                    if (Y(self) && (null === (i = self.worker) || void 0 === i ? void 0 : i.actor)) return self.worker.actor.sendAsync({
                        type: "GR",
                        data: t,
                        mustQueue: !0,
                        targetMapId: ht
                    }, n);
                }
                return function(t, e1) {
                    return new Promise((n, r)=>{
                        var i;
                        const s = new XMLHttpRequest;
                        s.open(t.method || "GET", t.url, !0), "arrayBuffer" !== t.type && "image" !== t.type || (s.responseType = "arraybuffer");
                        for(const e1 in t.headers)s.setRequestHeader(e1, t.headers[e1]);
                        "json" === t.type && (s.responseType = "text", (null === (i = t.headers) || void 0 === i ? void 0 : i.Accept) || s.setRequestHeader("Accept", "application/json")), s.withCredentials = "include" === t.credentials, s.onerror = ()=>{
                            r(new Error(s.statusText));
                        }, s.onload = ()=>{
                            if (!e1.signal.aborted) {
                                if ((s.status >= 200 && s.status < 300 || 0 === s.status) && null !== s.response) {
                                    let e1 = s.response;
                                    if ("json" === t.type) try {
                                        e1 = JSON.parse(s.response);
                                    } catch (t) {
                                        return void r(t);
                                    }
                                    n({
                                        data: e1,
                                        cacheControl: s.getResponseHeader("Cache-Control"),
                                        expires: s.getResponseHeader("Expires"),
                                        etag: s.getResponseHeader("ETag")
                                    });
                                } else {
                                    const e1 = new Blob([
                                        s.response
                                    ], {
                                        type: s.getResponseHeader("Content-Type")
                                    });
                                    r(new pt(s.status, s.statusText, t.url, e1));
                                }
                            }
                        }, e1.signal.addEventListener("abort", ()=>{
                            s.abort(), r(new ot(e1.signal.reason));
                        }), s.send(t.body);
                    });
                }(t, n);
            });
        };
        function yt(t) {
            if (!t || t.indexOf("://") <= 0 || t.startsWith("data:image/") || t.startsWith("blob:")) return !0;
            const e1 = new URL(t), n = window.location;
            return e1.protocol === n.protocol && e1.host === n.host;
        }
        function mt(t, e1, n) {
            var r;
            (null === (r = n[t]) || void 0 === r ? void 0 : r.includes(e1)) || (n[t] || (n[t] = []), n[t].push(e1));
        }
        function gt(t, e1, n) {
            if (null == n ? void 0 : n[t]) {
                const r = n[t].indexOf(e1);
                -1 !== r && n[t].splice(r, 1);
            }
        }
        class xt {
            constructor(t, e1 = {}){
                $(this, e1), this.type = t;
            }
        }
        class vt extends xt {
            constructor(t, e1 = {}){
                super("error", $({
                    error: t
                }, e1));
            }
        }
        class bt {
            on(t, e1) {
                return this._listeners || (this._listeners = {}), mt(t, e1, this._listeners), {
                    unsubscribe: ()=>{
                        this.off(t, e1);
                    }
                };
            }
            off(t, e1) {
                return gt(t, e1, this._listeners), gt(t, e1, this._oneTimeListeners), this;
            }
            once(t, e1) {
                return e1 ? (this._oneTimeListeners || (this._oneTimeListeners = {}), mt(t, e1, this._oneTimeListeners), this) : new Promise((e1)=>this.once(t, e1));
            }
            fire(t, e1) {
                var n, r;
                "string" == typeof t && (t = new xt(t, e1 || {}));
                const i = t.type;
                if (this.listens(i)) {
                    t.target = this;
                    const e1 = (null === (n = this._listeners) || void 0 === n ? void 0 : n[i]) ? this._listeners[i].slice() : [];
                    for (const n of e1)n.call(this, t);
                    const s = (null === (r = this._oneTimeListeners) || void 0 === r ? void 0 : r[i]) ? this._oneTimeListeners[i].slice() : [];
                    for (const e1 of s)gt(i, e1, this._oneTimeListeners), e1.call(this, t);
                    const o = this._eventedParent;
                    o && ($(t, "function" == typeof this._eventedParentData ? this._eventedParentData() : this._eventedParentData), o.fire(t));
                } else t instanceof vt && console.error(t.error);
                return this;
            }
            listens(t) {
                var e1, n, r, i, s;
                return (null === (n = null === (e1 = this._listeners) || void 0 === e1 ? void 0 : e1[t]) || void 0 === n ? void 0 : n.length) > 0 || (null === (i = null === (r = this._oneTimeListeners) || void 0 === r ? void 0 : r[t]) || void 0 === i ? void 0 : i.length) > 0 || (null === (s = this._eventedParent) || void 0 === s ? void 0 : s.listens(t));
            }
            setEventedParent(t, e1) {
                return this._eventedParent = t, this._eventedParentData = e1, this;
            }
        }
        var wt = {
            $version: 8,
            $root: {
                version: {
                    required: !0,
                    type: "enum",
                    values: [
                        8
                    ]
                },
                name: {
                    type: "string"
                },
                metadata: {
                    type: "*"
                },
                center: {
                    type: "array",
                    value: "number",
                    length: 2
                },
                centerAltitude: {
                    type: "number"
                },
                zoom: {
                    type: "number"
                },
                bearing: {
                    type: "number",
                    default: 0,
                    period: 360,
                    units: "degrees"
                },
                pitch: {
                    type: "number",
                    default: 0,
                    units: "degrees"
                },
                roll: {
                    type: "number",
                    default: 0,
                    units: "degrees"
                },
                state: {
                    type: "state",
                    default: {}
                },
                light: {
                    type: "light"
                },
                sky: {
                    type: "sky"
                },
                projection: {
                    type: "projection"
                },
                terrain: {
                    type: "terrain"
                },
                sources: {
                    required: !0,
                    type: "sources"
                },
                sprite: {
                    type: "sprite"
                },
                glyphs: {
                    type: "string"
                },
                "font-faces": {
                    type: "fontFaces"
                },
                transition: {
                    type: "transition"
                },
                layers: {
                    required: !0,
                    type: "array",
                    value: "layer"
                }
            },
            sources: {
                "*": {
                    type: "source"
                }
            },
            source: [
                "source_vector",
                "source_raster",
                "source_raster_dem",
                "source_geojson",
                "source_video",
                "source_image"
            ],
            source_vector: {
                type: {
                    required: !0,
                    type: "enum",
                    values: {
                        vector: {}
                    }
                },
                url: {
                    type: "string"
                },
                tiles: {
                    type: "array",
                    value: "string"
                },
                bounds: {
                    type: "array",
                    value: "number",
                    length: 4,
                    default: [
                        -180,
                        -85.051129,
                        180,
                        85.051129
                    ]
                },
                scheme: {
                    type: "enum",
                    values: {
                        xyz: {},
                        tms: {}
                    },
                    default: "xyz"
                },
                minzoom: {
                    type: "number",
                    default: 0
                },
                maxzoom: {
                    type: "number",
                    default: 22
                },
                attribution: {
                    type: "string"
                },
                promoteId: {
                    type: "promoteId"
                },
                volatile: {
                    type: "boolean",
                    default: !1
                },
                encoding: {
                    type: "enum",
                    values: {
                        mvt: {},
                        mlt: {}
                    },
                    default: "mvt"
                },
                "*": {
                    type: "*"
                }
            },
            source_raster: {
                type: {
                    required: !0,
                    type: "enum",
                    values: {
                        raster: {}
                    }
                },
                url: {
                    type: "string"
                },
                tiles: {
                    type: "array",
                    value: "string"
                },
                bounds: {
                    type: "array",
                    value: "number",
                    length: 4,
                    default: [
                        -180,
                        -85.051129,
                        180,
                        85.051129
                    ]
                },
                minzoom: {
                    type: "number",
                    default: 0
                },
                maxzoom: {
                    type: "number",
                    default: 22
                },
                tileSize: {
                    type: "number",
                    default: 512,
                    units: "pixels"
                },
                scheme: {
                    type: "enum",
                    values: {
                        xyz: {},
                        tms: {}
                    },
                    default: "xyz"
                },
                attribution: {
                    type: "string"
                },
                volatile: {
                    type: "boolean",
                    default: !1
                },
                "*": {
                    type: "*"
                }
            },
            source_raster_dem: {
                type: {
                    required: !0,
                    type: "enum",
                    values: {
                        "raster-dem": {}
                    }
                },
                url: {
                    type: "string"
                },
                tiles: {
                    type: "array",
                    value: "string"
                },
                bounds: {
                    type: "array",
                    value: "number",
                    length: 4,
                    default: [
                        -180,
                        -85.051129,
                        180,
                        85.051129
                    ]
                },
                minzoom: {
                    type: "number",
                    default: 0
                },
                maxzoom: {
                    type: "number",
                    default: 22
                },
                tileSize: {
                    type: "number",
                    default: 512,
                    units: "pixels"
                },
                attribution: {
                    type: "string"
                },
                encoding: {
                    type: "enum",
                    values: {
                        terrarium: {},
                        mapbox: {},
                        custom: {}
                    },
                    default: "mapbox"
                },
                redFactor: {
                    type: "number",
                    default: 1
                },
                blueFactor: {
                    type: "number",
                    default: 1
                },
                greenFactor: {
                    type: "number",
                    default: 1
                },
                baseShift: {
                    type: "number",
                    default: 0
                },
                volatile: {
                    type: "boolean",
                    default: !1
                },
                "*": {
                    type: "*"
                }
            },
            source_geojson: {
                type: {
                    required: !0,
                    type: "enum",
                    values: {
                        geojson: {}
                    }
                },
                data: {
                    required: !0,
                    type: "*"
                },
                maxzoom: {
                    type: "number",
                    default: 18
                },
                attribution: {
                    type: "string"
                },
                buffer: {
                    type: "number",
                    default: 128,
                    maximum: 512,
                    minimum: 0
                },
                filter: {
                    type: "filter"
                },
                tolerance: {
                    type: "number",
                    default: .375
                },
                cluster: {
                    type: "boolean",
                    default: !1
                },
                clusterRadius: {
                    type: "number",
                    default: 50,
                    minimum: 0
                },
                clusterMaxZoom: {
                    type: "number"
                },
                clusterMinPoints: {
                    type: "number"
                },
                clusterProperties: {
                    type: "*"
                },
                lineMetrics: {
                    type: "boolean",
                    default: !1
                },
                generateId: {
                    type: "boolean",
                    default: !1
                },
                promoteId: {
                    type: "promoteId"
                }
            },
            source_video: {
                type: {
                    required: !0,
                    type: "enum",
                    values: {
                        video: {}
                    }
                },
                urls: {
                    required: !0,
                    type: "array",
                    value: "string"
                },
                coordinates: {
                    required: !0,
                    type: "array",
                    length: 4,
                    value: {
                        type: "array",
                        length: 2,
                        value: "number"
                    }
                }
            },
            source_image: {
                type: {
                    required: !0,
                    type: "enum",
                    values: {
                        image: {}
                    }
                },
                url: {
                    required: !0,
                    type: "string"
                },
                coordinates: {
                    required: !0,
                    type: "array",
                    length: 4,
                    value: {
                        type: "array",
                        length: 2,
                        value: "number"
                    }
                }
            },
            layer: {
                id: {
                    type: "string",
                    required: !0
                },
                type: {
                    type: "enum",
                    values: {
                        fill: {},
                        line: {},
                        symbol: {},
                        circle: {},
                        heatmap: {},
                        "fill-extrusion": {},
                        raster: {},
                        hillshade: {},
                        "color-relief": {},
                        background: {}
                    },
                    required: !0
                },
                metadata: {
                    type: "*"
                },
                source: {
                    type: "string"
                },
                "source-layer": {
                    type: "string"
                },
                minzoom: {
                    type: "number",
                    minimum: 0,
                    maximum: 24
                },
                maxzoom: {
                    type: "number",
                    minimum: 0,
                    maximum: 24
                },
                filter: {
                    type: "filter"
                },
                layout: {
                    type: "layout"
                },
                paint: {
                    type: "paint"
                }
            },
            layout: [
                "layout_fill",
                "layout_line",
                "layout_circle",
                "layout_heatmap",
                "layout_fill-extrusion",
                "layout_symbol",
                "layout_raster",
                "layout_hillshade",
                "layout_color-relief",
                "layout_background"
            ],
            layout_background: {
                visibility: {
                    type: "enum",
                    values: {
                        visible: {},
                        none: {}
                    },
                    default: "visible",
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "global-state"
                        ]
                    },
                    "property-type": "data-constant"
                }
            },
            layout_fill: {
                "fill-sort-key": {
                    type: "number",
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                visibility: {
                    type: "enum",
                    values: {
                        visible: {},
                        none: {}
                    },
                    default: "visible",
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "global-state"
                        ]
                    },
                    "property-type": "data-constant"
                }
            },
            layout_circle: {
                "circle-sort-key": {
                    type: "number",
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                visibility: {
                    type: "enum",
                    values: {
                        visible: {},
                        none: {}
                    },
                    default: "visible",
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "global-state"
                        ]
                    },
                    "property-type": "data-constant"
                }
            },
            layout_heatmap: {
                visibility: {
                    type: "enum",
                    values: {
                        visible: {},
                        none: {}
                    },
                    default: "visible",
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "global-state"
                        ]
                    },
                    "property-type": "data-constant"
                }
            },
            "layout_fill-extrusion": {
                visibility: {
                    type: "enum",
                    values: {
                        visible: {},
                        none: {}
                    },
                    default: "visible",
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "global-state"
                        ]
                    },
                    "property-type": "data-constant"
                }
            },
            layout_line: {
                "line-cap": {
                    type: "enum",
                    values: {
                        butt: {},
                        round: {},
                        square: {}
                    },
                    default: "butt",
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "line-join": {
                    type: "enum",
                    values: {
                        bevel: {},
                        round: {},
                        miter: {}
                    },
                    default: "miter",
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "line-miter-limit": {
                    type: "number",
                    default: 2,
                    requires: [
                        {
                            "line-join": "miter"
                        }
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "line-round-limit": {
                    type: "number",
                    default: 1.05,
                    requires: [
                        {
                            "line-join": "round"
                        }
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "line-sort-key": {
                    type: "number",
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                visibility: {
                    type: "enum",
                    values: {
                        visible: {},
                        none: {}
                    },
                    default: "visible",
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "global-state"
                        ]
                    },
                    "property-type": "data-constant"
                }
            },
            layout_symbol: {
                "symbol-placement": {
                    type: "enum",
                    values: {
                        point: {},
                        line: {},
                        "line-center": {}
                    },
                    default: "point",
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "symbol-spacing": {
                    type: "number",
                    default: 250,
                    minimum: 1,
                    units: "pixels",
                    requires: [
                        {
                            "symbol-placement": "line"
                        }
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "symbol-avoid-edges": {
                    type: "boolean",
                    default: !1,
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "symbol-sort-key": {
                    type: "number",
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "symbol-z-order": {
                    type: "enum",
                    values: {
                        auto: {},
                        "viewport-y": {},
                        source: {}
                    },
                    default: "auto",
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "icon-allow-overlap": {
                    type: "boolean",
                    default: !1,
                    requires: [
                        "icon-image",
                        {
                            "!": "icon-overlap"
                        }
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "icon-overlap": {
                    type: "enum",
                    values: {
                        never: {},
                        always: {},
                        cooperative: {}
                    },
                    requires: [
                        "icon-image"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "icon-ignore-placement": {
                    type: "boolean",
                    default: !1,
                    requires: [
                        "icon-image"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "icon-optional": {
                    type: "boolean",
                    default: !1,
                    requires: [
                        "icon-image",
                        "text-field"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "icon-rotation-alignment": {
                    type: "enum",
                    values: {
                        map: {},
                        viewport: {},
                        auto: {}
                    },
                    default: "auto",
                    requires: [
                        "icon-image"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "icon-size": {
                    type: "number",
                    default: 1,
                    minimum: 0,
                    units: "factor of the original icon size",
                    requires: [
                        "icon-image"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "icon-text-fit": {
                    type: "enum",
                    values: {
                        none: {},
                        width: {},
                        height: {},
                        both: {}
                    },
                    default: "none",
                    requires: [
                        "icon-image",
                        "text-field"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "icon-text-fit-padding": {
                    type: "array",
                    value: "number",
                    length: 4,
                    default: [
                        0,
                        0,
                        0,
                        0
                    ],
                    units: "pixels",
                    requires: [
                        "icon-image",
                        "text-field",
                        {
                            "icon-text-fit": [
                                "both",
                                "width",
                                "height"
                            ]
                        }
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "icon-image": {
                    type: "resolvedImage",
                    tokens: !0,
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "icon-rotate": {
                    type: "number",
                    default: 0,
                    period: 360,
                    units: "degrees",
                    requires: [
                        "icon-image"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "icon-padding": {
                    type: "padding",
                    default: [
                        2
                    ],
                    units: "pixels",
                    requires: [
                        "icon-image"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "icon-keep-upright": {
                    type: "boolean",
                    default: !1,
                    requires: [
                        "icon-image",
                        {
                            "icon-rotation-alignment": "map"
                        },
                        {
                            "symbol-placement": [
                                "line",
                                "line-center"
                            ]
                        }
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "icon-offset": {
                    type: "array",
                    value: "number",
                    length: 2,
                    default: [
                        0,
                        0
                    ],
                    requires: [
                        "icon-image"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "icon-anchor": {
                    type: "enum",
                    values: {
                        center: {},
                        left: {},
                        right: {},
                        top: {},
                        bottom: {},
                        "top-left": {},
                        "top-right": {},
                        "bottom-left": {},
                        "bottom-right": {}
                    },
                    default: "center",
                    requires: [
                        "icon-image"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "icon-pitch-alignment": {
                    type: "enum",
                    values: {
                        map: {},
                        viewport: {},
                        auto: {}
                    },
                    default: "auto",
                    requires: [
                        "icon-image"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "text-pitch-alignment": {
                    type: "enum",
                    values: {
                        map: {},
                        viewport: {},
                        auto: {}
                    },
                    default: "auto",
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "text-rotation-alignment": {
                    type: "enum",
                    values: {
                        map: {},
                        viewport: {},
                        "viewport-glyph": {},
                        auto: {}
                    },
                    default: "auto",
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "text-field": {
                    type: "formatted",
                    default: "",
                    tokens: !0,
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "text-font": {
                    type: "array",
                    value: "string",
                    default: [
                        "Open Sans Regular",
                        "Arial Unicode MS Regular"
                    ],
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "text-size": {
                    type: "number",
                    default: 16,
                    minimum: 0,
                    units: "pixels",
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "text-max-width": {
                    type: "number",
                    default: 10,
                    minimum: 0,
                    units: "ems",
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "text-line-height": {
                    type: "number",
                    default: 1.2,
                    units: "ems",
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "text-letter-spacing": {
                    type: "number",
                    default: 0,
                    units: "ems",
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "text-justify": {
                    type: "enum",
                    values: {
                        auto: {},
                        left: {},
                        center: {},
                        right: {}
                    },
                    default: "center",
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "text-radial-offset": {
                    type: "number",
                    units: "ems",
                    default: 0,
                    requires: [
                        "text-field"
                    ],
                    "property-type": "data-driven",
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    }
                },
                "text-variable-anchor": {
                    type: "array",
                    value: "enum",
                    values: {
                        center: {},
                        left: {},
                        right: {},
                        top: {},
                        bottom: {},
                        "top-left": {},
                        "top-right": {},
                        "bottom-left": {},
                        "bottom-right": {}
                    },
                    requires: [
                        "text-field",
                        {
                            "symbol-placement": [
                                "point"
                            ]
                        }
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "text-variable-anchor-offset": {
                    type: "variableAnchorOffsetCollection",
                    requires: [
                        "text-field",
                        {
                            "symbol-placement": [
                                "point"
                            ]
                        }
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "text-anchor": {
                    type: "enum",
                    values: {
                        center: {},
                        left: {},
                        right: {},
                        top: {},
                        bottom: {},
                        "top-left": {},
                        "top-right": {},
                        "bottom-left": {},
                        "bottom-right": {}
                    },
                    default: "center",
                    requires: [
                        "text-field",
                        {
                            "!": "text-variable-anchor"
                        }
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "text-max-angle": {
                    type: "number",
                    default: 45,
                    units: "degrees",
                    requires: [
                        "text-field",
                        {
                            "symbol-placement": [
                                "line",
                                "line-center"
                            ]
                        }
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "text-writing-mode": {
                    type: "array",
                    value: "enum",
                    values: {
                        horizontal: {},
                        vertical: {}
                    },
                    requires: [
                        "text-field",
                        {
                            "symbol-placement": [
                                "point"
                            ]
                        }
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "text-rotate": {
                    type: "number",
                    default: 0,
                    period: 360,
                    units: "degrees",
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "text-padding": {
                    type: "number",
                    default: 2,
                    minimum: 0,
                    units: "pixels",
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "text-keep-upright": {
                    type: "boolean",
                    default: !0,
                    requires: [
                        "text-field",
                        {
                            "text-rotation-alignment": "map"
                        },
                        {
                            "symbol-placement": [
                                "line",
                                "line-center"
                            ]
                        }
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "text-transform": {
                    type: "enum",
                    values: {
                        none: {},
                        uppercase: {},
                        lowercase: {}
                    },
                    default: "none",
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "text-offset": {
                    type: "array",
                    value: "number",
                    units: "ems",
                    length: 2,
                    default: [
                        0,
                        0
                    ],
                    requires: [
                        "text-field",
                        {
                            "!": "text-radial-offset"
                        }
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "text-allow-overlap": {
                    type: "boolean",
                    default: !1,
                    requires: [
                        "text-field",
                        {
                            "!": "text-overlap"
                        }
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "text-overlap": {
                    type: "enum",
                    values: {
                        never: {},
                        always: {},
                        cooperative: {}
                    },
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "text-ignore-placement": {
                    type: "boolean",
                    default: !1,
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "text-optional": {
                    type: "boolean",
                    default: !1,
                    requires: [
                        "text-field",
                        "icon-image"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                visibility: {
                    type: "enum",
                    values: {
                        visible: {},
                        none: {}
                    },
                    default: "visible",
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "global-state"
                        ]
                    },
                    "property-type": "data-constant"
                }
            },
            layout_raster: {
                visibility: {
                    type: "enum",
                    values: {
                        visible: {},
                        none: {}
                    },
                    default: "visible",
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "global-state"
                        ]
                    },
                    "property-type": "data-constant"
                }
            },
            layout_hillshade: {
                visibility: {
                    type: "enum",
                    values: {
                        visible: {},
                        none: {}
                    },
                    default: "visible",
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "global-state"
                        ]
                    },
                    "property-type": "data-constant"
                }
            },
            "layout_color-relief": {
                visibility: {
                    type: "enum",
                    values: {
                        visible: {},
                        none: {}
                    },
                    default: "visible",
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "global-state"
                        ]
                    },
                    "property-type": "data-constant"
                }
            },
            filter: {
                type: "boolean",
                expression: {
                    interpolated: !1,
                    parameters: [
                        "zoom",
                        "feature"
                    ]
                },
                "property-type": "data-driven"
            },
            filter_operator: {
                type: "enum",
                values: {
                    "==": {},
                    "!=": {},
                    ">": {},
                    ">=": {},
                    "<": {},
                    "<=": {},
                    in: {},
                    "!in": {},
                    all: {},
                    any: {},
                    none: {},
                    has: {},
                    "!has": {}
                }
            },
            geometry_type: {
                type: "enum",
                values: {
                    Point: {},
                    LineString: {},
                    Polygon: {}
                }
            },
            function: {
                expression: {
                    type: "expression"
                },
                stops: {
                    type: "array",
                    value: "function_stop"
                },
                base: {
                    type: "number",
                    default: 1,
                    minimum: 0
                },
                property: {
                    type: "string",
                    default: "$zoom"
                },
                type: {
                    type: "enum",
                    values: {
                        identity: {},
                        exponential: {},
                        interval: {},
                        categorical: {}
                    },
                    default: "exponential"
                },
                colorSpace: {
                    type: "enum",
                    values: {
                        rgb: {},
                        lab: {},
                        hcl: {}
                    },
                    default: "rgb"
                },
                default: {
                    type: "*",
                    required: !1
                }
            },
            function_stop: {
                type: "array",
                minimum: 0,
                maximum: 24,
                value: [
                    "number",
                    "color"
                ],
                length: 2
            },
            expression: {
                type: "array",
                value: "expression_name",
                minimum: 1
            },
            light: {
                anchor: {
                    type: "enum",
                    default: "viewport",
                    values: {
                        map: {},
                        viewport: {}
                    },
                    "property-type": "data-constant",
                    transition: !1,
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    }
                },
                position: {
                    type: "array",
                    default: [
                        1.15,
                        210,
                        30
                    ],
                    length: 3,
                    value: "number",
                    "property-type": "data-constant",
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    }
                },
                color: {
                    type: "color",
                    "property-type": "data-constant",
                    default: "#ffffff",
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    transition: !0
                },
                intensity: {
                    type: "number",
                    "property-type": "data-constant",
                    default: .5,
                    minimum: 0,
                    maximum: 1,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    transition: !0
                }
            },
            sky: {
                "sky-color": {
                    type: "color",
                    "property-type": "data-constant",
                    default: "#88C6FC",
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    transition: !0
                },
                "horizon-color": {
                    type: "color",
                    "property-type": "data-constant",
                    default: "#ffffff",
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    transition: !0
                },
                "fog-color": {
                    type: "color",
                    "property-type": "data-constant",
                    default: "#ffffff",
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    transition: !0
                },
                "fog-ground-blend": {
                    type: "number",
                    "property-type": "data-constant",
                    default: .5,
                    minimum: 0,
                    maximum: 1,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    transition: !0
                },
                "horizon-fog-blend": {
                    type: "number",
                    "property-type": "data-constant",
                    default: .8,
                    minimum: 0,
                    maximum: 1,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    transition: !0
                },
                "sky-horizon-blend": {
                    type: "number",
                    "property-type": "data-constant",
                    default: .8,
                    minimum: 0,
                    maximum: 1,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    transition: !0
                },
                "atmosphere-blend": {
                    type: "number",
                    "property-type": "data-constant",
                    default: .8,
                    minimum: 0,
                    maximum: 1,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    transition: !0
                }
            },
            terrain: {
                source: {
                    type: "string",
                    required: !0
                },
                exaggeration: {
                    type: "number",
                    minimum: 0,
                    default: 1
                }
            },
            projection: {
                type: {
                    type: "projectionDefinition",
                    default: "mercator",
                    "property-type": "data-constant",
                    transition: !1,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    }
                }
            },
            paint: [
                "paint_fill",
                "paint_line",
                "paint_circle",
                "paint_heatmap",
                "paint_fill-extrusion",
                "paint_symbol",
                "paint_raster",
                "paint_hillshade",
                "paint_color-relief",
                "paint_background"
            ],
            paint_fill: {
                "fill-antialias": {
                    type: "boolean",
                    default: !0,
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "fill-opacity": {
                    type: "number",
                    default: 1,
                    minimum: 0,
                    maximum: 1,
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "fill-color": {
                    type: "color",
                    default: "#000000",
                    transition: !0,
                    requires: [
                        {
                            "!": "fill-pattern"
                        }
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "fill-outline-color": {
                    type: "color",
                    transition: !0,
                    requires: [
                        {
                            "!": "fill-pattern"
                        },
                        {
                            "fill-antialias": !0
                        }
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "fill-translate": {
                    type: "array",
                    value: "number",
                    length: 2,
                    default: [
                        0,
                        0
                    ],
                    transition: !0,
                    units: "pixels",
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "fill-translate-anchor": {
                    type: "enum",
                    values: {
                        map: {},
                        viewport: {}
                    },
                    default: "map",
                    requires: [
                        "fill-translate"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "fill-pattern": {
                    type: "resolvedImage",
                    transition: !0,
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "cross-faded-data-driven"
                }
            },
            "paint_fill-extrusion": {
                "fill-extrusion-opacity": {
                    type: "number",
                    default: 1,
                    minimum: 0,
                    maximum: 1,
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "fill-extrusion-color": {
                    type: "color",
                    default: "#000000",
                    transition: !0,
                    requires: [
                        {
                            "!": "fill-extrusion-pattern"
                        }
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "fill-extrusion-translate": {
                    type: "array",
                    value: "number",
                    length: 2,
                    default: [
                        0,
                        0
                    ],
                    transition: !0,
                    units: "pixels",
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "fill-extrusion-translate-anchor": {
                    type: "enum",
                    values: {
                        map: {},
                        viewport: {}
                    },
                    default: "map",
                    requires: [
                        "fill-extrusion-translate"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "fill-extrusion-pattern": {
                    type: "resolvedImage",
                    transition: !0,
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "cross-faded-data-driven"
                },
                "fill-extrusion-height": {
                    type: "number",
                    default: 0,
                    minimum: 0,
                    units: "meters",
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "fill-extrusion-base": {
                    type: "number",
                    default: 0,
                    minimum: 0,
                    units: "meters",
                    transition: !0,
                    requires: [
                        "fill-extrusion-height"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "fill-extrusion-vertical-gradient": {
                    type: "boolean",
                    default: !0,
                    transition: !1,
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                }
            },
            paint_line: {
                "line-opacity": {
                    type: "number",
                    default: 1,
                    minimum: 0,
                    maximum: 1,
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "line-color": {
                    type: "color",
                    default: "#000000",
                    transition: !0,
                    requires: [
                        {
                            "!": "line-pattern"
                        }
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "line-translate": {
                    type: "array",
                    value: "number",
                    length: 2,
                    default: [
                        0,
                        0
                    ],
                    transition: !0,
                    units: "pixels",
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "line-translate-anchor": {
                    type: "enum",
                    values: {
                        map: {},
                        viewport: {}
                    },
                    default: "map",
                    requires: [
                        "line-translate"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "line-width": {
                    type: "number",
                    default: 1,
                    minimum: 0,
                    transition: !0,
                    units: "pixels",
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "line-gap-width": {
                    type: "number",
                    default: 0,
                    minimum: 0,
                    transition: !0,
                    units: "pixels",
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "line-offset": {
                    type: "number",
                    default: 0,
                    transition: !0,
                    units: "pixels",
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "line-blur": {
                    type: "number",
                    default: 0,
                    minimum: 0,
                    transition: !0,
                    units: "pixels",
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "line-dasharray": {
                    type: "array",
                    value: "number",
                    minimum: 0,
                    transition: !0,
                    units: "line widths",
                    requires: [
                        {
                            "!": "line-pattern"
                        }
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "cross-faded-data-driven"
                },
                "line-pattern": {
                    type: "resolvedImage",
                    transition: !0,
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "cross-faded-data-driven"
                },
                "line-gradient": {
                    type: "color",
                    transition: !1,
                    requires: [
                        {
                            "!": "line-dasharray"
                        },
                        {
                            "!": "line-pattern"
                        },
                        {
                            source: "geojson",
                            has: {
                                lineMetrics: !0
                            }
                        }
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "line-progress"
                        ]
                    },
                    "property-type": "color-ramp"
                }
            },
            paint_circle: {
                "circle-radius": {
                    type: "number",
                    default: 5,
                    minimum: 0,
                    transition: !0,
                    units: "pixels",
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "circle-color": {
                    type: "color",
                    default: "#000000",
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "circle-blur": {
                    type: "number",
                    default: 0,
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "circle-opacity": {
                    type: "number",
                    default: 1,
                    minimum: 0,
                    maximum: 1,
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "circle-translate": {
                    type: "array",
                    value: "number",
                    length: 2,
                    default: [
                        0,
                        0
                    ],
                    transition: !0,
                    units: "pixels",
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "circle-translate-anchor": {
                    type: "enum",
                    values: {
                        map: {},
                        viewport: {}
                    },
                    default: "map",
                    requires: [
                        "circle-translate"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "circle-pitch-scale": {
                    type: "enum",
                    values: {
                        map: {},
                        viewport: {}
                    },
                    default: "map",
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "circle-pitch-alignment": {
                    type: "enum",
                    values: {
                        map: {},
                        viewport: {}
                    },
                    default: "viewport",
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "circle-stroke-width": {
                    type: "number",
                    default: 0,
                    minimum: 0,
                    transition: !0,
                    units: "pixels",
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "circle-stroke-color": {
                    type: "color",
                    default: "#000000",
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "circle-stroke-opacity": {
                    type: "number",
                    default: 1,
                    minimum: 0,
                    maximum: 1,
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                }
            },
            paint_heatmap: {
                "heatmap-radius": {
                    type: "number",
                    default: 30,
                    minimum: 1,
                    transition: !0,
                    units: "pixels",
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "heatmap-weight": {
                    type: "number",
                    default: 1,
                    minimum: 0,
                    transition: !1,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "heatmap-intensity": {
                    type: "number",
                    default: 1,
                    minimum: 0,
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "heatmap-color": {
                    type: "color",
                    default: [
                        "interpolate",
                        [
                            "linear"
                        ],
                        [
                            "heatmap-density"
                        ],
                        0,
                        "rgba(0, 0, 255, 0)",
                        .1,
                        "royalblue",
                        .3,
                        "cyan",
                        .5,
                        "lime",
                        .7,
                        "yellow",
                        1,
                        "red"
                    ],
                    transition: !1,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "heatmap-density"
                        ]
                    },
                    "property-type": "color-ramp"
                },
                "heatmap-opacity": {
                    type: "number",
                    default: 1,
                    minimum: 0,
                    maximum: 1,
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                }
            },
            paint_symbol: {
                "icon-opacity": {
                    type: "number",
                    default: 1,
                    minimum: 0,
                    maximum: 1,
                    transition: !0,
                    requires: [
                        "icon-image"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "icon-color": {
                    type: "color",
                    default: "#000000",
                    transition: !0,
                    requires: [
                        "icon-image"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "icon-halo-color": {
                    type: "color",
                    default: "rgba(0, 0, 0, 0)",
                    transition: !0,
                    requires: [
                        "icon-image"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "icon-halo-width": {
                    type: "number",
                    default: 0,
                    minimum: 0,
                    transition: !0,
                    units: "pixels",
                    requires: [
                        "icon-image"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "icon-halo-blur": {
                    type: "number",
                    default: 0,
                    minimum: 0,
                    transition: !0,
                    units: "pixels",
                    requires: [
                        "icon-image"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "icon-translate": {
                    type: "array",
                    value: "number",
                    length: 2,
                    default: [
                        0,
                        0
                    ],
                    transition: !0,
                    units: "pixels",
                    requires: [
                        "icon-image"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "icon-translate-anchor": {
                    type: "enum",
                    values: {
                        map: {},
                        viewport: {}
                    },
                    default: "map",
                    requires: [
                        "icon-image",
                        "icon-translate"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "text-opacity": {
                    type: "number",
                    default: 1,
                    minimum: 0,
                    maximum: 1,
                    transition: !0,
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "text-color": {
                    type: "color",
                    default: "#000000",
                    transition: !0,
                    overridable: !0,
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "text-halo-color": {
                    type: "color",
                    default: "rgba(0, 0, 0, 0)",
                    transition: !0,
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "text-halo-width": {
                    type: "number",
                    default: 0,
                    minimum: 0,
                    transition: !0,
                    units: "pixels",
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "text-halo-blur": {
                    type: "number",
                    default: 0,
                    minimum: 0,
                    transition: !0,
                    units: "pixels",
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "text-translate": {
                    type: "array",
                    value: "number",
                    length: 2,
                    default: [
                        0,
                        0
                    ],
                    transition: !0,
                    units: "pixels",
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "text-translate-anchor": {
                    type: "enum",
                    values: {
                        map: {},
                        viewport: {}
                    },
                    default: "map",
                    requires: [
                        "text-field",
                        "text-translate"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                }
            },
            paint_raster: {
                "raster-opacity": {
                    type: "number",
                    default: 1,
                    minimum: 0,
                    maximum: 1,
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "raster-hue-rotate": {
                    type: "number",
                    default: 0,
                    period: 360,
                    transition: !0,
                    units: "degrees",
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "raster-brightness-min": {
                    type: "number",
                    default: 0,
                    minimum: 0,
                    maximum: 1,
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "raster-brightness-max": {
                    type: "number",
                    default: 1,
                    minimum: 0,
                    maximum: 1,
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "raster-saturation": {
                    type: "number",
                    default: 0,
                    minimum: -1,
                    maximum: 1,
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "raster-contrast": {
                    type: "number",
                    default: 0,
                    minimum: -1,
                    maximum: 1,
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                resampling: {
                    type: "enum",
                    values: {
                        linear: {},
                        nearest: {}
                    },
                    default: "linear",
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "raster-resampling": {
                    type: "enum",
                    values: {
                        linear: {},
                        nearest: {}
                    },
                    default: "linear",
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "raster-fade-duration": {
                    type: "number",
                    default: 300,
                    minimum: 0,
                    transition: !1,
                    units: "milliseconds",
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                }
            },
            paint_hillshade: {
                "hillshade-illumination-direction": {
                    type: "numberArray",
                    default: 335,
                    minimum: 0,
                    maximum: 359,
                    transition: !1,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "hillshade-illumination-altitude": {
                    type: "numberArray",
                    default: 45,
                    minimum: 0,
                    maximum: 90,
                    transition: !1,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "hillshade-illumination-anchor": {
                    type: "enum",
                    values: {
                        map: {},
                        viewport: {}
                    },
                    default: "viewport",
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "hillshade-exaggeration": {
                    type: "number",
                    default: .5,
                    minimum: 0,
                    maximum: 1,
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "hillshade-shadow-color": {
                    type: "colorArray",
                    default: "#000000",
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "hillshade-highlight-color": {
                    type: "colorArray",
                    default: "#FFFFFF",
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "hillshade-accent-color": {
                    type: "color",
                    default: "#000000",
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "hillshade-method": {
                    type: "enum",
                    values: {
                        standard: {},
                        basic: {},
                        combined: {},
                        igor: {},
                        multidirectional: {}
                    },
                    default: "standard",
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                resampling: {
                    type: "enum",
                    values: {
                        linear: {},
                        nearest: {}
                    },
                    default: "linear",
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                }
            },
            "paint_color-relief": {
                "color-relief-opacity": {
                    type: "number",
                    default: 1,
                    minimum: 0,
                    maximum: 1,
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "color-relief-color": {
                    type: "color",
                    transition: !1,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "elevation"
                        ]
                    },
                    "property-type": "color-ramp"
                },
                resampling: {
                    type: "enum",
                    values: {
                        linear: {},
                        nearest: {}
                    },
                    default: "linear",
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                }
            },
            paint_background: {
                "background-color": {
                    type: "color",
                    default: "#000000",
                    transition: !0,
                    requires: [
                        {
                            "!": "background-pattern"
                        }
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "background-pattern": {
                    type: "resolvedImage",
                    transition: !0,
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "cross-faded"
                },
                "background-opacity": {
                    type: "number",
                    default: 1,
                    minimum: 0,
                    maximum: 1,
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                }
            },
            transition: {
                duration: {
                    type: "number",
                    default: 300,
                    minimum: 0,
                    units: "milliseconds"
                },
                delay: {
                    type: "number",
                    default: 0,
                    minimum: 0,
                    units: "milliseconds"
                }
            },
            "property-type": {
                "data-driven": {
                    type: "property-type"
                },
                "cross-faded": {
                    type: "property-type"
                },
                "cross-faded-data-driven": {
                    type: "property-type"
                },
                "color-ramp": {
                    type: "property-type"
                },
                "data-constant": {
                    type: "property-type"
                },
                constant: {
                    type: "property-type"
                }
            },
            promoteId: {
                "*": {
                    type: "string"
                }
            },
            interpolation: {
                type: "array",
                value: "interpolation_name",
                minimum: 1
            },
            interpolation_name: {
                type: "enum",
                values: {
                    linear: {
                        syntax: {
                            overloads: [
                                {
                                    parameters: [],
                                    "output-type": "interpolation"
                                }
                            ],
                            parameters: []
                        }
                    },
                    exponential: {
                        syntax: {
                            overloads: [
                                {
                                    parameters: [
                                        "base"
                                    ],
                                    "output-type": "interpolation"
                                }
                            ],
                            parameters: [
                                {
                                    name: "base",
                                    type: "number literal"
                                }
                            ]
                        }
                    },
                    "cubic-bezier": {
                        syntax: {
                            overloads: [
                                {
                                    parameters: [
                                        "x1",
                                        "y1",
                                        "x2",
                                        "y2"
                                    ],
                                    "output-type": "interpolation"
                                }
                            ],
                            parameters: [
                                {
                                    name: "x1",
                                    type: "number literal"
                                },
                                {
                                    name: "y1",
                                    type: "number literal"
                                },
                                {
                                    name: "x2",
                                    type: "number literal"
                                },
                                {
                                    name: "y2",
                                    type: "number literal"
                                }
                            ]
                        }
                    }
                }
            }
        };
        const _t = [
            "type",
            "source",
            "source-layer",
            "minzoom",
            "maxzoom",
            "filter",
            "layout"
        ];
        function St(t, e1) {
            const n = {};
            for(const e1 in t)"ref" !== e1 && (n[e1] = t[e1]);
            return _t.forEach((t)=>{
                t in e1 && (n[t] = e1[t]);
            }), n;
        }
        function At(t, e1) {
            if (Array.isArray(t)) {
                if (!Array.isArray(e1) || t.length !== e1.length) return !1;
                for(let n = 0; n < t.length; n++)if (!At(t[n], e1[n])) return !1;
                return !0;
            }
            if ("object" == typeof t && null !== t && null !== e1) {
                if ("object" != typeof e1) return !1;
                if (Object.keys(t).length !== Object.keys(e1).length) return !1;
                for(const n in t)if (!At(t[n], e1[n])) return !1;
                return !0;
            }
            return t === e1;
        }
        function Mt(t, e1) {
            t.push(e1);
        }
        function kt(t, e1, n) {
            Mt(n, {
                command: "addSource",
                args: [
                    t,
                    e1[t]
                ]
            });
        }
        function It(t, e1, n) {
            Mt(e1, {
                command: "removeSource",
                args: [
                    t
                ]
            }), n[t] = !0;
        }
        function Et(t, e1, n, r) {
            It(t, n, r), kt(t, e1, n);
        }
        function Tt(t, e1, n) {
            let r;
            for(r in t[n])if (Object.prototype.hasOwnProperty.call(t[n], r) && "data" !== r && !At(t[n][r], e1[n][r])) return !1;
            for(r in e1[n])if (Object.prototype.hasOwnProperty.call(e1[n], r) && "data" !== r && !At(t[n][r], e1[n][r])) return !1;
            return !0;
        }
        function Ft(t, e1, n, r, i, s) {
            t = t || {}, e1 = e1 || {};
            for(const o in t)Object.prototype.hasOwnProperty.call(t, o) && (At(t[o], e1[o]) || n.push({
                command: s,
                args: [
                    r,
                    o,
                    e1[o],
                    i
                ]
            }));
            for(const o in e1)Object.prototype.hasOwnProperty.call(e1, o) && !Object.prototype.hasOwnProperty.call(t, o) && (At(t[o], e1[o]) || n.push({
                command: s,
                args: [
                    r,
                    o,
                    e1[o],
                    i
                ]
            }));
        }
        function Pt(t) {
            return t.id;
        }
        function Dt(t, e1) {
            return t[e1.id] = e1, t;
        }
        class zt {
            constructor(t, e1, n, r){
                this.message = (t ? `${t}: ` : "") + n, r && (this.identifier = r), null != e1 && e1.__line__ && (this.line = e1.__line__);
            }
        }
        function Bt(t, ...e1) {
            for (const n of e1)for(const e1 in n)t[e1] = n[e1];
            return t;
        }
        class Ct extends Error {
            constructor(t, e1){
                super(e1), this.message = e1, this.key = t;
            }
        }
        class Vt {
            constructor(t, e1 = []){
                this.parent = t, this.bindings = {};
                for (const [t, n] of e1)this.bindings[t] = n;
            }
            concat(t) {
                return new Vt(this, t);
            }
            get(t) {
                if (this.bindings[t]) return this.bindings[t];
                if (this.parent) return this.parent.get(t);
                throw new Error(`${t} not found in scope.`);
            }
            has(t) {
                return !!this.bindings[t] || !!this.parent && this.parent.has(t);
            }
        }
        const Lt = {
            kind: "null"
        }, Ot = {
            kind: "number"
        }, $t = {
            kind: "string"
        }, Rt = {
            kind: "boolean"
        }, Nt = {
            kind: "color"
        }, Ut = {
            kind: "projectionDefinition"
        }, jt = {
            kind: "object"
        }, qt = {
            kind: "value"
        }, Gt = {
            kind: "collator"
        }, Xt = {
            kind: "formatted"
        }, Yt = {
            kind: "padding"
        }, Zt = {
            kind: "colorArray"
        }, Ht = {
            kind: "numberArray"
        }, Wt = {
            kind: "resolvedImage"
        }, Kt = {
            kind: "variableAnchorOffsetCollection"
        };
        function Jt(t, e1) {
            return {
                kind: "array",
                itemType: t,
                N: e1
            };
        }
        function Qt(t) {
            if ("array" === t.kind) {
                const e1 = Qt(t.itemType);
                return "number" == typeof t.N ? `array<${e1}, ${t.N}>` : "value" === t.itemType.kind ? "array" : `array<${e1}>`;
            }
            return t.kind;
        }
        const te = [
            Lt,
            Ot,
            $t,
            Rt,
            Nt,
            Ut,
            Xt,
            jt,
            Jt(qt),
            Yt,
            Ht,
            Zt,
            Wt,
            Kt
        ];
        function ee(t, e1) {
            if ("error" === e1.kind) return null;
            if ("array" === t.kind) {
                if ("array" === e1.kind && (0 === e1.N && "value" === e1.itemType.kind || !ee(t.itemType, e1.itemType)) && ("number" != typeof t.N || t.N === e1.N)) return null;
            } else {
                if (t.kind === e1.kind) return null;
                if ("value" === t.kind) {
                    for (const t of te)if (!ee(t, e1)) return null;
                }
            }
            return `Expected ${Qt(t)} but found ${Qt(e1)} instead.`;
        }
        function ne(t, e1) {
            return e1.some((e1)=>e1.kind === t.kind);
        }
        function re(t, e1) {
            return e1.some((e1)=>"null" === e1 ? null === t : "array" === e1 ? Array.isArray(t) : "object" === e1 ? t && !Array.isArray(t) && "object" == typeof t : e1 === typeof t);
        }
        function ie(t, e1) {
            return "array" === t.kind && "array" === e1.kind ? t.itemType.kind === e1.itemType.kind && "number" == typeof t.N : t.kind === e1.kind;
        }
        const se = .96422, oe = .82521, ae = 4 / 29, le = 6 / 29, ue = 3 * le * le, ce = le * le * le, he = Math.PI / 180, pe = 180 / Math.PI;
        function fe(t) {
            return (t %= 360) < 0 && (t += 360), t;
        }
        function de([t, e1, n, r]) {
            let i, s;
            const o = me((.2225045 * (t = ye(t)) + .7168786 * (e1 = ye(e1)) + .0606169 * (n = ye(n))) / 1);
            t === e1 && e1 === n ? i = s = o : (i = me((.4360747 * t + .3850649 * e1 + .1430804 * n) / se), s = me((.0139322 * t + .0971045 * e1 + .7141733 * n) / oe));
            const a = 116 * o - 16;
            return [
                a < 0 ? 0 : a,
                500 * (i - o),
                200 * (o - s),
                r
            ];
        }
        function ye(t) {
            return t <= .04045 ? t / 12.92 : Math.pow((t + .055) / 1.055, 2.4);
        }
        function me(t) {
            return t > ce ? Math.pow(t, 1 / 3) : t / ue + ae;
        }
        function ge([t, e1, n, r]) {
            let i = (t + 16) / 116, s = isNaN(e1) ? i : i + e1 / 500, o = isNaN(n) ? i : i - n / 200;
            return i = 1 * ve(i), s = se * ve(s), o = oe * ve(o), [
                xe(3.1338561 * s - 1.6168667 * i - .4906146 * o),
                xe(-0.9787684 * s + 1.9161415 * i + .033454 * o),
                xe(.0719453 * s - .2289914 * i + 1.4052427 * o),
                r
            ];
        }
        function xe(t) {
            return (t = t <= .00304 ? 12.92 * t : 1.055 * Math.pow(t, 1 / 2.4) - .055) < 0 ? 0 : t > 1 ? 1 : t;
        }
        function ve(t) {
            return t > le ? t * t * t : ue * (t - ae);
        }
        const be = Object.hasOwn || function(t, e1) {
            return Object.prototype.hasOwnProperty.call(t, e1);
        };
        function we(t, e1) {
            return be(t, e1) ? t[e1] : void 0;
        }
        function _e(t) {
            return parseInt(t.padEnd(2, t), 16) / 255;
        }
        function Se(t, e1) {
            return Ae(e1 ? t / 100 : t, 0, 1);
        }
        function Ae(t, e1, n) {
            return Math.min(Math.max(e1, t), n);
        }
        function Me(t) {
            return !t.some(Number.isNaN);
        }
        const ke = {
            aliceblue: [
                240,
                248,
                255
            ],
            antiquewhite: [
                250,
                235,
                215
            ],
            aqua: [
                0,
                255,
                255
            ],
            aquamarine: [
                127,
                255,
                212
            ],
            azure: [
                240,
                255,
                255
            ],
            beige: [
                245,
                245,
                220
            ],
            bisque: [
                255,
                228,
                196
            ],
            black: [
                0,
                0,
                0
            ],
            blanchedalmond: [
                255,
                235,
                205
            ],
            blue: [
                0,
                0,
                255
            ],
            blueviolet: [
                138,
                43,
                226
            ],
            brown: [
                165,
                42,
                42
            ],
            burlywood: [
                222,
                184,
                135
            ],
            cadetblue: [
                95,
                158,
                160
            ],
            chartreuse: [
                127,
                255,
                0
            ],
            chocolate: [
                210,
                105,
                30
            ],
            coral: [
                255,
                127,
                80
            ],
            cornflowerblue: [
                100,
                149,
                237
            ],
            cornsilk: [
                255,
                248,
                220
            ],
            crimson: [
                220,
                20,
                60
            ],
            cyan: [
                0,
                255,
                255
            ],
            darkblue: [
                0,
                0,
                139
            ],
            darkcyan: [
                0,
                139,
                139
            ],
            darkgoldenrod: [
                184,
                134,
                11
            ],
            darkgray: [
                169,
                169,
                169
            ],
            darkgreen: [
                0,
                100,
                0
            ],
            darkgrey: [
                169,
                169,
                169
            ],
            darkkhaki: [
                189,
                183,
                107
            ],
            darkmagenta: [
                139,
                0,
                139
            ],
            darkolivegreen: [
                85,
                107,
                47
            ],
            darkorange: [
                255,
                140,
                0
            ],
            darkorchid: [
                153,
                50,
                204
            ],
            darkred: [
                139,
                0,
                0
            ],
            darksalmon: [
                233,
                150,
                122
            ],
            darkseagreen: [
                143,
                188,
                143
            ],
            darkslateblue: [
                72,
                61,
                139
            ],
            darkslategray: [
                47,
                79,
                79
            ],
            darkslategrey: [
                47,
                79,
                79
            ],
            darkturquoise: [
                0,
                206,
                209
            ],
            darkviolet: [
                148,
                0,
                211
            ],
            deeppink: [
                255,
                20,
                147
            ],
            deepskyblue: [
                0,
                191,
                255
            ],
            dimgray: [
                105,
                105,
                105
            ],
            dimgrey: [
                105,
                105,
                105
            ],
            dodgerblue: [
                30,
                144,
                255
            ],
            firebrick: [
                178,
                34,
                34
            ],
            floralwhite: [
                255,
                250,
                240
            ],
            forestgreen: [
                34,
                139,
                34
            ],
            fuchsia: [
                255,
                0,
                255
            ],
            gainsboro: [
                220,
                220,
                220
            ],
            ghostwhite: [
                248,
                248,
                255
            ],
            gold: [
                255,
                215,
                0
            ],
            goldenrod: [
                218,
                165,
                32
            ],
            gray: [
                128,
                128,
                128
            ],
            green: [
                0,
                128,
                0
            ],
            greenyellow: [
                173,
                255,
                47
            ],
            grey: [
                128,
                128,
                128
            ],
            honeydew: [
                240,
                255,
                240
            ],
            hotpink: [
                255,
                105,
                180
            ],
            indianred: [
                205,
                92,
                92
            ],
            indigo: [
                75,
                0,
                130
            ],
            ivory: [
                255,
                255,
                240
            ],
            khaki: [
                240,
                230,
                140
            ],
            lavender: [
                230,
                230,
                250
            ],
            lavenderblush: [
                255,
                240,
                245
            ],
            lawngreen: [
                124,
                252,
                0
            ],
            lemonchiffon: [
                255,
                250,
                205
            ],
            lightblue: [
                173,
                216,
                230
            ],
            lightcoral: [
                240,
                128,
                128
            ],
            lightcyan: [
                224,
                255,
                255
            ],
            lightgoldenrodyellow: [
                250,
                250,
                210
            ],
            lightgray: [
                211,
                211,
                211
            ],
            lightgreen: [
                144,
                238,
                144
            ],
            lightgrey: [
                211,
                211,
                211
            ],
            lightpink: [
                255,
                182,
                193
            ],
            lightsalmon: [
                255,
                160,
                122
            ],
            lightseagreen: [
                32,
                178,
                170
            ],
            lightskyblue: [
                135,
                206,
                250
            ],
            lightslategray: [
                119,
                136,
                153
            ],
            lightslategrey: [
                119,
                136,
                153
            ],
            lightsteelblue: [
                176,
                196,
                222
            ],
            lightyellow: [
                255,
                255,
                224
            ],
            lime: [
                0,
                255,
                0
            ],
            limegreen: [
                50,
                205,
                50
            ],
            linen: [
                250,
                240,
                230
            ],
            magenta: [
                255,
                0,
                255
            ],
            maroon: [
                128,
                0,
                0
            ],
            mediumaquamarine: [
                102,
                205,
                170
            ],
            mediumblue: [
                0,
                0,
                205
            ],
            mediumorchid: [
                186,
                85,
                211
            ],
            mediumpurple: [
                147,
                112,
                219
            ],
            mediumseagreen: [
                60,
                179,
                113
            ],
            mediumslateblue: [
                123,
                104,
                238
            ],
            mediumspringgreen: [
                0,
                250,
                154
            ],
            mediumturquoise: [
                72,
                209,
                204
            ],
            mediumvioletred: [
                199,
                21,
                133
            ],
            midnightblue: [
                25,
                25,
                112
            ],
            mintcream: [
                245,
                255,
                250
            ],
            mistyrose: [
                255,
                228,
                225
            ],
            moccasin: [
                255,
                228,
                181
            ],
            navajowhite: [
                255,
                222,
                173
            ],
            navy: [
                0,
                0,
                128
            ],
            oldlace: [
                253,
                245,
                230
            ],
            olive: [
                128,
                128,
                0
            ],
            olivedrab: [
                107,
                142,
                35
            ],
            orange: [
                255,
                165,
                0
            ],
            orangered: [
                255,
                69,
                0
            ],
            orchid: [
                218,
                112,
                214
            ],
            palegoldenrod: [
                238,
                232,
                170
            ],
            palegreen: [
                152,
                251,
                152
            ],
            paleturquoise: [
                175,
                238,
                238
            ],
            palevioletred: [
                219,
                112,
                147
            ],
            papayawhip: [
                255,
                239,
                213
            ],
            peachpuff: [
                255,
                218,
                185
            ],
            peru: [
                205,
                133,
                63
            ],
            pink: [
                255,
                192,
                203
            ],
            plum: [
                221,
                160,
                221
            ],
            powderblue: [
                176,
                224,
                230
            ],
            purple: [
                128,
                0,
                128
            ],
            rebeccapurple: [
                102,
                51,
                153
            ],
            red: [
                255,
                0,
                0
            ],
            rosybrown: [
                188,
                143,
                143
            ],
            royalblue: [
                65,
                105,
                225
            ],
            saddlebrown: [
                139,
                69,
                19
            ],
            salmon: [
                250,
                128,
                114
            ],
            sandybrown: [
                244,
                164,
                96
            ],
            seagreen: [
                46,
                139,
                87
            ],
            seashell: [
                255,
                245,
                238
            ],
            sienna: [
                160,
                82,
                45
            ],
            silver: [
                192,
                192,
                192
            ],
            skyblue: [
                135,
                206,
                235
            ],
            slateblue: [
                106,
                90,
                205
            ],
            slategray: [
                112,
                128,
                144
            ],
            slategrey: [
                112,
                128,
                144
            ],
            snow: [
                255,
                250,
                250
            ],
            springgreen: [
                0,
                255,
                127
            ],
            steelblue: [
                70,
                130,
                180
            ],
            tan: [
                210,
                180,
                140
            ],
            teal: [
                0,
                128,
                128
            ],
            thistle: [
                216,
                191,
                216
            ],
            tomato: [
                255,
                99,
                71
            ],
            turquoise: [
                64,
                224,
                208
            ],
            violet: [
                238,
                130,
                238
            ],
            wheat: [
                245,
                222,
                179
            ],
            white: [
                255,
                255,
                255
            ],
            whitesmoke: [
                245,
                245,
                245
            ],
            yellow: [
                255,
                255,
                0
            ],
            yellowgreen: [
                154,
                205,
                50
            ]
        };
        function Ie(t, e1, n) {
            return t + n * (e1 - t);
        }
        function Ee(t, e1, n) {
            return t.map((t, r)=>Ie(t, e1[r], n));
        }
        class Te {
            constructor(t, e1, n, r = 1, i = !0){
                this.r = t, this.g = e1, this.b = n, this.a = r, i || (this.r *= r, this.g *= r, this.b *= r, r || this.overwriteGetter("rgb", [
                    t,
                    e1,
                    n,
                    r
                ]));
            }
            static parse(t) {
                if (t instanceof Te) return t;
                if ("string" != typeof t) return;
                const e1 = function(t) {
                    if ("transparent" === (t = t.toLowerCase().trim())) return [
                        0,
                        0,
                        0,
                        0
                    ];
                    const e1 = we(ke, t);
                    if (e1) {
                        const [t, n, r] = e1;
                        return [
                            t / 255,
                            n / 255,
                            r / 255,
                            1
                        ];
                    }
                    if (t.startsWith("#") && /^#(?:[0-9a-f]{3,4}|[0-9a-f]{6}|[0-9a-f]{8})$/.test(t)) {
                        const e1 = t.length < 6 ? 1 : 2;
                        let n = 1;
                        return [
                            _e(t.slice(n, n += e1)),
                            _e(t.slice(n, n += e1)),
                            _e(t.slice(n, n += e1)),
                            _e(t.slice(n, n + e1) || "ff")
                        ];
                    }
                    if (t.startsWith("rgb")) {
                        const e1 = t.match(/^rgba?\(\s*([\de.+-]+)(%)?(?:\s+|\s*(,)\s*)([\de.+-]+)(%)?(?:\s+|\s*(,)\s*)([\de.+-]+)(%)?(?:\s*([,\/])\s*([\de.+-]+)(%)?)?\s*\)$/);
                        if (e1) {
                            const [t, n, r, i, s, o, a, l, u, c, h, p] = e1, f = [
                                i || " ",
                                a || " ",
                                c
                            ].join("");
                            if ("  " === f || "  /" === f || ",," === f || ",,," === f) {
                                const t = [
                                    r,
                                    o,
                                    u
                                ].join(""), e1 = "%%%" === t ? 100 : "" === t ? 255 : 0;
                                if (e1) {
                                    const t = [
                                        Ae(+n / e1, 0, 1),
                                        Ae(+s / e1, 0, 1),
                                        Ae(+l / e1, 0, 1),
                                        h ? Se(+h, p) : 1
                                    ];
                                    if (Me(t)) return t;
                                }
                            }
                            return;
                        }
                    }
                    const n = t.match(/^hsla?\(\s*([\de.+-]+)(?:deg)?(?:\s+|\s*(,)\s*)([\de.+-]+)%(?:\s+|\s*(,)\s*)([\de.+-]+)%(?:\s*([,\/])\s*([\de.+-]+)(%)?)?\s*\)$/);
                    if (n) {
                        const [t, e1, r, i, s, o, a, l, u] = n, c = [
                            r || " ",
                            s || " ",
                            a
                        ].join("");
                        if ("  " === c || "  /" === c || ",," === c || ",,," === c) {
                            const t = [
                                +e1,
                                Ae(+i, 0, 100),
                                Ae(+o, 0, 100),
                                l ? Se(+l, u) : 1
                            ];
                            if (Me(t)) return function([t, e1, n, r]) {
                                function i(r) {
                                    const i = (r + t / 30) % 12, s = e1 * Math.min(n, 1 - n);
                                    return n - s * Math.max(-1, Math.min(i - 3, 9 - i, 1));
                                }
                                return t = fe(t), e1 /= 100, n /= 100, [
                                    i(0),
                                    i(8),
                                    i(4),
                                    r
                                ];
                            }(t);
                        }
                    }
                }(t);
                return e1 ? new Te(...e1, !1) : void 0;
            }
            get rgb() {
                const { r: t, g: e1, b: n, a: r } = this, i = r || 1 / 0;
                return this.overwriteGetter("rgb", [
                    t / i,
                    e1 / i,
                    n / i,
                    r
                ]);
            }
            get hcl() {
                return this.overwriteGetter("hcl", function(t) {
                    const [e1, n, r, i] = de(t), s = Math.sqrt(n * n + r * r);
                    return [
                        Math.round(1e4 * s) ? fe(Math.atan2(r, n) * pe) : NaN,
                        s,
                        e1,
                        i
                    ];
                }(this.rgb));
            }
            get lab() {
                return this.overwriteGetter("lab", de(this.rgb));
            }
            overwriteGetter(t, e1) {
                return Object.defineProperty(this, t, {
                    value: e1
                }), e1;
            }
            toString() {
                const [t, e1, n, r] = this.rgb;
                return `rgba(${[
                    t,
                    e1,
                    n
                ].map((t)=>Math.round(255 * t)).join(",")},${r})`;
            }
            static interpolate(t, e1, n, r = "rgb") {
                switch(r){
                    case "rgb":
                        {
                            const [r, i, s, o] = Ee(t.rgb, e1.rgb, n);
                            return new Te(r, i, s, o, !1);
                        }
                    case "hcl":
                        {
                            const [r, i, s, o] = t.hcl, [a, l, u, c] = e1.hcl;
                            let h, p;
                            if (isNaN(r) || isNaN(a)) isNaN(r) ? isNaN(a) ? h = NaN : (h = a, 1 !== s && 0 !== s || (p = l)) : (h = r, 1 !== u && 0 !== u || (p = i));
                            else {
                                let t = a - r;
                                a > r && t > 180 ? t -= 360 : a < r && r - a > 180 && (t += 360), h = r + n * t;
                            }
                            const [f, d, y, m] = function([t, e1, n, r]) {
                                return t = isNaN(t) ? 0 : t * he, ge([
                                    n,
                                    Math.cos(t) * e1,
                                    Math.sin(t) * e1,
                                    r
                                ]);
                            }([
                                h,
                                null != p ? p : Ie(i, l, n),
                                Ie(s, u, n),
                                Ie(o, c, n)
                            ]);
                            return new Te(f, d, y, m, !1);
                        }
                    case "lab":
                        {
                            const [r, i, s, o] = ge(Ee(t.lab, e1.lab, n));
                            return new Te(r, i, s, o, !1);
                        }
                }
            }
        }
        Te.black = new Te(0, 0, 0, 1), Te.white = new Te(1, 1, 1, 1), Te.transparent = new Te(0, 0, 0, 0), Te.red = new Te(1, 0, 0, 1);
        class Fe {
            constructor(t, e1, n){
                this.sensitivity = t ? e1 ? "variant" : "case" : e1 ? "accent" : "base", this.locale = n, this.collator = new Intl.Collator(this.locale ? this.locale : [], {
                    sensitivity: this.sensitivity,
                    usage: "search"
                });
            }
            compare(t, e1) {
                return this.collator.compare(t, e1);
            }
            resolvedLocale() {
                return new Intl.Collator(this.locale ? this.locale : []).resolvedOptions().locale;
            }
        }
        const Pe = [
            "bottom",
            "center",
            "top"
        ];
        class De {
            constructor(t, e1, n, r, i, s){
                this.text = t, this.image = e1, this.scale = n, this.fontStack = r, this.textColor = i, this.verticalAlign = s;
            }
        }
        class ze {
            constructor(t){
                this.sections = t;
            }
            static fromString(t) {
                return new ze([
                    new De(t, null, null, null, null, null)
                ]);
            }
            isEmpty() {
                return 0 === this.sections.length || !this.sections.some((t)=>0 !== t.text.length || t.image && 0 !== t.image.name.length);
            }
            static factory(t) {
                return t instanceof ze ? t : ze.fromString(t);
            }
            toString() {
                return 0 === this.sections.length ? "" : this.sections.map((t)=>t.text).join("");
            }
        }
        class Be {
            constructor(t){
                this.values = t.slice();
            }
            static parse(t) {
                if (t instanceof Be) return t;
                if ("number" == typeof t) return new Be([
                    t,
                    t,
                    t,
                    t
                ]);
                if (Array.isArray(t) && !(t.length < 1 || t.length > 4)) {
                    for (const e1 of t)if ("number" != typeof e1) return;
                    switch(t.length){
                        case 1:
                            t = [
                                t[0],
                                t[0],
                                t[0],
                                t[0]
                            ];
                            break;
                        case 2:
                            t = [
                                t[0],
                                t[1],
                                t[0],
                                t[1]
                            ];
                            break;
                        case 3:
                            t = [
                                t[0],
                                t[1],
                                t[2],
                                t[1]
                            ];
                    }
                    return new Be(t);
                }
            }
            toString() {
                return JSON.stringify(this.values);
            }
            static interpolate(t, e1, n) {
                return new Be(Ee(t.values, e1.values, n));
            }
        }
        class Ce {
            constructor(t){
                this.values = t.slice();
            }
            static parse(t) {
                if (t instanceof Ce) return t;
                if ("number" == typeof t) return new Ce([
                    t
                ]);
                if (Array.isArray(t)) {
                    for (const e1 of t)if ("number" != typeof e1) return;
                    return new Ce(t);
                }
            }
            toString() {
                return JSON.stringify(this.values);
            }
            static interpolate(t, e1, n) {
                return new Ce(Ee(t.values, e1.values, n));
            }
        }
        class Ve {
            constructor(t){
                this.values = t.slice();
            }
            static parse(t) {
                if (t instanceof Ve) return t;
                if ("string" == typeof t) {
                    const e1 = Te.parse(t);
                    if (!e1) return;
                    return new Ve([
                        e1
                    ]);
                }
                if (!Array.isArray(t)) return;
                const e1 = [];
                for (const n of t){
                    if ("string" != typeof n) return;
                    const t = Te.parse(n);
                    if (!t) return;
                    e1.push(t);
                }
                return new Ve(e1);
            }
            toString() {
                return JSON.stringify(this.values);
            }
            static interpolate(t, e1, n, r = "rgb") {
                const i = [];
                if (t.values.length != e1.values.length) throw new Error(`colorArray: Arrays have mismatched length (${t.values.length} vs. ${e1.values.length}), cannot interpolate.`);
                for(let s = 0; s < t.values.length; s++)i.push(Te.interpolate(t.values[s], e1.values[s], n, r));
                return new Ve(i);
            }
        }
        class Le extends Error {
            constructor(t){
                super(t), this.name = "RuntimeError";
            }
            toJSON() {
                return this.message;
            }
        }
        const Oe = new Set([
            "center",
            "left",
            "right",
            "top",
            "bottom",
            "top-left",
            "top-right",
            "bottom-left",
            "bottom-right"
        ]);
        class $e {
            constructor(t){
                this.values = t.slice();
            }
            static parse(t) {
                if (t instanceof $e) return t;
                if (Array.isArray(t) && !(t.length < 1) && t.length % 2 == 0) {
                    for(let e1 = 0; e1 < t.length; e1 += 2){
                        const n = t[e1], r = t[e1 + 1];
                        if ("string" != typeof n || !Oe.has(n)) return;
                        if (!Array.isArray(r) || 2 !== r.length || "number" != typeof r[0] || "number" != typeof r[1]) return;
                    }
                    return new $e(t);
                }
            }
            toString() {
                return JSON.stringify(this.values);
            }
            static interpolate(t, e1, n) {
                const r = t.values, i = e1.values;
                if (r.length !== i.length) throw new Le(`Cannot interpolate values of different length. from: ${t.toString()}, to: ${e1.toString()}`);
                const s = [];
                for(let t = 0; t < r.length; t += 2){
                    if (r[t] !== i[t]) throw new Le(`Cannot interpolate values containing mismatched anchors. from[${t}]: ${r[t]}, to[${t}]: ${i[t]}`);
                    s.push(r[t]);
                    const [e1, o] = r[t + 1], [a, l] = i[t + 1];
                    s.push([
                        Ie(e1, a, n),
                        Ie(o, l, n)
                    ]);
                }
                return new $e(s);
            }
        }
        class Re {
            constructor(t){
                this.name = t.name, this.available = t.available;
            }
            toString() {
                return this.name;
            }
            static fromString(t) {
                return t ? new Re({
                    name: t,
                    available: !1
                }) : null;
            }
        }
        class Ne {
            constructor(t, e1, n){
                this.from = t, this.to = e1, this.transition = n;
            }
            static interpolate(t, e1, n) {
                return new Ne(t, e1, n);
            }
            static parse(t) {
                return t instanceof Ne ? t : Array.isArray(t) && 3 === t.length && "string" == typeof t[0] && "string" == typeof t[1] && "number" == typeof t[2] ? new Ne(t[0], t[1], t[2]) : "object" == typeof t && "string" == typeof t.from && "string" == typeof t.to && "number" == typeof t.transition ? new Ne(t.from, t.to, t.transition) : "string" == typeof t ? new Ne(t, t, 1) : void 0;
            }
        }
        function Ue(t, e1, n, r) {
            return "number" == typeof t && t >= 0 && t <= 255 && "number" == typeof e1 && e1 >= 0 && e1 <= 255 && "number" == typeof n && n >= 0 && n <= 255 ? void 0 === r || "number" == typeof r && r >= 0 && r <= 1 ? null : `Invalid rgba value [${[
                t,
                e1,
                n,
                r
            ].join(", ")}]: 'a' must be between 0 and 1.` : `Invalid rgba value [${("number" == typeof r ? [
                t,
                e1,
                n,
                r
            ] : [
                t,
                e1,
                n
            ]).join(", ")}]: 'r', 'g', and 'b' must be between 0 and 255.`;
        }
        function je(t) {
            if (null === t || "string" == typeof t || "boolean" == typeof t || "number" == typeof t || t instanceof Ne || t instanceof Te || t instanceof Fe || t instanceof ze || t instanceof Be || t instanceof Ce || t instanceof Ve || t instanceof $e || t instanceof Re) return !0;
            if (Array.isArray(t)) {
                for (const e1 of t)if (!je(e1)) return !1;
                return !0;
            }
            if ("object" == typeof t) {
                for(const e1 in t)if (!je(t[e1])) return !1;
                return !0;
            }
            return !1;
        }
        function qe(t) {
            if (null === t) return Lt;
            if ("string" == typeof t) return $t;
            if ("boolean" == typeof t) return Rt;
            if ("number" == typeof t) return Ot;
            if (t instanceof Te) return Nt;
            if (t instanceof Ne) return Ut;
            if (t instanceof Fe) return Gt;
            if (t instanceof ze) return Xt;
            if (t instanceof Be) return Yt;
            if (t instanceof Ce) return Ht;
            if (t instanceof Ve) return Zt;
            if (t instanceof $e) return Kt;
            if (t instanceof Re) return Wt;
            if (Array.isArray(t)) {
                const e1 = t.length;
                let n;
                for (const e1 of t){
                    const t = qe(e1);
                    if (n) {
                        if (n === t) continue;
                        n = qt;
                        break;
                    }
                    n = t;
                }
                return Jt(n || qt, e1);
            }
            return jt;
        }
        function Ge(t) {
            const e1 = typeof t;
            return null === t ? "" : "string" === e1 || "number" === e1 || "boolean" === e1 ? String(t) : t instanceof Te || t instanceof Ne || t instanceof ze || t instanceof Be || t instanceof Ce || t instanceof Ve || t instanceof $e || t instanceof Re ? t.toString() : JSON.stringify(t);
        }
        class Xe {
            constructor(t, e1){
                this.type = t, this.value = e1;
            }
            static parse(t, e1) {
                if (2 !== t.length) return e1.error(`'literal' expression requires exactly one argument, but found ${t.length - 1} instead.`);
                if (!je(t[1])) return e1.error("invalid value");
                const n = t[1];
                let r = qe(n);
                const i = e1.expectedType;
                return "array" !== r.kind || 0 !== r.N || !i || "array" !== i.kind || "number" == typeof i.N && 0 !== i.N || (r = i), new Xe(r, n);
            }
            evaluate() {
                return this.value;
            }
            eachChild() {}
            outputDefined() {
                return !0;
            }
        }
        const Ye = {
            string: $t,
            number: Ot,
            boolean: Rt,
            object: jt
        };
        class Ze {
            constructor(t, e1){
                this.type = t, this.args = e1;
            }
            static parse(t, e1) {
                if (t.length < 2) return e1.error("Expected at least one argument.");
                let n, r = 1;
                const i = t[0];
                if ("array" === i) {
                    let i, s;
                    if (t.length > 2) {
                        const n = t[1];
                        if ("string" != typeof n || !(n in Ye) || "object" === n) return e1.error('The item type argument of "array" must be one of string, number, boolean', 1);
                        i = Ye[n], r++;
                    } else i = qt;
                    if (t.length > 3) {
                        if (null !== t[2] && ("number" != typeof t[2] || t[2] < 0 || t[2] !== Math.floor(t[2]))) return e1.error('The length argument to "array" must be a positive integer literal', 2);
                        s = t[2], r++;
                    }
                    n = Jt(i, s);
                } else {
                    if (!Ye[i]) throw new Error(`Types doesn't contain name = ${i}`);
                    n = Ye[i];
                }
                const s = [];
                for(; r < t.length; r++){
                    const n = e1.parse(t[r], r, qt);
                    if (!n) return null;
                    s.push(n);
                }
                return new Ze(n, s);
            }
            evaluate(t) {
                for(let e1 = 0; e1 < this.args.length; e1++){
                    const n = this.args[e1].evaluate(t);
                    if (!ee(this.type, qe(n))) return n;
                    if (e1 === this.args.length - 1) throw new Le(`Expected value to be of type ${Qt(this.type)}, but found ${Qt(qe(n))} instead.`);
                }
                throw new Error;
            }
            eachChild(t) {
                this.args.forEach(t);
            }
            outputDefined() {
                return this.args.every((t)=>t.outputDefined());
            }
        }
        const He = {
            "to-boolean": Rt,
            "to-color": Nt,
            "to-number": Ot,
            "to-string": $t
        };
        class We {
            constructor(t, e1){
                this.type = t, this.args = e1;
            }
            static parse(t, e1) {
                if (t.length < 2) return e1.error("Expected at least one argument.");
                const n = t[0];
                if (!He[n]) throw new Error(`Can't parse ${n} as it is not part of the known types`);
                if (("to-boolean" === n || "to-string" === n) && 2 !== t.length) return e1.error("Expected one argument.");
                const r = He[n], i = [];
                for(let n = 1; n < t.length; n++){
                    const r = e1.parse(t[n], n, qt);
                    if (!r) return null;
                    i.push(r);
                }
                return new We(r, i);
            }
            evaluate(t) {
                switch(this.type.kind){
                    case "boolean":
                        return Boolean(this.args[0].evaluate(t));
                    case "color":
                        {
                            let e1, n;
                            for (const r of this.args){
                                if (e1 = r.evaluate(t), n = null, e1 instanceof Te) return e1;
                                if ("string" == typeof e1) {
                                    const n = t.parseColor(e1);
                                    if (n) return n;
                                } else if (Array.isArray(e1) && (n = e1.length < 3 || e1.length > 4 ? `Invalid rgba value ${JSON.stringify(e1)}: expected an array containing either three or four numeric values.` : Ue(e1[0], e1[1], e1[2], e1[3]), !n)) return new Te(e1[0] / 255, e1[1] / 255, e1[2] / 255, e1[3]);
                            }
                            throw new Le(n || `Could not parse color from value '${"string" == typeof e1 ? e1 : JSON.stringify(e1)}'`);
                        }
                    case "padding":
                        {
                            let e1;
                            for (const n of this.args){
                                e1 = n.evaluate(t);
                                const r = Be.parse(e1);
                                if (r) return r;
                            }
                            throw new Le(`Could not parse padding from value '${"string" == typeof e1 ? e1 : JSON.stringify(e1)}'`);
                        }
                    case "numberArray":
                        {
                            let e1;
                            for (const n of this.args){
                                e1 = n.evaluate(t);
                                const r = Ce.parse(e1);
                                if (r) return r;
                            }
                            throw new Le(`Could not parse numberArray from value '${"string" == typeof e1 ? e1 : JSON.stringify(e1)}'`);
                        }
                    case "colorArray":
                        {
                            let e1;
                            for (const n of this.args){
                                e1 = n.evaluate(t);
                                const r = Ve.parse(e1);
                                if (r) return r;
                            }
                            throw new Le(`Could not parse colorArray from value '${"string" == typeof e1 ? e1 : JSON.stringify(e1)}'`);
                        }
                    case "variableAnchorOffsetCollection":
                        {
                            let e1;
                            for (const n of this.args){
                                e1 = n.evaluate(t);
                                const r = $e.parse(e1);
                                if (r) return r;
                            }
                            throw new Le(`Could not parse variableAnchorOffsetCollection from value '${"string" == typeof e1 ? e1 : JSON.stringify(e1)}'`);
                        }
                    case "number":
                        {
                            let e1 = null;
                            for (const n of this.args){
                                if (e1 = n.evaluate(t), null === e1) return 0;
                                const r = Number(e1);
                                if (!isNaN(r)) return r;
                            }
                            throw new Le(`Could not convert ${JSON.stringify(e1)} to number.`);
                        }
                    case "formatted":
                        return ze.fromString(Ge(this.args[0].evaluate(t)));
                    case "resolvedImage":
                        return Re.fromString(Ge(this.args[0].evaluate(t)));
                    case "projectionDefinition":
                        return this.args[0].evaluate(t);
                    default:
                        return Ge(this.args[0].evaluate(t));
                }
            }
            eachChild(t) {
                this.args.forEach(t);
            }
            outputDefined() {
                return this.args.every((t)=>t.outputDefined());
            }
        }
        const Ke = [
            "Unknown",
            "Point",
            "LineString",
            "Polygon"
        ];
        class Je {
            constructor(){
                this.globals = null, this.feature = null, this.featureState = null, this.formattedSection = null, this._parseColorCache = new Map, this.availableImages = null, this.canonical = null;
            }
            id() {
                return this.feature && "id" in this.feature ? this.feature.id : null;
            }
            geometryType() {
                return this.feature ? "number" == typeof this.feature.type ? Ke[this.feature.type] : this.feature.type : null;
            }
            geometry() {
                return this.feature && "geometry" in this.feature ? this.feature.geometry : null;
            }
            canonicalID() {
                return this.canonical;
            }
            properties() {
                return this.feature && this.feature.properties || {};
            }
            parseColor(t) {
                let e1 = this._parseColorCache.get(t);
                return e1 || (e1 = Te.parse(t), this._parseColorCache.set(t, e1)), e1;
            }
        }
        class Qe {
            constructor(t, e1, n = [], r, i = new Vt, s = []){
                this.registry = t, this.path = n, this.key = n.map((t)=>`[${t}]`).join(""), this.scope = i, this.errors = s, this.expectedType = r, this._isConstant = e1;
            }
            parse(t, e1, n, r, i = {}) {
                return e1 ? this.concat(e1, n, r)._parse(t, i) : this._parse(t, i);
            }
            _parse(t, e1) {
                function n(t, e1, n) {
                    return "assert" === n ? new Ze(e1, [
                        t
                    ]) : "coerce" === n ? new We(e1, [
                        t
                    ]) : t;
                }
                if (null !== t && "string" != typeof t && "boolean" != typeof t && "number" != typeof t || (t = [
                    "literal",
                    t
                ]), Array.isArray(t)) {
                    if (0 === t.length) return this.error('Expected an array with at least one element. If you wanted a literal array, use ["literal", []].');
                    const r = t[0];
                    if ("string" != typeof r) return this.error(`Expression name must be a string, but found ${typeof r} instead. If you wanted a literal array, use ["literal", [...]].`, 0), null;
                    const i = this.registry[r];
                    if (i) {
                        let r = i.parse(t, this);
                        if (!r) return null;
                        if (this.expectedType) {
                            const t = this.expectedType, i = r.type;
                            if ("string" !== t.kind && "number" !== t.kind && "boolean" !== t.kind && "object" !== t.kind && "array" !== t.kind || "value" !== i.kind) {
                                if ("projectionDefinition" === t.kind && [
                                    "string",
                                    "array"
                                ].includes(i.kind) || [
                                    "color",
                                    "formatted",
                                    "resolvedImage"
                                ].includes(t.kind) && [
                                    "value",
                                    "string"
                                ].includes(i.kind) || [
                                    "padding",
                                    "numberArray"
                                ].includes(t.kind) && [
                                    "value",
                                    "number",
                                    "array"
                                ].includes(i.kind) || "colorArray" === t.kind && [
                                    "value",
                                    "string",
                                    "array"
                                ].includes(i.kind) || "variableAnchorOffsetCollection" === t.kind && [
                                    "value",
                                    "array"
                                ].includes(i.kind)) r = n(r, t, e1.typeAnnotation || "coerce");
                                else if (this.checkSubtype(t, i)) return null;
                            } else r = n(r, t, e1.typeAnnotation || "assert");
                        }
                        if (!(r instanceof Xe) && "resolvedImage" !== r.type.kind && this._isConstant(r)) {
                            const t = new Je;
                            try {
                                r = new Xe(r.type, r.evaluate(t));
                            } catch (t) {
                                return this.error(t.message), null;
                            }
                        }
                        return r;
                    }
                    return this.error(`Unknown expression "${r}". If you wanted a literal array, use ["literal", [...]].`, 0);
                }
                return this.error(void 0 === t ? "'undefined' value invalid. Use null instead." : "object" == typeof t ? 'Bare objects invalid. Use ["literal", {...}] instead.' : `Expected an array, but found ${typeof t} instead.`);
            }
            concat(t, e1, n) {
                const r = "number" == typeof t ? this.path.concat(t) : this.path, i = n ? this.scope.concat(n) : this.scope;
                return new Qe(this.registry, this._isConstant, r, e1 || null, i, this.errors);
            }
            error(t, ...e1) {
                const n = `${this.key}${e1.map((t)=>`[${t}]`).join("")}`;
                this.errors.push(new Ct(n, t));
            }
            checkSubtype(t, e1) {
                const n = ee(t, e1);
                return n && this.error(n), n;
            }
        }
        class tn {
            constructor(t, e1){
                this.type = e1.type, this.bindings = [].concat(t), this.result = e1;
            }
            evaluate(t) {
                return this.result.evaluate(t);
            }
            eachChild(t) {
                for (const e1 of this.bindings)t(e1[1]);
                t(this.result);
            }
            static parse(t, e1) {
                if (t.length < 4) return e1.error(`Expected at least 3 arguments, but found ${t.length - 1} instead.`);
                const n = [];
                for(let r = 1; r < t.length - 1; r += 2){
                    const i = t[r];
                    if ("string" != typeof i) return e1.error(`Expected string, but found ${typeof i} instead.`, r);
                    if (/[^a-zA-Z0-9_]/.test(i)) return e1.error("Variable names must contain only alphanumeric characters or '_'.", r);
                    const s = e1.parse(t[r + 1], r + 1);
                    if (!s) return null;
                    n.push([
                        i,
                        s
                    ]);
                }
                const r = e1.parse(t[t.length - 1], t.length - 1, e1.expectedType, n);
                return r ? new tn(n, r) : null;
            }
            outputDefined() {
                return this.result.outputDefined();
            }
        }
        class en {
            constructor(t, e1){
                this.type = e1.type, this.name = t, this.boundExpression = e1;
            }
            static parse(t, e1) {
                if (2 !== t.length || "string" != typeof t[1]) return e1.error("'var' expression requires exactly one string literal argument.");
                const n = t[1];
                return e1.scope.has(n) ? new en(n, e1.scope.get(n)) : e1.error(`Unknown variable "${n}". Make sure "${n}" has been bound in an enclosing "let" expression before using it.`, 1);
            }
            evaluate(t) {
                return this.boundExpression.evaluate(t);
            }
            eachChild() {}
            outputDefined() {
                return !1;
            }
        }
        class nn {
            constructor(t, e1, n){
                this.type = t, this.index = e1, this.input = n;
            }
            static parse(t, e1) {
                if (3 !== t.length) return e1.error(`Expected 2 arguments, but found ${t.length - 1} instead.`);
                const n = e1.parse(t[1], 1, Ot), r = e1.parse(t[2], 2, Jt(e1.expectedType || qt));
                return n && r ? new nn(r.type.itemType, n, r) : null;
            }
            evaluate(t) {
                const e1 = this.index.evaluate(t), n = this.input.evaluate(t);
                if (e1 < 0) throw new Le(`Array index out of bounds: ${e1} < 0.`);
                if (e1 >= n.length) throw new Le(`Array index out of bounds: ${e1} > ${n.length - 1}.`);
                if (e1 !== Math.floor(e1)) throw new Le(`Array index must be an integer, but found ${e1} instead.`);
                return n[e1];
            }
            eachChild(t) {
                t(this.index), t(this.input);
            }
            outputDefined() {
                return !1;
            }
        }
        class rn {
            constructor(t, e1){
                this.type = Rt, this.needle = t, this.haystack = e1;
            }
            static parse(t, e1) {
                if (3 !== t.length) return e1.error(`Expected 2 arguments, but found ${t.length - 1} instead.`);
                const n = e1.parse(t[1], 1, qt), r = e1.parse(t[2], 2, qt);
                return n && r ? ne(n.type, [
                    Rt,
                    $t,
                    Ot,
                    Lt,
                    qt
                ]) ? new rn(n, r) : e1.error(`Expected first argument to be of type boolean, string, number or null, but found ${Qt(n.type)} instead`) : null;
            }
            evaluate(t) {
                const e1 = this.needle.evaluate(t), n = this.haystack.evaluate(t);
                if (!n) return !1;
                if (!re(e1, [
                    "boolean",
                    "string",
                    "number",
                    "null"
                ])) throw new Le(`Expected first argument to be of type boolean, string, number or null, but found ${Qt(qe(e1))} instead.`);
                if (!re(n, [
                    "string",
                    "array"
                ])) throw new Le(`Expected second argument to be of type array or string, but found ${Qt(qe(n))} instead.`);
                return n.indexOf(e1) >= 0;
            }
            eachChild(t) {
                t(this.needle), t(this.haystack);
            }
            outputDefined() {
                return !0;
            }
        }
        class sn {
            constructor(t, e1, n){
                this.type = Ot, this.needle = t, this.haystack = e1, this.fromIndex = n;
            }
            static parse(t, e1) {
                if (t.length <= 2 || t.length >= 5) return e1.error(`Expected 2 or 3 arguments, but found ${t.length - 1} instead.`);
                const n = e1.parse(t[1], 1, qt), r = e1.parse(t[2], 2, qt);
                if (!n || !r) return null;
                if (!ne(n.type, [
                    Rt,
                    $t,
                    Ot,
                    Lt,
                    qt
                ])) return e1.error(`Expected first argument to be of type boolean, string, number or null, but found ${Qt(n.type)} instead`);
                if (4 === t.length) {
                    const i = e1.parse(t[3], 3, Ot);
                    return i ? new sn(n, r, i) : null;
                }
                return new sn(n, r);
            }
            evaluate(t) {
                const e1 = this.needle.evaluate(t), n = this.haystack.evaluate(t);
                if (!re(e1, [
                    "boolean",
                    "string",
                    "number",
                    "null"
                ])) throw new Le(`Expected first argument to be of type boolean, string, number or null, but found ${Qt(qe(e1))} instead.`);
                let r;
                if (this.fromIndex && (r = this.fromIndex.evaluate(t)), re(n, [
                    "string"
                ])) {
                    const t = n.indexOf(e1, r);
                    return -1 === t ? -1 : [
                        ...n.slice(0, t)
                    ].length;
                }
                if (re(n, [
                    "array"
                ])) return n.indexOf(e1, r);
                throw new Le(`Expected second argument to be of type array or string, but found ${Qt(qe(n))} instead.`);
            }
            eachChild(t) {
                t(this.needle), t(this.haystack), this.fromIndex && t(this.fromIndex);
            }
            outputDefined() {
                return !1;
            }
        }
        class on {
            constructor(t, e1, n, r, i, s){
                this.inputType = t, this.type = e1, this.input = n, this.cases = r, this.outputs = i, this.otherwise = s;
            }
            static parse(t, e1) {
                if (t.length < 5) return e1.error(`Expected at least 4 arguments, but found only ${t.length - 1}.`);
                if (t.length % 2 != 1) return e1.error("Expected an even number of arguments.");
                let n, r;
                e1.expectedType && "value" !== e1.expectedType.kind && (r = e1.expectedType);
                const i = {}, s = [];
                for(let o = 2; o < t.length - 1; o += 2){
                    let a = t[o];
                    const l = t[o + 1];
                    Array.isArray(a) || (a = [
                        a
                    ]);
                    const u = e1.concat(o);
                    if (0 === a.length) return u.error("Expected at least one branch label.");
                    for (const t of a){
                        if ("number" != typeof t && "string" != typeof t) return u.error("Branch labels must be numbers or strings.");
                        if ("number" == typeof t && Math.abs(t) > Number.MAX_SAFE_INTEGER) return u.error(`Branch labels must be integers no larger than ${Number.MAX_SAFE_INTEGER}.`);
                        if ("number" == typeof t && Math.floor(t) !== t) return u.error("Numeric branch labels must be integer values.");
                        if (n) {
                            if (u.checkSubtype(n, qe(t))) return null;
                        } else n = qe(t);
                        if (void 0 !== i[String(t)]) return u.error("Branch labels must be unique.");
                        i[String(t)] = s.length;
                    }
                    const c = e1.parse(l, o, r);
                    if (!c) return null;
                    r = r || c.type, s.push(c);
                }
                const o = e1.parse(t[1], 1, qt);
                if (!o) return null;
                const a = e1.parse(t[t.length - 1], t.length - 1, r);
                return a ? "value" !== o.type.kind && e1.concat(1).checkSubtype(n, o.type) ? null : new on(n, r, o, i, s, a) : null;
            }
            evaluate(t) {
                const e1 = this.input.evaluate(t);
                return (qe(e1) === this.inputType && this.outputs[this.cases[e1]] || this.otherwise).evaluate(t);
            }
            eachChild(t) {
                t(this.input), this.outputs.forEach(t), t(this.otherwise);
            }
            outputDefined() {
                return this.outputs.every((t)=>t.outputDefined()) && this.otherwise.outputDefined();
            }
        }
        class an {
            constructor(t, e1, n){
                this.type = t, this.branches = e1, this.otherwise = n;
            }
            static parse(t, e1) {
                if (t.length < 4) return e1.error(`Expected at least 3 arguments, but found only ${t.length - 1}.`);
                if (t.length % 2 != 0) return e1.error("Expected an odd number of arguments.");
                let n;
                e1.expectedType && "value" !== e1.expectedType.kind && (n = e1.expectedType);
                const r = [];
                for(let i = 1; i < t.length - 1; i += 2){
                    const s = e1.parse(t[i], i, Rt);
                    if (!s) return null;
                    const o = e1.parse(t[i + 1], i + 1, n);
                    if (!o) return null;
                    r.push([
                        s,
                        o
                    ]), n = n || o.type;
                }
                const i = e1.parse(t[t.length - 1], t.length - 1, n);
                if (!i) return null;
                if (!n) throw new Error("Can't infer output type");
                return new an(n, r, i);
            }
            evaluate(t) {
                for (const [e1, n] of this.branches)if (e1.evaluate(t)) return n.evaluate(t);
                return this.otherwise.evaluate(t);
            }
            eachChild(t) {
                for (const [e1, n] of this.branches)t(e1), t(n);
                t(this.otherwise);
            }
            outputDefined() {
                return this.branches.every(([t, e1])=>e1.outputDefined()) && this.otherwise.outputDefined();
            }
        }
        class ln {
            constructor(t, e1, n, r){
                this.type = t, this.input = e1, this.beginIndex = n, this.endIndex = r;
            }
            static parse(t, e1) {
                if (t.length <= 2 || t.length >= 5) return e1.error(`Expected 2 or 3 arguments, but found ${t.length - 1} instead.`);
                const n = e1.parse(t[1], 1, qt), r = e1.parse(t[2], 2, Ot);
                if (!n || !r) return null;
                if (!ne(n.type, [
                    Jt(qt),
                    $t,
                    qt
                ])) return e1.error(`Expected first argument to be of type array or string, but found ${Qt(n.type)} instead`);
                if (4 === t.length) {
                    const i = e1.parse(t[3], 3, Ot);
                    return i ? new ln(n.type, n, r, i) : null;
                }
                return new ln(n.type, n, r);
            }
            evaluate(t) {
                const e1 = this.input.evaluate(t), n = this.beginIndex.evaluate(t);
                let r;
                if (this.endIndex && (r = this.endIndex.evaluate(t)), re(e1, [
                    "string"
                ])) return [
                    ...e1
                ].slice(n, r).join("");
                if (re(e1, [
                    "array"
                ])) return e1.slice(n, r);
                throw new Le(`Expected first argument to be of type array or string, but found ${Qt(qe(e1))} instead.`);
            }
            eachChild(t) {
                t(this.input), t(this.beginIndex), this.endIndex && t(this.endIndex);
            }
            outputDefined() {
                return !1;
            }
        }
        function un(t, e1) {
            const n = t.length - 1;
            let r, i, s = 0, o = n, a = 0;
            for(; s <= o;)if (a = Math.floor((s + o) / 2), r = t[a], i = t[a + 1], r <= e1) {
                if (a === n || e1 < i) return a;
                s = a + 1;
            } else {
                if (!(r > e1)) throw new Le("Input is not a number.");
                o = a - 1;
            }
            return 0;
        }
        class cn {
            constructor(t, e1, n){
                this.type = t, this.input = e1, this.labels = [], this.outputs = [];
                for (const [t, e1] of n)this.labels.push(t), this.outputs.push(e1);
            }
            static parse(t, e1) {
                if (t.length - 1 < 4) return e1.error(`Expected at least 4 arguments, but found only ${t.length - 1}.`);
                if ((t.length - 1) % 2 != 0) return e1.error("Expected an even number of arguments.");
                const n = e1.parse(t[1], 1, Ot);
                if (!n) return null;
                const r = [];
                let i = null;
                e1.expectedType && "value" !== e1.expectedType.kind && (i = e1.expectedType);
                for(let n = 1; n < t.length; n += 2){
                    const s = 1 === n ? -1 / 0 : t[n], o = t[n + 1], a = n, l = n + 1;
                    if ("number" != typeof s) return e1.error('Input/output pairs for "step" expressions must be defined using literal numeric values (not computed expressions) for the input values.', a);
                    if (r.length && r[r.length - 1][0] >= s) return e1.error('Input/output pairs for "step" expressions must be arranged with input values in strictly ascending order.', a);
                    const u = e1.parse(o, l, i);
                    if (!u) return null;
                    i = i || u.type, r.push([
                        s,
                        u
                    ]);
                }
                return new cn(i, n, r);
            }
            evaluate(t) {
                const e1 = this.labels, n = this.outputs;
                if (1 === e1.length) return n[0].evaluate(t);
                const r = this.input.evaluate(t);
                if (r <= e1[0]) return n[0].evaluate(t);
                const i = e1.length;
                return r >= e1[i - 1] ? n[i - 1].evaluate(t) : n[un(e1, r)].evaluate(t);
            }
            eachChild(t) {
                t(this.input);
                for (const e1 of this.outputs)t(e1);
            }
            outputDefined() {
                return this.outputs.every((t)=>t.outputDefined());
            }
        }
        function hn(t) {
            return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
        }
        var pn, fn, dn = function() {
            if (fn) return pn;
            function t(t, e1, n, r) {
                this.cx = 3 * t, this.bx = 3 * (n - t) - this.cx, this.ax = 1 - this.cx - this.bx, this.cy = 3 * e1, this.by = 3 * (r - e1) - this.cy, this.ay = 1 - this.cy - this.by, this.p1x = t, this.p1y = e1, this.p2x = n, this.p2y = r;
            }
            return fn = 1, pn = t, t.prototype = {
                sampleCurveX: function(t) {
                    return ((this.ax * t + this.bx) * t + this.cx) * t;
                },
                sampleCurveY: function(t) {
                    return ((this.ay * t + this.by) * t + this.cy) * t;
                },
                sampleCurveDerivativeX: function(t) {
                    return (3 * this.ax * t + 2 * this.bx) * t + this.cx;
                },
                solveCurveX: function(t, e1) {
                    if (void 0 === e1 && (e1 = 1e-6), t < 0) return 0;
                    if (t > 1) return 1;
                    for(var n = t, r = 0; r < 8; r++){
                        var i = this.sampleCurveX(n) - t;
                        if (Math.abs(i) < e1) return n;
                        var s = this.sampleCurveDerivativeX(n);
                        if (Math.abs(s) < 1e-6) break;
                        n -= i / s;
                    }
                    var o = 0, a = 1;
                    for(n = t, r = 0; r < 20 && (i = this.sampleCurveX(n), !(Math.abs(i - t) < e1)); r++)t > i ? o = n : a = n, n = .5 * (a - o) + o;
                    return n;
                },
                solve: function(t, e1) {
                    return this.sampleCurveY(this.solveCurveX(t, e1));
                }
            }, pn;
        }(), yn = hn(dn);
        class mn {
            constructor(t, e1, n, r, i){
                this.type = t, this.operator = e1, this.interpolation = n, this.input = r, this.labels = [], this.outputs = [];
                for (const [t, e1] of i)this.labels.push(t), this.outputs.push(e1);
            }
            static interpolationFactor(t, e1, n, r) {
                let i = 0;
                if ("exponential" === t.name) i = gn(e1, t.base, n, r);
                else if ("linear" === t.name) i = gn(e1, 1, n, r);
                else if ("cubic-bezier" === t.name) {
                    const s = t.controlPoints;
                    i = new yn(s[0], s[1], s[2], s[3]).solve(gn(e1, 1, n, r));
                }
                return i;
            }
            static parse(t, e1) {
                let [n, r, i, ...s] = t;
                if (!Array.isArray(r) || 0 === r.length) return e1.error("Expected an interpolation type expression.", 1);
                if ("linear" === r[0]) r = {
                    name: "linear"
                };
                else if ("exponential" === r[0]) {
                    const t = r[1];
                    if ("number" != typeof t) return e1.error("Exponential interpolation requires a numeric base.", 1, 1);
                    r = {
                        name: "exponential",
                        base: t
                    };
                } else {
                    if ("cubic-bezier" !== r[0]) return e1.error(`Unknown interpolation type ${String(r[0])}`, 1, 0);
                    {
                        const t = r.slice(1);
                        if (4 !== t.length || t.some((t)=>"number" != typeof t || t < 0 || t > 1)) return e1.error("Cubic bezier interpolation requires four numeric arguments with values between 0 and 1.", 1);
                        r = {
                            name: "cubic-bezier",
                            controlPoints: t
                        };
                    }
                }
                if (t.length - 1 < 4) return e1.error(`Expected at least 4 arguments, but found only ${t.length - 1}.`);
                if ((t.length - 1) % 2 != 0) return e1.error("Expected an even number of arguments.");
                if (i = e1.parse(i, 2, Ot), !i) return null;
                const o = [];
                let a = null;
                "interpolate-hcl" !== n && "interpolate-lab" !== n || e1.expectedType == Zt ? e1.expectedType && "value" !== e1.expectedType.kind && (a = e1.expectedType) : a = Nt;
                for(let t = 0; t < s.length; t += 2){
                    const n = s[t], r = s[t + 1], i = t + 3, l = t + 4;
                    if ("number" != typeof n) return e1.error('Input/output pairs for "interpolate" expressions must be defined using literal numeric values (not computed expressions) for the input values.', i);
                    if (o.length && o[o.length - 1][0] >= n) return e1.error('Input/output pairs for "interpolate" expressions must be arranged with input values in strictly ascending order.', i);
                    const u = e1.parse(r, l, a);
                    if (!u) return null;
                    a = a || u.type, o.push([
                        n,
                        u
                    ]);
                }
                return ie(a, Ot) || ie(a, Ut) || ie(a, Nt) || ie(a, Yt) || ie(a, Ht) || ie(a, Zt) || ie(a, Kt) || ie(a, Jt(Ot)) ? new mn(a, n, r, i, o) : e1.error(`Type ${Qt(a)} is not interpolatable.`);
            }
            evaluate(t) {
                const e1 = this.labels, n = this.outputs;
                if (1 === e1.length) return n[0].evaluate(t);
                const r = this.input.evaluate(t);
                if (r <= e1[0]) return n[0].evaluate(t);
                const i = e1.length;
                if (r >= e1[i - 1]) return n[i - 1].evaluate(t);
                const s = un(e1, r), o = mn.interpolationFactor(this.interpolation, r, e1[s], e1[s + 1]), a = n[s].evaluate(t), l = n[s + 1].evaluate(t);
                switch(this.operator){
                    case "interpolate":
                        switch(this.type.kind){
                            case "number":
                                return Ie(a, l, o);
                            case "color":
                                return Te.interpolate(a, l, o);
                            case "padding":
                                return Be.interpolate(a, l, o);
                            case "colorArray":
                                return Ve.interpolate(a, l, o);
                            case "numberArray":
                                return Ce.interpolate(a, l, o);
                            case "variableAnchorOffsetCollection":
                                return $e.interpolate(a, l, o);
                            case "array":
                                return Ee(a, l, o);
                            case "projectionDefinition":
                                return Ne.interpolate(a, l, o);
                        }
                    case "interpolate-hcl":
                        switch(this.type.kind){
                            case "color":
                                return Te.interpolate(a, l, o, "hcl");
                            case "colorArray":
                                return Ve.interpolate(a, l, o, "hcl");
                        }
                    case "interpolate-lab":
                        switch(this.type.kind){
                            case "color":
                                return Te.interpolate(a, l, o, "lab");
                            case "colorArray":
                                return Ve.interpolate(a, l, o, "lab");
                        }
                }
            }
            eachChild(t) {
                t(this.input);
                for (const e1 of this.outputs)t(e1);
            }
            outputDefined() {
                return this.outputs.every((t)=>t.outputDefined());
            }
        }
        function gn(t, e1, n, r) {
            const i = r - n, s = t - n;
            return 0 === i ? 0 : 1 === e1 ? s / i : (Math.pow(e1, s) - 1) / (Math.pow(e1, i) - 1);
        }
        const xn = {
            color: Te.interpolate,
            number: Ie,
            padding: Be.interpolate,
            numberArray: Ce.interpolate,
            colorArray: Ve.interpolate,
            variableAnchorOffsetCollection: $e.interpolate,
            array: Ee
        };
        class vn {
            constructor(t, e1){
                this.type = t, this.args = e1;
            }
            static parse(t, e1) {
                if (t.length < 2) return e1.error("Expected at least one argument.");
                let n = null;
                const r = e1.expectedType;
                r && "value" !== r.kind && (n = r);
                const i = [];
                for (const r of t.slice(1)){
                    const t = e1.parse(r, 1 + i.length, n, void 0, {
                        typeAnnotation: "omit"
                    });
                    if (!t) return null;
                    n = n || t.type, i.push(t);
                }
                if (!n) throw new Error("No output type");
                const s = r && i.some((t)=>ee(r, t.type));
                return new vn(s ? qt : n, i);
            }
            evaluate(t) {
                let e1, n = null, r = 0;
                for (const i of this.args)if (r++, n = i.evaluate(t), n && n instanceof Re && !n.available && (e1 || (e1 = n.name), n = null, r === this.args.length && (n = e1)), null !== n) break;
                return n;
            }
            eachChild(t) {
                this.args.forEach(t);
            }
            outputDefined() {
                return this.args.every((t)=>t.outputDefined());
            }
        }
        function bn(t, e1) {
            return "==" === t || "!=" === t ? "boolean" === e1.kind || "string" === e1.kind || "number" === e1.kind || "null" === e1.kind || "value" === e1.kind : "string" === e1.kind || "number" === e1.kind || "value" === e1.kind;
        }
        function wn(t, e1, n, r) {
            return 0 === r.compare(e1, n);
        }
        function _n(t, e1, n) {
            const r = "==" !== t && "!=" !== t;
            return class i {
                constructor(t, e1, n){
                    this.type = Rt, this.lhs = t, this.rhs = e1, this.collator = n, this.hasUntypedArgument = "value" === t.type.kind || "value" === e1.type.kind;
                }
                static parse(t, e1) {
                    if (3 !== t.length && 4 !== t.length) return e1.error("Expected two or three arguments.");
                    const n = t[0];
                    let s = e1.parse(t[1], 1, qt);
                    if (!s) return null;
                    if (!bn(n, s.type)) return e1.concat(1).error(`"${n}" comparisons are not supported for type '${Qt(s.type)}'.`);
                    let o = e1.parse(t[2], 2, qt);
                    if (!o) return null;
                    if (!bn(n, o.type)) return e1.concat(2).error(`"${n}" comparisons are not supported for type '${Qt(o.type)}'.`);
                    if (s.type.kind !== o.type.kind && "value" !== s.type.kind && "value" !== o.type.kind) return e1.error(`Cannot compare types '${Qt(s.type)}' and '${Qt(o.type)}'.`);
                    r && ("value" === s.type.kind && "value" !== o.type.kind ? s = new Ze(o.type, [
                        s
                    ]) : "value" !== s.type.kind && "value" === o.type.kind && (o = new Ze(s.type, [
                        o
                    ])));
                    let a = null;
                    if (4 === t.length) {
                        if ("string" !== s.type.kind && "string" !== o.type.kind && "value" !== s.type.kind && "value" !== o.type.kind) return e1.error("Cannot use collator to compare non-string types.");
                        if (a = e1.parse(t[3], 3, Gt), !a) return null;
                    }
                    return new i(s, o, a);
                }
                evaluate(i) {
                    const s = this.lhs.evaluate(i), o = this.rhs.evaluate(i);
                    if (r && this.hasUntypedArgument) {
                        const e1 = qe(s), n = qe(o);
                        if (e1.kind !== n.kind || "string" !== e1.kind && "number" !== e1.kind) throw new Le(`Expected arguments for "${t}" to be (string, string) or (number, number), but found (${e1.kind}, ${n.kind}) instead.`);
                    }
                    if (this.collator && !r && this.hasUntypedArgument) {
                        const t = qe(s), n = qe(o);
                        if ("string" !== t.kind || "string" !== n.kind) return e1(i, s, o);
                    }
                    return this.collator ? n(i, s, o, this.collator.evaluate(i)) : e1(i, s, o);
                }
                eachChild(t) {
                    t(this.lhs), t(this.rhs), this.collator && t(this.collator);
                }
                outputDefined() {
                    return !0;
                }
            };
        }
        const Sn = _n("==", function(t, e1, n) {
            return e1 === n;
        }, wn), An = _n("!=", function(t, e1, n) {
            return e1 !== n;
        }, function(t, e1, n, r) {
            return !wn(0, e1, n, r);
        }), Mn = _n("<", function(t, e1, n) {
            return e1 < n;
        }, function(t, e1, n, r) {
            return r.compare(e1, n) < 0;
        }), kn = _n(">", function(t, e1, n) {
            return e1 > n;
        }, function(t, e1, n, r) {
            return r.compare(e1, n) > 0;
        }), In = _n("<=", function(t, e1, n) {
            return e1 <= n;
        }, function(t, e1, n, r) {
            return r.compare(e1, n) <= 0;
        }), En = _n(">=", function(t, e1, n) {
            return e1 >= n;
        }, function(t, e1, n, r) {
            return r.compare(e1, n) >= 0;
        });
        class Tn {
            constructor(t, e1, n){
                this.type = Gt, this.locale = n, this.caseSensitive = t, this.diacriticSensitive = e1;
            }
            static parse(t, e1) {
                if (2 !== t.length) return e1.error("Expected one argument.");
                const n = t[1];
                if ("object" != typeof n || Array.isArray(n)) return e1.error("Collator options argument must be an object.");
                const r = e1.parse(void 0 !== n["case-sensitive"] && n["case-sensitive"], 1, Rt);
                if (!r) return null;
                const i = e1.parse(void 0 !== n["diacritic-sensitive"] && n["diacritic-sensitive"], 1, Rt);
                if (!i) return null;
                let s = null;
                return n.locale && (s = e1.parse(n.locale, 1, $t), !s) ? null : new Tn(r, i, s);
            }
            evaluate(t) {
                return new Fe(this.caseSensitive.evaluate(t), this.diacriticSensitive.evaluate(t), this.locale ? this.locale.evaluate(t) : null);
            }
            eachChild(t) {
                t(this.caseSensitive), t(this.diacriticSensitive), this.locale && t(this.locale);
            }
            outputDefined() {
                return !1;
            }
        }
        class Fn {
            constructor(t, e1, n, r, i, s){
                this.type = $t, this.number = t, this.locale = e1, this.currency = n, this.unit = r, this.minFractionDigits = i, this.maxFractionDigits = s;
            }
            static parse(t, e1) {
                if (3 !== t.length) return e1.error("Expected two arguments.");
                const n = e1.parse(t[1], 1, Ot);
                if (!n) return null;
                const r = t[2];
                if ("object" != typeof r || Array.isArray(r)) return e1.error("NumberFormat options argument must be an object.");
                let i = null;
                if (r.locale && (i = e1.parse(r.locale, 1, $t), !i)) return null;
                let s = null;
                if (r.currency && (s = e1.parse(r.currency, 1, $t), !s)) return null;
                let o = null;
                if (r.unit && (o = e1.parse(r.unit, 1, $t), !o)) return null;
                if (s && o) return e1.error("NumberFormat options `currency` and `unit` are mutually exclusive");
                let a = null;
                if (r["min-fraction-digits"] && (a = e1.parse(r["min-fraction-digits"], 1, Ot), !a)) return null;
                let l = null;
                return r["max-fraction-digits"] && (l = e1.parse(r["max-fraction-digits"], 1, Ot), !l) ? null : new Fn(n, i, s, o, a, l);
            }
            evaluate(t) {
                return new Intl.NumberFormat(this.locale ? this.locale.evaluate(t) : [], {
                    style: this.currency ? "currency" : this.unit ? "unit" : "decimal",
                    currency: this.currency ? this.currency.evaluate(t) : void 0,
                    unit: this.unit ? this.unit.evaluate(t) : void 0,
                    minimumFractionDigits: this.minFractionDigits ? this.minFractionDigits.evaluate(t) : void 0,
                    maximumFractionDigits: this.maxFractionDigits ? this.maxFractionDigits.evaluate(t) : void 0
                }).format(this.number.evaluate(t));
            }
            eachChild(t) {
                t(this.number), this.locale && t(this.locale), this.currency && t(this.currency), this.unit && t(this.unit), this.minFractionDigits && t(this.minFractionDigits), this.maxFractionDigits && t(this.maxFractionDigits);
            }
            outputDefined() {
                return !1;
            }
        }
        class Pn {
            constructor(t){
                this.type = Xt, this.sections = t;
            }
            static parse(t, e1) {
                if (t.length < 2) return e1.error("Expected at least one argument.");
                const n = t[1];
                if (!Array.isArray(n) && "object" == typeof n) return e1.error("First argument must be an image or text section.");
                const r = [];
                let i = !1;
                for(let n = 1; n <= t.length - 1; ++n){
                    const s = t[n];
                    if (i && "object" == typeof s && !Array.isArray(s)) {
                        i = !1;
                        let t = null;
                        if (s["font-scale"] && (t = e1.parse(s["font-scale"], 1, Ot), !t)) return null;
                        let n = null;
                        if (s["text-font"] && (n = e1.parse(s["text-font"], 1, Jt($t)), !n)) return null;
                        let o = null;
                        if (s["text-color"] && (o = e1.parse(s["text-color"], 1, Nt), !o)) return null;
                        let a = null;
                        if (s["vertical-align"]) {
                            if ("string" == typeof s["vertical-align"] && !Pe.includes(s["vertical-align"])) return e1.error(`'vertical-align' must be one of: 'bottom', 'center', 'top' but found '${s["vertical-align"]}' instead.`);
                            if (a = e1.parse(s["vertical-align"], 1, $t), !a) return null;
                        }
                        const l = r[r.length - 1];
                        l.scale = t, l.font = n, l.textColor = o, l.verticalAlign = a;
                    } else {
                        const s = e1.parse(t[n], 1, qt);
                        if (!s) return null;
                        const o = s.type.kind;
                        if ("string" !== o && "value" !== o && "null" !== o && "resolvedImage" !== o) return e1.error("Formatted text type must be 'string', 'value', 'image' or 'null'.");
                        i = !0, r.push({
                            content: s,
                            scale: null,
                            font: null,
                            textColor: null,
                            verticalAlign: null
                        });
                    }
                }
                return new Pn(r);
            }
            evaluate(t) {
                return new ze(this.sections.map((e1)=>{
                    const n = e1.content.evaluate(t);
                    return qe(n) === Wt ? new De("", n, null, null, null, e1.verticalAlign ? e1.verticalAlign.evaluate(t) : null) : new De(Ge(n), null, e1.scale ? e1.scale.evaluate(t) : null, e1.font ? e1.font.evaluate(t).join(",") : null, e1.textColor ? e1.textColor.evaluate(t) : null, e1.verticalAlign ? e1.verticalAlign.evaluate(t) : null);
                }));
            }
            eachChild(t) {
                for (const e1 of this.sections)t(e1.content), e1.scale && t(e1.scale), e1.font && t(e1.font), e1.textColor && t(e1.textColor), e1.verticalAlign && t(e1.verticalAlign);
            }
            outputDefined() {
                return !1;
            }
        }
        class Dn {
            constructor(t){
                this.type = Wt, this.input = t;
            }
            static parse(t, e1) {
                if (2 !== t.length) return e1.error("Expected two arguments.");
                const n = e1.parse(t[1], 1, $t);
                return n ? new Dn(n) : e1.error("No image name provided.");
            }
            evaluate(t) {
                const e1 = this.input.evaluate(t), n = Re.fromString(e1);
                return n && t.availableImages && (n.available = t.availableImages.indexOf(e1) > -1), n;
            }
            eachChild(t) {
                t(this.input);
            }
            outputDefined() {
                return !1;
            }
        }
        class zn {
            constructor(t){
                this.type = Ot, this.input = t;
            }
            static parse(t, e1) {
                if (2 !== t.length) return e1.error(`Expected 1 argument, but found ${t.length - 1} instead.`);
                const n = e1.parse(t[1], 1);
                return n ? "array" !== n.type.kind && "string" !== n.type.kind && "value" !== n.type.kind ? e1.error(`Expected argument of type string or array, but found ${Qt(n.type)} instead.`) : new zn(n) : null;
            }
            evaluate(t) {
                const e1 = this.input.evaluate(t);
                if ("string" == typeof e1) return [
                    ...e1
                ].length;
                if (Array.isArray(e1)) return e1.length;
                throw new Le(`Expected value to be of type string or array, but found ${Qt(qe(e1))} instead.`);
            }
            eachChild(t) {
                t(this.input);
            }
            outputDefined() {
                return !1;
            }
        }
        const Bn = 8192;
        function Cn(t, e1) {
            const n = (180 + t[0]) / 360, r = (180 - 180 / Math.PI * Math.log(Math.tan(Math.PI / 4 + t[1] * Math.PI / 360))) / 360, i = Math.pow(2, e1.z);
            return [
                Math.round(n * i * Bn),
                Math.round(r * i * Bn)
            ];
        }
        function Vn(t, e1) {
            const n = Math.pow(2, e1.z);
            var r, i;
            return [
                (i = (t[0] / Bn + e1.x) / n, 360 * i - 180),
                (r = (t[1] / Bn + e1.y) / n, 360 / Math.PI * Math.atan(Math.exp((180 - 360 * r) * Math.PI / 180)) - 90)
            ];
        }
        function Ln(t, e1) {
            t[0] = Math.min(t[0], e1[0]), t[1] = Math.min(t[1], e1[1]), t[2] = Math.max(t[2], e1[0]), t[3] = Math.max(t[3], e1[1]);
        }
        function On(t, e1) {
            return !(t[0] <= e1[0] || t[2] >= e1[2] || t[1] <= e1[1] || t[3] >= e1[3]);
        }
        function $n(t, e1, n) {
            const r = t[0] - e1[0], i = t[1] - e1[1], s = t[0] - n[0], o = t[1] - n[1];
            return r * o - s * i == 0 && r * s <= 0 && i * o <= 0;
        }
        function Rn(t, e1, n, r) {
            var i, s;
            return 0 != (i = [
                r[0] - n[0],
                r[1] - n[1]
            ])[0] * (s = [
                e1[0] - t[0],
                e1[1] - t[1]
            ])[1] - i[1] * s[0] && !(!Xn(t, e1, n, r) || !Xn(n, r, t, e1));
        }
        function Nn(t, e1, n) {
            for (const r of n)for(let n = 0; n < r.length - 1; ++n)if (Rn(t, e1, r[n], r[n + 1])) return !0;
            return !1;
        }
        function Un(t, e1, n = !1) {
            let r = !1;
            for (const a of e1)for(let e1 = 0; e1 < a.length - 1; e1++){
                if ($n(t, a[e1], a[e1 + 1])) return n;
                (s = a[e1])[1] > (i = t)[1] != (o = a[e1 + 1])[1] > i[1] && i[0] < (o[0] - s[0]) * (i[1] - s[1]) / (o[1] - s[1]) + s[0] && (r = !r);
            }
            var i, s, o;
            return r;
        }
        function jn(t, e1) {
            for (const n of e1)if (Un(t, n)) return !0;
            return !1;
        }
        function qn(t, e1) {
            for (const n of t)if (!Un(n, e1)) return !1;
            for(let n = 0; n < t.length - 1; ++n)if (Nn(t[n], t[n + 1], e1)) return !1;
            return !0;
        }
        function Gn(t, e1) {
            for (const n of e1)if (qn(t, n)) return !0;
            return !1;
        }
        function Xn(t, e1, n, r) {
            const i = r[0] - n[0], s = r[1] - n[1], o = (t[0] - n[0]) * s - i * (t[1] - n[1]), a = (e1[0] - n[0]) * s - i * (e1[1] - n[1]);
            return o > 0 && a < 0 || o < 0 && a > 0;
        }
        function Yn(t, e1, n) {
            const r = [];
            for(let i = 0; i < t.length; i++){
                const s = [];
                for(let r = 0; r < t[i].length; r++){
                    const o = Cn(t[i][r], n);
                    Ln(e1, o), s.push(o);
                }
                r.push(s);
            }
            return r;
        }
        function Zn(t, e1, n) {
            const r = [];
            for(let i = 0; i < t.length; i++){
                const s = Yn(t[i], e1, n);
                r.push(s);
            }
            return r;
        }
        function Hn(t, e1, n, r) {
            if (t[0] < n[0] || t[0] > n[2]) {
                const e1 = .5 * r;
                let i = t[0] - n[0] > e1 ? -r : n[0] - t[0] > e1 ? r : 0;
                0 === i && (i = t[0] - n[2] > e1 ? -r : n[2] - t[0] > e1 ? r : 0), t[0] += i;
            }
            Ln(e1, t);
        }
        function Wn(t, e1, n, r) {
            const i = Math.pow(2, r.z) * Bn, s = [
                r.x * Bn,
                r.y * Bn
            ], o = [];
            for (const r of t)for (const t of r){
                const r = [
                    t.x + s[0],
                    t.y + s[1]
                ];
                Hn(r, e1, n, i), o.push(r);
            }
            return o;
        }
        function Kn(t, e1, n, r) {
            const i = Math.pow(2, r.z) * Bn, s = [
                r.x * Bn,
                r.y * Bn
            ], o = [];
            for (const n of t){
                const t = [];
                for (const r of n){
                    const n = [
                        r.x + s[0],
                        r.y + s[1]
                    ];
                    Ln(e1, n), t.push(n);
                }
                o.push(t);
            }
            if (e1[2] - e1[0] <= i / 2) {
                (a = e1)[0] = a[1] = 1 / 0, a[2] = a[3] = -1 / 0;
                for (const t of o)for (const r of t)Hn(r, e1, n, i);
            }
            var a;
            return o;
        }
        class Jn {
            constructor(t, e1){
                this.type = Rt, this.geojson = t, this.geometries = e1;
            }
            static parse(t, e1) {
                if (2 !== t.length) return e1.error(`'within' expression requires exactly one argument, but found ${t.length - 1} instead.`);
                if (je(t[1])) {
                    const e1 = t[1];
                    if ("FeatureCollection" === e1.type) {
                        const t = [];
                        for (const n of e1.features){
                            const { type: e1, coordinates: r } = n.geometry;
                            "Polygon" === e1 && t.push(r), "MultiPolygon" === e1 && t.push(...r);
                        }
                        if (t.length) return new Jn(e1, {
                            type: "MultiPolygon",
                            coordinates: t
                        });
                    } else if ("Feature" === e1.type) {
                        const t = e1.geometry.type;
                        if ("Polygon" === t || "MultiPolygon" === t) return new Jn(e1, e1.geometry);
                    } else if ("Polygon" === e1.type || "MultiPolygon" === e1.type) return new Jn(e1, e1);
                }
                return e1.error("'within' expression requires valid geojson object that contains polygon geometry type.");
            }
            evaluate(t) {
                if (null != t.geometry() && null != t.canonicalID()) {
                    if ("Point" === t.geometryType()) return function(t, e1) {
                        const n = [
                            1 / 0,
                            1 / 0,
                            -1 / 0,
                            -1 / 0
                        ], r = [
                            1 / 0,
                            1 / 0,
                            -1 / 0,
                            -1 / 0
                        ], i = t.canonicalID();
                        if ("Polygon" === e1.type) {
                            const s = Yn(e1.coordinates, r, i), o = Wn(t.geometry(), n, r, i);
                            if (!On(n, r)) return !1;
                            for (const t of o)if (!Un(t, s)) return !1;
                        }
                        if ("MultiPolygon" === e1.type) {
                            const s = Zn(e1.coordinates, r, i), o = Wn(t.geometry(), n, r, i);
                            if (!On(n, r)) return !1;
                            for (const t of o)if (!jn(t, s)) return !1;
                        }
                        return !0;
                    }(t, this.geometries);
                    if ("LineString" === t.geometryType()) return function(t, e1) {
                        const n = [
                            1 / 0,
                            1 / 0,
                            -1 / 0,
                            -1 / 0
                        ], r = [
                            1 / 0,
                            1 / 0,
                            -1 / 0,
                            -1 / 0
                        ], i = t.canonicalID();
                        if ("Polygon" === e1.type) {
                            const s = Yn(e1.coordinates, r, i), o = Kn(t.geometry(), n, r, i);
                            if (!On(n, r)) return !1;
                            for (const t of o)if (!qn(t, s)) return !1;
                        }
                        if ("MultiPolygon" === e1.type) {
                            const s = Zn(e1.coordinates, r, i), o = Kn(t.geometry(), n, r, i);
                            if (!On(n, r)) return !1;
                            for (const t of o)if (!Gn(t, s)) return !1;
                        }
                        return !0;
                    }(t, this.geometries);
                }
                return !1;
            }
            eachChild() {}
            outputDefined() {
                return !0;
            }
        }
        let Qn = class {
            constructor(t = [], e1 = (t, e1)=>t < e1 ? -1 : t > e1 ? 1 : 0){
                if (this.data = t, this.length = this.data.length, this.compare = e1, this.length > 0) for(let t = (this.length >> 1) - 1; t >= 0; t--)this._down(t);
            }
            push(t) {
                this.data.push(t), this._up(this.length++);
            }
            pop() {
                if (0 === this.length) return;
                const t = this.data[0], e1 = this.data.pop();
                return --this.length > 0 && (this.data[0] = e1, this._down(0)), t;
            }
            peek() {
                return this.data[0];
            }
            _up(t) {
                const { data: e1, compare: n } = this, r = e1[t];
                for(; t > 0;){
                    const i = t - 1 >> 1, s = e1[i];
                    if (n(r, s) >= 0) break;
                    e1[t] = s, t = i;
                }
                e1[t] = r;
            }
            _down(t) {
                const { data: e1, compare: n } = this, r = this.length >> 1, i = e1[t];
                for(; t < r;){
                    let r = 1 + (t << 1);
                    const s = r + 1;
                    if (s < this.length && n(e1[s], e1[r]) < 0 && (r = s), n(e1[r], i) >= 0) break;
                    e1[t] = e1[r], t = r;
                }
                e1[t] = i;
            }
        };
        function tr(t, e1, n = 0, r = t.length - 1, i = nr) {
            for(; r > n;){
                if (r - n > 600) {
                    const s = r - n + 1, o = e1 - n + 1, a = Math.log(s), l = .5 * Math.exp(2 * a / 3), u = .5 * Math.sqrt(a * l * (s - l) / s) * (o - s / 2 < 0 ? -1 : 1);
                    tr(t, e1, Math.max(n, Math.floor(e1 - o * l / s + u)), Math.min(r, Math.floor(e1 + (s - o) * l / s + u)), i);
                }
                const s = t[e1];
                let o = n, a = r;
                for(er(t, n, e1), i(t[r], s) > 0 && er(t, n, r); o < a;){
                    for(er(t, o, a), o++, a--; i(t[o], s) < 0;)o++;
                    for(; i(t[a], s) > 0;)a--;
                }
                0 === i(t[n], s) ? er(t, n, a) : (a++, er(t, a, r)), a <= e1 && (n = a + 1), e1 <= a && (r = a - 1);
            }
        }
        function er(t, e1, n) {
            const r = t[e1];
            t[e1] = t[n], t[n] = r;
        }
        function nr(t, e1) {
            return t < e1 ? -1 : t > e1 ? 1 : 0;
        }
        function rr(t, e1) {
            if (t.length <= 1) return [
                t
            ];
            const n = [];
            let r, i;
            for (const e1 of t){
                const t = sr(e1);
                0 !== t && (e1.area = Math.abs(t), void 0 === i && (i = t < 0), i === t < 0 ? (r && n.push(r), r = [
                    e1
                ]) : r.push(e1));
            }
            if (r && n.push(r), e1 > 1) for(let t = 0; t < n.length; t++)n[t].length <= e1 || (tr(n[t], e1, 1, n[t].length - 1, ir), n[t] = n[t].slice(0, e1));
            return n;
        }
        function ir(t, e1) {
            return e1.area - t.area;
        }
        function sr(t) {
            let e1 = 0;
            for(let n, r, i = 0, s = t.length, o = s - 1; i < s; o = i++)n = t[i], r = t[o], e1 += (r.x - n.x) * (n.y + r.y);
            return e1;
        }
        const or = 1 / 298.257223563, ar = or * (2 - or), lr = Math.PI / 180;
        class ur {
            constructor(t){
                const e1 = 6378.137 * lr * 1e3, n = Math.cos(t * lr), r = 1 / (1 - ar * (1 - n * n)), i = Math.sqrt(r);
                this.kx = e1 * i * n, this.ky = e1 * i * r * (1 - ar);
            }
            distance(t, e1) {
                const n = this.wrap(t[0] - e1[0]) * this.kx, r = (t[1] - e1[1]) * this.ky;
                return Math.sqrt(n * n + r * r);
            }
            pointOnLine(t, e1) {
                let n, r, i, s, o = 1 / 0;
                for(let a = 0; a < t.length - 1; a++){
                    let l = t[a][0], u = t[a][1], c = this.wrap(t[a + 1][0] - l) * this.kx, h = (t[a + 1][1] - u) * this.ky, p = 0;
                    0 === c && 0 === h || (p = (this.wrap(e1[0] - l) * this.kx * c + (e1[1] - u) * this.ky * h) / (c * c + h * h), p > 1 ? (l = t[a + 1][0], u = t[a + 1][1]) : p > 0 && (l += c / this.kx * p, u += h / this.ky * p)), c = this.wrap(e1[0] - l) * this.kx, h = (e1[1] - u) * this.ky;
                    const f = c * c + h * h;
                    f < o && (o = f, n = l, r = u, i = a, s = p);
                }
                return {
                    point: [
                        n,
                        r
                    ],
                    index: i,
                    t: Math.max(0, Math.min(1, s))
                };
            }
            wrap(t) {
                for(; t < -180;)t += 360;
                for(; t > 180;)t -= 360;
                return t;
            }
        }
        function cr(t, e1) {
            return e1[0] - t[0];
        }
        function hr(t) {
            return t[1] - t[0] + 1;
        }
        function pr(t, e1) {
            return t[1] >= t[0] && t[1] < e1;
        }
        function fr(t, e1) {
            if (t[0] > t[1]) return [
                null,
                null
            ];
            const n = hr(t);
            if (e1) {
                if (2 === n) return [
                    t,
                    null
                ];
                const e1 = Math.floor(n / 2);
                return [
                    [
                        t[0],
                        t[0] + e1
                    ],
                    [
                        t[0] + e1,
                        t[1]
                    ]
                ];
            }
            if (1 === n) return [
                t,
                null
            ];
            const r = Math.floor(n / 2) - 1;
            return [
                [
                    t[0],
                    t[0] + r
                ],
                [
                    t[0] + r + 1,
                    t[1]
                ]
            ];
        }
        function dr(t, e1) {
            if (!pr(e1, t.length)) return [
                1 / 0,
                1 / 0,
                -1 / 0,
                -1 / 0
            ];
            const n = [
                1 / 0,
                1 / 0,
                -1 / 0,
                -1 / 0
            ];
            for(let r = e1[0]; r <= e1[1]; ++r)Ln(n, t[r]);
            return n;
        }
        function yr(t) {
            const e1 = [
                1 / 0,
                1 / 0,
                -1 / 0,
                -1 / 0
            ];
            for (const n of t)for (const t of n)Ln(e1, t);
            return e1;
        }
        function mr(t) {
            return t[0] !== -1 / 0 && t[1] !== -1 / 0 && t[2] !== 1 / 0 && t[3] !== 1 / 0;
        }
        function gr(t, e1, n) {
            if (!mr(t) || !mr(e1)) return NaN;
            let r = 0, i = 0;
            return t[2] < e1[0] && (r = e1[0] - t[2]), t[0] > e1[2] && (r = t[0] - e1[2]), t[1] > e1[3] && (i = t[1] - e1[3]), t[3] < e1[1] && (i = e1[1] - t[3]), n.distance([
                0,
                0
            ], [
                r,
                i
            ]);
        }
        function xr(t, e1, n) {
            const r = n.pointOnLine(e1, t);
            return n.distance(t, r.point);
        }
        function vr(t, e1, n, r, i) {
            const s = Math.min(xr(t, [
                n,
                r
            ], i), xr(e1, [
                n,
                r
            ], i)), o = Math.min(xr(n, [
                t,
                e1
            ], i), xr(r, [
                t,
                e1
            ], i));
            return Math.min(s, o);
        }
        function br(t, e1, n, r, i) {
            if (!pr(e1, t.length) || !pr(r, n.length)) return 1 / 0;
            let s = 1 / 0;
            for(let o = e1[0]; o < e1[1]; ++o){
                const e1 = t[o], a = t[o + 1];
                for(let t = r[0]; t < r[1]; ++t){
                    const r = n[t], o = n[t + 1];
                    if (Rn(e1, a, r, o)) return 0;
                    s = Math.min(s, vr(e1, a, r, o, i));
                }
            }
            return s;
        }
        function wr(t, e1, n, r, i) {
            if (!pr(e1, t.length) || !pr(r, n.length)) return NaN;
            let s = 1 / 0;
            for(let o = e1[0]; o <= e1[1]; ++o)for(let e1 = r[0]; e1 <= r[1]; ++e1)if (s = Math.min(s, i.distance(t[o], n[e1])), 0 === s) return s;
            return s;
        }
        function _r(t, e1, n) {
            if (Un(t, e1, !0)) return 0;
            let r = 1 / 0;
            for (const i of e1){
                const e1 = i[0], s = i[i.length - 1];
                if (e1 !== s && (r = Math.min(r, xr(t, [
                    s,
                    e1
                ], n)), 0 === r)) return r;
                const o = n.pointOnLine(i, t);
                if (r = Math.min(r, n.distance(t, o.point)), 0 === r) return r;
            }
            return r;
        }
        function Sr(t, e1, n, r) {
            if (!pr(e1, t.length)) return NaN;
            for(let r = e1[0]; r <= e1[1]; ++r)if (Un(t[r], n, !0)) return 0;
            let i = 1 / 0;
            for(let s = e1[0]; s < e1[1]; ++s){
                const e1 = t[s], o = t[s + 1];
                for (const t of n)for(let n = 0, s = t.length, a = s - 1; n < s; a = n++){
                    const s = t[a], l = t[n];
                    if (Rn(e1, o, s, l)) return 0;
                    i = Math.min(i, vr(e1, o, s, l, r));
                }
            }
            return i;
        }
        function Ar(t, e1) {
            for (const n of t)for (const t of n)if (Un(t, e1, !0)) return !0;
            return !1;
        }
        function Mr(t, e1, n, r = 1 / 0) {
            const i = yr(t), s = yr(e1);
            if (r !== 1 / 0 && gr(i, s, n) >= r) return r;
            if (On(i, s)) {
                if (Ar(t, e1)) return 0;
            } else if (Ar(e1, t)) return 0;
            let o = 1 / 0;
            for (const r of t)for(let t = 0, i = r.length, s = i - 1; t < i; s = t++){
                const i = r[s], a = r[t];
                for (const t of e1)for(let e1 = 0, r = t.length, s = r - 1; e1 < r; s = e1++){
                    const r = t[s], l = t[e1];
                    if (Rn(i, a, r, l)) return 0;
                    o = Math.min(o, vr(i, a, r, l, n));
                }
            }
            return o;
        }
        function kr(t, e1, n, r, i, s) {
            if (!s) return;
            const o = gr(dr(r, s), i, n);
            o < e1 && t.push([
                o,
                s,
                [
                    0,
                    0
                ]
            ]);
        }
        function Ir(t, e1, n, r, i, s, o) {
            if (!s || !o) return;
            const a = gr(dr(r, s), dr(i, o), n);
            a < e1 && t.push([
                a,
                s,
                o
            ]);
        }
        function Er(t, e1, n, r, i = 1 / 0) {
            let s = Math.min(r.distance(t[0], n[0][0]), i);
            if (0 === s) return s;
            const o = new Qn([
                [
                    0,
                    [
                        0,
                        t.length - 1
                    ],
                    [
                        0,
                        0
                    ]
                ]
            ], cr), a = yr(n);
            for(; o.length > 0;){
                const i = o.pop();
                if (i[0] >= s) continue;
                const l = i[1], u = e1 ? 50 : 100;
                if (hr(l) <= u) {
                    if (!pr(l, t.length)) return NaN;
                    if (e1) {
                        const e1 = Sr(t, l, n, r);
                        if (isNaN(e1) || 0 === e1) return e1;
                        s = Math.min(s, e1);
                    } else for(let e1 = l[0]; e1 <= l[1]; ++e1){
                        const i = _r(t[e1], n, r);
                        if (s = Math.min(s, i), 0 === s) return 0;
                    }
                } else {
                    const n = fr(l, e1);
                    kr(o, s, r, t, a, n[0]), kr(o, s, r, t, a, n[1]);
                }
            }
            return s;
        }
        function Tr(t, e1, n, r, i, s = 1 / 0) {
            let o = Math.min(s, i.distance(t[0], n[0]));
            if (0 === o) return o;
            const a = new Qn([
                [
                    0,
                    [
                        0,
                        t.length - 1
                    ],
                    [
                        0,
                        n.length - 1
                    ]
                ]
            ], cr);
            for(; a.length > 0;){
                const s = a.pop();
                if (s[0] >= o) continue;
                const l = s[1], u = s[2], c = e1 ? 50 : 100, h = r ? 50 : 100;
                if (hr(l) <= c && hr(u) <= h) {
                    if (!pr(l, t.length) && pr(u, n.length)) return NaN;
                    let s;
                    if (e1 && r) s = br(t, l, n, u, i), o = Math.min(o, s);
                    else if (e1 && !r) {
                        const e1 = t.slice(l[0], l[1] + 1);
                        for(let t = u[0]; t <= u[1]; ++t)if (s = xr(n[t], e1, i), o = Math.min(o, s), 0 === o) return o;
                    } else if (!e1 && r) {
                        const e1 = n.slice(u[0], u[1] + 1);
                        for(let n = l[0]; n <= l[1]; ++n)if (s = xr(t[n], e1, i), o = Math.min(o, s), 0 === o) return o;
                    } else s = wr(t, l, n, u, i), o = Math.min(o, s);
                } else {
                    const s = fr(l, e1), c = fr(u, r);
                    Ir(a, o, i, t, n, s[0], c[0]), Ir(a, o, i, t, n, s[0], c[1]), Ir(a, o, i, t, n, s[1], c[0]), Ir(a, o, i, t, n, s[1], c[1]);
                }
            }
            return o;
        }
        function Fr(t) {
            return "MultiPolygon" === t.type ? t.coordinates.map((t)=>({
                    type: "Polygon",
                    coordinates: t
                })) : "MultiLineString" === t.type ? t.coordinates.map((t)=>({
                    type: "LineString",
                    coordinates: t
                })) : "MultiPoint" === t.type ? t.coordinates.map((t)=>({
                    type: "Point",
                    coordinates: t
                })) : [
                t
            ];
        }
        class Pr {
            constructor(t, e1){
                this.type = Ot, this.geojson = t, this.geometries = e1;
            }
            static parse(t, e1) {
                if (2 !== t.length) return e1.error(`'distance' expression requires exactly one argument, but found ${t.length - 1} instead.`);
                if (je(t[1])) {
                    const e1 = t[1];
                    if ("FeatureCollection" === e1.type) return new Pr(e1, e1.features.map((t)=>Fr(t.geometry)).flat());
                    if ("Feature" === e1.type) return new Pr(e1, Fr(e1.geometry));
                    if ("type" in e1 && "coordinates" in e1) return new Pr(e1, Fr(e1));
                }
                return e1.error("'distance' expression requires valid geojson object that contains polygon geometry type.");
            }
            evaluate(t) {
                if (null != t.geometry() && null != t.canonicalID()) {
                    if ("Point" === t.geometryType()) return function(t, e1) {
                        const n = t.geometry(), r = n.flat().map((e1)=>Vn([
                                e1.x,
                                e1.y
                            ], t.canonical));
                        if (0 === n.length) return NaN;
                        const i = new ur(r[0][1]);
                        let s = 1 / 0;
                        for (const t of e1){
                            switch(t.type){
                                case "Point":
                                    s = Math.min(s, Tr(r, !1, [
                                        t.coordinates
                                    ], !1, i, s));
                                    break;
                                case "LineString":
                                    s = Math.min(s, Tr(r, !1, t.coordinates, !0, i, s));
                                    break;
                                case "Polygon":
                                    s = Math.min(s, Er(r, !1, t.coordinates, i, s));
                            }
                            if (0 === s) return s;
                        }
                        return s;
                    }(t, this.geometries);
                    if ("LineString" === t.geometryType()) return function(t, e1) {
                        const n = t.geometry(), r = n.flat().map((e1)=>Vn([
                                e1.x,
                                e1.y
                            ], t.canonical));
                        if (0 === n.length) return NaN;
                        const i = new ur(r[0][1]);
                        let s = 1 / 0;
                        for (const t of e1){
                            switch(t.type){
                                case "Point":
                                    s = Math.min(s, Tr(r, !0, [
                                        t.coordinates
                                    ], !1, i, s));
                                    break;
                                case "LineString":
                                    s = Math.min(s, Tr(r, !0, t.coordinates, !0, i, s));
                                    break;
                                case "Polygon":
                                    s = Math.min(s, Er(r, !0, t.coordinates, i, s));
                            }
                            if (0 === s) return s;
                        }
                        return s;
                    }(t, this.geometries);
                    if ("Polygon" === t.geometryType()) return function(t, e1) {
                        const n = t.geometry();
                        if (0 === n.length || 0 === n[0].length) return NaN;
                        const r = rr(n, 0).map((e1)=>e1.map((e1)=>e1.map((e1)=>Vn([
                                        e1.x,
                                        e1.y
                                    ], t.canonical)))), i = new ur(r[0][0][0][1]);
                        let s = 1 / 0;
                        for (const t of e1)for (const e1 of r){
                            switch(t.type){
                                case "Point":
                                    s = Math.min(s, Er([
                                        t.coordinates
                                    ], !1, e1, i, s));
                                    break;
                                case "LineString":
                                    s = Math.min(s, Er(t.coordinates, !0, e1, i, s));
                                    break;
                                case "Polygon":
                                    s = Math.min(s, Mr(e1, t.coordinates, i, s));
                            }
                            if (0 === s) return s;
                        }
                        return s;
                    }(t, this.geometries);
                }
                return NaN;
            }
            eachChild() {}
            outputDefined() {
                return !0;
            }
        }
        class Dr {
            constructor(t){
                this.type = qt, this.key = t;
            }
            static parse(t, e1) {
                if (2 !== t.length) return e1.error(`Expected 1 argument, but found ${t.length - 1} instead.`);
                const n = t[1];
                return null == n ? e1.error("Global state property must be defined.") : "string" != typeof n ? e1.error(`Global state property must be string, but found ${typeof t[1]} instead.`) : new Dr(n);
            }
            evaluate(t) {
                var e1;
                const n = null === (e1 = t.globals) || void 0 === e1 ? void 0 : e1.globalState;
                return n && 0 !== Object.keys(n).length ? we(n, this.key) : null;
            }
            eachChild() {}
            outputDefined() {
                return !1;
            }
        }
        const zr = {
            "==": Sn,
            "!=": An,
            ">": kn,
            "<": Mn,
            ">=": En,
            "<=": In,
            array: Ze,
            at: nn,
            boolean: Ze,
            case: an,
            coalesce: vn,
            collator: Tn,
            format: Pn,
            image: Dn,
            in: rn,
            "index-of": sn,
            interpolate: mn,
            "interpolate-hcl": mn,
            "interpolate-lab": mn,
            length: zn,
            let: tn,
            literal: Xe,
            match: on,
            number: Ze,
            "number-format": Fn,
            object: Ze,
            slice: ln,
            step: cn,
            string: Ze,
            "to-boolean": We,
            "to-color": We,
            "to-number": We,
            "to-string": We,
            var: en,
            within: Jn,
            distance: Pr,
            "global-state": Dr
        };
        class Br {
            constructor(t, e1, n, r){
                this.name = t, this.type = e1, this._evaluate = n, this.args = r;
            }
            evaluate(t) {
                return this._evaluate(t, this.args);
            }
            eachChild(t) {
                this.args.forEach(t);
            }
            outputDefined() {
                return !1;
            }
            static parse(t, e1) {
                const n = t[0], r = Br.definitions[n];
                if (!r) return e1.error(`Unknown expression "${n}". If you wanted a literal array, use ["literal", [...]].`, 0);
                const i = Array.isArray(r) ? r[0] : r.type, s = Array.isArray(r) ? [
                    [
                        r[1],
                        r[2]
                    ]
                ] : r.overloads, o = s.filter(([e1])=>!Array.isArray(e1) || e1.length === t.length - 1);
                let a = null;
                for (const [r, s] of o){
                    a = new Qe(e1.registry, $r, e1.path, null, e1.scope);
                    const o = [];
                    let l = !1;
                    for(let e1 = 1; e1 < t.length; e1++){
                        const n = t[e1], i = Array.isArray(r) ? r[e1 - 1] : r.type, s = a.parse(n, 1 + o.length, i);
                        if (!s) {
                            l = !0;
                            break;
                        }
                        o.push(s);
                    }
                    if (!l) {
                        if (Array.isArray(r) && r.length !== o.length) a.error(`Expected ${r.length} arguments, but found ${o.length} instead.`);
                        else {
                            for(let t = 0; t < o.length; t++){
                                const e1 = Array.isArray(r) ? r[t] : r.type, n = o[t];
                                a.concat(t + 1).checkSubtype(e1, n.type);
                            }
                            if (0 === a.errors.length) return new Br(n, i, s, o);
                        }
                    }
                }
                if (1 === o.length) e1.errors.push(...a.errors);
                else {
                    const n = (o.length ? o : s).map(([t])=>{
                        var e1;
                        return e1 = t, Array.isArray(e1) ? `(${e1.map(Qt).join(", ")})` : `(${Qt(e1.type)}...)`;
                    }).join(" | "), r = [];
                    for(let n = 1; n < t.length; n++){
                        const i = e1.parse(t[n], 1 + r.length);
                        if (!i) return null;
                        r.push(Qt(i.type));
                    }
                    e1.error(`Expected arguments of type ${n}, but found (${r.join(", ")}) instead.`);
                }
                return null;
            }
            static register(t, e1) {
                Br.definitions = e1;
                for(const n in e1)t[n] = Br;
            }
        }
        function Cr(t, [e1, n, r, i]) {
            e1 = e1.evaluate(t), n = n.evaluate(t), r = r.evaluate(t);
            const s = i ? i.evaluate(t) : 1, o = Ue(e1, n, r, s);
            if (o) throw new Le(o);
            return new Te(e1 / 255, n / 255, r / 255, s, !1);
        }
        function Vr(t, e1) {
            return t in e1;
        }
        function Lr(t, e1) {
            const n = e1[t];
            return void 0 === n ? null : n;
        }
        function Or(t) {
            return {
                type: t
            };
        }
        function $r(t) {
            if (t instanceof en) return $r(t.boundExpression);
            if (t instanceof Br && "error" === t.name) return !1;
            if (t instanceof Tn) return !1;
            if (t instanceof Jn) return !1;
            if (t instanceof Pr) return !1;
            if (t instanceof Dr) return !1;
            const e1 = t instanceof We || t instanceof Ze;
            let n = !0;
            return t.eachChild((t)=>{
                n = e1 ? n && $r(t) : n && t instanceof Xe;
            }), !!n && Rr(t) && Ur(t, [
                "zoom",
                "heatmap-density",
                "elevation",
                "line-progress",
                "accumulated",
                "is-supported-script"
            ]);
        }
        function Rr(t) {
            if (t instanceof Br) {
                if ("get" === t.name && 1 === t.args.length) return !1;
                if ("feature-state" === t.name) return !1;
                if ("has" === t.name && 1 === t.args.length) return !1;
                if ("properties" === t.name || "geometry-type" === t.name || "id" === t.name) return !1;
                if (/^filter-/.test(t.name)) return !1;
            }
            if (t instanceof Jn) return !1;
            if (t instanceof Pr) return !1;
            let e1 = !0;
            return t.eachChild((t)=>{
                e1 && !Rr(t) && (e1 = !1);
            }), e1;
        }
        function Nr(t) {
            if (t instanceof Br && "feature-state" === t.name) return !1;
            let e1 = !0;
            return t.eachChild((t)=>{
                e1 && !Nr(t) && (e1 = !1);
            }), e1;
        }
        function Ur(t, e1) {
            if (t instanceof Br && e1.indexOf(t.name) >= 0) return !1;
            let n = !0;
            return t.eachChild((t)=>{
                n && !Ur(t, e1) && (n = !1);
            }), n;
        }
        function jr(t) {
            return {
                result: "success",
                value: t
            };
        }
        function qr(t) {
            return {
                result: "error",
                value: t
            };
        }
        function Gr(t) {
            return "data-driven" === t["property-type"] || "cross-faded-data-driven" === t["property-type"];
        }
        function Xr(t) {
            return !!t.expression && t.expression.parameters.indexOf("zoom") > -1;
        }
        function Yr(t) {
            return !!t.expression && t.expression.interpolated;
        }
        function Zr(t) {
            return t instanceof Number ? "number" : t instanceof String ? "string" : t instanceof Boolean ? "boolean" : Array.isArray(t) ? "array" : null === t ? "null" : typeof t;
        }
        function Hr(t) {
            return "object" == typeof t && null !== t && !Array.isArray(t) && qe(t) === jt;
        }
        function Wr(t) {
            return t;
        }
        function Kr(t, e1) {
            const n = t.stops && "object" == typeof t.stops[0][0], r = n || !(n || void 0 !== t.property), i = t.type || (Yr(e1) ? "exponential" : "interval"), s = function(t) {
                switch(t.type){
                    case "color":
                        return Te.parse;
                    case "padding":
                        return Be.parse;
                    case "numberArray":
                        return Ce.parse;
                    case "colorArray":
                        return Ve.parse;
                    default:
                        return null;
                }
            }(e1);
            if (s && ((t = Bt({}, t)).stops && (t.stops = t.stops.map((t)=>[
                    t[0],
                    s(t[1])
                ])), t.default = s(t.default ? t.default : e1.default)), t.colorSpace && "rgb" !== (o = t.colorSpace) && "hcl" !== o && "lab" !== o) throw new Error(`Unknown color space: "${t.colorSpace}"`);
            var o;
            const a = function(t) {
                switch(t){
                    case "exponential":
                        return ei;
                    case "interval":
                        return ti;
                    case "categorical":
                        return Qr;
                    case "identity":
                        return ni;
                    default:
                        throw new Error(`Unknown function type "${t}"`);
                }
            }(i);
            let l, u;
            if ("categorical" === i) {
                l = Object.create(null);
                for (const e1 of t.stops)l[e1[0]] = e1[1];
                u = typeof t.stops[0][0];
            }
            if (n) {
                const n = {}, r = [];
                for(let e1 = 0; e1 < t.stops.length; e1++){
                    const i = t.stops[e1], s = i[0].zoom;
                    void 0 === n[s] && (n[s] = {
                        zoom: s,
                        type: t.type,
                        property: t.property,
                        default: t.default,
                        stops: []
                    }, r.push(s)), n[s].stops.push([
                        i[0].value,
                        i[1]
                    ]);
                }
                const i = [];
                for (const t of r)i.push([
                    n[t].zoom,
                    Kr(n[t], e1)
                ]);
                const s = {
                    name: "linear"
                };
                return {
                    kind: "composite",
                    interpolationType: s,
                    interpolationFactor: mn.interpolationFactor.bind(void 0, s),
                    zoomStops: i.map((t)=>t[0]),
                    evaluate: ({ zoom: n }, r)=>ei({
                            stops: i,
                            base: t.base
                        }, e1, n).evaluate(n, r)
                };
            }
            if (r) {
                const n = "exponential" === i ? {
                    name: "exponential",
                    base: void 0 !== t.base ? t.base : 1
                } : null;
                return {
                    kind: "camera",
                    interpolationType: n,
                    interpolationFactor: mn.interpolationFactor.bind(void 0, n),
                    zoomStops: t.stops.map((t)=>t[0]),
                    evaluate: ({ zoom: n })=>a(t, e1, n, l, u)
                };
            }
            return {
                kind: "source",
                evaluate (n, r) {
                    const i = r && r.properties ? r.properties[t.property] : void 0;
                    return void 0 === i ? Jr(t.default, e1.default) : a(t, e1, i, l, u);
                }
            };
        }
        function Jr(t, e1, n) {
            return void 0 !== t ? t : void 0 !== e1 ? e1 : void 0 !== n ? n : void 0;
        }
        function Qr(t, e1, n, r, i) {
            return Jr(typeof n === i ? r[n] : void 0, t.default, e1.default);
        }
        function ti(t, e1, n) {
            if ("number" !== Zr(n)) return Jr(t.default, e1.default);
            const r = t.stops.length;
            if (1 === r) return t.stops[0][1];
            if (n <= t.stops[0][0]) return t.stops[0][1];
            if (n >= t.stops[r - 1][0]) return t.stops[r - 1][1];
            const i = un(t.stops.map((t)=>t[0]), n);
            return t.stops[i][1];
        }
        function ei(t, e1, n) {
            const r = void 0 !== t.base ? t.base : 1;
            if ("number" !== Zr(n)) return Jr(t.default, e1.default);
            const i = t.stops.length;
            if (1 === i) return t.stops[0][1];
            if (n <= t.stops[0][0]) return t.stops[0][1];
            if (n >= t.stops[i - 1][0]) return t.stops[i - 1][1];
            const s = un(t.stops.map((t)=>t[0]), n), o = function(t, e1, n, r) {
                const i = r - n, s = t - n;
                return 0 === i ? 0 : 1 === e1 ? s / i : (Math.pow(e1, s) - 1) / (Math.pow(e1, i) - 1);
            }(n, r, t.stops[s][0], t.stops[s + 1][0]), a = t.stops[s][1], l = t.stops[s + 1][1], u = xn[e1.type] || Wr;
            return "function" == typeof a.evaluate ? {
                evaluate (...e1) {
                    const n = a.evaluate.apply(void 0, e1), r = l.evaluate.apply(void 0, e1);
                    if (void 0 !== n && void 0 !== r) return u(n, r, o, t.colorSpace);
                }
            } : u(a, l, o, t.colorSpace);
        }
        function ni(t, e1, n) {
            switch(e1.type){
                case "color":
                    n = Te.parse(n);
                    break;
                case "formatted":
                    n = ze.fromString(n.toString());
                    break;
                case "resolvedImage":
                    n = Re.fromString(n.toString());
                    break;
                case "padding":
                    n = Be.parse(n);
                    break;
                case "colorArray":
                    n = Ve.parse(n);
                    break;
                case "numberArray":
                    n = Ce.parse(n);
                    break;
                default:
                    Zr(n) === e1.type || "enum" === e1.type && e1.values[n] || (n = void 0);
            }
            return Jr(n, t.default, e1.default);
        }
        Br.register(zr, {
            error: [
                {
                    kind: "error"
                },
                [
                    $t
                ],
                (t, [e1])=>{
                    throw new Le(e1.evaluate(t));
                }
            ],
            typeof: [
                $t,
                [
                    qt
                ],
                (t, [e1])=>Qt(qe(e1.evaluate(t)))
            ],
            "to-rgba": [
                Jt(Ot, 4),
                [
                    Nt
                ],
                (t, [e1])=>{
                    const [n, r, i, s] = e1.evaluate(t).rgb;
                    return [
                        255 * n,
                        255 * r,
                        255 * i,
                        s
                    ];
                }
            ],
            rgb: [
                Nt,
                [
                    Ot,
                    Ot,
                    Ot
                ],
                Cr
            ],
            rgba: [
                Nt,
                [
                    Ot,
                    Ot,
                    Ot,
                    Ot
                ],
                Cr
            ],
            has: {
                type: Rt,
                overloads: [
                    [
                        [
                            $t
                        ],
                        (t, [e1])=>Vr(e1.evaluate(t), t.properties())
                    ],
                    [
                        [
                            $t,
                            jt
                        ],
                        (t, [e1, n])=>Vr(e1.evaluate(t), n.evaluate(t))
                    ]
                ]
            },
            get: {
                type: qt,
                overloads: [
                    [
                        [
                            $t
                        ],
                        (t, [e1])=>Lr(e1.evaluate(t), t.properties())
                    ],
                    [
                        [
                            $t,
                            jt
                        ],
                        (t, [e1, n])=>Lr(e1.evaluate(t), n.evaluate(t))
                    ]
                ]
            },
            "feature-state": [
                qt,
                [
                    $t
                ],
                (t, [e1])=>Lr(e1.evaluate(t), t.featureState || {})
            ],
            properties: [
                jt,
                [],
                (t)=>t.properties()
            ],
            "geometry-type": [
                $t,
                [],
                (t)=>t.geometryType()
            ],
            id: [
                qt,
                [],
                (t)=>t.id()
            ],
            zoom: [
                Ot,
                [],
                (t)=>t.globals.zoom
            ],
            "heatmap-density": [
                Ot,
                [],
                (t)=>t.globals.heatmapDensity || 0
            ],
            elevation: [
                Ot,
                [],
                (t)=>t.globals.elevation || 0
            ],
            "line-progress": [
                Ot,
                [],
                (t)=>t.globals.lineProgress || 0
            ],
            accumulated: [
                qt,
                [],
                (t)=>void 0 === t.globals.accumulated ? null : t.globals.accumulated
            ],
            "+": [
                Ot,
                Or(Ot),
                (t, e1)=>{
                    let n = 0;
                    for (const r of e1)n += r.evaluate(t);
                    return n;
                }
            ],
            "*": [
                Ot,
                Or(Ot),
                (t, e1)=>{
                    let n = 1;
                    for (const r of e1)n *= r.evaluate(t);
                    return n;
                }
            ],
            "-": {
                type: Ot,
                overloads: [
                    [
                        [
                            Ot,
                            Ot
                        ],
                        (t, [e1, n])=>e1.evaluate(t) - n.evaluate(t)
                    ],
                    [
                        [
                            Ot
                        ],
                        (t, [e1])=>-e1.evaluate(t)
                    ]
                ]
            },
            "/": [
                Ot,
                [
                    Ot,
                    Ot
                ],
                (t, [e1, n])=>e1.evaluate(t) / n.evaluate(t)
            ],
            "%": [
                Ot,
                [
                    Ot,
                    Ot
                ],
                (t, [e1, n])=>e1.evaluate(t) % n.evaluate(t)
            ],
            ln2: [
                Ot,
                [],
                ()=>Math.LN2
            ],
            pi: [
                Ot,
                [],
                ()=>Math.PI
            ],
            e: [
                Ot,
                [],
                ()=>Math.E
            ],
            "^": [
                Ot,
                [
                    Ot,
                    Ot
                ],
                (t, [e1, n])=>Math.pow(e1.evaluate(t), n.evaluate(t))
            ],
            sqrt: [
                Ot,
                [
                    Ot
                ],
                (t, [e1])=>Math.sqrt(e1.evaluate(t))
            ],
            log10: [
                Ot,
                [
                    Ot
                ],
                (t, [e1])=>Math.log(e1.evaluate(t)) / Math.LN10
            ],
            ln: [
                Ot,
                [
                    Ot
                ],
                (t, [e1])=>Math.log(e1.evaluate(t))
            ],
            log2: [
                Ot,
                [
                    Ot
                ],
                (t, [e1])=>Math.log(e1.evaluate(t)) / Math.LN2
            ],
            sin: [
                Ot,
                [
                    Ot
                ],
                (t, [e1])=>Math.sin(e1.evaluate(t))
            ],
            cos: [
                Ot,
                [
                    Ot
                ],
                (t, [e1])=>Math.cos(e1.evaluate(t))
            ],
            tan: [
                Ot,
                [
                    Ot
                ],
                (t, [e1])=>Math.tan(e1.evaluate(t))
            ],
            asin: [
                Ot,
                [
                    Ot
                ],
                (t, [e1])=>Math.asin(e1.evaluate(t))
            ],
            acos: [
                Ot,
                [
                    Ot
                ],
                (t, [e1])=>Math.acos(e1.evaluate(t))
            ],
            atan: [
                Ot,
                [
                    Ot
                ],
                (t, [e1])=>Math.atan(e1.evaluate(t))
            ],
            min: [
                Ot,
                Or(Ot),
                (t, e1)=>Math.min(...e1.map((e1)=>e1.evaluate(t)))
            ],
            max: [
                Ot,
                Or(Ot),
                (t, e1)=>Math.max(...e1.map((e1)=>e1.evaluate(t)))
            ],
            abs: [
                Ot,
                [
                    Ot
                ],
                (t, [e1])=>Math.abs(e1.evaluate(t))
            ],
            round: [
                Ot,
                [
                    Ot
                ],
                (t, [e1])=>{
                    const n = e1.evaluate(t);
                    return n < 0 ? -Math.round(-n) : Math.round(n);
                }
            ],
            floor: [
                Ot,
                [
                    Ot
                ],
                (t, [e1])=>Math.floor(e1.evaluate(t))
            ],
            ceil: [
                Ot,
                [
                    Ot
                ],
                (t, [e1])=>Math.ceil(e1.evaluate(t))
            ],
            "filter-==": [
                Rt,
                [
                    $t,
                    qt
                ],
                (t, [e1, n])=>t.properties()[e1.value] === n.value
            ],
            "filter-id-==": [
                Rt,
                [
                    qt
                ],
                (t, [e1])=>t.id() === e1.value
            ],
            "filter-type-==": [
                Rt,
                [
                    $t
                ],
                (t, [e1])=>t.geometryType() === e1.value
            ],
            "filter-<": [
                Rt,
                [
                    $t,
                    qt
                ],
                (t, [e1, n])=>{
                    const r = t.properties()[e1.value], i = n.value;
                    return typeof r == typeof i && r < i;
                }
            ],
            "filter-id-<": [
                Rt,
                [
                    qt
                ],
                (t, [e1])=>{
                    const n = t.id(), r = e1.value;
                    return typeof n == typeof r && n < r;
                }
            ],
            "filter->": [
                Rt,
                [
                    $t,
                    qt
                ],
                (t, [e1, n])=>{
                    const r = t.properties()[e1.value], i = n.value;
                    return typeof r == typeof i && r > i;
                }
            ],
            "filter-id->": [
                Rt,
                [
                    qt
                ],
                (t, [e1])=>{
                    const n = t.id(), r = e1.value;
                    return typeof n == typeof r && n > r;
                }
            ],
            "filter-<=": [
                Rt,
                [
                    $t,
                    qt
                ],
                (t, [e1, n])=>{
                    const r = t.properties()[e1.value], i = n.value;
                    return typeof r == typeof i && r <= i;
                }
            ],
            "filter-id-<=": [
                Rt,
                [
                    qt
                ],
                (t, [e1])=>{
                    const n = t.id(), r = e1.value;
                    return typeof n == typeof r && n <= r;
                }
            ],
            "filter->=": [
                Rt,
                [
                    $t,
                    qt
                ],
                (t, [e1, n])=>{
                    const r = t.properties()[e1.value], i = n.value;
                    return typeof r == typeof i && r >= i;
                }
            ],
            "filter-id->=": [
                Rt,
                [
                    qt
                ],
                (t, [e1])=>{
                    const n = t.id(), r = e1.value;
                    return typeof n == typeof r && n >= r;
                }
            ],
            "filter-has": [
                Rt,
                [
                    qt
                ],
                (t, [e1])=>e1.value in t.properties()
            ],
            "filter-has-id": [
                Rt,
                [],
                (t)=>null !== t.id() && void 0 !== t.id()
            ],
            "filter-type-in": [
                Rt,
                [
                    Jt($t)
                ],
                (t, [e1])=>e1.value.indexOf(t.geometryType()) >= 0
            ],
            "filter-id-in": [
                Rt,
                [
                    Jt(qt)
                ],
                (t, [e1])=>e1.value.indexOf(t.id()) >= 0
            ],
            "filter-in-small": [
                Rt,
                [
                    $t,
                    Jt(qt)
                ],
                (t, [e1, n])=>n.value.indexOf(t.properties()[e1.value]) >= 0
            ],
            "filter-in-large": [
                Rt,
                [
                    $t,
                    Jt(qt)
                ],
                (t, [e1, n])=>(function(t, e1, n, r) {
                        for(; n <= r;){
                            const i = n + r >> 1;
                            if (e1[i] === t) return !0;
                            e1[i] > t ? r = i - 1 : n = i + 1;
                        }
                        return !1;
                    })(t.properties()[e1.value], n.value, 0, n.value.length - 1)
            ],
            all: {
                type: Rt,
                overloads: [
                    [
                        [
                            Rt,
                            Rt
                        ],
                        (t, [e1, n])=>e1.evaluate(t) && n.evaluate(t)
                    ],
                    [
                        Or(Rt),
                        (t, e1)=>{
                            for (const n of e1)if (!n.evaluate(t)) return !1;
                            return !0;
                        }
                    ]
                ]
            },
            any: {
                type: Rt,
                overloads: [
                    [
                        [
                            Rt,
                            Rt
                        ],
                        (t, [e1, n])=>e1.evaluate(t) || n.evaluate(t)
                    ],
                    [
                        Or(Rt),
                        (t, e1)=>{
                            for (const n of e1)if (n.evaluate(t)) return !0;
                            return !1;
                        }
                    ]
                ]
            },
            "!": [
                Rt,
                [
                    Rt
                ],
                (t, [e1])=>!e1.evaluate(t)
            ],
            "is-supported-script": [
                Rt,
                [
                    $t
                ],
                (t, [e1])=>{
                    const n = t.globals && t.globals.isSupportedScript;
                    return !n || n(e1.evaluate(t));
                }
            ],
            upcase: [
                $t,
                [
                    $t
                ],
                (t, [e1])=>e1.evaluate(t).toUpperCase()
            ],
            downcase: [
                $t,
                [
                    $t
                ],
                (t, [e1])=>e1.evaluate(t).toLowerCase()
            ],
            concat: [
                $t,
                Or(qt),
                (t, e1)=>e1.map((e1)=>Ge(e1.evaluate(t))).join("")
            ],
            split: [
                Jt($t),
                [
                    $t,
                    $t
                ],
                (t, [e1, n])=>e1.evaluate(t).split(n.evaluate(t))
            ],
            join: [
                $t,
                [
                    Jt($t),
                    $t
                ],
                (t, [e1, n])=>e1.evaluate(t).join(n.evaluate(t))
            ],
            "resolved-locale": [
                $t,
                [
                    Gt
                ],
                (t, [e1])=>e1.evaluate(t).resolvedLocale()
            ]
        });
        class ri {
            constructor(t, e1, n){
                this.expression = t, this._warningHistory = {}, this._evaluator = new Je, this._defaultValue = e1 ? function(t) {
                    if ("color" === t.type && Hr(t.default)) return new Te(0, 0, 0, 0);
                    switch(t.type){
                        case "color":
                            return Te.parse(t.default) || null;
                        case "padding":
                            return Be.parse(t.default) || null;
                        case "numberArray":
                            return Ce.parse(t.default) || null;
                        case "colorArray":
                            return Ve.parse(t.default) || null;
                        case "variableAnchorOffsetCollection":
                            return $e.parse(t.default) || null;
                        case "projectionDefinition":
                            return Ne.parse(t.default) || null;
                        default:
                            return void 0 === t.default ? null : t.default;
                    }
                }(e1) : null, this._enumValues = e1 && "enum" === e1.type ? e1.values : null, this._globalState = n;
            }
            evaluateWithoutErrorHandling(t, e1, n, r, i, s) {
                return this._globalState && (t = pi(t, this._globalState)), this._evaluator.globals = t, this._evaluator.feature = e1, this._evaluator.featureState = n, this._evaluator.canonical = r, this._evaluator.availableImages = i || null, this._evaluator.formattedSection = s, this.expression.evaluate(this._evaluator);
            }
            evaluate(t, e1, n, r, i, s) {
                this._globalState && (t = pi(t, this._globalState)), this._evaluator.globals = t, this._evaluator.feature = e1 || null, this._evaluator.featureState = n || null, this._evaluator.canonical = r, this._evaluator.availableImages = i || null, this._evaluator.formattedSection = s || null;
                try {
                    const t = this.expression.evaluate(this._evaluator);
                    if (null == t || "number" == typeof t && t != t) return this._defaultValue;
                    if (this._enumValues && !(t in this._enumValues)) throw new Le(`Expected value to be one of ${Object.keys(this._enumValues).map((t)=>JSON.stringify(t)).join(", ")}, but found ${JSON.stringify(t)} instead.`);
                    return t;
                } catch (t) {
                    return this._warningHistory[t.message] || (this._warningHistory[t.message] = !0, "undefined" != typeof console && console.warn(t.message)), this._defaultValue;
                }
            }
        }
        function ii(t) {
            return Array.isArray(t) && t.length > 0 && "string" == typeof t[0] && t[0] in zr;
        }
        function si(t, e1, n) {
            const r = new Qe(zr, $r, [], e1 ? function(t) {
                const e1 = {
                    color: Nt,
                    string: $t,
                    number: Ot,
                    enum: $t,
                    boolean: Rt,
                    formatted: Xt,
                    padding: Yt,
                    numberArray: Ht,
                    colorArray: Zt,
                    projectionDefinition: Ut,
                    resolvedImage: Wt,
                    variableAnchorOffsetCollection: Kt
                };
                return "array" === t.type ? Jt(e1[t.value] || qt, t.length) : e1[t.type];
            }(e1) : void 0), i = r.parse(t, void 0, void 0, void 0, e1 && "string" === e1.type ? {
                typeAnnotation: "coerce"
            } : void 0);
            return i ? jr(new ri(i, e1, n)) : qr(r.errors);
        }
        class oi {
            constructor(t, e1, n){
                this.kind = t, this._styleExpression = e1, this.isStateDependent = "constant" !== t && !Nr(e1.expression), this.globalStateRefs = hi(e1.expression), this._globalState = n;
            }
            evaluateWithoutErrorHandling(t, e1, n, r, i, s) {
                return this._globalState && (t = pi(t, this._globalState)), this._styleExpression.evaluateWithoutErrorHandling(t, e1, n, r, i, s);
            }
            evaluate(t, e1, n, r, i, s) {
                return this._globalState && (t = pi(t, this._globalState)), this._styleExpression.evaluate(t, e1, n, r, i, s);
            }
        }
        class ai {
            constructor(t, e1, n, r, i){
                this.kind = t, this.zoomStops = n, this._styleExpression = e1, this.isStateDependent = "camera" !== t && !Nr(e1.expression), this.globalStateRefs = hi(e1.expression), this.interpolationType = r, this._globalState = i;
            }
            evaluateWithoutErrorHandling(t, e1, n, r, i, s) {
                return this._globalState && (t = pi(t, this._globalState)), this._styleExpression.evaluateWithoutErrorHandling(t, e1, n, r, i, s);
            }
            evaluate(t, e1, n, r, i, s) {
                return this._globalState && (t = pi(t, this._globalState)), this._styleExpression.evaluate(t, e1, n, r, i, s);
            }
            interpolationFactor(t, e1, n) {
                return this.interpolationType ? mn.interpolationFactor(this.interpolationType, t, e1, n) : 0;
            }
        }
        function li(t, e1, n) {
            const r = si(t, e1, n);
            if ("error" === r.result) return r;
            const i = r.value.expression, s = Rr(i);
            if (!s && !Gr(e1)) return qr([
                new Ct("", "data expressions not supported")
            ]);
            const o = Ur(i, [
                "zoom"
            ]);
            if (!o && !Xr(e1)) return qr([
                new Ct("", "zoom expressions not supported")
            ]);
            const a = ci(i);
            return a || o ? a instanceof Ct ? qr([
                a
            ]) : a instanceof mn && !Yr(e1) ? qr([
                new Ct("", '"interpolate" expressions cannot be used with this property')
            ]) : jr(a ? new ai(s ? "camera" : "composite", r.value, a.labels, a instanceof mn ? a.interpolation : void 0, n) : new oi(s ? "constant" : "source", r.value, n)) : qr([
                new Ct("", '"zoom" expression may only be used as input to a top-level "step" or "interpolate" expression.')
            ]);
        }
        class ui {
            constructor(t, e1){
                this._parameters = t, this._specification = e1, Bt(this, Kr(this._parameters, this._specification));
            }
            static deserialize(t) {
                return new ui(t._parameters, t._specification);
            }
            static serialize(t) {
                return {
                    _parameters: t._parameters,
                    _specification: t._specification
                };
            }
        }
        function ci(t) {
            let e1 = null;
            if (t instanceof tn) e1 = ci(t.result);
            else if (t instanceof vn) {
                for (const n of t.args)if (e1 = ci(n), e1) break;
            } else (t instanceof cn || t instanceof mn) && t.input instanceof Br && "zoom" === t.input.name && (e1 = t);
            return e1 instanceof Ct || t.eachChild((t)=>{
                const n = ci(t);
                n instanceof Ct ? e1 = n : !e1 && n ? e1 = new Ct("", '"zoom" expression may only be used as input to a top-level "step" or "interpolate" expression.') : e1 && n && e1 !== n && (e1 = new Ct("", 'Only one zoom-based "step" or "interpolate" subexpression may be used in an expression.'));
            }), e1;
        }
        function hi(t, e1 = new Set) {
            return t instanceof Dr && e1.add(t.key), t.eachChild((t)=>{
                hi(t, e1);
            }), e1;
        }
        function pi(t, e1) {
            const { zoom: n, heatmapDensity: r, elevation: i, lineProgress: s, isSupportedScript: o, accumulated: a } = null != t ? t : {};
            return {
                zoom: n,
                heatmapDensity: r,
                elevation: i,
                lineProgress: s,
                isSupportedScript: o,
                accumulated: a,
                globalState: e1
            };
        }
        function fi(t) {
            if (!0 === t || !1 === t) return !0;
            if (!Array.isArray(t) || 0 === t.length) return !1;
            switch(t[0]){
                case "has":
                    return t.length >= 2 && "$id" !== t[1] && "$type" !== t[1];
                case "in":
                    return t.length >= 3 && ("string" != typeof t[1] || Array.isArray(t[2]));
                case "!in":
                case "!has":
                case "none":
                    return !1;
                case "==":
                case "!=":
                case ">":
                case ">=":
                case "<":
                case "<=":
                    return 3 !== t.length || Array.isArray(t[1]) || Array.isArray(t[2]);
                case "any":
                case "all":
                    for (const e1 of t.slice(1))if (!fi(e1) && "boolean" != typeof e1) return !1;
                    return !0;
                default:
                    return !0;
            }
        }
        const di = {
            type: "boolean",
            default: !1,
            transition: !1,
            "property-type": "data-driven",
            expression: {
                interpolated: !1,
                parameters: [
                    "zoom",
                    "feature"
                ]
            }
        };
        function yi(t, e1) {
            if (null == t) return {
                filter: ()=>!0,
                needGeometry: !1,
                getGlobalStateRefs: ()=>new Set
            };
            fi(t) || (t = xi(t));
            const n = si(t, di, e1);
            if ("error" === n.result) throw new Error(n.value.map((t)=>`${t.key}: ${t.message}`).join(", "));
            return {
                filter: (t, e1, r)=>n.value.evaluate(t, e1, {}, r),
                needGeometry: gi(t),
                getGlobalStateRefs: ()=>hi(n.value.expression)
            };
        }
        function mi(t, e1) {
            return t < e1 ? -1 : t > e1 ? 1 : 0;
        }
        function gi(t) {
            if (!Array.isArray(t)) return !1;
            if ("within" === t[0] || "distance" === t[0]) return !0;
            for(let e1 = 1; e1 < t.length; e1++)if (gi(t[e1])) return !0;
            return !1;
        }
        function xi(t) {
            if (!t) return !0;
            const e1 = t[0];
            var n;
            return t.length <= 1 ? "any" !== e1 : "==" === e1 ? vi(t[1], t[2], "==") : "!=" === e1 ? _i(vi(t[1], t[2], "==")) : "<" === e1 || ">" === e1 || "<=" === e1 || ">=" === e1 ? vi(t[1], t[2], e1) : "any" === e1 ? (n = t.slice(1), [
                "any"
            ].concat(n.map(xi))) : "all" === e1 ? [
                "all"
            ].concat(t.slice(1).map(xi)) : "none" === e1 ? [
                "all"
            ].concat(t.slice(1).map(xi).map(_i)) : "in" === e1 ? bi(t[1], t.slice(2)) : "!in" === e1 ? _i(bi(t[1], t.slice(2))) : "has" === e1 ? wi(t[1]) : "!has" !== e1 || _i(wi(t[1]));
        }
        function vi(t, e1, n) {
            switch(t){
                case "$type":
                    return [
                        `filter-type-${n}`,
                        e1
                    ];
                case "$id":
                    return [
                        `filter-id-${n}`,
                        e1
                    ];
                default:
                    return [
                        `filter-${n}`,
                        t,
                        e1
                    ];
            }
        }
        function bi(t, e1) {
            if (0 === e1.length) return !1;
            switch(t){
                case "$type":
                    return [
                        "filter-type-in",
                        [
                            "literal",
                            e1
                        ]
                    ];
                case "$id":
                    return [
                        "filter-id-in",
                        [
                            "literal",
                            e1
                        ]
                    ];
                default:
                    return e1.length > 200 && !e1.some((t)=>typeof t != typeof e1[0]) ? [
                        "filter-in-large",
                        t,
                        [
                            "literal",
                            e1.sort(mi)
                        ]
                    ] : [
                        "filter-in-small",
                        t,
                        [
                            "literal",
                            e1
                        ]
                    ];
            }
        }
        function wi(t) {
            switch(t){
                case "$type":
                    return !0;
                case "$id":
                    return [
                        "filter-has-id"
                    ];
                default:
                    return [
                        "filter-has",
                        t
                    ];
            }
        }
        function _i(t) {
            return [
                "!",
                t
            ];
        }
        function Si(t) {
            const e1 = typeof t;
            if ("number" === e1 || "boolean" === e1 || "string" === e1 || null == t) return JSON.stringify(t);
            if (Array.isArray(t)) {
                let e1 = "[";
                for (const n of t)e1 += `${Si(n)},`;
                return `${e1}]`;
            }
            const n = Object.keys(t).sort();
            let r = "{";
            for(let e1 = 0; e1 < n.length; e1++)r += `${JSON.stringify(n[e1])}:${Si(t[n[e1]])},`;
            return `${r}}`;
        }
        function Ai(t) {
            let e1 = "";
            for (const n of _t)e1 += `/${Si(t[n])}`;
            return e1;
        }
        function Mi(t) {
            const e1 = t.value;
            return e1 ? [
                new zt(t.key, e1, "constants have been deprecated as of v8")
            ] : [];
        }
        function ki(t) {
            return t instanceof Number || t instanceof String || t instanceof Boolean ? t.valueOf() : t;
        }
        function Ii(t) {
            if (Array.isArray(t)) return t.map(Ii);
            if (t instanceof Object && !(t instanceof Number || t instanceof String || t instanceof Boolean)) {
                const e1 = {};
                for(const n in t)e1[n] = Ii(t[n]);
                return e1;
            }
            return ki(t);
        }
        function Ei(t) {
            const e1 = t.key, n = t.value, r = t.valueSpec || {}, i = t.objectElementValidators || {}, s = t.style, o = t.styleSpec, a = t.validateSpec;
            let l = [];
            const u = Zr(n);
            if ("object" !== u) return [
                new zt(e1, n, `object expected, ${u} found`)
            ];
            for(const t in n){
                const u = t.split(".")[0], c = we(r, u) || r["*"];
                let h;
                if (we(i, u)) h = i[u];
                else if (we(r, u)) {
                    if (void 0 === n[t]) continue;
                    h = a;
                } else if (i["*"]) h = i["*"];
                else {
                    if (!r["*"]) {
                        l.push(new zt(e1, n[t], `unknown property "${t}"`));
                        continue;
                    }
                    h = a;
                }
                l = l.concat(h({
                    key: (e1 ? `${e1}.` : e1) + t,
                    value: n[t],
                    valueSpec: c,
                    style: s,
                    styleSpec: o,
                    object: n,
                    objectKey: t,
                    validateSpec: a
                }, n));
            }
            for(const t in r)i[t] || r[t].required && void 0 === r[t].default && void 0 === n[t] && l.push(new zt(e1, n, `missing required property "${t}"`));
            return l;
        }
        function Ti(t) {
            const e1 = t.value, n = t.valueSpec, r = t.style, i = t.styleSpec, s = t.key, o = t.arrayElementValidator || t.validateSpec;
            if ("array" !== Zr(e1)) return [
                new zt(s, e1, `array expected, ${Zr(e1)} found`)
            ];
            if (n.length && e1.length !== n.length) return [
                new zt(s, e1, `array length ${n.length} expected, length ${e1.length} found`)
            ];
            let a = {
                type: n.value,
                values: n.values
            };
            i.$version < 7 && (a.function = n.function), "object" === Zr(n.value) && (a = n.value);
            let l = [];
            for(let n = 0; n < e1.length; n++)l = l.concat(o({
                array: e1,
                arrayIndex: n,
                value: e1[n],
                valueSpec: a,
                validateSpec: t.validateSpec,
                style: r,
                styleSpec: i,
                key: `${s}[${n}]`
            }));
            return l;
        }
        function Fi(t) {
            const e1 = t.key, n = t.value, r = t.valueSpec;
            let i = Zr(n);
            return "number" === i && n != n && (i = "NaN"), "number" !== i ? [
                new zt(e1, n, `number expected, ${i} found`)
            ] : "minimum" in r && n < r.minimum ? [
                new zt(e1, n, `${n} is less than the minimum value ${r.minimum}`)
            ] : "maximum" in r && n > r.maximum ? [
                new zt(e1, n, `${n} is greater than the maximum value ${r.maximum}`)
            ] : [];
        }
        function Pi(t) {
            const e1 = t.valueSpec, n = ki(t.value.type);
            let r, i, s, o = {};
            const a = "categorical" !== n && void 0 === t.value.property, l = !a, u = "array" === Zr(t.value.stops) && "array" === Zr(t.value.stops[0]) && "object" === Zr(t.value.stops[0][0]), c = Ei({
                key: t.key,
                value: t.value,
                valueSpec: t.styleSpec.function,
                validateSpec: t.validateSpec,
                style: t.style,
                styleSpec: t.styleSpec,
                objectElementValidators: {
                    stops: function(t) {
                        if ("identity" === n) return [
                            new zt(t.key, t.value, 'identity function may not have a "stops" property')
                        ];
                        let e1 = [];
                        const r = t.value;
                        return e1 = e1.concat(Ti({
                            key: t.key,
                            value: r,
                            valueSpec: t.valueSpec,
                            validateSpec: t.validateSpec,
                            style: t.style,
                            styleSpec: t.styleSpec,
                            arrayElementValidator: h
                        })), "array" === Zr(r) && 0 === r.length && e1.push(new zt(t.key, r, "array must have at least one stop")), e1;
                    },
                    default: function(t) {
                        return t.validateSpec({
                            key: t.key,
                            value: t.value,
                            valueSpec: e1,
                            validateSpec: t.validateSpec,
                            style: t.style,
                            styleSpec: t.styleSpec
                        });
                    }
                }
            });
            return "identity" === n && a && c.push(new zt(t.key, t.value, 'missing required property "property"')), "identity" === n || t.value.stops || c.push(new zt(t.key, t.value, 'missing required property "stops"')), "exponential" === n && t.valueSpec.expression && !Yr(t.valueSpec) && c.push(new zt(t.key, t.value, "exponential functions not supported")), t.styleSpec.$version >= 8 && (l && !Gr(t.valueSpec) ? c.push(new zt(t.key, t.value, "property functions not supported")) : a && !Xr(t.valueSpec) && c.push(new zt(t.key, t.value, "zoom functions not supported"))), "categorical" !== n && !u || void 0 !== t.value.property || c.push(new zt(t.key, t.value, '"property" property is required')), c;
            function h(t) {
                let n = [];
                const r = t.value, a = t.key;
                if ("array" !== Zr(r)) return [
                    new zt(a, r, `array expected, ${Zr(r)} found`)
                ];
                if (2 !== r.length) return [
                    new zt(a, r, `array length 2 expected, length ${r.length} found`)
                ];
                if (u) {
                    if ("object" !== Zr(r[0])) return [
                        new zt(a, r, `object expected, ${Zr(r[0])} found`)
                    ];
                    if (void 0 === r[0].zoom) return [
                        new zt(a, r, "object stop key must have zoom")
                    ];
                    if (void 0 === r[0].value) return [
                        new zt(a, r, "object stop key must have value")
                    ];
                    if (s && s > ki(r[0].zoom)) return [
                        new zt(a, r[0].zoom, "stop zoom values must appear in ascending order")
                    ];
                    ki(r[0].zoom) !== s && (s = ki(r[0].zoom), i = void 0, o = {}), n = n.concat(Ei({
                        key: `${a}[0]`,
                        value: r[0],
                        valueSpec: {
                            zoom: {}
                        },
                        validateSpec: t.validateSpec,
                        style: t.style,
                        styleSpec: t.styleSpec,
                        objectElementValidators: {
                            zoom: Fi,
                            value: p
                        }
                    }));
                } else n = n.concat(p({
                    key: `${a}[0]`,
                    value: r[0],
                    validateSpec: t.validateSpec,
                    style: t.style,
                    styleSpec: t.styleSpec
                }, r));
                return ii(Ii(r[1])) ? n.concat([
                    new zt(`${a}[1]`, r[1], "expressions are not allowed in function stops.")
                ]) : n.concat(t.validateSpec({
                    key: `${a}[1]`,
                    value: r[1],
                    valueSpec: e1,
                    validateSpec: t.validateSpec,
                    style: t.style,
                    styleSpec: t.styleSpec
                }));
            }
            function p(t, s) {
                const a = Zr(t.value), l = ki(t.value), u = null !== t.value ? t.value : s;
                if (r) {
                    if (a !== r) return [
                        new zt(t.key, u, `${a} stop domain type must match previous stop domain type ${r}`)
                    ];
                } else r = a;
                if ("number" !== a && "string" !== a && "boolean" !== a) return [
                    new zt(t.key, u, "stop domain value must be a number, string, or boolean")
                ];
                if ("number" !== a && "categorical" !== n) {
                    let r = `number expected, ${a} found`;
                    return Gr(e1) && void 0 === n && (r += '\nIf you intended to use a categorical function, specify `"type": "categorical"`.'), [
                        new zt(t.key, u, r)
                    ];
                }
                return "categorical" !== n || "number" !== a || isFinite(l) && Math.floor(l) === l ? "categorical" !== n && "number" === a && void 0 !== i && l < i ? [
                    new zt(t.key, u, "stop domain values must appear in ascending order")
                ] : (i = l, "categorical" === n && l in o ? [
                    new zt(t.key, u, "stop domain values must be unique")
                ] : (o[l] = !0, [])) : [
                    new zt(t.key, u, `integer expected, found ${l}`)
                ];
            }
        }
        function Di(t) {
            const e1 = ("property" === t.expressionContext ? li : si)(Ii(t.value), t.valueSpec);
            if ("error" === e1.result) return e1.value.map((e1)=>new zt(`${t.key}${e1.key}`, t.value, e1.message));
            const n = e1.value.expression || e1.value._styleExpression.expression;
            if ("property" === t.expressionContext && "text-font" === t.propertyKey && !n.outputDefined()) return [
                new zt(t.key, t.value, `Invalid data expression for "${t.propertyKey}". Output values must be contained as literals within the expression.`)
            ];
            if ("property" === t.expressionContext && "layout" === t.propertyType && !Nr(n)) return [
                new zt(t.key, t.value, '"feature-state" data expressions are not supported with layout properties.')
            ];
            if ("filter" === t.expressionContext && !Nr(n)) return [
                new zt(t.key, t.value, '"feature-state" data expressions are not supported with filters.')
            ];
            if (t.expressionContext && 0 === t.expressionContext.indexOf("cluster")) {
                if (!Ur(n, [
                    "zoom",
                    "feature-state"
                ])) return [
                    new zt(t.key, t.value, '"zoom" and "feature-state" expressions are not supported with cluster properties.')
                ];
                if ("cluster-initial" === t.expressionContext && !Rr(n)) return [
                    new zt(t.key, t.value, "Feature data expressions are not supported with initial expression part of cluster properties.")
                ];
            }
            return [];
        }
        function zi(t) {
            const e1 = t.key, n = t.value, r = Zr(n);
            return "string" !== r ? [
                new zt(e1, n, `color expected, ${r} found`)
            ] : Te.parse(String(n)) ? [] : [
                new zt(e1, n, `color expected, "${n}" found`)
            ];
        }
        function Bi(t) {
            const e1 = t.key, n = t.value, r = t.valueSpec, i = [];
            return Array.isArray(r.values) ? -1 === r.values.indexOf(ki(n)) && i.push(new zt(e1, n, `expected one of [${r.values.join(", ")}], ${JSON.stringify(n)} found`)) : -1 === Object.keys(r.values).indexOf(ki(n)) && i.push(new zt(e1, n, `expected one of [${Object.keys(r.values).join(", ")}], ${JSON.stringify(n)} found`)), i;
        }
        function Ci(t) {
            return fi(Ii(t.value)) ? Di(Bt({}, t, {
                expressionContext: "filter",
                valueSpec: {
                    value: "boolean"
                }
            })) : Vi(t);
        }
        function Vi(t) {
            const e1 = t.value, n = t.key;
            if ("array" !== Zr(e1)) return [
                new zt(n, e1, `array expected, ${Zr(e1)} found`)
            ];
            const r = t.styleSpec;
            let i, s = [];
            if (e1.length < 1) return [
                new zt(n, e1, "filter array must have at least 1 element")
            ];
            switch(s = s.concat(Bi({
                key: `${n}[0]`,
                value: e1[0],
                valueSpec: r.filter_operator,
                style: t.style,
                styleSpec: t.styleSpec
            })), ki(e1[0])){
                case "<":
                case "<=":
                case ">":
                case ">=":
                    e1.length >= 2 && "$type" === ki(e1[1]) && s.push(new zt(n, e1, `"$type" cannot be use with operator "${e1[0]}"`));
                case "==":
                case "!=":
                    3 !== e1.length && s.push(new zt(n, e1, `filter array for operator "${e1[0]}" must have 3 elements`));
                case "in":
                case "!in":
                    e1.length >= 2 && (i = Zr(e1[1]), "string" !== i && s.push(new zt(`${n}[1]`, e1[1], `string expected, ${i} found`)));
                    for(let o = 2; o < e1.length; o++)i = Zr(e1[o]), "$type" === ki(e1[1]) ? s = s.concat(Bi({
                        key: `${n}[${o}]`,
                        value: e1[o],
                        valueSpec: r.geometry_type,
                        style: t.style,
                        styleSpec: t.styleSpec
                    })) : "string" !== i && "number" !== i && "boolean" !== i && s.push(new zt(`${n}[${o}]`, e1[o], `string, number, or boolean expected, ${i} found`));
                    break;
                case "any":
                case "all":
                case "none":
                    for(let r = 1; r < e1.length; r++)s = s.concat(Vi({
                        key: `${n}[${r}]`,
                        value: e1[r],
                        style: t.style,
                        styleSpec: t.styleSpec
                    }));
                    break;
                case "has":
                case "!has":
                    i = Zr(e1[1]), 2 !== e1.length ? s.push(new zt(n, e1, `filter array for "${e1[0]}" operator must have 2 elements`)) : "string" !== i && s.push(new zt(`${n}[1]`, e1[1], `string expected, ${i} found`));
            }
            return s;
        }
        function Li(t, e1) {
            const n = t.key, r = t.validateSpec, i = t.style, s = t.styleSpec, o = t.value, a = t.objectKey, l = s[`${e1}_${t.layerType}`];
            if (!l) return [];
            const u = a.match(/^(.*)-transition$/);
            if ("paint" === e1 && u && l[u[1]] && l[u[1]].transition) return r({
                key: n,
                value: o,
                valueSpec: s.transition,
                style: i,
                styleSpec: s
            });
            const c = t.valueSpec || l[a];
            if (!c) return [
                new zt(n, o, `unknown property "${a}"`)
            ];
            let h;
            if ("string" === Zr(o) && Gr(c) && !c.tokens && (h = /^{([^}]+)}$/.exec(o))) return [
                new zt(n, o, `"${a}" does not support interpolation syntax\nUse an identity property function instead: \`{ "type": "identity", "property": ${JSON.stringify(h[1])} }\`.`)
            ];
            const p = [];
            return "symbol" === t.layerType && "text-font" === a && Hr(Ii(o)) && "identity" === ki(o.type) && p.push(new zt(n, o, '"text-font" does not support identity functions')), p.concat(r({
                key: t.key,
                value: o,
                valueSpec: c,
                style: i,
                styleSpec: s,
                expressionContext: "property",
                propertyType: e1,
                propertyKey: a
            }));
        }
        function Oi(t) {
            return Li(t, "paint");
        }
        function $i(t) {
            return Li(t, "layout");
        }
        function Ri(t) {
            var e1, n;
            let r = [];
            const i = t.value, s = t.key, o = t.style, a = t.styleSpec;
            if ("object" !== Zr(i)) return [
                new zt(s, i, `object expected, ${Zr(i)} found`)
            ];
            i.type || i.ref || r.push(new zt(s, i, 'either "type" or "ref" is required'));
            let l = ki(i.type);
            const u = ki(i.ref);
            if (i.id) {
                const e1 = ki(i.id);
                for(let n = 0; n < t.arrayIndex; n++){
                    const t = o.layers[n];
                    ki(t.id) === e1 && r.push(new zt(s, i.id, `duplicate layer id "${i.id}", previously used at line ${t.id.__line__}`));
                }
            }
            if ("ref" in i) {
                let t;
                [
                    "type",
                    "source",
                    "source-layer",
                    "filter",
                    "layout"
                ].forEach((t)=>{
                    t in i && r.push(new zt(s, i[t], `"${t}" is prohibited for ref layers`));
                }), o.layers.forEach((e1)=>{
                    ki(e1.id) === u && (t = e1);
                }), t ? t.ref ? r.push(new zt(s, i.ref, "ref cannot reference another ref layer")) : l = ki(t.type) : r.push(new zt(s, i.ref, `ref layer "${u}" not found`));
            } else if ("background" !== l) {
                if (i.source) {
                    const t = o.sources && o.sources[i.source], e1 = t && ki(t.type);
                    t ? "vector" === e1 && "raster" === l ? r.push(new zt(s, i.source, `layer "${i.id}" requires a raster source`)) : "raster-dem" !== e1 && "hillshade" === l || "raster-dem" !== e1 && "color-relief" === l ? r.push(new zt(s, i.source, `layer "${i.id}" requires a raster-dem source`)) : "raster" === e1 && "raster" !== l ? r.push(new zt(s, i.source, `layer "${i.id}" requires a vector source`)) : "vector" !== e1 || i["source-layer"] ? "raster-dem" === e1 && "hillshade" !== l && "color-relief" !== l ? r.push(new zt(s, i.source, "raster-dem source can only be used with layer type 'hillshade' or 'color-relief'.")) : "line" !== l || !i.paint || !i.paint["line-gradient"] || "geojson" === e1 && t.lineMetrics || r.push(new zt(s, i, `layer "${i.id}" specifies a line-gradient, which requires a GeoJSON source with \`lineMetrics\` enabled.`)) : r.push(new zt(s, i, `layer "${i.id}" must specify a "source-layer"`)) : r.push(new zt(s, i.source, `source "${i.source}" not found`));
                } else r.push(new zt(s, i, 'missing required property "source"'));
            }
            return "raster" === l && (null === (e1 = i.paint) || void 0 === e1 ? void 0 : e1.resampling) && (null === (n = i.paint) || void 0 === n ? void 0 : n["raster-resampling"]) && r.push(new zt(s, i.paint, `layer "${i.id}" redundantly specifies "resampling" and "raster-resampling" paint properties, but only one is allowed. It is advised to use "resampling".`)), r = r.concat(Ei({
                key: s,
                value: i,
                valueSpec: a.layer,
                style: t.style,
                styleSpec: t.styleSpec,
                validateSpec: t.validateSpec,
                objectElementValidators: {
                    "*": ()=>[],
                    type: ()=>t.validateSpec({
                            key: `${s}.type`,
                            value: i.type,
                            valueSpec: a.layer.type,
                            style: t.style,
                            styleSpec: t.styleSpec,
                            validateSpec: t.validateSpec,
                            object: i,
                            objectKey: "type"
                        }),
                    filter: Ci,
                    layout: (t)=>Ei({
                            layer: i,
                            key: t.key,
                            value: t.value,
                            style: t.style,
                            styleSpec: t.styleSpec,
                            validateSpec: t.validateSpec,
                            objectElementValidators: {
                                "*": (t)=>$i(Bt({
                                        layerType: l
                                    }, t))
                            }
                        }),
                    paint: (t)=>Ei({
                            layer: i,
                            key: t.key,
                            value: t.value,
                            style: t.style,
                            styleSpec: t.styleSpec,
                            validateSpec: t.validateSpec,
                            objectElementValidators: {
                                "*": (t)=>Oi(Bt({
                                        layerType: l
                                    }, t))
                            }
                        })
                }
            })), r;
        }
        function Ni(t) {
            const e1 = t.value, n = t.key, r = Zr(e1);
            return "string" !== r ? [
                new zt(n, e1, `string expected, ${r} found`)
            ] : [];
        }
        const Ui = {
            promoteId: function({ key: t, value: e1 }) {
                if ("string" === Zr(e1)) return Ni({
                    key: t,
                    value: e1
                });
                {
                    const n = [];
                    for(const r in e1)n.push(...Ni({
                        key: `${t}.${r}`,
                        value: e1[r]
                    }));
                    return n;
                }
            }
        };
        function ji(t) {
            const e1 = t.value, n = t.key, r = t.styleSpec, i = t.style, s = t.validateSpec;
            if (!e1.type) return [
                new zt(n, e1, '"type" is required')
            ];
            const o = ki(e1.type);
            let a;
            switch(o){
                case "vector":
                case "raster":
                    return a = Ei({
                        key: n,
                        value: e1,
                        valueSpec: r[`source_${o.replace("-", "_")}`],
                        style: t.style,
                        styleSpec: r,
                        objectElementValidators: Ui,
                        validateSpec: s
                    }), a;
                case "raster-dem":
                    return a = function(t) {
                        var e1;
                        const n = null !== (e1 = t.sourceName) && void 0 !== e1 ? e1 : "", r = t.value, i = t.styleSpec, s = i.source_raster_dem, o = t.style;
                        let a = [];
                        const l = Zr(r);
                        if (void 0 === r) return a;
                        if ("object" !== l) return a.push(new zt("source_raster_dem", r, `object expected, ${l} found`)), a;
                        const u = "custom" === ki(r.encoding), c = [
                            "redFactor",
                            "greenFactor",
                            "blueFactor",
                            "baseShift"
                        ], h = t.value.encoding ? `"${t.value.encoding}"` : "Default";
                        for(const e1 in r)!u && c.includes(e1) ? a.push(new zt(e1, r[e1], `In "${n}": "${e1}" is only valid when "encoding" is set to "custom". ${h} encoding found`)) : s[e1] ? a = a.concat(t.validateSpec({
                            key: e1,
                            value: r[e1],
                            valueSpec: s[e1],
                            validateSpec: t.validateSpec,
                            style: o,
                            styleSpec: i
                        })) : a.push(new zt(e1, r[e1], `unknown property "${e1}"`));
                        return a;
                    }({
                        sourceName: n,
                        value: e1,
                        style: t.style,
                        styleSpec: r,
                        validateSpec: s
                    }), a;
                case "geojson":
                    if (a = Ei({
                        key: n,
                        value: e1,
                        valueSpec: r.source_geojson,
                        style: i,
                        styleSpec: r,
                        validateSpec: s,
                        objectElementValidators: Ui
                    }), e1.cluster) for(const t in e1.clusterProperties){
                        const [r, i] = e1.clusterProperties[t], s = "string" == typeof r ? [
                            r,
                            [
                                "accumulated"
                            ],
                            [
                                "get",
                                t
                            ]
                        ] : r;
                        a.push(...Di({
                            key: `${n}.${t}.map`,
                            value: i,
                            expressionContext: "cluster-map"
                        })), a.push(...Di({
                            key: `${n}.${t}.reduce`,
                            value: s,
                            expressionContext: "cluster-reduce"
                        }));
                    }
                    return a;
                case "video":
                    return Ei({
                        key: n,
                        value: e1,
                        valueSpec: r.source_video,
                        style: i,
                        validateSpec: s,
                        styleSpec: r
                    });
                case "image":
                    return Ei({
                        key: n,
                        value: e1,
                        valueSpec: r.source_image,
                        style: i,
                        validateSpec: s,
                        styleSpec: r
                    });
                case "canvas":
                    return [
                        new zt(n, null, "Please use runtime APIs to add canvas sources, rather than including them in stylesheets.", "source.canvas")
                    ];
                default:
                    return Bi({
                        key: `${n}.type`,
                        value: e1.type,
                        valueSpec: {
                            values: [
                                "vector",
                                "raster",
                                "raster-dem",
                                "geojson",
                                "video",
                                "image"
                            ]
                        }
                    });
            }
        }
        function qi(t) {
            const e1 = t.value, n = t.styleSpec, r = n.light, i = t.style;
            let s = [];
            const o = Zr(e1);
            if (void 0 === e1) return s;
            if ("object" !== o) return s = s.concat([
                new zt("light", e1, `object expected, ${o} found`)
            ]), s;
            for(const o in e1){
                const a = o.match(/^(.*)-transition$/);
                s = s.concat(a && r[a[1]] && r[a[1]].transition ? t.validateSpec({
                    key: o,
                    value: e1[o],
                    valueSpec: n.transition,
                    validateSpec: t.validateSpec,
                    style: i,
                    styleSpec: n
                }) : r[o] ? t.validateSpec({
                    key: o,
                    value: e1[o],
                    valueSpec: r[o],
                    validateSpec: t.validateSpec,
                    style: i,
                    styleSpec: n
                }) : [
                    new zt(o, e1[o], `unknown property "${o}"`)
                ]);
            }
            return s;
        }
        function Gi(t) {
            const e1 = t.value, n = t.styleSpec, r = n.sky, i = t.style, s = Zr(e1);
            if (void 0 === e1) return [];
            if ("object" !== s) return [
                new zt("sky", e1, `object expected, ${s} found`)
            ];
            let o = [];
            for(const s in e1)o = o.concat(r[s] ? t.validateSpec({
                key: s,
                value: e1[s],
                valueSpec: r[s],
                style: i,
                styleSpec: n
            }) : [
                new zt(s, e1[s], `unknown property "${s}"`)
            ]);
            return o;
        }
        function Xi(t) {
            const e1 = t.value, n = t.styleSpec, r = n.terrain, i = t.style;
            let s = [];
            const o = Zr(e1);
            if (void 0 === e1) return s;
            if ("object" !== o) return s = s.concat([
                new zt("terrain", e1, `object expected, ${o} found`)
            ]), s;
            for(const o in e1)s = s.concat(r[o] ? t.validateSpec({
                key: o,
                value: e1[o],
                valueSpec: r[o],
                validateSpec: t.validateSpec,
                style: i,
                styleSpec: n
            }) : [
                new zt(o, e1[o], `unknown property "${o}"`)
            ]);
            return s;
        }
        function Yi(t) {
            let e1 = [];
            const n = t.value, r = t.key;
            if (Array.isArray(n)) {
                const i = [], s = [];
                for(const o in n)n[o].id && i.includes(n[o].id) && e1.push(new zt(r, n, `all the sprites' ids must be unique, but ${n[o].id} is duplicated`)), i.push(n[o].id), n[o].url && s.includes(n[o].url) && e1.push(new zt(r, n, `all the sprites' URLs must be unique, but ${n[o].url} is duplicated`)), s.push(n[o].url), e1 = e1.concat(Ei({
                    key: `${r}[${o}]`,
                    value: n[o],
                    valueSpec: {
                        id: {
                            type: "string",
                            required: !0
                        },
                        url: {
                            type: "string",
                            required: !0
                        }
                    },
                    validateSpec: t.validateSpec
                }));
                return e1;
            }
            return Ni({
                key: r,
                value: n
            });
        }
        function Zi(t) {
            return Boolean(t) && t.constructor === Object;
        }
        function Hi(t) {
            return Zi(t.value) ? [] : [
                new zt(t.key, t.value, `object expected, ${Zr(t.value)} found`)
            ];
        }
        const Wi = {
            "*": ()=>[],
            array: Ti,
            boolean: function(t) {
                const e1 = t.value, n = t.key, r = Zr(e1);
                return "boolean" !== r ? [
                    new zt(n, e1, `boolean expected, ${r} found`)
                ] : [];
            },
            number: Fi,
            color: zi,
            constants: Mi,
            enum: Bi,
            filter: Ci,
            function: Pi,
            layer: Ri,
            object: Ei,
            source: ji,
            light: qi,
            sky: Gi,
            terrain: Xi,
            projection: function(t) {
                const e1 = t.value, n = t.styleSpec, r = n.projection, i = t.style, s = Zr(e1);
                if (void 0 === e1) return [];
                if ("object" !== s) return [
                    new zt("projection", e1, `object expected, ${s} found`)
                ];
                let o = [];
                for(const s in e1)o = o.concat(r[s] ? t.validateSpec({
                    key: s,
                    value: e1[s],
                    valueSpec: r[s],
                    style: i,
                    styleSpec: n
                }) : [
                    new zt(s, e1[s], `unknown property "${s}"`)
                ]);
                return o;
            },
            projectionDefinition: function(t) {
                const e1 = t.key;
                let n = t.value;
                n = n instanceof String ? n.valueOf() : n;
                const r = Zr(n);
                return "array" !== r || function(t) {
                    return Array.isArray(t) && 3 === t.length && "string" == typeof t[0] && "string" == typeof t[1] && "number" == typeof t[2];
                }(n) || function(t) {
                    return !![
                        "interpolate",
                        "step",
                        "literal"
                    ].includes(t[0]);
                }(n) ? [
                    "array",
                    "string"
                ].includes(r) ? [] : [
                    new zt(e1, n, `projection expected, invalid type "${r}" found`)
                ] : [
                    new zt(e1, n, `projection expected, invalid array ${JSON.stringify(n)} found`)
                ];
            },
            string: Ni,
            formatted: function(t) {
                return 0 === Ni(t).length ? [] : Di(t);
            },
            resolvedImage: function(t) {
                return 0 === Ni(t).length ? [] : Di(t);
            },
            padding: function(t) {
                const e1 = t.key, n = t.value;
                if ("array" === Zr(n)) {
                    if (n.length < 1 || n.length > 4) return [
                        new zt(e1, n, `padding requires 1 to 4 values; ${n.length} values found`)
                    ];
                    const r = {
                        type: "number"
                    };
                    let i = [];
                    for(let s = 0; s < n.length; s++)i = i.concat(t.validateSpec({
                        key: `${e1}[${s}]`,
                        value: n[s],
                        validateSpec: t.validateSpec,
                        valueSpec: r
                    }));
                    return i;
                }
                return Fi({
                    key: e1,
                    value: n,
                    valueSpec: {}
                });
            },
            numberArray: function(t) {
                const e1 = t.key, n = t.value;
                if ("array" === Zr(n)) {
                    const r = {
                        type: "number"
                    };
                    if (n.length < 1) return [
                        new zt(e1, n, "array length at least 1 expected, length 0 found")
                    ];
                    let i = [];
                    for(let s = 0; s < n.length; s++)i = i.concat(t.validateSpec({
                        key: `${e1}[${s}]`,
                        value: n[s],
                        validateSpec: t.validateSpec,
                        valueSpec: r
                    }));
                    return i;
                }
                return Fi({
                    key: e1,
                    value: n,
                    valueSpec: {}
                });
            },
            colorArray: function(t) {
                const e1 = t.key, n = t.value;
                if ("array" === Zr(n)) {
                    if (n.length < 1) return [
                        new zt(e1, n, "array length at least 1 expected, length 0 found")
                    ];
                    let t = [];
                    for(let r = 0; r < n.length; r++)t = t.concat(zi({
                        key: `${e1}[${r}]`,
                        value: n[r]
                    }));
                    return t;
                }
                return zi({
                    key: e1,
                    value: n
                });
            },
            variableAnchorOffsetCollection: function(t) {
                const e1 = t.key, n = t.value, r = Zr(n), i = t.styleSpec;
                if ("array" !== r || n.length < 1 || n.length % 2 != 0) return [
                    new zt(e1, n, "variableAnchorOffsetCollection requires a non-empty array of even length")
                ];
                let s = [];
                for(let r = 0; r < n.length; r += 2)s = s.concat(Bi({
                    key: `${e1}[${r}]`,
                    value: n[r],
                    valueSpec: i.layout_symbol["text-anchor"]
                })), s = s.concat(Ti({
                    key: `${e1}[${r + 1}]`,
                    value: n[r + 1],
                    valueSpec: {
                        length: 2,
                        value: "number"
                    },
                    validateSpec: t.validateSpec,
                    style: t.style,
                    styleSpec: i
                }));
                return s;
            },
            sprite: Yi,
            state: Hi,
            fontFaces: function(t) {
                const e1 = t.key, n = t.value, r = t.validateSpec, i = t.styleSpec, s = t.style;
                if (!Zi(n)) return [
                    new zt(e1, n, `object expected, ${Zr(n)} found`)
                ];
                const o = [];
                for(const t in n){
                    const a = n[t], l = Zr(a);
                    if ("string" === l) o.push(...Ni({
                        key: `${e1}.${t}`,
                        value: a
                    }));
                    else if ("array" === l) {
                        const n = {
                            url: {
                                type: "string",
                                required: !0
                            },
                            "unicode-range": {
                                type: "array",
                                value: "string"
                            }
                        };
                        for (const [l, u] of a.entries())o.push(...Ei({
                            key: `${e1}.${t}[${l}]`,
                            value: u,
                            valueSpec: n,
                            styleSpec: i,
                            style: s,
                            validateSpec: r
                        }));
                    } else o.push(new zt(`${e1}.${t}`, a, `string or array expected, ${l} found`));
                }
                return o;
            }
        };
        function Ki(t) {
            const e1 = t.value, n = t.valueSpec, r = t.styleSpec;
            return t.validateSpec = Ki, n.expression && Hr(ki(e1)) ? Pi(t) : n.expression && ii(Ii(e1)) ? Di(t) : n.type && Wi[n.type] ? Wi[n.type](t) : Ei(Bt({}, t, {
                valueSpec: n.type ? r[n.type] : n
            }));
        }
        function Ji(t) {
            const e1 = t.value, n = t.key, r = Ni(t);
            return r.length || (-1 === e1.indexOf("{fontstack}") && r.push(new zt(n, e1, '"glyphs" url must include a "{fontstack}" token')), -1 === e1.indexOf("{range}") && r.push(new zt(n, e1, '"glyphs" url must include a "{range}" token'))), r;
        }
        function Qi(t, e1 = wt) {
            let n = [];
            return n = n.concat(Ki({
                key: "",
                value: t,
                valueSpec: e1.$root,
                styleSpec: e1,
                style: t,
                validateSpec: Ki,
                objectElementValidators: {
                    glyphs: Ji,
                    "*": ()=>[]
                }
            })), t.constants && (n = n.concat(Mi({
                key: "constants",
                value: t.constants
            }))), es(n);
        }
        function ts(t) {
            return function(e1) {
                return t(Object.assign({}, e1, {
                    validateSpec: Ki
                }));
            };
        }
        function es(t) {
            return [].concat(t).sort((t, e1)=>t.line - e1.line);
        }
        function ns(t) {
            return function(...e1) {
                return es(t.apply(this, e1));
            };
        }
        Qi.source = ns(ts(ji)), Qi.sprite = ns(ts(Yi)), Qi.glyphs = ns(ts(Ji)), Qi.light = ns(ts(qi)), Qi.sky = ns(ts(Gi)), Qi.terrain = ns(ts(Xi)), Qi.state = ns(ts(Hi)), Qi.layer = ns(ts(Ri)), Qi.filter = ns(ts(Ci)), Qi.paintProperty = ns(ts(Oi)), Qi.layoutProperty = ns(ts($i));
        const rs = {
            type: "enum",
            "property-type": "data-constant",
            expression: {
                interpolated: !1,
                parameters: [
                    "global-state"
                ]
            },
            values: {
                visible: {},
                none: {}
            },
            transition: !1,
            default: "visible"
        };
        class is {
            constructor(t, e1){
                this._globalState = e1, this.setValue(t);
            }
            evaluate() {
                var t;
                return null !== (t = this._literalValue) && void 0 !== t ? t : this._compiledValue.evaluate({});
            }
            setValue(t) {
                if (null == t || "visible" === t || "none" === t) return this._literalValue = "none" === t ? "none" : "visible", this._compiledValue = void 0, void (this._globalStateRefs = new Set);
                const e1 = si(t, rs, this._globalState);
                if ("error" === e1.result) throw this._literalValue = "visible", this._compiledValue = void 0, new Error(e1.value.map((t)=>`${t.key}: ${t.message}`).join(", "));
                this._literalValue = void 0, this._compiledValue = e1.value, this._globalStateRefs = hi(e1.value.expression);
            }
            getGlobalStateRefs() {
                return this._globalStateRefs;
            }
        }
        const ss = wt, os = Qi, as = os.light, ls = os.sky, us = os.paintProperty, cs = os.layoutProperty;
        function hs(t, e1) {
            let n = !1;
            if (null == e1 ? void 0 : e1.length) for (const r of e1)t.fire(new vt(new Error(r.message))), n = !0;
            return n;
        }
        class ps {
            constructor(t, e1, n){
                const r = this.cells = [];
                if (t instanceof ArrayBuffer) {
                    this.arrayBuffer = t;
                    const i = new Int32Array(this.arrayBuffer);
                    t = i[0], this.d = (e1 = i[1]) + 2 * (n = i[2]);
                    for(let t = 0; t < this.d * this.d; t++){
                        const e1 = i[3 + t], n = i[3 + t + 1];
                        r.push(e1 === n ? null : i.subarray(e1, n));
                    }
                    const s = i[3 + r.length + 1];
                    this.keys = i.subarray(i[3 + r.length], s), this.bboxes = i.subarray(s), this.insert = this._insertReadonly;
                } else {
                    this.d = e1 + 2 * n;
                    for(let t = 0; t < this.d * this.d; t++)r.push([]);
                    this.keys = [], this.bboxes = [];
                }
                this.n = e1, this.extent = t, this.padding = n, this.scale = e1 / t, this.uid = 0;
                const i = n / e1 * t;
                this.min = -i, this.max = t + i;
            }
            insert(t, e1, n, r, i) {
                this._forEachCell(e1, n, r, i, this._insertCell, this.uid++, void 0, void 0), this.keys.push(t), this.bboxes.push(e1), this.bboxes.push(n), this.bboxes.push(r), this.bboxes.push(i);
            }
            _insertReadonly() {
                throw new Error("Cannot insert into a GridIndex created from an ArrayBuffer.");
            }
            _insertCell(t, e1, n, r, i, s) {
                this.cells[i].push(s);
            }
            query(t, e1, n, r, i) {
                const s = this.min, o = this.max;
                if (t <= s && e1 <= s && o <= n && o <= r && !i) return [
                    ...this.keys
                ];
                {
                    const s = [];
                    return this._forEachCell(t, e1, n, r, this._queryCell, s, {}, i), s;
                }
            }
            _queryCell(t, e1, n, r, i, s, o, a) {
                const l = this.cells[i];
                if (null !== l) {
                    const i = this.keys, u = this.bboxes;
                    for (const c of l)if (void 0 === o[c]) {
                        const l = 4 * c;
                        (a ? a(u[l + 0], u[l + 1], u[l + 2], u[l + 3]) : t <= u[l + 2] && e1 <= u[l + 3] && n >= u[l + 0] && r >= u[l + 1]) ? (o[c] = !0, s.push(i[c])) : o[c] = !1;
                    }
                }
            }
            _forEachCell(t, e1, n, r, i, s, o, a) {
                const l = this._convertToCellCoord(t), u = this._convertToCellCoord(e1), c = this._convertToCellCoord(n), h = this._convertToCellCoord(r);
                for(let p = l; p <= c; p++)for(let l = u; l <= h; l++){
                    const u = this.d * l + p;
                    if ((!a || a(this._convertFromCellCoord(p), this._convertFromCellCoord(l), this._convertFromCellCoord(p + 1), this._convertFromCellCoord(l + 1))) && i.call(this, t, e1, n, r, u, s, o, a)) return;
                }
            }
            _convertFromCellCoord(t) {
                return (t - this.padding) / this.scale;
            }
            _convertToCellCoord(t) {
                return Math.max(0, Math.min(this.d - 1, Math.floor(t * this.scale) + this.padding));
            }
            toArrayBuffer() {
                if (this.arrayBuffer) return this.arrayBuffer;
                const t = this.cells, e1 = 3 + this.cells.length + 1 + 1;
                let n = 0;
                for (const t of this.cells)n += t.length;
                const r = new Int32Array(e1 + n + this.keys.length + this.bboxes.length);
                r[0] = this.extent, r[1] = this.n, r[2] = this.padding;
                let i = e1;
                for(let e1 = 0; e1 < t.length; e1++){
                    const n = t[e1];
                    r[3 + e1] = i, r.set(n, i), i += n.length;
                }
                return r[3 + t.length] = i, r.set(this.keys, i), i += this.keys.length, r[3 + t.length + 1] = i, r.set(this.bboxes, i), i += this.bboxes.length, r.buffer;
            }
            static serialize(t, e1) {
                const n = t.toArrayBuffer();
                return e1 && e1.push(n), {
                    buffer: n
                };
            }
            static deserialize(t) {
                return new ps(t.buffer);
            }
        }
        const fs = {};
        function ds(t, e1, n = {}) {
            if (fs[t]) throw new Error(`${t} is already registered.`);
            Object.defineProperty(e1, "_classRegistryKey", {
                value: t,
                writeable: !1
            }), fs[t] = {
                klass: e1,
                omit: n.omit || [],
                shallow: n.shallow || []
            };
        }
        ds("Object", Object), ds("Set", Set), ds("TransferableGridIndex", ps), ds("Color", Te), ds("Error", Error), ds("AJAXError", pt), ds("ResolvedImage", Re), ds("StylePropertyFunction", ui), ds("StyleExpression", ri, {
            omit: [
                "_evaluator"
            ]
        }), ds("ZoomDependentExpression", ai), ds("ZoomConstantExpression", oi), ds("CompoundExpression", Br, {
            omit: [
                "_evaluate"
            ]
        });
        for(const t in zr)zr[t]._classRegistryKey || ds(`Expression_${t}`, zr[t]);
        function ys(t) {
            var e1;
            return t && "undefined" != typeof ArrayBuffer && (t instanceof ArrayBuffer || "ArrayBuffer" === (null === (e1 = t.constructor) || void 0 === e1 ? void 0 : e1.name));
        }
        function ms(t) {
            return t.$name || t.constructor._classRegistryKey;
        }
        function gs(t) {
            return !function(t) {
                if (null === t || "object" != typeof t) return !1;
                const e1 = ms(t);
                return e1 && "Object" !== e1;
            }(t) && (null == t || "boolean" == typeof t || "number" == typeof t || "string" == typeof t || t instanceof Boolean || t instanceof Number || t instanceof String || t instanceof Date || t instanceof RegExp || t instanceof Blob || t instanceof Error || ys(t) || H(t) || ArrayBuffer.isView(t) || t instanceof ImageData);
        }
        function xs(t, e1) {
            if (gs(t)) return (ys(t) || H(t)) && e1 && e1.push(t), ArrayBuffer.isView(t) && e1 && e1.push(t.buffer), t instanceof ImageData && e1 && e1.push(t.data.buffer), t;
            if (Array.isArray(t)) {
                const n = [];
                for (const r of t)n.push(xs(r, e1));
                return n;
            }
            if ("object" != typeof t) throw new Error("can't serialize object of type " + typeof t);
            const n = ms(t);
            if (!n) throw new Error(`can't serialize object of unregistered class ${t.constructor.name}`);
            if (!fs[n]) throw new Error(`${n} is not registered.`);
            const { klass: r } = fs[n], i = r.serialize ? r.serialize(t, e1) : {};
            if (r.serialize) {
                if (i === (null == e1 ? void 0 : e1[e1.length - 1])) throw new Error("statically serialized object won't survive transfer of $name property");
            } else {
                for(const r in t){
                    if (!t.hasOwnProperty(r)) continue;
                    if (fs[n].omit.includes(r)) continue;
                    const s = t[r];
                    i[r] = fs[n].shallow.includes(r) ? s : xs(s, e1);
                }
                t instanceof Error && (i.message = t.message);
            }
            if (i.$name) throw new Error("$name property is reserved for worker serialization logic.");
            return "Object" !== n && (i.$name = n), i;
        }
        function vs(t) {
            if (gs(t)) return t;
            if (Array.isArray(t)) return t.map(vs);
            if ("object" != typeof t) throw new Error("can't deserialize object of type " + typeof t);
            const e1 = ms(t) || "Object";
            if (!fs[e1]) throw new Error(`can't deserialize unregistered class ${e1}`);
            const { klass: n } = fs[e1];
            if (!n) throw new Error(`can't deserialize unregistered class ${e1}`);
            if (n.deserialize) return n.deserialize(t);
            const r = Object.create(n.prototype);
            for (const n of Object.keys(t)){
                if ("$name" === n) continue;
                const i = t[n];
                r[n] = fs[e1].shallow.includes(n) ? i : vs(i);
            }
            return r;
        }
        class bs {
            constructor(){
                this.first = !0;
            }
            update(t, e1) {
                const n = Math.floor(t);
                return this.first ? (this.first = !1, this.lastIntegerZoom = n, this.lastIntegerZoomTime = 0, this.lastZoom = t, this.lastFloorZoom = n, !0) : (this.lastFloorZoom > n ? (this.lastIntegerZoom = n + 1, this.lastIntegerZoomTime = e1) : this.lastFloorZoom < n && (this.lastIntegerZoom = n, this.lastIntegerZoomTime = e1), t !== this.lastZoom && (this.lastZoom = t, this.lastFloorZoom = n, !0));
            }
        }
        function ws(t) {
            return /[\u02EA\u02EB\u2E80-\u2FDF\u2FF0-\u303F\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FD-\u30FF\u3105-\u312F\u31A0-\u4DBF\u4E00-\uA48C\uA490-\uA4C6\uF900-\uFA6D\uFA70-\uFAD9\uFE10-\uFE1F\uFE30-\uFE4F\uFF00-\uFFEF]|\uD81B[\uDFE0-\uDFFF]|[\uD81C-\uD822\uD840-\uD868\uD86A-\uD86D\uD86F-\uD872\uD874-\uD879\uD880-\uD883\uD885-\uD88C][\uDC00-\uDFFF]|\uD823[\uDC00-\uDCD5\uDCFF-\uDD1E\uDD80-\uDDF2]|\uD82B[\uDFF0-\uDFFF]|\uD82C[\uDC00-\uDEFB]|\uD83C[\uDE00-\uDEFF]|\uD869[\uDC00-\uDEDF\uDF00-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEAD\uDEB0-\uDFFF]|\uD87A[\uDC00-\uDFE0\uDFF0-\uDFFF]|\uD87B[\uDC00-\uDE5D]|\uD87E[\uDC00-\uDE1D]|\uD884[\uDC00-\uDF4A\uDF50-\uDFFF]|\uD88D[\uDC00-\uDC79]/gim.test(String.fromCodePoint(t));
        }
        function _s(t) {
            return /[\u02EA\u02EB\u1100-\u11FF\u1400-\u167F\u18B0-\u18F5\u2E80-\u2E99\u2E9B-\u2EF3\u2F00-\u2FD5\u2FF0-\u3007\u3012\u3013\u3020-\u302F\u3031-\u303F\u3041-\u3096\u309D-\u30FB\u30FD-\u30FF\u3105-\u312F\u3131-\u318E\u3190-\uA48C\uA490-\uA4C6\uA960-\uA97C\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFE10-\uFE1F\uFE30-\uFE48\uFE50-\uFE57\uFE5F-\uFE62\uFE67-\uFE6F\uFF00-\uFF07\uFF0A-\uFF0C\uFF0E-\uFF19\uFF1F-\uFF3A\uFF3C\uFF3E\uFF40-\uFF5A\uFFE0-\uFFE2\uFFE4-\uFFE7]|\uD802[\uDD80-\uDD9F]|\uD805[\uDD80-\uDDFF]|\uD806[\uDE00-\uDEBF]|\uD811[\uDC00-\uDE7F]|\uD81B[\uDFE0-\uDFE4\uDFF0-\uDFF6]|[\uD81C-\uD822\uD83D\uD840-\uD868\uD86A-\uD86D\uD86F-\uD872\uD874-\uD879\uD880-\uD883\uD885-\uD88C][\uDC00-\uDFFF]|\uD823[\uDC00-\uDCD5\uDCFF-\uDD1E\uDD80-\uDDF2]|\uD82B[\uDFF0-\uDFF3\uDFF5-\uDFFB\uDFFD\uDFFE]|\uD82C[\uDC00-\uDD22\uDD30-\uDEFB]|\uD833[\uDEC0-\uDFCF]|\uD834[\uDC00-\uDDFF\uDEE0-\uDF7F]|\uD836[\uDC00-\uDEAF]|\uD83C[\uDC00-\uDE00\uDF00-\uDFFF]|\uD83E[\uDD00-\uDEFF]|\uD869[\uDC00-\uDEDF\uDF00-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEAD\uDEB0-\uDFFF]|\uD87A[\uDC00-\uDFE0\uDFF0-\uDFFF]|\uD87B[\uDC00-\uDE5D]|\uD87E[\uDC00-\uDE1D]|\uD884[\uDC00-\uDF4A\uDF50-\uDFFF]|\uD88D[\uDC00-\uDC79]/gim.test(String.fromCodePoint(t));
        }
        function Ss(t) {
            return /\s/u.test(String.fromCodePoint(t));
        }
        function As(t) {
            for (const e1 of t)if (_s(e1.codePointAt(0))) return !0;
            return !1;
        }
        function Ms(t) {
            for (const e1 of t)if (!Es(e1.codePointAt(0))) return !1;
            return !0;
        }
        function ks(t) {
            const e1 = t.map((t)=>{
                try {
                    return new RegExp(`\\p{sc=${t}}`, "u").source;
                } catch (t) {
                    return null;
                }
            }).filter((t)=>t);
            return new RegExp(e1.join("|"), "u");
        }
        const Is = ks([
            "Arab",
            "Dupl",
            "Mong",
            "Ougr",
            "Syrc"
        ]);
        function Es(t) {
            return !Is.test(String.fromCodePoint(t));
        }
        function Ts(t) {
            var e1;
            return !(_s(t) || (e1 = t, /[\xA7\xA9\xAE\xB1\xBC-\xBE\xD7\xF7\u2016\u2020\u2021\u2030\u2031\u203B\u203C\u2042\u2047-\u2049\u2051\u2100-\u218F\u221E\u2234\u2235\u2300-\u2307\u230C-\u231F\u2324-\u2328\u232B\u237D-\u239A\u23BE-\u23CD\u23CF\u23D1-\u23DB\u23E2-\u2422\u2424-\u24FF\u25A0-\u2619\u2620-\u2767\u2776-\u2793\u2B12-\u2B2F\u2B50-\u2B59\u2BB8-\u2BEB\u3000-\u303F\u30A0-\u30FF\uE000-\uF8FF\uFE30-\uFE6F\uFF00-\uFFEF\uFFFC\uFFFD]|[\uDB80-\uDBFF][\uDC00-\uDFFF]/gim.test(String.fromCodePoint(e1))));
        }
        const Fs = ks([
            "Adlm",
            "Arab",
            "Armi",
            "Avst",
            "Chrs",
            "Cprt",
            "Egyp",
            "Elym",
            "Gara",
            "Hatr",
            "Hebr",
            "Hung",
            "Khar",
            "Lydi",
            "Mand",
            "Mani",
            "Mend",
            "Merc",
            "Mero",
            "Narb",
            "Nbat",
            "Nkoo",
            "Orkh",
            "Palm",
            "Phli",
            "Phlp",
            "Phnx",
            "Prti",
            "Rohg",
            "Samr",
            "Sarb",
            "Sogo",
            "Syrc",
            "Thaa",
            "Todr",
            "Yezi"
        ]);
        function Ps(t) {
            return Fs.test(String.fromCodePoint(t));
        }
        function Ds(t, e1) {
            return !(!e1 && Ps(t) || /[\u0900-\u0DFF\u0F00-\u109F\u1780-\u17FF]/gim.test(String.fromCodePoint(t)));
        }
        function zs(t) {
            for (const e1 of t)if (Ps(e1.codePointAt(0))) return !0;
            return !1;
        }
        const Bs = new class {
            constructor(){
                this.TIMEOUT = 5e3, this.applyArabicShaping = null, this.processBidirectionalText = null, this.processStyledBidirectionalText = null, this.pluginStatus = "unavailable", this.pluginURL = null, this.loadScriptResolve = ()=>{};
            }
            setState(t) {
                this.pluginStatus = t.pluginStatus, this.pluginURL = t.pluginURL;
            }
            getState() {
                return {
                    pluginStatus: this.pluginStatus,
                    pluginURL: this.pluginURL
                };
            }
            setMethods(t) {
                if (Bs.isParsed()) throw new Error("RTL text plugin already registered.");
                this.applyArabicShaping = t.applyArabicShaping, this.processBidirectionalText = t.processBidirectionalText, this.processStyledBidirectionalText = t.processStyledBidirectionalText, this.loadScriptResolve();
            }
            isParsed() {
                return null != this.applyArabicShaping && null != this.processBidirectionalText && null != this.processStyledBidirectionalText;
            }
            getRTLTextPluginStatus() {
                return this.pluginStatus;
            }
            syncState(t, n) {
                return e1(this, void 0, void 0, function*() {
                    if (this.isParsed()) return this.getState();
                    if ("loading" !== t.pluginStatus) return this.setState(t), t;
                    const e1 = t.pluginURL, r = new Promise((t)=>{
                        this.loadScriptResolve = t;
                    });
                    n(e1);
                    const i = new Promise((t)=>setTimeout(()=>t(), this.TIMEOUT));
                    if (yield Promise.race([
                        r,
                        i
                    ]), this.isParsed()) {
                        const t = {
                            pluginStatus: "loaded",
                            pluginURL: e1
                        };
                        return this.setState(t), t;
                    }
                    throw this.setState({
                        pluginStatus: "error",
                        pluginURL: ""
                    }), new Error(`RTL Text Plugin failed to import scripts from ${e1}`);
                });
            }
        };
        class Cs {
            constructor(t, e1){
                this.isSupportedScript = Vs, this.zoom = t, e1 ? (this.now = e1.now || 0, this.fadeDuration = e1.fadeDuration || 0, this.zoomHistory = e1.zoomHistory || new bs, this.transition = e1.transition || {}) : (this.now = 0, this.fadeDuration = 0, this.zoomHistory = new bs, this.transition = {});
            }
            crossFadingFactor() {
                return 0 === this.fadeDuration ? 1 : Math.min((this.now - this.zoomHistory.lastIntegerZoomTime) / this.fadeDuration, 1);
            }
            getCrossfadeParameters() {
                const t = this.zoom, e1 = t - Math.floor(t), n = this.crossFadingFactor();
                return t > this.zoomHistory.lastIntegerZoom ? {
                    fromScale: 2,
                    toScale: 1,
                    t: e1 + (1 - e1) * n
                } : {
                    fromScale: .5,
                    toScale: 1,
                    t: 1 - (1 - n) * e1
                };
            }
        }
        function Vs(t) {
            return function(t, e1) {
                for (const n of t)if (!Ds(n.codePointAt(0), e1)) return !1;
                return !0;
            }(t, "loaded" === Bs.getRTLTextPluginStatus());
        }
        const Ls = "-transition";
        class Os {
            constructor(t, e1, n){
                this.property = t, this.value = e1, this.expression = function(t, e1, n) {
                    if (Hr(t)) return new ui(t, e1);
                    if (ii(t)) {
                        const r = li(t, e1, n);
                        if ("error" === r.result) throw new Error(r.value.map((t)=>`${t.key}: ${t.message}`).join(", "));
                        return r.value;
                    }
                    {
                        let n = t;
                        return "color" === e1.type && "string" == typeof t ? n = Te.parse(t) : "padding" !== e1.type || "number" != typeof t && !Array.isArray(t) ? "numberArray" !== e1.type || "number" != typeof t && !Array.isArray(t) ? "colorArray" !== e1.type || "string" != typeof t && !Array.isArray(t) ? "variableAnchorOffsetCollection" === e1.type && Array.isArray(t) ? n = $e.parse(t) : "projectionDefinition" === e1.type && "string" == typeof t && (n = Ne.parse(t)) : n = Ve.parse(t) : n = Ce.parse(t) : n = Be.parse(t), {
                            globalStateRefs: new Set,
                            _globalState: null,
                            kind: "constant",
                            evaluate: ()=>n
                        };
                    }
                }(void 0 === e1 ? t.specification.default : e1, t.specification, n);
            }
            isDataDriven() {
                return "source" === this.expression.kind || "composite" === this.expression.kind;
            }
            getGlobalStateRefs() {
                return this.expression.globalStateRefs || new Set;
            }
            possiblyEvaluate(t, e1, n) {
                return this.property.possiblyEvaluate(this, t, e1, n);
            }
        }
        class $s {
            constructor(t, e1){
                this.property = t, this.value = new Os(t, void 0, e1);
            }
            transitioned(t, e1) {
                return new Ns(this.property, this.value, e1, $({}, t.transition, this.transition), t.now);
            }
            untransitioned() {
                return new Ns(this.property, this.value, null, {}, 0);
            }
        }
        class Rs {
            constructor(t, e1){
                this._properties = t, this._values = Object.create(t.defaultTransitionablePropertyValues), this._globalState = e1;
            }
            hasProperty(t) {
                return t in this._properties.defaultTransitionablePropertyValues;
            }
            getValue(t) {
                return j(this._values[t].value.value);
            }
            setValue(t, e1) {
                Object.hasOwn(this._values, t) || (this._values[t] = new $s(this._values[t].property, this._globalState)), this._values[t].value = new Os(this._values[t].property, null === e1 ? void 0 : j(e1), this._globalState);
            }
            getTransition(t) {
                return j(this._values[t].transition);
            }
            setTransition(t, e1) {
                Object.hasOwn(this._values, t) || (this._values[t] = new $s(this._values[t].property, this._globalState)), this._values[t].transition = j(e1) || void 0;
            }
            serialize() {
                const t = {};
                for (const e1 of Object.keys(this._values)){
                    const n = this.getValue(e1);
                    void 0 !== n && (t[e1] = n);
                    const r = this.getTransition(e1);
                    void 0 !== r && (t[`${e1}${Ls}`] = r);
                }
                return t;
            }
            transitioned(t, e1) {
                const n = new Us(this._properties);
                for (const r of Object.keys(this._values))n._values[r] = this._values[r].transitioned(t, e1._values[r]);
                return n;
            }
            untransitioned() {
                const t = new Us(this._properties);
                for (const e1 of Object.keys(this._values))t._values[e1] = this._values[e1].untransitioned();
                return t;
            }
        }
        class Ns {
            constructor(t, e1, n, r, i){
                this.property = t, this.value = e1, this.begin = i + r.delay || 0, this.end = this.begin + r.duration || 0, t.specification.transition && (r.delay || r.duration) && (this.prior = n);
            }
            possiblyEvaluate(t, e1, n) {
                const r = t.now || 0, i = this.value.possiblyEvaluate(t, e1, n), s = this.prior;
                if (s) {
                    if (r > this.end) return this.prior = null, i;
                    if (this.value.isDataDriven()) return this.prior = null, i;
                    if (r < this.begin) return s.possiblyEvaluate(t, e1, n);
                    {
                        const o = (r - this.begin) / (this.end - this.begin);
                        return this.property.interpolate(s.possiblyEvaluate(t, e1, n), i, B(o));
                    }
                }
                return i;
            }
        }
        class Us {
            constructor(t){
                this._properties = t, this._values = Object.create(t.defaultTransitioningPropertyValues);
            }
            possiblyEvaluate(t, e1, n) {
                const r = new Gs(this._properties);
                for (const i of Object.keys(this._values))r._values[i] = this._values[i].possiblyEvaluate(t, e1, n);
                return r;
            }
            hasTransition() {
                for (const t of Object.keys(this._values))if (this._values[t].prior) return !0;
                return !1;
            }
        }
        class js {
            constructor(t, e1){
                this._properties = t, this._values = Object.create(t.defaultPropertyValues), this._globalState = e1;
            }
            hasValue(t) {
                return void 0 !== this._values[t].value;
            }
            hasProperty(t) {
                return t in this._properties.defaultPropertyValues;
            }
            getValue(t) {
                return j(this._values[t].value);
            }
            setValue(t, e1) {
                this._values[t] = new Os(this._values[t].property, null === e1 ? void 0 : j(e1), this._globalState);
            }
            serialize() {
                const t = {};
                for (const e1 of Object.keys(this._values)){
                    const n = this.getValue(e1);
                    void 0 !== n && (t[e1] = n);
                }
                return t;
            }
            possiblyEvaluate(t, e1, n) {
                const r = new Gs(this._properties);
                for (const i of Object.keys(this._values))r._values[i] = this._values[i].possiblyEvaluate(t, e1, n);
                return r;
            }
        }
        class qs {
            constructor(t, e1, n){
                this.property = t, this.value = e1, this.parameters = n;
            }
            isConstant() {
                return "constant" === this.value.kind;
            }
            constantOr(t) {
                return "constant" === this.value.kind ? this.value.value : t;
            }
            evaluate(t, e1, n, r) {
                return this.property.evaluate(this.value, this.parameters, t, e1, n, r);
            }
        }
        class Gs {
            constructor(t){
                this._properties = t, this._values = Object.create(t.defaultPossiblyEvaluatedValues);
            }
            get(t) {
                return this._values[t];
            }
        }
        class Xs {
            constructor(t){
                this.specification = t;
            }
            possiblyEvaluate(t, e1) {
                if (t.isDataDriven()) throw new Error("Value should not be data driven");
                return t.expression.evaluate(e1);
            }
            interpolate(t, e1, n) {
                const r = xn[this.specification.type];
                return r ? r(t, e1, n) : t;
            }
        }
        class Ys {
            constructor(t, e1){
                this.specification = t, this.overrides = e1;
            }
            possiblyEvaluate(t, e1, n, r) {
                return new qs(this, "constant" === t.expression.kind || "camera" === t.expression.kind ? {
                    kind: "constant",
                    value: t.expression.evaluate(e1, null, {}, n, r)
                } : t.expression, e1);
            }
            interpolate(t, e1, n) {
                if ("constant" !== t.value.kind || "constant" !== e1.value.kind) return t;
                if (void 0 === t.value.value || void 0 === e1.value.value) return new qs(this, {
                    kind: "constant",
                    value: void 0
                }, t.parameters);
                const r = xn[this.specification.type];
                if (r) {
                    const i = r(t.value.value, e1.value.value, n);
                    return new qs(this, {
                        kind: "constant",
                        value: i
                    }, t.parameters);
                }
                return t;
            }
            evaluate(t, e1, n, r, i, s) {
                return "constant" === t.kind ? t.value : t.evaluate(e1, n, r, i, s);
            }
        }
        class Zs extends Ys {
            possiblyEvaluate(t, e1, n, r) {
                if (void 0 === t.value) return new qs(this, {
                    kind: "constant",
                    value: void 0
                }, e1);
                if ("constant" === t.expression.kind) {
                    const i = t.expression.evaluate(e1, null, {}, n, r), s = "resolvedImage" === t.property.specification.type && "string" != typeof i ? i.name : i, o = this._calculate(s, s, s, e1);
                    return new qs(this, {
                        kind: "constant",
                        value: o
                    }, e1);
                }
                if ("camera" === t.expression.kind) {
                    const n = this._calculate(t.expression.evaluate({
                        zoom: e1.zoom - 1
                    }), t.expression.evaluate({
                        zoom: e1.zoom
                    }), t.expression.evaluate({
                        zoom: e1.zoom + 1
                    }), e1);
                    return new qs(this, {
                        kind: "constant",
                        value: n
                    }, e1);
                }
                return new qs(this, t.expression, e1);
            }
            evaluate(t, e1, n, r, i, s) {
                if ("source" === t.kind) {
                    const o = t.evaluate(e1, n, r, i, s);
                    return this._calculate(o, o, o, e1);
                }
                return "composite" === t.kind ? this._calculate(t.evaluate({
                    zoom: Math.floor(e1.zoom) - 1
                }, n, r), t.evaluate({
                    zoom: Math.floor(e1.zoom)
                }, n, r), t.evaluate({
                    zoom: Math.floor(e1.zoom) + 1
                }, n, r), e1) : t.value;
            }
            _calculate(t, e1, n, r) {
                return r.zoom > r.zoomHistory.lastIntegerZoom ? {
                    from: t,
                    to: e1
                } : {
                    from: n,
                    to: e1
                };
            }
            interpolate(t) {
                return t;
            }
        }
        class Hs {
            constructor(t){
                this.specification = t;
            }
            possiblyEvaluate(t, e1, n, r) {
                if (void 0 !== t.value) {
                    if ("constant" === t.expression.kind) {
                        const i = t.expression.evaluate(e1, null, {}, n, r);
                        return this._calculate(i, i, i, e1);
                    }
                    return this._calculate(t.expression.evaluate(new Cs(Math.floor(e1.zoom - 1), e1)), t.expression.evaluate(new Cs(Math.floor(e1.zoom), e1)), t.expression.evaluate(new Cs(Math.floor(e1.zoom + 1), e1)), e1);
                }
            }
            _calculate(t, e1, n, r) {
                return r.zoom > r.zoomHistory.lastIntegerZoom ? {
                    from: t,
                    to: e1
                } : {
                    from: n,
                    to: e1
                };
            }
            interpolate(t) {
                return t;
            }
        }
        class Ws {
            constructor(t){
                this.specification = t;
            }
            possiblyEvaluate(t, e1, n, r) {
                return !!t.expression.evaluate(e1, null, {}, n, r);
            }
            interpolate() {
                return !1;
            }
        }
        class Ks {
            constructor(t){
                this.properties = t, this.defaultPropertyValues = {}, this.defaultTransitionablePropertyValues = {}, this.defaultTransitioningPropertyValues = {}, this.defaultPossiblyEvaluatedValues = {}, this.overridableProperties = [];
                for(const e1 in t){
                    const n = t[e1];
                    n.specification.overridable && this.overridableProperties.push(e1);
                    const r = this.defaultPropertyValues[e1] = new Os(n, void 0, void 0), i = this.defaultTransitionablePropertyValues[e1] = new $s(n, void 0);
                    this.defaultTransitioningPropertyValues[e1] = i.untransitioned(), this.defaultPossiblyEvaluatedValues[e1] = r.possiblyEvaluate({});
                }
            }
        }
        ds("DataDrivenProperty", Ys), ds("DataConstantProperty", Xs), ds("CrossFadedDataDrivenProperty", Zs), ds("CrossFadedProperty", Hs), ds("ColorRampProperty", Ws);
        const Js = " is a PAINT property not a LAYOUT property. Use get/setPaintProperty instead?", Qs = " is a LAYOUT property not a PAINT property. Use get/setLayoutProperty instead?";
        class to extends bt {
            constructor(t, e1, n){
                if (super(), this.id = t.id, this.type = t.type, this._globalState = n, this._featureFilter = {
                    filter: ()=>!0,
                    needGeometry: !1,
                    getGlobalStateRefs: ()=>new Set
                }, this._visibilityExpression = function(t, e1) {
                    return new is(t, e1);
                }(this.visibility, n), "custom" !== t.type && (this.metadata = t.metadata, this.minzoom = t.minzoom, this.maxzoom = t.maxzoom, "background" !== t.type && (this.source = t.source, this.sourceLayer = t["source-layer"], this.filter = t.filter, this._featureFilter = yi(t.filter, n)), e1.layout && (this._unevaluatedLayout = new js(e1.layout, n)), e1.paint)) {
                    this._transitionablePaint = new Rs(e1.paint, n);
                    for(const e1 in t.paint)this.setPaintProperty(e1, t.paint[e1], {
                        validate: !1
                    });
                    for(const e1 in t.layout)this.setLayoutProperty(e1, t.layout[e1], {
                        validate: !1
                    });
                    this._transitioningPaint = this._transitionablePaint.untransitioned(), this.paint = new Gs(e1.paint);
                }
            }
            setFilter(t) {
                this.filter = t, this._featureFilter = yi(t, this._globalState);
            }
            getCrossfadeParameters() {
                return this._crossfadeParameters;
            }
            getLayoutProperty(t) {
                var e1;
                if ("visibility" === t) return this.visibility;
                if (null === (e1 = this._transitionablePaint) || void 0 === e1 ? void 0 : e1.hasProperty(t)) throw new Error(t + Js);
                if (!this._unevaluatedLayout) throw new Error(`Cannot get layout property "${t}" on layer type "${this.type}" which has no layout properties.`);
                return this._unevaluatedLayout.getValue(t);
            }
            getLayoutAffectingGlobalStateRefs() {
                const t = new Set;
                for (const e1 of this._visibilityExpression.getGlobalStateRefs())t.add(e1);
                if (this._unevaluatedLayout) for(const e1 in this._unevaluatedLayout._values){
                    const n = this._unevaluatedLayout._values[e1];
                    for (const e1 of n.getGlobalStateRefs())t.add(e1);
                }
                for (const e1 of this._featureFilter.getGlobalStateRefs())t.add(e1);
                return t;
            }
            getPaintAffectingGlobalStateRefs() {
                var t;
                const e1 = new globalThis.Map;
                if (this._transitionablePaint) for(const n in this._transitionablePaint._values){
                    const r = this._transitionablePaint._values[n].value;
                    for (const i of r.getGlobalStateRefs()){
                        const s = null !== (t = e1.get(i)) && void 0 !== t ? t : [];
                        s.push({
                            name: n,
                            value: r.value
                        }), e1.set(i, s);
                    }
                }
                return e1;
            }
            getVisibilityAffectingGlobalStateRefs() {
                return this._visibilityExpression.getGlobalStateRefs();
            }
            setLayoutProperty(t, e1, n = {}) {
                var r;
                if ("visibility" === t) return this.visibility = e1, this._visibilityExpression.setValue(e1), void this.recalculateVisibility();
                (null === (r = this._transitionablePaint) || void 0 === r ? void 0 : r.hasProperty(t)) ? this.fire(new vt(new Error(t + Js))) : null != e1 && this._validate(cs, `layers.${this.id}.layout.${t}`, t, e1, n) || this._unevaluatedLayout.setValue(t, e1);
            }
            getPaintProperty(t) {
                var e1, n;
                if (t.endsWith(Ls)) {
                    const n = t.slice(0, -11);
                    if ("visibility" === n || (null === (e1 = this._unevaluatedLayout) || void 0 === e1 ? void 0 : e1.hasProperty(n))) throw new Error(t + Qs);
                    return this._transitionablePaint.getTransition(n);
                }
                if ("visibility" === t || (null === (n = this._unevaluatedLayout) || void 0 === n ? void 0 : n.hasProperty(t))) throw new Error(t + Qs);
                return this._transitionablePaint.getValue(t);
            }
            setPaintProperty(t, e1, n = {}) {
                var r;
                if ("visibility" === t || (null === (r = this._unevaluatedLayout) || void 0 === r ? void 0 : r.hasProperty(t))) return this.fire(new vt(new Error(t + Qs))), !1;
                if (null != e1 && this._validate(us, `layers.${this.id}.paint.${t}`, t, e1, n)) return !1;
                if (t.endsWith(Ls)) return this._transitionablePaint.setTransition(t.slice(0, -11), e1 || void 0), !1;
                {
                    const n = this._transitionablePaint._values[t], r = "cross-faded-data-driven" === n.property.specification["property-type"], i = n.value.isDataDriven(), s = n.value;
                    this._transitionablePaint.setValue(t, e1), this._handleSpecialPaintPropertyUpdate(t);
                    const o = this._transitionablePaint._values[t].value;
                    return o.isDataDriven() || i || r || this._handleOverridablePaintPropertyUpdate(t, s, o);
                }
            }
            _handleSpecialPaintPropertyUpdate(t) {}
            _handleOverridablePaintPropertyUpdate(t, e1, n) {
                return !1;
            }
            isHidden(t = this.minzoom, e1 = !1) {
                return !!(this.minzoom && t < (e1 ? Math.floor(this.minzoom) : this.minzoom)) || !!(this.maxzoom && t >= this.maxzoom) || "none" === this._evaluatedVisibility;
            }
            updateTransitions(t) {
                this._transitioningPaint = this._transitionablePaint.transitioned(t, this._transitioningPaint);
            }
            hasTransition() {
                return this._transitioningPaint.hasTransition();
            }
            recalculateVisibility() {
                this._evaluatedVisibility = this._visibilityExpression.evaluate();
            }
            recalculate(t, e1) {
                t.getCrossfadeParameters && (this._crossfadeParameters = t.getCrossfadeParameters()), this._unevaluatedLayout && (this.layout = this._unevaluatedLayout.possiblyEvaluate(t, void 0, e1)), this.paint = this._transitioningPaint.possiblyEvaluate(t, void 0, e1);
            }
            serialize() {
                var t, e1;
                const n = {
                    id: this.id,
                    type: this.type,
                    source: this.source,
                    "source-layer": this.sourceLayer,
                    metadata: this.metadata,
                    minzoom: this.minzoom,
                    maxzoom: this.maxzoom,
                    filter: this.filter,
                    layout: null === (t = this._unevaluatedLayout) || void 0 === t ? void 0 : t.serialize(),
                    paint: null === (e1 = this._transitionablePaint) || void 0 === e1 ? void 0 : e1.serialize()
                };
                return this.visibility && (n.layout || (n.layout = {}), n.layout.visibility = this.visibility), U(n, (t, e1)=>!(void 0 === t || "layout" === e1 && !Object.keys(t).length || "paint" === e1 && !Object.keys(t).length));
            }
            _validate(t, e1, n, r, i = {}) {
                return !1 !== (null == i ? void 0 : i.validate) && hs(this, t.call(os, {
                    key: e1,
                    layerType: this.type,
                    objectKey: n,
                    value: r,
                    styleSpec: wt,
                    style: {
                        glyphs: !0,
                        sprite: !0
                    }
                }));
            }
            is3D() {
                return !1;
            }
            isTileClipped() {
                return !1;
            }
            hasOffscreenPass() {
                return !1;
            }
            resize() {}
            isStateDependent() {
                for(const t in this.paint._values){
                    const e1 = this.paint.get(t);
                    if (e1 instanceof qs && Gr(e1.property.specification) && ("source" === e1.value.kind || "composite" === e1.value.kind) && e1.value.isStateDependent) return !0;
                }
                return !1;
            }
        }
        let eo;
        var no = {
            get paint () {
                return eo = eo || new Ks({
                    "raster-opacity": new Xs(wt.paint_raster["raster-opacity"]),
                    "raster-hue-rotate": new Xs(wt.paint_raster["raster-hue-rotate"]),
                    "raster-brightness-min": new Xs(wt.paint_raster["raster-brightness-min"]),
                    "raster-brightness-max": new Xs(wt.paint_raster["raster-brightness-max"]),
                    "raster-saturation": new Xs(wt.paint_raster["raster-saturation"]),
                    "raster-contrast": new Xs(wt.paint_raster["raster-contrast"]),
                    resampling: new Xs(wt.paint_raster.resampling),
                    "raster-resampling": new Xs(wt.paint_raster["raster-resampling"]),
                    "raster-fade-duration": new Xs(wt.paint_raster["raster-fade-duration"])
                });
            }
        };
        class ro extends to {
            constructor(t, e1){
                super(t, no, e1);
            }
        }
        const io = {
            Int8: Int8Array,
            Uint8: Uint8Array,
            Int16: Int16Array,
            Uint16: Uint16Array,
            Int32: Int32Array,
            Uint32: Uint32Array,
            Float32: Float32Array
        };
        class so {
            constructor(t, e1){
                this._structArray = t, this._pos1 = e1 * this.size, this._pos2 = this._pos1 / 2, this._pos4 = this._pos1 / 4, this._pos8 = this._pos1 / 8;
            }
        }
        class oo {
            constructor(){
                this.isTransferred = !1, this.capacity = -1, this.resize(0);
            }
            static serialize(t, e1) {
                return t._trim(), e1 && (t.isTransferred = !0, e1.push(t.arrayBuffer)), {
                    length: t.length,
                    arrayBuffer: t.arrayBuffer
                };
            }
            static deserialize(t) {
                const e1 = Object.create(this.prototype);
                return e1.arrayBuffer = t.arrayBuffer, e1.length = t.length, e1.capacity = t.arrayBuffer.byteLength / e1.bytesPerElement, e1._refreshViews(), e1;
            }
            _trim() {
                this.length !== this.capacity && (this.capacity = this.length, this.arrayBuffer = this.arrayBuffer.slice(0, this.length * this.bytesPerElement), this._refreshViews());
            }
            clear() {
                this.length = 0;
            }
            resize(t) {
                this.reserve(t), this.length = t;
            }
            reserve(t) {
                if (t > this.capacity) {
                    this.capacity = Math.max(t, Math.floor(5 * this.capacity), 128), this.arrayBuffer = new ArrayBuffer(this.capacity * this.bytesPerElement);
                    const e1 = this.uint8;
                    this._refreshViews(), e1 && this.uint8.set(e1);
                }
            }
            _refreshViews() {
                throw new Error("_refreshViews() must be implemented by each concrete StructArray layout");
            }
            freeBufferAfterUpload() {
                this.arrayBuffer = new ArrayBuffer(0), this._refreshViews();
            }
        }
        function ao(t, e1 = 1) {
            let n = 0, r = 0;
            return {
                members: t.map((t)=>{
                    const i = io[t.type].BYTES_PER_ELEMENT, s = n = lo(n, Math.max(e1, i)), o = t.components || 1;
                    return r = Math.max(r, i), n += i * o, {
                        name: t.name,
                        type: t.type,
                        components: o,
                        offset: s
                    };
                }),
                size: lo(n, Math.max(r, e1)),
                alignment: e1
            };
        }
        function lo(t, e1) {
            return Math.ceil(t / e1) * e1;
        }
        class uo extends oo {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
            }
            emplaceBack(t, e1) {
                const n = this.length;
                return this.resize(n + 1), this.emplace(n, t, e1);
            }
            emplace(t, e1, n) {
                const r = 2 * t;
                return this.int16[r + 0] = e1, this.int16[r + 1] = n, t;
            }
        }
        uo.prototype.bytesPerElement = 4, ds("StructArrayLayout2i4", uo);
        class co extends oo {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
            }
            emplaceBack(t, e1, n) {
                const r = this.length;
                return this.resize(r + 1), this.emplace(r, t, e1, n);
            }
            emplace(t, e1, n, r) {
                const i = 3 * t;
                return this.int16[i + 0] = e1, this.int16[i + 1] = n, this.int16[i + 2] = r, t;
            }
        }
        co.prototype.bytesPerElement = 6, ds("StructArrayLayout3i6", co);
        class ho extends oo {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
            }
            emplaceBack(t, e1, n, r) {
                const i = this.length;
                return this.resize(i + 1), this.emplace(i, t, e1, n, r);
            }
            emplace(t, e1, n, r, i) {
                const s = 4 * t;
                return this.int16[s + 0] = e1, this.int16[s + 1] = n, this.int16[s + 2] = r, this.int16[s + 3] = i, t;
            }
        }
        ho.prototype.bytesPerElement = 8, ds("StructArrayLayout4i8", ho);
        class po extends oo {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
            }
            emplaceBack(t, e1, n, r, i, s) {
                const o = this.length;
                return this.resize(o + 1), this.emplace(o, t, e1, n, r, i, s);
            }
            emplace(t, e1, n, r, i, s, o) {
                const a = 6 * t;
                return this.int16[a + 0] = e1, this.int16[a + 1] = n, this.int16[a + 2] = r, this.int16[a + 3] = i, this.int16[a + 4] = s, this.int16[a + 5] = o, t;
            }
        }
        po.prototype.bytesPerElement = 12, ds("StructArrayLayout2i4i12", po);
        class fo extends oo {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
            }
            emplaceBack(t, e1, n, r, i, s) {
                const o = this.length;
                return this.resize(o + 1), this.emplace(o, t, e1, n, r, i, s);
            }
            emplace(t, e1, n, r, i, s, o) {
                const a = 4 * t, l = 8 * t;
                return this.int16[a + 0] = e1, this.int16[a + 1] = n, this.uint8[l + 4] = r, this.uint8[l + 5] = i, this.uint8[l + 6] = s, this.uint8[l + 7] = o, t;
            }
        }
        fo.prototype.bytesPerElement = 8, ds("StructArrayLayout2i4ub8", fo);
        class yo extends oo {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(t, e1) {
                const n = this.length;
                return this.resize(n + 1), this.emplace(n, t, e1);
            }
            emplace(t, e1, n) {
                const r = 2 * t;
                return this.float32[r + 0] = e1, this.float32[r + 1] = n, t;
            }
        }
        yo.prototype.bytesPerElement = 8, ds("StructArrayLayout2f8", yo);
        class mo extends oo {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
            }
            emplaceBack(t, e1, n, r, i, s, o, a, l, u) {
                const c = this.length;
                return this.resize(c + 1), this.emplace(c, t, e1, n, r, i, s, o, a, l, u);
            }
            emplace(t, e1, n, r, i, s, o, a, l, u, c) {
                const h = 10 * t;
                return this.uint16[h + 0] = e1, this.uint16[h + 1] = n, this.uint16[h + 2] = r, this.uint16[h + 3] = i, this.uint16[h + 4] = s, this.uint16[h + 5] = o, this.uint16[h + 6] = a, this.uint16[h + 7] = l, this.uint16[h + 8] = u, this.uint16[h + 9] = c, t;
            }
        }
        mo.prototype.bytesPerElement = 20, ds("StructArrayLayout10ui20", mo);
        class go extends oo {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
            }
            emplaceBack(t, e1, n, r, i, s, o, a) {
                const l = this.length;
                return this.resize(l + 1), this.emplace(l, t, e1, n, r, i, s, o, a);
            }
            emplace(t, e1, n, r, i, s, o, a, l) {
                const u = 8 * t;
                return this.uint16[u + 0] = e1, this.uint16[u + 1] = n, this.uint16[u + 2] = r, this.uint16[u + 3] = i, this.uint16[u + 4] = s, this.uint16[u + 5] = o, this.uint16[u + 6] = a, this.uint16[u + 7] = l, t;
            }
        }
        go.prototype.bytesPerElement = 16, ds("StructArrayLayout8ui16", go);
        class xo extends oo {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
            }
            emplaceBack(t, e1, n, r, i, s, o, a, l, u, c, h) {
                const p = this.length;
                return this.resize(p + 1), this.emplace(p, t, e1, n, r, i, s, o, a, l, u, c, h);
            }
            emplace(t, e1, n, r, i, s, o, a, l, u, c, h, p) {
                const f = 12 * t;
                return this.int16[f + 0] = e1, this.int16[f + 1] = n, this.int16[f + 2] = r, this.int16[f + 3] = i, this.uint16[f + 4] = s, this.uint16[f + 5] = o, this.uint16[f + 6] = a, this.uint16[f + 7] = l, this.int16[f + 8] = u, this.int16[f + 9] = c, this.int16[f + 10] = h, this.int16[f + 11] = p, t;
            }
        }
        xo.prototype.bytesPerElement = 24, ds("StructArrayLayout4i4ui4i24", xo);
        class vo extends oo {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(t, e1, n) {
                const r = this.length;
                return this.resize(r + 1), this.emplace(r, t, e1, n);
            }
            emplace(t, e1, n, r) {
                const i = 3 * t;
                return this.float32[i + 0] = e1, this.float32[i + 1] = n, this.float32[i + 2] = r, t;
            }
        }
        vo.prototype.bytesPerElement = 12, ds("StructArrayLayout3f12", vo);
        class bo extends oo {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer);
            }
            emplaceBack(t) {
                const e1 = this.length;
                return this.resize(e1 + 1), this.emplace(e1, t);
            }
            emplace(t, e1) {
                return this.uint32[1 * t + 0] = e1, t;
            }
        }
        bo.prototype.bytesPerElement = 4, ds("StructArrayLayout1ul4", bo);
        class wo extends oo {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
            }
            emplaceBack(t, e1, n, r, i, s, o, a, l) {
                const u = this.length;
                return this.resize(u + 1), this.emplace(u, t, e1, n, r, i, s, o, a, l);
            }
            emplace(t, e1, n, r, i, s, o, a, l, u) {
                const c = 10 * t, h = 5 * t;
                return this.int16[c + 0] = e1, this.int16[c + 1] = n, this.int16[c + 2] = r, this.int16[c + 3] = i, this.int16[c + 4] = s, this.int16[c + 5] = o, this.uint32[h + 3] = a, this.uint16[c + 8] = l, this.uint16[c + 9] = u, t;
            }
        }
        wo.prototype.bytesPerElement = 20, ds("StructArrayLayout6i1ul2ui20", wo);
        class _o extends oo {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
            }
            emplaceBack(t, e1, n, r, i, s) {
                const o = this.length;
                return this.resize(o + 1), this.emplace(o, t, e1, n, r, i, s);
            }
            emplace(t, e1, n, r, i, s, o) {
                const a = 6 * t;
                return this.int16[a + 0] = e1, this.int16[a + 1] = n, this.int16[a + 2] = r, this.int16[a + 3] = i, this.int16[a + 4] = s, this.int16[a + 5] = o, t;
            }
        }
        _o.prototype.bytesPerElement = 12, ds("StructArrayLayout2i2i2i12", _o);
        class So extends oo {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
            }
            emplaceBack(t, e1, n, r, i) {
                const s = this.length;
                return this.resize(s + 1), this.emplace(s, t, e1, n, r, i);
            }
            emplace(t, e1, n, r, i, s) {
                const o = 4 * t, a = 8 * t;
                return this.float32[o + 0] = e1, this.float32[o + 1] = n, this.float32[o + 2] = r, this.int16[a + 6] = i, this.int16[a + 7] = s, t;
            }
        }
        So.prototype.bytesPerElement = 16, ds("StructArrayLayout2f1f2i16", So);
        class Ao extends oo {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
            }
            emplaceBack(t, e1, n, r, i, s) {
                const o = this.length;
                return this.resize(o + 1), this.emplace(o, t, e1, n, r, i, s);
            }
            emplace(t, e1, n, r, i, s, o) {
                const a = 16 * t, l = 4 * t, u = 8 * t;
                return this.uint8[a + 0] = e1, this.uint8[a + 1] = n, this.float32[l + 1] = r, this.float32[l + 2] = i, this.int16[u + 6] = s, this.int16[u + 7] = o, t;
            }
        }
        Ao.prototype.bytesPerElement = 16, ds("StructArrayLayout2ub2f2i16", Ao);
        class Mo extends oo {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
            }
            emplaceBack(t, e1, n) {
                const r = this.length;
                return this.resize(r + 1), this.emplace(r, t, e1, n);
            }
            emplace(t, e1, n, r) {
                const i = 3 * t;
                return this.uint16[i + 0] = e1, this.uint16[i + 1] = n, this.uint16[i + 2] = r, t;
            }
        }
        Mo.prototype.bytesPerElement = 6, ds("StructArrayLayout3ui6", Mo);
        class ko extends oo {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(t, e1, n, r, i, s, o, a, l, u, c, h, p, f, d, y, m) {
                const g = this.length;
                return this.resize(g + 1), this.emplace(g, t, e1, n, r, i, s, o, a, l, u, c, h, p, f, d, y, m);
            }
            emplace(t, e1, n, r, i, s, o, a, l, u, c, h, p, f, d, y, m, g) {
                const x = 24 * t, v = 12 * t, b = 48 * t;
                return this.int16[x + 0] = e1, this.int16[x + 1] = n, this.uint16[x + 2] = r, this.uint16[x + 3] = i, this.uint32[v + 2] = s, this.uint32[v + 3] = o, this.uint32[v + 4] = a, this.uint16[x + 10] = l, this.uint16[x + 11] = u, this.uint16[x + 12] = c, this.float32[v + 7] = h, this.float32[v + 8] = p, this.uint8[b + 36] = f, this.uint8[b + 37] = d, this.uint8[b + 38] = y, this.uint32[v + 10] = m, this.int16[x + 22] = g, t;
            }
        }
        ko.prototype.bytesPerElement = 48, ds("StructArrayLayout2i2ui3ul3ui2f3ub1ul1i48", ko);
        class Io extends oo {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(t, e1, n, r, i, s, o, a, l, u, c, h, p, f, d, y, m, g, x, v, b, w, _, S, A, M, k, I) {
                const E = this.length;
                return this.resize(E + 1), this.emplace(E, t, e1, n, r, i, s, o, a, l, u, c, h, p, f, d, y, m, g, x, v, b, w, _, S, A, M, k, I);
            }
            emplace(t, e1, n, r, i, s, o, a, l, u, c, h, p, f, d, y, m, g, x, v, b, w, _, S, A, M, k, I, E) {
                const T = 32 * t, F = 16 * t;
                return this.int16[T + 0] = e1, this.int16[T + 1] = n, this.int16[T + 2] = r, this.int16[T + 3] = i, this.int16[T + 4] = s, this.int16[T + 5] = o, this.int16[T + 6] = a, this.int16[T + 7] = l, this.uint16[T + 8] = u, this.uint16[T + 9] = c, this.uint16[T + 10] = h, this.uint16[T + 11] = p, this.uint16[T + 12] = f, this.uint16[T + 13] = d, this.uint16[T + 14] = y, this.uint16[T + 15] = m, this.uint16[T + 16] = g, this.uint16[T + 17] = x, this.uint16[T + 18] = v, this.uint16[T + 19] = b, this.uint16[T + 20] = w, this.uint16[T + 21] = _, this.uint16[T + 22] = S, this.uint32[F + 12] = A, this.float32[F + 13] = M, this.float32[F + 14] = k, this.uint16[T + 30] = I, this.uint16[T + 31] = E, t;
            }
        }
        Io.prototype.bytesPerElement = 64, ds("StructArrayLayout8i15ui1ul2f2ui64", Io);
        class Eo extends oo {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(t) {
                const e1 = this.length;
                return this.resize(e1 + 1), this.emplace(e1, t);
            }
            emplace(t, e1) {
                return this.float32[1 * t + 0] = e1, t;
            }
        }
        Eo.prototype.bytesPerElement = 4, ds("StructArrayLayout1f4", Eo);
        class To extends oo {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(t, e1, n) {
                const r = this.length;
                return this.resize(r + 1), this.emplace(r, t, e1, n);
            }
            emplace(t, e1, n, r) {
                const i = 3 * t;
                return this.uint16[6 * t + 0] = e1, this.float32[i + 1] = n, this.float32[i + 2] = r, t;
            }
        }
        To.prototype.bytesPerElement = 12, ds("StructArrayLayout1ui2f12", To);
        class Fo extends oo {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
            }
            emplaceBack(t, e1, n) {
                const r = this.length;
                return this.resize(r + 1), this.emplace(r, t, e1, n);
            }
            emplace(t, e1, n, r) {
                const i = 4 * t;
                return this.uint32[2 * t + 0] = e1, this.uint16[i + 2] = n, this.uint16[i + 3] = r, t;
            }
        }
        Fo.prototype.bytesPerElement = 8, ds("StructArrayLayout1ul2ui8", Fo);
        class Po extends oo {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
            }
            emplaceBack(t, e1) {
                const n = this.length;
                return this.resize(n + 1), this.emplace(n, t, e1);
            }
            emplace(t, e1, n) {
                const r = 2 * t;
                return this.uint16[r + 0] = e1, this.uint16[r + 1] = n, t;
            }
        }
        Po.prototype.bytesPerElement = 4, ds("StructArrayLayout2ui4", Po);
        class Do extends oo {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
            }
            emplaceBack(t) {
                const e1 = this.length;
                return this.resize(e1 + 1), this.emplace(e1, t);
            }
            emplace(t, e1) {
                return this.uint16[1 * t + 0] = e1, t;
            }
        }
        Do.prototype.bytesPerElement = 2, ds("StructArrayLayout1ui2", Do);
        class zo extends oo {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(t, e1, n, r) {
                const i = this.length;
                return this.resize(i + 1), this.emplace(i, t, e1, n, r);
            }
            emplace(t, e1, n, r, i) {
                const s = 4 * t;
                return this.float32[s + 0] = e1, this.float32[s + 1] = n, this.float32[s + 2] = r, this.float32[s + 3] = i, t;
            }
        }
        zo.prototype.bytesPerElement = 16, ds("StructArrayLayout4f16", zo);
        class Bo extends so {
            get anchorPointX() {
                return this._structArray.int16[this._pos2 + 0];
            }
            get anchorPointY() {
                return this._structArray.int16[this._pos2 + 1];
            }
            get x1() {
                return this._structArray.int16[this._pos2 + 2];
            }
            get y1() {
                return this._structArray.int16[this._pos2 + 3];
            }
            get x2() {
                return this._structArray.int16[this._pos2 + 4];
            }
            get y2() {
                return this._structArray.int16[this._pos2 + 5];
            }
            get featureIndex() {
                return this._structArray.uint32[this._pos4 + 3];
            }
            get sourceLayerIndex() {
                return this._structArray.uint16[this._pos2 + 8];
            }
            get bucketIndex() {
                return this._structArray.uint16[this._pos2 + 9];
            }
            get anchorPoint() {
                return new n(this.anchorPointX, this.anchorPointY);
            }
        }
        Bo.prototype.size = 20;
        class Co extends wo {
            get(t) {
                return new Bo(this, t);
            }
        }
        ds("CollisionBoxArray", Co);
        class Vo extends so {
            get anchorX() {
                return this._structArray.int16[this._pos2 + 0];
            }
            get anchorY() {
                return this._structArray.int16[this._pos2 + 1];
            }
            get glyphStartIndex() {
                return this._structArray.uint16[this._pos2 + 2];
            }
            get numGlyphs() {
                return this._structArray.uint16[this._pos2 + 3];
            }
            get vertexStartIndex() {
                return this._structArray.uint32[this._pos4 + 2];
            }
            get lineStartIndex() {
                return this._structArray.uint32[this._pos4 + 3];
            }
            get lineLength() {
                return this._structArray.uint32[this._pos4 + 4];
            }
            get segment() {
                return this._structArray.uint16[this._pos2 + 10];
            }
            get lowerSize() {
                return this._structArray.uint16[this._pos2 + 11];
            }
            get upperSize() {
                return this._structArray.uint16[this._pos2 + 12];
            }
            get lineOffsetX() {
                return this._structArray.float32[this._pos4 + 7];
            }
            get lineOffsetY() {
                return this._structArray.float32[this._pos4 + 8];
            }
            get writingMode() {
                return this._structArray.uint8[this._pos1 + 36];
            }
            get placedOrientation() {
                return this._structArray.uint8[this._pos1 + 37];
            }
            set placedOrientation(t) {
                this._structArray.uint8[this._pos1 + 37] = t;
            }
            get hidden() {
                return this._structArray.uint8[this._pos1 + 38];
            }
            set hidden(t) {
                this._structArray.uint8[this._pos1 + 38] = t;
            }
            get crossTileID() {
                return this._structArray.uint32[this._pos4 + 10];
            }
            set crossTileID(t) {
                this._structArray.uint32[this._pos4 + 10] = t;
            }
            get associatedIconIndex() {
                return this._structArray.int16[this._pos2 + 22];
            }
        }
        Vo.prototype.size = 48;
        class Lo extends ko {
            get(t) {
                return new Vo(this, t);
            }
        }
        ds("PlacedSymbolArray", Lo);
        class Oo extends so {
            get anchorX() {
                return this._structArray.int16[this._pos2 + 0];
            }
            get anchorY() {
                return this._structArray.int16[this._pos2 + 1];
            }
            get rightJustifiedTextSymbolIndex() {
                return this._structArray.int16[this._pos2 + 2];
            }
            get centerJustifiedTextSymbolIndex() {
                return this._structArray.int16[this._pos2 + 3];
            }
            get leftJustifiedTextSymbolIndex() {
                return this._structArray.int16[this._pos2 + 4];
            }
            get verticalPlacedTextSymbolIndex() {
                return this._structArray.int16[this._pos2 + 5];
            }
            get placedIconSymbolIndex() {
                return this._structArray.int16[this._pos2 + 6];
            }
            get verticalPlacedIconSymbolIndex() {
                return this._structArray.int16[this._pos2 + 7];
            }
            get key() {
                return this._structArray.uint16[this._pos2 + 8];
            }
            get textBoxStartIndex() {
                return this._structArray.uint16[this._pos2 + 9];
            }
            get textBoxEndIndex() {
                return this._structArray.uint16[this._pos2 + 10];
            }
            get verticalTextBoxStartIndex() {
                return this._structArray.uint16[this._pos2 + 11];
            }
            get verticalTextBoxEndIndex() {
                return this._structArray.uint16[this._pos2 + 12];
            }
            get iconBoxStartIndex() {
                return this._structArray.uint16[this._pos2 + 13];
            }
            get iconBoxEndIndex() {
                return this._structArray.uint16[this._pos2 + 14];
            }
            get verticalIconBoxStartIndex() {
                return this._structArray.uint16[this._pos2 + 15];
            }
            get verticalIconBoxEndIndex() {
                return this._structArray.uint16[this._pos2 + 16];
            }
            get featureIndex() {
                return this._structArray.uint16[this._pos2 + 17];
            }
            get numHorizontalGlyphVertices() {
                return this._structArray.uint16[this._pos2 + 18];
            }
            get numVerticalGlyphVertices() {
                return this._structArray.uint16[this._pos2 + 19];
            }
            get numIconVertices() {
                return this._structArray.uint16[this._pos2 + 20];
            }
            get numVerticalIconVertices() {
                return this._structArray.uint16[this._pos2 + 21];
            }
            get useRuntimeCollisionCircles() {
                return this._structArray.uint16[this._pos2 + 22];
            }
            get crossTileID() {
                return this._structArray.uint32[this._pos4 + 12];
            }
            set crossTileID(t) {
                this._structArray.uint32[this._pos4 + 12] = t;
            }
            get textBoxScale() {
                return this._structArray.float32[this._pos4 + 13];
            }
            get collisionCircleDiameter() {
                return this._structArray.float32[this._pos4 + 14];
            }
            get textAnchorOffsetStartIndex() {
                return this._structArray.uint16[this._pos2 + 30];
            }
            get textAnchorOffsetEndIndex() {
                return this._structArray.uint16[this._pos2 + 31];
            }
        }
        Oo.prototype.size = 64;
        class $o extends Io {
            get(t) {
                return new Oo(this, t);
            }
        }
        ds("SymbolInstanceArray", $o);
        class Ro extends Eo {
            getoffsetX(t) {
                return this.float32[1 * t + 0];
            }
        }
        ds("GlyphOffsetArray", Ro);
        class No extends co {
            getx(t) {
                return this.int16[3 * t + 0];
            }
            gety(t) {
                return this.int16[3 * t + 1];
            }
            gettileUnitDistanceFromAnchor(t) {
                return this.int16[3 * t + 2];
            }
        }
        ds("SymbolLineVertexArray", No);
        class Uo extends so {
            get textAnchor() {
                return this._structArray.uint16[this._pos2 + 0];
            }
            get textOffset0() {
                return this._structArray.float32[this._pos4 + 1];
            }
            get textOffset1() {
                return this._structArray.float32[this._pos4 + 2];
            }
        }
        Uo.prototype.size = 12;
        class jo extends To {
            get(t) {
                return new Uo(this, t);
            }
        }
        ds("TextAnchorOffsetArray", jo);
        class qo extends so {
            get featureIndex() {
                return this._structArray.uint32[this._pos4 + 0];
            }
            get sourceLayerIndex() {
                return this._structArray.uint16[this._pos2 + 2];
            }
            get bucketIndex() {
                return this._structArray.uint16[this._pos2 + 3];
            }
        }
        qo.prototype.size = 8;
        class Go extends Fo {
            get(t) {
                return new qo(this, t);
            }
        }
        ds("FeatureIndexArray", Go);
        class Xo extends uo {
        }
        class Yo extends uo {
        }
        class Zo extends uo {
        }
        class Ho extends po {
        }
        class Wo extends fo {
        }
        class Ko extends yo {
        }
        class Jo extends mo {
        }
        class Qo extends go {
        }
        class ta extends xo {
        }
        class ea extends vo {
        }
        class na extends bo {
        }
        class ra extends _o {
        }
        class ia extends Ao {
        }
        class sa extends Mo {
        }
        class oa extends Po {
        }
        const aa = ao([
            {
                name: "a_pos",
                components: 2,
                type: "Int16"
            }
        ], 4), { members: la } = aa;
        class ua {
            constructor(t = []){
                this._forceNewSegmentOnNextPrepare = !1, this.segments = t;
            }
            prepareSegment(t, e1, n, r) {
                const i = this.segments[this.segments.length - 1];
                return t > ua.MAX_VERTEX_ARRAY_LENGTH && G(`Max vertices per segment is ${ua.MAX_VERTEX_ARRAY_LENGTH}: bucket requested ${t}. Consider using the \`fillLargeMeshArrays\` function if you require meshes with more than ${ua.MAX_VERTEX_ARRAY_LENGTH} vertices.`), this._forceNewSegmentOnNextPrepare || !i || i.vertexLength + t > ua.MAX_VERTEX_ARRAY_LENGTH || i.sortKey !== r ? this.createNewSegment(e1, n, r) : i;
            }
            createNewSegment(t, e1, n) {
                const r = {
                    vertexOffset: t.length,
                    primitiveOffset: e1.length,
                    vertexLength: 0,
                    primitiveLength: 0,
                    vaos: {}
                };
                return void 0 !== n && (r.sortKey = n), this._forceNewSegmentOnNextPrepare = !1, this.segments.push(r), r;
            }
            getOrCreateLatestSegment(t, e1, n) {
                return this.prepareSegment(0, t, e1, n);
            }
            forceNewSegmentOnNextPrepare() {
                this._forceNewSegmentOnNextPrepare = !0;
            }
            get() {
                return this.segments;
            }
            destroy() {
                for (const t of this.segments)for(const e1 in t.vaos)t.vaos[e1].destroy();
            }
            static simpleSegment(t, e1, n, r) {
                return new ua([
                    {
                        vertexOffset: t,
                        primitiveOffset: e1,
                        vertexLength: n,
                        primitiveLength: r,
                        vaos: {},
                        sortKey: 0
                    }
                ]);
            }
        }
        function ca(t, e1) {
            return 256 * (t = L(Math.floor(t), 0, 255)) + L(Math.floor(e1), 0, 255);
        }
        ua.MAX_VERTEX_ARRAY_LENGTH = Math.pow(2, 16) - 1, ds("SegmentVector", ua);
        const ha = ao([
            {
                name: "a_pattern_from",
                components: 4,
                type: "Uint16"
            },
            {
                name: "a_pattern_to",
                components: 4,
                type: "Uint16"
            },
            {
                name: "a_pixel_ratio_from",
                components: 1,
                type: "Uint16"
            },
            {
                name: "a_pixel_ratio_to",
                components: 1,
                type: "Uint16"
            }
        ]), pa = ao([
            {
                name: "a_dasharray_from",
                components: 4,
                type: "Uint16"
            },
            {
                name: "a_dasharray_to",
                components: 4,
                type: "Uint16"
            }
        ]);
        var fa, da, ya, ma = {
            exports: {}
        }, ga = {
            exports: {}
        }, xa = {
            exports: {}
        }, va = function() {
            if (ya) return ma.exports;
            ya = 1;
            var t = (fa || (fa = 1, ga.exports = function(t, e1) {
                var n, r, i, s, o, a, l, u;
                for(r = t.length - (n = 3 & t.length), i = e1, o = 3432918353, a = 461845907, u = 0; u < r;)l = 255 & t.charCodeAt(u) | (255 & t.charCodeAt(++u)) << 8 | (255 & t.charCodeAt(++u)) << 16 | (255 & t.charCodeAt(++u)) << 24, ++u, i = 27492 + (65535 & (s = 5 * (65535 & (i = (i ^= l = (65535 & (l = (l = (65535 & l) * o + (((l >>> 16) * o & 65535) << 16) & 4294967295) << 15 | l >>> 17)) * a + (((l >>> 16) * a & 65535) << 16) & 4294967295) << 13 | i >>> 19)) + ((5 * (i >>> 16) & 65535) << 16) & 4294967295)) + ((58964 + (s >>> 16) & 65535) << 16);
                switch(l = 0, n){
                    case 3:
                        l ^= (255 & t.charCodeAt(u + 2)) << 16;
                    case 2:
                        l ^= (255 & t.charCodeAt(u + 1)) << 8;
                    case 1:
                        i ^= l = (65535 & (l = (l = (65535 & (l ^= 255 & t.charCodeAt(u))) * o + (((l >>> 16) * o & 65535) << 16) & 4294967295) << 15 | l >>> 17)) * a + (((l >>> 16) * a & 65535) << 16) & 4294967295;
                }
                return i ^= t.length, i = 2246822507 * (65535 & (i ^= i >>> 16)) + ((2246822507 * (i >>> 16) & 65535) << 16) & 4294967295, i = 3266489909 * (65535 & (i ^= i >>> 13)) + ((3266489909 * (i >>> 16) & 65535) << 16) & 4294967295, (i ^= i >>> 16) >>> 0;
            }), ga.exports), e1 = (da || (da = 1, xa.exports = function(t, e1) {
                for(var n, r = t.length, i = e1 ^ r, s = 0; r >= 4;)n = 1540483477 * (65535 & (n = 255 & t.charCodeAt(s) | (255 & t.charCodeAt(++s)) << 8 | (255 & t.charCodeAt(++s)) << 16 | (255 & t.charCodeAt(++s)) << 24)) + ((1540483477 * (n >>> 16) & 65535) << 16), i = 1540483477 * (65535 & i) + ((1540483477 * (i >>> 16) & 65535) << 16) ^ (n = 1540483477 * (65535 & (n ^= n >>> 24)) + ((1540483477 * (n >>> 16) & 65535) << 16)), r -= 4, ++s;
                switch(r){
                    case 3:
                        i ^= (255 & t.charCodeAt(s + 2)) << 16;
                    case 2:
                        i ^= (255 & t.charCodeAt(s + 1)) << 8;
                    case 1:
                        i = 1540483477 * (65535 & (i ^= 255 & t.charCodeAt(s))) + ((1540483477 * (i >>> 16) & 65535) << 16);
                }
                return i = 1540483477 * (65535 & (i ^= i >>> 13)) + ((1540483477 * (i >>> 16) & 65535) << 16), (i ^= i >>> 15) >>> 0;
            }), xa.exports);
            return ma.exports = t, ma.exports.murmur3 = t, ma.exports.murmur2 = e1, ma.exports;
        }(), ba = r(va);
        class wa {
            constructor(){
                this.ids = [], this.positions = [], this.indexed = !1;
            }
            add(t, e1, n, r) {
                this.ids.push(_a(t)), this.positions.push(e1, n, r);
            }
            getPositions(t) {
                if (!this.indexed) throw new Error("Trying to get index, but feature positions are not indexed");
                const e1 = _a(t);
                let n = 0, r = this.ids.length - 1;
                for(; n < r;){
                    const t = n + r >> 1;
                    this.ids[t] >= e1 ? r = t : n = t + 1;
                }
                const i = [];
                for(; this.ids[n] === e1;)i.push({
                    index: this.positions[3 * n],
                    start: this.positions[3 * n + 1],
                    end: this.positions[3 * n + 2]
                }), n++;
                return i;
            }
            static serialize(t, e1) {
                const n = new Float64Array(t.ids), r = new Uint32Array(t.positions);
                return Sa(n, r, 0, n.length - 1), e1 && e1.push(n.buffer, r.buffer), {
                    ids: n,
                    positions: r
                };
            }
            static deserialize(t) {
                const e1 = new wa;
                return e1.ids = t.ids, e1.positions = t.positions, e1.indexed = !0, e1;
            }
        }
        function _a(t) {
            const e1 = +t;
            return !isNaN(e1) && e1 <= Number.MAX_SAFE_INTEGER ? e1 : ba(String(t));
        }
        function Sa(t, e1, n, r) {
            for(; n < r;){
                const i = t[n + r >> 1];
                let s = n - 1, o = r + 1;
                for(;;){
                    do s++;
                    while (t[s] < i);
                    do o--;
                    while (t[o] > i);
                    if (s >= o) break;
                    Aa(t, s, o), Aa(e1, 3 * s, 3 * o), Aa(e1, 3 * s + 1, 3 * o + 1), Aa(e1, 3 * s + 2, 3 * o + 2);
                }
                o - n < r - o ? (Sa(t, e1, n, o), n = o + 1) : (Sa(t, e1, o + 1, r), r = o);
            }
        }
        function Aa(t, e1, n) {
            const r = t[e1];
            t[e1] = t[n], t[n] = r;
        }
        ds("FeaturePositionMap", wa);
        class Ma {
            constructor(t, e1){
                this.gl = t.gl, this.location = e1;
            }
        }
        class ka extends Ma {
            constructor(t, e1){
                super(t, e1), this.current = 0;
            }
            set(t) {
                this.current !== t && (this.current = t, this.gl.uniform1f(this.location, t));
            }
        }
        class Ia extends Ma {
            constructor(t, e1){
                super(t, e1), this.current = [
                    0,
                    0,
                    0,
                    0
                ];
            }
            set(t) {
                t[0] === this.current[0] && t[1] === this.current[1] && t[2] === this.current[2] && t[3] === this.current[3] || (this.current = t, this.gl.uniform4f(this.location, t[0], t[1], t[2], t[3]));
            }
        }
        class Ea extends Ma {
            constructor(t, e1){
                super(t, e1), this.current = Te.transparent;
            }
            set(t) {
                t.r === this.current.r && t.g === this.current.g && t.b === this.current.b && t.a === this.current.a || (this.current = t, this.gl.uniform4f(this.location, t.r, t.g, t.b, t.a));
            }
        }
        const Ta = new Float32Array(16);
        function Fa(t) {
            return [
                ca(255 * t.r, 255 * t.g),
                ca(255 * t.b, 255 * t.a)
            ];
        }
        class Pa {
            constructor(t, e1, n){
                this.value = t, this.uniformNames = e1.map((t)=>`u_${t}`), this.type = n;
            }
            setUniform(t, e1, n) {
                t.set(n.constantOr(this.value));
            }
            getBinding(t, e1, n) {
                return "color" === this.type ? new Ea(t, e1) : new ka(t, e1);
            }
        }
        class Da {
            constructor(t, e1){
                this.uniformNames = e1.map((t)=>`u_${t}`), this.patternFrom = null, this.patternTo = null, this.pixelRatioFrom = 1, this.pixelRatioTo = 1;
            }
            setConstantPatternPositions(t, e1) {
                this.pixelRatioFrom = e1.pixelRatio, this.pixelRatioTo = t.pixelRatio, this.patternFrom = e1.tlbr, this.patternTo = t.tlbr;
            }
            setConstantDashPositions(t, e1) {
                this.dashTo = [
                    0,
                    t.y,
                    t.height,
                    t.width
                ], this.dashFrom = [
                    0,
                    e1.y,
                    e1.height,
                    e1.width
                ];
            }
            setUniform(t, e1, n, r) {
                let i = null;
                "u_pattern_to" === r ? i = this.patternTo : "u_pattern_from" === r ? i = this.patternFrom : "u_dasharray_to" === r ? i = this.dashTo : "u_dasharray_from" === r ? i = this.dashFrom : "u_pixel_ratio_to" === r ? i = this.pixelRatioTo : "u_pixel_ratio_from" === r && (i = this.pixelRatioFrom), null !== i && t.set(i);
            }
            getBinding(t, e1, n) {
                return n.startsWith("u_pattern") || n.startsWith("u_dasharray_") ? new Ia(t, e1) : new ka(t, e1);
            }
        }
        class za {
            constructor(t, e1, n, r){
                this.expression = t, this.type = n, this.maxValue = 0, this.paintVertexAttributes = e1.map((t)=>({
                        name: `a_${t}`,
                        type: "Float32",
                        components: "color" === n ? 2 : 1,
                        offset: 0
                    })), this.paintVertexArray = new r;
            }
            populatePaintArray(t, e1, n) {
                const r = this.paintVertexArray.length, i = this.expression.evaluate(new Cs(0, n), e1, {}, n.canonical, [], n.formattedSection);
                this.paintVertexArray.resize(t), this._setPaintValue(r, t, i);
            }
            updatePaintArray(t, e1, n, r, i) {
                const s = this.expression.evaluate(new Cs(0, i), n, r);
                this._setPaintValue(t, e1, s);
            }
            _setPaintValue(t, e1, n) {
                if ("color" === this.type) {
                    const r = Fa(n);
                    for(let n = t; n < e1; n++)this.paintVertexArray.emplace(n, r[0], r[1]);
                } else {
                    for(let r = t; r < e1; r++)this.paintVertexArray.emplace(r, n);
                    this.maxValue = Math.max(this.maxValue, Math.abs(n));
                }
            }
            upload(t) {
                var e1, n;
                (null === (e1 = this.paintVertexArray) || void 0 === e1 ? void 0 : e1.arrayBuffer.byteLength) && ((null === (n = this.paintVertexBuffer) || void 0 === n ? void 0 : n.buffer) ? this.paintVertexBuffer.updateData(this.paintVertexArray) : this.paintVertexBuffer = t.createVertexBuffer(this.paintVertexArray, this.paintVertexAttributes, this.expression.isStateDependent));
            }
            destroy() {
                this.paintVertexBuffer && this.paintVertexBuffer.destroy();
            }
        }
        class Ba {
            constructor(t, e1, n, r, i, s){
                this.expression = t, this.uniformNames = e1.map((t)=>`u_${t}_t`), this.type = n, this.useIntegerZoom = r, this.zoom = i, this.maxValue = 0, this.paintVertexAttributes = e1.map((t)=>({
                        name: `a_${t}`,
                        type: "Float32",
                        components: "color" === n ? 4 : 2,
                        offset: 0
                    })), this.paintVertexArray = new s;
            }
            populatePaintArray(t, e1, n) {
                const r = this.expression.evaluate(new Cs(this.zoom, n), e1, {}, n.canonical, [], n.formattedSection), i = this.expression.evaluate(new Cs(this.zoom + 1, n), e1, {}, n.canonical, [], n.formattedSection), s = this.paintVertexArray.length;
                this.paintVertexArray.resize(t), this._setPaintValue(s, t, r, i);
            }
            updatePaintArray(t, e1, n, r, i) {
                const s = this.expression.evaluate(new Cs(this.zoom, i), n, r), o = this.expression.evaluate(new Cs(this.zoom + 1, i), n, r);
                this._setPaintValue(t, e1, s, o);
            }
            _setPaintValue(t, e1, n, r) {
                if ("color" === this.type) {
                    const i = Fa(n), s = Fa(r);
                    for(let n = t; n < e1; n++)this.paintVertexArray.emplace(n, i[0], i[1], s[0], s[1]);
                } else {
                    for(let i = t; i < e1; i++)this.paintVertexArray.emplace(i, n, r);
                    this.maxValue = Math.max(this.maxValue, Math.abs(n), Math.abs(r));
                }
            }
            upload(t) {
                var e1, n;
                (null === (e1 = this.paintVertexArray) || void 0 === e1 ? void 0 : e1.arrayBuffer.byteLength) && ((null === (n = this.paintVertexBuffer) || void 0 === n ? void 0 : n.buffer) ? this.paintVertexBuffer.updateData(this.paintVertexArray) : this.paintVertexBuffer = t.createVertexBuffer(this.paintVertexArray, this.paintVertexAttributes, this.expression.isStateDependent));
            }
            destroy() {
                this.paintVertexBuffer && this.paintVertexBuffer.destroy();
            }
            setUniform(t, e1) {
                const n = this.useIntegerZoom ? Math.floor(e1.zoom) : e1.zoom, r = L(this.expression.interpolationFactor(n, this.zoom, this.zoom + 1), 0, 1);
                t.set(r);
            }
            getBinding(t, e1, n) {
                return new ka(t, e1);
            }
        }
        class Ca {
            constructor(t, e1, n, r, i, s){
                this.expression = t, this.type = e1, this.useIntegerZoom = n, this.zoom = r, this.layerId = s, this.zoomInPaintVertexArray = new i, this.zoomOutPaintVertexArray = new i;
            }
            populatePaintArray(t, e1, n) {
                const r = this.zoomInPaintVertexArray.length;
                this.zoomInPaintVertexArray.resize(t), this.zoomOutPaintVertexArray.resize(t), this._setPaintValues(r, t, this.getPositionIds(e1), n);
            }
            updatePaintArray(t, e1, n, r, i) {
                this._setPaintValues(t, e1, this.getPositionIds(n), i);
            }
            _setPaintValues(t, e1, n, r) {
                const i = this.getPositions(r);
                if (!i || !n) return;
                const s = i[n.min], o = i[n.mid], a = i[n.max];
                if (s && o && a) for(let n = t; n < e1; n++)this.emplace(this.zoomInPaintVertexArray, n, o, s), this.emplace(this.zoomOutPaintVertexArray, n, o, a);
            }
            upload(t) {
                var e1, n;
                if ((null === (e1 = this.zoomInPaintVertexArray) || void 0 === e1 ? void 0 : e1.arrayBuffer.byteLength) && (null === (n = this.zoomOutPaintVertexArray) || void 0 === n ? void 0 : n.arrayBuffer.byteLength)) {
                    const e1 = this.getVertexAttributes();
                    this.zoomInPaintVertexBuffer = t.createVertexBuffer(this.zoomInPaintVertexArray, e1, this.expression.isStateDependent), this.zoomOutPaintVertexBuffer = t.createVertexBuffer(this.zoomOutPaintVertexArray, e1, this.expression.isStateDependent);
                }
            }
            destroy() {
                this.zoomOutPaintVertexBuffer && this.zoomOutPaintVertexBuffer.destroy(), this.zoomInPaintVertexBuffer && this.zoomInPaintVertexBuffer.destroy();
            }
        }
        class Va extends Ca {
            getPositions(t) {
                return t.imagePositions;
            }
            getPositionIds(t) {
                var e1;
                return null === (e1 = t.patterns) || void 0 === e1 ? void 0 : e1[this.layerId];
            }
            getVertexAttributes() {
                return ha.members;
            }
            emplace(t, e1, n, r) {
                t.emplace(e1, n.tlbr[0], n.tlbr[1], n.tlbr[2], n.tlbr[3], r.tlbr[0], r.tlbr[1], r.tlbr[2], r.tlbr[3], n.pixelRatio, r.pixelRatio);
            }
        }
        class La extends Ca {
            getPositions(t) {
                return t.dashPositions;
            }
            getPositionIds(t) {
                var e1;
                return null === (e1 = t.dashes) || void 0 === e1 ? void 0 : e1[this.layerId];
            }
            getVertexAttributes() {
                return pa.members;
            }
            emplace(t, e1, n, r) {
                t.emplace(e1, 0, n.y, n.height, n.width, 0, r.y, r.height, r.width);
            }
        }
        class Oa {
            constructor(t, e1, n){
                this.binders = {}, this._buffers = [];
                const r = [];
                for(const i in t.paint._values){
                    if (!n(i)) continue;
                    const s = t.paint.get(i);
                    if (!(s instanceof qs && Gr(s.property.specification))) continue;
                    const o = Ra(i, t.type), a = s.value, l = s.property.specification.type, u = s.property.useIntegerZoom, c = s.property.specification["property-type"], h = "cross-faded" === c || "cross-faded-data-driven" === c;
                    if ("constant" === a.kind) this.binders[i] = h ? new Da(a.value, o) : new Pa(a.value, o, l), r.push(`/u_${i}`);
                    else if ("source" === a.kind || h) {
                        const n = Na(i, l, "source");
                        this.binders[i] = h ? "line-dasharray" === i ? new La(a, l, u, e1, n, t.id) : new Va(a, l, u, e1, n, t.id) : new za(a, o, l, n), r.push(`/a_${i}`);
                    } else {
                        const t = Na(i, l, "composite");
                        this.binders[i] = new Ba(a, o, l, u, e1, t), r.push(`/z_${i}`);
                    }
                }
                this.cacheKey = r.sort().join("");
            }
            getMaxValue(t) {
                const e1 = this.binders[t];
                return e1 instanceof za || e1 instanceof Ba ? e1.maxValue : 0;
            }
            populatePaintArrays(t, e1, n) {
                for(const r in this.binders){
                    const i = this.binders[r];
                    (i instanceof za || i instanceof Ba || i instanceof Ca) && i.populatePaintArray(t, e1, n);
                }
            }
            setConstantPatternPositions(t, e1) {
                for(const n in this.binders){
                    const r = this.binders[n];
                    r instanceof Da && r.setConstantPatternPositions(t, e1);
                }
            }
            setConstantDashPositions(t, e1) {
                for(const n in this.binders){
                    const r = this.binders[n];
                    r instanceof Da && r.setConstantDashPositions(t, e1);
                }
            }
            updatePaintArrays(t, e1, n, r, i) {
                let s = !1;
                for(const o in t){
                    const a = e1.getPositions(o);
                    for (const e1 of a){
                        const a = n.feature(e1.index);
                        for(const n in this.binders){
                            const l = this.binders[n];
                            if ((l instanceof za || l instanceof Ba || l instanceof Ca) && !0 === l.expression.isStateDependent) {
                                const u = r.paint.get(n);
                                l.expression = u.value, l.updatePaintArray(e1.start, e1.end, a, t[o], i), s = !0;
                            }
                        }
                    }
                }
                return s;
            }
            defines() {
                const t = [];
                for(const e1 in this.binders){
                    const n = this.binders[e1];
                    (n instanceof Pa || n instanceof Da) && t.push(...n.uniformNames.map((t)=>`#define HAS_UNIFORM_${t}`));
                }
                return t;
            }
            getBinderAttributes() {
                const t = [];
                for(const e1 in this.binders){
                    const n = this.binders[e1];
                    if (n instanceof za || n instanceof Ba) for (const e1 of n.paintVertexAttributes)t.push(e1.name);
                    else if (n instanceof Ca) {
                        const e1 = n.getVertexAttributes();
                        for (const n of e1)t.push(n.name);
                    }
                }
                return t;
            }
            getBinderUniforms() {
                const t = [];
                for(const e1 in this.binders){
                    const n = this.binders[e1];
                    if (n instanceof Pa || n instanceof Da || n instanceof Ba) for (const e1 of n.uniformNames)t.push(e1);
                }
                return t;
            }
            getPaintVertexBuffers() {
                return this._buffers;
            }
            getUniforms(t, e1) {
                const n = [];
                for(const r in this.binders){
                    const i = this.binders[r];
                    if (i instanceof Pa || i instanceof Da || i instanceof Ba) {
                        for (const s of i.uniformNames)if (e1[s]) {
                            const o = i.getBinding(t, e1[s], s);
                            n.push({
                                name: s,
                                property: r,
                                binding: o
                            });
                        }
                    }
                }
                return n;
            }
            setUniforms(t, e1, n, r) {
                for (const { name: t, property: i, binding: s } of e1)this.binders[i].setUniform(s, r, n.get(i), t);
            }
            updatePaintBuffers(t) {
                this._buffers = [];
                for(const e1 in this.binders){
                    const n = this.binders[e1];
                    if (t && n instanceof Ca) {
                        const e1 = 2 === t.fromScale ? n.zoomInPaintVertexBuffer : n.zoomOutPaintVertexBuffer;
                        e1 && this._buffers.push(e1);
                    } else (n instanceof za || n instanceof Ba) && n.paintVertexBuffer && this._buffers.push(n.paintVertexBuffer);
                }
            }
            upload(t) {
                for(const e1 in this.binders){
                    const n = this.binders[e1];
                    (n instanceof za || n instanceof Ba || n instanceof Ca) && n.upload(t);
                }
                this.updatePaintBuffers();
            }
            destroy() {
                for(const t in this.binders){
                    const e1 = this.binders[t];
                    (e1 instanceof za || e1 instanceof Ba || e1 instanceof Ca) && e1.destroy();
                }
            }
        }
        class $a {
            constructor(t, e1, n = ()=>!0){
                this.programConfigurations = {};
                for (const r of t)this.programConfigurations[r.id] = new Oa(r, e1, n);
                this.needsUpload = !1, this._featureMap = new wa, this._bufferOffset = 0;
            }
            populatePaintArrays(t, e1, n, r) {
                for(const n in this.programConfigurations)this.programConfigurations[n].populatePaintArrays(t, e1, r);
                void 0 !== e1.id && this._featureMap.add(e1.id, n, this._bufferOffset, t), this._bufferOffset = t, this.needsUpload = !0;
            }
            updatePaintArrays(t, e1, n, r) {
                for (const i of n)this.needsUpload = this.programConfigurations[i.id].updatePaintArrays(t, this._featureMap, e1, i, r) || this.needsUpload;
            }
            get(t) {
                return this.programConfigurations[t];
            }
            upload(t) {
                if (this.needsUpload) {
                    for(const e1 in this.programConfigurations)this.programConfigurations[e1].upload(t);
                    this.needsUpload = !1;
                }
            }
            destroy() {
                for(const t in this.programConfigurations)this.programConfigurations[t].destroy();
            }
        }
        function Ra(t, e1) {
            return ({
                "text-opacity": [
                    "opacity"
                ],
                "icon-opacity": [
                    "opacity"
                ],
                "text-color": [
                    "fill_color"
                ],
                "icon-color": [
                    "fill_color"
                ],
                "text-halo-color": [
                    "halo_color"
                ],
                "icon-halo-color": [
                    "halo_color"
                ],
                "text-halo-blur": [
                    "halo_blur"
                ],
                "icon-halo-blur": [
                    "halo_blur"
                ],
                "text-halo-width": [
                    "halo_width"
                ],
                "icon-halo-width": [
                    "halo_width"
                ],
                "line-gap-width": [
                    "gapwidth"
                ],
                "line-dasharray": [
                    "dasharray_to",
                    "dasharray_from"
                ],
                "line-pattern": [
                    "pattern_to",
                    "pattern_from",
                    "pixel_ratio_to",
                    "pixel_ratio_from"
                ],
                "fill-pattern": [
                    "pattern_to",
                    "pattern_from",
                    "pixel_ratio_to",
                    "pixel_ratio_from"
                ],
                "fill-extrusion-pattern": [
                    "pattern_to",
                    "pattern_from",
                    "pixel_ratio_to",
                    "pixel_ratio_from"
                ]
            })[t] || [
                t.replace(`${e1}-`, "").replace(/-/g, "_")
            ];
        }
        function Na(t, e1, n) {
            const r = {
                color: {
                    source: yo,
                    composite: zo
                },
                number: {
                    source: Eo,
                    composite: yo
                }
            }, i = function(t) {
                return ({
                    "line-pattern": {
                        source: Jo,
                        composite: Jo
                    },
                    "fill-pattern": {
                        source: Jo,
                        composite: Jo
                    },
                    "fill-extrusion-pattern": {
                        source: Jo,
                        composite: Jo
                    },
                    "line-dasharray": {
                        source: Qo,
                        composite: Qo
                    }
                })[t];
            }(t);
            return (null == i ? void 0 : i[n]) || r[e1][n];
        }
        ds("ConstantBinder", Pa), ds("CrossFadedConstantBinder", Da), ds("SourceExpressionBinder", za), ds("CrossFadedPatternBinder", Va), ds("CrossFadedDasharrayBinder", La), ds("CompositeExpressionBinder", Ba), ds("ProgramConfiguration", Oa, {
            omit: [
                "_buffers"
            ]
        }), ds("ProgramConfigurationSet", $a);
        const Ua = Math.pow(2, 14) - 1, ja = -Ua - 1;
        function qa(t) {
            const e1 = T / t.extent, n = t.loadGeometry();
            for (const t of n)for (const n of t){
                const t = Math.round(n.x * e1), r = Math.round(n.y * e1);
                n.x = L(t, ja, Ua), n.y = L(r, ja, Ua), (t < n.x || t > n.x + 1 || r < n.y || r > n.y + 1) && G("Geometry exceeds allowed extent, reduce your vector tile buffer size");
            }
            return n;
        }
        function Ga(t, e1) {
            return {
                type: t.type,
                id: t.id,
                properties: t.properties,
                geometry: e1 ? qa(t) : []
            };
        }
        const Xa = -32768;
        function Ya(t, e1, n, r, i) {
            t.emplaceBack(Xa + 8 * e1 + r, Xa + 8 * n + i);
        }
        class Za {
            constructor(t){
                this.zoom = t.zoom, this.overscaling = t.overscaling, this.layers = t.layers, this.layerIds = this.layers.map((t)=>t.id), this.index = t.index, this.hasDependencies = !1, this.layoutVertexArray = new Yo, this.indexArray = new sa, this.segments = new ua, this.programConfigurations = new $a(t.layers, t.zoom), this.stateDependentLayerIds = this.layers.filter((t)=>t.isStateDependent()).map((t)=>t.id);
            }
            populate(t, e1, n) {
                const r = this.layers[0], i = [];
                let s = null, o = !1, a = "heatmap" === r.type;
                if ("circle" === r.type) {
                    const t = r;
                    s = t.layout.get("circle-sort-key"), o = !s.isConstant(), a || (a = "map" === t.paint.get("circle-pitch-alignment"));
                }
                const l = a ? e1.subdivisionGranularity.circle : 1;
                for (const { feature: e1, id: r, index: a, sourceLayerIndex: l } of t){
                    const t = this.layers[0]._featureFilter.needGeometry, u = Ga(e1, t);
                    if (!this.layers[0]._featureFilter.filter(new Cs(this.zoom), u, n)) continue;
                    const c = o ? s.evaluate(u, {}, n) : void 0, h = {
                        id: r,
                        properties: e1.properties,
                        type: e1.type,
                        sourceLayerIndex: l,
                        index: a,
                        geometry: t ? u.geometry : qa(e1),
                        patterns: {},
                        sortKey: c
                    };
                    i.push(h);
                }
                o && i.sort((t, e1)=>t.sortKey - e1.sortKey);
                for (const r of i){
                    const { geometry: i, index: s, sourceLayerIndex: o } = r, a = t[s].feature;
                    this.addFeature(r, i, s, n, l), e1.featureIndex.insert(a, i, s, o, this.index);
                }
            }
            update(t, e1, n) {
                this.stateDependentLayers.length && this.programConfigurations.updatePaintArrays(t, e1, this.stateDependentLayers, {
                    imagePositions: n
                });
            }
            isEmpty() {
                return 0 === this.layoutVertexArray.length;
            }
            uploadPending() {
                return !this.uploaded || this.programConfigurations.needsUpload;
            }
            upload(t) {
                this.uploaded || (this.layoutVertexBuffer = t.createVertexBuffer(this.layoutVertexArray, la), this.indexBuffer = t.createIndexBuffer(this.indexArray)), this.programConfigurations.upload(t), this.uploaded = !0;
            }
            destroy() {
                this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.programConfigurations.destroy(), this.segments.destroy());
            }
            addFeature(t, e1, n, r, i = 1) {
                let s;
                switch(i){
                    case 1:
                        s = [
                            0,
                            7
                        ];
                        break;
                    case 3:
                        s = [
                            0,
                            2,
                            5,
                            7
                        ];
                        break;
                    case 5:
                        s = [
                            0,
                            1,
                            3,
                            4,
                            6,
                            7
                        ];
                        break;
                    case 7:
                        s = [
                            0,
                            1,
                            2,
                            3,
                            4,
                            5,
                            6,
                            7
                        ];
                        break;
                    default:
                        throw new Error(`Invalid circle bucket granularity: ${i}; valid values are 1, 3, 5, 7.`);
                }
                const o = s.length;
                for (const n of e1)for (const e1 of n){
                    const n = e1.x, r = e1.y;
                    if (n < 0 || n >= T || r < 0 || r >= T) continue;
                    const i = this.segments.prepareSegment(o * o, this.layoutVertexArray, this.indexArray, t.sortKey), a = i.vertexLength;
                    for(let t = 0; t < o; t++)for(let e1 = 0; e1 < o; e1++)Ya(this.layoutVertexArray, n, r, s[e1], s[t]);
                    for(let t = 0; t < o - 1; t++)for(let e1 = 0; e1 < o - 1; e1++){
                        const n = a + t * o + e1, r = a + (t + 1) * o + e1;
                        this.indexArray.emplaceBack(n, r + 1, n + 1), this.indexArray.emplaceBack(n, r, r + 1);
                    }
                    i.vertexLength += o * o, i.primitiveLength += (o - 1) * (o - 1) * 2;
                }
                this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length, t, n, {
                    imagePositions: {},
                    canonical: r
                });
            }
        }
        function Ha(t, e1) {
            for (const n of t)if (il(e1, n)) return !0;
            for (const n of e1)if (il(t, n)) return !0;
            return Qa(t, e1);
        }
        function Wa(t, e1, n) {
            return !!il(t, e1) || el(e1, t, n);
        }
        function Ka(t, e1) {
            if (1 === t.length) return rl(e1, t[0]);
            for (const n of e1)for (const e1 of n)if (il(t, e1)) return !0;
            for (const n of t)if (rl(e1, n)) return !0;
            for (const n of e1)if (Qa(t, n)) return !0;
            return !1;
        }
        function Ja(t, e1, n) {
            if (t.length > 1) {
                if (Qa(t, e1)) return !0;
                for (const r of e1)if (el(r, t, n)) return !0;
            }
            for (const r of t)if (el(r, e1, n)) return !0;
            return !1;
        }
        function Qa(t, e1) {
            if (0 === t.length || 0 === e1.length) return !1;
            for(let n = 0; n < t.length - 1; n++){
                const r = t[n], i = t[n + 1];
                for(let t = 0; t < e1.length - 1; t++)if (tl(r, i, e1[t], e1[t + 1])) return !0;
            }
            return !1;
        }
        function tl(t, e1, n, r) {
            return X(t, n, r) !== X(e1, n, r) && X(t, e1, n) !== X(t, e1, r);
        }
        function el(t, e1, n) {
            const r = n * n;
            if (1 === e1.length) return t.distSqr(e1[0]) < r;
            for(let n = 1; n < e1.length; n++)if (nl(t, e1[n - 1], e1[n]) < r) return !0;
            return !1;
        }
        function nl(t, e1, n) {
            const r = e1.distSqr(n);
            if (0 === r) return t.distSqr(e1);
            const i = ((t.x - e1.x) * (n.x - e1.x) + (t.y - e1.y) * (n.y - e1.y)) / r;
            return t.distSqr(i < 0 ? e1 : i > 1 ? n : n.sub(e1)._mult(i)._add(e1));
        }
        function rl(t, e1) {
            let n, r, i, s = !1;
            for (const o of t){
                n = o;
                for(let t = 0, o = n.length - 1; t < n.length; o = t++)r = n[t], i = n[o], r.y > e1.y != i.y > e1.y && e1.x < (i.x - r.x) * (e1.y - r.y) / (i.y - r.y) + r.x && (s = !s);
            }
            return s;
        }
        function il(t, e1) {
            let n = !1;
            for(let r = 0, i = t.length - 1; r < t.length; i = r++){
                const s = t[r], o = t[i];
                s.y > e1.y != o.y > e1.y && e1.x < (o.x - s.x) * (e1.y - s.y) / (o.y - s.y) + s.x && (n = !n);
            }
            return n;
        }
        function sl(t, e1, n) {
            const r = n[0], i = n[2];
            if (t.x < r.x && e1.x < r.x || t.x > i.x && e1.x > i.x || t.y < r.y && e1.y < r.y || t.y > i.y && e1.y > i.y) return !1;
            const s = X(t, e1, n[0]);
            return s !== X(t, e1, n[1]) || s !== X(t, e1, n[2]) || s !== X(t, e1, n[3]);
        }
        function ol(t, e1, n) {
            const r = e1.paint.get(t).value;
            return "constant" === r.kind ? r.value : n.programConfigurations.get(e1.id).getMaxValue(t);
        }
        function al(t) {
            return Math.sqrt(t[0] * t[0] + t[1] * t[1]);
        }
        function ll(t, e1, r, i, s) {
            if (!e1[0] && !e1[1]) return t;
            const o = n.convert(e1)._mult(s);
            "viewport" === r && o._rotate(-i);
            const a = [];
            for (const e1 of t)a.push(e1.sub(o));
            return a;
        }
        function ul(t) {
            const e1 = [];
            for(let n = 0; n < t.length; n++){
                const r = t[n], i = e1.at(-1);
                (0 === n || i && !r.equals(i)) && e1.push(r);
            }
            return e1;
        }
        function cl({ queryGeometry: t, size: e1 }, n) {
            return Wa(t, n, e1);
        }
        function hl({ queryGeometry: t, size: e1, transform: n, unwrappedTileID: r, getElevation: i }, s) {
            return Wa(t, s, e1 * (n.projectTileCoordinates(s.x, s.y, r, i).signedDistanceFromCamera / n.cameraToCenterDistance));
        }
        function pl({ queryGeometry: t, size: e1, transform: n, unwrappedTileID: r, getElevation: i }, s) {
            const o = n.projectTileCoordinates(s.x, s.y, r, i).signedDistanceFromCamera, a = e1 * (n.cameraToCenterDistance / o);
            return Wa(t, yl(s, n, r, i), a);
        }
        function fl({ queryGeometry: t, size: e1, transform: n, unwrappedTileID: r, getElevation: i }, s) {
            return Wa(t, yl(s, n, r, i), e1);
        }
        function dl({ queryGeometry: t, size: e1, transform: n, unwrappedTileID: r, getElevation: i, pitchAlignment: s = "map", pitchScale: o = "map" }, a) {
            const l = "map" === s ? "map" === o ? cl : hl : "map" === o ? pl : fl, u = {
                queryGeometry: t,
                size: e1,
                transform: n,
                unwrappedTileID: r,
                getElevation: i
            };
            for (const t of a)for (const e1 of t)if (l(u, e1)) return !0;
            return !1;
        }
        function yl(t, e1, r, i) {
            const s = e1.projectTileCoordinates(t.x, t.y, r, i).point;
            return new n((.5 * s.x + .5) * e1.width, (.5 * -s.y + .5) * e1.height);
        }
        let ml, gl;
        ds("CircleBucket", Za, {
            omit: [
                "layers"
            ]
        });
        var xl = {
            get paint () {
                return gl = gl || new Ks({
                    "circle-radius": new Ys(wt.paint_circle["circle-radius"]),
                    "circle-color": new Ys(wt.paint_circle["circle-color"]),
                    "circle-blur": new Ys(wt.paint_circle["circle-blur"]),
                    "circle-opacity": new Ys(wt.paint_circle["circle-opacity"]),
                    "circle-translate": new Xs(wt.paint_circle["circle-translate"]),
                    "circle-translate-anchor": new Xs(wt.paint_circle["circle-translate-anchor"]),
                    "circle-pitch-scale": new Xs(wt.paint_circle["circle-pitch-scale"]),
                    "circle-pitch-alignment": new Xs(wt.paint_circle["circle-pitch-alignment"]),
                    "circle-stroke-width": new Ys(wt.paint_circle["circle-stroke-width"]),
                    "circle-stroke-color": new Ys(wt.paint_circle["circle-stroke-color"]),
                    "circle-stroke-opacity": new Ys(wt.paint_circle["circle-stroke-opacity"])
                });
            },
            get layout () {
                return ml = ml || new Ks({
                    "circle-sort-key": new Ys(wt.layout_circle["circle-sort-key"])
                });
            }
        };
        class vl extends to {
            constructor(t, e1){
                super(t, xl, e1);
            }
            createBucket(t) {
                return new Za(t);
            }
            queryRadius(t) {
                const e1 = t;
                return ol("circle-radius", this, e1) + ol("circle-stroke-width", this, e1) + al(this.paint.get("circle-translate"));
            }
            queryIntersectsFeature({ queryGeometry: t, feature: e1, featureState: n, geometry: r, transform: i, pixelsToTileUnits: s, unwrappedTileID: o, getElevation: a }) {
                const l = ll(t, this.paint.get("circle-translate"), this.paint.get("circle-translate-anchor"), -i.bearingInRadians, s), u = this.paint.get("circle-radius").evaluate(e1, n) + this.paint.get("circle-stroke-width").evaluate(e1, n), c = this.paint.get("circle-pitch-scale"), h = this.paint.get("circle-pitch-alignment");
                let p, f;
                return "map" === h ? (p = l, f = u * s) : (p = function(t, e1, n, r) {
                    return t.map((t)=>yl(t, e1, n, r));
                }(l, i, o, a), f = u), dl({
                    queryGeometry: p,
                    size: f,
                    transform: i,
                    unwrappedTileID: o,
                    getElevation: a,
                    pitchAlignment: h,
                    pitchScale: c
                }, r);
            }
        }
        class bl extends Za {
        }
        let wl;
        ds("HeatmapBucket", bl, {
            omit: [
                "layers"
            ]
        });
        var _l = {
            get paint () {
                return wl = wl || new Ks({
                    "heatmap-radius": new Ys(wt.paint_heatmap["heatmap-radius"]),
                    "heatmap-weight": new Ys(wt.paint_heatmap["heatmap-weight"]),
                    "heatmap-intensity": new Xs(wt.paint_heatmap["heatmap-intensity"]),
                    "heatmap-color": new Ws(wt.paint_heatmap["heatmap-color"]),
                    "heatmap-opacity": new Xs(wt.paint_heatmap["heatmap-opacity"])
                });
            }
        };
        function Sl(t, { width: e1, height: n }, r, i) {
            if (i) {
                if (i instanceof Uint8ClampedArray) i = new Uint8Array(i.buffer);
                else if (i.length !== e1 * n * r) throw new RangeError(`mismatched image size. expected: ${i.length} but got: ${e1 * n * r}`);
            } else i = new Uint8Array(e1 * n * r);
            return t.width = e1, t.height = n, t.data = i, t;
        }
        function Al(t, { width: e1, height: n }, r) {
            if (e1 === t.width && n === t.height) return;
            const i = Sl({}, {
                width: e1,
                height: n
            }, r);
            Ml(t, i, {
                x: 0,
                y: 0
            }, {
                x: 0,
                y: 0
            }, {
                width: Math.min(t.width, e1),
                height: Math.min(t.height, n)
            }, r), t.width = e1, t.height = n, t.data = i.data;
        }
        function Ml(t, e1, n, r, i, s) {
            if (0 === i.width || 0 === i.height) return e1;
            if (i.width > t.width || i.height > t.height || n.x > t.width - i.width || n.y > t.height - i.height) throw new RangeError("out of range source coordinates for image copy");
            if (i.width > e1.width || i.height > e1.height || r.x > e1.width - i.width || r.y > e1.height - i.height) throw new RangeError("out of range destination coordinates for image copy");
            const o = t.data, a = e1.data;
            if (o === a) throw new Error("srcData equals dstData, so image is already copied");
            for(let l = 0; l < i.height; l++){
                const u = ((n.y + l) * t.width + n.x) * s, c = ((r.y + l) * e1.width + r.x) * s;
                for(let t = 0; t < i.width * s; t++)a[c + t] = o[u + t];
            }
            return e1;
        }
        class kl {
            constructor(t, e1){
                Sl(this, t, 1, e1);
            }
            resize(t) {
                Al(this, t, 1);
            }
            clone() {
                return new kl({
                    width: this.width,
                    height: this.height
                }, new Uint8Array(this.data));
            }
            static copy(t, e1, n, r, i) {
                Ml(t, e1, n, r, i, 1);
            }
        }
        class Il {
            constructor(t, e1){
                Sl(this, t, 4, e1);
            }
            resize(t) {
                Al(this, t, 4);
            }
            replace(t, e1) {
                e1 ? this.data.set(t) : this.data = t instanceof Uint8ClampedArray ? new Uint8Array(t.buffer) : t;
            }
            clone() {
                return new Il({
                    width: this.width,
                    height: this.height
                }, new Uint8Array(this.data));
            }
            static copy(t, e1, n, r, i) {
                Ml(t, e1, n, r, i, 4);
            }
            setPixel(t, e1, n) {
                const r = 4 * (t * this.width + e1);
                this.data[r + 0] = Math.round(255 * n.r / n.a), this.data[r + 1] = Math.round(255 * n.g / n.a), this.data[r + 2] = Math.round(255 * n.b / n.a), this.data[r + 3] = Math.round(255 * n.a);
            }
        }
        function El(t) {
            const e1 = new Uint8Array(t.length);
            for(let n = 0; n < t.length; n += 4){
                const r = t[n + 3];
                e1[n + 0] = Math.round(t[n + 0] * r / 255), e1[n + 1] = Math.round(t[n + 1] * r / 255), e1[n + 2] = Math.round(t[n + 2] * r / 255), e1[n + 3] = r;
            }
            return e1;
        }
        function Tl(t) {
            const e1 = {}, n = t.resolution || 256, r = t.clips ? t.clips.length : 1, i = t.image || new Il({
                width: n,
                height: r
            });
            if (Math.log(n) / Math.LN2 % 1 != 0) throw new Error(`width is not a power of 2 - ${n}`);
            const s = (r, s, o)=>{
                e1[t.evaluationKey] = o;
                const a = t.expression.evaluate(e1);
                i.setPixel(r / 4 / n, s / 4, a);
            };
            if (t.clips) for(let e1 = 0, i = 0; e1 < r; ++e1, i += 4 * n)for(let r = 0, o = 0; r < n; r++, o += 4){
                const a = r / (n - 1), { start: l, end: u } = t.clips[e1];
                s(i, o, l * (1 - a) + u * a);
            }
            else for(let t = 0, e1 = 0; t < n; t++, e1 += 4)s(0, e1, t / (n - 1));
            return i;
        }
        ds("AlphaImage", kl), ds("RGBAImage", Il);
        const Fl = "big-fb";
        class Pl extends to {
            createBucket(t) {
                return new bl(t);
            }
            constructor(t, e1){
                super(t, _l, e1), this.heatmapFbos = new Map, this._updateColorRamp();
            }
            _handleSpecialPaintPropertyUpdate(t) {
                "heatmap-color" === t && this._updateColorRamp();
            }
            _updateColorRamp() {
                this.colorRamp = Tl({
                    expression: this._transitionablePaint._values["heatmap-color"].value.expression,
                    evaluationKey: "heatmapDensity",
                    image: this.colorRamp
                }), this.colorRampTexture = null;
            }
            resize() {
                this.heatmapFbos.has(Fl) && this.heatmapFbos.delete(Fl);
            }
            queryRadius(t) {
                return ol("heatmap-radius", this, t);
            }
            queryIntersectsFeature({ queryGeometry: t, feature: e1, featureState: n, geometry: r, transform: i, pixelsToTileUnits: s, unwrappedTileID: o, getElevation: a }) {
                return dl({
                    queryGeometry: t,
                    size: this.paint.get("heatmap-radius").evaluate(e1, n) * s,
                    transform: i,
                    unwrappedTileID: o,
                    getElevation: a
                }, r);
            }
            hasOffscreenPass() {
                return 0 !== this.paint.get("heatmap-opacity") && !this.isHidden();
            }
        }
        let Dl;
        var zl = {
            get paint () {
                return Dl = Dl || new Ks({
                    "hillshade-illumination-direction": new Xs(wt.paint_hillshade["hillshade-illumination-direction"]),
                    "hillshade-illumination-altitude": new Xs(wt.paint_hillshade["hillshade-illumination-altitude"]),
                    "hillshade-illumination-anchor": new Xs(wt.paint_hillshade["hillshade-illumination-anchor"]),
                    "hillshade-exaggeration": new Xs(wt.paint_hillshade["hillshade-exaggeration"]),
                    "hillshade-shadow-color": new Xs(wt.paint_hillshade["hillshade-shadow-color"]),
                    "hillshade-highlight-color": new Xs(wt.paint_hillshade["hillshade-highlight-color"]),
                    "hillshade-accent-color": new Xs(wt.paint_hillshade["hillshade-accent-color"]),
                    "hillshade-method": new Xs(wt.paint_hillshade["hillshade-method"]),
                    resampling: new Xs(wt.paint_hillshade.resampling)
                });
            }
        };
        class Bl extends to {
            constructor(t, e1){
                super(t, zl, e1), this.recalculate({
                    zoom: 0,
                    zoomHistory: {}
                }, void 0);
            }
            getIlluminationProperties() {
                let t = this.paint.get("hillshade-illumination-direction").values, e1 = this.paint.get("hillshade-illumination-altitude").values, n = this.paint.get("hillshade-highlight-color").values, r = this.paint.get("hillshade-shadow-color").values;
                const i = Math.max(t.length, e1.length, n.length, r.length);
                t = t.concat(Array(i - t.length).fill(t.at(-1))), e1 = e1.concat(Array(i - e1.length).fill(e1.at(-1))), n = n.concat(Array(i - n.length).fill(n.at(-1))), r = r.concat(Array(i - r.length).fill(r.at(-1)));
                const s = e1.map(et);
                return {
                    directionRadians: t.map(et),
                    altitudeRadians: s,
                    shadowColor: r,
                    highlightColor: n
                };
            }
            hasOffscreenPass() {
                return 0 !== this.paint.get("hillshade-exaggeration") && !this.isHidden();
            }
        }
        let Cl;
        var Vl = {
            get paint () {
                return Cl = Cl || new Ks({
                    "color-relief-opacity": new Xs(wt["paint_color-relief"]["color-relief-opacity"]),
                    "color-relief-color": new Ws(wt["paint_color-relief"]["color-relief-color"]),
                    resampling: new Xs(wt["paint_color-relief"].resampling)
                });
            }
        };
        function Ll(t) {
            return "data" in t;
        }
        class Ol {
            constructor(t, e1, n, r){
                this.context = t, this.format = n, this.texture = t.gl.createTexture(), this._ownedHandle = this.texture, this.update(e1, r);
            }
            update(t, e1, n) {
                var r;
                const { width: i, height: s } = t, o = ((null === (r = this.size) || void 0 === r ? void 0 : r[0]) !== i || this.size[1] !== s) && !n, { context: a } = this, { gl: l } = a;
                this.useMipmap = Boolean(null == e1 ? void 0 : e1.useMipmap), l.bindTexture(l.TEXTURE_2D, this.texture), a.pixelStoreUnpackFlipY.set(!1), a.pixelStoreUnpack.set(1);
                const u = this.format === l.RGBA && !1 !== (null == e1 ? void 0 : e1.premultiply);
                if (o) this.size = [
                    i,
                    s
                ], Ll(t) ? (a.pixelStoreUnpackPremultiplyAlpha.set(!1), this._uploadRawData(t, u, i, s, l)) : (a.pixelStoreUnpackPremultiplyAlpha.set(u), this._uploadDomImage(t, l));
                else {
                    const { x: e1, y: r } = n || {
                        x: 0,
                        y: 0
                    };
                    Ll(t) ? (a.pixelStoreUnpackPremultiplyAlpha.set(!1), this._updateRawData(t, u, e1, r, i, s, l)) : (a.pixelStoreUnpackPremultiplyAlpha.set(u), this._updateDomImage(t, e1, r, l));
                }
                this.useMipmap && this.isSizePowerOfTwo() && l.generateMipmap(l.TEXTURE_2D), a.pixelStoreUnpackFlipY.setDefault(), a.pixelStoreUnpack.setDefault(), a.pixelStoreUnpackPremultiplyAlpha.setDefault();
            }
            _uploadDomImage(t, e1) {
                e1.texImage2D(e1.TEXTURE_2D, 0, this.format, this.format, e1.UNSIGNED_BYTE, t);
            }
            _uploadRawData(t, e1, n, r, i) {
                let { data: s } = t;
                e1 && s && (s = El(s)), i.texImage2D(i.TEXTURE_2D, 0, this.format, n, r, 0, this.format, i.UNSIGNED_BYTE, s);
            }
            _updateDomImage(t, e1, n, r) {
                r.texSubImage2D(r.TEXTURE_2D, 0, e1, n, r.RGBA, r.UNSIGNED_BYTE, t);
            }
            _updateRawData(t, e1, n, r, i, s, o) {
                let { data: a } = t;
                e1 && a && (a = El(a)), o.texSubImage2D(o.TEXTURE_2D, 0, n, r, i, s, o.RGBA, o.UNSIGNED_BYTE, a);
            }
            bind(t, e1, n) {
                const { context: r } = this, { gl: i } = r;
                this.texture !== this._ownedHandle && (this.texture = this._ownedHandle), i.bindTexture(i.TEXTURE_2D, this.texture), n !== i.LINEAR_MIPMAP_NEAREST || this.isSizePowerOfTwo() || (n = i.LINEAR), t !== this.filter && (i.texParameteri(i.TEXTURE_2D, i.TEXTURE_MAG_FILTER, t), i.texParameteri(i.TEXTURE_2D, i.TEXTURE_MIN_FILTER, n || t), this.filter = t), e1 !== this.wrap && (i.texParameteri(i.TEXTURE_2D, i.TEXTURE_WRAP_S, e1), i.texParameteri(i.TEXTURE_2D, i.TEXTURE_WRAP_T, e1), this.wrap = e1);
            }
            isSizePowerOfTwo() {
                return this.size[0] === this.size[1] && Math.log(this.size[0]) / Math.LN2 % 1 == 0;
            }
            destroy() {
                const { gl: t } = this.context;
                t.deleteTexture(this.texture), this.texture = null, this._ownedHandle = null;
            }
        }
        class $l {
            constructor(t, e1, n, r = 1, i = 1, s = 1, o = 0){
                if (this.uid = t, e1.height !== e1.width) throw new RangeError("DEM tiles must be square");
                if (n && ![
                    "mapbox",
                    "terrarium",
                    "custom"
                ].includes(n)) return void G(`"${n}" is not a valid encoding type. Valid types include "mapbox", "terrarium" and "custom".`);
                this.stride = e1.height;
                const a = this.dim = e1.height - 2;
                switch(this.data = new Uint32Array(e1.data.buffer), n){
                    case "terrarium":
                        this.redFactor = 256, this.greenFactor = 1, this.blueFactor = 1 / 256, this.baseShift = 32768;
                        break;
                    case "custom":
                        this.redFactor = r, this.greenFactor = i, this.blueFactor = s, this.baseShift = o;
                        break;
                    default:
                        this.redFactor = 6553.6, this.greenFactor = 25.6, this.blueFactor = .1, this.baseShift = 1e4;
                }
                for(let t = 0; t < a; t++)this.data[this._idx(-1, t)] = this.data[this._idx(0, t)], this.data[this._idx(a, t)] = this.data[this._idx(a - 1, t)], this.data[this._idx(t, -1)] = this.data[this._idx(t, 0)], this.data[this._idx(t, a)] = this.data[this._idx(t, a - 1)];
                this.data[this._idx(-1, -1)] = this.data[this._idx(0, 0)], this.data[this._idx(a, -1)] = this.data[this._idx(a - 1, 0)], this.data[this._idx(-1, a)] = this.data[this._idx(0, a - 1)], this.data[this._idx(a, a)] = this.data[this._idx(a - 1, a - 1)], this.min = Number.MAX_SAFE_INTEGER, this.max = Number.MIN_SAFE_INTEGER;
                for(let t = 0; t < a; t++)for(let e1 = 0; e1 < a; e1++){
                    const n = this.get(t, e1);
                    n > this.max && (this.max = n), n < this.min && (this.min = n);
                }
            }
            get(t, e1) {
                const n = new Uint8Array(this.data.buffer), r = 4 * this._idx(t, e1);
                return this.unpack(n[r], n[r + 1], n[r + 2]);
            }
            getUnpackVector() {
                return [
                    this.redFactor,
                    this.greenFactor,
                    this.blueFactor,
                    this.baseShift
                ];
            }
            _idx(t, e1) {
                if (t < -1 || t >= this.dim + 1 || e1 < -1 || e1 >= this.dim + 1) throw new RangeError(`Out of range source coordinates for DEM data. x: ${t}, y: ${e1}, dim: ${this.dim}`);
                return (e1 + 1) * this.stride + (t + 1);
            }
            unpack(t, e1, n) {
                return t * this.redFactor + e1 * this.greenFactor + n * this.blueFactor - this.baseShift;
            }
            pack(t) {
                return Rl(t, this.getUnpackVector());
            }
            getPixels() {
                return new Il({
                    width: this.stride,
                    height: this.stride
                }, new Uint8Array(this.data.buffer));
            }
            backfillBorder(t, e1, n) {
                if (this.dim !== t.dim) throw new Error("dem dimension mismatch");
                let r = e1 * this.dim, i = e1 * this.dim + this.dim, s = n * this.dim, o = n * this.dim + this.dim;
                switch(e1){
                    case -1:
                        r = i - 1;
                        break;
                    case 1:
                        i = r + 1;
                }
                switch(n){
                    case -1:
                        s = o - 1;
                        break;
                    case 1:
                        o = s + 1;
                }
                const a = -e1 * this.dim, l = -n * this.dim;
                for(let e1 = s; e1 < o; e1++)for(let n = r; n < i; n++)this.data[this._idx(n, e1)] = t.data[this._idx(n + a, e1 + l)];
            }
        }
        function Rl(t, e1) {
            const n = e1[0], r = e1[1], i = e1[2], s = e1[3], o = Math.min(n, r, i), a = Math.round((t + s) / o);
            return {
                r: Math.floor(a * o / n) % 256,
                g: Math.floor(a * o / r) % 256,
                b: Math.floor(a * o / i) % 256
            };
        }
        ds("DEMData", $l);
        class Nl extends to {
            constructor(t, e1){
                super(t, Vl, e1);
            }
            _createColorRamp(t) {
                const e1 = {
                    elevationStops: [],
                    colorStops: []
                }, n = this._transitionablePaint._values["color-relief-color"].value.expression;
                if (n instanceof oi && n._styleExpression.expression instanceof mn) {
                    this.colorRampExpression = n;
                    const t = n._styleExpression.expression;
                    e1.elevationStops = t.labels, e1.colorStops = [];
                    for (const n of e1.elevationStops)e1.colorStops.push(t.evaluate({
                        globals: {
                            elevation: n
                        }
                    }));
                }
                if (e1.elevationStops.length < 1 && (e1.elevationStops = [
                    0
                ], e1.colorStops = [
                    Te.transparent
                ]), e1.elevationStops.length < 2 && (e1.elevationStops.push(e1.elevationStops[0] + 1), e1.colorStops.push(e1.colorStops[0])), e1.elevationStops.length <= t) return e1;
                const r = {
                    elevationStops: [],
                    colorStops: []
                }, i = (e1.elevationStops.length - 1) / (t - 1);
                for(let t = 0; t < e1.elevationStops.length - .5; t += i)r.elevationStops.push(e1.elevationStops[Math.round(t)]), r.colorStops.push(e1.colorStops[Math.round(t)]);
                return G(`Too many colors in specification of ${this.id} color-relief layer, may not render properly. Max possible colors: ${t}, provided: ${e1.elevationStops.length}`), r;
            }
            _colorRampChanged() {
                return this.colorRampExpression != this._transitionablePaint._values["color-relief-color"].value.expression;
            }
            getColorRampTextures(t, e1, n) {
                if (this.colorRampTextures && !this._colorRampChanged()) return this.colorRampTextures;
                const r = this._createColorRamp(e1), i = new Il({
                    width: r.colorStops.length,
                    height: 1
                }), s = new Il({
                    width: r.colorStops.length,
                    height: 1
                });
                for(let t = 0; t < r.elevationStops.length; t++){
                    const e1 = Rl(r.elevationStops[t], n);
                    s.setPixel(0, t, new Te(e1.r / 255, e1.g / 255, e1.b / 255, 1)), i.setPixel(0, t, r.colorStops[t]);
                }
                return this.colorRampTextures = {
                    elevationTexture: new Ol(t, s, t.gl.RGBA),
                    colorTexture: new Ol(t, i, t.gl.RGBA)
                }, this.colorRampTextures;
            }
            hasOffscreenPass() {
                return !this.isHidden() && !!this.colorRampTextures;
            }
        }
        const Ul = ao([
            {
                name: "a_pos",
                components: 2,
                type: "Int16"
            }
        ], 4), { members: jl } = Ul;
        function ql(t, e1, n) {
            const r = n.patternDependencies;
            let i = !1;
            for (const n of e1){
                const e1 = n.paint.get(`${t}-pattern`);
                e1.isConstant() || (i = !0);
                const s = e1.constantOr(null);
                s && (i = !0, r[s.to] = !0, r[s.from] = !0);
            }
            return i;
        }
        function Gl(t, e1, n, r, i) {
            const { zoom: s } = r, o = i.patternDependencies;
            for (const r of e1){
                const e1 = r.paint.get(`${t}-pattern`).value;
                if ("constant" !== e1.kind) {
                    let t = e1.evaluate({
                        zoom: s - 1
                    }, n, {}, i.availableImages), a = e1.evaluate({
                        zoom: s
                    }, n, {}, i.availableImages), l = e1.evaluate({
                        zoom: s + 1
                    }, n, {}, i.availableImages);
                    t = (null == t ? void 0 : t.name) ? t.name : t, a = (null == a ? void 0 : a.name) ? a.name : a, l = (null == l ? void 0 : l.name) ? l.name : l, o[t] = !0, o[a] = !0, o[l] = !0, n.patterns[r.id] = {
                        min: t,
                        mid: a,
                        max: l
                    };
                }
            }
            return n;
        }
        function Xl(t, e1, n, r, i) {
            let s;
            if (i === function(t, e1, n, r) {
                let i = 0;
                for(let s = e1, o = n - r; s < n; s += r)i += (t[o] - t[s]) * (t[s + 1] + t[o + 1]), o = s;
                return i;
            }(t, e1, n, r) > 0) for(let i = e1; i < n; i += r)s = du(i / r | 0, t[i], t[i + 1], s);
            else for(let i = n - r; i >= e1; i -= r)s = du(i / r | 0, t[i], t[i + 1], s);
            return s && lu(s, s.next) && (yu(s), s = s.next), s;
        }
        function Yl(t, e1) {
            if (!t) return t;
            e1 || (e1 = t);
            let n, r = t;
            do if (n = !1, r.steiner || !lu(r, r.next) && 0 !== au(r.prev, r, r.next)) r = r.next;
            else {
                if (yu(r), r = e1 = r.prev, r === r.next) break;
                n = !0;
            }
            while (n || r !== e1);
            return e1;
        }
        function Zl(t, e1, n, r, i, s, o) {
            if (!t) return;
            !o && s && function(t, e1, n, r) {
                let i = t;
                do 0 === i.z && (i.z = nu(i.x, i.y, e1, n, r)), i.prevZ = i.prev, i.nextZ = i.next, i = i.next;
                while (i !== t);
                i.prevZ.nextZ = null, i.prevZ = null, function(t) {
                    let e1, n = 1;
                    do {
                        let r, i = t;
                        t = null;
                        let s = null;
                        for(e1 = 0; i;){
                            e1++;
                            let o = i, a = 0;
                            for(let t = 0; t < n && (a++, o = o.nextZ, o); t++);
                            let l = n;
                            for(; a > 0 || l > 0 && o;)0 !== a && (0 === l || !o || i.z <= o.z) ? (r = i, i = i.nextZ, a--) : (r = o, o = o.nextZ, l--), s ? s.nextZ = r : t = r, r.prevZ = s, s = r;
                            i = o;
                        }
                        s.nextZ = null, n *= 2;
                    }while (e1 > 1);
                }(i);
            }(t, r, i, s);
            let a = t;
            for(; t.prev !== t.next;){
                const l = t.prev, u = t.next;
                if (s ? Wl(t, r, i, s) : Hl(t)) e1.push(l.i, t.i, u.i), yu(t), t = u.next, a = u.next;
                else if ((t = u) === a) {
                    o ? 1 === o ? Zl(t = Kl(Yl(t), e1), e1, n, r, i, s, 2) : 2 === o && Jl(t, e1, n, r, i, s) : Zl(Yl(t), e1, n, r, i, s, 1);
                    break;
                }
            }
        }
        function Hl(t) {
            const e1 = t.prev, n = t, r = t.next;
            if (au(e1, n, r) >= 0) return !1;
            const i = e1.x, s = n.x, o = r.x, a = e1.y, l = n.y, u = r.y, c = Math.min(i, s, o), h = Math.min(a, l, u), p = Math.max(i, s, o), f = Math.max(a, l, u);
            let d = r.next;
            for(; d !== e1;){
                if (d.x >= c && d.x <= p && d.y >= h && d.y <= f && su(i, a, s, l, o, u, d.x, d.y) && au(d.prev, d, d.next) >= 0) return !1;
                d = d.next;
            }
            return !0;
        }
        function Wl(t, e1, n, r) {
            const i = t.prev, s = t, o = t.next;
            if (au(i, s, o) >= 0) return !1;
            const a = i.x, l = s.x, u = o.x, c = i.y, h = s.y, p = o.y, f = Math.min(a, l, u), d = Math.min(c, h, p), y = Math.max(a, l, u), m = Math.max(c, h, p), g = nu(f, d, e1, n, r), x = nu(y, m, e1, n, r);
            let v = t.prevZ, b = t.nextZ;
            for(; v && v.z >= g && b && b.z <= x;){
                if (v.x >= f && v.x <= y && v.y >= d && v.y <= m && v !== i && v !== o && su(a, c, l, h, u, p, v.x, v.y) && au(v.prev, v, v.next) >= 0) return !1;
                if (v = v.prevZ, b.x >= f && b.x <= y && b.y >= d && b.y <= m && b !== i && b !== o && su(a, c, l, h, u, p, b.x, b.y) && au(b.prev, b, b.next) >= 0) return !1;
                b = b.nextZ;
            }
            for(; v && v.z >= g;){
                if (v.x >= f && v.x <= y && v.y >= d && v.y <= m && v !== i && v !== o && su(a, c, l, h, u, p, v.x, v.y) && au(v.prev, v, v.next) >= 0) return !1;
                v = v.prevZ;
            }
            for(; b && b.z <= x;){
                if (b.x >= f && b.x <= y && b.y >= d && b.y <= m && b !== i && b !== o && su(a, c, l, h, u, p, b.x, b.y) && au(b.prev, b, b.next) >= 0) return !1;
                b = b.nextZ;
            }
            return !0;
        }
        function Kl(t, e1) {
            let n = t;
            do {
                const r = n.prev, i = n.next.next;
                !lu(r, i) && uu(r, n, n.next, i) && pu(r, i) && pu(i, r) && (e1.push(r.i, n.i, i.i), yu(n), yu(n.next), n = t = i), n = n.next;
            }while (n !== t);
            return Yl(n);
        }
        function Jl(t, e1, n, r, i, s) {
            let o = t;
            do {
                let t = o.next.next;
                for(; t !== o.prev;){
                    if (o.i !== t.i && ou(o, t)) {
                        let a = fu(o, t);
                        return o = Yl(o, o.next), a = Yl(a, a.next), Zl(o, e1, n, r, i, s, 0), void Zl(a, e1, n, r, i, s, 0);
                    }
                    t = t.next;
                }
                o = o.next;
            }while (o !== t);
        }
        function Ql(t, e1) {
            let n = t.x - e1.x;
            return 0 === n && (n = t.y - e1.y, 0 === n) && (n = (t.next.y - t.y) / (t.next.x - t.x) - (e1.next.y - e1.y) / (e1.next.x - e1.x)), n;
        }
        function tu(t, e1) {
            const n = function(t, e1) {
                let n = e1;
                const r = t.x, i = t.y;
                let s, o = -1 / 0;
                if (lu(t, n)) return n;
                do {
                    if (lu(t, n.next)) return n.next;
                    if (i <= n.y && i >= n.next.y && n.next.y !== n.y) {
                        const t = n.x + (i - n.y) * (n.next.x - n.x) / (n.next.y - n.y);
                        if (t <= r && t > o && (o = t, s = n.x < n.next.x ? n : n.next, t === r)) return s;
                    }
                    n = n.next;
                }while (n !== e1);
                if (!s) return null;
                const a = s, l = s.x, u = s.y;
                let c = 1 / 0;
                n = s;
                do {
                    if (r >= n.x && n.x >= l && r !== n.x && iu(i < u ? r : o, i, l, u, i < u ? o : r, i, n.x, n.y)) {
                        const e1 = Math.abs(i - n.y) / (r - n.x);
                        pu(n, t) && (e1 < c || e1 === c && (n.x > s.x || n.x === s.x && eu(s, n))) && (s = n, c = e1);
                    }
                    n = n.next;
                }while (n !== a);
                return s;
            }(t, e1);
            if (!n) return e1;
            const r = fu(n, t);
            return Yl(r, r.next), Yl(n, n.next);
        }
        function eu(t, e1) {
            return au(t.prev, t, e1.prev) < 0 && au(e1.next, t, t.next) < 0;
        }
        function nu(t, e1, n, r, i) {
            return (t = 1431655765 & ((t = 858993459 & ((t = 252645135 & ((t = 16711935 & ((t = (t - n) * i | 0) | t << 8)) | t << 4)) | t << 2)) | t << 1)) | (e1 = 1431655765 & ((e1 = 858993459 & ((e1 = 252645135 & ((e1 = 16711935 & ((e1 = (e1 - r) * i | 0) | e1 << 8)) | e1 << 4)) | e1 << 2)) | e1 << 1)) << 1;
        }
        function ru(t) {
            let e1 = t, n = t;
            do (e1.x < n.x || e1.x === n.x && e1.y < n.y) && (n = e1), e1 = e1.next;
            while (e1 !== t);
            return n;
        }
        function iu(t, e1, n, r, i, s, o, a) {
            return (i - o) * (e1 - a) >= (t - o) * (s - a) && (t - o) * (r - a) >= (n - o) * (e1 - a) && (n - o) * (s - a) >= (i - o) * (r - a);
        }
        function su(t, e1, n, r, i, s, o, a) {
            return !(t === o && e1 === a) && iu(t, e1, n, r, i, s, o, a);
        }
        function ou(t, e1) {
            return t.next.i !== e1.i && t.prev.i !== e1.i && !function(t, e1) {
                let n = t;
                do {
                    if (n.i !== t.i && n.next.i !== t.i && n.i !== e1.i && n.next.i !== e1.i && uu(n, n.next, t, e1)) return !0;
                    n = n.next;
                }while (n !== t);
                return !1;
            }(t, e1) && (pu(t, e1) && pu(e1, t) && function(t, e1) {
                let n = t, r = !1;
                const i = (t.x + e1.x) / 2, s = (t.y + e1.y) / 2;
                do n.y > s != n.next.y > s && n.next.y !== n.y && i < (n.next.x - n.x) * (s - n.y) / (n.next.y - n.y) + n.x && (r = !r), n = n.next;
                while (n !== t);
                return r;
            }(t, e1) && (au(t.prev, t, e1.prev) || au(t, e1.prev, e1)) || lu(t, e1) && au(t.prev, t, t.next) > 0 && au(e1.prev, e1, e1.next) > 0);
        }
        function au(t, e1, n) {
            return (e1.y - t.y) * (n.x - e1.x) - (e1.x - t.x) * (n.y - e1.y);
        }
        function lu(t, e1) {
            return t.x === e1.x && t.y === e1.y;
        }
        function uu(t, e1, n, r) {
            const i = hu(au(t, e1, n)), s = hu(au(t, e1, r)), o = hu(au(n, r, t)), a = hu(au(n, r, e1));
            return i !== s && o !== a || !(0 !== i || !cu(t, n, e1)) || !(0 !== s || !cu(t, r, e1)) || !(0 !== o || !cu(n, t, r)) || !(0 !== a || !cu(n, e1, r));
        }
        function cu(t, e1, n) {
            return e1.x <= Math.max(t.x, n.x) && e1.x >= Math.min(t.x, n.x) && e1.y <= Math.max(t.y, n.y) && e1.y >= Math.min(t.y, n.y);
        }
        function hu(t) {
            return t > 0 ? 1 : t < 0 ? -1 : 0;
        }
        function pu(t, e1) {
            return au(t.prev, t, t.next) < 0 ? au(t, e1, t.next) >= 0 && au(t, t.prev, e1) >= 0 : au(t, e1, t.prev) < 0 || au(t, t.next, e1) < 0;
        }
        function fu(t, e1) {
            const n = mu(t.i, t.x, t.y), r = mu(e1.i, e1.x, e1.y), i = t.next, s = e1.prev;
            return t.next = e1, e1.prev = t, n.next = i, i.prev = n, r.next = n, n.prev = r, s.next = r, r.prev = s, r;
        }
        function du(t, e1, n, r) {
            const i = mu(t, e1, n);
            return r ? (i.next = r.next, i.prev = r, r.next.prev = i, r.next = i) : (i.prev = i, i.next = i), i;
        }
        function yu(t) {
            t.next.prev = t.prev, t.prev.next = t.next, t.prevZ && (t.prevZ.nextZ = t.nextZ), t.nextZ && (t.nextZ.prevZ = t.prevZ);
        }
        function mu(t, e1, n) {
            return {
                i: t,
                x: e1,
                y: n,
                prev: null,
                next: null,
                z: 0,
                prevZ: null,
                nextZ: null,
                steiner: !1
            };
        }
        class gu {
            constructor(t, e1){
                if (e1 > t) throw new Error("Min granularity must not be greater than base granularity.");
                this._baseZoomGranularity = t, this._minGranularity = e1;
            }
            getGranularityForZoomLevel(t) {
                return Math.max(Math.floor(this._baseZoomGranularity / (1 << t)), this._minGranularity, 1);
            }
        }
        class xu {
            constructor(t){
                this.fill = t.fill, this.line = t.line, this.tile = t.tile, this.stencil = t.stencil, this.circle = t.circle;
            }
        }
        xu.noSubdivision = new xu({
            fill: new gu(0, 0),
            line: new gu(0, 0),
            tile: new gu(0, 0),
            stencil: new gu(0, 0),
            circle: 1
        }), ds("SubdivisionGranularityExpression", gu), ds("SubdivisionGranularitySetting", xu);
        const vu = -32768, bu = 32767;
        class wu {
            constructor(t, e1){
                this._vertexBuffer = [], this._vertexDictionary = new Map, this._used = !1, this._granularity = t, this._granularityCellSize = T / t, this._canonical = e1;
            }
            _getKey(t, e1) {
                return (t += 32768) << 16 | e1 + 32768;
            }
            _vertexToIndex(t, e1) {
                if (t < -32768 || e1 < -32768 || t > 32767 || e1 > 32767) throw new Error("Vertex coordinates are out of signed 16 bit integer range.");
                const n = 0 | Math.round(t), r = 0 | Math.round(e1), i = this._getKey(n, r);
                if (this._vertexDictionary.has(i)) return this._vertexDictionary.get(i);
                const s = this._vertexBuffer.length / 2;
                return this._vertexDictionary.set(i, s), this._vertexBuffer.push(n, r), s;
            }
            _subdivideTrianglesScanline(t) {
                if (this._granularity < 2) return function(t, e1) {
                    const n = [];
                    for(let r = 0; r < e1.length; r += 3){
                        const i = e1[r], s = e1[r + 1], o = e1[r + 2], a = t[2 * i], l = t[2 * i + 1];
                        (t[2 * s] - a) * (t[2 * o + 1] - l) - (t[2 * s + 1] - l) * (t[2 * o] - a) > 0 ? (n.push(i), n.push(o), n.push(s)) : (n.push(i), n.push(s), n.push(o));
                    }
                    return n;
                }(this._vertexBuffer, t);
                const e1 = [], n = t.length;
                for(let r = 0; r < n; r += 3){
                    const n = [
                        t[r + 0],
                        t[r + 1],
                        t[r + 2]
                    ], i = [
                        this._vertexBuffer[2 * t[r + 0] + 0],
                        this._vertexBuffer[2 * t[r + 0] + 1],
                        this._vertexBuffer[2 * t[r + 1] + 0],
                        this._vertexBuffer[2 * t[r + 1] + 1],
                        this._vertexBuffer[2 * t[r + 2] + 0],
                        this._vertexBuffer[2 * t[r + 2] + 1]
                    ];
                    let s = 1 / 0, o = 1 / 0, a = -1 / 0, l = -1 / 0;
                    for(let t = 0; t < 3; t++){
                        const e1 = i[2 * t], n = i[2 * t + 1];
                        s = Math.min(s, e1), a = Math.max(a, e1), o = Math.min(o, n), l = Math.max(l, n);
                    }
                    if (s === a || o === l) continue;
                    const u = Math.floor(s / this._granularityCellSize), c = Math.ceil(a / this._granularityCellSize), h = Math.floor(o / this._granularityCellSize), p = Math.ceil(l / this._granularityCellSize);
                    if (u !== c || h !== p) for(let t = h; t < p; t++){
                        const r = this._scanlineGenerateVertexRingForCellRow(t, i, n);
                        Au(this._vertexBuffer, r, e1);
                    }
                    else e1.push(...n);
                }
                return e1;
            }
            _scanlineGenerateVertexRingForCellRow(t, e1, n) {
                const r = t * this._granularityCellSize, i = r + this._granularityCellSize, s = [];
                for(let t = 0; t < 3; t++){
                    const o = e1[2 * t], a = e1[2 * t + 1], l = e1[2 * (t + 1) % 6], u = e1[(2 * (t + 1) + 1) % 6], c = e1[2 * (t + 2) % 6], h = e1[(2 * (t + 2) + 1) % 6], p = l - o, f = u - a, d = 0 === p, y = 0 === f, m = (r - a) / f, g = (i - a) / f, x = Math.min(m, g), v = Math.max(m, g);
                    if (!y && (x >= 1 || v <= 0) || y && (a < r || a > i)) {
                        u >= r && u <= i && s.push(n[(t + 1) % 3]);
                        continue;
                    }
                    !y && x > 0 && s.push(this._vertexToIndex(o + p * x, a + f * x));
                    const b = o + p * Math.max(x, 0), w = o + p * Math.min(v, 1);
                    d || this._generateIntraEdgeVertices(s, o, a, l, u, b, w), !y && v < 1 && s.push(this._vertexToIndex(o + p * v, a + f * v)), (y || u >= r && u <= i) && s.push(n[(t + 1) % 3]), !y && (u <= r || u >= i) && this._generateInterEdgeVertices(s, o, a, l, u, c, h, w, r, i);
                }
                return s;
            }
            _generateIntraEdgeVertices(t, e1, n, r, i, s, o) {
                const a = r - e1, l = i - n, u = 0 === l, c = u ? Math.min(e1, r) : Math.min(s, o), h = u ? Math.max(e1, r) : Math.max(s, o), p = Math.floor(c / this._granularityCellSize) + 1, f = Math.ceil(h / this._granularityCellSize) - 1;
                if (u ? e1 < r : s < o) for(let r = p; r <= f; r++){
                    const i = r * this._granularityCellSize;
                    t.push(this._vertexToIndex(i, n + l * (i - e1) / a));
                }
                else for(let r = f; r >= p; r--){
                    const i = r * this._granularityCellSize;
                    t.push(this._vertexToIndex(i, n + l * (i - e1) / a));
                }
            }
            _generateInterEdgeVertices(t, e1, n, r, i, s, o, a, l, u) {
                const c = i - n, h = s - r, p = o - i, f = (l - i) / p, d = (u - i) / p, y = Math.min(f, d), m = Math.max(f, d), g = r + h * y;
                let x = Math.floor(Math.min(g, a) / this._granularityCellSize) + 1, v = Math.ceil(Math.max(g, a) / this._granularityCellSize) - 1, b = a < g;
                const w = 0 === p;
                if (w && (o === l || o === u)) return;
                if (w || y >= 1 || m <= 0) {
                    const t = n - o, r = s + (e1 - s) * Math.min((l - o) / t, (u - o) / t);
                    x = Math.floor(Math.min(r, a) / this._granularityCellSize) + 1, v = Math.ceil(Math.max(r, a) / this._granularityCellSize) - 1, b = a < r;
                }
                const _ = c > 0 ? u : l;
                if (b) for(let e1 = x; e1 <= v; e1++)t.push(this._vertexToIndex(e1 * this._granularityCellSize, _));
                else for(let e1 = v; e1 >= x; e1--)t.push(this._vertexToIndex(e1 * this._granularityCellSize, _));
            }
            _generateOutline(t) {
                const e1 = [];
                for (const n of t){
                    const t = Su(n, this._granularity, !0), r = this._pointArrayToIndices(t), i = [];
                    for(let t = 1; t < r.length; t++)i.push(r[t - 1]), i.push(r[t]);
                    e1.push(i);
                }
                return e1;
            }
            _handlePoles(t) {
                let e1 = !1, n = !1;
                this._canonical && (0 === this._canonical.y && (e1 = !0), this._canonical.y === (1 << this._canonical.z) - 1 && (n = !0)), (e1 || n) && this._fillPoles(t, e1, n);
            }
            _ensureNoPoleVertices() {
                const t = this._vertexBuffer;
                for(let e1 = 0; e1 < t.length; e1 += 2){
                    const n = t[e1 + 1];
                    n === vu && (t[e1 + 1] = -32767), n === bu && (t[e1 + 1] = 32766);
                }
            }
            _generatePoleQuad(t, e1, n, r, i, s) {
                r > i != (s === vu) ? (t.push(e1), t.push(n), t.push(this._vertexToIndex(r, s)), t.push(n), t.push(this._vertexToIndex(i, s)), t.push(this._vertexToIndex(r, s))) : (t.push(n), t.push(e1), t.push(this._vertexToIndex(r, s)), t.push(this._vertexToIndex(i, s)), t.push(n), t.push(this._vertexToIndex(r, s)));
            }
            _fillPoles(t, e1, n) {
                const r = this._vertexBuffer, i = T, s = t.length;
                for(let o = 2; o < s; o += 3){
                    const s = t[o - 2], a = t[o - 1], l = t[o], u = r[2 * s], c = r[2 * s + 1], h = r[2 * a], p = r[2 * a + 1], f = r[2 * l], d = r[2 * l + 1];
                    e1 && (0 === c && 0 === p && this._generatePoleQuad(t, s, a, u, h, vu), 0 === p && 0 === d && this._generatePoleQuad(t, a, l, h, f, vu), 0 === d && 0 === c && this._generatePoleQuad(t, l, s, f, u, vu)), n && (c === i && p === i && this._generatePoleQuad(t, s, a, u, h, bu), p === i && d === i && this._generatePoleQuad(t, a, l, h, f, bu), d === i && c === i && this._generatePoleQuad(t, l, s, f, u, bu));
                }
            }
            _initializeVertices(t) {
                for(let e1 = 0; e1 < t.length; e1 += 2)this._vertexToIndex(t[e1], t[e1 + 1]);
            }
            subdividePolygonInternal(t, e1) {
                if (this._used) throw new Error("Subdivision: multiple use not allowed.");
                this._used = !0;
                const { flattened: n, holeIndices: r } = function(t) {
                    const e1 = [], n = [];
                    for (const r of t)if (0 !== r.length) {
                        r !== t[0] && e1.push(n.length / 2);
                        for (const t of r)n.push(t.x), n.push(t.y);
                    }
                    return {
                        flattened: n,
                        holeIndices: e1
                    };
                }(t);
                let i;
                this._initializeVertices(n);
                try {
                    const t = function(t, e1, n = 2) {
                        const r = e1 && e1.length, i = r ? e1[0] * n : t.length;
                        let s = Xl(t, 0, i, n, !0);
                        const o = [];
                        if (!s || s.next === s.prev) return o;
                        let a, l, u;
                        if (r && (s = function(t, e1, n, r) {
                            const i = [];
                            for(let n = 0, s = e1.length; n < s; n++){
                                const o = Xl(t, e1[n] * r, n < s - 1 ? e1[n + 1] * r : t.length, r, !1);
                                o === o.next && (o.steiner = !0), i.push(ru(o));
                            }
                            i.sort(Ql);
                            for(let t = 0; t < i.length; t++)n = tu(i[t], n);
                            return n;
                        }(t, e1, s, n)), t.length > 80 * n) {
                            a = t[0], l = t[1];
                            let e1 = a, r = l;
                            for(let s = n; s < i; s += n){
                                const n = t[s], i = t[s + 1];
                                n < a && (a = n), i < l && (l = i), n > e1 && (e1 = n), i > r && (r = i);
                            }
                            u = Math.max(e1 - a, r - l), u = 0 !== u ? 32767 / u : 0;
                        }
                        return Zl(s, o, n, a, l, u, 0), o;
                    }(n, r), e1 = this._convertIndices(n, t);
                    i = this._subdivideTrianglesScanline(e1);
                } catch (t) {
                    console.error(t);
                }
                let s = [];
                return e1 && (s = this._generateOutline(t)), this._ensureNoPoleVertices(), this._handlePoles(i), {
                    verticesFlattened: this._vertexBuffer,
                    indicesTriangles: i,
                    indicesLineList: s
                };
            }
            _convertIndices(t, e1) {
                const n = [];
                for (const r of e1)n.push(this._vertexToIndex(t[2 * r], t[2 * r + 1]));
                return n;
            }
            _pointArrayToIndices(t) {
                const e1 = [];
                for (const n of t)e1.push(this._vertexToIndex(n.x, n.y));
                return e1;
            }
        }
        function _u(t, e1, n, r = !0) {
            return new wu(n, e1).subdividePolygonInternal(t, r);
        }
        function Su(t, e1, r = !1) {
            if (!t || t.length < 1) return [];
            if (t.length < 2) return [];
            const i = t[0], s = t[t.length - 1], o = r && (i.x !== s.x || i.y !== s.y);
            if (e1 < 2) return o ? [
                ...t,
                t[0]
            ] : [
                ...t
            ];
            const a = Math.floor(T / e1), l = [];
            l.push(new n(t[0].x, t[0].y));
            const u = t.length, c = o ? u : u - 1;
            for(let e1 = 0; e1 < c; e1++){
                const r = t[e1], i = e1 < u - 1 ? t[e1 + 1] : t[0], s = r.x, o = r.y, c = i.x, h = i.y, p = s !== c, f = o !== h;
                if (!p && !f) continue;
                const d = c - s, y = h - o, m = Math.abs(d), g = Math.abs(y);
                let x = s, v = o;
                for(;;){
                    const t = d > 0 ? (Math.floor(x / a) + 1) * a : (Math.ceil(x / a) - 1) * a, e1 = y > 0 ? (Math.floor(v / a) + 1) * a : (Math.ceil(v / a) - 1) * a, r = Math.abs(x - t), i = Math.abs(v - e1), s = Math.abs(x - c), o = Math.abs(v - h), u = p ? r / m : Number.POSITIVE_INFINITY, b = f ? i / g : Number.POSITIVE_INFINITY;
                    if ((s <= r || !p) && (o <= i || !f)) break;
                    if (u < b && p || !f) {
                        x = t, v += y * u;
                        const e1 = new n(x, Math.round(v));
                        l[l.length - 1].x === e1.x && l[l.length - 1].y === e1.y || l.push(e1);
                    } else {
                        x += d * b, v = e1;
                        const t = new n(Math.round(x), v);
                        l[l.length - 1].x === t.x && l[l.length - 1].y === t.y || l.push(t);
                    }
                }
                const b = new n(c, h);
                l[l.length - 1].x === b.x && l[l.length - 1].y === b.y || l.push(b);
            }
            return l;
        }
        function Au(t, e1, n) {
            if (0 === e1.length) throw new Error("Subdivision vertex ring is empty.");
            let r = 0, i = t[2 * e1[0]];
            for(let n = 1; n < e1.length; n++){
                const s = t[2 * e1[n]];
                s < i && (i = s, r = n);
            }
            const s = e1.length;
            let o = r, a = (o + 1) % s;
            for(;;){
                const r = o - 1 >= 0 ? o - 1 : s - 1, i = (a + 1) % s, l = t[2 * e1[r]], u = t[2 * e1[i]], c = t[2 * e1[o]], h = t[2 * e1[o] + 1], p = t[2 * e1[a] + 1];
                let f = !1;
                if (l < u) f = !0;
                else if (l > u) f = !1;
                else {
                    const n = p - h, s = -(t[2 * e1[a]] - c), o = h < p ? 1 : -1;
                    ((l - c) * n + (t[2 * e1[r] + 1] - h) * s) * o > ((u - c) * n + (t[2 * e1[i] + 1] - h) * s) * o && (f = !0);
                }
                if (f) {
                    const t = e1[r], i = e1[o], l = e1[a];
                    t !== i && t !== l && i !== l && n.push(l, i, t), o--, o < 0 && (o = s - 1);
                } else {
                    const t = e1[i], r = e1[o], l = e1[a];
                    t !== r && t !== l && r !== l && n.push(l, r, t), a++, a >= s && (a = 0);
                }
                if (r === i) break;
            }
        }
        function Mu(t, e1, n, r, i, s, o, a, l) {
            const u = i.length / 2, c = o && a && l;
            if (u < ua.MAX_VERTEX_ARRAY_LENGTH) {
                const h = e1.prepareSegment(u, n, r), p = h.vertexLength;
                for(let t = 0; t < s.length; t += 3)r.emplaceBack(p + s[t], p + s[t + 1], p + s[t + 2]);
                let f, d;
                h.vertexLength += u, h.primitiveLength += s.length / 3, c && (d = o.prepareSegment(u, n, a), f = d.vertexLength, d.vertexLength += u);
                for(let e1 = 0; e1 < i.length; e1 += 2)t(i[e1], i[e1 + 1]);
                if (c) for (const t of l){
                    for(let e1 = 1; e1 < t.length; e1 += 2)a.emplaceBack(f + t[e1 - 1], f + t[e1]);
                    d.primitiveLength += t.length / 2;
                }
            } else !function(t, e1, n, r, i, s) {
                const o = [];
                for(let t = 0; t < r.length / 2; t++)o.push(-1);
                const a = {
                    count: 0
                };
                let l = 0, u = t.getOrCreateLatestSegment(e1, n), c = u.vertexLength;
                for(let h = 2; h < i.length; h += 3){
                    const p = i[h - 2], f = i[h - 1], d = i[h];
                    let y = o[p] < l, m = o[f] < l, g = o[d] < l;
                    u.vertexLength + ((y ? 1 : 0) + (m ? 1 : 0) + (g ? 1 : 0)) > ua.MAX_VERTEX_ARRAY_LENGTH && (u = t.createNewSegment(e1, n), l = a.count, y = !0, m = !0, g = !0, c = 0);
                    const x = ku(o, r, s, a, p, y, u), v = ku(o, r, s, a, f, m, u), b = ku(o, r, s, a, d, g, u);
                    n.emplaceBack(c + x - l, c + v - l, c + b - l), u.primitiveLength++;
                }
            }(e1, n, r, i, s, t), c && function(t, e1, n, r, i, s) {
                const o = [];
                for(let t = 0; t < r.length / 2; t++)o.push(-1);
                const a = {
                    count: 0
                };
                let l = 0, u = t.getOrCreateLatestSegment(e1, n), c = u.vertexLength;
                for (const h of i)for(let i = 1; i < h.length; i += 2){
                    const p = h[i - 1], f = h[i];
                    let d = o[p] < l, y = o[f] < l;
                    u.vertexLength + ((d ? 1 : 0) + (y ? 1 : 0)) > ua.MAX_VERTEX_ARRAY_LENGTH && (u = t.createNewSegment(e1, n), l = a.count, d = !0, y = !0, c = 0);
                    const m = ku(o, r, s, a, p, d, u), g = ku(o, r, s, a, f, y, u);
                    n.emplaceBack(c + m - l, c + g - l), u.primitiveLength++;
                }
            }(o, n, a, i, l, t), e1.forceNewSegmentOnNextPrepare(), null == o || o.forceNewSegmentOnNextPrepare();
        }
        function ku(t, e1, n, r, i, s, o) {
            if (s) {
                const s = r.count;
                return n(e1[2 * i], e1[2 * i + 1]), t[i] = r.count, r.count++, o.vertexLength++, s;
            }
            return t[i];
        }
        class Iu {
            constructor(t){
                this.zoom = t.zoom, this.overscaling = t.overscaling, this.layers = t.layers, this.layerIds = this.layers.map((t)=>t.id), this.index = t.index, this.hasDependencies = !1, this.patternFeatures = [], this.layoutVertexArray = new Zo, this.indexArray = new sa, this.indexArray2 = new oa, this.programConfigurations = new $a(t.layers, t.zoom), this.segments = new ua, this.segments2 = new ua, this.stateDependentLayerIds = this.layers.filter((t)=>t.isStateDependent()).map((t)=>t.id);
            }
            populate(t, e1, n) {
                this.hasDependencies = ql("fill", this.layers, e1);
                const r = this.layers[0].layout.get("fill-sort-key"), i = !r.isConstant(), s = [];
                for (const { feature: o, id: a, index: l, sourceLayerIndex: u } of t){
                    const t = this.layers[0]._featureFilter.needGeometry, c = Ga(o, t);
                    if (!this.layers[0]._featureFilter.filter(new Cs(this.zoom), c, n)) continue;
                    const h = i ? r.evaluate(c, {}, n, e1.availableImages) : void 0, p = {
                        id: a,
                        properties: o.properties,
                        type: o.type,
                        sourceLayerIndex: u,
                        index: l,
                        geometry: t ? c.geometry : qa(o),
                        patterns: {},
                        sortKey: h
                    };
                    s.push(p);
                }
                i && s.sort((t, e1)=>t.sortKey - e1.sortKey);
                for (const r of s){
                    const { geometry: i, index: s, sourceLayerIndex: o } = r;
                    if (this.hasDependencies) {
                        const t = Gl("fill", this.layers, r, {
                            zoom: this.zoom
                        }, e1);
                        this.patternFeatures.push(t);
                    } else this.addFeature(r, i, s, n, {}, e1.subdivisionGranularity);
                    e1.featureIndex.insert(t[s].feature, i, s, o, this.index);
                }
            }
            update(t, e1, n) {
                this.stateDependentLayers.length && this.programConfigurations.updatePaintArrays(t, e1, this.stateDependentLayers, {
                    imagePositions: n
                });
            }
            addFeatures(t, e1, n) {
                for (const r of this.patternFeatures)this.addFeature(r, r.geometry, r.index, e1, n, t.subdivisionGranularity);
            }
            isEmpty() {
                return 0 === this.layoutVertexArray.length;
            }
            uploadPending() {
                return !this.uploaded || this.programConfigurations.needsUpload;
            }
            upload(t) {
                this.uploaded || (this.layoutVertexBuffer = t.createVertexBuffer(this.layoutVertexArray, jl), this.indexBuffer = t.createIndexBuffer(this.indexArray), this.indexBuffer2 = t.createIndexBuffer(this.indexArray2)), this.programConfigurations.upload(t), this.uploaded = !0;
            }
            destroy() {
                this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.indexBuffer2.destroy(), this.programConfigurations.destroy(), this.segments.destroy(), this.segments2.destroy());
            }
            addFeature(t, e1, n, r, i, s) {
                for (const t of rr(e1, 500)){
                    const e1 = _u(t, r, s.fill.getGranularityForZoomLevel(r.z)), n = this.layoutVertexArray;
                    Mu((t, e1)=>{
                        n.emplaceBack(t, e1);
                    }, this.segments, this.layoutVertexArray, this.indexArray, e1.verticesFlattened, e1.indicesTriangles, this.segments2, this.indexArray2, e1.indicesLineList);
                }
                this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length, t, n, {
                    imagePositions: i,
                    canonical: r
                });
            }
        }
        let Eu, Tu;
        ds("FillBucket", Iu, {
            omit: [
                "layers",
                "patternFeatures"
            ]
        });
        var Fu = {
            get paint () {
                return Tu = Tu || new Ks({
                    "fill-antialias": new Xs(wt.paint_fill["fill-antialias"]),
                    "fill-opacity": new Ys(wt.paint_fill["fill-opacity"]),
                    "fill-color": new Ys(wt.paint_fill["fill-color"]),
                    "fill-outline-color": new Ys(wt.paint_fill["fill-outline-color"]),
                    "fill-translate": new Xs(wt.paint_fill["fill-translate"]),
                    "fill-translate-anchor": new Xs(wt.paint_fill["fill-translate-anchor"]),
                    "fill-pattern": new Zs(wt.paint_fill["fill-pattern"])
                });
            },
            get layout () {
                return Eu = Eu || new Ks({
                    "fill-sort-key": new Ys(wt.layout_fill["fill-sort-key"])
                });
            }
        };
        class Pu extends to {
            constructor(t, e1){
                super(t, Fu, e1);
            }
            recalculate(t, e1) {
                super.recalculate(t, e1);
                const n = this.paint._values["fill-outline-color"];
                "constant" === n.value.kind && void 0 === n.value.value && (this.paint._values["fill-outline-color"] = this.paint._values["fill-color"]);
            }
            createBucket(t) {
                return new Iu(t);
            }
            queryRadius() {
                return al(this.paint.get("fill-translate"));
            }
            queryIntersectsFeature({ queryGeometry: t, geometry: e1, transform: n, pixelsToTileUnits: r }) {
                return Ka(ll(t, this.paint.get("fill-translate"), this.paint.get("fill-translate-anchor"), -n.bearingInRadians, r), e1);
            }
            isTileClipped() {
                return !0;
            }
        }
        const Du = ao([
            {
                name: "a_pos",
                components: 2,
                type: "Int16"
            },
            {
                name: "a_normal_ed",
                components: 4,
                type: "Int16"
            }
        ], 4), zu = ao([
            {
                name: "a_centroid",
                components: 2,
                type: "Int16"
            }
        ], 4), { members: Bu } = Du;
        class Cu {
            constructor(t, e1, n, r, i){
                this.properties = {}, this.extent = n, this.type = 0, this.id = void 0, this._pbf = t, this._geometry = -1, this._keys = r, this._values = i, t.readFields(Vu, this, e1);
            }
            loadGeometry() {
                const t = this._pbf;
                t.pos = this._geometry;
                const e1 = t.readVarint() + t.pos, r = [];
                let i, s = 1, o = 0, a = 0, l = 0;
                for(; t.pos < e1;){
                    if (o <= 0) {
                        const e1 = t.readVarint();
                        s = 7 & e1, o = e1 >> 3;
                    }
                    if (o--, 1 === s || 2 === s) a += t.readSVarint(), l += t.readSVarint(), 1 === s && (i && r.push(i), i = []), i && i.push(new n(a, l));
                    else {
                        if (7 !== s) throw new Error(`unknown command ${s}`);
                        i && i.push(i[0].clone());
                    }
                }
                return i && r.push(i), r;
            }
            bbox() {
                const t = this._pbf;
                t.pos = this._geometry;
                const e1 = t.readVarint() + t.pos;
                let n = 1, r = 0, i = 0, s = 0, o = 1 / 0, a = -1 / 0, l = 1 / 0, u = -1 / 0;
                for(; t.pos < e1;){
                    if (r <= 0) {
                        const e1 = t.readVarint();
                        n = 7 & e1, r = e1 >> 3;
                    }
                    if (r--, 1 === n || 2 === n) i += t.readSVarint(), s += t.readSVarint(), i < o && (o = i), i > a && (a = i), s < l && (l = s), s > u && (u = s);
                    else if (7 !== n) throw new Error(`unknown command ${n}`);
                }
                return [
                    o,
                    l,
                    a,
                    u
                ];
            }
            toGeoJSON(t, e1, n) {
                const r = this.extent * Math.pow(2, n), i = this.extent * t, s = this.extent * e1, o = this.loadGeometry();
                function a(t) {
                    return [
                        360 * (t.x + i) / r - 180,
                        360 / Math.PI * Math.atan(Math.exp((1 - 2 * (t.y + s) / r) * Math.PI)) - 90
                    ];
                }
                function l(t) {
                    return t.map(a);
                }
                let u;
                if (1 === this.type) {
                    const t = [];
                    for (const e1 of o)t.push(e1[0]);
                    const e1 = l(t);
                    u = 1 === t.length ? {
                        type: "Point",
                        coordinates: e1[0]
                    } : {
                        type: "MultiPoint",
                        coordinates: e1
                    };
                } else if (2 === this.type) {
                    const t = o.map(l);
                    u = 1 === t.length ? {
                        type: "LineString",
                        coordinates: t[0]
                    } : {
                        type: "MultiLineString",
                        coordinates: t
                    };
                } else {
                    if (3 !== this.type) throw new Error("unknown feature type");
                    {
                        const t = Lu(o), e1 = [];
                        for (const n of t)e1.push(n.map(l));
                        u = 1 === e1.length ? {
                            type: "Polygon",
                            coordinates: e1[0]
                        } : {
                            type: "MultiPolygon",
                            coordinates: e1
                        };
                    }
                }
                const c = {
                    type: "Feature",
                    geometry: u,
                    properties: this.properties
                };
                return null != this.id && (c.id = this.id), c;
            }
        }
        function Vu(t, e1, n) {
            1 === t ? e1.id = n.readVarint() : 2 === t ? function(t, e1) {
                const n = t.readVarint() + t.pos;
                for(; t.pos < n;){
                    const n = e1._keys[t.readVarint()], r = e1._values[t.readVarint()];
                    e1.properties[n] = r;
                }
            }(n, e1) : 3 === t ? e1.type = n.readVarint() : 4 === t && (e1._geometry = n.pos);
        }
        function Lu(t) {
            const e1 = t.length;
            if (e1 <= 1) return [
                t
            ];
            const n = [];
            let r, i;
            for(let s = 0; s < e1; s++){
                const e1 = Ou(t[s]);
                0 !== e1 && (void 0 === i && (i = e1 < 0), i === e1 < 0 ? (r && n.push(r), r = [
                    t[s]
                ]) : r && r.push(t[s]));
            }
            return r && n.push(r), n;
        }
        function Ou(t) {
            let e1 = 0;
            for(let n, r, i = 0, s = t.length, o = s - 1; i < s; o = i++)n = t[i], r = t[o], e1 += (r.x - n.x) * (n.y + r.y);
            return e1;
        }
        Cu.types = [
            "Unknown",
            "Point",
            "LineString",
            "Polygon"
        ];
        class $u {
            constructor(t, e1){
                this.version = 1, this.name = "", this.extent = 4096, this.length = 0, this._pbf = t, this._keys = [], this._values = [], this._features = [], t.readFields(Ru, this, e1), this.length = this._features.length;
            }
            feature(t) {
                if (t < 0 || t >= this._features.length) throw new Error("feature index out of bounds");
                this._pbf.pos = this._features[t];
                const e1 = this._pbf.readVarint() + this._pbf.pos;
                return new Cu(this._pbf, e1, this.extent, this._keys, this._values);
            }
        }
        function Ru(t, e1, n) {
            15 === t ? e1.version = n.readVarint() : 1 === t ? e1.name = n.readString() : 5 === t ? e1.extent = n.readVarint() : 2 === t ? e1._features.push(n.pos) : 3 === t ? e1._keys.push(n.readString()) : 4 === t && e1._values.push(function(t) {
                let e1 = null;
                const n = t.readVarint() + t.pos;
                for(; t.pos < n;){
                    const n = t.readVarint() >> 3;
                    e1 = 1 === n ? t.readString() : 2 === n ? t.readFloat() : 3 === n ? t.readDouble() : 4 === n ? t.readVarint64() : 5 === n ? t.readVarint() : 6 === n ? t.readSVarint() : 7 === n ? t.readBoolean() : null;
                }
                if (null == e1) throw new Error("unknown feature value");
                return e1;
            }(n));
        }
        class Nu {
            constructor(t, e1){
                this.layers = t.readFields(Uu, {}, e1);
            }
        }
        function Uu(t, e1, n) {
            if (3 === t) {
                const t = new $u(n, n.readVarint() + n.pos);
                t.length && (e1[t.name] = t);
            }
        }
        const ju = Math.pow(2, 13);
        function qu(t, e1, n, r, i, s, o, a) {
            t.emplaceBack(e1, n, 2 * Math.floor(r * ju) + o, i * ju * 2, s * ju * 2, Math.round(a));
        }
        class Gu {
            constructor(t){
                this.zoom = t.zoom, this.overscaling = t.overscaling, this.layers = t.layers, this.layerIds = this.layers.map((t)=>t.id), this.index = t.index, this.hasDependencies = !1, this.layoutVertexArray = new Ho, this.centroidVertexArray = new Xo, this.indexArray = new sa, this.programConfigurations = new $a(t.layers, t.zoom), this.segments = new ua, this.stateDependentLayerIds = this.layers.filter((t)=>t.isStateDependent()).map((t)=>t.id);
            }
            populate(t, e1, n) {
                this.features = [], this.hasDependencies = ql("fill-extrusion", this.layers, e1);
                for (const { feature: r, id: i, index: s, sourceLayerIndex: o } of t){
                    const t = this.layers[0]._featureFilter.needGeometry, a = Ga(r, t);
                    if (!this.layers[0]._featureFilter.filter(new Cs(this.zoom), a, n)) continue;
                    const l = {
                        id: i,
                        sourceLayerIndex: o,
                        index: s,
                        geometry: t ? a.geometry : qa(r),
                        properties: r.properties,
                        type: r.type,
                        patterns: {}
                    };
                    this.hasDependencies ? this.features.push(Gl("fill-extrusion", this.layers, l, {
                        zoom: this.zoom
                    }, e1)) : this.addFeature(l, l.geometry, s, n, {}, e1.subdivisionGranularity), e1.featureIndex.insert(r, l.geometry, s, o, this.index, !0);
                }
            }
            addFeatures(t, e1, n) {
                for (const r of this.features){
                    const { geometry: i } = r;
                    this.addFeature(r, i, r.index, e1, n, t.subdivisionGranularity);
                }
            }
            update(t, e1, n) {
                this.stateDependentLayers.length && this.programConfigurations.updatePaintArrays(t, e1, this.stateDependentLayers, {
                    imagePositions: n
                });
            }
            isEmpty() {
                return 0 === this.layoutVertexArray.length && 0 === this.centroidVertexArray.length;
            }
            uploadPending() {
                return !this.uploaded || this.programConfigurations.needsUpload;
            }
            upload(t) {
                this.uploaded || (this.layoutVertexBuffer = t.createVertexBuffer(this.layoutVertexArray, Bu), this.centroidVertexBuffer = t.createVertexBuffer(this.centroidVertexArray, zu.members, !0), this.indexBuffer = t.createIndexBuffer(this.indexArray)), this.programConfigurations.upload(t), this.uploaded = !0;
            }
            destroy() {
                this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.programConfigurations.destroy(), this.segments.destroy(), this.centroidVertexBuffer.destroy());
            }
            addFeature(t, e1, n, r, i, s) {
                for (const n of rr(e1, 500)){
                    const e1 = {
                        x: 0,
                        y: 0,
                        sampleCount: 0
                    }, i = this.layoutVertexArray.length;
                    this.processPolygon(e1, r, t, n, s);
                    const o = this.layoutVertexArray.length - i, a = Math.floor(e1.x / e1.sampleCount), l = Math.floor(e1.y / e1.sampleCount);
                    for(let t = 0; t < o; t++)this.centroidVertexArray.emplaceBack(a, l);
                }
                this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length, t, n, {
                    imagePositions: i,
                    canonical: r
                });
            }
            processPolygon(t, e1, n, r, i) {
                if (r.length < 1) return;
                if (Zu(r[0])) return;
                for (const e1 of r)0 !== e1.length && Xu(t, e1);
                const s = {
                    segment: this.segments.prepareSegment(4, this.layoutVertexArray, this.indexArray)
                }, o = i.fill.getGranularityForZoomLevel(e1.z), a = "Polygon" === Cu.types[n.type];
                for (const t of r){
                    if (0 === t.length) continue;
                    if (Zu(t)) continue;
                    const e1 = Su(t, o, a);
                    this._generateSideFaces(e1, s);
                }
                if (!a) return;
                const l = _u(r, e1, o, !1), u = this.layoutVertexArray;
                Mu((t, e1)=>{
                    qu(u, t, e1, 0, 0, 1, 1, 0);
                }, this.segments, this.layoutVertexArray, this.indexArray, l.verticesFlattened, l.indicesTriangles);
            }
            _generateSideFaces(t, e1) {
                let n = 0;
                for(let r = 1; r < t.length; r++){
                    const i = t[r], s = t[r - 1];
                    if (Yu(i, s)) continue;
                    e1.segment.vertexLength + 4 > ua.MAX_VERTEX_ARRAY_LENGTH && (e1.segment = this.segments.prepareSegment(4, this.layoutVertexArray, this.indexArray));
                    const o = i.sub(s)._perp()._unit(), a = s.dist(i);
                    n + a > 32768 && (n = 0), qu(this.layoutVertexArray, i.x, i.y, o.x, o.y, 0, 0, n), qu(this.layoutVertexArray, i.x, i.y, o.x, o.y, 0, 1, n), n += a, qu(this.layoutVertexArray, s.x, s.y, o.x, o.y, 0, 0, n), qu(this.layoutVertexArray, s.x, s.y, o.x, o.y, 0, 1, n);
                    const l = e1.segment.vertexLength;
                    this.indexArray.emplaceBack(l, l + 2, l + 1), this.indexArray.emplaceBack(l + 1, l + 2, l + 3), e1.segment.vertexLength += 4, e1.segment.primitiveLength += 2;
                }
            }
        }
        function Xu(t, e1) {
            for(let n = 0; n < e1.length; n++){
                const r = e1[n];
                n === e1.length - 1 && e1[0].x === r.x && e1[0].y === r.y || (t.x += r.x, t.y += r.y, t.sampleCount++);
            }
        }
        function Yu(t, e1) {
            return t.x === e1.x && (t.x < 0 || t.x > T) || t.y === e1.y && (t.y < 0 || t.y > T);
        }
        function Zu(t) {
            return t.every((t)=>t.x < 0) || t.every((t)=>t.x > T) || t.every((t)=>t.y < 0) || t.every((t)=>t.y > T);
        }
        let Hu;
        ds("FillExtrusionBucket", Gu, {
            omit: [
                "layers",
                "features"
            ]
        });
        var Wu = {
            get paint () {
                return Hu = Hu || new Ks({
                    "fill-extrusion-opacity": new Xs(wt["paint_fill-extrusion"]["fill-extrusion-opacity"]),
                    "fill-extrusion-color": new Ys(wt["paint_fill-extrusion"]["fill-extrusion-color"]),
                    "fill-extrusion-translate": new Xs(wt["paint_fill-extrusion"]["fill-extrusion-translate"]),
                    "fill-extrusion-translate-anchor": new Xs(wt["paint_fill-extrusion"]["fill-extrusion-translate-anchor"]),
                    "fill-extrusion-pattern": new Zs(wt["paint_fill-extrusion"]["fill-extrusion-pattern"]),
                    "fill-extrusion-height": new Ys(wt["paint_fill-extrusion"]["fill-extrusion-height"]),
                    "fill-extrusion-base": new Ys(wt["paint_fill-extrusion"]["fill-extrusion-base"]),
                    "fill-extrusion-vertical-gradient": new Xs(wt["paint_fill-extrusion"]["fill-extrusion-vertical-gradient"])
                });
            }
        };
        class Ku extends to {
            constructor(t, e1){
                super(t, Wu, e1);
            }
            createBucket(t) {
                return new Gu(t);
            }
            queryRadius() {
                return al(this.paint.get("fill-extrusion-translate"));
            }
            is3D() {
                return !0;
            }
            queryIntersectsFeature({ queryGeometry: t, feature: e1, featureState: r, geometry: i, transform: s, pixelsToTileUnits: o, pixelPosMatrix: a }) {
                const l = ll(t, this.paint.get("fill-extrusion-translate"), this.paint.get("fill-extrusion-translate-anchor"), -s.bearingInRadians, o), u = this.paint.get("fill-extrusion-height").evaluate(e1, r), c = this.paint.get("fill-extrusion-base").evaluate(e1, r), h = function(t, e1) {
                    const r = [];
                    for (const i of t){
                        const t = [
                            i.x,
                            i.y,
                            0,
                            1
                        ];
                        A(t, t, e1), r.push(new n(t[0] / t[3], t[1] / t[3]));
                    }
                    return r;
                }(l, a), p = function(t, e1, r, i) {
                    const s = [], o = [], a = i[8] * e1, l = i[9] * e1, u = i[10] * e1, c = i[11] * e1, h = i[8] * r, p = i[9] * r, f = i[10] * r, d = i[11] * r;
                    for (const e1 of t){
                        const t = [], r = [];
                        for (const s of e1){
                            const e1 = s.x, o = s.y, y = i[0] * e1 + i[4] * o + i[12], m = i[1] * e1 + i[5] * o + i[13], g = i[2] * e1 + i[6] * o + i[14], x = i[3] * e1 + i[7] * o + i[15], v = g + u, b = x + c, w = y + h, _ = m + p, S = g + f, A = x + d, M = new n((y + a) / b, (m + l) / b);
                            M.z = v / b, t.push(M);
                            const k = new n(w / A, _ / A);
                            k.z = S / A, r.push(k);
                        }
                        s.push(t), o.push(r);
                    }
                    return [
                        s,
                        o
                    ];
                }(i, c, u, a);
                return function(t, e1, n) {
                    let r = 1 / 0;
                    Ka(n, e1) && (r = Qu(n, e1[0]));
                    for(let i = 0; i < e1.length; i++){
                        const s = e1[i], o = t[i];
                        for(let t = 0; t < s.length - 1; t++){
                            const e1 = s[t], i = [
                                e1,
                                s[t + 1],
                                o[t + 1],
                                o[t],
                                e1
                            ];
                            Ha(n, i) && (r = Math.min(r, Qu(n, i)));
                        }
                    }
                    return r !== 1 / 0 && r;
                }(p[0], p[1], h);
            }
        }
        function Ju(t, e1) {
            return t.x * e1.x + t.y * e1.y;
        }
        function Qu(t, e1) {
            if (1 === t.length) {
                let n = 0;
                const r = e1[n++];
                let i;
                for(; !i || r.equals(i);)if (i = e1[n++], !i) return 1 / 0;
                for(; n < e1.length; n++){
                    const s = e1[n], o = t[0], a = i.sub(r), l = s.sub(r), u = o.sub(r), c = Ju(a, a), h = Ju(a, l), p = Ju(l, l), f = Ju(u, a), d = Ju(u, l), y = c * p - h * h, m = (p * f - h * d) / y, g = (c * d - h * f) / y, x = r.z * (1 - m - g) + i.z * m + s.z * g;
                    if (isFinite(x)) return x;
                }
                return 1 / 0;
            }
            {
                let t = 1 / 0;
                for (const n of e1)t = Math.min(t, n.z);
                return t;
            }
        }
        const tc = [
            Int8Array,
            Uint8Array,
            Uint8ClampedArray,
            Int16Array,
            Uint16Array,
            Int32Array,
            Uint32Array,
            Float32Array,
            Float64Array
        ];
        class ec {
            static from(t) {
                if (!(t instanceof ArrayBuffer)) throw new Error("Data must be an instance of ArrayBuffer.");
                const [e1, n] = new Uint8Array(t, 0, 2);
                if (219 !== e1) throw new Error("Data does not appear to be in a KDBush format.");
                const r = n >> 4;
                if (1 !== r) throw new Error(`Got v${r} data when expected v1.`);
                const i = tc[15 & n];
                if (!i) throw new Error("Unrecognized array type.");
                const [s] = new Uint16Array(t, 2, 1), [o] = new Uint32Array(t, 4, 1);
                return new ec(o, s, i, t);
            }
            constructor(t, e1 = 64, n = Float64Array, r){
                if (isNaN(t) || t < 0) throw new Error(`Unpexpected numItems value: ${t}.`);
                this.numItems = +t, this.nodeSize = Math.min(Math.max(+e1, 2), 65535), this.ArrayType = n, this.IndexArrayType = t < 65536 ? Uint16Array : Uint32Array;
                const i = tc.indexOf(this.ArrayType), s = 2 * t * this.ArrayType.BYTES_PER_ELEMENT, o = t * this.IndexArrayType.BYTES_PER_ELEMENT, a = (8 - o % 8) % 8;
                if (i < 0) throw new Error(`Unexpected typed array class: ${n}.`);
                r && r instanceof ArrayBuffer ? (this.data = r, this.ids = new this.IndexArrayType(this.data, 8, t), this.coords = new this.ArrayType(this.data, 8 + o + a, 2 * t), this._pos = 2 * t, this._finished = !0) : (this.data = new ArrayBuffer(8 + s + o + a), this.ids = new this.IndexArrayType(this.data, 8, t), this.coords = new this.ArrayType(this.data, 8 + o + a, 2 * t), this._pos = 0, this._finished = !1, new Uint8Array(this.data, 0, 2).set([
                    219,
                    16 + i
                ]), new Uint16Array(this.data, 2, 1)[0] = e1, new Uint32Array(this.data, 4, 1)[0] = t);
            }
            add(t, e1) {
                const n = this._pos >> 1;
                return this.ids[n] = n, this.coords[this._pos++] = t, this.coords[this._pos++] = e1, n;
            }
            finish() {
                const t = this._pos >> 1;
                if (t !== this.numItems) throw new Error(`Added ${t} items when expected ${this.numItems}.`);
                return nc(this.ids, this.coords, this.nodeSize, 0, this.numItems - 1, 0), this._finished = !0, this;
            }
            range(t, e1, n, r) {
                if (!this._finished) throw new Error("Data not yet indexed - call index.finish().");
                const { ids: i, coords: s, nodeSize: o } = this, a = [
                    0,
                    i.length - 1,
                    0
                ], l = [];
                for(; a.length;){
                    const u = a.pop() || 0, c = a.pop() || 0, h = a.pop() || 0;
                    if (c - h <= o) {
                        for(let o = h; o <= c; o++){
                            const a = s[2 * o], u = s[2 * o + 1];
                            a >= t && a <= n && u >= e1 && u <= r && l.push(i[o]);
                        }
                        continue;
                    }
                    const p = h + c >> 1, f = s[2 * p], d = s[2 * p + 1];
                    f >= t && f <= n && d >= e1 && d <= r && l.push(i[p]), (0 === u ? t <= f : e1 <= d) && (a.push(h), a.push(p - 1), a.push(1 - u)), (0 === u ? n >= f : r >= d) && (a.push(p + 1), a.push(c), a.push(1 - u));
                }
                return l;
            }
            within(t, e1, n) {
                if (!this._finished) throw new Error("Data not yet indexed - call index.finish().");
                const { ids: r, coords: i, nodeSize: s } = this, o = [
                    0,
                    r.length - 1,
                    0
                ], a = [], l = n * n;
                for(; o.length;){
                    const u = o.pop() || 0, c = o.pop() || 0, h = o.pop() || 0;
                    if (c - h <= s) {
                        for(let n = h; n <= c; n++)oc(i[2 * n], i[2 * n + 1], t, e1) <= l && a.push(r[n]);
                        continue;
                    }
                    const p = h + c >> 1, f = i[2 * p], d = i[2 * p + 1];
                    oc(f, d, t, e1) <= l && a.push(r[p]), (0 === u ? t - n <= f : e1 - n <= d) && (o.push(h), o.push(p - 1), o.push(1 - u)), (0 === u ? t + n >= f : e1 + n >= d) && (o.push(p + 1), o.push(c), o.push(1 - u));
                }
                return a;
            }
        }
        function nc(t, e1, n, r, i, s) {
            if (i - r <= n) return;
            const o = r + i >> 1;
            rc(t, e1, o, r, i, s), nc(t, e1, n, r, o - 1, 1 - s), nc(t, e1, n, o + 1, i, 1 - s);
        }
        function rc(t, e1, n, r, i, s) {
            for(; i > r;){
                if (i - r > 600) {
                    const o = i - r + 1, a = n - r + 1, l = Math.log(o), u = .5 * Math.exp(2 * l / 3), c = .5 * Math.sqrt(l * u * (o - u) / o) * (a - o / 2 < 0 ? -1 : 1);
                    rc(t, e1, n, Math.max(r, Math.floor(n - a * u / o + c)), Math.min(i, Math.floor(n + (o - a) * u / o + c)), s);
                }
                const o = e1[2 * n + s];
                let a = r, l = i;
                for(ic(t, e1, r, n), e1[2 * i + s] > o && ic(t, e1, r, i); a < l;){
                    for(ic(t, e1, a, l), a++, l--; e1[2 * a + s] < o;)a++;
                    for(; e1[2 * l + s] > o;)l--;
                }
                e1[2 * r + s] === o ? ic(t, e1, r, l) : (l++, ic(t, e1, l, i)), l <= n && (r = l + 1), n <= l && (i = l - 1);
            }
        }
        function ic(t, e1, n, r) {
            sc(t, n, r), sc(e1, 2 * n, 2 * r), sc(e1, 2 * n + 1, 2 * r + 1);
        }
        function sc(t, e1, n) {
            const r = t[e1];
            t[e1] = t[n], t[n] = r;
        }
        function oc(t, e1, n, r) {
            const i = t - n, s = e1 - r;
            return i * i + s * s;
        }
        function ac(t, e1, n, r) {
            let i = r;
            const s = e1 + (n - e1 >> 1);
            let o, a = n - e1;
            const l = t[e1], u = t[e1 + 1], c = t[n], h = t[n + 1];
            for(let r = e1 + 3; r < n; r += 3){
                const e1 = lc(t[r], t[r + 1], l, u, c, h);
                if (e1 > i) o = r, i = e1;
                else if (e1 === i) {
                    const t = Math.abs(r - s);
                    t < a && (o = r, a = t);
                }
            }
            i > r && (o - e1 > 3 && ac(t, e1, o, r), t[o + 2] = i, n - o > 3 && ac(t, o, n, r));
        }
        function lc(t, e1, n, r, i, s) {
            let o = i - n, a = s - r;
            if (0 !== o || 0 !== a) {
                const l = ((t - n) * o + (e1 - r) * a) / (o * o + a * a);
                l > 1 ? (n = i, r = s) : l > 0 && (n += o * l, r += a * l);
            }
            return o = t - n, a = e1 - r, o * o + a * a;
        }
        function uc(t, e1, n, r) {
            const i = {
                type: e1,
                geom: n
            }, s = {
                id: null == t ? null : t,
                type: i.type,
                geometry: i.geom,
                tags: r,
                minX: 1 / 0,
                minY: 1 / 0,
                maxX: -1 / 0,
                maxY: -1 / 0
            };
            switch(i.type){
                case "Point":
                case "MultiPoint":
                    hc(s, i.geom);
                    break;
                case "LineString":
                    hc(s, i.geom.points);
                    break;
                case "Polygon":
                    hc(s, i.geom[0].points);
                    break;
                case "MultiLineString":
                    for (const t of i.geom)hc(s, t.points);
                    break;
                case "MultiPolygon":
                    for (const t of i.geom)hc(s, t[0].points);
            }
            return s;
        }
        function cc(t) {
            t.points.length > 64 && (t.points = new Float64Array(t.points));
        }
        function hc(t, e1) {
            for(let n = 0; n < e1.length; n += 3)t.minX = Math.min(t.minX, e1[n]), t.minY = Math.min(t.minY, e1[n + 1]), t.maxX = Math.max(t.maxX, e1[n]), t.maxY = Math.max(t.maxY, e1[n + 1]);
        }
        function pc(t, e1) {
            const n = [];
            switch(t.type){
                case "FeatureCollection":
                    for(let r = 0; r < t.features.length; r++)fc(n, t.features[r], e1, r);
                    break;
                case "Feature":
                    fc(n, t, e1);
                    break;
                default:
                    fc(n, {
                        geometry: t,
                        properties: void 0
                    }, e1);
            }
            return n;
        }
        function fc(t, e1, n, r) {
            if (!e1.geometry) return;
            if ("GeometryCollection" === e1.geometry.type) return void function(t, e1, n, r, i) {
                for (const s of n.geometries)fc(t, {
                    id: e1.id,
                    geometry: s,
                    properties: e1.properties
                }, r, i);
            }(t, e1, e1.geometry, n, r);
            const i = e1.geometry.coordinates;
            if (!i?.length) return;
            const s = function(t, e1, n) {
                return e1.promoteId ? t.properties?.[e1.promoteId] : e1.generateId ? n || 0 : t.id;
            }(e1, n, r), o = Math.pow(n.tolerance / ((1 << n.maxZoom) * n.extent), 2);
            switch(e1.geometry.type){
                case "Point":
                    return void function(t, e1, n, r) {
                        const i = [];
                        i.push(mc(n.coordinates[0]), gc(n.coordinates[1]), 0), t.push(uc(e1, "Point", i, r));
                    }(t, s, e1.geometry, e1.properties);
                case "MultiPoint":
                    return void function(t, e1, n, r) {
                        const i = [];
                        for (const t of n.coordinates)i.push(mc(t[0]), gc(t[1]), 0);
                        t.push(uc(e1, "MultiPoint", i, r));
                    }(t, s, e1.geometry, e1.properties);
                case "LineString":
                    return void function(t, e1, n, r, i) {
                        const s = {
                            points: []
                        };
                        dc(n.coordinates, s, r, !1), t.push(uc(e1, "LineString", s, i));
                    }(t, s, e1.geometry, o, e1.properties);
                case "MultiLineString":
                    return void function(t, e1, n, r, i, s) {
                        if (i.lineMetrics) for (const i of n.coordinates){
                            const n = {
                                points: []
                            };
                            dc(i, n, r, !1), t.push(uc(e1, "LineString", n, s));
                        }
                        else {
                            const i = [];
                            yc(n.coordinates, i, r, !1), t.push(uc(e1, "MultiLineString", i, s));
                        }
                    }(t, s, e1.geometry, o, n, e1.properties);
                case "Polygon":
                    return void function(t, e1, n, r, i) {
                        const s = [];
                        yc(n.coordinates, s, r, !0), t.push(uc(e1, "Polygon", s, i));
                    }(t, s, e1.geometry, o, e1.properties);
                case "MultiPolygon":
                    return void function(t, e1, n, r, i) {
                        const s = [];
                        for (const t of n.coordinates){
                            const e1 = [];
                            yc(t, e1, r, !0), s.push(e1);
                        }
                        t.push(uc(e1, "MultiPolygon", s, i));
                    }(t, s, e1.geometry, o, e1.properties);
                default:
                    throw new Error("Input data is not a valid GeoJSON object.");
            }
        }
        function dc(t, e1, n, r) {
            let i, s, o = 0;
            for(let n = 0; n < t.length; n++){
                const a = mc(t[n][0]), l = gc(t[n][1]);
                e1.points.push(a, l, 0), n > 0 && (o += r ? (i * l - a * s) / 2 : Math.sqrt(Math.pow(a - i, 2) + Math.pow(l - s, 2))), i = a, s = l;
            }
            const a = e1.points.length - 3;
            e1.points[2] = 1, n > 0 && ac(e1.points, 0, a, n), e1.points[a + 2] = 1, cc(e1), e1.size = Math.abs(o), e1.start = 0, e1.end = e1.size;
        }
        function yc(t, e1, n, r) {
            for(let i = 0; i < t.length; i++){
                const s = {
                    points: []
                };
                dc(t[i], s, n, r), e1.push(s);
            }
        }
        function mc(t) {
            return t / 360 + .5;
        }
        function gc(t) {
            const e1 = Math.sin(t * Math.PI / 180), n = .5 - .25 * Math.log((1 + e1) / (1 - e1)) / Math.PI;
            return n < 0 ? 0 : n > 1 ? 1 : n;
        }
        function xc(t) {
            const e1 = {
                type: "Feature",
                geometry: vc(t),
                properties: t.tags
            };
            return null != t.id && (e1.id = t.id), e1;
        }
        function vc(t) {
            const { type: e1, geometry: n } = t;
            switch(e1){
                case "Point":
                    return {
                        type: e1,
                        coordinates: wc(n[0], n[1])
                    };
                case "MultiPoint":
                    return {
                        type: e1,
                        coordinates: bc(n)
                    };
                case "LineString":
                    return {
                        type: e1,
                        coordinates: bc(n.points)
                    };
                case "MultiLineString":
                case "Polygon":
                    return {
                        type: e1,
                        coordinates: n.map((t)=>bc(t.points))
                    };
                case "MultiPolygon":
                    return {
                        type: e1,
                        coordinates: n.map((t)=>t.map((t)=>bc(t.points)))
                    };
            }
        }
        function bc(t) {
            const e1 = [];
            for(let n = 0; n < t.length; n += 3)e1.push(wc(t[n], t[n + 1]));
            return e1;
        }
        function wc(t, e1) {
            return [
                _c(t),
                Sc(e1)
            ];
        }
        function _c(t) {
            return 360 * (t - .5);
        }
        function Sc(t) {
            const e1 = (180 - 360 * t) * Math.PI / 180;
            return 360 * Math.atan(Math.exp(e1)) / Math.PI - 90;
        }
        var Ac;
        function Mc(t, e1, n, r, i, s, o, a) {
            if (r /= e1, s >= (n /= e1) && o < r) return t;
            if (o < n || s >= r) return null;
            const l = [];
            for (const e1 of t){
                const t = i === Ac.X ? e1.minX : e1.minY, s = i === Ac.X ? e1.maxX : e1.maxY;
                if (t >= n && s < r) l.push(e1);
                else if (!(s < n || t >= r)) switch(e1.type){
                    case "Point":
                    case "MultiPoint":
                        kc(e1, l, n, r, i);
                        continue;
                    case "LineString":
                        Ic(e1, l, n, r, i, a);
                        continue;
                    case "MultiLineString":
                        Ec(e1, l, n, r, i);
                        continue;
                    case "Polygon":
                        Tc(e1, l, n, r, i);
                        continue;
                    case "MultiPolygon":
                        Fc(e1, l, n, r, i);
                        continue;
                }
            }
            return l.length ? l : null;
        }
        function kc(t, e1, n, r, i) {
            const s = [];
            (function(t, e1, n, r, i) {
                for(let s = 0; s < t.length; s += 3){
                    const o = t[s + i];
                    o >= n && o <= r && Bc(e1, t[s], t[s + 1], t[s + 2]);
                }
            })(t.geometry, s, n, r, i), s.length && e1.push(uc(t.id, 3 === s.length ? "Point" : "MultiPoint", s, t.tags));
        }
        function Ic(t, e1, n, r, i, s) {
            const o = [];
            if (Pc(t.geometry, o, n, r, i, !1, s.lineMetrics), o.length) {
                if (s.lineMetrics) for (const n of o)e1.push(uc(t.id, "LineString", n, t.tags));
                else e1.push(o.length > 1 ? uc(t.id, "MultiLineString", o, t.tags) : uc(t.id, "LineString", o[0], t.tags));
            }
        }
        function Ec(t, e1, n, r, i) {
            const s = [];
            zc(t.geometry, s, n, r, i, !1), s.length && e1.push(1 !== s.length ? uc(t.id, "MultiLineString", s, t.tags) : uc(t.id, "LineString", s[0], t.tags));
        }
        function Tc(t, e1, n, r, i) {
            const s = [];
            zc(t.geometry, s, n, r, i, !0), s.length && e1.push(uc(t.id, "Polygon", s, t.tags));
        }
        function Fc(t, e1, n, r, i) {
            const s = [];
            for (const e1 of t.geometry){
                const t = [];
                zc(e1, t, n, r, i, !0), t.length && s.push(t);
            }
            s.length && e1.push(uc(t.id, "MultiPolygon", s, t.tags));
        }
        function Pc(t, e1, n, r, i, s, o) {
            let a = Dc(t);
            const l = i === Ac.X ? Cc : Vc;
            let u, c, h = t.start;
            for(let p = 0; p < t.points.length - 3; p += 3){
                const f = t.points[p], d = t.points[p + 1], y = t.points[p + 2], m = t.points[p + 3], g = t.points[p + 4], x = i === Ac.X ? f : d, v = i === Ac.X ? m : g;
                let b = !1;
                o && (u = Math.sqrt(Math.pow(f - m, 2) + Math.pow(d - g, 2))), x < n ? v > n && (c = l(a, f, d, m, g, n), o && (a.start = h + u * c)) : x > r ? v < r && (c = l(a, f, d, m, g, r), o && (a.start = h + u * c)) : Bc(a.points, f, d, y), v < n && x >= n && (c = l(a, f, d, m, g, n), b = !0), v > r && x <= r && (c = l(a, f, d, m, g, r), b = !0), !s && b && (o && (a.end = h + u * c), e1.push(a), a = Dc(t)), o && (h += u);
            }
            let p = t.points.length - 3;
            const f = t.points[p], d = t.points[p + 1], y = i === Ac.X ? f : d;
            y >= n && y <= r && Bc(a.points, f, d, t.points[p + 2]), p = a.points.length - 3, s && p >= 3 && (a.points[p] !== a.points[0] || a.points[p + 1] !== a.points[1]) && Bc(a.points, a.points[0], a.points[1], a.points[2]), a.points.length && (cc(a), e1.push(a));
        }
        function Dc(t) {
            return {
                points: [],
                size: t.size,
                start: t.start,
                end: t.end
            };
        }
        function zc(t, e1, n, r, i, s) {
            for (const o of t)Pc(o, e1, n, r, i, s, !1);
        }
        function Bc(t, e1, n, r) {
            t.push(e1, n, r);
        }
        function Cc(t, e1, n, r, i, s) {
            const o = (s - e1) / (r - e1);
            return Bc(t.points, s, n + (i - n) * o, 1), o;
        }
        function Vc(t, e1, n, r, i, s) {
            const o = (s - n) / (i - n);
            return Bc(t.points, e1 + (r - e1) * o, s, 1), o;
        }
        function Lc(t, e1) {
            const n = e1.buffer / e1.extent;
            let r = t;
            const i = Mc(t, 1, -1 - n, n, Ac.X, -1, 2, e1), s = Mc(t, 1, 1 - n, 2 + n, Ac.X, -1, 2, e1);
            return i || s ? (r = Mc(t, 1, -n, 1 + n, Ac.X, -1, 2, e1) || [], i && (r = Oc(i, 1).concat(r)), s && (r = r.concat(Oc(s, -1))), r) : r;
        }
        function Oc(t, e1) {
            const n = [];
            for (const r of t)switch(r.type){
                case "Point":
                case "MultiPoint":
                    {
                        const t = $c(r.geometry, e1);
                        n.push(uc(r.id, r.type, t, r.tags));
                        continue;
                    }
                case "LineString":
                    {
                        const t = Rc(r.geometry, e1);
                        n.push(uc(r.id, r.type, t, r.tags));
                        continue;
                    }
                case "MultiLineString":
                case "Polygon":
                    {
                        const t = [];
                        for (const n of r.geometry)t.push(Rc(n, e1));
                        n.push(uc(r.id, r.type, t, r.tags));
                        continue;
                    }
                case "MultiPolygon":
                    {
                        const t = [];
                        for (const n of r.geometry){
                            const r = [];
                            for (const t of n)r.push(Rc(t, e1));
                            t.push(r);
                        }
                        n.push(uc(r.id, r.type, t, r.tags));
                        continue;
                    }
            }
            return n;
        }
        function $c(t, e1) {
            const n = [];
            for(let r = 0; r < t.length; r += 3)n.push(t[r] + e1, t[r + 1], t[r + 2]);
            return n;
        }
        function Rc(t, e1) {
            const n = {
                points: [],
                size: t.size
            };
            void 0 !== t.start && (n.start = t.start, n.end = t.end);
            for(let r = 0; r < t.points.length; r += 3)n.points.push(t.points[r] + e1, t.points[r + 1], t.points[r + 2]);
            return cc(n), n;
        }
        function Nc(t, e1, n) {
            const r = !!e1.newGeometry, i = e1.removeAllProperties || e1.removeProperties?.length > 0 || e1.addOrUpdateProperties?.length > 0;
            if (r) {
                const r = t[0];
                let s = pc({
                    type: "FeatureCollection",
                    features: [
                        {
                            type: "Feature",
                            id: r.id,
                            geometry: e1.newGeometry,
                            properties: i ? Uc(r.tags, e1) : r.tags
                        }
                    ]
                }, n);
                return s = Lc(s, n), s;
            }
            if (i) {
                const n = [];
                for (const r of t){
                    const t = {
                        ...r
                    };
                    t.tags = Uc(t.tags, e1), n.push(t);
                }
                return n;
            }
            return t;
        }
        function Uc(t, e1) {
            if (e1.removeAllProperties) return {};
            const n = {
                ...t || {}
            };
            if (e1.removeProperties) for (const t of e1.removeProperties)delete n[t];
            if (e1.addOrUpdateProperties) for (const { key: t, value: r } of e1.addOrUpdateProperties)n[t] = r;
            return n;
        }
        !function(t) {
            t[t.X = 0] = "X", t[t.Y = 1] = "Y";
        }(Ac || (Ac = {}));
        const jc = {
            minZoom: 0,
            maxZoom: 16,
            minPoints: 2,
            radius: 40,
            extent: 512,
            nodeSize: 64,
            log: !1,
            generateId: !1,
            reduce: null,
            map: (t)=>t
        };
        class qc {
            constructor(t){
                this.options = Object.assign(Object.create(jc), t), this.trees = new Array(this.options.maxZoom + 1), this.stride = this.options.reduce ? 7 : 6, this.clusterProps = [], this.points = [];
            }
            load(t) {
                const e1 = [];
                for (const n of t){
                    if (!n.geometry) continue;
                    const [t, r] = n.geometry.coordinates, [i, s] = [
                        mc(t),
                        gc(r)
                    ];
                    e1.push({
                        id: n.id,
                        type: "Point",
                        geometry: [
                            i,
                            s
                        ],
                        tags: n.properties
                    });
                }
                this.createIndex(e1);
            }
            initialize(t) {
                const e1 = [];
                for (const n of t)"Point" === n.type && e1.push(n);
                this.createIndex(e1);
            }
            updateIndex(t, e1, n) {
                this.options = Object.assign(Object.create(jc), n.clusterOptions), this.initialize(t);
            }
            createIndex(t) {
                const { log: e1, minZoom: n, maxZoom: r } = this.options;
                e1 && console.time("total time");
                const i = `prepare ${t.length} points`;
                e1 && console.time(i), this.points = t;
                const s = [];
                for(let e1 = 0; e1 < t.length; e1++){
                    const n = t[e1];
                    if (!n?.geometry) continue;
                    let [r, i] = n.geometry;
                    r = Math.fround(r), i = Math.fround(i), s.push(r, i, 1 / 0, e1, -1, 1), this.options.reduce && s.push(0);
                }
                let o = this.trees[r + 1] = this.createTree(s);
                e1 && console.timeEnd(i);
                for(let t = r; t >= n; t--){
                    const n = Date.now();
                    o = this.trees[t] = this.createTree(this.cluster(o, t)), e1 && console.log("z%d: %d clusters in %dms", t, o.numItems, Date.now() - n);
                }
                e1 && console.timeEnd("total time");
            }
            getClusters(t, e1) {
                return this.getClustersInternal(t, e1).map((t)=>xc(t));
            }
            getClustersInternal(t, e1) {
                let n = ((t[0] + 180) % 360 + 360) % 360 - 180;
                const r = Math.max(-90, Math.min(90, t[1]));
                let i = 180 === t[2] ? 180 : ((t[2] + 180) % 360 + 360) % 360 - 180;
                const s = Math.max(-90, Math.min(90, t[3]));
                if (t[2] - t[0] >= 360) n = -180, i = 180;
                else if (n > i) {
                    const t = this.getClustersInternal([
                        n,
                        r,
                        180,
                        s
                    ], e1), o = this.getClustersInternal([
                        -180,
                        r,
                        i,
                        s
                    ], e1);
                    return t.concat(o);
                }
                const o = this.trees[this.limitZoom(e1)], a = o.range(mc(n), gc(s), mc(i), gc(r)), l = o.flatData, u = [];
                for (const t of a){
                    const e1 = this.stride * t;
                    u.push(l[e1 + 5] > 1 ? Gc(l, e1, this.clusterProps) : this.points[l[e1 + 3]]);
                }
                return u;
            }
            getChildren(t) {
                const e1 = this.getOriginId(t), n = this.getOriginZoom(t), r = new Error("No cluster with the specified id: " + t), i = this.trees[n];
                if (!i) throw r;
                const s = i.flatData;
                if (e1 * this.stride >= s.length) throw r;
                const o = this.options.radius / (this.options.extent * Math.pow(2, n - 1)), a = i.within(s[e1 * this.stride], s[e1 * this.stride + 1], o), l = [];
                for (const e1 of a){
                    const n = e1 * this.stride;
                    s[n + 4] === t && l.push(s[n + 5] > 1 ? Xc(s, n, this.clusterProps) : xc(this.points[s[n + 3]]));
                }
                if (0 === l.length) throw r;
                return l;
            }
            getLeaves(t, e1, n) {
                const r = [];
                return this.appendLeaves(r, t, e1 = e1 || 10, n = n || 0, 0), r;
            }
            getTile(t, e1, n) {
                const r = this.trees[this.limitZoom(t)];
                if (!r) return null;
                const i = Math.pow(2, t), { extent: s, radius: o } = this.options, a = o / s, l = (n - a) / i, u = (n + 1 + a) / i, c = {
                    transformed: !0,
                    features: [],
                    source: null,
                    x: e1,
                    y: n,
                    z: t
                };
                return this.addTileFeatures(r.range((e1 - a) / i, l, (e1 + 1 + a) / i, u), r.flatData, e1, n, i, c), 0 === e1 && this.addTileFeatures(r.range(1 - a / i, l, 1, u), r.flatData, i, n, i, c), e1 === i - 1 && this.addTileFeatures(r.range(0, l, a / i, u), r.flatData, -1, n, i, c), c;
            }
            getClusterExpansionZoom(t) {
                return this.getOriginZoom(t);
            }
            appendLeaves(t, e1, n, r, i) {
                const s = this.getChildren(e1);
                for (const e1 of s){
                    const s = e1.properties;
                    if (s?.cluster ? i + s.point_count <= r ? i += s.point_count : i = this.appendLeaves(t, s.cluster_id, n, r, i) : i < r ? i++ : t.push(e1), t.length === n) break;
                }
                return i;
            }
            createTree(t) {
                const e1 = new ec(t.length / this.stride | 0, this.options.nodeSize, Float32Array);
                for(let n = 0; n < t.length; n += this.stride)e1.add(t[n], t[n + 1]);
                return e1.finish(), e1.flatData = t, e1.data = null, e1;
            }
            addTileFeatures(t, e1, n, r, i, s) {
                for (const o of t){
                    const t = o * this.stride, a = e1[t + 5] > 1;
                    let l, u, c;
                    if (a) l = Yc(e1, t, this.clusterProps), u = e1[t], c = e1[t + 1];
                    else {
                        const n = this.points[e1[t + 3]];
                        l = n.tags, [u, c] = n.geometry;
                    }
                    const h = {
                        type: 1,
                        geometry: [
                            [
                                Math.round(this.options.extent * (u * i - n)),
                                Math.round(this.options.extent * (c * i - r))
                            ]
                        ],
                        tags: l
                    };
                    let p;
                    p = a || this.options.generateId ? e1[t + 3] : this.points[e1[t + 3]].id, void 0 !== p && (h.id = p), s.features.push(h);
                }
            }
            limitZoom(t) {
                return Math.max(this.options.minZoom, Math.min(Math.floor(+t), this.options.maxZoom + 1));
            }
            cluster(t, e1) {
                const { radius: n, extent: r, reduce: i, minPoints: s } = this.options, o = n / (r * Math.pow(2, e1)), a = t.flatData, l = [], u = this.stride;
                for(let n = 0; n < a.length; n += u){
                    if (a[n + 2] <= e1) continue;
                    a[n + 2] = e1;
                    const r = a[n], c = a[n + 1], h = t.within(a[n], a[n + 1], o), p = a[n + 5];
                    let f = p;
                    for (const t of h){
                        const n = t * u;
                        a[n + 2] > e1 && (f += a[n + 5]);
                    }
                    if (f > p && f >= s) {
                        let t, s = r * p, o = c * p, d = -1;
                        const y = (n / u << 5) + (e1 + 1) + this.points.length;
                        for (const r of h){
                            const l = r * u;
                            if (a[l + 2] <= e1) continue;
                            a[l + 2] = e1;
                            const c = a[l + 5];
                            s += a[l] * c, o += a[l + 1] * c, a[l + 4] = y, i && (t || (t = this.map(a, n, !0), d = this.clusterProps.length, this.clusterProps.push(t)), i(t, this.map(a, l)));
                        }
                        a[n + 4] = y, l.push(s / f, o / f, 1 / 0, y, -1, f), i && l.push(d);
                    } else {
                        for(let t = 0; t < u; t++)l.push(a[n + t]);
                        if (f > 1) for (const t of h){
                            const n = t * u;
                            if (!(a[n + 2] <= e1)) {
                                a[n + 2] = e1;
                                for(let t = 0; t < u; t++)l.push(a[n + t]);
                            }
                        }
                    }
                }
                return l;
            }
            getOriginId(t) {
                return t - this.points.length >> 5;
            }
            getOriginZoom(t) {
                return (t - this.points.length) % 32;
            }
            map(t, e1, n) {
                if (t[e1 + 5] > 1) {
                    const r = this.clusterProps[t[e1 + 6]];
                    return n ? Object.assign({}, r) : r;
                }
                const r = this.points[t[e1 + 3]].tags, i = this.options.map(r);
                return n && i === r ? Object.assign({}, i) : i;
            }
        }
        function Gc(t, e1, n) {
            return {
                id: t[e1 + 3],
                type: "Point",
                tags: Yc(t, e1, n),
                geometry: [
                    t[e1],
                    t[e1 + 1]
                ]
            };
        }
        function Xc(t, e1, n) {
            return {
                type: "Feature",
                id: t[e1 + 3],
                properties: Yc(t, e1, n),
                geometry: {
                    type: "Point",
                    coordinates: [
                        _c(t[e1]),
                        Sc(t[e1 + 1])
                    ]
                }
            };
        }
        function Yc(t, e1, n) {
            const r = t[e1 + 5], i = r >= 1e4 ? `${Math.round(r / 1e3)}k` : r >= 1e3 ? Math.round(r / 100) / 10 + "k" : r, s = t[e1 + 6], o = -1 === s ? {} : Object.assign({}, n[s]);
            return Object.assign(o, {
                cluster: !0,
                cluster_id: t[e1 + 3],
                point_count: r,
                point_count_abbreviated: i
            });
        }
        const Zc = "geojsonvt_clip_start", Hc = "geojsonvt_clip_end";
        function Wc(t, e1, n, r, i) {
            const s = e1 === i.maxZoom ? 0 : i.tolerance / ((1 << e1) * i.extent), o = {
                transformed: !1,
                features: [],
                source: null,
                x: n,
                y: r,
                z: e1,
                minX: 2,
                minY: 1,
                maxX: -1,
                maxY: 0,
                numPoints: 0,
                numSimplified: 0,
                numFeatures: t.length
            };
            for (const e1 of t)Kc(o, e1, s, i);
            return o;
        }
        function Kc(t, e1, n, r) {
            switch(t.minX = Math.min(t.minX, e1.minX), t.minY = Math.min(t.minY, e1.minY), t.maxX = Math.max(t.maxX, e1.maxX), t.maxY = Math.max(t.maxY, e1.maxY), e1.type){
                case "Point":
                case "MultiPoint":
                    return void function(t, e1) {
                        const n = [];
                        for(let r = 0; r < e1.geometry.length; r += 3)n.push(e1.geometry[r], e1.geometry[r + 1]), t.numPoints++, t.numSimplified++;
                        if (!n.length) return;
                        const r = {
                            type: 1,
                            tags: e1.tags || null,
                            geometry: n
                        };
                        null !== e1.id && (r.id = e1.id), t.features.push(r);
                    }(t, e1);
                case "LineString":
                    return void function(t, e1, n, r) {
                        const i = [];
                        if (Jc(i, e1.geometry, t, n, !1, !1), !i.length) return;
                        let s = e1.tags || null;
                        if (r.lineMetrics) {
                            s = {};
                            for(const t in e1.tags)s[t] = e1.tags[t];
                            s[Zc] = e1.geometry.start / e1.geometry.size, s[Hc] = e1.geometry.end / e1.geometry.size;
                        }
                        const o = {
                            type: 2,
                            tags: s,
                            geometry: i
                        };
                        null !== e1.id && (o.id = e1.id), t.features.push(o);
                    }(t, e1, n, r);
                case "MultiLineString":
                case "Polygon":
                    return void function(t, e1, n) {
                        const r = [];
                        for(let i = 0; i < e1.geometry.length; i++)Jc(r, e1.geometry[i], t, n, "Polygon" === e1.type, 0 === i);
                        if (!r.length) return;
                        const i = {
                            type: "Polygon" === e1.type ? 3 : 2,
                            tags: e1.tags || null,
                            geometry: r
                        };
                        null !== e1.id && (i.id = e1.id), t.features.push(i);
                    }(t, e1, n);
                case "MultiPolygon":
                    return void function(t, e1, n) {
                        const r = [];
                        for(let i = 0; i < e1.geometry.length; i++){
                            const s = e1.geometry[i];
                            for(let e1 = 0; e1 < s.length; e1++)Jc(r, s[e1], t, n, !0, 0 === e1);
                        }
                        if (!r.length) return;
                        const i = {
                            type: 3,
                            tags: e1.tags || null,
                            geometry: r
                        };
                        null !== e1.id && (i.id = e1.id), t.features.push(i);
                    }(t, e1, n);
            }
        }
        function Jc(t, e1, n, r, i, s) {
            const o = r * r;
            if (r > 0 && e1.size < (i ? o : r)) return void (n.numPoints += e1.points.length / 3);
            const a = [];
            for(let t = 0; t < e1.points.length; t += 3)(0 === r || e1.points[t + 2] > o) && (n.numSimplified++, a.push(e1.points[t], e1.points[t + 1])), n.numPoints++;
            i && function(t, e1) {
                let n = 0;
                for(let e1 = 0, r = t.length, i = r - 2; e1 < r; i = e1, e1 += 2)n += (t[e1] - t[i]) * (t[e1 + 1] + t[i + 1]);
                if (n > 0 === e1) for(let e1 = 0, n = t.length; e1 < n / 2; e1 += 2){
                    const r = t[e1], i = t[e1 + 1];
                    t[e1] = t[n - 2 - e1], t[e1 + 1] = t[n - 1 - e1], t[n - 2 - e1] = r, t[n - 1 - e1] = i;
                }
            }(a, s), t.push(a);
        }
        function Qc(t, e1) {
            if (t.transformed) return t;
            const n = 1 << t.z, r = t.x, i = t.y;
            for (const s of t.features)1 === s.type ? th(s, e1, n, r, i) : eh(s, e1, n, r, i);
            return t.transformed = !0, t;
        }
        function th(t, e1, n, r, i) {
            const s = t, o = t.geometry, a = [];
            for(let t = 0; t < o.length; t += 2)a.push(nh(o[t], o[t + 1], e1, n, r, i));
            return s.geometry = a, s;
        }
        function eh(t, e1, n, r, i) {
            const s = t, o = t.geometry, a = [];
            for (const t of o){
                const s = [];
                for(let o = 0; o < t.length; o += 2)s.push(nh(t[o], t[o + 1], e1, n, r, i));
                a.push(s);
            }
            return s.geometry = a, s;
        }
        function nh(t, e1, n, r, i, s) {
            return [
                Math.round(n * (t * r - i)),
                Math.round(n * (e1 * r - s))
            ];
        }
        class rh {
            constructor(t){
                this.options = t, this.total = 0, this.stats = {}, this.tiles = {}, this.tileCoords = [], this.stats = {}, this.total = 0;
            }
            initialize(t) {
                this.splitTile(t, 0, 0, 0), this.options.debug && (t.length && console.log("features: %d, points: %d", this.tiles[0].numFeatures, this.tiles[0].numPoints), console.timeEnd("generate tiles"), console.log("tiles generated:", this.total, JSON.stringify(this.stats)));
            }
            updateIndex(t, e1, n) {
                n.debug > 1 && (console.log("invalidating tiles"), console.time("invalidating")), this.invalidateTiles(e1), n.debug > 1 && console.timeEnd("invalidating");
                const [r, i, s] = [
                    0,
                    0,
                    0
                ], o = Wc(t, r, i, s, n);
                o.source = t;
                const a = ih(r, i, s);
                if (this.tiles[a] = o, this.tileCoords.push({
                    z: r,
                    x: i,
                    y: s,
                    id: a
                }), n.debug) {
                    const t = `z${r}`;
                    this.stats[t] = (this.stats[t] || 0) + 1, this.total++;
                }
            }
            getClusterExpansionZoom(t) {
                return null;
            }
            getChildren(t) {
                return null;
            }
            getLeaves(t, e1, n) {
                return null;
            }
            getTile(t, e1, n) {
                const { extent: r, debug: i } = this.options, s = 1 << t, o = ih(t, e1 = e1 + s & s - 1, n);
                if (this.tiles[o]) return Qc(this.tiles[o], r);
                i > 1 && console.log("drilling down to z%d-%d-%d", t, e1, n);
                let a, l = t, u = e1, c = n;
                for(; !a && l > 0;)l--, u >>= 1, c >>= 1, a = this.tiles[ih(l, u, c)];
                return a?.source ? (i > 1 && (console.log("found parent tile z%d-%d-%d", l, u, c), console.time("drilling down")), this.splitTile(a.source, l, u, c, t, e1, n), i > 1 && console.timeEnd("drilling down"), this.tiles[o] ? Qc(this.tiles[o], r) : null) : null;
            }
            splitTile(t, e1, n, r, i, s, o) {
                const a = [
                    t,
                    e1,
                    n,
                    r
                ], l = this.options, u = l.debug;
                for(; a.length;){
                    r = a.pop(), n = a.pop(), e1 = a.pop(), t = a.pop();
                    const c = 1 << e1, h = ih(e1, n, r);
                    let p = this.tiles[h];
                    if (!p && (u > 1 && console.time("creation"), p = this.tiles[h] = Wc(t, e1, n, r, l), this.tileCoords.push({
                        z: e1,
                        x: n,
                        y: r,
                        id: h
                    }), u)) {
                        u > 1 && (console.log("tile z%d-%d-%d (features: %d, points: %d, simplified: %d)", e1, n, r, p.numFeatures, p.numPoints, p.numSimplified), console.timeEnd("creation"));
                        const t = `z${e1}`;
                        this.stats[t] = (this.stats[t] || 0) + 1, this.total++;
                    }
                    if (p.source = t, null == i) {
                        if (e1 === l.indexMaxZoom || p.numPoints <= l.indexMaxPoints) continue;
                    } else {
                        if (e1 === l.maxZoom || e1 === i) continue;
                        if (null != i) {
                            const t = i - e1;
                            if (n !== s >> t || r !== o >> t) continue;
                        }
                    }
                    if (p.source = null, !t.length) continue;
                    u > 1 && console.time("clipping");
                    const f = .5 * l.buffer / l.extent, d = .5 - f, y = .5 + f, m = 1 + f;
                    let g = null, x = null, v = null, b = null;
                    const w = Mc(t, c, n - f, n + y, Ac.X, p.minX, p.maxX, l), _ = Mc(t, c, n + d, n + m, Ac.X, p.minX, p.maxX, l);
                    w && (g = Mc(w, c, r - f, r + y, Ac.Y, p.minY, p.maxY, l), x = Mc(w, c, r + d, r + m, Ac.Y, p.minY, p.maxY, l)), _ && (v = Mc(_, c, r - f, r + y, Ac.Y, p.minY, p.maxY, l), b = Mc(_, c, r + d, r + m, Ac.Y, p.minY, p.maxY, l)), u > 1 && console.timeEnd("clipping"), a.push(g || [], e1 + 1, 2 * n, 2 * r), a.push(x || [], e1 + 1, 2 * n, 2 * r + 1), a.push(v || [], e1 + 1, 2 * n + 1, 2 * r), a.push(b || [], e1 + 1, 2 * n + 1, 2 * r + 1);
                }
            }
            invalidateTiles(t) {
                if (!t.length) return;
                const e1 = this.options, { debug: n } = e1;
                let r = 1 / 0, i = -1 / 0, s = 1 / 0, o = -1 / 0;
                for (const e1 of t)r = Math.min(r, e1.minX), i = Math.max(i, e1.maxX), s = Math.min(s, e1.minY), o = Math.max(o, e1.maxY);
                const a = e1.buffer / e1.extent, l = new Set;
                for(const e1 in this.tiles){
                    const u = this.tiles[e1], c = 1 << u.z, h = (u.x - a) / c, p = (u.x + 1 + a) / c, f = (u.y - a) / c, d = (u.y + 1 + a) / c;
                    if (i < h || r >= p || o < f || s >= d) continue;
                    let y = !1;
                    for (const e1 of t)if (e1.maxX >= h && e1.minX < p && e1.maxY >= f && e1.minY < d) {
                        y = !0;
                        break;
                    }
                    if (y) {
                        if (n) {
                            n > 1 && console.log("invalidate tile z%d-%d-%d (features: %d, points: %d, simplified: %d)", u.z, u.x, u.y, u.numFeatures, u.numPoints, u.numSimplified);
                            const t = `z${u.z}`;
                            this.stats[t] = (this.stats[t] || 0) - 1, this.total--;
                        }
                        delete this.tiles[e1], l.add(e1);
                    }
                }
                l.size && (this.tileCoords = this.tileCoords.filter((t)=>!l.has(t.id)));
            }
        }
        function ih(t, e1, n) {
            return 32 * ((1 << t) * n + e1) + t;
        }
        const sh = {
            maxZoom: 14,
            indexMaxZoom: 5,
            indexMaxPoints: 1e5,
            tolerance: 3,
            extent: 4096,
            buffer: 64,
            lineMetrics: !1,
            promoteId: null,
            generateId: !1,
            updateable: !1,
            cluster: !1,
            clusterOptions: jc,
            debug: 0
        }, oh = ao([
            {
                name: "a_pos_normal",
                components: 2,
                type: "Int16"
            },
            {
                name: "a_data",
                components: 4,
                type: "Uint8"
            }
        ], 4), { members: ah } = oh, lh = ao([
            {
                name: "a_uv_x",
                components: 1,
                type: "Float32"
            },
            {
                name: "a_split_index",
                components: 1,
                type: "Float32"
            }
        ]), { members: uh } = lh, ch = Math.cos(Math.PI / 180 * 37.5), hh = Math.pow(2, 14) / .5;
        class ph {
            constructor(t){
                this.zoom = t.zoom, this.overscaling = t.overscaling, this.layers = t.layers, this.layerIds = this.layers.map((t)=>t.id), this.index = t.index, this.hasDependencies = !1, this.patternFeatures = [], this.lineClipsArray = [], this.gradients = {};
                for (const t of this.layers)this.gradients[t.id] = {};
                this.layoutVertexArray = new Wo, this.layoutVertexArray2 = new Ko, this.indexArray = new sa, this.programConfigurations = new $a(t.layers, t.zoom), this.segments = new ua, this.maxLineLength = 0, this.stateDependentLayerIds = this.layers.filter((t)=>t.isStateDependent()).map((t)=>t.id);
            }
            populate(t, e1, n) {
                this.hasDependencies = ql("line", this.layers, e1) || this.hasLineDasharray(this.layers);
                const r = this.layers[0].layout.get("line-sort-key"), i = !r.isConstant(), s = [];
                for (const { feature: e1, id: o, index: a, sourceLayerIndex: l } of t){
                    const t = this.layers[0]._featureFilter.needGeometry, u = Ga(e1, t);
                    if (!this.layers[0]._featureFilter.filter(new Cs(this.zoom), u, n)) continue;
                    const c = i ? r.evaluate(u, {}, n) : void 0, h = {
                        id: o,
                        properties: e1.properties,
                        type: e1.type,
                        sourceLayerIndex: l,
                        index: a,
                        geometry: t ? u.geometry : qa(e1),
                        patterns: {},
                        dashes: {},
                        sortKey: c
                    };
                    s.push(h);
                }
                i && s.sort((t, e1)=>t.sortKey - e1.sortKey);
                for (const r of s){
                    const { geometry: i, index: s, sourceLayerIndex: o } = r;
                    this.hasDependencies ? (ql("line", this.layers, e1) ? Gl("line", this.layers, r, {
                        zoom: this.zoom
                    }, e1) : this.hasLineDasharray(this.layers) && this.addLineDashDependencies(this.layers, r, this.zoom, e1), this.patternFeatures.push(r)) : this.addFeature(r, i, s, n, {}, {}, e1.subdivisionGranularity), e1.featureIndex.insert(t[s].feature, i, s, o, this.index);
                }
            }
            update(t, e1, n, r) {
                this.stateDependentLayers.length && this.programConfigurations.updatePaintArrays(t, e1, this.stateDependentLayers, {
                    imagePositions: n,
                    dashPositions: r
                });
            }
            addFeatures(t, e1, n, r) {
                for (const i of this.patternFeatures)this.addFeature(i, i.geometry, i.index, e1, n, r, t.subdivisionGranularity);
            }
            isEmpty() {
                return 0 === this.layoutVertexArray.length;
            }
            uploadPending() {
                return !this.uploaded || this.programConfigurations.needsUpload;
            }
            upload(t) {
                this.uploaded || (0 !== this.layoutVertexArray2.length && (this.layoutVertexBuffer2 = t.createVertexBuffer(this.layoutVertexArray2, uh)), this.layoutVertexBuffer = t.createVertexBuffer(this.layoutVertexArray, ah), this.indexBuffer = t.createIndexBuffer(this.indexArray)), this.programConfigurations.upload(t), this.uploaded = !0;
            }
            destroy() {
                this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.programConfigurations.destroy(), this.segments.destroy());
            }
            lineFeatureClips(t) {
                if (t.properties && Object.hasOwn(t.properties, Zc) && Object.hasOwn(t.properties, Hc)) return {
                    start: +t.properties[Zc],
                    end: +t.properties[Hc]
                };
            }
            addFeature(t, e1, n, r, i, s, o) {
                const a = this.layers[0].layout, l = a.get("line-join").evaluate(t, {}), u = a.get("line-cap").evaluate(t, {}), c = a.get("line-miter-limit").evaluate(t, {}), h = a.get("line-round-limit").evaluate(t, {});
                this.lineClips = this.lineFeatureClips(t);
                for (const n of e1)this.addLine(n, t, l, u, c, h, r, o);
                this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length, t, n, {
                    imagePositions: i,
                    dashPositions: s,
                    canonical: r
                });
            }
            addLine(t, e1, n, r, i, s, o, a) {
                if (this.distance = 0, this.scaledDistance = 0, this.totalDistance = 0, t = Su(t, o ? a.line.getGranularityForZoomLevel(o.z) : 1), this.lineClips) {
                    this.lineClipsArray.push(this.lineClips);
                    for(let e1 = 0; e1 < t.length - 1; e1++)this.totalDistance += t[e1].dist(t[e1 + 1]);
                    this.updateScaledDistance(), this.maxLineLength = Math.max(this.maxLineLength, this.totalDistance);
                }
                const l = "Polygon" === Cu.types[e1.type];
                let u = t.length;
                for(; u >= 2 && t[u - 1].equals(t[u - 2]);)u--;
                let c = 0;
                for(; c < u - 1 && t[c].equals(t[c + 1]);)c++;
                if (u < (l ? 3 : 2)) return;
                "bevel" === n && (i = 1.05);
                const h = this.overscaling <= 16 ? 122880 / (512 * this.overscaling) : 0, p = this.segments.prepareSegment(10 * u, this.layoutVertexArray, this.indexArray);
                let f, d, y, m, g;
                this.e1 = this.e2 = -1, l && (f = t[u - 2], g = t[c].sub(f)._unit()._perp());
                for(let e1 = c; e1 < u; e1++){
                    if (y = e1 === u - 1 ? l ? t[c + 1] : void 0 : t[e1 + 1], y && t[e1].equals(y)) continue;
                    g && (m = g), f && (d = f), f = t[e1], g = y ? y.sub(f)._unit()._perp() : m, m || (m = g);
                    let o = m.add(g);
                    0 === o.x && 0 === o.y || o._unit();
                    const a = m.x * g.x + m.y * g.y, x = o.x * g.x + o.y * g.y, v = 0 !== x ? 1 / x : 1 / 0, b = 2 * Math.sqrt(2 - 2 * x), w = x < ch && d && y, _ = m.x * g.y - m.y * g.x > 0;
                    if (w && e1 > c) {
                        const t = f.dist(d);
                        if (t > 2 * h) {
                            const e1 = f.sub(f.sub(d)._mult(h / t)._round());
                            this.updateDistance(d, e1), this.addCurrentVertex(e1, m, 0, 0, p), d = e1;
                        }
                    }
                    const S = d && y;
                    let A = S ? n : l ? "butt" : r;
                    if (S && "round" === A && (v < s ? A = "miter" : v <= 2 && (A = "fakeround")), "miter" === A && v > i && (A = "bevel"), "bevel" === A && (v > 2 && (A = "flipbevel"), v < i && (A = "miter")), d && this.updateDistance(d, f), "miter" === A) o._mult(v), this.addCurrentVertex(f, o, 0, 0, p);
                    else if ("flipbevel" === A) {
                        if (v > 100) o = g.mult(-1);
                        else {
                            const t = v * m.add(g).mag() / m.sub(g).mag();
                            o._perp()._mult(t * (_ ? -1 : 1));
                        }
                        this.addCurrentVertex(f, o, 0, 0, p), this.addCurrentVertex(f, o.mult(-1), 0, 0, p);
                    } else if ("bevel" === A || "fakeround" === A) {
                        const t = -Math.sqrt(v * v - 1), e1 = _ ? t : 0, n = _ ? 0 : t;
                        if (d && this.addCurrentVertex(f, m, e1, n, p), "fakeround" === A) {
                            const t = Math.round(180 * b / Math.PI / 20);
                            for(let e1 = 1; e1 < t; e1++){
                                let n = e1 / t;
                                if (.5 !== n) {
                                    const t = n - .5;
                                    n += n * t * (n - 1) * ((1.0904 + a * (a * (3.55645 - 1.43519 * a) - 3.2452)) * t * t + (.848013 + a * (.215638 * a - 1.06021)));
                                }
                                const r = g.sub(m)._mult(n)._add(m)._unit()._mult(_ ? -1 : 1);
                                this.addHalfVertex(f, r.x, r.y, !1, _, 0, p);
                            }
                        }
                        y && this.addCurrentVertex(f, g, -e1, -n, p);
                    } else if ("butt" === A) this.addCurrentVertex(f, o, 0, 0, p);
                    else if ("square" === A) {
                        const t = d ? 1 : -1;
                        this.addCurrentVertex(f, o, t, t, p);
                    } else "round" === A && (d && (this.addCurrentVertex(f, m, 0, 0, p), this.addCurrentVertex(f, m, 1, 1, p, !0)), y && (this.addCurrentVertex(f, g, -1, -1, p, !0), this.addCurrentVertex(f, g, 0, 0, p)));
                    if (w && e1 < u - 1) {
                        const t = f.dist(y);
                        if (t > 2 * h) {
                            const e1 = f.add(y.sub(f)._mult(h / t)._round());
                            this.updateDistance(f, e1), this.addCurrentVertex(e1, g, 0, 0, p), f = e1;
                        }
                    }
                }
            }
            addCurrentVertex(t, e1, n, r, i, s = !1) {
                const o = e1.y * r - e1.x, a = -e1.y - e1.x * r;
                this.addHalfVertex(t, e1.x + e1.y * n, e1.y - e1.x * n, s, !1, n, i), this.addHalfVertex(t, o, a, s, !0, -r, i), this.distance > hh / 2 && 0 === this.totalDistance && (this.distance = 0, this.updateScaledDistance(), this.addCurrentVertex(t, e1, n, r, i, s));
            }
            addHalfVertex({ x: t, y: e1 }, n, r, i, s, o, a) {
                const l = .5 * (this.lineClips ? this.scaledDistance * (hh - 1) : this.scaledDistance);
                this.layoutVertexArray.emplaceBack((t << 1) + (i ? 1 : 0), (e1 << 1) + (s ? 1 : 0), Math.round(63 * n) + 128, Math.round(63 * r) + 128, 1 + (0 === o ? 0 : o < 0 ? -1 : 1) | (63 & l) << 2, l >> 6), this.lineClips && this.layoutVertexArray2.emplaceBack((this.scaledDistance - this.lineClips.start) / (this.lineClips.end - this.lineClips.start), this.lineClipsArray.length);
                const u = a.vertexLength++;
                this.e1 >= 0 && this.e2 >= 0 && (this.indexArray.emplaceBack(this.e1, u, this.e2), a.primitiveLength++), s ? this.e2 = u : this.e1 = u;
            }
            updateScaledDistance() {
                this.scaledDistance = this.lineClips ? this.lineClips.start + (this.lineClips.end - this.lineClips.start) * this.distance / this.totalDistance : this.distance;
            }
            updateDistance(t, e1) {
                this.distance += t.dist(e1), this.updateScaledDistance();
            }
            hasLineDasharray(t) {
                for (const e1 of t){
                    const t = e1.paint.get("line-dasharray");
                    if (t && !t.isConstant()) return !0;
                }
                return !1;
            }
            addLineDashDependencies(t, e1, n, r) {
                for (const i of t){
                    const t = i.paint.get("line-dasharray");
                    if (!t || "constant" === t.value.kind) continue;
                    const s = "round" === i.layout.get("line-cap").evaluate(e1, {}), o = {
                        dasharray: t.value.evaluate({
                            zoom: n - 1
                        }, e1, {}),
                        round: s
                    }, a = {
                        dasharray: t.value.evaluate({
                            zoom: n
                        }, e1, {}),
                        round: s
                    }, l = {
                        dasharray: t.value.evaluate({
                            zoom: n + 1
                        }, e1, {}),
                        round: s
                    }, u = `${o.dasharray.join(",")},${o.round}`, c = `${a.dasharray.join(",")},${a.round}`, h = `${l.dasharray.join(",")},${l.round}`;
                    r.dashDependencies[u] = o, r.dashDependencies[c] = a, r.dashDependencies[h] = l, e1.dashes[i.id] = {
                        min: u,
                        mid: c,
                        max: h
                    };
                }
            }
        }
        let fh, dh;
        ds("LineBucket", ph, {
            omit: [
                "layers",
                "patternFeatures"
            ]
        });
        var yh = {
            get paint () {
                return dh = dh || new Ks({
                    "line-opacity": new Ys(wt.paint_line["line-opacity"]),
                    "line-color": new Ys(wt.paint_line["line-color"]),
                    "line-translate": new Xs(wt.paint_line["line-translate"]),
                    "line-translate-anchor": new Xs(wt.paint_line["line-translate-anchor"]),
                    "line-width": new Ys(wt.paint_line["line-width"]),
                    "line-gap-width": new Ys(wt.paint_line["line-gap-width"]),
                    "line-offset": new Ys(wt.paint_line["line-offset"]),
                    "line-blur": new Ys(wt.paint_line["line-blur"]),
                    "line-dasharray": new Zs(wt.paint_line["line-dasharray"]),
                    "line-pattern": new Zs(wt.paint_line["line-pattern"]),
                    "line-gradient": new Ws(wt.paint_line["line-gradient"])
                });
            },
            get layout () {
                return fh = fh || new Ks({
                    "line-cap": new Ys(wt.layout_line["line-cap"]),
                    "line-join": new Ys(wt.layout_line["line-join"]),
                    "line-miter-limit": new Ys(wt.layout_line["line-miter-limit"]),
                    "line-round-limit": new Ys(wt.layout_line["line-round-limit"]),
                    "line-sort-key": new Ys(wt.layout_line["line-sort-key"])
                });
            }
        };
        class mh extends Ys {
            possiblyEvaluate(t, e1) {
                return e1 = new Cs(Math.floor(e1.zoom), {
                    now: e1.now,
                    fadeDuration: e1.fadeDuration,
                    zoomHistory: e1.zoomHistory,
                    transition: e1.transition
                }), super.possiblyEvaluate(t, e1);
            }
            evaluate(t, e1, n, r) {
                return e1 = $({}, e1, {
                    zoom: Math.floor(e1.zoom)
                }), super.evaluate(t, e1, n, r);
            }
        }
        let gh;
        class xh extends to {
            constructor(t, e1){
                super(t, yh, e1), this.gradientVersion = 0, gh || (gh = new mh(yh.paint.properties["line-width"].specification), gh.useIntegerZoom = !0);
            }
            _handleSpecialPaintPropertyUpdate(t) {
                if ("line-gradient" === t) {
                    const t = this.gradientExpression();
                    this.stepInterpolant = !!function(t) {
                        return void 0 !== t._styleExpression;
                    }(t) && t._styleExpression.expression instanceof cn, this.gradientVersion = (this.gradientVersion + 1) % Number.MAX_SAFE_INTEGER;
                }
            }
            gradientExpression() {
                return this._transitionablePaint._values["line-gradient"].value.expression;
            }
            recalculate(t, e1) {
                super.recalculate(t, e1), this.paint._values["line-floorwidth"] = gh.possiblyEvaluate(this._transitioningPaint._values["line-width"].value, t);
            }
            createBucket(t) {
                return new ph(t);
            }
            queryRadius(t) {
                const e1 = t, n = vh(ol("line-width", this, e1), ol("line-gap-width", this, e1)), r = ol("line-offset", this, e1);
                return n / 2 + Math.abs(r) + al(this.paint.get("line-translate"));
            }
            queryIntersectsFeature({ queryGeometry: t, feature: e1, featureState: r, geometry: i, transform: s, pixelsToTileUnits: o }) {
                const a = ll(t, this.paint.get("line-translate"), this.paint.get("line-translate-anchor"), -s.bearingInRadians, o), l = o / 2 * vh(this.paint.get("line-width").evaluate(e1, r), this.paint.get("line-gap-width").evaluate(e1, r)), u = this.paint.get("line-offset").evaluate(e1, r);
                return u && (i = function(t, e1) {
                    const r = [];
                    for (const i of t){
                        const t = ul(i), s = [];
                        for(let r = 0; r < t.length; r++){
                            const i = t[r], o = t[r - 1], a = t[r + 1], l = 0 === r ? new n(0, 0) : i.sub(o)._unit()._perp(), u = r === t.length - 1 ? new n(0, 0) : a.sub(i)._unit()._perp(), c = l._add(u)._unit(), h = c.x * u.x + c.y * u.y;
                            0 !== h && c._mult(1 / h), s.push(c._mult(e1)._add(i));
                        }
                        r.push(s);
                    }
                    return r;
                }(i, u * o)), function(t, e1, n) {
                    for (const r of e1){
                        if (t.length >= 3) {
                            for (const e1 of r)if (il(t, e1)) return !0;
                        }
                        if (Ja(t, r, n)) return !0;
                    }
                    return !1;
                }(a, i, l);
            }
            isTileClipped() {
                return !0;
            }
        }
        function vh(t, e1) {
            return e1 > 0 ? e1 + 2 * t : t;
        }
        const bh = ao([
            {
                name: "a_pos_offset",
                components: 4,
                type: "Int16"
            },
            {
                name: "a_data",
                components: 4,
                type: "Uint16"
            },
            {
                name: "a_pixeloffset",
                components: 4,
                type: "Int16"
            }
        ], 4), wh = ao([
            {
                name: "a_projected_pos",
                components: 3,
                type: "Float32"
            }
        ], 4);
        ao([
            {
                name: "a_fade_opacity",
                components: 1,
                type: "Uint32"
            }
        ], 4);
        const _h = ao([
            {
                name: "a_placed",
                components: 2,
                type: "Uint8"
            },
            {
                name: "a_shift",
                components: 2,
                type: "Float32"
            },
            {
                name: "a_box_real",
                components: 2,
                type: "Int16"
            }
        ]);
        ao([
            {
                type: "Int16",
                name: "anchorPointX"
            },
            {
                type: "Int16",
                name: "anchorPointY"
            },
            {
                type: "Int16",
                name: "x1"
            },
            {
                type: "Int16",
                name: "y1"
            },
            {
                type: "Int16",
                name: "x2"
            },
            {
                type: "Int16",
                name: "y2"
            },
            {
                type: "Uint32",
                name: "featureIndex"
            },
            {
                type: "Uint16",
                name: "sourceLayerIndex"
            },
            {
                type: "Uint16",
                name: "bucketIndex"
            }
        ]);
        const Sh = ao([
            {
                name: "a_pos",
                components: 2,
                type: "Int16"
            },
            {
                name: "a_anchor_pos",
                components: 2,
                type: "Int16"
            },
            {
                name: "a_extrude",
                components: 2,
                type: "Int16"
            }
        ], 4), Ah = ao([
            {
                name: "a_pos",
                components: 2,
                type: "Float32"
            },
            {
                name: "a_radius",
                components: 1,
                type: "Float32"
            },
            {
                name: "a_flags",
                components: 2,
                type: "Int16"
            }
        ], 4);
        function Mh(t, e1, n) {
            const r = e1.layout.get("text-transform").evaluate(n, {});
            return "uppercase" === r ? t = t.toLocaleUpperCase() : "lowercase" === r && (t = t.toLocaleLowerCase()), Bs.applyArabicShaping && (t = Bs.applyArabicShaping(t)), t;
        }
        function kh(t, e1, n) {
            for (const r of t.sections)r.text = Mh(r.text, e1, n);
            return t;
        }
        ao([
            {
                name: "triangle",
                components: 3,
                type: "Uint16"
            }
        ]), ao([
            {
                type: "Int16",
                name: "anchorX"
            },
            {
                type: "Int16",
                name: "anchorY"
            },
            {
                type: "Uint16",
                name: "glyphStartIndex"
            },
            {
                type: "Uint16",
                name: "numGlyphs"
            },
            {
                type: "Uint32",
                name: "vertexStartIndex"
            },
            {
                type: "Uint32",
                name: "lineStartIndex"
            },
            {
                type: "Uint32",
                name: "lineLength"
            },
            {
                type: "Uint16",
                name: "segment"
            },
            {
                type: "Uint16",
                name: "lowerSize"
            },
            {
                type: "Uint16",
                name: "upperSize"
            },
            {
                type: "Float32",
                name: "lineOffsetX"
            },
            {
                type: "Float32",
                name: "lineOffsetY"
            },
            {
                type: "Uint8",
                name: "writingMode"
            },
            {
                type: "Uint8",
                name: "placedOrientation"
            },
            {
                type: "Uint8",
                name: "hidden"
            },
            {
                type: "Uint32",
                name: "crossTileID"
            },
            {
                type: "Int16",
                name: "associatedIconIndex"
            }
        ]), ao([
            {
                type: "Int16",
                name: "anchorX"
            },
            {
                type: "Int16",
                name: "anchorY"
            },
            {
                type: "Int16",
                name: "rightJustifiedTextSymbolIndex"
            },
            {
                type: "Int16",
                name: "centerJustifiedTextSymbolIndex"
            },
            {
                type: "Int16",
                name: "leftJustifiedTextSymbolIndex"
            },
            {
                type: "Int16",
                name: "verticalPlacedTextSymbolIndex"
            },
            {
                type: "Int16",
                name: "placedIconSymbolIndex"
            },
            {
                type: "Int16",
                name: "verticalPlacedIconSymbolIndex"
            },
            {
                type: "Uint16",
                name: "key"
            },
            {
                type: "Uint16",
                name: "textBoxStartIndex"
            },
            {
                type: "Uint16",
                name: "textBoxEndIndex"
            },
            {
                type: "Uint16",
                name: "verticalTextBoxStartIndex"
            },
            {
                type: "Uint16",
                name: "verticalTextBoxEndIndex"
            },
            {
                type: "Uint16",
                name: "iconBoxStartIndex"
            },
            {
                type: "Uint16",
                name: "iconBoxEndIndex"
            },
            {
                type: "Uint16",
                name: "verticalIconBoxStartIndex"
            },
            {
                type: "Uint16",
                name: "verticalIconBoxEndIndex"
            },
            {
                type: "Uint16",
                name: "featureIndex"
            },
            {
                type: "Uint16",
                name: "numHorizontalGlyphVertices"
            },
            {
                type: "Uint16",
                name: "numVerticalGlyphVertices"
            },
            {
                type: "Uint16",
                name: "numIconVertices"
            },
            {
                type: "Uint16",
                name: "numVerticalIconVertices"
            },
            {
                type: "Uint16",
                name: "useRuntimeCollisionCircles"
            },
            {
                type: "Uint32",
                name: "crossTileID"
            },
            {
                type: "Float32",
                name: "textBoxScale"
            },
            {
                type: "Float32",
                name: "collisionCircleDiameter"
            },
            {
                type: "Uint16",
                name: "textAnchorOffsetStartIndex"
            },
            {
                type: "Uint16",
                name: "textAnchorOffsetEndIndex"
            }
        ]), ao([
            {
                type: "Float32",
                name: "offsetX"
            }
        ]), ao([
            {
                type: "Int16",
                name: "x"
            },
            {
                type: "Int16",
                name: "y"
            },
            {
                type: "Int16",
                name: "tileUnitDistanceFromAnchor"
            }
        ]), ao([
            {
                type: "Uint16",
                name: "textAnchor"
            },
            {
                type: "Float32",
                components: 2,
                name: "textOffset"
            }
        ]);
        var Ih = 24;
        const Eh = {
            "!": "\uFE15",
            "#": "\uFF03",
            $: "\uFF04",
            "%": "\uFF05",
            "&": "\uFF06",
            "(": "\uFE35",
            ")": "\uFE36",
            "*": "\uFF0A",
            "+": "\uFF0B",
            ",": "\uFE10",
            "-": "\uFE32",
            ".": "\u30FB",
            "/": "\uFF0F",
            ":": "\uFE13",
            ";": "\uFE14",
            "<": "\uFE3F",
            "=": "\uFF1D",
            ">": "\uFE40",
            "?": "\uFE16",
            "@": "\uFF20",
            "[": "\uFE47",
            "\\": "\uFF3C",
            "]": "\uFE48",
            "^": "\uFF3E",
            _: "\uFE33",
            "`": "\uFF40",
            "{": "\uFE37",
            "|": "\u2015",
            "}": "\uFE38",
            "~": "\uFF5E",
            "\xa2": "\uFFE0",
            "\xa3": "\uFFE1",
            "\xa5": "\uFFE5",
            "\xa6": "\uFFE4",
            "\xac": "\uFFE2",
            "\xaf": "\uFFE3",
            "\u2013": "\uFE32",
            "\u2014": "\uFE31",
            "\u2018": "\uFE43",
            "\u2019": "\uFE44",
            "\u201C": "\uFE41",
            "\u201D": "\uFE42",
            "\u2026": "\uFE19",
            "\u22EF": "\uFE19",
            "\u2027": "\u30FB",
            "\u20A9": "\uFFE6",
            "\u3001": "\uFE11",
            "\u3002": "\uFE12",
            "\u3008": "\uFE3F",
            "\u3009": "\uFE40",
            "\u300A": "\uFE3D",
            "\u300B": "\uFE3E",
            "\u300C": "\uFE41",
            "\u300D": "\uFE42",
            "\u300E": "\uFE43",
            "\u300F": "\uFE44",
            "\u3010": "\uFE3B",
            "\u3011": "\uFE3C",
            "\u3014": "\uFE39",
            "\u3015": "\uFE3A",
            "\u3016": "\uFE17",
            "\u3017": "\uFE18",
            "\uFF01": "\uFE15",
            "\uFF08": "\uFE35",
            "\uFF09": "\uFE36",
            "\uFF0C": "\uFE10",
            "\uFF0D": "\uFE32",
            "\uFF0E": "\u30FB",
            "\uFF1A": "\uFE13",
            "\uFF1B": "\uFE14",
            "\uFF1C": "\uFE3F",
            "\uFF1E": "\uFE40",
            "\uFF1F": "\uFE16",
            "\uFF3B": "\uFE47",
            "\uFF3D": "\uFE48",
            "\uFF3F": "\uFE33",
            "\uFF5B": "\uFE37",
            "\uFF5C": "\u2015",
            "\uFF5D": "\uFE38",
            "\uFF5F": "\uFE35",
            "\uFF60": "\uFE36",
            "\uFF61": "\uFE12",
            "\uFF62": "\uFE41",
            "\uFF63": "\uFE42"
        }, Th = {
            10: !0,
            32: !0,
            38: !0,
            41: !0,
            43: !0,
            45: !0,
            47: !0,
            173: !0,
            183: !0,
            8203: !0,
            8208: !0,
            8211: !0,
            8231: !0
        }, Fh = {
            40: !0
        };
        function Ph(t, e1, n, r, i, s) {
            if ("fontStack" in e1) {
                const r = n[e1.fontStack], s = null == r ? void 0 : r[t];
                return s ? s.metrics.advance * e1.scale + i : 0;
            }
            {
                const t = r[e1.imageName];
                return t ? t.displaySize[0] * e1.scale * Ih / s + i : 0;
            }
        }
        function Dh(t, e1, n, r) {
            const i = Math.pow(t - e1, 2);
            return r ? t < e1 ? i / 2 : 2 * i : i + Math.abs(n) * n;
        }
        function zh(t, e1, n) {
            let r = 0;
            return 10 === t && (r -= 1e4), n && (r += 150), 40 !== t && 65288 !== t || (r += 50), 41 !== e1 && 65289 !== e1 || (r += 50), r;
        }
        function Bh(t, e1, n, r, i, s) {
            let o = null, a = Dh(e1, n, i, s);
            for (const t of r){
                const r = Dh(e1 - t.x, n, i, s) + t.badness;
                r <= a && (o = t, a = r);
            }
            return {
                index: t,
                x: e1,
                priorBreak: o,
                badness: a
            };
        }
        function Ch(t) {
            return t ? Ch(t.priorBreak).concat(t.index) : [];
        }
        class Vh {
            constructor(t = "", e1 = [], n = []){
                this.text = t, this.sections = e1, this.sectionIndex = n, this.imageSectionID = null;
            }
            static fromFeature(t, e1) {
                const n = new Vh;
                for (const r of t.sections)r.image ? n.addImageSection(r) : n.addTextSection(r, e1);
                return n;
            }
            length() {
                return [
                    ...this.text
                ].length;
            }
            getSection(t) {
                return this.sections[this.sectionIndex[t]];
            }
            getSectionIndex(t) {
                return this.sectionIndex[t];
            }
            verticalizePunctuation() {
                this.text = function(t) {
                    let e1 = "", n = {
                        premature: !0,
                        value: void 0
                    };
                    const r = t[Symbol.iterator]();
                    let i = r.next();
                    const s = t[Symbol.iterator]();
                    s.next();
                    let o = s.next();
                    for(; !i.done;)e1 += !o.done && Ts(o.value.codePointAt(0)) && !Eh[o.value] || !n.premature && Ts(n.value.codePointAt(0)) && !Eh[n.value] || !Eh[i.value] ? i.value : Eh[i.value], n = {
                        value: i.value,
                        premature: !1
                    }, i = r.next(), o = s.next();
                    return e1;
                }(this.text);
            }
            hasZeroWidthSpaces() {
                return this.text.includes("\u200B");
            }
            trim() {
                const t = this.text.match(/^\s*/), e1 = t ? t[0].length : 0, n = this.text.match(/\S\s*$/), r = n ? n[0].length - 1 : 0;
                this.text = this.text.substring(e1, this.text.length - r), this.sectionIndex = this.sectionIndex.slice(e1, this.sectionIndex.length - r);
            }
            substring(t, e1) {
                const n = [
                    ...this.text
                ].slice(t, e1).join(""), r = this.sectionIndex.slice(t, e1);
                return new Vh(n, this.sections, r);
            }
            toCodeUnitIndex(t) {
                return [
                    ...this.text
                ].slice(0, t).join("").length;
            }
            toString() {
                return this.text;
            }
            getMaxScale() {
                return this.sectionIndex.reduce((t, e1)=>Math.max(t, this.sections[e1].scale), 0);
            }
            getMaxImageSize(t) {
                let e1 = 0, n = 0;
                for(let r = 0; r < this.length(); r++){
                    const i = this.getSection(r);
                    if ("imageName" in i) {
                        const r = t[i.imageName];
                        if (!r) continue;
                        const s = r.displaySize;
                        e1 = Math.max(e1, s[0]), n = Math.max(n, s[1]);
                    }
                }
                return {
                    maxImageWidth: e1,
                    maxImageHeight: n
                };
            }
            addTextSection(t, e1) {
                this.text += t.text, this.sections.push({
                    scale: t.scale || 1,
                    verticalAlign: t.verticalAlign || "bottom",
                    fontStack: t.fontStack || e1
                });
                const n = this.sections.length - 1;
                this.sectionIndex.push(...[
                    ...t.text
                ].map(()=>n));
            }
            addImageSection(t) {
                const e1 = t.image ? t.image.name : "";
                if (0 === e1.length) return void G("Can't add FormattedSection with an empty image.");
                const n = this.getNextImageSectionCharCode();
                n ? (this.text += String.fromCharCode(n), this.sections.push({
                    scale: 1,
                    verticalAlign: t.verticalAlign || "bottom",
                    imageName: e1
                }), this.sectionIndex.push(this.sections.length - 1)) : G("Reached maximum number of images 6401");
            }
            getNextImageSectionCharCode() {
                return this.imageSectionID ? this.imageSectionID >= 63743 ? null : ++this.imageSectionID : (this.imageSectionID = 57344, this.imageSectionID);
            }
            determineLineBreaks(t, e1, n, r, i) {
                const s = [], o = this.determineAverageLineWidth(t, e1, n, r, i), a = this.hasZeroWidthSpaces();
                let l = 0, u = 0;
                const c = this.text[Symbol.iterator]();
                let h = c.next();
                const p = this.text[Symbol.iterator]();
                p.next();
                let f = p.next();
                const d = this.text[Symbol.iterator]();
                d.next(), d.next();
                let y = d.next();
                for(; !h.done;){
                    const e1 = this.getSection(u), m = h.value.codePointAt(0);
                    if (Ss(m) || (l += Ph(m, e1, n, r, t, i)), !f.done) {
                        const t = ws(m), n = f.value.codePointAt(0);
                        (Th[m] || t || "imageName" in e1 || !y.done && Fh[n]) && s.push(Bh(u + 1, l, o, s, zh(m, n, t && a), !1));
                    }
                    u++, h = c.next(), f = p.next(), y = d.next();
                }
                return Ch(Bh(this.length(), l, o, s, 0, !0));
            }
            determineAverageLineWidth(t, e1, n, r, i) {
                let s = 0, o = 0;
                for (const e1 of this.text){
                    const a = this.getSection(o);
                    s += Ph(e1.codePointAt(0), a, n, r, t, i), o++;
                }
                return s / Math.max(1, Math.ceil(s / e1));
            }
        }
        const Lh = 4294967296, Oh = 1 / Lh, $h = "undefined" == typeof TextDecoder ? null : new TextDecoder("utf-8");
        class Rh {
            constructor(t = new Uint8Array(16)){
                this.buf = ArrayBuffer.isView(t) ? t : new Uint8Array(t), this.dataView = new DataView(this.buf.buffer), this.pos = 0, this.type = 0, this.length = this.buf.length;
            }
            readFields(t, e1, n = this.length) {
                for(; this.pos < n;){
                    const n = this.readVarint(), r = n >> 3, i = this.pos;
                    this.type = 7 & n, t(r, e1, this), this.pos === i && this.skip(n);
                }
                return e1;
            }
            readMessage(t, e1) {
                return this.readFields(t, e1, this.readVarint() + this.pos);
            }
            readFixed32() {
                const t = this.dataView.getUint32(this.pos, !0);
                return this.pos += 4, t;
            }
            readSFixed32() {
                const t = this.dataView.getInt32(this.pos, !0);
                return this.pos += 4, t;
            }
            readFixed64() {
                const t = this.dataView.getUint32(this.pos, !0) + this.dataView.getUint32(this.pos + 4, !0) * Lh;
                return this.pos += 8, t;
            }
            readSFixed64() {
                const t = this.dataView.getUint32(this.pos, !0) + this.dataView.getInt32(this.pos + 4, !0) * Lh;
                return this.pos += 8, t;
            }
            readFloat() {
                const t = this.dataView.getFloat32(this.pos, !0);
                return this.pos += 4, t;
            }
            readDouble() {
                const t = this.dataView.getFloat64(this.pos, !0);
                return this.pos += 8, t;
            }
            readVarint(t) {
                const e1 = this.buf;
                let n, r;
                return r = e1[this.pos++], n = 127 & r, r < 128 ? n : (r = e1[this.pos++], n |= (127 & r) << 7, r < 128 ? n : (r = e1[this.pos++], n |= (127 & r) << 14, r < 128 ? n : (r = e1[this.pos++], n |= (127 & r) << 21, r < 128 ? n : (r = e1[this.pos], n |= (15 & r) << 28, function(t, e1, n) {
                    const r = n.buf;
                    let i, s;
                    if (s = r[n.pos++], i = (112 & s) >> 4, s < 128) return Nh(t, i, e1);
                    if (s = r[n.pos++], i |= (127 & s) << 3, s < 128) return Nh(t, i, e1);
                    if (s = r[n.pos++], i |= (127 & s) << 10, s < 128) return Nh(t, i, e1);
                    if (s = r[n.pos++], i |= (127 & s) << 17, s < 128) return Nh(t, i, e1);
                    if (s = r[n.pos++], i |= (127 & s) << 24, s < 128) return Nh(t, i, e1);
                    if (s = r[n.pos++], i |= (1 & s) << 31, s < 128) return Nh(t, i, e1);
                    throw new Error("Expected varint not more than 10 bytes");
                }(n, t, this)))));
            }
            readVarint64() {
                return this.readVarint(!0);
            }
            readSVarint() {
                const t = this.readVarint();
                return t % 2 == 1 ? (t + 1) / -2 : t / 2;
            }
            readBoolean() {
                return Boolean(this.readVarint());
            }
            readString() {
                const t = this.readVarint() + this.pos, e1 = this.pos;
                return this.pos = t, t - e1 >= 12 && $h ? $h.decode(this.buf.subarray(e1, t)) : function(t, e1, n) {
                    let r = "", i = e1;
                    for(; i < n;){
                        const e1 = t[i];
                        let s, o, a, l = null, u = e1 > 239 ? 4 : e1 > 223 ? 3 : e1 > 191 ? 2 : 1;
                        if (i + u > n) break;
                        1 === u ? e1 < 128 && (l = e1) : 2 === u ? (s = t[i + 1], 128 == (192 & s) && (l = (31 & e1) << 6 | 63 & s, l <= 127 && (l = null))) : 3 === u ? (s = t[i + 1], o = t[i + 2], 128 == (192 & s) && 128 == (192 & o) && (l = (15 & e1) << 12 | (63 & s) << 6 | 63 & o, (l <= 2047 || l >= 55296 && l <= 57343) && (l = null))) : 4 === u && (s = t[i + 1], o = t[i + 2], a = t[i + 3], 128 == (192 & s) && 128 == (192 & o) && 128 == (192 & a) && (l = (15 & e1) << 18 | (63 & s) << 12 | (63 & o) << 6 | 63 & a, (l <= 65535 || l >= 1114112) && (l = null))), null === l ? (l = 65533, u = 1) : l > 65535 && (l -= 65536, r += String.fromCharCode(l >>> 10 & 1023 | 55296), l = 56320 | 1023 & l), r += String.fromCharCode(l), i += u;
                    }
                    return r;
                }(this.buf, e1, t);
            }
            readBytes() {
                const t = this.readVarint() + this.pos, e1 = this.buf.subarray(this.pos, t);
                return this.pos = t, e1;
            }
            readPackedVarint(t = [], e1) {
                const n = this.readPackedEnd();
                for(; this.pos < n;)t.push(this.readVarint(e1));
                return t;
            }
            readPackedSVarint(t = []) {
                const e1 = this.readPackedEnd();
                for(; this.pos < e1;)t.push(this.readSVarint());
                return t;
            }
            readPackedBoolean(t = []) {
                const e1 = this.readPackedEnd();
                for(; this.pos < e1;)t.push(this.readBoolean());
                return t;
            }
            readPackedFloat(t = []) {
                const e1 = this.readPackedEnd();
                for(; this.pos < e1;)t.push(this.readFloat());
                return t;
            }
            readPackedDouble(t = []) {
                const e1 = this.readPackedEnd();
                for(; this.pos < e1;)t.push(this.readDouble());
                return t;
            }
            readPackedFixed32(t = []) {
                const e1 = this.readPackedEnd();
                for(; this.pos < e1;)t.push(this.readFixed32());
                return t;
            }
            readPackedSFixed32(t = []) {
                const e1 = this.readPackedEnd();
                for(; this.pos < e1;)t.push(this.readSFixed32());
                return t;
            }
            readPackedFixed64(t = []) {
                const e1 = this.readPackedEnd();
                for(; this.pos < e1;)t.push(this.readFixed64());
                return t;
            }
            readPackedSFixed64(t = []) {
                const e1 = this.readPackedEnd();
                for(; this.pos < e1;)t.push(this.readSFixed64());
                return t;
            }
            readPackedEnd() {
                return 2 === this.type ? this.readVarint() + this.pos : this.pos + 1;
            }
            skip(t) {
                const e1 = 7 & t;
                if (0 === e1) for(; this.buf[this.pos++] > 127;);
                else if (2 === e1) this.pos = this.readVarint() + this.pos;
                else if (5 === e1) this.pos += 4;
                else {
                    if (1 !== e1) throw new Error(`Unimplemented type: ${e1}`);
                    this.pos += 8;
                }
            }
            writeTag(t, e1) {
                this.writeVarint(t << 3 | e1);
            }
            realloc(t) {
                let e1 = this.length || 16;
                for(; e1 < this.pos + t;)e1 *= 2;
                if (e1 !== this.length) {
                    const t = new Uint8Array(e1);
                    t.set(this.buf), this.buf = t, this.dataView = new DataView(t.buffer), this.length = e1;
                }
            }
            finish() {
                return this.length = this.pos, this.pos = 0, this.buf.subarray(0, this.length);
            }
            writeFixed32(t) {
                this.realloc(4), this.dataView.setInt32(this.pos, t, !0), this.pos += 4;
            }
            writeSFixed32(t) {
                this.realloc(4), this.dataView.setInt32(this.pos, t, !0), this.pos += 4;
            }
            writeFixed64(t) {
                this.realloc(8), this.dataView.setInt32(this.pos, -1 & t, !0), this.dataView.setInt32(this.pos + 4, Math.floor(t * Oh), !0), this.pos += 8;
            }
            writeSFixed64(t) {
                this.realloc(8), this.dataView.setInt32(this.pos, -1 & t, !0), this.dataView.setInt32(this.pos + 4, Math.floor(t * Oh), !0), this.pos += 8;
            }
            writeVarint(t) {
                (t = +t || 0) > 268435455 || t < 0 ? function(t, e1) {
                    let n, r;
                    if (t >= 0 ? (n = t % 4294967296 | 0, r = t / 4294967296 | 0) : (n = ~(-t % 4294967296), r = ~(-t / 4294967296), 4294967295 ^ n ? n = n + 1 | 0 : (n = 0, r = r + 1 | 0)), t >= 0x10000000000000000 || t < -18446744073709552000) throw new Error("Given varint doesn't fit into 10 bytes");
                    e1.realloc(10), function(t, e1, n) {
                        n.buf[n.pos++] = 127 & t | 128, t >>>= 7, n.buf[n.pos++] = 127 & t | 128, t >>>= 7, n.buf[n.pos++] = 127 & t | 128, t >>>= 7, n.buf[n.pos++] = 127 & t | 128, n.buf[n.pos] = 127 & (t >>>= 7);
                    }(n, 0, e1), function(t, e1) {
                        const n = (7 & t) << 4;
                        e1.buf[e1.pos++] |= n | ((t >>>= 3) ? 128 : 0), t && (e1.buf[e1.pos++] = 127 & t | ((t >>>= 7) ? 128 : 0), t && (e1.buf[e1.pos++] = 127 & t | ((t >>>= 7) ? 128 : 0), t && (e1.buf[e1.pos++] = 127 & t | ((t >>>= 7) ? 128 : 0), t && (e1.buf[e1.pos++] = 127 & t | ((t >>>= 7) ? 128 : 0), t && (e1.buf[e1.pos++] = 127 & t)))));
                    }(r, e1);
                }(t, this) : (this.realloc(4), this.buf[this.pos++] = 127 & t | (t > 127 ? 128 : 0), t <= 127 || (this.buf[this.pos++] = 127 & (t >>>= 7) | (t > 127 ? 128 : 0), t <= 127 || (this.buf[this.pos++] = 127 & (t >>>= 7) | (t > 127 ? 128 : 0), t <= 127 || (this.buf[this.pos++] = t >>> 7 & 127))));
            }
            writeSVarint(t) {
                this.writeVarint(t < 0 ? 2 * -t - 1 : 2 * t);
            }
            writeBoolean(t) {
                this.writeVarint(+t);
            }
            writeString(t) {
                t = String(t), this.realloc(4 * t.length), this.pos++;
                const e1 = this.pos;
                this.pos = function(t, e1, n) {
                    for(let r, i, s = 0; s < e1.length; s++){
                        if (r = e1.charCodeAt(s), r > 55295 && r < 57344) {
                            if (!i) {
                                r > 56319 || s + 1 === e1.length ? (t[n++] = 239, t[n++] = 191, t[n++] = 189) : i = r;
                                continue;
                            }
                            if (r < 56320) {
                                t[n++] = 239, t[n++] = 191, t[n++] = 189, i = r;
                                continue;
                            }
                            r = i - 55296 << 10 | r - 56320 | 65536, i = null;
                        } else i && (t[n++] = 239, t[n++] = 191, t[n++] = 189, i = null);
                        r < 128 ? t[n++] = r : (r < 2048 ? t[n++] = r >> 6 | 192 : (r < 65536 ? t[n++] = r >> 12 | 224 : (t[n++] = r >> 18 | 240, t[n++] = r >> 12 & 63 | 128), t[n++] = r >> 6 & 63 | 128), t[n++] = 63 & r | 128);
                    }
                    return n;
                }(this.buf, t, this.pos);
                const n = this.pos - e1;
                n >= 128 && Uh(e1, n, this), this.pos = e1 - 1, this.writeVarint(n), this.pos += n;
            }
            writeFloat(t) {
                this.realloc(4), this.dataView.setFloat32(this.pos, t, !0), this.pos += 4;
            }
            writeDouble(t) {
                this.realloc(8), this.dataView.setFloat64(this.pos, t, !0), this.pos += 8;
            }
            writeBytes(t) {
                const e1 = t.length;
                this.writeVarint(e1), this.realloc(e1);
                for(let n = 0; n < e1; n++)this.buf[this.pos++] = t[n];
            }
            writeRawMessage(t, e1) {
                this.pos++;
                const n = this.pos;
                t(e1, this);
                const r = this.pos - n;
                r >= 128 && Uh(n, r, this), this.pos = n - 1, this.writeVarint(r), this.pos += r;
            }
            writeMessage(t, e1, n) {
                this.writeTag(t, 2), this.writeRawMessage(e1, n);
            }
            writePackedVarint(t, e1) {
                e1.length && this.writeMessage(t, jh, e1);
            }
            writePackedSVarint(t, e1) {
                e1.length && this.writeMessage(t, qh, e1);
            }
            writePackedBoolean(t, e1) {
                e1.length && this.writeMessage(t, Yh, e1);
            }
            writePackedFloat(t, e1) {
                e1.length && this.writeMessage(t, Gh, e1);
            }
            writePackedDouble(t, e1) {
                e1.length && this.writeMessage(t, Xh, e1);
            }
            writePackedFixed32(t, e1) {
                e1.length && this.writeMessage(t, Zh, e1);
            }
            writePackedSFixed32(t, e1) {
                e1.length && this.writeMessage(t, Hh, e1);
            }
            writePackedFixed64(t, e1) {
                e1.length && this.writeMessage(t, Wh, e1);
            }
            writePackedSFixed64(t, e1) {
                e1.length && this.writeMessage(t, Kh, e1);
            }
            writeBytesField(t, e1) {
                this.writeTag(t, 2), this.writeBytes(e1);
            }
            writeFixed32Field(t, e1) {
                this.writeTag(t, 5), this.writeFixed32(e1);
            }
            writeSFixed32Field(t, e1) {
                this.writeTag(t, 5), this.writeSFixed32(e1);
            }
            writeFixed64Field(t, e1) {
                this.writeTag(t, 1), this.writeFixed64(e1);
            }
            writeSFixed64Field(t, e1) {
                this.writeTag(t, 1), this.writeSFixed64(e1);
            }
            writeVarintField(t, e1) {
                this.writeTag(t, 0), this.writeVarint(e1);
            }
            writeSVarintField(t, e1) {
                this.writeTag(t, 0), this.writeSVarint(e1);
            }
            writeStringField(t, e1) {
                this.writeTag(t, 2), this.writeString(e1);
            }
            writeFloatField(t, e1) {
                this.writeTag(t, 5), this.writeFloat(e1);
            }
            writeDoubleField(t, e1) {
                this.writeTag(t, 1), this.writeDouble(e1);
            }
            writeBooleanField(t, e1) {
                this.writeVarintField(t, +e1);
            }
        }
        function Nh(t, e1, n) {
            return n ? 4294967296 * e1 + (t >>> 0) : 4294967296 * (e1 >>> 0) + (t >>> 0);
        }
        function Uh(t, e1, n) {
            const r = e1 <= 16383 ? 1 : e1 <= 2097151 ? 2 : e1 <= 268435455 ? 3 : Math.floor(Math.log(e1) / (7 * Math.LN2));
            n.realloc(r);
            for(let e1 = n.pos - 1; e1 >= t; e1--)n.buf[e1 + r] = n.buf[e1];
        }
        function jh(t, e1) {
            for(let n = 0; n < t.length; n++)e1.writeVarint(t[n]);
        }
        function qh(t, e1) {
            for(let n = 0; n < t.length; n++)e1.writeSVarint(t[n]);
        }
        function Gh(t, e1) {
            for(let n = 0; n < t.length; n++)e1.writeFloat(t[n]);
        }
        function Xh(t, e1) {
            for(let n = 0; n < t.length; n++)e1.writeDouble(t[n]);
        }
        function Yh(t, e1) {
            for(let n = 0; n < t.length; n++)e1.writeBoolean(t[n]);
        }
        function Zh(t, e1) {
            for(let n = 0; n < t.length; n++)e1.writeFixed32(t[n]);
        }
        function Hh(t, e1) {
            for(let n = 0; n < t.length; n++)e1.writeSFixed32(t[n]);
        }
        function Wh(t, e1) {
            for(let n = 0; n < t.length; n++)e1.writeFixed64(t[n]);
        }
        function Kh(t, e1) {
            for(let n = 0; n < t.length; n++)e1.writeSFixed64(t[n]);
        }
        function Jh(t, e1, n) {
            1 === t && n.readMessage(Qh, e1);
        }
        function Qh(t, e1, n) {
            if (3 === t) {
                const { id: t, bitmap: r, width: i, height: s, left: o, top: a, advance: l } = n.readMessage(tp, {});
                e1.push({
                    id: t,
                    bitmap: new kl({
                        width: i + 6,
                        height: s + 6
                    }, r),
                    metrics: {
                        width: i,
                        height: s,
                        left: o,
                        top: a,
                        advance: l
                    }
                });
            }
        }
        function tp(t, e1, n) {
            1 === t ? e1.id = n.readVarint() : 2 === t ? e1.bitmap = n.readBytes() : 3 === t ? e1.width = n.readVarint() : 4 === t ? e1.height = n.readVarint() : 5 === t ? e1.left = n.readSVarint() : 6 === t ? e1.top = n.readSVarint() : 7 === t && (e1.advance = n.readVarint());
        }
        function ep(t) {
            let e1 = 0, n = 0;
            for (const r of t)e1 += r.w * r.h, n = Math.max(n, r.w);
            t.sort((t, e1)=>e1.h - t.h);
            const r = [
                {
                    x: 0,
                    y: 0,
                    w: Math.max(Math.ceil(Math.sqrt(e1 / .95)), n),
                    h: 1 / 0
                }
            ];
            let i = 0, s = 0;
            for (const e1 of t)for(let t = r.length - 1; t >= 0; t--){
                const n = r[t];
                if (!(e1.w > n.w || e1.h > n.h)) {
                    if (e1.x = n.x, e1.y = n.y, s = Math.max(s, e1.y + e1.h), i = Math.max(i, e1.x + e1.w), e1.w === n.w && e1.h === n.h) {
                        const e1 = r.pop();
                        e1 && t < r.length && (r[t] = e1);
                    } else e1.h === n.h ? (n.x += e1.w, n.w -= e1.w) : e1.w === n.w ? (n.y += e1.h, n.h -= e1.h) : (r.push({
                        x: n.x + e1.w,
                        y: n.y,
                        w: n.w - e1.w,
                        h: e1.h
                    }), n.y += e1.h, n.h -= e1.h);
                    break;
                }
            }
            return {
                w: i,
                h: s,
                fill: e1 / (i * s) || 0
            };
        }
        class np {
            constructor(t, { pixelRatio: e1, version: n, stretchX: r, stretchY: i, content: s, textFitWidth: o, textFitHeight: a }){
                this.paddedRect = t, this.pixelRatio = e1, this.stretchX = r, this.stretchY = i, this.content = s, this.version = n, this.textFitWidth = o, this.textFitHeight = a;
            }
            get tl() {
                return [
                    this.paddedRect.x + 1,
                    this.paddedRect.y + 1
                ];
            }
            get br() {
                return [
                    this.paddedRect.x + this.paddedRect.w - 1,
                    this.paddedRect.y + this.paddedRect.h - 1
                ];
            }
            get tlbr() {
                return this.tl.concat(this.br);
            }
            get displaySize() {
                return [
                    (this.paddedRect.w - 2) / this.pixelRatio,
                    (this.paddedRect.h - 2) / this.pixelRatio
                ];
            }
        }
        class rp {
            constructor(t, e1){
                const n = {}, r = {};
                this.haveRenderCallbacks = [];
                const i = [];
                this.addImages(t, n, i), this.addImages(e1, r, i);
                const { w: s, h: o } = ep(i), a = new Il({
                    width: s || 1,
                    height: o || 1
                });
                for(const e1 in t){
                    const r = t[e1], i = n[e1].paddedRect;
                    Il.copy(r.data, a, {
                        x: 0,
                        y: 0
                    }, {
                        x: i.x + 1,
                        y: i.y + 1
                    }, r.data);
                }
                for(const t in e1){
                    const n = e1[t], i = r[t].paddedRect, s = i.x + 1, o = i.y + 1, l = n.data.width, u = n.data.height;
                    Il.copy(n.data, a, {
                        x: 0,
                        y: 0
                    }, {
                        x: s,
                        y: o
                    }, n.data), Il.copy(n.data, a, {
                        x: 0,
                        y: u - 1
                    }, {
                        x: s,
                        y: o - 1
                    }, {
                        width: l,
                        height: 1
                    }), Il.copy(n.data, a, {
                        x: 0,
                        y: 0
                    }, {
                        x: s,
                        y: o + u
                    }, {
                        width: l,
                        height: 1
                    }), Il.copy(n.data, a, {
                        x: l - 1,
                        y: 0
                    }, {
                        x: s - 1,
                        y: o
                    }, {
                        width: 1,
                        height: u
                    }), Il.copy(n.data, a, {
                        x: 0,
                        y: 0
                    }, {
                        x: s + l,
                        y: o
                    }, {
                        width: 1,
                        height: u
                    });
                }
                this.image = a, this.iconPositions = n, this.patternPositions = r;
            }
            addImages(t, e1, n) {
                for(const r in t){
                    const i = t[r], s = {
                        x: 0,
                        y: 0,
                        w: i.data.width + 2,
                        h: i.data.height + 2
                    };
                    n.push(s), e1[r] = new np(s, i), i.hasRenderCallback && this.haveRenderCallbacks.push(r);
                }
            }
            patchUpdatedImages(t, e1) {
                t.dispatchRenderCallbacks(this.haveRenderCallbacks);
                for(const n in t.updatedImages)this.patchUpdatedImage(this.iconPositions[n], t.getImage(n), e1), this.patchUpdatedImage(this.patternPositions[n], t.getImage(n), e1);
            }
            patchUpdatedImage(t, e1, n) {
                if (!t || !e1) return;
                if (t.version === e1.version) return;
                t.version = e1.version;
                const [r, i] = t.tl;
                n.update(e1.data, void 0, {
                    x: r,
                    y: i
                });
            }
        }
        var ip;
        function sp(e1, n, r, i, s, o, a, l, u, c, h, p, f, d, y) {
            const m = Vh.fromFeature(e1, s);
            let g;
            p === t.ax.vertical && m.verticalizePunctuation();
            let x = m.determineLineBreaks(c, o, n, i, d);
            const { processBidirectionalText: v, processStyledBidirectionalText: b } = Bs;
            if (v && 1 === m.sections.length) {
                g = [], x = x.map((t)=>m.toCodeUnitIndex(t));
                const t = v(m.toString(), x);
                for (const e1 of t){
                    const t = [
                        ...e1
                    ].map(()=>0);
                    g.push(new Vh(e1, m.sections, t));
                }
            } else if (b) {
                g = [], x = x.map((t)=>m.toCodeUnitIndex(t));
                let t = 0;
                const e1 = [];
                for (const n of m.text)e1.push(...Array(n.length).fill(m.sectionIndex[t])), t++;
                const n = b(m.text, e1, x);
                for (const t of n){
                    const e1 = [];
                    let n = "";
                    for (const r of t[0])e1.push(t[1][n.length]), n += r;
                    g.push(new Vh(t[0], m.sections, e1));
                }
            } else g = function(t, e1) {
                const n = [];
                let r = 0;
                for (const i of e1)n.push(t.substring(r, i)), r = i;
                return r < t.length() && n.push(t.substring(r, t.length())), n;
            }(m, x);
            const w = [], _ = {
                positionedLines: w,
                text: m.toString(),
                top: h[1],
                bottom: h[1],
                left: h[0],
                right: h[0],
                writingMode: p,
                iconsInText: !1,
                verticalizable: !1
            };
            return function(t, e1, n, r, i, s, o, a, l, u, c, h) {
                let p = 0, f = 0, d = 0, y = 0;
                const m = "right" === a ? 1 : "left" === a ? 0 : .5, g = Ih / h;
                let x = 0;
                for (const o of i){
                    o.trim();
                    const i = o.getMaxScale(), a = {
                        positionedGlyphs: [],
                        lineOffset: 0
                    };
                    t.positionedLines[x] = a;
                    const h = a.positionedGlyphs;
                    let v = 0;
                    if (!o.length()) {
                        f += s, ++x;
                        continue;
                    }
                    const b = ap(r, o, g);
                    let w = 0;
                    for (const s of o.text){
                        const a = o.getSection(w), d = s.codePointAt(0), y = up(l, c, d), m = {
                            glyph: d,
                            imageName: null,
                            x: p,
                            y: f + -17,
                            vertical: y,
                            scale: 1,
                            fontStack: "",
                            sectionIndex: o.getSectionIndex(w),
                            metrics: null,
                            rect: null
                        };
                        let x;
                        if ("fontStack" in a) {
                            if (x = cp(a, d, y, b, e1, n), !x) continue;
                            m.fontStack = a.fontStack;
                        } else {
                            if (t.iconsInText = !0, a.scale *= g, x = hp(a, y, i, b, r), !x) continue;
                            v = Math.max(v, x.imageOffset), m.imageName = a.imageName;
                        }
                        const { rect: _, metrics: S, baselineOffset: A } = x;
                        m.y += A, m.scale = a.scale, m.metrics = S, m.rect = _, h.push(m), y ? (t.verticalizable = !0, p += ("imageName" in a ? S.advance : Ih) * a.scale + u) : p += S.advance * a.scale + u, w++;
                    }
                    0 !== h.length && (d = Math.max(p - u, d), pp(h, 0, h.length - 1, m)), p = 0, a.lineOffset = Math.max(v, (i - 1) * Ih);
                    const _ = s * i + v;
                    f += _, y = Math.max(_, y), ++x;
                }
                const { horizontalAlign: v, verticalAlign: b } = op(o);
                (function(t, e1, n, r, i, s, o, a, l) {
                    const u = (e1 - n) * i;
                    let c = 0;
                    c = s !== o ? -a * r - -17 : -r * l * o + .5 * o;
                    for (const e1 of t)for (const t of e1.positionedGlyphs)t.x += u, t.y += c;
                })(t.positionedLines, m, v, b, d, y, s, f, i.length), t.top += -b * f, t.bottom = t.top + f, t.left += -v * d, t.right = t.left + d;
            }(_, n, r, i, g, a, l, u, p, c, f, y), !function(t) {
                for (const e1 of t)if (0 !== e1.positionedGlyphs.length) return !1;
                return !0;
            }(w) && _;
        }
        function op(t) {
            let e1 = .5, n = .5;
            switch(t){
                case "right":
                case "top-right":
                case "bottom-right":
                    e1 = 1;
                    break;
                case "left":
                case "top-left":
                case "bottom-left":
                    e1 = 0;
            }
            switch(t){
                case "bottom":
                case "bottom-right":
                case "bottom-left":
                    n = 1;
                    break;
                case "top":
                case "top-right":
                case "top-left":
                    n = 0;
            }
            return {
                horizontalAlign: e1,
                verticalAlign: n
            };
        }
        function ap(t, e1, n) {
            const r = e1.getMaxScale() * Ih, { maxImageWidth: i, maxImageHeight: s } = e1.getMaxImageSize(t), o = Math.max(r, s * n);
            return {
                verticalLineContentWidth: Math.max(r, i * n),
                horizontalLineContentHeight: o
            };
        }
        function lp(t) {
            switch(t){
                case "top":
                    return 0;
                case "center":
                    return .5;
                default:
                    return 1;
            }
        }
        function up(e1, n, r) {
            var i;
            return !(e1 === t.ax.horizontal || !n && !_s(r) || n && (Ss(r) || (i = r, /\p{sc=Arab}/u.test(String.fromCodePoint(i)))));
        }
        function cp(t, e1, n, r, i, s) {
            const o = s[t.fontStack], a = function(t, e1, n, r) {
                if (null == t ? void 0 : t.rect) return t;
                const i = e1[n.fontStack], s = null == i ? void 0 : i[r];
                return s ? {
                    rect: null,
                    metrics: s.metrics
                } : null;
            }(null == o ? void 0 : o[e1], i, t, e1);
            if (null === a) return null;
            let l;
            if (n) l = r.verticalLineContentWidth - t.scale * Ih;
            else {
                const e1 = lp(t.verticalAlign);
                l = (r.horizontalLineContentHeight - t.scale * Ih) * e1;
            }
            return {
                rect: a.rect,
                metrics: a.metrics,
                baselineOffset: l
            };
        }
        function hp(t, e1, n, r, i) {
            const s = i[t.imageName];
            if (!s) return null;
            const o = s.paddedRect, a = s.displaySize, l = {
                width: a[0],
                height: a[1],
                left: 1,
                top: -3,
                advance: e1 ? a[1] : a[0]
            };
            let u;
            if (e1) u = r.verticalLineContentWidth - a[1] * t.scale;
            else {
                const e1 = lp(t.verticalAlign);
                u = (r.horizontalLineContentHeight - a[1] * t.scale) * e1;
            }
            return {
                rect: o,
                metrics: l,
                baselineOffset: u,
                imageOffset: (e1 ? a[0] : a[1]) * t.scale - Ih * n
            };
        }
        function pp(t, e1, n, r) {
            if (0 === r) return;
            const i = t[n], s = (t[n].x + i.metrics.advance * i.scale) * r;
            for(let r = e1; r <= n; r++)t[r].x -= s;
        }
        function fp(t, e1, n) {
            const { horizontalAlign: r, verticalAlign: i } = op(n), s = e1[0] - t.displaySize[0] * r, o = e1[1] - t.displaySize[1] * i;
            return {
                image: t,
                top: o,
                bottom: o + t.displaySize[1],
                left: s,
                right: s + t.displaySize[0]
            };
        }
        function dp(t) {
            var e1, n;
            let r = t.left, i = t.top, s = t.right - r, o = t.bottom - i;
            const a = null !== (e1 = t.image.textFitWidth) && void 0 !== e1 ? e1 : "stretchOrShrink", l = null !== (n = t.image.textFitHeight) && void 0 !== n ? n : "stretchOrShrink", u = (t.image.content[2] - t.image.content[0]) / (t.image.content[3] - t.image.content[1]);
            if ("proportional" === l) {
                if ("stretchOnly" === a && s / o < u || "proportional" === a) {
                    const t = Math.ceil(o * u);
                    r *= t / s, s = t;
                }
            } else if ("proportional" === a && "stretchOnly" === l && 0 !== u && s / o > u) {
                const t = Math.ceil(s / u);
                i *= t / o, o = t;
            }
            return {
                x1: r,
                y1: i,
                x2: r + s,
                y2: i + o
            };
        }
        function yp(t, e1, n, r, i, s) {
            const o = t.image;
            let a;
            if (o.content) {
                const t = o.content, e1 = o.pixelRatio || 1;
                a = [
                    t[0] / e1,
                    t[1] / e1,
                    o.displaySize[0] - t[2] / e1,
                    o.displaySize[1] - t[3] / e1
                ];
            }
            const l = e1.left * s, u = e1.right * s;
            let c, h, p, f;
            "width" === n || "both" === n ? (f = i[0] + l - r[3], h = i[0] + u + r[1]) : (f = i[0] + (l + u - o.displaySize[0]) / 2, h = f + o.displaySize[0]);
            const d = e1.top * s, y = e1.bottom * s;
            return "height" === n || "both" === n ? (c = i[1] + d - r[0], p = i[1] + y + r[2]) : (c = i[1] + (d + y - o.displaySize[1]) / 2, p = c + o.displaySize[1]), {
                image: o,
                top: c,
                right: h,
                bottom: p,
                left: f,
                collisionPadding: a
            };
        }
        ds("ImagePosition", np), ds("ImageAtlas", rp), t.ax = void 0, (ip = t.ax || (t.ax = {}))[ip.none = 0] = "none", ip[ip.horizontal = 1] = "horizontal", ip[ip.vertical = 2] = "vertical", ip[ip.horizontalOnly = 3] = "horizontalOnly";
        const mp = 128, gp = 32640;
        function xp(t, e1) {
            const { expression: n } = e1;
            if ("constant" === n.kind) return {
                kind: "constant",
                layoutSize: n.evaluate(new Cs(t + 1))
            };
            if ("source" === n.kind) return {
                kind: "source"
            };
            {
                const { zoomStops: e1, interpolationType: r } = n;
                let i = 0;
                for(; i < e1.length && e1[i] <= t;)i++;
                i = Math.max(0, i - 1);
                let s = i;
                for(; s < e1.length && e1[s] < t + 1;)s++;
                s = Math.min(e1.length - 1, s);
                const o = e1[i], a = e1[s];
                return "composite" === n.kind ? {
                    kind: "composite",
                    minZoom: o,
                    maxZoom: a,
                    interpolationType: r
                } : {
                    kind: "camera",
                    minZoom: o,
                    maxZoom: a,
                    minSize: n.evaluate(new Cs(o)),
                    maxSize: n.evaluate(new Cs(a)),
                    interpolationType: r
                };
            }
        }
        function vp(t, e1, n) {
            let r = "never";
            const i = t.get(e1);
            return i ? r = i : t.get(n) && (r = "always"), r;
        }
        const bp = [
            {
                name: "a_fade_opacity",
                components: 1,
                type: "Uint8",
                offset: 0
            }
        ];
        function wp(t, e1, n, r, i, s, o, a, l, u, c, h, p) {
            const f = a ? Math.min(gp, Math.round(a[0])) : 0, d = a ? Math.min(gp, Math.round(a[1])) : 0;
            t.emplaceBack(e1, n, Math.round(32 * r), Math.round(32 * i), s, o, (f << 1) + (l ? 1 : 0), d, 16 * u, 16 * c, 256 * h, 256 * p);
        }
        function _p(t, e1, n) {
            t.emplaceBack(e1.x, e1.y, n), t.emplaceBack(e1.x, e1.y, n), t.emplaceBack(e1.x, e1.y, n), t.emplaceBack(e1.x, e1.y, n);
        }
        function Sp(t) {
            for (const e1 of t.sections)if (zs(e1.text)) return !0;
            return !1;
        }
        class Ap {
            constructor(t){
                this.layoutVertexArray = new ta, this.indexArray = new sa, this.programConfigurations = t, this.segments = new ua, this.dynamicLayoutVertexArray = new ea, this.opacityVertexArray = new na, this.hasVisibleVertices = !1, this.placedSymbolArray = new Lo;
            }
            isEmpty() {
                return 0 === this.layoutVertexArray.length && 0 === this.indexArray.length && 0 === this.dynamicLayoutVertexArray.length && 0 === this.opacityVertexArray.length;
            }
            upload(t, e1, n, r) {
                this.isEmpty() || (n && (this.layoutVertexBuffer = t.createVertexBuffer(this.layoutVertexArray, bh.members), this.indexBuffer = t.createIndexBuffer(this.indexArray, e1), this.dynamicLayoutVertexBuffer = t.createVertexBuffer(this.dynamicLayoutVertexArray, wh.members, !0), this.opacityVertexBuffer = t.createVertexBuffer(this.opacityVertexArray, bp, !0), this.opacityVertexBuffer.itemSize = 1), (n || r) && this.programConfigurations.upload(t));
            }
            destroy() {
                this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.programConfigurations.destroy(), this.segments.destroy(), this.dynamicLayoutVertexBuffer.destroy(), this.opacityVertexBuffer.destroy());
            }
        }
        ds("SymbolBuffers", Ap);
        class Mp {
            constructor(t, e1, n){
                this.layoutVertexArray = new t, this.layoutAttributes = e1, this.indexArray = new n, this.segments = new ua, this.collisionVertexArray = new ia;
            }
            upload(t) {
                this.layoutVertexBuffer = t.createVertexBuffer(this.layoutVertexArray, this.layoutAttributes), this.indexBuffer = t.createIndexBuffer(this.indexArray), this.collisionVertexBuffer = t.createVertexBuffer(this.collisionVertexArray, _h.members, !0);
            }
            destroy() {
                this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.segments.destroy(), this.collisionVertexBuffer.destroy());
            }
        }
        ds("CollisionBuffers", Mp);
        class kp {
            constructor(e1){
                this.collisionBoxArray = e1.collisionBoxArray, this.zoom = e1.zoom, this.overscaling = e1.overscaling, this.layers = e1.layers, this.layerIds = this.layers.map((t)=>t.id), this.index = e1.index, this.pixelRatio = e1.pixelRatio, this.sourceLayerIndex = e1.sourceLayerIndex, this.hasDependencies = !1, this.hasRTLText = !1, this.sortKeyRanges = [], this.collisionCircleArray = [];
                const n = this.layers[0]._unevaluatedLayout._values;
                this.textSizeData = xp(this.zoom, n["text-size"]), this.iconSizeData = xp(this.zoom, n["icon-size"]);
                const r = this.layers[0].layout, i = r.get("symbol-sort-key"), s = r.get("symbol-z-order");
                this.canOverlap = "never" !== vp(r, "text-overlap", "text-allow-overlap") || "never" !== vp(r, "icon-overlap", "icon-allow-overlap") || r.get("text-ignore-placement") || r.get("icon-ignore-placement"), this.sortFeaturesByKey = "viewport-y" !== s && !i.isConstant(), this.sortFeaturesByY = ("viewport-y" === s || "auto" === s && !this.sortFeaturesByKey) && this.canOverlap, "point" === r.get("symbol-placement") && (this.writingModes = r.get("text-writing-mode").map((e1)=>t.ax[e1])), this.stateDependentLayerIds = this.layers.filter((t)=>t.isStateDependent()).map((t)=>t.id), this.sourceID = e1.sourceID;
            }
            createArrays() {
                this.text = new Ap(new $a(this.layers, this.zoom, (t)=>t.startsWith("text"))), this.icon = new Ap(new $a(this.layers, this.zoom, (t)=>t.startsWith("icon"))), this.glyphOffsetArray = new Ro, this.lineVertexArray = new No, this.symbolInstances = new $o, this.textAnchorOffsets = new jo;
            }
            calculateGlyphDependencies(t, e1, n, r, i) {
                for (const s of t)if (e1[s.codePointAt(0)] = !0, (n || r) && i) {
                    const t = Eh[s];
                    t && (e1[t.codePointAt(0)] = !0);
                }
            }
            populate(e1, n, r) {
                var i;
                const s = this.layers[0], o = s.layout, a = o.get("text-font"), l = o.get("text-field"), u = o.get("icon-image"), c = ("constant" !== l.value.kind || l.value.value instanceof ze && !l.value.value.isEmpty() || l.value.value.toString().length > 0) && ("constant" !== a.value.kind || a.value.value.length > 0), h = "constant" !== u.value.kind || !!u.value.value || Object.keys(u.parameters).length > 0, p = o.get("symbol-sort-key");
                if (this.features = [], !c && !h) return;
                const f = n.iconDependencies, d = n.glyphDependencies, y = n.availableImages, m = new Cs(this.zoom);
                for (const { feature: n, id: l, index: u, sourceLayerIndex: g } of e1){
                    const e1 = s._featureFilter.needGeometry, x = Ga(n, e1);
                    if (!s._featureFilter.filter(m, x, r)) continue;
                    let v, b;
                    if (e1 || (x.geometry = qa(n)), c) {
                        const t = s.getValueAndResolveTokens("text-field", x, r, y), e1 = ze.factory(t);
                        this.hasRTLText || (this.hasRTLText = Sp(e1)), (!this.hasRTLText || "unavailable" === Bs.getRTLTextPluginStatus() || this.hasRTLText && Bs.isParsed()) && (v = kh(e1, s, x));
                    }
                    if (h) {
                        const t = s.getValueAndResolveTokens("icon-image", x, r, y);
                        b = t instanceof Re ? t : Re.fromString(t);
                    }
                    if (!v && !b) continue;
                    const w = this.sortFeaturesByKey ? p.evaluate(x, {}, r) : void 0;
                    if (this.features.push({
                        id: l,
                        text: v,
                        icon: b,
                        index: u,
                        sourceLayerIndex: g,
                        geometry: x.geometry,
                        properties: n.properties,
                        type: Cu.types[n.type],
                        sortKey: w
                    }), b && (f[b.name] = !0), v) {
                        const e1 = a.evaluate(x, {}, r).join(","), n = "viewport" !== o.get("text-rotation-alignment") && "point" !== o.get("symbol-placement");
                        this.allowVerticalPlacement = null === (i = this.writingModes) || void 0 === i ? void 0 : i.includes(t.ax.vertical);
                        for (const t of v.sections)if (t.image) f[t.image.name] = !0;
                        else {
                            const r = As(v.toString()), i = t.fontStack || e1;
                            d[i] || (d[i] = {}), this.calculateGlyphDependencies(t.text, d[i], n, this.allowVerticalPlacement, r);
                        }
                    }
                }
                "line" === o.get("symbol-placement") && (this.features = function(t) {
                    const e1 = {}, n = {}, r = [];
                    let i = 0;
                    function s(e1) {
                        r.push(t[e1]), i++;
                    }
                    function o(t, e1, i) {
                        const s = n[t];
                        return delete n[t], n[e1] = s, r[s].geometry[0].pop(), r[s].geometry[0] = r[s].geometry[0].concat(i[0]), s;
                    }
                    function a(t, n, i) {
                        const s = e1[n];
                        return delete e1[n], e1[t] = s, r[s].geometry[0].shift(), r[s].geometry[0] = i[0].concat(r[s].geometry[0]), s;
                    }
                    function l(t, e1, n) {
                        const r = n ? e1[0][e1[0].length - 1] : e1[0][0];
                        return `${t}:${r.x}:${r.y}`;
                    }
                    for(let u = 0; u < t.length; u++){
                        const c = t[u], h = c.geometry, p = c.text ? c.text.toString() : null;
                        if (!p) {
                            s(u);
                            continue;
                        }
                        const f = l(p, h), d = l(p, h, !0);
                        if (f in n && d in e1 && n[f] !== e1[d]) {
                            const t = a(f, d, h), i = o(f, d, r[t].geometry);
                            delete e1[f], delete n[d], n[l(p, r[i].geometry, !0)] = i, r[t].geometry = null;
                        } else f in n ? o(f, d, h) : d in e1 ? a(f, d, h) : (s(u), e1[f] = i - 1, n[d] = i - 1);
                    }
                    return r.filter((t)=>t.geometry);
                }(this.features)), this.sortFeaturesByKey && this.features.sort((t, e1)=>t.sortKey - e1.sortKey);
            }
            update(t, e1, n) {
                this.stateDependentLayers.length && (this.text.programConfigurations.updatePaintArrays(t, e1, this.layers, {
                    imagePositions: n
                }), this.icon.programConfigurations.updatePaintArrays(t, e1, this.layers, {
                    imagePositions: n
                }));
            }
            isEmpty() {
                return 0 === this.symbolInstances.length && !this.hasRTLText;
            }
            uploadPending() {
                return !this.uploaded || this.text.programConfigurations.needsUpload || this.icon.programConfigurations.needsUpload;
            }
            upload(t) {
                !this.uploaded && this.hasDebugData() && (this.textCollisionBox.upload(t), this.iconCollisionBox.upload(t)), this.text.upload(t, this.sortFeaturesByY, !this.uploaded, this.text.programConfigurations.needsUpload), this.icon.upload(t, this.sortFeaturesByY, !this.uploaded, this.icon.programConfigurations.needsUpload), this.uploaded = !0;
            }
            destroyDebugData() {
                this.textCollisionBox.destroy(), this.iconCollisionBox.destroy();
            }
            destroy() {
                this.text.destroy(), this.icon.destroy(), this.hasDebugData() && this.destroyDebugData();
            }
            addToLineVertexArray(t, e1) {
                const n = this.lineVertexArray.length;
                if (void 0 !== t.segment) {
                    let n = t.dist(e1[t.segment + 1]), r = t.dist(e1[t.segment]);
                    const i = {};
                    for(let r = t.segment + 1; r < e1.length; r++)i[r] = {
                        x: e1[r].x,
                        y: e1[r].y,
                        tileUnitDistanceFromAnchor: n
                    }, r < e1.length - 1 && (n += e1[r + 1].dist(e1[r]));
                    for(let n = t.segment || 0; n >= 0; n--)i[n] = {
                        x: e1[n].x,
                        y: e1[n].y,
                        tileUnitDistanceFromAnchor: r
                    }, n > 0 && (r += e1[n - 1].dist(e1[n]));
                    for(let t = 0; t < e1.length; t++){
                        const e1 = i[t];
                        this.lineVertexArray.emplaceBack(e1.x, e1.y, e1.tileUnitDistanceFromAnchor);
                    }
                }
                return {
                    lineStartIndex: n,
                    lineLength: this.lineVertexArray.length - n
                };
            }
            addSymbols(e1, n, r, i, s, o, a, l, u, c, h, p) {
                const f = e1.indexArray, d = e1.layoutVertexArray, y = e1.segments.prepareSegment(4 * n.length, d, f, this.canOverlap ? o.sortKey : void 0), m = this.glyphOffsetArray.length, g = y.vertexLength, x = this.allowVerticalPlacement && a === t.ax.vertical ? Math.PI / 2 : 0, v = o.text && o.text.sections;
                for(let t = 0; t < n.length; t++){
                    const { tl: i, tr: s, bl: a, br: u, tex: c, pixelOffsetTL: h, pixelOffsetBR: m, minFontScaleX: g, minFontScaleY: b, glyphOffset: w, isSDF: _, sectionIndex: S } = n[t], A = y.vertexLength, M = w[1];
                    wp(d, l.x, l.y, i.x, M + i.y, c.x, c.y, r, _, h.x, h.y, g, b), wp(d, l.x, l.y, s.x, M + s.y, c.x + c.w, c.y, r, _, m.x, h.y, g, b), wp(d, l.x, l.y, a.x, M + a.y, c.x, c.y + c.h, r, _, h.x, m.y, g, b), wp(d, l.x, l.y, u.x, M + u.y, c.x + c.w, c.y + c.h, r, _, m.x, m.y, g, b), _p(e1.dynamicLayoutVertexArray, l, x), f.emplaceBack(A, A + 2, A + 1), f.emplaceBack(A + 1, A + 2, A + 3), y.vertexLength += 4, y.primitiveLength += 2, this.glyphOffsetArray.emplaceBack(w[0]), t !== n.length - 1 && S === n[t + 1].sectionIndex || e1.programConfigurations.populatePaintArrays(d.length, o, o.index, {
                        imagePositions: {},
                        canonical: p,
                        formattedSection: null == v ? void 0 : v[S]
                    });
                }
                e1.placedSymbolArray.emplaceBack(l.x, l.y, m, this.glyphOffsetArray.length - m, g, u, c, l.segment, r ? r[0] : 0, r ? r[1] : 0, i[0], i[1], a, 0, !1, 0, h);
            }
            _addCollisionDebugVertex(t, e1, n, r, i, s) {
                return e1.emplaceBack(0, 0), t.emplaceBack(n.x, n.y, r, i, Math.round(s.x), Math.round(s.y));
            }
            addCollisionDebugVertices(t, e1, r, i, s, o, a) {
                const l = s.segments.prepareSegment(4, s.layoutVertexArray, s.indexArray), u = l.vertexLength, c = s.layoutVertexArray, h = s.collisionVertexArray, p = a.anchorX, f = a.anchorY;
                this._addCollisionDebugVertex(c, h, o, p, f, new n(t, e1)), this._addCollisionDebugVertex(c, h, o, p, f, new n(r, e1)), this._addCollisionDebugVertex(c, h, o, p, f, new n(r, i)), this._addCollisionDebugVertex(c, h, o, p, f, new n(t, i)), l.vertexLength += 4;
                const d = s.indexArray;
                d.emplaceBack(u, u + 1), d.emplaceBack(u + 1, u + 2), d.emplaceBack(u + 2, u + 3), d.emplaceBack(u + 3, u), l.primitiveLength += 4;
            }
            addDebugCollisionBoxes(t, e1, n, r) {
                for(let i = t; i < e1; i++){
                    const t = this.collisionBoxArray.get(i);
                    this.addCollisionDebugVertices(t.x1, t.y1, t.x2, t.y2, r ? this.textCollisionBox : this.iconCollisionBox, t.anchorPoint, n);
                }
            }
            generateCollisionDebugBuffers() {
                this.hasDebugData() && this.destroyDebugData(), this.textCollisionBox = new Mp(ra, Sh.members, oa), this.iconCollisionBox = new Mp(ra, Sh.members, oa);
                for(let t = 0; t < this.symbolInstances.length; t++){
                    const e1 = this.symbolInstances.get(t);
                    this.addDebugCollisionBoxes(e1.textBoxStartIndex, e1.textBoxEndIndex, e1, !0), this.addDebugCollisionBoxes(e1.verticalTextBoxStartIndex, e1.verticalTextBoxEndIndex, e1, !0), this.addDebugCollisionBoxes(e1.iconBoxStartIndex, e1.iconBoxEndIndex, e1, !1), this.addDebugCollisionBoxes(e1.verticalIconBoxStartIndex, e1.verticalIconBoxEndIndex, e1, !1);
                }
            }
            _deserializeCollisionBoxesForSymbol(t, e1, n, r, i, s, o, a, l) {
                const u = {};
                for(let r = e1; r < n; r++){
                    const e1 = t.get(r);
                    u.textBox = {
                        x1: e1.x1,
                        y1: e1.y1,
                        x2: e1.x2,
                        y2: e1.y2,
                        anchorPointX: e1.anchorPointX,
                        anchorPointY: e1.anchorPointY
                    }, u.textFeatureIndex = e1.featureIndex;
                    break;
                }
                for(let e1 = r; e1 < i; e1++){
                    const n = t.get(e1);
                    u.verticalTextBox = {
                        x1: n.x1,
                        y1: n.y1,
                        x2: n.x2,
                        y2: n.y2,
                        anchorPointX: n.anchorPointX,
                        anchorPointY: n.anchorPointY
                    }, u.verticalTextFeatureIndex = n.featureIndex;
                    break;
                }
                for(let e1 = s; e1 < o; e1++){
                    const n = t.get(e1);
                    u.iconBox = {
                        x1: n.x1,
                        y1: n.y1,
                        x2: n.x2,
                        y2: n.y2,
                        anchorPointX: n.anchorPointX,
                        anchorPointY: n.anchorPointY
                    }, u.iconFeatureIndex = n.featureIndex;
                    break;
                }
                for(let e1 = a; e1 < l; e1++){
                    const n = t.get(e1);
                    u.verticalIconBox = {
                        x1: n.x1,
                        y1: n.y1,
                        x2: n.x2,
                        y2: n.y2,
                        anchorPointX: n.anchorPointX,
                        anchorPointY: n.anchorPointY
                    }, u.verticalIconFeatureIndex = n.featureIndex;
                    break;
                }
                return u;
            }
            deserializeCollisionBoxes(t) {
                this.collisionArrays = [];
                for(let e1 = 0; e1 < this.symbolInstances.length; e1++){
                    const n = this.symbolInstances.get(e1);
                    this.collisionArrays.push(this._deserializeCollisionBoxesForSymbol(t, n.textBoxStartIndex, n.textBoxEndIndex, n.verticalTextBoxStartIndex, n.verticalTextBoxEndIndex, n.iconBoxStartIndex, n.iconBoxEndIndex, n.verticalIconBoxStartIndex, n.verticalIconBoxEndIndex));
                }
            }
            hasTextData() {
                return this.text.segments.get().length > 0;
            }
            hasIconData() {
                return this.icon.segments.get().length > 0;
            }
            hasDebugData() {
                return this.textCollisionBox && this.iconCollisionBox;
            }
            hasTextCollisionBoxData() {
                return this.hasDebugData() && this.textCollisionBox.segments.get().length > 0;
            }
            hasIconCollisionBoxData() {
                return this.hasDebugData() && this.iconCollisionBox.segments.get().length > 0;
            }
            addIndicesForPlacedSymbol(t, e1) {
                const n = t.placedSymbolArray.get(e1), r = n.vertexStartIndex + 4 * n.numGlyphs;
                for(let e1 = n.vertexStartIndex; e1 < r; e1 += 4)t.indexArray.emplaceBack(e1, e1 + 2, e1 + 1), t.indexArray.emplaceBack(e1 + 1, e1 + 2, e1 + 3);
            }
            getSortedSymbolIndexes(t) {
                if (this.sortedAngle === t && void 0 !== this.symbolInstanceIndexes) return this.symbolInstanceIndexes;
                const e1 = Math.sin(t), n = Math.cos(t), r = [], i = [], s = [];
                for(let t = 0; t < this.symbolInstances.length; ++t){
                    s.push(t);
                    const o = this.symbolInstances.get(t);
                    r.push(0 | Math.round(e1 * o.anchorX + n * o.anchorY)), i.push(o.featureIndex);
                }
                return s.sort((t, e1)=>r[t] - r[e1] || i[e1] - i[t]), s;
            }
            addToSortKeyRanges(t, e1) {
                const n = this.sortKeyRanges[this.sortKeyRanges.length - 1];
                (null == n ? void 0 : n.sortKey) === e1 ? n.symbolInstanceEnd = t + 1 : this.sortKeyRanges.push({
                    sortKey: e1,
                    symbolInstanceStart: t,
                    symbolInstanceEnd: t + 1
                });
            }
            sortFeatures(t) {
                if (this.sortFeaturesByY && this.sortedAngle !== t && !(this.text.segments.get().length > 1 || this.icon.segments.get().length > 1)) {
                    this.symbolInstanceIndexes = this.getSortedSymbolIndexes(t), this.sortedAngle = t, this.text.indexArray.clear(), this.icon.indexArray.clear(), this.featureSortOrder = [];
                    for (const t of this.symbolInstanceIndexes){
                        const e1 = this.symbolInstances.get(t);
                        this.featureSortOrder.push(e1.featureIndex);
                        const n = [
                            e1.rightJustifiedTextSymbolIndex,
                            e1.centerJustifiedTextSymbolIndex,
                            e1.leftJustifiedTextSymbolIndex
                        ];
                        for(let t = 0; t < n.length; t++){
                            const e1 = n[t];
                            e1 >= 0 && n.indexOf(e1) === t && this.addIndicesForPlacedSymbol(this.text, e1);
                        }
                        e1.verticalPlacedTextSymbolIndex >= 0 && this.addIndicesForPlacedSymbol(this.text, e1.verticalPlacedTextSymbolIndex), e1.placedIconSymbolIndex >= 0 && this.addIndicesForPlacedSymbol(this.icon, e1.placedIconSymbolIndex), e1.verticalPlacedIconSymbolIndex >= 0 && this.addIndicesForPlacedSymbol(this.icon, e1.verticalPlacedIconSymbolIndex);
                    }
                    this.text.indexBuffer && this.text.indexBuffer.updateData(this.text.indexArray), this.icon.indexBuffer && this.icon.indexBuffer.updateData(this.icon.indexArray);
                }
            }
        }
        let Ip, Ep;
        ds("SymbolBucket", kp, {
            omit: [
                "layers",
                "collisionBoxArray",
                "features",
                "compareText"
            ]
        }), kp.MAX_GLYPHS = 65535, kp.addDynamicAttributes = _p;
        var Tp = {
            get paint () {
                return Ep = Ep || new Ks({
                    "icon-opacity": new Ys(wt.paint_symbol["icon-opacity"]),
                    "icon-color": new Ys(wt.paint_symbol["icon-color"]),
                    "icon-halo-color": new Ys(wt.paint_symbol["icon-halo-color"]),
                    "icon-halo-width": new Ys(wt.paint_symbol["icon-halo-width"]),
                    "icon-halo-blur": new Ys(wt.paint_symbol["icon-halo-blur"]),
                    "icon-translate": new Xs(wt.paint_symbol["icon-translate"]),
                    "icon-translate-anchor": new Xs(wt.paint_symbol["icon-translate-anchor"]),
                    "text-opacity": new Ys(wt.paint_symbol["text-opacity"]),
                    "text-color": new Ys(wt.paint_symbol["text-color"], {
                        runtimeType: Nt,
                        getOverride: (t)=>t.textColor,
                        hasOverride: (t)=>!!t.textColor
                    }),
                    "text-halo-color": new Ys(wt.paint_symbol["text-halo-color"]),
                    "text-halo-width": new Ys(wt.paint_symbol["text-halo-width"]),
                    "text-halo-blur": new Ys(wt.paint_symbol["text-halo-blur"]),
                    "text-translate": new Xs(wt.paint_symbol["text-translate"]),
                    "text-translate-anchor": new Xs(wt.paint_symbol["text-translate-anchor"])
                });
            },
            get layout () {
                return Ip = Ip || new Ks({
                    "symbol-placement": new Xs(wt.layout_symbol["symbol-placement"]),
                    "symbol-spacing": new Xs(wt.layout_symbol["symbol-spacing"]),
                    "symbol-avoid-edges": new Xs(wt.layout_symbol["symbol-avoid-edges"]),
                    "symbol-sort-key": new Ys(wt.layout_symbol["symbol-sort-key"]),
                    "symbol-z-order": new Xs(wt.layout_symbol["symbol-z-order"]),
                    "icon-allow-overlap": new Xs(wt.layout_symbol["icon-allow-overlap"]),
                    "icon-overlap": new Xs(wt.layout_symbol["icon-overlap"]),
                    "icon-ignore-placement": new Xs(wt.layout_symbol["icon-ignore-placement"]),
                    "icon-optional": new Xs(wt.layout_symbol["icon-optional"]),
                    "icon-rotation-alignment": new Xs(wt.layout_symbol["icon-rotation-alignment"]),
                    "icon-size": new Ys(wt.layout_symbol["icon-size"]),
                    "icon-text-fit": new Xs(wt.layout_symbol["icon-text-fit"]),
                    "icon-text-fit-padding": new Xs(wt.layout_symbol["icon-text-fit-padding"]),
                    "icon-image": new Ys(wt.layout_symbol["icon-image"]),
                    "icon-rotate": new Ys(wt.layout_symbol["icon-rotate"]),
                    "icon-padding": new Ys(wt.layout_symbol["icon-padding"]),
                    "icon-keep-upright": new Xs(wt.layout_symbol["icon-keep-upright"]),
                    "icon-offset": new Ys(wt.layout_symbol["icon-offset"]),
                    "icon-anchor": new Ys(wt.layout_symbol["icon-anchor"]),
                    "icon-pitch-alignment": new Xs(wt.layout_symbol["icon-pitch-alignment"]),
                    "text-pitch-alignment": new Xs(wt.layout_symbol["text-pitch-alignment"]),
                    "text-rotation-alignment": new Xs(wt.layout_symbol["text-rotation-alignment"]),
                    "text-field": new Ys(wt.layout_symbol["text-field"]),
                    "text-font": new Ys(wt.layout_symbol["text-font"]),
                    "text-size": new Ys(wt.layout_symbol["text-size"]),
                    "text-max-width": new Ys(wt.layout_symbol["text-max-width"]),
                    "text-line-height": new Xs(wt.layout_symbol["text-line-height"]),
                    "text-letter-spacing": new Ys(wt.layout_symbol["text-letter-spacing"]),
                    "text-justify": new Ys(wt.layout_symbol["text-justify"]),
                    "text-radial-offset": new Ys(wt.layout_symbol["text-radial-offset"]),
                    "text-variable-anchor": new Xs(wt.layout_symbol["text-variable-anchor"]),
                    "text-variable-anchor-offset": new Ys(wt.layout_symbol["text-variable-anchor-offset"]),
                    "text-anchor": new Ys(wt.layout_symbol["text-anchor"]),
                    "text-max-angle": new Xs(wt.layout_symbol["text-max-angle"]),
                    "text-writing-mode": new Xs(wt.layout_symbol["text-writing-mode"]),
                    "text-rotate": new Ys(wt.layout_symbol["text-rotate"]),
                    "text-padding": new Xs(wt.layout_symbol["text-padding"]),
                    "text-keep-upright": new Xs(wt.layout_symbol["text-keep-upright"]),
                    "text-transform": new Ys(wt.layout_symbol["text-transform"]),
                    "text-offset": new Ys(wt.layout_symbol["text-offset"]),
                    "text-allow-overlap": new Xs(wt.layout_symbol["text-allow-overlap"]),
                    "text-overlap": new Xs(wt.layout_symbol["text-overlap"]),
                    "text-ignore-placement": new Xs(wt.layout_symbol["text-ignore-placement"]),
                    "text-optional": new Xs(wt.layout_symbol["text-optional"])
                });
            }
        };
        class Fp {
            constructor(t){
                if (void 0 === t.property.overrides) throw new Error("overrides must be provided to instantiate FormatSectionOverride class");
                this.type = t.property.overrides ? t.property.overrides.runtimeType : Lt, this.defaultValue = t;
            }
            evaluate(t) {
                if (t.formattedSection) {
                    const e1 = this.defaultValue.property.overrides;
                    if (null == e1 ? void 0 : e1.hasOverride(t.formattedSection)) return e1.getOverride(t.formattedSection);
                }
                return t.feature && t.featureState ? this.defaultValue.evaluate(t.feature, t.featureState) : this.defaultValue.property.specification.default;
            }
            eachChild(t) {
                this.defaultValue.isConstant() || t(this.defaultValue.value._styleExpression.expression);
            }
            outputDefined() {
                return !1;
            }
            serialize() {
                return null;
            }
        }
        ds("FormatSectionOverride", Fp, {
            omit: [
                "defaultValue"
            ]
        });
        class Pp extends to {
            constructor(t, e1){
                super(t, Tp, e1);
            }
            recalculate(t, e1) {
                if (super.recalculate(t, e1), "auto" === this.layout.get("icon-rotation-alignment") && (this.layout._values["icon-rotation-alignment"] = "point" !== this.layout.get("symbol-placement") ? "map" : "viewport"), "auto" === this.layout.get("text-rotation-alignment") && (this.layout._values["text-rotation-alignment"] = "point" !== this.layout.get("symbol-placement") ? "map" : "viewport"), "auto" === this.layout.get("text-pitch-alignment") && (this.layout._values["text-pitch-alignment"] = "map" === this.layout.get("text-rotation-alignment") ? "map" : "viewport"), "auto" === this.layout.get("icon-pitch-alignment") && (this.layout._values["icon-pitch-alignment"] = this.layout.get("icon-rotation-alignment")), "point" === this.layout.get("symbol-placement")) {
                    const t = this.layout.get("text-writing-mode");
                    if (t) {
                        const e1 = [];
                        for (const n of t)e1.includes(n) || e1.push(n);
                        this.layout._values["text-writing-mode"] = e1;
                    } else this.layout._values["text-writing-mode"] = [
                        "horizontal"
                    ];
                }
                this._setPaintOverrides();
            }
            getValueAndResolveTokens(t, e1, n, r) {
                const i = this.layout.get(t).evaluate(e1, {}, n, r), s = this._unevaluatedLayout._values[t];
                return s.isDataDriven() || ii(s.value) || !i ? i : function(t, e1) {
                    return e1.replace(/{([^{}]+)}/g, (e1, n)=>t && n in t ? String(t[n]) : "");
                }(e1.properties, i);
            }
            createBucket(t) {
                return new kp(t);
            }
            queryRadius() {
                return 0;
            }
            queryIntersectsFeature() {
                throw new Error("Should take a different path in FeatureIndex");
            }
            _setPaintOverrides() {
                for (const t of Tp.paint.overridableProperties){
                    if (!Pp.hasPaintOverride(this.layout, t)) continue;
                    const e1 = this.paint.get(t), n = new Fp(e1), r = new ri(n, e1.property.specification);
                    let i = null;
                    i = "constant" === e1.value.kind || "source" === e1.value.kind ? new oi("source", r) : new ai("composite", r, e1.value.zoomStops), this.paint._values[t] = new qs(e1.property, i, e1.parameters);
                }
            }
            _handleOverridablePaintPropertyUpdate(t, e1, n) {
                return !(!this.layout || e1.isDataDriven() || n.isDataDriven()) && Pp.hasPaintOverride(this.layout, t);
            }
            static hasPaintOverride(t, e1) {
                const n = t.get("text-field"), r = Tp.paint.properties[e1];
                let i = !1;
                const s = (t)=>{
                    var e1;
                    for (const n of t)if (null === (e1 = r.overrides) || void 0 === e1 ? void 0 : e1.hasOverride(n)) return void (i = !0);
                };
                if ("constant" === n.value.kind && n.value.value instanceof ze) s(n.value.value.sections);
                else if ("source" === n.value.kind || "composite" === n.value.kind) {
                    const t = (e1)=>{
                        i || (e1 instanceof Xe && qe(e1.value) === Xt ? s(e1.value.sections) : e1 instanceof Pn ? s(e1.sections) : e1.eachChild(t));
                    }, e1 = n.value;
                    e1._styleExpression && t(e1._styleExpression.expression);
                }
                return i;
            }
        }
        let Dp;
        var zp = {
            get paint () {
                return Dp = Dp || new Ks({
                    "background-color": new Xs(wt.paint_background["background-color"]),
                    "background-pattern": new Hs(wt.paint_background["background-pattern"]),
                    "background-opacity": new Xs(wt.paint_background["background-opacity"])
                });
            }
        };
        class Bp extends to {
            constructor(t, e1){
                super(t, zp, e1);
            }
        }
        class Cp extends to {
            constructor(t, e1){
                super(t, {}, e1), this.onAdd = (t)=>{
                    this.implementation.onAdd && this.implementation.onAdd(t, t.painter.context.gl);
                }, this.onRemove = (t)=>{
                    this.implementation.onRemove && this.implementation.onRemove(t, t.painter.context.gl);
                }, this.implementation = t;
            }
            is3D() {
                return "3d" === this.implementation.renderingMode;
            }
            hasOffscreenPass() {
                return void 0 !== this.implementation.prerender;
            }
            recalculate() {}
            updateTransitions() {}
            hasTransition() {
                return !1;
            }
            serialize() {
                throw new Error("Custom layers cannot be serialized");
            }
        }
        class Vp {
            constructor(t){
                this._methodToThrottle = t, this._triggered = !1, this._channel = new MessageChannel, this._channel.port2.onmessage = ()=>{
                    this._triggered = !1, this._methodToThrottle();
                };
            }
            trigger() {
                var t;
                this._triggered || (this._triggered = !0, null === (t = this._channel) || void 0 === t || t.port1.postMessage(!0));
            }
            remove() {
                delete this._channel, this._methodToThrottle = ()=>{};
            }
        }
        const Lp = {
            once: !0
        }, Op = 6371008.8;
        class $p {
            constructor(t, e1){
                if (isNaN(t) || isNaN(e1)) throw new Error(`Invalid LngLat object: (${t}, ${e1})`);
                if (this.lng = +t, this.lat = +e1, this.lat > 90 || this.lat < -90) throw new Error("Invalid LngLat latitude value: must be between -90 and 90");
            }
            wrap() {
                return new $p(O(this.lng, -180, 180), this.lat);
            }
            toArray() {
                return [
                    this.lng,
                    this.lat
                ];
            }
            toString() {
                return `LngLat(${this.lng}, ${this.lat})`;
            }
            distanceTo(t) {
                const e1 = Math.PI / 180, n = this.lat * e1, r = t.lat * e1, i = Math.sin(n) * Math.sin(r) + Math.cos(n) * Math.cos(r) * Math.cos((t.lng - this.lng) * e1);
                return Op * Math.acos(Math.min(i, 1));
            }
            static convert(t) {
                if (t instanceof $p) return t;
                if (Array.isArray(t) && (2 === t.length || 3 === t.length)) return new $p(Number(t[0]), Number(t[1]));
                if (!Array.isArray(t) && "object" == typeof t && null !== t) return new $p(Number("lng" in t ? t.lng : t.lon), Number(t.lat));
                throw new Error("`LngLatLike` argument must be specified as a LngLat instance, an object {lng: <lng>, lat: <lat>}, an object {lon: <lng>, lat: <lat>}, or an array of [<lng>, <lat>]");
            }
        }
        const Rp = 2 * Math.PI * Op;
        function Np(t) {
            return Rp * Math.cos(t * Math.PI / 180);
        }
        function Up(t) {
            return (180 + t) / 360;
        }
        function jp(t) {
            return (180 - 180 / Math.PI * Math.log(Math.tan(Math.PI / 4 + t * Math.PI / 360))) / 360;
        }
        function qp(t, e1) {
            return t / Np(e1);
        }
        function Gp(t) {
            return 360 * t - 180;
        }
        function Xp(t) {
            return 360 / Math.PI * Math.atan(Math.exp((180 - 360 * t) * Math.PI / 180)) - 90;
        }
        function Yp(t, e1) {
            return t * Np(Xp(e1));
        }
        class Zp {
            constructor(t, e1, n = 0){
                this.x = +t, this.y = +e1, this.z = +n;
            }
            static fromLngLat(t, e1 = 0) {
                const n = $p.convert(t);
                return new Zp(Up(n.lng), jp(n.lat), qp(e1, n.lat));
            }
            toLngLat() {
                return new $p(Gp(this.x), Xp(this.y));
            }
            toAltitude() {
                return Yp(this.z, this.y);
            }
            meterInMercatorCoordinateUnits() {
                var t;
                return 1 / Rp * (t = Xp(this.y), 1 / Math.cos(t * Math.PI / 180));
            }
        }
        function Hp(t, e1, n) {
            var r = 2 * Math.PI * 6378137 / 256 / Math.pow(2, n);
            return [
                t * r - 2 * Math.PI * 6378137 / 2,
                e1 * r - 2 * Math.PI * 6378137 / 2
            ];
        }
        class Wp {
            constructor(t, e1, n){
                if (!function(t, e1, n) {
                    return !(t < 0 || t > 25 || n < 0 || n >= Math.pow(2, t) || e1 < 0 || e1 >= Math.pow(2, t));
                }(t, e1, n)) throw new Error(`x=${e1}, y=${n}, z=${t} outside of bounds. 0<=x<${Math.pow(2, t)}, 0<=y<${Math.pow(2, t)} 0<=z<=25 `);
                this.z = t, this.x = e1, this.y = n, this.key = Qp(0, t, t, e1, n);
            }
            equals(t) {
                return this.z === t.z && this.x === t.x && this.y === t.y;
            }
            url(t, e1, n) {
                const r = (s = this.y, o = this.z, a = Hp(256 * (i = this.x), 256 * (s = Math.pow(2, o) - s - 1), o), l = Hp(256 * (i + 1), 256 * (s + 1), o), a[0] + "," + a[1] + "," + l[0] + "," + l[1]);
                var i, s, o, a, l;
                const u = function(t, e1, n) {
                    let r = "";
                    for(let i = t; i > 0; i--){
                        const t = 1 << i - 1;
                        r += (e1 & t ? 1 : 0) + (n & t ? 2 : 0);
                    }
                    return r;
                }(this.z, this.x, this.y);
                return t[(this.x + this.y) % t.length].replace(/{prefix}/g, (this.x % 16).toString(16) + (this.y % 16).toString(16)).replace(/{z}/g, String(this.z)).replace(/{x}/g, String(this.x)).replace(/{y}/g, String("tms" === n ? Math.pow(2, this.z) - this.y - 1 : this.y)).replace(/{ratio}/g, e1 > 1 ? "@2x" : "").replace(/{quadkey}/g, u).replace(/{bbox-epsg-3857}/g, r);
            }
            isChildOf(t) {
                const e1 = this.z - t.z;
                return e1 > 0 && t.x === this.x >> e1 && t.y === this.y >> e1;
            }
            getTilePoint(t) {
                const e1 = Math.pow(2, this.z);
                return new n((t.x * e1 - this.x) * T, (t.y * e1 - this.y) * T);
            }
            toString() {
                return `${this.z}/${this.x}/${this.y}`;
            }
        }
        class Kp {
            constructor(t, e1){
                this.wrap = t, this.canonical = e1, this.key = Qp(t, e1.z, e1.z, e1.x, e1.y);
            }
        }
        class Jp {
            constructor(t, e1, n, r, i){
                if (this.terrainRttPosMatrix32f = null, t < n) throw new Error(`overscaledZ should be >= z; overscaledZ = ${t}; z = ${n}`);
                this.overscaledZ = t, this.wrap = e1, this.canonical = new Wp(n, +r, +i), this.key = Qp(e1, t, n, r, i);
            }
            clone() {
                return new Jp(this.overscaledZ, this.wrap, this.canonical.z, this.canonical.x, this.canonical.y);
            }
            equals(t) {
                return this.overscaledZ === t.overscaledZ && this.wrap === t.wrap && this.canonical.equals(t.canonical);
            }
            scaledTo(t) {
                if (t > this.overscaledZ) throw new Error(`targetZ > this.overscaledZ; targetZ = ${t}; overscaledZ = ${this.overscaledZ}`);
                const e1 = this.canonical.z - t;
                return t > this.canonical.z ? new Jp(t, this.wrap, this.canonical.z, this.canonical.x, this.canonical.y) : new Jp(t, this.wrap, t, this.canonical.x >> e1, this.canonical.y >> e1);
            }
            isOverscaled() {
                return this.overscaledZ > this.canonical.z;
            }
            calculateScaledKey(t, e1) {
                if (t > this.overscaledZ) throw new Error(`targetZ > this.overscaledZ; targetZ = ${t}; overscaledZ = ${this.overscaledZ}`);
                const n = this.canonical.z - t;
                return t > this.canonical.z ? Qp(this.wrap * +e1, t, this.canonical.z, this.canonical.x, this.canonical.y) : Qp(this.wrap * +e1, t, t, this.canonical.x >> n, this.canonical.y >> n);
            }
            isChildOf(t) {
                if (t.wrap !== this.wrap) return !1;
                if (this.overscaledZ - t.overscaledZ <= 0) return !1;
                if (0 === t.overscaledZ) return this.overscaledZ > 0;
                const e1 = this.canonical.z - t.canonical.z;
                return !(e1 < 0) && t.canonical.x === this.canonical.x >> e1 && t.canonical.y === this.canonical.y >> e1;
            }
            children(t) {
                if (this.overscaledZ >= t) return [
                    new Jp(this.overscaledZ + 1, this.wrap, this.canonical.z, this.canonical.x, this.canonical.y)
                ];
                const e1 = this.canonical.z + 1, n = 2 * this.canonical.x, r = 2 * this.canonical.y;
                return [
                    new Jp(e1, this.wrap, e1, n, r),
                    new Jp(e1, this.wrap, e1, n + 1, r),
                    new Jp(e1, this.wrap, e1, n, r + 1),
                    new Jp(e1, this.wrap, e1, n + 1, r + 1)
                ];
            }
            isLessThan(t) {
                return this.wrap < t.wrap || !(this.wrap > t.wrap) && (this.overscaledZ < t.overscaledZ || !(this.overscaledZ > t.overscaledZ) && (this.canonical.x < t.canonical.x || !(this.canonical.x > t.canonical.x) && this.canonical.y < t.canonical.y));
            }
            wrapped() {
                return new Jp(this.overscaledZ, 0, this.canonical.z, this.canonical.x, this.canonical.y);
            }
            unwrapTo(t) {
                return new Jp(this.overscaledZ, t, this.canonical.z, this.canonical.x, this.canonical.y);
            }
            overscaleFactor() {
                return Math.pow(2, this.overscaledZ - this.canonical.z);
            }
            toUnwrapped() {
                return new Kp(this.wrap, this.canonical);
            }
            toString() {
                return `${this.overscaledZ}/${this.canonical.x}/${this.canonical.y}`;
            }
            getTilePoint(t) {
                return this.canonical.getTilePoint(new Zp(t.x - this.wrap, t.y));
            }
            normalizeCoordinates(t, e1, n = 8192) {
                if (t >= 0 && t < n && e1 >= 0 && e1 < n) return {
                    tileID: this,
                    x: t,
                    y: e1
                };
                const r = Math.floor(t / n), i = Math.floor(e1 / n), s = t - r * n, o = e1 - i * n, a = this.canonical.z, l = 1 << a, u = this.canonical.y + i;
                if (u < 0 || u >= l) return null;
                let c = this.canonical.x + r, h = this.wrap;
                return c < 0 ? (h -= Math.ceil(-c / l), c = (c % l + l) % l) : c >= l && (h += Math.floor(c / l), c %= l), {
                    tileID: new Jp(this.overscaledZ, h, a, c, u),
                    x: s,
                    y: o
                };
            }
        }
        function Qp(t, e1, n, r, i) {
            (t *= 2) < 0 && (t = -1 * t - 1);
            const s = 1 << n;
            return (s * s * t + s * i + r).toString(36) + n.toString(36) + e1.toString(36);
        }
        ds("CanonicalTileID", Wp), ds("OverscaledTileID", Jp, {
            omit: [
                "terrainRttPosMatrix32f"
            ]
        });
        class tf {
            constructor(){
                this.minX = 1 / 0, this.maxX = -1 / 0, this.minY = 1 / 0, this.maxY = -1 / 0;
            }
            extend(t) {
                return this.minX = Math.min(this.minX, t.x), this.minY = Math.min(this.minY, t.y), this.maxX = Math.max(this.maxX, t.x), this.maxY = Math.max(this.maxY, t.y), this;
            }
            expandBy(t) {
                return this.minX -= t, this.minY -= t, this.maxX += t, this.maxY += t, (this.minX > this.maxX || this.minY > this.maxY) && (this.minX = 1 / 0, this.maxX = -1 / 0, this.minY = 1 / 0, this.maxY = -1 / 0), this;
            }
            shrinkBy(t) {
                return this.expandBy(-t);
            }
            map(t) {
                const e1 = new tf;
                return e1.extend(t(new n(this.minX, this.minY))), e1.extend(t(new n(this.maxX, this.minY))), e1.extend(t(new n(this.minX, this.maxY))), e1.extend(t(new n(this.maxX, this.maxY))), e1;
            }
            static fromPoints(t) {
                const e1 = new tf;
                for (const n of t)e1.extend(n);
                return e1;
            }
            contains(t) {
                return t.x >= this.minX && t.x <= this.maxX && t.y >= this.minY && t.y <= this.maxY;
            }
            empty() {
                return this.minX > this.maxX;
            }
            width() {
                return this.maxX - this.minX;
            }
            height() {
                return this.maxY - this.minY;
            }
            covers(t) {
                return !this.empty() && !t.empty() && t.minX >= this.minX && t.maxX <= this.maxX && t.minY >= this.minY && t.maxY <= this.maxY;
            }
            intersects(t) {
                return !this.empty() && !t.empty() && t.minX <= this.maxX && t.maxX >= this.minX && t.minY <= this.maxY && t.maxY >= this.minY;
            }
        }
        class ef {
            constructor(t){
                this._stringToNumber = {}, this._numberToString = [];
                for(let e1 = 0; e1 < t.length; e1++){
                    const n = t[e1];
                    this._stringToNumber[n] = e1, this._numberToString[e1] = n;
                }
            }
            encode(t) {
                return this._stringToNumber[t];
            }
            decode(t) {
                if (t >= this._numberToString.length) throw new Error(`Out of bounds. Index requested n=${t} can't be >= this._numberToString.length ${this._numberToString.length}`);
                return this._numberToString[t];
            }
        }
        class nf {
            constructor(t, e1, n, r, i){
                this.type = "Feature", this._vectorTileFeature = t, this._x = n, this._y = r, this._z = e1, this.properties = t.properties, this.id = i;
            }
            projectPoint(t, e1, n, r) {
                return [
                    360 * (t.x + e1) / r - 180,
                    360 / Math.PI * Math.atan(Math.exp((1 - 2 * (t.y + n) / r) * Math.PI)) - 90
                ];
            }
            projectLine(t, e1, n, r) {
                return t.map((t)=>this.projectPoint(t, e1, n, r));
            }
            get geometry() {
                if (this._geometry) return this._geometry;
                const t = this._vectorTileFeature, e1 = t.extent * Math.pow(2, this._z), n = t.extent * this._x, r = t.extent * this._y, i = t.loadGeometry();
                switch(t.type){
                    case 1:
                        {
                            const t = [];
                            for (const e1 of i)t.push(e1[0]);
                            const s = this.projectLine(t, n, r, e1);
                            this._geometry = 1 === t.length ? {
                                type: "Point",
                                coordinates: s[0]
                            } : {
                                type: "MultiPoint",
                                coordinates: s
                            };
                            break;
                        }
                    case 2:
                        {
                            const t = i.map((t)=>this.projectLine(t, n, r, e1));
                            this._geometry = 1 === t.length ? {
                                type: "LineString",
                                coordinates: t[0]
                            } : {
                                type: "MultiLineString",
                                coordinates: t
                            };
                            break;
                        }
                    case 3:
                        {
                            const t = Lu(i), s = [];
                            for (const i of t)s.push(i.map((t)=>this.projectLine(t, n, r, e1)));
                            this._geometry = 1 === s.length ? {
                                type: "Polygon",
                                coordinates: s[0]
                            } : {
                                type: "MultiPolygon",
                                coordinates: s
                            };
                            break;
                        }
                    default:
                        throw new Error(`unknown feature type: ${t.type}`);
                }
                return this._geometry;
            }
            set geometry(t) {
                this._geometry = t;
            }
            toJSON() {
                const t = {
                    geometry: this.geometry
                };
                for(const e1 in this)"_geometry" !== e1 && "_vectorTileFeature" !== e1 && "_x" !== e1 && "_y" !== e1 && "_z" !== e1 && (t[e1] = this[e1]);
                return t;
            }
        }
        class rf {
            constructor(t, e1, n){
                this._name = t, this.dataBuffer = e1, "number" == typeof n ? this._size = n : (this.nullabilityBuffer = n, this._size = n.size());
            }
            getValue(t) {
                return this.nullabilityBuffer && !this.nullabilityBuffer.get(t) ? null : this.getValueFromBuffer(t);
            }
            has(t) {
                return this.nullabilityBuffer?.get(t) || !this.nullabilityBuffer;
            }
            get name() {
                return this._name;
            }
            get size() {
                return this._size;
            }
        }
        class sf extends rf {
        }
        class of extends sf {
            getValueFromBuffer(t) {
                return this.dataBuffer[t];
            }
        }
        class af extends sf {
            getValueFromBuffer(t) {
                return this.dataBuffer[t];
            }
        }
        class lf extends rf {
            constructor(t, e1, n, r){
                super(t, e1, r), this.delta = n;
            }
        }
        class uf extends lf {
            constructor(t, e1, n, r){
                super(t, Int32Array.of(e1), n, r);
            }
            getValueFromBuffer(t) {
                return this.dataBuffer[0] + t * this.delta;
            }
        }
        class cf extends rf {
            constructor(t, e1, n, r){
                super(t, r ? Int32Array.of(e1) : Uint32Array.of(e1), n);
            }
            getValueFromBuffer(t) {
                return this.dataBuffer[0];
            }
        }
        class hf {
            constructor(t, e1, n, r, i = 4096){
                this._name = t, this._geometryVector = e1, this._idVector = n, this._propertyVectors = r, this._extent = i;
            }
            get name() {
                return this._name;
            }
            get idVector() {
                return this._idVector;
            }
            get geometryVector() {
                return this._geometryVector;
            }
            get propertyVectors() {
                return this._propertyVectors;
            }
            getPropertyVector(t) {
                return this.propertyVectorsMap || (this.propertyVectorsMap = new Map(this._propertyVectors.map((t)=>[
                        t.name,
                        t
                    ]))), this.propertyVectorsMap.get(t);
            }
            get numFeatures() {
                return this.geometryVector.numGeometries;
            }
            get extent() {
                return this._extent;
            }
            getFeatures() {
                const t = [], e1 = this.geometryVector.getGeometries();
                for(let n = 0; n < this.numFeatures; n++){
                    let r;
                    if (this.idVector) {
                        const t = this.idVector.getValue(n);
                        r = this.containsMaxSafeIntegerValues(this.idVector) && null !== t ? Number(t) : t;
                    }
                    const i = {
                        coordinates: e1[n],
                        type: this.geometryVector.geometryType(n)
                    }, s = {};
                    for (const t of this.propertyVectors){
                        if (!t) continue;
                        const e1 = t.name, r = t.getValue(n);
                        null !== r && (s[e1] = r);
                    }
                    t.push({
                        id: r,
                        geometry: i,
                        properties: s
                    });
                }
                return t;
            }
            containsMaxSafeIntegerValues(t) {
                return t instanceof of || t instanceof cf || t instanceof uf || t instanceof af;
            }
        }
        class pf {
            constructor(t){
                this.value = t;
            }
            get() {
                return this.value;
            }
            set(t) {
                this.value = t;
            }
            increment() {
                return this.value++;
            }
            add(t) {
                this.value += t;
            }
        }
        var ff, df;
        !function(t) {
            t.NONE = "NONE", t.DELTA = "DELTA", t.COMPONENTWISE_DELTA = "COMPONENTWISE_DELTA", t.RLE = "RLE", t.MORTON = "MORTON", t.PDE = "PDE";
        }(ff || (ff = {})), function(t) {
            t.NONE = "NONE", t.FAST_PFOR = "FAST_PFOR", t.VARINT = "VARINT", t.ALP = "ALP";
        }(df || (df = {}));
        const yf = new Uint32Array(33);
        yf[0] = 0;
        for(let t = 1; t <= 32; t++)yf[t] = 32 === t ? 4294967295 : 4294967295 >>> 32 - t;
        const mf = yf, gf = 256;
        function xf(t, e1) {
            return t - t % e1;
        }
        function vf(t) {
            const e1 = t >>> 0;
            return ((255 & e1) << 24 | (65280 & e1) << 8 | e1 >>> 8 & 65280 | e1 >>> 24 & 255) >>> 0;
        }
        const bf = function() {
            if (!Number.isFinite(65536)) return 65536;
            const t = xf(Math.floor(65536), gf);
            return 0 === t ? gf : t;
        }(), wf = 3 * bf / gf + bf | 0;
        function _f() {
            const t = new Uint8Array(wf);
            return {
                dataToBePacked: new Array(33),
                dataPointers: new Int32Array(33),
                byteContainer: t,
                byteContainerI32: new Int32Array(t.buffer, t.byteOffset, t.byteLength >>> 2),
                exceptionSizes: new Int32Array(33)
            };
        }
        function Sf(t, e1, n, r, i) {
            switch(i){
                case 1:
                    !function(t, e1, n, r) {
                        let i = r, s = e1;
                        for(let e1 = 0; e1 < 8; e1++){
                            const e1 = t[s++] >>> 0;
                            n[i++] = e1 >>> 0 & 1, n[i++] = e1 >>> 1 & 1, n[i++] = e1 >>> 2 & 1, n[i++] = e1 >>> 3 & 1, n[i++] = e1 >>> 4 & 1, n[i++] = e1 >>> 5 & 1, n[i++] = e1 >>> 6 & 1, n[i++] = e1 >>> 7 & 1, n[i++] = e1 >>> 8 & 1, n[i++] = e1 >>> 9 & 1, n[i++] = e1 >>> 10 & 1, n[i++] = e1 >>> 11 & 1, n[i++] = e1 >>> 12 & 1, n[i++] = e1 >>> 13 & 1, n[i++] = e1 >>> 14 & 1, n[i++] = e1 >>> 15 & 1, n[i++] = e1 >>> 16 & 1, n[i++] = e1 >>> 17 & 1, n[i++] = e1 >>> 18 & 1, n[i++] = e1 >>> 19 & 1, n[i++] = e1 >>> 20 & 1, n[i++] = e1 >>> 21 & 1, n[i++] = e1 >>> 22 & 1, n[i++] = e1 >>> 23 & 1, n[i++] = e1 >>> 24 & 1, n[i++] = e1 >>> 25 & 1, n[i++] = e1 >>> 26 & 1, n[i++] = e1 >>> 27 & 1, n[i++] = e1 >>> 28 & 1, n[i++] = e1 >>> 29 & 1, n[i++] = e1 >>> 30 & 1, n[i++] = e1 >>> 31 & 1;
                        }
                    }(t, e1, n, r);
                    break;
                case 2:
                    !function(t, e1, n, r) {
                        let i = r, s = e1;
                        for(let e1 = 0; e1 < 8; e1++){
                            const e1 = t[s++] >>> 0, r = t[s++] >>> 0;
                            n[i++] = e1 >>> 0 & 3, n[i++] = e1 >>> 2 & 3, n[i++] = e1 >>> 4 & 3, n[i++] = e1 >>> 6 & 3, n[i++] = e1 >>> 8 & 3, n[i++] = e1 >>> 10 & 3, n[i++] = e1 >>> 12 & 3, n[i++] = e1 >>> 14 & 3, n[i++] = e1 >>> 16 & 3, n[i++] = e1 >>> 18 & 3, n[i++] = e1 >>> 20 & 3, n[i++] = e1 >>> 22 & 3, n[i++] = e1 >>> 24 & 3, n[i++] = e1 >>> 26 & 3, n[i++] = e1 >>> 28 & 3, n[i++] = e1 >>> 30 & 3, n[i++] = r >>> 0 & 3, n[i++] = r >>> 2 & 3, n[i++] = r >>> 4 & 3, n[i++] = r >>> 6 & 3, n[i++] = r >>> 8 & 3, n[i++] = r >>> 10 & 3, n[i++] = r >>> 12 & 3, n[i++] = r >>> 14 & 3, n[i++] = r >>> 16 & 3, n[i++] = r >>> 18 & 3, n[i++] = r >>> 20 & 3, n[i++] = r >>> 22 & 3, n[i++] = r >>> 24 & 3, n[i++] = r >>> 26 & 3, n[i++] = r >>> 28 & 3, n[i++] = r >>> 30 & 3;
                        }
                    }(t, e1, n, r);
                    break;
                case 3:
                    !function(t, e1, n, r) {
                        let i = r, s = e1;
                        for(let e1 = 0; e1 < 8; e1++){
                            const e1 = t[s++] >>> 0, r = t[s++] >>> 0, o = t[s++] >>> 0;
                            n[i++] = e1 >>> 0 & 7, n[i++] = e1 >>> 3 & 7, n[i++] = e1 >>> 6 & 7, n[i++] = e1 >>> 9 & 7, n[i++] = e1 >>> 12 & 7, n[i++] = e1 >>> 15 & 7, n[i++] = e1 >>> 18 & 7, n[i++] = e1 >>> 21 & 7, n[i++] = e1 >>> 24 & 7, n[i++] = e1 >>> 27 & 7, n[i++] = 7 & (e1 >>> 30 | (1 & r) << 2), n[i++] = r >>> 1 & 7, n[i++] = r >>> 4 & 7, n[i++] = r >>> 7 & 7, n[i++] = r >>> 10 & 7, n[i++] = r >>> 13 & 7, n[i++] = r >>> 16 & 7, n[i++] = r >>> 19 & 7, n[i++] = r >>> 22 & 7, n[i++] = r >>> 25 & 7, n[i++] = r >>> 28 & 7, n[i++] = 7 & (r >>> 31 | (3 & o) << 1), n[i++] = o >>> 2 & 7, n[i++] = o >>> 5 & 7, n[i++] = o >>> 8 & 7, n[i++] = o >>> 11 & 7, n[i++] = o >>> 14 & 7, n[i++] = o >>> 17 & 7, n[i++] = o >>> 20 & 7, n[i++] = o >>> 23 & 7, n[i++] = o >>> 26 & 7, n[i++] = o >>> 29 & 7;
                        }
                    }(t, e1, n, r);
                    break;
                case 4:
                    !function(t, e1, n, r) {
                        let i = r, s = e1;
                        for(let e1 = 0; e1 < 8; e1++){
                            const e1 = t[s++] >>> 0, r = t[s++] >>> 0, o = t[s++] >>> 0, a = t[s++] >>> 0;
                            n[i++] = e1 >>> 0 & 15, n[i++] = e1 >>> 4 & 15, n[i++] = e1 >>> 8 & 15, n[i++] = e1 >>> 12 & 15, n[i++] = e1 >>> 16 & 15, n[i++] = e1 >>> 20 & 15, n[i++] = e1 >>> 24 & 15, n[i++] = e1 >>> 28 & 15, n[i++] = r >>> 0 & 15, n[i++] = r >>> 4 & 15, n[i++] = r >>> 8 & 15, n[i++] = r >>> 12 & 15, n[i++] = r >>> 16 & 15, n[i++] = r >>> 20 & 15, n[i++] = r >>> 24 & 15, n[i++] = r >>> 28 & 15, n[i++] = o >>> 0 & 15, n[i++] = o >>> 4 & 15, n[i++] = o >>> 8 & 15, n[i++] = o >>> 12 & 15, n[i++] = o >>> 16 & 15, n[i++] = o >>> 20 & 15, n[i++] = o >>> 24 & 15, n[i++] = o >>> 28 & 15, n[i++] = a >>> 0 & 15, n[i++] = a >>> 4 & 15, n[i++] = a >>> 8 & 15, n[i++] = a >>> 12 & 15, n[i++] = a >>> 16 & 15, n[i++] = a >>> 20 & 15, n[i++] = a >>> 24 & 15, n[i++] = a >>> 28 & 15;
                        }
                    }(t, e1, n, r);
                    break;
                case 5:
                    !function(t, e1, n, r) {
                        let i = r, s = e1;
                        for(let e1 = 0; e1 < 8; e1++){
                            const e1 = t[s++] >>> 0, r = t[s++] >>> 0, o = t[s++] >>> 0, a = t[s++] >>> 0, l = t[s++] >>> 0;
                            n[i++] = e1 >>> 0 & 31, n[i++] = e1 >>> 5 & 31, n[i++] = e1 >>> 10 & 31, n[i++] = e1 >>> 15 & 31, n[i++] = e1 >>> 20 & 31, n[i++] = e1 >>> 25 & 31, n[i++] = 31 & (e1 >>> 30 | (7 & r) << 2), n[i++] = r >>> 3 & 31, n[i++] = r >>> 8 & 31, n[i++] = r >>> 13 & 31, n[i++] = r >>> 18 & 31, n[i++] = r >>> 23 & 31, n[i++] = 31 & (r >>> 28 | (1 & o) << 4), n[i++] = o >>> 1 & 31, n[i++] = o >>> 6 & 31, n[i++] = o >>> 11 & 31, n[i++] = o >>> 16 & 31, n[i++] = o >>> 21 & 31, n[i++] = o >>> 26 & 31, n[i++] = 31 & (o >>> 31 | (15 & a) << 1), n[i++] = a >>> 4 & 31, n[i++] = a >>> 9 & 31, n[i++] = a >>> 14 & 31, n[i++] = a >>> 19 & 31, n[i++] = a >>> 24 & 31, n[i++] = 31 & (a >>> 29 | (3 & l) << 3), n[i++] = l >>> 2 & 31, n[i++] = l >>> 7 & 31, n[i++] = l >>> 12 & 31, n[i++] = l >>> 17 & 31, n[i++] = l >>> 22 & 31, n[i++] = l >>> 27 & 31;
                        }
                    }(t, e1, n, r);
                    break;
                case 6:
                    !function(t, e1, n, r) {
                        let i = r, s = e1;
                        for(let e1 = 0; e1 < 8; e1++){
                            const e1 = t[s++] >>> 0, r = t[s++] >>> 0, o = t[s++] >>> 0, a = t[s++] >>> 0, l = t[s++] >>> 0, u = t[s++] >>> 0;
                            n[i++] = e1 >>> 0 & 63, n[i++] = e1 >>> 6 & 63, n[i++] = e1 >>> 12 & 63, n[i++] = e1 >>> 18 & 63, n[i++] = e1 >>> 24 & 63, n[i++] = 63 & (e1 >>> 30 | (15 & r) << 2), n[i++] = r >>> 4 & 63, n[i++] = r >>> 10 & 63, n[i++] = r >>> 16 & 63, n[i++] = r >>> 22 & 63, n[i++] = 63 & (r >>> 28 | (3 & o) << 4), n[i++] = o >>> 2 & 63, n[i++] = o >>> 8 & 63, n[i++] = o >>> 14 & 63, n[i++] = o >>> 20 & 63, n[i++] = o >>> 26 & 63, n[i++] = a >>> 0 & 63, n[i++] = a >>> 6 & 63, n[i++] = a >>> 12 & 63, n[i++] = a >>> 18 & 63, n[i++] = a >>> 24 & 63, n[i++] = 63 & (a >>> 30 | (15 & l) << 2), n[i++] = l >>> 4 & 63, n[i++] = l >>> 10 & 63, n[i++] = l >>> 16 & 63, n[i++] = l >>> 22 & 63, n[i++] = 63 & (l >>> 28 | (3 & u) << 4), n[i++] = u >>> 2 & 63, n[i++] = u >>> 8 & 63, n[i++] = u >>> 14 & 63, n[i++] = u >>> 20 & 63, n[i++] = u >>> 26 & 63;
                        }
                    }(t, e1, n, r);
                    break;
                case 7:
                    !function(t, e1, n, r) {
                        let i = r, s = e1;
                        for(let e1 = 0; e1 < 8; e1++){
                            const e1 = t[s++] >>> 0, r = t[s++] >>> 0, o = t[s++] >>> 0, a = t[s++] >>> 0, l = t[s++] >>> 0, u = t[s++] >>> 0, c = t[s++] >>> 0;
                            n[i++] = e1 >>> 0 & 127, n[i++] = e1 >>> 7 & 127, n[i++] = e1 >>> 14 & 127, n[i++] = e1 >>> 21 & 127, n[i++] = 127 & (e1 >>> 28 | (7 & r) << 4), n[i++] = r >>> 3 & 127, n[i++] = r >>> 10 & 127, n[i++] = r >>> 17 & 127, n[i++] = r >>> 24 & 127, n[i++] = 127 & (r >>> 31 | (63 & o) << 1), n[i++] = o >>> 6 & 127, n[i++] = o >>> 13 & 127, n[i++] = o >>> 20 & 127, n[i++] = 127 & (o >>> 27 | (3 & a) << 5), n[i++] = a >>> 2 & 127, n[i++] = a >>> 9 & 127, n[i++] = a >>> 16 & 127, n[i++] = a >>> 23 & 127, n[i++] = 127 & (a >>> 30 | (31 & l) << 2), n[i++] = l >>> 5 & 127, n[i++] = l >>> 12 & 127, n[i++] = l >>> 19 & 127, n[i++] = 127 & (l >>> 26 | (1 & u) << 6), n[i++] = u >>> 1 & 127, n[i++] = u >>> 8 & 127, n[i++] = u >>> 15 & 127, n[i++] = u >>> 22 & 127, n[i++] = 127 & (u >>> 29 | (15 & c) << 3), n[i++] = c >>> 4 & 127, n[i++] = c >>> 11 & 127, n[i++] = c >>> 18 & 127, n[i++] = c >>> 25 & 127;
                        }
                    }(t, e1, n, r);
                    break;
                case 8:
                    !function(t, e1, n, r) {
                        let i = r, s = e1;
                        for(let e1 = 0; e1 < 8; e1++){
                            const e1 = t[s++] >>> 0, r = t[s++] >>> 0, o = t[s++] >>> 0, a = t[s++] >>> 0, l = t[s++] >>> 0, u = t[s++] >>> 0, c = t[s++] >>> 0, h = t[s++] >>> 0;
                            n[i++] = e1 >>> 0 & 255, n[i++] = e1 >>> 8 & 255, n[i++] = e1 >>> 16 & 255, n[i++] = e1 >>> 24 & 255, n[i++] = r >>> 0 & 255, n[i++] = r >>> 8 & 255, n[i++] = r >>> 16 & 255, n[i++] = r >>> 24 & 255, n[i++] = o >>> 0 & 255, n[i++] = o >>> 8 & 255, n[i++] = o >>> 16 & 255, n[i++] = o >>> 24 & 255, n[i++] = a >>> 0 & 255, n[i++] = a >>> 8 & 255, n[i++] = a >>> 16 & 255, n[i++] = a >>> 24 & 255, n[i++] = l >>> 0 & 255, n[i++] = l >>> 8 & 255, n[i++] = l >>> 16 & 255, n[i++] = l >>> 24 & 255, n[i++] = u >>> 0 & 255, n[i++] = u >>> 8 & 255, n[i++] = u >>> 16 & 255, n[i++] = u >>> 24 & 255, n[i++] = c >>> 0 & 255, n[i++] = c >>> 8 & 255, n[i++] = c >>> 16 & 255, n[i++] = c >>> 24 & 255, n[i++] = h >>> 0 & 255, n[i++] = h >>> 8 & 255, n[i++] = h >>> 16 & 255, n[i++] = h >>> 24 & 255;
                        }
                    }(t, e1, n, r);
                    break;
                case 16:
                    !function(t, e1, n, r) {
                        let i = r, s = e1;
                        for(let e1 = 0; e1 < 128; e1++){
                            const e1 = t[s++] >>> 0;
                            n[i++] = 65535 & e1, n[i++] = e1 >>> 16 & 65535;
                        }
                    }(t, e1, n, r);
                    break;
                default:
                    !function(t, e1, n, r, i) {
                        const s = mf[i] >>> 0;
                        let o = e1, a = 0, l = t[o] >>> 0, u = r;
                        for(let e1 = 0; e1 < 8; e1++){
                            for(let e1 = 0; e1 < 32; e1++)if (a + i <= 32) n[u + e1] = l >>> a & s, a += i, 32 === a && (a = 0, o++, 31 !== e1 && (l = t[o] >>> 0));
                            else {
                                const r = 32 - a, c = l >>> a;
                                o++, l = t[o] >>> 0;
                                const h = i - r;
                                n[u + e1] = (c | (l & -1 >>> 32 - h >>> 0) << r) & s, a = h;
                            }
                            u += 32, a = 0, e1 < 7 && (l = t[o] >>> 0);
                        }
                    }(t, e1, n, r, i);
            }
            return e1 + (i << 3) | 0;
        }
        function Af(t, e1, n, r) {
            if (n + 2 > e1) throw new Error(`FastPFOR decode: byteContainer underflow at block=${r} (need 2 bytes for [bitWidth, exceptionCount], bytePos=${n}, byteSize=${e1})`);
            const i = t[n++], s = t[n++];
            if (i > 32) throw new Error(`FastPFOR decode: invalid bitWidth=${i} at block=${r} (expected 0..32). This likely indicates corrupted or truncated input.`);
            return {
                bitWidth: i,
                exceptionCount: s,
                bytePosIn: n
            };
        }
        function Mf(t, e1, n, r, i, s, o, a, l) {
            const { maxBits: u, exceptionBitWidth: c, bytePosIn: h } = function(t, e1, n, r, i, s) {
                if (n + 1 > e1) throw new Error(`FastPFOR decode: exception header underflow at block=${s} (need 1 byte for maxBits, bytePos=${n}, byteSize=${e1})`);
                const o = t[n++];
                if (o < r || o > 32) throw new Error(`FastPFOR decode: invalid maxBits=${o} at block=${s} (bitWidth=${r}, expected ${r}..32)`);
                const a = o - r | 0;
                if (a < 1 || a > 32) throw new Error(`FastPFOR decode: invalid exceptionBitWidth=${a} at block=${s} (bitWidth=${r}, maxBits=${o})`);
                if (n + i > e1) throw new Error(`FastPFOR decode: exception positions underflow at block=${s} (need=${i}, have=${e1 - n})`);
                return {
                    maxBits: o,
                    exceptionBitWidth: a,
                    bytePosIn: n
                };
            }(i, s, o, n, r, l);
            if (o = h, 1 === c) {
                const s = 1 << n;
                for(let n = 0; n < r; n = n + 1 | 0)t[i[o++] + e1 | 0] |= s;
                return o;
            }
            const p = a.dataToBePacked[c];
            if (!p) throw new Error(`FastPFOR decode: missing exception stream for exceptionBitWidth=${c} (bitWidth=${n}, maxBits=${u}) at block ${l}`);
            const f = a.dataPointers;
            let d = 0 | f[c];
            const y = 0 | a.exceptionSizes[c];
            if (d + r > y) throw new Error(`FastPFOR decode: exception stream overflow for exceptionBitWidth=${c} (ptr=${d}, need ${r}, size=${y}) at block ${l}`);
            for(let s = 0; s < r; s = s + 1 | 0){
                const r = i[o++], s = 0 | p[d++];
                t[r + e1 | 0] |= s << n;
            }
            return f[c] = d, o;
        }
        function kf(t, e1, n, r, i, s) {
            const o = 0 | n, a = 0 | t[o];
            if (a <= 0 || o + a > t.length - 1) throw new Error(`FastPFOR decode: invalid whereMeta=${a} at pageStart=${o} (expected > 0 and pageStart+whereMeta < encoded.length=${t.length})`);
            const l = o + 1 | 0, u = o + a | 0, c = t[u] >>> 0, h = c + 3 >>> 2, p = u + 1, f = p + h;
            if (f >= t.length) throw new Error(`FastPFOR decode: invalid byteSize=${c} (metaInts=${h}, pageStart=${o}, packedEnd=${u}, byteContainerStart=${p}) causes bitmapPos=${f} out of bounds (encoded.length=${t.length})`);
            const d = function(t, e1, n, r) {
                r.byteContainer.length < n && (r.byteContainer = new Uint8Array(2 * n), r.byteContainerI32 = void 0);
                const i = r.byteContainer, s = n >>> 2;
                if (3 & i.byteOffset) for(let n = 0; n < s; n = n + 1 | 0){
                    const r = 0 | t[e1 + n | 0], s = n << 2;
                    i[s] = 255 & r, i[s + 1 | 0] = r >>> 8 & 255, i[s + 2 | 0] = r >>> 16 & 255, i[s + 3 | 0] = r >>> 24 & 255;
                }
                else {
                    let n = r.byteContainerI32;
                    (!n || n.buffer !== i.buffer || n.byteOffset !== i.byteOffset || n.length < s) && (n = r.byteContainerI32 = new Int32Array(i.buffer, i.byteOffset, i.byteLength >>> 2)), n.set(t.subarray(e1, e1 + s));
                }
                const o = 3 & n;
                if (o > 0) {
                    const n = 0 | t[e1 + s | 0], r = s << 2;
                    for(let t = 0; t < o; t = t + 1 | 0)i[r + t | 0] = n >>> (t << 3) & 255;
                }
                return i;
            }(t, p, c, s), y = c, m = function(t, e1, n) {
                const r = 0 | t[e1++], i = n.dataToBePacked;
                for(let s = 2; s <= 32; s = s + 1 | 0){
                    if (!(r >>> s - 1 & 1)) continue;
                    if (e1 >= t.length) throw new Error(`FastPFOR decode: truncated exception stream header (bitWidth=${s}, streamWordIndex=${e1}, needWords=1, availableWords=${t.length - e1}, encodedWords=${t.length})`);
                    const o = t[e1++] >>> 0, a = xf(o + 31, 32), l = o * s + 31 >>> 5;
                    if (e1 + l > t.length) throw new Error(`FastPFOR decode: truncated exception stream (bitWidth=${s}, size=${o}, streamWordIndex=${e1}, needWords=${l}, availableWords=${t.length - e1}, encodedWords=${t.length})`);
                    let u = i[s];
                    (!u || u.length < a) && (u = i[s] = new Uint32Array(a));
                    let c = 0;
                    for(; c < o; c = c + 32 | 0)If(t, e1, u, c, s), e1 = e1 + s | 0;
                    e1 = e1 - ((c - o | 0) * s >>> 5) | 0, n.exceptionSizes[s] = o;
                }
                return e1;
            }(t, f, s);
            return s.dataPointers.fill(0), function(t, e1, n, r, i, s, o, a, l, u) {
                let c = 0 | n, h = 0;
                for(let e1 = 0; e1 < o; e1 = e1 + 1 | 0){
                    const n = Af(a, l, h, e1);
                    h = n.bytePosIn;
                    const r = n.bitWidth, o = n.exceptionCount, p = s + e1 * gf | 0;
                    switch(r){
                        case 0:
                            i.fill(0, p, p + gf);
                            break;
                        case 32:
                            for(let e1 = 0; e1 < gf; e1 = e1 + 1 | 0)i[p + e1 | 0] = 0 | t[c + e1 | 0];
                            c = c + gf | 0;
                            break;
                        default:
                            c = Sf(t, c, i, p, r);
                    }
                    o > 0 && (h = Mf(i, p, r, o, a, l, h, u, e1));
                }
                if (c !== r) throw new Error(`FastPFOR decode: packed region mismatch (pageStart=${e1}, packedStart=${n}, consumedPackedEnd=${c}, expectedPackedEnd=${r}, packedWords=${r - n}, encoded.length=${t.length})`);
            }(t, o, l, u, e1, 0 | r, i / gf | 0, d, y, s), m;
        }
        function If(t, e1, n, r, i) {
            switch(i){
                case 2:
                    return void function(t, e1, n, r) {
                        let i = r;
                        const s = t[e1] >>> 0, o = t[e1 + 1] >>> 0;
                        n[i++] = s >>> 0 & 3, n[i++] = s >>> 2 & 3, n[i++] = s >>> 4 & 3, n[i++] = s >>> 6 & 3, n[i++] = s >>> 8 & 3, n[i++] = s >>> 10 & 3, n[i++] = s >>> 12 & 3, n[i++] = s >>> 14 & 3, n[i++] = s >>> 16 & 3, n[i++] = s >>> 18 & 3, n[i++] = s >>> 20 & 3, n[i++] = s >>> 22 & 3, n[i++] = s >>> 24 & 3, n[i++] = s >>> 26 & 3, n[i++] = s >>> 28 & 3, n[i++] = s >>> 30 & 3, n[i++] = o >>> 0 & 3, n[i++] = o >>> 2 & 3, n[i++] = o >>> 4 & 3, n[i++] = o >>> 6 & 3, n[i++] = o >>> 8 & 3, n[i++] = o >>> 10 & 3, n[i++] = o >>> 12 & 3, n[i++] = o >>> 14 & 3, n[i++] = o >>> 16 & 3, n[i++] = o >>> 18 & 3, n[i++] = o >>> 20 & 3, n[i++] = o >>> 22 & 3, n[i++] = o >>> 24 & 3, n[i++] = o >>> 26 & 3, n[i++] = o >>> 28 & 3, n[i] = o >>> 30 & 3;
                    }(t, e1, n, r);
                case 3:
                    return void function(t, e1, n, r) {
                        let i = r;
                        const s = t[e1] >>> 0, o = t[e1 + 1] >>> 0, a = t[e1 + 2] >>> 0;
                        n[i++] = s >>> 0 & 7, n[i++] = s >>> 3 & 7, n[i++] = s >>> 6 & 7, n[i++] = s >>> 9 & 7, n[i++] = s >>> 12 & 7, n[i++] = s >>> 15 & 7, n[i++] = s >>> 18 & 7, n[i++] = s >>> 21 & 7, n[i++] = s >>> 24 & 7, n[i++] = s >>> 27 & 7, n[i++] = 7 & (s >>> 30 | (1 & o) << 2), n[i++] = o >>> 1 & 7, n[i++] = o >>> 4 & 7, n[i++] = o >>> 7 & 7, n[i++] = o >>> 10 & 7, n[i++] = o >>> 13 & 7, n[i++] = o >>> 16 & 7, n[i++] = o >>> 19 & 7, n[i++] = o >>> 22 & 7, n[i++] = o >>> 25 & 7, n[i++] = o >>> 28 & 7, n[i++] = 7 & (o >>> 31 | (3 & a) << 1), n[i++] = a >>> 2 & 7, n[i++] = a >>> 5 & 7, n[i++] = a >>> 8 & 7, n[i++] = a >>> 11 & 7, n[i++] = a >>> 14 & 7, n[i++] = a >>> 17 & 7, n[i++] = a >>> 20 & 7, n[i++] = a >>> 23 & 7, n[i++] = a >>> 26 & 7, n[i] = a >>> 29 & 7;
                    }(t, e1, n, r);
                case 4:
                    return void function(t, e1, n, r) {
                        let i = r;
                        const s = t[e1] >>> 0, o = t[e1 + 1] >>> 0, a = t[e1 + 2] >>> 0, l = t[e1 + 3] >>> 0;
                        n[i++] = s >>> 0 & 15, n[i++] = s >>> 4 & 15, n[i++] = s >>> 8 & 15, n[i++] = s >>> 12 & 15, n[i++] = s >>> 16 & 15, n[i++] = s >>> 20 & 15, n[i++] = s >>> 24 & 15, n[i++] = s >>> 28 & 15, n[i++] = o >>> 0 & 15, n[i++] = o >>> 4 & 15, n[i++] = o >>> 8 & 15, n[i++] = o >>> 12 & 15, n[i++] = o >>> 16 & 15, n[i++] = o >>> 20 & 15, n[i++] = o >>> 24 & 15, n[i++] = o >>> 28 & 15, n[i++] = a >>> 0 & 15, n[i++] = a >>> 4 & 15, n[i++] = a >>> 8 & 15, n[i++] = a >>> 12 & 15, n[i++] = a >>> 16 & 15, n[i++] = a >>> 20 & 15, n[i++] = a >>> 24 & 15, n[i++] = a >>> 28 & 15, n[i++] = l >>> 0 & 15, n[i++] = l >>> 4 & 15, n[i++] = l >>> 8 & 15, n[i++] = l >>> 12 & 15, n[i++] = l >>> 16 & 15, n[i++] = l >>> 20 & 15, n[i++] = l >>> 24 & 15, n[i] = l >>> 28 & 15;
                    }(t, e1, n, r);
                case 5:
                    return void function(t, e1, n, r) {
                        let i = r;
                        const s = t[e1] >>> 0, o = t[e1 + 1] >>> 0, a = t[e1 + 2] >>> 0, l = t[e1 + 3] >>> 0, u = t[e1 + 4] >>> 0;
                        n[i++] = s >>> 0 & 31, n[i++] = s >>> 5 & 31, n[i++] = s >>> 10 & 31, n[i++] = s >>> 15 & 31, n[i++] = s >>> 20 & 31, n[i++] = s >>> 25 & 31, n[i++] = 31 & (s >>> 30 | (7 & o) << 2), n[i++] = o >>> 3 & 31, n[i++] = o >>> 8 & 31, n[i++] = o >>> 13 & 31, n[i++] = o >>> 18 & 31, n[i++] = o >>> 23 & 31, n[i++] = 31 & (o >>> 28 | (1 & a) << 4), n[i++] = a >>> 1 & 31, n[i++] = a >>> 6 & 31, n[i++] = a >>> 11 & 31, n[i++] = a >>> 16 & 31, n[i++] = a >>> 21 & 31, n[i++] = a >>> 26 & 31, n[i++] = 31 & (a >>> 31 | (15 & l) << 1), n[i++] = l >>> 4 & 31, n[i++] = l >>> 9 & 31, n[i++] = l >>> 14 & 31, n[i++] = l >>> 19 & 31, n[i++] = l >>> 24 & 31, n[i++] = 31 & (l >>> 29 | (3 & u) << 3), n[i++] = u >>> 2 & 31, n[i++] = u >>> 7 & 31, n[i++] = u >>> 12 & 31, n[i++] = u >>> 17 & 31, n[i++] = u >>> 22 & 31, n[i] = u >>> 27 & 31;
                    }(t, e1, n, r);
                case 6:
                    return void function(t, e1, n, r) {
                        let i = r;
                        const s = t[e1] >>> 0, o = t[e1 + 1] >>> 0, a = t[e1 + 2] >>> 0, l = t[e1 + 3] >>> 0, u = t[e1 + 4] >>> 0, c = t[e1 + 5] >>> 0;
                        n[i++] = s >>> 0 & 63, n[i++] = s >>> 6 & 63, n[i++] = s >>> 12 & 63, n[i++] = s >>> 18 & 63, n[i++] = s >>> 24 & 63, n[i++] = 63 & (s >>> 30 | (15 & o) << 2), n[i++] = o >>> 4 & 63, n[i++] = o >>> 10 & 63, n[i++] = o >>> 16 & 63, n[i++] = o >>> 22 & 63, n[i++] = 63 & (o >>> 28 | (3 & a) << 4), n[i++] = a >>> 2 & 63, n[i++] = a >>> 8 & 63, n[i++] = a >>> 14 & 63, n[i++] = a >>> 20 & 63, n[i++] = a >>> 26 & 63, n[i++] = l >>> 0 & 63, n[i++] = l >>> 6 & 63, n[i++] = l >>> 12 & 63, n[i++] = l >>> 18 & 63, n[i++] = l >>> 24 & 63, n[i++] = 63 & (l >>> 30 | (15 & u) << 2), n[i++] = u >>> 4 & 63, n[i++] = u >>> 10 & 63, n[i++] = u >>> 16 & 63, n[i++] = u >>> 22 & 63, n[i++] = 63 & (u >>> 28 | (3 & c) << 4), n[i++] = c >>> 2 & 63, n[i++] = c >>> 8 & 63, n[i++] = c >>> 14 & 63, n[i++] = c >>> 20 & 63, n[i] = c >>> 26 & 63;
                    }(t, e1, n, r);
                case 7:
                    return void function(t, e1, n, r) {
                        let i = r;
                        const s = t[e1] >>> 0, o = t[e1 + 1] >>> 0, a = t[e1 + 2] >>> 0, l = t[e1 + 3] >>> 0, u = t[e1 + 4] >>> 0, c = t[e1 + 5] >>> 0, h = t[e1 + 6] >>> 0;
                        n[i++] = s >>> 0 & 127, n[i++] = s >>> 7 & 127, n[i++] = s >>> 14 & 127, n[i++] = s >>> 21 & 127, n[i++] = 127 & (s >>> 28 | (7 & o) << 4), n[i++] = o >>> 3 & 127, n[i++] = o >>> 10 & 127, n[i++] = o >>> 17 & 127, n[i++] = o >>> 24 & 127, n[i++] = 127 & (o >>> 31 | (63 & a) << 1), n[i++] = a >>> 6 & 127, n[i++] = a >>> 13 & 127, n[i++] = a >>> 20 & 127, n[i++] = 127 & (a >>> 27 | (3 & l) << 5), n[i++] = l >>> 2 & 127, n[i++] = l >>> 9 & 127, n[i++] = l >>> 16 & 127, n[i++] = l >>> 23 & 127, n[i++] = 127 & (l >>> 30 | (31 & u) << 2), n[i++] = u >>> 5 & 127, n[i++] = u >>> 12 & 127, n[i++] = u >>> 19 & 127, n[i++] = 127 & (u >>> 26 | (1 & c) << 6), n[i++] = c >>> 1 & 127, n[i++] = c >>> 8 & 127, n[i++] = c >>> 15 & 127, n[i++] = c >>> 22 & 127, n[i++] = 127 & (c >>> 29 | (15 & h) << 3), n[i++] = h >>> 4 & 127, n[i++] = h >>> 11 & 127, n[i++] = h >>> 18 & 127, n[i] = h >>> 25 & 127;
                    }(t, e1, n, r);
                case 8:
                    return void function(t, e1, n, r) {
                        let i = r;
                        const s = t[e1] >>> 0, o = t[e1 + 1] >>> 0, a = t[e1 + 2] >>> 0, l = t[e1 + 3] >>> 0, u = t[e1 + 4] >>> 0, c = t[e1 + 5] >>> 0, h = t[e1 + 6] >>> 0, p = t[e1 + 7] >>> 0;
                        n[i++] = s >>> 0 & 255, n[i++] = s >>> 8 & 255, n[i++] = s >>> 16 & 255, n[i++] = s >>> 24 & 255, n[i++] = o >>> 0 & 255, n[i++] = o >>> 8 & 255, n[i++] = o >>> 16 & 255, n[i++] = o >>> 24 & 255, n[i++] = a >>> 0 & 255, n[i++] = a >>> 8 & 255, n[i++] = a >>> 16 & 255, n[i++] = a >>> 24 & 255, n[i++] = l >>> 0 & 255, n[i++] = l >>> 8 & 255, n[i++] = l >>> 16 & 255, n[i++] = l >>> 24 & 255, n[i++] = u >>> 0 & 255, n[i++] = u >>> 8 & 255, n[i++] = u >>> 16 & 255, n[i++] = u >>> 24 & 255, n[i++] = c >>> 0 & 255, n[i++] = c >>> 8 & 255, n[i++] = c >>> 16 & 255, n[i++] = c >>> 24 & 255, n[i++] = h >>> 0 & 255, n[i++] = h >>> 8 & 255, n[i++] = h >>> 16 & 255, n[i++] = h >>> 24 & 255, n[i++] = p >>> 0 & 255, n[i++] = p >>> 8 & 255, n[i++] = p >>> 16 & 255, n[i] = p >>> 24 & 255;
                    }(t, e1, n, r);
                case 9:
                    return void function(t, e1, n, r) {
                        let i = r;
                        const s = t[e1] >>> 0, o = t[e1 + 1] >>> 0, a = t[e1 + 2] >>> 0, l = t[e1 + 3] >>> 0, u = t[e1 + 4] >>> 0, c = t[e1 + 5] >>> 0, h = t[e1 + 6] >>> 0, p = t[e1 + 7] >>> 0, f = t[e1 + 8] >>> 0;
                        n[i++] = s >>> 0 & 511, n[i++] = s >>> 9 & 511, n[i++] = s >>> 18 & 511, n[i++] = 511 & (s >>> 27 | (15 & o) << 5), n[i++] = o >>> 4 & 511, n[i++] = o >>> 13 & 511, n[i++] = o >>> 22 & 511, n[i++] = 511 & (o >>> 31 | (255 & a) << 1), n[i++] = a >>> 8 & 511, n[i++] = a >>> 17 & 511, n[i++] = 511 & (a >>> 26 | (7 & l) << 6), n[i++] = l >>> 3 & 511, n[i++] = l >>> 12 & 511, n[i++] = l >>> 21 & 511, n[i++] = 511 & (l >>> 30 | (127 & u) << 2), n[i++] = u >>> 7 & 511, n[i++] = u >>> 16 & 511, n[i++] = 511 & (u >>> 25 | (3 & c) << 7), n[i++] = c >>> 2 & 511, n[i++] = c >>> 11 & 511, n[i++] = c >>> 20 & 511, n[i++] = 511 & (c >>> 29 | (63 & h) << 3), n[i++] = h >>> 6 & 511, n[i++] = h >>> 15 & 511, n[i++] = 511 & (h >>> 24 | (1 & p) << 8), n[i++] = p >>> 1 & 511, n[i++] = p >>> 10 & 511, n[i++] = p >>> 19 & 511, n[i++] = 511 & (p >>> 28 | (31 & f) << 4), n[i++] = f >>> 5 & 511, n[i++] = f >>> 14 & 511, n[i] = f >>> 23 & 511;
                    }(t, e1, n, r);
                case 10:
                    return void function(t, e1, n, r) {
                        let i = r;
                        const s = t[e1] >>> 0, o = t[e1 + 1] >>> 0, a = t[e1 + 2] >>> 0, l = t[e1 + 3] >>> 0, u = t[e1 + 4] >>> 0, c = t[e1 + 5] >>> 0, h = t[e1 + 6] >>> 0, p = t[e1 + 7] >>> 0, f = t[e1 + 8] >>> 0, d = t[e1 + 9] >>> 0;
                        n[i++] = s >>> 0 & 1023, n[i++] = s >>> 10 & 1023, n[i++] = s >>> 20 & 1023, n[i++] = 1023 & (s >>> 30 | (255 & o) << 2), n[i++] = o >>> 8 & 1023, n[i++] = o >>> 18 & 1023, n[i++] = 1023 & (o >>> 28 | (63 & a) << 4), n[i++] = a >>> 6 & 1023, n[i++] = a >>> 16 & 1023, n[i++] = 1023 & (a >>> 26 | (15 & l) << 6), n[i++] = l >>> 4 & 1023, n[i++] = l >>> 14 & 1023, n[i++] = 1023 & (l >>> 24 | (3 & u) << 8), n[i++] = u >>> 2 & 1023, n[i++] = u >>> 12 & 1023, n[i++] = u >>> 22 & 1023, n[i++] = c >>> 0 & 1023, n[i++] = c >>> 10 & 1023, n[i++] = c >>> 20 & 1023, n[i++] = 1023 & (c >>> 30 | (255 & h) << 2), n[i++] = h >>> 8 & 1023, n[i++] = h >>> 18 & 1023, n[i++] = 1023 & (h >>> 28 | (63 & p) << 4), n[i++] = p >>> 6 & 1023, n[i++] = p >>> 16 & 1023, n[i++] = 1023 & (p >>> 26 | (15 & f) << 6), n[i++] = f >>> 4 & 1023, n[i++] = f >>> 14 & 1023, n[i++] = 1023 & (f >>> 24 | (3 & d) << 8), n[i++] = d >>> 2 & 1023, n[i++] = d >>> 12 & 1023, n[i] = d >>> 22 & 1023;
                    }(t, e1, n, r);
                case 11:
                    return void function(t, e1, n, r) {
                        let i = r;
                        const s = t[e1] >>> 0, o = t[e1 + 1] >>> 0, a = t[e1 + 2] >>> 0, l = t[e1 + 3] >>> 0, u = t[e1 + 4] >>> 0, c = t[e1 + 5] >>> 0, h = t[e1 + 6] >>> 0, p = t[e1 + 7] >>> 0, f = t[e1 + 8] >>> 0, d = t[e1 + 9] >>> 0, y = t[e1 + 10] >>> 0;
                        n[i++] = s >>> 0 & 2047, n[i++] = s >>> 11 & 2047, n[i++] = 2047 & (s >>> 22 | (1 & o) << 10), n[i++] = o >>> 1 & 2047, n[i++] = o >>> 12 & 2047, n[i++] = 2047 & (o >>> 23 | (3 & a) << 9), n[i++] = a >>> 2 & 2047, n[i++] = a >>> 13 & 2047, n[i++] = 2047 & (a >>> 24 | (7 & l) << 8), n[i++] = l >>> 3 & 2047, n[i++] = l >>> 14 & 2047, n[i++] = 2047 & (l >>> 25 | (15 & u) << 7), n[i++] = u >>> 4 & 2047, n[i++] = u >>> 15 & 2047, n[i++] = 2047 & (u >>> 26 | (31 & c) << 6), n[i++] = c >>> 5 & 2047, n[i++] = c >>> 16 & 2047, n[i++] = 2047 & (c >>> 27 | (63 & h) << 5), n[i++] = h >>> 6 & 2047, n[i++] = h >>> 17 & 2047, n[i++] = 2047 & (h >>> 28 | (127 & p) << 4), n[i++] = p >>> 7 & 2047, n[i++] = p >>> 18 & 2047, n[i++] = 2047 & (p >>> 29 | (255 & f) << 3), n[i++] = f >>> 8 & 2047, n[i++] = f >>> 19 & 2047, n[i++] = 2047 & (f >>> 30 | (511 & d) << 2), n[i++] = d >>> 9 & 2047, n[i++] = d >>> 20 & 2047, n[i++] = 2047 & (d >>> 31 | (1023 & y) << 1), n[i++] = y >>> 10 & 2047, n[i] = y >>> 21 & 2047;
                    }(t, e1, n, r);
                case 12:
                    return void function(t, e1, n, r) {
                        let i = r;
                        const s = t[e1] >>> 0, o = t[e1 + 1] >>> 0, a = t[e1 + 2] >>> 0, l = t[e1 + 3] >>> 0, u = t[e1 + 4] >>> 0, c = t[e1 + 5] >>> 0, h = t[e1 + 6] >>> 0, p = t[e1 + 7] >>> 0, f = t[e1 + 8] >>> 0, d = t[e1 + 9] >>> 0, y = t[e1 + 10] >>> 0, m = t[e1 + 11] >>> 0;
                        n[i++] = s >>> 0 & 4095, n[i++] = s >>> 12 & 4095, n[i++] = 4095 & (s >>> 24 | (15 & o) << 8), n[i++] = o >>> 4 & 4095, n[i++] = o >>> 16 & 4095, n[i++] = 4095 & (o >>> 28 | (255 & a) << 4), n[i++] = a >>> 8 & 4095, n[i++] = a >>> 20 & 4095, n[i++] = l >>> 0 & 4095, n[i++] = l >>> 12 & 4095, n[i++] = 4095 & (l >>> 24 | (15 & u) << 8), n[i++] = u >>> 4 & 4095, n[i++] = u >>> 16 & 4095, n[i++] = 4095 & (u >>> 28 | (255 & c) << 4), n[i++] = c >>> 8 & 4095, n[i++] = c >>> 20 & 4095, n[i++] = h >>> 0 & 4095, n[i++] = h >>> 12 & 4095, n[i++] = 4095 & (h >>> 24 | (15 & p) << 8), n[i++] = p >>> 4 & 4095, n[i++] = p >>> 16 & 4095, n[i++] = 4095 & (p >>> 28 | (255 & f) << 4), n[i++] = f >>> 8 & 4095, n[i++] = f >>> 20 & 4095, n[i++] = d >>> 0 & 4095, n[i++] = d >>> 12 & 4095, n[i++] = 4095 & (d >>> 24 | (15 & y) << 8), n[i++] = y >>> 4 & 4095, n[i++] = y >>> 16 & 4095, n[i++] = 4095 & (y >>> 28 | (255 & m) << 4), n[i++] = m >>> 8 & 4095, n[i] = m >>> 20 & 4095;
                    }(t, e1, n, r);
                case 16:
                    return void function(t, e1, n, r) {
                        let i = r;
                        const s = t[e1] >>> 0, o = t[e1 + 1] >>> 0, a = t[e1 + 2] >>> 0, l = t[e1 + 3] >>> 0, u = t[e1 + 4] >>> 0, c = t[e1 + 5] >>> 0, h = t[e1 + 6] >>> 0, p = t[e1 + 7] >>> 0, f = t[e1 + 8] >>> 0, d = t[e1 + 9] >>> 0, y = t[e1 + 10] >>> 0, m = t[e1 + 11] >>> 0, g = t[e1 + 12] >>> 0, x = t[e1 + 13] >>> 0, v = t[e1 + 14] >>> 0, b = t[e1 + 15] >>> 0;
                        n[i++] = s >>> 0 & 65535, n[i++] = s >>> 16 & 65535, n[i++] = o >>> 0 & 65535, n[i++] = o >>> 16 & 65535, n[i++] = a >>> 0 & 65535, n[i++] = a >>> 16 & 65535, n[i++] = l >>> 0 & 65535, n[i++] = l >>> 16 & 65535, n[i++] = u >>> 0 & 65535, n[i++] = u >>> 16 & 65535, n[i++] = c >>> 0 & 65535, n[i++] = c >>> 16 & 65535, n[i++] = h >>> 0 & 65535, n[i++] = h >>> 16 & 65535, n[i++] = p >>> 0 & 65535, n[i++] = p >>> 16 & 65535, n[i++] = f >>> 0 & 65535, n[i++] = f >>> 16 & 65535, n[i++] = d >>> 0 & 65535, n[i++] = d >>> 16 & 65535, n[i++] = y >>> 0 & 65535, n[i++] = y >>> 16 & 65535, n[i++] = m >>> 0 & 65535, n[i++] = m >>> 16 & 65535, n[i++] = g >>> 0 & 65535, n[i++] = g >>> 16 & 65535, n[i++] = x >>> 0 & 65535, n[i++] = x >>> 16 & 65535, n[i++] = v >>> 0 & 65535, n[i++] = v >>> 16 & 65535, n[i++] = b >>> 0 & 65535, n[i] = b >>> 16 & 65535;
                    }(t, e1, n, r);
                case 32:
                    for(let i = 0; i < 32; i = i + 1 | 0)n[r + i | 0] = 0 | t[e1 + i | 0];
                    return;
            }
            const s = mf[i] >>> 0;
            let o = e1, a = 0, l = t[o] >>> 0;
            for(let e1 = 0; e1 < 32; e1++)if (a + i <= 32) n[r + e1] = l >>> a & s, a += i, 32 === a && (a = 0, o++, 31 !== e1 && (l = t[o] >>> 0));
            else {
                const u = 32 - a, c = l >>> a;
                o++, l = t[o] >>> 0, n[r + e1] = (c | (l & mf[i - u] >>> 0) << u) & s, a = i - u;
            }
        }
        function Ef(t, e1, n) {
            const r = new Uint32Array(n);
            let i = 0, s = e1.get();
            for(let e1 = 0; e1 < r.length; e1++){
                let e1 = t[s++], n = 127 & e1;
                e1 < 128 || (e1 = t[s++], n |= (127 & e1) << 7, e1 < 128 || (e1 = t[s++], n |= (127 & e1) << 14, e1 < 128 || (e1 = t[s++], n |= (127 & e1) << 21, e1 < 128 || (e1 = t[s++], n |= (15 & e1) << 28)))), r[i++] = n;
            }
            return e1.set(s), r;
        }
        function Tf(t, e1, n) {
            const r = new BigUint64Array(n);
            for(let n = 0; n < r.length; n++)r[n] = Ff(t, e1);
            return r;
        }
        function Ff(t, e1) {
            let n = 0n, r = 0, i = e1.get();
            for(; i < t.length;){
                const e1 = t[i++];
                if (n |= BigInt(127 & e1) << BigInt(r), !(128 & e1)) break;
                if (r += 7, r >= 64) throw new Error("Varint too long");
            }
            return e1.set(i), n;
        }
        function Pf(t, e1) {
            let n, r;
            return r = t[e1.get()], e1.increment(), n = 127 & r, r < 128 ? n : (r = t[e1.get()], e1.increment(), n |= (127 & r) << 7, r < 128 ? n : (r = t[e1.get()], e1.increment(), n |= (127 & r) << 14, r < 128 ? n : (r = t[e1.get()], e1.increment(), n |= (127 & r) << 21, r < 128 ? n : (r = t[e1.get()], n |= (15 & r) << 28, function(t, e1, n) {
                let r, i;
                if (i = e1[n.get()], n.increment(), r = (112 & i) >> 4, i < 128) return 4294967296 * r + (t >>> 0);
                if (i = e1[n.get()], n.increment(), r |= (127 & i) << 3, i < 128) return 4294967296 * r + (t >>> 0);
                if (i = e1[n.get()], n.increment(), r |= (127 & i) << 10, i < 128) return 4294967296 * r + (t >>> 0);
                if (i = e1[n.get()], n.increment(), r |= (127 & i) << 17, i < 128) return 4294967296 * r + (t >>> 0);
                if (i = e1[n.get()], n.increment(), r |= (127 & i) << 24, i < 128) return 4294967296 * r + (t >>> 0);
                if (i = e1[n.get()], n.increment(), r |= (1 & i) << 31, i < 128) return 4294967296 * r + (t >>> 0);
                throw new Error("Expected varint not more than 10 bytes");
            }(n, t, e1)))));
        }
        function Df(t) {
            return t >>> 1 ^ -(1 & t);
        }
        function zf(t) {
            return t >> 1n ^ -(1n & t);
        }
        function Bf(t) {
            return t % 2 == 1 ? (t + 1) / -2 : t / 2;
        }
        function Cf(t, e1, n) {
            if (void 0 === n) {
                n = 0;
                for(let r = 0; r < e1; r++)n += t[r];
            }
            const r = new Uint32Array(n);
            let i = 0;
            for(let n = 0; n < e1; n++){
                const s = t[n];
                r.fill(t[n + e1], i, i + s), i += s;
            }
            return r;
        }
        function Vf(t, e1, n) {
            if (void 0 === n) {
                n = 0;
                for(let r = 0; r < e1; r++)n += Number(t[r]);
            }
            const r = new BigUint64Array(n);
            let i = 0;
            for(let n = 0; n < e1; n++){
                const s = Number(t[n]);
                r.fill(t[n + e1], i, i + s), i += s;
            }
            return r;
        }
        function Lf(t, e1, n) {
            const r = new Float64Array(n);
            let i = 0;
            for(let n = 0; n < e1; n++){
                const s = t[n];
                r.fill(t[n + e1], i, i + s), i += s;
            }
            return r;
        }
        function Of(t) {
            const e1 = new Int32Array(t.length);
            e1[0] = Df(t[0]);
            const n = t.length / 4 * 4;
            let r = 1;
            if (n >= 4) for(; r < n - 4; r += 4){
                const n = t[r + 1], i = t[r + 2], s = t[r + 3];
                e1[r] = Df(t[r]) + e1[r - 1], e1[r + 1] = Df(n) + e1[r], e1[r + 2] = Df(i) + e1[r + 1], e1[r + 3] = Df(s) + e1[r + 2];
            }
            for(; r !== t.length; ++r)e1[r] = Df(t[r]) + e1[r - 1];
            return e1;
        }
        function $f(t) {
            const e1 = new BigInt64Array(t.length);
            e1[0] = zf(t[0]);
            const n = t.length / 4 * 4;
            let r = 1;
            if (n >= 4) for(; r < n - 4; r += 4){
                const n = t[r + 1], i = t[r + 2], s = t[r + 3];
                e1[r] = zf(t[r]) + e1[r - 1], e1[r + 1] = zf(n) + e1[r], e1[r + 2] = zf(i) + e1[r + 1], e1[r + 3] = zf(s) + e1[r + 2];
            }
            for(; r !== e1.length; ++r)e1[r] = zf(t[r]) + e1[r - 1];
            return e1;
        }
        function Rf(t) {
            const e1 = t.length / 4 * 4;
            let n = 1;
            if (e1 >= 4) for(let r = t[0]; n < e1 - 4; n += 4)r = t[n] += r, r = t[n + 1] += r, r = t[n + 2] += r, r = t[n + 3] += r;
            for(; n !== t.length;)t[n] += t[n - 1], ++n;
        }
        var Nf, Uf, jf, qf, Gf, Xf, Yf, Zf;
        function Hf(t, e1) {
            const n = function(t, e1) {
                const n = t[e1.get()], r = Object.values(Nf)[n >> 4];
                let i = null;
                switch(r){
                    case Nf.DATA:
                        i = {
                            dictionaryType: Object.values(Uf)[15 & n]
                        };
                        break;
                    case Nf.OFFSET:
                        i = {
                            offsetType: Object.values(jf)[15 & n]
                        };
                        break;
                    case Nf.LENGTH:
                        i = {
                            lengthType: Object.values(qf)[15 & n]
                        };
                }
                e1.increment();
                const s = t[e1.get()], o = Object.values(ff)[s >> 5], a = Object.values(ff)[s >> 2 & 7], l = Object.values(df)[3 & s];
                e1.increment();
                const u = Ef(t, e1, 2), c = u[0];
                return {
                    physicalStreamType: r,
                    logicalStreamType: i,
                    logicalLevelTechnique1: o,
                    logicalLevelTechnique2: a,
                    physicalLevelTechnique: l,
                    numValues: c,
                    byteLength: u[1],
                    decompressedCount: c
                };
            }(t, e1);
            return n.logicalLevelTechnique1 === ff.MORTON ? function(t, e1, n) {
                const r = Ef(e1, n, 2);
                return {
                    physicalStreamType: t.physicalStreamType,
                    logicalStreamType: t.logicalStreamType,
                    logicalLevelTechnique1: t.logicalLevelTechnique1,
                    logicalLevelTechnique2: t.logicalLevelTechnique2,
                    physicalLevelTechnique: t.physicalLevelTechnique,
                    numValues: t.numValues,
                    byteLength: t.byteLength,
                    decompressedCount: t.decompressedCount,
                    numBits: r[0],
                    coordinateShift: r[1]
                };
            }(n, t, e1) : ff.RLE !== n.logicalLevelTechnique1 && ff.RLE !== n.logicalLevelTechnique2 || df.NONE === n.physicalLevelTechnique ? n : function(t, e1, n) {
                const r = Ef(e1, n, 2);
                return {
                    physicalStreamType: t.physicalStreamType,
                    logicalStreamType: t.logicalStreamType,
                    logicalLevelTechnique1: t.logicalLevelTechnique1,
                    logicalLevelTechnique2: t.logicalLevelTechnique2,
                    physicalLevelTechnique: t.physicalLevelTechnique,
                    numValues: t.numValues,
                    byteLength: t.byteLength,
                    decompressedCount: r[1],
                    runs: r[0],
                    numRleValues: r[1]
                };
            }(n, t, e1);
        }
        !function(t) {
            t.PRESENT = "PRESENT", t.DATA = "DATA", t.OFFSET = "OFFSET", t.LENGTH = "LENGTH";
        }(Nf || (Nf = {})), function(t) {
            t.NONE = "NONE", t.SINGLE = "SINGLE", t.SHARED = "SHARED", t.VERTEX = "VERTEX", t.MORTON = "MORTON", t.FSST = "FSST";
        }(Uf || (Uf = {})), function(t) {
            t.VERTEX = "VERTEX", t.INDEX = "INDEX", t.STRING = "STRING", t.KEY = "KEY";
        }(jf || (jf = {})), function(t) {
            t.VAR_BINARY = "VAR_BINARY", t.GEOMETRIES = "GEOMETRIES", t.PARTS = "PARTS", t.RINGS = "RINGS", t.TRIANGLES = "TRIANGLES", t.SYMBOL = "SYMBOL", t.DICTIONARY = "DICTIONARY";
        }(qf || (qf = {})), function(t) {
            t[t.FLAT = 0] = "FLAT", t[t.CONST = 1] = "CONST", t[t.SEQUENCE = 2] = "SEQUENCE", t[t.DICTIONARY = 3] = "DICTIONARY", t[t.FSST_DICTIONARY = 4] = "FSST_DICTIONARY";
        }(Gf || (Gf = {}));
        class Wf {
            constructor(t, e1){
                this.values = t, this._size = e1;
            }
            get(t) {
                const e1 = Math.floor(t / 8);
                return 1 == (this.values[e1] >> t % 8 & 1);
            }
            set(t, e1) {
                const n = Math.floor(t / 8);
                this.values[n] = this.values[n] | (e1 ? 1 : 0) << t % 8;
            }
            getInt(t) {
                const e1 = Math.floor(t / 8);
                return this.values[e1] >> t % 8 & 1;
            }
            size() {
                return this._size;
            }
            getBuffer() {
                return this.values;
            }
        }
        function Kf(t, e1, n) {
            if (!e1) return t;
            const r = e1.size(), i = new t.constructor(r);
            let s = 0;
            for(let o = 0; o < r; o++)i[o] = e1.get(o) ? t[s++] : n;
            return i;
        }
        function Jf(t, e1, n, r, i) {
            return function(t, e1, n, r) {
                let i;
                switch(e1.logicalLevelTechnique1){
                    case ff.DELTA:
                        if (e1.logicalLevelTechnique2 === ff.RLE) {
                            const n = e1;
                            if (!r) return function(t, e1, n) {
                                const r = new Int32Array(n);
                                let i = 0, s = 0;
                                for(let n = 0; n < e1; n++){
                                    const o = t[n], a = Df(t[n + e1]);
                                    for(let t = 0; t < o; t++)s += a, r[i++] = s;
                                }
                                return r;
                            }(t, n.runs, n.numRleValues);
                            i = Of(t = Cf(t, n.runs, n.numRleValues));
                        } else i = Of(t);
                        break;
                    case ff.RLE:
                        i = function(t, e1, n) {
                            if (void 0 === n) {
                                n = 0;
                                for(let r = 0; r < e1; r++)n += t[r];
                            }
                            const r = new Int32Array(n);
                            let i = 0;
                            for(let n = 0; n < e1; n++){
                                const s = t[n];
                                let o = t[n + e1];
                                o = Df(o), r.fill(o, i, i + s), i += s;
                            }
                            return r;
                        }(t, e1.runs, e1.numRleValues);
                        break;
                    case ff.MORTON:
                        Rf(t), i = new Int32Array(t);
                        break;
                    case ff.COMPONENTWISE_DELTA:
                        i = function(t) {
                            if (t.length < 2) return new Int32Array(t);
                            const e1 = new Int32Array(t.length);
                            e1[0] = Df(t[0]), e1[1] = Df(t[1]);
                            const n = t.length / 4 * 4;
                            let r = 2;
                            if (n >= 4) for(; r < n - 4; r += 4){
                                const n = t[r + 1], i = t[r + 2], s = t[r + 3];
                                e1[r] = Df(t[r]) + e1[r - 2], e1[r + 1] = Df(n) + e1[r - 1], e1[r + 2] = Df(i) + e1[r], e1[r + 3] = Df(s) + e1[r + 1];
                            }
                            for(; r !== t.length; r += 2)e1[r] = Df(t[r]) + e1[r - 2], e1[r + 1] = Df(t[r + 1]) + e1[r - 1];
                            return e1;
                        }(t);
                        break;
                    case ff.NONE:
                        i = function(t) {
                            const e1 = new Int32Array(t.length);
                            for(let n = 0; n < t.length; n++)e1[n] = Df(t[n]);
                            return e1;
                        }(t);
                        break;
                    default:
                        throw new Error(`The specified Logical level technique is not supported: ${e1.logicalLevelTechnique1}`);
                }
                return r ? Kf(i, r, 0) : i;
            }(ed(t, e1, n), n, 0, i);
        }
        function Qf(t, e1, n, r, i) {
            return function(t, e1, n, r) {
                let i;
                switch(e1.logicalLevelTechnique1){
                    case ff.DELTA:
                        i = function(t) {
                            const e1 = new Uint32Array(t.length);
                            e1[0] = Df(t[0]) >>> 0;
                            for(let n = 1; n < t.length; n++)e1[n] = e1[n - 1] + Df(t[n]) >>> 0;
                            return e1;
                        }(e1.logicalLevelTechnique2 === ff.RLE ? Cf(t, e1.runs, e1.numRleValues) : t);
                        break;
                    case ff.RLE:
                        i = Cf(t, e1.runs, e1.numRleValues);
                        break;
                    case ff.MORTON:
                        Rf(t), i = t;
                        break;
                    case ff.COMPONENTWISE_DELTA:
                        i = function(t) {
                            if (t.length < 2) return new Uint32Array(t);
                            const e1 = new Uint32Array(t.length);
                            e1[0] = Df(t[0]) >>> 0, e1[1] = Df(t[1]) >>> 0;
                            for(let n = 2; n < t.length; n += 2)e1[n] = e1[n - 2] + Df(t[n]) >>> 0, e1[n + 1] = e1[n - 1] + Df(t[n + 1]) >>> 0;
                            return e1;
                        }(t);
                        break;
                    case ff.NONE:
                        i = t;
                        break;
                    default:
                        throw new Error(`The specified Logical level technique is not supported: ${e1.logicalLevelTechnique1}`);
                }
                return r ? Kf(i, r, 0) : i;
            }(ed(t, e1, n), n, 0, i);
        }
        function td(t, e1, n) {
            return function(t, e1) {
                if (e1.logicalLevelTechnique1 === ff.DELTA && e1.logicalLevelTechnique2 === ff.NONE) return function(t) {
                    const e1 = new Int32Array(t.length + 1);
                    e1[0] = 0, e1[1] = Df(t[0]);
                    let n = e1[1];
                    for(let r = 2; r !== e1.length; ++r)n += Df(t[r - 1]), e1[r] = e1[r - 1] + n;
                    return new Uint32Array(e1);
                }(t);
                if (e1.logicalLevelTechnique1 === ff.RLE && e1.logicalLevelTechnique2 === ff.NONE) return function(t, e1, n) {
                    const r = new Uint32Array(n + 1);
                    r[0] = 0;
                    let i = 1, s = r[0];
                    for(let n = 0; n < e1; n++){
                        const o = t[n], a = t[n + e1];
                        for(let t = i; t < i + o; t++)r[t] = a + s, s = r[t];
                        i += o;
                    }
                    return r;
                }(t, e1.runs, e1.numRleValues);
                if (e1.logicalLevelTechnique1 === ff.NONE && e1.logicalLevelTechnique2 === ff.NONE) {
                    !function(t) {
                        let e1 = 0;
                        for(let n = 0; n < t.length; n++)t[n] += e1, e1 = t[n];
                    }(t);
                    const n = new Uint32Array(e1.numValues + 1);
                    return n[0] = 0, n.set(t, 1), n;
                }
                if (e1.logicalLevelTechnique1 === ff.DELTA && e1.logicalLevelTechnique2 === ff.RLE) {
                    const n = function(t, e1, n) {
                        const r = new Int32Array(n + 1);
                        r[0] = 0;
                        let i = 1, s = r[0];
                        for(let n = 0; n < e1; n++){
                            const o = t[n];
                            let a = t[n + e1];
                            a = Df(a);
                            for(let t = i; t < i + o; t++)r[t] = a + s, s = r[t];
                            i += o;
                        }
                        return r;
                    }(t, e1.runs, e1.numRleValues);
                    return Rf(n), new Uint32Array(n);
                }
                throw new Error("Only delta encoding is supported for transforming length to offset streams yet.");
            }(ed(t, e1, n), n);
        }
        function ed(t, e1, n) {
            const r = n.physicalLevelTechnique;
            switch(r){
                case df.FAST_PFOR:
                    return function(t, e1, n, r) {
                        return function(t, e1, n, r, i) {
                            const s = r.get();
                            if (3 & n) throw new Error(`FastPFOR: invalid encodedByteLength=${n} at offset=${s} (encodedBytes.length=${t.length}; expected a multiple of 4 bytes for an int32 big-endian word stream)`);
                            const o = n >>> 2, a = function(t, e1) {
                                if (e1 <= t.encodedWords.length) return t.encodedWords;
                                const n = new Uint32Array(Math.max(16, 2 * e1));
                                return t.encodedWords = n, n;
                            }(i, o);
                            !function(t, e1, n, r) {
                                if (e1 < 0 || n < 0 || e1 + n > t.length) throw new RangeError(`decodeBigEndianInt32sInto: out of bounds (offset=${e1}, byteLength=${n}, bytes.length=${t.length})`);
                                const i = Math.floor(n / 4), s = n % 4 != 0, o = s ? i + 1 : i;
                                if (r.length < o) throw new RangeError(`decodeBigEndianInt32sInto: out.length=${r.length} < ${o}`);
                                if (i > 0) {
                                    const n = t.byteOffset + e1;
                                    if (3 & n) for(let n = 0; n < i; n++){
                                        const i = e1 + 4 * n;
                                        r[n] = t[i] << 24 | t[i + 1] << 16 | t[i + 2] << 8 | t[i + 3];
                                    }
                                    else {
                                        const e1 = new Uint32Array(t.buffer, n, i);
                                        for(let t = 0; t < i; t++)r[t] = 0 | vf(e1[t]);
                                    }
                                }
                                if (s) {
                                    const s = e1 + 4 * i, o = n - 4 * i;
                                    let a = 0;
                                    for(let e1 = 0; e1 < o; e1++)a |= t[s + e1] << 24 - 8 * e1;
                                    r[i] = 0 | a;
                                }
                            }(t, s, n, a);
                            const l = function(t, e1, n) {
                                let r = 0, i = 0;
                                const s = new Uint32Array(e1), o = n ?? _f();
                                if (t.length > 0) {
                                    const e1 = 0 | t[r];
                                    if (r = r + 1 | 0, 255 & e1) throw new Error(`FastPFOR decode: invalid alignedLength=${e1} (expected multiple of 256)`);
                                    if (i + e1 > s.length) throw new Error(`FastPFOR decode: output buffer too small (outPos=${i}, alignedLength=${e1}, out.length=${s.length})`);
                                    r = function(t, e1, n, r, i, s) {
                                        const o = r + xf(i, gf);
                                        let a = r, l = n;
                                        for(; a !== o;){
                                            const n = Math.min(bf, o - a);
                                            l = kf(t, e1, l, a, n, s), a = a + n | 0;
                                        }
                                        return l;
                                    }(t, s, r, i, e1, o), i = i + e1 | 0;
                                }
                                return function(t, e1, n, r, i, s) {
                                    if (0 === s) return e1;
                                    let o = 0, a = e1;
                                    const l = e1 + n, u = i;
                                    let c = i;
                                    const h = i + s;
                                    let p = 0, f = 0;
                                    for(; a < l && c < h;){
                                        const e1 = t[a] >>> o & 255;
                                        if (o += 8, a += o >>> 5, o &= 31, p |= (127 & e1) << f, 128 & e1) r[c++] = 0 | p, p = 0, f = 0;
                                        else if (f += 7, f > 28) throw new Error(`FastPFOR VByte: unterminated value (expected MSB=1 terminator within 5 bytes; shift=${f}, partial=${p}, decoded=${c - u}/${s}, inPos=${a}, inEnd=${l})`);
                                    }
                                    if (c !== h) throw new Error(`FastPFOR VByte: truncated stream (decoded=${c - u}, expected=${s}, consumedWords=${a - e1}/${n}, vbyteStart=${e1}, vbyteEnd=${l})`);
                                }(t, r, t.length - r | 0, s, i, e1 - i | 0), s;
                            }(a.subarray(0, o), e1, i.decoderWorkspace);
                            return r.add(n), l;
                        }(t, e1, n, r, function(t = 16) {
                            if (t < 0) throw new RangeError(`initialEncodedWordCapacity must be >= 0, got ${t}`);
                            const e1 = Math.max(16, 0 | t);
                            return {
                                encodedWords: new Uint32Array(e1),
                                decoderWorkspace: _f()
                            };
                        }(n >>> 2));
                    }(t, n.numValues, n.byteLength, e1);
                case df.VARINT:
                    return Ef(t, e1, n.numValues);
                case df.NONE:
                    {
                        const r = e1.get();
                        e1.add(n.byteLength);
                        const i = t.subarray(r, e1.get());
                        return new Uint32Array(i);
                    }
                default:
                    throw new Error(`Specified physicalLevelTechnique ${r} is not supported (yet).`);
            }
        }
        function nd(t, e1, n) {
            const r = ed(t, e1, n);
            return 1 === r.length ? r[0] : function(t) {
                return t[1];
            }(r);
        }
        function rd(t, e1, n) {
            return function(t) {
                if (2 === t.length) {
                    const e1 = Df(t[1]);
                    return [
                        e1,
                        e1
                    ];
                }
                return [
                    Df(t[2]),
                    Df(t[3])
                ];
            }(ed(t, e1, n));
        }
        function id(t, e1, n) {
            return function(t) {
                if (2 === t.length) {
                    const e1 = zf(t[1]);
                    return [
                        e1,
                        e1
                    ];
                }
                return [
                    zf(t[2]),
                    zf(t[3])
                ];
            }(Tf(t, e1, n.numValues));
        }
        function sd(t, e1, n, r) {
            return function(t, e1, n) {
                let r;
                switch(e1.logicalLevelTechnique1){
                    case ff.DELTA:
                        r = function(t) {
                            const e1 = new BigUint64Array(t.length);
                            e1[0] = BigInt.asUintN(64, zf(t[0]));
                            for(let n = 1; n < t.length; n++)e1[n] = BigInt.asUintN(64, e1[n - 1] + zf(t[n]));
                            return e1;
                        }(e1.logicalLevelTechnique2 === ff.RLE ? Vf(t, e1.runs, e1.numRleValues) : t);
                        break;
                    case ff.RLE:
                        r = Vf(t, e1.runs, e1.numRleValues);
                        break;
                    case ff.NONE:
                        r = t;
                        break;
                    default:
                        throw new Error(`The specified Logical level technique is not supported: ${e1.logicalLevelTechnique1}`);
                }
                return n ? Kf(r, n, 0n) : r;
            }(Tf(t, e1, n.numValues), n, r);
        }
        function od(t, e1, n) {
            const r = Tf(t, e1, n.numValues);
            return 1 === r.length ? r[0] : function(t) {
                return t[1];
            }(r);
        }
        function ad(t, e1, n, r, i = "int32") {
            const s = t.logicalLevelTechnique1;
            if (s === ff.RLE) return 1 === t.runs ? Gf.CONST : Gf.FLAT;
            if (s !== ff.DELTA || t.logicalLevelTechnique2 !== ff.RLE) return 1 === t.numValues ? Gf.CONST : Gf.FLAT;
            const o = e1 instanceof Wf ? e1.size() : e1;
            if (t.numRleValues !== o) return Gf.FLAT;
            if (1 === t.runs) return Gf.SEQUENCE;
            if (2 !== t.runs) return 1 === t.numValues ? Gf.CONST : Gf.FLAT;
            const a = r.get();
            if (t.physicalLevelTechnique === df.VARINT) return function(t, e1, n) {
                const r = new pf(e1.get());
                if ("int64" === n) {
                    const e1 = Tf(t, r, 4);
                    return 2n === e1[2] && 2n === e1[3];
                }
                const i = Ef(t, r, 4);
                return 2 === i[2] && 2 === i[3];
            }(n, r, i) ? Gf.SEQUENCE : 1 === t.numValues ? Gf.CONST : Gf.FLAT;
            const l = r.get(), u = new Int32Array(n.buffer, n.byteOffset + l, 4);
            return r.set(a), 2 === u[2] && 2 === u[3] ? Gf.SEQUENCE : 1 === t.numValues ? Gf.CONST : Gf.FLAT;
        }
        class ld extends sf {
            getValueFromBuffer(t) {
                return this.dataBuffer[t];
            }
        }
        class ud extends lf {
            constructor(t, e1, n, r){
                super(t, BigInt64Array.of(e1), n, r);
            }
            getValueFromBuffer(t) {
                return this.dataBuffer[0] + BigInt(t) * this.delta;
            }
        }
        function cd(t, e1, n) {
            return {
                x: hd(t, e1) - n,
                y: hd(t >> 1, e1) - n
            };
        }
        function hd(t, e1) {
            let n = 0;
            for(let r = 0; r < e1; r++)n |= (t & 1 << 2 * r) >> r;
            return n;
        }
        function pd(t, e1, r, i, s, o, a) {
            return t === Zf.MORTON ? function(t, e1, r, i, s, o) {
                const a = new Array(s ? i + 1 : i);
                for(let s = 0; s < i; s++){
                    const i = cd(t[e1[r + s]], o.numBits, o.coordinateShift);
                    a[s] = new n(i.x, i.y);
                }
                return s && (a[a.length - 1] = a[0]), a;
            }(e1, r, i, s, o, a) : function(t, e1, r, i, s) {
                const o = new Array(s ? i + 1 : i);
                for(let s = 0; s < 2 * i; s += 2){
                    const i = 2 * e1[r + s / 2];
                    o[s / 2] = new n(t[i], t[i + 1]);
                }
                return s && (o[o.length - 1] = o[0]), o;
            }(e1, r, i, s, o);
        }
        function fd(t, e1, r, i) {
            const s = new Array(i ? r + 1 : r);
            for(let i = 0; i < 2 * r; i += 2)s[i / 2] = new n(t[e1 + i], t[e1 + i + 1]);
            return i && (s[s.length - 1] = s[0]), s;
        }
        !function(t) {
            t[t.POINT = 0] = "POINT", t[t.LINESTRING = 1] = "LINESTRING", t[t.POLYGON = 2] = "POLYGON", t[t.MULTIPOINT = 3] = "MULTIPOINT", t[t.MULTILINESTRING = 4] = "MULTILINESTRING", t[t.MULTIPOLYGON = 5] = "MULTIPOLYGON";
        }(Xf || (Xf = {})), function(t) {
            t[t.POINT = 0] = "POINT", t[t.LINESTRING = 1] = "LINESTRING", t[t.POLYGON = 2] = "POLYGON";
        }(Yf || (Yf = {})), function(t) {
            t[t.MORTON = 0] = "MORTON", t[t.VEC_2 = 1] = "VEC_2", t[t.VEC_3 = 2] = "VEC_3";
        }(Zf || (Zf = {}));
        class dd {
            constructor(t, e1, n, r, i){
                this._vertexBufferType = t, this._topologyVector = e1, this._vertexOffsets = n, this._vertexBuffer = r, this._mortonSettings = i;
            }
            get vertexBufferType() {
                return this._vertexBufferType;
            }
            get topologyVector() {
                return this._topologyVector;
            }
            get vertexOffsets() {
                return this._vertexOffsets;
            }
            get vertexBuffer() {
                return this._vertexBuffer;
            }
            getSimpleEncodedVertex(t) {
                const e1 = this.vertexOffsets ? 2 * this.vertexOffsets[t] : 2 * t;
                return [
                    this.vertexBuffer[e1],
                    this.vertexBuffer[e1 + 1]
                ];
            }
            getVertex(t) {
                if (this.vertexOffsets && this.mortonSettings) {
                    const e1 = cd(this.vertexBuffer[this.vertexOffsets[t]], this.mortonSettings.numBits, this.mortonSettings.coordinateShift);
                    return [
                        e1.x,
                        e1.y
                    ];
                }
                const e1 = this.vertexOffsets ? 2 * this.vertexOffsets[t] : 2 * t;
                return [
                    this.vertexBuffer[e1],
                    this.vertexBuffer[e1 + 1]
                ];
            }
            getGeometries() {
                return function(t) {
                    const e1 = new Array(t.numGeometries);
                    let r = 1, i = 1, s = 1, o = 0, a = 0, l = 0;
                    const u = t.mortonSettings, c = t.topologyVector, h = c.geometryOffsets, p = c.partOffsets, f = c.ringOffsets, d = t.vertexOffsets, y = !d || 0 === d.length, m = t.containsPolygonGeometry(), g = t.vertexBuffer;
                    for(let c = 0; c < t.numGeometries; c++)switch(t.geometryType(c)){
                        case Xf.POINT:
                            {
                                let c, m;
                                if (y) c = g[a++], m = g[a++];
                                else if (t.vertexBufferType === Zf.MORTON) {
                                    const t = cd(g[d[l++]], u.numBits, u.coordinateShift);
                                    c = t.x, m = t.y;
                                } else {
                                    const t = 2 * d[l++];
                                    c = g[t], m = g[t + 1];
                                }
                                e1[o++] = [
                                    [
                                        new n(c, m)
                                    ]
                                ], h && s++, p && r++, f && i++;
                            }
                            break;
                        case Xf.MULTIPOINT:
                            {
                                const t = h[s] - h[s - 1];
                                s++;
                                const u = new Array(t);
                                if (y) for(let e1 = 0; e1 < t; e1++){
                                    const t = g[a++], r = g[a++];
                                    u[e1] = new n(t, r);
                                }
                                else for(let e1 = 0; e1 < t; e1++){
                                    const t = 2 * d[l++];
                                    u[e1] = new n(g[t], g[t + 1]);
                                }
                                e1[o++] = u.map((t)=>[
                                        t
                                    ]), r += t, i += t;
                            }
                            break;
                        case Xf.LINESTRING:
                            {
                                let n, c;
                                m ? (n = f[i] - f[i - 1], i++) : n = p[r] - p[r - 1], r++, y ? (c = fd(g, a, n, !1), a += 2 * n) : (c = pd(t.vertexBufferType, g, d, l, n, !1, u), l += n), e1[o++] = [
                                    c
                                ], h && s++;
                            }
                            break;
                        case Xf.POLYGON:
                            {
                                const n = p[r] - p[r - 1];
                                r++;
                                const c = new Array(n - 1);
                                let m, x = f[i] - f[i - 1];
                                if (i++, y) {
                                    m = fd(g, a, x, !0), a += 2 * x;
                                    for(let t = 0; t < c.length; t++)x = f[i] - f[i - 1], i++, c[t] = fd(g, a, x, !0), a += 2 * x;
                                } else {
                                    m = pd(t.vertexBufferType, g, d, l, x, !0, u), l += x;
                                    for(let e1 = 0; e1 < c.length; e1++)x = f[i] - f[i - 1], i++, c[e1] = pd(t.vertexBufferType, g, d, l, x, !0, u), l += x;
                                }
                                e1[o++] = [
                                    m
                                ].concat(c), h && s++;
                            }
                            break;
                        case Xf.MULTILINESTRING:
                            {
                                const n = h[s] - h[s - 1];
                                s++;
                                const c = new Array(n);
                                for(let e1 = 0; e1 < n; e1++){
                                    let n;
                                    if (m ? (n = f[i] - f[i - 1], i++) : n = p[r] - p[r - 1], r++, y) c[e1] = fd(g, a, n, !1), a += 2 * n;
                                    else {
                                        const r = pd(t.vertexBufferType, g, d, l, n, !1, u);
                                        c[e1] = r, l += n;
                                    }
                                }
                                e1[o++] = c;
                            }
                            break;
                        case Xf.MULTIPOLYGON:
                            {
                                const n = h[s] - h[s - 1];
                                s++;
                                const c = new Array(n);
                                for(let e1 = 0; e1 < n; e1++){
                                    const n = p[r] - p[r - 1];
                                    let s;
                                    r++;
                                    const o = new Array(n - 1), h = f[i] - f[i - 1];
                                    i++, y ? (s = fd(g, a, h, !0), a += 2 * h) : (s = pd(t.vertexBufferType, g, d, l, h, !0, u), l += h);
                                    for(let e1 = 0; e1 < o.length; e1++){
                                        const n = f[i] - f[i - 1];
                                        i++, y ? (o[e1] = fd(g, a, n, !0), a += 2 * n) : (o[e1] = pd(t.vertexBufferType, g, d, l, n, !0, u), l += n);
                                    }
                                    c[e1] = [
                                        s
                                    ].concat(o);
                                }
                                e1[o++] = c.flat();
                            }
                            break;
                        default:
                            throw new Error("The specified geometry type is currently not supported.");
                    }
                    return e1;
                }(this);
            }
            get mortonSettings() {
                return this._mortonSettings;
            }
        }
        class yd extends dd {
            constructor(t, e1, n, r, i, s, o){
                super(n, r, i, s, o), this._numGeometries = t, this._geometryType = e1;
            }
            geometryType(t) {
                return this._geometryType;
            }
            get numGeometries() {
                return this._numGeometries;
            }
            containsPolygonGeometry() {
                return this._geometryType === Xf.POLYGON || this._geometryType === Xf.MULTIPOLYGON;
            }
            containsSingleGeometryType() {
                return !0;
            }
        }
        class md extends dd {
            constructor(t, e1, n, r, i, s){
                super(t, n, r, i, s), this._geometryTypes = e1;
            }
            geometryType(t) {
                return this._geometryTypes[t];
            }
            get numGeometries() {
                return this._geometryTypes.length;
            }
            containsPolygonGeometry() {
                for(let t = 0; t < this.numGeometries; t++)if (this.geometryType(t) === Xf.POLYGON || this.geometryType(t) === Xf.MULTIPOLYGON) return !0;
                return !1;
            }
            containsSingleGeometryType() {
                return !1;
            }
        }
        class gd {
            constructor(t, e1, n, r){
                this._triangleOffsets = t, this._indexBuffer = e1, this._vertexBuffer = n, this._topologyVector = r;
            }
            get triangleOffsets() {
                return this._triangleOffsets;
            }
            get indexBuffer() {
                return this._indexBuffer;
            }
            get vertexBuffer() {
                return this._vertexBuffer;
            }
            get topologyVector() {
                return this._topologyVector;
            }
            getGeometries() {
                if (!this._topologyVector) throw new Error("Cannot convert GpuVector to coordinates without topology information");
                const t = new Array(this.numGeometries), e1 = this._topologyVector, r = e1.partOffsets, i = e1.ringOffsets, s = e1.geometryOffsets;
                let o = 0, a = 1, l = 1, u = 1;
                for(let e1 = 0; e1 < this.numGeometries; e1++)switch(this.geometryType(e1)){
                    case Xf.POLYGON:
                        {
                            const c = r[a] - r[a - 1];
                            a++;
                            const h = [];
                            for(let t = 0; t < c; t++){
                                const t = i[l] - i[l - 1];
                                l++;
                                const e1 = [];
                                for(let r = 0; r < t; r++){
                                    const t = this._vertexBuffer[o++], r = this._vertexBuffer[o++];
                                    e1.push(new n(t, r));
                                }
                                e1.length > 0 && e1.push(e1[0]), h.push(e1);
                            }
                            t[e1] = h, s && u++;
                        }
                        break;
                    case Xf.MULTIPOLYGON:
                        {
                            const c = s[u] - s[u - 1];
                            u++;
                            const h = [];
                            for(let t = 0; t < c; t++){
                                const t = r[a] - r[a - 1];
                                a++;
                                for(let e1 = 0; e1 < t; e1++){
                                    const t = i[l] - i[l - 1];
                                    l++;
                                    const e1 = [];
                                    for(let r = 0; r < t; r++){
                                        const t = this._vertexBuffer[o++], r = this._vertexBuffer[o++];
                                        e1.push(new n(t, r));
                                    }
                                    e1.length > 0 && e1.push(e1[0]), h.push(e1);
                                }
                            }
                            t[e1] = h;
                        }
                }
                return t;
            }
            [Symbol.iterator]() {
                return null;
            }
        }
        function xd(t, e1, n, r, i, s) {
            return new vd(t, e1, n, r, i, s);
        }
        class vd extends gd {
            constructor(t, e1, n, r, i, s){
                super(n, r, i, s), this._numGeometries = t, this._geometryType = e1;
            }
            geometryType(t) {
                return this._geometryType;
            }
            get numGeometries() {
                return this._numGeometries;
            }
            containsSingleGeometryType() {
                return !0;
            }
        }
        function bd(t, e1, n, r, i) {
            return new wd(t, e1, n, r, i);
        }
        class wd extends gd {
            constructor(t, e1, n, r, i){
                super(e1, n, r, i), this._geometryTypes = t;
            }
            geometryType(t) {
                return this._geometryTypes[t];
            }
            get numGeometries() {
                return this._geometryTypes.length;
            }
            containsSingleGeometryType() {
                return !1;
            }
        }
        function _d(t, e1, n, r, i) {
            const s = Hf(t, n);
            let o, a, l, u;
            if (ad(s, r, t, n) === Gf.CONST) {
                const i = nd(t, n, s);
                let c, h, p, f;
                for(let r = 0; r < e1 - 1; r++){
                    const e1 = Hf(t, n);
                    switch(e1.physicalStreamType){
                        case Nf.LENGTH:
                            switch(e1.logicalStreamType.lengthType){
                                case qf.GEOMETRIES:
                                    c = td(t, n, e1);
                                    break;
                                case qf.PARTS:
                                    h = td(t, n, e1);
                                    break;
                                case qf.RINGS:
                                    p = td(t, n, e1);
                                    break;
                                case qf.TRIANGLES:
                                    f = td(t, n, e1);
                            }
                            break;
                        case Nf.OFFSET:
                            switch(e1.logicalStreamType.offsetType){
                                case jf.VERTEX:
                                    o = Qf(t, n, e1);
                                    break;
                                case jf.INDEX:
                                    u = Qf(t, n, e1);
                            }
                            break;
                        case Nf.DATA:
                            Uf.VERTEX === e1.logicalStreamType.dictionaryType ? a = Jf(t, n, e1) : (l = {
                                numBits: e1.numBits,
                                coordinateShift: e1.coordinateShift
                            }, a = Qf(t, n, e1));
                    }
                }
                return u ? void 0 !== c || void 0 !== h ? xd(r, i, f, u, a, {
                    geometryOffsets: c,
                    partOffsets: h,
                    ringOffsets: p
                }) : xd(r, i, f, u, a) : void 0 === l ? function(t, e1, n, r, i) {
                    return new yd(t, e1, Zf.VEC_2, n, r, i);
                }(r, i, {
                    geometryOffsets: c,
                    partOffsets: h,
                    ringOffsets: p
                }, o, a) : function(t, e1, n, r, i, s) {
                    return new yd(t, e1, Zf.MORTON, n, r, i, s);
                }(r, i, {
                    geometryOffsets: c,
                    partOffsets: h,
                    ringOffsets: p
                }, o, a, l);
            }
            const c = Qf(t, n, s);
            let h, p, f, d, y, m, g;
            for(let r = 0; r < e1 - 1; r++){
                const e1 = Hf(t, n);
                switch(e1.physicalStreamType){
                    case Nf.LENGTH:
                        switch(e1.logicalStreamType.lengthType){
                            case qf.GEOMETRIES:
                                h = Qf(t, n, e1);
                                break;
                            case qf.PARTS:
                                p = Qf(t, n, e1);
                                break;
                            case qf.RINGS:
                                f = Qf(t, n, e1);
                                break;
                            case qf.TRIANGLES:
                                d = td(t, n, e1);
                        }
                        break;
                    case Nf.OFFSET:
                        switch(e1.logicalStreamType.offsetType){
                            case jf.VERTEX:
                                o = Qf(t, n, e1);
                                break;
                            case jf.INDEX:
                                u = Qf(t, n, e1);
                        }
                        break;
                    case Nf.DATA:
                        Uf.VERTEX === e1.logicalStreamType.dictionaryType ? a = Jf(t, n, e1) : (l = {
                            numBits: e1.numBits,
                            coordinateShift: e1.coordinateShift
                        }, a = Qf(t, n, e1));
                }
            }
            return h ? (y = Sd(c, h, 2), p && f ? (m = Ad(c, y, p, !1), g = function(t, e1, n, r) {
                const i = new Uint32Array(n[n.length - 1] + 1);
                let s = 0;
                i[0] = s;
                let o = 1, a = 1, l = 0;
                for(let u = 0; u < t.length; u++){
                    const c = t[u], h = e1[u + 1] - e1[u];
                    if (0 !== c && 3 !== c) for(let t = 0; t < h; t++){
                        const t = n[o] - n[o - 1];
                        o++;
                        for(let e1 = 0; e1 < t; e1++)s = i[a++] = s + r[l++];
                    }
                    else for(let t = 0; t < h; t++)i[a++] = ++s, o++;
                }
                return i;
            }(c, y, m, f)) : p && (m = function(t, e1, n) {
                const r = new Uint32Array(e1[e1.length - 1] + 1);
                let i = 0;
                r[0] = i;
                let s = 1, o = 0;
                for(let a = 0; a < t.length; a++){
                    const l = t[a], u = e1[a + 1] - e1[a];
                    if (4 === l || 1 === l) for(let t = 0; t < u; t++)i = r[s++] = i + n[o++];
                    else for(let t = 0; t < u; t++)r[s++] = ++i;
                }
                return r;
            }(c, y, p))) : p && f ? (m = Sd(c, p, 1), g = Ad(c, m, f, !0)) : p && (m = Sd(c, p, 0)), u && !m ? bd(c, d, u, a) : u ? bd(c, d, u, a, {
                geometryOffsets: y,
                partOffsets: m,
                ringOffsets: g
            }) : void 0 === l ? function(t, e1, n, r) {
                return new md(Zf.VEC_2, t, e1, n, r);
            }(c, {
                geometryOffsets: y,
                partOffsets: m,
                ringOffsets: g
            }, o, a) : function(t, e1, n, r, i) {
                return new md(Zf.MORTON, t, e1, n, r, i);
            }(c, {
                geometryOffsets: y,
                partOffsets: m,
                ringOffsets: g
            }, o, a, l);
        }
        function Sd(t, e1, n) {
            const r = new Uint32Array(t.length + 1);
            let i = 0;
            r[0] = i;
            let s = 0;
            for(let o = 0; o < t.length; o++)i = r[o + 1] = i + (t[o] > n ? e1[s++] : 1);
            return r;
        }
        function Ad(t, e1, n, r) {
            const i = new Uint32Array(e1[e1.length - 1] + 1);
            let s = 0;
            i[0] = s;
            let o = 1, a = 0;
            for(let l = 0; l < t.length; l++){
                const u = t[l], c = e1[l + 1] - e1[l];
                if (5 === u || 2 === u || r && (4 === u || 1 === u)) for(let t = 0; t < c; t++)s = i[o++] = s + n[a++];
                else for(let t = 0; t < c; t++)i[o++] = ++s;
            }
            return i;
        }
        class Md extends rf {
            constructor(t, e1, n){
                super(t, e1.getBuffer(), n), this.dataVector = e1;
            }
            getValueFromBuffer(t) {
                return this.dataVector.get(t);
            }
        }
        class kd extends sf {
            getValueFromBuffer(t) {
                return this.dataBuffer[t];
            }
        }
        class Id extends rf {
            constructor(t, e1, n, r){
                super(t, r ? BigInt64Array.of(e1) : BigUint64Array.of(e1), n);
            }
            getValueFromBuffer(t) {
                return this.dataBuffer[0];
            }
        }
        function Ed(t, e1, n, r, i) {
            const s = function(t, e1, n, r) {
                const i = new Uint8Array(e1);
                let s = 0;
                const o = r.get() + n;
                for(; s < e1 && !(r.get() >= o);){
                    const n = t[r.increment()];
                    if (n <= 127) {
                        const o = n + 3, a = t[r.increment()], l = Math.min(s + o, e1);
                        i.fill(a, s, l), s = l;
                    } else {
                        const o = 256 - n;
                        for(let n = 0; n < o && s < e1; n++)i[s++] = t[r.increment()];
                    }
                }
                return r.set(o), i;
            }(t, Math.ceil(e1 / 8), n, r);
            return i ? function(t, e1, n) {
                if (!n) return t;
                const r = n.size(), i = new Wf(t, e1), s = new Wf(new Uint8Array(Math.ceil(r / 8)), r);
                let o = 0;
                for(let t = 0; t < r; t++){
                    const e1 = !!n.get(t) && i.get(o++);
                    s.set(t, e1);
                }
                return s.getBuffer();
            }(s, e1, i) : s;
        }
        const Td = new TextDecoder;
        function Fd(t, e1, n) {
            return n - e1 >= 12 ? Td.decode(t.subarray(e1, n)) : function(t, e1, n) {
                let r = "", i = e1;
                for(; i < n;){
                    const e1 = t[i];
                    let s, o, a, l = null, u = e1 > 239 ? 4 : e1 > 223 ? 3 : e1 > 191 ? 2 : 1;
                    if (i + u > n) break;
                    1 === u ? e1 < 128 && (l = e1) : 2 === u ? (s = t[i + 1], 128 == (192 & s) && (l = (31 & e1) << 6 | 63 & s, l <= 127 && (l = null))) : 3 === u ? (s = t[i + 1], o = t[i + 2], 128 == (192 & s) && 128 == (192 & o) && (l = (15 & e1) << 12 | (63 & s) << 6 | 63 & o, (l <= 2047 || l >= 55296 && l <= 57343) && (l = null))) : 4 === u && (s = t[i + 1], o = t[i + 2], a = t[i + 3], 128 == (192 & s) && 128 == (192 & o) && 128 == (192 & a) && (l = (15 & e1) << 18 | (63 & s) << 12 | (63 & o) << 6 | 63 & a, (l <= 65535 || l >= 1114112) && (l = null))), null === l ? (l = 65533, u = 1) : l > 65535 && (l -= 65536, r += String.fromCharCode(l >>> 10 & 1023 | 55296), l = 56320 | 1023 & l), r += String.fromCharCode(l), i += u;
                }
                return r;
            }(t, e1, n);
        }
        class Pd extends rf {
            constructor(t, e1, n, r){
                super(t, n, r), this.offsetBuffer = e1;
            }
        }
        class Dd extends Pd {
            constructor(t, e1, n, r){
                super(t, e1, n, r ?? e1.length - 1);
            }
            getValueFromBuffer(t) {
                return Fd(this.dataBuffer, this.offsetBuffer[t], this.offsetBuffer[t + 1]);
            }
        }
        class zd extends Pd {
            constructor(t, e1, n, r, i){
                super(t, n, r, i ?? e1.length), this.indexBuffer = e1, this.indexBuffer = e1;
            }
            getValueFromBuffer(t) {
                const e1 = this.indexBuffer[t];
                return Fd(this.dataBuffer, this.offsetBuffer[e1], this.offsetBuffer[e1 + 1]);
            }
        }
        class Bd extends Pd {
            constructor(t, e1, n, r, i, s, o){
                super(t, n, r, o), this.indexBuffer = e1, this.symbolOffsetBuffer = i, this.symbolTableBuffer = s;
            }
            getValueFromBuffer(t) {
                null == this.decodedDictionary && (null == this.symbolLengthBuffer && (this.symbolLengthBuffer = this.offsetToLengthBuffer(this.symbolOffsetBuffer)), this.decodedDictionary = function(t, e1, n) {
                    const r = [], i = new Array(e1.length).fill(0);
                    for(let t = 1; t < e1.length; t++)i[t] = i[t - 1] + e1[t - 1];
                    for(let s = 0; s < n.length; s++)if (255 === n[s]) r.push(n[++s]);
                    else {
                        const o = e1[n[s]], a = i[n[s]];
                        for(let e1 = 0; e1 < o; e1++)r.push(t[a + e1]);
                    }
                    return new Uint8Array(r);
                }(this.symbolTableBuffer, this.symbolLengthBuffer, this.dataBuffer));
                const e1 = this.indexBuffer[t];
                return Fd(this.decodedDictionary, this.offsetBuffer[e1], this.offsetBuffer[e1 + 1]);
            }
            offsetToLengthBuffer(t) {
                const e1 = new Uint32Array(t.length - 1);
                let n = t[0];
                for(let r = 1; r < t.length; r++){
                    const i = t[r];
                    e1[r - 1] = i - n, n = i;
                }
                return e1;
            }
        }
        function Cd(t, e1, n, r, i, s) {
            return "scalarType" === n.type ? function(t, e1, n, r, i, s) {
                let o = null;
                if (0 === t) return null;
                if (s.nullable) {
                    const t = Hf(e1, n), r = t.numValues, i = n.get(), s = Ed(e1, r, t.byteLength, n);
                    n.set(i + t.byteLength), o = new Wf(s, t.numValues);
                }
                const a = o ?? r;
                switch(i.physicalType){
                    case 4:
                    case 3:
                        return function(t, e1, n, r, i) {
                            const s = Hf(t, e1), o = ad(s, i, t, e1), a = 3 === r.physicalType;
                            if (o === Gf.FLAT) {
                                const r = Vd(i) ? i : void 0, o = a ? Jf(t, e1, s, 0, r) : Qf(t, e1, s, 0, r);
                                return new of(n.name, o, i);
                            }
                            if (o === Gf.SEQUENCE) {
                                const r = rd(t, e1, s);
                                return new uf(n.name, r[0], r[1], s.numRleValues);
                            }
                            const l = a ? function(t, e1, n) {
                                const r = ed(t, e1, n);
                                return 1 === r.length ? Df(r[0]) : function(t) {
                                    return Df(t[1]);
                                }(r);
                            }(t, e1, s) : nd(t, e1, s);
                            return new cf(n.name, l, i, a);
                        }(e1, n, s, i, a);
                    case 9:
                        return function(t, e1, n, r, i) {
                            let s = null, o = null, a = null, l = null, u = null, c = i ?? null, h = null, p = null;
                            for(let t = 0; t < r; t++){
                                const t = Hf(e1, n);
                                switch(t.physicalStreamType){
                                    case Nf.PRESENT:
                                        {
                                            const r = Ed(e1, t.numValues, t.byteLength, n), s = new Wf(r, t.numValues);
                                            c = i ?? s;
                                            break;
                                        }
                                    case Nf.OFFSET:
                                        o = Qf(e1, n, t, 0, c);
                                        break;
                                    case Nf.LENGTH:
                                        {
                                            const r = td(e1, n, t);
                                            qf.DICTIONARY === t.logicalStreamType.lengthType ? s = r : qf.SYMBOL === t.logicalStreamType.lengthType ? l = r : h = r;
                                            break;
                                        }
                                    case Nf.DATA:
                                        {
                                            const r = e1.subarray(n.get(), n.get() + t.byteLength);
                                            n.add(t.byteLength);
                                            const i = t.logicalStreamType.dictionaryType;
                                            Uf.FSST === i ? u = r : Uf.SINGLE === i || Uf.SHARED === i ? a = r : Uf.NONE === i && (p = r);
                                            break;
                                        }
                                }
                            }
                            return function(t, e1, n, r, i, s, o) {
                                return e1 ? new Bd(t, n, r, i, s, e1, o) : null;
                            }(t, u, o, s, a, l, c) ?? function(t, e1, n, r, i) {
                                return e1 ? i ? new zd(t, n, r, e1, i) : new zd(t, n, r, e1) : null;
                            }(t, a, o, s, c) ?? function(t, e1, n, r, i) {
                                if (!e1 || !n) return null;
                                if (r) return i ? new zd(t, r, e1, n, i) : new zd(t, r, e1, n);
                                if (i && i.size() !== e1.length - 1) {
                                    const r = new Uint32Array(i.size());
                                    let s = 0;
                                    for(let t = 0; t < i.size(); t++)r[t] = i.get(t) ? s++ : 0;
                                    return new zd(t, r, e1, n, i);
                                }
                                return i ? new Dd(t, e1, n, i) : new Dd(t, e1, n);
                            }(t, h, p, o, c);
                        }(s.name, e1, n, s.nullable ? t - 1 : t, o);
                    case 0:
                        return function(t, e1, n, r, i) {
                            const s = Hf(t, e1), o = s.numValues, a = e1.get(), l = Vd(i) ? i : void 0, u = Ed(t, o, s.byteLength, e1, l);
                            e1.set(a + s.byteLength);
                            const c = new Wf(u, o);
                            return new Md(n.name, c, i);
                        }(e1, n, s, 0, a);
                    case 6:
                    case 5:
                        return function(t, e1, n, r, i) {
                            const s = Hf(t, e1), o = ad(s, r, t, e1, "int64"), a = 5 === i.physicalType;
                            if (o === Gf.FLAT) {
                                const i = Vd(r) ? r : void 0, o = a ? function(t, e1, n, r) {
                                    return function(t, e1, n) {
                                        let r;
                                        switch(e1.logicalLevelTechnique1){
                                            case ff.DELTA:
                                                if (e1.logicalLevelTechnique2 === ff.RLE) {
                                                    const i = e1;
                                                    if (!n) return function(t, e1, n) {
                                                        const r = new BigInt64Array(n);
                                                        let i = 0, s = 0n;
                                                        for(let n = 0; n < e1; n++){
                                                            const o = Number(t[n]), a = zf(t[n + e1]);
                                                            for(let t = 0; t < o; t++)s += a, r[i++] = s;
                                                        }
                                                        return r;
                                                    }(t, i.runs, i.numRleValues);
                                                    r = $f(t = Vf(t, i.runs, i.numRleValues));
                                                } else r = $f(t);
                                                break;
                                            case ff.RLE:
                                                r = function(t, e1, n) {
                                                    if (void 0 === n) {
                                                        n = 0;
                                                        for(let r = 0; r < e1; r++)n += Number(t[r]);
                                                    }
                                                    const r = new BigInt64Array(n);
                                                    let i = 0;
                                                    for(let n = 0; n < e1; n++){
                                                        const s = Number(t[n]);
                                                        let o = t[n + e1];
                                                        o = zf(o), r.fill(o, i, i + s), i += s;
                                                    }
                                                    return r;
                                                }(t, e1.runs, e1.numRleValues);
                                                break;
                                            case ff.NONE:
                                                r = function(t) {
                                                    const e1 = new BigInt64Array(t.length);
                                                    for(let n = 0; n < t.length; n++)e1[n] = zf(t[n]);
                                                    return e1;
                                                }(t);
                                                break;
                                            default:
                                                throw new Error(`The specified Logical level technique is not supported: ${e1.logicalLevelTechnique1}`);
                                        }
                                        return n ? Kf(r, n, 0n) : r;
                                    }(Tf(t, e1, n.numValues), n, r);
                                }(t, e1, s, i) : sd(t, e1, s, i);
                                return new ld(n.name, o, r);
                            }
                            if (o === Gf.SEQUENCE) {
                                const r = id(t, e1, s);
                                return new ud(n.name, r[0], r[1], s.numRleValues);
                            }
                            const l = a ? function(t, e1, n) {
                                const r = Tf(t, e1, n.numValues);
                                return 1 === r.length ? zf(r[0]) : function(t) {
                                    return zf(t[1]);
                                }(r);
                            }(t, e1, s) : od(t, e1, s);
                            return new Id(n.name, l, r, a);
                        }(e1, n, s, a, i);
                    case 7:
                        return function(t, e1, n, r) {
                            const i = Hf(t, e1), s = Vd(r) ? r : void 0, o = function(t, e1, n, r) {
                                const i = e1.get(), s = i + n * Float32Array.BYTES_PER_ELEMENT, o = new Uint8Array(t.subarray(i, s)).buffer, a = new Float32Array(o);
                                return e1.set(s), r ? Kf(a, r, 0) : a;
                            }(t, e1, i.numValues, s);
                            return new kd(n.name, o, r);
                        }(e1, n, s, a);
                    case 8:
                        return function(t, e1, n, r) {
                            const i = Hf(t, e1), s = Vd(r) ? r : void 0, o = function(t, e1, n, r) {
                                const i = e1.get(), s = i + n * Float64Array.BYTES_PER_ELEMENT, o = new Uint8Array(t.subarray(i, s)).buffer, a = new Float64Array(o);
                                return e1.set(s), r ? Kf(a, r, 0) : a;
                            }(t, e1, i.numValues, s);
                            return new af(n.name, o, r);
                        }(e1, n, s, a);
                    default:
                        throw new Error(`The specified data type for the field is currently not supported: ${i}`);
                }
            }(r, t, e1, i, n.scalarType, n) : 0 === r ? null : function(t, e1, n, r) {
                let i = null, s = null, o = null, a = null, l = !1;
                for(; !l;){
                    const n = Hf(t, e1);
                    switch(n.physicalStreamType){
                        case Nf.LENGTH:
                            qf.DICTIONARY === n.logicalStreamType.lengthType ? i = td(t, e1, n) : o = td(t, e1, n);
                            break;
                        case Nf.DATA:
                            Uf.SINGLE === n.logicalStreamType.dictionaryType || Uf.SHARED === n.logicalStreamType.dictionaryType ? (s = t.subarray(e1.get(), e1.get() + n.byteLength), l = !0) : a = t.subarray(e1.get(), e1.get() + n.byteLength), e1.add(n.byteLength);
                    }
                }
                const u = n.complexType.children, c = [];
                let h = 0;
                for (const l of u){
                    const u = Ef(t, e1, 1)[0];
                    if (0 === u) continue;
                    const p = l.name ? `${n.name}${l.name}` : n.name;
                    if (2 !== u || "scalarField" !== l.type || 9 !== l.scalarField.physicalType) throw new Error("Currently only optional string fields are implemented for a struct.");
                    const f = Hf(t, e1), d = Ed(t, f.numValues, f.byteLength, e1), y = Hf(t, e1), m = Qf(t, e1, y, 0, y.decompressedCount !== r ? new Wf(d, f.numValues) : void 0);
                    c[h++] = a ? new Bd(p, m, i, s, o, a, new Wf(d, f.numValues)) : new zd(p, m, i, s, new Wf(d, f.numValues));
                }
                return c;
            }(t, e1, n, i);
        }
        function Vd(t) {
            return t instanceof Wf;
        }
        function Ld(t) {
            switch(t){
                case 0:
                case 1:
                case 2:
                case 3:
                    {
                        const e1 = {};
                        e1.nullable = !!(1 & t), e1.columnScope = 0;
                        const n = {
                            type: "logicalType",
                            logicalType: 0
                        };
                        return n.longID = !!(2 & t), e1.scalarType = n, e1.type = "scalarType", e1;
                    }
                case 4:
                    {
                        const t = {
                            nullable: !1,
                            columnScope: 0
                        }, e1 = {
                            type: "physicalType",
                            physicalType: 0
                        };
                        return t.type = "complexType", t.complexType = e1, t;
                    }
                case 30:
                    {
                        const t = {
                            nullable: !1,
                            columnScope: 0
                        }, e1 = {
                            type: "physicalType",
                            physicalType: 1
                        };
                        return t.type = "complexType", t.complexType = e1, t;
                    }
                default:
                    return function(t) {
                        let e1;
                        switch(t){
                            case 10:
                            case 11:
                                e1 = 0;
                                break;
                            case 12:
                            case 13:
                                e1 = 1;
                                break;
                            case 14:
                            case 15:
                                e1 = 2;
                                break;
                            case 16:
                            case 17:
                                e1 = 3;
                                break;
                            case 18:
                            case 19:
                                e1 = 4;
                                break;
                            case 20:
                            case 21:
                                e1 = 5;
                                break;
                            case 22:
                            case 23:
                                e1 = 6;
                                break;
                            case 24:
                            case 25:
                                e1 = 7;
                                break;
                            case 26:
                            case 27:
                                e1 = 8;
                                break;
                            case 28:
                            case 29:
                                e1 = 9;
                                break;
                            default:
                                return null;
                        }
                        const n = {};
                        n.nullable = !!(1 & t), n.columnScope = 0;
                        const r = {
                            type: "physicalType"
                        };
                        return r.physicalType = e1, n.type = "scalarType", n.scalarType = r, n;
                    }(t);
            }
        }
        function Od(t) {
            return t >= 10;
        }
        function $d(t) {
            return 30 === t;
        }
        function Rd(t) {
            if ("scalarType" === t.type) {
                const e1 = t.scalarType;
                if ("physicalType" === e1.type) switch(e1.physicalType){
                    case 0:
                    case 1:
                    case 2:
                    case 3:
                    case 4:
                    case 5:
                    case 6:
                    case 7:
                    case 8:
                    default:
                        return !1;
                    case 9:
                        return !0;
                }
                if ("logicalType" === e1.type) return !1;
            } else if ("complexType" === t.type) {
                const e1 = t.complexType;
                if ("physicalType" === e1.type) switch(e1.physicalType){
                    case 0:
                    case 1:
                        return !0;
                    default:
                        return !1;
                }
            }
            return console.warn("Unexpected column type in hasStreamCount", t), !1;
        }
        function Nd(t) {
            return "complexType" === t.type && "physicalType" === t.complexType?.type && 0 === t.complexType.physicalType;
        }
        const Ud = new TextDecoder;
        function jd(t, e1) {
            const n = Ef(t, e1, 1)[0];
            if (0 === n) return "";
            const r = e1.get(), i = t.subarray(r, r + n);
            return e1.add(n), Ud.decode(i);
        }
        function qd(t, e1) {
            const n = Ef(t, e1, 1)[0] >>> 0;
            if (n < 10 || n > 30) throw new Error(`Unsupported field type code ${n}. Supported: 10-29(scalars), 30(STRUCT)`);
            const r = Ld(n);
            if (Od(n) && (r.name = jd(t, e1)), $d(n)) {
                const n = Ef(t, e1, 1)[0] >>> 0;
                r.complexType.children = new Array(n);
                for(let i = 0; i < n; i++)r.complexType.children[i] = qd(t, e1);
            }
            return function(t) {
                return {
                    name: t.name,
                    nullable: t.nullable,
                    scalarField: t.scalarType,
                    complexField: t.complexType,
                    type: "scalarType" === t.type ? "scalarField" : "complexField"
                };
            }(r);
        }
        function Gd(t, e1) {
            const n = Ef(t, e1, 1)[0] >>> 0, r = Ld(n);
            if (!r) throw new Error(`Unsupported column type code ${n}. Supported: 0-3(ID), 4(GEOMETRY), 10-29(scalars), 30(STRUCT)`);
            if (Od(n) ? r.name = jd(t, e1) : n >= 0 && n <= 3 ? r.name = "id" : 4 === n && (r.name = "geometry"), $d(n)) {
                const n = Ef(t, e1, 1)[0] >>> 0, i = r.complexType;
                i.children = new Array(n);
                for(let r = 0; r < n; r++)i.children[r] = qd(t, e1);
            }
            return r;
        }
        function Xd(t, e1) {
            const n = {
                featureTables: []
            }, r = {};
            r.name = jd(t, e1);
            const i = Ef(t, e1, 1)[0] >>> 0, s = Ef(t, e1, 1)[0] >>> 0;
            r.columns = new Array(s);
            for(let n = 0; n < s; n++)r.columns[n] = Gd(t, e1);
            return n.featureTables.push(r), [
                n,
                i
            ];
        }
        function Yd(t, e1, n, r, i, s, o = !1) {
            const a = e1.scalarType;
            if (!a || "logicalType" !== a.type || 0 !== a.logicalType) throw new Error(`ID column must be a logical ID scalar type: ${r}`);
            const l = a.longID ? 6 : 4, u = "number" == typeof s ? void 0 : s, c = ad(i, s, t, n, 6 === l ? "int64" : "int32");
            if (4 === l) switch(c){
                case Gf.FLAT:
                    {
                        const e1 = Qf(t, n, i, 0, u);
                        return new of(r, e1, s);
                    }
                case Gf.SEQUENCE:
                    {
                        const e1 = rd(t, n, i);
                        return new uf(r, e1[0], e1[1], i.numRleValues);
                    }
                case Gf.CONST:
                    {
                        const e1 = nd(t, n, i);
                        return new cf(r, e1, s, !1);
                    }
            }
            switch(c){
                case Gf.FLAT:
                    {
                        if (o) {
                            const e1 = function(t, e1, n) {
                                const r = function(t, e1, n) {
                                    const r = new Float64Array(n);
                                    for(let i = 0; i < n; i++)r[i] = Pf(t, e1);
                                    return r;
                                }(t, e1, n.numValues);
                                return function(t, e1) {
                                    switch(e1.logicalLevelTechnique1){
                                        case ff.DELTA:
                                            return e1.logicalLevelTechnique2 === ff.RLE && (t = Lf(t, e1.runs, e1.numRleValues)), function(t) {
                                                t[0] = Bf(t[0]);
                                                const e1 = t.length / 4 * 4;
                                                let n = 1;
                                                if (e1 >= 4) for(; n < e1 - 4; n += 4){
                                                    const e1 = t[n + 1], r = t[n + 2], i = t[n + 3];
                                                    t[n] = Bf(t[n]) + t[n - 1], t[n + 1] = Bf(e1) + t[n], t[n + 2] = Bf(r) + t[n + 1], t[n + 3] = Bf(i) + t[n + 2];
                                                }
                                                for(; n !== t.length; ++n)t[n] = Bf(t[n]) + t[n - 1];
                                            }(t), t;
                                        case ff.RLE:
                                            return function(t, e1) {
                                                return Lf(t, e1.runs, e1.numRleValues);
                                            }(t, e1);
                                        case ff.NONE:
                                            return t;
                                        default:
                                            throw new Error(`The specified Logical level technique is not supported: ${e1.logicalLevelTechnique1}`);
                                    }
                                }(r, n);
                            }(t, n, i);
                            return new af(r, e1, s);
                        }
                        const e1 = sd(t, n, i, u);
                        return new ld(r, e1, s);
                    }
                case Gf.SEQUENCE:
                    {
                        const e1 = id(t, n, i);
                        return new ud(r, e1[0], e1[1], i.numRleValues);
                    }
                case Gf.CONST:
                    {
                        const e1 = od(t, n, i);
                        return new Id(r, e1, s, !1);
                    }
            }
            throw new Error("Vector type not supported for id column.");
        }
        class Zd {
            constructor(t, e1){
                var n;
                switch(this._featureData = t, this.properties = this._featureData.properties || {}, null === (n = this._featureData.geometry) || void 0 === n ? void 0 : n.type){
                    case Xf.POINT:
                    case Xf.MULTIPOINT:
                        this.type = 1;
                        break;
                    case Xf.LINESTRING:
                    case Xf.MULTILINESTRING:
                        this.type = 2;
                        break;
                    case Xf.POLYGON:
                    case Xf.MULTIPOLYGON:
                        this.type = 3;
                        break;
                    default:
                        this.type = 0;
                }
                this.extent = e1, this.id = Number(this._featureData.id);
            }
            loadGeometry() {
                const t = [];
                for (const e1 of this._featureData.geometry.coordinates){
                    const r = [];
                    for (const t of e1)r.push(new n(t.x, t.y));
                    t.push(r);
                }
                return t;
            }
        }
        class Hd {
            constructor(t){
                this.features = [], this.featureTable = t, this.name = t.name, this.extent = t.extent, this.version = 2, this.features = t.getFeatures(), this.length = this.features.length;
            }
            feature(t) {
                return new Zd(this.features[t], this.extent);
            }
        }
        class Wd {
            constructor(t){
                this.layers = {};
                const e1 = function(t, e1, n = !0) {
                    const r = new pf(0), i = [];
                    for(; r.get() < t.length;){
                        const e1 = Ef(t, r, 1)[0] >>> 0, o = r.get() + e1;
                        if (o > t.length) throw new Error(`Block overruns tile: ${o} > ${t.length}`);
                        if (1 != Ef(t, r, 1)[0] >>> 0) {
                            r.set(o);
                            continue;
                        }
                        const [a, l] = Xd(t, r), u = a.featureTables[0];
                        let c = null, h = null;
                        const p = [];
                        let f = 0;
                        for (const e1 of u.columns){
                            const i = e1.name;
                            if ("scalarType" === (s = e1).type && "logicalType" === s.scalarType?.type && 0 === s.scalarType.logicalType) {
                                let s = null;
                                if (e1.nullable) {
                                    const e1 = Hf(t, r), n = r.get(), i = Ed(t, e1.numValues, e1.byteLength, r);
                                    r.set(n + e1.byteLength), s = new Wf(i, e1.numValues);
                                }
                                const o = Hf(t, r);
                                f = s ? s.size() : o.decompressedCount, c = Yd(t, e1, r, i, o, s ?? f, n);
                            } else if (Nd(e1)) {
                                const e1 = Ef(t, r, 1)[0];
                                if (0 === f) {
                                    const e1 = r.get();
                                    f = Hf(t, r).decompressedCount, r.set(e1);
                                }
                                h = _d(t, e1, r, f);
                            } else {
                                const n = Rd(e1) ? Ef(t, r, 1)[0] : 1;
                                if (0 === n) continue;
                                const i = Cd(t, r, e1, n, f);
                                if (i) {
                                    if (Array.isArray(i)) for (const t of i)p.push(t);
                                    else p.push(i);
                                }
                            }
                        }
                        const d = new hf(u.name, h, c, p, l);
                        i.push(d), r.set(o);
                    }
                    var s;
                    return i;
                }(new Uint8Array(t));
                this.layers = e1.reduce((t, e1)=>Object.assign(Object.assign({}, t), {
                        [e1.name]: new Hd(e1)
                    }), {});
            }
        }
        class Kd {
            constructor(t, e1){
                this.feature = t, this.type = t.type, this.properties = t.tags ? t.tags : {}, this.extent = e1, "id" in t && ("string" == typeof t.id ? this.id = parseInt(t.id, 10) : "number" != typeof t.id || isNaN(t.id) || (this.id = t.id));
            }
            loadGeometry() {
                const t = [], e1 = 1 === this.feature.type ? [
                    this.feature.geometry
                ] : this.feature.geometry;
                for (const r of e1){
                    const e1 = [];
                    for (const t of r)e1.push(new n(t[0], t[1]));
                    t.push(e1);
                }
                return t;
            }
        }
        const Jd = "_geojsonTileLayer";
        function Qd(t, e1, n = "") {
            e1.writeVarintField(15, t.version || 1), e1.writeStringField(1, t.name || ""), e1.writeVarintField(5, t.extent || 4096);
            const r = {
                jsonPrefix: n,
                keys: [],
                values: [],
                keycache: {},
                valuecache: {}
            };
            for(let n = 0; n < t.length; n++)r.feature = t.feature(n), e1.writeMessage(2, ty, r);
            const i = r.keys;
            for (const t of i)e1.writeStringField(3, t);
            const s = r.values;
            for (const t of s)e1.writeMessage(4, sy, t);
        }
        function ty(t, e1) {
            if (!t.feature) return;
            const n = t.feature;
            void 0 !== n.id && e1.writeVarintField(1, n.id), e1.writeMessage(2, ey, t), e1.writeVarintField(3, n.type), e1.writeMessage(4, iy, n);
        }
        function ey(t, e1) {
            for(const n in t.feature?.properties){
                let r = t.feature.properties[n], i = t.keycache[n];
                if (null == r) continue;
                void 0 === i && (t.keys.push(n), i = t.keys.length - 1, t.keycache[n] = i), e1.writeVarint(i), "string" != typeof r && "boolean" != typeof r && "number" != typeof r && (r = t.jsonPrefix + JSON.stringify(r));
                const s = typeof r + ":" + r;
                let o = t.valuecache[s];
                void 0 === o && (t.values.push(r), o = t.values.length - 1, t.valuecache[s] = o), e1.writeVarint(o);
            }
        }
        function ny(t, e1) {
            return (e1 << 3) + (7 & t);
        }
        function ry(t) {
            return t << 1 ^ t >> 31;
        }
        function iy(t, e1) {
            const n = t.loadGeometry(), r = t.type;
            let i = 0, s = 0;
            for (const o of n){
                let n = 1;
                1 === r && (n = o.length), e1.writeVarint(ny(1, n));
                const a = 3 === r ? o.length - 1 : o.length;
                for(let t = 0; t < a; t++){
                    1 === t && 1 !== r && e1.writeVarint(ny(2, a - 1));
                    const n = o[t].x - i, l = o[t].y - s;
                    e1.writeVarint(ry(n)), e1.writeVarint(ry(l)), i += n, s += l;
                }
                3 === t.type && e1.writeVarint(ny(7, 1));
            }
        }
        function sy(t, e1) {
            const n = typeof t;
            "string" === n ? e1.writeStringField(1, t) : "boolean" === n ? e1.writeBooleanField(7, t) : "number" === n && (t % 1 != 0 ? e1.writeDoubleField(3, t) : t < 0 ? e1.writeSVarintField(6, t) : e1.writeVarintField(5, t));
        }
        class oy {
            constructor(t, e1){
                this.tileID = t, this.x = t.canonical.x, this.y = t.canonical.y, this.z = t.canonical.z, this.grid = new ps(T, 16, 0), this.grid3D = new ps(T, 16, 0), this.featureIndexArray = new Go, this.promoteId = e1;
            }
            insert(t, e1, n, r, i, s) {
                const o = this.featureIndexArray.length;
                this.featureIndexArray.emplaceBack(n, r, i);
                const a = s ? this.grid3D : this.grid;
                for (const t of e1){
                    const e1 = [
                        1 / 0,
                        1 / 0,
                        -1 / 0,
                        -1 / 0
                    ];
                    for (const n of t)e1[0] = Math.min(e1[0], n.x), e1[1] = Math.min(e1[1], n.y), e1[2] = Math.max(e1[2], n.x), e1[3] = Math.max(e1[3], n.y);
                    e1[0] < T && e1[1] < T && e1[2] >= 0 && e1[3] >= 0 && a.insert(o, e1[0], e1[1], e1[2], e1[3]);
                }
            }
            loadVTLayers() {
                return this.vtLayers || (this.vtLayers = "mlt" !== this.encoding ? new Nu(new Rh(this.rawTileData)).layers : new Wd(this.rawTileData).layers, this.sourceLayerCoder = new ef(this.vtLayers ? Object.keys(this.vtLayers).sort() : [
                    Jd
                ])), this.vtLayers;
            }
            query(t, e1, r, i) {
                this.loadVTLayers();
                const s = t.params, o = T / t.tileSize / t.scale, a = yi(s.filter, s.globalState), l = t.queryGeometry, u = t.queryPadding * o, c = tf.fromPoints(l), h = this.grid.query(c.minX - u, c.minY - u, c.maxX + u, c.maxY + u), p = tf.fromPoints(t.cameraQueryGeometry).expandBy(u), f = this.grid3D.query(p.minX, p.minY, p.maxX, p.maxY, (e1, r, i, s)=>(function(t, e1, r, i, s) {
                        for (const n of t)if (e1 <= n.x && r <= n.y && i >= n.x && s >= n.y) return !0;
                        const o = [
                            new n(e1, r),
                            new n(e1, s),
                            new n(i, s),
                            new n(i, r)
                        ];
                        if (t.length > 2) {
                            for (const e1 of o)if (il(t, e1)) return !0;
                        }
                        for(let e1 = 0; e1 < t.length - 1; e1++)if (sl(t[e1], t[e1 + 1], o)) return !0;
                        return !1;
                    })(t.cameraQueryGeometry, e1 - u, r - u, i + u, s + u));
                for (const t of f)h.push(t);
                h.sort(ly);
                const d = {};
                let y;
                for (const n of h){
                    if (n === y) continue;
                    y = n;
                    const u = this.featureIndexArray.get(n);
                    let c = null;
                    this.loadMatchingFeature(d, u.bucketIndex, u.sourceLayerIndex, u.featureIndex, a, s.layers, s.availableImages, e1, r, i, (e1, n, r)=>(c || (c = qa(e1)), n.queryIntersectsFeature({
                            queryGeometry: l,
                            feature: e1,
                            featureState: r,
                            geometry: c,
                            zoom: this.z,
                            transform: t.transform,
                            pixelsToTileUnits: o,
                            pixelPosMatrix: t.pixelPosMatrix,
                            unwrappedTileID: this.tileID.toUnwrapped(),
                            getElevation: t.getElevation
                        })));
                }
                return d;
            }
            loadMatchingFeature(t, e1, n, r, i, s, o, a, l, u, c) {
                const h = this.bucketLayerIDs[e1];
                if (s && !h.some((t)=>s.has(t))) return;
                const p = this.sourceLayerCoder.decode(n), f = this.vtLayers[p].feature(r);
                if (i.needGeometry) {
                    const t = Ga(f, !0);
                    if (!i.filter(new Cs(this.tileID.overscaledZ), t, this.tileID.canonical)) return;
                } else if (!i.filter(new Cs(this.tileID.overscaledZ), f)) return;
                const d = this.getId(f, p);
                for (const e1 of h){
                    if (s && !s.has(e1)) continue;
                    const n = a[e1];
                    if (!n) continue;
                    let i = {};
                    d && u && (i = u.getState(n.sourceLayer || Jd, d));
                    const h = $({}, l[e1]);
                    h.paint = ay(h.paint, n.paint, f, i, o), h.layout = ay(h.layout, n.layout, f, i, o);
                    const p = !c || c(f, n, i);
                    if (!p) continue;
                    const y = new nf(f, this.z, this.x, this.y, d);
                    y.layer = h;
                    let m = t[e1];
                    void 0 === m && (m = t[e1] = []), m.push({
                        featureIndex: r,
                        feature: y,
                        intersectionZ: p
                    });
                }
            }
            lookupSymbolFeatures(t, e1, n, r, i, s, o, a) {
                const l = {};
                this.loadVTLayers();
                const u = yi(i.filterSpec, i.globalState);
                for (const i of t)this.loadMatchingFeature(l, n, r, i, u, s, o, a, e1);
                return l;
            }
            hasLayer(t) {
                for (const e1 of this.bucketLayerIDs)for (const n of e1)if (t === n) return !0;
                return !1;
            }
            getId(t, e1) {
                var n;
                let r = t.id;
                return this.promoteId && (r = t.properties["string" == typeof this.promoteId ? this.promoteId : this.promoteId[e1]], "boolean" == typeof r && (r = Number(r)), void 0 === r && (null === (n = t.properties) || void 0 === n ? void 0 : n.cluster) && this.promoteId && (r = Number(t.properties.cluster_id))), r;
            }
        }
        function ay(t, e1, n, r, i) {
            return N(t, (t, s)=>{
                const o = e1 instanceof Gs ? e1.get(s) : null;
                return (null == o ? void 0 : o.evaluate) ? o.evaluate(n, r, i) : o;
            });
        }
        function ly(t, e1) {
            return e1 - t;
        }
        function uy(t, e1, r, i, s) {
            const o = [];
            for (const a of t){
                let t;
                for(let l = 0; l < a.length - 1; l++){
                    let u = a[l], c = a[l + 1];
                    u.x < e1 && c.x < e1 || (u.x < e1 ? u = new n(e1, u.y + (e1 - u.x) / (c.x - u.x) * (c.y - u.y))._round() : c.x < e1 && (c = new n(e1, u.y + (e1 - u.x) / (c.x - u.x) * (c.y - u.y))._round()), u.y < r && c.y < r || (u.y < r ? u = new n(u.x + (r - u.y) / (c.y - u.y) * (c.x - u.x), r)._round() : c.y < r && (c = new n(u.x + (r - u.y) / (c.y - u.y) * (c.x - u.x), r)._round()), u.x >= i && c.x >= i || (u.x >= i ? u = new n(i, u.y + (i - u.x) / (c.x - u.x) * (c.y - u.y))._round() : c.x >= i && (c = new n(i, u.y + (i - u.x) / (c.x - u.x) * (c.y - u.y))._round()), u.y >= s && c.y >= s || (u.y >= s ? u = new n(u.x + (s - u.y) / (c.y - u.y) * (c.x - u.x), s)._round() : c.y >= s && (c = new n(u.x + (s - u.y) / (c.y - u.y) * (c.x - u.x), s)._round()), t && u.equals(t[t.length - 1]) || (t = [
                        u
                    ], o.push(t)), t.push(c)))));
                }
            }
            return o;
        }
        function cy(t, e1, n, r, i) {
            switch(e1){
                case 1:
                    return function(t, e1, n, r) {
                        const i = [];
                        for (const s of t)for (const t of s){
                            const s = 0 === r ? t.x : t.y;
                            s >= e1 && s <= n && i.push([
                                t
                            ]);
                        }
                        return i;
                    }(t, n, r, i);
                case 2:
                    return py(t, n, r, i, !1);
                case 3:
                    return py(t, n, r, i, !0);
            }
            return [];
        }
        function hy(t, e1, r, i, s) {
            const o = 0 === i ? fy : dy;
            let a = [];
            const l = [];
            for(let n = 0; n < t.length - 1; n++){
                const u = t[n], c = t[n + 1], h = 0 === i ? u.x : u.y, p = 0 === i ? c.x : c.y;
                let f = !1;
                h < e1 ? p > e1 && a.push(o(u, c, e1)) : h > r ? p < r && a.push(o(u, c, r)) : a.push(u), p < e1 && h >= e1 && (a.push(o(u, c, e1)), f = !0), p > r && h <= r && (a.push(o(u, c, r)), f = !0), !s && f && (l.push(a), a = []);
            }
            const u = t.length - 1, c = 0 === i ? t[u].x : t[u].y;
            return c >= e1 && c <= r && a.push(t[u]), s && a.length > 0 && !a[0].equals(a[a.length - 1]) && a.push(new n(a[0].x, a[0].y)), a.length > 0 && l.push(a), l;
        }
        function py(t, e1, n, r, i) {
            const s = [];
            for (const o of t){
                const t = hy(o, e1, n, r, i);
                t.length > 0 && s.push(...t);
            }
            return s;
        }
        function fy(t, e1, r) {
            return new n(r, t.y + (r - t.x) / (e1.x - t.x) * (e1.y - t.y));
        }
        function dy(t, e1, r) {
            return new n(t.x + (r - t.y) / (e1.y - t.y) * (e1.x - t.x), r);
        }
        ds("FeatureIndex", oy, {
            omit: [
                "rawTileData",
                "sourceLayerCoder"
            ]
        });
        class yy extends n {
            constructor(t, e1, n, r){
                super(t, e1), this.angle = n, void 0 !== r && (this.segment = r);
            }
            clone() {
                return new yy(this.x, this.y, this.angle, this.segment);
            }
        }
        function my(t, e1, n, r, i) {
            if (void 0 === e1.segment || 0 === n) return !0;
            let s = e1, o = e1.segment + 1, a = 0;
            for(; a > -n / 2;){
                if (o--, o < 0) return !1;
                a -= t[o].dist(s), s = t[o];
            }
            a += t[o].dist(t[o + 1]), o++;
            const l = [];
            let u = 0;
            for(; a < n / 2;){
                const e1 = t[o], n = t[o + 1];
                if (!n) return !1;
                let s = t[o - 1].angleTo(e1) - e1.angleTo(n);
                for(s = Math.abs((s + 3 * Math.PI) % (2 * Math.PI) - Math.PI), l.push({
                    distance: a,
                    angleDelta: s
                }), u += s; a - l[0].distance > r;)u -= l.shift().angleDelta;
                if (u > i) return !1;
                o++, a += e1.dist(n);
            }
            return !0;
        }
        function gy(t) {
            let e1 = 0;
            for(let n = 0; n < t.length - 1; n++)e1 += t[n].dist(t[n + 1]);
            return e1;
        }
        function xy(t, e1, n) {
            return t ? .6 * e1 * n : 0;
        }
        function vy(t, e1) {
            return Math.max(t ? t.right - t.left : 0, e1 ? e1.right - e1.left : 0);
        }
        function by(t, e1, n, r, i, s) {
            const o = xy(n, i, s), a = vy(n, r) * s;
            let l = 0;
            const u = gy(t) / 2;
            for(let n = 0; n < t.length - 1; n++){
                const r = t[n], i = t[n + 1], s = r.dist(i);
                if (l + s > u) {
                    const c = (u - l) / s, h = xn.number(r.x, i.x, c), p = xn.number(r.y, i.y, c), f = new yy(h, p, i.angleTo(r), n);
                    return f._round(), !o || my(t, f, a, o, e1) ? f : void 0;
                }
                l += s;
            }
        }
        function wy(t, e1, n, r, i, s, o, a, l) {
            const u = xy(r, s, o), c = vy(r, i), h = c * o, p = 0 === t[0].x || t[0].x === l || 0 === t[0].y || t[0].y === l;
            return e1 - h < e1 / 4 && (e1 = h + e1 / 4), _y(t, p ? e1 / 2 * a % e1 : (c / 2 + 2 * s) * o * a % e1, e1, u, n, h, p, !1, l);
        }
        function _y(t, e1, n, r, i, s, o, a, l) {
            const u = s / 2, c = gy(t);
            let h = 0, p = e1 - n, f = [];
            for(let e1 = 0; e1 < t.length - 1; e1++){
                const o = t[e1], a = t[e1 + 1], d = o.dist(a), y = a.angleTo(o);
                for(; p + n < h + d;){
                    p += n;
                    const m = (p - h) / d, g = xn.number(o.x, a.x, m), x = xn.number(o.y, a.y, m);
                    if (g >= 0 && g < l && x >= 0 && x < l && p - u >= 0 && p + u <= c) {
                        const n = new yy(g, x, y, e1);
                        n._round(), r && !my(t, n, s, r, i) || f.push(n);
                    }
                }
                h += d;
            }
            return a || f.length || o || (f = _y(t, h / 2, n, r, i, s, o, !0, l)), f;
        }
        function Sy(t, e1, r, i) {
            const s = [], o = t.image, a = o.pixelRatio, l = o.paddedRect.w - 2, u = o.paddedRect.h - 2;
            let c = {
                x1: t.left,
                y1: t.top,
                x2: t.right,
                y2: t.bottom
            };
            const h = o.stretchX || [
                [
                    0,
                    l
                ]
            ], p = o.stretchY || [
                [
                    0,
                    u
                ]
            ], f = (t, e1)=>t + e1[1] - e1[0], d = h.reduce(f, 0), y = p.reduce(f, 0), m = l - d, g = u - y;
            let x = 0, v = d, b = 0, w = y, _ = 0, S = m, A = 0, M = g;
            if (o.content && i) {
                const e1 = o.content, n = e1[2] - e1[0], r = e1[3] - e1[1];
                (o.textFitWidth || o.textFitHeight) && (c = dp(t)), x = Ay(h, 0, e1[0]), b = Ay(p, 0, e1[1]), v = Ay(h, e1[0], e1[2]), w = Ay(p, e1[1], e1[3]), _ = e1[0] - x, A = e1[1] - b, S = n - v, M = r - w;
            }
            const k = c.x1, I = c.y1, E = c.x2 - k, T = c.y2 - I, F = (t, i, s, l)=>{
                const u = ky(t.stretch - x, v, E, k), c = Iy(t.fixed - _, S, t.stretch, d), h = ky(i.stretch - b, w, T, I), p = Iy(i.fixed - A, M, i.stretch, y), f = ky(s.stretch - x, v, E, k), m = Iy(s.fixed - _, S, s.stretch, d), g = ky(l.stretch - b, w, T, I), F = Iy(l.fixed - A, M, l.stretch, y), P = new n(u, h), D = new n(f, h), z = new n(f, g), B = new n(u, g), C = new n(c / a, p / a), V = new n(m / a, F / a), L = e1 * Math.PI / 180;
                if (L) {
                    const t = Math.sin(L), e1 = Math.cos(L), n = [
                        e1,
                        -t,
                        t,
                        e1
                    ];
                    P._matMult(n), D._matMult(n), B._matMult(n), z._matMult(n);
                }
                const O = t.stretch + t.fixed, $ = i.stretch + i.fixed;
                return {
                    tl: P,
                    tr: D,
                    bl: B,
                    br: z,
                    tex: {
                        x: o.paddedRect.x + 1 + O,
                        y: o.paddedRect.y + 1 + $,
                        w: s.stretch + s.fixed - O,
                        h: l.stretch + l.fixed - $
                    },
                    writingMode: void 0,
                    glyphOffset: [
                        0,
                        0
                    ],
                    sectionIndex: 0,
                    pixelOffsetTL: C,
                    pixelOffsetBR: V,
                    minFontScaleX: S / a / E,
                    minFontScaleY: M / a / T,
                    isSDF: r
                };
            };
            if (i && (o.stretchX || o.stretchY)) {
                const t = My(h, m, d), e1 = My(p, g, y);
                for(let n = 0; n < t.length - 1; n++){
                    const r = t[n], i = t[n + 1];
                    for(let t = 0; t < e1.length - 1; t++)s.push(F(r, e1[t], i, e1[t + 1]));
                }
            } else s.push(F({
                fixed: 0,
                stretch: -1
            }, {
                fixed: 0,
                stretch: -1
            }, {
                fixed: 0,
                stretch: l + 1
            }, {
                fixed: 0,
                stretch: u + 1
            }));
            return s;
        }
        function Ay(t, e1, n) {
            let r = 0;
            for (const i of t)r += Math.max(e1, Math.min(n, i[1])) - Math.max(e1, Math.min(n, i[0]));
            return r;
        }
        function My(t, e1, n) {
            const r = [
                {
                    fixed: -1,
                    stretch: 0
                }
            ];
            for (const [e1, n] of t){
                const t = r[r.length - 1];
                r.push({
                    fixed: e1 - t.stretch,
                    stretch: t.stretch
                }), r.push({
                    fixed: e1 - t.stretch,
                    stretch: t.stretch + (n - e1)
                });
            }
            return r.push({
                fixed: e1 + 1,
                stretch: n
            }), r;
        }
        function ky(t, e1, n, r) {
            return t / e1 * n + r;
        }
        function Iy(t, e1, n, r) {
            return t - e1 * n / r;
        }
        ds("Anchor", yy);
        class Ey {
            constructor(t, e1, r, i, s, o, a, l, u, c){
                var h;
                if (this.boxStartIndex = t.length, u) {
                    let t = o.top, e1 = o.bottom;
                    const n = o.collisionPadding;
                    n && (t -= n[1], e1 += n[3]);
                    let r = e1 - t;
                    r > 0 && (r = Math.max(10, r), this.circleDiameter = r);
                } else {
                    const u = (null === (h = o.image) || void 0 === h ? void 0 : h.content) && (o.image.textFitWidth || o.image.textFitHeight) ? dp(o) : {
                        x1: o.left,
                        y1: o.top,
                        x2: o.right,
                        y2: o.bottom
                    };
                    u.y1 = u.y1 * a - l[0], u.y2 = u.y2 * a + l[2], u.x1 = u.x1 * a - l[3], u.x2 = u.x2 * a + l[1];
                    const p = o.collisionPadding;
                    if (p && (u.x1 -= p[0] * a, u.y1 -= p[1] * a, u.x2 += p[2] * a, u.y2 += p[3] * a), c) {
                        const t = new n(u.x1, u.y1), e1 = new n(u.x2, u.y1), r = new n(u.x1, u.y2), i = new n(u.x2, u.y2), s = c * Math.PI / 180;
                        t._rotate(s), e1._rotate(s), r._rotate(s), i._rotate(s), u.x1 = Math.min(t.x, e1.x, r.x, i.x), u.x2 = Math.max(t.x, e1.x, r.x, i.x), u.y1 = Math.min(t.y, e1.y, r.y, i.y), u.y2 = Math.max(t.y, e1.y, r.y, i.y);
                    }
                    t.emplaceBack(e1.x, e1.y, u.x1, u.y1, u.x2, u.y2, r, i, s);
                }
                this.boxEndIndex = t.length;
            }
        }
        class Ty {
            constructor(t = [], e1 = (t, e1)=>t < e1 ? -1 : t > e1 ? 1 : 0){
                if (this.data = t, this.length = this.data.length, this.compare = e1, this.length > 0) for(let t = (this.length >> 1) - 1; t >= 0; t--)this._down(t);
            }
            push(t) {
                this.data.push(t), this._up(this.length++);
            }
            pop() {
                if (0 === this.length) return;
                const t = this.data[0], e1 = this.data.pop();
                return --this.length > 0 && (this.data[0] = e1, this._down(0)), t;
            }
            peek() {
                return this.data[0];
            }
            _up(t) {
                const { data: e1, compare: n } = this, r = e1[t];
                for(; t > 0;){
                    const i = t - 1 >> 1, s = e1[i];
                    if (n(r, s) >= 0) break;
                    e1[t] = s, t = i;
                }
                e1[t] = r;
            }
            _down(t) {
                const { data: e1, compare: n } = this, r = this.length >> 1, i = e1[t];
                for(; t < r;){
                    let r = 1 + (t << 1);
                    const s = r + 1;
                    if (s < this.length && n(e1[s], e1[r]) < 0 && (r = s), n(e1[r], i) >= 0) break;
                    e1[t] = e1[r], t = r;
                }
                e1[t] = i;
            }
        }
        function Fy(t, e1 = 1) {
            const r = tf.fromPoints(t[0]), i = Math.min(r.width(), r.height());
            let s = i / 2;
            const o = new Ty([], Py), { minX: a, minY: l, maxX: u, maxY: c } = r;
            if (0 === i) return new n(a, l);
            for(let e1 = a; e1 < u; e1 += i)for(let n = l; n < c; n += i)o.push(new Dy(e1 + s, n + s, s, t));
            const h = function(t) {
                let e1 = 0, n = 0, r = 0;
                const i = t[0];
                for(let t = 0, s = i.length, o = s - 1; t < s; o = t++){
                    const s = i[t], a = i[o], l = s.x * a.y - a.x * s.y;
                    n += (s.x + a.x) * l, r += (s.y + a.y) * l, e1 += 3 * l;
                }
                return new Dy(n / e1, r / e1, 0, t);
            }(t);
            let p = h;
            for(; o.length;){
                const n = o.pop();
                (n.d > p.d || !p.d) && (p = n), n.max - p.d <= e1 || (s = n.h / 2, o.push(new Dy(n.p.x - s, n.p.y - s, s, t)), o.push(new Dy(n.p.x + s, n.p.y - s, s, t)), o.push(new Dy(n.p.x - s, n.p.y + s, s, t)), o.push(new Dy(n.p.x + s, n.p.y + s, s, t)));
            }
            return h.d > 0 && p.d - h.d <= e1 ? h.p : p.p;
        }
        function Py(t, e1) {
            return e1.max - t.max;
        }
        class Dy {
            constructor(t, e1, r, i){
                this.p = new n(t, e1), this.h = r, this.d = function(t, e1) {
                    let n = !1, r = 1 / 0;
                    for (const i of e1)for(let e1 = 0, s = i.length, o = s - 1; e1 < s; o = e1++){
                        const s = i[e1], a = i[o];
                        s.y > t.y != a.y > t.y && t.x < (a.x - s.x) * (t.y - s.y) / (a.y - s.y) + s.x && (n = !n), r = Math.min(r, nl(t, s, a));
                    }
                    return (n ? 1 : -1) * Math.sqrt(r);
                }(this.p, i), this.max = this.d + this.h * Math.SQRT2;
            }
        }
        var zy;
        t.aM = void 0, (zy = t.aM || (t.aM = {}))[zy.center = 1] = "center", zy[zy.left = 2] = "left", zy[zy.right = 3] = "right", zy[zy.top = 4] = "top", zy[zy.bottom = 5] = "bottom", zy[zy["top-left"] = 6] = "top-left", zy[zy["top-right"] = 7] = "top-right", zy[zy["bottom-left"] = 8] = "bottom-left", zy[zy["bottom-right"] = 9] = "bottom-right";
        const By = Number.POSITIVE_INFINITY;
        function Cy(t, e1) {
            return e1[1] !== By ? function(t, e1, n) {
                let r = 0, i = 0;
                switch(e1 = Math.abs(e1), n = Math.abs(n), t){
                    case "top-right":
                    case "top-left":
                    case "top":
                        i = n - 7;
                        break;
                    case "bottom-right":
                    case "bottom-left":
                    case "bottom":
                        i = 7 - n;
                }
                switch(t){
                    case "top-right":
                    case "bottom-right":
                    case "right":
                        r = -e1;
                        break;
                    case "top-left":
                    case "bottom-left":
                    case "left":
                        r = e1;
                }
                return [
                    r,
                    i
                ];
            }(t, e1[0], e1[1]) : function(t, e1) {
                let n = 0, r = 0;
                e1 < 0 && (e1 = 0);
                const i = e1 / Math.SQRT2;
                switch(t){
                    case "top-right":
                    case "top-left":
                        r = i - 7;
                        break;
                    case "bottom-right":
                    case "bottom-left":
                        r = 7 - i;
                        break;
                    case "bottom":
                        r = 7 - e1;
                        break;
                    case "top":
                        r = e1 - 7;
                }
                switch(t){
                    case "top-right":
                    case "bottom-right":
                        n = -i;
                        break;
                    case "top-left":
                    case "bottom-left":
                        n = i;
                        break;
                    case "left":
                        n = e1;
                        break;
                    case "right":
                        n = -e1;
                }
                return [
                    n,
                    r
                ];
            }(t, e1[0]);
        }
        function Vy(t, e1, n) {
            var r;
            const i = t.layout, s = null === (r = i.get("text-variable-anchor-offset")) || void 0 === r ? void 0 : r.evaluate(e1, {}, n);
            if (s) {
                const t = s.values, e1 = [];
                for(let n = 0; n < t.length; n += 2){
                    const r = e1[n] = t[n], i = t[n + 1].map((t)=>t * Ih);
                    r.startsWith("top") ? i[1] -= 7 : r.startsWith("bottom") && (i[1] += 7), e1[n + 1] = i;
                }
                return new $e(e1);
            }
            const o = i.get("text-variable-anchor");
            if (o) {
                let r;
                r = void 0 !== t._unevaluatedLayout.getValue("text-radial-offset") ? [
                    i.get("text-radial-offset").evaluate(e1, {}, n) * Ih,
                    By
                ] : i.get("text-offset").evaluate(e1, {}, n).map((t)=>t * Ih);
                const s = [];
                for (const t of o)s.push(t, Cy(t, r));
                return new $e(s);
            }
            return null;
        }
        function Ly(t) {
            switch(t){
                case "right":
                case "top-right":
                case "bottom-right":
                    return "right";
                case "left":
                case "top-left":
                case "bottom-left":
                    return "left";
            }
            return "center";
        }
        function Oy(e1, n, r, i, s, o, a, l, u, c, h, p) {
            let f = o.textMaxSize.evaluate(n, {});
            void 0 === f && (f = a);
            const d = e1.layers[0].layout, y = d.get("icon-offset").evaluate(n, {}, h), m = Ry(r.horizontal), g = a / 24, x = e1.tilePixelRatio * g, v = e1.tilePixelRatio * f / 24, b = e1.tilePixelRatio * l, w = e1.tilePixelRatio * d.get("symbol-spacing"), _ = d.get("text-padding") * e1.tilePixelRatio, S = function(t, e1, n, r = 1) {
                const i = t.get("icon-padding").evaluate(e1, {}, n), s = null == i ? void 0 : i.values;
                return [
                    s[0] * r,
                    s[1] * r,
                    s[2] * r,
                    s[3] * r
                ];
            }(d, n, h, e1.tilePixelRatio), A = d.get("text-max-angle") / 180 * Math.PI, M = "viewport" !== d.get("text-rotation-alignment") && "point" !== d.get("symbol-placement"), k = "map" === d.get("icon-rotation-alignment") && "point" !== d.get("symbol-placement"), I = d.get("symbol-placement"), E = w / 2, F = d.get("icon-text-fit");
            let P;
            i && "none" !== F && (e1.allowVerticalPlacement && r.vertical && (P = yp(i, r.vertical, F, d.get("icon-text-fit-padding"), y, g)), m && (i = yp(i, m, F, d.get("icon-text-fit-padding"), y, g)));
            const D = h ? p.line.getGranularityForZoomLevel(h.z) : 1, z = (l, p)=>{
                p.x < 0 || p.x >= T || p.y < 0 || p.y >= T || function(e1, n, r, i, s, o, a, l, u, c, h, p, f, d, y, m, g, x, v, b, w, _, S, A, M) {
                    const k = e1.addToLineVertexArray(n, r);
                    let I, E, T, F, P = 0, D = 0, z = 0, B = 0, C = -1, V = -1;
                    const L = {};
                    let O = ba("");
                    if (e1.allowVerticalPlacement && i.vertical) {
                        const t = l.layout.get("text-rotate").evaluate(w, {}, A) + 90;
                        T = new Ey(u, n, c, h, p, i.vertical, f, d, y, t), a && (F = new Ey(u, n, c, h, p, a, g, x, y, t));
                    }
                    if (s) {
                        const r = l.layout.get("icon-rotate").evaluate(w, {}), i = "none" !== l.layout.get("icon-text-fit"), o = Sy(s, r, S, i), f = a ? Sy(a, r, S, i) : void 0;
                        E = new Ey(u, n, c, h, p, s, g, x, !1, r), P = 4 * o.length;
                        const d = e1.iconSizeData;
                        let y = null;
                        "source" === d.kind ? (y = [
                            mp * l.layout.get("icon-size").evaluate(w, {})
                        ], y[0] > gp && G(`${e1.layerIds[0]}: Value for "icon-size" is >= 255. Reduce your "icon-size".`)) : "composite" === d.kind && (y = [
                            mp * _.compositeIconSizes[0].evaluate(w, {}, A),
                            mp * _.compositeIconSizes[1].evaluate(w, {}, A)
                        ], (y[0] > gp || y[1] > gp) && G(`${e1.layerIds[0]}: Value for "icon-size" is >= 255. Reduce your "icon-size".`)), e1.addSymbols(e1.icon, o, y, b, v, w, t.ax.none, n, k.lineStartIndex, k.lineLength, -1, A), C = e1.icon.placedSymbolArray.length - 1, f && (D = 4 * f.length, e1.addSymbols(e1.icon, f, y, b, v, w, t.ax.vertical, n, k.lineStartIndex, k.lineLength, -1, A), V = e1.icon.placedSymbolArray.length - 1);
                    }
                    const $ = Object.keys(i.horizontal);
                    for (const r of $){
                        const s = i.horizontal[r];
                        if (!I) {
                            O = ba(s.text);
                            const t = l.layout.get("text-rotate").evaluate(w, {}, A);
                            I = new Ey(u, n, c, h, p, s, f, d, y, t);
                        }
                        const a = 1 === s.positionedLines.length;
                        if (z += $y(e1, n, s, o, l, y, w, m, k, i.vertical ? t.ax.horizontal : t.ax.horizontalOnly, a ? $ : [
                            r
                        ], L, C, _, A), a) break;
                    }
                    i.vertical && (B += $y(e1, n, i.vertical, o, l, y, w, m, k, t.ax.vertical, [
                        "vertical"
                    ], L, V, _, A));
                    const R = I ? I.boxStartIndex : e1.collisionBoxArray.length, N = I ? I.boxEndIndex : e1.collisionBoxArray.length, U = T ? T.boxStartIndex : e1.collisionBoxArray.length, j = T ? T.boxEndIndex : e1.collisionBoxArray.length, q = E ? E.boxStartIndex : e1.collisionBoxArray.length, X = E ? E.boxEndIndex : e1.collisionBoxArray.length, Y = F ? F.boxStartIndex : e1.collisionBoxArray.length, Z = F ? F.boxEndIndex : e1.collisionBoxArray.length;
                    let H = -1;
                    const W = (t, e1)=>(null == t ? void 0 : t.circleDiameter) ? Math.max(t.circleDiameter, e1) : e1;
                    H = W(I, H), H = W(T, H), H = W(E, H), H = W(F, H);
                    const K = H > -1 ? 1 : 0;
                    K && (H *= M / Ih), e1.glyphOffsetArray.length >= kp.MAX_GLYPHS && G("Too many glyphs being rendered in a tile. See https://github.com/mapbox/mapbox-gl-js/issues/2907"), void 0 !== w.sortKey && e1.addToSortKeyRanges(e1.symbolInstances.length, w.sortKey);
                    const J = Vy(l, w, A), [Q, tt] = function(e1, n) {
                        const r = e1.length, i = null == n ? void 0 : n.values;
                        if ((null == i ? void 0 : i.length) > 0) for(let n = 0; n < i.length; n += 2){
                            const r = i[n + 1];
                            e1.emplaceBack(t.aM[i[n]], r[0], r[1]);
                        }
                        return [
                            r,
                            e1.length
                        ];
                    }(e1.textAnchorOffsets, J);
                    e1.symbolInstances.emplaceBack(n.x, n.y, L.right >= 0 ? L.right : -1, L.center >= 0 ? L.center : -1, L.left >= 0 ? L.left : -1, L.vertical || -1, C, V, O, R, N, U, j, q, X, Y, Z, c, z, B, P, D, K, 0, f, H, Q, tt);
                }(e1, p, l, r, i, s, P, e1.layers[0], e1.collisionBoxArray, n.index, n.sourceLayerIndex, e1.index, x, [
                    _,
                    _,
                    _,
                    _
                ], M, u, b, S, k, y, n, o, c, h, a);
            };
            if ("line" === I) for (const t of uy(n.geometry, 0, 0, T, T)){
                const n = Su(t, D), s = wy(n, w, A, r.vertical || m, i, 24, v, e1.overscaling, T);
                for (const t of s)m && Ny(e1, m.text, E, t) || z(n, t);
            }
            else if ("line-center" === I) {
                for (const t of n.geometry)if (t.length > 1) {
                    const e1 = Su(t, D), n = by(e1, A, r.vertical || m, i, 24, v);
                    n && z(e1, n);
                }
            } else if ("Polygon" === n.type) for (const t of rr(n.geometry, 0)){
                const e1 = Fy(t, 16);
                z(Su(t[0], D, !0), new yy(e1.x, e1.y, 0));
            }
            else if ("LineString" === n.type) for (const t of n.geometry){
                const e1 = Su(t, D);
                z(e1, new yy(e1[0].x, e1[0].y, 0));
            }
            else if ("Point" === n.type) for (const t of n.geometry)for (const e1 of t)z([
                e1
            ], new yy(e1.x, e1.y, 0));
        }
        function $y(t, e1, r, i, s, o, a, l, u, c, h, p, f, d, y) {
            const m = function(t, e1, r, i, s, o, a, l) {
                const u = i.layout.get("text-rotate").evaluate(o, {}) * Math.PI / 180, c = [];
                for (const t of e1.positionedLines)for (const i of t.positionedGlyphs){
                    if (!i.rect) continue;
                    const o = i.rect || {};
                    let h = 4, p = !0, f = 1, d = 0;
                    const y = (s || l) && i.vertical, m = i.metrics.advance * i.scale / 2;
                    if (l && e1.verticalizable && (d = t.lineOffset / 2 - (i.imageName ? -(Ih - i.metrics.width * i.scale) / 2 : (i.scale - 1) * Ih)), i.imageName) {
                        const t = a[i.imageName];
                        p = t.sdf, f = t.pixelRatio, h = 1 / f;
                    }
                    const g = s ? [
                        i.x + m,
                        i.y
                    ] : [
                        0,
                        0
                    ];
                    let x = s ? [
                        0,
                        0
                    ] : [
                        i.x + m + r[0],
                        i.y + r[1] - d
                    ], v = [
                        0,
                        0
                    ];
                    y && (v = x, x = [
                        0,
                        0
                    ]);
                    const b = i.metrics.isDoubleResolution ? 2 : 1, w = (i.metrics.left - h) * i.scale - m + x[0], _ = (-i.metrics.top - h) * i.scale + x[1], S = w + o.w / b * i.scale / f, A = _ + o.h / b * i.scale / f, M = new n(w, _), k = new n(S, _), I = new n(w, A), E = new n(S, A);
                    if (y) {
                        const t = new n(-m, m - -17), e1 = -Math.PI / 2, r = 12 - m, s = new n(22 - r, -(i.imageName ? r : 0)), o = new n(...v);
                        M._rotateAround(e1, t)._add(s)._add(o), k._rotateAround(e1, t)._add(s)._add(o), I._rotateAround(e1, t)._add(s)._add(o), E._rotateAround(e1, t)._add(s)._add(o);
                    }
                    if (u) {
                        const t = Math.sin(u), e1 = Math.cos(u), n = [
                            e1,
                            -t,
                            t,
                            e1
                        ];
                        M._matMult(n), k._matMult(n), I._matMult(n), E._matMult(n);
                    }
                    const T = new n(0, 0), F = new n(0, 0);
                    c.push({
                        tl: M,
                        tr: k,
                        bl: I,
                        br: E,
                        tex: o,
                        writingMode: e1.writingMode,
                        glyphOffset: g,
                        sectionIndex: i.sectionIndex,
                        isSDF: p,
                        pixelOffsetTL: T,
                        pixelOffsetBR: F,
                        minFontScaleX: 0,
                        minFontScaleY: 0
                    });
                }
                return c;
            }(0, r, l, s, o, a, i, t.allowVerticalPlacement), g = t.textSizeData;
            let x = null;
            "source" === g.kind ? (x = [
                mp * s.layout.get("text-size").evaluate(a, {})
            ], x[0] > gp && G(`${t.layerIds[0]}: Value for "text-size" is >= 255. Reduce your "text-size".`)) : "composite" === g.kind && (x = [
                mp * d.compositeTextSizes[0].evaluate(a, {}, y),
                mp * d.compositeTextSizes[1].evaluate(a, {}, y)
            ], (x[0] > gp || x[1] > gp) && G(`${t.layerIds[0]}: Value for "text-size" is >= 255. Reduce your "text-size".`)), t.addSymbols(t.text, m, x, l, o, a, c, e1, u.lineStartIndex, u.lineLength, f, y);
            for (const e1 of h)p[e1] = t.text.placedSymbolArray.length - 1;
            return 4 * m.length;
        }
        function Ry(t) {
            for(const e1 in t)return t[e1];
            return null;
        }
        function Ny(t, e1, n, r) {
            const i = t.compareText;
            if (e1 in i) {
                const t = i[e1];
                for(let e1 = t.length - 1; e1 >= 0; e1--)if (r.dist(t[e1]) < n) return !0;
            } else i[e1] = [];
            return i[e1].push(r), !1;
        }
        t.$ = at, t.A = f, t.B = Ls, t.C = hs, t.D = Xs, t.E = bt, t.F = os, t.G = function([t, e1, n]) {
            return e1 += 90, e1 *= Math.PI / 180, n *= Math.PI / 180, {
                x: t * Math.cos(e1) * Math.sin(n),
                y: t * Math.sin(e1) * Math.sin(n),
                z: t * Math.cos(n)
            };
        }, t.H = xn, t.I = np, t.J = Cs, t.K = ls, t.L = function(t) {
            if (null == Z) {
                const e1 = t.navigator ? t.navigator.userAgent : null;
                Z = !!t.safari || !(!e1 || !(/\b(iPad|iPhone|iPod)\b/.test(e1) || e1.match("Safari") && !e1.match("Chrome")));
            }
            return Z;
        }, t.M = ht, t.N = class {
            constructor(t, e1){
                this.target = t, this.mapId = e1, this.resolveRejects = {}, this.tasks = {}, this.taskQueue = [], this.abortControllers = {}, this.messageHandlers = {}, this.invoker = new Vp(()=>this.process()), this.subscription = tt(this.target, "message", (t)=>this.receive(t), !1), this.globalScope = Y(self) ? t : window;
            }
            registerMessageHandler(t, e1) {
                this.messageHandlers[t] = e1;
            }
            unregisterMessageHandler(t) {
                delete this.messageHandlers[t];
            }
            sendAsync(t, e1) {
                return new Promise((n, r)=>{
                    const i = Math.round(1e18 * Math.random()).toString(36).substring(0, 10), s = e1 ? tt(e1.signal, "abort", ()=>{
                        null == s || s.unsubscribe(), delete this.resolveRejects[i];
                        const e1 = {
                            id: i,
                            type: "<cancel>",
                            origin: location.origin,
                            targetMapId: t.targetMapId,
                            sourceMapId: this.mapId
                        };
                        this.target.postMessage(e1);
                    }, Lp) : null;
                    this.resolveRejects[i] = {
                        resolve: (t)=>{
                            null == s || s.unsubscribe(), n(t);
                        },
                        reject: (t)=>{
                            null == s || s.unsubscribe(), r(t);
                        }
                    };
                    const o = [], a = Object.assign(Object.assign({}, t), {
                        id: i,
                        sourceMapId: this.mapId,
                        origin: location.origin,
                        data: xs(t.data, o)
                    });
                    this.target.postMessage(a, {
                        transfer: o
                    });
                });
            }
            receive(t) {
                const e1 = t.data, n = e1.id, r = [
                    "file://",
                    "resource://android",
                    "null"
                ], i = [
                    e1.origin,
                    location.origin
                ], s = e1.origin === location.origin, o = i.some((t)=>r.includes(t));
                if ((s || o) && (!e1.targetMapId || this.mapId === e1.targetMapId)) {
                    if ("<cancel>" === e1.type) {
                        delete this.tasks[n];
                        const t = this.abortControllers[n];
                        return delete this.abortControllers[n], void (t && t.abort());
                    }
                    if (Y(self) || e1.mustQueue) return this.tasks[n] = e1, this.taskQueue.push(n), void this.invoker.trigger();
                    this.processTask(n, e1);
                }
            }
            process() {
                if (0 === this.taskQueue.length) return;
                const t = this.taskQueue.shift(), e1 = this.tasks[t];
                delete this.tasks[t], this.taskQueue.length > 0 && this.invoker.trigger(), e1 && this.processTask(t, e1);
            }
            processTask(t, n) {
                return e1(this, void 0, void 0, function*() {
                    if ("<response>" === n.type) {
                        const e1 = this.resolveRejects[t];
                        if (delete this.resolveRejects[t], !e1) return;
                        return void (n.error ? e1.reject(P(vs(n.error))) : e1.resolve(vs(n.data)));
                    }
                    if (!this.messageHandlers[n.type]) return void this.completeTask(t, new Error(`Could not find a registered handler for ${n.type}, map ID: ${this.mapId}, available handlers: ${Object.keys(this.messageHandlers).join(", ")}`));
                    const e1 = vs(n.data), r = new AbortController;
                    this.abortControllers[t] = r;
                    try {
                        const i = yield this.messageHandlers[n.type](n.sourceMapId, e1, r);
                        this.completeTask(t, null, i);
                    } catch (e1) {
                        this.completeTask(t, P(e1));
                    }
                });
            }
            completeTask(t, e1, n) {
                const r = [];
                delete this.abortControllers[t];
                const i = {
                    id: t,
                    type: "<response>",
                    sourceMapId: this.mapId,
                    origin: location.origin,
                    error: e1 ? xs(e1) : null,
                    data: xs(n, r)
                };
                this.target.postMessage(i, {
                    transfer: r
                });
            }
            remove() {
                this.invoker.remove(), this.subscription.unsubscribe();
            }
        }, t.O = function() {
            var t = new f(16);
            return f != Float32Array && (t[1] = 0, t[2] = 0, t[3] = 0, t[4] = 0, t[6] = 0, t[7] = 0, t[8] = 0, t[9] = 0, t[11] = 0, t[12] = 0, t[13] = 0, t[14] = 0), t[0] = 1, t[5] = 1, t[10] = 1, t[15] = 1, t;
        }, t.P = n, t.Q = function(t, e1, n) {
            var r, i, s, o, a, l, u, c, h, p, f, d, y = n[0], m = n[1], g = n[2];
            return e1 === t ? (t[12] = e1[0] * y + e1[4] * m + e1[8] * g + e1[12], t[13] = e1[1] * y + e1[5] * m + e1[9] * g + e1[13], t[14] = e1[2] * y + e1[6] * m + e1[10] * g + e1[14], t[15] = e1[3] * y + e1[7] * m + e1[11] * g + e1[15]) : (i = e1[1], s = e1[2], o = e1[3], a = e1[4], l = e1[5], u = e1[6], c = e1[7], h = e1[8], p = e1[9], f = e1[10], d = e1[11], t[0] = r = e1[0], t[1] = i, t[2] = s, t[3] = o, t[4] = a, t[5] = l, t[6] = u, t[7] = c, t[8] = h, t[9] = p, t[10] = f, t[11] = d, t[12] = r * y + a * m + h * g + e1[12], t[13] = i * y + l * m + p * g + e1[13], t[14] = s * y + u * m + f * g + e1[14], t[15] = o * y + c * m + d * g + e1[15]), t;
        }, t.R = Il, t.S = function(t, e1, n) {
            var r = n[0], i = n[1], s = n[2];
            return t[0] = e1[0] * r, t[1] = e1[1] * r, t[2] = e1[2] * r, t[3] = e1[3] * r, t[4] = e1[4] * i, t[5] = e1[5] * i, t[6] = e1[6] * i, t[7] = e1[7] * i, t[8] = e1[8] * s, t[9] = e1[9] * s, t[10] = e1[10] * s, t[11] = e1[11] * s, t[12] = e1[12], t[13] = e1[13], t[14] = e1[14], t[15] = e1[15], t;
        }, t.T = Ol, t.U = function(t, e1, n) {
            var r = e1[0], i = e1[1], s = e1[2], o = e1[3], a = e1[4], l = e1[5], u = e1[6], c = e1[7], h = e1[8], p = e1[9], f = e1[10], d = e1[11], y = e1[12], m = e1[13], g = e1[14], x = e1[15], v = n[0], b = n[1], w = n[2], _ = n[3];
            return t[0] = v * r + b * a + w * h + _ * y, t[1] = v * i + b * l + w * p + _ * m, t[2] = v * s + b * u + w * f + _ * g, t[3] = v * o + b * c + w * d + _ * x, t[4] = (v = n[4]) * r + (b = n[5]) * a + (w = n[6]) * h + (_ = n[7]) * y, t[5] = v * i + b * l + w * p + _ * m, t[6] = v * s + b * u + w * f + _ * g, t[7] = v * o + b * c + w * d + _ * x, t[8] = (v = n[8]) * r + (b = n[9]) * a + (w = n[10]) * h + (_ = n[11]) * y, t[9] = v * i + b * l + w * p + _ * m, t[10] = v * s + b * u + w * f + _ * g, t[11] = v * o + b * c + w * d + _ * x, t[12] = (v = n[12]) * r + (b = n[13]) * a + (w = n[14]) * h + (_ = n[15]) * y, t[13] = v * i + b * l + w * p + _ * m, t[14] = v * s + b * u + w * f + _ * g, t[15] = v * o + b * c + w * d + _ * x, t;
        }, t.V = function(t, e1) {
            const n = {};
            for (const r of e1)r in t && (n[r] = t[r]);
            return n;
        }, t.W = $p, t.X = O, t.Y = jp, t.Z = Up, t._ = e1, t.a = ot, t.a$ = function(t) {
            var e1 = new f(3);
            return e1[0] = t[0], e1[1] = t[1], e1[2] = t[2], e1;
        }, t.a0 = c, t.a1 = h, t.a2 = K, t.a3 = Jp, t.a4 = Gp, t.a5 = Xp, t.a6 = T, t.a7 = Zp, t.a8 = tf, t.a9 = 25, t.aA = function(t) {
            var e1 = t[0], n = t[1];
            return Math.sqrt(e1 * e1 + n * n);
        }, t.aB = function(t) {
            return t[0] = 0, t[1] = 0, t;
        }, t.aC = function(t, e1, n) {
            return t[0] = e1[0] * n, t[1] = e1[1] * n, t;
        }, t.aD = _p, t.aE = A, t.aF = function(t, e1, r, i) {
            const s = e1.y - t.y, o = e1.x - t.x, a = i.y - r.y, l = i.x - r.x, u = a * o - l * s;
            if (0 === u) return null;
            const c = (l * (t.y - r.y) - a * (t.x - r.x)) / u;
            return new n(t.x + c * o, t.y + c * s);
        }, t.aG = uy, t.aH = Ha, t.aI = function(t) {
            let e1 = 1 / 0, n = 1 / 0, r = -1 / 0, i = -1 / 0;
            for (const s of t)e1 = Math.min(e1, s.x), n = Math.min(n, s.y), r = Math.max(r, s.x), i = Math.max(i, s.y);
            return [
                e1,
                n,
                r,
                i
            ];
        }, t.aJ = Ih, t.aK = F, t.aL = function(t, e1, n, r, i = !1) {
            if (!n[0] && !n[1]) return [
                0,
                0
            ];
            const s = i ? "map" === r ? -t.bearingInRadians : 0 : "viewport" === r ? t.bearingInRadians : 0;
            if (s) {
                const t = Math.sin(s), e1 = Math.cos(s);
                n = [
                    n[0] * e1 - n[1] * t,
                    n[0] * t + n[1] * e1
                ];
            }
            return [
                i ? n[0] : F(e1, n[0], t.zoom),
                i ? n[1] : F(e1, n[1], t.zoom)
            ];
        }, t.aN = vp, t.aO = Ly, t.aP = op, t.aQ = (t)=>"symbol" === t.type, t.aR = ec, t.aS = ao, t.aT = xu, t.aU = Xo, t.aV = ua, t.aW = sa, t.aX = nt, t.aY = Yp, t.aZ = b, t.a_ = v, t.aa = Wp, t.ab = (t)=>{
            const e1 = window.document.createElement("video");
            return e1.muted = !0, new Promise((n)=>{
                e1.onloadstart = ()=>{
                    n(e1);
                };
                for (const n of t){
                    const t = window.document.createElement("source");
                    yt(n) || (e1.crossOrigin = "Anonymous"), t.src = n, e1.appendChild(t);
                }
            });
        }, t.ac = zt, t.ad = function() {
            return R++;
        }, t.ae = Co, t.af = kp, t.ag = Jd, t.ah = yi, t.ai = Ga, t.aj = nf, t.ak = function(t) {
            const e1 = {};
            if (t.replace(/(?:^|(?:\s*\,\s*))([^\x00-\x20\(\)<>@\,;\:\\"\/\[\]\?\=\{\}\x7F]+)(?:\=(?:([^\x00-\x20\(\)<>@\,;\:\\"\/\[\]\?\=\{\}\x7F]+)|(?:\"((?:[^"\\]|\\.)*)\")))?/g, (t, n, r, i)=>{
                const s = r || i;
                return e1[n] = !s || s.toLowerCase(), "";
            }), e1["max-age"]) {
                const t = parseInt(e1["max-age"], 10);
                isNaN(t) ? delete e1["max-age"] : e1["max-age"] = t;
            }
            return e1;
        }, t.al = L, t.am = 85.051129, t.an = et, t.ao = function(t) {
            return Math.pow(2, t);
        }, t.ap = y, t.aq = qp, t.ar = function(t) {
            return Math.log(t) / Math.LN2;
        }, t.as = function(t) {
            var e1 = t[0], n = t[1];
            return e1 * e1 + n * n;
        }, t.at = function(t) {
            if (!t.length) return new Set;
            const e1 = Math.max(...t.map((t)=>t.canonical.z));
            let n = 1 / 0, r = -1 / 0, i = 1 / 0, s = -1 / 0;
            const o = [];
            for (const a of t){
                const { x: t, y: l, z: u } = a.canonical, c = Math.pow(2, e1 - u), h = t * c, p = l * c;
                o.push({
                    id: a,
                    x: h,
                    y: p
                }), h < n && (n = h), h > r && (r = h), p < i && (i = p), p > s && (s = p);
            }
            const a = new Set;
            for (const t of o)t.x !== n && t.x !== r && t.y !== i && t.y !== s || a.add(t.id);
            return a;
        }, t.au = function(t, e1) {
            const n = Math.abs(2 * t.wrap) - +(t.wrap < 0), r = Math.abs(2 * e1.wrap) - +(e1.wrap < 0);
            return t.overscaledZ - e1.overscaledZ || r - n || e1.canonical.y - t.canonical.y || e1.canonical.x - t.canonical.x;
        }, t.av = class {
            constructor(t, e1){
                this.max = t, this.onRemove = e1, this.reset();
            }
            reset() {
                for(const t in this.data)for (const e1 of this.data[t])e1.timeout && clearTimeout(e1.timeout), this.onRemove(e1.value);
                return this.data = {}, this.order = [], this;
            }
            add(t, e1, n) {
                const r = t.wrapped().key;
                void 0 === this.data[r] && (this.data[r] = []);
                const i = {
                    value: e1,
                    timeout: void 0
                };
                if (void 0 !== n && (i.timeout = setTimeout(()=>{
                    this.remove(t, i);
                }, n)), this.data[r].push(i), this.order.push(r), this.order.length > this.max) {
                    const t = this._getAndRemoveByKey(this.order[0]);
                    t && this.onRemove(t);
                }
                return this;
            }
            has(t) {
                return t.wrapped().key in this.data;
            }
            getAndRemove(t) {
                return this.has(t) ? this._getAndRemoveByKey(t.wrapped().key) : null;
            }
            _getAndRemoveByKey(t) {
                const e1 = this.data[t].shift();
                return e1.timeout && clearTimeout(e1.timeout), 0 === this.data[t].length && delete this.data[t], this.order.splice(this.order.indexOf(t), 1), e1.value;
            }
            getByKey(t) {
                const e1 = this.data[t];
                return e1 ? e1[0].value : null;
            }
            get(t) {
                return this.has(t) ? this.data[t.wrapped().key][0].value : null;
            }
            remove(t, e1) {
                if (!this.has(t)) return this;
                const n = t.wrapped().key, r = void 0 === e1 ? 0 : this.data[n].indexOf(e1), i = this.data[n][r];
                return this.data[n].splice(r, 1), i.timeout && clearTimeout(i.timeout), 0 === this.data[n].length && delete this.data[n], this.onRemove(i.value), this.order.splice(this.order.indexOf(n), 1), this;
            }
            setMaxSize(t) {
                for(this.max = t; this.order.length > this.max;){
                    const t = this._getAndRemoveByKey(this.order[0]);
                    t && this.onRemove(t);
                }
                return this;
            }
            filter(t) {
                const e1 = [];
                for(const n in this.data)for (const r of this.data[n])t(r.value) || e1.push(r);
                for (const t of e1)this.remove(t.value.tileID, t);
            }
        }, t.aw = function(t, e1) {
            let n = 0, r = 0;
            if ("constant" === t.kind) r = t.layoutSize;
            else if ("source" !== t.kind) {
                const { interpolationType: i, minZoom: s, maxZoom: o } = t, a = i ? L(mn.interpolationFactor(i, e1, s, o), 0, 1) : 0;
                "camera" === t.kind ? r = xn.number(t.minSize, t.maxSize, a) : n = a;
            }
            return {
                uSizeT: n,
                uSize: r
            };
        }, t.ay = function(t, { uSize: e1, uSizeT: n }, { lowerSize: r, upperSize: i }) {
            return "source" === t.kind ? r / mp : "composite" === t.kind ? xn.number(r / mp, i / mp, n) : e1;
        }, t.az = I, t.b = H, t.b$ = Ea, t.b0 = function(t, e1, n) {
            return t[0] = e1[0] - n[0], t[1] = e1[1] - n[1], t[2] = e1[2] - n[2], t;
        }, t.b1 = function(t, e1) {
            var n = e1[0], r = e1[1], i = e1[2], s = n * n + r * r + i * i;
            return s > 0 && (s = 1 / Math.sqrt(s)), t[0] = e1[0] * s, t[1] = e1[1] * s, t[2] = e1[2] * s, t;
        }, t.b2 = w, t.b3 = function(t, e1) {
            return t[0] * e1[0] + t[1] * e1[1] + t[2] * e1[2];
        }, t.b4 = function(t, e1, n) {
            return t[0] = e1[0] * n[0], t[1] = e1[1] * n[1], t[2] = e1[2] * n[2], t[3] = e1[3] * n[3], t;
        }, t.b5 = g, t.b6 = function(t, e1, n) {
            const r = e1[0] * n[0] + e1[1] * n[1] + e1[2] * n[2];
            return 0 === r ? null : (-(t[0] * n[0] + t[1] * n[1] + t[2] * n[2]) - n[3]) / r;
        }, t.b7 = S, t.b8 = function(t, e1, n) {
            return t[0] = e1[0] * n, t[1] = e1[1] * n, t[2] = e1[2] * n, t[3] = e1[3] * n, t;
        }, t.b9 = function(t, e1) {
            return t[0] * e1[0] + t[1] * e1[1] + t[2] * e1[2] + t[3];
        }, t.bA = k, t.bB = function(t, e1, n) {
            var r = n[0], i = n[1], s = n[2], o = n[3], a = e1[0], l = e1[1], u = e1[2], c = i * u - s * l, h = s * a - r * u, p = r * l - i * a;
            return t[0] = a + o * (c += c) + i * (p += p) - s * (h += h), t[1] = l + o * h + s * c - r * p, t[2] = u + o * p + r * h - i * c, t;
        }, t.bC = function(t, e1, n) {
            const r = (i = [
                t[0],
                t[1],
                t[2],
                e1[0],
                e1[1],
                e1[2],
                n[0],
                n[1],
                n[2]
            ])[0] * ((c = i[8]) * (o = i[4]) - (a = i[5]) * (u = i[7])) + i[1] * (-c * (s = i[3]) + a * (l = i[6])) + i[2] * (u * s - o * l);
            var i, s, o, a, l, u, c;
            if (0 === r) return null;
            const h = w([], [
                e1[0],
                e1[1],
                e1[2]
            ], [
                n[0],
                n[1],
                n[2]
            ]), p = w([], [
                n[0],
                n[1],
                n[2]
            ], [
                t[0],
                t[1],
                t[2]
            ]), f = w([], [
                t[0],
                t[1],
                t[2]
            ], [
                e1[0],
                e1[1],
                e1[2]
            ]), d = b([], h, -t[3]);
            return v(d, d, b([], p, -e1[3])), v(d, d, b([], f, -n[3])), b(d, d, 1 / r), d;
        }, t.bD = Op, t.bE = function() {
            return new Float64Array(4);
        }, t.bF = function(t, e1, n, r) {
            var i = [], s = [];
            return i[0] = e1[0] - n[0], i[1] = e1[1] - n[1], i[2] = e1[2] - n[2], s[0] = i[0] * Math.cos(r) - i[1] * Math.sin(r), s[1] = i[0] * Math.sin(r) + i[1] * Math.cos(r), s[2] = i[2], t[0] = s[0] + n[0], t[1] = s[1] + n[1], t[2] = s[2] + n[2], t;
        }, t.bG = function(t, e1, n, r) {
            var i = [], s = [];
            return i[0] = e1[0] - n[0], i[1] = e1[1] - n[1], i[2] = e1[2] - n[2], s[0] = i[0], s[1] = i[1] * Math.cos(r) - i[2] * Math.sin(r), s[2] = i[1] * Math.sin(r) + i[2] * Math.cos(r), t[0] = s[0] + n[0], t[1] = s[1] + n[1], t[2] = s[2] + n[2], t;
        }, t.bH = function(t, e1, n, r) {
            var i = [], s = [];
            return i[0] = e1[0] - n[0], i[1] = e1[1] - n[1], i[2] = e1[2] - n[2], s[0] = i[2] * Math.sin(r) + i[0] * Math.cos(r), s[1] = i[1], s[2] = i[2] * Math.cos(r) - i[0] * Math.sin(r), t[0] = s[0] + n[0], t[1] = s[1] + n[1], t[2] = s[2] + n[2], t;
        }, t.bI = function(t, e1, n) {
            var r = Math.sin(n), i = Math.cos(n), s = e1[0], o = e1[1], a = e1[2], l = e1[3], u = e1[8], c = e1[9], h = e1[10], p = e1[11];
            return e1 !== t && (t[4] = e1[4], t[5] = e1[5], t[6] = e1[6], t[7] = e1[7], t[12] = e1[12], t[13] = e1[13], t[14] = e1[14], t[15] = e1[15]), t[0] = s * i - u * r, t[1] = o * i - c * r, t[2] = a * i - h * r, t[3] = l * i - p * r, t[8] = s * r + u * i, t[9] = o * r + c * i, t[10] = a * r + h * i, t[11] = l * r + p * i, t;
        }, t.bJ = function(t, e1) {
            const n = D(t, 360), r = D(e1, 360), i = r - n, s = r > n ? i - 360 : i + 360;
            return Math.abs(i) < Math.abs(s) ? i : s;
        }, t.bK = function(t) {
            return t[0] = 0, t[1] = 0, t[2] = 0, t;
        }, t.bL = function(t, e1, n, r) {
            const i = Math.sqrt(t * t + e1 * e1), s = Math.sqrt(n * n + r * r);
            t /= i, e1 /= i, n /= s, r /= s;
            const o = Math.acos(t * n + e1 * r);
            return -e1 * n + t * r > 0 ? o : -o;
        }, t.bM = function(t, e1) {
            const n = D(t, 2 * Math.PI), r = D(e1, 2 * Math.PI);
            return Math.min(Math.abs(n - r), Math.abs(n - r + 2 * Math.PI), Math.abs(n - r - 2 * Math.PI));
        }, t.bN = function() {
            const t = {}, e1 = wt.$version;
            for(const n in wt.$root){
                const r = wt.$root[n];
                if (r.required) {
                    let i = null;
                    i = "version" === n ? e1 : "array" === r.type ? [] : {}, null != i && (t[n] = i);
                }
            }
            return t;
        }, t.bO = ft, t.bP = bs, t.bQ = function t(e1, n) {
            if (Array.isArray(e1)) {
                if (!Array.isArray(n) || e1.length !== n.length) return !1;
                for(let r = 0; r < e1.length; r++)if (!t(e1[r], n[r])) return !1;
                return !0;
            }
            if ("object" == typeof e1 && null !== e1 && null !== n) {
                if ("object" != typeof n) return !1;
                if (Object.keys(e1).length !== Object.keys(n).length) return !1;
                for(const r in e1)if (!t(e1[r], n[r])) return !1;
                return !0;
            }
            return e1 === n;
        }, t.bR = lt, t.bS = function(t) {
            t = t.slice();
            const e1 = Object.create(null);
            for(let n = 0; n < t.length; n++)e1[t[n].id] = t[n];
            for(let n = 0; n < t.length; n++)"ref" in t[n] && (t[n] = St(t[n], e1[t[n].ref]));
            return t;
        }, t.bT = function(t, e1) {
            if ("custom" === t.type) return new Cp(t, e1);
            switch(t.type){
                case "background":
                    return new Bp(t, e1);
                case "circle":
                    return new vl(t, e1);
                case "color-relief":
                    return new Nl(t, e1);
                case "fill":
                    return new Pu(t, e1);
                case "fill-extrusion":
                    return new Ku(t, e1);
                case "heatmap":
                    return new Pl(t, e1);
                case "hillshade":
                    return new Bl(t, e1);
                case "line":
                    return new xh(t, e1);
                case "raster":
                    return new ro(t, e1);
                case "symbol":
                    return new Pp(t, e1);
            }
        }, t.bU = (t)=>"raster" === t.type, t.bV = j, t.bW = function(t, e1) {
            if (!t) return [
                {
                    command: "setStyle",
                    args: [
                        e1
                    ]
                }
            ];
            let n = [];
            try {
                if (!At(t.version, e1.version)) return [
                    {
                        command: "setStyle",
                        args: [
                            e1
                        ]
                    }
                ];
                At(t.center, e1.center) || n.push({
                    command: "setCenter",
                    args: [
                        e1.center
                    ]
                }), At(t.state, e1.state) || n.push({
                    command: "setGlobalState",
                    args: [
                        e1.state
                    ]
                }), At(t.centerAltitude, e1.centerAltitude) || n.push({
                    command: "setCenterAltitude",
                    args: [
                        e1.centerAltitude
                    ]
                }), At(t.zoom, e1.zoom) || n.push({
                    command: "setZoom",
                    args: [
                        e1.zoom
                    ]
                }), At(t.bearing, e1.bearing) || n.push({
                    command: "setBearing",
                    args: [
                        e1.bearing
                    ]
                }), At(t.pitch, e1.pitch) || n.push({
                    command: "setPitch",
                    args: [
                        e1.pitch
                    ]
                }), At(t.roll, e1.roll) || n.push({
                    command: "setRoll",
                    args: [
                        e1.roll
                    ]
                }), At(t.sprite, e1.sprite) || n.push({
                    command: "setSprite",
                    args: [
                        e1.sprite
                    ]
                }), At(t.glyphs, e1.glyphs) || n.push({
                    command: "setGlyphs",
                    args: [
                        e1.glyphs
                    ]
                }), At(t.transition, e1.transition) || n.push({
                    command: "setTransition",
                    args: [
                        e1.transition
                    ]
                }), At(t.light, e1.light) || n.push({
                    command: "setLight",
                    args: [
                        e1.light
                    ]
                }), At(t.terrain, e1.terrain) || n.push({
                    command: "setTerrain",
                    args: [
                        e1.terrain
                    ]
                }), At(t.sky, e1.sky) || n.push({
                    command: "setSky",
                    args: [
                        e1.sky
                    ]
                }), At(t.projection, e1.projection) || n.push({
                    command: "setProjection",
                    args: [
                        e1.projection
                    ]
                });
                const r = {}, i = [];
                !function(t, e1, n, r) {
                    let i;
                    for(i in e1 = e1 || {}, t = t || {})Object.prototype.hasOwnProperty.call(t, i) && (Object.prototype.hasOwnProperty.call(e1, i) || It(i, n, r));
                    for(i in e1)Object.prototype.hasOwnProperty.call(e1, i) && (Object.prototype.hasOwnProperty.call(t, i) ? At(t[i], e1[i]) || ("geojson" === t[i].type && "geojson" === e1[i].type && Tt(t, e1, i) ? Mt(n, {
                        command: "setGeoJSONSourceData",
                        args: [
                            i,
                            e1[i].data
                        ]
                    }) : Et(i, e1, n, r)) : kt(i, e1, n));
                }(t.sources, e1.sources, i, r);
                const s = [];
                t.layers && t.layers.forEach((t)=>{
                    "source" in t && r[t.source] ? n.push({
                        command: "removeLayer",
                        args: [
                            t.id
                        ]
                    }) : s.push(t);
                }), n = n.concat(i), function(t, e1, n) {
                    e1 = e1 || [];
                    const r = (t = t || []).map(Pt), i = e1.map(Pt), s = t.reduce(Dt, {}), o = e1.reduce(Dt, {}), a = r.slice(), l = Object.create(null);
                    let u, c, h, p, f;
                    for(let t = 0, e1 = 0; t < r.length; t++)u = r[t], Object.prototype.hasOwnProperty.call(o, u) ? e1++ : (Mt(n, {
                        command: "removeLayer",
                        args: [
                            u
                        ]
                    }), a.splice(a.indexOf(u, e1), 1));
                    for(let t = 0, e1 = 0; t < i.length; t++)u = i[i.length - 1 - t], a[a.length - 1 - t] !== u && (Object.prototype.hasOwnProperty.call(s, u) ? (Mt(n, {
                        command: "removeLayer",
                        args: [
                            u
                        ]
                    }), a.splice(a.lastIndexOf(u, a.length - e1), 1)) : e1++, p = a[a.length - t], Mt(n, {
                        command: "addLayer",
                        args: [
                            o[u],
                            p
                        ]
                    }), a.splice(a.length - t, 0, u), l[u] = !0);
                    for(let t = 0; t < i.length; t++)if (u = i[t], c = s[u], h = o[u], !l[u] && !At(c, h)) {
                        if (At(c.source, h.source) && At(c["source-layer"], h["source-layer"]) && At(c.type, h.type)) {
                            for(f in Ft(c.layout, h.layout, n, u, null, "setLayoutProperty"), Ft(c.paint, h.paint, n, u, null, "setPaintProperty"), At(c.filter, h.filter) || Mt(n, {
                                command: "setFilter",
                                args: [
                                    u,
                                    h.filter
                                ]
                            }), At(c.minzoom, h.minzoom) && At(c.maxzoom, h.maxzoom) || Mt(n, {
                                command: "setLayerZoomRange",
                                args: [
                                    u,
                                    h.minzoom,
                                    h.maxzoom
                                ]
                            }), c)Object.prototype.hasOwnProperty.call(c, f) && "layout" !== f && "paint" !== f && "filter" !== f && "metadata" !== f && "minzoom" !== f && "maxzoom" !== f && (0 === f.indexOf("paint.") ? Ft(c[f], h[f], n, u, f.slice(6), "setPaintProperty") : At(c[f], h[f]) || Mt(n, {
                                command: "setLayerProperty",
                                args: [
                                    u,
                                    f,
                                    h[f]
                                ]
                            }));
                            for(f in h)Object.prototype.hasOwnProperty.call(h, f) && !Object.prototype.hasOwnProperty.call(c, f) && "layout" !== f && "paint" !== f && "filter" !== f && "metadata" !== f && "minzoom" !== f && "maxzoom" !== f && (0 === f.indexOf("paint.") ? Ft(c[f], h[f], n, u, f.slice(6), "setPaintProperty") : At(c[f], h[f]) || Mt(n, {
                                command: "setLayerProperty",
                                args: [
                                    u,
                                    f,
                                    h[f]
                                ]
                            }));
                        } else Mt(n, {
                            command: "removeLayer",
                            args: [
                                u
                            ]
                        }), p = a[a.lastIndexOf(u) + 1], Mt(n, {
                            command: "addLayer",
                            args: [
                                h,
                                p
                            ]
                        });
                    }
                }(s, e1.layers, n);
            } catch (t) {
                console.warn("Unable to compute style diff:", t), n = [
                    {
                        command: "setStyle",
                        args: [
                            e1
                        ]
                    }
                ];
            }
            return n;
        }, t.bX = function(t) {
            const e1 = [], n = t.id;
            return void 0 === n && e1.push({
                message: `layers.${n}: missing required property "id"`
            }), void 0 === t.render && e1.push({
                message: `layers.${n}: missing required method "render"`
            }), t.renderingMode && "2d" !== t.renderingMode && "3d" !== t.renderingMode && e1.push({
                message: `layers.${n}: property "renderingMode" must be either "2d" or "3d"`
            }), e1;
        }, t.bY = N, t.bZ = U, t.b_ = class extends Ma {
            constructor(t, e1){
                super(t, e1), this.current = 0;
            }
            set(t) {
                this.current !== t && (this.current = t, this.gl.uniform1i(this.location, t));
            }
        }, t.ba = Kp, t.bb = Qp, t.bc = function(t, e1, n, r, i) {
            var s = 1 / Math.tan(e1 / 2);
            if (t[0] = s / n, t[1] = 0, t[2] = 0, t[3] = 0, t[4] = 0, t[5] = s, t[6] = 0, t[7] = 0, t[8] = 0, t[9] = 0, t[11] = -1, t[12] = 0, t[13] = 0, t[15] = 0, null != i && i !== 1 / 0) {
                var o = 1 / (r - i);
                t[10] = (i + r) * o, t[14] = 2 * i * r * o;
            } else t[10] = -1, t[14] = -2 * r;
            return t;
        }, t.bd = function(t) {
            var e1 = new f(16);
            return e1[0] = t[0], e1[1] = t[1], e1[2] = t[2], e1[3] = t[3], e1[4] = t[4], e1[5] = t[5], e1[6] = t[6], e1[7] = t[7], e1[8] = t[8], e1[9] = t[9], e1[10] = t[10], e1[11] = t[11], e1[12] = t[12], e1[13] = t[13], e1[14] = t[14], e1[15] = t[15], e1;
        }, t.be = function(t, e1, n) {
            var r = Math.sin(n), i = Math.cos(n), s = e1[0], o = e1[1], a = e1[2], l = e1[3], u = e1[4], c = e1[5], h = e1[6], p = e1[7];
            return e1 !== t && (t[8] = e1[8], t[9] = e1[9], t[10] = e1[10], t[11] = e1[11], t[12] = e1[12], t[13] = e1[13], t[14] = e1[14], t[15] = e1[15]), t[0] = s * i + u * r, t[1] = o * i + c * r, t[2] = a * i + h * r, t[3] = l * i + p * r, t[4] = u * i - s * r, t[5] = c * i - o * r, t[6] = h * i - a * r, t[7] = p * i - l * r, t;
        }, t.bf = function(t, e1, n) {
            var r = Math.sin(n), i = Math.cos(n), s = e1[4], o = e1[5], a = e1[6], l = e1[7], u = e1[8], c = e1[9], h = e1[10], p = e1[11];
            return e1 !== t && (t[0] = e1[0], t[1] = e1[1], t[2] = e1[2], t[3] = e1[3], t[12] = e1[12], t[13] = e1[13], t[14] = e1[14], t[15] = e1[15]), t[4] = s * i + u * r, t[5] = o * i + c * r, t[6] = a * i + h * r, t[7] = l * i + p * r, t[8] = u * i - s * r, t[9] = c * i - o * r, t[10] = h * i - a * r, t[11] = p * i - l * r, t;
        }, t.bg = function(t, e1) {
            var n = e1[0], r = e1[1], i = e1[2], s = e1[3], o = e1[4], a = e1[5], l = e1[6], u = e1[7], c = e1[8], h = e1[9], p = e1[10], f = e1[11], d = e1[12], y = e1[13], m = e1[14], g = e1[15], x = n * a - r * o, v = n * l - i * o, b = n * u - s * o, w = r * l - i * a, _ = r * u - s * a, S = i * u - s * l, A = c * y - h * d, M = c * m - p * d, k = c * g - f * d, I = h * m - p * y, E = h * g - f * y, T = p * g - f * m, F = x * T - v * E + b * I + w * k - _ * M + S * A;
            return F ? (t[0] = (a * T - l * E + u * I) * (F = 1 / F), t[1] = (i * E - r * T - s * I) * F, t[2] = (y * S - m * _ + g * w) * F, t[3] = (p * _ - h * S - f * w) * F, t[4] = (l * k - o * T - u * M) * F, t[5] = (n * T - i * k + s * M) * F, t[6] = (m * b - d * S - g * v) * F, t[7] = (c * S - p * b + f * v) * F, t[8] = (o * E - a * k + u * A) * F, t[9] = (r * k - n * E - s * A) * F, t[10] = (d * _ - y * b + g * x) * F, t[11] = (h * b - c * _ - f * x) * F, t[12] = (a * M - o * I - l * A) * F, t[13] = (n * I - r * M + i * A) * F, t[14] = (y * v - d * w - m * x) * F, t[15] = (c * w - h * v + p * x) * F, t) : null;
        }, t.bh = function() {
            const t = new Float32Array(16);
            return y(t), t;
        }, t.bi = function() {
            const t = new Float64Array(16);
            return y(t), t;
        }, t.bj = function() {
            return new Float64Array(16);
        }, t.bk = function(t, e1, n) {
            const r = new Float64Array(4);
            return k(r, t, e1 - 90, n), r;
        }, t.bl = function(t, e1, n, r) {
            var i, s, o, a, l, u = e1[0], c = e1[1], h = e1[2], f = e1[3], d = n[0], y = n[1], m = n[2], g = n[3];
            return (s = u * d + c * y + h * m + f * g) < 0 && (s = -s, d = -d, y = -y, m = -m, g = -g), 1 - s > p ? (i = Math.acos(s), o = Math.sin(i), a = Math.sin((1 - r) * i) / o, l = Math.sin(r * i) / o) : (a = 1 - r, l = r), t[0] = a * u + l * d, t[1] = a * c + l * y, t[2] = a * h + l * m, t[3] = a * f + l * g, t;
        }, t.bm = function(t) {
            const e1 = new Float64Array(9);
            var n, r, i, s, o, a, l, u, c, h, p, f, d, y, m, g, x, v;
            h = (i = (r = t)[0]) * (l = i + i), p = (s = r[1]) * l, d = (o = r[2]) * l, y = o * (u = s + s), g = (a = r[3]) * l, x = a * u, v = a * (c = o + o), (n = e1)[0] = 1 - (f = s * u) - (m = o * c), n[3] = p - v, n[6] = d + x, n[1] = p + v, n[4] = 1 - h - m, n[7] = y - g, n[2] = d - x, n[5] = y + g, n[8] = 1 - h - f;
            const b = nt(-Math.asin(L(e1[2], -1, 1)));
            let w, _;
            return Math.hypot(e1[5], e1[8]) < .001 ? (w = 0, _ = -nt(Math.atan2(e1[3], e1[4]))) : (w = nt(0 === e1[5] && 0 === e1[8] ? 0 : Math.atan2(e1[5], e1[8])), _ = nt(0 === e1[1] && 0 === e1[0] ? 0 : Math.atan2(e1[1], e1[0]))), {
                roll: w,
                pitch: b + 90,
                bearing: _
            };
        }, t.bn = function(t, e1) {
            return t.roll == e1.roll && t.pitch == e1.pitch && t.bearing == e1.bearing;
        }, t.bo = Te, t.bp = ka, t.bq = vu, t.br = bu, t.bs = gu, t.bt = z, t.bu = B, t.bv = Ne, t.bw = function(t, e1, n, r, i) {
            return z(r, i, L((t - e1) / (n - e1), 0, 1));
        }, t.bx = function(t, e1, n, r) {
            return t[0] = e1[0] + n[0] * r, t[1] = e1[1] + n[1] * r, t[2] = e1[2] + n[2] * r, t;
        }, t.by = D, t.bz = function() {
            return new Float64Array(3);
        }, t.c = ut, t.c$ = si, t.c0 = class extends Ma {
            constructor(t, e1){
                super(t, e1), this.current = Ta;
            }
            set(t) {
                if (t[12] !== this.current[12] || t[0] !== this.current[0]) return this.current = t, void this.gl.uniformMatrix4fv(this.location, !1, t);
                for(let e1 = 1; e1 < 16; e1++)if (t[e1] !== this.current[e1]) {
                    this.current = t, this.gl.uniformMatrix4fv(this.location, !1, t);
                    break;
                }
            }
        }, t.c1 = Ia, t.c2 = class extends Ma {
            constructor(t, e1){
                super(t, e1), this.current = [
                    0,
                    0,
                    0
                ];
            }
            set(t) {
                t[0] === this.current[0] && t[1] === this.current[1] && t[2] === this.current[2] || (this.current = t, this.gl.uniform3f(this.location, t[0], t[1], t[2]));
            }
        }, t.c3 = class extends Ma {
            constructor(t, e1){
                super(t, e1), this.current = [
                    0,
                    0
                ];
            }
            set(t) {
                t[0] === this.current[0] && t[1] === this.current[1] || (this.current = t, this.gl.uniform2f(this.location, t[0], t[1]));
            }
        }, t.c4 = d, t.c5 = function(t, e1) {
            var n = Math.sin(e1), r = Math.cos(e1);
            return t[0] = r, t[1] = n, t[2] = 0, t[3] = -n, t[4] = r, t[5] = 0, t[6] = 0, t[7] = 0, t[8] = 1, t;
        }, t.c6 = function(t, e1, n) {
            var r = e1[0], i = e1[1], s = e1[2];
            return t[0] = r * n[0] + i * n[3] + s * n[6], t[1] = r * n[1] + i * n[4] + s * n[7], t[2] = r * n[2] + i * n[5] + s * n[8], t;
        }, t.c7 = function(t, e1, n, r, i, s, o) {
            var a = 1 / (e1 - n), l = 1 / (r - i), u = 1 / (s - o);
            return t[0] = -2 * a, t[1] = 0, t[2] = 0, t[3] = 0, t[4] = 0, t[5] = -2 * l, t[6] = 0, t[7] = 0, t[8] = 0, t[9] = 0, t[10] = 2 * u, t[11] = 0, t[12] = (e1 + n) * a, t[13] = (i + r) * l, t[14] = (o + s) * u, t[15] = 1, t;
        }, t.c8 = class extends Ma {
            constructor(t, e1){
                super(t, e1), this.current = new Array;
            }
            set(t) {
                if (t != this.current) {
                    this.current = t;
                    const e1 = new Float32Array(4 * t.length);
                    for(let n = 0; n < t.length; n++)e1[4 * n] = t[n].r, e1[4 * n + 1] = t[n].g, e1[4 * n + 2] = t[n].b, e1[4 * n + 3] = t[n].a;
                    this.gl.uniform4fv(this.location, e1);
                }
            }
        }, t.c9 = class extends Ma {
            constructor(t, e1){
                super(t, e1), this.current = new Array;
            }
            set(t) {
                if (t != this.current) {
                    this.current = t;
                    const e1 = new Float32Array(t);
                    this.gl.uniform1fv(this.location, e1);
                }
            }
        }, t.cA = function(t, e1) {
            return rt[e1] && "touches" in t;
        }, t.cB = function(t) {
            return rt[t] || it[t];
        }, t.cC = function(t, e1, n) {
            var r = e1[0], i = e1[1];
            return t[0] = n[0] * r + n[4] * i + n[12], t[1] = n[1] * r + n[5] * i + n[13], t;
        }, t.cD = function(t, e1) {
            const { x: n, y: r } = Zp.fromLngLat(e1);
            return !(t < 0 || t > 25 || r < 0 || r >= 1 || n < 0 || n >= 1);
        }, t.cE = function(t, e1) {
            return t[0] = e1[0], t[1] = 0, t[2] = 0, t[3] = 0, t[4] = 0, t[5] = e1[1], t[6] = 0, t[7] = 0, t[8] = 0, t[9] = 0, t[10] = e1[2], t[11] = 0, t[12] = 0, t[13] = 0, t[14] = 0, t[15] = 1, t;
        }, t.cF = class extends co {
        }, t.cG = pt, t.cH = function(t, e1) {
            ut.REGISTERED_PROTOCOLS[t] = e1;
        }, t.cI = function(t) {
            delete ut.REGISTERED_PROTOCOLS[t];
        }, t.cJ = function(t, e1) {
            const n = {};
            for(let r = 0; r < t.length; r++){
                const i = e1 && e1[t[r].id] || Ai(t[r]);
                e1 && (e1[t[r].id] = i);
                let s = n[i];
                s || (s = n[i] = []), s.push(t[r]);
            }
            const r = [];
            for(const t in n)r.push(n[t]);
            return r;
        }, t.cK = ds, t.cL = ef, t.cM = oy, t.cN = rp, t.cO = function(e1) {
            var n, r;
            e1.bucket.createArrays(), e1.bucket.tilePixelRatio = T / (512 * e1.bucket.overscaling), e1.bucket.compareText = {}, e1.bucket.iconsNeedLinear = !1;
            const i = e1.bucket.layers[0], s = i.layout, o = i._unevaluatedLayout._values, a = {
                layoutIconSize: o["icon-size"].possiblyEvaluate(new Cs(e1.bucket.zoom + 1), e1.canonical),
                layoutTextSize: o["text-size"].possiblyEvaluate(new Cs(e1.bucket.zoom + 1), e1.canonical),
                textMaxSize: o["text-size"].possiblyEvaluate(new Cs(18))
            };
            if ("composite" === e1.bucket.textSizeData.kind) {
                const { minZoom: t, maxZoom: n } = e1.bucket.textSizeData;
                a.compositeTextSizes = [
                    o["text-size"].possiblyEvaluate(new Cs(t), e1.canonical),
                    o["text-size"].possiblyEvaluate(new Cs(n), e1.canonical)
                ];
            }
            if ("composite" === e1.bucket.iconSizeData.kind) {
                const { minZoom: t, maxZoom: n } = e1.bucket.iconSizeData;
                a.compositeIconSizes = [
                    o["icon-size"].possiblyEvaluate(new Cs(t), e1.canonical),
                    o["icon-size"].possiblyEvaluate(new Cs(n), e1.canonical)
                ];
            }
            const l = s.get("text-line-height") * Ih, u = "viewport" !== s.get("text-rotation-alignment") && "point" !== s.get("symbol-placement"), c = s.get("text-keep-upright"), h = s.get("text-size");
            for (const o of e1.bucket.features){
                const p = s.get("text-font").evaluate(o, {}, e1.canonical).join(","), f = h.evaluate(o, {}, e1.canonical), d = a.layoutTextSize.evaluate(o, {}, e1.canonical), y = a.layoutIconSize.evaluate(o, {}, e1.canonical), m = {
                    horizontal: {},
                    vertical: void 0
                }, g = o.text;
                let x, v = [
                    0,
                    0
                ];
                if (g) {
                    const n = g.toString(), r = s.get("text-letter-spacing").evaluate(o, {}, e1.canonical) * Ih, a = Ms(n) ? r : 0, h = s.get("text-anchor").evaluate(o, {}, e1.canonical), y = Vy(i, o, e1.canonical);
                    if (!y) {
                        const t = s.get("text-radial-offset").evaluate(o, {}, e1.canonical);
                        v = t ? Cy(h, [
                            t * Ih,
                            By
                        ]) : s.get("text-offset").evaluate(o, {}, e1.canonical).map((t)=>t * Ih);
                    }
                    let x = u ? "center" : s.get("text-justify").evaluate(o, {}, e1.canonical);
                    const b = "point" === s.get("symbol-placement") ? s.get("text-max-width").evaluate(o, {}, e1.canonical) * Ih : 1 / 0, w = ()=>{
                        e1.bucket.allowVerticalPlacement && As(n) && (m.vertical = sp(g, e1.glyphMap, e1.glyphPositions, e1.imagePositions, p, b, l, h, "left", a, v, t.ax.vertical, !0, d, f));
                    };
                    if (!u && y) {
                        const n = new Set;
                        if ("auto" === x) for(let t = 0; t < y.values.length; t += 2)n.add(Ly(y.values[t]));
                        else n.add(x);
                        let r = !1;
                        for (const i of n)if (!m.horizontal[i]) {
                            if (r) m.horizontal[i] = m.horizontal[0];
                            else {
                                const n = sp(g, e1.glyphMap, e1.glyphPositions, e1.imagePositions, p, b, l, "center", i, a, v, t.ax.horizontal, !1, d, f);
                                n && (m.horizontal[i] = n, r = 1 === n.positionedLines.length);
                            }
                        }
                        w();
                    } else {
                        "auto" === x && (x = Ly(h));
                        const r = sp(g, e1.glyphMap, e1.glyphPositions, e1.imagePositions, p, b, l, h, x, a, v, t.ax.horizontal, !1, d, f);
                        r && (m.horizontal[x] = r), w(), As(n) && u && c && (m.vertical = sp(g, e1.glyphMap, e1.glyphPositions, e1.imagePositions, p, b, l, h, x, a, v, t.ax.vertical, !1, d, f));
                    }
                }
                let b = !1;
                if (null === (n = o.icon) || void 0 === n ? void 0 : n.name) {
                    const t = e1.imageMap[o.icon.name];
                    t && (x = fp(e1.imagePositions[o.icon.name], s.get("icon-offset").evaluate(o, {}, e1.canonical), s.get("icon-anchor").evaluate(o, {}, e1.canonical)), b = !!t.sdf, void 0 === e1.bucket.sdfIcons ? e1.bucket.sdfIcons = b : e1.bucket.sdfIcons !== b && G("Style sheet warning: Cannot mix SDF and non-SDF icons in one buffer"), (t.pixelRatio !== e1.bucket.pixelRatio || 0 !== s.get("icon-rotate").constantOr(1)) && (e1.bucket.iconsNeedLinear = !0));
                }
                const w = Ry(m.horizontal) || m.vertical;
                (r = e1.bucket).iconsInText || (r.iconsInText = !!w && w.iconsInText), (w || x) && Oy(e1.bucket, o, m, x, e1.imageMap, a, d, y, v, b, e1.canonical, e1.subdivisionGranularity);
            }
            e1.showCollisionBoxes && e1.bucket.generateCollisionDebugBuffers();
        }, t.cP = Iu, t.cQ = Gu, t.cR = ph, t.cS = function(t, e1 = "") {
            const n = new Rh;
            return function(t, e1, n = "") {
                for(const r in t.layers)e1.writeMessage(3, (t, e1)=>Qd(t, e1, n), t.layers[r]);
            }(t, n, e1), n.finish();
        }, t.cT = function(t, e1, n, r, i, s) {
            let o = cy(t, e1, n, i, 0);
            return o = cy(o, e1, r, s, 1), o;
        }, t.cU = class {
            constructor(t){
                this.maxEntries = t, this.map = new Map;
            }
            get(t) {
                const e1 = this.map.get(t);
                return void 0 !== e1 && (this.map.delete(t), this.map.set(t, e1)), e1;
            }
            set(t, e1) {
                if (this.map.has(t)) this.map.delete(t);
                else if (this.map.size >= this.maxEntries) {
                    const t = this.map.keys().next().value;
                    this.map.delete(t);
                }
                this.map.set(t, e1);
            }
            clear() {
                this.map.clear();
            }
        }, t.cV = Nu, t.cW = Rh, t.cX = Wd, t.cY = function(t, n, r, i, s) {
            return e1(this, void 0, void 0, function*() {
                if (h()) try {
                    return yield K(t, n, r, i, s);
                } catch (t) {}
                return function(t, e1, n, r, i) {
                    const s = t.width, o = t.height;
                    J && Q || (J = new OffscreenCanvas(s, o), Q = J.getContext("2d", {
                        willReadFrequently: !0
                    })), J.width = s, J.height = o, Q.drawImage(t, 0, 0, s, o);
                    const a = Q.getImageData(e1, n, r, i);
                    return Q.clearRect(0, 0, s, o), a.data;
                }(t, n, r, i, s);
            });
        }, t.cZ = $l, t.c_ = class {
            constructor(t, e1){
                this.layers = {
                    [Jd]: this
                }, this.name = Jd, this.version = e1 ? e1.version : 1, this.extent = e1 ? e1.extent : 4096, this.length = t.length, this.features = t;
            }
            feature(t) {
                return new Kd(this.features[t], this.extent);
            }
        }, t.ca = class extends So {
        }, t.cb = Ah, t.cc = class extends Mo {
        }, t.cd = Fl, t.ce = function(t) {
            return t <= 1 ? 1 : Math.pow(2, Math.ceil(Math.log(t) / Math.LN2));
        }, t.cf = Tl, t.cg = function(t, e1, n) {
            var r = e1[0], i = e1[1], s = e1[2], o = n[3] * r + n[7] * i + n[11] * s + n[15];
            return t[0] = (n[0] * r + n[4] * i + n[8] * s + n[12]) / (o = o || 1), t[1] = (n[1] * r + n[5] * i + n[9] * s + n[13]) / o, t[2] = (n[2] * r + n[6] * i + n[10] * s + n[14]) / o, t;
        }, t.ch = class extends ho {
        }, t.ci = class extends Do {
        }, t.cj = function(t, e1) {
            return t[0] === e1[0] && t[1] === e1[1] && t[2] === e1[2] && t[3] === e1[3] && t[4] === e1[4] && t[5] === e1[5] && t[6] === e1[6] && t[7] === e1[7] && t[8] === e1[8] && t[9] === e1[9] && t[10] === e1[10] && t[11] === e1[11] && t[12] === e1[12] && t[13] === e1[13] && t[14] === e1[14] && t[15] === e1[15];
        }, t.ck = function(t, e1) {
            var n = t[0], r = t[1], i = t[2], s = t[3], o = t[4], a = t[5], l = t[6], u = t[7], c = t[8], h = t[9], f = t[10], d = t[11], y = t[12], m = t[13], g = t[14], x = t[15], v = e1[0], b = e1[1], w = e1[2], _ = e1[3], S = e1[4], A = e1[5], M = e1[6], k = e1[7], I = e1[8], E = e1[9], T = e1[10], F = e1[11], P = e1[12], D = e1[13], z = e1[14], B = e1[15];
            return Math.abs(n - v) <= p * Math.max(1, Math.abs(n), Math.abs(v)) && Math.abs(r - b) <= p * Math.max(1, Math.abs(r), Math.abs(b)) && Math.abs(i - w) <= p * Math.max(1, Math.abs(i), Math.abs(w)) && Math.abs(s - _) <= p * Math.max(1, Math.abs(s), Math.abs(_)) && Math.abs(o - S) <= p * Math.max(1, Math.abs(o), Math.abs(S)) && Math.abs(a - A) <= p * Math.max(1, Math.abs(a), Math.abs(A)) && Math.abs(l - M) <= p * Math.max(1, Math.abs(l), Math.abs(M)) && Math.abs(u - k) <= p * Math.max(1, Math.abs(u), Math.abs(k)) && Math.abs(c - I) <= p * Math.max(1, Math.abs(c), Math.abs(I)) && Math.abs(h - E) <= p * Math.max(1, Math.abs(h), Math.abs(E)) && Math.abs(f - T) <= p * Math.max(1, Math.abs(f), Math.abs(T)) && Math.abs(d - F) <= p * Math.max(1, Math.abs(d), Math.abs(F)) && Math.abs(y - P) <= p * Math.max(1, Math.abs(y), Math.abs(P)) && Math.abs(m - D) <= p * Math.max(1, Math.abs(m), Math.abs(D)) && Math.abs(g - z) <= p * Math.max(1, Math.abs(g), Math.abs(z)) && Math.abs(x - B) <= p * Math.max(1, Math.abs(x), Math.abs(B));
        }, t.cl = function(t, e1) {
            return t[0] = e1[0], t[1] = e1[1], t[2] = e1[2], t[3] = e1[3], t[4] = e1[4], t[5] = e1[5], t[6] = e1[6], t[7] = e1[7], t[8] = e1[8], t[9] = e1[9], t[10] = e1[10], t[11] = e1[11], t[12] = e1[12], t[13] = e1[13], t[14] = e1[14], t[15] = e1[15], t;
        }, t.cm = (t)=>"circle" === t.type, t.cn = (t)=>"heatmap" === t.type, t.co = (t)=>"line" === t.type, t.cp = (t)=>"fill" === t.type, t.cq = (t)=>"fill-extrusion" === t.type, t.cr = (t)=>"hillshade" === t.type, t.cs = (t)=>"color-relief" === t.type, t.ct = (t)=>"background" === t.type, t.cu = (t)=>"custom" === t.type, t.cv = C, t.cw = function(t, e1, n) {
            if (e1 <= 0) return t;
            const r = 1 / e1;
            return void 0 === n || Math.abs(n) < 1e-10 ? Math.round(t * r) / r : (n > 0 ? Math.ceil(t * r - 1e-9) : Math.floor(t * r + 1e-10)) / r;
        }, t.cx = function(t, e1, n) {
            const r = E(e1.x - n.x, e1.y - n.y), i = E(t.x - n.x, t.y - n.y);
            var s, o;
            return nt(Math.atan2(r[0] * i[1] - r[1] * i[0], (s = r)[0] * (o = i)[0] + s[1] * o[1]));
        }, t.cy = V, t.cz = function(t, e1) {
            var n;
            if (!it[e1]) return !1;
            const r = null == t ? void 0 : t.target, i = (null === (n = null == r ? void 0 : r.ownerDocument) || void 0 === n ? void 0 : n.defaultView) || window;
            return t instanceof i.MouseEvent || t instanceof i.WheelEvent;
        }, t.d = P, t.d0 = class {
            constructor(t, e1){
                const n = (e1 = this.options = Object.assign({}, sh, e1)).debug;
                if (n && console.time("preprocess data"), e1.maxZoom < 0 || e1.maxZoom > 24) throw new Error("maxZoom should be in the 0-24 range");
                if (e1.promoteId && e1.generateId) throw new Error("promoteId and generateId cannot be used together.");
                let r = pc(t, e1);
                n && (console.timeEnd("preprocess data"), console.log("index: maxZoom: %d, maxPoints: %d", e1.indexMaxZoom, e1.indexMaxPoints), console.time("generate tiles")), r = Lc(r, e1), e1.updateable && (this.source = r), this.initializeIndex(r, e1);
            }
            initializeIndex(t, e1) {
                this.tileIndex = e1.cluster ? new qc(e1.clusterOptions) : new rh(e1), t.length && this.tileIndex.initialize(t);
            }
            getTile(t, e1, n) {
                return e1 = +e1, n = +n, (t = +t) < 0 || t > 24 ? null : this.tileIndex.getTile(t, e1, n);
            }
            updateData(t, e1) {
                const n = this.options;
                if (!n.updateable) throw new Error("to update tile geojson `updateable` option must be set to true");
                let { affected: r, source: i } = function(t, e1, n) {
                    const r = function(t, e1) {
                        return t ? {
                            removeAll: t.removeAll,
                            remove: new Set(t.remove || []),
                            add: new Map(t.add?.map((t)=>[
                                    e1.promoteId ? t.properties[e1.promoteId] : t.id,
                                    t
                                ])),
                            update: new Map(t.update?.map((t)=>[
                                    t.id,
                                    t
                                ]))
                        } : {
                            remove: new Set,
                            add: new Map,
                            update: new Map
                        };
                    }(e1, n);
                    let i = [];
                    if (r.removeAll && (i = t, t = []), r.remove.size || r.add.size) {
                        const e1 = [];
                        for (const n of t)(r.remove.has(n.id) || r.add.has(n.id)) && e1.push(n);
                        if (e1.length) {
                            i.push(...e1);
                            const n = new Set(e1.map((t)=>t.id));
                            t = t.filter((t)=>!n.has(t.id));
                        }
                        if (r.add.size) {
                            let e1 = pc({
                                type: "FeatureCollection",
                                features: Array.from(r.add.values())
                            }, n);
                            e1 = Lc(e1, n), i.push(...e1), t.push(...e1);
                        }
                    }
                    if (r.update.size) {
                        const e1 = new Map, s = [];
                        for (const n of t)r.update.has(n.id) ? e1.set(n.id, [
                            ...e1.get(n.id) || [],
                            n
                        ]) : s.push(n);
                        for (const [t, o] of r.update){
                            const r = e1.get(t);
                            if (!r || 0 === r.length) continue;
                            const a = Nc(r, o, n);
                            i.push(...r, ...a), s.push(...a);
                        }
                        t = s;
                    }
                    return {
                        affected: i,
                        source: t
                    };
                }(this.source, t, n);
                e1 && ({ affected: r, source: i } = this.filterUpdate(i, r, e1)), r.length && (this.source = i, this.tileIndex.updateIndex(i, r, n));
            }
            filterUpdate(t, e1, n) {
                const r = new Set;
                for (const i of t)null != i.id && (n(xc(i)) || (e1.push(i), r.add(i.id)));
                return {
                    affected: e1,
                    source: t = t.filter((t)=>!r.has(t.id))
                };
            }
            getData() {
                if (!this.options.updateable) throw new Error("to retrieve data the `updateable` option must be set to true");
                return {
                    type: "FeatureCollection",
                    features: this.source.map((t)=>xc(t))
                };
            }
            updateClusterOptions(t, e1) {
                const n = this.options.cluster;
                this.options.cluster = t, this.options.clusterOptions = e1, n != t ? this.initializeIndex(this.source, this.options) : this.tileIndex.updateIndex(this.source, [], this.options);
            }
            getClusterExpansionZoom(t) {
                return this.tileIndex.getClusterExpansionZoom(t);
            }
            getClusterChildren(t) {
                return this.tileIndex.getChildren(t);
            }
            getClusterLeaves(t, e1, n) {
                return this.tileIndex.getLeaves(t, e1, n);
            }
        }, t.d1 = Bs, t.e = $, t.f = yt, t.g = ct, t.h = (t)=>e1(void 0, void 0, void 0, function*() {
                if (0 === t.byteLength) return createImageBitmap(new ImageData(1, 1));
                const e1 = new Blob([
                    new Uint8Array(t)
                ], {
                    type: "image/png"
                });
                try {
                    return createImageBitmap(e1);
                } catch (t) {
                    throw new Error(`Could not load image because of ${P(t).message}. Please make sure to use a supported image type such as PNG or JPEG. Note that SVGs are not supported.`);
                }
            }), t.i = Y, t.j = (t)=>new Promise((e1, n)=>{
                const r = new Image;
                r.onload = ()=>{
                    e1(r), URL.revokeObjectURL(r.src), r.onload = null, window.requestAnimationFrame(()=>r.src = W);
                }, r.onerror = ()=>n(new Error("Could not load image. Please make sure to use a supported image type such as PNG or JPEG. Note that SVGs are not supported."));
                const i = new Blob([
                    new Uint8Array(t)
                ], {
                    type: "image/png"
                });
                r.src = t.byteLength ? URL.createObjectURL(i) : W;
            }), t.k = (t, e1)=>dt($(t, {
                type: "json"
            }), e1), t.l = vt, t.m = dt, t.n = xt, t.o = (t, e1)=>dt($(t, {
                type: "arrayBuffer"
            }), e1), t.p = ep, t.q = function(t) {
            return new Rh(t).readFields(Jh, []);
        }, t.r = function(t) {
            return /[\u02EA\u02EB\u1100-\u11FF\u2E80-\u2FDF\u3000-\u30FF\u3105-\u312F\u3131-\u318E\u31A0-\u4DBF\u4E00-\uA48C\uA490-\uA4C6\uA960-\uA97C\uAC00-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFE10-\uFE1F\uFE30-\uFE4F\uFF00-\uFFEF]|\uD81B[\uDFE0-\uDFFF]|[\uD81C-\uD822\uD840-\uD868\uD86A-\uD86D\uD86F-\uD872\uD874-\uD879\uD880-\uD883\uD885-\uD88C][\uDC00-\uDFFF]|\uD823[\uDC00-\uDCD5\uDCFF-\uDD1E\uDD80-\uDDF2]|\uD82B[\uDFF0-\uDFFF]|\uD82C[\uDC00-\uDEFB]|\uD83C[\uDE00-\uDEFF]|\uD869[\uDC00-\uDEDF\uDF00-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEAD\uDEB0-\uDFFF]|\uD87A[\uDC00-\uDFE0\uDFF0-\uDFFF]|\uD87B[\uDC00-\uDE5D]|\uD87E[\uDC00-\uDE1D]|\uD884[\uDC00-\uDF4A\uDF50-\uDFFF]|\uD88D[\uDC00-\uDC79]/gim.test(String.fromCodePoint(t));
        }, t.s = tt, t.t = kl, t.u = Ks, t.v = ss, t.w = G, t.x = wt, t.y = Rs, t.z = as;
    });
    define("worker", [
        "./shared"
    ], function(e1) {
        "use strict";
        class t {
            constructor(e1, t){
                this.keyCache = {}, e1 && this.replace(e1, t);
            }
            replace(e1, t) {
                this._layerConfigs = {}, this._layers = {}, this.update(e1, [], t);
            }
            update(t, i, s) {
                for (const i of t){
                    this._layerConfigs[i.id] = i;
                    const t = this._layers[i.id] = e1.bT(i, s);
                    t._featureFilter = e1.ah(t.filter, s), this.keyCache[i.id] && delete this.keyCache[i.id];
                }
                for (const e1 of i)delete this.keyCache[e1], delete this._layerConfigs[e1], delete this._layers[e1];
                this.familiesBySource = {};
                const r = e1.cJ(Object.values(this._layerConfigs), this.keyCache);
                for (const t of r){
                    const i = t.map((e1)=>this._layers[e1.id]), s = i[0];
                    if (s.isHidden()) continue;
                    const r = s.source || "";
                    let o = this.familiesBySource[r];
                    o || (o = this.familiesBySource[r] = {});
                    const n = s.sourceLayer || e1.ag;
                    let a = o[n];
                    a || (a = o[n] = []), a.push(i);
                }
            }
        }
        class i {
            constructor(t){
                const i = {}, s = [];
                for(const e1 in t){
                    const r = t[e1], o = i[e1] = {};
                    for(const e1 in r){
                        const t = r[+e1];
                        if (!t || 0 === t.bitmap.width || 0 === t.bitmap.height) continue;
                        const i = {
                            x: 0,
                            y: 0,
                            w: t.bitmap.width + 2,
                            h: t.bitmap.height + 2
                        };
                        s.push(i), o[e1] = {
                            rect: i,
                            metrics: t.metrics
                        };
                    }
                }
                const { w: r, h: o } = e1.p(s), n = new e1.t({
                    width: r || 1,
                    height: o || 1
                });
                for(const s in t){
                    const r = t[s];
                    for(const t in r){
                        const o = r[+t];
                        if (!o || 0 === o.bitmap.width || 0 === o.bitmap.height) continue;
                        const a = i[s][t].rect;
                        e1.t.copy(o.bitmap, n, {
                            x: 0,
                            y: 0
                        }, {
                            x: a.x + 1,
                            y: a.y + 1
                        }, o.bitmap);
                    }
                }
                this.image = n, this.positions = i;
            }
        }
        e1.cK("GlyphAtlas", i);
        class s {
            constructor(t){
                this.tileID = new e1.a3(t.tileID.overscaledZ, t.tileID.wrap, t.tileID.canonical.z, t.tileID.canonical.x, t.tileID.canonical.y), this.uid = t.uid, this.zoom = t.zoom, this.pixelRatio = t.pixelRatio, this.tileSize = t.tileSize, this.source = t.source, this.overscaling = this.tileID.overscaleFactor(), this.showCollisionBoxes = t.showCollisionBoxes, this.collectResourceTiming = !!t.collectResourceTiming, this.returnDependencies = !!t.returnDependencies, this.promoteId = t.promoteId, this.inFlightDependencies = [];
            }
            parse(t, s, o, n, a) {
                return e1._(this, void 0, void 0, function*() {
                    this.status = "parsing", this.data = t, this.collisionBoxArray = new e1.ae;
                    const l = new e1.cL(Object.keys(t.layers).sort()), c = new e1.cM(this.tileID, this.promoteId);
                    c.bucketLayerIDs = [];
                    const h = {}, d = {
                        featureIndex: c,
                        iconDependencies: {},
                        patternDependencies: {},
                        glyphDependencies: {},
                        dashDependencies: {},
                        availableImages: o,
                        subdivisionGranularity: a
                    }, u = s.familiesBySource[this.source];
                    for(const i in u){
                        const s = t.layers[i];
                        if (!s) continue;
                        1 === s.version && e1.w(`Vector tile source "${this.source}" layer "${i}" does not use vector tile spec v2 and therefore may have some rendering errors.`);
                        const n = l.encode(i), a = [];
                        for(let e1 = 0; e1 < s.length; e1++){
                            const t = s.feature(e1), r = c.getId(t, i);
                            a.push({
                                feature: t,
                                id: r,
                                index: e1,
                                sourceLayerIndex: n
                            });
                        }
                        for (const t of u[i]){
                            const i = t[0];
                            i.source !== this.source && e1.w(`layer.source = ${i.source} does not equal this.source = ${this.source}`), i.isHidden(this.zoom, !0) || (r(t, this.zoom, o), (h[i.id] = i.createBucket({
                                index: c.bucketLayerIDs.length,
                                layers: t,
                                zoom: this.zoom,
                                pixelRatio: this.pixelRatio,
                                overscaling: this.overscaling,
                                collisionBoxArray: this.collisionBoxArray,
                                sourceLayerIndex: n,
                                sourceID: this.source
                            })).populate(a, d, this.tileID.canonical), c.bucketLayerIDs.push(t.map((e1)=>e1.id)));
                        }
                    }
                    const g = e1.bY(d.glyphDependencies, (e1)=>Object.keys(e1).map(Number));
                    for (const e1 of this.inFlightDependencies)null == e1 || e1.abort();
                    this.inFlightDependencies = [];
                    let p = Promise.resolve({});
                    if (Object.keys(g).length) {
                        const e1 = new AbortController;
                        this.inFlightDependencies.push(e1), p = n.sendAsync({
                            type: "GG",
                            data: {
                                stacks: g,
                                source: this.source,
                                tileID: this.tileID,
                                type: "glyphs"
                            }
                        }, e1);
                    }
                    const f = Object.keys(d.iconDependencies);
                    let y = Promise.resolve({});
                    if (f.length) {
                        const e1 = new AbortController;
                        this.inFlightDependencies.push(e1), y = n.sendAsync({
                            type: "GI",
                            data: {
                                icons: f,
                                source: this.source,
                                tileID: this.tileID,
                                type: "icons"
                            }
                        }, e1);
                    }
                    const v = Object.keys(d.patternDependencies);
                    let m = Promise.resolve({});
                    if (v.length) {
                        const e1 = new AbortController;
                        this.inFlightDependencies.push(e1), m = n.sendAsync({
                            type: "GI",
                            data: {
                                icons: v,
                                source: this.source,
                                tileID: this.tileID,
                                type: "patterns"
                            }
                        }, e1);
                    }
                    const _ = d.dashDependencies;
                    let S = Promise.resolve({});
                    if (Object.keys(_).length) {
                        const e1 = new AbortController;
                        this.inFlightDependencies.push(e1), S = n.sendAsync({
                            type: "GDA",
                            data: {
                                dashes: _
                            }
                        }, e1);
                    }
                    const [w, b, I, T] = yield Promise.all([
                        p,
                        y,
                        m,
                        S
                    ]), k = new i(w), x = new e1.cN(b, I);
                    for(const t in h){
                        const i = h[t];
                        i instanceof e1.af ? (r(i.layers, this.zoom, o), e1.cO({
                            bucket: i,
                            glyphMap: w,
                            glyphPositions: k.positions,
                            imageMap: b,
                            imagePositions: x.iconPositions,
                            showCollisionBoxes: this.showCollisionBoxes,
                            canonical: this.tileID.canonical,
                            subdivisionGranularity: d.subdivisionGranularity
                        })) : i.hasDependencies && (i instanceof e1.cP || i instanceof e1.cQ || i instanceof e1.cR) && (r(i.layers, this.zoom, o), i.addFeatures(d, this.tileID.canonical, x.patternPositions, T));
                    }
                    return this.status = "done", {
                        buckets: Object.values(h).filter((e1)=>!e1.isEmpty()),
                        featureIndex: c,
                        collisionBoxArray: this.collisionBoxArray,
                        glyphAtlasImage: k.image,
                        imageAtlas: x,
                        dashPositions: T,
                        glyphMap: this.returnDependencies ? w : null,
                        iconMap: this.returnDependencies ? b : null,
                        glyphPositions: this.returnDependencies ? k.positions : null
                    };
                });
            }
        }
        function r(t, i, s) {
            const r = new e1.J(i);
            for (const e1 of t)e1.recalculate(r, s);
        }
        class o {
            constructor(){
                this.loading = {}, this.loaded = {}, this.parsing = {};
            }
            startLoading(e1, t) {
                this.loading[e1] = t;
            }
            finishLoading(e1) {
                delete this.loading[e1];
            }
            abort(e1) {
                const t = this.loading[e1];
                (null == t ? void 0 : t.abort) && (t.abort.abort(), delete this.loading[e1]);
            }
            setParsing(e1, t) {
                this.parsing[e1] = t;
            }
            consumeParsing(e1) {
                const t = this.parsing[e1];
                if (t) return delete this.parsing[e1], t;
            }
            clearParsing(e1) {
                delete this.parsing[e1];
            }
            markLoaded(e1, t) {
                this.loaded[e1] = t;
            }
            getLoaded(e1) {
                const t = this.loaded[e1];
                if (t) return t;
            }
            removeLoaded(e1) {
                delete this.loaded[e1];
            }
            clearLoaded() {
                this.loaded = {};
            }
        }
        class n {
            constructor(e1){
                this.start = `${e1}#start`, this.end = `${e1}#end`, this.measure = e1, performance.mark(this.start);
            }
            finish() {
                performance.mark(this.end);
                let e1 = performance.getEntriesByName(this.measure);
                return 0 === e1.length && (performance.measure(this.measure, this.start, this.end), e1 = performance.getEntriesByName(this.measure), performance.clearMarks(this.start), performance.clearMarks(this.end), performance.clearMeasures(this.measure)), e1;
            }
        }
        class a {
            constructor(e1, t, i, s, r){
                this.type = e1, this.properties = i || {}, this.extent = r, this.pointsArray = t, this.id = s;
            }
            loadGeometry() {
                return this.pointsArray.map((t)=>t.map((t)=>new e1.P(t.x, t.y)));
            }
        }
        class l {
            constructor(e1, t, i){
                this.version = 2, this._myFeatures = e1, this.name = t, this.length = e1.length, this.extent = i;
            }
            feature(e1) {
                return this._myFeatures[e1];
            }
        }
        class c {
            constructor(){
                this.layers = {};
            }
            addLayer(e1) {
                this.layers[e1.name] = e1;
            }
        }
        function h(t) {
            let i = e1.cS(t);
            return 0 === i.byteOffset && i.byteLength === i.buffer.byteLength || (i = new Uint8Array(i)), {
                vectorTile: t,
                rawData: i.buffer
            };
        }
        function d(t, i, s) {
            const { extent: r } = t, o = Math.pow(2, s.z - i.z), n = (s.x - i.x * o) * r, c = (s.y - i.y * o) * r, h = [];
            for(let i = 0; i < t.length; i++){
                const s = t.feature(i);
                let l = s.loadGeometry();
                for (const e1 of l)for (const t of e1)t.x = t.x * o - n, t.y = t.y * o - c;
                const d = 128;
                l = e1.cT(l, s.type, -d, -d, r + d, r + d), 0 !== l.length && h.push(new a(s.type, l, s.properties, s.id, r));
            }
            return new l(h, t.name, r);
        }
        class u {
            constructor(t, i, s){
                this.actor = t, this.layerIndex = i, this.availableImages = s, this.tileState = new o, this.overzoomedTileResultCache = new e1.cU(1e3);
            }
            loadVectorTile(t, i) {
                try {
                    return {
                        vectorTile: "mlt" !== t.encoding ? new e1.cV(new e1.cW(i)) : new e1.cX(i),
                        rawData: i
                    };
                } catch (s) {
                    const r = new Uint8Array(i);
                    let o = `Unable to parse the tile at ${t.request.url}, `;
                    throw o += 31 === r[0] && 139 === r[1] ? "please make sure the data is not gzipped and that you have configured the relevant header in the server" : `got error: ${e1.d(s).message}`, new Error(o);
                }
            }
            loadTile(t) {
                return e1._(this, void 0, void 0, function*() {
                    const { uid: i, overzoomParameters: r } = t;
                    r && (t.request = r.overzoomRequest);
                    const o = this._startRequestTiming(t), n = new s(t);
                    this.tileState.startLoading(i, n);
                    const a = new AbortController;
                    n.abort = a;
                    try {
                        const s = yield e1.o(t.request, a);
                        if (t.etag && t.etag === s.etag) return this.tileState.finishLoading(i), this._getEtagUnmodifiedResult(s, o);
                        const l = this.loadVectorTile(t, s.data);
                        if (this.tileState.finishLoading(i), !l) return null;
                        let { vectorTile: c, rawData: h } = l;
                        r && ({ vectorTile: c, rawData: h } = this._getOverzoomTile(t, c));
                        const d = this._getExpiryData(s), u = this._finishRequestTiming(o);
                        n.vectorTile = c, this.tileState.markLoaded(i, n);
                        const g = {
                            rawData: h,
                            cacheControl: d,
                            resourceTiming: u
                        };
                        this.tileState.setParsing(i, g);
                        try {
                            return yield this._parseWorkerTile(n, t, g);
                        } finally{
                            this.tileState.clearParsing(i);
                        }
                    } catch (e1) {
                        throw this.tileState.finishLoading(i), n.status = "done", this.tileState.markLoaded(i, n), e1;
                    }
                });
            }
            _getEtagUnmodifiedResult(t, i) {
                const s = this._getExpiryData(t), r = this._finishRequestTiming(i);
                return e1.e({
                    etagUnmodified: !0
                }, s, r);
            }
            _parseWorkerTile(t, i, s) {
                return e1._(this, void 0, void 0, function*() {
                    let r = yield t.parse(t.vectorTile, this.layerIndex, this.availableImages, this.actor, i.subdivisionGranularity);
                    if (s) {
                        const { rawData: t, cacheControl: o, resourceTiming: n } = s;
                        r = e1.e({
                            rawTileData: t.slice(0),
                            encoding: i.encoding
                        }, r, o, n);
                    }
                    return r;
                });
            }
            _getExpiryData({ expires: e1, cacheControl: t, etag: i }) {
                const s = {};
                return e1 && (s.expires = e1), t && (s.cacheControl = t), i && (s.etag = i), s;
            }
            _startRequestTiming(e1) {
                var t;
                if (null === (t = e1.request) || void 0 === t ? void 0 : t.collectResourceTiming) return new n(e1.request.url);
            }
            _finishRequestTiming(e1) {
                const t = null == e1 ? void 0 : e1.finish();
                return t ? {
                    resourceTiming: JSON.parse(JSON.stringify(t))
                } : {};
            }
            _getOverzoomTile(e1, t) {
                var i;
                const { tileID: s, source: r, overzoomParameters: o } = e1, { maxZoomTileID: n } = o, a = `${n.key}_${s.key}_${null === (i = e1.request) || void 0 === i ? void 0 : i.url}`, l = this.overzoomedTileResultCache.get(a);
                if (l) return l;
                const u = new c, g = this.layerIndex.familiesBySource[r];
                for(const e1 in g){
                    const i = t.layers[e1];
                    if (!i) continue;
                    const r = d(i, n, s.canonical);
                    r.length > 0 && u.addLayer(r);
                }
                const p = h(u);
                return this.overzoomedTileResultCache.set(a, p), p;
            }
            reloadTile(t) {
                return e1._(this, void 0, void 0, function*() {
                    const e1 = t.uid, i = this.tileState.getLoaded(e1);
                    if (!i) throw new Error("Should not be trying to reload a tile that was never loaded or has been removed");
                    if (i.showCollisionBoxes = t.showCollisionBoxes, "parsing" === i.status) {
                        const s = this.tileState.consumeParsing(e1);
                        return yield this._parseWorkerTile(i, t, s);
                    }
                    if ("done" === i.status && i.vectorTile) return yield this._parseWorkerTile(i, t);
                });
            }
            abortTile(t) {
                return e1._(this, void 0, void 0, function*() {
                    this.tileState.abort(t.uid);
                });
            }
            removeTile(t) {
                return e1._(this, void 0, void 0, function*() {
                    this.tileState.removeLoaded(t.uid);
                });
            }
        }
        class g {
            constructor(){
                this.loaded = {};
            }
            loadTile(t) {
                return e1._(this, void 0, void 0, function*() {
                    const { uid: i, encoding: s, rawImageData: r, redFactor: o, greenFactor: n, blueFactor: a, baseShift: l } = t, c = r.width + 2, h = r.height + 2, d = e1.b(r) ? new e1.R({
                        width: c,
                        height: h
                    }, (yield e1.cY(r, -1, -1, c, h))) : r, u = new e1.cZ(i, d, s, o, n, a, l);
                    return this.loaded || (this.loaded = {}), this.loaded[i] = u, u;
                });
            }
            removeTile(e1) {
                const t = this.loaded, i = e1.uid;
                (null == t ? void 0 : t[i]) && delete t[i];
            }
        }
        class p {
            constructor(e1, t, i, s = f){
                this.actor = e1, this.layerIndex = t, this.availableImages = i, this.tileState = new o, this._createGeoJSONIndex = s;
            }
            loadVectorTile(t) {
                if (!this._geoJSONIndex) throw new Error("Unable to parse the data into a cluster or geojson");
                const { z: i, x: s, y: r } = t.tileID.canonical, o = this._geoJSONIndex.getTile(i, s, r);
                return o ? h(new e1.c_(o.features, {
                    version: 2,
                    extent: e1.a6
                })) : null;
            }
            loadTile(t) {
                return e1._(this, void 0, void 0, function*() {
                    const { uid: e1 } = t, i = new s(t);
                    i.abort = new AbortController;
                    try {
                        const s = this.loadVectorTile(t);
                        if (!s) return null;
                        const { vectorTile: r, rawData: o } = s;
                        i.vectorTile = r, this.tileState.markLoaded(e1, i);
                        const n = {
                            rawData: o
                        };
                        this.tileState.setParsing(e1, n);
                        try {
                            return yield this._parseWorkerTile(i, t, n);
                        } finally{
                            this.tileState.clearParsing(e1);
                        }
                    } catch (t) {
                        throw i.status = "done", this.tileState.markLoaded(e1, i), t;
                    }
                });
            }
            _reloadLoadedTile(t) {
                return e1._(this, void 0, void 0, function*() {
                    const e1 = t.uid, i = this.tileState.getLoaded(e1);
                    if (!i) throw new Error("Should not be trying to reload a tile that was never loaded or has been removed");
                    if (i.showCollisionBoxes = t.showCollisionBoxes, "parsing" === i.status) {
                        const s = this.tileState.consumeParsing(e1);
                        return yield this._parseWorkerTile(i, t, s);
                    }
                    if ("done" === i.status && i.vectorTile) return yield this._parseWorkerTile(i, t);
                });
            }
            _parseWorkerTile(t, i, s) {
                return e1._(this, void 0, void 0, function*() {
                    let r = yield t.parse(t.vectorTile, this.layerIndex, this.availableImages, this.actor, i.subdivisionGranularity);
                    if (s) {
                        const { rawData: t } = s;
                        r = e1.e({
                            rawTileData: t.slice(0),
                            encoding: "mvt"
                        }, r);
                    }
                    return r;
                });
            }
            abortTile(t) {
                return e1._(this, void 0, void 0, function*() {
                    this.tileState.abort(t.uid);
                });
            }
            removeTile(t) {
                return e1._(this, void 0, void 0, function*() {
                    this.tileState.removeLoaded(t.uid);
                });
            }
            loadData(t) {
                return e1._(this, void 0, void 0, function*() {
                    var i;
                    null === (i = this._pendingRequest) || void 0 === i || i.abort();
                    const s = this._startRequestTiming(t);
                    this._pendingRequest = new AbortController;
                    try {
                        yield this.loadAndProcessGeoJSON(t, this._pendingRequest), delete this._pendingRequest, this.tileState.clearLoaded();
                        const e1 = {};
                        return t.request && (e1.data = t.data), this._finishRequestTiming(s, t, e1), e1;
                    } catch (t) {
                        if (delete this._pendingRequest, !e1.$(t)) throw t;
                        return {
                            abandoned: !0
                        };
                    }
                });
            }
            _startRequestTiming(e1) {
                var t;
                if (null === (t = e1.request) || void 0 === t ? void 0 : t.collectResourceTiming) return new n(e1.request.url);
            }
            _finishRequestTiming(e1, t, i) {
                const s = null == e1 ? void 0 : e1.finish();
                s && (i.resourceTiming = {
                    [t.source]: JSON.parse(JSON.stringify(s))
                });
            }
            reloadTile(e1) {
                return this.tileState.getLoaded(e1.uid) ? this._reloadLoadedTile(e1) : this.loadTile(e1);
            }
            loadAndProcessGeoJSON(t, i) {
                return e1._(this, void 0, void 0, function*() {
                    var s;
                    if (t.request && (t.data = (yield e1.k(t.request, i)).data), t.data) return t.data = this._filterGeoJSON(t.data, t.filter), void (this._geoJSONIndex = this._createGeoJSONIndex(t.data, t));
                    if (t.dataDiff) return null !== (s = this._geoJSONIndex) && void 0 !== s || (this._geoJSONIndex = this._createGeoJSONIndex({
                        type: "FeatureCollection",
                        features: []
                    }, t)), void this._geoJSONIndex.updateData(t.dataDiff, this._getFilterPredicate(t.filter));
                    if (t.updateCluster && this._geoJSONIndex.updateClusterOptions(t.geojsonVtOptions.cluster, y(t)), null == this._geoJSONIndex) throw new Error(`Input data given to '${t.source}' is not a valid GeoJSON object.`);
                });
            }
            _filterGeoJSON(e1, t) {
                if ("FeatureCollection" !== e1.type) return e1;
                const i = this._getFilterPredicate(t);
                return i ? {
                    type: "FeatureCollection",
                    features: e1.features.filter((e1)=>i(e1))
                } : e1;
            }
            _getFilterPredicate(t) {
                if ("boolean" != typeof t && !(null == t ? void 0 : t.length)) return;
                const i = e1.c$(t, {
                    type: "boolean",
                    "property-type": "data-driven",
                    overridable: !1,
                    transition: !1
                });
                if ("error" === i.result) throw new Error(i.value.map((e1)=>`${e1.key}: ${e1.message}`).join(", "));
                return (e1)=>i.value.evaluate({
                        zoom: 0
                    }, e1);
            }
            removeSource(t) {
                return e1._(this, void 0, void 0, function*() {
                    var e1;
                    null === (e1 = this._pendingRequest) || void 0 === e1 || e1.abort();
                });
            }
            getClusterExpansionZoom(e1) {
                return this._geoJSONIndex.getClusterExpansionZoom(e1.clusterId);
            }
            getClusterChildren(e1) {
                return this._geoJSONIndex.getClusterChildren(e1.clusterId);
            }
            getClusterLeaves(e1) {
                return this._geoJSONIndex.getClusterLeaves(e1.clusterId, e1.limit, e1.offset);
            }
        }
        function f(t, i) {
            const s = e1.e(i.geojsonVtOptions || {}, {
                updateable: !0,
                clusterOptions: y(i)
            });
            return new e1.d0(t, s);
        }
        function y({ geojsonVtOptions: t, clusterProperties: i }) {
            if (!i || !t.clusterOptions) return t.clusterOptions;
            const s = {}, r = {}, o = {
                accumulated: null,
                zoom: 0
            }, n = {
                properties: null
            }, a = Object.keys(i);
            for (const t of a){
                const [o, n] = i[t], a = e1.c$(n), l = e1.c$("string" == typeof o ? [
                    o,
                    [
                        "accumulated"
                    ],
                    [
                        "get",
                        t
                    ]
                ] : o);
                s[t] = a.value, r[t] = l.value;
            }
            return t.clusterOptions.map = (e1)=>{
                n.properties = e1;
                const t = {};
                for (const e1 of a)t[e1] = s[e1].evaluate(o, n);
                return t;
            }, t.clusterOptions.reduce = (e1, t)=>{
                n.properties = t;
                for (const t of a)o.accumulated = e1[t], e1[t] = r[t].evaluate(o, n);
            }, t.clusterOptions;
        }
        class v {
            constructor(t){
                this.self = t, this.actor = new e1.N(t), this.layerIndexes = {}, this.availableImages = {}, this.workerSources = {}, this.demWorkerSources = {}, this.externalWorkerSourceTypes = {}, this.globalStates = new Map, this.self.registerWorkerSource = (e1, t)=>{
                    if (this.externalWorkerSourceTypes[e1]) throw new Error(`Worker source with name "${e1}" already registered.`);
                    this.externalWorkerSourceTypes[e1] = t;
                }, this.self.addProtocol = e1.cH, this.self.removeProtocol = e1.cI, this.self.registerRTLTextPlugin = (t)=>{
                    e1.d1.setMethods(t);
                }, this.self.makeRequest = e1.m, this.actor.registerMessageHandler("LDT", (e1, t)=>this._getDEMWorkerSource(e1, t.source).loadTile(t)), this.actor.registerMessageHandler("RDT", (t, i)=>e1._(this, void 0, void 0, function*() {
                        this._getDEMWorkerSource(t, i.source).removeTile(i);
                    })), this.actor.registerMessageHandler("GCEZ", (t, i)=>e1._(this, void 0, void 0, function*() {
                        return this._getWorkerSource(t, i.type, i.source).getClusterExpansionZoom(i);
                    })), this.actor.registerMessageHandler("GCC", (t, i)=>e1._(this, void 0, void 0, function*() {
                        return this._getWorkerSource(t, i.type, i.source).getClusterChildren(i);
                    })), this.actor.registerMessageHandler("GCL", (t, i)=>e1._(this, void 0, void 0, function*() {
                        return this._getWorkerSource(t, i.type, i.source).getClusterLeaves(i);
                    })), this.actor.registerMessageHandler("LD", (e1, t)=>this._getWorkerSource(e1, t.type, t.source).loadData(t)), this.actor.registerMessageHandler("LT", (e1, t)=>this._getWorkerSource(e1, t.type, t.source).loadTile(t)), this.actor.registerMessageHandler("RT", (e1, t)=>this._getWorkerSource(e1, t.type, t.source).reloadTile(t)), this.actor.registerMessageHandler("AT", (e1, t)=>this._getWorkerSource(e1, t.type, t.source).abortTile(t)), this.actor.registerMessageHandler("RMT", (e1, t)=>this._getWorkerSource(e1, t.type, t.source).removeTile(t)), this.actor.registerMessageHandler("RS", (t, i)=>e1._(this, void 0, void 0, function*() {
                        var e1, s;
                        if (!(null === (s = null === (e1 = this.workerSources[t]) || void 0 === e1 ? void 0 : e1[i.type]) || void 0 === s ? void 0 : s[i.source])) return;
                        const r = this.workerSources[t][i.type][i.source];
                        delete this.workerSources[t][i.type][i.source], void 0 !== r.removeSource && r.removeSource(i);
                    })), this.actor.registerMessageHandler("RM", (t)=>e1._(this, void 0, void 0, function*() {
                        delete this.layerIndexes[t], delete this.availableImages[t], delete this.workerSources[t], delete this.demWorkerSources[t], this.globalStates.delete(t);
                    })), this.actor.registerMessageHandler("SR", (t, i)=>e1._(this, void 0, void 0, function*() {
                        this.referrer = i;
                    })), this.actor.registerMessageHandler("SRPS", (e1, t)=>this._syncRTLPluginState(e1, t)), this.actor.registerMessageHandler("IS", (t, i)=>e1._(this, void 0, void 0, function*() {
                        this.self.importScripts(i);
                    })), this.actor.registerMessageHandler("SI", (e1, t)=>this._setImages(e1, t)), this.actor.registerMessageHandler("UL", (t, i)=>e1._(this, void 0, void 0, function*() {
                        this._getLayerIndex(t).update(i.layers, i.removedIds, this._getGlobalState(t));
                    })), this.actor.registerMessageHandler("UGS", (t, i)=>e1._(this, void 0, void 0, function*() {
                        const e1 = this._getGlobalState(t);
                        for(const t in i)e1[t] = i[t];
                    })), this.actor.registerMessageHandler("SL", (t, i)=>e1._(this, void 0, void 0, function*() {
                        this._getLayerIndex(t).replace(i, this._getGlobalState(t));
                    }));
            }
            _getGlobalState(e1) {
                let t = this.globalStates.get(e1);
                return t || (t = {}, this.globalStates.set(e1, t)), t;
            }
            _setImages(t, i) {
                return e1._(this, void 0, void 0, function*() {
                    this.availableImages[t] = i;
                    for(const e1 in this.workerSources[t]){
                        const s = this.workerSources[t][e1];
                        for(const e1 in s)s[e1].availableImages = i;
                    }
                });
            }
            _syncRTLPluginState(t, i) {
                return e1._(this, void 0, void 0, function*() {
                    return yield e1.d1.syncState(i, this.self.importScripts);
                });
            }
            _getAvailableImages(e1) {
                let t = this.availableImages[e1];
                return t || (t = []), t;
            }
            _getLayerIndex(e1) {
                let i = this.layerIndexes[e1];
                return i || (i = this.layerIndexes[e1] = new t), i;
            }
            _getWorkerSource(e1, t, i) {
                var s, r;
                if ((s = this.workerSources)[e1] || (s[e1] = {}), (r = this.workerSources[e1])[t] || (r[t] = {}), !this.workerSources[e1][t][i]) {
                    const s = {
                        sendAsync: (t, i)=>(t.targetMapId = e1, this.actor.sendAsync(t, i))
                    };
                    switch(t){
                        case "vector":
                            this.workerSources[e1][t][i] = new u(s, this._getLayerIndex(e1), this._getAvailableImages(e1));
                            break;
                        case "geojson":
                            this.workerSources[e1][t][i] = new p(s, this._getLayerIndex(e1), this._getAvailableImages(e1));
                            break;
                        default:
                            this.workerSources[e1][t][i] = new this.externalWorkerSourceTypes[t](s, this._getLayerIndex(e1), this._getAvailableImages(e1));
                    }
                }
                return this.workerSources[e1][t][i];
            }
            _getDEMWorkerSource(e1, t) {
                var i, s;
                return (i = this.demWorkerSources)[e1] || (i[e1] = {}), (s = this.demWorkerSources[e1])[t] || (s[t] = new g), this.demWorkerSources[e1][t];
            }
        }
        return e1.i(self) && (self.worker = new v(self)), v;
    });
    define("index", [
        "exports",
        "./shared"
    ], function(e1, t) {
        "use strict";
        var i = "5.24.0";
        function o() {
            var e1 = new t.A(4);
            return t.A != Float32Array && (e1[1] = 0, e1[2] = 0), e1[0] = 1, e1[3] = 1, e1;
        }
        let a, r, s;
        const n = {
            frame (e1, i, o, a) {
                const r = a || window, s = r.requestAnimationFrame((e1)=>{
                    n(), i(e1);
                }), { unsubscribe: n } = t.s(e1.signal, "abort", ()=>{
                    n(), r.cancelAnimationFrame(s), o(new t.a(e1.signal.reason));
                }, !1);
            },
            frameAsync (e1, t) {
                return new Promise((i, o)=>{
                    this.frame(e1, i, o, t);
                });
            },
            getImageData (e1, t = 0) {
                return this.getImageCanvasContext(e1).getImageData(-t, -t, e1.width + 2 * t, e1.height + 2 * t);
            },
            getImageCanvasContext (e1) {
                const t = window.document.createElement("canvas"), i = t.getContext("2d", {
                    willReadFrequently: !0
                });
                if (!i) throw new Error("failed to create canvas 2d context");
                return t.width = e1.width, t.height = e1.height, i.drawImage(e1, 0, 0, e1.width, e1.height), i;
            },
            resolveURL: (e1)=>(a || (a = document.createElement("a")), a.href = e1, a.href),
            hardwareConcurrency: "undefined" != typeof navigator && navigator.hardwareConcurrency || 4,
            get prefersReducedMotion () {
                return void 0 !== s ? s : !!matchMedia && (null != r || (r = matchMedia("(prefers-reduced-motion: reduce)")), r.matches);
            },
            set prefersReducedMotion (e){
                s = e;
            }
        }, l = new class {
            constructor(){
                this._frozenAt = null;
            }
            getCurrentTime() {
                return null !== this._frozenAt ? this._frozenAt : performance.now();
            }
            setNow(e1) {
                this._frozenAt = e1;
            }
            restoreNow() {
                this._frozenAt = null;
            }
            isFrozen() {
                return null !== this._frozenAt;
            }
        };
        function c() {
            return l.getCurrentTime();
        }
        var h, u;
        class d {
            static create(e1, t, i) {
                const o = window.document.createElement(e1);
                return void 0 !== t && (o.className = t), i && i.appendChild(o), o;
            }
            static createNS(e1, t) {
                return window.document.createElementNS(e1, t);
            }
            static disableDrag() {
                d.docStyle && d.selectProp && (d.userSelect = d.docStyle[d.selectProp], d.docStyle[d.selectProp] = "none");
            }
            static enableDrag() {
                d.docStyle && d.selectProp && (d.docStyle[d.selectProp] = d.userSelect);
            }
            static suppressClickInternal(e1) {
                e1.preventDefault(), e1.stopPropagation(), window.removeEventListener("click", d.suppressClickInternal, !0);
            }
            static suppressClick() {
                window.addEventListener("click", d.suppressClickInternal, !0), window.setTimeout(()=>{
                    window.removeEventListener("click", d.suppressClickInternal, !0);
                }, 0);
            }
            static getScale(e1) {
                const t = e1.getBoundingClientRect();
                return {
                    x: t.width / e1.offsetWidth || 1,
                    y: t.height / e1.offsetHeight || 1,
                    boundingClientRect: t
                };
            }
            static getPoint(e1, i, o) {
                const a = i.boundingClientRect;
                return new t.P((o.clientX - a.left) / i.x - e1.clientLeft, (o.clientY - a.top) / i.y - e1.clientTop);
            }
            static mousePos(e1, t) {
                const i = d.getScale(e1);
                return d.getPoint(e1, i, t);
            }
            static touchPos(e1, t) {
                const i = [], o = d.getScale(e1);
                for (const a of t)i.push(d.getPoint(e1, o, a));
                return i;
            }
            static sanitize(e1) {
                const t = (new DOMParser).parseFromString(e1, "text/html").body || document.createElement("body"), i = t.querySelectorAll("script");
                for (const e1 of i)e1.remove();
                return d.clean(t), t.innerHTML;
            }
            static isPossiblyDangerous(e1, t) {
                const i = t.replace(/\s+/g, "").toLowerCase();
                return !(![
                    "src",
                    "href",
                    "xlink:href"
                ].includes(e1) || !i.includes("javascript:") && !i.includes("data:")) || !!e1.startsWith("on") || void 0;
            }
            static clean(e1) {
                const t = e1.children;
                for (const e1 of t)d.removeAttributes(e1), d.clean(e1);
            }
            static removeAttributes(e1) {
                for (const { name: t, value: i } of e1.attributes)d.isPossiblyDangerous(t, i) && e1.removeAttribute(t);
            }
        }
        d.docStyle = "undefined" != typeof window && (null === (h = window.document) || void 0 === h ? void 0 : h.documentElement.style), d.selectProp = !d.docStyle || "userSelect" in d.docStyle ? "userSelect" : "webkitUserSelect", function(e1) {
            let i, o, a, r;
            e1.resetRequestQueue = ()=>{
                i = [], o = 0, a = 0, r = {};
            }, e1.addThrottleControl = (e1)=>{
                const t = a++;
                return r[t] = e1, t;
            }, e1.removeThrottleControl = (e1)=>{
                delete r[e1], n();
            }, e1.getImage = (e1, o, a = !0)=>new Promise((r, s)=>{
                    e1.headers || (e1.headers = {}), e1.headers.accept = "image/webp,*/*", t.e(e1, {
                        type: "image"
                    }), i.push({
                        abortController: o,
                        requestParameters: e1,
                        supportImageRefresh: a,
                        state: "queued",
                        onError: (e1)=>{
                            s(e1);
                        },
                        onSuccess: (e1)=>{
                            r(e1);
                        }
                    }), n();
                });
            const s = (e1)=>t._(this, void 0, void 0, function*() {
                    e1.state = "running";
                    const { requestParameters: i, supportImageRefresh: a, onError: r, onSuccess: s, abortController: c } = e1, h = !1 === a && !t.i(self) && !t.g(i.url) && (!i.headers || Object.keys(i.headers).reduce((e1, t)=>e1 && "accept" === t, !0));
                    o++;
                    const u = h ? l(i, c) : t.m(i, c);
                    try {
                        const i = yield u;
                        delete e1.abortController, e1.state = "completed", i.data instanceof HTMLImageElement || t.b(i.data) ? s(i) : i.data && s({
                            data: yield (d = i.data, "function" == typeof createImageBitmap ? t.h(d) : t.j(d)),
                            cacheControl: i.cacheControl,
                            expires: i.expires
                        });
                    } catch (i) {
                        delete e1.abortController, r(t.d(i));
                    } finally{
                        o--, n();
                    }
                    var d;
                }), n = ()=>{
                const e1 = (()=>{
                    for (const e1 of Object.keys(r))if (r[e1]()) return !0;
                    return !1;
                })() ? t.c.MAX_PARALLEL_IMAGE_REQUESTS_PER_FRAME : t.c.MAX_PARALLEL_IMAGE_REQUESTS;
                for(let t = o; t < e1 && i.length > 0; t++){
                    const e1 = i.shift();
                    e1.abortController.signal.aborted ? t-- : s(e1);
                }
            }, l = (e1, i)=>new Promise((o, a)=>{
                    const r = new Image, s = e1.url, n = e1.credentials;
                    n && "include" === n ? r.crossOrigin = "use-credentials" : (n && "same-origin" === n || !t.f(s)) && (r.crossOrigin = "anonymous"), i.signal.addEventListener("abort", ()=>{
                        r.src = "", a(new t.a(i.signal.reason));
                    }), r.fetchPriority = "high", r.onload = ()=>{
                        r.onerror = r.onload = null, o({
                            data: r
                        });
                    }, r.onerror = ()=>{
                        r.onerror = r.onload = null, i.signal.aborted || a(new Error("Could not load image. Please make sure to use a supported image type such as PNG or JPEG. Note that SVGs are not supported."));
                    }, r.src = s;
                });
        }(u || (u = {})), u.resetRequestQueue();
        class _ {
            constructor(e1){
                this._transformRequestFn = null != e1 ? e1 : null;
            }
            transformRequest(e1, t) {
                return this._transformRequestFn && this._transformRequestFn(e1, t) || {
                    url: e1
                };
            }
            setTransformRequest(e1) {
                this._transformRequestFn = e1;
            }
        }
        function p(e1) {
            const t = [];
            if ("string" == typeof e1) t.push({
                id: "default",
                url: e1
            });
            else if (e1 && e1.length > 0) {
                const i = [];
                for (const { id: o, url: a } of e1){
                    const e1 = `${o}${a}`;
                    i.includes(e1) || (i.push(e1), t.push({
                        id: o,
                        url: a
                    }));
                }
            }
            return t;
        }
        function m(e1, t, i) {
            try {
                const o = new URL(e1);
                return o.pathname += `${t}${i}`, o.toString();
            } catch (t) {
                throw new Error(`Invalid sprite URL "${e1}", must be absolute. Modify style specification directly or use TransformStyleFunction to correct the issue dynamically`);
            }
        }
        function f(e1) {
            const { userImage: t } = e1;
            return !(!(null == t ? void 0 : t.render) || !t.render() || (e1.data.replace(new Uint8Array(t.data.buffer)), 0));
        }
        class g extends t.E {
            constructor(){
                super(), this.images = {}, this.updatedImages = {}, this.callbackDispatchedThisFrame = {}, this.loaded = !1, this.requestors = [], this.patterns = {}, this.atlasImage = new t.R({
                    width: 1,
                    height: 1
                }), this.dirty = !0;
            }
            destroy() {
                this.atlasTexture && (this.atlasTexture.destroy(), this.atlasTexture = null);
                for (const e1 of Object.keys(this.images))this.removeImage(e1);
                this.patterns = {}, this.atlasImage = new t.R({
                    width: 1,
                    height: 1
                }), this.dirty = !0;
            }
            isLoaded() {
                return this.loaded;
            }
            setLoaded(e1) {
                if (this.loaded !== e1 && (this.loaded = e1, e1)) {
                    for (const { ids: e1, promiseResolve: t } of this.requestors)t(this._getImagesForIds(e1));
                    this.requestors = [];
                }
            }
            getImage(e1) {
                const i = this.images[e1];
                if (i && !i.data && i.spriteData) {
                    const e1 = i.spriteData;
                    i.data = new t.R({
                        width: e1.width,
                        height: e1.height
                    }, e1.context.getImageData(e1.x, e1.y, e1.width, e1.height).data), i.spriteData = null;
                }
                return i;
            }
            addImage(e1, t) {
                if (this.images[e1]) throw new Error(`Image id ${e1} already exist, use updateImage instead`);
                this._validate(e1, t) && (this.images[e1] = t);
            }
            _validate(e1, i) {
                let o = !0;
                const a = i.data || i.spriteData;
                return this._validateStretch(i.stretchX, null == a ? void 0 : a.width) || (this.fire(new t.l(new Error(`Image "${e1}" has invalid "stretchX" value`))), o = !1), this._validateStretch(i.stretchY, null == a ? void 0 : a.height) || (this.fire(new t.l(new Error(`Image "${e1}" has invalid "stretchY" value`))), o = !1), this._validateContent(i.content, i) || (this.fire(new t.l(new Error(`Image "${e1}" has invalid "content" value`))), o = !1), o;
            }
            _validateStretch(e1, t) {
                if (!e1) return !0;
                let i = 0;
                for (const o of e1){
                    if (o[0] < i || o[1] < o[0] || t < o[1]) return !1;
                    i = o[1];
                }
                return !0;
            }
            _validateContent(e1, t) {
                if (!e1) return !0;
                if (4 !== e1.length) return !1;
                const i = t.spriteData, o = (null == i ? void 0 : i.width) || t.data.width, a = (null == i ? void 0 : i.height) || t.data.height;
                return !(e1[0] < 0 || o < e1[0] || e1[1] < 0 || a < e1[1] || e1[2] < 0 || o < e1[2] || e1[3] < 0 || a < e1[3] || e1[2] < e1[0] || !(e1[3] >= e1[1]));
            }
            updateImage(e1, t, i = !0) {
                const o = this.getImage(e1);
                if (i && (o.data.width !== t.data.width || o.data.height !== t.data.height)) throw new Error(`size mismatch between old image (${o.data.width}x${o.data.height}) and new image (${t.data.width}x${t.data.height}).`);
                t.version = o.version + 1, this.images[e1] = t, this.updatedImages[e1] = !0;
            }
            removeImage(e1) {
                var t;
                const i = this.images[e1];
                delete this.images[e1], delete this.patterns[e1], (null === (t = i.userImage) || void 0 === t ? void 0 : t.onRemove) && i.userImage.onRemove();
            }
            listImages() {
                return Object.keys(this.images);
            }
            getImages(e1) {
                return new Promise((t, i)=>{
                    let o = !0;
                    if (!this.isLoaded()) for (const t of e1)this.images[t] || (o = !1);
                    this.isLoaded() || o ? t(this._getImagesForIds(e1)) : this.requestors.push({
                        ids: e1,
                        promiseResolve: t
                    });
                });
            }
            _getImagesForIds(e1) {
                var i;
                const o = {};
                for (const a of e1){
                    let e1 = this.getImage(a);
                    e1 || (this.fire(new t.n("styleimagemissing", {
                        id: a
                    })), e1 = this.getImage(a)), e1 ? o[a] = {
                        data: e1.data.clone(),
                        pixelRatio: e1.pixelRatio,
                        sdf: e1.sdf,
                        version: e1.version,
                        stretchX: e1.stretchX,
                        stretchY: e1.stretchY,
                        content: e1.content,
                        textFitWidth: e1.textFitWidth,
                        textFitHeight: e1.textFitHeight,
                        hasRenderCallback: Boolean(null === (i = e1.userImage) || void 0 === i ? void 0 : i.render)
                    } : t.w(`Image "${a}" could not be loaded. Please make sure you have added the image with map.addImage() or a "sprite" property in your style. You can provide missing images by listening for the "styleimagemissing" map event.`);
                }
                return o;
            }
            getPixelSize() {
                const { width: e1, height: t } = this.atlasImage;
                return {
                    width: e1,
                    height: t
                };
            }
            getPattern(e1) {
                const i = this.patterns[e1], o = this.getImage(e1);
                if (!o) return null;
                if (i && i.position.version === o.version) return i.position;
                if (i) i.position.version = o.version;
                else {
                    const i = {
                        w: o.data.width + 2,
                        h: o.data.height + 2,
                        x: 0,
                        y: 0
                    }, a = new t.I(i, o);
                    this.patterns[e1] = {
                        bin: i,
                        position: a
                    };
                }
                return this._updatePatternAtlas(), this.patterns[e1].position;
            }
            bind(e1) {
                const i = e1.gl;
                this.atlasTexture ? this.dirty && (this.atlasTexture.update(this.atlasImage), this.dirty = !1) : this.atlasTexture = new t.T(e1, this.atlasImage, i.RGBA), this.atlasTexture.bind(i.LINEAR, i.CLAMP_TO_EDGE);
            }
            _updatePatternAtlas() {
                const e1 = [];
                for(const t in this.patterns)e1.push(this.patterns[t].bin);
                const { w: i, h: o } = t.p(e1), a = this.atlasImage;
                a.resize({
                    width: i || 1,
                    height: o || 1
                });
                for(const e1 in this.patterns){
                    const { bin: i } = this.patterns[e1], o = i.x + 1, r = i.y + 1, s = this.getImage(e1).data, n = s.width, l = s.height;
                    t.R.copy(s, a, {
                        x: 0,
                        y: 0
                    }, {
                        x: o,
                        y: r
                    }, {
                        width: n,
                        height: l
                    }), t.R.copy(s, a, {
                        x: 0,
                        y: l - 1
                    }, {
                        x: o,
                        y: r - 1
                    }, {
                        width: n,
                        height: 1
                    }), t.R.copy(s, a, {
                        x: 0,
                        y: 0
                    }, {
                        x: o,
                        y: r + l
                    }, {
                        width: n,
                        height: 1
                    }), t.R.copy(s, a, {
                        x: n - 1,
                        y: 0
                    }, {
                        x: o - 1,
                        y: r
                    }, {
                        width: 1,
                        height: l
                    }), t.R.copy(s, a, {
                        x: 0,
                        y: 0
                    }, {
                        x: o + n,
                        y: r
                    }, {
                        width: 1,
                        height: l
                    });
                }
                this.dirty = !0;
            }
            beginFrame() {
                this.callbackDispatchedThisFrame = {};
            }
            dispatchRenderCallbacks(e1) {
                for (const i of e1){
                    if (this.callbackDispatchedThisFrame[i]) continue;
                    this.callbackDispatchedThisFrame[i] = !0;
                    const e1 = this.getImage(i);
                    e1 || t.w(`Image with ID: "${i}" was not found`), f(e1) && this.updateImage(i, e1);
                }
            }
            cloneImages() {
                const e1 = {};
                for(const t in this.images){
                    const i = this.images[t];
                    e1[t] = Object.assign(Object.assign({}, i), {
                        data: i.data ? i.data.clone() : null
                    });
                }
                return e1;
            }
        }
        const v = 1e20, x = new Float64Array(256);
        for(let e1 = 0; e1 < 256; e1++){
            const t = .5 - Math.pow(e1 / 255, 1 / 2.2);
            x[e1] = t * Math.abs(t);
        }
        function b(e1, t, i, o, a, r, s, n, l) {
            for(let c = t; c < t + o; c++)y(e1, i * r + c, r, a, s, n, l);
            for(let c = i; c < i + a; c++)y(e1, c * r + t, 1, o, s, n, l);
        }
        function y(e1, t, i, o, a, r, s) {
            r[0] = 0, s[0] = -v, s[1] = v, a[0] = e1[t];
            for(let n = 1, l = 0, c = 0; n < o; n++){
                a[n] = e1[t + n * i];
                const o = n * n;
                do {
                    const e1 = r[l];
                    c = (a[n] - a[e1] + o - e1 * e1) / (n - e1) / 2;
                }while (c <= s[l] && --l > -1);
                l++, r[l] = n, s[l] = c, s[l + 1] = v;
            }
            for(let n = 0, l = 0; n < o; n++){
                for(; s[l + 1] < n;)l++;
                const o = r[l], c = n - o;
                e1[t + n * i] = a[o] + c * c;
            }
        }
        x[255] = -v;
        const w = t.v.layout_symbol["text-font"].default.join(",");
        class T {
            constructor(e1, t, i){
                this.requestManager = e1, this.localIdeographFontFamily = t, this.entries = {}, this.lang = i;
            }
            setURL(e1) {
                this.url = e1;
            }
            getGlyphs(e1) {
                return t._(this, void 0, void 0, function*() {
                    const t = [];
                    for(const i in e1)for (const o of e1[i])t.push(this._getAndCacheGlyphsPromise(i, o));
                    const i = yield Promise.all(t), o = {};
                    for (const { stack: e1, id: t, glyph: a } of i)o[e1] || (o[e1] = {}), o[e1][t] = a && {
                        id: a.id,
                        bitmap: a.bitmap.clone(),
                        metrics: a.metrics
                    };
                    return o;
                });
            }
            _getAndCacheGlyphsPromise(e1, i) {
                return t._(this, void 0, void 0, function*() {
                    var t, o;
                    null !== (t = (o = this.entries)[e1]) && void 0 !== t || (o[e1] = {
                        glyphs: {},
                        requests: {},
                        ranges: {}
                    });
                    const a = this.entries[e1];
                    let r = a.glyphs[i];
                    return void 0 !== r ? {
                        stack: e1,
                        id: i,
                        glyph: r
                    } : !this.url || this._charUsesLocalIdeographFontFamily(i) ? (r = a.glyphs[i] = this._drawGlyph(a, e1, i), {
                        stack: e1,
                        id: i,
                        glyph: r
                    }) : yield this._downloadAndCacheRangePromise(e1, i);
                });
            }
            _downloadAndCacheRangePromise(e1, i) {
                return t._(this, void 0, void 0, function*() {
                    var o;
                    const a = this.entries[e1], r = Math.floor(i / 256);
                    if (a.ranges[r]) return {
                        stack: e1,
                        id: i,
                        glyph: null
                    };
                    (o = a.requests)[r] || (o[r] = T.loadGlyphRange(e1, r, this.url, this.requestManager));
                    try {
                        const t = yield a.requests[r];
                        for(const e1 in t)a.glyphs[+e1] = t[+e1];
                        return a.ranges[r] = !0, {
                            stack: e1,
                            id: i,
                            glyph: t[i] || null
                        };
                    } catch (o) {
                        const s = a.glyphs[i] = this._drawGlyph(a, e1, i);
                        return this._warnOnMissingGlyphRange(s, r, i, t.d(o)), {
                            stack: e1,
                            id: i,
                            glyph: s
                        };
                    }
                });
            }
            _warnOnMissingGlyphRange(e1, i, o, a) {
                const r = 256 * i, s = r + 255, n = o.toString(16).padStart(4, "0").toUpperCase();
                t.w(`Unable to load glyph range ${i}, ${r}-${s}. Rendering codepoint U+${n} locally instead. ${a}`);
            }
            _charUsesLocalIdeographFontFamily(e1) {
                return !!this.localIdeographFontFamily && t.r(e1);
            }
            _drawGlyph(e1, i, o) {
                const a = i === w && "" !== this.localIdeographFontFamily && this._charUsesLocalIdeographFontFamily(o), r = a ? "ideographTinySDF" : "tinySDF";
                e1[r] || (e1[r] = this._createTinySDF(a ? this.localIdeographFontFamily : i));
                const s = e1[r].draw(String.fromCodePoint(o)), n = /^\p{gc=Cf}+$/u.test(String.fromCodePoint(o));
                return {
                    id: o,
                    bitmap: new t.t({
                        width: s.width || 60,
                        height: s.height || 60
                    }, s.data),
                    metrics: {
                        width: n ? 0 : s.glyphWidth / 2 || 24,
                        height: s.glyphHeight / 2 || 24,
                        left: s.glyphLeft / 2 + .5 || 0,
                        top: s.glyphTop / 2 - 27.5 || -8,
                        advance: n ? 0 : s.glyphAdvance / 2 || 24,
                        isDoubleResolution: !0
                    }
                };
            }
            _createTinySDF(e1) {
                const t = e1 ? e1.split(",") : [];
                t.push("sans-serif");
                const i = t.map((e1)=>/[-\w]+/.test(e1) ? e1 : `'${CSS.escape(e1)}'`).join(",");
                return new T.TinySDF({
                    fontSize: 48,
                    buffer: 6,
                    radius: 16,
                    cutoff: .25,
                    fontFamily: i,
                    fontWeight: this._fontWeight(t[0]),
                    fontStyle: this._fontStyle(t[0]),
                    lang: this.lang
                });
            }
            _fontStyle(e1) {
                return /italic/i.test(e1) ? "italic" : /oblique/i.test(e1) ? "oblique" : "normal";
            }
            _fontWeight(e1) {
                const t = {
                    thin: 100,
                    hairline: 100,
                    "extra light": 200,
                    "ultra light": 200,
                    light: 300,
                    normal: 400,
                    regular: 400,
                    medium: 500,
                    semibold: 600,
                    demibold: 600,
                    bold: 700,
                    "extra bold": 800,
                    "ultra bold": 800,
                    black: 900,
                    heavy: 900,
                    "extra black": 950,
                    "ultra black": 950
                };
                let i;
                for (const [o, a] of Object.entries(t))new RegExp(`\\b${o}\\b`, "i").test(e1) && (i = `${a}`);
                return i;
            }
            destroy() {
                for(const e1 in this.entries){
                    const t = this.entries[e1];
                    t.tinySDF = null, t.ideographTinySDF = null, t.glyphs = {}, t.requests = {}, t.ranges = {};
                }
                this.entries = {};
            }
        }
        T.loadGlyphRange = function(e1, i, o, a) {
            return t._(this, void 0, void 0, function*() {
                const r = 256 * i, s = r + 255, n = yield a.transformRequest(o.replace("{fontstack}", e1).replace("{range}", `${r}-${s}`), "Glyphs"), l = yield t.o(n, new AbortController);
                if (!(null == l ? void 0 : l.data)) throw new Error(`Could not load glyph range. range: ${i}, ${r}-${s}`);
                const c = {};
                for (const e1 of t.q(l.data))c[e1.id] = e1;
                return c;
            });
        }, T.TinySDF = class {
            constructor({ fontSize: e1 = 24, buffer: t = 3, radius: i = 8, cutoff: o = .25, fontFamily: a = "sans-serif", fontWeight: r = "normal", fontStyle: s = "normal", lang: n = null } = {}){
                this.buffer = t, this.radius = i, this.cutoff = o, this.lang = n;
                const l = this.size = e1 + 4 * t, c = this._createCanvas(l), h = this.ctx = c.getContext("2d", {
                    willReadFrequently: !0
                });
                h.font = `${s} ${r} ${e1}px ${a}`, h.textBaseline = "alphabetic", h.textAlign = "left", h.fillStyle = "black", this.gridOuter = new Float64Array(l * l), this.gridInner = new Float64Array(l * l), this.f = new Float64Array(l), this.z = new Float64Array(l + 1), this.v = new Uint16Array(l);
            }
            _createCanvas(e1) {
                if ("undefined" != typeof OffscreenCanvas) return new OffscreenCanvas(e1, e1);
                const t = document.createElement("canvas");
                return t.width = t.height = e1, t;
            }
            draw(e1) {
                const { width: t, actualBoundingBoxAscent: i, actualBoundingBoxDescent: o, actualBoundingBoxLeft: a, actualBoundingBoxRight: r } = this.ctx.measureText(e1), s = Math.ceil(i), n = Math.floor(a), l = Math.max(0, Math.min(this.size - this.buffer, Math.ceil(r) - n)), c = Math.max(0, Math.min(this.size - this.buffer, s + Math.ceil(o))), h = l + 2 * this.buffer, u = c + 2 * this.buffer, d = Math.max(h * u, 0), _ = new Uint8ClampedArray(d), p = {
                    data: _,
                    width: h,
                    height: u,
                    glyphWidth: l,
                    glyphHeight: c,
                    glyphTop: s,
                    glyphLeft: n,
                    glyphAdvance: t
                };
                if (0 === l || 0 === c) return p;
                const { ctx: m, buffer: f, gridInner: g, gridOuter: y } = this;
                this.lang && (m.lang = this.lang), m.clearRect(f, f, l, c), m.fillText(e1, f - n, f + s);
                const w = m.getImageData(f, f, l, c);
                y.fill(v, 0, d), g.fill(0, 0, d);
                let T = 3;
                for(let e1 = 0; e1 < c; e1++){
                    let t = (e1 + f) * h + f;
                    for(let e1 = 0; e1 < l; e1++, T += 4, t++){
                        const e1 = w.data[T];
                        if (0 === e1) continue;
                        const i = x[e1];
                        y[t] = Math.max(0, i), g[t] = Math.max(0, -i);
                    }
                }
                b(y, 0, 0, h, u, h, this.f, this.v, this.z), b(g, f, f, l, c, h, this.f, this.v, this.z);
                const P = 255 / this.radius, C = 255 * (1 - this.cutoff);
                for(let e1 = 0; e1 < d; e1++){
                    const t = Math.sqrt(y[e1]) - Math.sqrt(g[e1]);
                    _[e1] = Math.round(C - P * t);
                }
                return p;
            }
        };
        class P {
            constructor(){
                this.specification = t.x.light.position;
            }
            possiblyEvaluate(e1, i) {
                return t.G(e1.expression.evaluate(i));
            }
            interpolate(e1, i, o) {
                return {
                    x: t.H.number(e1.x, i.x, o),
                    y: t.H.number(e1.y, i.y, o),
                    z: t.H.number(e1.z, i.z, o)
                };
            }
        }
        let C;
        class M extends t.E {
            constructor(e1){
                super(), C || (C = new t.u({
                    anchor: new t.D(t.x.light.anchor),
                    position: new P,
                    color: new t.D(t.x.light.color),
                    intensity: new t.D(t.x.light.intensity)
                })), this._transitionable = new t.y(C, void 0), this.setLight(e1), this._transitioning = this._transitionable.untransitioned();
            }
            getLight() {
                return this._transitionable.serialize();
            }
            setLight(e1, i = {}) {
                if (!this._validate(t.z, e1, i)) for(const i in e1){
                    const o = e1[i];
                    i.endsWith(t.B) ? this._transitionable.setTransition(i.slice(0, -t.B.length), o) : this._transitionable.setValue(i, o);
                }
            }
            updateTransitions(e1) {
                this._transitioning = this._transitionable.transitioned(e1, this._transitioning);
            }
            hasTransition() {
                return this._transitioning.hasTransition();
            }
            recalculate(e1) {
                this.properties = this._transitioning.possiblyEvaluate(e1);
            }
            _validate(e1, i, o) {
                return !1 !== (null == o ? void 0 : o.validate) && t.C(this, e1.call(t.F, {
                    value: i,
                    style: {
                        glyphs: !0,
                        sprite: !0
                    },
                    styleSpec: t.x
                }));
            }
        }
        const I = new t.u({
            "sky-color": new t.D(t.x.sky["sky-color"]),
            "horizon-color": new t.D(t.x.sky["horizon-color"]),
            "fog-color": new t.D(t.x.sky["fog-color"]),
            "fog-ground-blend": new t.D(t.x.sky["fog-ground-blend"]),
            "horizon-fog-blend": new t.D(t.x.sky["horizon-fog-blend"]),
            "sky-horizon-blend": new t.D(t.x.sky["sky-horizon-blend"]),
            "atmosphere-blend": new t.D(t.x.sky["atmosphere-blend"])
        });
        class E extends t.E {
            constructor(e1){
                super(), this._transitionable = new t.y(I, void 0), this.setSky(e1), this._transitioning = this._transitionable.untransitioned(), this.recalculate(new t.J(0));
            }
            setSky(e1, i = {}) {
                if (!this._validate(t.K, e1, i)) {
                    e1 || (e1 = {
                        "sky-color": "transparent",
                        "horizon-color": "transparent",
                        "fog-color": "transparent",
                        "fog-ground-blend": 1,
                        "atmosphere-blend": 0
                    });
                    for(const i in e1){
                        const o = e1[i];
                        i.endsWith(t.B) ? this._transitionable.setTransition(i.slice(0, -t.B.length), o) : this._transitionable.setValue(i, o);
                    }
                }
            }
            getSky() {
                return this._transitionable.serialize();
            }
            updateTransitions(e1) {
                this._transitioning = this._transitionable.transitioned(e1, this._transitioning);
            }
            hasTransition() {
                return this._transitioning.hasTransition();
            }
            recalculate(e1) {
                this.properties = this._transitioning.possiblyEvaluate(e1);
            }
            _validate(e1, i, o = {}) {
                return !1 !== (null == o ? void 0 : o.validate) && t.C(this, e1.call(t.F, t.e({
                    value: i,
                    style: {
                        glyphs: !0,
                        sprite: !0
                    },
                    styleSpec: t.x
                })));
            }
            calculateFogBlendOpacity(e1) {
                return e1 < 60 ? 0 : e1 < 70 ? (e1 - 60) / 10 : 1;
            }
        }
        class S {
            constructor(e1, t){
                this.width = e1, this.height = t, this.nextRow = 0, this.data = new Uint8Array(this.width * this.height), this.dashEntry = {};
            }
            getDash(e1, t) {
                var i;
                const o = e1.join(",") + String(t);
                return (i = this.dashEntry)[o] || (i[o] = this.addDash(e1, t)), this.dashEntry[o];
            }
            getDashRanges(e1, t, i) {
                const o = [];
                let a = e1.length % 2 == 1 ? -e1[e1.length - 1] * i : 0, r = e1[0] * i, s = !0;
                o.push({
                    left: a,
                    right: r,
                    isDash: s,
                    zeroLength: 0 === e1[0]
                });
                let n = e1[0];
                for(let t = 1; t < e1.length; t++){
                    s = !s;
                    const l = e1[t];
                    a = n * i, n += l, r = n * i, o.push({
                        left: a,
                        right: r,
                        isDash: s,
                        zeroLength: 0 === l
                    });
                }
                return o;
            }
            addRoundDash(e1, t, i) {
                const o = t / 2;
                for(let t = -i; t <= i; t++){
                    const a = this.width * (this.nextRow + i + t);
                    let r = 0, s = e1[r];
                    for(let n = 0; n < this.width; n++){
                        n / s.right > 1 && (s = e1[++r]);
                        const l = Math.abs(n - s.left), c = Math.abs(n - s.right), h = Math.min(l, c);
                        let u;
                        const d = t / i * (o + 1);
                        if (s.isDash) {
                            const e1 = o - Math.abs(d);
                            u = Math.sqrt(h * h + e1 * e1);
                        } else u = o - Math.sqrt(h * h + d * d);
                        this.data[a + n] = Math.max(0, Math.min(255, u + 128));
                    }
                }
            }
            addRegularDash(e1) {
                for(let t = e1.length - 1; t >= 0; --t){
                    const i = e1[t], o = e1[t + 1];
                    i.zeroLength ? e1.splice(t, 1) : o && o.isDash === i.isDash && (o.left = i.left, e1.splice(t, 1));
                }
                const t = e1[0], i = e1[e1.length - 1];
                t.isDash === i.isDash && (t.left = i.left - this.width, i.right = t.right + this.width);
                const o = this.width * this.nextRow;
                let a = 0, r = e1[a];
                for(let t = 0; t < this.width; t++){
                    t / r.right > 1 && (r = e1[++a]);
                    const i = Math.abs(t - r.left), s = Math.abs(t - r.right), n = Math.min(i, s);
                    this.data[o + t] = Math.max(0, Math.min(255, (r.isDash ? n : -n) + 128));
                }
            }
            addDash(e1, i) {
                const o = i ? 7 : 0, a = 2 * o + 1;
                if (this.nextRow + a > this.height) return t.w("LineAtlas out of space"), null;
                let r = 0;
                for (const t of e1)r += t;
                if (0 !== r) {
                    const t = this.width / r, a = this.getDashRanges(e1, this.width, t);
                    i ? this.addRoundDash(a, t, o) : this.addRegularDash(a);
                }
                const s = {
                    y: this.nextRow + o,
                    height: 2 * o,
                    width: r
                };
                return this.nextRow += a, this.dirty = !0, s;
            }
            bind(e1) {
                const t = e1.gl;
                this.texture ? (t.bindTexture(t.TEXTURE_2D, this.texture), this.dirty && (this.dirty = !1, t.texSubImage2D(t.TEXTURE_2D, 0, 0, 0, this.width, this.height, t.ALPHA, t.UNSIGNED_BYTE, this.data))) : (this.texture = t.createTexture(), t.bindTexture(t.TEXTURE_2D, this.texture), t.texParameteri(t.TEXTURE_2D, t.TEXTURE_WRAP_S, t.REPEAT), t.texParameteri(t.TEXTURE_2D, t.TEXTURE_WRAP_T, t.REPEAT), t.texParameteri(t.TEXTURE_2D, t.TEXTURE_MIN_FILTER, t.LINEAR), t.texParameteri(t.TEXTURE_2D, t.TEXTURE_MAG_FILTER, t.LINEAR), t.texImage2D(t.TEXTURE_2D, 0, t.ALPHA, this.width, this.height, 0, t.ALPHA, t.UNSIGNED_BYTE, this.data));
            }
        }
        const z = "maplibre_preloaded_worker_pool";
        class R {
            constructor(){
                this.active = {};
            }
            acquire(e1) {
                if (!this.workers) for(this.workers = []; this.workers.length < R.workerCount;)this.workers.push(new Worker(t.c.WORKER_URL));
                return this.active[e1] = !0, this.workers.slice();
            }
            release(e1) {
                if (delete this.active[e1], 0 === this.numActive()) {
                    for (const e1 of this.workers)e1.terminate();
                    this.workers = null;
                }
            }
            isPreloaded() {
                return !!this.active[z];
            }
            numActive() {
                return Object.keys(this.active).length;
            }
        }
        const D = Math.floor(n.hardwareConcurrency / 2);
        let A, L;
        function F() {
            return A || (A = new R), A;
        }
        R.workerCount = t.L(globalThis) ? Math.max(Math.min(D, 3), 1) : 1;
        class k {
            constructor(e1, i){
                this.workerPool = e1, this.actors = [], this.currentActor = 0, this.id = i;
                const o = this.workerPool.acquire(i);
                for(let e1 = 0; e1 < o.length; e1++){
                    const a = new t.N(o[e1], i);
                    a.name = `Worker ${e1}`, this.actors.push(a);
                }
                if (!this.actors.length) throw new Error("No actors found");
            }
            broadcast(e1, t) {
                const i = [];
                for (const o of this.actors)i.push(o.sendAsync({
                    type: e1,
                    data: t
                }));
                return Promise.all(i);
            }
            getActor() {
                return this.currentActor = (this.currentActor + 1) % this.actors.length, this.actors[this.currentActor];
            }
            remove(e1 = !0) {
                for (const e1 of this.actors)e1.remove();
                this.actors = [], e1 && this.workerPool.release(this.id);
            }
            registerMessageHandler(e1, t) {
                for (const i of this.actors)i.registerMessageHandler(e1, t);
            }
            unregisterMessageHandler(e1) {
                for (const t of this.actors)t.unregisterMessageHandler(e1);
            }
        }
        function B() {
            return L || (L = new k(F(), t.M), L.registerMessageHandler("GR", (e1, i, o)=>t.m(i, o))), L;
        }
        function O(e1, i) {
            const o = t.O();
            return t.Q(o, o, [
                1,
                1,
                0
            ]), t.S(o, o, [
                .5 * e1.width,
                .5 * e1.height,
                1
            ]), e1.calculatePosMatrix ? t.U(o, o, e1.calculatePosMatrix(i.toUnwrapped())) : o;
        }
        function j(e1, t, i, o, a, r, s) {
            var n;
            const l = function(e1, t, i) {
                if (e1) for (const o of e1){
                    const e1 = t[o];
                    if ((null == e1 ? void 0 : e1.source) === i && "fill-extrusion" === e1.type) return !0;
                }
                else for(const e1 in t){
                    const o = t[e1];
                    if (o.source === i && "fill-extrusion" === o.type) return !0;
                }
                return !1;
            }(null !== (n = null == a ? void 0 : a.layers) && void 0 !== n ? n : null, t, e1.id), c = r.maxPitchScaleFactor(), h = e1.tilesIn(o, c, l);
            h.sort(N);
            const u = [];
            for (const o of h)u.push({
                wrappedTileID: o.tileID.wrapped().key,
                queryResults: o.tile.queryRenderedFeatures(t, i, e1.getState(), o.queryGeometry, o.cameraQueryGeometry, o.scale, a, r, c, O(r, o.tileID), s ? (e1, t)=>s(o.tileID, e1, t) : void 0)
            });
            return function(e1, t) {
                for(const i in e1)for (const o of e1[i])Z(o, t);
                return e1;
            }(function(e1) {
                const t = {}, i = {};
                for (const { queryResults: o, wrappedTileID: a } of e1){
                    i[a] || (i[a] = {});
                    const e1 = i[a];
                    for(const i in o){
                        const a = o[i];
                        e1[i] || (e1[i] = {});
                        const r = e1[i];
                        t[i] || (t[i] = []);
                        for (const e1 of a)r[e1.featureIndex] || (r[e1.featureIndex] = !0, t[i].push(e1));
                    }
                }
                return t;
            }(u), e1);
        }
        function N(e1, t) {
            const i = e1.tileID, o = t.tileID;
            return i.overscaledZ - o.overscaledZ || i.canonical.y - o.canonical.y || i.wrap - o.wrap || i.canonical.x - o.canonical.x;
        }
        function Z(e1, t) {
            const i = e1.feature, o = t.getFeatureState(i.layer["source-layer"], i.id);
            i.source = i.layer.source, i.layer["source-layer"] && (i.sourceLayer = i.layer["source-layer"]), i.state = o;
        }
        function U(e1, i, o, a) {
            return t._(this, void 0, void 0, function*() {
                let r = e1;
                if (e1.url ? r = (yield t.k((yield i.transformRequest(e1.url, "Source")), o)).data : yield n.frameAsync(o, a), !r) return null;
                const s = t.V(t.e(r, e1), [
                    "tiles",
                    "minzoom",
                    "maxzoom",
                    "attribution",
                    "bounds",
                    "scheme",
                    "tileSize",
                    "encoding"
                ]);
                return "vector_layers" in r && r.vector_layers && (s.vectorLayerIds = r.vector_layers.map((e1)=>e1.id)), s;
            });
        }
        class G {
            constructor(e1, t){
                e1 && (t ? this.setSouthWest(e1).setNorthEast(t) : Array.isArray(e1) && (4 === e1.length ? this.setSouthWest([
                    e1[0],
                    e1[1]
                ]).setNorthEast([
                    e1[2],
                    e1[3]
                ]) : this.setSouthWest(e1[0]).setNorthEast(e1[1])));
            }
            setNorthEast(e1) {
                return this._ne = e1 instanceof t.W ? new t.W(e1.lng, e1.lat) : t.W.convert(e1), this;
            }
            setSouthWest(e1) {
                return this._sw = e1 instanceof t.W ? new t.W(e1.lng, e1.lat) : t.W.convert(e1), this;
            }
            extend(e1) {
                const i = this._sw, o = this._ne;
                let a, r;
                if (e1 instanceof t.W) a = e1, r = e1;
                else {
                    if (!(e1 instanceof G)) return Array.isArray(e1) ? 4 === e1.length || e1.every(Array.isArray) ? this.extend(G.convert(e1)) : this.extend(t.W.convert(e1)) : e1 && ("lng" in e1 || "lon" in e1) && "lat" in e1 ? this.extend(t.W.convert(e1)) : this;
                    if (a = e1._sw, r = e1._ne, !a || !r) return this;
                }
                return i || o ? (i.lng = Math.min(a.lng, i.lng), i.lat = Math.min(a.lat, i.lat), o.lng = Math.max(r.lng, o.lng), o.lat = Math.max(r.lat, o.lat)) : (this._sw = new t.W(a.lng, a.lat), this._ne = new t.W(r.lng, r.lat)), this;
            }
            getCenter() {
                return new t.W((this._sw.lng + this._ne.lng) / 2, (this._sw.lat + this._ne.lat) / 2);
            }
            getSouthWest() {
                return this._sw;
            }
            getNorthEast() {
                return this._ne;
            }
            getNorthWest() {
                return new t.W(this.getWest(), this.getNorth());
            }
            getSouthEast() {
                return new t.W(this.getEast(), this.getSouth());
            }
            getWest() {
                return this._sw.lng;
            }
            getSouth() {
                return this._sw.lat;
            }
            getEast() {
                return this._ne.lng;
            }
            getNorth() {
                return this._ne.lat;
            }
            toArray() {
                return [
                    this._sw.toArray(),
                    this._ne.toArray()
                ];
            }
            toString() {
                return `LngLatBounds(${this._sw.toString()}, ${this._ne.toString()})`;
            }
            isEmpty() {
                return !(this._sw && this._ne);
            }
            contains(e1) {
                const { lng: i, lat: o } = t.W.convert(e1);
                let a = this._sw.lng <= i && i <= this._ne.lng;
                return this._sw.lng > this._ne.lng && (a = this._sw.lng >= i && i >= this._ne.lng), this._sw.lat <= o && o <= this._ne.lat && a;
            }
            intersects(e1) {
                if (!((e1 = G.convert(e1)).getNorth() >= this.getSouth() && e1.getSouth() <= this.getNorth())) return !1;
                const i = Math.abs(this.getEast() - this.getWest()), o = Math.abs(e1.getEast() - e1.getWest());
                if (i >= 360 || o >= 360) return !0;
                const a = t.X(this.getWest(), -180, 180), r = t.X(this.getEast(), -180, 180), s = t.X(e1.getWest(), -180, 180), n = t.X(e1.getEast(), -180, 180), l = a > r, c = s > n;
                return !(!l || !c) || (l ? n >= a || s <= r : c ? r >= s || a <= n : s <= r && n >= a);
            }
            static convert(e1) {
                return e1 instanceof G ? e1 : e1 ? new G(e1) : e1;
            }
            static fromLngLat(e1, i = 0) {
                const o = 360 * i / 40075017, a = o / Math.cos(Math.PI / 180 * e1.lat);
                return new G(new t.W(e1.lng - a, e1.lat - o), new t.W(e1.lng + a, e1.lat + o));
            }
            adjustAntiMeridian() {
                const e1 = new t.W(this._sw.lng, this._sw.lat), i = new t.W(this._ne.lng, this._ne.lat);
                return new G(e1, e1.lng > i.lng ? new t.W(i.lng + 360, i.lat) : i);
            }
        }
        class V {
            constructor(e1, t, i){
                this.bounds = G.convert(this.validateBounds(e1)), this.minzoom = t || 0, this.maxzoom = i || 24;
            }
            validateBounds(e1) {
                return Array.isArray(e1) && 4 === e1.length ? [
                    Math.max(-180, e1[0]),
                    Math.max(-90, e1[1]),
                    Math.min(180, e1[2]),
                    Math.min(90, e1[3])
                ] : [
                    -180,
                    -90,
                    180,
                    90
                ];
            }
            contains(e1) {
                const i = Math.pow(2, e1.z), o = Math.floor(t.Z(this.bounds.getWest()) * i), a = Math.floor(t.Y(this.bounds.getNorth()) * i), r = Math.ceil(t.Z(this.bounds.getEast()) * i), s = Math.ceil(t.Y(this.bounds.getSouth()) * i);
                return e1.x >= o && e1.x < r && e1.y >= a && e1.y < s;
            }
        }
        class W extends t.E {
            constructor(e1, i, o, a){
                if (super(), this.id = e1, this.dispatcher = o, this.type = "vector", this.minzoom = 0, this.maxzoom = 22, this.scheme = "xyz", this.tileSize = 512, this.reparseOverscaled = !0, this.isTileClipped = !0, this._loaded = !1, t.e(this, t.V(i, [
                    "url",
                    "scheme",
                    "tileSize",
                    "promoteId",
                    "encoding"
                ])), this._options = t.e({
                    type: "vector"
                }, i), this._collectResourceTiming = i.collectResourceTiming, 512 !== this.tileSize) throw new Error("vector tile sources must have a tileSize of 512");
                this.setEventedParent(a);
            }
            load() {
                return t._(this, arguments, void 0, function*(e1 = !1) {
                    this._loaded = !1, this.fire(new t.n("dataloading", {
                        dataType: "source"
                    })), this._tileJSONRequest = new AbortController;
                    try {
                        const i = yield U(this._options, this.map._requestManager, this._tileJSONRequest, this.map._ownerWindow);
                        this._tileJSONRequest = null, this._loaded = !0, i && (t.e(this, i), i.bounds && (this.tileBounds = new V(i.bounds, this.minzoom, this.maxzoom)), this.fire(new t.n("data", {
                            dataType: "source",
                            sourceDataType: "metadata"
                        })), this.fire(new t.n("data", {
                            dataType: "source",
                            sourceDataType: "content",
                            sourceDataChanged: e1
                        })));
                    } catch (e1) {
                        this._tileJSONRequest = null, this._loaded = !0, t.$(e1) || this.fire(new t.l(t.d(e1)));
                    }
                });
            }
            loaded() {
                return this._loaded;
            }
            hasTile(e1) {
                return !this.tileBounds || this.tileBounds.contains(e1.canonical);
            }
            onAdd(e1) {
                this.map = e1, this.load();
            }
            setSourceProperty(e1) {
                this._tileJSONRequest && this._tileJSONRequest.abort(), e1(), this.load(!0);
            }
            setTiles(e1) {
                return this.setSourceProperty(()=>{
                    this._options.tiles = e1;
                }), this;
            }
            setUrl(e1) {
                return this.setSourceProperty(()=>{
                    this.url = e1, this._options.url = e1;
                }), this;
            }
            onRemove() {
                this._tileJSONRequest && (this._tileJSONRequest.abort(), this._tileJSONRequest = null);
            }
            serialize() {
                return t.e({}, this._options);
            }
            loadTile(e1) {
                return t._(this, void 0, void 0, function*() {
                    const t = e1.tileID.canonical.url(this.tiles, this.map.getPixelRatio(), this.scheme), i = {
                        request: yield this.map._requestManager.transformRequest(t, "Tile"),
                        uid: e1.uid,
                        tileID: e1.tileID,
                        zoom: e1.tileID.overscaledZ,
                        tileSize: this.tileSize * e1.tileID.overscaleFactor(),
                        type: this.type,
                        source: this.id,
                        pixelRatio: this.map.getPixelRatio(),
                        showCollisionBoxes: this.map.showCollisionBoxes,
                        promoteId: this.promoteId,
                        subdivisionGranularity: this.map.style.projection.subdivisionGranularity,
                        encoding: this.encoding,
                        overzoomParameters: yield this._getOverzoomParameters(e1),
                        etag: e1.etag
                    };
                    i.request.collectResourceTiming = this._collectResourceTiming;
                    let o = "RT";
                    if (e1.actor && "expired" !== e1.state) {
                        if ("loading" === e1.state) return new Promise((t, i)=>{
                            e1.reloadPromise = {
                                resolve: t,
                                reject: i
                            };
                        });
                    } else e1.actor = this.dispatcher.getActor(), o = "LT";
                    e1.abortController = new AbortController;
                    try {
                        const t = yield e1.actor.sendAsync({
                            type: o,
                            data: i
                        }, e1.abortController);
                        if (delete e1.abortController, e1.aborted) return;
                        this._afterTileLoadWorkerResponse(e1, t);
                        const a = {};
                        return (null == t ? void 0 : t.etagUnmodified) && (a.unmodified = !0), a;
                    } catch (t) {
                        if (delete e1.abortController, e1.aborted) return;
                        if (t && 404 !== t.status) throw t;
                        this._afterTileLoadWorkerResponse(e1, null);
                    }
                });
            }
            _getOverzoomParameters(e1) {
                return t._(this, void 0, void 0, function*() {
                    if (e1.tileID.canonical.z <= this.maxzoom) return;
                    if (void 0 === this.map._zoomLevelsToOverscale) return;
                    const t = e1.tileID.scaledTo(this.maxzoom).canonical, i = t.url(this.tiles, this.map.getPixelRatio(), this.scheme);
                    return {
                        maxZoomTileID: t,
                        overzoomRequest: yield this.map._requestManager.transformRequest(i, "Tile")
                    };
                });
            }
            _afterTileLoadWorkerResponse(e1, t) {
                if ((null == t ? void 0 : t.resourceTiming) && (e1.resourceTiming = t.resourceTiming), t && this.map._refreshExpiredTiles && e1.setExpiryData(t), e1.etag = null == t ? void 0 : t.etag, e1.loadVectorData(t, this.map.painter), e1.reloadPromise) {
                    const t = e1.reloadPromise;
                    e1.reloadPromise = null, this.loadTile(e1).then(t.resolve).catch(t.reject);
                }
            }
            abortTile(e1) {
                return t._(this, void 0, void 0, function*() {
                    e1.abortController && (e1.abortController.abort(), delete e1.abortController), e1.actor && (yield e1.actor.sendAsync({
                        type: "AT",
                        data: {
                            uid: e1.uid,
                            type: this.type,
                            source: this.id
                        }
                    }));
                });
            }
            unloadTile(e1) {
                return t._(this, void 0, void 0, function*() {
                    e1.unloadVectorData(), e1.actor && (yield e1.actor.sendAsync({
                        type: "RMT",
                        data: {
                            uid: e1.uid,
                            type: this.type,
                            source: this.id
                        }
                    }));
                });
            }
            hasTransition() {
                return !1;
            }
        }
        class q extends t.E {
            constructor(e1, i, o, a){
                super(), this.id = e1, this.dispatcher = o, this.setEventedParent(a), this.type = "raster", this.minzoom = 0, this.maxzoom = 22, this.roundZoom = !0, this.scheme = "xyz", this.tileSize = 512, this._loaded = !1, this._options = t.e({
                    type: "raster"
                }, i), t.e(this, t.V(i, [
                    "url",
                    "scheme",
                    "tileSize"
                ]));
            }
            load() {
                return t._(this, arguments, void 0, function*(e1 = !1) {
                    this._loaded = !1, this.fire(new t.n("dataloading", {
                        dataType: "source"
                    })), this._tileJSONRequest = new AbortController;
                    try {
                        const i = yield U(this._options, this.map._requestManager, this._tileJSONRequest, this.map._ownerWindow);
                        this._tileJSONRequest = null, this._loaded = !0, i && (t.e(this, i), i.bounds && (this.tileBounds = new V(i.bounds, this.minzoom, this.maxzoom)), this.fire(new t.n("data", {
                            dataType: "source",
                            sourceDataType: "metadata"
                        })), this.fire(new t.n("data", {
                            dataType: "source",
                            sourceDataType: "content",
                            sourceDataChanged: e1
                        })));
                    } catch (e1) {
                        this._tileJSONRequest = null, this._loaded = !0, t.$(e1) || this.fire(new t.l(t.d(e1)));
                    }
                });
            }
            loaded() {
                return this._loaded;
            }
            onAdd(e1) {
                this.map = e1, this.load();
            }
            onRemove() {
                this._tileJSONRequest && (this._tileJSONRequest.abort(), this._tileJSONRequest = null);
            }
            setSourceProperty(e1) {
                this._tileJSONRequest && (this._tileJSONRequest.abort(), this._tileJSONRequest = null), e1(), this.load(!0);
            }
            setTiles(e1) {
                return this.setSourceProperty(()=>{
                    this._options.tiles = e1;
                }), this;
            }
            setUrl(e1) {
                return this.setSourceProperty(()=>{
                    this.url = e1, this._options.url = e1;
                }), this;
            }
            serialize() {
                return t.e({}, this._options);
            }
            hasTile(e1) {
                return !this.tileBounds || this.tileBounds.contains(e1.canonical);
            }
            loadTile(e1) {
                return t._(this, void 0, void 0, function*() {
                    const i = e1.tileID.canonical.url(this.tiles, this.map.getPixelRatio(), this.scheme);
                    e1.abortController = new AbortController;
                    try {
                        const o = yield u.getImage((yield this.map._requestManager.transformRequest(i, "Tile")), e1.abortController, this.map._refreshExpiredTiles);
                        if (delete e1.abortController, e1.aborted) return void (e1.state = "unloaded");
                        if (null == o ? void 0 : o.data) {
                            this.map._refreshExpiredTiles && (o.cacheControl || o.expires) && e1.setExpiryData({
                                cacheControl: o.cacheControl,
                                expires: o.expires
                            });
                            const i = this.map.painter.context, a = i.gl, r = o.data;
                            e1.texture = this.map.painter.getTileTexture(r.width), e1.texture ? e1.texture.update(r, {
                                useMipmap: !0
                            }) : (e1.texture = new t.T(i, r, a.RGBA, {
                                useMipmap: !0
                            }), e1.texture.bind(a.LINEAR, a.CLAMP_TO_EDGE, a.LINEAR_MIPMAP_NEAREST)), e1.state = "loaded";
                        }
                    } catch (t) {
                        if (delete e1.abortController, e1.aborted) e1.state = "unloaded";
                        else if (t) throw e1.state = "errored", t;
                    }
                });
            }
            abortTile(e1) {
                return t._(this, void 0, void 0, function*() {
                    e1.abortController && (e1.abortController.abort(), delete e1.abortController);
                });
            }
            unloadTile(e1) {
                return t._(this, void 0, void 0, function*() {
                    e1.texture && this.map.painter.saveTileTexture(e1.texture);
                });
            }
            hasTransition() {
                return !1;
            }
        }
        class $ extends q {
            constructor(e1, i, o, a){
                super(e1, i, o, a), this.type = "raster-dem", this.maxzoom = 22, this._options = t.e({
                    type: "raster-dem"
                }, i), this.encoding = i.encoding || "mapbox", this.redFactor = i.redFactor, this.greenFactor = i.greenFactor, this.blueFactor = i.blueFactor, this.baseShift = i.baseShift;
            }
            loadTile(e1) {
                return t._(this, void 0, void 0, function*() {
                    const i = e1.tileID.canonical.url(this.tiles, this.map.getPixelRatio(), this.scheme), o = yield this.map._requestManager.transformRequest(i, "Tile");
                    e1.neighboringTiles = this._getNeighboringTiles(e1.tileID), e1.abortController = new AbortController;
                    try {
                        const i = yield u.getImage(o, e1.abortController, this.map._refreshExpiredTiles);
                        if (delete e1.abortController, e1.aborted) return void (e1.state = "unloaded");
                        if (null == i ? void 0 : i.data) {
                            const o = i.data;
                            this.map._refreshExpiredTiles && (i.cacheControl || i.expires) && e1.setExpiryData({
                                cacheControl: i.cacheControl,
                                expires: i.expires
                            });
                            const a = t.b(o) && t.a0() ? o : yield this.readImageNow(o), r = {
                                type: this.type,
                                uid: e1.uid,
                                source: this.id,
                                rawImageData: a,
                                encoding: this.encoding,
                                redFactor: this.redFactor,
                                greenFactor: this.greenFactor,
                                blueFactor: this.blueFactor,
                                baseShift: this.baseShift
                            };
                            if (e1.actor && "expired" !== e1.state && "reloading" !== e1.state) return;
                            e1.actor && "expired" !== e1.state || (e1.actor = this.dispatcher.getActor()), e1.dem = yield e1.actor.sendAsync({
                                type: "LDT",
                                data: r
                            }), e1.needsHillshadePrepare = !0, e1.needsTerrainPrepare = !0, e1.state = "loaded";
                        }
                    } catch (t) {
                        if (delete e1.abortController, e1.aborted) e1.state = "unloaded";
                        else if (t) throw e1.state = "errored", t;
                    }
                });
            }
            readImageNow(e1) {
                return t._(this, void 0, void 0, function*() {
                    if ("undefined" != typeof VideoFrame && t.a1()) {
                        const i = e1.width + 2, o = e1.height + 2;
                        try {
                            return new t.R({
                                width: i,
                                height: o
                            }, (yield t.a2(e1, -1, -1, i, o)));
                        } catch (e1) {}
                    }
                    return n.getImageData(e1, 1);
                });
            }
            _getNeighboringTiles(e1) {
                const i = e1.canonical, o = Math.pow(2, i.z), a = (i.x - 1 + o) % o, r = 0 === i.x ? e1.wrap - 1 : e1.wrap, s = (i.x + 1 + o) % o, n = i.x + 1 === o ? e1.wrap + 1 : e1.wrap, l = {};
                return l[new t.a3(e1.overscaledZ, r, i.z, a, i.y).key] = {
                    backfilled: !1
                }, l[new t.a3(e1.overscaledZ, n, i.z, s, i.y).key] = {
                    backfilled: !1
                }, i.y > 0 && (l[new t.a3(e1.overscaledZ, r, i.z, a, i.y - 1).key] = {
                    backfilled: !1
                }, l[new t.a3(e1.overscaledZ, e1.wrap, i.z, i.x, i.y - 1).key] = {
                    backfilled: !1
                }, l[new t.a3(e1.overscaledZ, n, i.z, s, i.y - 1).key] = {
                    backfilled: !1
                }), i.y + 1 < o && (l[new t.a3(e1.overscaledZ, r, i.z, a, i.y + 1).key] = {
                    backfilled: !1
                }, l[new t.a3(e1.overscaledZ, e1.wrap, i.z, i.x, i.y + 1).key] = {
                    backfilled: !1
                }, l[new t.a3(e1.overscaledZ, n, i.z, s, i.y + 1).key] = {
                    backfilled: !1
                }), l;
            }
            unloadTile(e1) {
                return t._(this, void 0, void 0, function*() {
                    e1.demTexture && this.map.painter.saveTileTexture(e1.demTexture), e1.fbo && (e1.fbo.destroy(), delete e1.fbo), e1.dem && delete e1.dem, delete e1.neighboringTiles, e1.state = "unloaded", e1.actor && (yield e1.actor.sendAsync({
                        type: "RDT",
                        data: {
                            type: this.type,
                            uid: e1.uid,
                            source: this.id
                        }
                    }));
                });
            }
        }
        function H(e1, t) {
            return t ? e1.properties[t] : e1.id;
        }
        function X(e1, t) {
            const i = {
                id: e1.id
            };
            if (t.removeAllProperties && (delete e1.removeProperties, delete e1.addOrUpdateProperties, delete t.removeProperties), t.removeProperties) for (const i of t.removeProperties){
                const t = e1.addOrUpdateProperties.findIndex((e1)=>e1.key === i);
                t > -1 && e1.addOrUpdateProperties.splice(t, 1);
            }
            return (e1.removeAllProperties || t.removeAllProperties) && (i.removeAllProperties = !0), (e1.removeProperties || t.removeProperties) && (i.removeProperties = [
                ...e1.removeProperties || [],
                ...t.removeProperties || []
            ]), (e1.addOrUpdateProperties || t.addOrUpdateProperties) && (i.addOrUpdateProperties = [
                ...e1.addOrUpdateProperties || [],
                ...t.addOrUpdateProperties || []
            ]), (e1.newGeometry || t.newGeometry) && (i.newGeometry = t.newGeometry || e1.newGeometry), i;
        }
        function K(e1) {
            var t, i;
            if (!e1) return {};
            const o = {};
            return o.removeAll = e1.removeAll, o.remove = new Set(e1.remove || []), o.add = new Map(null === (t = e1.add) || void 0 === t ? void 0 : t.map((e1)=>[
                    e1.id,
                    e1
                ])), o.update = new Map(null === (i = e1.update) || void 0 === i ? void 0 : i.map((e1)=>[
                    e1.id,
                    e1
                ])), o;
        }
        function Y(e1) {
            return e1 && 0 !== e1.length ? "number" == typeof e1[0] ? [
                e1
            ] : e1.flatMap((e1)=>Y(e1)) : [];
        }
        function Q(e1) {
            return "GeometryCollection" === e1.type ? e1.geometries.flatMap((e1)=>Q(e1)) : Y(e1.coordinates);
        }
        function J(e1) {
            const t = new G;
            let i;
            switch(e1.type){
                case "FeatureCollection":
                    i = e1.features.flatMap((e1)=>Q(e1.geometry));
                    break;
                case "Feature":
                    i = Q(e1.geometry);
                    break;
                default:
                    i = Q(e1);
            }
            if (0 === i.length) return t;
            for (const e1 of i){
                const [i, o] = e1;
                t.extend([
                    i,
                    o
                ]);
            }
            return t;
        }
        class ee extends t.E {
            constructor(e1, i, o, a){
                super(), this.id = e1, this.type = "geojson", this.minzoom = 0, this.maxzoom = 18, this.tileSize = 512, this.isTileClipped = !0, this.reparseOverscaled = !0, this._removed = !1, this._isUpdatingWorker = !1, this._pendingWorkerUpdate = {
                    data: i.data
                }, this.actor = o.getActor(), this.setEventedParent(a), this._data = "string" == typeof i.data ? {
                    url: i.data
                } : {
                    geojson: i.data
                }, this._options = t.e({}, i), this._collectResourceTiming = i.collectResourceTiming, void 0 !== i.maxzoom && (this.maxzoom = i.maxzoom), i.type && (this.type = i.type), i.attribution && (this.attribution = i.attribution), this.promoteId = i.promoteId, void 0 !== i.clusterMaxZoom && this.maxzoom <= i.clusterMaxZoom && t.w(`The maxzoom value "${this.maxzoom}" is expected to be greater than the clusterMaxZoom value "${i.clusterMaxZoom}".`), this.workerOptions = t.e({
                    source: this.id,
                    geojsonVtOptions: {
                        buffer: this._pixelsToTileUnits(void 0 !== i.buffer ? i.buffer : 128),
                        tolerance: this._pixelsToTileUnits(void 0 !== i.tolerance ? i.tolerance : .375),
                        extent: t.a6,
                        maxZoom: this.maxzoom,
                        lineMetrics: i.lineMetrics || !1,
                        generateId: i.generateId || !1,
                        promoteId: "string" == typeof i.promoteId ? i.promoteId : void 0,
                        cluster: i.cluster || !1,
                        clusterOptions: {
                            maxZoom: this._getClusterMaxZoom(i.clusterMaxZoom),
                            minPoints: Math.max(2, i.clusterMinPoints || 2),
                            extent: t.a6,
                            radius: this._pixelsToTileUnits(i.clusterRadius || 50),
                            log: !1,
                            generateId: i.generateId || !1
                        }
                    },
                    clusterProperties: i.clusterProperties,
                    filter: i.filter
                }, i.workerOptions);
            }
            _hasPendingWorkerUpdate() {
                return void 0 !== this._pendingWorkerUpdate.data || void 0 !== this._pendingWorkerUpdate.diff || this._pendingWorkerUpdate.updateCluster;
            }
            _pixelsToTileUnits(e1) {
                return e1 * (t.a6 / this.tileSize);
            }
            _getClusterMaxZoom(e1) {
                const i = e1 ? Math.round(e1) : this.maxzoom - 1;
                return Number.isInteger(e1) || void 0 === e1 || t.w(`Integer expected for option 'clusterMaxZoom': provided value "${e1}" rounded to "${i}"`), i;
            }
            load() {
                return t._(this, void 0, void 0, function*() {
                    yield this._updateWorkerData();
                });
            }
            onAdd(e1) {
                this.map = e1, this.load();
            }
            setData(e1, t) {
                this._data = "string" == typeof e1 ? {
                    url: e1
                } : {
                    geojson: e1
                }, this._pendingWorkerUpdate = {
                    data: e1
                };
                const i = this._updateWorkerData();
                return t ? i : this;
            }
            updateData(e1, t) {
                this._pendingWorkerUpdate.diff = function(e1, t) {
                    if (!e1) return t || {};
                    if (!t) return e1 || {};
                    const i = K(e1), o = K(t);
                    !function(e1, t) {
                        t.removeAll && (e1.add.clear(), e1.update.clear(), e1.remove.clear(), t.remove.clear());
                        for (const i of t.remove)e1.add.delete(i), e1.update.delete(i);
                        for (const [i, o] of t.update){
                            const a = e1.update.get(i);
                            a && (t.update.set(i, X(a, o)), e1.update.delete(i));
                        }
                    }(i, o);
                    const a = {};
                    if ((i.removeAll || o.removeAll) && (a.removeAll = !0), a.remove = new Set([
                        ...i.remove,
                        ...o.remove
                    ]), a.add = new Map([
                        ...i.add,
                        ...o.add
                    ]), a.update = new Map([
                        ...i.update,
                        ...o.update
                    ]), a.remove.size && a.add.size) for (const e1 of a.add.keys())a.remove.delete(e1);
                    return function(e1) {
                        const t = {};
                        return e1.removeAll && (t.removeAll = e1.removeAll), e1.remove && (t.remove = Array.from(e1.remove)), e1.add && (t.add = Array.from(e1.add.values())), e1.update && (t.update = Array.from(e1.update.values())), t;
                    }(a);
                }(this._pendingWorkerUpdate.diff, e1);
                const i = this._updateWorkerData();
                return t ? i : this;
            }
            getData() {
                return t._(this, void 0, void 0, function*() {
                    return this._data.url && (yield this.once("data")), this._data.geojson ? this._data.geojson : {
                        type: "FeatureCollection",
                        features: Array.from(this._data.updateable.values())
                    };
                });
            }
            getBounds() {
                return t._(this, void 0, void 0, function*() {
                    return J((yield this.getData()));
                });
            }
            setClusterOptions(e1) {
                return this.workerOptions.geojsonVtOptions.cluster = e1.cluster, void 0 !== e1.clusterRadius && (this.workerOptions.geojsonVtOptions.clusterOptions.radius = this._pixelsToTileUnits(e1.clusterRadius)), void 0 !== e1.clusterMaxZoom && (this.workerOptions.geojsonVtOptions.clusterOptions.maxZoom = this._getClusterMaxZoom(e1.clusterMaxZoom)), this._pendingWorkerUpdate.updateCluster = !0, this._updateWorkerData(), this;
            }
            getClusterExpansionZoom(e1) {
                return this.actor.sendAsync({
                    type: "GCEZ",
                    data: {
                        type: this.type,
                        clusterId: e1,
                        source: this.id
                    }
                });
            }
            getClusterChildren(e1) {
                return this.actor.sendAsync({
                    type: "GCC",
                    data: {
                        type: this.type,
                        clusterId: e1,
                        source: this.id
                    }
                });
            }
            getClusterLeaves(e1, t, i) {
                return this.actor.sendAsync({
                    type: "GCL",
                    data: {
                        type: this.type,
                        source: this.id,
                        clusterId: e1,
                        limit: t,
                        offset: i
                    }
                });
            }
            _updateWorkerData() {
                return t._(this, void 0, void 0, function*() {
                    if (this._isUpdatingWorker) return;
                    if (!this._hasPendingWorkerUpdate()) return void t.w(`No pending worker updates for GeoJSONSource ${this.id}.`);
                    const { data: e1, diff: i, updateCluster: o } = this._pendingWorkerUpdate, a = this._getLoadGeoJSONParameters(e1, i, o);
                    void 0 !== e1 ? this._pendingWorkerUpdate.data = void 0 : i ? this._pendingWorkerUpdate.diff = void 0 : o && (this._pendingWorkerUpdate.updateCluster = void 0), yield this._dispatchWorkerUpdate(a);
                });
            }
            _getLoadGeoJSONParameters(e1, i, o) {
                return t._(this, void 0, void 0, function*() {
                    const a = t.e({
                        type: this.type
                    }, this.workerOptions);
                    return "string" == typeof e1 ? (a.request = yield this.map._requestManager.transformRequest(n.resolveURL(e1), "Source"), a.request.collectResourceTiming = this._collectResourceTiming, a) : void 0 !== e1 ? (a.data = e1, a) : i ? (a.dataDiff = i, a) : o ? (a.updateCluster = !0, a) : void 0;
                });
            }
            _dispatchWorkerUpdate(e1) {
                return t._(this, void 0, void 0, function*() {
                    this._isUpdatingWorker = !0, this.fire(new t.n("dataloading", {
                        dataType: "source"
                    }));
                    try {
                        const i = yield e1, o = yield this.actor.sendAsync({
                            type: "LD",
                            data: i
                        });
                        if (this._isUpdatingWorker = !1, this._removed || o.abandoned) return void this.fire(new t.n("dataabort", {
                            dataType: "source"
                        }));
                        o.data && (this._data = {
                            geojson: o.data
                        });
                        const a = this._applyDiffToSource(i.dataDiff), r = this._getShouldReloadTileOptions(a), s = {
                            dataType: "source"
                        };
                        this._applyResourceTiming(s, o), this.fire(new t.n("data", Object.assign(Object.assign({}, s), {
                            sourceDataType: "metadata"
                        }))), this.fire(new t.n("data", Object.assign(Object.assign({}, s), {
                            sourceDataType: "content",
                            shouldReloadTileOptions: r
                        })));
                    } catch (e1) {
                        if (this._isUpdatingWorker = !1, this._removed) return void this.fire(new t.n("dataabort", {
                            dataType: "source"
                        }));
                        this.fire(new t.l(t.d(e1)));
                    } finally{
                        this._hasPendingWorkerUpdate() && this._updateWorkerData();
                    }
                });
            }
            _applyResourceTiming(e1, i) {
                var o;
                if (!this._collectResourceTiming) return;
                const a = null === (o = i.resourceTiming) || void 0 === o ? void 0 : o[this.id];
                if (!a) return;
                const r = a.slice(0);
                (null == r ? void 0 : r.length) && t.e(e1, {
                    resourceTiming: r
                });
            }
            _applyDiffToSource(e1) {
                if (!e1) return;
                const t = "string" == typeof this.promoteId ? this.promoteId : void 0;
                if (!this._data.url && !this._data.updateable) {
                    const e1 = function(e1, t) {
                        const i = new Map;
                        if (null == e1) return i;
                        if (null == e1.type) return i;
                        if ("Feature" === e1.type) {
                            const o = H(e1, t);
                            if (null == o) return;
                            return i.set(o, e1), i;
                        }
                        if ("FeatureCollection" === e1.type) {
                            const o = new Set;
                            for (const a of e1.features){
                                const e1 = H(a, t);
                                if (null == e1) return;
                                if (o.has(e1)) return;
                                o.add(e1), i.set(e1, a);
                            }
                            return i;
                        }
                    }(this._data.geojson, t);
                    if (!e1) throw new Error(`GeoJSONSource "${this.id}": GeoJSON data is not compatible with updateData`);
                    this._data = {
                        updateable: e1
                    };
                }
                if (!this._data.updateable) return;
                const i = function(e1, t, i) {
                    var o, a;
                    const r = [];
                    if (t.removeAll) e1.clear();
                    else if (t.remove) for (const i of t.remove){
                        const t = e1.get(i);
                        t && (r.push(t.geometry), e1.delete(i));
                    }
                    if (t.add) for (const o of t.add){
                        const t = H(o, i);
                        if (null == t) continue;
                        const a = e1.get(t);
                        a && r.push(a.geometry), r.push(o.geometry), e1.set(t, o);
                    }
                    if (t.update) for (const i of t.update){
                        const t = e1.get(i.id);
                        if (!t) continue;
                        const s = !!i.newGeometry, n = i.removeAllProperties || (null === (o = i.removeProperties) || void 0 === o ? void 0 : o.length) > 0 || (null === (a = i.addOrUpdateProperties) || void 0 === a ? void 0 : a.length) > 0;
                        if (!s && !n) continue;
                        r.push(t.geometry);
                        const l = Object.assign({}, t);
                        if (e1.set(i.id, l), s && (r.push(i.newGeometry), l.geometry = i.newGeometry), n) {
                            if (l.properties = i.removeAllProperties ? {} : Object.assign({}, l.properties || {}), i.removeProperties) for (const e1 of i.removeProperties)delete l.properties[e1];
                            if (i.addOrUpdateProperties) for (const { key: e1, value: t } of i.addOrUpdateProperties)l.properties[e1] = t;
                        }
                    }
                    return r;
                }(this._data.updateable, e1, t);
                return e1.removeAll || this._options.cluster ? void 0 : i;
            }
            _getShouldReloadTileOptions(e1) {
                if (e1) return {
                    affectedBounds: e1.filter(Boolean).map((e1)=>J(e1))
                };
            }
            shouldReloadTile(e1, { affectedBounds: i }) {
                if ("loading" === e1.state) return !0;
                if ("unloaded" === e1.state) return !1;
                const { buffer: o, extent: a } = this.workerOptions.geojsonVtOptions, r = function({ x: e1, y: i, z: o }, a = 0) {
                    const r = t.a4((e1 - a) / Math.pow(2, o)), s = t.a5((i + 1 + a) / Math.pow(2, o)), n = t.a4((e1 + 1 + a) / Math.pow(2, o)), l = t.a5((i - a) / Math.pow(2, o));
                    return new G([
                        r,
                        s
                    ], [
                        n,
                        l
                    ]);
                }(e1.tileID.canonical, o / a);
                for (const e1 of i)if (r.intersects(e1)) return !0;
                return !1;
            }
            loaded() {
                return !this._isUpdatingWorker && !this._hasPendingWorkerUpdate();
            }
            loadTile(e1) {
                return t._(this, void 0, void 0, function*() {
                    const t = e1.actor ? "RT" : "LT";
                    e1.actor = this.actor;
                    const i = {
                        type: this.type,
                        uid: e1.uid,
                        tileID: e1.tileID,
                        zoom: e1.tileID.overscaledZ,
                        maxZoom: this.maxzoom,
                        tileSize: this.tileSize,
                        source: this.id,
                        pixelRatio: this.map.getPixelRatio(),
                        showCollisionBoxes: this.map.showCollisionBoxes,
                        promoteId: this.promoteId,
                        subdivisionGranularity: this.map.style.projection.subdivisionGranularity
                    };
                    e1.abortController = new AbortController;
                    const o = yield this.actor.sendAsync({
                        type: t,
                        data: i
                    }, e1.abortController);
                    delete e1.abortController, e1.unloadVectorData(), e1.aborted || e1.loadVectorData(o, this.map.painter, "RT" === t);
                });
            }
            abortTile(e1) {
                return t._(this, void 0, void 0, function*() {
                    e1.abortController && (e1.abortController.abort(), delete e1.abortController), e1.aborted = !0;
                });
            }
            unloadTile(e1) {
                return t._(this, void 0, void 0, function*() {
                    e1.unloadVectorData(), yield this.actor.sendAsync({
                        type: "RMT",
                        data: {
                            uid: e1.uid,
                            type: this.type,
                            source: this.id
                        }
                    });
                });
            }
            onRemove() {
                this._removed = !0, this.actor.sendAsync({
                    type: "RS",
                    data: {
                        type: this.type,
                        source: this.id
                    }
                });
            }
            serialize() {
                return t.e({}, this._options, {
                    type: this.type,
                    data: this._data.updateable ? {
                        type: "FeatureCollection",
                        features: Array.from(this._data.updateable.values())
                    } : this._data.url || this._data.geojson
                });
            }
            hasTransition() {
                return !1;
            }
        }
        class te extends t.E {
            constructor(e1, t, i, o){
                super(), this.flippedWindingOrder = !1, this.id = e1, this.dispatcher = i, this.coordinates = t.coordinates, this.type = "image", this.minzoom = 0, this.maxzoom = 22, this.tileSize = 512, this.tiles = {}, this._loaded = !1, this.setEventedParent(o), this.options = t;
            }
            load(e1) {
                return t._(this, void 0, void 0, function*() {
                    this._loaded = !1, this.fire(new t.n("dataloading", {
                        dataType: "source"
                    })), this.url = this.options.url, this._request = new AbortController;
                    try {
                        const t = yield u.getImage((yield this.map._requestManager.transformRequest(this.url, "Image")), this._request);
                        this._request = null, this._loaded = !0, (null == t ? void 0 : t.data) && (this.image = t.data, e1 && (this.coordinates = e1), this._finishLoading());
                    } catch (e1) {
                        this._request = null, this._loaded = !0, t.$(e1) || this.fire(new t.l(t.d(e1)));
                    }
                });
            }
            loaded() {
                return this._loaded;
            }
            updateImage(e1) {
                return e1.url ? (this._request && (this._request.abort(), this._request = null), this.options.url = e1.url, this.load(e1.coordinates).finally(()=>this.texture = null), this) : this;
            }
            _finishLoading() {
                this.map && (this.setCoordinates(this.coordinates), this.fire(new t.n("data", {
                    dataType: "source",
                    sourceDataType: "metadata"
                })));
            }
            onAdd(e1) {
                this.map = e1, this.load();
            }
            onRemove() {
                this._request && (this._request.abort(), this._request = null);
            }
            setCoordinates(e1) {
                this.coordinates = e1;
                const i = e1.map(t.a7.fromLngLat);
                var o;
                return this.tileID = function(e1) {
                    const i = t.a8.fromPoints(e1), o = i.width(), a = i.height(), r = Math.max(o, a), s = Math.max(0, Math.floor(-Math.log(r) / Math.LN2)), n = Math.pow(2, s);
                    return new t.aa(s, Math.floor((i.minX + i.maxX) / 2 * n), Math.floor((i.minY + i.maxY) / 2 * n));
                }(i), this.terrainTileRanges = this._getOverlappingTileRanges(i), this.minzoom = this.maxzoom = this.tileID.z, this.tileCoords = i.map((e1)=>this.tileID.getTilePoint(e1)._round()), this.flippedWindingOrder = ((o = this.tileCoords)[1].x - o[0].x) * (o[2].y - o[0].y) - (o[1].y - o[0].y) * (o[2].x - o[0].x) < 0, this.fire(new t.n("data", {
                    dataType: "source",
                    sourceDataType: "content"
                })), this;
            }
            prepare() {
                if (0 === Object.keys(this.tiles).length || !this.image) return;
                const e1 = this.map.painter.context, i = e1.gl;
                this.texture || (this.texture = new t.T(e1, this.image, i.RGBA), this.texture.bind(i.LINEAR, i.CLAMP_TO_EDGE));
                let o = !1;
                for(const e1 in this.tiles){
                    const t = this.tiles[e1];
                    "loaded" !== t.state && (t.state = "loaded", t.texture = this.texture, o = !0);
                }
                o && this.fire(new t.n("data", {
                    dataType: "source",
                    sourceDataType: "idle",
                    sourceId: this.id
                }));
            }
            loadTile(e1) {
                return t._(this, void 0, void 0, function*() {
                    var t;
                    (null === (t = this.tileID) || void 0 === t ? void 0 : t.equals(e1.tileID.canonical)) ? (this.tiles[String(e1.tileID.wrap)] = e1, e1.buckets = {}) : e1.state = "errored";
                });
            }
            serialize() {
                return {
                    type: "image",
                    url: this.options.url,
                    coordinates: this.coordinates
                };
            }
            hasTransition() {
                return !1;
            }
            _getOverlappingTileRanges(e1) {
                const { minX: i, minY: o, maxX: a, maxY: r } = t.a8.fromPoints(e1), s = {};
                for(let e1 = 0; e1 <= t.a9; e1++){
                    const t = Math.pow(2, e1), n = Math.floor(i * t), l = Math.floor(o * t), c = Math.floor(a * t), h = Math.floor(r * t), u = (n % t + t) % t, d = c % t, _ = Math.floor(n / t), p = Math.floor(c / t);
                    s[e1] = {
                        minWrap: _,
                        maxWrap: p,
                        minTileXWrapped: u,
                        maxTileXWrapped: d,
                        minTileY: l,
                        maxTileY: h
                    };
                }
                return s;
            }
        }
        class ie extends te {
            constructor(e1, t, i, o){
                super(e1, t, i, o), this._onPlayingHandler = ()=>{
                    var e1;
                    null === (e1 = this.map) || void 0 === e1 || e1.triggerRepaint();
                }, this.roundZoom = !0, this.type = "video", this.options = t;
            }
            load() {
                return t._(this, void 0, void 0, function*() {
                    this._loaded = !1;
                    const e1 = this.options;
                    this.urls = [];
                    for (const t of e1.urls)this.urls.push((yield this.map._requestManager.transformRequest(t, "Source")).url);
                    try {
                        const e1 = yield t.ab(this.urls);
                        if (this._loaded = !0, !e1) return;
                        this.video = e1, this.video.loop = !0, this.video.addEventListener("playing", this._onPlayingHandler), this.map && this.video.play(), this._finishLoading();
                    } catch (e1) {
                        this.fire(new t.l(t.d(e1)));
                    }
                });
            }
            pause() {
                this.video && this.video.pause();
            }
            play() {
                this.video && this.video.play();
            }
            seek(e1) {
                if (this.video) {
                    const i = this.video.seekable;
                    e1 < i.start(0) || e1 > i.end(0) ? this.fire(new t.l(new t.ac(`sources.${this.id}`, null, `Playback for this video can be set only between the ${i.start(0)} and ${i.end(0)}-second mark.`))) : this.video.currentTime = e1;
                }
            }
            getVideo() {
                return this.video;
            }
            onAdd(e1) {
                this.map || (this.map = e1, this.load(), this.video && (this.video.play(), this.setCoordinates(this.coordinates)));
            }
            onRemove() {
                super.onRemove(), this.video && (this.video.removeEventListener("playing", this._onPlayingHandler), this.video.pause());
            }
            prepare() {
                if (0 === Object.keys(this.tiles).length || this.video.readyState < 2) return;
                const e1 = this.map.painter.context, i = e1.gl;
                this.texture ? this.video.paused || (this.texture.bind(i.LINEAR, i.CLAMP_TO_EDGE), i.texSubImage2D(i.TEXTURE_2D, 0, 0, 0, i.RGBA, i.UNSIGNED_BYTE, this.video)) : (this.texture = new t.T(e1, this.video, i.RGBA), this.texture.bind(i.LINEAR, i.CLAMP_TO_EDGE));
                let o = !1;
                for(const e1 in this.tiles){
                    const t = this.tiles[e1];
                    "loaded" !== t.state && (t.state = "loaded", t.texture = this.texture, o = !0);
                }
                o && this.fire(new t.n("data", {
                    dataType: "source",
                    sourceDataType: "idle",
                    sourceId: this.id
                }));
            }
            serialize() {
                return {
                    type: "video",
                    urls: this.urls,
                    coordinates: this.coordinates
                };
            }
            hasTransition() {
                return this.video && !this.video.paused;
            }
        }
        class oe extends te {
            constructor(e1, i, o, a){
                super(e1, i, o, a), i.coordinates ? Array.isArray(i.coordinates) && 4 === i.coordinates.length && !i.coordinates.some((e1)=>!Array.isArray(e1) || 2 !== e1.length || e1.some((e1)=>"number" != typeof e1)) || this.fire(new t.l(new t.ac(`sources.${e1}`, null, '"coordinates" property must be an array of 4 longitude/latitude array pairs'))) : this.fire(new t.l(new t.ac(`sources.${e1}`, null, 'missing required property "coordinates"'))), i.animate && "boolean" != typeof i.animate && this.fire(new t.l(new t.ac(`sources.${e1}`, null, 'optional "animate" property must be a boolean value'))), i.canvas ? "string" == typeof i.canvas || i.canvas instanceof HTMLCanvasElement || this.fire(new t.l(new t.ac(`sources.${e1}`, null, '"canvas" must be either a string representing the ID of the canvas element from which to read, or an HTMLCanvasElement instance'))) : this.fire(new t.l(new t.ac(`sources.${e1}`, null, 'missing required property "canvas"'))), this.options = i, this.animate = void 0 === i.animate || i.animate;
            }
            load() {
                return t._(this, void 0, void 0, function*() {
                    this._loaded = !0, this.canvas || (this.canvas = this.options.canvas instanceof HTMLCanvasElement ? this.options.canvas : document.getElementById(this.options.canvas)), this.width = this.canvas.width, this.height = this.canvas.height, this._hasInvalidDimensions() ? this.fire(new t.l(new Error("Canvas dimensions cannot be less than or equal to zero."))) : (this.play = function() {
                        this._playing = !0, this.map.triggerRepaint();
                    }, this.pause = function() {
                        this._playing && (this.prepare(), this._playing = !1);
                    }, this._finishLoading());
                });
            }
            getCanvas() {
                return this.canvas;
            }
            onAdd(e1) {
                this.map = e1, this.load(), this.canvas && this.animate && this.play();
            }
            onRemove() {
                this.pause();
            }
            prepare() {
                let e1 = !1;
                if (this.canvas.width !== this.width && (this.width = this.canvas.width, e1 = !0), this.canvas.height !== this.height && (this.height = this.canvas.height, e1 = !0), this._hasInvalidDimensions()) return;
                if (0 === Object.keys(this.tiles).length) return;
                const i = this.map.painter.context, o = i.gl;
                this.texture ? (e1 || this._playing) && this.texture.update(this.canvas, {
                    premultiply: !0
                }) : (this.texture = new t.T(i, this.canvas, o.RGBA, {
                    premultiply: !0
                }), this.texture.bind(o.LINEAR, o.CLAMP_TO_EDGE));
                let a = !1;
                for(const e1 in this.tiles){
                    const t = this.tiles[e1];
                    "loaded" !== t.state && (t.state = "loaded", t.texture = this.texture, a = !0);
                }
                a && this.fire(new t.n("data", {
                    dataType: "source",
                    sourceDataType: "idle",
                    sourceId: this.id
                }));
            }
            serialize() {
                return {
                    type: "canvas",
                    animate: this.animate,
                    canvas: this.options.canvas,
                    coordinates: this.coordinates
                };
            }
            hasTransition() {
                return this._playing;
            }
            _hasInvalidDimensions() {
                for (const e1 of [
                    this.canvas.width,
                    this.canvas.height
                ])if (isNaN(e1) || e1 <= 0) return !0;
                return !1;
            }
        }
        const ae = {}, re = (e1)=>{
            switch(e1){
                case "geojson":
                    return ee;
                case "image":
                    return te;
                case "raster":
                    return q;
                case "raster-dem":
                    return $;
                case "vector":
                    return W;
                case "video":
                    return ie;
                case "canvas":
                    return oe;
            }
            return ae[e1];
        }, se = "RTLPluginLoaded";
        class ne extends t.E {
            constructor(){
                super(...arguments), this.status = "unavailable", this.url = null, this.dispatcher = B();
            }
            _syncState(e1) {
                return this.status = e1, this.dispatcher.broadcast("SRPS", {
                    pluginStatus: e1,
                    pluginURL: this.url
                }).catch((e1)=>{
                    throw this.status = "error", e1;
                });
            }
            getRTLTextPluginStatus() {
                return this.status;
            }
            clearRTLTextPlugin() {
                this.status = "unavailable", this.url = null;
            }
            setRTLTextPlugin(e1) {
                return t._(this, arguments, void 0, function*(e1, t = !1) {
                    if (this.url) throw new Error("setRTLTextPlugin cannot be called multiple times.");
                    if (this.url = n.resolveURL(e1), !this.url) throw new Error(`requested url ${e1} is invalid`);
                    if ("unavailable" === this.status) {
                        if (!t) return this._requestImport();
                        this.status = "deferred", this._syncState(this.status);
                    } else if ("requested" === this.status) return this._requestImport();
                });
            }
            _requestImport() {
                return t._(this, void 0, void 0, function*() {
                    yield this._syncState("loading"), this.status = "loaded", this.fire(new t.n(se));
                });
            }
            lazyLoad() {
                "unavailable" === this.status ? this.status = "requested" : "deferred" === this.status && this._requestImport();
            }
        }
        let le = null;
        function ce() {
            return le || (le = new ne), le;
        }
        var he, ue;
        !function(e1) {
            e1[e1.Base = 0] = "Base", e1[e1.Parent = 1] = "Parent";
        }(he || (he = {})), function(e1) {
            e1[e1.Departing = 0] = "Departing", e1[e1.Incoming = 1] = "Incoming";
        }(ue || (ue = {}));
        class de {
            constructor(e1, i){
                this.timeAdded = 0, this.fadeEndTime = 0, this.fadeOpacity = 1, this.tileID = e1, this.uid = t.ad(), this.uses = 0, this.tileSize = i, this.buckets = {}, this.expirationTime = null, this.queryPadding = 0, this.hasSymbolBuckets = !1, this.hasRTLText = !1, this.dependencies = {}, this.rtt = [], this.rttFingerprint = {}, this.expiredRequestCount = 0, this.state = "loading";
            }
            isRenderable(e1) {
                return this.hasData() && (!this.fadeEndTime || this.fadeOpacity > 0) && (e1 || !this.holdingForSymbolFade());
            }
            setCrossFadeLogic({ fadingRole: e1, fadingDirection: t, fadingParentID: i, fadeEndTime: o }) {
                this.resetFadeLogic(), this.fadingRole = e1, this.fadingDirection = t, this.fadingParentID = i, this.fadeEndTime = o;
            }
            setSelfFadeLogic(e1) {
                this.resetFadeLogic(), this.selfFading = !0, this.fadeEndTime = e1;
            }
            resetFadeLogic() {
                this.fadingRole = null, this.fadingDirection = null, this.fadingParentID = null, this.selfFading = !1, this.timeAdded = c(), this.fadeEndTime = 0, this.fadeOpacity = 1;
            }
            wasRequested() {
                return "errored" === this.state || "loaded" === this.state || "reloading" === this.state;
            }
            clearTextures(e1) {
                this.demTexture && e1.saveTileTexture(this.demTexture), this.demTexture = null;
            }
            loadVectorData(e1, i, o) {
                if (!0 !== (null == e1 ? void 0 : e1.etagUnmodified)) {
                    if (this.hasData() && this.unloadVectorData(), this.state = "loaded", e1) {
                        e1.featureIndex && (this.latestFeatureIndex = e1.featureIndex, e1.rawTileData ? (this.latestRawTileData = e1.rawTileData, this.latestEncoding = e1.encoding, this.latestFeatureIndex.rawTileData = e1.rawTileData, this.latestFeatureIndex.encoding = e1.encoding) : this.latestRawTileData && (this.latestFeatureIndex.rawTileData = this.latestRawTileData, this.latestFeatureIndex.encoding = this.latestEncoding)), this.collisionBoxArray = e1.collisionBoxArray, this.buckets = function(e1, t) {
                            const i = {};
                            if (!t) return i;
                            for (const o of e1){
                                const e1 = o.layerIds.map((e1)=>t.getLayer(e1)).filter(Boolean);
                                if (0 !== e1.length) {
                                    o.layers = e1, o.stateDependentLayerIds && (o.stateDependentLayers = o.stateDependentLayerIds.map((t)=>e1.filter((e1)=>e1.id === t)[0]));
                                    for (const t of e1)i[t.id] = o;
                                }
                            }
                            return i;
                        }(e1.buckets, null == i ? void 0 : i.style), this.hasSymbolBuckets = !1;
                        for(const e1 in this.buckets){
                            const i = this.buckets[e1];
                            if (i instanceof t.af) {
                                if (this.hasSymbolBuckets = !0, !o) break;
                                i.justReloaded = !0;
                            }
                        }
                        if (this.hasRTLText = !1, this.hasSymbolBuckets) for(const e1 in this.buckets){
                            const i = this.buckets[e1];
                            if (i instanceof t.af && i.hasRTLText) {
                                this.hasRTLText = !0, ce().lazyLoad();
                                break;
                            }
                        }
                        this.queryPadding = 0;
                        for(const e1 in this.buckets){
                            const t = this.buckets[e1];
                            this.queryPadding = Math.max(this.queryPadding, i.style.getLayer(e1).queryRadius(t));
                        }
                        e1.imageAtlas && (this.imageAtlas = e1.imageAtlas), e1.glyphAtlasImage && (this.glyphAtlasImage = e1.glyphAtlasImage), this.dashPositions = e1.dashPositions;
                    } else this.collisionBoxArray = new t.ae;
                } else this.state = "loaded";
            }
            unloadVectorData() {
                for(const e1 in this.buckets)this.buckets[e1].destroy();
                this.buckets = {}, this.imageAtlasTexture && this.imageAtlasTexture.destroy(), this.glyphAtlasTexture && this.glyphAtlasTexture.destroy(), this.imageAtlas = null, this.dashPositions = null, this.latestFeatureIndex = null, this.state = "unloaded";
            }
            getBucket(e1) {
                return this.buckets[e1.id];
            }
            upload(e1) {
                for(const t in this.buckets){
                    const i = this.buckets[t];
                    i.uploadPending() && i.upload(e1);
                }
                const i = e1.gl;
                this.imageAtlas && !this.imageAtlas.uploaded && (this.imageAtlasTexture = new t.T(e1, this.imageAtlas.image, i.RGBA), this.imageAtlas.uploaded = !0), this.glyphAtlasImage && (this.glyphAtlasTexture = new t.T(e1, this.glyphAtlasImage, i.ALPHA), this.glyphAtlasImage = null);
            }
            prepare(e1) {
                this.imageAtlas && this.imageAtlas.patchUpdatedImages(e1, this.imageAtlasTexture);
            }
            queryRenderedFeatures(e1, t, i, o, a, r, s, n, l, c, h) {
                var u;
                return (null === (u = this.latestFeatureIndex) || void 0 === u ? void 0 : u.rawTileData) ? this.latestFeatureIndex.query({
                    queryGeometry: o,
                    cameraQueryGeometry: a,
                    scale: r,
                    tileSize: this.tileSize,
                    pixelPosMatrix: c,
                    transform: n,
                    params: s,
                    queryPadding: this.queryPadding * l,
                    getElevation: h
                }, e1, t, i) : {};
            }
            querySourceFeatures(e1, i) {
                const o = this.latestFeatureIndex;
                if (!(null == o ? void 0 : o.rawTileData)) return;
                const a = o.loadVTLayers(), r = (null == i ? void 0 : i.sourceLayer) ? i.sourceLayer : "", s = a[t.ag] || a[r];
                if (!s) return;
                const n = t.ah(null == i ? void 0 : i.filter, null == i ? void 0 : i.globalState), { z: l, x: c, y: h } = this.tileID.canonical, u = {
                    z: l,
                    x: c,
                    y: h
                };
                for(let i = 0; i < s.length; i++){
                    const a = s.feature(i);
                    if (n.needGeometry) {
                        const e1 = t.ai(a, !0);
                        if (!n.filter(new t.J(this.tileID.overscaledZ), e1, this.tileID.canonical)) continue;
                    } else if (!n.filter(new t.J(this.tileID.overscaledZ), a)) continue;
                    const d = o.getId(a, r), _ = new t.aj(a, l, c, h, d);
                    _.tile = u, e1.push(_);
                }
            }
            hasData() {
                return "loaded" === this.state || "reloading" === this.state || "expired" === this.state;
            }
            patternsLoaded() {
                return this.imageAtlas && !!Object.keys(this.imageAtlas.patternPositions).length;
            }
            setExpiryData(e1) {
                const i = this.expirationTime;
                if (e1.cacheControl) {
                    const i = t.ak(e1.cacheControl);
                    i["max-age"] && (this.expirationTime = Date.now() + 1e3 * i["max-age"]);
                } else e1.expires && (this.expirationTime = new Date(e1.expires).getTime());
                if (this.expirationTime) {
                    const e1 = Date.now();
                    let t = !1;
                    if (this.expirationTime > e1) t = !1;
                    else if (i) {
                        if (this.expirationTime < i) t = !0;
                        else {
                            const o = this.expirationTime - i;
                            o ? this.expirationTime = e1 + Math.max(o, 3e4) : t = !0;
                        }
                    } else t = !0;
                    t ? (this.expiredRequestCount++, this.state = "expired") : this.expiredRequestCount = 0;
                }
            }
            getExpiryTimeout() {
                if (this.expirationTime) return this.expiredRequestCount ? 1e3 * (1 << Math.min(this.expiredRequestCount - 1, 31)) : Math.min(this.expirationTime - (new Date).getTime(), Math.pow(2, 31) - 1);
            }
            setFeatureState(e1, i) {
                var o, a, r;
                if (!(null === (o = this.latestFeatureIndex) || void 0 === o ? void 0 : o.rawTileData) || 0 === Object.keys(e1).length) return;
                const s = this.latestFeatureIndex.loadVTLayers();
                for(const o in this.buckets){
                    if (!i.style.hasLayer(o)) continue;
                    const n = this.buckets[o], l = n.layers[0].sourceLayer || t.ag, c = s[l], h = e1[l];
                    if (!c || !h || 0 === Object.keys(h).length) continue;
                    n.update(h, c, (null === (a = this.imageAtlas) || void 0 === a ? void 0 : a.patternPositions) || {}, this.dashPositions || {});
                    const u = null === (r = null == i ? void 0 : i.style) || void 0 === r ? void 0 : r.getLayer(o);
                    u && (this.queryPadding = Math.max(this.queryPadding, u.queryRadius(n)));
                }
            }
            holdingForSymbolFade() {
                return void 0 !== this.symbolFadeHoldUntil;
            }
            symbolFadeFinished() {
                return !this.symbolFadeHoldUntil || this.symbolFadeHoldUntil < c();
            }
            clearSymbolFadeHold() {
                this.symbolFadeHoldUntil = void 0;
            }
            setSymbolHoldDuration(e1) {
                this.symbolFadeHoldUntil = c() + e1;
            }
            setDependencies(e1, t) {
                const i = {};
                for (const e1 of t)i[e1] = !0;
                this.dependencies[e1] = i;
            }
            hasDependency(e1, t) {
                for (const i of e1){
                    const e1 = this.dependencies[i];
                    if (e1) {
                        for (const i of t)if (e1[i]) return !0;
                    }
                }
                return !1;
            }
        }
        class _e {
            constructor(){
                this.state = {}, this.stateChanges = {}, this.deletedStates = {}, this.revision = 0;
            }
            updateState(e1, i, o) {
                var a, r, s, n, l;
                const c = String(i);
                if ((n = this.stateChanges)[e1] || (n[e1] = {}), (l = this.stateChanges[e1])[c] || (l[c] = {}), t.e(this.stateChanges[e1][c], o), null === this.deletedStates[e1]) {
                    this.deletedStates[e1] = {};
                    for(const t in this.state[e1])t !== c && (this.deletedStates[e1][t] = null);
                } else if (null === (null === (a = this.deletedStates[e1]) || void 0 === a ? void 0 : a[c])) {
                    this.deletedStates[e1][c] = {};
                    for(const t in this.state[e1][c])o[t] || (this.deletedStates[e1][c][t] = null);
                } else for(const t in o)null === (null === (s = null === (r = this.deletedStates[e1]) || void 0 === r ? void 0 : r[c]) || void 0 === s ? void 0 : s[t]) && delete this.deletedStates[e1][c][t];
            }
            removeFeatureState(e1, t, i) {
                var o, a, r;
                if (null === this.deletedStates[e1]) return;
                const s = String(t);
                if ((a = this.deletedStates)[e1] || (a[e1] = {}), i && void 0 !== t) null !== this.deletedStates[e1][s] && ((r = this.deletedStates[e1])[s] || (r[s] = {}), this.deletedStates[e1][s][i] = null);
                else if (void 0 !== t) {
                    if (null === (o = this.stateChanges[e1]) || void 0 === o ? void 0 : o[s]) for(i in this.deletedStates[e1][s] = {}, this.stateChanges[e1][s])this.deletedStates[e1][s][i] = null;
                    else this.deletedStates[e1][s] = null;
                } else this.deletedStates[e1] = null;
            }
            getState(e1, i) {
                const o = String(i), a = t.e({}, (this.state[e1] || {})[o], (this.stateChanges[e1] || {})[o]);
                if (null === this.deletedStates[e1]) return {};
                if (this.deletedStates[e1]) {
                    const t = this.deletedStates[e1][i];
                    if (null === t) return {};
                    for(const e1 in t)delete a[e1];
                }
                return a;
            }
            initializeTileState(e1, t) {
                e1.setFeatureState(this.state, t);
            }
            coalesceChanges(e1, i) {
                var o, a, r;
                const s = {};
                for(const e1 in this.stateChanges){
                    (o = this.state)[e1] || (o[e1] = {});
                    const i = {};
                    for(const o in this.stateChanges[e1])(a = this.state[e1])[o] || (a[o] = {}), t.e(this.state[e1][o], this.stateChanges[e1][o]), i[o] = this.state[e1][o];
                    s[e1] = i;
                }
                for(const e1 in this.deletedStates){
                    (r = this.state)[e1] || (r[e1] = {});
                    const i = {};
                    if (null === this.deletedStates[e1]) for(const t in this.state[e1])i[t] = {}, this.state[e1][t] = {};
                    else for(const t in this.deletedStates[e1]){
                        if (null === this.deletedStates[e1][t]) this.state[e1][t] = {};
                        else for (const i of Object.keys(this.deletedStates[e1][t]))delete this.state[e1][t][i];
                        i[t] = this.state[e1][t];
                    }
                    s[e1] || (s[e1] = {}), t.e(s[e1], i);
                }
                this.stateChanges = {}, this.deletedStates = {}, 0 !== Object.keys(s).length && (this.revision++, e1.setFeatureState(s, i));
            }
        }
        const pe = 89.25;
        function me(e1, i) {
            const o = t.al(i.lat, -t.am, t.am);
            return new t.P(t.Z(i.lng) * e1, t.Y(o) * e1);
        }
        function fe(e1, i) {
            return new t.a7(i.x / e1, i.y / e1).toLngLat();
        }
        function ge(e1) {
            return e1.cameraToCenterDistance * Math.min(.85 * Math.tan(t.an(90 - e1.pitch)), Math.tan(t.an(pe - e1.pitch)));
        }
        function ve(e1, i) {
            const o = e1.canonical, a = i / t.ao(o.z), r = o.x + Math.pow(2, o.z) * e1.wrap, s = t.ap(new Float64Array(16));
            return t.Q(s, s, [
                r * a,
                o.y * a,
                0
            ]), t.S(s, s, [
                a / t.a6,
                a / t.a6,
                1
            ]), s;
        }
        function xe(e1, i, o, a, r) {
            const s = t.a7.fromLngLat(e1, i), n = r * t.aq(1, e1.lat), { x: l, y: c, z: h } = be(o, a);
            return new t.a7(s.x + n * -l, s.y + n * -c, s.z + n * -h);
        }
        function be(e1, i) {
            const o = t.an(e1), a = t.an(i), r = Math.cos(-o), s = Math.sin(o);
            return {
                x: s * Math.sin(a),
                y: -s * Math.cos(a),
                z: r
            };
        }
        function ye(e1, t, i) {
            const o = t.intersectsFrustum(e1);
            if (!i || 0 === o) return o;
            const a = t.intersectsPlane(i);
            return 0 === a ? 0 : 2 === o && 2 === a ? 2 : 1;
        }
        function we(e1, t, i) {
            let o = 0;
            const a = (i - t) / 10;
            for(let r = 0; r < 10; r++)o += a * Math.pow(Math.cos(t + (r + .5) / 10 * (i - t)), e1);
            return o;
        }
        function Te(e1, i) {
            return function(o, a, r, s, n) {
                const l = 2 * ((e1 - 1) / t.ar(Math.cos(t.an(pe - n)) / Math.cos(t.an(pe))) - 1), c = Math.acos(r / s), h = 2 * we(l - 1, 0, t.an(n / 2)), u = Math.min(t.an(pe), c + t.an(n / 2)), d = we(l - 1, Math.min(u, c - t.an(n / 2)), u), _ = Math.atan(a / r), p = Math.hypot(a, r);
                let m = o;
                return m += t.ar(s / p / Math.max(.5, Math.cos(t.an(n / 2)))), m += l * t.ar(Math.cos(_)) / 2, m -= t.ar(Math.max(1, d / h / i)) / 2, m;
            };
        }
        const Pe = Te(9.314, 3);
        function Ce(e1, i) {
            const o = (i.roundZoom ? Math.round : Math.floor)(e1.zoom + t.ar(e1.tileSize / i.tileSize));
            return Math.max(0, o);
        }
        function Me(e1, i) {
            const o = e1.getCameraFrustum(), a = e1.getClippingPlane(), r = e1.screenPointToMercatorCoordinate(e1.getCameraPoint()), s = t.a7.fromLngLat(e1.center, e1.elevation);
            r.z = s.z + Math.cos(e1.pitchInRadians) * e1.cameraToCenterDistance / e1.worldSize;
            const n = e1.getCoveringTilesDetailsProvider(), l = n.allowVariableZoom(e1, i), c = Ce(e1, i), h = i.minzoom || 0, u = void 0 !== i.maxzoom ? i.maxzoom : e1.maxZoom, d = Math.min(Math.max(0, c), u), _ = Math.pow(2, d), p = [
                _ * r.x,
                _ * r.y,
                0
            ], m = [
                _ * s.x,
                _ * s.y,
                0
            ], f = Math.hypot(s.x - r.x, s.y - r.y), g = Math.abs(s.z - r.z), v = Math.hypot(f, g), x = (e1)=>({
                    zoom: 0,
                    x: 0,
                    y: 0,
                    wrap: e1,
                    fullyVisible: !1
                }), b = [], y = [];
            if (e1.renderWorldCopies && n.allowWorldCopies()) for(let e1 = 1; e1 <= 3; e1++)b.push(x(-e1)), b.push(x(e1));
            for(b.push(x(0)); b.length > 0;){
                const _ = b.pop(), f = _.x, x = _.y;
                let w = _.fullyVisible;
                const T = {
                    x: f,
                    y: x,
                    z: _.zoom
                }, P = n.getTileBoundingVolume(T, _.wrap, e1.elevation, i);
                if (!w) {
                    const e1 = ye(o, P, a);
                    if (0 === e1) continue;
                    w = 2 === e1;
                }
                const C = n.distanceToTile2d(r.x, r.y, T, P);
                let M = c;
                l && (M = (i.calculateTileZoom || Pe)(e1.zoom + t.ar(e1.tileSize / i.tileSize), C, g, v, e1.fov)), M = (i.roundZoom ? Math.round : Math.floor)(M), M = Math.max(0, M);
                const I = Math.min(M, u);
                if (_.wrap = n.getWrap(s, T, _.wrap), _.zoom >= I) {
                    if (_.zoom < h) continue;
                    const e1 = d - _.zoom, o = p[0] - .5 - (f << e1), a = p[1] - .5 - (x << e1), r = i.reparseOverscaled ? Math.max(_.zoom, M) : _.zoom;
                    y.push({
                        tileID: new t.a3(_.zoom === u ? r : _.zoom, _.wrap, _.zoom, f, x),
                        distanceSq: t.as([
                            m[0] - .5 - f,
                            m[1] - .5 - x
                        ]),
                        tileDistanceToCamera: Math.sqrt(o * o + a * a)
                    });
                } else for(let e1 = 0; e1 < 4; e1++)b.push({
                    zoom: _.zoom + 1,
                    x: (f << 1) + e1 % 2,
                    y: (x << 1) + (e1 >> 1),
                    wrap: _.wrap,
                    fullyVisible: w
                });
            }
            return y.sort((e1, t)=>e1.distanceSq - t.distanceSq).map((e1)=>e1.tileID);
        }
        const Ie = t.a8.fromPoints([
            new t.P(0, 0),
            new t.P(t.a6, t.a6)
        ]);
        function Ee(e1) {
            return "raster" === e1 || "image" === e1 || "video" === e1;
        }
        function Se(e1, t, i, o, a, r, s) {
            if (!t.hasData()) return !1;
            const { tileID: n, fadingRole: l, fadingDirection: c, fadingParentID: h } = t;
            if (l === he.Base && c === ue.Incoming && h) return i[h.key] = h, !0;
            const u = Math.max(n.overscaledZ - a, r);
            for(let a = n.overscaledZ - 1; a >= u; a--){
                const r = n.scaledTo(a), l = e1.getLoadedTile(r);
                if (l) return t.setCrossFadeLogic({
                    fadingRole: he.Base,
                    fadingDirection: ue.Incoming,
                    fadingParentID: l.tileID,
                    fadeEndTime: o + s
                }), l.setCrossFadeLogic({
                    fadingRole: he.Parent,
                    fadingDirection: ue.Departing,
                    fadeEndTime: o + s
                }), i[r.key] = r, !0;
            }
            return !1;
        }
        function ze(e1, t, i, o, a, r) {
            if (!t.hasData()) return !1;
            const s = t.tileID.children(a);
            let n = Re(e1, t, s, i, o, a, r);
            if (n) return !0;
            for (const l of s)Re(e1, t, l.children(a), i, o, a, r) && (n = !0);
            return n;
        }
        function Re(e1, t, i, o, a, r, s) {
            if (i[0].overscaledZ >= r) return !1;
            let n = !1;
            for (const r of i){
                const i = e1.getLoadedTile(r);
                if (!i) continue;
                const { fadingRole: l, fadingDirection: c, fadingParentID: h } = i;
                l === he.Base && c === ue.Departing && h || (i.setCrossFadeLogic({
                    fadingRole: he.Base,
                    fadingDirection: ue.Departing,
                    fadingParentID: t.tileID,
                    fadeEndTime: a + s
                }), t.setCrossFadeLogic({
                    fadingRole: he.Parent,
                    fadingDirection: ue.Incoming,
                    fadeEndTime: a + s
                })), o[r.key] = r, n = !0;
            }
            return n;
        }
        function De(e1, t, i, o) {
            const a = e1.tileID;
            return !!e1.selfFading || !e1.hasData() && !!t.has(a) && (e1.setSelfFadeLogic(i + o), !0);
        }
        function Ae(e1, t) {
            var i;
            e1.needsHillshadePrepare = !0, e1.needsTerrainPrepare = !0;
            let o = t.tileID.canonical.x - e1.tileID.canonical.x;
            const a = t.tileID.canonical.y - e1.tileID.canonical.y, r = Math.pow(2, e1.tileID.canonical.z), s = t.tileID.key;
            0 === o && 0 === a || Math.abs(a) > 1 || (Math.abs(o) > 1 && (1 === Math.abs(o + r) ? o += r : 1 === Math.abs(o - r) && (o -= r)), t.dem && e1.dem && (e1.dem.backfillBorder(t.dem, o, a), (null === (i = e1.neighboringTiles) || void 0 === i ? void 0 : i[s]) && (e1.neighboringTiles[s].backfilled = !0)));
        }
        class Le {
            constructor(){
                this._tiles = {};
            }
            handleWrapJump(e1) {
                const t = {};
                for(const i in this._tiles){
                    const o = this._tiles[i];
                    o.tileID = o.tileID.unwrapTo(o.tileID.wrap + e1), t[o.tileID.key] = o;
                }
                this._tiles = t;
            }
            setFeatureState(e1, t) {
                for(const i in this._tiles)this._tiles[i].setFeatureState(e1, t);
            }
            getAllTiles() {
                return Object.values(this._tiles);
            }
            getAllIds(e1 = !1) {
                return e1 ? Object.values(this._tiles).map((e1)=>e1.tileID).sort(t.au).map((e1)=>e1.key) : Object.keys(this._tiles);
            }
            getTileById(e1) {
                return this._tiles[e1];
            }
            setTile(e1, t) {
                this._tiles[e1] = t;
            }
            deleteTileById(e1) {
                delete this._tiles[e1];
            }
            getLoadedTile(e1) {
                const t = this.getTileById(e1.key);
                return (null == t ? void 0 : t.hasData()) ? t : null;
            }
            isIdRenderable(e1, t = !1) {
                var i;
                return null === (i = this.getTileById(e1)) || void 0 === i ? void 0 : i.isRenderable(t);
            }
            getRenderableIds(e1 = 0, i) {
                const o = [];
                for (const e1 of this.getAllIds())this.isIdRenderable(e1, i) && o.push(this.getTileById(e1));
                return i ? o.sort((i, o)=>{
                    const a = i.tileID, r = o.tileID, s = new t.P(a.canonical.x, a.canonical.y)._rotate(-e1), n = new t.P(r.canonical.x, r.canonical.y)._rotate(-e1);
                    return a.overscaledZ - r.overscaledZ || n.y - s.y || n.x - s.x;
                }).map((e1)=>e1.tileID.key) : o.map((e1)=>e1.tileID).sort(t.au).map((e1)=>e1.key);
            }
        }
        class Fe extends t.E {
            constructor(e1, i, o){
                super(), this.id = e1, this.dispatcher = o, this.on("data", (e1)=>{
                    this._dataHandler(e1);
                }), this.on("dataloading", ()=>{
                    this._sourceErrored = !1;
                }), this.on("error", ()=>{
                    this._sourceErrored = this._source.loaded();
                }), this._source = ((e1, t, i, o)=>{
                    const a = new (re(t.type))(e1, t, i, o);
                    if (a.id !== e1) throw new Error(`Expected Source id to be ${e1} instead of ${a.id}`);
                    return a;
                })(e1, i, o, this), this._inViewTiles = new Le, this._outOfViewCache = new t.av(0, (e1)=>this._unloadTile(e1)), this._timers = {}, this._maxTileCacheSize = null, this._maxTileCacheZoomLevels = null, this._rasterFadeDuration = 0, this._maxFadingAncestorLevels = 5, this._state = new _e, this._didEmitContent = !1, this._updated = !1;
            }
            onAdd(e1) {
                var t;
                this.map = e1, this._maxTileCacheSize = e1 ? e1._maxTileCacheSize : null, this._maxTileCacheZoomLevels = e1 ? e1._maxTileCacheZoomLevels : null, (null === (t = this._source) || void 0 === t ? void 0 : t.onAdd) && this._source.onAdd(e1);
            }
            onRemove(e1) {
                var t;
                for (const e1 of this._inViewTiles.getAllTiles())e1.unloadVectorData();
                this.clearTiles(), (null === (t = this._source) || void 0 === t ? void 0 : t.onRemove) && this._source.onRemove(e1), this._inViewTiles = new Le;
            }
            loaded() {
                if (this._sourceErrored) return !0;
                if (!this._sourceLoaded) return !1;
                if (!this._source.loaded()) return !1;
                if (!(void 0 === this.used && void 0 === this.usedForTerrain || this.used || this.usedForTerrain)) return !0;
                if (!this._updated) return !1;
                for (const e1 of this._inViewTiles.getAllTiles())if ("loaded" !== e1.state && "errored" !== e1.state) return !1;
                return !0;
            }
            getSource() {
                return this._source;
            }
            getState() {
                return this._state;
            }
            pause() {
                this._paused = !0;
            }
            resume() {
                if (!this._paused) return;
                const e1 = this._shouldReloadOnResume;
                this._paused = !1, this._shouldReloadOnResume = !1, e1 && this.reload(), this.transform && this.update(this.transform, this.terrain);
            }
            _loadTile(e1, i, o) {
                return t._(this, void 0, void 0, function*() {
                    try {
                        const t = yield this._source.loadTile(e1);
                        this._tileLoaded(e1, i, o, t);
                    } catch (i) {
                        e1.state = "errored", 404 !== i.status ? this._source.fire(new t.l(t.d(i), {
                            tile: e1
                        })) : this.update(this.transform, this.terrain);
                    }
                });
            }
            _unloadTile(e1) {
                this._source.unloadTile && this._source.unloadTile(e1);
            }
            _abortTile(e1) {
                this._source.abortTile && this._source.abortTile(e1), this._source.fire(new t.n("dataabort", {
                    tile: e1,
                    coord: e1.tileID,
                    dataType: "source"
                }));
            }
            serialize() {
                return this._source.serialize();
            }
            prepare(e1) {
                this._source.prepare && this._source.prepare(), this._state.coalesceChanges(this._inViewTiles, this.map ? this.map.painter : null);
                for (const t of this._inViewTiles.getAllTiles())t.upload(e1), t.prepare(this.map.style.imageManager);
            }
            getIds() {
                return this._inViewTiles.getAllIds(!0);
            }
            getRenderableIds(e1) {
                var t;
                return this._inViewTiles.getRenderableIds(null === (t = this.transform) || void 0 === t ? void 0 : t.bearingInRadians, e1);
            }
            hasRenderableParent(e1) {
                const t = e1.overscaledZ - 1;
                if (t >= this._source.minzoom) {
                    const i = this.getLoadedTile(e1.scaledTo(t));
                    if (i) return this._inViewTiles.isIdRenderable(i.tileID.key);
                }
                return !1;
            }
            reload(e1, t) {
                if (this._paused) this._shouldReloadOnResume = !0;
                else {
                    this._outOfViewCache.reset();
                    for (const i of this._inViewTiles.getAllIds()){
                        const o = this._inViewTiles.getTileById(i);
                        t && !this._source.shouldReloadTile(o, t) || (e1 ? this._reloadTile(i, "expired") : "errored" !== o.state && this._reloadTile(i, "reloading"));
                    }
                }
            }
            _reloadTile(e1, i) {
                return t._(this, void 0, void 0, function*() {
                    const t = this._inViewTiles.getTileById(e1);
                    t && ("loading" !== t.state && (t.state = i), yield this._loadTile(t, e1, i));
                });
            }
            _tileLoaded(e1, i, o, a) {
                e1.timeAdded = c(), e1.selfFading && (e1.fadeEndTime = e1.timeAdded + this._rasterFadeDuration), "expired" === o && (e1.refreshedUponExpiration = !0), this._setTileReloadTimer(i, e1), (null == a ? void 0 : a.unmodified) || ("raster-dem" === this.getSource().type && e1.dem && function(e1, t) {
                    var i, o, a;
                    const r = t.getRenderableIds();
                    for (const s of r){
                        if (!(null === (i = e1.neighboringTiles) || void 0 === i ? void 0 : i[s])) continue;
                        const r = t.getTileById(s);
                        e1.neighboringTiles[s].backfilled || Ae(e1, r), (null === (a = null === (o = r.neighboringTiles) || void 0 === o ? void 0 : o[e1.tileID.key]) || void 0 === a ? void 0 : a.backfilled) || Ae(r, e1);
                    }
                }(e1, this._inViewTiles), this._state.initializeTileState(e1, this.map ? this.map.painter : null), e1.aborted || this._source.fire(new t.n("data", {
                    dataType: "source",
                    tile: e1,
                    coord: e1.tileID
                })));
            }
            getTile(e1) {
                return this.getTileByID(e1.key);
            }
            getTileByID(e1) {
                return this._inViewTiles.getTileById(e1);
            }
            _retainLoadedChildren(e1, t) {
                const i = this._getLoadedDescendents(t), o = new Set;
                for (const a of t){
                    const t = i[a.key];
                    if (!(null == t ? void 0 : t.length)) {
                        o.add(a);
                        continue;
                    }
                    const r = a.overscaledZ + Fe.maxOverzooming, s = t.filter((e1)=>e1.tileID.overscaledZ <= r);
                    if (!s.length) {
                        o.add(a);
                        continue;
                    }
                    const n = Math.min(...s.map((e1)=>e1.tileID.overscaledZ)), l = s.filter((e1)=>e1.tileID.overscaledZ === n).map((e1)=>e1.tileID);
                    for (const t of l)e1[t.key] = t;
                    this._areDescendentsComplete(l, n, a.overscaledZ) || o.add(a);
                }
                return o;
            }
            _getLoadedDescendents(e1) {
                var t;
                const i = {};
                for (const o of this._inViewTiles.getAllTiles().filter((e1)=>e1.hasData()))for (const a of e1)o.tileID.isChildOf(a) && (i[t = a.key] || (i[t] = []), i[a.key].push(o));
                return i;
            }
            _areDescendentsComplete(e1, t, i) {
                return 1 === e1.length && e1[0].isOverscaled() ? e1[0].overscaledZ === t : Math.pow(4, t - i) === e1.length;
            }
            getLoadedTile(e1) {
                return this._inViewTiles.getLoadedTile(e1);
            }
            updateCacheSize(e1) {
                const i = Math.ceil(e1.width / this._source.tileSize) + 1, o = Math.ceil(e1.height / this._source.tileSize) + 1, a = Math.floor(i * o * (null === this._maxTileCacheZoomLevels ? t.c.MAX_TILE_CACHE_ZOOM_LEVELS : this._maxTileCacheZoomLevels)), r = "number" == typeof this._maxTileCacheSize ? Math.min(this._maxTileCacheSize, a) : a;
                this._outOfViewCache.setMaxSize(r);
            }
            handleWrapJump(e1) {
                const t = Math.round((e1 - (void 0 === this._prevLng ? e1 : this._prevLng)) / 360);
                this._prevLng = e1, t && (this._inViewTiles.handleWrapJump(t), this._resetTileReloadTimers());
            }
            update(e1, i) {
                if (!this._sourceLoaded || this._paused) return;
                let o;
                this.transform = e1, this.terrain = i, this.updateCacheSize(e1), this.handleWrapJump(this.transform.center.lng), this.used || this.usedForTerrain ? this._source.tileID ? o = e1.getVisibleUnwrappedCoordinates(this._source.tileID).map((e1)=>new t.a3(e1.canonical.z, e1.wrap, e1.canonical.z, e1.canonical.x, e1.canonical.y)) : (o = Me(e1, {
                    tileSize: this.usedForTerrain ? this.tileSize : this._source.tileSize,
                    minzoom: this._source.minzoom,
                    maxzoom: "vector" === this._source.type && void 0 !== this.map._zoomLevelsToOverscale ? e1.maxZoom - this.map._zoomLevelsToOverscale : this._source.maxzoom,
                    roundZoom: !this.usedForTerrain && this._source.roundZoom,
                    reparseOverscaled: this._source.reparseOverscaled,
                    terrain: i,
                    calculateTileZoom: this._source.calculateTileZoom
                }), this._source.hasTile && (o = o.filter((e1)=>this._source.hasTile(e1)))) : o = [], this.usedForTerrain && (o = this._addTerrainIdealTiles(o));
                const a = 0 === o.length && !this._updated && this._didEmitContent;
                this._updated = !0, a && this.fire(new t.n("data", {
                    sourceDataType: "idle",
                    dataType: "source",
                    sourceId: this.id
                }));
                const r = Ce(e1, this._source), s = this._updateRetainedTiles(o, r), n = Ee(this._source.type);
                n && this._rasterFadeDuration > 0 && !i && function(e1, i, o, a, r, s, n) {
                    const l = c(), h = t.at(i);
                    for (const t of i){
                        const i = e1.getTileById(t.key);
                        i.fadingDirection !== ue.Departing && 0 !== i.fadeOpacity || i.resetFadeLogic(), Se(e1, i, o, l, a, r, n) || ze(e1, i, o, l, s, n) || De(i, h, l, n) || i.resetFadeLogic();
                    }
                }(this._inViewTiles, o, s, this._maxFadingAncestorLevels, this._source.minzoom, this._source.maxzoom, this._rasterFadeDuration), n ? this._cleanUpRasterTiles(s) : this._cleanUpVectorTiles(s);
            }
            _cleanUpRasterTiles(e1) {
                for (const t of this._inViewTiles.getAllIds())e1[t] || this._removeTile(t);
            }
            _cleanUpVectorTiles(e1) {
                for (const t of this._inViewTiles.getAllIds()){
                    const i = this._inViewTiles.getTileById(t);
                    e1[t] ? i.clearSymbolFadeHold() : i.hasSymbolBuckets ? i.holdingForSymbolFade() ? i.symbolFadeFinished() && this._removeTile(t) : i.setSymbolHoldDuration(this.map._fadeDuration) : this._removeTile(t);
                }
            }
            _addTerrainIdealTiles(e1) {
                const t = [];
                for (const i of e1)if (i.canonical.z > this._source.minzoom) {
                    const e1 = i.scaledTo(i.canonical.z - 1);
                    t.push(e1);
                    const o = i.scaledTo(Math.max(this._source.minzoom, Math.min(i.canonical.z, 5)));
                    t.push(o);
                }
                return e1.concat(t);
            }
            releaseSymbolFadeTiles() {
                for (const e1 of this._inViewTiles.getAllIds())this._inViewTiles.getTileById(e1).holdingForSymbolFade() && this._removeTile(e1);
            }
            _updateRetainedTiles(e1, t) {
                var i;
                const o = new Set;
                for (const t of e1)this._addTile(t).hasData() || o.add(t);
                const a = e1.reduce((e1, t)=>(e1[t.key] = t, e1), {}), r = this._retainLoadedChildren(a, o), s = {}, n = Math.max(t - Fe.maxUnderzooming, this._source.minzoom);
                for (const e1 of r){
                    let t = this._inViewTiles.getTileById(e1.key), o = null == t ? void 0 : t.wasRequested();
                    for(let r = e1.overscaledZ - 1; r >= n; --r){
                        const n = e1.scaledTo(r);
                        if (s[n.key]) break;
                        if (s[n.key] = !0, t = this.getTile(n), !t && o && (t = this._addTile(n)), t) {
                            const e1 = t.hasData();
                            if ((e1 || !(null === (i = this.map) || void 0 === i ? void 0 : i.cancelPendingTileRequestsWhileZooming) || o) && (a[n.key] = n), o = t.wasRequested(), e1) break;
                        }
                    }
                }
                return a;
            }
            _addTile(e1) {
                let i = this._inViewTiles.getTileById(e1.key);
                if (i) return i;
                i = this._outOfViewCache.getAndRemove(e1), i && (i.resetFadeLogic(), this._setTileReloadTimer(e1.key, i), i.tileID = e1, this._state.initializeTileState(i, this.map ? this.map.painter : null));
                const o = i;
                return i || (i = new de(e1, this._source.tileSize * e1.overscaleFactor()), this._loadTile(i, e1.key, i.state)), i.uses++, this._inViewTiles.setTile(e1.key, i), o || this._source.fire(new t.n("dataloading", {
                    tile: i,
                    coord: i.tileID,
                    dataType: "source"
                })), i;
            }
            _setTileReloadTimer(e1, t) {
                this._clearTileReloadTimer(e1);
                const i = t.getExpiryTimeout();
                i && (this._timers[e1] = setTimeout(()=>{
                    this._reloadTile(e1, "expired"), delete this._timers[e1];
                }, i));
            }
            _clearTileReloadTimer(e1) {
                const t = this._timers[e1];
                t && (clearTimeout(t), delete this._timers[e1]);
            }
            _resetTileReloadTimers() {
                for(const e1 in this._timers)clearTimeout(this._timers[e1]), delete this._timers[e1];
                for (const e1 of this._inViewTiles.getAllIds()){
                    const t = this._inViewTiles.getTileById(e1);
                    this._setTileReloadTimer(e1, t);
                }
            }
            refreshTiles(e1) {
                for (const t of this._inViewTiles.getAllIds()){
                    const i = this._inViewTiles.getTileById(t);
                    (this._inViewTiles.isIdRenderable(t) || "errored" == i.state) && e1.some((e1)=>e1.equals(i.tileID.canonical)) && this._reloadTile(t, "expired");
                }
            }
            _removeTile(e1) {
                const t = this._inViewTiles.getTileById(e1);
                t && (t.uses--, this._inViewTiles.deleteTileById(e1), this._clearTileReloadTimer(e1), t.uses > 0 || (t.hasData() && "reloading" !== t.state ? this._outOfViewCache.add(t.tileID, t, t.getExpiryTimeout()) : (t.aborted = !0, this._abortTile(t), this._unloadTile(t))));
            }
            _dataHandler(e1) {
                "source" === e1.dataType && ("metadata" !== e1.sourceDataType ? "content" === e1.sourceDataType && this._sourceLoaded && !this._paused && (this.reload(e1.sourceDataChanged, e1.shouldReloadTileOptions), this.transform && this.update(this.transform, this.terrain), this._didEmitContent = !0) : this._sourceLoaded = !0);
            }
            clearTiles() {
                this._shouldReloadOnResume = !1, this._paused = !1;
                for (const e1 of this._inViewTiles.getAllIds())this._removeTile(e1);
                this._outOfViewCache.reset();
            }
            tilesIn(e1, i, o) {
                const a = [], r = this.transform;
                if (!r) return a;
                const s = r.getCoveringTilesDetailsProvider().allowWorldCopies(), n = o ? r.getCameraQueryGeometry(e1) : e1, l = (e1)=>r.screenPointToMercatorCoordinate(e1, this.terrain), c = this.transformBbox(e1, l, !s), h = this.transformBbox(n, l, !s), u = this.getIds(), d = t.a8.fromPoints(h);
                for (const e1 of u){
                    const o = this._inViewTiles.getTileById(e1);
                    if (o.holdingForSymbolFade()) continue;
                    const n = s ? [
                        o.tileID
                    ] : [
                        o.tileID.unwrapTo(-1),
                        o.tileID.unwrapTo(0)
                    ], l = Math.pow(2, r.zoom - o.tileID.overscaledZ), u = i * o.queryPadding * t.a6 / o.tileSize / l;
                    for (const e1 of n){
                        const i = d.map((i)=>e1.getTilePoint(new t.a7(i.x, i.y)));
                        if (i.expandBy(u), i.intersects(Ie)) {
                            const t = c.map((t)=>e1.getTilePoint(t)), i = h.map((t)=>e1.getTilePoint(t));
                            a.push({
                                tile: o,
                                tileID: s ? e1 : e1.unwrapTo(0),
                                queryGeometry: t,
                                cameraQueryGeometry: i,
                                scale: l
                            });
                        }
                    }
                }
                return a;
            }
            transformBbox(e1, i, o) {
                let a = e1.map(i);
                if (o) {
                    const o = t.a8.fromPoints(e1);
                    o.shrinkBy(.001 * Math.min(o.width(), o.height()));
                    const r = o.map(i);
                    t.a8.fromPoints(a).covers(r) || (a = a.map((e1)=>e1.x > .5 ? new t.a7(e1.x - 1, e1.y, e1.z) : e1));
                }
                return a;
            }
            getVisibleCoordinates(e1) {
                const t = this.getRenderableIds(e1).map((e1)=>this._inViewTiles.getTileById(e1).tileID);
                return this.transform && this.transform.populateCache(t), t;
            }
            hasTransition() {
                return !!this._source.hasTransition() || Ee(this._source.type) && function(e1, t) {
                    if (t <= 0) return !1;
                    const i = c();
                    for (const t of e1.getAllTiles())if (t.fadeEndTime >= i) return !0;
                    return !1;
                }(this._inViewTiles, this._rasterFadeDuration);
            }
            setRasterFadeDuration(e1) {
                this._rasterFadeDuration = e1;
            }
            setFeatureState(e1, i, o) {
                e1 || (e1 = t.ag), this._state.updateState(e1, i, o);
            }
            removeFeatureState(e1, i, o) {
                e1 || (e1 = t.ag), this._state.removeFeatureState(e1, i, o);
            }
            getFeatureState(e1, i) {
                return e1 || (e1 = t.ag), this._state.getState(e1, i);
            }
            setDependencies(e1, t, i) {
                const o = this._inViewTiles.getTileById(e1);
                o && o.setDependencies(t, i);
            }
            reloadTilesForDependencies(e1, t) {
                for (const i of this._inViewTiles.getAllIds())this._inViewTiles.getTileById(i).hasDependency(e1, t) && this._reloadTile(i, "reloading");
                this._outOfViewCache.filter((i)=>!i.hasDependency(e1, t));
            }
            areTilesLoaded() {
                for (const e1 of this._inViewTiles.getAllTiles())if ("loaded" !== e1.state && "errored" !== e1.state) return !1;
                return !0;
            }
        }
        Fe.maxUnderzooming = 10, Fe.maxOverzooming = 3;
        class ke {
            constructor(e1, t){
                this.reset(e1, t);
            }
            reset(e1, t) {
                this.points = e1 || [], this._distances = [
                    0
                ];
                for(let e1 = 1; e1 < this.points.length; e1++)this._distances[e1] = this._distances[e1 - 1] + this.points[e1].dist(this.points[e1 - 1]);
                this.length = this._distances[this._distances.length - 1], this.padding = Math.min(t || 0, .5 * this.length), this.paddedLength = this.length - 2 * this.padding;
            }
            lerp(e1) {
                if (1 === this.points.length) return this.points[0];
                e1 = t.al(e1, 0, 1);
                let i = 1, o = this._distances[i];
                const a = e1 * this.paddedLength + this.padding;
                for(; o < a && i < this._distances.length;)o = this._distances[++i];
                const r = i - 1, s = this._distances[r], n = o - s, l = n > 0 ? (a - s) / n : 0;
                return this.points[r].mult(1 - l).add(this.points[i].mult(l));
            }
        }
        function Be(e1, t) {
            let i = !0;
            return "always" === e1 || "never" !== e1 && "never" !== t || (i = !1), i;
        }
        class Oe {
            constructor(e1, t, i){
                const o = this.boxCells = [], a = this.circleCells = [];
                this.xCellCount = Math.ceil(e1 / i), this.yCellCount = Math.ceil(t / i);
                for(let e1 = 0; e1 < this.xCellCount * this.yCellCount; e1++)o.push([]), a.push([]);
                this.circleKeys = [], this.boxKeys = [], this.bboxes = [], this.circles = [], this.width = e1, this.height = t, this.xScale = this.xCellCount / e1, this.yScale = this.yCellCount / t, this.boxUid = 0, this.circleUid = 0;
            }
            keysLength() {
                return this.boxKeys.length + this.circleKeys.length;
            }
            insert(e1, t, i, o, a) {
                this._forEachCell(t, i, o, a, this._insertBoxCell, this.boxUid++), this.boxKeys.push(e1), this.bboxes.push(t), this.bboxes.push(i), this.bboxes.push(o), this.bboxes.push(a);
            }
            insertCircle(e1, t, i, o) {
                this._forEachCell(t - o, i - o, t + o, i + o, this._insertCircleCell, this.circleUid++), this.circleKeys.push(e1), this.circles.push(t), this.circles.push(i), this.circles.push(o);
            }
            _insertBoxCell(e1, t, i, o, a, r) {
                this.boxCells[a].push(r);
            }
            _insertCircleCell(e1, t, i, o, a, r) {
                this.circleCells[a].push(r);
            }
            _query(e1, t, i, o, a, r, s) {
                if (i < 0 || e1 > this.width || o < 0 || t > this.height) return [];
                const n = [];
                if (e1 <= 0 && t <= 0 && this.width <= i && this.height <= o) {
                    if (a) return [
                        {
                            key: null,
                            x1: e1,
                            y1: t,
                            x2: i,
                            y2: o
                        }
                    ];
                    for(let e1 = 0; e1 < this.boxKeys.length; e1++)n.push({
                        key: this.boxKeys[e1],
                        x1: this.bboxes[4 * e1],
                        y1: this.bboxes[4 * e1 + 1],
                        x2: this.bboxes[4 * e1 + 2],
                        y2: this.bboxes[4 * e1 + 3]
                    });
                    for(let e1 = 0; e1 < this.circleKeys.length; e1++){
                        const t = this.circles[3 * e1], i = this.circles[3 * e1 + 1], o = this.circles[3 * e1 + 2];
                        n.push({
                            key: this.circleKeys[e1],
                            x1: t - o,
                            y1: i - o,
                            x2: t + o,
                            y2: i + o
                        });
                    }
                } else this._forEachCell(e1, t, i, o, this._queryCell, n, {
                    hitTest: a,
                    overlapMode: r,
                    seenUids: {
                        box: {},
                        circle: {}
                    }
                }, s);
                return n;
            }
            query(e1, t, i, o) {
                return this._query(e1, t, i, o, !1, null);
            }
            hitTest(e1, t, i, o, a, r) {
                return this._query(e1, t, i, o, !0, a, r).length > 0;
            }
            hitTestCircle(e1, t, i, o, a) {
                const r = e1 - i, s = e1 + i, n = t - i, l = t + i;
                if (s < 0 || r > this.width || l < 0 || n > this.height) return !1;
                const c = [];
                return this._forEachCell(r, n, s, l, this._queryCellCircle, c, {
                    hitTest: !0,
                    overlapMode: o,
                    circle: {
                        x: e1,
                        y: t,
                        radius: i
                    },
                    seenUids: {
                        box: {},
                        circle: {}
                    }
                }, a), c.length > 0;
            }
            _queryCell(e1, t, i, o, a, r, s, n) {
                const { seenUids: l, hitTest: c, overlapMode: h } = s, u = this.boxCells[a], d = 1e-6;
                if (null !== u) {
                    const a = this.bboxes;
                    for (const s of u)if (!l.box[s]) {
                        l.box[s] = !0;
                        const u = 4 * s, _ = this.boxKeys[s];
                        if (e1 <= a[u + 2] + d && t <= a[u + 3] + d && i >= a[u + 0] - d && o >= a[u + 1] - d && (!n || n(_)) && (!c || !Be(h, _.overlapMode)) && (r.push({
                            key: _,
                            x1: a[u],
                            y1: a[u + 1],
                            x2: a[u + 2],
                            y2: a[u + 3]
                        }), c)) return !0;
                    }
                }
                const _ = this.circleCells[a];
                if (null !== _) {
                    const a = this.circles;
                    for (const s of _)if (!l.circle[s]) {
                        l.circle[s] = !0;
                        const u = 3 * s, d = this.circleKeys[s];
                        if (this._circleAndRectCollide(a[u], a[u + 1], a[u + 2], e1, t, i, o) && (!n || n(d)) && (!c || !Be(h, d.overlapMode))) {
                            const e1 = a[u], t = a[u + 1], i = a[u + 2];
                            if (r.push({
                                key: d,
                                x1: e1 - i,
                                y1: t - i,
                                x2: e1 + i,
                                y2: t + i
                            }), c) return !0;
                        }
                    }
                }
                return !1;
            }
            _queryCellCircle(e1, t, i, o, a, r, s, n) {
                const { circle: l, seenUids: c, overlapMode: h } = s, u = this.boxCells[a];
                if (null !== u) {
                    const e1 = this.bboxes;
                    for (const t of u)if (!c.box[t]) {
                        c.box[t] = !0;
                        const i = 4 * t, o = this.boxKeys[t];
                        if (this._circleAndRectCollide(l.x, l.y, l.radius, e1[i + 0], e1[i + 1], e1[i + 2], e1[i + 3]) && (!n || n(o)) && !Be(h, o.overlapMode)) return r.push(!0), !0;
                    }
                }
                const d = this.circleCells[a];
                if (null !== d) {
                    const e1 = this.circles;
                    for (const t of d)if (!c.circle[t]) {
                        c.circle[t] = !0;
                        const i = 3 * t, o = this.circleKeys[t];
                        if (this._circlesCollide(e1[i], e1[i + 1], e1[i + 2], l.x, l.y, l.radius) && (!n || n(o)) && !Be(h, o.overlapMode)) return r.push(!0), !0;
                    }
                }
            }
            _forEachCell(e1, t, i, o, a, r, s, n) {
                const l = this._convertToXCellCoord(e1), c = this._convertToYCellCoord(t), h = this._convertToXCellCoord(i), u = this._convertToYCellCoord(o);
                for(let d = l; d <= h; d++)for(let l = c; l <= u; l++)if (a.call(this, e1, t, i, o, this.xCellCount * l + d, r, s, n)) return;
            }
            _convertToXCellCoord(e1) {
                return Math.max(0, Math.min(this.xCellCount - 1, Math.floor(e1 * this.xScale)));
            }
            _convertToYCellCoord(e1) {
                return Math.max(0, Math.min(this.yCellCount - 1, Math.floor(e1 * this.yScale)));
            }
            _circlesCollide(e1, t, i, o, a, r) {
                const s = o - e1, n = a - t, l = i + r;
                return l * l > s * s + n * n;
            }
            _circleAndRectCollide(e1, t, i, o, a, r, s) {
                const n = (r - o) / 2, l = Math.abs(e1 - (o + n));
                if (l > n + i) return !1;
                const c = (s - a) / 2, h = Math.abs(t - (a + c));
                if (h > c + i) return !1;
                if (l <= n || h <= c) return !0;
                const u = l - n, d = h - c;
                return u * u + d * d <= i * i;
            }
        }
        function je(e1, t) {
            const i = 1 / (t[0] * t[0] + t[1] * t[1] + t[2] * t[2]), o = 1 / (t[8] * t[8] + t[9] * t[9] + t[10] * t[10]), a = t[0] * i, r = t[4] * i, s = t[8] * o, n = t[1] * i, l = t[5] * i, c = t[9] * o, h = t[2] * i, u = t[6] * i, d = t[10] * o;
            e1[0] = a, e1[1] = r, e1[2] = s, e1[4] = n, e1[5] = l, e1[6] = c, e1[8] = h, e1[9] = u, e1[10] = d;
            const _ = t[12], p = t[13], m = t[14];
            return e1[12] = -a * _ - n * p - h * m, e1[13] = -r * _ - l * p - u * m, e1[14] = -s * _ - c * p - d * m, e1[3] = 0, e1[7] = 0, e1[11] = 0, e1[15] = 1, e1;
        }
        const Ne = t.O();
        function Ze(e1, i, a) {
            const r = t.O();
            if (!e1) {
                const { vecSouth: e1, vecEast: t } = Ge(i), a = o();
                a[0] = t[0], a[1] = t[1], a[2] = e1[0], a[3] = e1[1], s = a, (d = (l = (n = a)[0]) * (u = n[3]) - (h = n[2]) * (c = n[1])) && (s[0] = u * (d = 1 / d), s[1] = -c * d, s[2] = -h * d, s[3] = l * d), r[0] = a[0], r[1] = a[1], r[4] = a[2], r[5] = a[3];
            }
            var s, n, l, c, h, u, d;
            return t.S(r, r, [
                1 / a,
                1 / a,
                1
            ]), r;
        }
        function Ue(e1, i, o, a) {
            if (e1) {
                const e1 = t.O();
                if (!i) {
                    const { vecSouth: t, vecEast: i } = Ge(o);
                    e1[0] = i[0], e1[1] = i[1], e1[4] = t[0], e1[5] = t[1];
                }
                return t.S(e1, e1, [
                    a,
                    a,
                    1
                ]), e1;
            }
            return o.pixelsToClipSpaceMatrix;
        }
        function Ge(e1) {
            const i = Math.cos(e1.rollInRadians), o = Math.sin(e1.rollInRadians), a = Math.cos(e1.pitchInRadians), r = Math.cos(e1.bearingInRadians), s = Math.sin(e1.bearingInRadians), n = t.az();
            n[0] = -r * a * o - s * i, n[1] = -s * a * o + r * i;
            const l = t.aA(n);
            l < 1e-9 ? t.aB(n) : t.aC(n, n, 1 / l);
            const c = t.az();
            c[0] = r * a * i - s * o, c[1] = s * a * i + r * o;
            const h = t.aA(c);
            return h < 1e-9 ? t.aB(c) : t.aC(c, c, 1 / h), {
                vecEast: c,
                vecSouth: n
            };
        }
        function Ve(e1, i, o, a) {
            let r;
            a ? (r = [
                e1,
                i,
                a(e1, i),
                1
            ], t.aE(r, r, o)) : (r = [
                e1,
                i,
                0,
                1
            ], nt(r, r, o));
            const s = r[3];
            return {
                point: new t.P(r[0] / s, r[1] / s),
                signedDistanceFromCamera: s,
                isOccluded: !1
            };
        }
        function We(e1, t) {
            return .5 + e1 / t * .5;
        }
        function qe(e1, t) {
            return e1.x >= -t[0] && e1.x <= t[0] && e1.y >= -t[1] && e1.y <= t[1];
        }
        function $e(e1, i, o, a, r, s, n, l, c, h, u, d, _) {
            const p = o ? e1.textSizeData : e1.iconSizeData, m = t.aw(p, i.transform.zoom), f = [
                256 / i.width * 2 + 1,
                256 / i.height * 2 + 1
            ], g = o ? e1.text.dynamicLayoutVertexArray : e1.icon.dynamicLayoutVertexArray;
            g.clear();
            const v = e1.lineVertexArray, x = o ? e1.text.placedSymbolArray : e1.icon.placedSymbolArray, b = i.transform.width / i.transform.height;
            let y = !1;
            for(let o = 0; o < x.length; o++){
                const w = x.get(o);
                if (w.hidden || w.writingMode === t.ax.vertical && !y) {
                    st(w.numGlyphs, g);
                    continue;
                }
                y = !1;
                const T = new t.P(w.anchorX, w.anchorY), P = {
                    getElevation: _,
                    pitchedLabelPlaneMatrix: a,
                    lineVertexArray: v,
                    pitchWithMap: s,
                    projectionCache: {
                        projections: {},
                        offsets: {},
                        cachedAnchorPoint: void 0,
                        anyProjectionOccluded: !1
                    },
                    transform: i.transform,
                    tileAnchorPoint: T,
                    unwrappedTileID: c,
                    width: h,
                    height: u,
                    translation: d
                }, C = tt(w.anchorX, w.anchorY, P);
                if (!qe(C.point, f)) {
                    st(w.numGlyphs, g);
                    continue;
                }
                const M = We(i.transform.cameraToCenterDistance, C.signedDistanceFromCamera), I = t.ay(p, m, w), E = s ? I * i.transform.getPitchedTextCorrection(w.anchorX, w.anchorY, c) / M : I * M, S = Ke({
                    projectionContext: P,
                    pitchedLabelPlaneMatrixInverse: r,
                    symbol: w,
                    fontSize: E,
                    flip: !1,
                    keepUpright: n,
                    glyphOffsetArray: e1.glyphOffsetArray,
                    dynamicLayoutVertexArray: g,
                    aspectRatio: b,
                    rotateToLine: l
                });
                y = S.useVertical, (S.notEnoughRoom || y || S.needsFlipping && Ke({
                    projectionContext: P,
                    pitchedLabelPlaneMatrixInverse: r,
                    symbol: w,
                    fontSize: E,
                    flip: !0,
                    keepUpright: n,
                    glyphOffsetArray: e1.glyphOffsetArray,
                    dynamicLayoutVertexArray: g,
                    aspectRatio: b,
                    rotateToLine: l
                }).notEnoughRoom) && st(w.numGlyphs, g);
            }
            o ? e1.text.dynamicLayoutVertexBuffer.updateData(g) : e1.icon.dynamicLayoutVertexBuffer.updateData(g);
        }
        function He(e1, t, i, o, a, r, s, n) {
            const l = r.glyphStartIndex + r.numGlyphs, c = r.lineStartIndex, h = r.lineStartIndex + r.lineLength, u = t.getoffsetX(r.glyphStartIndex), d = t.getoffsetX(l - 1), _ = at(e1 * u, i, o, a, r.segment, c, h, n, s);
            if (!_) return null;
            const p = at(e1 * d, i, o, a, r.segment, c, h, n, s);
            return p ? n.projectionCache.anyProjectionOccluded ? null : {
                first: _,
                last: p
            } : null;
        }
        function Xe(e1, i, o, a) {
            return e1 === t.ax.horizontal && Math.abs(o.y - i.y) > Math.abs(o.x - i.x) * a ? {
                useVertical: !0
            } : (e1 === t.ax.vertical ? i.y < o.y : i.x > o.x) ? {
                needsFlipping: !0
            } : null;
        }
        function Ke(e1) {
            const { projectionContext: i, pitchedLabelPlaneMatrixInverse: o, symbol: a, fontSize: r, flip: s, keepUpright: n, glyphOffsetArray: l, dynamicLayoutVertexArray: c, aspectRatio: h, rotateToLine: u } = e1, d = r / 24, _ = a.lineOffsetX * d, p = a.lineOffsetY * d;
            let m;
            if (a.numGlyphs > 1) {
                const e1 = a.glyphStartIndex + a.numGlyphs, t = a.lineStartIndex, r = a.lineStartIndex + a.lineLength, c = He(d, l, _, p, s, a, u, i);
                if (!c) return {
                    notEnoughRoom: !0
                };
                const f = et(c.first.point.x, c.first.point.y, i, o), g = et(c.last.point.x, c.last.point.y, i, o);
                if (n && !s) {
                    const e1 = Xe(a.writingMode, f, g, h);
                    if (e1) return e1;
                }
                m = [
                    c.first
                ];
                for(let o = a.glyphStartIndex + 1; o < e1 - 1; o++){
                    const e1 = at(d * l.getoffsetX(o), _, p, s, a.segment, t, r, i, u);
                    if (!e1) return {
                        notEnoughRoom: !0
                    };
                    m.push(e1);
                }
                m.push(c.last);
            } else {
                if (n && !s) {
                    const e1 = Je(i.tileAnchorPoint.x, i.tileAnchorPoint.y, i).point, r = a.lineStartIndex + a.segment + 1, s = new t.P(i.lineVertexArray.getx(r), i.lineVertexArray.gety(r)), n = Je(s.x, s.y, i), l = n.signedDistanceFromCamera > 0 ? n.point : Ye(i.tileAnchorPoint, s, e1, 1, i), c = et(e1.x, e1.y, i, o), u = et(l.x, l.y, i, o), d = Xe(a.writingMode, c, u, h);
                    if (d) return d;
                }
                const e1 = at(d * l.getoffsetX(a.glyphStartIndex), _, p, s, a.segment, a.lineStartIndex, a.lineStartIndex + a.lineLength, i, u);
                if (!e1 || i.projectionCache.anyProjectionOccluded) return {
                    notEnoughRoom: !0
                };
                m = [
                    e1
                ];
            }
            for (const e1 of m)t.aD(c, e1.point, e1.angle);
            return {};
        }
        function Ye(e1, t, i, o, a) {
            const r = e1.add(e1.sub(t)._unit()), s = Je(r.x, r.y, a).point, n = i.sub(s);
            return i.add(n._mult(o / n.mag()));
        }
        function Qe(e1, i, o) {
            const a = i.projectionCache;
            if (a.projections[e1]) return a.projections[e1];
            const r = new t.P(i.lineVertexArray.getx(e1), i.lineVertexArray.gety(e1)), s = Je(r.x, r.y, i);
            if (s.signedDistanceFromCamera > 0) return a.projections[e1] = s.point, a.anyProjectionOccluded || (a.anyProjectionOccluded = s.isOccluded), s.point;
            const n = e1 - o.direction;
            return Ye(0 === o.distanceFromAnchor ? i.tileAnchorPoint : new t.P(i.lineVertexArray.getx(n), i.lineVertexArray.gety(n)), r, o.previousVertex, o.absOffsetX - o.distanceFromAnchor + 1, i);
        }
        function Je(e1, t, i) {
            const o = e1 + i.translation[0], a = t + i.translation[1];
            let r;
            return i.pitchWithMap ? (r = Ve(o, a, i.pitchedLabelPlaneMatrix, i.getElevation), r.isOccluded = !1) : (r = i.transform.projectTileCoordinates(o, a, i.unwrappedTileID, i.getElevation), r.point.x = (.5 * r.point.x + .5) * i.width, r.point.y = (.5 * -r.point.y + .5) * i.height), r;
        }
        function et(e1, i, o, a) {
            if (o.pitchWithMap) {
                const r = [
                    e1,
                    i,
                    0,
                    1
                ];
                return t.aE(r, r, a), o.transform.projectTileCoordinates(r[0] / r[3], r[1] / r[3], o.unwrappedTileID, o.getElevation).point;
            }
            return {
                x: e1 / o.width * 2 - 1,
                y: 1 - i / o.height * 2
            };
        }
        function tt(e1, t, i) {
            return i.transform.projectTileCoordinates(e1, t, i.unwrappedTileID, i.getElevation);
        }
        function it(e1, t, i) {
            return e1._unit()._perp()._mult(t * i);
        }
        function ot(e1, i, o, a, r, s, n, l, c) {
            if (l.projectionCache.offsets[e1]) return l.projectionCache.offsets[e1];
            const h = o.add(i);
            if (e1 + c.direction < a || e1 + c.direction >= r) return l.projectionCache.offsets[e1] = h, h;
            const u = Qe(e1 + c.direction, l, c), d = it(u.sub(o), n, c.direction), _ = o.add(d), p = u.add(d);
            return l.projectionCache.offsets[e1] = t.aF(s, h, _, p) || h, l.projectionCache.offsets[e1];
        }
        function at(e1, t, i, o, a, r, s, n, l) {
            const c = o ? e1 - t : e1 + t;
            let h = c > 0 ? 1 : -1, u = 0;
            o && (h *= -1, u = Math.PI), h < 0 && (u += Math.PI);
            let d, _ = h > 0 ? r + a : r + a + 1;
            n.projectionCache.cachedAnchorPoint ? d = n.projectionCache.cachedAnchorPoint : (d = Je(n.tileAnchorPoint.x, n.tileAnchorPoint.y, n).point, n.projectionCache.cachedAnchorPoint = d);
            let p, m, f = d, g = d, v = 0, x = 0;
            const b = Math.abs(c), y = [];
            let w;
            for(; v + x <= b;){
                if (_ += h, _ < r || _ >= s) return null;
                v += x, g = f, m = p;
                const e1 = {
                    absOffsetX: b,
                    direction: h,
                    distanceFromAnchor: v,
                    previousVertex: g
                };
                if (f = Qe(_, n, e1), 0 === i) y.push(g), w = f.sub(g);
                else {
                    let t;
                    const o = f.sub(g);
                    t = 0 === o.mag() ? it(Qe(_ + h, n, e1).sub(f), i, h) : it(o, i, h), m || (m = g.add(t)), p = ot(_, t, f, r, s, m, i, n, e1), y.push(m), w = p.sub(m);
                }
                x = w.mag();
            }
            const T = w._mult((b - v) / x)._add(m || g), P = u + Math.atan2(f.y - g.y, f.x - g.x);
            return y.push(T), {
                point: T,
                angle: l ? P : 0,
                path: y
            };
        }
        const rt = new Float32Array([
            -1 / 0,
            -1 / 0,
            0,
            -1 / 0,
            -1 / 0,
            0,
            -1 / 0,
            -1 / 0,
            0,
            -1 / 0,
            -1 / 0,
            0
        ]);
        function st(e1, t) {
            for(let i = 0; i < e1; i++){
                const e1 = t.length;
                t.resize(e1 + 4), t.float32.set(rt, 3 * e1);
            }
        }
        function nt(e1, t, i) {
            const o = t[0], a = t[1];
            return e1[0] = i[0] * o + i[4] * a + i[12], e1[1] = i[1] * o + i[5] * a + i[13], e1[3] = i[3] * o + i[7] * a + i[15], e1;
        }
        const lt = 100;
        class ct {
            constructor(e1, t = new Oe(e1.width + 200, e1.height + 200, 25), i = new Oe(e1.width + 200, e1.height + 200, 25)){
                this.transform = e1, this.grid = t, this.ignoredGrid = i, this.pitchFactor = Math.cos(e1.pitch * Math.PI / 180) * e1.cameraToCenterDistance, this.screenRightBoundary = e1.width + lt, this.screenBottomBoundary = e1.height + lt, this.gridRightBoundary = e1.width + 200, this.gridBottomBoundary = e1.height + 200, this.perspectiveRatioCutoff = .6;
            }
            placeCollisionBox(e1, t, i, o, a, r, s, n, l, c, h, u) {
                const d = this.projectAndGetPerspectiveRatio(e1.anchorPointX + n[0], e1.anchorPointY + n[1], a, c, u), _ = i * d.perspectiveRatio;
                let p;
                if (r || s) p = this._projectCollisionBox(e1, _, o, a, r, s, n, d, c, h, u);
                else {
                    const t = d.x + (h ? h.x * _ : 0), i = d.y + (h ? h.y * _ : 0);
                    p = {
                        allPointsOccluded: !1,
                        box: [
                            t + e1.x1 * _,
                            i + e1.y1 * _,
                            t + e1.x2 * _,
                            i + e1.y2 * _
                        ]
                    };
                }
                const [m, f, g, v] = p.box, x = r ? p.allPointsOccluded : d.isOccluded;
                let b = x;
                return b || (b = d.perspectiveRatio < this.perspectiveRatioCutoff), b || (b = !this.isInsideGrid(m, f, g, v)), b || "always" !== t && this.grid.hitTest(m, f, g, v, t, l) ? {
                    box: [
                        m,
                        f,
                        g,
                        v
                    ],
                    placeable: !1,
                    offscreen: !1,
                    occluded: x
                } : {
                    box: [
                        m,
                        f,
                        g,
                        v
                    ],
                    placeable: !0,
                    offscreen: this.isOffscreen(m, f, g, v),
                    occluded: x
                };
            }
            placeCollisionCircles(e1, i, o, a, r, s, n, l, c, h, u, d, _, p) {
                const m = [], f = new t.P(i.anchorX, i.anchorY), g = this.getPerspectiveRatio(f.x, f.y, s, p), v = (c ? r * this.transform.getPitchedTextCorrection(i.anchorX, i.anchorY, s) / g : r * g) / t.aJ, x = {
                    getElevation: p,
                    pitchedLabelPlaneMatrix: n,
                    lineVertexArray: o,
                    pitchWithMap: c,
                    projectionCache: {
                        projections: {},
                        offsets: {},
                        cachedAnchorPoint: void 0,
                        anyProjectionOccluded: !1
                    },
                    transform: this.transform,
                    tileAnchorPoint: f,
                    unwrappedTileID: s,
                    width: this.transform.width,
                    height: this.transform.height,
                    translation: _
                }, b = He(v, a, i.lineOffsetX * v, i.lineOffsetY * v, !1, i, !1, x);
                let y = !1, w = !1, T = !0;
                if (b) {
                    const i = .5 * u * g + d, o = new t.P(-100, -100), a = new t.P(this.screenRightBoundary, this.screenBottomBoundary), r = new ke, s = b.first, n = b.last;
                    let _ = [];
                    for(let e1 = s.path.length - 1; e1 >= 1; e1--)_.push(s.path[e1]);
                    for(let e1 = 1; e1 < n.path.length; e1++)_.push(n.path[e1]);
                    const p = 2.5 * i;
                    if (c) {
                        const e1 = this.projectPathToScreenSpace(_, x);
                        _ = e1.some((e1)=>e1.signedDistanceFromCamera <= 0) ? [] : e1.map((e1)=>e1.point);
                    }
                    let f = [];
                    if (_.length > 0) {
                        const e1 = _[0].clone(), i = _[0].clone();
                        for(let t = 1; t < _.length; t++)e1.x = Math.min(e1.x, _[t].x), e1.y = Math.min(e1.y, _[t].y), i.x = Math.max(i.x, _[t].x), i.y = Math.max(i.y, _[t].y);
                        f = e1.x >= o.x && i.x <= a.x && e1.y >= o.y && i.y <= a.y ? [
                            _
                        ] : i.x < o.x || e1.x > a.x || i.y < o.y || e1.y > a.y ? [] : t.aG([
                            _
                        ], o.x, o.y, a.x, a.y);
                    }
                    for (const t of f){
                        r.reset(t, .25 * i);
                        let o = 0;
                        o = r.length <= .5 * i ? 1 : Math.ceil(r.paddedLength / p) + 1;
                        for(let t = 0; t < o; t++){
                            const a = t / Math.max(o - 1, 1), s = r.lerp(a), n = s.x + lt, c = s.y + lt;
                            m.push(n, c, i, 0);
                            const u = n - i, d = c - i, _ = n + i, p = c + i;
                            if (T && (T = this.isOffscreen(u, d, _, p)), w || (w = this.isInsideGrid(u, d, _, p)), "always" !== e1 && this.grid.hitTestCircle(n, c, i, e1, h) && (y = !0, !l)) return {
                                circles: [],
                                offscreen: !1,
                                collisionDetected: y
                            };
                        }
                    }
                }
                return {
                    circles: !l && y || !w || g < this.perspectiveRatioCutoff ? [] : m,
                    offscreen: T,
                    collisionDetected: y
                };
            }
            projectPathToScreenSpace(e1, t) {
                const i = function(e1, t) {
                    const i = Ne;
                    return function(e1, t) {
                        const i = 1 / (t[0] * t[5] - t[1] * t[4]);
                        e1[0] = t[5] * i, e1[1] = -t[1] * i, e1[2] = 0, e1[3] = 0, e1[4] = -t[4] * i, e1[5] = t[0] * i, e1[6] = 0, e1[7] = 0, e1[8] = 0, e1[9] = 0, e1[10] = 1 / t[10], e1[11] = 0, e1[12] = 0, e1[13] = 0, e1[14] = 0, e1[15] = 1 / t[15];
                    }(i, t.pitchedLabelPlaneMatrix), e1.map((e1)=>{
                        const o = Ve(e1.x, e1.y, i, t.getElevation), a = t.transform.projectTileCoordinates(o.point.x, o.point.y, t.unwrappedTileID, t.getElevation);
                        return a.point.x = (.5 * a.point.x + .5) * t.width, a.point.y = (.5 * -a.point.y + .5) * t.height, a;
                    });
                }(e1, t);
                return function(e1) {
                    let t = 0, i = 0, o = 0, a = 0;
                    for(let r = 0; r < e1.length; r++)e1[r].isOccluded ? (o = r + 1, a = 0) : (a++, a > i && (i = a, t = o));
                    return e1.slice(t, t + i);
                }(i);
            }
            queryRenderedSymbols(e1) {
                if (0 === e1.length || 0 === this.grid.keysLength() && 0 === this.ignoredGrid.keysLength()) return {};
                const i = [], o = new t.a8;
                for (const a of e1){
                    const e1 = new t.P(a.x + lt, a.y + lt);
                    o.extend(e1), i.push(e1);
                }
                const { minX: a, minY: r, maxX: s, maxY: n } = o, l = this.grid.query(a, r, s, n).concat(this.ignoredGrid.query(a, r, s, n)), c = {}, h = {};
                for (const e1 of l){
                    const o = e1.key;
                    if (void 0 === c[o.bucketInstanceId] && (c[o.bucketInstanceId] = {}), c[o.bucketInstanceId][o.featureIndex]) continue;
                    const a = [
                        new t.P(e1.x1, e1.y1),
                        new t.P(e1.x2, e1.y1),
                        new t.P(e1.x2, e1.y2),
                        new t.P(e1.x1, e1.y2)
                    ];
                    t.aH(i, a) && (c[o.bucketInstanceId][o.featureIndex] = !0, void 0 === h[o.bucketInstanceId] && (h[o.bucketInstanceId] = []), h[o.bucketInstanceId].push(o.featureIndex));
                }
                return h;
            }
            insertCollisionBox(e1, t, i, o, a, r) {
                (i ? this.ignoredGrid : this.grid).insert({
                    bucketInstanceId: o,
                    featureIndex: a,
                    collisionGroupID: r,
                    overlapMode: t
                }, e1[0], e1[1], e1[2], e1[3]);
            }
            insertCollisionCircles(e1, t, i, o, a, r) {
                const s = i ? this.ignoredGrid : this.grid, n = {
                    bucketInstanceId: o,
                    featureIndex: a,
                    collisionGroupID: r,
                    overlapMode: t
                };
                for(let t = 0; t < e1.length; t += 4)s.insertCircle(n, e1[t], e1[t + 1], e1[t + 2]);
            }
            projectAndGetPerspectiveRatio(e1, i, o, a, r) {
                if (r) {
                    let o;
                    a ? (o = [
                        e1,
                        i,
                        a(e1, i),
                        1
                    ], t.aE(o, o, r)) : (o = [
                        e1,
                        i,
                        0,
                        1
                    ], nt(o, o, r));
                    const s = o[3];
                    return {
                        x: (o[0] / s + 1) / 2 * this.transform.width + lt,
                        y: (-o[1] / s + 1) / 2 * this.transform.height + lt,
                        perspectiveRatio: .5 + this.transform.cameraToCenterDistance / s * .5,
                        isOccluded: !1,
                        signedDistanceFromCamera: s
                    };
                }
                {
                    const t = this.transform.projectTileCoordinates(e1, i, o, a);
                    return {
                        x: (t.point.x + 1) / 2 * this.transform.width + lt,
                        y: (1 - t.point.y) / 2 * this.transform.height + lt,
                        perspectiveRatio: .5 + this.transform.cameraToCenterDistance / t.signedDistanceFromCamera * .5,
                        isOccluded: t.isOccluded,
                        signedDistanceFromCamera: t.signedDistanceFromCamera
                    };
                }
            }
            getPerspectiveRatio(e1, t, i, o) {
                const a = this.transform.projectTileCoordinates(e1, t, i, o);
                return .5 + this.transform.cameraToCenterDistance / a.signedDistanceFromCamera * .5;
            }
            isOffscreen(e1, t, i, o) {
                return i < lt || e1 >= this.screenRightBoundary || o < lt || t > this.screenBottomBoundary;
            }
            isInsideGrid(e1, t, i, o) {
                return i >= 0 && e1 < this.gridRightBoundary && o >= 0 && t < this.gridBottomBoundary;
            }
            getViewportMatrix() {
                const e1 = t.ap([]);
                return t.Q(e1, e1, [
                    -100,
                    -100,
                    0
                ]), e1;
            }
            _projectCollisionBox(e1, i, o, a, r, s, n, l, c, h, u) {
                let d = 1, _ = 0, p = 0, m = 1;
                const f = e1.anchorPointX + n[0], g = e1.anchorPointY + n[1];
                if (s && !r) {
                    const e1 = this.projectAndGetPerspectiveRatio(f + 1, g, a, c, u), t = e1.x - l.x, i = Math.atan((e1.y - l.y) / t) + (t < 0 ? Math.PI : 0), o = Math.sin(i), r = Math.cos(i);
                    d = r, _ = o, p = -o, m = r;
                } else if (!s && r) {
                    const e1 = Ge(this.transform);
                    d = e1.vecEast[0], _ = e1.vecEast[1], p = e1.vecSouth[0], m = e1.vecSouth[1];
                }
                let v = l.x, x = l.y, b = i;
                r && (v = f, x = g, b = Math.pow(2, -(this.transform.zoom - o.overscaledZ)), b *= this.transform.getPitchedTextCorrection(f, g, a), h || (b *= t.al(.5 + l.signedDistanceFromCamera / this.transform.cameraToCenterDistance * .5, 0, 4))), h && (v += d * h.x * b + p * h.y * b, x += _ * h.x * b + m * h.y * b);
                const y = e1.x1 * b, w = e1.x2 * b, T = (y + w) / 2, P = e1.y1 * b, C = e1.y2 * b, M = (P + C) / 2, I = [
                    {
                        offsetX: y,
                        offsetY: P
                    },
                    {
                        offsetX: T,
                        offsetY: P
                    },
                    {
                        offsetX: w,
                        offsetY: P
                    },
                    {
                        offsetX: w,
                        offsetY: M
                    },
                    {
                        offsetX: w,
                        offsetY: C
                    },
                    {
                        offsetX: T,
                        offsetY: C
                    },
                    {
                        offsetX: y,
                        offsetY: C
                    },
                    {
                        offsetX: y,
                        offsetY: M
                    }
                ];
                let E = [];
                for (const { offsetX: e1, offsetY: i } of I)E.push(new t.P(v + d * e1 + p * i, x + _ * e1 + m * i));
                let S = !1;
                if (r) {
                    const e1 = E.map((e1)=>this.projectAndGetPerspectiveRatio(e1.x, e1.y, a, c, u));
                    S = e1.some((e1)=>!e1.isOccluded), E = e1.map((e1)=>new t.P(e1.x, e1.y));
                } else S = !0;
                return {
                    box: t.aI(E),
                    allPointsOccluded: !S
                };
            }
        }
        class ht {
            constructor(e1, t, i, o){
                this.opacity = e1 ? Math.max(0, Math.min(1, e1.opacity + (e1.placed ? t : -t))) : o && i ? 1 : 0, this.placed = i;
            }
            isHidden() {
                return 0 === this.opacity && !this.placed;
            }
        }
        class ut {
            constructor(e1, t, i, o, a){
                this.text = new ht(e1 ? e1.text : null, t, i, a), this.icon = new ht(e1 ? e1.icon : null, t, o, a);
            }
            isHidden() {
                return this.text.isHidden() && this.icon.isHidden();
            }
        }
        class dt {
            constructor(e1, t, i){
                this.text = e1, this.icon = t, this.skipFade = i;
            }
        }
        class _t {
            constructor(e1, t, i, o, a){
                this.bucketInstanceId = e1, this.featureIndex = t, this.sourceLayerIndex = i, this.bucketIndex = o, this.tileID = a;
            }
        }
        class pt {
            constructor(e1){
                this.crossSourceCollisions = e1, this.maxGroupID = 0, this.collisionGroups = {};
            }
            get(e1) {
                if (this.crossSourceCollisions) return {
                    ID: 0,
                    predicate: null
                };
                if (!this.collisionGroups[e1]) {
                    const t = ++this.maxGroupID;
                    this.collisionGroups[e1] = {
                        ID: t,
                        predicate: (e1)=>e1.collisionGroupID === t
                    };
                }
                return this.collisionGroups[e1];
            }
        }
        function mt(e1, i, o, a, r) {
            const { horizontalAlign: s, verticalAlign: n } = t.aP(e1);
            return new t.P(-(s - .5) * i + a[0] * r, -(n - .5) * o + a[1] * r);
        }
        class ft {
            constructor(e1, t, i, o, a){
                this.transform = e1.clone(), this.terrain = t, this.collisionIndex = new ct(this.transform), this.placements = {}, this.opacities = {}, this.variableOffsets = {}, this.stale = !1, this.commitTime = 0, this.fadeDuration = i, this.retainedQueryData = {}, this.collisionGroups = new pt(o), this.collisionCircleArrays = {}, this.collisionBoxArrays = new Map, this.prevPlacement = a, a && (a.prevPlacement = void 0), this.placedOrientations = {};
            }
            _getTerrainElevationFunc(e1) {
                const t = this.terrain;
                return t ? (i, o)=>t.getElevation(e1, i, o) : null;
            }
            getBucketParts(e1, i, o, a) {
                const r = o.getBucket(i), s = o.latestFeatureIndex;
                if (!r || !s || i.id !== r.layerIds[0]) return;
                const n = o.collisionBoxArray, l = r.layers[0].layout, c = r.layers[0].paint, h = Math.pow(2, this.transform.zoom - o.tileID.overscaledZ), u = o.tileSize / t.a6, d = o.tileID.toUnwrapped(), _ = "map" === l.get("text-rotation-alignment"), p = t.aK(o, 1, this.transform.zoom), m = t.aL(this.collisionIndex.transform, o, c.get("text-translate"), c.get("text-translate-anchor")), f = t.aL(this.collisionIndex.transform, o, c.get("icon-translate"), c.get("icon-translate-anchor")), g = Ze(_, this.transform, p);
                this.retainedQueryData[r.bucketInstanceId] = new _t(r.bucketInstanceId, s, r.sourceLayerIndex, r.index, o.tileID);
                const v = {
                    bucket: r,
                    layout: l,
                    translationText: m,
                    translationIcon: f,
                    unwrappedTileID: d,
                    pitchedLabelPlaneMatrix: g,
                    scale: h,
                    textPixelRatio: u,
                    holdingForFade: o.holdingForSymbolFade(),
                    collisionBoxArray: n,
                    partiallyEvaluatedTextSize: t.aw(r.textSizeData, this.transform.zoom),
                    collisionGroup: this.collisionGroups.get(r.sourceID)
                };
                if (a) for (const t of r.sortKeyRanges){
                    const { sortKey: i, symbolInstanceStart: o, symbolInstanceEnd: a } = t;
                    e1.push({
                        sortKey: i,
                        symbolInstanceStart: o,
                        symbolInstanceEnd: a,
                        parameters: v
                    });
                }
                else e1.push({
                    symbolInstanceStart: 0,
                    symbolInstanceEnd: r.symbolInstances.length,
                    parameters: v
                });
            }
            attemptAnchorPlacement(e1, i, o, a, r, s, n, l, c, h, u, d, _, p, m, f, g, v, x, b) {
                var y, w, T;
                const P = t.aM[e1.textAnchor], C = [
                    e1.textOffset0,
                    e1.textOffset1
                ], M = mt(P, o, a, C, r), I = this.collisionIndex.placeCollisionBox(i, d, l, c, h, n, s, f, u.predicate, x, M, b);
                if ((!v || this.collisionIndex.placeCollisionBox(v, d, l, c, h, n, s, g, u.predicate, x, M, b).placeable) && I.placeable) {
                    let e1;
                    if ((null === (y = this.prevPlacement) || void 0 === y ? void 0 : y.variableOffsets[_.crossTileID]) && (null === (T = null === (w = this.prevPlacement) || void 0 === w ? void 0 : w.placements[_.crossTileID]) || void 0 === T ? void 0 : T.text) && (e1 = this.prevPlacement.variableOffsets[_.crossTileID].anchor), 0 === _.crossTileID) throw new Error("symbolInstance.crossTileID can't be 0");
                    return this.variableOffsets[_.crossTileID] = {
                        textOffset: C,
                        width: o,
                        height: a,
                        anchor: P,
                        textBoxScale: r,
                        prevAnchor: e1
                    }, this.markUsedJustification(p, P, _, m), p.allowVerticalPlacement && (this.markUsedOrientation(p, m, _), this.placedOrientations[_.crossTileID] = m), {
                        shift: M,
                        placedGlyphBoxes: I
                    };
                }
            }
            placeLayerBucketPart(e1, i, o) {
                const { bucket: a, layout: r, translationText: s, translationIcon: n, unwrappedTileID: l, pitchedLabelPlaneMatrix: c, textPixelRatio: h, holdingForFade: u, collisionBoxArray: d, partiallyEvaluatedTextSize: _, collisionGroup: p } = e1.parameters, m = r.get("text-optional"), f = r.get("icon-optional"), g = t.aN(r, "text-overlap", "text-allow-overlap"), v = "always" === g, x = t.aN(r, "icon-overlap", "icon-allow-overlap"), b = "always" === x, y = "map" === r.get("text-rotation-alignment"), w = "map" === r.get("text-pitch-alignment"), T = "none" !== r.get("icon-text-fit"), P = "viewport-y" === r.get("symbol-z-order"), C = v && (b || !a.hasIconData() || f), M = b && (v || !a.hasTextData() || m);
                !a.collisionArrays && d && a.deserializeCollisionBoxes(d);
                const I = this.retainedQueryData[a.bucketInstanceId].tileID, E = this._getTerrainElevationFunc(I), S = this.transform.getFastPathSimpleProjectionMatrix(I), z = (e1, d, b)=>{
                    var P, z;
                    if (i[e1.crossTileID]) return;
                    if (u) return void (this.placements[e1.crossTileID] = new dt(!1, !1, !1));
                    let R = !1, D = !1, A = !0, L = null, F = {
                        box: null,
                        placeable: !1,
                        offscreen: null,
                        occluded: !1
                    }, k = {
                        placeable: !1
                    }, B = null, O = null, j = null, N = 0, Z = 0, U = 0;
                    d.textFeatureIndex ? N = d.textFeatureIndex : e1.useRuntimeCollisionCircles && (N = e1.featureIndex), d.verticalTextFeatureIndex && (Z = d.verticalTextFeatureIndex);
                    const G = d.textBox;
                    if (G) {
                        const i = (i)=>{
                            let o = t.ax.horizontal;
                            if (a.allowVerticalPlacement && !i && this.prevPlacement) {
                                const t = this.prevPlacement.placedOrientations[e1.crossTileID];
                                t && (this.placedOrientations[e1.crossTileID] = t, o = t, this.markUsedOrientation(a, o, e1));
                            }
                            return o;
                        }, r = (i, o)=>{
                            if (a.allowVerticalPlacement && e1.numVerticalGlyphVertices > 0 && d.verticalTextBox) {
                                for (const e1 of a.writingModes)if (e1 === t.ax.vertical ? (F = o(), k = F) : F = i(), null == F ? void 0 : F.placeable) break;
                            } else F = i();
                        }, c = e1.textAnchorOffsetStartIndex, u = e1.textAnchorOffsetEndIndex;
                        if (u === c) {
                            const o = (t, i)=>{
                                const o = this.collisionIndex.placeCollisionBox(t, g, h, I, l, w, y, s, p.predicate, E, void 0, S);
                                return (null == o ? void 0 : o.placeable) && (this.markUsedOrientation(a, i, e1), this.placedOrientations[e1.crossTileID] = i), o;
                            };
                            r(()=>o(G, t.ax.horizontal), ()=>{
                                const i = d.verticalTextBox;
                                return a.allowVerticalPlacement && e1.numVerticalGlyphVertices > 0 && i ? o(i, t.ax.vertical) : {
                                    box: null,
                                    offscreen: null
                                };
                            }), i(null == F ? void 0 : F.placeable);
                        } else {
                            let _ = t.aM[null === (z = null === (P = this.prevPlacement) || void 0 === P ? void 0 : P.variableOffsets[e1.crossTileID]) || void 0 === z ? void 0 : z.anchor];
                            const m = (t, i, r)=>{
                                const d = t.x2 - t.x1, m = t.y2 - t.y1, f = e1.textBoxScale, v = T && "never" === x ? i : null;
                                let b = null, P = "never" === g ? 1 : 2, C = "never";
                                _ && P++;
                                for(let i = 0; i < P; i++){
                                    for(let i = c; i < u; i++){
                                        const o = a.textAnchorOffsets.get(i);
                                        if (_ && o.textAnchor !== _) continue;
                                        const c = this.attemptAnchorPlacement(o, t, d, m, f, y, w, h, I, l, p, C, e1, a, r, s, n, v, E);
                                        if (c && (b = c.placedGlyphBoxes, null == b ? void 0 : b.placeable)) return R = !0, L = c.shift, b;
                                    }
                                    _ ? _ = null : C = g;
                                }
                                return o && !b && (b = {
                                    box: this.collisionIndex.placeCollisionBox(G, "always", h, I, l, w, y, s, p.predicate, E, void 0, S).box,
                                    offscreen: !1,
                                    placeable: !1,
                                    occluded: !1
                                }), b;
                            };
                            r(()=>m(G, d.iconBox, t.ax.horizontal), ()=>{
                                const i = d.verticalTextBox;
                                return a.allowVerticalPlacement && !(null == F ? void 0 : F.placeable) && e1.numVerticalGlyphVertices > 0 && i ? m(i, d.verticalIconBox, t.ax.vertical) : {
                                    box: null,
                                    occluded: !0,
                                    offscreen: null
                                };
                            }), F && (R = F.placeable, A = F.offscreen);
                            const f = i(null == F ? void 0 : F.placeable);
                            if (!R && this.prevPlacement) {
                                const t = this.prevPlacement.variableOffsets[e1.crossTileID];
                                t && (this.variableOffsets[e1.crossTileID] = t, this.markUsedJustification(a, t.anchor, e1, f));
                            }
                        }
                    }
                    if (B = F, R = null == B ? void 0 : B.placeable, A = null == B ? void 0 : B.offscreen, e1.useRuntimeCollisionCircles && e1.centerJustifiedTextSymbolIndex >= 0) {
                        const i = a.text.placedSymbolArray.get(e1.centerJustifiedTextSymbolIndex), n = t.ay(a.textSizeData, _, i), h = r.get("text-padding");
                        O = this.collisionIndex.placeCollisionCircles(g, i, a.lineVertexArray, a.glyphOffsetArray, n, l, c, o, w, p.predicate, e1.collisionCircleDiameter, h, s, E), O.circles.length && O.collisionDetected && !o && t.w("Collisions detected, but collision boxes are not shown"), R = v || O.circles.length > 0 && !O.collisionDetected, A && (A = O.offscreen);
                    }
                    if (d.iconFeatureIndex && (U = d.iconFeatureIndex), d.iconBox) {
                        const e1 = (e1)=>this.collisionIndex.placeCollisionBox(e1, x, h, I, l, w, y, n, p.predicate, E, T && L ? L : void 0, S);
                        k && k.placeable && d.verticalIconBox ? (j = e1(d.verticalIconBox), D = j.placeable) : (j = e1(d.iconBox), D = j.placeable), A && (A = j.offscreen);
                    }
                    const V = m || 0 === e1.numHorizontalGlyphVertices && 0 === e1.numVerticalGlyphVertices, W = f || 0 === e1.numIconVertices;
                    V || W ? W ? V || D && (D = R) : R = D && R : D = R = D && R;
                    const q = D && j.placeable;
                    if (R && B.placeable && this.collisionIndex.insertCollisionBox(B.box, g, r.get("text-ignore-placement"), a.bucketInstanceId, k && k.placeable && Z ? Z : N, p.ID), q && this.collisionIndex.insertCollisionBox(j.box, x, r.get("icon-ignore-placement"), a.bucketInstanceId, U, p.ID), O && R && this.collisionIndex.insertCollisionCircles(O.circles, g, r.get("text-ignore-placement"), a.bucketInstanceId, N, p.ID), o && this.storeCollisionData(a.bucketInstanceId, b, d, B, j, O), 0 === e1.crossTileID) throw new Error("symbolInstance.crossTileID can't be 0");
                    if (0 === a.bucketInstanceId) throw new Error("bucket.bucketInstanceId can't be 0");
                    this.placements[e1.crossTileID] = new dt((R || C) && !(null == B ? void 0 : B.occluded), (D || M) && !(null == j ? void 0 : j.occluded), A || a.justReloaded), i[e1.crossTileID] = !0;
                };
                if (P) {
                    if (0 !== e1.symbolInstanceStart) throw new Error("bucket.bucketInstanceId should be 0");
                    const t = a.getSortedSymbolIndexes(-this.transform.bearingInRadians);
                    for(let e1 = t.length - 1; e1 >= 0; --e1){
                        const i = t[e1];
                        z(a.symbolInstances.get(i), a.collisionArrays[i], i);
                    }
                } else for(let t = e1.symbolInstanceStart; t < e1.symbolInstanceEnd; t++)z(a.symbolInstances.get(t), a.collisionArrays[t], t);
                a.justReloaded = !1;
            }
            storeCollisionData(e1, t, i, o, a, r) {
                if (i.textBox || i.iconBox) {
                    let r, s;
                    this.collisionBoxArrays.has(e1) ? r = this.collisionBoxArrays.get(e1) : (r = new Map, this.collisionBoxArrays.set(e1, r)), r.has(t) ? s = r.get(t) : (s = {
                        text: null,
                        icon: null
                    }, r.set(t, s)), i.textBox && (s.text = o.box), i.iconBox && (s.icon = a.box);
                }
                if (r) {
                    let t = this.collisionCircleArrays[e1];
                    void 0 === t && (t = this.collisionCircleArrays[e1] = []);
                    for(let e1 = 0; e1 < r.circles.length; e1 += 4)t.push(r.circles[e1 + 0] - lt), t.push(r.circles[e1 + 1] - lt), t.push(r.circles[e1 + 2]), t.push(r.collisionDetected ? 1 : 0);
                }
            }
            markUsedJustification(e1, i, o, a) {
                let r;
                r = a === t.ax.vertical ? o.verticalPlacedTextSymbolIndex : ({
                    left: o.leftJustifiedTextSymbolIndex,
                    center: o.centerJustifiedTextSymbolIndex,
                    right: o.rightJustifiedTextSymbolIndex
                })[t.aO(i)];
                const s = [
                    o.leftJustifiedTextSymbolIndex,
                    o.centerJustifiedTextSymbolIndex,
                    o.rightJustifiedTextSymbolIndex,
                    o.verticalPlacedTextSymbolIndex
                ];
                for (const t of s)t >= 0 && (e1.text.placedSymbolArray.get(t).crossTileID = r >= 0 && t !== r ? 0 : o.crossTileID);
            }
            markUsedOrientation(e1, i, o) {
                const a = i === t.ax.horizontal || i === t.ax.horizontalOnly ? i : 0, r = i === t.ax.vertical ? i : 0, s = [
                    o.leftJustifiedTextSymbolIndex,
                    o.centerJustifiedTextSymbolIndex,
                    o.rightJustifiedTextSymbolIndex
                ];
                for (const t of s)e1.text.placedSymbolArray.get(t).placedOrientation = a;
                o.verticalPlacedTextSymbolIndex && (e1.text.placedSymbolArray.get(o.verticalPlacedTextSymbolIndex).placedOrientation = r);
            }
            commit(e1) {
                this.commitTime = e1, this.zoomAtLastRecencyCheck = this.transform.zoom;
                const t = this.prevPlacement;
                let i = !1;
                this.prevZoomAdjustment = t ? t.zoomAdjustment(this.transform.zoom) : 0;
                const o = t ? t.symbolFadeChange(e1) : 1, a = t ? t.opacities : {}, r = t ? t.variableOffsets : {}, s = t ? t.placedOrientations : {};
                for(const e1 in this.placements){
                    const t = this.placements[e1], r = a[e1];
                    r ? (this.opacities[e1] = new ut(r, o, t.text, t.icon), i || (i = t.text !== r.text.placed), i || (i = t.icon !== r.icon.placed)) : (this.opacities[e1] = new ut(null, o, t.text, t.icon, t.skipFade), i || (i = t.text || t.icon));
                }
                for(const e1 in a){
                    const t = a[e1];
                    if (!this.opacities[e1]) {
                        const a = new ut(t, o, !1, !1);
                        a.isHidden() || (this.opacities[e1] = a, i || (i = t.text.placed), i || (i = t.icon.placed));
                    }
                }
                for(const e1 in r)this.variableOffsets[e1] || !this.opacities[e1] || this.opacities[e1].isHidden() || (this.variableOffsets[e1] = r[e1]);
                for(const e1 in s)this.placedOrientations[e1] || !this.opacities[e1] || this.opacities[e1].isHidden() || (this.placedOrientations[e1] = s[e1]);
                if (t && void 0 === t.lastPlacementChangeTime) throw new Error("Last placement time for previous placement is not defined");
                i ? this.lastPlacementChangeTime = e1 : "number" != typeof this.lastPlacementChangeTime && (this.lastPlacementChangeTime = t ? t.lastPlacementChangeTime : e1);
            }
            updateLayerOpacities(e1, t) {
                const i = {};
                for (const o of t){
                    const t = o.getBucket(e1);
                    t && o.latestFeatureIndex && e1.id === t.layerIds[0] && this.updateBucketOpacities(t, o.tileID, i, o.collisionBoxArray);
                }
            }
            updateBucketOpacities(e1, i, o, a) {
                e1.hasTextData() && (e1.text.opacityVertexArray.clear(), e1.text.hasVisibleVertices = !1), e1.hasIconData() && (e1.icon.opacityVertexArray.clear(), e1.icon.hasVisibleVertices = !1), e1.hasIconCollisionBoxData() && e1.iconCollisionBox.collisionVertexArray.clear(), e1.hasTextCollisionBoxData() && e1.textCollisionBox.collisionVertexArray.clear();
                const r = e1.layers[0], s = r.layout, n = new ut(null, 0, !1, !1, !0), l = s.get("text-allow-overlap"), c = s.get("icon-allow-overlap"), h = r._unevaluatedLayout.hasValue("text-variable-anchor") || r._unevaluatedLayout.hasValue("text-variable-anchor-offset"), u = "map" === s.get("text-rotation-alignment"), d = "map" === s.get("text-pitch-alignment"), _ = "none" !== s.get("icon-text-fit"), p = new ut(null, 0, l && (c || !e1.hasIconData() || s.get("icon-optional")), c && (l || !e1.hasTextData() || s.get("text-optional")), !0);
                !e1.collisionArrays && a && (e1.hasIconCollisionBoxData() || e1.hasTextCollisionBoxData()) && e1.deserializeCollisionBoxes(a);
                const m = (e1, t, i)=>{
                    for(let o = 0; o < t / 4; o++)e1.opacityVertexArray.emplaceBack(i);
                    e1.hasVisibleVertices || (e1.hasVisibleVertices = i !== Mt);
                }, f = this.collisionBoxArrays.get(e1.bucketInstanceId);
                for(let i = 0; i < e1.symbolInstances.length; i++){
                    const a = e1.symbolInstances.get(i), { numHorizontalGlyphVertices: r, numVerticalGlyphVertices: s, crossTileID: l } = a;
                    let c = this.opacities[l];
                    o[l] ? c = n : c || (c = p, this.opacities[l] = c), o[l] = !0;
                    const g = a.numIconVertices > 0, v = this.placedOrientations[a.crossTileID], x = v === t.ax.vertical, b = v === t.ax.horizontal || v === t.ax.horizontalOnly;
                    if (r > 0 || s > 0) {
                        const t = Ct(c.text);
                        m(e1.text, r, x ? Mt : t), m(e1.text, s, b ? Mt : t);
                        const i = c.text.isHidden(), o = [
                            a.rightJustifiedTextSymbolIndex,
                            a.centerJustifiedTextSymbolIndex,
                            a.leftJustifiedTextSymbolIndex
                        ];
                        for (const t of o)t >= 0 && (e1.text.placedSymbolArray.get(t).hidden = i || x ? 1 : 0);
                        a.verticalPlacedTextSymbolIndex >= 0 && (e1.text.placedSymbolArray.get(a.verticalPlacedTextSymbolIndex).hidden = i || b ? 1 : 0);
                        const n = this.variableOffsets[a.crossTileID];
                        n && this.markUsedJustification(e1, n.anchor, a, v);
                        const l = this.placedOrientations[a.crossTileID];
                        l && (this.markUsedJustification(e1, "left", a, l), this.markUsedOrientation(e1, l, a));
                    }
                    if (g) {
                        const t = Ct(c.icon), i = !(_ && a.verticalPlacedIconSymbolIndex && x);
                        a.placedIconSymbolIndex >= 0 && (m(e1.icon, a.numIconVertices, i ? t : Mt), e1.icon.placedSymbolArray.get(a.placedIconSymbolIndex).hidden = c.icon.isHidden()), a.verticalPlacedIconSymbolIndex >= 0 && (m(e1.icon, a.numVerticalIconVertices, i ? Mt : t), e1.icon.placedSymbolArray.get(a.verticalPlacedIconSymbolIndex).hidden = c.icon.isHidden());
                    }
                    const y = (null == f ? void 0 : f.has(i)) ? f.get(i) : {
                        text: null,
                        icon: null
                    };
                    if (e1.hasIconCollisionBoxData() || e1.hasTextCollisionBoxData()) {
                        const o = e1.collisionArrays[i];
                        if (o) {
                            let i = new t.P(0, 0);
                            if (o.textBox || o.verticalTextBox) {
                                let t = !0;
                                if (h) {
                                    const e1 = this.variableOffsets[l];
                                    e1 ? (i = mt(e1.anchor, e1.width, e1.height, e1.textOffset, e1.textBoxScale), u && i._rotate(d ? -this.transform.bearingInRadians : this.transform.bearingInRadians)) : t = !1;
                                }
                                if (o.textBox || o.verticalTextBox) {
                                    let a;
                                    o.textBox && (a = x), o.verticalTextBox && (a = b), gt(e1.textCollisionBox.collisionVertexArray, c.text.placed, !t || a, y.text, i.x, i.y);
                                }
                            }
                            if (o.iconBox || o.verticalIconBox) {
                                const t = Boolean(!b && o.verticalIconBox);
                                let a;
                                o.iconBox && (a = t), o.verticalIconBox && (a = !t), gt(e1.iconCollisionBox.collisionVertexArray, c.icon.placed, a, y.icon, _ ? i.x : 0, _ ? i.y : 0);
                            }
                        }
                    }
                }
                if (e1.sortFeatures(-this.transform.bearingInRadians), this.retainedQueryData[e1.bucketInstanceId] && (this.retainedQueryData[e1.bucketInstanceId].featureSortOrder = e1.featureSortOrder), e1.hasTextData() && e1.text.opacityVertexBuffer && e1.text.opacityVertexBuffer.updateData(e1.text.opacityVertexArray), e1.hasIconData() && e1.icon.opacityVertexBuffer && e1.icon.opacityVertexBuffer.updateData(e1.icon.opacityVertexArray), e1.hasIconCollisionBoxData() && e1.iconCollisionBox.collisionVertexBuffer && e1.iconCollisionBox.collisionVertexBuffer.updateData(e1.iconCollisionBox.collisionVertexArray), e1.hasTextCollisionBoxData() && e1.textCollisionBox.collisionVertexBuffer && e1.textCollisionBox.collisionVertexBuffer.updateData(e1.textCollisionBox.collisionVertexArray), e1.text.opacityVertexArray.length !== e1.text.layoutVertexArray.length / 4) throw new Error(`bucket.text.opacityVertexArray.length (= ${e1.text.opacityVertexArray.length}) !== bucket.text.layoutVertexArray.length (= ${e1.text.layoutVertexArray.length}) / 4`);
                if (e1.icon.opacityVertexArray.length !== e1.icon.layoutVertexArray.length / 4) throw new Error(`bucket.icon.opacityVertexArray.length (= ${e1.icon.opacityVertexArray.length}) !== bucket.icon.layoutVertexArray.length (= ${e1.icon.layoutVertexArray.length}) / 4`);
                e1.bucketInstanceId in this.collisionCircleArrays && (e1.collisionCircleArray = this.collisionCircleArrays[e1.bucketInstanceId], delete this.collisionCircleArrays[e1.bucketInstanceId]);
            }
            symbolFadeChange(e1) {
                return 0 === this.fadeDuration ? 1 : (e1 - this.commitTime) / this.fadeDuration + this.prevZoomAdjustment;
            }
            zoomAdjustment(e1) {
                return Math.max(0, (this.transform.zoom - e1) / 1.5);
            }
            hasTransitions(e1) {
                return this.stale || e1 - this.lastPlacementChangeTime < this.fadeDuration;
            }
            stillRecent(e1, t) {
                const i = this.zoomAtLastRecencyCheck === t ? 1 - this.zoomAdjustment(t) : 1;
                return this.zoomAtLastRecencyCheck = t, this.commitTime + this.fadeDuration * i > e1;
            }
            setStale() {
                this.stale = !0;
            }
        }
        function gt(e1, t, i, o, a, r) {
            o && 0 !== o.length || (o = [
                0,
                0,
                0,
                0
            ]);
            const s = o[0] - lt, n = o[1] - lt, l = o[2] - lt, c = o[3] - lt;
            e1.emplaceBack(t ? 1 : 0, i ? 1 : 0, a || 0, r || 0, s, n), e1.emplaceBack(t ? 1 : 0, i ? 1 : 0, a || 0, r || 0, l, n), e1.emplaceBack(t ? 1 : 0, i ? 1 : 0, a || 0, r || 0, l, c), e1.emplaceBack(t ? 1 : 0, i ? 1 : 0, a || 0, r || 0, s, c);
        }
        const vt = Math.pow(2, 25), xt = Math.pow(2, 24), bt = Math.pow(2, 17), yt = Math.pow(2, 16), wt = Math.pow(2, 9), Tt = Math.pow(2, 8), Pt = Math.pow(2, 1);
        function Ct(e1) {
            if (0 === e1.opacity && !e1.placed) return 0;
            if (1 === e1.opacity && e1.placed) return 4294967295;
            const t = e1.placed ? 1 : 0, i = Math.floor(127 * e1.opacity);
            return i * vt + t * xt + i * bt + t * yt + i * wt + t * Tt + i * Pt + t;
        }
        const Mt = 0;
        class It {
            constructor(e1){
                this._sortAcrossTiles = "viewport-y" !== e1.layout.get("symbol-z-order") && !e1.layout.get("symbol-sort-key").isConstant(), this._currentTileIndex = 0, this._currentPartIndex = 0, this._seenCrossTileIDs = {}, this._bucketParts = [];
            }
            continuePlacement(e1, t, i, o, a) {
                const r = this._bucketParts;
                for(; this._currentTileIndex < e1.length;)if (t.getBucketParts(r, o, e1[this._currentTileIndex], this._sortAcrossTiles), this._currentTileIndex++, a()) return !0;
                for(this._sortAcrossTiles && (this._sortAcrossTiles = !1, r.sort((e1, t)=>e1.sortKey - t.sortKey)); this._currentPartIndex < r.length;)if (t.placeLayerBucketPart(r[this._currentPartIndex], this._seenCrossTileIDs, i), this._currentPartIndex++, a()) return !0;
                return !1;
            }
        }
        class Et {
            constructor(e1, t, i, o, a, r, s, n){
                this.placement = new ft(e1, t, r, s, n), this._currentPlacementIndex = i.length - 1, this._forceFullPlacement = o, this._showCollisionBoxes = a, this._done = !1;
            }
            isDone() {
                return this._done;
            }
            continuePlacement(e1, i, o) {
                const a = c(), r = ()=>!this._forceFullPlacement && c() - a > 2;
                for(; this._currentPlacementIndex >= 0;){
                    const a = i[e1[this._currentPlacementIndex]], s = this.placement.collisionIndex.transform.zoom;
                    if (t.aQ(a) && a.layout && (!a.minzoom || a.minzoom <= s) && (!a.maxzoom || a.maxzoom > s)) {
                        if (this._inProgressLayer || (this._inProgressLayer = new It(a)), this._inProgressLayer.continuePlacement(o[a.source], this.placement, this._showCollisionBoxes, a, r)) return;
                        delete this._inProgressLayer;
                    }
                    this._currentPlacementIndex--;
                }
                this._done = !0;
            }
            commit(e1) {
                return this.placement.commit(e1), this.placement;
            }
        }
        const St = 512 / t.a6 / 2;
        class zt {
            constructor(e1, i, o){
                this.tileID = e1, this.bucketInstanceId = o, this._symbolsByKey = {};
                const a = new Map;
                for(let e1 = 0; e1 < i.length; e1++){
                    const t = i.get(e1), o = t.key, r = a.get(o);
                    r ? r.push(t) : a.set(o, [
                        t
                    ]);
                }
                for (const [e1, i] of a){
                    const o = {
                        positions: i.map((e1)=>({
                                x: Math.floor(e1.anchorX * St),
                                y: Math.floor(e1.anchorY * St)
                            })),
                        crossTileIDs: i.map((e1)=>e1.crossTileID)
                    };
                    if (o.positions.length > 128) {
                        const e1 = new t.aR(o.positions.length, 16, Uint16Array);
                        for (const { x: t, y: i } of o.positions)e1.add(t, i);
                        e1.finish(), delete o.positions, o.index = e1;
                    }
                    this._symbolsByKey[e1] = o;
                }
            }
            getScaledCoordinates(e1, i) {
                const { x: o, y: a, z: r } = this.tileID.canonical, { x: s, y: n, z: l } = i.canonical, c = St / Math.pow(2, l - r), h = (n * t.a6 + e1.anchorY) * c, u = a * t.a6 * St;
                return {
                    x: Math.floor((s * t.a6 + e1.anchorX) * c - o * t.a6 * St),
                    y: Math.floor(h - u)
                };
            }
            findMatches(e1, t, i) {
                const o = this.tileID.canonical.z < t.canonical.z ? 1 : Math.pow(2, this.tileID.canonical.z - t.canonical.z);
                for(let a = 0; a < e1.length; a++){
                    const r = e1.get(a);
                    if (r.crossTileID) continue;
                    const s = this._symbolsByKey[r.key];
                    if (!s) continue;
                    const n = this.getScaledCoordinates(r, t);
                    if (s.index) {
                        const e1 = s.index.range(n.x - o, n.y - o, n.x + o, n.y + o).sort();
                        for (const t of e1){
                            const e1 = s.crossTileIDs[t];
                            if (!i[e1]) {
                                i[e1] = !0, r.crossTileID = e1;
                                break;
                            }
                        }
                    } else if (s.positions) for(let e1 = 0; e1 < s.positions.length; e1++){
                        const t = s.positions[e1], a = s.crossTileIDs[e1];
                        if (Math.abs(t.x - n.x) <= o && Math.abs(t.y - n.y) <= o && !i[a]) {
                            i[a] = !0, r.crossTileID = a;
                            break;
                        }
                    }
                }
            }
            getCrossTileIDsLists() {
                return Object.values(this._symbolsByKey).map(({ crossTileIDs: e1 })=>e1);
            }
        }
        class Rt {
            constructor(){
                this.maxCrossTileID = 0;
            }
            generate() {
                return ++this.maxCrossTileID;
            }
        }
        class Dt {
            constructor(){
                this.indexes = {}, this.usedCrossTileIDs = {}, this.lng = 0;
            }
            handleWrapJump(e1) {
                const t = Math.round((e1 - this.lng) / 360);
                if (0 !== t) for(const e1 in this.indexes){
                    const i = this.indexes[e1], o = {};
                    for(const e1 in i){
                        const a = i[e1];
                        a.tileID = a.tileID.unwrapTo(a.tileID.wrap + t), o[a.tileID.key] = a;
                    }
                    this.indexes[e1] = o;
                }
                this.lng = e1;
            }
            addBucket(e1, t, i) {
                var o, a, r;
                if (null === (o = this.indexes[e1.overscaledZ]) || void 0 === o ? void 0 : o[e1.key]) {
                    if (this.indexes[e1.overscaledZ][e1.key].bucketInstanceId === t.bucketInstanceId) return !1;
                    this.removeBucketCrossTileIDs(e1.overscaledZ, this.indexes[e1.overscaledZ][e1.key]);
                }
                for(let e1 = 0; e1 < t.symbolInstances.length; e1++)t.symbolInstances.get(e1).crossTileID = 0;
                (a = this.usedCrossTileIDs)[r = e1.overscaledZ] || (a[r] = {});
                const s = this.usedCrossTileIDs[e1.overscaledZ];
                for(const i in this.indexes){
                    const o = this.indexes[i];
                    if (Number(i) > e1.overscaledZ) for(const i in o){
                        const a = o[i];
                        a.tileID.isChildOf(e1) && a.findMatches(t.symbolInstances, e1, s);
                    }
                    else {
                        const a = o[e1.scaledTo(Number(i)).key];
                        a && a.findMatches(t.symbolInstances, e1, s);
                    }
                }
                for(let e1 = 0; e1 < t.symbolInstances.length; e1++){
                    const o = t.symbolInstances.get(e1);
                    o.crossTileID || (o.crossTileID = i.generate(), s[o.crossTileID] = !0);
                }
                return void 0 === this.indexes[e1.overscaledZ] && (this.indexes[e1.overscaledZ] = {}), this.indexes[e1.overscaledZ][e1.key] = new zt(e1, t.symbolInstances, t.bucketInstanceId), !0;
            }
            removeBucketCrossTileIDs(e1, t) {
                for (const i of t.getCrossTileIDsLists())for (const t of i)delete this.usedCrossTileIDs[e1][t];
            }
            removeStaleBuckets(e1) {
                let t = !1;
                for(const i in this.indexes){
                    const o = this.indexes[i];
                    for(const a in o)e1[o[a].bucketInstanceId] || (this.removeBucketCrossTileIDs(i, o[a]), delete o[a], t = !0);
                }
                return t;
            }
        }
        class At {
            constructor(){
                this.layerIndexes = {}, this.crossTileIDs = new Rt, this.maxBucketInstanceId = 0, this.bucketsInCurrentPlacement = {};
            }
            addLayer(e1, t, i) {
                let o = this.layerIndexes[e1.id];
                void 0 === o && (o = this.layerIndexes[e1.id] = new Dt);
                let a = !1;
                const r = {};
                o.handleWrapJump(i);
                for (const i of t){
                    const t = i.getBucket(e1);
                    e1.id === (null == t ? void 0 : t.layerIds[0]) && (t.bucketInstanceId || (this.maxBucketInstanceId += 1, t.bucketInstanceId = this.maxBucketInstanceId), o.addBucket(i.tileID, t, this.crossTileIDs) && (a = !0), r[t.bucketInstanceId] = !0);
                }
                return o.removeStaleBuckets(r) && (a = !0), a;
            }
            pruneUnusedLayers(e1) {
                const t = {};
                for (const i of e1)t[i] = !0;
                for(const e1 in this.layerIndexes)t[e1] || delete this.layerIndexes[e1];
            }
        }
        var Lt = "void main() {fragColor=vec4(1.0);}";
        const Ft = {
            prelude: kt("#ifdef GL_ES\nprecision mediump float;\n#else\n#if !defined(lowp)\n#define lowp\n#endif\n#if !defined(mediump)\n#define mediump\n#endif\n#if !defined(highp)\n#define highp\n#endif\n#endif\nout highp vec4 fragColor;", "#ifdef GL_ES\nprecision highp float;\n#else\n#if !defined(lowp)\n#define lowp\n#endif\n#if !defined(mediump)\n#define mediump\n#endif\n#if !defined(highp)\n#define highp\n#endif\n#endif\nvec2 unpack_float(const float packedValue) {int packedIntValue=int(packedValue);int v0=packedIntValue/256;return vec2(v0,packedIntValue-v0*256);}vec2 unpack_opacity(const float packedOpacity) {int intOpacity=int(packedOpacity)/2;return vec2(float(intOpacity)/127.0,mod(packedOpacity,2.0));}vec4 decode_color(const vec2 encodedColor) {return vec4(unpack_float(encodedColor[0])/255.0,unpack_float(encodedColor[1])/255.0\n);}float unpack_mix_vec2(const vec2 packedValue,const float t) {return mix(packedValue[0],packedValue[1],t);}vec4 unpack_mix_color(const vec4 packedColors,const float t) {vec4 minColor=decode_color(vec2(packedColors[0],packedColors[1]));vec4 maxColor=decode_color(vec2(packedColors[2],packedColors[3]));return mix(minColor,maxColor,t);}vec2 get_pattern_pos(const vec2 pixel_coord_upper,const vec2 pixel_coord_lower,const vec2 pattern_size,const float tile_units_to_pixels,const vec2 pos) {vec2 offset=mod(mod(mod(pixel_coord_upper,pattern_size)*256.0,pattern_size)*256.0+pixel_coord_lower,pattern_size);return (tile_units_to_pixels*pos+offset)/pattern_size;}mat3 rotationMatrixFromAxisAngle(vec3 u,float angle) {float c=cos(angle);float s=sin(angle);float c2=1.0-c;return mat3(u.x*u.x*c2+      c,u.x*u.y*c2-u.z*s,u.x*u.z*c2+u.y*s,u.y*u.x*c2+u.z*s,u.y*u.y*c2+    c,u.y*u.z*c2-u.x*s,u.z*u.x*c2-u.y*s,u.z*u.y*c2+u.x*s,u.z*u.z*c2+    c\n);}\n#ifdef TERRAIN3D\nuniform sampler2D u_terrain;uniform float u_terrain_dim;uniform mat4 u_terrain_matrix;uniform vec4 u_terrain_unpack;uniform float u_terrain_exaggeration;uniform highp sampler2D u_depth;\n#endif\nconst highp vec4 bitSh=vec4(256.*256.*256.,256.*256.,256.,1.);const highp vec4 bitShifts=vec4(1.)/bitSh;highp float unpack(highp vec4 color) {return dot(color,bitShifts);}highp float depthOpacity(vec3 frag) {\n#ifdef TERRAIN3D\nhighp float d=unpack(texture(u_depth,frag.xy*0.5+0.5))+0.0001-frag.z;return 1.0-max(0.0,min(1.0,-d*500.0));\n#else\nreturn 1.0;\n#endif\n}float calculate_visibility(vec4 pos) {\n#ifdef TERRAIN3D\nvec3 frag=pos.xyz/pos.w;highp float d=depthOpacity(frag);if (d > 0.95) return 1.0;return (d+depthOpacity(frag+vec3(0.0,0.01,0.0)))/2.0;\n#else\nreturn 1.0;\n#endif\n}float ele(vec2 pos) {\n#ifdef TERRAIN3D\nvec4 rgb=(texture(u_terrain,pos)*255.0)*u_terrain_unpack;return rgb.r+rgb.g+rgb.b-u_terrain_unpack.a;\n#else\nreturn 0.0;\n#endif\n}float get_elevation(vec2 pos) {\n#ifdef TERRAIN3D\n#ifdef GLOBE\nif ((pos.y <-32767.5) || (pos.y > 32766.5)) {return 0.0;}\n#endif\nvec2 coord=(u_terrain_matrix*vec4(pos,0.0,1.0)).xy*u_terrain_dim+1.0;vec2 f=fract(coord);vec2 c=(floor(coord)+0.5)/(u_terrain_dim+2.0);float d=1.0/(u_terrain_dim+2.0);float tl=ele(c);float tr=ele(c+vec2(d,0.0));float bl=ele(c+vec2(0.0,d));float br=ele(c+vec2(d,d));float elevation=mix(mix(tl,tr,f.x),mix(bl,br,f.x),f.y);return elevation*u_terrain_exaggeration;\n#else\nreturn 0.0;\n#endif\n}const float PI=3.141592653589793;uniform mat4 u_projection_matrix;"),
            projectionMercator: kt("", "float projectLineThickness(float tileY) {return 1.0;}float projectCircleRadius(float tileY) {return 1.0;}vec4 projectTile(vec2 p) {vec4 result=u_projection_matrix*vec4(p,0.0,1.0);return result;}vec4 projectTile(vec2 p,vec2 rawPos) {vec4 result=u_projection_matrix*vec4(p,0.0,1.0);if (rawPos.y <-32767.5 || rawPos.y > 32766.5) {result.z=-10000000.0;}return result;}vec4 projectTileWithElevation(vec2 posInTile,float elevation) {return u_projection_matrix*vec4(posInTile,elevation,1.0);}vec4 projectTileFor3D(vec2 posInTile,float elevation) {return projectTileWithElevation(posInTile,elevation);}"),
            projectionGlobe: kt("", "#define GLOBE_RADIUS 6371008.8\nuniform highp vec4 u_projection_tile_mercator_coords;uniform highp vec4 u_projection_clipping_plane;uniform highp float u_projection_transition;uniform mat4 u_projection_fallback_matrix;vec3 globeRotateVector(vec3 vec,vec2 angles) {vec3 axisRight=vec3(vec.z,0.0,-vec.x);vec3 axisUp=cross(axisRight,vec);axisRight=normalize(axisRight);axisUp=normalize(axisUp);vec2 t=tan(angles);return normalize(vec+axisRight*t.x+axisUp*t.y);}mat3 globeGetRotationMatrix(vec3 spherePos) {vec3 axisRight=vec3(spherePos.z,0.0,-spherePos.x);vec3 axisDown=cross(axisRight,spherePos);axisRight=normalize(axisRight);axisDown=normalize(axisDown);return mat3(axisRight,axisDown,spherePos\n);}float circumferenceRatioAtTileY(float tileY) {float mercator_pos_y=u_projection_tile_mercator_coords.y+u_projection_tile_mercator_coords.w*tileY;float spherical_y=2.0*atan(exp(PI-(mercator_pos_y*PI*2.0)))-PI*0.5;return cos(spherical_y);}float projectLineThickness(float tileY) {float thickness=1.0/circumferenceRatioAtTileY(tileY); \nif (u_projection_transition < 0.999) {return mix(1.0,thickness,u_projection_transition);} else {return thickness;}}vec3 projectToSphere(vec2 translatedPos,vec2 rawPos) {vec2 mercator_pos=u_projection_tile_mercator_coords.xy+u_projection_tile_mercator_coords.zw*translatedPos;vec2 spherical;spherical.x=mercator_pos.x*PI*2.0+PI;spherical.y=2.0*atan(exp(PI-(mercator_pos.y*PI*2.0)))-PI*0.5;float len=cos(spherical.y);vec3 pos=vec3(sin(spherical.x)*len,sin(spherical.y),cos(spherical.x)*len\n);if (rawPos.y <-32767.5) {pos=vec3(0.0,1.0,0.0);}if (rawPos.y > 32766.5) {pos=vec3(0.0,-1.0,0.0);}return pos;}vec3 projectToSphere(vec2 posInTile) {return projectToSphere(posInTile,vec2(0.0,0.0));}float globeComputeClippingZ(vec3 spherePos) {return (1.0-(dot(spherePos,u_projection_clipping_plane.xyz)+u_projection_clipping_plane.w));}vec4 interpolateProjection(vec2 posInTile,vec3 spherePos,float elevation) {vec3 elevatedPos=spherePos*(1.0+elevation/GLOBE_RADIUS);vec4 globePosition=u_projection_matrix*vec4(elevatedPos,1.0);globePosition.z=globeComputeClippingZ(elevatedPos)*globePosition.w;if (u_projection_transition > 0.999) {return globePosition;}vec4 flatPosition=u_projection_fallback_matrix*vec4(posInTile,elevation,1.0);const float z_globeness_threshold=0.2;vec4 result=globePosition;result.z=mix(0.0,globePosition.z,clamp((u_projection_transition-z_globeness_threshold)/(1.0-z_globeness_threshold),0.0,1.0));result.xyw=mix(flatPosition.xyw,globePosition.xyw,u_projection_transition);if ((posInTile.y <-32767.5) || (posInTile.y > 32766.5)) {result=globePosition;const float poles_hidden_anim_percentage=0.02;result.z=mix(globePosition.z,100.0,pow(max((1.0-u_projection_transition)/poles_hidden_anim_percentage,0.0),8.0));}return result;}vec4 interpolateProjectionFor3D(vec2 posInTile,vec3 spherePos,float elevation) {vec3 elevatedPos=spherePos*(1.0+elevation/GLOBE_RADIUS);vec4 globePosition=u_projection_matrix*vec4(elevatedPos,1.0);if (u_projection_transition > 0.999) {return globePosition;}vec4 fallbackPosition=u_projection_fallback_matrix*vec4(posInTile,elevation,1.0);return mix(fallbackPosition,globePosition,u_projection_transition);}vec4 projectTile(vec2 posInTile) {return interpolateProjection(posInTile,projectToSphere(posInTile),0.0);}vec4 projectTile(vec2 posInTile,vec2 rawPos) {return interpolateProjection(posInTile,projectToSphere(posInTile,rawPos),0.0);}vec4 projectTileWithElevation(vec2 posInTile,float elevation) {return interpolateProjection(posInTile,projectToSphere(posInTile),elevation);}vec4 projectTileFor3D(vec2 posInTile,float elevation) {vec3 spherePos=projectToSphere(posInTile,posInTile);return interpolateProjectionFor3D(posInTile,spherePos,elevation);}"),
            background: kt("uniform vec4 u_color;uniform float u_opacity;void main() {fragColor=u_color*u_opacity;\n#ifdef OVERDRAW_INSPECTOR\nfragColor=vec4(1.0);\n#endif\n}", "in vec2 a_pos;void main() {gl_Position=projectTile(a_pos);}"),
            backgroundPattern: kt("uniform vec2 u_pattern_tl_a;uniform vec2 u_pattern_br_a;uniform vec2 u_pattern_tl_b;uniform vec2 u_pattern_br_b;uniform vec2 u_texsize;uniform float u_mix;uniform float u_opacity;uniform sampler2D u_image;in vec2 v_pos_a;in vec2 v_pos_b;void main() {vec2 imagecoord=mod(v_pos_a,1.0);vec2 pos=mix(u_pattern_tl_a/u_texsize,u_pattern_br_a/u_texsize,imagecoord);vec4 color1=texture(u_image,pos);vec2 imagecoord_b=mod(v_pos_b,1.0);vec2 pos2=mix(u_pattern_tl_b/u_texsize,u_pattern_br_b/u_texsize,imagecoord_b);vec4 color2=texture(u_image,pos2);fragColor=mix(color1,color2,u_mix)*u_opacity;\n#ifdef OVERDRAW_INSPECTOR\nfragColor=vec4(1.0);\n#endif\n}", "uniform vec2 u_pattern_size_a;uniform vec2 u_pattern_size_b;uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform float u_scale_a;uniform float u_scale_b;uniform float u_tile_units_to_pixels;in vec2 a_pos;out vec2 v_pos_a;out vec2 v_pos_b;void main() {gl_Position=projectTile(a_pos);v_pos_a=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,u_scale_a*u_pattern_size_a,u_tile_units_to_pixels,a_pos);v_pos_b=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,u_scale_b*u_pattern_size_b,u_tile_units_to_pixels,a_pos);}"),
            circle: kt("in vec3 v_data;in float v_visibility;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define mediump float radius\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define highp vec4 stroke_color\n#pragma mapbox: define mediump float stroke_width\n#pragma mapbox: define lowp float stroke_opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize mediump float radius\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize highp vec4 stroke_color\n#pragma mapbox: initialize mediump float stroke_width\n#pragma mapbox: initialize lowp float stroke_opacity\nvec2 extrude=v_data.xy;float extrude_length=length(extrude);float antialiased_blur=v_data.z;float opacity_t=smoothstep(0.0,antialiased_blur,extrude_length-1.0);float color_t=stroke_width < 0.01 ? 0.0 : smoothstep(antialiased_blur,0.0,extrude_length-radius/(radius+stroke_width));fragColor=v_visibility*opacity_t*mix(color*opacity,stroke_color*stroke_opacity,color_t);const float epsilon=0.5/255.0;if (fragColor.r < epsilon && fragColor.g < epsilon && fragColor.b < epsilon && fragColor.a < epsilon) {discard;}\n#ifdef OVERDRAW_INSPECTOR\nfragColor=vec4(1.0);\n#endif\n}", "uniform bool u_scale_with_map;uniform bool u_pitch_with_map;uniform vec2 u_extrude_scale;uniform highp float u_globe_extrude_scale;uniform lowp float u_device_pixel_ratio;uniform highp float u_camera_to_center_distance;uniform vec2 u_translate;in vec2 a_pos;out vec3 v_data;out float v_visibility;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define mediump float radius\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define highp vec4 stroke_color\n#pragma mapbox: define mediump float stroke_width\n#pragma mapbox: define lowp float stroke_opacity\nvoid main(void) {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize mediump float radius\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize highp vec4 stroke_color\n#pragma mapbox: initialize mediump float stroke_width\n#pragma mapbox: initialize lowp float stroke_opacity\nvec2 pos_raw=a_pos+32768.0;vec2 extrude=vec2(mod(pos_raw,8.0)/7.0*2.0-1.0);vec2 circle_center=floor(pos_raw/8.0)+u_translate;float ele=get_elevation(circle_center);v_visibility=calculate_visibility(projectTileWithElevation(circle_center,ele));if (u_pitch_with_map) {\n#ifdef GLOBE\nvec3 center_vector=projectToSphere(circle_center);\n#endif\nfloat angle_scale=u_globe_extrude_scale;vec2 corner_position=circle_center;if (u_scale_with_map) {angle_scale*=(radius+stroke_width);corner_position+=extrude*u_extrude_scale*(radius+stroke_width);} else {\n#ifdef GLOBE\nvec4 projected_center=interpolateProjection(circle_center,center_vector,ele);\n#else\nvec4 projected_center=projectTileWithElevation(circle_center,ele);\n#endif\ncorner_position+=extrude*u_extrude_scale*(radius+stroke_width)*(projected_center.w/u_camera_to_center_distance);angle_scale*=(radius+stroke_width)*(projected_center.w/u_camera_to_center_distance);}\n#ifdef GLOBE\nvec2 angles=extrude*angle_scale;vec3 corner_vector=globeRotateVector(center_vector,angles);gl_Position=interpolateProjection(corner_position,corner_vector,ele);\n#else\ngl_Position=projectTileWithElevation(corner_position,ele);\n#endif\n} else {gl_Position=projectTileWithElevation(circle_center,ele);if (gl_Position.z/gl_Position.w > 1.0) {gl_Position.xy=vec2(10000.0);}if (u_scale_with_map) {gl_Position.xy+=extrude*(radius+stroke_width)*u_extrude_scale*u_camera_to_center_distance;} else {gl_Position.xy+=extrude*(radius+stroke_width)*u_extrude_scale*gl_Position.w;}}float antialiasblur=-max(1.0/u_device_pixel_ratio/(radius+stroke_width),blur);v_data=vec3(extrude.x,extrude.y,antialiasblur);}"),
            clippingMask: kt(Lt, "in vec2 a_pos;void main() {gl_Position=projectTile(a_pos);}"),
            heatmap: kt("uniform highp float u_intensity;in vec2 v_extrude;\n#pragma mapbox: define highp float weight\n#define GAUSS_COEF 0.3989422804014327\nvoid main() {\n#pragma mapbox: initialize highp float weight\nfloat d=-0.5*3.0*3.0*dot(v_extrude,v_extrude);float val=weight*u_intensity*GAUSS_COEF*exp(d);fragColor=vec4(val,1.0,1.0,1.0);\n#ifdef OVERDRAW_INSPECTOR\nfragColor=vec4(1.0);\n#endif\n}", "uniform float u_extrude_scale;uniform float u_opacity;uniform float u_intensity;uniform highp float u_globe_extrude_scale;in vec2 a_pos;out vec2 v_extrude;\n#pragma mapbox: define highp float weight\n#pragma mapbox: define mediump float radius\nconst highp float ZERO=1.0/255.0/16.0;\n#define GAUSS_COEF 0.3989422804014327\nvoid main(void) {\n#pragma mapbox: initialize highp float weight\n#pragma mapbox: initialize mediump float radius\nvec2 pos_raw=a_pos+32768.0;vec2 unscaled_extrude=vec2(mod(pos_raw,8.0)/7.0*2.0-1.0);float S=sqrt(-2.0*log(ZERO/weight/u_intensity/GAUSS_COEF))/3.0;v_extrude=S*unscaled_extrude;vec2 extrude=v_extrude*radius*u_extrude_scale;vec2 circle_center=floor(pos_raw/8.0);\n#ifdef GLOBE\nvec2 angles=v_extrude*radius*u_globe_extrude_scale;vec3 center_vector=projectToSphere(circle_center);vec3 corner_vector=globeRotateVector(center_vector,angles);gl_Position=interpolateProjection(circle_center+extrude,corner_vector,0.0);\n#else\ngl_Position=projectTileFor3D(circle_center+extrude,get_elevation(circle_center));\n#endif\n}"),
            heatmapTexture: kt("uniform sampler2D u_image;uniform sampler2D u_color_ramp;uniform float u_opacity;in vec2 v_pos;void main() {float t=texture(u_image,v_pos).r;vec4 color=texture(u_color_ramp,vec2(t,0.5));fragColor=color*u_opacity;\n#ifdef OVERDRAW_INSPECTOR\nfragColor=vec4(0.0);\n#endif\n}", "uniform mat4 u_matrix;uniform vec2 u_world;in vec2 a_pos;out vec2 v_pos;void main() {gl_Position=u_matrix*vec4(a_pos*u_world,0,1);v_pos.x=a_pos.x;v_pos.y=1.0-a_pos.y;}"),
            collisionBox: kt("in float v_placed;in float v_notUsed;void main() {float alpha=0.5;fragColor=vec4(1.0,0.0,0.0,1.0)*alpha;if (v_placed > 0.5) {fragColor=vec4(0.0,0.0,1.0,0.5)*alpha;}if (v_notUsed > 0.5) {fragColor*=.1;}}", "in vec2 a_anchor_pos;in vec2 a_placed;in vec2 a_box_real;uniform vec2 u_pixel_extrude_scale;out float v_placed;out float v_notUsed;void main() {gl_Position=projectTileWithElevation(a_anchor_pos,get_elevation(a_anchor_pos));gl_Position.xy=((a_box_real+0.5)*u_pixel_extrude_scale*2.0-1.0)*vec2(1.0,-1.0)*gl_Position.w;if (gl_Position.z/gl_Position.w < 1.1) {gl_Position.z=0.5;}v_placed=a_placed.x;v_notUsed=a_placed.y;}"),
            collisionCircle: kt("in float v_radius;in vec2 v_extrude;in float v_collision;void main() {float alpha=0.5;float stroke_radius=0.9;float distance_to_center=length(v_extrude);float distance_to_edge=abs(distance_to_center-v_radius);float opacity_t=smoothstep(-stroke_radius,0.0,-distance_to_edge);vec4 color=mix(vec4(0.0,0.0,1.0,0.5),vec4(1.0,0.0,0.0,1.0),v_collision);fragColor=color*alpha*opacity_t;}", "in vec2 a_pos;in float a_radius;in vec2 a_flags;uniform vec2 u_viewport_size;out float v_radius;out vec2 v_extrude;out float v_collision;void main() {float radius=a_radius;float collision=a_flags.x;float vertexIdx=a_flags.y;vec2 quadVertexOffset=vec2(mix(-1.0,1.0,float(vertexIdx >=2.0)),mix(-1.0,1.0,float(vertexIdx >=1.0 && vertexIdx <=2.0)));vec2 quadVertexExtent=quadVertexOffset*radius;float padding_factor=1.2;v_radius=radius;v_extrude=quadVertexExtent*padding_factor;v_collision=collision;gl_Position=vec4((a_pos/u_viewport_size*2.0-1.0)*vec2(1.0,-1.0),0.0,1.0)+vec4(quadVertexExtent*padding_factor/u_viewport_size*2.0,0.0,0.0);}"),
            colorRelief: kt("#ifdef GL_ES\nprecision highp float;\n#endif\nuniform sampler2D u_image;uniform vec4 u_unpack;uniform sampler2D u_elevation_stops;uniform sampler2D u_color_stops;uniform int u_color_ramp_size;uniform float u_opacity;in vec2 v_pos;float getElevation(vec2 coord) {vec4 data=texture(u_image,coord)*255.0;data.a=-1.0;return dot(data,u_unpack);}float getElevationStop(int stop) {float x=(float(stop)+0.5)/float(u_color_ramp_size);vec4 data=texture(u_elevation_stops,vec2(x,0))*255.0;data.a=-1.0;return dot(data,u_unpack);}void main() {float el=getElevation(v_pos);int r=(u_color_ramp_size-1);int l=0;float el_l=getElevationStop(l);float el_r=getElevationStop(r);while(r-l > 1){int m=(r+l)/2;float el_m=getElevationStop(m);if(el < el_m){r=m;el_r=el_m;}else\n{l=m;el_l=el_m;}}float x=(float(l)+(el-el_l)/(el_r-el_l)+0.5)/float(u_color_ramp_size);fragColor=u_opacity*texture(u_color_stops,vec2(x,0));\n#ifdef OVERDRAW_INSPECTOR\nfragColor=vec4(1.0);\n#endif\n}", "uniform vec2 u_dimension;in vec2 a_pos;out vec2 v_pos;void main() {gl_Position=projectTile(a_pos,a_pos);highp vec2 epsilon=1.0/u_dimension;float scale=(u_dimension.x-2.0)/u_dimension.x;v_pos=(a_pos/8192.0)*scale+epsilon;if (a_pos.y <-32767.5) {v_pos.y=0.0;}if (a_pos.y > 32766.5) {v_pos.y=1.0;}}"),
            debug: kt("uniform highp vec4 u_color;uniform sampler2D u_overlay;in vec2 v_uv;void main() {vec4 overlay_color=texture(u_overlay,v_uv);fragColor=mix(u_color,overlay_color,overlay_color.a);}", "in vec2 a_pos;out vec2 v_uv;uniform float u_overlay_scale;void main() {v_uv=a_pos/8192.0;gl_Position=projectTileWithElevation(a_pos*u_overlay_scale,get_elevation(a_pos));}"),
            depth: kt(Lt, "in vec2 a_pos;void main() {\n#ifdef GLOBE\ngl_Position=projectTileFor3D(a_pos,0.0);\n#else\ngl_Position=u_projection_matrix*vec4(a_pos,0.0,1.0);\n#endif\n}"),
            fill: kt("#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float opacity\nfragColor=color*opacity;\n#ifdef OVERDRAW_INSPECTOR\nfragColor=vec4(1.0);\n#endif\n}", "uniform vec2 u_fill_translate;in vec2 a_pos;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float opacity\ngl_Position=projectTile(a_pos+u_fill_translate,a_pos);}"),
            fillOutline: kt("in vec2 v_pos;\n#ifdef GLOBE\nin float v_depth;\n#endif\n#pragma mapbox: define highp vec4 outline_color\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 outline_color\n#pragma mapbox: initialize lowp float opacity\nfloat dist=length(v_pos-gl_FragCoord.xy);float alpha=1.0-smoothstep(0.0,1.0,dist);fragColor=outline_color*(alpha*opacity);\n#ifdef GLOBE\nif (v_depth > 1.0) {discard;}\n#endif\n#ifdef OVERDRAW_INSPECTOR\nfragColor=vec4(1.0);\n#endif\n}", "uniform vec2 u_world;uniform vec2 u_fill_translate;in vec2 a_pos;out vec2 v_pos;\n#ifdef GLOBE\nout float v_depth;\n#endif\n#pragma mapbox: define highp vec4 outline_color\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 outline_color\n#pragma mapbox: initialize lowp float opacity\ngl_Position=projectTile(a_pos+u_fill_translate,a_pos);v_pos=(gl_Position.xy/gl_Position.w+1.0)/2.0*u_world;\n#ifdef GLOBE\nv_depth=gl_Position.z/gl_Position.w;\n#endif\n}"),
            fillOutlinePattern: kt("uniform vec2 u_texsize;uniform sampler2D u_image;uniform float u_fade;in vec2 v_pos_a;in vec2 v_pos_b;in vec2 v_pos;\n#ifdef GLOBE\nin float v_depth;\n#endif\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;vec2 imagecoord=mod(v_pos_a,1.0);vec2 pos=mix(pattern_tl_a/u_texsize,pattern_br_a/u_texsize,imagecoord);vec4 color1=texture(u_image,pos);vec2 imagecoord_b=mod(v_pos_b,1.0);vec2 pos2=mix(pattern_tl_b/u_texsize,pattern_br_b/u_texsize,imagecoord_b);vec4 color2=texture(u_image,pos2);float dist=length(v_pos-gl_FragCoord.xy);float alpha=1.0-smoothstep(0.0,1.0,dist);fragColor=mix(color1,color2,u_fade)*alpha*opacity;\n#ifdef GLOBE\nif (v_depth > 1.0) {discard;}\n#endif\n#ifdef OVERDRAW_INSPECTOR\nfragColor=vec4(1.0);\n#endif\n}", "uniform vec2 u_world;uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform vec3 u_scale;uniform vec2 u_fill_translate;in vec2 a_pos;out vec2 v_pos_a;out vec2 v_pos_b;out vec2 v_pos;\n#ifdef GLOBE\nout float v_depth;\n#endif\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\n#pragma mapbox: define lowp float pixel_ratio_from\n#pragma mapbox: define lowp float pixel_ratio_to\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\n#pragma mapbox: initialize lowp float pixel_ratio_from\n#pragma mapbox: initialize lowp float pixel_ratio_to\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;float tileRatio=u_scale.x;float fromScale=u_scale.y;float toScale=u_scale.z;gl_Position=projectTile(a_pos+u_fill_translate,a_pos);vec2 display_size_a=(pattern_br_a-pattern_tl_a)/pixel_ratio_from;vec2 display_size_b=(pattern_br_b-pattern_tl_b)/pixel_ratio_to;v_pos_a=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,fromScale*display_size_a,tileRatio,a_pos);v_pos_b=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,toScale*display_size_b,tileRatio,a_pos);v_pos=(gl_Position.xy/gl_Position.w+1.0)/2.0*u_world;\n#ifdef GLOBE\nv_depth=gl_Position.z/gl_Position.w;\n#endif\n}"),
            fillPattern: kt("#ifdef GL_ES\nprecision highp float;\n#endif\nuniform vec2 u_texsize;uniform float u_fade;uniform sampler2D u_image;in vec2 v_pos_a;in vec2 v_pos_b;\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;vec2 imagecoord=mod(v_pos_a,1.0);vec2 pos=mix(pattern_tl_a/u_texsize,pattern_br_a/u_texsize,imagecoord);vec4 color1=texture(u_image,pos);vec2 imagecoord_b=mod(v_pos_b,1.0);vec2 pos2=mix(pattern_tl_b/u_texsize,pattern_br_b/u_texsize,imagecoord_b);vec4 color2=texture(u_image,pos2);fragColor=mix(color1,color2,u_fade)*opacity;\n#ifdef OVERDRAW_INSPECTOR\nfragColor=vec4(1.0);\n#endif\n}", "uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform vec3 u_scale;uniform vec2 u_fill_translate;in vec2 a_pos;out vec2 v_pos_a;out vec2 v_pos_b;\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\n#pragma mapbox: define lowp float pixel_ratio_from\n#pragma mapbox: define lowp float pixel_ratio_to\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\n#pragma mapbox: initialize lowp float pixel_ratio_from\n#pragma mapbox: initialize lowp float pixel_ratio_to\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;float tileZoomRatio=u_scale.x;float fromScale=u_scale.y;float toScale=u_scale.z;vec2 display_size_a=(pattern_br_a-pattern_tl_a)/pixel_ratio_from;vec2 display_size_b=(pattern_br_b-pattern_tl_b)/pixel_ratio_to;gl_Position=projectTile(a_pos+u_fill_translate,a_pos);v_pos_a=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,fromScale*display_size_a,tileZoomRatio,a_pos);v_pos_b=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,toScale*display_size_b,tileZoomRatio,a_pos);}"),
            fillExtrusion: kt("in vec4 v_color;void main() {fragColor=v_color;\n#ifdef OVERDRAW_INSPECTOR\nfragColor=vec4(1.0);\n#endif\n}", "uniform vec3 u_lightcolor;uniform lowp vec3 u_lightpos;uniform lowp vec3 u_lightpos_globe;uniform lowp float u_lightintensity;uniform float u_vertical_gradient;uniform lowp float u_opacity;uniform vec2 u_fill_translate;in vec2 a_pos;in vec4 a_normal_ed;\n#ifdef TERRAIN3D\nin vec2 a_centroid;\n#endif\nout vec4 v_color;\n#pragma mapbox: define highp float base\n#pragma mapbox: define highp float height\n#pragma mapbox: define highp vec4 color\nvoid main() {\n#pragma mapbox: initialize highp float base\n#pragma mapbox: initialize highp float height\n#pragma mapbox: initialize highp vec4 color\nvec3 normal=a_normal_ed.xyz;\n#ifdef TERRAIN3D\nfloat height_terrain3d_offset=get_elevation(a_centroid);float base_terrain3d_offset=height_terrain3d_offset-(base > 0.0 ? 0.0 : 10.0);\n#else\nfloat height_terrain3d_offset=0.0;float base_terrain3d_offset=0.0;\n#endif\nbase=max(0.0,base)+base_terrain3d_offset;height=max(0.0,height)+height_terrain3d_offset;float t=mod(normal.x,2.0);float elevation=t > 0.0 ? height : base;vec2 posInTile=a_pos+u_fill_translate;\n#ifdef GLOBE\nvec3 spherePos=projectToSphere(posInTile,a_pos);gl_Position=interpolateProjectionFor3D(posInTile,spherePos,elevation);\n#else\ngl_Position=u_projection_matrix*vec4(posInTile,elevation,1.0);\n#endif\nfloat colorvalue=color.r*0.2126+color.g*0.7152+color.b*0.0722;v_color=vec4(0.0,0.0,0.0,1.0);vec4 ambientlight=vec4(0.03,0.03,0.03,1.0);color+=ambientlight;vec3 normalForLighting=normal/16384.0;float directional=clamp(dot(normalForLighting,u_lightpos),0.0,1.0);\n#ifdef GLOBE\nmat3 rotMatrix=globeGetRotationMatrix(spherePos);normalForLighting=rotMatrix*normalForLighting;directional=mix(directional,clamp(dot(normalForLighting,u_lightpos_globe),0.0,1.0),u_projection_transition);\n#endif\ndirectional=mix((1.0-u_lightintensity),max((1.0-colorvalue+u_lightintensity),1.0),directional);if (normal.y !=0.0) {directional*=((1.0-u_vertical_gradient)+(u_vertical_gradient*clamp((t+base)*pow(height/150.0,0.5),mix(0.7,0.98,1.0-u_lightintensity),1.0)));}v_color.r+=clamp(color.r*directional*u_lightcolor.r,mix(0.0,0.3,1.0-u_lightcolor.r),1.0);v_color.g+=clamp(color.g*directional*u_lightcolor.g,mix(0.0,0.3,1.0-u_lightcolor.g),1.0);v_color.b+=clamp(color.b*directional*u_lightcolor.b,mix(0.0,0.3,1.0-u_lightcolor.b),1.0);v_color*=u_opacity;}"),
            fillExtrusionPattern: kt("uniform vec2 u_texsize;uniform float u_fade;uniform sampler2D u_image;in vec2 v_pos_a;in vec2 v_pos_b;in vec4 v_lighting;\n#pragma mapbox: define lowp float base\n#pragma mapbox: define lowp float height\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\n#pragma mapbox: define lowp float pixel_ratio_from\n#pragma mapbox: define lowp float pixel_ratio_to\nvoid main() {\n#pragma mapbox: initialize lowp float base\n#pragma mapbox: initialize lowp float height\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\n#pragma mapbox: initialize lowp float pixel_ratio_from\n#pragma mapbox: initialize lowp float pixel_ratio_to\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;vec2 imagecoord=mod(v_pos_a,1.0);vec2 pos=mix(pattern_tl_a/u_texsize,pattern_br_a/u_texsize,imagecoord);vec4 color1=texture(u_image,pos);vec2 imagecoord_b=mod(v_pos_b,1.0);vec2 pos2=mix(pattern_tl_b/u_texsize,pattern_br_b/u_texsize,imagecoord_b);vec4 color2=texture(u_image,pos2);vec4 mixedColor=mix(color1,color2,u_fade);fragColor=mixedColor*v_lighting;\n#ifdef OVERDRAW_INSPECTOR\nfragColor=vec4(1.0);\n#endif\n}", "uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform float u_height_factor;uniform vec3 u_scale;uniform float u_vertical_gradient;uniform lowp float u_opacity;uniform vec2 u_fill_translate;uniform vec3 u_lightcolor;uniform lowp vec3 u_lightpos;uniform lowp vec3 u_lightpos_globe;uniform lowp float u_lightintensity;in vec2 a_pos;in vec4 a_normal_ed;\n#ifdef TERRAIN3D\nin vec2 a_centroid;\n#endif\n#ifdef GLOBE\nout vec3 v_sphere_pos;\n#endif\nout vec2 v_pos_a;out vec2 v_pos_b;out vec4 v_lighting;\n#pragma mapbox: define lowp float base\n#pragma mapbox: define lowp float height\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\n#pragma mapbox: define lowp float pixel_ratio_from\n#pragma mapbox: define lowp float pixel_ratio_to\nvoid main() {\n#pragma mapbox: initialize lowp float base\n#pragma mapbox: initialize lowp float height\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\n#pragma mapbox: initialize lowp float pixel_ratio_from\n#pragma mapbox: initialize lowp float pixel_ratio_to\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;float tileRatio=u_scale.x;float fromScale=u_scale.y;float toScale=u_scale.z;vec3 normal=a_normal_ed.xyz;float edgedistance=a_normal_ed.w;vec2 display_size_a=(pattern_br_a-pattern_tl_a)/pixel_ratio_from;vec2 display_size_b=(pattern_br_b-pattern_tl_b)/pixel_ratio_to;\n#ifdef TERRAIN3D\nfloat height_terrain3d_offset=get_elevation(a_centroid);float base_terrain3d_offset=height_terrain3d_offset-(base > 0.0 ? 0.0 : 10.0);\n#else\nfloat height_terrain3d_offset=0.0;float base_terrain3d_offset=0.0;\n#endif\nbase=max(0.0,base)+base_terrain3d_offset;height=max(0.0,height)+height_terrain3d_offset;float t=mod(normal.x,2.0);float elevation=t > 0.0 ? height : base;vec2 posInTile=a_pos+u_fill_translate;\n#ifdef GLOBE\nvec3 spherePos=projectToSphere(posInTile,a_pos);vec3 elevatedPos=spherePos*(1.0+elevation/GLOBE_RADIUS);v_sphere_pos=elevatedPos;gl_Position=interpolateProjectionFor3D(posInTile,spherePos,elevation);\n#else\ngl_Position=u_projection_matrix*vec4(posInTile,elevation,1.0);\n#endif\nvec2 pos=normal.x==1.0 && normal.y==0.0 && normal.z==16384.0\n? a_pos\n: vec2(edgedistance,elevation*u_height_factor);v_pos_a=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,fromScale*display_size_a,tileRatio,pos);v_pos_b=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,toScale*display_size_b,tileRatio,pos);v_lighting=vec4(0.0,0.0,0.0,1.0);float directional=clamp(dot(normal/16383.0,u_lightpos),0.0,1.0);directional=mix((1.0-u_lightintensity),max((0.5+u_lightintensity),1.0),directional);if (normal.y !=0.0) {directional*=((1.0-u_vertical_gradient)+(u_vertical_gradient*clamp((t+base)*pow(height/150.0,0.5),mix(0.7,0.98,1.0-u_lightintensity),1.0)));}v_lighting.rgb+=clamp(directional*u_lightcolor,mix(vec3(0.0),vec3(0.3),1.0-u_lightcolor),vec3(1.0));v_lighting*=u_opacity;}"),
            hillshadePrepare: kt("#ifdef GL_ES\nprecision highp float;\n#endif\nuniform sampler2D u_image;in vec2 v_pos;uniform vec2 u_dimension;uniform float u_zoom;uniform vec4 u_unpack;float getElevation(vec2 coord,float bias) {vec4 data=texture(u_image,coord)*255.0;data.a=-1.0;return dot(data,u_unpack);}void main() {vec2 epsilon=1.0/u_dimension;float tileSize=u_dimension.x-2.0;float a=getElevation(v_pos+vec2(-epsilon.x,-epsilon.y),0.0);float b=getElevation(v_pos+vec2(0,-epsilon.y),0.0);float c=getElevation(v_pos+vec2(epsilon.x,-epsilon.y),0.0);float d=getElevation(v_pos+vec2(-epsilon.x,0),0.0);float e=getElevation(v_pos,0.0);float f=getElevation(v_pos+vec2(epsilon.x,0),0.0);float g=getElevation(v_pos+vec2(-epsilon.x,epsilon.y),0.0);float h=getElevation(v_pos+vec2(0,epsilon.y),0.0);float i=getElevation(v_pos+vec2(epsilon.x,epsilon.y),0.0);float exaggerationFactor=u_zoom < 2.0 ? 0.4 : u_zoom < 4.5 ? 0.35 : 0.3;float exaggeration=u_zoom < 15.0 ? (u_zoom-15.0)*exaggerationFactor : 0.0;vec2 deriv=vec2((c+f+f+i)-(a+d+d+g),(g+h+h+i)-(a+b+b+c))*tileSize/pow(2.0,exaggeration+(28.2562-u_zoom));fragColor=clamp(vec4(deriv.x/8.0+0.5,deriv.y/8.0+0.5,1.0,1.0),0.0,1.0);\n#ifdef OVERDRAW_INSPECTOR\nfragColor=vec4(1.0);\n#endif\n}", "uniform mat4 u_matrix;uniform vec2 u_dimension;in vec2 a_pos;in vec2 a_texture_pos;out vec2 v_pos;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);highp vec2 epsilon=1.0/u_dimension;float scale=(u_dimension.x-2.0)/u_dimension.x;v_pos=(a_texture_pos/8192.0)*scale+epsilon;}"),
            hillshade: kt("uniform sampler2D u_image;in vec2 v_pos;uniform vec2 u_latrange;uniform float u_exaggeration;uniform vec4 u_accent;uniform int u_method;uniform float u_altitudes[NUM_ILLUMINATION_SOURCES];uniform float u_azimuths[NUM_ILLUMINATION_SOURCES];uniform vec4 u_shadows[NUM_ILLUMINATION_SOURCES];uniform vec4 u_highlights[NUM_ILLUMINATION_SOURCES];\n#define PI 3.141592653589793\n#define STANDARD 0\n#define COMBINED 1\n#define IGOR 2\n#define MULTIDIRECTIONAL 3\n#define BASIC 4\nfloat get_aspect(vec2 deriv){return deriv.x !=0.0 ? atan(deriv.y,-deriv.x) : PI/2.0*(deriv.y > 0.0 ? 1.0 :-1.0);}void igor_hillshade(vec2 deriv){deriv=deriv*u_exaggeration*2.0;float aspect=get_aspect(deriv);float azimuth=u_azimuths[0]+PI;float slope_stength=atan(length(deriv))*2.0/PI;float aspect_strength=1.0-abs(mod((aspect+azimuth)/PI+0.5,2.0)-1.0);float shadow_strength=slope_stength*aspect_strength;float highlight_strength=slope_stength*(1.0-aspect_strength);fragColor=u_shadows[0]*shadow_strength+u_highlights[0]*highlight_strength;}void standard_hillshade(vec2 deriv){float azimuth=u_azimuths[0]+PI;float slope=atan(0.625*length(deriv));float aspect=get_aspect(deriv);float intensity=u_exaggeration;float base=1.875-intensity*1.75;float maxValue=0.5*PI;float scaledSlope=intensity !=0.5 ? ((pow(base,slope)-1.0)/(pow(base,maxValue)-1.0))*maxValue : slope;float accent=cos(scaledSlope);vec4 accent_color=(1.0-accent)*u_accent*clamp(intensity*2.0,0.0,1.0);float shade=abs(mod((aspect+azimuth)/PI+0.5,2.0)-1.0);vec4 shade_color=mix(u_shadows[0],u_highlights[0],shade)*sin(scaledSlope)*clamp(intensity*2.0,0.0,1.0);fragColor=accent_color*(1.0-shade_color.a)+shade_color;}void basic_hillshade(vec2 deriv){deriv=deriv*u_exaggeration*2.0;float azimuth=u_azimuths[0]+PI;float cos_az=cos(azimuth);float sin_az=sin(azimuth);float cos_alt=cos(u_altitudes[0]);float sin_alt=sin(u_altitudes[0]);float cang=(sin_alt-(deriv.y*cos_az*cos_alt-deriv.x*sin_az*cos_alt))/sqrt(1.0+dot(deriv,deriv));float shade=clamp(cang,0.0,1.0);if(shade > 0.5){fragColor=u_highlights[0]*(2.0*shade-1.0);}else\n{fragColor=u_shadows[0]*(1.0-2.0*shade);}}void multidirectional_hillshade(vec2 deriv){deriv=deriv*u_exaggeration*2.0;fragColor=vec4(0,0,0,0);for(int i=0; i < NUM_ILLUMINATION_SOURCES; i++){float cos_alt=cos(u_altitudes[i]);float sin_alt=sin(u_altitudes[i]);float cos_az=-cos(u_azimuths[i]);float sin_az=-sin(u_azimuths[i]);float cang=(sin_alt-(deriv.y*cos_az*cos_alt-deriv.x*sin_az*cos_alt))/sqrt(1.0+dot(deriv,deriv));float shade=clamp(cang,0.0,1.0);if(shade > 0.5){fragColor+=u_highlights[i]*(2.0*shade-1.0)/float(NUM_ILLUMINATION_SOURCES);}else\n{fragColor+=u_shadows[i]*(1.0-2.0*shade)/float(NUM_ILLUMINATION_SOURCES);}}}void combined_hillshade(vec2 deriv){deriv=deriv*u_exaggeration*2.0;float azimuth=u_azimuths[0]+PI;float cos_az=cos(azimuth);float sin_az=sin(azimuth);float cos_alt=cos(u_altitudes[0]);float sin_alt=sin(u_altitudes[0]);float cang=acos((sin_alt-(deriv.y*cos_az*cos_alt-deriv.x*sin_az*cos_alt))/sqrt(1.0+dot(deriv,deriv)));cang=clamp(cang,0.0,PI/2.0);float shade=cang*atan(length(deriv))*4.0/PI/PI;float highlight=(PI/2.0-cang)*atan(length(deriv))*4.0/PI/PI;fragColor=u_shadows[0]*shade+u_highlights[0]*highlight;}void main() {vec4 pixel=texture(u_image,v_pos);float scaleFactor=cos(radians((u_latrange[0]-u_latrange[1])*(1.0-v_pos.y)+u_latrange[1]));vec2 deriv=((pixel.rg*8.0)-4.0)/scaleFactor;if (u_method==BASIC) {basic_hillshade(deriv);} else if (u_method==COMBINED) {combined_hillshade(deriv);} else if (u_method==IGOR) {igor_hillshade(deriv);} else if (u_method==MULTIDIRECTIONAL) {multidirectional_hillshade(deriv);} else if (u_method==STANDARD) {standard_hillshade(deriv);} else {standard_hillshade(deriv);}\n#ifdef OVERDRAW_INSPECTOR\nfragColor=vec4(1.0);\n#endif\n}", "uniform mat4 u_matrix;in vec2 a_pos;out vec2 v_pos;void main() {gl_Position=projectTile(a_pos,a_pos);v_pos=a_pos/8192.0;if (a_pos.y <-32767.5) {v_pos.y=0.0;}if (a_pos.y > 32766.5) {v_pos.y=1.0;}}"),
            line: kt("uniform lowp float u_device_pixel_ratio;in vec2 v_width2;in vec2 v_normal;in float v_gamma_scale;\n#ifdef GLOBE\nin float v_depth;\n#endif\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\nfloat dist=length(v_normal)*v_width2.s;float blur2=(blur+1.0/u_device_pixel_ratio)*v_gamma_scale;float alpha=clamp(min(dist-(v_width2.t-blur2),v_width2.s-dist)/blur2,0.0,1.0);fragColor=color*(alpha*opacity);\n#ifdef GLOBE\nif (v_depth > 1.0) {discard;}\n#endif\n#ifdef OVERDRAW_INSPECTOR\nfragColor=vec4(1.0);\n#endif\n}", "\n#define scale 0.015873016\nin vec2 a_pos_normal;in vec4 a_data;uniform vec2 u_translation;uniform mediump float u_ratio;uniform vec2 u_units_to_pixels;uniform lowp float u_device_pixel_ratio;out vec2 v_normal;out vec2 v_width2;out float v_gamma_scale;out highp float v_linesofar;\n#ifdef GLOBE\nout float v_depth;\n#endif\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define mediump float gapwidth\n#pragma mapbox: define lowp float offset\n#pragma mapbox: define mediump float width\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump float gapwidth\n#pragma mapbox: initialize lowp float offset\n#pragma mapbox: initialize mediump float width\nfloat ANTIALIASING=1.0/u_device_pixel_ratio/2.0;vec2 a_extrude=a_data.xy-128.0;float a_direction=mod(a_data.z,4.0)-1.0;v_linesofar=(floor(a_data.z/4.0)+a_data.w*64.0)*2.0;vec2 pos=floor(a_pos_normal*0.5);mediump vec2 normal=a_pos_normal-2.0*pos;normal.y=normal.y*2.0-1.0;v_normal=normal;gapwidth=gapwidth/2.0;float halfwidth=width/2.0;offset=-1.0*offset;float inset=gapwidth+(gapwidth > 0.0 ? ANTIALIASING : 0.0);float outset=gapwidth+halfwidth*(gapwidth > 0.0 ? 2.0 : 1.0)+(halfwidth==0.0 ? 0.0 : ANTIALIASING);mediump vec2 dist=outset*a_extrude*scale;mediump float u=0.5*a_direction;mediump float t=1.0-abs(u);mediump vec2 offset2=offset*a_extrude*scale*normal.y*mat2(t,-u,u,t);float adjustedThickness=projectLineThickness(pos.y);vec4 projected_no_extrude=projectTile(pos+offset2/u_ratio*adjustedThickness+u_translation);vec4 projected_with_extrude=projectTile(pos+offset2/u_ratio*adjustedThickness+u_translation+dist/u_ratio*adjustedThickness);gl_Position=projected_with_extrude;\n#ifdef GLOBE\nv_depth=gl_Position.z/gl_Position.w;\n#endif\n#ifdef TERRAIN3D\nv_gamma_scale=1.0;\n#else\nfloat extrude_length_without_perspective=length(dist);float extrude_length_with_perspective=length((projected_with_extrude.xy-projected_no_extrude.xy)/projected_with_extrude.w*u_units_to_pixels);v_gamma_scale=extrude_length_without_perspective/extrude_length_with_perspective;\n#endif\nv_width2=vec2(outset,inset);}"),
            lineGradient: kt("uniform lowp float u_device_pixel_ratio;uniform sampler2D u_image;in vec2 v_width2;in vec2 v_normal;in float v_gamma_scale;in highp vec2 v_uv;\n#ifdef GLOBE\nin float v_depth;\n#endif\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\nfloat dist=length(v_normal)*v_width2.s;float blur2=(blur+1.0/u_device_pixel_ratio)*v_gamma_scale;float alpha=clamp(min(dist-(v_width2.t-blur2),v_width2.s-dist)/blur2,0.0,1.0);vec4 color=texture(u_image,v_uv);fragColor=color*(alpha*opacity);\n#ifdef GLOBE\nif (v_depth > 1.0) {discard;}\n#endif\n#ifdef OVERDRAW_INSPECTOR\nfragColor=vec4(1.0);\n#endif\n}", "\n#define scale 0.015873016\nin vec2 a_pos_normal;in vec4 a_data;in float a_uv_x;in float a_split_index;uniform vec2 u_translation;uniform mediump float u_ratio;uniform lowp float u_device_pixel_ratio;uniform vec2 u_units_to_pixels;uniform float u_image_height;out vec2 v_normal;out vec2 v_width2;out float v_gamma_scale;out highp vec2 v_uv;\n#ifdef GLOBE\nout float v_depth;\n#endif\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define mediump float gapwidth\n#pragma mapbox: define lowp float offset\n#pragma mapbox: define mediump float width\nvoid main() {\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump float gapwidth\n#pragma mapbox: initialize lowp float offset\n#pragma mapbox: initialize mediump float width\nfloat ANTIALIASING=1.0/u_device_pixel_ratio/2.0;vec2 a_extrude=a_data.xy-128.0;float a_direction=mod(a_data.z,4.0)-1.0;highp float texel_height=1.0/u_image_height;highp float half_texel_height=0.5*texel_height;v_uv=vec2(a_uv_x,a_split_index*texel_height-half_texel_height);vec2 pos=floor(a_pos_normal*0.5);mediump vec2 normal=a_pos_normal-2.0*pos;normal.y=normal.y*2.0-1.0;v_normal=normal;gapwidth=gapwidth/2.0;float halfwidth=width/2.0;offset=-1.0*offset;float inset=gapwidth+(gapwidth > 0.0 ? ANTIALIASING : 0.0);float outset=gapwidth+halfwidth*(gapwidth > 0.0 ? 2.0 : 1.0)+(halfwidth==0.0 ? 0.0 : ANTIALIASING);mediump vec2 dist=outset*a_extrude*scale;mediump float u=0.5*a_direction;mediump float t=1.0-abs(u);mediump vec2 offset2=offset*a_extrude*scale*normal.y*mat2(t,-u,u,t);float adjustedThickness=projectLineThickness(pos.y);vec4 projected_no_extrude=projectTile(pos+offset2/u_ratio*adjustedThickness+u_translation);vec4 projected_with_extrude=projectTile(pos+offset2/u_ratio*adjustedThickness+u_translation+dist/u_ratio*adjustedThickness);gl_Position=projected_with_extrude;\n#ifdef GLOBE\nv_depth=gl_Position.z/gl_Position.w;\n#endif\n#ifdef TERRAIN3D\nv_gamma_scale=1.0;\n#else\nfloat extrude_length_without_perspective=length(dist);float extrude_length_with_perspective=length((projected_with_extrude.xy-projected_no_extrude.xy)/projected_with_extrude.w*u_units_to_pixels);v_gamma_scale=extrude_length_without_perspective/extrude_length_with_perspective;\n#endif\nv_width2=vec2(outset,inset);}"),
            linePattern: kt("#ifdef GL_ES\nprecision highp float;\n#endif\nuniform lowp float u_device_pixel_ratio;uniform vec2 u_texsize;uniform float u_fade;uniform mediump vec3 u_scale;uniform sampler2D u_image;in vec2 v_normal;in vec2 v_width2;in float v_linesofar;in float v_gamma_scale;in float v_width;\n#ifdef GLOBE\nin float v_depth;\n#endif\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\n#pragma mapbox: define lowp float pixel_ratio_from\n#pragma mapbox: define lowp float pixel_ratio_to\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\n#pragma mapbox: initialize lowp float pixel_ratio_from\n#pragma mapbox: initialize lowp float pixel_ratio_to\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;float tileZoomRatio=u_scale.x;float fromScale=u_scale.y;float toScale=u_scale.z;vec2 display_size_a=(pattern_br_a-pattern_tl_a)/pixel_ratio_from;vec2 display_size_b=(pattern_br_b-pattern_tl_b)/pixel_ratio_to;vec2 pattern_size_a=vec2(display_size_a.x*fromScale/tileZoomRatio,display_size_a.y);vec2 pattern_size_b=vec2(display_size_b.x*toScale/tileZoomRatio,display_size_b.y);float aspect_a=display_size_a.y/v_width;float aspect_b=display_size_b.y/v_width;float dist=length(v_normal)*v_width2.s;float blur2=(blur+1.0/u_device_pixel_ratio)*v_gamma_scale;float alpha=clamp(min(dist-(v_width2.t-blur2),v_width2.s-dist)/blur2,0.0,1.0);float x_a=mod(v_linesofar/pattern_size_a.x*aspect_a,1.0);float x_b=mod(v_linesofar/pattern_size_b.x*aspect_b,1.0);float y=0.5*v_normal.y+0.5;vec2 texel_size=1.0/u_texsize;vec2 pos_a=mix(pattern_tl_a*texel_size-texel_size,pattern_br_a*texel_size+texel_size,vec2(x_a,y));vec2 pos_b=mix(pattern_tl_b*texel_size-texel_size,pattern_br_b*texel_size+texel_size,vec2(x_b,y));vec4 color=mix(texture(u_image,pos_a),texture(u_image,pos_b),u_fade);fragColor=color*alpha*opacity;\n#ifdef GLOBE\nif (v_depth > 1.0) {discard;}\n#endif\n#ifdef OVERDRAW_INSPECTOR\nfragColor=vec4(1.0);\n#endif\n}", "\n#define scale 0.015873016\n#define LINE_DISTANCE_SCALE 2.0\nin vec2 a_pos_normal;in vec4 a_data;uniform vec2 u_translation;uniform vec2 u_units_to_pixels;uniform mediump float u_ratio;uniform lowp float u_device_pixel_ratio;out vec2 v_normal;out vec2 v_width2;out float v_linesofar;out float v_gamma_scale;out float v_width;\n#ifdef GLOBE\nout float v_depth;\n#endif\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float offset\n#pragma mapbox: define mediump float gapwidth\n#pragma mapbox: define mediump float width\n#pragma mapbox: define lowp float floorwidth\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\n#pragma mapbox: define lowp float pixel_ratio_from\n#pragma mapbox: define lowp float pixel_ratio_to\nvoid main() {\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float offset\n#pragma mapbox: initialize mediump float gapwidth\n#pragma mapbox: initialize mediump float width\n#pragma mapbox: initialize lowp float floorwidth\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\n#pragma mapbox: initialize lowp float pixel_ratio_from\n#pragma mapbox: initialize lowp float pixel_ratio_to\nfloat ANTIALIASING=1.0/u_device_pixel_ratio/2.0;vec2 a_extrude=a_data.xy-128.0;float a_direction=mod(a_data.z,4.0)-1.0;float a_linesofar=(floor(a_data.z/4.0)+a_data.w*64.0)*LINE_DISTANCE_SCALE;vec2 pos=floor(a_pos_normal*0.5);mediump vec2 normal=a_pos_normal-2.0*pos;normal.y=normal.y*2.0-1.0;v_normal=normal;gapwidth=gapwidth/2.0;float halfwidth=width/2.0;offset=-1.0*offset;float inset=gapwidth+(gapwidth > 0.0 ? ANTIALIASING : 0.0);float outset=gapwidth+halfwidth*(gapwidth > 0.0 ? 2.0 : 1.0)+(halfwidth==0.0 ? 0.0 : ANTIALIASING);mediump vec2 dist=outset*a_extrude*scale;mediump float u=0.5*a_direction;mediump float t=1.0-abs(u);mediump vec2 offset2=offset*a_extrude*scale*normal.y*mat2(t,-u,u,t);float adjustedThickness=projectLineThickness(pos.y);vec4 projected_no_extrude=projectTile(pos+offset2/u_ratio*adjustedThickness+u_translation);vec4 projected_with_extrude=projectTile(pos+offset2/u_ratio*adjustedThickness+u_translation+dist/u_ratio*adjustedThickness);gl_Position=projected_with_extrude;\n#ifdef GLOBE\nv_depth=gl_Position.z/gl_Position.w;\n#endif\n#ifdef TERRAIN3D\nv_gamma_scale=1.0;\n#else\nfloat extrude_length_without_perspective=length(dist);float extrude_length_with_perspective=length((projected_with_extrude.xy-projected_no_extrude.xy)/projected_with_extrude.w*u_units_to_pixels);v_gamma_scale=extrude_length_without_perspective/extrude_length_with_perspective;\n#endif\nv_linesofar=a_linesofar;v_width2=vec2(outset,inset);v_width=floorwidth;}"),
            lineSDF: kt("uniform lowp float u_device_pixel_ratio;uniform lowp float u_lineatlas_width;uniform sampler2D u_image;uniform float u_mix;in vec2 v_normal;in vec2 v_width2;in vec2 v_tex_a;in vec2 v_tex_b;in float v_gamma_scale;\n#ifdef GLOBE\nin float v_depth;\n#endif\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define mediump float width\n#pragma mapbox: define lowp float floorwidth\n#pragma mapbox: define mediump vec4 dasharray_from\n#pragma mapbox: define mediump vec4 dasharray_to\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump float width\n#pragma mapbox: initialize lowp float floorwidth\n#pragma mapbox: initialize mediump vec4 dasharray_from\n#pragma mapbox: initialize mediump vec4 dasharray_to\nfloat dist=length(v_normal)*v_width2.s;float blur2=(blur+1.0/u_device_pixel_ratio)*v_gamma_scale;float alpha=clamp(min(dist-(v_width2.t-blur2),v_width2.s-dist)/blur2,0.0,1.0);float sdfdist_a=texture(u_image,v_tex_a).a;float sdfdist_b=texture(u_image,v_tex_b).a;float sdfdist=mix(sdfdist_a,sdfdist_b,u_mix);float sdfgamma=(u_lineatlas_width/256.0/u_device_pixel_ratio)/min(dasharray_from.w,dasharray_to.w);alpha*=smoothstep(0.5-sdfgamma/floorwidth,0.5+sdfgamma/floorwidth,sdfdist);fragColor=color*(alpha*opacity);\n#ifdef GLOBE\nif (v_depth > 1.0) {discard;}\n#endif\n#ifdef OVERDRAW_INSPECTOR\nfragColor=vec4(1.0);\n#endif\n}", "\n#define scale 0.015873016\n#define LINE_DISTANCE_SCALE 2.0\nin vec2 a_pos_normal;in vec4 a_data;uniform vec2 u_translation;uniform mediump float u_ratio;uniform lowp float u_device_pixel_ratio;uniform vec2 u_units_to_pixels;uniform float u_tileratio;uniform float u_crossfade_from;uniform float u_crossfade_to;uniform float u_lineatlas_height;out vec2 v_normal;out vec2 v_width2;out vec2 v_tex_a;out vec2 v_tex_b;out float v_gamma_scale;\n#ifdef GLOBE\nout float v_depth;\n#endif\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define mediump float gapwidth\n#pragma mapbox: define lowp float offset\n#pragma mapbox: define mediump float width\n#pragma mapbox: define lowp float floorwidth\n#pragma mapbox: define mediump vec4 dasharray_from\n#pragma mapbox: define mediump vec4 dasharray_to\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump float gapwidth\n#pragma mapbox: initialize lowp float offset\n#pragma mapbox: initialize mediump float width\n#pragma mapbox: initialize lowp float floorwidth\n#pragma mapbox: initialize mediump vec4 dasharray_from\n#pragma mapbox: initialize mediump vec4 dasharray_to\nfloat ANTIALIASING=1.0/u_device_pixel_ratio/2.0;vec2 a_extrude=a_data.xy-128.0;float a_direction=mod(a_data.z,4.0)-1.0;float a_linesofar=(floor(a_data.z/4.0)+a_data.w*64.0)*LINE_DISTANCE_SCALE;vec2 pos=floor(a_pos_normal*0.5);mediump vec2 normal=a_pos_normal-2.0*pos;normal.y=normal.y*2.0-1.0;v_normal=normal;gapwidth=gapwidth/2.0;float halfwidth=width/2.0;offset=-1.0*offset;float inset=gapwidth+(gapwidth > 0.0 ? ANTIALIASING : 0.0);float outset=gapwidth+halfwidth*(gapwidth > 0.0 ? 2.0 : 1.0)+(halfwidth==0.0 ? 0.0 : ANTIALIASING);mediump vec2 dist=outset*a_extrude*scale;mediump float u=0.5*a_direction;mediump float t=1.0-abs(u);mediump vec2 offset2=offset*a_extrude*scale*normal.y*mat2(t,-u,u,t);float adjustedThickness=projectLineThickness(pos.y);vec4 projected_no_extrude=projectTile(pos+offset2/u_ratio*adjustedThickness+u_translation);vec4 projected_with_extrude=projectTile(pos+offset2/u_ratio*adjustedThickness+u_translation+dist/u_ratio*adjustedThickness);gl_Position=projected_with_extrude;\n#ifdef GLOBE\nv_depth=gl_Position.z/gl_Position.w;\n#endif\n#ifdef TERRAIN3D\nv_gamma_scale=1.0;\n#else\nfloat extrude_length_without_perspective=length(dist);float extrude_length_with_perspective=length((projected_with_extrude.xy-projected_no_extrude.xy)/projected_with_extrude.w*u_units_to_pixels);v_gamma_scale=extrude_length_without_perspective/extrude_length_with_perspective;\n#endif\nfloat u_patternscale_a_x=u_tileratio/dasharray_from.w/u_crossfade_from;float u_patternscale_a_y=-dasharray_from.z/2.0/u_lineatlas_height;float u_patternscale_b_x=u_tileratio/dasharray_to.w/u_crossfade_to;float u_patternscale_b_y=-dasharray_to.z/2.0/u_lineatlas_height;v_tex_a=vec2(a_linesofar*u_patternscale_a_x/floorwidth,normal.y*u_patternscale_a_y+(float(dasharray_from.y)+0.5)/u_lineatlas_height);v_tex_b=vec2(a_linesofar*u_patternscale_b_x/floorwidth,normal.y*u_patternscale_b_y+(float(dasharray_to.y)+0.5)/u_lineatlas_height);v_width2=vec2(outset,inset);}"),
            lineGradientSDF: kt("uniform lowp float u_device_pixel_ratio;uniform sampler2D u_image;uniform sampler2D u_image_dash;uniform float u_mix;uniform lowp float u_lineatlas_width;in vec2 v_normal;in vec2 v_width2;in vec2 v_tex_a;in vec2 v_tex_b;in float v_gamma_scale;in highp vec2 v_uv;\n#ifdef GLOBE\nin float v_depth;\n#endif\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define mediump float width\n#pragma mapbox: define lowp float floorwidth\n#pragma mapbox: define mediump vec4 dasharray_from\n#pragma mapbox: define mediump vec4 dasharray_to\nvoid main() {\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump float width\n#pragma mapbox: initialize lowp float floorwidth\n#pragma mapbox: initialize mediump vec4 dasharray_from\n#pragma mapbox: initialize mediump vec4 dasharray_to\nfloat dist=length(v_normal)*v_width2.s;float blur2=(blur+1.0/u_device_pixel_ratio)*v_gamma_scale;float alpha=clamp(min(dist-(v_width2.t-blur2),v_width2.s-dist)/blur2,0.0,1.0);vec4 color=texture(u_image,v_uv);float sdfdist_a=texture(u_image_dash,v_tex_a).a;float sdfdist_b=texture(u_image_dash,v_tex_b).a;float sdfdist=mix(sdfdist_a,sdfdist_b,u_mix);float sdfgamma=(u_lineatlas_width/256.0)/min(dasharray_from.w,dasharray_to.w);float dash_alpha=smoothstep(0.5-sdfgamma/floorwidth,0.5+sdfgamma/floorwidth,sdfdist);fragColor=color*(alpha*dash_alpha*opacity);\n#ifdef GLOBE\nif (v_depth > 1.0) {discard;}\n#endif\n#ifdef OVERDRAW_INSPECTOR\nfragColor=vec4(1.0);\n#endif\n}", "\n#define scale 0.015873016\n#define LINE_DISTANCE_SCALE 2.0\nin vec2 a_pos_normal;in vec4 a_data;in float a_uv_x;in float a_split_index;uniform vec2 u_translation;uniform mediump float u_ratio;uniform lowp float u_device_pixel_ratio;uniform vec2 u_units_to_pixels;uniform float u_image_height;uniform float u_tileratio;uniform float u_crossfade_from;uniform float u_crossfade_to;uniform float u_lineatlas_height;out vec2 v_normal;out vec2 v_width2;out float v_gamma_scale;out highp vec2 v_uv;out vec2 v_tex_a;out vec2 v_tex_b;\n#ifdef GLOBE\nout float v_depth;\n#endif\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define mediump float gapwidth\n#pragma mapbox: define lowp float offset\n#pragma mapbox: define mediump float width\n#pragma mapbox: define lowp float floorwidth\n#pragma mapbox: define mediump vec4 dasharray_from\n#pragma mapbox: define mediump vec4 dasharray_to\nvoid main() {\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump float gapwidth\n#pragma mapbox: initialize lowp float offset\n#pragma mapbox: initialize mediump float width\n#pragma mapbox: initialize lowp float floorwidth\n#pragma mapbox: initialize mediump vec4 dasharray_from\n#pragma mapbox: initialize mediump vec4 dasharray_to\nfloat ANTIALIASING=1.0/u_device_pixel_ratio/2.0;vec2 a_extrude=a_data.xy-128.0;float a_direction=mod(a_data.z,4.0)-1.0;float a_linesofar=(floor(a_data.z/4.0)+a_data.w*64.0)*LINE_DISTANCE_SCALE;float texel_height=1.0/u_image_height;float half_texel_height=0.5*texel_height;v_uv=vec2(a_uv_x,a_split_index*texel_height-half_texel_height);vec2 pos=floor(a_pos_normal*0.5);mediump vec2 normal=a_pos_normal-2.0*pos;normal.y=normal.y*2.0-1.0;v_normal=normal;gapwidth=gapwidth/2.0;float halfwidth=width/2.0;offset=-1.0*offset;float inset=gapwidth+(gapwidth > 0.0 ? ANTIALIASING : 0.0);float outset=gapwidth+halfwidth*(gapwidth > 0.0 ? 2.0 : 1.0)+(halfwidth==0.0 ? 0.0 : ANTIALIASING);mediump vec2 dist=outset*a_extrude*scale;mediump float u=0.5*a_direction;mediump float t=1.0-abs(u);mediump vec2 offset2=offset*a_extrude*scale*normal.y*mat2(t,-u,u,t);float adjustedThickness=projectLineThickness(pos.y);vec4 projected_no_extrude=projectTile(pos+offset2/u_ratio*adjustedThickness+u_translation);vec4 projected_with_extrude=projectTile(pos+offset2/u_ratio*adjustedThickness+u_translation+dist/u_ratio*adjustedThickness);gl_Position=projected_with_extrude;\n#ifdef GLOBE\nv_depth=gl_Position.z/gl_Position.w;\n#endif\n#ifdef TERRAIN3D\nv_gamma_scale=1.0;\n#else\nfloat extrude_length_without_perspective=length(dist);float extrude_length_with_perspective=length((projected_with_extrude.xy-projected_no_extrude.xy)/projected_with_extrude.w*u_units_to_pixels);v_gamma_scale=extrude_length_without_perspective/extrude_length_with_perspective;\n#endif\nfloat u_patternscale_a_x=u_tileratio/dasharray_from.w/u_crossfade_from;float u_patternscale_a_y=-dasharray_from.z/2.0/u_lineatlas_height;float u_patternscale_b_x=u_tileratio/dasharray_to.w/u_crossfade_to;float u_patternscale_b_y=-dasharray_to.z/2.0/u_lineatlas_height;v_tex_a=vec2(a_linesofar*u_patternscale_a_x/floorwidth,normal.y*u_patternscale_a_y+(float(dasharray_from.y)+0.5)/u_lineatlas_height);v_tex_b=vec2(a_linesofar*u_patternscale_b_x/floorwidth,normal.y*u_patternscale_b_y+(float(dasharray_to.y)+0.5)/u_lineatlas_height);v_width2=vec2(outset,inset);}"),
            raster: kt("uniform float u_fade_t;uniform float u_opacity;uniform sampler2D u_image0;uniform sampler2D u_image1;in vec2 v_pos0;in vec2 v_pos1;uniform float u_brightness_low;uniform float u_brightness_high;uniform float u_saturation_factor;uniform float u_contrast_factor;uniform vec3 u_spin_weights;void main() {vec4 color0=texture(u_image0,v_pos0);vec4 color1=texture(u_image1,v_pos1);if (color0.a > 0.0) {color0.rgb=color0.rgb/color0.a;}if (color1.a > 0.0) {color1.rgb=color1.rgb/color1.a;}vec4 color=mix(color0,color1,u_fade_t);color.a*=u_opacity;vec3 rgb=color.rgb;rgb=vec3(dot(rgb,u_spin_weights.xyz),dot(rgb,u_spin_weights.zxy),dot(rgb,u_spin_weights.yzx));float average=(color.r+color.g+color.b)/3.0;rgb+=(average-rgb)*u_saturation_factor;rgb=(rgb-0.5)*u_contrast_factor+0.5;vec3 u_high_vec=vec3(u_brightness_low,u_brightness_low,u_brightness_low);vec3 u_low_vec=vec3(u_brightness_high,u_brightness_high,u_brightness_high);fragColor=vec4(mix(u_high_vec,u_low_vec,rgb)*color.a,color.a);\n#ifdef OVERDRAW_INSPECTOR\nfragColor=vec4(1.0);\n#endif\n}", "uniform vec2 u_tl_parent;uniform float u_scale_parent;uniform float u_buffer_scale;uniform vec4 u_coords_top;uniform vec4 u_coords_bottom;in vec2 a_pos;out vec2 v_pos0;out vec2 v_pos1;void main() {vec2 fractionalPos=a_pos/8192.0;vec2 position=mix(mix(u_coords_top.xy,u_coords_top.zw,fractionalPos.x),mix(u_coords_bottom.xy,u_coords_bottom.zw,fractionalPos.x),fractionalPos.y);gl_Position=projectTile(position,position);v_pos0=((fractionalPos-0.5)/u_buffer_scale)+0.5;\n#ifdef GLOBE\nif (a_pos.y <-32767.5) {v_pos0.y=0.0;}if (a_pos.y > 32766.5) {v_pos0.y=1.0;}\n#endif\nv_pos1=(v_pos0*u_scale_parent)+u_tl_parent;}"),
            symbolIcon: kt("uniform sampler2D u_texture;in vec2 v_tex;in float v_total_opacity;void main() {fragColor=texture(u_texture,v_tex)*v_total_opacity;\n#ifdef OVERDRAW_INSPECTOR\nfragColor=vec4(1.0);\n#endif\n}", "in vec4 a_pos_offset;in vec4 a_data;in vec4 a_pixeloffset;in vec3 a_projected_pos;in float a_fade_opacity;uniform bool u_is_size_zoom_constant;uniform bool u_is_size_feature_constant;uniform highp float u_size_t;uniform highp float u_size;uniform highp float u_camera_to_center_distance;uniform highp float u_pitch;uniform bool u_rotate_symbol;uniform highp float u_aspect_ratio;uniform float u_fade_change;uniform mat4 u_label_plane_matrix;uniform mat4 u_coord_matrix;uniform bool u_is_text;uniform bool u_pitch_with_map;uniform vec2 u_texsize;uniform bool u_is_along_line;uniform bool u_is_variable_anchor;uniform vec2 u_translation;uniform float u_pitched_scale;out vec2 v_tex;out float v_total_opacity;\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\nvec2 a_pos=a_pos_offset.xy;vec2 a_offset=a_pos_offset.zw;vec2 a_tex=a_data.xy;vec2 a_size=a_data.zw;float a_size_min=floor(a_size[0]*0.5);vec2 a_pxoffset=a_pixeloffset.xy;vec2 a_minFontScale=a_pixeloffset.zw/256.0;float ele=get_elevation(a_pos);highp float segment_angle=-a_projected_pos[2];float size;if (!u_is_size_zoom_constant && !u_is_size_feature_constant) {size=mix(a_size_min,a_size[1],u_size_t)/128.0;} else if (u_is_size_zoom_constant && !u_is_size_feature_constant) {size=a_size_min/128.0;} else {size=u_size;}vec2 translated_a_pos=a_pos+u_translation;vec4 projectedPoint=projectTileWithElevation(translated_a_pos,ele);vec2 fade_opacity=unpack_opacity(a_fade_opacity);float fade_change=fade_opacity[1] > 0.5 ? u_fade_change :-u_fade_change;float visibility=calculate_visibility(projectedPoint);v_total_opacity=opacity*max(0.0,min(visibility,fade_opacity[0]+fade_change));if (v_total_opacity < 0.1){gl_Position=vec4(-2.,-2.,-2.,1.);return;}highp float camera_to_anchor_distance=projectedPoint.w;highp float distance_ratio=u_pitch_with_map ?\ncamera_to_anchor_distance/u_camera_to_center_distance :\nu_camera_to_center_distance/camera_to_anchor_distance;highp float perspective_ratio=clamp(0.5+0.5*distance_ratio,0.0,4.0);size*=perspective_ratio;float fontScale=u_is_text ? size/24.0 : size;highp float symbol_rotation=0.0;if (u_rotate_symbol) {vec4 offsetProjectedPoint=projectTileWithElevation(translated_a_pos+vec2(1,0),ele);vec2 a=projectedPoint.xy/projectedPoint.w;vec2 b=offsetProjectedPoint.xy/offsetProjectedPoint.w;symbol_rotation=atan((b.y-a.y)/u_aspect_ratio,b.x-a.x);}highp float angle_sin=sin(segment_angle+symbol_rotation);highp float angle_cos=cos(segment_angle+symbol_rotation);mat2 rotation_matrix=mat2(angle_cos,-1.0*angle_sin,angle_sin,angle_cos);vec4 projected_pos;if (u_is_along_line || u_is_variable_anchor) {projected_pos=vec4(a_projected_pos.xy,ele,1.0);} else if (u_pitch_with_map) {projected_pos=u_label_plane_matrix*vec4(a_projected_pos.xy+u_translation,ele,1.0);} else {projected_pos=u_label_plane_matrix*projectTileWithElevation(a_projected_pos.xy+u_translation,ele);}float z=float(u_pitch_with_map)*projected_pos.z/projected_pos.w;float projectionScaling=1.0;\n#ifdef GLOBE\nif(u_pitch_with_map) {float anchor_pos_tile_y=(u_coord_matrix*vec4(projected_pos.xy/projected_pos.w,z,1.0)).y;projectionScaling=mix(projectionScaling,1.0/circumferenceRatioAtTileY(anchor_pos_tile_y)*u_pitched_scale,u_projection_transition);}\n#endif\nvec4 finalPos=u_coord_matrix*vec4(projected_pos.xy/projected_pos.w+rotation_matrix*(a_offset/32.0*max(a_minFontScale,fontScale)+a_pxoffset/16.0)*projectionScaling,z,1.0);if(u_pitch_with_map) {finalPos=projectTileWithElevation(finalPos.xy,finalPos.z);}gl_Position=finalPos;v_tex=a_tex/u_texsize;}"),
            symbolSDF: kt("#define SDF_PX 8.0\nuniform bool u_is_halo;uniform bool u_is_plain;uniform sampler2D u_texture;uniform highp float u_gamma_scale;uniform lowp float u_device_pixel_ratio;uniform bool u_is_text;in vec2 v_data0;in vec3 v_data1;\n#pragma mapbox: define highp vec4 fill_color\n#pragma mapbox: define highp vec4 halo_color\n#pragma mapbox: define lowp float halo_width\n#pragma mapbox: define lowp float halo_blur\nvoid main() {\n#pragma mapbox: initialize highp vec4 fill_color\n#pragma mapbox: initialize highp vec4 halo_color\n#pragma mapbox: initialize lowp float halo_width\n#pragma mapbox: initialize lowp float halo_blur\nfloat EDGE_GAMMA=0.105/u_device_pixel_ratio;vec2 tex=v_data0.xy;float gamma_scale=v_data1.x;float size=v_data1.y;float total_opacity=v_data1[2];float fontScale=u_is_text ? size/24.0 : size;highp float gamma=EDGE_GAMMA/(fontScale*u_gamma_scale);lowp float inner_edge=(256.0-64.0)/256.0;lowp float dist=texture(u_texture,tex).a;lowp vec4 color_alpha_out_text,color_alpha_out_halo;if (u_is_plain){highp float gamma_scaled=gamma*gamma_scale;highp float alpha=smoothstep(inner_edge-gamma_scaled,inner_edge+gamma_scaled,dist);color_alpha_out_text=total_opacity*alpha*fill_color;}if (u_is_halo) {float gamma_halo=(halo_blur*1.19/SDF_PX+EDGE_GAMMA)/(fontScale*u_gamma_scale);float inner_edge_halo=inner_edge+gamma_halo*gamma_scale;highp float gamma_scaled_halo=gamma_halo*gamma_scale;highp float alpha_halo=smoothstep(inner_edge_halo-gamma_scaled_halo,inner_edge_halo+gamma_scaled_halo,dist);highp float halo_edge=(6.0-halo_width/fontScale)/SDF_PX;alpha_halo= min(smoothstep(halo_edge-gamma_scaled_halo,halo_edge+gamma_scaled_halo,dist),1.0-alpha_halo);color_alpha_out_halo=total_opacity*alpha_halo*halo_color;}if (u_is_plain && u_is_halo) {fragColor=color_alpha_out_text+(1.-color_alpha_out_text.a)*color_alpha_out_halo;} else if (u_is_halo){fragColor=color_alpha_out_halo;} else {fragColor=color_alpha_out_text;}\n#ifdef OVERDRAW_INSPECTOR\nfragColor=vec4(1.0);\n#endif\n}", "in vec4 a_pos_offset;in vec4 a_data;in vec4 a_pixeloffset;in vec3 a_projected_pos;in float a_fade_opacity;uniform bool u_is_size_zoom_constant;uniform bool u_is_size_feature_constant;uniform highp float u_size_t;uniform highp float u_size;uniform mat4 u_label_plane_matrix;uniform mat4 u_coord_matrix;uniform bool u_is_text;uniform bool u_pitch_with_map;uniform bool u_is_along_line;uniform bool u_is_variable_anchor;uniform highp float u_pitch;uniform bool u_rotate_symbol;uniform highp float u_aspect_ratio;uniform highp float u_camera_to_center_distance;uniform float u_fade_change;uniform vec2 u_texsize;uniform vec2 u_translation;uniform float u_pitched_scale;out vec2 v_data0;out vec3 v_data1;\n#pragma mapbox: define highp vec4 fill_color\n#pragma mapbox: define highp vec4 halo_color\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float halo_width\n#pragma mapbox: define lowp float halo_blur\nvoid main() {\n#pragma mapbox: initialize highp vec4 fill_color\n#pragma mapbox: initialize highp vec4 halo_color\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float halo_width\n#pragma mapbox: initialize lowp float halo_blur\nvec2 a_pos=a_pos_offset.xy;vec2 a_offset=a_pos_offset.zw;vec2 a_tex=a_data.xy;vec2 a_size=a_data.zw;float a_size_min=floor(a_size[0]*0.5);vec2 a_pxoffset=a_pixeloffset.xy/16.0;vec2 a_minFontScale=a_pixeloffset.zw/256.0;float ele=get_elevation(a_pos);highp float segment_angle=-a_projected_pos[2];float size;if (!u_is_size_zoom_constant && !u_is_size_feature_constant) {size=mix(a_size_min,a_size[1],u_size_t)/128.0;} else if (u_is_size_zoom_constant && !u_is_size_feature_constant) {size=a_size_min/128.0;} else {size=u_size;}vec2 translated_a_pos=a_pos+u_translation;vec4 projectedPoint=projectTileWithElevation(translated_a_pos,ele);vec2 fade_opacity=unpack_opacity(a_fade_opacity);float visibility=calculate_visibility(projectedPoint);float fade_change=fade_opacity[1] > 0.5 ? u_fade_change :-u_fade_change;float interpolated_fade_opacity=max(0.0,min(visibility,fade_opacity[0]+fade_change));float total_opacity=opacity*interpolated_fade_opacity;if (total_opacity < 0.1){gl_Position=vec4(-2.,-2.,-2.,1.);return;}highp float camera_to_anchor_distance=projectedPoint.w;highp float distance_ratio=u_pitch_with_map ?\ncamera_to_anchor_distance/u_camera_to_center_distance :\nu_camera_to_center_distance/camera_to_anchor_distance;highp float perspective_ratio=clamp(0.5+0.5*distance_ratio,0.0,4.0);size*=perspective_ratio;float fontScale=u_is_text ? size/24.0 : size;highp float symbol_rotation=0.0;if (u_rotate_symbol) {vec4 offsetProjectedPoint=projectTileWithElevation(translated_a_pos+vec2(1,0),ele);vec2 a=projectedPoint.xy/projectedPoint.w;vec2 b=offsetProjectedPoint.xy/offsetProjectedPoint.w;symbol_rotation=atan((b.y-a.y)/u_aspect_ratio,b.x-a.x);}highp float angle_sin=sin(segment_angle+symbol_rotation);highp float angle_cos=cos(segment_angle+symbol_rotation);mat2 rotation_matrix=mat2(angle_cos,-1.0*angle_sin,angle_sin,angle_cos);vec4 projected_pos;if (u_is_along_line || u_is_variable_anchor) {projected_pos=vec4(a_projected_pos.xy,ele,1.0);} else if (u_pitch_with_map) {projected_pos=u_label_plane_matrix*vec4(a_projected_pos.xy+u_translation,ele,1.0);} else {projected_pos=u_label_plane_matrix*projectTileWithElevation(a_projected_pos.xy+u_translation,ele);}float z=float(u_pitch_with_map)*projected_pos.z/projected_pos.w;float projectionScaling=1.0;\n#ifdef GLOBE\nif(u_pitch_with_map) {float anchor_pos_tile_y=(u_coord_matrix*vec4(projected_pos.xy/projected_pos.w,z,1.0)).y;projectionScaling=mix(projectionScaling,1.0/circumferenceRatioAtTileY(anchor_pos_tile_y)*u_pitched_scale,u_projection_transition);}\n#endif\nvec4 finalPos=u_coord_matrix*vec4(projected_pos.xy/projected_pos.w+rotation_matrix*(a_offset/32.0*max(a_minFontScale,fontScale)+a_pxoffset)*projectionScaling,z,1.0);if(u_pitch_with_map) {finalPos=projectTileWithElevation(finalPos.xy,finalPos.z);}float gamma_scale=finalPos.w;gl_Position=finalPos;v_data0=a_tex/u_texsize;v_data1=vec3(gamma_scale,size,total_opacity);}"),
            symbolTextAndIcon: kt("#define SDF_PX 8.0\n#define SDF 1.0\n#define ICON 0.0\nuniform bool u_is_halo;uniform bool u_is_text;uniform sampler2D u_texture;uniform sampler2D u_texture_icon;uniform highp float u_gamma_scale;uniform lowp float u_device_pixel_ratio;in vec4 v_data0;in vec4 v_data1;\n#pragma mapbox: define highp vec4 fill_color\n#pragma mapbox: define highp vec4 halo_color\n#pragma mapbox: define lowp float halo_width\n#pragma mapbox: define lowp float halo_blur\nvoid main() {\n#pragma mapbox: initialize highp vec4 fill_color\n#pragma mapbox: initialize highp vec4 halo_color\n#pragma mapbox: initialize lowp float halo_width\n#pragma mapbox: initialize lowp float halo_blur\nfloat total_opacity=v_data1[2];if (v_data1.w==ICON) {vec2 tex_icon=v_data0.zw;fragColor=texture(u_texture_icon,tex_icon)*total_opacity;\n#ifdef OVERDRAW_INSPECTOR\nfragColor=vec4(1.0);\n#endif\nreturn;}vec2 tex=v_data0.xy;float EDGE_GAMMA=0.105/u_device_pixel_ratio;float gamma_scale=v_data1.x;float size=v_data1.y;float fontScale=size/24.0;highp float gamma=EDGE_GAMMA/(fontScale*u_gamma_scale);lowp float buff=(256.0-64.0)/256.0;lowp float dist=texture(u_texture,tex).a;lowp vec4 color_alpha_out,color_alpha_out_halo;if (u_is_text) {highp float gamma_scaled=gamma*gamma_scale;highp float alpha=smoothstep(buff-gamma_scaled,buff+gamma_scaled,dist);color_alpha_out=fill_color*(alpha*total_opacity);}if (u_is_halo) {highp float gamma_halo=(halo_blur*1.19/SDF_PX+EDGE_GAMMA)/(fontScale*u_gamma_scale);lowp float buff_halo=(6.0-halo_width/fontScale)/SDF_PX;highp float gamma_scaled_halo=gamma_halo*gamma_scale;highp float alpha_halo=smoothstep(buff_halo-gamma_scaled_halo,buff_halo+gamma_scaled_halo,dist);color_alpha_out_halo=halo_color*(alpha_halo*total_opacity);}if (u_is_text && u_is_halo) {fragColor=color_alpha_out+(1.-color_alpha_out.a)*color_alpha_out_halo;} else if (u_is_halo) {fragColor=color_alpha_out_halo;} else {fragColor=color_alpha_out;}\n#ifdef OVERDRAW_INSPECTOR\nfragColor=vec4(1.0);\n#endif\n}", "in vec4 a_pos_offset;in vec4 a_data;in vec3 a_projected_pos;in float a_fade_opacity;uniform bool u_is_size_zoom_constant;uniform bool u_is_size_feature_constant;uniform highp float u_size_t;uniform highp float u_size;uniform mat4 u_label_plane_matrix;uniform mat4 u_coord_matrix;uniform bool u_is_text;uniform bool u_pitch_with_map;uniform highp float u_pitch;uniform bool u_rotate_symbol;uniform highp float u_aspect_ratio;uniform highp float u_camera_to_center_distance;uniform float u_fade_change;uniform vec2 u_texsize;uniform vec2 u_texsize_icon;uniform bool u_is_along_line;uniform bool u_is_variable_anchor;uniform vec2 u_translation;uniform float u_pitched_scale;out vec4 v_data0;out vec4 v_data1;\n#pragma mapbox: define highp vec4 fill_color\n#pragma mapbox: define highp vec4 halo_color\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float halo_width\n#pragma mapbox: define lowp float halo_blur\nvoid main() {\n#pragma mapbox: initialize highp vec4 fill_color\n#pragma mapbox: initialize highp vec4 halo_color\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float halo_width\n#pragma mapbox: initialize lowp float halo_blur\nvec2 a_pos=a_pos_offset.xy;vec2 a_offset=a_pos_offset.zw;vec2 a_tex=a_data.xy;vec2 a_size=a_data.zw;float a_size_min=floor(a_size[0]*0.5);float is_sdf=a_size[0]-2.0*a_size_min;float ele=get_elevation(a_pos);highp float segment_angle=-a_projected_pos[2];float size;if (!u_is_size_zoom_constant && !u_is_size_feature_constant) {size=mix(a_size_min,a_size[1],u_size_t)/128.0;} else if (u_is_size_zoom_constant && !u_is_size_feature_constant) {size=a_size_min/128.0;} else {size=u_size;}vec2 translated_a_pos=a_pos+u_translation;vec4 projectedPoint=projectTileWithElevation(translated_a_pos,ele);vec2 fade_opacity=unpack_opacity(a_fade_opacity);float visibility=calculate_visibility(projectedPoint);float fade_change=fade_opacity[1] > 0.5 ? u_fade_change :-u_fade_change;float interpolated_fade_opacity=max(0.0,min(visibility,fade_opacity[0]+fade_change));float total_opacity=opacity*interpolated_fade_opacity;if (total_opacity < 0.1){gl_Position=vec4(-2.,-2.,-2.,1.);return;}highp float camera_to_anchor_distance=projectedPoint.w;highp float distance_ratio=u_pitch_with_map ?\ncamera_to_anchor_distance/u_camera_to_center_distance :\nu_camera_to_center_distance/camera_to_anchor_distance;highp float perspective_ratio=clamp(0.5+0.5*distance_ratio,0.0,4.0);size*=perspective_ratio;float fontScale=size/24.0;highp float symbol_rotation=0.0;if (u_rotate_symbol) {vec4 offsetProjectedPoint=projectTileWithElevation(translated_a_pos+vec2(1,0),ele);vec2 a=projectedPoint.xy/projectedPoint.w;vec2 b=offsetProjectedPoint.xy/offsetProjectedPoint.w;symbol_rotation=atan((b.y-a.y)/u_aspect_ratio,b.x-a.x);}highp float angle_sin=sin(segment_angle+symbol_rotation);highp float angle_cos=cos(segment_angle+symbol_rotation);mat2 rotation_matrix=mat2(angle_cos,-1.0*angle_sin,angle_sin,angle_cos);vec4 projected_pos;if (u_is_along_line || u_is_variable_anchor) {projected_pos=vec4(a_projected_pos.xy,ele,1.0);} else if (u_pitch_with_map) {projected_pos=u_label_plane_matrix*vec4(a_projected_pos.xy+u_translation,ele,1.0);} else {projected_pos=u_label_plane_matrix*projectTileWithElevation(a_projected_pos.xy+u_translation,ele);}float z=float(u_pitch_with_map)*projected_pos.z/projected_pos.w;float projectionScaling=1.0;\n#ifdef GLOBE\nif(u_pitch_with_map && !u_is_along_line) {float anchor_pos_tile_y=(u_coord_matrix*vec4(projected_pos.xy/projected_pos.w,z,1.0)).y;projectionScaling=mix(projectionScaling,1.0/circumferenceRatioAtTileY(anchor_pos_tile_y)*u_pitched_scale,u_projection_transition);}\n#endif\nvec4 finalPos=u_coord_matrix*vec4(projected_pos.xy/projected_pos.w+rotation_matrix*(a_offset/32.0*fontScale)*projectionScaling,z,1.0);if(u_pitch_with_map) {finalPos=projectTileWithElevation(finalPos.xy,finalPos.z);}float gamma_scale=finalPos.w;gl_Position=finalPos;v_data0.xy=a_tex/u_texsize;v_data0.zw=a_tex/u_texsize_icon;v_data1=vec4(gamma_scale,size,total_opacity,is_sdf);}"),
            terrain: kt("uniform sampler2D u_texture;uniform vec4 u_fog_color;uniform vec4 u_horizon_color;uniform float u_fog_ground_blend;uniform float u_fog_ground_blend_opacity;uniform float u_horizon_fog_blend;uniform bool u_is_globe_mode;in vec2 v_texture_pos;in float v_fog_depth;const float gamma=2.2;vec4 gammaToLinear(vec4 color) {return pow(color,vec4(gamma));}vec4 linearToGamma(vec4 color) {return pow(color,vec4(1.0/gamma));}void main() {vec4 surface_color=texture(u_texture,vec2(v_texture_pos.x,1.0-v_texture_pos.y));if (!u_is_globe_mode && u_fog_ground_blend_opacity > 0.0 && v_fog_depth > u_fog_ground_blend) {vec4 surface_color_linear=gammaToLinear(surface_color);float blend_color=smoothstep(0.0,1.0,max((v_fog_depth-u_horizon_fog_blend)/(1.0-u_horizon_fog_blend),0.0));vec4 fog_horizon_color_linear=mix(gammaToLinear(u_fog_color),gammaToLinear(u_horizon_color),blend_color);float factor_fog=max(v_fog_depth-u_fog_ground_blend,0.0)/(1.0-u_fog_ground_blend);fragColor=linearToGamma(mix(surface_color_linear,fog_horizon_color_linear,pow(factor_fog,2.0)*u_fog_ground_blend_opacity));} else {fragColor=surface_color;}}", "in vec3 a_pos3d;uniform mat4 u_fog_matrix;uniform float u_ele_delta;out vec2 v_texture_pos;out float v_fog_depth;void main() {float ele=get_elevation(a_pos3d.xy);float ele_delta=a_pos3d.z==1.0 ? u_ele_delta : 0.0;v_texture_pos=a_pos3d.xy/8192.0;gl_Position=projectTileFor3D(a_pos3d.xy,ele-ele_delta);vec4 pos=u_fog_matrix*vec4(a_pos3d.xy,ele,1.0);v_fog_depth=pos.z/pos.w*0.5+0.5;}"),
            terrainDepth: kt("in float v_depth;const highp vec4 bitSh=vec4(256.*256.*256.,256.*256.,256.,1.);const highp vec4 bitMsk=vec4(0.,vec3(1./256.0));highp vec4 pack(highp float value) {highp vec4 comp=fract(value*bitSh);comp-=comp.xxyz*bitMsk;return comp;}void main() {fragColor=pack(v_depth);}", "in vec3 a_pos3d;uniform float u_ele_delta;out float v_depth;void main() {float ele=get_elevation(a_pos3d.xy);float ele_delta=a_pos3d.z==1.0 ? u_ele_delta : 0.0;gl_Position=projectTileFor3D(a_pos3d.xy,ele-ele_delta);v_depth=gl_Position.z/gl_Position.w;}"),
            terrainCoords: kt("precision mediump float;uniform sampler2D u_texture;uniform float u_terrain_coords_id;in vec2 v_texture_pos;void main() {vec4 rgba=texture(u_texture,v_texture_pos);fragColor=vec4(rgba.r,rgba.g,rgba.b,u_terrain_coords_id);}", "in vec3 a_pos3d;uniform float u_ele_delta;out vec2 v_texture_pos;void main() {float ele=get_elevation(a_pos3d.xy);float ele_delta=a_pos3d.z==1.0 ? u_ele_delta : 0.0;v_texture_pos=a_pos3d.xy/8192.0;gl_Position=projectTileFor3D(a_pos3d.xy,ele-ele_delta);}"),
            projectionErrorMeasurement: kt("in vec4 v_output_error_encoded;void main() {fragColor=v_output_error_encoded;}", "in vec2 a_pos;uniform highp float u_input;uniform highp float u_output_expected;out vec4 v_output_error_encoded;void main() {float real_output=2.0*atan(exp(PI-(u_input*PI*2.0)))-PI*0.5;float error=real_output-u_output_expected;float abs_error=abs(error)*128.0;v_output_error_encoded.x=min(floor(abs_error*256.0),255.0)/255.0;abs_error-=v_output_error_encoded.x;v_output_error_encoded.y=min(floor(abs_error*65536.0),255.0)/255.0;abs_error-=v_output_error_encoded.x/255.0;v_output_error_encoded.z=min(floor(abs_error*16777216.0),255.0)/255.0;v_output_error_encoded.w=error >=0.0 ? 1.0 : 0.0;gl_Position=vec4(a_pos,0.0,1.0);}"),
            atmosphere: kt("#ifdef GL_ES\nprecision highp float;\n#endif\nin vec3 view_direction;uniform vec3 u_sun_pos;uniform vec3 u_globe_position;uniform float u_globe_radius;uniform float u_atmosphere_blend;/**Shader use from https:*Made some change to adapt to MapLibre Globe geometry*/const float PI=3.141592653589793;const int iSteps=5;const int jSteps=3;/*radius of the planet*/const float EARTH_RADIUS=6371e3;/*radius of the atmosphere*/const float ATMOS_RADIUS=6471e3;vec2 rsi(vec3 r0,vec3 rd,float sr) {float a=dot(rd,rd);float b=2.0*dot(rd,r0);float c=dot(r0,r0)-(sr*sr);float d=(b*b)-4.0*a*c;if (d < 0.0) return vec2(1e5,-1e5);return vec2((-b-sqrt(d))/(2.0*a),(-b+sqrt(d))/(2.0*a));}vec4 atmosphere(vec3 r,vec3 r0,vec3 pSun,float iSun,float rPlanet,float rAtmos,vec3 kRlh,float kMie,float shRlh,float shMie,float g) {pSun=normalize(pSun);r=normalize(r);vec2 p=rsi(r0,r,rAtmos);if (p.x > p.y) {return vec4(0.0,0.0,0.0,1.0);}if (p.x < 0.0) {p.x=0.0;}vec3 pos=r0+r*p.x;vec2 p2=rsi(r0,r,rPlanet);if (p2.x <=p2.y && p2.x > 0.0) {p.y=min(p.y,p2.x);}float iStepSize=(p.y-p.x)/float(iSteps);float iTime=p.x+iStepSize*0.5;vec3 totalRlh=vec3(0,0,0);vec3 totalMie=vec3(0,0,0);float iOdRlh=0.0;float iOdMie=0.0;float mu=dot(r,pSun);float mumu=mu*mu;float gg=g*g;float pRlh=3.0/(16.0*PI)*(1.0+mumu);float pMie=3.0/(8.0*PI)*((1.0-gg)*(mumu+1.0))/(pow(1.0+gg-2.0*mu*g,1.5)*(2.0+gg));for (int i=0; i < iSteps; i++) {vec3 iPos=r0+r*iTime;float iHeight=length(iPos)-rPlanet;float odStepRlh=exp(-iHeight/shRlh)*iStepSize;float odStepMie=exp(-iHeight/shMie)*iStepSize;iOdRlh+=odStepRlh;iOdMie+=odStepMie;float jStepSize=rsi(iPos,pSun,rAtmos).y/float(jSteps);float jTime=jStepSize*0.5;float jOdRlh=0.0;float jOdMie=0.0;for (int j=0; j < jSteps; j++) {vec3 jPos=iPos+pSun*jTime;float jHeight=length(jPos)-rPlanet;jOdRlh+=exp(-jHeight/shRlh)*jStepSize;jOdMie+=exp(-jHeight/shMie)*jStepSize;jTime+=jStepSize;}vec3 attn=exp(-(kMie*(iOdMie+jOdMie)+kRlh*(iOdRlh+jOdRlh)));totalRlh+=odStepRlh*attn;totalMie+=odStepMie*attn;iTime+=iStepSize;}float opacity=exp(-(length(kRlh)*length(totalRlh)+kMie*length(totalMie)));vec3 color=iSun*(pRlh*kRlh*totalRlh+pMie*kMie*totalMie);return vec4(color,opacity);}void main() {vec3 scale_camera_pos=-u_globe_position*EARTH_RADIUS/u_globe_radius;vec4 color=atmosphere(normalize(view_direction),scale_camera_pos,u_sun_pos,22.0,EARTH_RADIUS,ATMOS_RADIUS,vec3(5.5e-6,13.0e-6,22.4e-6),21e-6,8e3,1.2e3,0.758\n);color.rgb=1.0-exp(-1.0*color.rgb);color=pow(color,vec4(1.0/2.2));fragColor=vec4(color.rgb,1.0-color.a)*u_atmosphere_blend;}", "in vec2 a_pos;uniform mat4 u_inv_proj_matrix;out vec3 view_direction;void main() {view_direction=(u_inv_proj_matrix*vec4(a_pos,0.0,1.0)).xyz;gl_Position=vec4(a_pos,0.0,1.0);}"),
            sky: kt("uniform vec4 u_sky_color;uniform vec4 u_horizon_color;uniform vec2 u_horizon;uniform vec2 u_horizon_normal;uniform float u_sky_horizon_blend;uniform float u_sky_blend;void main() {float x=gl_FragCoord.x;float y=gl_FragCoord.y;float blend=(y-u_horizon.y)*u_horizon_normal.y+(x-u_horizon.x)*u_horizon_normal.x;if (blend > 0.0) {if (blend < u_sky_horizon_blend) {fragColor=mix(u_sky_color,u_horizon_color,pow(1.0-blend/u_sky_horizon_blend,2.0));} else {fragColor=u_sky_color;}}fragColor=mix(fragColor,vec4(vec3(0.0),0.0),u_sky_blend);}", "in vec2 a_pos;void main() {gl_Position=vec4(a_pos,1.0,1.0);}")
        };
        function kt(e1, t) {
            const i = /#pragma mapbox: ([\w]+) ([\w]+) ([\w]+) ([\w]+)/g, o = t.match(/in ([\w]+) ([\w]+)/g), a = e1.match(/uniform ([\w]+) ([\w]+)([\s]*)([\w]*)/g), r = t.match(/uniform ([\w]+) ([\w]+)([\s]*)([\w]*)/g), s = r ? r.concat(a) : a, n = {};
            return {
                fragmentSource: e1 = e1.replace(i, (e1, t, i, o, a)=>(n[a] = !0, "define" === t ? `\n#ifndef HAS_UNIFORM_u_${a}\nin ${i} ${o} ${a};\n#else\nuniform ${i} ${o} u_${a};\n#endif\n` : `\n#ifdef HAS_UNIFORM_u_${a}\n    ${i} ${o} ${a} = u_${a};\n#endif\n`)),
                vertexSource: t = t.replace(i, (e1, t, i, o, a)=>{
                    const r = "float" === o ? "vec2" : "vec4", s = a.match(/color/) ? "color" : r;
                    return n[a] ? "define" === t ? `\n#ifndef HAS_UNIFORM_u_${a}\nuniform lowp float u_${a}_t;\nin ${i} ${r} a_${a};\nout ${i} ${o} ${a};\n#else\nuniform ${i} ${o} u_${a};\n#endif\n` : "vec4" === s ? `\n#ifndef HAS_UNIFORM_u_${a}\n    ${a} = a_${a};\n#else\n    ${i} ${o} ${a} = u_${a};\n#endif\n` : `\n#ifndef HAS_UNIFORM_u_${a}\n    ${a} = unpack_mix_${s}(a_${a}, u_${a}_t);\n#else\n    ${i} ${o} ${a} = u_${a};\n#endif\n` : "define" === t ? `\n#ifndef HAS_UNIFORM_u_${a}\nuniform lowp float u_${a}_t;\nin ${i} ${r} a_${a};\n#else\nuniform ${i} ${o} u_${a};\n#endif\n` : "vec4" === s ? `\n#ifndef HAS_UNIFORM_u_${a}\n    ${i} ${o} ${a} = a_${a};\n#else\n    ${i} ${o} ${a} = u_${a};\n#endif\n` : `\n#ifndef HAS_UNIFORM_u_${a}\n    ${i} ${o} ${a} = unpack_mix_${s}(a_${a}, u_${a}_t);\n#else\n    ${i} ${o} ${a} = u_${a};\n#endif\n`;
                }),
                staticAttributes: o,
                staticUniforms: s
            };
        }
        class Bt {
            constructor(e1, t, i){
                this.vertexBuffer = e1, this.indexBuffer = t, this.segments = i;
            }
            destroy() {
                this.vertexBuffer.destroy(), this.indexBuffer.destroy(), this.segments.destroy(), this.vertexBuffer = null, this.indexBuffer = null, this.segments = null;
            }
        }
        var Ot = t.aS([
            {
                name: "a_pos",
                type: "Int16",
                components: 2
            }
        ]);
        const jt = "#define PROJECTION_MERCATOR", Nt = "mercator";
        class Zt {
            constructor(){
                this._cachedMesh = null;
            }
            get name() {
                return "mercator";
            }
            get useSubdivision() {
                return !1;
            }
            get shaderVariantName() {
                return Nt;
            }
            get shaderDefine() {
                return jt;
            }
            get shaderPreludeCode() {
                return Ft.projectionMercator;
            }
            get vertexShaderPreludeCode() {
                return Ft.projectionMercator.vertexSource;
            }
            get subdivisionGranularity() {
                return t.aT.noSubdivision;
            }
            get useGlobeControls() {
                return !1;
            }
            get transitionState() {
                return 0;
            }
            get latitudeErrorCorrectionRadians() {
                return 0;
            }
            destroy() {}
            updateGPUdependent(e1) {}
            getMeshFromTileID(e1, i, o, a, r) {
                if (this._cachedMesh) return this._cachedMesh;
                const s = new t.aU;
                s.emplaceBack(0, 0), s.emplaceBack(t.a6, 0), s.emplaceBack(0, t.a6), s.emplaceBack(t.a6, t.a6);
                const n = e1.createVertexBuffer(s, Ot.members), l = t.aV.simpleSegment(0, 0, 4, 2), c = new t.aW;
                c.emplaceBack(1, 0, 2), c.emplaceBack(1, 2, 3);
                const h = e1.createIndexBuffer(c);
                return this._cachedMesh = new Bt(n, h, l), this._cachedMesh;
            }
            recalculate() {}
            hasTransition() {
                return !1;
            }
            setErrorQueryLatitudeDegrees(e1) {}
        }
        class Ut {
            constructor(e1 = 0, t = 0, i = 0, o = 0){
                if (isNaN(e1) || e1 < 0 || isNaN(t) || t < 0 || isNaN(i) || i < 0 || isNaN(o) || o < 0) throw new Error("Invalid value for edge-insets, top, bottom, left and right must all be numbers");
                this.top = e1, this.bottom = t, this.left = i, this.right = o;
            }
            interpolate(e1, i, o) {
                return null != i.top && null != e1.top && (this.top = t.H.number(e1.top, i.top, o)), null != i.bottom && null != e1.bottom && (this.bottom = t.H.number(e1.bottom, i.bottom, o)), null != i.left && null != e1.left && (this.left = t.H.number(e1.left, i.left, o)), null != i.right && null != e1.right && (this.right = t.H.number(e1.right, i.right, o)), this;
            }
            getCenter(e1, i) {
                const o = t.al((this.left + e1 - this.right) / 2, 0, e1), a = t.al((this.top + i - this.bottom) / 2, 0, i);
                return new t.P(o, a);
            }
            equals(e1) {
                return this.top === e1.top && this.bottom === e1.bottom && this.left === e1.left && this.right === e1.right;
            }
            clone() {
                return new Ut(this.top, this.bottom, this.left, this.right);
            }
            toJSON() {
                return {
                    top: this.top,
                    bottom: this.bottom,
                    left: this.left,
                    right: this.right
                };
            }
        }
        function Gt(e1, t) {
            if (!e1.renderWorldCopies || e1.lngRange) return;
            const i = t.lng - e1.center.lng;
            t.lng += i > 180 ? -360 : i < -180 ? 360 : 0;
        }
        function Vt(e1) {
            return Math.max(0, Math.floor(e1));
        }
        class Wt {
            constructor(e1, i){
                var o;
                this.applyConstrain = (e1, t)=>null !== this._constrainOverride ? this._constrainOverride(e1, t) : this._callbacks.defaultConstrain(e1, t), this._callbacks = e1, this._tileSize = 512, this._renderWorldCopies = void 0 === (null == i ? void 0 : i.renderWorldCopies) || !!(null == i ? void 0 : i.renderWorldCopies), this._minZoom = (null == i ? void 0 : i.minZoom) || 0, this._maxZoom = (null == i ? void 0 : i.maxZoom) || 22, this._minPitch = null == (null == i ? void 0 : i.minPitch) ? 0 : null == i ? void 0 : i.minPitch, this._maxPitch = null == (null == i ? void 0 : i.maxPitch) ? 60 : null == i ? void 0 : i.maxPitch, this._constrainOverride = null !== (o = null == i ? void 0 : i.constrainOverride) && void 0 !== o ? o : null, this.setMaxBounds(), this._width = 0, this._height = 0, this._center = new t.W(0, 0), this._elevation = 0, this._zoom = 0, this._tileZoom = Vt(this._zoom), this._scale = t.ao(this._zoom), this._bearingInRadians = 0, this._fovInRadians = .6435011087932844, this._pitchInRadians = 0, this._rollInRadians = 0, this._unmodified = !0, this._edgeInsets = new Ut, this._minElevationForCurrentTile = 0, this._autoCalculateNearFarZ = !0;
            }
            apply(e1, i, o) {
                this._constrainOverride = e1.constrainOverride, this._latRange = e1.latRange, this._lngRange = e1.lngRange, this._width = e1.width, this._height = e1.height, this._center = e1.center, this._elevation = e1.elevation, this._minElevationForCurrentTile = e1.minElevationForCurrentTile, this._zoom = e1.zoom, this._tileZoom = Vt(this._zoom), this._scale = t.ao(this._zoom), this._bearingInRadians = e1.bearingInRadians, this._fovInRadians = e1.fovInRadians, this._pitchInRadians = e1.pitchInRadians, this._rollInRadians = e1.rollInRadians, this._unmodified = e1.unmodified, this._edgeInsets = new Ut(e1.padding.top, e1.padding.bottom, e1.padding.left, e1.padding.right), this._minZoom = e1.minZoom, this._maxZoom = e1.maxZoom, this._minPitch = e1.minPitch, this._maxPitch = e1.maxPitch, this._renderWorldCopies = e1.renderWorldCopies, this._cameraToCenterDistance = e1.cameraToCenterDistance, this._nearZ = e1.nearZ, this._farZ = e1.farZ, this._autoCalculateNearFarZ = !o && e1.autoCalculateNearFarZ, i && this.constrainInternal(), this._calcMatrices();
            }
            get pixelsToClipSpaceMatrix() {
                return this._pixelsToClipSpaceMatrix;
            }
            get clipSpaceToPixelsMatrix() {
                return this._clipSpaceToPixelsMatrix;
            }
            get minElevationForCurrentTile() {
                return this._minElevationForCurrentTile;
            }
            setMinElevationForCurrentTile(e1) {
                this._minElevationForCurrentTile = e1;
            }
            get tileSize() {
                return this._tileSize;
            }
            get tileZoom() {
                return this._tileZoom;
            }
            get scale() {
                return this._scale;
            }
            get width() {
                return this._width;
            }
            get height() {
                return this._height;
            }
            get bearingInRadians() {
                return this._bearingInRadians;
            }
            get lngRange() {
                return this._lngRange;
            }
            get latRange() {
                return this._latRange;
            }
            get pixelsToGLUnits() {
                return this._pixelsToGLUnits;
            }
            get minZoom() {
                return this._minZoom;
            }
            setMinZoom(e1) {
                this._minZoom !== e1 && (this._minZoom = e1, this.setZoom(this.applyConstrain(this._center, this.zoom).zoom));
            }
            get maxZoom() {
                return this._maxZoom;
            }
            setMaxZoom(e1) {
                this._maxZoom !== e1 && (this._maxZoom = e1, this.setZoom(this.applyConstrain(this._center, this.zoom).zoom));
            }
            get minPitch() {
                return this._minPitch;
            }
            setMinPitch(e1) {
                this._minPitch !== e1 && (this._minPitch = e1, this.setPitch(Math.max(this.pitch, e1)));
            }
            get maxPitch() {
                return this._maxPitch;
            }
            setMaxPitch(e1) {
                this._maxPitch !== e1 && (this._maxPitch = e1, this.setPitch(Math.min(this.pitch, e1)));
            }
            get renderWorldCopies() {
                return this._renderWorldCopies;
            }
            setRenderWorldCopies(e1) {
                void 0 === e1 ? e1 = !0 : null === e1 && (e1 = !1), this._renderWorldCopies = e1;
            }
            get constrainOverride() {
                return this._constrainOverride;
            }
            setConstrainOverride(e1) {
                void 0 === e1 && (e1 = null), this._constrainOverride !== e1 && (this._constrainOverride = e1, this.constrainInternal(), this._calcMatrices());
            }
            get worldSize() {
                return this._tileSize * this._scale;
            }
            get centerOffset() {
                return this.centerPoint._sub(this.size._div(2));
            }
            get size() {
                return new t.P(this._width, this._height);
            }
            get bearing() {
                return this._bearingInRadians / Math.PI * 180;
            }
            setBearing(e1) {
                const i = t.X(e1, -180, 180) * Math.PI / 180;
                var a, r, s, n, l, c, h, u, d;
                this._bearingInRadians !== i && (this._unmodified = !1, this._bearingInRadians = i, this._calcMatrices(), this._rotationMatrix = o(), a = this._rotationMatrix, s = -this._bearingInRadians, n = (r = this._rotationMatrix)[0], l = r[1], c = r[2], h = r[3], u = Math.sin(s), d = Math.cos(s), a[0] = n * d + c * u, a[1] = l * d + h * u, a[2] = n * -u + c * d, a[3] = l * -u + h * d);
            }
            get rotationMatrix() {
                return this._rotationMatrix;
            }
            get pitchInRadians() {
                return this._pitchInRadians;
            }
            get pitch() {
                return this._pitchInRadians / Math.PI * 180;
            }
            setPitch(e1) {
                const i = t.al(e1, this.minPitch, this.maxPitch) / 180 * Math.PI;
                this._pitchInRadians !== i && (this._unmodified = !1, this._pitchInRadians = i, this._calcMatrices());
            }
            get rollInRadians() {
                return this._rollInRadians;
            }
            get roll() {
                return this._rollInRadians / Math.PI * 180;
            }
            setRoll(e1) {
                const t = e1 / 180 * Math.PI;
                this._rollInRadians !== t && (this._unmodified = !1, this._rollInRadians = t, this._calcMatrices());
            }
            get fovInRadians() {
                return this._fovInRadians;
            }
            get fov() {
                return t.aX(this._fovInRadians);
            }
            setFov(e1) {
                e1 = t.al(e1, .1, 150), this.fov !== e1 && (this._unmodified = !1, this._fovInRadians = t.an(e1), this._calcMatrices());
            }
            get zoom() {
                return this._zoom;
            }
            setZoom(e1) {
                const i = this.applyConstrain(this._center, e1).zoom;
                this._zoom !== i && (this._unmodified = !1, this._zoom = i, this._tileZoom = Math.max(0, Math.floor(i)), this._scale = t.ao(i), this.constrainInternal(), this._calcMatrices());
            }
            get center() {
                return this._center;
            }
            setCenter(e1) {
                e1.lat === this._center.lat && e1.lng === this._center.lng || (this._unmodified = !1, this._center = e1, this.constrainInternal(), this._calcMatrices());
            }
            get elevation() {
                return this._elevation;
            }
            setElevation(e1) {
                e1 !== this._elevation && (this._elevation = e1, this.constrainInternal(), this._calcMatrices());
            }
            get padding() {
                return this._edgeInsets.toJSON();
            }
            setPadding(e1) {
                this._edgeInsets.equals(e1) || (this._unmodified = !1, this._edgeInsets.interpolate(this._edgeInsets, e1, 1), this._calcMatrices());
            }
            get centerPoint() {
                return this._edgeInsets.getCenter(this._width, this._height);
            }
            get pixelsPerMeter() {
                return this._pixelPerMeter;
            }
            get unmodified() {
                return this._unmodified;
            }
            get cameraToCenterDistance() {
                return this._cameraToCenterDistance;
            }
            get nearZ() {
                return this._nearZ;
            }
            get farZ() {
                return this._farZ;
            }
            get autoCalculateNearFarZ() {
                return this._autoCalculateNearFarZ;
            }
            overrideNearFarZ(e1, t) {
                this._autoCalculateNearFarZ = !1, this._nearZ = e1, this._farZ = t, this._calcMatrices();
            }
            clearNearFarZOverride() {
                this._autoCalculateNearFarZ = !0, this._calcMatrices();
            }
            isPaddingEqual(e1) {
                return this._edgeInsets.equals(e1);
            }
            interpolatePadding(e1, t, i) {
                this._unmodified = !1, this._edgeInsets.interpolate(e1, t, i), this.constrainInternal(), this._calcMatrices();
            }
            resize(e1, t, i = !0) {
                this._width = e1, this._height = t, i && this.constrainInternal(), this._calcMatrices();
            }
            getMaxBounds() {
                var e1, t;
                return 2 !== (null === (e1 = this._latRange) || void 0 === e1 ? void 0 : e1.length) || 2 !== (null === (t = this._lngRange) || void 0 === t ? void 0 : t.length) ? null : new G([
                    this._lngRange[0],
                    this._latRange[0]
                ], [
                    this._lngRange[1],
                    this._latRange[1]
                ]);
            }
            setMaxBounds(e1) {
                e1 ? (this._lngRange = [
                    e1.getWest(),
                    e1.getEast()
                ], this._latRange = [
                    e1.getSouth(),
                    e1.getNorth()
                ], this.constrainInternal()) : (this._lngRange = null, this._latRange = [
                    -t.am,
                    t.am
                ]);
            }
            getCameraQueryGeometry(e1, i) {
                if (1 === i.length) return [
                    i[0],
                    e1
                ];
                {
                    const { minX: o, minY: a, maxX: r, maxY: s } = t.a8.fromPoints(i).extend(e1);
                    return [
                        new t.P(o, a),
                        new t.P(r, a),
                        new t.P(r, s),
                        new t.P(o, s),
                        new t.P(o, a)
                    ];
                }
            }
            constrainInternal() {
                if (!this.center || !this._width || !this._height || this._constraining) return;
                this._constraining = !0;
                const e1 = this._unmodified, { center: t, zoom: i } = this.applyConstrain(this.center, this.zoom);
                this.setCenter(t), this.setZoom(i), this._unmodified = e1, this._constraining = !1;
            }
            _calcMatrices() {
                if (this._width && this._height) {
                    this._pixelsToGLUnits = [
                        2 / this._width,
                        -2 / this._height
                    ];
                    let e1 = t.ap(new Float64Array(16));
                    t.S(e1, e1, [
                        this._width / 2,
                        -this._height / 2,
                        1
                    ]), t.Q(e1, e1, [
                        1,
                        -1,
                        0
                    ]), this._clipSpaceToPixelsMatrix = e1, e1 = t.ap(new Float64Array(16)), t.S(e1, e1, [
                        1,
                        -1,
                        1
                    ]), t.Q(e1, e1, [
                        -1,
                        -1,
                        0
                    ]), t.S(e1, e1, [
                        2 / this._width,
                        2 / this._height,
                        1
                    ]), this._pixelsToClipSpaceMatrix = e1, this._cameraToCenterDistance = .5 / Math.tan(this.fovInRadians / 2) * this._height;
                }
                this._callbacks.calcMatrices();
            }
            calculateCenterFromCameraLngLatAlt(e1, i, o, a) {
                const r = void 0 !== o ? o : this.bearing, s = a = void 0 !== a ? a : this.pitch, { distanceToCenter: n, clampedElevation: l } = this._distanceToCenterFromAltElevationPitch(i, this.elevation, s), { x: c, y: h } = be(s, r), u = t.a7.fromLngLat(e1, i);
                let d, _, p = t.aY(1, u.y), m = 0;
                do {
                    if (m += 1, m > 10) break;
                    _ = n / p, d = new t.a7(u.x + c * _, u.y + h * _), p = 1 / d.meterInMercatorCoordinateUnits();
                }while (Math.abs(n - _ * p) > 1e-12);
                return {
                    center: d.toLngLat(),
                    elevation: l,
                    zoom: t.ar(this.height / 2 / Math.tan(this.fovInRadians / 2) / _ / this.tileSize)
                };
            }
            recalculateZoomAndCenter(e1) {
                if (this.elevation - e1 == 0) return;
                const i = 1 / this.worldSize, o = t.aq(1, this.center.lat) * this.worldSize, a = t.a7.fromLngLat(this.center, this.elevation), r = a.x / i, s = a.y / i, n = a.z / i, l = this.pitch, c = this.bearing, { x: h, y: u, z: d } = be(l, c), _ = this.cameraToCenterDistance, p = r + _ * -h, m = s + _ * -u, f = n + _ * d, { distanceToCenter: g, clampedElevation: v } = this._distanceToCenterFromAltElevationPitch(f / o, e1, l), x = g * o, b = new t.a7((p + h * x) * i, (m + u * x) * i, 0).toLngLat(), y = t.aq(1, b.lat), w = t.ar(this.height / 2 / Math.tan(this.fovInRadians / 2) / g / y / this.tileSize);
                this._elevation = v, this._center = b, this.setZoom(w);
            }
            _distanceToCenterFromAltElevationPitch(e1, i, o) {
                const a = -Math.cos(t.an(o)), r = e1 - i;
                let s, n = i;
                return a * r >= 0 || Math.abs(a) < .1 ? (s = 1e4, n = e1 + s * a) : s = -r / a, {
                    distanceToCenter: s,
                    clampedElevation: n
                };
            }
            getCameraPoint() {
                const e1 = Math.tan(this.pitchInRadians) * (this.cameraToCenterDistance || 1);
                return this.centerPoint.add(new t.P(e1 * Math.sin(this.rollInRadians), e1 * Math.cos(this.rollInRadians)));
            }
            getCameraAltitude() {
                return Math.cos(this.pitchInRadians) * this._cameraToCenterDistance / this._pixelPerMeter + this.elevation;
            }
            getCameraLngLat() {
                const e1 = t.aq(1, this.center.lat) * this.worldSize;
                return xe(this.center, this.elevation, this.pitch, this.bearing, this.cameraToCenterDistance / e1).toLngLat();
            }
            getMercatorTileCoordinates(e1) {
                if (!e1) return [
                    0,
                    0,
                    1,
                    1
                ];
                const i = e1.canonical.z >= 0 ? 1 << e1.canonical.z : Math.pow(2, e1.canonical.z);
                return [
                    e1.canonical.x / i,
                    e1.canonical.y / i,
                    1 / i / t.a6,
                    1 / i / t.a6
                ];
            }
        }
        class qt {
            constructor(e1, i){
                this.min = e1, this.max = i, this.center = t.aZ([], t.a_([], this.min, this.max), .5);
            }
            quadrant(e1) {
                const i = [
                    e1 % 2 == 0,
                    e1 < 2
                ], o = t.a$(this.min), a = t.a$(this.max);
                for(let e1 = 0; e1 < i.length; e1++)o[e1] = i[e1] ? this.min[e1] : this.center[e1], a[e1] = i[e1] ? this.center[e1] : this.max[e1];
                return a[2] = this.max[2], new qt(o, a);
            }
            distanceX(e1) {
                return Math.max(Math.min(this.max[0], e1[0]), this.min[0]) - e1[0];
            }
            distanceY(e1) {
                return Math.max(Math.min(this.max[1], e1[1]), this.min[1]) - e1[1];
            }
            intersectsFrustum(e1) {
                let t = !0;
                for (const i of e1.planes){
                    const e1 = this.intersectsPlane(i);
                    if (0 === e1) return 0;
                    1 === e1 && (t = !1);
                }
                return t ? 2 : e1.aabb.min[0] > this.max[0] || e1.aabb.min[1] > this.max[1] || e1.aabb.min[2] > this.max[2] || e1.aabb.max[0] < this.min[0] || e1.aabb.max[1] < this.min[1] || e1.aabb.max[2] < this.min[2] ? 0 : 1;
            }
            intersectsPlane(e1) {
                let t = e1[3], i = e1[3];
                for(let o = 0; o < 3; o++)e1[o] > 0 ? (t += e1[o] * this.min[o], i += e1[o] * this.max[o]) : (i += e1[o] * this.min[o], t += e1[o] * this.max[o]);
                return t >= 0 ? 2 : i < 0 ? 0 : 1;
            }
        }
        class $t {
            distanceToTile2d(e1, t, i, o) {
                const a = o, r = a.distanceX([
                    e1,
                    t
                ]), s = a.distanceY([
                    e1,
                    t
                ]);
                return Math.hypot(r, s);
            }
            getWrap(e1, t, i) {
                return i;
            }
            getTileBoundingVolume(e1, i, o, a) {
                var r, s;
                let n = 0, l = 0;
                if (null == a ? void 0 : a.terrain) {
                    const c = new t.a3(e1.z, i, e1.z, e1.x, e1.y), h = a.terrain.getMinMaxElevation(c);
                    n = null !== (r = h.minElevation) && void 0 !== r ? r : Math.min(0, o), l = null !== (s = h.maxElevation) && void 0 !== s ? s : Math.max(0, o);
                }
                const c = 1 << e1.z;
                return new qt([
                    i + e1.x / c,
                    e1.y / c,
                    n
                ], [
                    i + (e1.x + 1) / c,
                    (e1.y + 1) / c,
                    l
                ]);
            }
            allowVariableZoom(e1, i) {
                const o = e1.fov * (Math.abs(Math.cos(e1.rollInRadians)) * e1.height + Math.abs(Math.sin(e1.rollInRadians)) * e1.width) / e1.height, a = t.al(78.5 - o / 2, 0, 60);
                return !!i.terrain || e1.pitch > a;
            }
            allowWorldCopies() {
                return !0;
            }
            prepareNextFrame() {}
        }
        class Ht {
            constructor(e1, t, i){
                this.points = e1, this.planes = t, this.aabb = i;
            }
            static fromInvProjectionMatrix(e1, i = 1, o = 0, a, r) {
                const s = r ? [
                    [
                        6,
                        5,
                        4
                    ],
                    [
                        0,
                        1,
                        2
                    ],
                    [
                        0,
                        3,
                        7
                    ],
                    [
                        2,
                        1,
                        5
                    ],
                    [
                        3,
                        2,
                        6
                    ],
                    [
                        0,
                        4,
                        5
                    ]
                ] : [
                    [
                        0,
                        1,
                        2
                    ],
                    [
                        6,
                        5,
                        4
                    ],
                    [
                        0,
                        3,
                        7
                    ],
                    [
                        2,
                        1,
                        5
                    ],
                    [
                        3,
                        2,
                        6
                    ],
                    [
                        0,
                        4,
                        5
                    ]
                ], n = Math.pow(2, o), l = [
                    [
                        -1,
                        1,
                        -1,
                        1
                    ],
                    [
                        1,
                        1,
                        -1,
                        1
                    ],
                    [
                        1,
                        -1,
                        -1,
                        1
                    ],
                    [
                        -1,
                        -1,
                        -1,
                        1
                    ],
                    [
                        -1,
                        1,
                        1,
                        1
                    ],
                    [
                        1,
                        1,
                        1,
                        1
                    ],
                    [
                        1,
                        -1,
                        1,
                        1
                    ],
                    [
                        -1,
                        -1,
                        1,
                        1
                    ]
                ].map((o)=>(function(e1, i, o, a) {
                        const r = t.aE([], e1, i), s = 1 / r[3] / o * a;
                        return t.b4(r, r, [
                            s,
                            s,
                            1 / r[3],
                            s
                        ]);
                    })(o, e1, i, n));
                a && function(e1, i, o, a) {
                    const r = a ? 4 : 0, s = a ? 0 : 4;
                    let n = 0;
                    const l = [], c = [];
                    for(let i = 0; i < 4; i++){
                        const o = t.b0([], e1[i + s], e1[i + r]), a = t.b5(o);
                        t.aZ(o, o, 1 / a), l.push(a), c.push(o);
                    }
                    for(let i = 0; i < 4; i++){
                        const a = t.b6(e1[i + r], c[i], o);
                        n = null !== a && a >= 0 ? Math.max(n, a) : Math.max(n, l[i]);
                    }
                    const h = function(e1, i) {
                        const o = t.b0([], e1[i[0]], e1[i[1]]), a = t.b0([], e1[i[2]], e1[i[1]]), r = [
                            0,
                            0,
                            0,
                            0
                        ];
                        return t.b1(r, t.b2([], o, a)), r[3] = -t.b3(r, e1[i[0]]), r;
                    }(e1, i), u = function(e1, i) {
                        const o = t.b7(e1), a = t.b8([], e1, 1 / o), r = t.b0([], i, t.aZ([], a, t.b3(i, a))), s = t.b7(r);
                        if (s > 0) {
                            const e1 = Math.sqrt(1 - a[3] * a[3]), o = t.aZ([], a, -a[3]), n = t.a_([], o, t.aZ([], r, e1 / s));
                            return t.b9(i, n);
                        }
                        return null;
                    }(o, h);
                    if (null !== u) {
                        const e1 = u / t.b3(c[0], h);
                        n = Math.min(n, e1);
                    }
                    for(let t = 0; t < 4; t++){
                        const i = Math.min(n, l[t]);
                        e1[t + s] = [
                            e1[t + r][0] + c[t][0] * i,
                            e1[t + r][1] + c[t][1] * i,
                            e1[t + r][2] + c[t][2] * i,
                            1
                        ];
                    }
                }(l, s[0], a, r);
                const c = s.map((e1)=>{
                    const i = t.b0([], l[e1[0]], l[e1[1]]), o = t.b0([], l[e1[2]], l[e1[1]]), a = t.b1([], t.b2([], i, o)), r = -t.b3(a, l[e1[1]]);
                    return a.concat(r);
                }), h = [
                    Number.POSITIVE_INFINITY,
                    Number.POSITIVE_INFINITY,
                    Number.POSITIVE_INFINITY
                ], u = [
                    Number.NEGATIVE_INFINITY,
                    Number.NEGATIVE_INFINITY,
                    Number.NEGATIVE_INFINITY
                ];
                for (const e1 of l)for(let t = 0; t < 3; t++)h[t] = Math.min(h[t], e1[t]), u[t] = Math.max(u[t], e1[t]);
                return new Ht(l, c, new qt(h, u));
            }
        }
        class Xt {
            get pixelsToClipSpaceMatrix() {
                return this._helper.pixelsToClipSpaceMatrix;
            }
            get clipSpaceToPixelsMatrix() {
                return this._helper.clipSpaceToPixelsMatrix;
            }
            get pixelsToGLUnits() {
                return this._helper.pixelsToGLUnits;
            }
            get centerOffset() {
                return this._helper.centerOffset;
            }
            get size() {
                return this._helper.size;
            }
            get rotationMatrix() {
                return this._helper.rotationMatrix;
            }
            get centerPoint() {
                return this._helper.centerPoint;
            }
            get pixelsPerMeter() {
                return this._helper.pixelsPerMeter;
            }
            setMinZoom(e1) {
                this._helper.setMinZoom(e1);
            }
            setMaxZoom(e1) {
                this._helper.setMaxZoom(e1);
            }
            setMinPitch(e1) {
                this._helper.setMinPitch(e1);
            }
            setMaxPitch(e1) {
                this._helper.setMaxPitch(e1);
            }
            setRenderWorldCopies(e1) {
                this._helper.setRenderWorldCopies(e1);
            }
            setBearing(e1) {
                this._helper.setBearing(e1);
            }
            setPitch(e1) {
                this._helper.setPitch(e1);
            }
            setRoll(e1) {
                this._helper.setRoll(e1);
            }
            setFov(e1) {
                this._helper.setFov(e1);
            }
            setZoom(e1) {
                this._helper.setZoom(e1);
            }
            setCenter(e1) {
                this._helper.setCenter(e1);
            }
            setElevation(e1) {
                this._helper.setElevation(e1);
            }
            setMinElevationForCurrentTile(e1) {
                this._helper.setMinElevationForCurrentTile(e1);
            }
            setPadding(e1) {
                this._helper.setPadding(e1);
            }
            interpolatePadding(e1, t, i) {
                this._helper.interpolatePadding(e1, t, i);
            }
            isPaddingEqual(e1) {
                return this._helper.isPaddingEqual(e1);
            }
            resize(e1, t, i = !0) {
                this._helper.resize(e1, t, i);
            }
            getMaxBounds() {
                return this._helper.getMaxBounds();
            }
            setMaxBounds(e1) {
                this._helper.setMaxBounds(e1);
            }
            setConstrainOverride(e1) {
                this._helper.setConstrainOverride(e1);
            }
            overrideNearFarZ(e1, t) {
                this._helper.overrideNearFarZ(e1, t);
            }
            clearNearFarZOverride() {
                this._helper.clearNearFarZOverride();
            }
            getCameraQueryGeometry(e1) {
                return this._helper.getCameraQueryGeometry(this.getCameraPoint(), e1);
            }
            get tileSize() {
                return this._helper.tileSize;
            }
            get tileZoom() {
                return this._helper.tileZoom;
            }
            get scale() {
                return this._helper.scale;
            }
            get worldSize() {
                return this._helper.worldSize;
            }
            get width() {
                return this._helper.width;
            }
            get height() {
                return this._helper.height;
            }
            get lngRange() {
                return this._helper.lngRange;
            }
            get latRange() {
                return this._helper.latRange;
            }
            get minZoom() {
                return this._helper.minZoom;
            }
            get maxZoom() {
                return this._helper.maxZoom;
            }
            get zoom() {
                return this._helper.zoom;
            }
            get center() {
                return this._helper.center;
            }
            get minPitch() {
                return this._helper.minPitch;
            }
            get maxPitch() {
                return this._helper.maxPitch;
            }
            get pitch() {
                return this._helper.pitch;
            }
            get pitchInRadians() {
                return this._helper.pitchInRadians;
            }
            get roll() {
                return this._helper.roll;
            }
            get rollInRadians() {
                return this._helper.rollInRadians;
            }
            get bearing() {
                return this._helper.bearing;
            }
            get bearingInRadians() {
                return this._helper.bearingInRadians;
            }
            get fov() {
                return this._helper.fov;
            }
            get fovInRadians() {
                return this._helper.fovInRadians;
            }
            get elevation() {
                return this._helper.elevation;
            }
            get minElevationForCurrentTile() {
                return this._helper.minElevationForCurrentTile;
            }
            get padding() {
                return this._helper.padding;
            }
            get unmodified() {
                return this._helper.unmodified;
            }
            get renderWorldCopies() {
                return this._helper.renderWorldCopies;
            }
            get cameraToCenterDistance() {
                return this._helper.cameraToCenterDistance;
            }
            get constrainOverride() {
                return this._helper.constrainOverride;
            }
            get nearZ() {
                return this._helper.nearZ;
            }
            get farZ() {
                return this._helper.farZ;
            }
            get autoCalculateNearFarZ() {
                return this._helper.autoCalculateNearFarZ;
            }
            setTransitionState(e1, t) {}
            constructor(e1){
                this._posMatrixCache = new Map, this._alignedPosMatrixCache = new Map, this._fogMatrixCacheF32 = new Map, this.defaultConstrain = (e1, i)=>{
                    i = t.al(+i, this.minZoom, this.maxZoom);
                    const o = {
                        center: new t.W(e1.lng, e1.lat),
                        zoom: i
                    };
                    let a = this._helper._lngRange;
                    if (!this._helper._renderWorldCopies && null === a) {
                        const e1 = 180 - 1e-10;
                        a = [
                            -e1,
                            e1
                        ];
                    }
                    const r = this.tileSize * t.ao(o.zoom);
                    let s = 0, n = r, l = 0, c = r, h = 0, u = 0;
                    const { x: d, y: _ } = this.size;
                    if (this._helper._latRange) {
                        const e1 = this._helper._latRange;
                        s = t.Y(e1[1]) * r, n = t.Y(e1[0]) * r, n - s < _ && (h = _ / (n - s));
                    }
                    a && (l = t.X(t.Z(a[0]) * r, 0, r), c = t.X(t.Z(a[1]) * r, 0, r), c < l && (c += r), c - l < d && (u = d / (c - l)));
                    const { x: p, y: m } = me(r, e1);
                    let f, g;
                    const v = Math.max(u || 0, h || 0);
                    if (v) {
                        const e1 = new t.P(u ? (c + l) / 2 : p, h ? (n + s) / 2 : m);
                        return o.center = fe(r, e1).wrap(), o.zoom += t.ar(v), o;
                    }
                    if (this._helper._latRange) {
                        const e1 = _ / 2;
                        m - e1 < s && (g = s + e1), m + e1 > n && (g = n - e1);
                    }
                    if (a) {
                        const e1 = (l + c) / 2;
                        let i = p;
                        this._helper._renderWorldCopies && (i = t.X(p, e1 - r / 2, e1 + r / 2));
                        const o = d / 2;
                        i - o < l && (f = l + o), i + o > c && (f = c - o);
                    }
                    if (void 0 !== f || void 0 !== g) {
                        const e1 = new t.P(null != f ? f : p, null != g ? g : m);
                        o.center = fe(r, e1).wrap();
                    }
                    return o;
                }, this.applyConstrain = (e1, t)=>this._helper.applyConstrain(e1, t), this._helper = new Wt({
                    calcMatrices: ()=>this._calcMatrices(),
                    defaultConstrain: (e1, t)=>this.defaultConstrain(e1, t)
                }, e1), this._coveringTilesDetailsProvider = new $t;
            }
            clone() {
                const e1 = new Xt;
                return e1.apply(this, !1), e1;
            }
            apply(e1, t, i) {
                this._helper.apply(e1, t, i);
            }
            get cameraPosition() {
                return this._cameraPosition;
            }
            get projectionMatrix() {
                return this._projectionMatrix;
            }
            get modelViewProjectionMatrix() {
                return this._viewProjMatrix;
            }
            get inverseProjectionMatrix() {
                return this._invProjMatrix;
            }
            get mercatorMatrix() {
                return this._mercatorMatrix;
            }
            getVisibleUnwrappedCoordinates(e1) {
                const i = [
                    new t.ba(0, e1)
                ];
                if (this._helper._renderWorldCopies) {
                    const o = this.screenPointToMercatorCoordinate(new t.P(0, 0)), a = this.screenPointToMercatorCoordinate(new t.P(this._helper._width, 0)), r = this.screenPointToMercatorCoordinate(new t.P(this._helper._width, this._helper._height)), s = this.screenPointToMercatorCoordinate(new t.P(0, this._helper._height)), n = Math.floor(Math.min(o.x, a.x, r.x, s.x)), l = Math.floor(Math.max(o.x, a.x, r.x, s.x)), c = 1;
                    for(let o = n - c; o <= l + c; o++)0 !== o && i.push(new t.ba(o, e1));
                }
                return i;
            }
            getCameraFrustum() {
                return Ht.fromInvProjectionMatrix(this._invViewProjMatrix, this.worldSize);
            }
            getClippingPlane() {
                return null;
            }
            getCoveringTilesDetailsProvider() {
                return this._coveringTilesDetailsProvider;
            }
            recalculateZoomAndCenter(e1) {
                const t = this.screenPointToLocation(this.centerPoint, e1), i = e1 ? e1.getElevationForLngLatZoom(t, this._helper._tileZoom) : 0;
                this._helper.recalculateZoomAndCenter(i);
            }
            setLocationAtPoint(e1, i) {
                const o = t.aq(this.elevation, this.center.lat), a = this.screenPointToMercatorCoordinateAtZ(i, o), r = this.screenPointToMercatorCoordinateAtZ(this.centerPoint, o), s = t.a7.fromLngLat(e1), n = new t.a7(s.x - (a.x - r.x), s.y - (a.y - r.y));
                this.setCenter(null == n ? void 0 : n.toLngLat()), this._helper._renderWorldCopies && this.setCenter(this.center.wrap());
            }
            locationToScreenPoint(e1, i) {
                return i ? this.coordinatePoint(t.a7.fromLngLat(e1), i.getElevationForLngLat(e1, this), this._pixelMatrix3D) : this.coordinatePoint(t.a7.fromLngLat(e1));
            }
            screenPointToLocation(e1, t) {
                var i;
                return null === (i = this.screenPointToMercatorCoordinate(e1, t)) || void 0 === i ? void 0 : i.toLngLat();
            }
            screenPointToMercatorCoordinate(e1, t) {
                if (t) {
                    const i = t.pointCoordinate(e1);
                    if (null != i) return i;
                }
                return this.screenPointToMercatorCoordinateAtZ(e1);
            }
            screenPointToMercatorCoordinateAtZ(e1, i) {
                const o = i || 0, a = [
                    e1.x,
                    e1.y,
                    0,
                    1
                ], r = [
                    e1.x,
                    e1.y,
                    1,
                    1
                ];
                t.aE(a, a, this._pixelMatrixInverse), t.aE(r, r, this._pixelMatrixInverse);
                const s = a[3], n = r[3], l = a[1] / s, c = r[1] / n, h = a[2] / s, u = r[2] / n, d = h === u ? 0 : (o - h) / (u - h);
                return new t.a7(t.H.number(a[0] / s, r[0] / n, d) / this.worldSize, t.H.number(l, c, d) / this.worldSize, o);
            }
            coordinatePoint(e1, i = 0, o = this._pixelMatrix) {
                const a = [
                    e1.x * this.worldSize,
                    e1.y * this.worldSize,
                    i,
                    1
                ];
                return t.aE(a, a, o), new t.P(a[0] / a[3], a[1] / a[3]);
            }
            getBounds() {
                const e1 = Math.max(0, this._helper._height / 2 - ge(this));
                return (new G).extend(this.screenPointToLocation(new t.P(0, e1))).extend(this.screenPointToLocation(new t.P(this._helper._width, e1))).extend(this.screenPointToLocation(new t.P(this._helper._width, this._helper._height))).extend(this.screenPointToLocation(new t.P(0, this._helper._height)));
            }
            isPointOnMapSurface(e1, t) {
                return t ? null != t.pointCoordinate(e1) : e1.y > this.height / 2 - ge(this);
            }
            calculatePosMatrix(e1, i = !1, o) {
                var a;
                const r = null !== (a = e1.key) && void 0 !== a ? a : t.bb(e1.wrap, e1.canonical.z, e1.canonical.z, e1.canonical.x, e1.canonical.y), s = i ? this._alignedPosMatrixCache : this._posMatrixCache;
                if (s.has(r)) {
                    const e1 = s.get(r);
                    return o ? e1.f32 : e1.f64;
                }
                const n = ve(e1, this.worldSize);
                t.U(n, i ? this._alignedProjMatrix : this._viewProjMatrix, n);
                const l = {
                    f64: n,
                    f32: new Float32Array(n)
                };
                return s.set(r, l), o ? l.f32 : l.f64;
            }
            calculateFogMatrix(e1) {
                const i = e1.key, o = this._fogMatrixCacheF32;
                if (o.has(i)) return o.get(i);
                const a = ve(e1, this.worldSize);
                return t.U(a, this._fogMatrix, a), o.set(i, new Float32Array(a)), o.get(i);
            }
            calculateCenterFromCameraLngLatAlt(e1, t, i, o) {
                return this._helper.calculateCenterFromCameraLngLatAlt(e1, t, i, o);
            }
            _calculateNearFarZIfNeeded(e1, i, o) {
                if (!this._helper.autoCalculateNearFarZ) return;
                const a = Math.min(this.elevation, this.minElevationForCurrentTile, this.getCameraAltitude() - 100), r = e1 - a * this._helper._pixelPerMeter / Math.cos(i), s = a < 0 ? r : e1, n = Math.PI / 2 + this.pitchInRadians, l = t.an(this.fov) * (Math.abs(Math.cos(t.an(this.roll))) * this.height + Math.abs(Math.sin(t.an(this.roll))) * this.width) / this.height * (.5 + o.y / this.height), c = Math.sin(l) * s / Math.sin(t.al(Math.PI - n - l, .01, Math.PI - .01)), h = ge(this), u = Math.atan(h / this._helper.cameraToCenterDistance), d = t.an(.75), _ = u > d ? 2 * u * (.5 + o.y / (2 * h)) : d, p = Math.sin(_) * s / Math.sin(t.al(Math.PI - n - _, .01, Math.PI - .01)), m = Math.min(c, p);
                this._helper._farZ = 1.01 * (Math.cos(Math.PI / 2 - i) * m + s), this._helper._nearZ = this._helper._height / 50;
            }
            _calcMatrices() {
                if (!this._helper._height) return;
                const e1 = this.centerOffset, i = me(this.worldSize, this.center), o = i.x, a = i.y;
                this._helper._pixelPerMeter = t.aq(1, this.center.lat) * this.worldSize;
                const r = t.an(Math.min(this.pitch, pe)), s = Math.max(this._helper.cameraToCenterDistance / 2, this._helper.cameraToCenterDistance + this._helper._elevation * this._helper._pixelPerMeter / Math.cos(r));
                let n;
                var l, c;
                this._calculateNearFarZIfNeeded(s, r, e1), n = new Float64Array(16), t.bc(n, this.fovInRadians, this._helper._width / this._helper._height, this._helper._nearZ, this._helper._farZ), this._invProjMatrix = new Float64Array(16), (l = this._invProjMatrix)[0] = 1 / (c = n)[0], l[1] = 0, l[2] = 0, l[3] = 0, l[4] = 0, l[5] = 1 / c[5], l[6] = 0, l[7] = 0, l[8] = 0, l[9] = 0, l[10] = 0, l[11] = 1 / c[14], l[12] = 0, l[13] = 0, l[14] = -1, l[15] = c[10] / c[14], n[8] = 2 * -e1.x / this._helper._width, n[9] = 2 * e1.y / this._helper._height, this._projectionMatrix = t.bd(n), t.S(n, n, [
                    1,
                    -1,
                    1
                ]), t.Q(n, n, [
                    0,
                    0,
                    -this._helper.cameraToCenterDistance
                ]), t.be(n, n, -this.rollInRadians), t.bf(n, n, this.pitchInRadians), t.be(n, n, -this.bearingInRadians), t.Q(n, n, [
                    -o,
                    -a,
                    0
                ]), this._mercatorMatrix = t.S([], n, [
                    this.worldSize,
                    this.worldSize,
                    this.worldSize
                ]), t.S(n, n, [
                    1,
                    1,
                    this._helper._pixelPerMeter
                ]), this._pixelMatrix = t.U(new Float64Array(16), this.clipSpaceToPixelsMatrix, n), t.Q(n, n, [
                    0,
                    0,
                    -this.elevation
                ]), this._viewProjMatrix = n, this._invViewProjMatrix = t.bg([], n);
                const h = [
                    0,
                    0,
                    -1,
                    1
                ];
                t.aE(h, h, this._invViewProjMatrix), this._cameraPosition = [
                    h[0] / h[3],
                    h[1] / h[3],
                    h[2] / h[3]
                ], this._fogMatrix = new Float64Array(16), t.bc(this._fogMatrix, this.fovInRadians, this.width / this.height, s, this._helper._farZ), this._fogMatrix[8] = 2 * -e1.x / this.width, this._fogMatrix[9] = 2 * e1.y / this.height, t.S(this._fogMatrix, this._fogMatrix, [
                    1,
                    -1,
                    1
                ]), t.Q(this._fogMatrix, this._fogMatrix, [
                    0,
                    0,
                    -this.cameraToCenterDistance
                ]), t.be(this._fogMatrix, this._fogMatrix, -this.rollInRadians), t.bf(this._fogMatrix, this._fogMatrix, this.pitchInRadians), t.be(this._fogMatrix, this._fogMatrix, -this.bearingInRadians), t.Q(this._fogMatrix, this._fogMatrix, [
                    -o,
                    -a,
                    0
                ]), t.S(this._fogMatrix, this._fogMatrix, [
                    1,
                    1,
                    this._helper._pixelPerMeter
                ]), t.Q(this._fogMatrix, this._fogMatrix, [
                    0,
                    0,
                    -this.elevation
                ]), this._pixelMatrix3D = t.U(new Float64Array(16), this.clipSpaceToPixelsMatrix, n);
                const u = this._helper._width % 2 / 2, d = this._helper._height % 2 / 2, _ = Math.cos(this.bearingInRadians), p = Math.sin(-this.bearingInRadians), m = o - Math.round(o) + _ * u + p * d, f = a - Math.round(a) + _ * d + p * u, g = new Float64Array(n);
                if (t.Q(g, g, [
                    m > .5 ? m - 1 : m,
                    f > .5 ? f - 1 : f,
                    0
                ]), this._alignedProjMatrix = g, n = t.bg(new Float64Array(16), this._pixelMatrix), !n) throw new Error("failed to invert matrix");
                this._pixelMatrixInverse = n, this._clearMatrixCaches();
            }
            _clearMatrixCaches() {
                this._posMatrixCache.clear(), this._alignedPosMatrixCache.clear(), this._fogMatrixCacheF32.clear();
            }
            maxPitchScaleFactor() {
                if (!this._pixelMatrixInverse) return 1;
                const e1 = this.screenPointToMercatorCoordinate(new t.P(0, 0)), i = [
                    e1.x * this.worldSize,
                    e1.y * this.worldSize,
                    0,
                    1
                ];
                return t.aE(i, i, this._pixelMatrix)[3] / this._helper.cameraToCenterDistance;
            }
            getCameraPoint() {
                return this._helper.getCameraPoint();
            }
            getCameraAltitude() {
                return this._helper.getCameraAltitude();
            }
            getCameraLngLat() {
                const e1 = t.aq(1, this.center.lat) * this.worldSize;
                return xe(this.center, this.elevation, this.pitch, this.bearing, this._helper.cameraToCenterDistance / e1).toLngLat();
            }
            lngLatToCameraDepth(e1, i) {
                const o = t.a7.fromLngLat(e1), a = [
                    o.x * this.worldSize,
                    o.y * this.worldSize,
                    i,
                    1
                ];
                return t.aE(a, a, this._viewProjMatrix), a[2] / a[3];
            }
            getProjectionData(e1) {
                const { overscaledTileID: i, aligned: o, applyTerrainMatrix: a } = e1, r = this._helper.getMercatorTileCoordinates(i), s = i ? this.calculatePosMatrix(i, o, !0) : null;
                let n;
                return n = (null == i ? void 0 : i.terrainRttPosMatrix32f) && a ? i.terrainRttPosMatrix32f : s || t.bh(), {
                    mainMatrix: n,
                    tileMercatorCoords: r,
                    clippingPlane: [
                        0,
                        0,
                        0,
                        0
                    ],
                    projectionTransition: 0,
                    fallbackMatrix: n
                };
            }
            isLocationOccluded(e1) {
                return !1;
            }
            getPixelScale() {
                return 1;
            }
            getCircleRadiusCorrection() {
                return 1;
            }
            getPitchedTextCorrection(e1, t, i) {
                return 1;
            }
            transformLightDirection(e1) {
                return t.a$(e1);
            }
            getRayDirectionFromPixel(e1) {
                throw new Error("Not implemented.");
            }
            projectTileCoordinates(e1, i, o, a) {
                const r = this.calculatePosMatrix(o);
                let s;
                a ? (s = [
                    e1,
                    i,
                    a(e1, i),
                    1
                ], t.aE(s, s, r)) : (s = [
                    e1,
                    i,
                    0,
                    1
                ], nt(s, s, r));
                const n = s[3];
                return {
                    point: new t.P(s[0] / n, s[1] / n),
                    signedDistanceFromCamera: n,
                    isOccluded: !1
                };
            }
            populateCache(e1) {
                for (const t of e1)this.calculatePosMatrix(t);
            }
            getMatrixForModel(e1, i) {
                const o = t.a7.fromLngLat(e1, i), a = o.meterInMercatorCoordinateUnits(), r = t.bi();
                return t.Q(r, r, [
                    o.x,
                    o.y,
                    o.z
                ]), t.be(r, r, Math.PI), t.bf(r, r, Math.PI / 2), t.S(r, r, [
                    -a,
                    a,
                    a
                ]), r;
            }
            getProjectionDataForCustomLayer(e1 = !0) {
                const i = new t.a3(0, 0, 0, 0, 0), o = this.getProjectionData({
                    overscaledTileID: i,
                    applyGlobeMatrix: e1
                }), a = ve(i, this.worldSize);
                t.U(a, this._viewProjMatrix, a), o.tileMercatorCoords = [
                    0,
                    0,
                    1,
                    1
                ];
                const r = [
                    t.a6,
                    t.a6,
                    this.worldSize / this._helper.pixelsPerMeter
                ], s = t.bj();
                return t.S(s, a, r), o.fallbackMatrix = s, o.mainMatrix = s, o;
            }
            getFastPathSimpleProjectionMatrix(e1) {
                return this.calculatePosMatrix(e1);
            }
        }
        function Kt() {
            t.w("Map cannot fit within canvas with the given bounds, padding, and/or offset.");
        }
        function Yt(e1) {
            if (e1.useSlerp) {
                if (e1.k < 1) {
                    const i = t.bk(e1.startEulerAngles.roll, e1.startEulerAngles.pitch, e1.startEulerAngles.bearing), o = t.bk(e1.endEulerAngles.roll, e1.endEulerAngles.pitch, e1.endEulerAngles.bearing), a = new Float64Array(4);
                    t.bl(a, i, o, e1.k);
                    const r = t.bm(a);
                    e1.tr.setRoll(r.roll), e1.tr.setPitch(r.pitch), e1.tr.setBearing(r.bearing);
                } else e1.tr.setRoll(e1.endEulerAngles.roll), e1.tr.setPitch(e1.endEulerAngles.pitch), e1.tr.setBearing(e1.endEulerAngles.bearing);
            } else e1.tr.setRoll(t.H.number(e1.startEulerAngles.roll, e1.endEulerAngles.roll, e1.k)), e1.tr.setPitch(t.H.number(e1.startEulerAngles.pitch, e1.endEulerAngles.pitch, e1.k)), e1.tr.setBearing(t.H.number(e1.startEulerAngles.bearing, e1.endEulerAngles.bearing, e1.k));
        }
        function Qt(e1, i, o, a, r) {
            const s = r.padding, n = me(r.worldSize, o.getNorthWest()), l = me(r.worldSize, o.getNorthEast()), c = me(r.worldSize, o.getSouthEast()), h = me(r.worldSize, o.getSouthWest()), u = t.an(-a), d = n.rotate(u), _ = l.rotate(u), p = c.rotate(u), m = h.rotate(u), f = new t.P(Math.max(d.x, _.x, m.x, p.x), Math.max(d.y, _.y, m.y, p.y)), g = new t.P(Math.min(d.x, _.x, m.x, p.x), Math.min(d.y, _.y, m.y, p.y)), v = f.sub(g), x = (r.width - (s.left + s.right + i.left + i.right)) / v.x, b = (r.height - (s.top + s.bottom + i.top + i.bottom)) / v.y;
            if (b < 0 || x < 0) return void Kt();
            const y = Math.min(t.ar(r.scale * Math.min(x, b)), e1.maxZoom), w = t.P.convert(e1.offset), T = new t.P((i.left - i.right) / 2, (i.top - i.bottom) / 2).rotate(t.an(a)), P = w.add(T).mult(r.scale / t.ao(y));
            return {
                center: fe(r.worldSize, n.add(c).div(2).sub(P)),
                zoom: y,
                bearing: a
            };
        }
        class Jt {
            get useGlobeControls() {
                return !1;
            }
            handlePanInertia(e1, t) {
                const i = e1.mag(), o = Math.abs(ge(t));
                return {
                    easingOffset: e1.mult(Math.min(.75 * o / i, 1)),
                    easingCenter: t.center
                };
            }
            handleMapControlsRollPitchBearingZoom(e1, t) {
                e1.bearingDelta && t.setBearing(t.bearing + e1.bearingDelta), e1.pitchDelta && t.setPitch(t.pitch + e1.pitchDelta), e1.rollDelta && t.setRoll(t.roll + e1.rollDelta), e1.zoomDelta && t.setZoom(t.zoom + e1.zoomDelta);
            }
            handleMapControlsPan(e1, t, i) {
                e1.around.distSqr(t.centerPoint) < .01 || t.setLocationAtPoint(i, e1.around);
            }
            cameraForBoxAndBearing(e1, t, i, o, a) {
                return Qt(e1, t, i, o, a);
            }
            handleJumpToCenterZoom(e1, i) {
                e1.zoom !== (void 0 !== i.zoom ? +i.zoom : e1.zoom) && e1.setZoom(+i.zoom), void 0 !== i.center && e1.setCenter(t.W.convert(i.center));
            }
            handleEaseTo(e1, i) {
                const o = e1.zoom, a = e1.padding, r = {
                    roll: e1.roll,
                    pitch: e1.pitch,
                    bearing: e1.bearing
                }, s = {
                    roll: void 0 === i.roll ? e1.roll : i.roll,
                    pitch: void 0 === i.pitch ? e1.pitch : i.pitch,
                    bearing: void 0 === i.bearing ? e1.bearing : i.bearing
                }, n = void 0 !== i.zoom, l = !e1.isPaddingEqual(i.padding);
                let c = !1;
                const h = n ? +i.zoom : e1.zoom;
                let u = e1.centerPoint.add(i.offsetAsPoint);
                const d = e1.screenPointToLocation(u), { center: _, zoom: p } = e1.applyConstrain(t.W.convert(i.center || d), null != h ? h : o);
                Gt(e1, _);
                const m = me(e1.worldSize, d), f = me(e1.worldSize, _).sub(m), g = t.ao(p - o);
                return c = p !== o, {
                    easeFunc: (n)=>{
                        if (c && e1.setZoom(t.H.number(o, p, n)), t.bn(r, s) || Yt({
                            startEulerAngles: r,
                            endEulerAngles: s,
                            tr: e1,
                            k: n,
                            useSlerp: r.roll != s.roll
                        }), l && (e1.interpolatePadding(a, i.padding, n), u = e1.centerPoint.add(i.offsetAsPoint)), i.around) e1.setLocationAtPoint(i.around, i.aroundPoint);
                        else {
                            const i = t.ao(e1.zoom - o), a = p > o ? Math.min(2, g) : Math.max(.5, g), r = Math.pow(a, 1 - n), s = fe(e1.worldSize, m.add(f.mult(n * r)).mult(i));
                            e1.setLocationAtPoint(e1.renderWorldCopies ? s.wrap() : s, u);
                        }
                    },
                    isZooming: c,
                    elevationCenter: _
                };
            }
            handleFlyTo(e1, i) {
                const o = void 0 !== i.zoom, a = e1.zoom, r = e1.applyConstrain(t.W.convert(i.center || i.locationAtOffset), o ? +i.zoom : a), s = r.center, n = r.zoom;
                Gt(e1, s);
                const l = me(e1.worldSize, i.locationAtOffset), c = me(e1.worldSize, s).sub(l), h = c.mag(), u = t.ao(n - a);
                let d;
                if (void 0 !== i.minZoom) {
                    const o = Math.min(+i.minZoom, a, n), r = e1.applyConstrain(s, o).zoom;
                    d = t.ao(r - a);
                }
                return {
                    easeFunc: (i, o, r, h)=>{
                        e1.setZoom(1 === i ? n : a + t.ar(o));
                        const u = 1 === i ? s : fe(e1.worldSize, l.add(c.mult(r)).mult(o));
                        e1.setLocationAtPoint(e1.renderWorldCopies ? u.wrap() : u, h);
                    },
                    scaleOfZoom: u,
                    targetCenter: s,
                    scaleOfMinZoom: d,
                    pixelPathLength: h
                };
            }
        }
        class ei {
            constructor(e1, t, i){
                this.blendFunction = e1, this.blendColor = t, this.mask = i;
            }
        }
        ei.Replace = [
            1,
            0
        ], ei.disabled = new ei(ei.Replace, t.bo.transparent, [
            !1,
            !1,
            !1,
            !1
        ]), ei.unblended = new ei(ei.Replace, t.bo.transparent, [
            !0,
            !0,
            !0,
            !0
        ]), ei.alphaBlended = new ei([
            1,
            771
        ], t.bo.transparent, [
            !0,
            !0,
            !0,
            !0
        ]);
        const ti = 2305;
        class ii {
            constructor(e1, t, i){
                this.enable = e1, this.mode = t, this.frontFace = i;
            }
        }
        ii.disabled = new ii(!1, 1029, ti), ii.backCCW = new ii(!0, 1029, ti), ii.frontCCW = new ii(!0, 1028, ti);
        class oi {
            constructor(e1, t, i){
                this.func = e1, this.mask = t, this.range = i;
            }
        }
        oi.ReadOnly = !1, oi.ReadWrite = !0, oi.disabled = new oi(519, oi.ReadOnly, [
            0,
            1
        ]);
        const ai = 7680;
        class ri {
            constructor(e1, t, i, o, a, r){
                this.test = e1, this.ref = t, this.mask = i, this.fail = o, this.depthFail = a, this.pass = r;
            }
        }
        function si(e1) {
            return "undefined" != typeof WebGL2RenderingContext && e1 instanceof WebGL2RenderingContext;
        }
        ri.disabled = new ri({
            func: 519,
            mask: 0
        }, 0, 0, ai, ai, ai);
        class ni {
            get awaitingQuery() {
                return !!this._readbackQueue;
            }
            constructor(e1){
                this._readbackWaitFrames = 4, this._measureWaitFrames = 6, this._texWidth = 1, this._texHeight = 1, this._measuredError = 0, this._updateCount = 0, this._lastReadbackFrame = -1000, this._readbackQueue = null, this._cachedRenderContext = e1;
                const i = e1.context, o = i.gl;
                this._texFormat = o.RGBA, this._texType = o.UNSIGNED_BYTE;
                const a = new t.aU;
                a.emplaceBack(-1, -1), a.emplaceBack(2, -1), a.emplaceBack(-1, 2);
                const r = new t.aW;
                r.emplaceBack(0, 1, 2), this._fullscreenTriangle = new Bt(i.createVertexBuffer(a, Ot.members), i.createIndexBuffer(r), t.aV.simpleSegment(0, 0, a.length, r.length)), this._resultBuffer = new Uint8Array(4), i.activeTexture.set(o.TEXTURE1);
                const s = o.createTexture();
                o.bindTexture(o.TEXTURE_2D, s), o.texParameteri(o.TEXTURE_2D, o.TEXTURE_WRAP_S, o.CLAMP_TO_EDGE), o.texParameteri(o.TEXTURE_2D, o.TEXTURE_WRAP_T, o.CLAMP_TO_EDGE), o.texParameteri(o.TEXTURE_2D, o.TEXTURE_MIN_FILTER, o.NEAREST), o.texParameteri(o.TEXTURE_2D, o.TEXTURE_MAG_FILTER, o.NEAREST), o.texImage2D(o.TEXTURE_2D, 0, this._texFormat, this._texWidth, this._texHeight, 0, this._texFormat, this._texType, null), this._fbo = i.createFramebuffer(this._texWidth, this._texHeight, !1, !1), this._fbo.colorAttachment.set(s), si(o) && (this._pbo = o.createBuffer(), o.bindBuffer(o.PIXEL_PACK_BUFFER, this._pbo), o.bufferData(o.PIXEL_PACK_BUFFER, 4, o.STREAM_READ), o.bindBuffer(o.PIXEL_PACK_BUFFER, null));
            }
            destroy() {
                const e1 = this._cachedRenderContext.context.gl;
                this._fullscreenTriangle.destroy(), this._fbo.destroy(), e1.deleteBuffer(this._pbo), this._fullscreenTriangle = null, this._fbo = null, this._pbo = null, this._resultBuffer = null;
            }
            updateErrorLoop(e1, t) {
                const i = this._updateCount;
                return this._readbackQueue ? i >= this._readbackQueue.frameNumberIssued + this._readbackWaitFrames && this._tryReadback() : i >= this._lastReadbackFrame + this._measureWaitFrames && this._renderErrorTexture(e1, t), this._updateCount++, this._measuredError;
            }
            _bindFramebuffer() {
                const e1 = this._cachedRenderContext.context, t = e1.gl;
                e1.activeTexture.set(t.TEXTURE1), t.bindTexture(t.TEXTURE_2D, this._fbo.colorAttachment.get()), e1.bindFramebuffer.set(this._fbo.framebuffer);
            }
            _renderErrorTexture(e1, i) {
                const o = this._cachedRenderContext.context, a = o.gl;
                if (this._bindFramebuffer(), o.viewport.set([
                    0,
                    0,
                    this._texWidth,
                    this._texHeight
                ]), o.clear({
                    color: t.bo.transparent
                }), this._cachedRenderContext.useProgram("projectionErrorMeasurement").draw(o, a.TRIANGLES, oi.disabled, ri.disabled, ei.unblended, ii.disabled, ((e1, t)=>({
                        u_input: e1,
                        u_output_expected: t
                    }))(e1, i), null, null, "$clipping", this._fullscreenTriangle.vertexBuffer, this._fullscreenTriangle.indexBuffer, this._fullscreenTriangle.segments), this._pbo && si(a)) {
                    a.bindBuffer(a.PIXEL_PACK_BUFFER, this._pbo), a.readBuffer(a.COLOR_ATTACHMENT0), a.readPixels(0, 0, this._texWidth, this._texHeight, this._texFormat, this._texType, 0), a.bindBuffer(a.PIXEL_PACK_BUFFER, null);
                    const e1 = a.fenceSync(a.SYNC_GPU_COMMANDS_COMPLETE, 0);
                    a.flush(), this._readbackQueue = {
                        frameNumberIssued: this._updateCount,
                        sync: e1
                    };
                } else this._readbackQueue = {
                    frameNumberIssued: this._updateCount,
                    sync: null
                };
            }
            _tryReadback() {
                const e1 = this._cachedRenderContext.context.gl;
                if (this._pbo && this._readbackQueue && si(e1)) {
                    const i = e1.clientWaitSync(this._readbackQueue.sync, 0, 0);
                    if (i === e1.WAIT_FAILED) return t.w("WebGL2 clientWaitSync failed."), this._readbackQueue = null, void (this._lastReadbackFrame = this._updateCount);
                    if (i === e1.TIMEOUT_EXPIRED) return;
                    e1.bindBuffer(e1.PIXEL_PACK_BUFFER, this._pbo), e1.getBufferSubData(e1.PIXEL_PACK_BUFFER, 0, this._resultBuffer, 0, 4), e1.bindBuffer(e1.PIXEL_PACK_BUFFER, null);
                } else this._bindFramebuffer(), e1.readPixels(0, 0, this._texWidth, this._texHeight, this._texFormat, this._texType, this._resultBuffer);
                this._readbackQueue = null, this._measuredError = ni._parseRGBA8float(this._resultBuffer), this._lastReadbackFrame = this._updateCount;
            }
            static _parseRGBA8float(e1) {
                let t = 0;
                return t += e1[0] / 256, t += e1[1] / 65536, t += e1[2] / 16777216, e1[3] < 127 && (t = -t), t / 128;
            }
        }
        const li = t.a6 / 128;
        function ci(e1, i) {
            const o = void 0 !== e1.granularity ? Math.max(e1.granularity, 1) : 1, a = o + (e1.generateBorders ? 2 : 0), r = o + (e1.extendToNorthPole || e1.generateBorders ? 1 : 0) + (e1.extendToSouthPole || e1.generateBorders ? 1 : 0), s = a + 1, n = r + 1, l = e1.generateBorders ? -1 : 0, c = e1.generateBorders || e1.extendToNorthPole ? -1 : 0, h = o + (e1.generateBorders ? 1 : 0), u = o + (e1.generateBorders || e1.extendToSouthPole ? 1 : 0), d = s * n, _ = a * r * 6, p = s * n > 65536;
            if (p && "16bit" === i) throw new Error("Granularity is too large and meshes would not fit inside 16 bit vertex indices.");
            const m = p || "32bit" === i, f = new Int16Array(2 * d);
            let g = 0;
            for(let i = c; i <= u; i++)for(let a = l; a <= h; a++){
                let r = a / o * t.a6;
                -1 === a && (r = -li), a === o + 1 && (r = t.a6 + li);
                let s = i / o * t.a6;
                -1 === i && (s = e1.extendToNorthPole ? t.bq : -li), i === o + 1 && (s = e1.extendToSouthPole ? t.br : t.a6 + li), f[g++] = r, f[g++] = s;
            }
            const v = m ? new Uint32Array(_) : new Uint16Array(_);
            let x = 0;
            for(let e1 = 0; e1 < r; e1++)for(let t = 0; t < a; t++){
                const i = t + 1 + e1 * s, o = t + (e1 + 1) * s, a = t + 1 + (e1 + 1) * s;
                v[x++] = t + e1 * s, v[x++] = o, v[x++] = i, v[x++] = i, v[x++] = o, v[x++] = a;
            }
            return {
                vertices: f.buffer.slice(0),
                indices: v.buffer.slice(0),
                uses32bitIndices: m
            };
        }
        const hi = new t.aT({
            fill: new t.bs(128, 2),
            line: new t.bs(512, 0),
            tile: new t.bs(128, 32),
            stencil: new t.bs(128, 1),
            circle: 3
        });
        class ui {
            constructor(){
                this._tileMeshCache = {}, this._errorCorrectionUsable = 0, this._errorMeasurementLastValue = 0, this._errorCorrectionPreviousValue = 0, this._errorMeasurementLastChangeTime = -1000;
            }
            get name() {
                return "vertical-perspective";
            }
            get transitionState() {
                return 1;
            }
            get useSubdivision() {
                return !0;
            }
            get shaderVariantName() {
                return "globe";
            }
            get shaderDefine() {
                return "#define GLOBE";
            }
            get shaderPreludeCode() {
                return Ft.projectionGlobe;
            }
            get vertexShaderPreludeCode() {
                return Ft.projectionMercator.vertexSource;
            }
            get subdivisionGranularity() {
                return hi;
            }
            get useGlobeControls() {
                return !0;
            }
            get latitudeErrorCorrectionRadians() {
                return this._errorCorrectionUsable;
            }
            destroy() {
                this._errorMeasurement && this._errorMeasurement.destroy();
            }
            updateGPUdependent(e1) {
                this._errorMeasurement || (this._errorMeasurement = new ni(e1));
                const i = t.Y(this._errorQueryLatitudeDegrees), o = 2 * Math.atan(Math.exp(Math.PI - i * Math.PI * 2)) - .5 * Math.PI, a = this._errorMeasurement.updateErrorLoop(i, o), r = c();
                a !== this._errorMeasurementLastValue && (this._errorCorrectionPreviousValue = this._errorCorrectionUsable, this._errorMeasurementLastValue = a, this._errorMeasurementLastChangeTime = r);
                const s = Math.min(Math.max((r - this._errorMeasurementLastChangeTime) / 1e3 / .5, 0), 1);
                this._errorCorrectionUsable = t.bt(this._errorCorrectionPreviousValue, -this._errorMeasurementLastValue, t.bu(s));
            }
            _getMeshKey(e1) {
                return `${e1.granularity.toString(36)}_${e1.generateBorders ? "b" : ""}${e1.extendToNorthPole ? "n" : ""}${e1.extendToSouthPole ? "s" : ""}`;
            }
            getMeshFromTileID(e1, t, i, o, a) {
                const r = ("stencil" === a ? hi.stencil : hi.tile).getGranularityForZoomLevel(t.z);
                return this._getMesh(e1, {
                    granularity: r,
                    generateBorders: i,
                    extendToNorthPole: 0 === t.y && o,
                    extendToSouthPole: t.y === (1 << t.z) - 1 && o
                });
            }
            _getMesh(e1, i) {
                const o = this._getMeshKey(i);
                if (o in this._tileMeshCache) return this._tileMeshCache[o];
                const a = function(e1, i) {
                    const o = ci(i, "16bit"), a = t.aU.deserialize({
                        arrayBuffer: o.vertices,
                        length: o.vertices.byteLength / 2 / 2
                    }), r = t.aW.deserialize({
                        arrayBuffer: o.indices,
                        length: o.indices.byteLength / 2 / 3
                    });
                    return new Bt(e1.createVertexBuffer(a, Ot.members), e1.createIndexBuffer(r), t.aV.simpleSegment(0, 0, a.length, r.length));
                }(e1, i);
                return this._tileMeshCache[o] = a, a;
            }
            recalculate(e1) {}
            hasTransition() {
                var e1;
                const t = c();
                let i = !1;
                return i || (i = (t - this._errorMeasurementLastChangeTime) / 1e3 < .7), i || (i = null === (e1 = this._errorMeasurement) || void 0 === e1 ? void 0 : e1.awaitingQuery), i;
            }
            setErrorQueryLatitudeDegrees(e1) {
                this._errorQueryLatitudeDegrees = e1;
            }
        }
        const di = new t.u({
            type: new t.D(t.x.projection.type)
        });
        class _i extends t.E {
            constructor(e1){
                super(), this._transitionable = new t.y(di, void 0), this.setProjection(e1), this._transitioning = this._transitionable.untransitioned(), this.recalculate(new t.J(0)), this._mercatorProjection = new Zt, this._verticalPerspectiveProjection = new ui;
            }
            get transitionState() {
                const e1 = this.properties.get("type");
                if ("string" == typeof e1 && "mercator" === e1) return 0;
                if ("string" == typeof e1 && "vertical-perspective" === e1) return 1;
                if (e1 instanceof t.bv) {
                    if ("vertical-perspective" === e1.from && "mercator" === e1.to) return 1 - e1.transition;
                    if ("mercator" === e1.from && "vertical-perspective" === e1.to) return e1.transition;
                }
                return 1;
            }
            get useGlobeRendering() {
                return this.transitionState > 0;
            }
            get latitudeErrorCorrectionRadians() {
                return this._verticalPerspectiveProjection.latitudeErrorCorrectionRadians;
            }
            get currentProjection() {
                return this.useGlobeRendering ? this._verticalPerspectiveProjection : this._mercatorProjection;
            }
            get name() {
                return "globe";
            }
            get useSubdivision() {
                return this.currentProjection.useSubdivision;
            }
            get shaderVariantName() {
                return this.currentProjection.shaderVariantName;
            }
            get shaderDefine() {
                return this.currentProjection.shaderDefine;
            }
            get shaderPreludeCode() {
                return this.currentProjection.shaderPreludeCode;
            }
            get vertexShaderPreludeCode() {
                return this.currentProjection.vertexShaderPreludeCode;
            }
            get subdivisionGranularity() {
                return this.currentProjection.subdivisionGranularity;
            }
            get useGlobeControls() {
                return this.transitionState > 0;
            }
            destroy() {
                this._mercatorProjection.destroy(), this._verticalPerspectiveProjection.destroy();
            }
            updateGPUdependent(e1) {
                this._mercatorProjection.updateGPUdependent(e1), this._verticalPerspectiveProjection.updateGPUdependent(e1);
            }
            getMeshFromTileID(e1, t, i, o, a) {
                return this.currentProjection.getMeshFromTileID(e1, t, i, o, a);
            }
            setProjection(e1) {
                this._transitionable.setValue("type", (null == e1 ? void 0 : e1.type) || "mercator");
            }
            updateTransitions(e1) {
                this._transitioning = this._transitionable.transitioned(e1, this._transitioning);
            }
            hasTransition() {
                return this._transitioning.hasTransition() || this.currentProjection.hasTransition();
            }
            recalculate(e1) {
                this.properties = this._transitioning.possiblyEvaluate(e1);
            }
            setErrorQueryLatitudeDegrees(e1) {
                this._verticalPerspectiveProjection.setErrorQueryLatitudeDegrees(e1), this._mercatorProjection.setErrorQueryLatitudeDegrees(e1);
            }
        }
        function pi(e1) {
            const t = gi(e1.worldSize, e1.center.lat);
            return 2 * Math.PI * t;
        }
        function mi(e1, i, o, a, r) {
            const s = 1 / (1 << r), n = i / t.a6 * s + a * s, l = t.by((e1 / t.a6 * s + o * s) * Math.PI * 2 + Math.PI, 2 * Math.PI), c = 2 * Math.atan(Math.exp(Math.PI - n * Math.PI * 2)) - .5 * Math.PI, h = Math.cos(c), u = new Float64Array(3);
            return u[0] = Math.sin(l) * h, u[1] = Math.sin(c), u[2] = Math.cos(l) * h, u;
        }
        function fi(e1) {
            return function(e1, t) {
                const i = Math.cos(t), o = new Float64Array(3);
                return o[0] = Math.sin(e1) * i, o[1] = Math.sin(t), o[2] = Math.cos(e1) * i, o;
            }(e1.lng * Math.PI / 180, e1.lat * Math.PI / 180);
        }
        function gi(e1, t) {
            return e1 / (2 * Math.PI) / Math.cos(t * Math.PI / 180);
        }
        function vi(e1) {
            const i = Math.asin(e1[1]) / Math.PI * 180, o = Math.sqrt(e1[0] * e1[0] + e1[2] * e1[2]);
            if (o > 1e-6) {
                const a = e1[0] / o, r = Math.acos(e1[2] / o), s = (a > 0 ? r : -r) / Math.PI * 180;
                return new t.W(t.X(s, -180, 180), i);
            }
            return new t.W(0, i);
        }
        function xi(e1) {
            return Math.cos(e1 * Math.PI / 180);
        }
        function bi(e1, i) {
            const o = xi(e1), a = xi(i);
            return t.ar(a / o);
        }
        function yi(e1, i) {
            const o = e1.rotate(i.bearingInRadians), a = i.zoom + bi(i.center.lat, 0), r = t.bt(1 / xi(i.center.lat), 1 / xi(Math.min(Math.abs(i.center.lat), 60)), t.bw(a, 7, 3, 0, 1)), s = 360 / pi({
                worldSize: i.worldSize,
                center: {
                    lat: i.center.lat
                }
            });
            return new t.W(i.center.lng - o.x * s * r, t.al(i.center.lat + o.y * s, -t.am, t.am));
        }
        function wi(e1) {
            const t = .5 * e1, i = Math.sin(t), o = Math.cos(t);
            return Math.log(i + o) - Math.log(o - i);
        }
        function Ti(e1, i, o, a) {
            const r = e1.lat + o * a;
            if (Math.abs(o) > 1) {
                const s = (Math.sign(e1.lat + o) !== Math.sign(e1.lat) ? -Math.abs(e1.lat) : Math.abs(e1.lat)) * Math.PI / 180, n = Math.abs(e1.lat + o) * Math.PI / 180, l = wi(s + a * (n - s)), c = wi(s), h = wi(n);
                return new t.W(e1.lng + i * ((l - c) / (h - c)), r);
            }
            return new t.W(e1.lng + i * a, r);
        }
        class Pi {
            constructor(e1){
                this._cachePrevious = new Map, this._cache = new Map, this._hadAnyChanges = !1, this._boundingVolumeFactory = e1;
            }
            swapBuffers() {
                if (!this._hadAnyChanges) return;
                const e1 = this._cachePrevious;
                this._cachePrevious = this._cache, this._cache = e1, this._cache.clear(), this._hadAnyChanges = !1;
            }
            getTileBoundingVolume(e1, t, i, o) {
                const a = `${e1.z}_${e1.x}_${e1.y}_${(null == o ? void 0 : o.terrain) ? "t" : ""}`, r = this._cache.get(a);
                if (r) return r;
                const s = this._cachePrevious.get(a);
                if (s) return this._cache.set(a, s), s;
                const n = this._boundingVolumeFactory(e1, t, i, o);
                return this._cache.set(a, n), this._hadAnyChanges = !0, n;
            }
        }
        class Ci {
            constructor(e1, t, i, o){
                this.min = i, this.max = o, this.points = e1, this.planes = t;
            }
            static fromAabb(e1, t) {
                const i = [];
                for(let o = 0; o < 8; o++)i.push([
                    1 & ~o ? e1[0] : t[0],
                    1 == (o >> 1 & 1) ? t[1] : e1[1],
                    1 == (o >> 2 & 1) ? t[2] : e1[2]
                ]);
                return new Ci(i, [
                    [
                        -1,
                        0,
                        0,
                        t[0]
                    ],
                    [
                        1,
                        0,
                        0,
                        -e1[0]
                    ],
                    [
                        0,
                        -1,
                        0,
                        t[1]
                    ],
                    [
                        0,
                        1,
                        0,
                        -e1[1]
                    ],
                    [
                        0,
                        0,
                        -1,
                        t[2]
                    ],
                    [
                        0,
                        0,
                        1,
                        -e1[2]
                    ]
                ], e1, t);
            }
            static fromCenterSizeAngles(e1, i, o) {
                const a = t.bA([], o[0], o[1], o[2]), r = t.bB([], [
                    i[0],
                    0,
                    0
                ], a), s = t.bB([], [
                    0,
                    i[1],
                    0
                ], a), n = t.bB([], [
                    0,
                    0,
                    i[2]
                ], a), l = [
                    ...e1
                ], c = [
                    ...e1
                ];
                for(let t = 0; t < 8; t++)for(let i = 0; i < 3; i++){
                    const o = e1[i] + r[i] * (1 & ~t ? -1 : 1) + s[i] * (1 == (t >> 1 & 1) ? 1 : -1) + n[i] * (1 == (t >> 2 & 1) ? 1 : -1);
                    l[i] = Math.min(l[i], o), c[i] = Math.max(c[i], o);
                }
                const h = [];
                for(let i = 0; i < 8; i++){
                    const o = [
                        ...e1
                    ];
                    t.a_(o, o, t.aZ([], r, 1 & ~i ? -1 : 1)), t.a_(o, o, t.aZ([], s, 1 == (i >> 1 & 1) ? 1 : -1)), t.a_(o, o, t.aZ([], n, 1 == (i >> 2 & 1) ? 1 : -1)), h.push(o);
                }
                return new Ci(h, [
                    [
                        ...r,
                        -t.b3(r, h[0])
                    ],
                    [
                        ...s,
                        -t.b3(s, h[0])
                    ],
                    [
                        ...n,
                        -t.b3(n, h[0])
                    ],
                    [
                        -r[0],
                        -r[1],
                        -r[2],
                        -t.b3(r, h[7])
                    ],
                    [
                        -s[0],
                        -s[1],
                        -s[2],
                        -t.b3(s, h[7])
                    ],
                    [
                        -n[0],
                        -n[1],
                        -n[2],
                        -t.b3(n, h[7])
                    ]
                ], l, c);
            }
            intersectsFrustum(e1) {
                let t = !0;
                const i = this.points.length, o = this.planes.length, a = e1.planes.length, r = e1.points.length;
                for(let o = 0; o < a; o++){
                    const a = e1.planes[o];
                    let r = 0;
                    for(let e1 = 0; e1 < i; e1++){
                        const t = this.points[e1];
                        a[0] * t[0] + a[1] * t[1] + a[2] * t[2] + a[3] >= 0 && r++;
                    }
                    if (0 === r) return 0;
                    r < i && (t = !1);
                }
                if (t) return 2;
                for(let t = 0; t < o; t++){
                    const i = this.planes[t];
                    let o = 0;
                    for(let t = 0; t < r; t++){
                        const a = e1.points[t];
                        i[0] * a[0] + i[1] * a[1] + i[2] * a[2] + i[3] >= 0 && o++;
                    }
                    if (0 === o) return 0;
                }
                return 1;
            }
            intersectsPlane(e1) {
                const t = this.points.length;
                let i = 0;
                for(let o = 0; o < t; o++){
                    const t = this.points[o];
                    e1[0] * t[0] + e1[1] * t[1] + e1[2] * t[2] + e1[3] >= 0 && i++;
                }
                return i === t ? 2 : 0 === i ? 0 : 1;
            }
        }
        function Mi(e1, t, i) {
            const o = e1 - t;
            return o < 0 ? -o : Math.max(0, o - i);
        }
        function Ii(e1, t, i, o, a) {
            const r = e1 - i;
            let s;
            return s = r < 0 ? Math.min(-r, 1 + r - a) : r > a ? Math.min(Math.max(r - a, 0), 1 - r) : 0, Math.max(s, Mi(t, o, a));
        }
        class Ei {
            constructor(){
                this._boundingVolumeCache = new Pi(this._computeTileBoundingVolume);
            }
            prepareNextFrame() {
                this._boundingVolumeCache.swapBuffers();
            }
            distanceToTile2d(e1, t, i, o) {
                const a = 1 << i.z, r = 1 / a, s = i.x / a, n = i.y / a;
                let l = 2;
                return l = Math.min(l, Ii(e1, t, s, n, r)), l = Math.min(l, Ii(e1, t, s + .5, -n - r, r)), l = Math.min(l, Ii(e1, t, s + .5, 2 - n - r, r)), l;
            }
            getWrap(e1, t, i) {
                const o = 1 << t.z, a = 1 / o, r = t.x / o, s = Mi(e1.x, r, a), n = Mi(e1.x, r - 1, a), l = Mi(e1.x, r + 1, a), c = Math.min(s, n, l);
                return c === l ? 1 : c === n ? -1 : 0;
            }
            allowVariableZoom(e1, t) {
                return Ce(e1, t) > 4;
            }
            allowWorldCopies() {
                return !1;
            }
            getTileBoundingVolume(e1, t, i, o) {
                return this._boundingVolumeCache.getTileBoundingVolume(e1, t, i, o);
            }
            _computeTileBoundingVolume(e1, i, o, a) {
                var r, s;
                let n = 0, l = 0;
                if (null == a ? void 0 : a.terrain) {
                    const c = new t.a3(e1.z, i, e1.z, e1.x, e1.y), h = a.terrain.getMinMaxElevation(c);
                    n = null !== (r = h.minElevation) && void 0 !== r ? r : Math.min(0, o), l = null !== (s = h.maxElevation) && void 0 !== s ? s : Math.max(0, o);
                }
                if (n /= t.bD, l /= t.bD, n += 1, l += 1, e1.z <= 0) return Ci.fromAabb([
                    -l,
                    -l,
                    -l
                ], [
                    l,
                    l,
                    l
                ]);
                if (1 === e1.z) return Ci.fromAabb([
                    0 === e1.x ? -l : 0,
                    0 === e1.y ? 0 : -l,
                    -l
                ], [
                    0 === e1.x ? 0 : l,
                    0 === e1.y ? l : 0,
                    l
                ]);
                {
                    const i = [
                        mi(0, 0, e1.x, e1.y, e1.z),
                        mi(t.a6, 0, e1.x, e1.y, e1.z),
                        mi(t.a6, t.a6, e1.x, e1.y, e1.z),
                        mi(0, t.a6, e1.x, e1.y, e1.z)
                    ], o = [];
                    for (const e1 of i)o.push(t.aZ([], e1, l));
                    if (l !== n) for (const e1 of i)o.push(t.aZ([], e1, n));
                    0 === e1.y && o.push([
                        0,
                        1,
                        0
                    ]), e1.y === (1 << e1.z) - 1 && o.push([
                        0,
                        -1,
                        0
                    ]);
                    const a = [
                        1,
                        1,
                        1
                    ], r = [
                        -1,
                        -1,
                        -1
                    ];
                    for (const e1 of o)for(let t = 0; t < 3; t++)a[t] = Math.min(a[t], e1[t]), r[t] = Math.max(r[t], e1[t]);
                    const s = mi(t.a6 / 2, t.a6 / 2, e1.x, e1.y, e1.z), c = t.b2([], [
                        0,
                        1,
                        0
                    ], s);
                    t.b1(c, c);
                    const h = t.b2([], s, c);
                    t.b1(h, h);
                    const u = t.b2([], i[2], i[1]);
                    t.b1(u, u);
                    const d = t.b2([], i[0], i[3]);
                    t.b1(d, d), o.push(t.aZ([], s, l)), e1.y >= (1 << e1.z) / 2 && o.push(t.aZ([], mi(t.a6 / 2, 0, e1.x, e1.y, e1.z), l)), e1.y < (1 << e1.z) / 2 && o.push(t.aZ([], mi(t.a6 / 2, t.a6, e1.x, e1.y, e1.z), l));
                    const _ = Si(s, o), p = Si(h, o), m = [
                        -s[0],
                        -s[1],
                        -s[2],
                        _.max
                    ], f = [
                        s[0],
                        s[1],
                        s[2],
                        -_.min
                    ], g = [
                        -h[0],
                        -h[1],
                        -h[2],
                        p.max
                    ], v = [
                        h[0],
                        h[1],
                        h[2],
                        -p.min
                    ], x = [
                        ...u,
                        0
                    ], b = [
                        ...d,
                        0
                    ], y = [];
                    return 0 === e1.y ? y.push(t.bC(b, x, m), t.bC(b, x, f)) : y.push(t.bC(g, x, m), t.bC(g, x, f), t.bC(g, b, m), t.bC(g, b, f)), e1.y === (1 << e1.z) - 1 ? y.push(t.bC(b, x, m), t.bC(b, x, f)) : y.push(t.bC(v, x, m), t.bC(v, x, f), t.bC(v, b, m), t.bC(v, b, f)), new Ci(y, [
                        m,
                        f,
                        g,
                        v,
                        x,
                        b
                    ], a, r);
                }
            }
        }
        function Si(e1, i) {
            let o = 1 / 0, a = -1 / 0;
            for (const r of i){
                const i = t.b3(e1, r);
                o = Math.min(o, i), a = Math.max(a, i);
            }
            return {
                min: o,
                max: a
            };
        }
        class zi {
            get pixelsToClipSpaceMatrix() {
                return this._helper.pixelsToClipSpaceMatrix;
            }
            get clipSpaceToPixelsMatrix() {
                return this._helper.clipSpaceToPixelsMatrix;
            }
            get pixelsToGLUnits() {
                return this._helper.pixelsToGLUnits;
            }
            get centerOffset() {
                return this._helper.centerOffset;
            }
            get size() {
                return this._helper.size;
            }
            get rotationMatrix() {
                return this._helper.rotationMatrix;
            }
            get centerPoint() {
                return this._helper.centerPoint;
            }
            get pixelsPerMeter() {
                return this._helper.pixelsPerMeter;
            }
            setMinZoom(e1) {
                this._helper.setMinZoom(e1);
            }
            setMaxZoom(e1) {
                this._helper.setMaxZoom(e1);
            }
            setMinPitch(e1) {
                this._helper.setMinPitch(e1);
            }
            setMaxPitch(e1) {
                this._helper.setMaxPitch(e1);
            }
            setRenderWorldCopies(e1) {
                this._helper.setRenderWorldCopies(e1);
            }
            setBearing(e1) {
                this._helper.setBearing(e1);
            }
            setPitch(e1) {
                this._helper.setPitch(e1);
            }
            setRoll(e1) {
                this._helper.setRoll(e1);
            }
            setFov(e1) {
                this._helper.setFov(e1);
            }
            setZoom(e1) {
                this._helper.setZoom(e1);
            }
            setCenter(e1) {
                this._helper.setCenter(e1);
            }
            setElevation(e1) {
                this._helper.setElevation(e1);
            }
            setMinElevationForCurrentTile(e1) {
                this._helper.setMinElevationForCurrentTile(e1);
            }
            setPadding(e1) {
                this._helper.setPadding(e1);
            }
            interpolatePadding(e1, t, i) {
                this._helper.interpolatePadding(e1, t, i);
            }
            isPaddingEqual(e1) {
                return this._helper.isPaddingEqual(e1);
            }
            resize(e1, t) {
                this._helper.resize(e1, t);
            }
            getMaxBounds() {
                return this._helper.getMaxBounds();
            }
            setMaxBounds(e1) {
                this._helper.setMaxBounds(e1);
            }
            setConstrainOverride(e1) {
                this._helper.setConstrainOverride(e1);
            }
            overrideNearFarZ(e1, t) {
                this._helper.overrideNearFarZ(e1, t);
            }
            clearNearFarZOverride() {
                this._helper.clearNearFarZOverride();
            }
            getCameraQueryGeometry(e1) {
                return this._helper.getCameraQueryGeometry(this.getCameraPoint(), e1);
            }
            get tileSize() {
                return this._helper.tileSize;
            }
            get tileZoom() {
                return this._helper.tileZoom;
            }
            get scale() {
                return this._helper.scale;
            }
            get worldSize() {
                return this._helper.worldSize;
            }
            get width() {
                return this._helper.width;
            }
            get height() {
                return this._helper.height;
            }
            get lngRange() {
                return this._helper.lngRange;
            }
            get latRange() {
                return this._helper.latRange;
            }
            get minZoom() {
                return this._helper.minZoom;
            }
            get maxZoom() {
                return this._helper.maxZoom;
            }
            get zoom() {
                return this._helper.zoom;
            }
            get center() {
                return this._helper.center;
            }
            get minPitch() {
                return this._helper.minPitch;
            }
            get maxPitch() {
                return this._helper.maxPitch;
            }
            get pitch() {
                return this._helper.pitch;
            }
            get pitchInRadians() {
                return this._helper.pitchInRadians;
            }
            get roll() {
                return this._helper.roll;
            }
            get rollInRadians() {
                return this._helper.rollInRadians;
            }
            get bearing() {
                return this._helper.bearing;
            }
            get bearingInRadians() {
                return this._helper.bearingInRadians;
            }
            get fov() {
                return this._helper.fov;
            }
            get fovInRadians() {
                return this._helper.fovInRadians;
            }
            get elevation() {
                return this._helper.elevation;
            }
            get minElevationForCurrentTile() {
                return this._helper.minElevationForCurrentTile;
            }
            get padding() {
                return this._helper.padding;
            }
            get unmodified() {
                return this._helper.unmodified;
            }
            get renderWorldCopies() {
                return this._helper.renderWorldCopies;
            }
            get constrainOverride() {
                return this._helper.constrainOverride;
            }
            get nearZ() {
                return this._helper.nearZ;
            }
            get farZ() {
                return this._helper.farZ;
            }
            get autoCalculateNearFarZ() {
                return this._helper.autoCalculateNearFarZ;
            }
            setTransitionState(e1) {}
            constructor(e1){
                this._cachedClippingPlane = t.bE(), this._projectionMatrix = t.bi(), this._globeViewProjMatrix32f = t.bh(), this._globeViewProjMatrixNoCorrection = t.bi(), this._globeViewProjMatrixNoCorrectionInverted = t.bi(), this._globeProjMatrixInverted = t.bi(), this._cameraPosition = t.bz(), this._globeLatitudeErrorCorrectionRadians = 0, this.defaultConstrain = (e1, i)=>{
                    const o = t.al(e1.lat, -t.am, t.am), a = t.al(+i, this.minZoom + bi(0, o), this.maxZoom);
                    return {
                        center: new t.W(e1.lng, o),
                        zoom: a
                    };
                }, this.applyConstrain = (e1, t)=>this._helper.applyConstrain(e1, t), this._helper = new Wt({
                    calcMatrices: ()=>this._calcMatrices(),
                    defaultConstrain: (e1, t)=>this.defaultConstrain(e1, t)
                }, e1), this._coveringTilesDetailsProvider = new Ei;
            }
            clone() {
                const e1 = new zi;
                return e1.apply(this, !1), e1;
            }
            apply(e1, t, i) {
                this._globeLatitudeErrorCorrectionRadians = i || 0, this._helper.apply(e1, t);
            }
            get projectionMatrix() {
                return this._projectionMatrix;
            }
            get modelViewProjectionMatrix() {
                return this._globeViewProjMatrixNoCorrection;
            }
            get inverseProjectionMatrix() {
                return this._globeProjMatrixInverted;
            }
            get cameraPosition() {
                const e1 = t.bz();
                return e1[0] = this._cameraPosition[0], e1[1] = this._cameraPosition[1], e1[2] = this._cameraPosition[2], e1;
            }
            get cameraToCenterDistance() {
                return this._helper.cameraToCenterDistance;
            }
            getProjectionData(e1) {
                const { overscaledTileID: t, applyGlobeMatrix: i } = e1, o = this._helper.getMercatorTileCoordinates(t);
                return {
                    mainMatrix: this._globeViewProjMatrix32f,
                    tileMercatorCoords: o,
                    clippingPlane: this._cachedClippingPlane,
                    projectionTransition: i ? 1 : 0,
                    fallbackMatrix: this._globeViewProjMatrix32f
                };
            }
            _computeClippingPlane(e1) {
                const i = this.pitchInRadians, o = this.cameraToCenterDistance / e1, a = Math.sin(i) * o, r = Math.cos(i) * o + 1, s = 1 / Math.sqrt(a * a + r * r) * 1;
                let n = -a, l = r;
                const c = Math.sqrt(n * n + l * l);
                n /= c, l /= c;
                const h = [
                    0,
                    n,
                    l
                ];
                t.bF(h, h, [
                    0,
                    0,
                    0
                ], -this.bearingInRadians), t.bG(h, h, [
                    0,
                    0,
                    0
                ], -1 * this.center.lat * Math.PI / 180), t.bH(h, h, [
                    0,
                    0,
                    0
                ], this.center.lng * Math.PI / 180);
                const u = 1 / t.b5(h);
                return t.aZ(h, h, u), [
                    ...h,
                    -s * u
                ];
            }
            isLocationOccluded(e1) {
                return !this.isSurfacePointVisible(fi(e1));
            }
            transformLightDirection(e1) {
                const i = this._helper._center.lng * Math.PI / 180, o = this._helper._center.lat * Math.PI / 180, a = Math.cos(o), r = [
                    Math.sin(i) * a,
                    Math.sin(o),
                    Math.cos(i) * a
                ], s = [
                    r[2],
                    0,
                    -r[0]
                ], n = [
                    0,
                    0,
                    0
                ];
                t.b2(n, s, r), t.b1(s, s), t.b1(n, n);
                const l = [
                    0,
                    0,
                    0
                ];
                return t.b1(l, [
                    s[0] * e1[0] + n[0] * e1[1] + r[0] * e1[2],
                    s[1] * e1[0] + n[1] * e1[1] + r[1] * e1[2],
                    s[2] * e1[0] + n[2] * e1[1] + r[2] * e1[2]
                ]), l;
            }
            getPixelScale() {
                return 1 / Math.cos(this._helper._center.lat * Math.PI / 180);
            }
            getCircleRadiusCorrection() {
                return Math.cos(this._helper._center.lat * Math.PI / 180);
            }
            getPitchedTextCorrection(e1, i, o) {
                const a = function(e1, i, o) {
                    const a = 1 / (1 << o.z);
                    return new t.a7(e1 / t.a6 * a + o.x * a, i / t.a6 * a + o.y * a);
                }(e1, i, o.canonical), r = (s = a.y, [
                    t.by(a.x * Math.PI * 2 + Math.PI, 2 * Math.PI),
                    2 * Math.atan(Math.exp(Math.PI - s * Math.PI * 2)) - .5 * Math.PI
                ]);
                var s;
                return this.getCircleRadiusCorrection() / Math.cos(r[1]);
            }
            projectTileCoordinates(e1, i, o, a) {
                const r = o.canonical, s = mi(e1, i, r.x, r.y, r.z), n = 1 + (a ? a(e1, i) : 0) / t.bD, l = [
                    s[0] * n,
                    s[1] * n,
                    s[2] * n,
                    1
                ];
                t.aE(l, l, this._globeViewProjMatrixNoCorrection);
                const c = this._cachedClippingPlane, h = c[0] * s[0] + c[1] * s[1] + c[2] * s[2] + c[3] < 0;
                return {
                    point: new t.P(l[0] / l[3], l[1] / l[3]),
                    signedDistanceFromCamera: l[3],
                    isOccluded: h
                };
            }
            _calcMatrices() {
                if (!this._helper._width || !this._helper._height) return;
                const e1 = gi(this.worldSize, this.center.lat), i = t.bj(), o = t.bj();
                this._helper.autoCalculateNearFarZ && (this._helper._nearZ = .5, this._helper._farZ = this.cameraToCenterDistance + 2 * e1), t.bc(i, this.fovInRadians, this.width / this.height, this._helper._nearZ, this._helper._farZ);
                const a = this.centerOffset;
                i[8] = 2 * -a.x / this._helper._width, i[9] = 2 * a.y / this._helper._height, this._projectionMatrix = t.bd(i), this._globeProjMatrixInverted = t.bj(), t.bg(this._globeProjMatrixInverted, i), t.Q(i, i, [
                    0,
                    0,
                    -this.cameraToCenterDistance
                ]), t.be(i, i, this.rollInRadians), t.bf(i, i, -this.pitchInRadians), t.be(i, i, this.bearingInRadians), t.Q(i, i, [
                    0,
                    0,
                    -e1
                ]);
                const r = t.bz();
                r[0] = e1, r[1] = e1, r[2] = e1, t.bf(o, i, this.center.lat * Math.PI / 180), t.bI(o, o, -this.center.lng * Math.PI / 180), t.S(o, o, r), this._globeViewProjMatrixNoCorrection = o, t.bf(i, i, this.center.lat * Math.PI / 180 - this._globeLatitudeErrorCorrectionRadians), t.bI(i, i, -this.center.lng * Math.PI / 180), t.S(i, i, r), this._globeViewProjMatrix32f = new Float32Array(i), this._globeViewProjMatrixNoCorrectionInverted = t.bj(), t.bg(this._globeViewProjMatrixNoCorrectionInverted, o);
                const s = t.bz();
                this._cameraPosition = t.bz(), this._cameraPosition[2] = this.cameraToCenterDistance / e1, t.bF(this._cameraPosition, this._cameraPosition, s, -this.rollInRadians), t.bG(this._cameraPosition, this._cameraPosition, s, this.pitchInRadians), t.bF(this._cameraPosition, this._cameraPosition, s, -this.bearingInRadians), t.a_(this._cameraPosition, this._cameraPosition, [
                    0,
                    0,
                    1
                ]), t.bG(this._cameraPosition, this._cameraPosition, s, -this.center.lat * Math.PI / 180), t.bH(this._cameraPosition, this._cameraPosition, s, this.center.lng * Math.PI / 180), this._cachedClippingPlane = this._computeClippingPlane(e1);
                const n = t.bd(this._globeViewProjMatrixNoCorrectionInverted);
                t.S(n, n, [
                    1,
                    1,
                    -1
                ]), this._cachedFrustum = Ht.fromInvProjectionMatrix(n, 1, 0, this._cachedClippingPlane, !0);
            }
            calculateFogMatrix(e1) {
                t.w("calculateFogMatrix is not supported on globe projection.");
                const i = t.bj();
                return t.ap(i), i;
            }
            getVisibleUnwrappedCoordinates(e1) {
                return [
                    new t.ba(0, e1)
                ];
            }
            getCameraFrustum() {
                return this._cachedFrustum;
            }
            getClippingPlane() {
                return this._cachedClippingPlane;
            }
            getCoveringTilesDetailsProvider() {
                return this._coveringTilesDetailsProvider;
            }
            recalculateZoomAndCenter(e1) {
                e1 && t.w("terrain is not fully supported on vertical perspective projection."), this._helper.recalculateZoomAndCenter(0);
            }
            maxPitchScaleFactor() {
                return 1;
            }
            getCameraPoint() {
                return this._helper.getCameraPoint();
            }
            getCameraAltitude() {
                return this._helper.getCameraAltitude();
            }
            getCameraLngLat() {
                return this._helper.getCameraLngLat();
            }
            lngLatToCameraDepth(e1, i) {
                if (!this._globeViewProjMatrixNoCorrection) return 1;
                const o = fi(e1);
                t.aZ(o, o, 1 + i / t.bD);
                const a = t.bE();
                return t.aE(a, [
                    o[0],
                    o[1],
                    o[2],
                    1
                ], this._globeViewProjMatrixNoCorrection), a[2] / a[3];
            }
            populateCache(e1) {}
            getBounds() {
                const e1 = .5 * this.width, i = .5 * this.height, o = [
                    new t.P(0, 0),
                    new t.P(e1, 0),
                    new t.P(this.width, 0),
                    new t.P(this.width, i),
                    new t.P(this.width, this.height),
                    new t.P(e1, this.height),
                    new t.P(0, this.height),
                    new t.P(0, i)
                ], a = [];
                for (const e1 of o)a.push(this.unprojectScreenPoint(e1));
                let r = 0, s = 0, n = 0, l = 0;
                const c = this.center;
                for (const e1 of a){
                    const i = t.bJ(c.lng, e1.lng), o = t.bJ(c.lat, e1.lat);
                    i < s && (s = i), i > r && (r = i), o < l && (l = o), o > n && (n = o);
                }
                const h = [
                    c.lng + s,
                    c.lat + l,
                    c.lng + r,
                    c.lat + n
                ];
                return this.isSurfacePointOnScreen([
                    0,
                    1,
                    0
                ]) && (h[3] = 90, h[0] = -180, h[2] = 180), this.isSurfacePointOnScreen([
                    0,
                    -1,
                    0
                ]) && (h[1] = -90, h[0] = -180, h[2] = 180), new G(h);
            }
            calculateCenterFromCameraLngLatAlt(e1, t, i, o) {
                return this._helper.calculateCenterFromCameraLngLatAlt(e1, t, i, o);
            }
            setLocationAtPoint(e1, i) {
                const o = fi(this.unprojectScreenPoint(i)), a = fi(e1), r = t.bz();
                t.bK(r);
                const s = t.bz();
                t.bH(s, o, r, -this.center.lng * Math.PI / 180), t.bG(s, s, r, this.center.lat * Math.PI / 180);
                const n = a[0] * a[0] + a[2] * a[2], l = s[0] * s[0];
                if (n < l) return;
                const c = Math.sqrt(n - l), h = -c, u = t.bL(a[0], a[2], s[0], c), d = t.bL(a[0], a[2], s[0], h), _ = t.bz();
                t.bH(_, a, r, -u);
                const p = t.bL(_[1], _[2], s[1], s[2]), m = t.bz();
                t.bH(m, a, r, -d);
                const f = t.bL(m[1], m[2], s[1], s[2]), g = .5 * Math.PI, v = p >= -g && p <= g, x = f >= -g && f <= g;
                let b, y;
                if (v && x) {
                    const e1 = this.center.lng * Math.PI / 180, i = this.center.lat * Math.PI / 180;
                    t.bM(u, e1) + t.bM(p, i) < t.bM(d, e1) + t.bM(f, i) ? (b = u, y = p) : (b = d, y = f);
                } else if (v) b = u, y = p;
                else {
                    if (!x) return;
                    b = d, y = f;
                }
                const w = b / Math.PI * 180, T = y / Math.PI * 180, P = this.center.lat;
                this.setCenter(new t.W(w, t.al(T, -90, 90))), this.setZoom(this.zoom + bi(P, this.center.lat));
            }
            locationToScreenPoint(e1, i) {
                const o = fi(e1);
                if (i) {
                    const a = i.getElevationForLngLatZoom(e1, this._helper._tileZoom);
                    t.aZ(o, o, 1 + a / t.bD);
                }
                return this._projectSurfacePointToScreen(o);
            }
            _projectSurfacePointToScreen(e1) {
                const i = t.bE();
                return t.aE(i, [
                    ...e1,
                    1
                ], this._globeViewProjMatrixNoCorrection), i[0] /= i[3], i[1] /= i[3], new t.P((.5 * i[0] + .5) * this.width, (.5 * -i[1] + .5) * this.height);
            }
            screenPointToMercatorCoordinate(e1, i) {
                if (i) {
                    const t = i.pointCoordinate(e1);
                    if (t) return t;
                }
                return t.a7.fromLngLat(this.unprojectScreenPoint(e1));
            }
            screenPointToLocation(e1, t) {
                var i;
                return null === (i = this.screenPointToMercatorCoordinate(e1, t)) || void 0 === i ? void 0 : i.toLngLat();
            }
            isPointOnMapSurface(e1, t) {
                const i = this._cameraPosition, o = this.getRayDirectionFromPixel(e1);
                return !!this.rayPlanetIntersection(i, o);
            }
            getRayDirectionFromPixel(e1) {
                const i = t.bE();
                i[0] = e1.x / this.width * 2 - 1, i[1] = -1 * (e1.y / this.height * 2 - 1), i[2] = 1, i[3] = 1, t.aE(i, i, this._globeViewProjMatrixNoCorrectionInverted), i[0] /= i[3], i[1] /= i[3], i[2] /= i[3];
                const o = t.bz();
                o[0] = i[0] - this._cameraPosition[0], o[1] = i[1] - this._cameraPosition[1], o[2] = i[2] - this._cameraPosition[2];
                const a = t.bz();
                return t.b1(a, o), a;
            }
            isSurfacePointVisible(e1) {
                const t = this._cachedClippingPlane;
                return t[0] * e1[0] + t[1] * e1[1] + t[2] * e1[2] + t[3] >= 0;
            }
            isSurfacePointOnScreen(e1) {
                if (!this.isSurfacePointVisible(e1)) return !1;
                const i = t.bE();
                return t.aE(i, [
                    ...e1,
                    1
                ], this._globeViewProjMatrixNoCorrection), i[0] /= i[3], i[1] /= i[3], i[2] /= i[3], i[0] > -1 && i[0] < 1 && i[1] > -1 && i[1] < 1 && i[2] > -1 && i[2] < 1;
            }
            rayPlanetIntersection(e1, i) {
                const o = t.b3(e1, i), a = t.bz(), r = t.bz();
                t.aZ(r, i, o), t.b0(a, e1, r);
                const s = 1 - t.b3(a, a);
                if (s < 0) return null;
                const n = t.b3(e1, e1) - 1, l = -o + (o < 0 ? 1 : -1) * Math.sqrt(s), c = n / l, h = l;
                return {
                    tMin: Math.min(c, h),
                    tMax: Math.max(c, h)
                };
            }
            unprojectScreenPoint(e1) {
                const i = this._cameraPosition, o = this.getRayDirectionFromPixel(e1), a = this.rayPlanetIntersection(i, o);
                if (a) {
                    const e1 = t.bz();
                    t.a_(e1, i, [
                        o[0] * a.tMin,
                        o[1] * a.tMin,
                        o[2] * a.tMin
                    ]);
                    const r = t.bz();
                    return t.b1(r, e1), vi(r);
                }
                const r = this._cachedClippingPlane, s = r[0] * o[0] + r[1] * o[1] + r[2] * o[2], n = -t.b9(r, i) / s, l = t.bz();
                if (n > 0) t.a_(l, i, [
                    o[0] * n,
                    o[1] * n,
                    o[2] * n
                ]);
                else {
                    const e1 = t.bz();
                    t.a_(e1, i, [
                        2 * o[0],
                        2 * o[1],
                        2 * o[2]
                    ]);
                    const a = t.b9(this._cachedClippingPlane, e1);
                    t.b0(l, e1, [
                        this._cachedClippingPlane[0] * a,
                        this._cachedClippingPlane[1] * a,
                        this._cachedClippingPlane[2] * a
                    ]);
                }
                const c = function(e1) {
                    const i = t.bz();
                    return i[0] = e1[0] * -e1[3], i[1] = e1[1] * -e1[3], i[2] = e1[2] * -e1[3], {
                        center: i,
                        radius: Math.sqrt(1 - e1[3] * e1[3])
                    };
                }(r);
                return vi(function(e1, i, o) {
                    const a = t.bz();
                    t.b0(a, o, e1);
                    const r = t.bz();
                    return t.bx(r, e1, a, i / t.b7(a)), r;
                }(c.center, c.radius, l));
            }
            getMatrixForModel(e1, i) {
                const o = t.W.convert(e1), a = 1 / t.bD, r = t.bi();
                return t.bI(r, r, o.lng / 180 * Math.PI), t.bf(r, r, -o.lat / 180 * Math.PI), t.Q(r, r, [
                    0,
                    0,
                    1 + i / t.bD
                ]), t.bf(r, r, .5 * Math.PI), t.S(r, r, [
                    a,
                    a,
                    a
                ]), r;
            }
            getProjectionDataForCustomLayer(e1 = !0) {
                const i = this.getProjectionData({
                    overscaledTileID: new t.a3(0, 0, 0, 0, 0),
                    applyGlobeMatrix: e1
                });
                return i.tileMercatorCoords = [
                    0,
                    0,
                    1,
                    1
                ], i;
            }
            getFastPathSimpleProjectionMatrix(e1) {}
        }
        class Ri {
            get pixelsToClipSpaceMatrix() {
                return this._helper.pixelsToClipSpaceMatrix;
            }
            get clipSpaceToPixelsMatrix() {
                return this._helper.clipSpaceToPixelsMatrix;
            }
            get pixelsToGLUnits() {
                return this._helper.pixelsToGLUnits;
            }
            get centerOffset() {
                return this._helper.centerOffset;
            }
            get size() {
                return this._helper.size;
            }
            get rotationMatrix() {
                return this._helper.rotationMatrix;
            }
            get centerPoint() {
                return this._helper.centerPoint;
            }
            get pixelsPerMeter() {
                return this._helper.pixelsPerMeter;
            }
            setMinZoom(e1) {
                this._helper.setMinZoom(e1);
            }
            setMaxZoom(e1) {
                this._helper.setMaxZoom(e1);
            }
            setMinPitch(e1) {
                this._helper.setMinPitch(e1);
            }
            setMaxPitch(e1) {
                this._helper.setMaxPitch(e1);
            }
            setRenderWorldCopies(e1) {
                this._helper.setRenderWorldCopies(e1);
            }
            setBearing(e1) {
                this._helper.setBearing(e1);
            }
            setPitch(e1) {
                this._helper.setPitch(e1);
            }
            setRoll(e1) {
                this._helper.setRoll(e1);
            }
            setFov(e1) {
                this._helper.setFov(e1);
            }
            setZoom(e1) {
                this._helper.setZoom(e1);
            }
            setCenter(e1) {
                this._helper.setCenter(e1);
            }
            setElevation(e1) {
                this._helper.setElevation(e1);
            }
            setMinElevationForCurrentTile(e1) {
                this._helper.setMinElevationForCurrentTile(e1);
            }
            setPadding(e1) {
                this._helper.setPadding(e1);
            }
            interpolatePadding(e1, t, i) {
                this._helper.interpolatePadding(e1, t, i);
            }
            isPaddingEqual(e1) {
                return this._helper.isPaddingEqual(e1);
            }
            resize(e1, t, i = !0) {
                this._helper.resize(e1, t, i);
            }
            getMaxBounds() {
                return this._helper.getMaxBounds();
            }
            setMaxBounds(e1) {
                this._helper.setMaxBounds(e1);
            }
            setConstrainOverride(e1) {
                this._helper.setConstrainOverride(e1);
            }
            overrideNearFarZ(e1, t) {
                this._helper.overrideNearFarZ(e1, t);
            }
            clearNearFarZOverride() {
                this._helper.clearNearFarZOverride();
            }
            getCameraQueryGeometry(e1) {
                return this._helper.getCameraQueryGeometry(this.getCameraPoint(), e1);
            }
            get tileSize() {
                return this._helper.tileSize;
            }
            get tileZoom() {
                return this._helper.tileZoom;
            }
            get scale() {
                return this._helper.scale;
            }
            get worldSize() {
                return this._helper.worldSize;
            }
            get width() {
                return this._helper.width;
            }
            get height() {
                return this._helper.height;
            }
            get lngRange() {
                return this._helper.lngRange;
            }
            get latRange() {
                return this._helper.latRange;
            }
            get minZoom() {
                return this._helper.minZoom;
            }
            get maxZoom() {
                return this._helper.maxZoom;
            }
            get zoom() {
                return this._helper.zoom;
            }
            get center() {
                return this._helper.center;
            }
            get minPitch() {
                return this._helper.minPitch;
            }
            get maxPitch() {
                return this._helper.maxPitch;
            }
            get pitch() {
                return this._helper.pitch;
            }
            get pitchInRadians() {
                return this._helper.pitchInRadians;
            }
            get roll() {
                return this._helper.roll;
            }
            get rollInRadians() {
                return this._helper.rollInRadians;
            }
            get bearing() {
                return this._helper.bearing;
            }
            get bearingInRadians() {
                return this._helper.bearingInRadians;
            }
            get fov() {
                return this._helper.fov;
            }
            get fovInRadians() {
                return this._helper.fovInRadians;
            }
            get elevation() {
                return this._helper.elevation;
            }
            get minElevationForCurrentTile() {
                return this._helper.minElevationForCurrentTile;
            }
            get padding() {
                return this._helper.padding;
            }
            get unmodified() {
                return this._helper.unmodified;
            }
            get renderWorldCopies() {
                return this._helper.renderWorldCopies;
            }
            get cameraToCenterDistance() {
                return this._helper.cameraToCenterDistance;
            }
            get constrainOverride() {
                return this._helper.constrainOverride;
            }
            get nearZ() {
                return this._helper.nearZ;
            }
            get farZ() {
                return this._helper.farZ;
            }
            get autoCalculateNearFarZ() {
                return this._helper.autoCalculateNearFarZ;
            }
            get isGlobeRendering() {
                return this._globeness > 0;
            }
            setTransitionState(e1, t) {
                this._globeness = e1, this._globeLatitudeErrorCorrectionRadians = t, this._calcMatrices(), this._verticalPerspectiveTransform.getCoveringTilesDetailsProvider().prepareNextFrame(), this._mercatorTransform.getCoveringTilesDetailsProvider().prepareNextFrame();
            }
            get currentTransform() {
                return this.isGlobeRendering ? this._verticalPerspectiveTransform : this._mercatorTransform;
            }
            constructor(e1){
                this._globeLatitudeErrorCorrectionRadians = 0, this._globeness = 1, this.defaultConstrain = (e1, t)=>this.currentTransform.defaultConstrain(e1, t), this.applyConstrain = (e1, t)=>this._helper.applyConstrain(e1, t), this._helper = new Wt({
                    calcMatrices: ()=>this._calcMatrices(),
                    defaultConstrain: (e1, t)=>this.defaultConstrain(e1, t)
                }, e1), this._globeness = 1, this._mercatorTransform = new Xt, this._verticalPerspectiveTransform = new zi;
            }
            clone() {
                const e1 = new Ri;
                return e1._globeness = this._globeness, e1._globeLatitudeErrorCorrectionRadians = this._globeLatitudeErrorCorrectionRadians, e1.apply(this, !1), e1;
            }
            apply(e1, t) {
                this._helper.apply(e1, t), this._mercatorTransform.apply(this, !1), this._verticalPerspectiveTransform.apply(this, !1, this._globeLatitudeErrorCorrectionRadians);
            }
            get projectionMatrix() {
                return this.currentTransform.projectionMatrix;
            }
            get modelViewProjectionMatrix() {
                return this.currentTransform.modelViewProjectionMatrix;
            }
            get inverseProjectionMatrix() {
                return this.currentTransform.inverseProjectionMatrix;
            }
            get cameraPosition() {
                return this.currentTransform.cameraPosition;
            }
            getProjectionData(e1) {
                const t = this._mercatorTransform.getProjectionData(e1), i = this._verticalPerspectiveTransform.getProjectionData(e1);
                return {
                    mainMatrix: this.isGlobeRendering ? i.mainMatrix : t.mainMatrix,
                    clippingPlane: i.clippingPlane,
                    tileMercatorCoords: i.tileMercatorCoords,
                    projectionTransition: e1.applyGlobeMatrix ? this._globeness : 0,
                    fallbackMatrix: t.fallbackMatrix
                };
            }
            isLocationOccluded(e1) {
                return this.currentTransform.isLocationOccluded(e1);
            }
            transformLightDirection(e1) {
                return this.currentTransform.transformLightDirection(e1);
            }
            getPixelScale() {
                return t.bt(this._mercatorTransform.getPixelScale(), this._verticalPerspectiveTransform.getPixelScale(), this._globeness);
            }
            getCircleRadiusCorrection() {
                return t.bt(this._mercatorTransform.getCircleRadiusCorrection(), this._verticalPerspectiveTransform.getCircleRadiusCorrection(), this._globeness);
            }
            getPitchedTextCorrection(e1, i, o) {
                const a = this._mercatorTransform.getPitchedTextCorrection(e1, i, o), r = this._verticalPerspectiveTransform.getPitchedTextCorrection(e1, i, o);
                return t.bt(a, r, this._globeness);
            }
            projectTileCoordinates(e1, t, i, o) {
                return this.currentTransform.projectTileCoordinates(e1, t, i, o);
            }
            _calcMatrices() {
                this._helper._width && this._helper._height && (this._verticalPerspectiveTransform.apply(this, !1, this._globeLatitudeErrorCorrectionRadians), this._helper._nearZ = this._verticalPerspectiveTransform.nearZ, this._helper._farZ = this._verticalPerspectiveTransform.farZ, this._mercatorTransform.apply(this, !0, this.isGlobeRendering), this._helper._nearZ = this._mercatorTransform.nearZ, this._helper._farZ = this._mercatorTransform.farZ);
            }
            calculateFogMatrix(e1) {
                return this.currentTransform.calculateFogMatrix(e1);
            }
            getVisibleUnwrappedCoordinates(e1) {
                return this.currentTransform.getVisibleUnwrappedCoordinates(e1);
            }
            getCameraFrustum() {
                return this.currentTransform.getCameraFrustum();
            }
            getClippingPlane() {
                return this.currentTransform.getClippingPlane();
            }
            getCoveringTilesDetailsProvider() {
                return this.currentTransform.getCoveringTilesDetailsProvider();
            }
            recalculateZoomAndCenter(e1) {
                this._mercatorTransform.recalculateZoomAndCenter(e1), this._verticalPerspectiveTransform.recalculateZoomAndCenter(e1);
            }
            maxPitchScaleFactor() {
                return this._mercatorTransform.maxPitchScaleFactor();
            }
            getCameraPoint() {
                return this._helper.getCameraPoint();
            }
            getCameraAltitude() {
                return this._helper.getCameraAltitude();
            }
            getCameraLngLat() {
                return this._helper.getCameraLngLat();
            }
            lngLatToCameraDepth(e1, t) {
                return this.currentTransform.lngLatToCameraDepth(e1, t);
            }
            populateCache(e1) {
                this._mercatorTransform.populateCache(e1), this._verticalPerspectiveTransform.populateCache(e1);
            }
            getBounds() {
                return this.currentTransform.getBounds();
            }
            calculateCenterFromCameraLngLatAlt(e1, t, i, o) {
                return this._helper.calculateCenterFromCameraLngLatAlt(e1, t, i, o);
            }
            setLocationAtPoint(e1, t) {
                if (!this.isGlobeRendering) return this._mercatorTransform.setLocationAtPoint(e1, t), void this.apply(this._mercatorTransform, !1);
                this._verticalPerspectiveTransform.setLocationAtPoint(e1, t), this.apply(this._verticalPerspectiveTransform, !1);
            }
            locationToScreenPoint(e1, t) {
                return this.currentTransform.locationToScreenPoint(e1, t);
            }
            screenPointToMercatorCoordinate(e1, t) {
                return this.currentTransform.screenPointToMercatorCoordinate(e1, t);
            }
            screenPointToLocation(e1, t) {
                return this.currentTransform.screenPointToLocation(e1, t);
            }
            isPointOnMapSurface(e1, t) {
                return this.currentTransform.isPointOnMapSurface(e1, t);
            }
            getRayDirectionFromPixel(e1) {
                return this._verticalPerspectiveTransform.getRayDirectionFromPixel(e1);
            }
            getMatrixForModel(e1, t) {
                return this.currentTransform.getMatrixForModel(e1, t);
            }
            getProjectionDataForCustomLayer(e1 = !0) {
                const t = this._mercatorTransform.getProjectionDataForCustomLayer(e1);
                if (!this.isGlobeRendering) return t;
                const i = this._verticalPerspectiveTransform.getProjectionDataForCustomLayer(e1);
                return i.fallbackMatrix = t.mainMatrix, i;
            }
            getFastPathSimpleProjectionMatrix(e1) {
                return this.currentTransform.getFastPathSimpleProjectionMatrix(e1);
            }
        }
        class Di {
            get useGlobeControls() {
                return !0;
            }
            handlePanInertia(e1, i) {
                const o = yi(e1, i);
                return Math.abs(o.lng - i.center.lng) > 180 && (o.lng = i.center.lng + 179.5 * Math.sign(o.lng - i.center.lng)), {
                    easingCenter: o,
                    easingOffset: new t.P(0, 0)
                };
            }
            handleMapControlsRollPitchBearingZoom(e1, i) {
                const o = e1.around, a = i.screenPointToLocation(o);
                e1.bearingDelta && i.setBearing(i.bearing + e1.bearingDelta), e1.pitchDelta && i.setPitch(i.pitch + e1.pitchDelta), e1.rollDelta && i.setRoll(i.roll + e1.rollDelta);
                const r = i.zoom;
                e1.zoomDelta && i.setZoom(i.zoom + e1.zoomDelta);
                const s = i.zoom - r;
                if (0 === s) return;
                const n = t.bJ(i.center.lng, a.lng), l = n / (Math.abs(n / 180) + 1), c = t.bJ(i.center.lat, a.lat), h = i.getRayDirectionFromPixel(o), u = i.cameraPosition, d = -1 * t.b3(u, h), _ = t.bz();
                t.a_(_, u, [
                    h[0] * d,
                    h[1] * d,
                    h[2] * d
                ]);
                const p = t.b5(_) - 1, m = Math.exp(.5 * -Math.max(p - .3, 0)), f = gi(i.worldSize, i.center.lat) / Math.min(i.width, i.height), g = t.bw(f, .9, .5, 1, .25), v = (1 - t.ao(-s)) * Math.min(m, g), x = i.center.lat, b = i.zoom, y = new t.W(i.center.lng + l * v, t.al(i.center.lat + c * v, -t.am, t.am));
                i.setLocationAtPoint(a, o);
                const w = i.center, T = t.bw(Math.abs(n), 45, 85, 0, 1), P = t.bw(f, .75, .35, 0, 1), C = Math.pow(Math.max(T, P), .25), M = t.bJ(w.lng, y.lng), I = t.bJ(w.lat, y.lat);
                i.setCenter(new t.W(w.lng + M * C, w.lat + I * C).wrap()), i.setZoom(b + bi(x, i.center.lat));
            }
            handleMapControlsPan(e1, t, i) {
                if (!e1.panDelta) return;
                const o = t.center.lat, a = t.zoom;
                t.setCenter(yi(e1.panDelta, t).wrap()), t.setZoom(a + bi(o, t.center.lat));
            }
            cameraForBoxAndBearing(e1, i, o, a, r) {
                const s = Qt(e1, i, o, a, r), n = i.left / r.width * 2 - 1, l = (r.width - i.right) / r.width * 2 - 1, c = i.top / r.height * -2 + 1, h = (r.height - i.bottom) / r.height * -2 + 1, u = t.bJ(o.getWest(), o.getEast()) < 0, d = u ? o.getEast() : o.getWest(), _ = u ? o.getWest() : o.getEast(), p = Math.max(o.getNorth(), o.getSouth()), m = Math.min(o.getNorth(), o.getSouth()), f = d + .5 * t.bJ(d, _), g = p + .5 * t.bJ(p, m), v = r.clone();
                v.setCenter(s.center), v.setBearing(s.bearing), v.setPitch(0), v.setRoll(0), v.setZoom(s.zoom);
                const x = v.modelViewProjectionMatrix, b = [
                    fi(o.getNorthWest()),
                    fi(o.getNorthEast()),
                    fi(o.getSouthWest()),
                    fi(o.getSouthEast()),
                    fi(new t.W(_, g)),
                    fi(new t.W(d, g)),
                    fi(new t.W(f, p)),
                    fi(new t.W(f, m))
                ], y = fi(s.center);
                let w = Number.POSITIVE_INFINITY;
                for (const e1 of b)n < 0 && (w = Di.getLesserNonNegativeNonNull(w, Di.solveVectorScale(e1, y, x, "x", n))), l > 0 && (w = Di.getLesserNonNegativeNonNull(w, Di.solveVectorScale(e1, y, x, "x", l))), c > 0 && (w = Di.getLesserNonNegativeNonNull(w, Di.solveVectorScale(e1, y, x, "y", c))), h < 0 && (w = Di.getLesserNonNegativeNonNull(w, Di.solveVectorScale(e1, y, x, "y", h)));
                if (Number.isFinite(w) && 0 !== w) return s.zoom = Math.min(v.zoom + t.ar(w), e1.maxZoom), s;
                Kt();
            }
            handleJumpToCenterZoom(e1, i) {
                const o = e1.center.lat, a = e1.applyConstrain(i.center ? t.W.convert(i.center) : e1.center, e1.zoom).center;
                e1.setCenter(a.wrap());
                const r = void 0 !== i.zoom ? +i.zoom : e1.zoom + bi(o, a.lat);
                e1.zoom !== r && e1.setZoom(r);
            }
            handleEaseTo(e1, i) {
                const o = e1.zoom, a = e1.center, r = e1.padding, s = {
                    roll: e1.roll,
                    pitch: e1.pitch,
                    bearing: e1.bearing
                }, n = {
                    roll: void 0 === i.roll ? e1.roll : i.roll,
                    pitch: void 0 === i.pitch ? e1.pitch : i.pitch,
                    bearing: void 0 === i.bearing ? e1.bearing : i.bearing
                }, l = void 0 !== i.zoom, c = !e1.isPaddingEqual(i.padding);
                let h = !1;
                const u = i.center ? t.W.convert(i.center) : a, d = e1.applyConstrain(u, o).center;
                Gt(e1, d);
                const _ = e1.clone();
                _.setCenter(d), _.setZoom(l ? +i.zoom : o + bi(a.lat, u.lat)), _.setBearing(i.bearing);
                const p = new t.P(t.al(e1.centerPoint.x + i.offsetAsPoint.x, 0, e1.width), t.al(e1.centerPoint.y + i.offsetAsPoint.y, 0, e1.height));
                _.setLocationAtPoint(d, p);
                const m = (i.offset && i.offsetAsPoint.mag()) > 0 ? _.center : d, f = l ? +i.zoom : o + bi(a.lat, m.lat), g = o + bi(a.lat, 0), v = f + bi(m.lat, 0), x = t.bJ(a.lng, m.lng), b = t.bJ(a.lat, m.lat), y = t.ao(v - g);
                return h = f !== o, {
                    easeFunc: (o)=>{
                        if (t.bn(s, n) || Yt({
                            startEulerAngles: s,
                            endEulerAngles: n,
                            tr: e1,
                            k: o,
                            useSlerp: s.roll != n.roll
                        }), c && e1.interpolatePadding(r, i.padding, o), i.around) t.w("Easing around a point is not supported under globe projection."), e1.setLocationAtPoint(i.around, i.aroundPoint);
                        else {
                            const t = v > g ? Math.min(2, y) : Math.max(.5, y), i = Math.pow(t, 1 - o), r = Ti(a, x, b, o * i);
                            e1.setCenter(r.wrap());
                        }
                        if (h) {
                            const i = t.H.number(g, v, o) + bi(0, e1.center.lat);
                            e1.setZoom(i);
                        }
                    },
                    isZooming: h,
                    elevationCenter: m
                };
            }
            handleFlyTo(e1, i) {
                const o = void 0 !== i.zoom, a = e1.center, r = e1.zoom, s = e1.padding, n = !e1.isPaddingEqual(i.padding), l = e1.applyConstrain(t.W.convert(i.center || i.locationAtOffset), r).center, c = o ? +i.zoom : e1.zoom + bi(e1.center.lat, l.lat), h = e1.clone();
                h.setCenter(l), h.setZoom(c), h.setBearing(i.bearing);
                const u = new t.P(t.al(e1.centerPoint.x + i.offsetAsPoint.x, 0, e1.width), t.al(e1.centerPoint.y + i.offsetAsPoint.y, 0, e1.height));
                h.setLocationAtPoint(l, u);
                const d = h.center;
                Gt(e1, d);
                const _ = function(e1, i, o) {
                    const a = fi(i), r = fi(o), s = t.b3(a, r), n = Math.acos(s), l = pi(e1);
                    return n / (2 * Math.PI) * l;
                }(e1, a, d), p = r + bi(a.lat, 0), m = c + bi(d.lat, 0), f = t.ao(m - p);
                let g;
                if ("number" == typeof i.minZoom) {
                    const o = +i.minZoom + bi(d.lat, 0), a = Math.min(o, p, m) + bi(0, d.lat), r = e1.applyConstrain(d, a).zoom + bi(d.lat, 0);
                    g = t.ao(r - p);
                }
                const v = t.bJ(a.lng, d.lng), x = t.bJ(a.lat, d.lat);
                return {
                    easeFunc: (o, r, l, h)=>{
                        const u = Ti(a, v, x, l);
                        n && e1.interpolatePadding(s, i.padding, o);
                        const _ = 1 === o ? d : u;
                        e1.setCenter(_.wrap());
                        const m = p + t.ar(r);
                        e1.setZoom(1 === o ? c : m + bi(0, _.lat));
                    },
                    scaleOfZoom: f,
                    targetCenter: d,
                    scaleOfMinZoom: g,
                    pixelPathLength: _
                };
            }
            static solveVectorScale(e1, t, i, o, a) {
                const r = "x" === o ? [
                    i[0],
                    i[4],
                    i[8],
                    i[12]
                ] : [
                    i[1],
                    i[5],
                    i[9],
                    i[13]
                ], s = [
                    i[3],
                    i[7],
                    i[11],
                    i[15]
                ], n = e1[0] * r[0] + e1[1] * r[1] + e1[2] * r[2], l = e1[0] * s[0] + e1[1] * s[1] + e1[2] * s[2], c = t[0] * r[0] + t[1] * r[1] + t[2] * r[2], h = t[0] * s[0] + t[1] * s[1] + t[2] * s[2];
                return c + a * l === n + a * h || s[3] * (n - c) + r[3] * (h - l) + n * h == c * l ? null : (c + r[3] - a * h - a * s[3]) / (c - n - a * h + a * l);
            }
            static getLesserNonNegativeNonNull(e1, t) {
                return null !== t && t >= 0 && t < e1 ? t : e1;
            }
        }
        class Ai {
            constructor(e1){
                this._globe = e1, this._mercatorCameraHelper = new Jt, this._verticalPerspectiveCameraHelper = new Di;
            }
            get useGlobeControls() {
                return this._globe.useGlobeRendering;
            }
            get currentHelper() {
                return this.useGlobeControls ? this._verticalPerspectiveCameraHelper : this._mercatorCameraHelper;
            }
            handlePanInertia(e1, t) {
                return this.currentHelper.handlePanInertia(e1, t);
            }
            handleMapControlsRollPitchBearingZoom(e1, t) {
                this.currentHelper.handleMapControlsRollPitchBearingZoom(e1, t);
            }
            handleMapControlsPan(e1, t, i) {
                this.currentHelper.handleMapControlsPan(e1, t, i);
            }
            cameraForBoxAndBearing(e1, t, i, o, a) {
                return this.currentHelper.cameraForBoxAndBearing(e1, t, i, o, a);
            }
            handleJumpToCenterZoom(e1, t) {
                this.currentHelper.handleJumpToCenterZoom(e1, t);
            }
            handleEaseTo(e1, t) {
                return this.currentHelper.handleEaseTo(e1, t);
            }
            handleFlyTo(e1, t) {
                return this.currentHelper.handleFlyTo(e1, t);
            }
        }
        const Li = (e1, i)=>t.C(e1, null == i ? void 0 : i.filter((e1)=>"source.canvas" !== e1.identifier)), Fi = t.bN();
        class ki extends t.E {
            constructor(e1, i = {}){
                var o, a;
                super(), this._rtlPluginLoaded = ()=>{
                    for(const e1 in this.tileManagers){
                        const t = this.tileManagers[e1].getSource().type;
                        "vector" !== t && "geojson" !== t || this.tileManagers[e1].reload();
                    }
                }, this.map = e1, this.dispatcher = new k(F(), e1._getMapId()), this.dispatcher.registerMessageHandler("GG", (e1, t)=>this.getGlyphs(e1, t)), this.dispatcher.registerMessageHandler("GI", (e1, t)=>this.getImages(e1, t)), this.dispatcher.registerMessageHandler("GDA", (e1, t)=>this.getDashes(e1, t)), this.imageManager = new g, this.imageManager.setEventedParent(this);
                const r = (null === (o = e1._container) || void 0 === o ? void 0 : o.lang) || "undefined" != typeof document && (null === (a = document.documentElement) || void 0 === a ? void 0 : a.lang) || void 0;
                this.glyphManager = new T(e1._requestManager, i.localIdeographFontFamily, r), this.lineAtlas = new S(256, 512), this.crossTileSymbolIndex = new At, this._setInitialValues(), this._resetUpdates(), this.dispatcher.broadcast("SR", t.bO()), ce().on(se, this._rtlPluginLoaded), this.on("data", (e1)=>{
                    if ("source" !== e1.dataType || "metadata" !== e1.sourceDataType) return;
                    const t = this.tileManagers[e1.sourceId];
                    if (!t) return;
                    const i = t.getSource();
                    if (null == i ? void 0 : i.vectorLayerIds) for(const e1 in this._layers){
                        const t = this._layers[e1];
                        t.source === i.id && this._validateLayer(t);
                    }
                });
            }
            _setInitialValues() {
                var e1;
                this._spritesImagesIds = {}, this._layers = {}, this._order = [], this.tileManagers = {}, this.zoomHistory = new t.bP, this._availableImages = [], this._globalState = {}, this._serializedLayers = {}, this.stylesheet = null, this.light = null, this.sky = null, this.projection && (this.projection.destroy(), delete this.projection), this._loaded = !1, this._changed = !1, this._updatedLayers = {}, this._updatedSources = {}, this._changedImages = {}, this._glyphsDidChange = !1, this._updatedPaintProps = {}, this._layerOrderChanged = !1, this.crossTileSymbolIndex = new ((null === (e1 = this.crossTileSymbolIndex) || void 0 === e1 ? void 0 : e1.constructor) || Object), this.pauseablePlacement = void 0, this.placement = void 0, this.z = 0;
            }
            setGlobalStateProperty(e1, i) {
                var o, a, r;
                this._checkLoaded();
                const s = null === i ? null !== (r = null === (a = null === (o = this.stylesheet.state) || void 0 === o ? void 0 : o[e1]) || void 0 === a ? void 0 : a.default) && void 0 !== r ? r : null : i;
                if (t.bQ(s, this._globalState[e1])) return this;
                this._globalState[e1] = s, this._applyGlobalStateChanges([
                    e1
                ]);
            }
            getGlobalState() {
                return this._globalState;
            }
            setGlobalState(e1) {
                this._checkLoaded();
                const i = [];
                for(const o in e1)!t.bQ(this._globalState[o], e1[o].default) && (i.push(o), this._globalState[o] = e1[o].default);
                this._applyGlobalStateChanges(i);
            }
            _applyGlobalStateChanges(e1) {
                if (0 === e1.length) return;
                const t = new Set, i = {};
                for (const o of e1){
                    i[o] = this._globalState[o];
                    for(const e1 in this._layers){
                        const i = this._layers[e1], a = i.getLayoutAffectingGlobalStateRefs(), r = i.getPaintAffectingGlobalStateRefs(), s = i.getVisibilityAffectingGlobalStateRefs();
                        if (a.has(o) && t.add(i.source), r.has(o)) for (const { name: e1, value: t } of r.get(o))this._updatePaintProperty(i, e1, t);
                        (null == s ? void 0 : s.has(o)) && (i.recalculateVisibility(), this._updateLayer(i));
                    }
                }
                this.dispatcher.broadcast("UGS", i);
                for(const e1 in this.tileManagers)t.has(e1) && (this._reloadSource(e1), this._changed = !0);
            }
            loadURL(e1) {
                return t._(this, arguments, void 0, function*(e1, i = {}, o) {
                    this.fire(new t.n("dataloading", {
                        dataType: "style"
                    })), i.validate = "boolean" != typeof i.validate || i.validate, this._loadStyleRequest = new AbortController;
                    const a = this._loadStyleRequest;
                    try {
                        const r = yield this.map._requestManager.transformRequest(e1, "Style");
                        t.bR(a.signal);
                        const s = yield t.k(r, a);
                        this._loadStyleRequest === a && (this._loadStyleRequest = null), this._load(s.data, i, o);
                    } catch (e1) {
                        this._loadStyleRequest === a && (this._loadStyleRequest = null), e1 && !a.signal.aborted && this.fire(new t.l(t.d(e1)));
                    }
                });
            }
            loadJSON(e1, i = {}, o) {
                this.fire(new t.n("dataloading", {
                    dataType: "style"
                })), this._frameRequest = new AbortController, n.frameAsync(this._frameRequest, this.map._ownerWindow).then(()=>{
                    this._frameRequest = null, i.validate = !1 !== i.validate, this._load(e1, i, o);
                }).catch(()=>{});
            }
            loadEmpty() {
                this.fire(new t.n("dataloading", {
                    dataType: "style"
                })), this._load(Fi, {
                    validate: !1
                });
            }
            _load(e1, i, o) {
                var a, r;
                let s = i.transformStyle ? i.transformStyle(o, e1) : e1;
                if (!i.validate || !Li(this, t.F(s))) {
                    s = Object.assign({}, s), this._loaded = !0, this.stylesheet = s;
                    for(const e1 in s.sources)this.addSource(e1, s.sources[e1], {
                        validate: !1
                    });
                    s.sprite ? this._loadSprite(s.sprite) : this.imageManager.setLoaded(!0), this.glyphManager.setURL(s.glyphs), this._createLayers(), this.light = new M(this.stylesheet.light), this._setProjectionInternal((null === (a = this.stylesheet.projection) || void 0 === a ? void 0 : a.type) || "mercator"), this.sky = new E(this.stylesheet.sky), this.map.setTerrain(null !== (r = this.stylesheet.terrain) && void 0 !== r ? r : null), this.fire(new t.n("data", {
                        dataType: "style"
                    })), this.fire(new t.n("style.load"));
                }
            }
            _createLayers() {
                var e1, i, o;
                const a = t.bS(this.stylesheet.layers);
                this.setGlobalState(null !== (e1 = this.stylesheet.state) && void 0 !== e1 ? e1 : null), this.dispatcher.broadcast("SL", a), this._order = a.map((e1)=>e1.id), this._layers = {}, this._serializedLayers = null;
                for (const e1 of a){
                    const a = t.bT(e1, this._globalState);
                    if (a.setEventedParent(this, {
                        layer: {
                            id: e1.id
                        }
                    }), this._layers[e1.id] = a, t.bU(a) && this.tileManagers[a.source]) {
                        const t = null !== (o = null === (i = e1.paint) || void 0 === i ? void 0 : i["raster-fade-duration"]) && void 0 !== o ? o : a.paint.get("raster-fade-duration");
                        this.tileManagers[a.source].setRasterFadeDuration(t);
                    }
                }
            }
            _loadSprite(e1, i = !1, o) {
                this.imageManager.setLoaded(!1);
                const a = new AbortController;
                let r;
                this._spriteRequest = a, (function(e1, i, o, a) {
                    return t._(this, void 0, void 0, function*() {
                        const r = p(e1), s = o > 1 ? "@2x" : "", l = {}, c = {};
                        for (const { id: e1, url: o } of r){
                            const r = yield i.transformRequest(m(o, s, ".json"), "SpriteJSON");
                            l[e1] = t.k(r, a);
                            const n = yield i.transformRequest(m(o, s, ".png"), "SpriteImage");
                            c[e1] = u.getImage(n, a);
                        }
                        return yield Promise.all([
                            ...Object.values(l),
                            ...Object.values(c)
                        ]), function(e1, i) {
                            return t._(this, void 0, void 0, function*() {
                                const t = {};
                                for(const o in e1){
                                    t[o] = {};
                                    const a = n.getImageCanvasContext((yield i[o]).data), r = (yield e1[o]).data;
                                    for(const e1 in r){
                                        const { width: i, height: s, x: n, y: l, sdf: c, pixelRatio: h, stretchX: u, stretchY: d, content: _, textFitWidth: p, textFitHeight: m } = r[e1];
                                        t[o][e1] = {
                                            data: null,
                                            pixelRatio: h,
                                            sdf: c,
                                            stretchX: u,
                                            stretchY: d,
                                            content: _,
                                            textFitWidth: p,
                                            textFitHeight: m,
                                            spriteData: {
                                                width: i,
                                                height: s,
                                                x: n,
                                                y: l,
                                                context: a
                                            }
                                        };
                                    }
                                }
                                return t;
                            });
                        }(l, c);
                    });
                })(e1, this.map._requestManager, this.map.getPixelRatio(), this._spriteRequest).then((e1)=>{
                    if (this._spriteRequest = null, e1) for(const t in e1){
                        this._spritesImagesIds[t] = [];
                        const o = this._spritesImagesIds[t] ? this._spritesImagesIds[t].filter((t)=>!(t in e1)) : [];
                        for (const e1 of o)this.imageManager.removeImage(e1), this._changedImages[e1] = !0;
                        for(const o in e1[t]){
                            const a = "default" === t ? o : `${t}:${o}`;
                            this._spritesImagesIds[t].push(a), a in this.imageManager.images ? this.imageManager.updateImage(a, e1[t][o], !1) : this.imageManager.addImage(a, e1[t][o]), i && (this._changedImages[a] = !0);
                        }
                    }
                }).catch((e1)=>{
                    this._spriteRequest = null, r = e1, a.signal.aborted || this.fire(new t.l(r));
                }).finally(()=>{
                    this.imageManager.setLoaded(!0), this._availableImages = this.imageManager.listImages(), i && (this._changed = !0), this.dispatcher.broadcast("SI", this._availableImages), this.fire(new t.n("data", {
                        dataType: "style"
                    })), o && o(r);
                });
            }
            _unloadSprite() {
                for (const e1 of Object.values(this._spritesImagesIds).flat())this.imageManager.removeImage(e1), this._changedImages[e1] = !0;
                this._spritesImagesIds = {}, this._availableImages = this.imageManager.listImages(), this._changed = !0, this.dispatcher.broadcast("SI", this._availableImages), this.fire(new t.n("data", {
                    dataType: "style"
                }));
            }
            _validateLayer(e1) {
                const i = this.tileManagers[e1.source];
                if (!i) return;
                const o = e1.sourceLayer;
                if (!o) return;
                const a = i.getSource();
                ("geojson" === a.type || a.vectorLayerIds && !a.vectorLayerIds.includes(o)) && this.fire(new t.l(new Error(`Source layer "${o}" does not exist on source "${a.id}" as specified by style layer "${e1.id}".`)));
            }
            loaded() {
                if (!this._loaded) return !1;
                if (Object.keys(this._updatedSources).length) return !1;
                for(const e1 in this.tileManagers)if (!this.tileManagers[e1].loaded()) return !1;
                return this.imageManager.isLoaded();
            }
            _serializeByIds(e1, i = !1) {
                const o = this._serializedAllLayers();
                if (!e1 || 0 === e1.length) return Object.values(i ? t.bV(o) : o);
                const a = [];
                for (const r of e1)if (o[r]) {
                    const e1 = i ? t.bV(o[r]) : o[r];
                    a.push(e1);
                }
                return a;
            }
            _serializedAllLayers() {
                let e1 = this._serializedLayers;
                if (e1) return e1;
                e1 = this._serializedLayers = {};
                const t = Object.keys(this._layers);
                for (const i of t){
                    const t = this._layers[i];
                    "custom" !== t.type && (e1[i] = t.serialize());
                }
                return e1;
            }
            hasTransitions() {
                var e1, t, i;
                if (null === (e1 = this.light) || void 0 === e1 ? void 0 : e1.hasTransition()) return !0;
                if (null === (t = this.sky) || void 0 === t ? void 0 : t.hasTransition()) return !0;
                if (null === (i = this.projection) || void 0 === i ? void 0 : i.hasTransition()) return !0;
                for(const e1 in this.tileManagers)if (this.tileManagers[e1].hasTransition()) return !0;
                for(const e1 in this._layers)if (this._layers[e1].hasTransition()) return !0;
                return !1;
            }
            _checkLoaded() {
                if (!this._loaded) throw new Error("Style is not done loading.");
            }
            update(e1) {
                if (!this._loaded) return;
                const i = this._changed;
                if (i) {
                    const t = Object.keys(this._updatedLayers), i = Object.keys(this._removedLayers);
                    (t.length || i.length) && this._updateWorkerLayers(t, i);
                    for(const e1 in this._updatedSources){
                        const t = this._updatedSources[e1];
                        if ("reload" === t) this._reloadSource(e1);
                        else {
                            if ("clear" !== t) throw new Error(`Invalid action ${t}`);
                            this._clearSource(e1);
                        }
                    }
                    this._updateTilesForChangedImages(), this._updateTilesForChangedGlyphs();
                    for(const t in this._updatedPaintProps)this._layers[t].updateTransitions(e1);
                    this.light.updateTransitions(e1), this.sky.updateTransitions(e1), this._resetUpdates();
                }
                const o = {};
                for(const e1 in this.tileManagers){
                    const t = this.tileManagers[e1];
                    o[e1] = t.used, t.used = !1;
                }
                for (const t of this._order){
                    const i = this._layers[t];
                    i.recalculate(e1, this._availableImages), !i.isHidden(e1.zoom) && i.source && (this.tileManagers[i.source].used = !0);
                }
                for(const e1 in o){
                    const i = this.tileManagers[e1];
                    !!o[e1] != !!i.used && i.fire(new t.n("data", {
                        sourceDataType: "visibility",
                        dataType: "source",
                        sourceId: e1
                    }));
                }
                this.light.recalculate(e1), this.sky.recalculate(e1), this.projection.recalculate(e1), this.z = e1.zoom, i && this.fire(new t.n("data", {
                    dataType: "style"
                }));
            }
            _updateTilesForChangedImages() {
                const e1 = Object.keys(this._changedImages);
                if (e1.length) {
                    for(const t in this.tileManagers)this.tileManagers[t].reloadTilesForDependencies([
                        "icons",
                        "patterns"
                    ], e1);
                    this._changedImages = {};
                }
            }
            _updateTilesForChangedGlyphs() {
                if (this._glyphsDidChange) {
                    for(const e1 in this.tileManagers)this.tileManagers[e1].reloadTilesForDependencies([
                        "glyphs"
                    ], [
                        ""
                    ]);
                    this._glyphsDidChange = !1;
                }
            }
            _updateWorkerLayers(e1, t) {
                this.dispatcher.broadcast("UL", {
                    layers: this._serializeByIds(e1, !1),
                    removedIds: t
                });
            }
            _resetUpdates() {
                this._changed = !1, this._updatedLayers = {}, this._removedLayers = {}, this._updatedSources = {}, this._updatedPaintProps = {}, this._changedImages = {}, this._glyphsDidChange = !1;
            }
            setState(e1, i = {}) {
                var o;
                this._checkLoaded();
                const a = this.serialize();
                if (e1 = i.transformStyle ? i.transformStyle(a, e1) : e1, (null === (o = i.validate) || void 0 === o || o) && Li(this, t.F(e1))) return !1;
                (e1 = t.bV(e1)).layers = t.bS(e1.layers);
                const r = t.bW(a, e1), s = this._getOperationsToPerform(r);
                if (s.unimplemented.length > 0) throw new Error(`Unimplemented: ${s.unimplemented.join(", ")}.`);
                if (0 === s.operations.length) return !1;
                for (const e1 of s.operations)e1();
                return this.stylesheet = e1, this._serializedLayers = null, this.fire(new t.n("style.load", {
                    style: this
                })), !0;
            }
            _getOperationsToPerform(e1) {
                const t = [], i = [];
                for (const o of e1)switch(o.command){
                    case "setCenter":
                    case "setZoom":
                    case "setBearing":
                    case "setPitch":
                    case "setRoll":
                        continue;
                    case "addLayer":
                        t.push(()=>this.addLayer.apply(this, o.args));
                        break;
                    case "removeLayer":
                        t.push(()=>this.removeLayer.apply(this, o.args));
                        break;
                    case "setPaintProperty":
                        t.push(()=>this.setPaintProperty.apply(this, o.args));
                        break;
                    case "setLayoutProperty":
                        t.push(()=>this.setLayoutProperty.apply(this, o.args));
                        break;
                    case "setFilter":
                        t.push(()=>this.setFilter.apply(this, o.args));
                        break;
                    case "addSource":
                        t.push(()=>this.addSource.apply(this, o.args));
                        break;
                    case "removeSource":
                        t.push(()=>this.removeSource.apply(this, o.args));
                        break;
                    case "setLayerZoomRange":
                        t.push(()=>this.setLayerZoomRange.apply(this, o.args));
                        break;
                    case "setLight":
                        t.push(()=>this.setLight.apply(this, o.args));
                        break;
                    case "setGeoJSONSourceData":
                        t.push(()=>this.setGeoJSONSourceData.apply(this, o.args));
                        break;
                    case "setGlyphs":
                        t.push(()=>this.setGlyphs.apply(this, o.args));
                        break;
                    case "setSprite":
                        t.push(()=>this.setSprite.apply(this, o.args));
                        break;
                    case "setTerrain":
                        t.push(()=>this.map.setTerrain.apply(this, o.args));
                        break;
                    case "setSky":
                        t.push(()=>this.setSky.apply(this, o.args));
                        break;
                    case "setProjection":
                        this.setProjection.apply(this, o.args);
                        break;
                    case "setGlobalState":
                        t.push(()=>this.setGlobalState.apply(this, o.args));
                        break;
                    case "setTransition":
                        t.push(()=>{});
                        break;
                    default:
                        i.push(o.command);
                }
                return {
                    operations: t,
                    unimplemented: i
                };
            }
            addImage(e1, i) {
                if (this.getImage(e1)) return this.fire(new t.l(new Error(`An image named "${e1}" already exists.`)));
                this.imageManager.addImage(e1, i), this._afterImageUpdated(e1);
            }
            updateImage(e1, t) {
                this.imageManager.updateImage(e1, t);
            }
            getImage(e1) {
                return this.imageManager.getImage(e1);
            }
            removeImage(e1) {
                if (!this.getImage(e1)) return this.fire(new t.l(new Error(`An image named "${e1}" does not exist.`)));
                this.imageManager.removeImage(e1), this._afterImageUpdated(e1);
            }
            _afterImageUpdated(e1) {
                this._availableImages = this.imageManager.listImages(), this._changedImages[e1] = !0, this._changed = !0, this.dispatcher.broadcast("SI", this._availableImages), this.fire(new t.n("data", {
                    dataType: "style"
                }));
            }
            listImages() {
                return this._checkLoaded(), this.imageManager.listImages();
            }
            addSource(e1, i, o = {}) {
                var a;
                if (this._checkLoaded(), void 0 !== this.tileManagers[e1]) throw new Error(`Source "${e1}" already exists.`);
                if (!i.type) throw new Error(`The type property must be defined, but only the following properties were given: ${Object.keys(i).join(", ")}.`);
                if ([
                    "vector",
                    "raster",
                    "geojson",
                    "video",
                    "image"
                ].includes(i.type) && this._validate(t.F.source, `sources.${e1}`, i, null, o)) return;
                (null === (a = this.map) || void 0 === a ? void 0 : a._collectResourceTiming) && (i.collectResourceTiming = !0);
                const r = this.tileManagers[e1] = new Fe(e1, i, this.dispatcher);
                r.style = this, r.setEventedParent(this, ()=>({
                        isSourceLoaded: r.loaded(),
                        source: r.serialize(),
                        sourceId: e1
                    })), r.onAdd(this.map), this._changed = !0;
            }
            removeSource(e1) {
                if (this._checkLoaded(), void 0 === this.tileManagers[e1]) throw new Error(`There is no source with this ID=${e1}`);
                for(const i in this._layers)if (this._layers[i].source === e1) return this.fire(new t.l(new Error(`Source "${e1}" cannot be removed while layer "${i}" is using it.`)));
                const i = this.tileManagers[e1];
                delete this.tileManagers[e1], delete this._updatedSources[e1], i.fire(new t.n("data", {
                    sourceDataType: "metadata",
                    dataType: "source",
                    sourceId: e1
                })), i.setEventedParent(null), i.onRemove(this.map), this._changed = !0;
            }
            setGeoJSONSourceData(e1, t) {
                if (this._checkLoaded(), void 0 === this.tileManagers[e1]) throw new Error(`There is no source with this ID=${e1}`);
                const i = this.tileManagers[e1].getSource();
                if ("geojson" !== i.type) throw new Error(`geojsonSource.type is ${i.type}, which is !== 'geojson`);
                i.setData(t), this._changed = !0;
            }
            getSource(e1) {
                var t;
                return null === (t = this.tileManagers[e1]) || void 0 === t ? void 0 : t.getSource();
            }
            addLayer(e1, i, o = {}) {
                this._checkLoaded();
                const a = e1.id;
                if (this.getLayer(a)) return void this.fire(new t.l(new Error(`Layer "${a}" already exists on this map.`)));
                let r;
                if ("custom" === e1.type) {
                    if (Li(this, t.bX(e1))) return;
                    r = t.bT(e1, this._globalState);
                } else {
                    if ("source" in e1 && "object" == typeof e1.source && (this.addSource(a, e1.source), e1 = t.bV(e1), e1 = t.e(e1, {
                        source: a
                    })), this._validate(t.F.layer, `layers.${a}`, e1, {
                        arrayIndex: -1
                    }, o)) return;
                    r = t.bT(e1, this._globalState), this._validateLayer(r), r.setEventedParent(this, {
                        layer: {
                            id: a
                        }
                    });
                }
                const s = i ? this._order.indexOf(i) : this._order.length;
                if (i && -1 === s) this.fire(new t.l(new Error(`Cannot add layer "${a}" before non-existing layer "${i}".`)));
                else {
                    if (this._order.splice(s, 0, a), this._layerOrderChanged = !0, this._layers[a] = r, this._removedLayers[a] && r.source && "custom" !== r.type) {
                        const e1 = this._removedLayers[a];
                        delete this._removedLayers[a], e1.type !== r.type ? this._updatedSources[r.source] = "clear" : (this._updatedSources[r.source] = "reload", this.tileManagers[r.source].pause());
                    }
                    this._updateLayer(r), r.onAdd && r.onAdd(this.map);
                }
            }
            moveLayer(e1, i) {
                if (this._checkLoaded(), this._changed = !0, !this._layers[e1]) return void this.fire(new t.l(new Error(`The layer '${e1}' does not exist in the map's style and cannot be moved.`)));
                if (e1 === i) return;
                const o = this._order.indexOf(e1);
                this._order.splice(o, 1);
                const a = i ? this._order.indexOf(i) : this._order.length;
                i && -1 === a ? this.fire(new t.l(new Error(`Cannot move layer "${e1}" before non-existing layer "${i}".`))) : (this._order.splice(a, 0, e1), this._layerOrderChanged = !0);
            }
            removeLayer(e1) {
                this._checkLoaded();
                const i = this._layers[e1];
                if (!i) return void this.fire(new t.l(new Error(`Cannot remove non-existing layer "${e1}".`)));
                i.setEventedParent(null);
                const o = this._order.indexOf(e1);
                this._order.splice(o, 1), this._layerOrderChanged = !0, this._changed = !0, this._removedLayers[e1] = i, delete this._layers[e1], this._serializedLayers && delete this._serializedLayers[e1], delete this._updatedLayers[e1], delete this._updatedPaintProps[e1], i.onRemove && i.onRemove(this.map);
            }
            getLayer(e1) {
                return this._layers[e1];
            }
            getLayersOrder() {
                return [
                    ...this._order
                ];
            }
            hasLayer(e1) {
                return e1 in this._layers;
            }
            setLayerZoomRange(e1, i, o) {
                this._checkLoaded();
                const a = this.getLayer(e1);
                a ? a.minzoom === i && a.maxzoom === o || (null != i && (a.minzoom = i), null != o && (a.maxzoom = o), this._updateLayer(a)) : this.fire(new t.l(new Error(`Cannot set the zoom range of non-existing layer "${e1}".`)));
            }
            setFilter(e1, i, o = {}) {
                this._checkLoaded();
                const a = this.getLayer(e1);
                if (a) {
                    if (!t.bQ(a.filter, i)) return null == i ? (a.setFilter(void 0), void this._updateLayer(a)) : void (this._validate(t.F.filter, `layers.${a.id}.filter`, i, null, o) || (a.setFilter(t.bV(i)), this._updateLayer(a)));
                } else this.fire(new t.l(new Error(`Cannot filter non-existing layer "${e1}".`)));
            }
            getFilter(e1) {
                return t.bV(this.getLayer(e1).filter);
            }
            setLayoutProperty(e1, i, o, a = {}) {
                this._checkLoaded();
                const r = this.getLayer(e1);
                r ? t.bQ(r.getLayoutProperty(i), o) || (r.setLayoutProperty(i, o, a), this._updateLayer(r)) : this.fire(new t.l(new Error(`Cannot style non-existing layer "${e1}".`)));
            }
            getLayoutProperty(e1, i) {
                const o = this.getLayer(e1);
                if (o) return o.getLayoutProperty(i);
                this.fire(new t.l(new Error(`Cannot get style of non-existing layer "${e1}".`)));
            }
            setPaintProperty(e1, i, o, a = {}) {
                this._checkLoaded();
                const r = this.getLayer(e1);
                r ? t.bQ(r.getPaintProperty(i), o) || this._updatePaintProperty(r, i, o, a) : this.fire(new t.l(new Error(`Cannot style non-existing layer "${e1}".`)));
            }
            _updatePaintProperty(e1, i, o, a = {}) {
                e1.setPaintProperty(i, o, a) && this._updateLayer(e1), t.bU(e1) && "raster-fade-duration" === i && this.tileManagers[e1.source].setRasterFadeDuration(o), this._changed = !0, this._updatedPaintProps[e1.id] = !0, this._serializedLayers = null;
            }
            getPaintProperty(e1, t) {
                return this.getLayer(e1).getPaintProperty(t);
            }
            setFeatureState(e1, i) {
                this._checkLoaded();
                const o = e1.source, a = e1.sourceLayer, r = this.tileManagers[o];
                if (void 0 === r) return void this.fire(new t.l(new Error(`The source '${o}' does not exist in the map's style.`)));
                const s = r.getSource().type;
                "geojson" === s && a ? this.fire(new t.l(new Error("GeoJSON sources cannot have a sourceLayer parameter."))) : "vector" !== s || a ? (void 0 === e1.id && this.fire(new t.l(new Error("The feature id parameter must be provided."))), r.setFeatureState(a, e1.id, i)) : this.fire(new t.l(new Error("The sourceLayer parameter must be provided for vector source types.")));
            }
            removeFeatureState(e1, i) {
                this._checkLoaded();
                const o = e1.source, a = this.tileManagers[o];
                if (void 0 === a) return void this.fire(new t.l(new Error(`The source '${o}' does not exist in the map's style.`)));
                const r = a.getSource().type, s = "vector" === r ? e1.sourceLayer : void 0;
                "vector" !== r || s ? i && "string" != typeof e1.id && "number" != typeof e1.id ? this.fire(new t.l(new Error("A feature id is required to remove its specific state property."))) : a.removeFeatureState(s, e1.id, i) : this.fire(new t.l(new Error("The sourceLayer parameter must be provided for vector source types.")));
            }
            getFeatureState(e1) {
                this._checkLoaded();
                const i = e1.source, o = e1.sourceLayer, a = this.tileManagers[i];
                if (void 0 !== a) return "vector" !== a.getSource().type || o ? (void 0 === e1.id && this.fire(new t.l(new Error("The feature id parameter must be provided."))), a.getFeatureState(o, e1.id)) : void this.fire(new t.l(new Error("The sourceLayer parameter must be provided for vector source types.")));
                this.fire(new t.l(new Error(`The source '${i}' does not exist in the map's style.`)));
            }
            getTransition() {
                var e1;
                return t.e({
                    duration: 300,
                    delay: 0
                }, null === (e1 = this.stylesheet) || void 0 === e1 ? void 0 : e1.transition);
            }
            serialize() {
                if (!this._loaded) return;
                const e1 = t.bY(this.tileManagers, (e1)=>e1.serialize()), i = this._serializeByIds(this._order, !0), o = this.map.getTerrain() || void 0, a = this.stylesheet;
                return t.bZ({
                    version: a.version,
                    name: a.name,
                    metadata: a.metadata,
                    light: a.light,
                    sky: a.sky,
                    center: a.center,
                    zoom: a.zoom,
                    bearing: a.bearing,
                    pitch: a.pitch,
                    sprite: a.sprite,
                    glyphs: a.glyphs,
                    transition: a.transition,
                    projection: a.projection,
                    sources: e1,
                    layers: i,
                    terrain: o
                }, (e1)=>void 0 !== e1);
            }
            _updateLayer(e1) {
                this._updatedLayers[e1.id] = !0, e1.source && !this._updatedSources[e1.source] && "raster" !== this.tileManagers[e1.source].getSource().type && (this._updatedSources[e1.source] = "reload", this.tileManagers[e1.source].pause()), this._serializedLayers = null, this._changed = !0;
            }
            _flattenAndSortRenderedFeatures(e1) {
                const t = (e1)=>"fill-extrusion" === this._layers[e1].type, i = {}, o = [];
                for(let a = this._order.length - 1; a >= 0; a--){
                    const r = this._order[a];
                    if (t(r)) {
                        i[r] = a;
                        for (const t of e1){
                            const e1 = t[r];
                            if (e1) for (const t of e1)o.push(t);
                        }
                    }
                }
                o.sort((e1, t)=>t.intersectionZ - e1.intersectionZ);
                const a = [];
                for(let r = this._order.length - 1; r >= 0; r--){
                    const s = this._order[r];
                    if (t(s)) for(let e1 = o.length - 1; e1 >= 0; e1--){
                        const t = o[e1].feature;
                        if (i[t.layer.id] < r) break;
                        a.push(t), o.pop();
                    }
                    else for (const t of e1){
                        const e1 = t[s];
                        if (e1) for (const t of e1)a.push(t.feature);
                    }
                }
                return a;
            }
            queryRenderedFeatures(e1, i, o) {
                (null == i ? void 0 : i.filter) && this._validate(t.F.filter, "queryRenderedFeatures.filter", i.filter, null, i);
                const a = {};
                if (null == i ? void 0 : i.layers) {
                    if (!(Array.isArray(i.layers) || i.layers instanceof Set)) return this.fire(new t.l(new Error("parameters.layers must be an Array or a Set of strings"))), [];
                    for (const e1 of i.layers){
                        const i = this._layers[e1];
                        if (!i) return this.fire(new t.l(new Error(`The layer '${e1}' does not exist in the map's style and cannot be queried for features.`))), [];
                        a[i.source] = !0;
                    }
                }
                const r = [];
                i.availableImages = this._availableImages;
                const s = this._serializedAllLayers(), n = i.layers instanceof Set ? i.layers : Array.isArray(i.layers) ? new Set(i.layers) : null, l = Object.assign(Object.assign({}, i), {
                    layers: n,
                    globalState: this._globalState
                });
                for(const t in this.tileManagers)i.layers && !a[t] || r.push(j(this.tileManagers[t], this._layers, s, e1, l, o, this.map.terrain ? (e1, t, i)=>this.map.terrain.getElevation(e1, t, i) : void 0));
                return this.placement && r.push(function(e1, t, i, o, a, r, s) {
                    const n = {}, l = r.queryRenderedSymbols(o), c = [];
                    for (const e1 of Object.keys(l).map(Number))c.push(s[e1]);
                    c.sort(N);
                    for (const i of c){
                        const o = i.featureIndex.lookupSymbolFeatures(l[i.bucketInstanceId], t, i.bucketIndex, i.sourceLayerIndex, {
                            filterSpec: a.filter,
                            globalState: a.globalState
                        }, a.layers, a.availableImages, e1);
                        for(const e1 in o){
                            n[e1] || (n[e1] = []);
                            const t = o[e1];
                            t.sort((e1, t)=>{
                                const o = i.featureSortOrder;
                                if (o) {
                                    const i = o.indexOf(e1.featureIndex);
                                    return o.indexOf(t.featureIndex) - i;
                                }
                                return t.featureIndex - e1.featureIndex;
                            });
                            for (const i of t)n[e1].push(i);
                        }
                    }
                    return function(e1, t, i) {
                        for(const o in e1)for (const a of e1[o])Z(a, i[t[o].source]);
                        return e1;
                    }(n, e1, i);
                }(this._layers, s, this.tileManagers, e1, l, this.placement.collisionIndex, this.placement.retainedQueryData)), this._flattenAndSortRenderedFeatures(r);
            }
            querySourceFeatures(e1, i) {
                (null == i ? void 0 : i.filter) && this._validate(t.F.filter, "querySourceFeatures.filter", i.filter, null, i);
                const o = this.tileManagers[e1];
                return o ? function(e1, t) {
                    const i = e1.getRenderableIds().map((t)=>e1.getTileByID(t)), o = [], a = {};
                    for (const e1 of i){
                        const i = e1.tileID.canonical.key;
                        a[i] || (a[i] = !0, e1.querySourceFeatures(o, t));
                    }
                    return o;
                }(o, i ? Object.assign(Object.assign({}, i), {
                    globalState: this._globalState
                }) : {
                    globalState: this._globalState
                }) : [];
            }
            getLight() {
                return this.light.getLight();
            }
            setLight(e1, i = {}) {
                this._checkLoaded();
                const o = this.light.getLight();
                let a = !1;
                for(const i in e1)if (!t.bQ(e1[i], o[i])) {
                    a = !0;
                    break;
                }
                if (!a) return;
                const r = {
                    now: c(),
                    transition: t.e({
                        duration: 300,
                        delay: 0
                    }, this.stylesheet.transition)
                };
                this.light.setLight(e1, i), this.light.updateTransitions(r);
            }
            getProjection() {
                var e1;
                return null === (e1 = this.stylesheet) || void 0 === e1 ? void 0 : e1.projection;
            }
            setProjection(e1) {
                this._checkLoaded();
                const t = null != e1 ? e1 : {
                    type: "mercator"
                };
                if (this.stylesheet.projection = e1, this.projection) {
                    if (this.projection.name === t.type) return;
                    this.projection.destroy(), delete this.projection;
                }
                this._setProjectionInternal(t.type);
            }
            getSky() {
                var e1;
                return null === (e1 = this.stylesheet) || void 0 === e1 ? void 0 : e1.sky;
            }
            setSky(e1, i = {}) {
                this._checkLoaded();
                const o = this.getSky();
                let a = !1;
                if (!e1 && !o) return;
                if (e1 && !o) a = !0;
                else if (!e1 && o) a = !0;
                else for(const i in e1)if (!t.bQ(e1[i], o[i])) {
                    a = !0;
                    break;
                }
                if (!a) return;
                const r = {
                    now: c(),
                    transition: t.e({
                        duration: 300,
                        delay: 0
                    }, this.stylesheet.transition)
                };
                this.stylesheet.sky = e1, this.sky.setSky(e1, i), this.sky.updateTransitions(r);
            }
            _setProjectionInternal(e1) {
                const i = function(e1, i) {
                    const o = {
                        constrainOverride: i
                    };
                    if (Array.isArray(e1)) {
                        const t = new _i({
                            type: e1
                        });
                        return {
                            projection: t,
                            transform: new Ri(o),
                            cameraHelper: new Ai(t)
                        };
                    }
                    switch(e1){
                        case "mercator":
                            return {
                                projection: new Zt,
                                transform: new Xt(o),
                                cameraHelper: new Jt
                            };
                        case "globe":
                            {
                                const e1 = new _i({
                                    type: [
                                        "interpolate",
                                        [
                                            "linear"
                                        ],
                                        [
                                            "zoom"
                                        ],
                                        11,
                                        "vertical-perspective",
                                        12,
                                        "mercator"
                                    ]
                                });
                                return {
                                    projection: e1,
                                    transform: new Ri(o),
                                    cameraHelper: new Ai(e1)
                                };
                            }
                        case "vertical-perspective":
                            return {
                                projection: new ui,
                                transform: new zi(o),
                                cameraHelper: new Di
                            };
                        default:
                            return t.w(`Unknown projection name: ${e1}. Falling back to mercator projection.`), {
                                projection: new Zt,
                                transform: new Xt(o),
                                cameraHelper: new Jt
                            };
                    }
                }(e1, this.map.transformConstrain);
                this.projection = i.projection, this.map.migrateProjection(i.transform, i.cameraHelper);
                for(const e1 in this.tileManagers)this.tileManagers[e1].reload();
            }
            _validate(e1, i, o, a, r = {}) {
                return !1 !== (null == r ? void 0 : r.validate) && Li(this, e1.call(t.F, t.e({
                    key: i,
                    style: this.serialize(),
                    value: o,
                    styleSpec: t.x
                }, a)));
            }
            _remove(e1 = !0) {
                this._frameRequest && (this._frameRequest.abort(), this._frameRequest = null), this._loadStyleRequest && (this._loadStyleRequest.abort(), this._loadStyleRequest = null), this._spriteRequest && (this._spriteRequest.abort(), this._spriteRequest = null), ce().off(se, this._rtlPluginLoaded);
                for(const e1 in this._layers)this._layers[e1].setEventedParent(null);
                for(const e1 in this.tileManagers){
                    const t = this.tileManagers[e1];
                    t.setEventedParent(null), t.onRemove(this.map);
                }
                this.imageManager.setEventedParent(null), this.setEventedParent(null), e1 && this.dispatcher.broadcast("RM", void 0), this.dispatcher.remove(e1);
            }
            _clearSource(e1) {
                this.tileManagers[e1].clearTiles();
            }
            _reloadSource(e1) {
                this.tileManagers[e1].resume(), this.tileManagers[e1].reload();
            }
            _updateSources(e1) {
                for(const t in this.tileManagers)this.tileManagers[t].update(e1, this.map.terrain);
            }
            _generateCollisionBoxes() {
                for(const e1 in this.tileManagers)this._reloadSource(e1);
            }
            _updatePlacement(e1, t, i, o, a = !1) {
                let r = !1, s = !1;
                const n = {};
                for (const t of this._order){
                    const i = this._layers[t];
                    if ("symbol" !== i.type) continue;
                    if (!n[i.source]) {
                        const e1 = this.tileManagers[i.source];
                        n[i.source] = e1.getRenderableIds(!0).map((t)=>e1.getTileByID(t)).sort((e1, t)=>t.tileID.overscaledZ - e1.tileID.overscaledZ || (e1.tileID.isLessThan(t.tileID) ? -1 : 1));
                    }
                    const o = this.crossTileSymbolIndex.addLayer(i, n[i.source], e1.center.lng);
                    r || (r = o);
                }
                if (this.crossTileSymbolIndex.pruneUnusedLayers(this._order), a || (a = this._layerOrderChanged || 0 === i), (a || !this.pauseablePlacement || this.pauseablePlacement.isDone() && !this.placement.stillRecent(c(), e1.zoom)) && (this.pauseablePlacement = new Et(e1, this.map.terrain, this._order, a, t, i, o, this.placement), this._layerOrderChanged = !1), this.pauseablePlacement.isDone() ? this.placement.setStale() : (this.pauseablePlacement.continuePlacement(this._order, this._layers, n), this.pauseablePlacement.isDone() && (this.placement = this.pauseablePlacement.commit(c()), s = !0), r && this.pauseablePlacement.placement.setStale()), s || r) for (const e1 of this._order){
                    const t = this._layers[e1];
                    "symbol" === t.type && this.placement.updateLayerOpacities(t, n[t.source]);
                }
                return !this.pauseablePlacement.isDone() || this.placement.hasTransitions(c());
            }
            _releaseSymbolFadeTiles() {
                for(const e1 in this.tileManagers)this.tileManagers[e1].releaseSymbolFadeTiles();
            }
            getImages(e1, i) {
                return t._(this, void 0, void 0, function*() {
                    const e1 = yield this.imageManager.getImages(i.icons);
                    this._updateTilesForChangedImages();
                    const t = this.tileManagers[i.source];
                    return t && t.setDependencies(i.tileID.key, i.type, i.icons), e1;
                });
            }
            getGlyphs(e1, i) {
                return t._(this, void 0, void 0, function*() {
                    const e1 = yield this.glyphManager.getGlyphs(i.stacks), t = this.tileManagers[i.source];
                    return t && t.setDependencies(i.tileID.key, i.type, [
                        ""
                    ]), e1;
                });
            }
            getGlyphsUrl() {
                return this.stylesheet.glyphs || null;
            }
            setGlyphs(e1, i = {}) {
                this._checkLoaded(), e1 && this._validate(t.F.glyphs, "glyphs", e1, null, i) || (this._glyphsDidChange = !0, this.stylesheet.glyphs = e1, this.glyphManager.entries = {}, this.glyphManager.setURL(e1));
            }
            getDashes(e1, i) {
                return t._(this, void 0, void 0, function*() {
                    const e1 = {};
                    for (const [t, o] of Object.entries(i.dashes))e1[t] = this.lineAtlas.getDash(o.dasharray, o.round);
                    return e1;
                });
            }
            addSprite(e1, i, o = {}, a) {
                this._checkLoaded();
                const r = [
                    {
                        id: e1,
                        url: i
                    }
                ], s = [
                    ...p(this.stylesheet.sprite),
                    ...r
                ];
                this._validate(t.F.sprite, "sprite", s, null, o) || (this.stylesheet.sprite = s, this._loadSprite(r, !0, a));
            }
            removeSprite(e1) {
                this._checkLoaded();
                const i = p(this.stylesheet.sprite);
                if (i.find((t)=>t.id === e1)) {
                    if (this._spritesImagesIds[e1]) for (const t of this._spritesImagesIds[e1])this.imageManager.removeImage(t), this._changedImages[t] = !0;
                    i.splice(i.findIndex((t)=>t.id === e1), 1), this.stylesheet.sprite = i.length > 0 ? i : void 0, delete this._spritesImagesIds[e1], this._availableImages = this.imageManager.listImages(), this._changed = !0, this.dispatcher.broadcast("SI", this._availableImages), this.fire(new t.n("data", {
                        dataType: "style"
                    }));
                } else this.fire(new t.l(new Error(`Sprite "${e1}" doesn't exists on this map.`)));
            }
            getSprite() {
                return p(this.stylesheet.sprite);
            }
            setSprite(e1, i = {}, o) {
                this._checkLoaded(), e1 && this._validate(t.F.sprite, "sprite", e1, null, i) || (this.stylesheet.sprite = e1, e1 ? this._loadSprite(e1, !0, o) : (this._unloadSprite(), o && o(null)));
            }
            destroy() {
                this._frameRequest && (this._frameRequest.abort(), this._frameRequest = null), this._loadStyleRequest && (this._loadStyleRequest.abort(), this._loadStyleRequest = null), this._spriteRequest && (this._spriteRequest.abort(), this._spriteRequest = null);
                for(const e1 in this.tileManagers){
                    const t = this.tileManagers[e1];
                    t.setEventedParent(null), t.onRemove(this.map);
                }
                this.tileManagers = {}, this.imageManager && (this.imageManager.setEventedParent(null), this.imageManager.destroy(), this._availableImages = [], this._spritesImagesIds = {}), this.glyphManager && this.glyphManager.destroy();
                for(const e1 in this._layers){
                    const t = this._layers[e1];
                    t.setEventedParent(null), t.onRemove && t.onRemove(this.map);
                }
                this._setInitialValues(), this.setEventedParent(null), this.dispatcher.unregisterMessageHandler("GG"), this.dispatcher.unregisterMessageHandler("GI"), this.dispatcher.unregisterMessageHandler("GDA"), this.dispatcher.remove(!0), this._listeners = {}, this._oneTimeListeners = {};
            }
        }
        var Bi = t.aS([
            {
                name: "a_pos",
                type: "Int16",
                components: 2
            },
            {
                name: "a_texture_pos",
                type: "Int16",
                components: 2
            }
        ]);
        class Oi {
            constructor(){
                this.boundProgram = null, this.boundLayoutVertexBuffer = null, this.boundPaintVertexBuffers = [], this.boundIndexBuffer = null, this.boundVertexOffset = null, this.boundDynamicVertexBuffer = null, this.vao = null;
            }
            bind(e1, t, i, o, a, r, s, n, l) {
                this.context = e1;
                let c = this.boundPaintVertexBuffers.length !== o.length;
                for(let e1 = 0; !c && e1 < o.length; e1++)this.boundPaintVertexBuffers[e1] !== o[e1] && (c = !0);
                !this.vao || this.boundProgram !== t || this.boundLayoutVertexBuffer !== i || c || this.boundIndexBuffer !== a || this.boundVertexOffset !== r || this.boundDynamicVertexBuffer !== s || this.boundDynamicVertexBuffer2 !== n || this.boundDynamicVertexBuffer3 !== l ? this.freshBind(t, i, o, a, r, s, n, l) : (e1.bindVertexArray.set(this.vao), s && s.bind(), (null == a ? void 0 : a.dynamicDraw) && a.bind(), n && n.bind(), l && l.bind());
            }
            freshBind(e1, t, i, o, a, r, s, n) {
                const l = e1.numAttributes, c = this.context, h = c.gl;
                this.vao && this.destroy(), this.vao = c.createVertexArray(), c.bindVertexArray.set(this.vao), this.boundProgram = e1, this.boundLayoutVertexBuffer = t, this.boundPaintVertexBuffers = i, this.boundIndexBuffer = o, this.boundVertexOffset = a, this.boundDynamicVertexBuffer = r, this.boundDynamicVertexBuffer2 = s, this.boundDynamicVertexBuffer3 = n, t.enableAttributes(h, e1);
                for (const t of i)t.enableAttributes(h, e1);
                r && r.enableAttributes(h, e1), s && s.enableAttributes(h, e1), n && n.enableAttributes(h, e1), t.bind(), t.setVertexAttribPointers(h, e1, a);
                for (const t of i)t.bind(), t.setVertexAttribPointers(h, e1, a);
                r && (r.bind(), r.setVertexAttribPointers(h, e1, a)), o && o.bind(), s && (s.bind(), s.setVertexAttribPointers(h, e1, a)), n && (n.bind(), n.setVertexAttribPointers(h, e1, a)), c.currentNumAttributes = l;
            }
            destroy() {
                this.vao && (this.context.deleteVertexArray(this.vao), this.vao = null);
            }
        }
        const ji = (e1, i, o, a, r)=>({
                u_texture: 0,
                u_ele_delta: e1,
                u_fog_matrix: i,
                u_fog_color: o ? o.properties.get("fog-color") : t.bo.white,
                u_fog_ground_blend: o ? o.properties.get("fog-ground-blend") : 1,
                u_fog_ground_blend_opacity: r ? 0 : o ? o.calculateFogBlendOpacity(a) : 0,
                u_horizon_color: o ? o.properties.get("horizon-color") : t.bo.white,
                u_horizon_fog_blend: o ? o.properties.get("horizon-fog-blend") : 1,
                u_is_globe_mode: r ? 1 : 0
            }), Ni = {
            mainMatrix: "u_projection_matrix",
            tileMercatorCoords: "u_projection_tile_mercator_coords",
            clippingPlane: "u_projection_clipping_plane",
            projectionTransition: "u_projection_transition",
            fallbackMatrix: "u_projection_fallback_matrix"
        };
        function Zi(e1) {
            const t = [];
            for (const i of e1){
                if (null === i) continue;
                const e1 = i.split(" ");
                t.push(e1.pop());
            }
            return t;
        }
        class Ui {
            constructor(e1, i, o, a, r, s, n, l, c = []){
                const h = e1.gl;
                this.program = h.createProgram();
                const u = Zi(i.staticAttributes), d = o ? o.getBinderAttributes() : [], _ = u.concat(d), p = Ft.prelude.staticUniforms ? Zi(Ft.prelude.staticUniforms) : [], m = n.staticUniforms ? Zi(n.staticUniforms) : [], f = i.staticUniforms ? Zi(i.staticUniforms) : [], g = o ? o.getBinderUniforms() : [], v = p.concat(m).concat(f).concat(g), x = [];
                for (const e1 of v)x.includes(e1) || x.push(e1);
                const b = o ? o.defines() : [];
                si(h) && b.unshift("#version 300 es"), r && b.push("#define OVERDRAW_INSPECTOR;"), s && b.push("#define TERRAIN3D;"), l && b.push(l), c && b.push(...c);
                let y = b.concat(Ft.prelude.fragmentSource, n.fragmentSource, i.fragmentSource).join("\n"), w = b.concat(Ft.prelude.vertexSource, n.vertexSource, i.vertexSource).join("\n");
                si(h) || (y = function(e1) {
                    return e1.replace(/\bin\s/g, "varying ").replace("out highp vec4 fragColor;", "").replace(/fragColor/g, "gl_FragColor").replace(/texture\(/g, "texture2D(");
                }(y), w = function(e1) {
                    return e1.replace(/\bin\s/g, "attribute ").replace(/\bout\s/g, "varying ").replace(/texture\(/g, "texture2D(");
                }(w));
                const T = h.createShader(h.FRAGMENT_SHADER);
                if (h.isContextLost()) return void (this.failedToCreate = !0);
                if (h.shaderSource(T, y), h.compileShader(T), !h.getShaderParameter(T, h.COMPILE_STATUS)) throw new Error(`Could not compile fragment shader: ${h.getShaderInfoLog(T)}`);
                h.attachShader(this.program, T);
                const P = h.createShader(h.VERTEX_SHADER);
                if (h.isContextLost()) return void (this.failedToCreate = !0);
                if (h.shaderSource(P, w), h.compileShader(P), !h.getShaderParameter(P, h.COMPILE_STATUS)) throw new Error(`Could not compile vertex shader: ${h.getShaderInfoLog(P)}`);
                h.attachShader(this.program, P), this.attributes = {};
                const C = {};
                this.numAttributes = _.length;
                for(let e1 = 0; e1 < this.numAttributes; e1++)_[e1] && (h.bindAttribLocation(this.program, e1, _[e1]), this.attributes[_[e1]] = e1);
                if (h.linkProgram(this.program), !h.getProgramParameter(this.program, h.LINK_STATUS)) throw new Error(`Program failed to link: ${h.getProgramInfoLog(this.program)}`);
                h.deleteShader(P), h.deleteShader(T);
                for (const e1 of x)if (e1 && !C[e1]) {
                    const t = h.getUniformLocation(this.program, e1);
                    t && (C[e1] = t);
                }
                this.fixedUniforms = a(e1, C), this.terrainUniforms = ((e1, i)=>({
                        u_depth: new t.b_(e1, i.u_depth),
                        u_terrain: new t.b_(e1, i.u_terrain),
                        u_terrain_dim: new t.bp(e1, i.u_terrain_dim),
                        u_terrain_matrix: new t.c0(e1, i.u_terrain_matrix),
                        u_terrain_unpack: new t.c1(e1, i.u_terrain_unpack),
                        u_terrain_exaggeration: new t.bp(e1, i.u_terrain_exaggeration)
                    }))(e1, C), this.projectionUniforms = ((e1, i)=>({
                        u_projection_matrix: new t.c0(e1, i.u_projection_matrix),
                        u_projection_tile_mercator_coords: new t.c1(e1, i.u_projection_tile_mercator_coords),
                        u_projection_clipping_plane: new t.c1(e1, i.u_projection_clipping_plane),
                        u_projection_transition: new t.bp(e1, i.u_projection_transition),
                        u_projection_fallback_matrix: new t.c0(e1, i.u_projection_fallback_matrix)
                    }))(e1, C), this.binderUniforms = o ? o.getUniforms(e1, C) : [];
            }
            draw(e1, t, i, o, a, r, s, n, l, c, h, u, d, _, p, m, f, g, v) {
                var x;
                const b = e1.gl;
                if (this.failedToCreate) return;
                if (e1.program.set(this.program), e1.setDepthMode(i), e1.setStencilMode(o), e1.setColorMode(a), e1.setCullFace(r), n) {
                    e1.activeTexture.set(b.TEXTURE2), b.bindTexture(b.TEXTURE_2D, n.depthTexture), e1.activeTexture.set(b.TEXTURE3), b.bindTexture(b.TEXTURE_2D, n.texture);
                    for(const e1 in this.terrainUniforms)this.terrainUniforms[e1].set(n[e1]);
                }
                if (l) for(const e1 in l)this.projectionUniforms[Ni[e1]].set(l[e1]);
                if (s) for(const e1 in this.fixedUniforms)this.fixedUniforms[e1].set(s[e1]);
                m && m.setUniforms(e1, this.binderUniforms, _, {
                    zoom: p
                });
                let y = 0;
                switch(t){
                    case b.LINES:
                        y = 2;
                        break;
                    case b.TRIANGLES:
                        y = 3;
                        break;
                    case b.LINE_STRIP:
                        y = 1;
                }
                for (const i of d.get())i.vaos || (i.vaos = {}), (x = i.vaos)[c] || (x[c] = new Oi), i.vaos[c].bind(e1, this, h, m ? m.getPaintVertexBuffers() : [], u, i.vertexOffset, f, g, v), b.drawElements(t, i.primitiveLength * y, b.UNSIGNED_SHORT, i.primitiveOffset * y * 2);
            }
        }
        function Gi(e1, i, o) {
            const a = 1 / t.aK(o, 1, i.transform.tileZoom), r = Math.pow(2, o.tileID.overscaledZ), s = o.tileSize * Math.pow(2, i.transform.tileZoom) / r, n = s * (o.tileID.canonical.x + o.tileID.wrap * r), l = s * o.tileID.canonical.y;
            return {
                u_image: 0,
                u_texsize: o.imageAtlasTexture.size,
                u_scale: [
                    a,
                    e1.fromScale,
                    e1.toScale
                ],
                u_fade: e1.t,
                u_pixel_coord_upper: [
                    n >> 16,
                    l >> 16
                ],
                u_pixel_coord_lower: [
                    65535 & n,
                    65535 & l
                ]
            };
        }
        const Vi = (e1, i, o, a)=>{
            const r = e1.style.light, s = r.properties.get("position"), n = [
                s.x,
                s.y,
                s.z
            ], l = t.c4();
            "viewport" === r.properties.get("anchor") && t.c5(l, e1.transform.bearingInRadians), t.c6(n, n, l);
            const c = e1.transform.transformLightDirection(n), h = r.properties.get("color");
            return {
                u_lightpos: n,
                u_lightpos_globe: c,
                u_lightintensity: r.properties.get("intensity"),
                u_lightcolor: [
                    h.r,
                    h.g,
                    h.b
                ],
                u_vertical_gradient: +i,
                u_opacity: o,
                u_fill_translate: a
            };
        }, Wi = (e1, i, o, a, r, s, n)=>t.e(Vi(e1, i, o, a), Gi(s, e1, n), {
                u_height_factor: -Math.pow(2, r.overscaledZ) / n.tileSize / 8
            }), qi = (e1, i, o, a)=>t.e(Gi(i, e1, o), {
                u_fill_translate: a
            }), $i = (e1, t)=>({
                u_world: e1,
                u_fill_translate: t
            }), Hi = (e1, i, o, a, r)=>t.e(qi(e1, i, o, r), {
                u_world: a
            }), Xi = (e1, i, o, a, r)=>{
            const s = e1.transform;
            let n, l, c = 0;
            if ("map" === o.paint.get("circle-pitch-alignment")) {
                const e1 = t.aK(i, 1, s.zoom);
                n = !0, l = [
                    e1,
                    e1
                ], c = e1 / (t.a6 * Math.pow(2, i.tileID.overscaledZ)) * 2 * Math.PI * r;
            } else n = !1, l = s.pixelsToGLUnits;
            return {
                u_camera_to_center_distance: s.cameraToCenterDistance,
                u_scale_with_map: +("map" === o.paint.get("circle-pitch-scale")),
                u_pitch_with_map: +n,
                u_device_pixel_ratio: e1.pixelRatio,
                u_extrude_scale: l,
                u_globe_extrude_scale: c,
                u_translate: a
            };
        }, Ki = (e1)=>({
                u_pixel_extrude_scale: [
                    1 / e1.width,
                    1 / e1.height
                ]
            }), Yi = (e1)=>({
                u_viewport_size: [
                    e1.width,
                    e1.height
                ]
            }), Qi = (e1, t = 1)=>({
                u_color: e1,
                u_overlay: 0,
                u_overlay_scale: t
            }), Ji = (e1, i, o, a)=>{
            const r = t.aK(e1, 1, i) / (t.a6 * Math.pow(2, e1.tileID.overscaledZ)) * 2 * Math.PI * a;
            return {
                u_extrude_scale: t.aK(e1, 1, i),
                u_intensity: o,
                u_globe_extrude_scale: r
            };
        }, eo = (e1, i, o, a)=>{
            const r = t.O();
            t.c7(r, 0, e1.width, e1.height, 0, 0, 1);
            const s = e1.context.gl;
            return {
                u_matrix: r,
                u_world: [
                    s.drawingBufferWidth,
                    s.drawingBufferHeight
                ],
                u_image: o,
                u_color_ramp: a,
                u_opacity: i.paint.get("heatmap-opacity")
            };
        }, to = (e1, t, i)=>{
            const o = i.paint.get("hillshade-accent-color");
            let a;
            switch(i.paint.get("hillshade-method")){
                case "basic":
                    a = 4;
                    break;
                case "combined":
                    a = 1;
                    break;
                case "igor":
                    a = 2;
                    break;
                case "multidirectional":
                    a = 3;
                    break;
                default:
                    a = 0;
            }
            const r = i.getIlluminationProperties();
            for(let t = 0; t < r.directionRadians.length; t++)"viewport" === i.paint.get("hillshade-illumination-anchor") && (r.directionRadians[t] += e1.transform.bearingInRadians);
            return {
                u_image: 0,
                u_latrange: oo(0, t.tileID),
                u_exaggeration: i.paint.get("hillshade-exaggeration"),
                u_altitudes: r.altitudeRadians,
                u_azimuths: r.directionRadians,
                u_accent: o,
                u_method: a,
                u_highlights: r.highlightColor,
                u_shadows: r.shadowColor
            };
        }, io = (e1, i)=>{
            const o = i.stride, a = t.O();
            return t.c7(a, 0, t.a6, -t.a6, 0, 0, 1), t.Q(a, a, [
                0,
                -t.a6,
                0
            ]), {
                u_matrix: a,
                u_image: 1,
                u_dimension: [
                    o,
                    o
                ],
                u_zoom: e1.overscaledZ,
                u_unpack: i.getUnpackVector()
            };
        };
        function oo(e1, i) {
            const o = Math.pow(2, i.canonical.z), a = i.canonical.y;
            return [
                new t.a7(0, a / o).toLngLat().lat,
                new t.a7(0, (a + 1) / o).toLngLat().lat
            ];
        }
        const ao = (e1, t, i = 0)=>({
                u_image: 0,
                u_unpack: t.getUnpackVector(),
                u_dimension: [
                    t.stride,
                    t.stride
                ],
                u_elevation_stops: 1,
                u_color_stops: 4,
                u_color_ramp_size: i,
                u_opacity: e1.paint.get("color-relief-opacity")
            }), ro = (e1, i, o, a)=>{
            const r = e1.transform;
            return {
                u_translation: uo(e1, i, o),
                u_ratio: a / t.aK(i, 1, r.zoom),
                u_device_pixel_ratio: e1.pixelRatio,
                u_units_to_pixels: [
                    1 / r.pixelsToGLUnits[0],
                    1 / r.pixelsToGLUnits[1]
                ]
            };
        }, so = (e1, i, o, a, r)=>t.e(ro(e1, i, o, a), {
                u_image: 0,
                u_image_height: r
            }), no = (e1, i, o, a, r)=>{
            const s = e1.transform, n = ho(i, s);
            return {
                u_translation: uo(e1, i, o),
                u_texsize: i.imageAtlasTexture.size,
                u_ratio: a / t.aK(i, 1, s.zoom),
                u_device_pixel_ratio: e1.pixelRatio,
                u_image: 0,
                u_scale: [
                    n,
                    r.fromScale,
                    r.toScale
                ],
                u_fade: r.t,
                u_units_to_pixels: [
                    1 / s.pixelsToGLUnits[0],
                    1 / s.pixelsToGLUnits[1]
                ]
            };
        }, lo = (e1, i, o, a, r)=>{
            const s = ho(i, e1.transform);
            return t.e(ro(e1, i, o, a), {
                u_tileratio: s,
                u_crossfade_from: r.fromScale,
                u_crossfade_to: r.toScale,
                u_image: 0,
                u_mix: r.t,
                u_lineatlas_width: e1.lineAtlas.width,
                u_lineatlas_height: e1.lineAtlas.height
            });
        }, co = (e1, i, o, a, r, s)=>{
            const n = ho(i, e1.transform);
            return t.e(ro(e1, i, o, a), {
                u_image: 0,
                u_image_height: s,
                u_tileratio: n,
                u_crossfade_from: r.fromScale,
                u_crossfade_to: r.toScale,
                u_image_dash: 1,
                u_mix: r.t,
                u_lineatlas_width: e1.lineAtlas.width,
                u_lineatlas_height: e1.lineAtlas.height
            });
        };
        function ho(e1, i) {
            return 1 / t.aK(e1, 1, i.tileZoom);
        }
        function uo(e1, i, o) {
            return t.aL(e1.transform, i, o.paint.get("line-translate"), o.paint.get("line-translate-anchor"));
        }
        const _o = (e1, t, i, o, a)=>{
            var r, s;
            return {
                u_tl_parent: e1,
                u_scale_parent: t,
                u_buffer_scale: 1,
                u_fade_t: i.mix,
                u_opacity: i.opacity * o.paint.get("raster-opacity"),
                u_image0: 0,
                u_image1: 1,
                u_brightness_low: o.paint.get("raster-brightness-min"),
                u_brightness_high: o.paint.get("raster-brightness-max"),
                u_saturation_factor: (s = o.paint.get("raster-saturation"), s > 0 ? 1 - 1 / (1.001 - s) : -s),
                u_contrast_factor: (r = o.paint.get("raster-contrast"), r > 0 ? 1 / (1 - r) : 1 + r),
                u_spin_weights: po(o.paint.get("raster-hue-rotate")),
                u_coords_top: [
                    a[0].x,
                    a[0].y,
                    a[1].x,
                    a[1].y
                ],
                u_coords_bottom: [
                    a[3].x,
                    a[3].y,
                    a[2].x,
                    a[2].y
                ]
            };
        };
        function po(e1) {
            e1 *= Math.PI / 180;
            const t = Math.sin(e1), i = Math.cos(e1);
            return [
                (2 * i + 1) / 3,
                (-Math.sqrt(3) * t - i + 1) / 3,
                (Math.sqrt(3) * t - i + 1) / 3
            ];
        }
        const mo = (e1, t, i, o, a, r, s, n, l, c, h, u, d)=>{
            const _ = s.transform;
            return {
                u_is_size_zoom_constant: +("constant" === e1 || "source" === e1),
                u_is_size_feature_constant: +("constant" === e1 || "camera" === e1),
                u_size_t: t ? t.uSizeT : 0,
                u_size: t ? t.uSize : 0,
                u_camera_to_center_distance: _.cameraToCenterDistance,
                u_pitch: _.pitch / 360 * 2 * Math.PI,
                u_rotate_symbol: +i,
                u_aspect_ratio: _.width / _.height,
                u_fade_change: s.options.fadeDuration ? s.symbolFadeChange : 1,
                u_label_plane_matrix: n,
                u_coord_matrix: l,
                u_is_text: +h,
                u_pitch_with_map: +o,
                u_is_along_line: a,
                u_is_variable_anchor: r,
                u_texsize: u,
                u_texture: 0,
                u_translation: c,
                u_pitched_scale: d
            };
        }, fo = (e1, i, o, a, r, s, n, l, c, h, u, d, _, p)=>{
            const m = n.transform;
            return t.e(mo(e1, i, o, a, r, s, n, l, c, h, u, d, p), {
                u_gamma_scale: a ? Math.cos(m.pitch * Math.PI / 180) * m.cameraToCenterDistance : 1,
                u_device_pixel_ratio: n.pixelRatio,
                u_is_halo: _ ? 1 : 0,
                u_is_plain: 1
            });
        }, go = (e1, i, o, a, r, s, n, l, c, h, u, d, _)=>t.e(fo(e1, i, o, a, r, s, n, l, c, h, !0, u, !0, _), {
                u_texsize_icon: d,
                u_texture_icon: 1
            }), vo = (e1, t)=>({
                u_opacity: e1,
                u_color: t
            }), xo = (e1, i, o, a, r)=>t.e(function(e1, i, o, a) {
                const r = o.imageManager.getPattern(e1.from.toString()), s = o.imageManager.getPattern(e1.to.toString()), { width: n, height: l } = o.imageManager.getPixelSize(), c = Math.pow(2, a.tileID.overscaledZ), h = a.tileSize * Math.pow(2, o.transform.tileZoom) / c, u = h * (a.tileID.canonical.x + a.tileID.wrap * c), d = h * a.tileID.canonical.y;
                return {
                    u_image: 0,
                    u_pattern_tl_a: r.tl,
                    u_pattern_br_a: r.br,
                    u_pattern_tl_b: s.tl,
                    u_pattern_br_b: s.br,
                    u_texsize: [
                        n,
                        l
                    ],
                    u_mix: i.t,
                    u_pattern_size_a: r.displaySize,
                    u_pattern_size_b: s.displaySize,
                    u_scale_a: i.fromScale,
                    u_scale_b: i.toScale,
                    u_tile_units_to_pixels: 1 / t.aK(a, 1, o.transform.tileZoom),
                    u_pixel_coord_upper: [
                        u >> 16,
                        d >> 16
                    ],
                    u_pixel_coord_lower: [
                        65535 & u,
                        65535 & d
                    ]
                };
            }(o, r, i, a), {
                u_opacity: e1
            }), bo = (e1, t)=>{}, yo = {
            fillExtrusion: (e1, i)=>({
                    u_lightpos: new t.c2(e1, i.u_lightpos),
                    u_lightpos_globe: new t.c2(e1, i.u_lightpos_globe),
                    u_lightintensity: new t.bp(e1, i.u_lightintensity),
                    u_lightcolor: new t.c2(e1, i.u_lightcolor),
                    u_vertical_gradient: new t.bp(e1, i.u_vertical_gradient),
                    u_opacity: new t.bp(e1, i.u_opacity),
                    u_fill_translate: new t.c3(e1, i.u_fill_translate)
                }),
            fillExtrusionPattern: (e1, i)=>({
                    u_lightpos: new t.c2(e1, i.u_lightpos),
                    u_lightpos_globe: new t.c2(e1, i.u_lightpos_globe),
                    u_lightintensity: new t.bp(e1, i.u_lightintensity),
                    u_lightcolor: new t.c2(e1, i.u_lightcolor),
                    u_vertical_gradient: new t.bp(e1, i.u_vertical_gradient),
                    u_height_factor: new t.bp(e1, i.u_height_factor),
                    u_opacity: new t.bp(e1, i.u_opacity),
                    u_fill_translate: new t.c3(e1, i.u_fill_translate),
                    u_image: new t.b_(e1, i.u_image),
                    u_texsize: new t.c3(e1, i.u_texsize),
                    u_pixel_coord_upper: new t.c3(e1, i.u_pixel_coord_upper),
                    u_pixel_coord_lower: new t.c3(e1, i.u_pixel_coord_lower),
                    u_scale: new t.c2(e1, i.u_scale),
                    u_fade: new t.bp(e1, i.u_fade)
                }),
            fill: (e1, i)=>({
                    u_fill_translate: new t.c3(e1, i.u_fill_translate)
                }),
            fillPattern: (e1, i)=>({
                    u_image: new t.b_(e1, i.u_image),
                    u_texsize: new t.c3(e1, i.u_texsize),
                    u_pixel_coord_upper: new t.c3(e1, i.u_pixel_coord_upper),
                    u_pixel_coord_lower: new t.c3(e1, i.u_pixel_coord_lower),
                    u_scale: new t.c2(e1, i.u_scale),
                    u_fade: new t.bp(e1, i.u_fade),
                    u_fill_translate: new t.c3(e1, i.u_fill_translate)
                }),
            fillOutline: (e1, i)=>({
                    u_world: new t.c3(e1, i.u_world),
                    u_fill_translate: new t.c3(e1, i.u_fill_translate)
                }),
            fillOutlinePattern: (e1, i)=>({
                    u_world: new t.c3(e1, i.u_world),
                    u_image: new t.b_(e1, i.u_image),
                    u_texsize: new t.c3(e1, i.u_texsize),
                    u_pixel_coord_upper: new t.c3(e1, i.u_pixel_coord_upper),
                    u_pixel_coord_lower: new t.c3(e1, i.u_pixel_coord_lower),
                    u_scale: new t.c2(e1, i.u_scale),
                    u_fade: new t.bp(e1, i.u_fade),
                    u_fill_translate: new t.c3(e1, i.u_fill_translate)
                }),
            circle: (e1, i)=>({
                    u_camera_to_center_distance: new t.bp(e1, i.u_camera_to_center_distance),
                    u_scale_with_map: new t.b_(e1, i.u_scale_with_map),
                    u_pitch_with_map: new t.b_(e1, i.u_pitch_with_map),
                    u_extrude_scale: new t.c3(e1, i.u_extrude_scale),
                    u_device_pixel_ratio: new t.bp(e1, i.u_device_pixel_ratio),
                    u_globe_extrude_scale: new t.bp(e1, i.u_globe_extrude_scale),
                    u_translate: new t.c3(e1, i.u_translate)
                }),
            collisionBox: (e1, i)=>({
                    u_pixel_extrude_scale: new t.c3(e1, i.u_pixel_extrude_scale)
                }),
            collisionCircle: (e1, i)=>({
                    u_viewport_size: new t.c3(e1, i.u_viewport_size)
                }),
            debug: (e1, i)=>({
                    u_color: new t.b$(e1, i.u_color),
                    u_overlay: new t.b_(e1, i.u_overlay),
                    u_overlay_scale: new t.bp(e1, i.u_overlay_scale)
                }),
            depth: bo,
            clippingMask: bo,
            heatmap: (e1, i)=>({
                    u_extrude_scale: new t.bp(e1, i.u_extrude_scale),
                    u_intensity: new t.bp(e1, i.u_intensity),
                    u_globe_extrude_scale: new t.bp(e1, i.u_globe_extrude_scale)
                }),
            heatmapTexture: (e1, i)=>({
                    u_matrix: new t.c0(e1, i.u_matrix),
                    u_world: new t.c3(e1, i.u_world),
                    u_image: new t.b_(e1, i.u_image),
                    u_color_ramp: new t.b_(e1, i.u_color_ramp),
                    u_opacity: new t.bp(e1, i.u_opacity)
                }),
            hillshade: (e1, i)=>({
                    u_image: new t.b_(e1, i.u_image),
                    u_latrange: new t.c3(e1, i.u_latrange),
                    u_exaggeration: new t.bp(e1, i.u_exaggeration),
                    u_altitudes: new t.c9(e1, i.u_altitudes),
                    u_azimuths: new t.c9(e1, i.u_azimuths),
                    u_accent: new t.b$(e1, i.u_accent),
                    u_method: new t.b_(e1, i.u_method),
                    u_shadows: new t.c8(e1, i.u_shadows),
                    u_highlights: new t.c8(e1, i.u_highlights)
                }),
            hillshadePrepare: (e1, i)=>({
                    u_matrix: new t.c0(e1, i.u_matrix),
                    u_image: new t.b_(e1, i.u_image),
                    u_dimension: new t.c3(e1, i.u_dimension),
                    u_zoom: new t.bp(e1, i.u_zoom),
                    u_unpack: new t.c1(e1, i.u_unpack)
                }),
            colorRelief: (e1, i)=>({
                    u_image: new t.b_(e1, i.u_image),
                    u_unpack: new t.c1(e1, i.u_unpack),
                    u_dimension: new t.c3(e1, i.u_dimension),
                    u_elevation_stops: new t.b_(e1, i.u_elevation_stops),
                    u_color_stops: new t.b_(e1, i.u_color_stops),
                    u_color_ramp_size: new t.b_(e1, i.u_color_ramp_size),
                    u_opacity: new t.bp(e1, i.u_opacity)
                }),
            line: (e1, i)=>({
                    u_translation: new t.c3(e1, i.u_translation),
                    u_ratio: new t.bp(e1, i.u_ratio),
                    u_device_pixel_ratio: new t.bp(e1, i.u_device_pixel_ratio),
                    u_units_to_pixels: new t.c3(e1, i.u_units_to_pixels)
                }),
            lineGradient: (e1, i)=>({
                    u_translation: new t.c3(e1, i.u_translation),
                    u_ratio: new t.bp(e1, i.u_ratio),
                    u_device_pixel_ratio: new t.bp(e1, i.u_device_pixel_ratio),
                    u_units_to_pixels: new t.c3(e1, i.u_units_to_pixels),
                    u_image: new t.b_(e1, i.u_image),
                    u_image_height: new t.bp(e1, i.u_image_height)
                }),
            linePattern: (e1, i)=>({
                    u_translation: new t.c3(e1, i.u_translation),
                    u_texsize: new t.c3(e1, i.u_texsize),
                    u_ratio: new t.bp(e1, i.u_ratio),
                    u_device_pixel_ratio: new t.bp(e1, i.u_device_pixel_ratio),
                    u_image: new t.b_(e1, i.u_image),
                    u_units_to_pixels: new t.c3(e1, i.u_units_to_pixels),
                    u_scale: new t.c2(e1, i.u_scale),
                    u_fade: new t.bp(e1, i.u_fade)
                }),
            lineSDF: (e1, i)=>({
                    u_translation: new t.c3(e1, i.u_translation),
                    u_ratio: new t.bp(e1, i.u_ratio),
                    u_device_pixel_ratio: new t.bp(e1, i.u_device_pixel_ratio),
                    u_units_to_pixels: new t.c3(e1, i.u_units_to_pixels),
                    u_image: new t.b_(e1, i.u_image),
                    u_mix: new t.bp(e1, i.u_mix),
                    u_tileratio: new t.bp(e1, i.u_tileratio),
                    u_crossfade_from: new t.bp(e1, i.u_crossfade_from),
                    u_crossfade_to: new t.bp(e1, i.u_crossfade_to),
                    u_lineatlas_width: new t.bp(e1, i.u_lineatlas_width),
                    u_lineatlas_height: new t.bp(e1, i.u_lineatlas_height)
                }),
            lineGradientSDF: (e1, i)=>({
                    u_translation: new t.c3(e1, i.u_translation),
                    u_ratio: new t.bp(e1, i.u_ratio),
                    u_device_pixel_ratio: new t.bp(e1, i.u_device_pixel_ratio),
                    u_units_to_pixels: new t.c3(e1, i.u_units_to_pixels),
                    u_image: new t.b_(e1, i.u_image),
                    u_image_height: new t.bp(e1, i.u_image_height),
                    u_tileratio: new t.bp(e1, i.u_tileratio),
                    u_crossfade_from: new t.bp(e1, i.u_crossfade_from),
                    u_crossfade_to: new t.bp(e1, i.u_crossfade_to),
                    u_image_dash: new t.b_(e1, i.u_image_dash),
                    u_mix: new t.bp(e1, i.u_mix),
                    u_lineatlas_width: new t.bp(e1, i.u_lineatlas_width),
                    u_lineatlas_height: new t.bp(e1, i.u_lineatlas_height)
                }),
            raster: (e1, i)=>({
                    u_tl_parent: new t.c3(e1, i.u_tl_parent),
                    u_scale_parent: new t.bp(e1, i.u_scale_parent),
                    u_buffer_scale: new t.bp(e1, i.u_buffer_scale),
                    u_fade_t: new t.bp(e1, i.u_fade_t),
                    u_opacity: new t.bp(e1, i.u_opacity),
                    u_image0: new t.b_(e1, i.u_image0),
                    u_image1: new t.b_(e1, i.u_image1),
                    u_brightness_low: new t.bp(e1, i.u_brightness_low),
                    u_brightness_high: new t.bp(e1, i.u_brightness_high),
                    u_saturation_factor: new t.bp(e1, i.u_saturation_factor),
                    u_contrast_factor: new t.bp(e1, i.u_contrast_factor),
                    u_spin_weights: new t.c2(e1, i.u_spin_weights),
                    u_coords_top: new t.c1(e1, i.u_coords_top),
                    u_coords_bottom: new t.c1(e1, i.u_coords_bottom)
                }),
            symbolIcon: (e1, i)=>({
                    u_is_size_zoom_constant: new t.b_(e1, i.u_is_size_zoom_constant),
                    u_is_size_feature_constant: new t.b_(e1, i.u_is_size_feature_constant),
                    u_size_t: new t.bp(e1, i.u_size_t),
                    u_size: new t.bp(e1, i.u_size),
                    u_camera_to_center_distance: new t.bp(e1, i.u_camera_to_center_distance),
                    u_pitch: new t.bp(e1, i.u_pitch),
                    u_rotate_symbol: new t.b_(e1, i.u_rotate_symbol),
                    u_aspect_ratio: new t.bp(e1, i.u_aspect_ratio),
                    u_fade_change: new t.bp(e1, i.u_fade_change),
                    u_label_plane_matrix: new t.c0(e1, i.u_label_plane_matrix),
                    u_coord_matrix: new t.c0(e1, i.u_coord_matrix),
                    u_is_text: new t.b_(e1, i.u_is_text),
                    u_pitch_with_map: new t.b_(e1, i.u_pitch_with_map),
                    u_is_along_line: new t.b_(e1, i.u_is_along_line),
                    u_is_variable_anchor: new t.b_(e1, i.u_is_variable_anchor),
                    u_texsize: new t.c3(e1, i.u_texsize),
                    u_texture: new t.b_(e1, i.u_texture),
                    u_translation: new t.c3(e1, i.u_translation),
                    u_pitched_scale: new t.bp(e1, i.u_pitched_scale)
                }),
            symbolSDF: (e1, i)=>({
                    u_is_size_zoom_constant: new t.b_(e1, i.u_is_size_zoom_constant),
                    u_is_size_feature_constant: new t.b_(e1, i.u_is_size_feature_constant),
                    u_size_t: new t.bp(e1, i.u_size_t),
                    u_size: new t.bp(e1, i.u_size),
                    u_camera_to_center_distance: new t.bp(e1, i.u_camera_to_center_distance),
                    u_pitch: new t.bp(e1, i.u_pitch),
                    u_rotate_symbol: new t.b_(e1, i.u_rotate_symbol),
                    u_aspect_ratio: new t.bp(e1, i.u_aspect_ratio),
                    u_fade_change: new t.bp(e1, i.u_fade_change),
                    u_label_plane_matrix: new t.c0(e1, i.u_label_plane_matrix),
                    u_coord_matrix: new t.c0(e1, i.u_coord_matrix),
                    u_is_text: new t.b_(e1, i.u_is_text),
                    u_pitch_with_map: new t.b_(e1, i.u_pitch_with_map),
                    u_is_along_line: new t.b_(e1, i.u_is_along_line),
                    u_is_variable_anchor: new t.b_(e1, i.u_is_variable_anchor),
                    u_texsize: new t.c3(e1, i.u_texsize),
                    u_texture: new t.b_(e1, i.u_texture),
                    u_gamma_scale: new t.bp(e1, i.u_gamma_scale),
                    u_device_pixel_ratio: new t.bp(e1, i.u_device_pixel_ratio),
                    u_is_halo: new t.b_(e1, i.u_is_halo),
                    u_is_plain: new t.b_(e1, i.u_is_plain),
                    u_translation: new t.c3(e1, i.u_translation),
                    u_pitched_scale: new t.bp(e1, i.u_pitched_scale)
                }),
            symbolTextAndIcon: (e1, i)=>({
                    u_is_size_zoom_constant: new t.b_(e1, i.u_is_size_zoom_constant),
                    u_is_size_feature_constant: new t.b_(e1, i.u_is_size_feature_constant),
                    u_size_t: new t.bp(e1, i.u_size_t),
                    u_size: new t.bp(e1, i.u_size),
                    u_camera_to_center_distance: new t.bp(e1, i.u_camera_to_center_distance),
                    u_pitch: new t.bp(e1, i.u_pitch),
                    u_rotate_symbol: new t.b_(e1, i.u_rotate_symbol),
                    u_aspect_ratio: new t.bp(e1, i.u_aspect_ratio),
                    u_fade_change: new t.bp(e1, i.u_fade_change),
                    u_label_plane_matrix: new t.c0(e1, i.u_label_plane_matrix),
                    u_coord_matrix: new t.c0(e1, i.u_coord_matrix),
                    u_is_text: new t.b_(e1, i.u_is_text),
                    u_pitch_with_map: new t.b_(e1, i.u_pitch_with_map),
                    u_is_along_line: new t.b_(e1, i.u_is_along_line),
                    u_is_variable_anchor: new t.b_(e1, i.u_is_variable_anchor),
                    u_texsize: new t.c3(e1, i.u_texsize),
                    u_texsize_icon: new t.c3(e1, i.u_texsize_icon),
                    u_texture: new t.b_(e1, i.u_texture),
                    u_texture_icon: new t.b_(e1, i.u_texture_icon),
                    u_gamma_scale: new t.bp(e1, i.u_gamma_scale),
                    u_device_pixel_ratio: new t.bp(e1, i.u_device_pixel_ratio),
                    u_is_halo: new t.b_(e1, i.u_is_halo),
                    u_translation: new t.c3(e1, i.u_translation),
                    u_pitched_scale: new t.bp(e1, i.u_pitched_scale)
                }),
            background: (e1, i)=>({
                    u_opacity: new t.bp(e1, i.u_opacity),
                    u_color: new t.b$(e1, i.u_color)
                }),
            backgroundPattern: (e1, i)=>({
                    u_opacity: new t.bp(e1, i.u_opacity),
                    u_image: new t.b_(e1, i.u_image),
                    u_pattern_tl_a: new t.c3(e1, i.u_pattern_tl_a),
                    u_pattern_br_a: new t.c3(e1, i.u_pattern_br_a),
                    u_pattern_tl_b: new t.c3(e1, i.u_pattern_tl_b),
                    u_pattern_br_b: new t.c3(e1, i.u_pattern_br_b),
                    u_texsize: new t.c3(e1, i.u_texsize),
                    u_mix: new t.bp(e1, i.u_mix),
                    u_pattern_size_a: new t.c3(e1, i.u_pattern_size_a),
                    u_pattern_size_b: new t.c3(e1, i.u_pattern_size_b),
                    u_scale_a: new t.bp(e1, i.u_scale_a),
                    u_scale_b: new t.bp(e1, i.u_scale_b),
                    u_pixel_coord_upper: new t.c3(e1, i.u_pixel_coord_upper),
                    u_pixel_coord_lower: new t.c3(e1, i.u_pixel_coord_lower),
                    u_tile_units_to_pixels: new t.bp(e1, i.u_tile_units_to_pixels)
                }),
            terrain: (e1, i)=>({
                    u_texture: new t.b_(e1, i.u_texture),
                    u_ele_delta: new t.bp(e1, i.u_ele_delta),
                    u_fog_matrix: new t.c0(e1, i.u_fog_matrix),
                    u_fog_color: new t.b$(e1, i.u_fog_color),
                    u_fog_ground_blend: new t.bp(e1, i.u_fog_ground_blend),
                    u_fog_ground_blend_opacity: new t.bp(e1, i.u_fog_ground_blend_opacity),
                    u_horizon_color: new t.b$(e1, i.u_horizon_color),
                    u_horizon_fog_blend: new t.bp(e1, i.u_horizon_fog_blend),
                    u_is_globe_mode: new t.bp(e1, i.u_is_globe_mode)
                }),
            terrainDepth: (e1, i)=>({
                    u_ele_delta: new t.bp(e1, i.u_ele_delta)
                }),
            terrainCoords: (e1, i)=>({
                    u_texture: new t.b_(e1, i.u_texture),
                    u_terrain_coords_id: new t.bp(e1, i.u_terrain_coords_id),
                    u_ele_delta: new t.bp(e1, i.u_ele_delta)
                }),
            projectionErrorMeasurement: (e1, i)=>({
                    u_input: new t.bp(e1, i.u_input),
                    u_output_expected: new t.bp(e1, i.u_output_expected)
                }),
            atmosphere: (e1, i)=>({
                    u_sun_pos: new t.c2(e1, i.u_sun_pos),
                    u_atmosphere_blend: new t.bp(e1, i.u_atmosphere_blend),
                    u_globe_position: new t.c2(e1, i.u_globe_position),
                    u_globe_radius: new t.bp(e1, i.u_globe_radius),
                    u_inv_proj_matrix: new t.c0(e1, i.u_inv_proj_matrix)
                }),
            sky: (e1, i)=>({
                    u_sky_color: new t.b$(e1, i.u_sky_color),
                    u_horizon_color: new t.b$(e1, i.u_horizon_color),
                    u_horizon: new t.c3(e1, i.u_horizon),
                    u_horizon_normal: new t.c3(e1, i.u_horizon_normal),
                    u_sky_horizon_blend: new t.bp(e1, i.u_sky_horizon_blend),
                    u_sky_blend: new t.bp(e1, i.u_sky_blend)
                })
        };
        class wo {
            constructor(e1, t, i){
                this.context = e1;
                const o = e1.gl;
                this.buffer = o.createBuffer(), this.dynamicDraw = Boolean(i), this.context.unbindVAO(), e1.bindElementBuffer.set(this.buffer), o.bufferData(o.ELEMENT_ARRAY_BUFFER, t.arrayBuffer, this.dynamicDraw ? o.DYNAMIC_DRAW : o.STATIC_DRAW), this.dynamicDraw || t.freeBufferAfterUpload();
            }
            bind() {
                this.context.bindElementBuffer.set(this.buffer);
            }
            updateData(e1) {
                const t = this.context.gl;
                if (!this.dynamicDraw) throw new Error("Attempted to update data while not in dynamic mode.");
                this.context.unbindVAO(), this.bind(), t.bufferSubData(t.ELEMENT_ARRAY_BUFFER, 0, e1.arrayBuffer);
            }
            destroy() {
                this.buffer && (this.context.gl.deleteBuffer(this.buffer), delete this.buffer);
            }
        }
        const To = {
            Int8: "BYTE",
            Uint8: "UNSIGNED_BYTE",
            Int16: "SHORT",
            Uint16: "UNSIGNED_SHORT",
            Int32: "INT",
            Uint32: "UNSIGNED_INT",
            Float32: "FLOAT"
        };
        class Po {
            constructor(e1, t, i, o){
                this.length = t.length, this.attributes = i, this.itemSize = t.bytesPerElement, this.dynamicDraw = o, this.context = e1;
                const a = e1.gl;
                this.buffer = a.createBuffer(), e1.bindVertexBuffer.set(this.buffer), a.bufferData(a.ARRAY_BUFFER, t.arrayBuffer, this.dynamicDraw ? a.DYNAMIC_DRAW : a.STATIC_DRAW), this.dynamicDraw || t.freeBufferAfterUpload();
            }
            bind() {
                this.context.bindVertexBuffer.set(this.buffer);
            }
            updateData(e1) {
                if (e1.length !== this.length) throw new Error(`Length of new data is ${e1.length}, which doesn't match current length of ${this.length}`);
                const t = this.context.gl;
                this.bind(), t.bufferSubData(t.ARRAY_BUFFER, 0, e1.arrayBuffer);
            }
            enableAttributes(e1, t) {
                for (const i of this.attributes){
                    const o = t.attributes[i.name];
                    void 0 !== o && e1.enableVertexAttribArray(o);
                }
            }
            setVertexAttribPointers(e1, t, i) {
                for (const o of this.attributes){
                    const a = t.attributes[o.name];
                    void 0 !== a && e1.vertexAttribPointer(a, o.components, e1[To[o.type]], !1, this.itemSize, o.offset + this.itemSize * (i || 0));
                }
            }
            destroy() {
                this.buffer && (this.context.gl.deleteBuffer(this.buffer), delete this.buffer);
            }
        }
        class Co {
            constructor(e1){
                this.gl = e1.gl, this.default = this.getDefault(), this.current = this.default, this.dirty = !1;
            }
            get() {
                return this.current;
            }
            set(e1) {}
            getDefault() {
                return this.default;
            }
            setDefault() {
                this.set(this.default);
            }
        }
        class Mo extends Co {
            getDefault() {
                return t.bo.transparent;
            }
            set(e1) {
                const t = this.current;
                (e1.r !== t.r || e1.g !== t.g || e1.b !== t.b || e1.a !== t.a || this.dirty) && (this.gl.clearColor(e1.r, e1.g, e1.b, e1.a), this.current = e1, this.dirty = !1);
            }
        }
        class Io extends Co {
            getDefault() {
                return 1;
            }
            set(e1) {
                (e1 !== this.current || this.dirty) && (this.gl.clearDepth(e1), this.current = e1, this.dirty = !1);
            }
        }
        class Eo extends Co {
            getDefault() {
                return 0;
            }
            set(e1) {
                (e1 !== this.current || this.dirty) && (this.gl.clearStencil(e1), this.current = e1, this.dirty = !1);
            }
        }
        class So extends Co {
            getDefault() {
                return [
                    !0,
                    !0,
                    !0,
                    !0
                ];
            }
            set(e1) {
                const t = this.current;
                (e1[0] !== t[0] || e1[1] !== t[1] || e1[2] !== t[2] || e1[3] !== t[3] || this.dirty) && (this.gl.colorMask(e1[0], e1[1], e1[2], e1[3]), this.current = e1, this.dirty = !1);
            }
        }
        class zo extends Co {
            getDefault() {
                return !0;
            }
            set(e1) {
                (e1 !== this.current || this.dirty) && (this.gl.depthMask(e1), this.current = e1, this.dirty = !1);
            }
        }
        class Ro extends Co {
            getDefault() {
                return 255;
            }
            set(e1) {
                (e1 !== this.current || this.dirty) && (this.gl.stencilMask(e1), this.current = e1, this.dirty = !1);
            }
        }
        class Do extends Co {
            getDefault() {
                return {
                    func: this.gl.ALWAYS,
                    ref: 0,
                    mask: 255
                };
            }
            set(e1) {
                const t = this.current;
                (e1.func !== t.func || e1.ref !== t.ref || e1.mask !== t.mask || this.dirty) && (this.gl.stencilFunc(e1.func, e1.ref, e1.mask), this.current = e1, this.dirty = !1);
            }
        }
        class Ao extends Co {
            getDefault() {
                const e1 = this.gl;
                return [
                    e1.KEEP,
                    e1.KEEP,
                    e1.KEEP
                ];
            }
            set(e1) {
                const t = this.current;
                (e1[0] !== t[0] || e1[1] !== t[1] || e1[2] !== t[2] || this.dirty) && (this.gl.stencilOp(e1[0], e1[1], e1[2]), this.current = e1, this.dirty = !1);
            }
        }
        class Lo extends Co {
            getDefault() {
                return !1;
            }
            set(e1) {
                if (e1 === this.current && !this.dirty) return;
                const t = this.gl;
                e1 ? t.enable(t.STENCIL_TEST) : t.disable(t.STENCIL_TEST), this.current = e1, this.dirty = !1;
            }
        }
        class Fo extends Co {
            getDefault() {
                return [
                    0,
                    1
                ];
            }
            set(e1) {
                const t = this.current;
                (e1[0] !== t[0] || e1[1] !== t[1] || this.dirty) && (this.gl.depthRange(e1[0], e1[1]), this.current = e1, this.dirty = !1);
            }
        }
        class ko extends Co {
            getDefault() {
                return !1;
            }
            set(e1) {
                if (e1 === this.current && !this.dirty) return;
                const t = this.gl;
                e1 ? t.enable(t.DEPTH_TEST) : t.disable(t.DEPTH_TEST), this.current = e1, this.dirty = !1;
            }
        }
        class Bo extends Co {
            getDefault() {
                return this.gl.LESS;
            }
            set(e1) {
                (e1 !== this.current || this.dirty) && (this.gl.depthFunc(e1), this.current = e1, this.dirty = !1);
            }
        }
        class Oo extends Co {
            getDefault() {
                return !1;
            }
            set(e1) {
                if (e1 === this.current && !this.dirty) return;
                const t = this.gl;
                e1 ? t.enable(t.BLEND) : t.disable(t.BLEND), this.current = e1, this.dirty = !1;
            }
        }
        class jo extends Co {
            getDefault() {
                const e1 = this.gl;
                return [
                    e1.ONE,
                    e1.ZERO
                ];
            }
            set(e1) {
                const t = this.current;
                (e1[0] !== t[0] || e1[1] !== t[1] || this.dirty) && (this.gl.blendFunc(e1[0], e1[1]), this.current = e1, this.dirty = !1);
            }
        }
        class No extends Co {
            getDefault() {
                return t.bo.transparent;
            }
            set(e1) {
                const t = this.current;
                (e1.r !== t.r || e1.g !== t.g || e1.b !== t.b || e1.a !== t.a || this.dirty) && (this.gl.blendColor(e1.r, e1.g, e1.b, e1.a), this.current = e1, this.dirty = !1);
            }
        }
        class Zo extends Co {
            getDefault() {
                return this.gl.FUNC_ADD;
            }
            set(e1) {
                (e1 !== this.current || this.dirty) && (this.gl.blendEquation(e1), this.current = e1, this.dirty = !1);
            }
        }
        class Uo extends Co {
            getDefault() {
                return !1;
            }
            set(e1) {
                if (e1 === this.current && !this.dirty) return;
                const t = this.gl;
                e1 ? t.enable(t.CULL_FACE) : t.disable(t.CULL_FACE), this.current = e1, this.dirty = !1;
            }
        }
        class Go extends Co {
            getDefault() {
                return this.gl.BACK;
            }
            set(e1) {
                (e1 !== this.current || this.dirty) && (this.gl.cullFace(e1), this.current = e1, this.dirty = !1);
            }
        }
        class Vo extends Co {
            getDefault() {
                return this.gl.CCW;
            }
            set(e1) {
                (e1 !== this.current || this.dirty) && (this.gl.frontFace(e1), this.current = e1, this.dirty = !1);
            }
        }
        class Wo extends Co {
            getDefault() {
                return null;
            }
            set(e1) {
                (e1 !== this.current || this.dirty) && (this.gl.useProgram(e1), this.current = e1, this.dirty = !1);
            }
        }
        class qo extends Co {
            getDefault() {
                return this.gl.TEXTURE0;
            }
            set(e1) {
                (e1 !== this.current || this.dirty) && (this.gl.activeTexture(e1), this.current = e1, this.dirty = !1);
            }
        }
        class $o extends Co {
            getDefault() {
                const e1 = this.gl;
                return [
                    0,
                    0,
                    e1.drawingBufferWidth,
                    e1.drawingBufferHeight
                ];
            }
            set(e1) {
                const t = this.current;
                (e1[0] !== t[0] || e1[1] !== t[1] || e1[2] !== t[2] || e1[3] !== t[3] || this.dirty) && (this.gl.viewport(e1[0], e1[1], e1[2], e1[3]), this.current = e1, this.dirty = !1);
            }
        }
        class Ho extends Co {
            getDefault() {
                return null;
            }
            set(e1) {
                if (e1 === this.current && !this.dirty) return;
                const t = this.gl;
                t.bindFramebuffer(t.FRAMEBUFFER, e1), this.current = e1, this.dirty = !1;
            }
        }
        class Xo extends Co {
            getDefault() {
                return null;
            }
            set(e1) {
                if (e1 === this.current && !this.dirty) return;
                const t = this.gl;
                t.bindRenderbuffer(t.RENDERBUFFER, e1), this.current = e1, this.dirty = !1;
            }
        }
        class Ko extends Co {
            getDefault() {
                return null;
            }
            set(e1) {
                if (e1 === this.current && !this.dirty) return;
                const t = this.gl;
                t.bindTexture(t.TEXTURE_2D, e1), this.current = e1, this.dirty = !1;
            }
        }
        class Yo extends Co {
            getDefault() {
                return null;
            }
            set(e1) {
                if (e1 === this.current && !this.dirty) return;
                const t = this.gl;
                t.bindBuffer(t.ARRAY_BUFFER, e1), this.current = e1, this.dirty = !1;
            }
        }
        class Qo extends Co {
            getDefault() {
                return null;
            }
            set(e1) {
                const t = this.gl;
                t.bindBuffer(t.ELEMENT_ARRAY_BUFFER, e1), this.current = e1, this.dirty = !1;
            }
        }
        class Jo extends Co {
            getDefault() {
                return null;
            }
            set(e1) {
                var t;
                if (e1 === this.current && !this.dirty) return;
                const i = this.gl;
                si(i) ? i.bindVertexArray(e1) : null === (t = i.getExtension("OES_vertex_array_object")) || void 0 === t || t.bindVertexArrayOES(e1), this.current = e1, this.dirty = !1;
            }
        }
        class ea extends Co {
            getDefault() {
                return 4;
            }
            set(e1) {
                if (e1 === this.current && !this.dirty) return;
                const t = this.gl;
                t.pixelStorei(t.UNPACK_ALIGNMENT, e1), this.current = e1, this.dirty = !1;
            }
        }
        class ta extends Co {
            getDefault() {
                return !1;
            }
            set(e1) {
                if (e1 === this.current && !this.dirty) return;
                const t = this.gl;
                t.pixelStorei(t.UNPACK_PREMULTIPLY_ALPHA_WEBGL, e1), this.current = e1, this.dirty = !1;
            }
        }
        class ia extends Co {
            getDefault() {
                return !1;
            }
            set(e1) {
                if (e1 === this.current && !this.dirty) return;
                const t = this.gl;
                t.pixelStorei(t.UNPACK_FLIP_Y_WEBGL, e1), this.current = e1, this.dirty = !1;
            }
        }
        class oa extends Co {
            constructor(e1, t){
                super(e1), this.context = e1, this.parent = t;
            }
            getDefault() {
                return null;
            }
        }
        class aa extends oa {
            setDirty() {
                this.dirty = !0;
            }
            set(e1) {
                if (e1 === this.current && !this.dirty) return;
                this.context.bindFramebuffer.set(this.parent);
                const t = this.gl;
                t.framebufferTexture2D(t.FRAMEBUFFER, t.COLOR_ATTACHMENT0, t.TEXTURE_2D, e1, 0), this.current = e1, this.dirty = !1;
            }
        }
        class ra extends oa {
            set(e1) {
                if (e1 === this.current && !this.dirty) return;
                this.context.bindFramebuffer.set(this.parent);
                const t = this.gl;
                t.framebufferRenderbuffer(t.FRAMEBUFFER, t.DEPTH_ATTACHMENT, t.RENDERBUFFER, e1), this.current = e1, this.dirty = !1;
            }
        }
        class sa extends oa {
            set(e1) {
                if (e1 === this.current && !this.dirty) return;
                this.context.bindFramebuffer.set(this.parent);
                const t = this.gl;
                t.framebufferRenderbuffer(t.FRAMEBUFFER, t.DEPTH_STENCIL_ATTACHMENT, t.RENDERBUFFER, e1), this.current = e1, this.dirty = !1;
            }
        }
        const na = "Framebuffer is not complete";
        class la {
            constructor(e1, t, i, o, a){
                this.context = e1, this.width = t, this.height = i;
                const r = e1.gl, s = this.framebuffer = r.createFramebuffer();
                if (this.colorAttachment = new aa(e1, s), o) this.depthAttachment = a ? new sa(e1, s) : new ra(e1, s);
                else if (a) throw new Error("Stencil cannot be set without depth");
                if (r.checkFramebufferStatus(r.FRAMEBUFFER) !== r.FRAMEBUFFER_COMPLETE) throw new Error(na);
            }
            destroy() {
                const e1 = this.context.gl, t = this.colorAttachment.get();
                if (t && e1.deleteTexture(t), this.depthAttachment) {
                    const t = this.depthAttachment.get();
                    t && e1.deleteRenderbuffer(t);
                }
                e1.deleteFramebuffer(this.framebuffer);
            }
        }
        class ca {
            constructor(e1){
                var t, i;
                if (this.gl = e1, this.clearColor = new Mo(this), this.clearDepth = new Io(this), this.clearStencil = new Eo(this), this.colorMask = new So(this), this.depthMask = new zo(this), this.stencilMask = new Ro(this), this.stencilFunc = new Do(this), this.stencilOp = new Ao(this), this.stencilTest = new Lo(this), this.depthRange = new Fo(this), this.depthTest = new ko(this), this.depthFunc = new Bo(this), this.blend = new Oo(this), this.blendFunc = new jo(this), this.blendColor = new No(this), this.blendEquation = new Zo(this), this.cullFace = new Uo(this), this.cullFaceSide = new Go(this), this.frontFace = new Vo(this), this.program = new Wo(this), this.activeTexture = new qo(this), this.viewport = new $o(this), this.bindFramebuffer = new Ho(this), this.bindRenderbuffer = new Xo(this), this.bindTexture = new Ko(this), this.bindVertexBuffer = new Yo(this), this.bindElementBuffer = new Qo(this), this.bindVertexArray = new Jo(this), this.pixelStoreUnpack = new ea(this), this.pixelStoreUnpackPremultiplyAlpha = new ta(this), this.pixelStoreUnpackFlipY = new ia(this), this.extTextureFilterAnisotropic = e1.getExtension("EXT_texture_filter_anisotropic"), this.extTextureFilterAnisotropic && (this.extTextureFilterAnisotropicMax = e1.getParameter(this.extTextureFilterAnisotropic.MAX_TEXTURE_MAX_ANISOTROPY_EXT)), this.maxTextureSize = e1.getParameter(e1.MAX_TEXTURE_SIZE), si(e1)) {
                    this.HALF_FLOAT = e1.HALF_FLOAT;
                    const o = e1.getExtension("EXT_color_buffer_half_float");
                    this.RGBA16F = null !== (t = e1.RGBA16F) && void 0 !== t ? t : null == o ? void 0 : o.RGBA16F_EXT, this.RGB16F = null !== (i = e1.RGB16F) && void 0 !== i ? i : null == o ? void 0 : o.RGB16F_EXT, e1.getExtension("EXT_color_buffer_float");
                } else {
                    e1.getExtension("EXT_color_buffer_half_float"), e1.getExtension("OES_texture_half_float_linear");
                    const t = e1.getExtension("OES_texture_half_float");
                    this.HALF_FLOAT = null == t ? void 0 : t.HALF_FLOAT_OES;
                }
            }
            setDefault() {
                this.unbindVAO(), this.clearColor.setDefault(), this.clearDepth.setDefault(), this.clearStencil.setDefault(), this.colorMask.setDefault(), this.depthMask.setDefault(), this.stencilMask.setDefault(), this.stencilFunc.setDefault(), this.stencilOp.setDefault(), this.stencilTest.setDefault(), this.depthRange.setDefault(), this.depthTest.setDefault(), this.depthFunc.setDefault(), this.blend.setDefault(), this.blendFunc.setDefault(), this.blendColor.setDefault(), this.blendEquation.setDefault(), this.cullFace.setDefault(), this.cullFaceSide.setDefault(), this.frontFace.setDefault(), this.program.setDefault(), this.activeTexture.setDefault(), this.bindFramebuffer.setDefault(), this.pixelStoreUnpack.setDefault(), this.pixelStoreUnpackPremultiplyAlpha.setDefault(), this.pixelStoreUnpackFlipY.setDefault();
            }
            setDirty() {
                this.clearColor.dirty = !0, this.clearDepth.dirty = !0, this.clearStencil.dirty = !0, this.colorMask.dirty = !0, this.depthMask.dirty = !0, this.stencilMask.dirty = !0, this.stencilFunc.dirty = !0, this.stencilOp.dirty = !0, this.stencilTest.dirty = !0, this.depthRange.dirty = !0, this.depthTest.dirty = !0, this.depthFunc.dirty = !0, this.blend.dirty = !0, this.blendFunc.dirty = !0, this.blendColor.dirty = !0, this.blendEquation.dirty = !0, this.cullFace.dirty = !0, this.cullFaceSide.dirty = !0, this.frontFace.dirty = !0, this.program.dirty = !0, this.activeTexture.dirty = !0, this.viewport.dirty = !0, this.bindFramebuffer.dirty = !0, this.bindRenderbuffer.dirty = !0, this.bindTexture.dirty = !0, this.bindVertexBuffer.dirty = !0, this.bindElementBuffer.dirty = !0, this.bindVertexArray.dirty = !0, this.pixelStoreUnpack.dirty = !0, this.pixelStoreUnpackPremultiplyAlpha.dirty = !0, this.pixelStoreUnpackFlipY.dirty = !0;
            }
            createIndexBuffer(e1, t) {
                return new wo(this, e1, t);
            }
            createVertexBuffer(e1, t, i) {
                return new Po(this, e1, t, i);
            }
            createRenderbuffer(e1, t, i) {
                const o = this.gl, a = o.createRenderbuffer();
                return this.bindRenderbuffer.set(a), o.renderbufferStorage(o.RENDERBUFFER, e1, t, i), this.bindRenderbuffer.set(null), a;
            }
            createFramebuffer(e1, t, i, o) {
                return new la(this, e1, t, i, o);
            }
            clear({ color: e1, depth: t, stencil: i }) {
                const o = this.gl;
                let a = 0;
                e1 && (a |= o.COLOR_BUFFER_BIT, this.clearColor.set(e1), this.colorMask.set([
                    !0,
                    !0,
                    !0,
                    !0
                ])), void 0 !== t && (a |= o.DEPTH_BUFFER_BIT, this.depthRange.set([
                    0,
                    1
                ]), this.clearDepth.set(t), this.depthMask.set(!0)), void 0 !== i && (a |= o.STENCIL_BUFFER_BIT, this.clearStencil.set(i), this.stencilMask.set(255)), o.clear(a);
            }
            setCullFace(e1) {
                !1 === e1.enable ? this.cullFace.set(!1) : (this.cullFace.set(!0), this.cullFaceSide.set(e1.mode), this.frontFace.set(e1.frontFace));
            }
            setDepthMode(e1) {
                e1.func !== this.gl.ALWAYS || e1.mask ? (this.depthTest.set(!0), this.depthFunc.set(e1.func), this.depthMask.set(e1.mask), this.depthRange.set(e1.range)) : this.depthTest.set(!1);
            }
            setStencilMode(e1) {
                e1.test.func !== this.gl.ALWAYS || e1.mask ? (this.stencilTest.set(!0), this.stencilMask.set(e1.mask), this.stencilOp.set([
                    e1.fail,
                    e1.depthFail,
                    e1.pass
                ]), this.stencilFunc.set({
                    func: e1.test.func,
                    ref: e1.ref,
                    mask: e1.test.mask
                })) : this.stencilTest.set(!1);
            }
            setColorMode(e1) {
                t.bQ(e1.blendFunction, ei.Replace) ? this.blend.set(!1) : (this.blend.set(!0), this.blendFunc.set(e1.blendFunction), this.blendColor.set(e1.blendColor)), this.colorMask.set(e1.mask);
            }
            createVertexArray() {
                var e1;
                return si(this.gl) ? this.gl.createVertexArray() : null === (e1 = this.gl.getExtension("OES_vertex_array_object")) || void 0 === e1 ? void 0 : e1.createVertexArrayOES();
            }
            deleteVertexArray(e1) {
                var t;
                si(this.gl) ? this.gl.deleteVertexArray(e1) : null === (t = this.gl.getExtension("OES_vertex_array_object")) || void 0 === t || t.deleteVertexArrayOES(e1);
            }
            unbindVAO() {
                this.bindVertexArray.set(null);
            }
        }
        let ha;
        function ua(e1, i, o, a, r) {
            var s, n;
            const l = e1.context, c = e1.transform, h = l.gl, u = e1.useProgram("collisionBox"), d = [];
            let _ = 0, p = 0;
            for (const t of a){
                const a = i.getTile(t).getBucket(o);
                if (!a) continue;
                const n = r ? a.textCollisionBox : a.iconCollisionBox, m = a.collisionCircleArray;
                m.length > 0 && (d.push({
                    circleArray: m,
                    circleOffset: p,
                    coord: t
                }), _ += m.length / 4, p = _), n && u.draw(l, h.LINES, oi.disabled, ri.disabled, e1.colorModeForRenderPass(), ii.disabled, Ki(e1.transform), null === (s = e1.style.map.terrain) || void 0 === s ? void 0 : s.getTerrainData(t), c.getProjectionData({
                    overscaledTileID: t,
                    applyGlobeMatrix: !0,
                    applyTerrainMatrix: !0
                }), o.id, n.layoutVertexBuffer, n.indexBuffer, n.segments, null, e1.transform.zoom, null, null, n.collisionVertexBuffer);
            }
            if (!r || !d.length) return;
            const m = e1.useProgram("collisionCircle"), f = new t.ca;
            f.resize(4 * _), f._trim();
            let g = 0;
            for (const e1 of d)for(let t = 0; t < e1.circleArray.length / 4; t++){
                const i = 4 * t, o = e1.circleArray[i + 0], a = e1.circleArray[i + 1], r = e1.circleArray[i + 2], s = e1.circleArray[i + 3];
                f.emplace(g++, o, a, r, s, 0), f.emplace(g++, o, a, r, s, 1), f.emplace(g++, o, a, r, s, 2), f.emplace(g++, o, a, r, s, 3);
            }
            (!ha || ha.length < 2 * _) && (ha = function(e1) {
                const i = 2 * e1, o = new t.cc;
                o.resize(i), o._trim();
                for(let e1 = 0; e1 < i; e1++){
                    const t = 6 * e1;
                    o.uint16[t + 0] = 4 * e1 + 0, o.uint16[t + 1] = 4 * e1 + 1, o.uint16[t + 2] = 4 * e1 + 2, o.uint16[t + 3] = 4 * e1 + 2, o.uint16[t + 4] = 4 * e1 + 3, o.uint16[t + 5] = 4 * e1 + 0;
                }
                return o;
            }(_));
            const v = l.createIndexBuffer(ha, !0), x = l.createVertexBuffer(f, t.cb.members, !0);
            for (const i of d){
                const a = Yi(e1.transform);
                m.draw(l, h.TRIANGLES, oi.disabled, ri.disabled, e1.colorModeForRenderPass(), ii.disabled, a, null === (n = e1.style.map.terrain) || void 0 === n ? void 0 : n.getTerrainData(i.coord), null, o.id, x, v, t.aV.simpleSegment(0, 2 * i.circleOffset, i.circleArray.length, i.circleArray.length / 2), null, e1.transform.zoom, null, null, null);
            }
            x.destroy(), v.destroy();
        }
        const da = t.ap(new Float32Array(16));
        function _a(e1, i, o, a, r, s) {
            const { horizontalAlign: n, verticalAlign: l } = t.aP(e1);
            return new t.P((-(n - .5) * i / r + a[0]) * s, (-(l - .5) * o / r + a[1]) * s);
        }
        function pa(e1, i, o, a, r, s) {
            const n = i.tileAnchorPoint.add(new t.P(i.translation[0], i.translation[1]));
            if (i.pitchWithMap) {
                let e1 = a.mult(s);
                o || (e1 = e1.rotate(-r));
                const t = n.add(e1);
                return Ve(t.x, t.y, i.pitchedLabelPlaneMatrix, i.getElevation).point;
            }
            if (o) {
                const t = Je(i.tileAnchorPoint.x + 1, i.tileAnchorPoint.y, i).point.sub(e1), o = Math.atan(t.y / t.x) + (t.x < 0 ? Math.PI : 0);
                return e1.add(a.rotate(o));
            }
            return e1.add(a);
        }
        function ma(e1, i, o, a, r, s, n, l, c, h, u, d) {
            const _ = e1.text.placedSymbolArray, p = e1.text.dynamicLayoutVertexArray, m = e1.icon.dynamicLayoutVertexArray, f = {};
            p.clear();
            for(let m = 0; m < _.length; m++){
                const g = _.get(m), v = g.hidden || !g.crossTileID || e1.allowVerticalPlacement && !g.placedOrientation ? null : a[g.crossTileID];
                if (v) {
                    const a = new t.P(g.anchorX, g.anchorY), _ = {
                        getElevation: d,
                        width: r.width,
                        height: r.height,
                        pitchedLabelPlaneMatrix: s,
                        pitchWithMap: o,
                        transform: r,
                        tileAnchorPoint: a,
                        translation: h,
                        unwrappedTileID: u
                    }, m = o ? tt(a.x, a.y, _) : Je(a.x, a.y, _), x = We(r.cameraToCenterDistance, m.signedDistanceFromCamera);
                    let b = t.ay(e1.textSizeData, l, g) * x / t.aJ;
                    o && (b *= e1.tilePixelRatio / n);
                    const { width: y, height: w, anchor: T, textOffset: P, textBoxScale: C } = v, M = _a(T, y, w, P, C, b), I = r.getPitchedTextCorrection(a.x + h[0], a.y + h[1], u), E = pa(m.point, _, i, M, -r.bearingInRadians, I), S = e1.allowVerticalPlacement && g.placedOrientation === t.ax.vertical ? Math.PI / 2 : 0;
                    for(let e1 = 0; e1 < g.numGlyphs; e1++)t.aD(p, E, S);
                    c && g.associatedIconIndex >= 0 && (f[g.associatedIconIndex] = {
                        shiftedAnchor: E,
                        angle: S
                    });
                } else st(g.numGlyphs, p);
            }
            if (c) {
                m.clear();
                const i = e1.icon.placedSymbolArray;
                for(let e1 = 0; e1 < i.length; e1++){
                    const o = i.get(e1);
                    if (o.hidden) st(o.numGlyphs, m);
                    else {
                        const i = f[e1];
                        if (i) for(let e1 = 0; e1 < o.numGlyphs; e1++)t.aD(m, i.shiftedAnchor, i.angle);
                        else st(o.numGlyphs, m);
                    }
                }
                e1.icon.dynamicLayoutVertexBuffer.updateData(m);
            }
            e1.text.dynamicLayoutVertexBuffer.updateData(p);
        }
        function fa(e1, t, i) {
            return i.iconsInText && t ? "symbolTextAndIcon" : e1 ? "symbolSDF" : "symbolIcon";
        }
        function ga(e1, i, o, a, r, s, n, l, c, h, u, d, _) {
            var p, m;
            const f = e1.context, g = f.gl, v = e1.transform, x = "map" === l, b = "map" === c, y = "viewport" !== l && "point" !== o.layout.get("symbol-placement"), w = x && !b && !y, T = !o.layout.get("symbol-sort-key").isConstant();
            let P = !1;
            const C = e1.getDepthModeForSublayer(0, oi.ReadOnly), M = o._unevaluatedLayout.hasValue("text-variable-anchor") || o._unevaluatedLayout.hasValue("text-variable-anchor-offset"), I = [], E = v.getCircleRadiusCorrection();
            for (const l of a){
                const a = i.getTile(l), c = a.getBucket(o);
                if (!c) continue;
                const u = r ? c.text : c.icon;
                if (!(null == u ? void 0 : u.segments.get().length) || !u.hasVisibleVertices) continue;
                const d = u.programConfigurations.get(o.id), m = r || c.sdfIcons, f = r ? c.textSizeData : c.iconSizeData, C = b || 0 !== v.pitch, S = e1.useProgram(fa(m, r, c), d), z = t.aw(f, v.zoom), R = null === (p = e1.style.map.terrain) || void 0 === p ? void 0 : p.getTerrainData(l);
                let D, A, L, F, k = [
                    0,
                    0
                ], B = null;
                if (r) A = a.glyphAtlasTexture, L = g.LINEAR, D = a.glyphAtlasTexture.size, c.iconsInText && (k = a.imageAtlasTexture.size, B = a.imageAtlasTexture, F = C || e1.options.rotating || e1.options.zooming || "composite" === f.kind || "camera" === f.kind ? g.LINEAR : g.NEAREST);
                else {
                    const t = 1 !== o.layout.get("icon-size").constantOr(0) || c.iconsNeedLinear;
                    A = a.imageAtlasTexture, L = m || e1.options.rotating || e1.options.zooming || t || C ? g.LINEAR : g.NEAREST, D = a.imageAtlasTexture.size;
                }
                const O = t.aK(a, 1, e1.transform.zoom), j = Ze(x, e1.transform, O), N = Ue(b, x, e1.transform, O), Z = t.aL(v, a, s, n), U = v.getProjectionData({
                    overscaledTileID: l,
                    applyGlobeMatrix: !_,
                    applyTerrainMatrix: !0
                }), G = M && c.hasTextData(), V = "none" !== o.layout.get("icon-text-fit") && G && c.hasIconData();
                if (y) {
                    const i = t.O();
                    je(i, j);
                    const a = e1.style.map.terrain ? (t, i)=>e1.style.map.terrain.getElevation(l, t, i) : null, s = "map" === o.layout.get("text-rotation-alignment");
                    $e(c, e1, r, j, i, b, h, s, l.toUnwrapped(), v.width, v.height, Z, a);
                }
                const W = r && M || V, q = y || W ? da : b ? j : e1.transform.clipSpaceToPixelsMatrix, $ = m && 0 !== o.paint.get(r ? "text-halo-width" : "icon-halo-width").constantOr(1);
                let H;
                H = m ? c.iconsInText ? go(f.kind, z, w, b, y, W, e1, q, N, Z, D, k, E) : fo(f.kind, z, w, b, y, W, e1, q, N, Z, r, D, $, E) : mo(f.kind, z, w, b, y, W, e1, q, N, Z, r, D, E);
                const X = {
                    program: S,
                    buffers: u,
                    uniformValues: H,
                    projectionData: U,
                    atlasTexture: A,
                    atlasTextureIcon: B,
                    atlasInterpolation: L,
                    atlasInterpolationIcon: F,
                    isSDF: m,
                    hasHalo: $
                };
                if (T && c.canOverlap) {
                    P = !0;
                    const e1 = u.segments.get();
                    for (const i of e1)I.push({
                        segments: new t.aV([
                            i
                        ]),
                        sortKey: i.sortKey,
                        state: X,
                        terrainData: R
                    });
                } else I.push({
                    segments: u.segments,
                    sortKey: 0,
                    state: X,
                    terrainData: R
                });
            }
            P && I.sort((e1, t)=>e1.sortKey - t.sortKey);
            const S = null !== (m = o.paint.get(r ? "text-halo-width" : "icon-halo-width").constantOr(null)) && void 0 !== m ? m : 1 / 0, z = o.layout.get("text-letter-spacing").constantOr(0) * t.aJ < 0 || S > 1;
            for (const t of I){
                const i = t.state;
                f.activeTexture.set(g.TEXTURE0), i.atlasTexture.bind(i.atlasInterpolation, g.CLAMP_TO_EDGE), i.atlasTextureIcon && (f.activeTexture.set(g.TEXTURE1), i.atlasTextureIcon && i.atlasTextureIcon.bind(i.atlasInterpolationIcon, g.CLAMP_TO_EDGE));
                const a = i.isSDF && i.hasHalo;
                if (a) {
                    const a = i.uniformValues;
                    a.u_is_halo = 1, z && (a.u_is_plain = 0, va(i.buffers, t.segments, o, e1, i.program, C, u, d, a, i.projectionData, t.terrainData), a.u_is_halo = 0, a.u_is_plain = 1);
                }
                va(i.buffers, t.segments, o, e1, i.program, C, u, d, i.uniformValues, i.projectionData, t.terrainData), a && !z && (i.uniformValues.u_is_halo = 0);
            }
        }
        function va(e1, t, i, o, a, r, s, n, l, c, h) {
            const u = o.context;
            a.draw(u, u.gl.TRIANGLES, r, s, n, ii.backCCW, l, h, c, i.id, e1.layoutVertexBuffer, e1.indexBuffer, t, i.paint, o.transform.zoom, e1.programConfigurations.get(i.id), e1.dynamicLayoutVertexBuffer, e1.opacityVertexBuffer);
        }
        function xa(e1, i, o, a, r) {
            const s = e1.context, n = s.gl, l = ri.disabled, c = new ei([
                n.ONE,
                n.ONE
            ], t.bo.transparent, [
                !0,
                !0,
                !0,
                !0
            ]), h = i.getBucket(o);
            if (!h) return;
            const u = a.key;
            let d = o.heatmapFbos.get(u);
            d || (d = ya(s, i.tileSize, i.tileSize), o.heatmapFbos.set(u, d)), s.bindFramebuffer.set(d.framebuffer), s.viewport.set([
                0,
                0,
                i.tileSize,
                i.tileSize
            ]), s.clear({
                color: t.bo.transparent
            });
            const _ = h.programConfigurations.get(o.id), p = e1.useProgram("heatmap", _, !r), m = e1.transform.getProjectionData({
                overscaledTileID: i.tileID,
                applyGlobeMatrix: !0,
                applyTerrainMatrix: !0
            }), f = e1.style.map.terrain.getTerrainData(a);
            p.draw(s, n.TRIANGLES, oi.disabled, l, c, ii.disabled, Ji(i, e1.transform.zoom, o.paint.get("heatmap-intensity"), 1), f, m, o.id, h.layoutVertexBuffer, h.indexBuffer, h.segments, o.paint, e1.transform.zoom, _);
        }
        function ba(e1, t, i, o, a) {
            const r = e1.context, s = r.gl, n = e1.transform;
            r.setColorMode(e1.colorModeForRenderPass());
            const l = wa(r, t), c = i.key, h = t.heatmapFbos.get(c);
            if (!h) return;
            r.activeTexture.set(s.TEXTURE0), s.bindTexture(s.TEXTURE_2D, h.colorAttachment.get()), r.activeTexture.set(s.TEXTURE1), l.bind(s.LINEAR, s.CLAMP_TO_EDGE);
            const u = n.getProjectionData({
                overscaledTileID: i,
                applyTerrainMatrix: a,
                applyGlobeMatrix: !o
            });
            e1.useProgram("heatmapTexture").draw(r, s.TRIANGLES, oi.disabled, ri.disabled, e1.colorModeForRenderPass(), ii.disabled, eo(e1, t, 0, 1), null, u, t.id, e1.rasterBoundsBuffer, e1.quadTriangleIndexBuffer, e1.rasterBoundsSegments, t.paint, n.zoom), h.destroy(), t.heatmapFbos.delete(c);
        }
        function ya(e1, t, i) {
            var o, a;
            const r = e1.gl, s = r.createTexture();
            r.bindTexture(r.TEXTURE_2D, s), r.texParameteri(r.TEXTURE_2D, r.TEXTURE_WRAP_S, r.CLAMP_TO_EDGE), r.texParameteri(r.TEXTURE_2D, r.TEXTURE_WRAP_T, r.CLAMP_TO_EDGE), r.texParameteri(r.TEXTURE_2D, r.TEXTURE_MIN_FILTER, r.LINEAR), r.texParameteri(r.TEXTURE_2D, r.TEXTURE_MAG_FILTER, r.LINEAR);
            const n = null !== (o = e1.HALF_FLOAT) && void 0 !== o ? o : r.UNSIGNED_BYTE, l = null !== (a = e1.RGBA16F) && void 0 !== a ? a : r.RGBA;
            r.texImage2D(r.TEXTURE_2D, 0, l, t, i, 0, r.RGBA, n, null);
            const c = e1.createFramebuffer(t, i, !1, !1);
            return c.colorAttachment.set(s), c;
        }
        function wa(e1, i) {
            return i.colorRampTexture || (i.colorRampTexture = new t.T(e1, i.colorRamp, e1.gl.RGBA)), i.colorRampTexture;
        }
        function Ta(e1, i, o, a, r, s, n, l) {
            let c = 256;
            if (r.stepInterpolant) {
                const a = i.getSource().maxzoom, r = n.canonical.z === a ? Math.ceil(1 << e1.transform.maxZoom - n.canonical.z) : 1;
                c = t.al(t.ce(s.maxLineLength / t.a6 * 1024 * r), 256, o.maxTextureSize);
            }
            return l.gradient = t.cf({
                expression: r.gradientExpression(),
                evaluationKey: "lineProgress",
                resolution: c,
                image: l.gradient || void 0,
                clips: s.lineClipsArray
            }), l.texture ? l.texture.update(l.gradient) : l.texture = new t.T(o, l.gradient, a.RGBA), l.version = r.gradientVersion, l.texture;
        }
        function Pa(e1, t, i, o, a) {
            e1.activeTexture.set(t.TEXTURE0), i.imageAtlasTexture.bind(t.LINEAR, t.CLAMP_TO_EDGE), o.updatePaintBuffers(a);
        }
        function Ca(e1, t, i, o, a, r) {
            (a || e1.lineAtlas.dirty) && (t.activeTexture.set(i.TEXTURE0), e1.lineAtlas.bind(t)), o.updatePaintBuffers(r);
        }
        function Ma(e1, t, i, o, a, r, s) {
            const n = r.gradients[a.id];
            let l = n.texture;
            a.gradientVersion !== n.version && (l = Ta(e1, t, i, o, a, r, s, n)), i.activeTexture.set(o.TEXTURE0), l.bind(a.stepInterpolant ? o.NEAREST : o.LINEAR, o.CLAMP_TO_EDGE);
        }
        function Ia(e1, t, i, o, a, r, s, n, l) {
            const c = r.gradients[a.id];
            let h = c.texture;
            a.gradientVersion !== c.version && (h = Ta(e1, t, i, o, a, r, s, c)), i.activeTexture.set(o.TEXTURE0), h.bind(a.stepInterpolant ? o.NEAREST : o.LINEAR, o.CLAMP_TO_EDGE), i.activeTexture.set(o.TEXTURE1), e1.lineAtlas.bind(i), n.updatePaintBuffers(l);
        }
        function Ea(e1, t, i, o, a) {
            if (!i || !(null == o ? void 0 : o.imageAtlas)) return;
            const r = o.imageAtlas.patternPositions;
            let s = r[i.to.toString()], n = r[i.from.toString()];
            if (!s && n && (s = n), !n && s && (n = s), !s || !n) {
                const e1 = a.getPaintProperty(t);
                s = r[e1], n = r[e1];
            }
            s && n && e1.setConstantPatternPositions(s, n);
        }
        function Sa(e1, i, o, a, r, s, n, l) {
            var c;
            const h = e1.context.gl, u = "fill-pattern", d = o.paint.get(u), _ = null == d ? void 0 : d.constantOr(1), p = o.getCrossfadeParameters();
            let m, f, g, v, x;
            const b = e1.transform, y = o.paint.get("fill-translate"), w = o.paint.get("fill-translate-anchor");
            n ? (f = _ && !o.getPaintProperty("fill-outline-color") ? "fillOutlinePattern" : "fillOutline", m = h.LINES) : (f = _ ? "fillPattern" : "fill", m = h.TRIANGLES);
            const T = d.constantOr(null);
            for (const d of a){
                const a = i.getTile(d);
                if (_ && !a.patternsLoaded()) continue;
                const P = a.getBucket(o);
                if (!P) continue;
                const C = P.programConfigurations.get(o.id), M = e1.useProgram(f, C), I = null === (c = e1.style.map.terrain) || void 0 === c ? void 0 : c.getTerrainData(d);
                _ && (e1.context.activeTexture.set(h.TEXTURE0), a.imageAtlasTexture.bind(h.LINEAR, h.CLAMP_TO_EDGE), C.updatePaintBuffers(p)), Ea(C, u, T, a, o);
                const E = b.getProjectionData({
                    overscaledTileID: d,
                    applyGlobeMatrix: !l,
                    applyTerrainMatrix: !0
                }), S = t.aL(b, a, y, w);
                if (n) {
                    v = P.indexBuffer2, x = P.segments2;
                    const t = [
                        h.drawingBufferWidth,
                        h.drawingBufferHeight
                    ];
                    g = "fillOutlinePattern" === f && _ ? Hi(e1, p, a, t, S) : $i(t, S);
                } else v = P.indexBuffer, x = P.segments, g = _ ? qi(e1, p, a, S) : {
                    u_fill_translate: S
                };
                const z = e1.stencilModeForClipping(d);
                M.draw(e1.context, m, r, z, s, ii.backCCW, g, I, E, o.id, P.layoutVertexBuffer, v, x, o.paint, e1.transform.zoom, C);
            }
        }
        function za(e1, i, o, a, r, s, n, l) {
            var c;
            const h = e1.context, u = h.gl, d = "fill-extrusion-pattern", _ = o.paint.get(d), p = _.constantOr(1), m = o.getCrossfadeParameters(), f = o.paint.get("fill-extrusion-opacity"), g = _.constantOr(null), v = e1.transform;
            for (const _ of a){
                const a = i.getTile(_), x = a.getBucket(o);
                if (!x) continue;
                const b = null === (c = e1.style.map.terrain) || void 0 === c ? void 0 : c.getTerrainData(_), y = x.programConfigurations.get(o.id), w = e1.useProgram(p ? "fillExtrusionPattern" : "fillExtrusion", y);
                p && (e1.context.activeTexture.set(u.TEXTURE0), a.imageAtlasTexture.bind(u.LINEAR, u.CLAMP_TO_EDGE), y.updatePaintBuffers(m));
                const T = v.getProjectionData({
                    overscaledTileID: _,
                    applyGlobeMatrix: !l,
                    applyTerrainMatrix: !0
                });
                Ea(y, d, g, a, o);
                const P = t.aL(v, a, o.paint.get("fill-extrusion-translate"), o.paint.get("fill-extrusion-translate-anchor")), C = o.paint.get("fill-extrusion-vertical-gradient"), M = p ? Wi(e1, C, f, P, _, m, a) : Vi(e1, C, f, P);
                w.draw(h, h.gl.TRIANGLES, r, s, n, ii.backCCW, M, b, T, o.id, x.layoutVertexBuffer, x.indexBuffer, x.segments, o.paint, e1.transform.zoom, y, e1.style.map.terrain && x.centroidVertexBuffer);
            }
        }
        function Ra(e1, t, i, o, a, r, s, n, l) {
            var c;
            const h = e1.style.projection, u = e1.context, d = e1.transform, _ = u.gl, p = [
                `#define NUM_ILLUMINATION_SOURCES ${i.paint.get("hillshade-highlight-color").values.length}`
            ], m = e1.useProgram("hillshade", null, !1, p), f = !e1.options.moving;
            for (const p of o){
                const o = t.getTile(p), g = o.fbo;
                if (!g) continue;
                const v = h.getMeshFromTileID(u, p.canonical, n, !0, "raster"), x = null === (c = e1.style.map.terrain) || void 0 === c ? void 0 : c.getTerrainData(p);
                u.activeTexture.set(_.TEXTURE0), _.bindTexture(_.TEXTURE_2D, g.colorAttachment.get());
                const b = d.getProjectionData({
                    overscaledTileID: p,
                    aligned: f,
                    applyGlobeMatrix: !l,
                    applyTerrainMatrix: !0
                });
                m.draw(u, _.TRIANGLES, r, a[p.overscaledZ], s, ii.backCCW, to(e1, o, i), x, b, i.id, v.vertexBuffer, v.indexBuffer, v.segments);
            }
        }
        let Da = 0;
        function Aa(e1, i, o, a, r, s, n, l, c) {
            var h;
            const u = e1.style.projection, d = e1.context, _ = e1.transform, p = d.gl, m = e1.useProgram("colorRelief"), f = !e1.options.moving, g = "nearest" === o.paint.get("resampling") ? p.NEAREST : p.LINEAR;
            let v = !0, x = 0;
            for (const b of a){
                const a = i.getTile(b), y = a.dem;
                if (v) {
                    Da || (Da = p.getParameter(p.MAX_TEXTURE_SIZE));
                    const e1 = Da, { elevationTexture: t, colorTexture: i } = o.getColorRampTextures(d, e1, y.getUnpackVector());
                    d.activeTexture.set(p.TEXTURE1), t.bind(p.NEAREST, p.CLAMP_TO_EDGE), d.activeTexture.set(p.TEXTURE4), i.bind(p.LINEAR, p.CLAMP_TO_EDGE), v = !1, x = t.size[0];
                }
                if (!(null == y ? void 0 : y.data)) continue;
                const w = y.stride, T = y.getPixels();
                if (d.activeTexture.set(p.TEXTURE0), d.pixelStoreUnpackPremultiplyAlpha.set(!1), a.demTexture || (a.demTexture = e1.getTileTexture(w)), a.demTexture) {
                    const e1 = a.demTexture;
                    e1.update(T, {
                        premultiply: !1
                    }), e1.bind(g, p.CLAMP_TO_EDGE);
                } else a.demTexture = new t.T(d, T, p.RGBA, {
                    premultiply: !1
                }), a.demTexture.bind(g, p.CLAMP_TO_EDGE);
                const P = u.getMeshFromTileID(d, b.canonical, l, !0, "raster"), C = null === (h = e1.style.map.terrain) || void 0 === h ? void 0 : h.getTerrainData(b), M = _.getProjectionData({
                    overscaledTileID: b,
                    aligned: f,
                    applyGlobeMatrix: !c,
                    applyTerrainMatrix: !0
                });
                m.draw(d, p.TRIANGLES, s, r[b.overscaledZ], n, ii.backCCW, ao(o, a.dem, x), C, M, o.id, P.vertexBuffer, P.indexBuffer, P.segments);
            }
        }
        const La = [
            new t.P(0, 0),
            new t.P(t.a6, 0),
            new t.P(t.a6, t.a6),
            new t.P(0, t.a6)
        ];
        function Fa(e1, t, i, o, a, r, s, n, l = !1, c = !1) {
            var h;
            const u = o[o.length - 1].overscaledZ, d = e1.context, _ = d.gl, p = e1.useProgram("raster"), m = e1.transform, f = e1.style.projection, g = e1.colorModeForRenderPass(), v = !e1.options.moving, x = i.paint.get("raster-opacity"), b = "nearest" === i.paint.get("resampling") || "nearest" === i.paint.get("raster-resampling") ? _.NEAREST : _.LINEAR, y = i.paint.get("raster-fade-duration"), w = !!e1.style.map.terrain;
            for (const T of o){
                const o = e1.getDepthModeForSublayer(T.overscaledZ - u, 1 === x ? oi.ReadWrite : oi.ReadOnly, _.LESS), P = t.getTile(T);
                d.activeTexture.set(_.TEXTURE0), P.texture.bind(b, _.CLAMP_TO_EDGE, _.LINEAR_MIPMAP_NEAREST), d.activeTexture.set(_.TEXTURE1);
                const { parentTile: C, parentScaleBy: M, parentTopLeft: I, fadeValues: E } = ka(P, t, y, w);
                P.fadeOpacity = E.tileOpacity, C ? (C.fadeOpacity = E.parentTileOpacity, C.texture.bind(b, _.CLAMP_TO_EDGE, _.LINEAR_MIPMAP_NEAREST)) : P.texture.bind(b, _.CLAMP_TO_EDGE, _.LINEAR_MIPMAP_NEAREST), P.texture.useMipmap && d.extTextureFilterAnisotropic && e1.transform.pitch > e1.options.anisotropicFilterPitch && _.texParameterf(_.TEXTURE_2D, d.extTextureFilterAnisotropic.TEXTURE_MAX_ANISOTROPY_EXT, d.extTextureFilterAnisotropicMax);
                const S = null === (h = e1.style.map.terrain) || void 0 === h ? void 0 : h.getTerrainData(T), z = m.getProjectionData({
                    overscaledTileID: T,
                    aligned: v,
                    applyGlobeMatrix: !c,
                    applyTerrainMatrix: !0
                }), R = _o(I, M, E.fadeMix, i, n), D = f.getMeshFromTileID(d, T.canonical, r, s, "raster");
                p.draw(d, _.TRIANGLES, o, a ? a[T.overscaledZ] : ri.disabled, g, l ? ii.frontCCW : ii.backCCW, R, S, z, i.id, D.vertexBuffer, D.indexBuffer, D.segments);
            }
        }
        function ka(e1, i, o, a) {
            const r = {
                parentTile: null,
                parentScaleBy: 1,
                parentTopLeft: [
                    0,
                    0
                ],
                fadeValues: {
                    tileOpacity: 1,
                    parentTileOpacity: 1,
                    fadeMix: {
                        opacity: 1,
                        mix: 0
                    }
                }
            };
            if (0 === o || a) return r;
            if (e1.fadingParentID) {
                const a = i.getLoadedTile(e1.fadingParentID);
                if (!a) return r;
                const s = Math.pow(2, a.tileID.overscaledZ - e1.tileID.overscaledZ), n = [
                    e1.tileID.canonical.x * s % 1,
                    e1.tileID.canonical.y * s % 1
                ], l = function(e1, i, o) {
                    const a = c(), r = (a - i.timeAdded) / o, s = e1.fadingDirection === ue.Incoming, n = t.al((a - e1.timeAdded) / o, 0, 1), l = t.al(1 - r, 0, 1), h = s ? n : l;
                    return {
                        tileOpacity: h,
                        parentTileOpacity: s ? l : n,
                        fadeMix: {
                            opacity: 1,
                            mix: 1 - h
                        }
                    };
                }(e1, a, o);
                return {
                    parentTile: a,
                    parentScaleBy: s,
                    parentTopLeft: n,
                    fadeValues: l
                };
            }
            if (e1.selfFading) {
                const i = function(e1, i) {
                    const o = (c() - e1.timeAdded) / i, a = t.al(o, 0, 1);
                    return {
                        tileOpacity: a,
                        fadeMix: {
                            opacity: a,
                            mix: 0
                        }
                    };
                }(e1, o);
                return {
                    parentTile: null,
                    parentScaleBy: 1,
                    parentTopLeft: [
                        0,
                        0
                    ],
                    fadeValues: i
                };
            }
            return r;
        }
        const Ba = new t.bo(1, 0, 0, 1), Oa = new t.bo(0, 1, 0, 1), ja = new t.bo(0, 0, 1, 1), Na = new t.bo(1, 0, 1, 1), Za = new t.bo(0, 1, 1, 1);
        function Ua(e1, t, i, o) {
            Va(e1, 0, t + i / 2, e1.transform.width, i, o);
        }
        function Ga(e1, t, i, o) {
            Va(e1, t - i / 2, 0, i, e1.transform.height, o);
        }
        function Va(e1, t, i, o, a, r) {
            const s = e1.context, n = s.gl;
            n.enable(n.SCISSOR_TEST), n.scissor(t * e1.pixelRatio, i * e1.pixelRatio, o * e1.pixelRatio, a * e1.pixelRatio), s.clear({
                color: r
            }), n.disable(n.SCISSOR_TEST);
        }
        function Wa(e1, i, o) {
            var a;
            const r = e1.context, s = r.gl, n = e1.useProgram("debug"), l = oi.disabled, c = ri.disabled, h = e1.colorModeForRenderPass(), u = "$debug", d = null === (a = e1.style.map.terrain) || void 0 === a ? void 0 : a.getTerrainData(o);
            r.activeTexture.set(s.TEXTURE0);
            const _ = i.getTileByID(o.key).latestRawTileData, p = Math.floor(((null == _ ? void 0 : _.byteLength) || 0) / 1024), m = i.getTile(o).tileSize, f = 512 / Math.min(m, 512) * (o.overscaledZ / e1.transform.zoom) * .5;
            let g = o.canonical.toString();
            o.overscaledZ !== o.canonical.z && (g += ` => ${o.overscaledZ}`), function(e1, t) {
                e1.initDebugOverlayCanvas();
                const i = e1.debugOverlayCanvas, o = e1.context.gl, a = e1.debugOverlayCanvas.getContext("2d");
                a.clearRect(0, 0, i.width, i.height), a.shadowColor = "white", a.shadowBlur = 2, a.lineWidth = 1.5, a.strokeStyle = "white", a.textBaseline = "top", a.font = "bold 36px Open Sans, sans-serif", a.fillText(t, 5, 5), a.strokeText(t, 5, 5), e1.debugOverlayTexture.update(i), e1.debugOverlayTexture.bind(o.LINEAR, o.CLAMP_TO_EDGE);
            }(e1, `${g} ${p}kB`);
            const v = e1.transform.getProjectionData({
                overscaledTileID: o,
                applyGlobeMatrix: !0,
                applyTerrainMatrix: !0
            });
            n.draw(r, s.TRIANGLES, l, c, ei.alphaBlended, ii.disabled, Qi(t.bo.transparent, f), null, v, u, e1.debugBuffer, e1.quadTriangleIndexBuffer, e1.debugSegments), n.draw(r, s.LINE_STRIP, l, c, h, ii.disabled, Qi(t.bo.red), d, v, u, e1.debugBuffer, e1.tileBorderIndexBuffer, e1.debugSegments);
        }
        function qa(e1, t, i, o) {
            const { isRenderingGlobe: a } = o, r = e1.context, s = r.gl, n = e1.transform, l = e1.colorModeForRenderPass(), c = e1.getDepthModeFor3D(), h = e1.useProgram("terrain");
            r.bindFramebuffer.set(null), r.viewport.set([
                0,
                0,
                e1.width,
                e1.height
            ]);
            for (const o of i){
                const i = t.getTerrainMesh(o.tileID), u = e1.renderToTexture.getTexture(o), d = t.getTerrainData(o.tileID);
                r.activeTexture.set(s.TEXTURE0), s.bindTexture(s.TEXTURE_2D, u.texture);
                const _ = t.getMeshFrameDelta(n.zoom), p = n.calculateFogMatrix(o.tileID.toUnwrapped()), m = ji(_, p, e1.style.sky, n.pitch, a), f = n.getProjectionData({
                    overscaledTileID: o.tileID,
                    applyTerrainMatrix: !1,
                    applyGlobeMatrix: !0
                });
                h.draw(r, s.TRIANGLES, c, ri.disabled, l, ii.backCCW, m, d, f, "terrain", i.vertexBuffer, i.indexBuffer, i.segments);
            }
        }
        function $a(e1, i) {
            if (!i.mesh) {
                const o = new t.aU;
                o.emplaceBack(-1, -1), o.emplaceBack(1, -1), o.emplaceBack(1, 1), o.emplaceBack(-1, 1);
                const a = new t.aW;
                a.emplaceBack(0, 1, 2), a.emplaceBack(0, 2, 3), i.mesh = new Bt(e1.createVertexBuffer(o, Ot.members), e1.createIndexBuffer(a), t.aV.simpleSegment(0, 0, o.length, a.length));
            }
            return i.mesh;
        }
        const Ha = {
            symbol: function(e1, i, o, a, r, s) {
                if ("translucent" !== e1.renderPass) return;
                const { isRenderingToTexture: n } = s, l = ri.disabled, c = e1.colorModeForRenderPass();
                (o._unevaluatedLayout.hasValue("text-variable-anchor") || o._unevaluatedLayout.hasValue("text-variable-anchor-offset")) && function(e1, i, o, a, r, s, n, l, c) {
                    var h;
                    const u = i.transform, d = i.style.map.terrain, _ = "map" === r, p = "map" === s;
                    for (const r of e1){
                        const e1 = a.getTile(r), s = e1.getBucket(o);
                        if (!(null === (h = null == s ? void 0 : s.text) || void 0 === h ? void 0 : h.segments.get().length)) continue;
                        const m = t.aw(s.textSizeData, u.zoom), f = t.aK(e1, 1, i.transform.zoom), g = Ze(_, i.transform, f), v = "none" !== o.layout.get("icon-text-fit") && s.hasIconData();
                        if (m) {
                            const i = Math.pow(2, u.zoom - e1.tileID.overscaledZ), o = d ? (e1, t)=>d.getElevation(r, e1, t) : null;
                            ma(s, _, p, c, u, g, i, m, v, t.aL(u, e1, n, l), r.toUnwrapped(), o);
                        }
                    }
                }(a, e1, o, i, o.layout.get("text-rotation-alignment"), o.layout.get("text-pitch-alignment"), o.paint.get("text-translate"), o.paint.get("text-translate-anchor"), r), 0 !== o.paint.get("icon-opacity").constantOr(1) && ga(e1, i, o, a, !1, o.paint.get("icon-translate"), o.paint.get("icon-translate-anchor"), o.layout.get("icon-rotation-alignment"), o.layout.get("icon-pitch-alignment"), o.layout.get("icon-keep-upright"), l, c, n), 0 !== o.paint.get("text-opacity").constantOr(1) && ga(e1, i, o, a, !0, o.paint.get("text-translate"), o.paint.get("text-translate-anchor"), o.layout.get("text-rotation-alignment"), o.layout.get("text-pitch-alignment"), o.layout.get("text-keep-upright"), l, c, n), i.map.showCollisionBoxes && (ua(e1, i, o, a, !0), ua(e1, i, o, a, !1));
            },
            circle: function(e1, i, o, a, r) {
                var s;
                if ("translucent" !== e1.renderPass) return;
                const { isRenderingToTexture: n } = r, l = o.paint.get("circle-opacity"), c = o.paint.get("circle-stroke-width"), h = o.paint.get("circle-stroke-opacity"), u = !o.layout.get("circle-sort-key").isConstant();
                if (0 === l.constantOr(1) && (0 === c.constantOr(1) || 0 === h.constantOr(1))) return;
                const d = e1.context, _ = d.gl, p = e1.transform, m = e1.getDepthModeForSublayer(0, oi.ReadOnly), f = ri.disabled, g = e1.colorModeForRenderPass(), v = [], x = p.getCircleRadiusCorrection();
                for (const r of a){
                    const a = i.getTile(r), l = a.getBucket(o);
                    if (!l) continue;
                    const c = o.paint.get("circle-translate"), h = o.paint.get("circle-translate-anchor"), d = t.aL(p, a, c, h), _ = l.programConfigurations.get(o.id), m = e1.useProgram("circle", _), f = l.layoutVertexBuffer, g = l.indexBuffer, b = null === (s = e1.style.map.terrain) || void 0 === s ? void 0 : s.getTerrainData(r), y = {
                        programConfiguration: _,
                        program: m,
                        layoutVertexBuffer: f,
                        indexBuffer: g,
                        uniformValues: Xi(e1, a, o, d, x),
                        terrainData: b,
                        projectionData: p.getProjectionData({
                            overscaledTileID: r,
                            applyGlobeMatrix: !n,
                            applyTerrainMatrix: !0
                        })
                    };
                    if (u) {
                        const e1 = l.segments.get();
                        for (const i of e1)v.push({
                            segments: new t.aV([
                                i
                            ]),
                            sortKey: i.sortKey,
                            state: y
                        });
                    } else v.push({
                        segments: l.segments,
                        sortKey: 0,
                        state: y
                    });
                }
                u && v.sort((e1, t)=>e1.sortKey - t.sortKey);
                for (const t of v){
                    const { programConfiguration: i, program: a, layoutVertexBuffer: r, indexBuffer: s, uniformValues: n, terrainData: l, projectionData: c } = t.state;
                    a.draw(d, _.TRIANGLES, m, f, g, ii.backCCW, n, l, c, o.id, r, s, t.segments, o.paint, e1.transform.zoom, i);
                }
            },
            heatmap: function(e1, i, o, a, r) {
                if (0 === o.paint.get("heatmap-opacity")) return;
                const s = e1.context, { isRenderingToTexture: n, isRenderingGlobe: l } = r;
                if (e1.style.map.terrain) {
                    for (const t of a){
                        const a = i.getTile(t);
                        i.hasRenderableParent(t) || ("offscreen" === e1.renderPass ? xa(e1, a, o, t, l) : "translucent" === e1.renderPass && ba(e1, o, t, n, l));
                    }
                    s.viewport.set([
                        0,
                        0,
                        e1.width,
                        e1.height
                    ]);
                } else "offscreen" === e1.renderPass ? function(e1, i, o, a) {
                    const r = e1.context, s = r.gl, n = e1.transform, l = ri.disabled, c = new ei([
                        s.ONE,
                        s.ONE
                    ], t.bo.transparent, [
                        !0,
                        !0,
                        !0,
                        !0
                    ]);
                    (function(e1, i, o) {
                        const a = e1.gl;
                        e1.activeTexture.set(a.TEXTURE1), e1.viewport.set([
                            0,
                            0,
                            i.width / 4,
                            i.height / 4
                        ]);
                        let r = o.heatmapFbos.get(t.cd);
                        r ? (a.bindTexture(a.TEXTURE_2D, r.colorAttachment.get()), e1.bindFramebuffer.set(r.framebuffer)) : (r = ya(e1, i.width / 4, i.height / 4), o.heatmapFbos.set(t.cd, r));
                    })(r, e1, o), r.clear({
                        color: t.bo.transparent
                    });
                    for (const t of a){
                        if (i.hasRenderableParent(t)) continue;
                        const a = i.getTile(t), h = a.getBucket(o);
                        if (!h) continue;
                        const u = h.programConfigurations.get(o.id), d = e1.useProgram("heatmap", u), _ = n.getProjectionData({
                            overscaledTileID: t,
                            applyGlobeMatrix: !0,
                            applyTerrainMatrix: !1
                        }), p = n.getCircleRadiusCorrection();
                        d.draw(r, s.TRIANGLES, oi.disabled, l, c, ii.backCCW, Ji(a, n.zoom, o.paint.get("heatmap-intensity"), p), null, _, o.id, h.layoutVertexBuffer, h.indexBuffer, h.segments, o.paint, n.zoom, u);
                    }
                    r.viewport.set([
                        0,
                        0,
                        e1.width,
                        e1.height
                    ]);
                }(e1, i, o, a) : "translucent" === e1.renderPass && function(e1, i) {
                    const o = e1.context, a = o.gl;
                    o.setColorMode(e1.colorModeForRenderPass());
                    const r = i.heatmapFbos.get(t.cd);
                    r && (o.activeTexture.set(a.TEXTURE0), a.bindTexture(a.TEXTURE_2D, r.colorAttachment.get()), o.activeTexture.set(a.TEXTURE1), wa(o, i).bind(a.LINEAR, a.CLAMP_TO_EDGE), e1.useProgram("heatmapTexture").draw(o, a.TRIANGLES, oi.disabled, ri.disabled, e1.colorModeForRenderPass(), ii.disabled, eo(e1, i, 0, 1), null, null, i.id, e1.viewportBuffer, e1.quadTriangleIndexBuffer, e1.viewportSegments, i.paint, e1.transform.zoom));
                }(e1, o);
            },
            line: function(e1, t, i, o, a) {
                var r;
                if ("translucent" !== e1.renderPass) return;
                const { isRenderingToTexture: s } = a, n = i.paint.get("line-opacity"), l = i.paint.get("line-width");
                if (0 === n.constantOr(1) || 0 === l.constantOr(1)) return;
                const c = e1.getDepthModeForSublayer(0, oi.ReadOnly), h = e1.colorModeForRenderPass(), u = i.paint.get("line-dasharray"), d = u.constantOr(1), _ = i.paint.get("line-pattern"), p = _.constantOr(1), m = i.paint.get("line-gradient"), f = i.getCrossfadeParameters();
                let g;
                g = p ? "linePattern" : d && m ? "lineGradientSDF" : d ? "lineSDF" : m ? "lineGradient" : "line";
                const v = e1.context, x = v.gl, b = e1.transform;
                let y = !0;
                for (const a of o){
                    const o = t.getTile(a);
                    if (p && !o.patternsLoaded()) continue;
                    const n = o.getBucket(i);
                    if (!n) continue;
                    const l = n.programConfigurations.get(i.id), w = e1.context.program.get(), T = e1.useProgram(g, l), P = y || T.program !== w, C = null === (r = e1.style.map.terrain) || void 0 === r ? void 0 : r.getTerrainData(a), M = _.constantOr(null), I = null == u ? void 0 : u.constantOr(null);
                    if (M && o.imageAtlas) {
                        const e1 = o.imageAtlas, t = e1.patternPositions[M.to.toString()], i = e1.patternPositions[M.from.toString()];
                        t && i && l.setConstantPatternPositions(t, i);
                    } else if (I) {
                        const t = "round" === i.layout.get("line-cap").constantOr(null), o = e1.lineAtlas.getDash(I.to, t), a = e1.lineAtlas.getDash(I.from, t);
                        l.setConstantDashPositions(o, a);
                    }
                    const E = b.getProjectionData({
                        overscaledTileID: a,
                        applyGlobeMatrix: !s,
                        applyTerrainMatrix: !0
                    }), S = b.getPixelScale();
                    let z;
                    p ? (z = no(e1, o, i, S, f), Pa(v, x, o, l, f)) : d && m ? (z = co(e1, o, i, S, f, n.lineClipsArray.length), Ia(e1, t, v, x, i, n, a, l, f)) : d ? (z = lo(e1, o, i, S, f), Ca(e1, v, x, l, P, f)) : m ? (z = so(e1, o, i, S, n.lineClipsArray.length), Ma(e1, t, v, x, i, n, a)) : z = ro(e1, o, i, S);
                    const R = e1.stencilModeForClipping(a);
                    T.draw(v, x.TRIANGLES, c, R, h, ii.disabled, z, C, E, i.id, n.layoutVertexBuffer, n.indexBuffer, n.segments, i.paint, e1.transform.zoom, l, n.layoutVertexBuffer2), y = !1;
                }
            },
            fill: function(e1, i, o, a, r) {
                const s = o.paint.get("fill-color"), n = o.paint.get("fill-opacity");
                if (0 === n.constantOr(1)) return;
                const { isRenderingToTexture: l } = r, c = e1.colorModeForRenderPass(), h = o.paint.get("fill-pattern"), u = e1.opaquePassEnabledForLayer() && !h.constantOr(1) && 1 === s.constantOr(t.bo.transparent).a && 1 === n.constantOr(0) ? "opaque" : "translucent";
                if (e1.renderPass === u) {
                    const t = e1.getDepthModeForSublayer(1, "opaque" === e1.renderPass ? oi.ReadWrite : oi.ReadOnly);
                    Sa(e1, i, o, a, t, c, !1, l);
                }
                if ("translucent" === e1.renderPass && o.paint.get("fill-antialias")) {
                    const t = e1.getDepthModeForSublayer(o.getPaintProperty("fill-outline-color") ? 2 : 0, oi.ReadOnly);
                    Sa(e1, i, o, a, t, c, !0, l);
                }
            },
            fillExtrusion: function(e1, t, i, o, a) {
                const r = i.paint.get("fill-extrusion-opacity");
                if (0 === r) return;
                const { isRenderingToTexture: s } = a;
                if ("translucent" === e1.renderPass) {
                    const a = new oi(e1.context.gl.LEQUAL, oi.ReadWrite, e1.depthRangeFor3D);
                    if (1 !== r || i.paint.get("fill-extrusion-pattern").constantOr(1)) za(e1, t, i, o, a, ri.disabled, ei.disabled, s), za(e1, t, i, o, a, e1.stencilModeFor3D(), e1.colorModeForRenderPass(), s);
                    else {
                        const r = e1.colorModeForRenderPass();
                        za(e1, t, i, o, a, ri.disabled, r, s);
                    }
                }
            },
            hillshade: function(e1, i, o, a, r) {
                if ("offscreen" !== e1.renderPass && "translucent" !== e1.renderPass) return;
                const { isRenderingToTexture: s } = r, n = e1.context, l = e1.style.projection.useSubdivision, c = e1.getDepthModeForSublayer(0, oi.ReadOnly), h = e1.colorModeForRenderPass();
                if ("offscreen" === e1.renderPass) !function(e1, i, o, a, r, s, n) {
                    const l = e1.context, c = l.gl, h = "nearest" === a.paint.get("resampling") ? c.NEAREST : c.LINEAR;
                    for (const u of o){
                        const o = i.getTile(u), d = o.dem;
                        if (!(null == d ? void 0 : d.data)) continue;
                        if (!o.needsHillshadePrepare) continue;
                        const _ = d.dim, p = d.stride, m = d.getPixels();
                        if (l.activeTexture.set(c.TEXTURE1), l.pixelStoreUnpackPremultiplyAlpha.set(!1), o.demTexture || (o.demTexture = e1.getTileTexture(p)), o.demTexture) {
                            const e1 = o.demTexture;
                            e1.update(m, {
                                premultiply: !1
                            }), e1.bind(c.NEAREST, c.CLAMP_TO_EDGE);
                        } else o.demTexture = new t.T(l, m, c.RGBA, {
                            premultiply: !1
                        }), o.demTexture.bind(c.NEAREST, c.CLAMP_TO_EDGE);
                        l.activeTexture.set(c.TEXTURE0);
                        let f = o.fbo;
                        if (!f) {
                            const e1 = new t.T(l, {
                                width: _,
                                height: _,
                                data: null
                            }, c.RGBA);
                            e1.bind(h, c.CLAMP_TO_EDGE), f = o.fbo = l.createFramebuffer(_, _, !0, !1), f.colorAttachment.set(e1.texture);
                        }
                        l.bindFramebuffer.set(f.framebuffer), l.viewport.set([
                            0,
                            0,
                            _,
                            _
                        ]), e1.useProgram("hillshadePrepare").draw(l, c.TRIANGLES, r, s, n, ii.disabled, io(o.tileID, d), null, null, a.id, e1.rasterBoundsBuffer, e1.quadTriangleIndexBuffer, e1.rasterBoundsSegments), o.needsHillshadePrepare = !1;
                    }
                }(e1, i, a, o, c, ri.disabled, h), n.viewport.set([
                    0,
                    0,
                    e1.width,
                    e1.height
                ]);
                else if ("translucent" === e1.renderPass) {
                    if (l) {
                        const [t, r, n] = e1.stencilConfigForOverlapTwoPass(a);
                        Ra(e1, i, o, n, t, c, h, !1, s), Ra(e1, i, o, n, r, c, h, !0, s);
                    } else {
                        const [t, r] = e1.getStencilConfigForOverlapAndUpdateStencilID(a);
                        Ra(e1, i, o, r, t, c, h, !1, s);
                    }
                }
            },
            colorRelief: function(e1, t, i, o, a) {
                if ("translucent" !== e1.renderPass) return;
                if (!o.length) return;
                const { isRenderingToTexture: r } = a, s = e1.style.projection.useSubdivision, n = e1.getDepthModeForSublayer(0, oi.ReadOnly), l = e1.colorModeForRenderPass();
                if (s) {
                    const [a, s, c] = e1.stencilConfigForOverlapTwoPass(o);
                    Aa(e1, t, i, c, a, n, l, !1, r), Aa(e1, t, i, c, s, n, l, !0, r);
                } else {
                    const [a, s] = e1.getStencilConfigForOverlapAndUpdateStencilID(o);
                    Aa(e1, t, i, s, a, n, l, !1, r);
                }
            },
            raster: function(e1, t, i, o, a) {
                if ("translucent" !== e1.renderPass) return;
                if (0 === i.paint.get("raster-opacity")) return;
                if (!o.length) return;
                const { isRenderingToTexture: r } = a, s = t.getSource(), n = e1.style.projection.useSubdivision;
                if (s instanceof te) Fa(e1, t, i, o, null, !1, !1, s.tileCoords, s.flippedWindingOrder, r);
                else if (n) {
                    const [a, s, n] = e1.stencilConfigForOverlapTwoPass(o);
                    Fa(e1, t, i, n, a, !1, !0, La, !1, r), Fa(e1, t, i, n, s, !0, !0, La, !1, r);
                } else {
                    const [a, s] = e1.getStencilConfigForOverlapAndUpdateStencilID(o);
                    Fa(e1, t, i, s, a, !1, !0, La, !1, r);
                }
            },
            background: function(e1, t, i, o, a) {
                var r;
                const s = i.paint.get("background-color"), n = i.paint.get("background-opacity");
                if (0 === n) return;
                const { isRenderingToTexture: l } = a, c = e1.context, h = c.gl, u = e1.style.projection, d = e1.transform, _ = d.tileSize, p = i.paint.get("background-pattern");
                if (e1.isPatternMissing(p)) return;
                const m = !p && 1 === s.a && 1 === n && e1.opaquePassEnabledForLayer() ? "opaque" : "translucent";
                if (e1.renderPass !== m) return;
                const f = ri.disabled, g = e1.getDepthModeForSublayer(0, "opaque" === m ? oi.ReadWrite : oi.ReadOnly), v = e1.colorModeForRenderPass(), x = e1.useProgram(p ? "backgroundPattern" : "background"), b = o || Me(d, {
                    tileSize: _,
                    terrain: e1.style.map.terrain
                });
                p && (c.activeTexture.set(h.TEXTURE0), e1.imageManager.bind(e1.context));
                const y = i.getCrossfadeParameters();
                for (const t of b){
                    const o = d.getProjectionData({
                        overscaledTileID: t,
                        applyGlobeMatrix: !l,
                        applyTerrainMatrix: !0
                    }), a = p ? xo(n, e1, p, {
                        tileID: t,
                        tileSize: _
                    }, y) : vo(n, s), m = null === (r = e1.style.map.terrain) || void 0 === r ? void 0 : r.getTerrainData(t), b = u.getMeshFromTileID(c, t.canonical, !1, !0, "raster");
                    x.draw(c, h.TRIANGLES, g, f, v, ii.backCCW, a, m, o, i.id, b.vertexBuffer, b.indexBuffer, b.segments);
                }
            },
            sky: function(e1, t) {
                const i = e1.context, o = i.gl, a = ((e1, t, i)=>{
                    const o = Math.cos(t.rollInRadians), a = Math.sin(t.rollInRadians), r = ge(t), s = t.getProjectionData({
                        overscaledTileID: null,
                        applyGlobeMatrix: !0,
                        applyTerrainMatrix: !0
                    }).projectionTransition;
                    return {
                        u_sky_color: e1.properties.get("sky-color"),
                        u_horizon_color: e1.properties.get("horizon-color"),
                        u_horizon: [
                            (t.width / 2 - r * a) * i,
                            (t.height / 2 + r * o) * i
                        ],
                        u_horizon_normal: [
                            -a,
                            o
                        ],
                        u_sky_horizon_blend: e1.properties.get("sky-horizon-blend") * t.height / 2 * i,
                        u_sky_blend: s
                    };
                })(t, e1.style.map.transform, e1.pixelRatio), r = new oi(o.LEQUAL, oi.ReadWrite, [
                    0,
                    1
                ]), s = ri.disabled, n = e1.colorModeForRenderPass(), l = e1.useProgram("sky"), c = $a(i, t);
                l.draw(i, o.TRIANGLES, r, s, n, ii.disabled, a, null, void 0, "sky", c.vertexBuffer, c.indexBuffer, c.segments);
            },
            atmosphere: function(e1, i, o) {
                const a = e1.context, r = a.gl, s = e1.useProgram("atmosphere"), n = new oi(r.LEQUAL, oi.ReadOnly, [
                    0,
                    1
                ]), l = e1.transform, c = function(e1, i) {
                    const o = e1.properties.get("position"), a = [
                        -o.x,
                        -o.y,
                        -o.z
                    ], r = t.ap(new Float64Array(16));
                    return "map" === e1.properties.get("anchor") && (t.be(r, r, i.rollInRadians), t.bf(r, r, -i.pitchInRadians), t.be(r, r, i.bearingInRadians), t.bf(r, r, i.center.lat * Math.PI / 180), t.bI(r, r, -i.center.lng * Math.PI / 180)), t.cg(a, a, r), a;
                }(o, e1.transform), h = l.getProjectionData({
                    overscaledTileID: null,
                    applyGlobeMatrix: !0,
                    applyTerrainMatrix: !0
                }), u = i.properties.get("atmosphere-blend") * h.projectionTransition;
                if (0 === u) return;
                const d = gi(l.worldSize, l.center.lat), _ = l.inverseProjectionMatrix, p = new Float64Array(4);
                p[3] = 1, t.aE(p, p, l.modelViewProjectionMatrix), p[0] /= p[3], p[1] /= p[3], p[2] /= p[3], p[3] = 1, t.aE(p, p, _), p[0] /= p[3], p[1] /= p[3], p[2] /= p[3], p[3] = 1;
                const m = ((e1, t, i, o, a)=>({
                        u_sun_pos: e1,
                        u_atmosphere_blend: t,
                        u_globe_position: i,
                        u_globe_radius: o,
                        u_inv_proj_matrix: a
                    }))(c, u, [
                    p[0],
                    p[1],
                    p[2]
                ], d, _), f = $a(a, i);
                s.draw(a, r.TRIANGLES, n, ri.disabled, ei.alphaBlended, ii.disabled, m, null, null, "atmosphere", f.vertexBuffer, f.indexBuffer, f.segments);
            },
            custom: function(e1, t, i, o) {
                const { isRenderingGlobe: a } = o, r = e1.context, s = i.implementation, n = e1.style.projection, l = e1.transform, c = l.getProjectionDataForCustomLayer(a), h = {
                    farZ: l.farZ,
                    nearZ: l.nearZ,
                    fov: l.fov * Math.PI / 180,
                    modelViewProjectionMatrix: l.modelViewProjectionMatrix,
                    projectionMatrix: l.projectionMatrix,
                    shaderData: {
                        variantName: n.shaderVariantName,
                        vertexShaderPrelude: `const float PI = 3.141592653589793;\nuniform mat4 u_projection_matrix;\n${n.shaderPreludeCode.vertexSource}`,
                        define: n.shaderDefine
                    },
                    defaultProjectionData: c
                }, u = s.renderingMode ? s.renderingMode : "2d";
                if ("offscreen" === e1.renderPass) {
                    const t = s.prerender;
                    t && (e1.setCustomLayerDefaults(), r.setColorMode(e1.colorModeForRenderPass()), t.call(s, r.gl, h), r.setDirty(), e1.setBaseState());
                } else if ("translucent" === e1.renderPass) {
                    e1.setCustomLayerDefaults(), r.setColorMode(e1.colorModeForRenderPass()), r.setStencilMode(ri.disabled);
                    const t = "3d" === u ? e1.getDepthModeFor3D() : e1.getDepthModeForSublayer(0, oi.ReadOnly);
                    r.setDepthMode(t), s.render(r.gl, h), r.setDirty(), e1.setBaseState(), r.bindFramebuffer.set(null);
                }
            },
            debug: function(e1, t, i) {
                for (const o of i)Wa(e1, t, o);
            },
            debugPadding: function(e1) {
                const t = e1.transform.padding;
                Ua(e1, e1.transform.height - (t.top || 0), 3, Ba), Ua(e1, t.bottom || 0, 3, Oa), Ga(e1, t.left || 0, 3, ja), Ga(e1, e1.transform.width - (t.right || 0), 3, Na);
                const i = e1.transform.centerPoint;
                !function(e1, t, i, o) {
                    Va(e1, t - 1, i - 10, 2, 20, o), Va(e1, t - 10, i - 1, 20, 2, o);
                }(e1, i.x, e1.transform.height - i.y, Za);
            },
            terrainDepth: function(e1, i) {
                const o = e1.context, a = o.gl, r = e1.transform, s = ei.unblended, n = new oi(a.LEQUAL, oi.ReadWrite, [
                    0,
                    1
                ]), l = i.tileManager.getRenderableTiles(), c = e1.useProgram("terrainDepth");
                o.bindFramebuffer.set(i.getFramebuffer("depth").framebuffer), o.viewport.set([
                    0,
                    0,
                    e1.width / devicePixelRatio,
                    e1.height / devicePixelRatio
                ]), o.clear({
                    color: t.bo.transparent,
                    depth: 1
                });
                for (const e1 of l){
                    const t = i.getTerrainMesh(e1.tileID), l = i.getTerrainData(e1.tileID), h = r.getProjectionData({
                        overscaledTileID: e1.tileID,
                        applyTerrainMatrix: !1,
                        applyGlobeMatrix: !0
                    }), u = {
                        u_ele_delta: i.getMeshFrameDelta(r.zoom)
                    };
                    c.draw(o, a.TRIANGLES, n, ri.disabled, s, ii.backCCW, u, l, h, "terrain", t.vertexBuffer, t.indexBuffer, t.segments);
                }
                o.bindFramebuffer.set(null), o.viewport.set([
                    0,
                    0,
                    e1.width,
                    e1.height
                ]);
            },
            terrainCoords: function(e1, i) {
                const o = e1.context, a = o.gl, r = e1.transform, s = ei.unblended, n = new oi(a.LEQUAL, oi.ReadWrite, [
                    0,
                    1
                ]), l = i.getCoordsTexture(), c = i.tileManager.getRenderableTiles(), h = e1.useProgram("terrainCoords");
                o.bindFramebuffer.set(i.getFramebuffer("coords").framebuffer), o.viewport.set([
                    0,
                    0,
                    e1.width / devicePixelRatio,
                    e1.height / devicePixelRatio
                ]), o.clear({
                    color: t.bo.transparent,
                    depth: 1
                }), i.coordsIndex = [];
                for (const e1 of c){
                    const t = i.getTerrainMesh(e1.tileID), c = i.getTerrainData(e1.tileID);
                    o.activeTexture.set(a.TEXTURE0), a.bindTexture(a.TEXTURE_2D, l.texture);
                    const u = {
                        u_terrain_coords_id: (255 - i.coordsIndex.length) / 255,
                        u_texture: 0,
                        u_ele_delta: i.getMeshFrameDelta(r.zoom)
                    }, d = r.getProjectionData({
                        overscaledTileID: e1.tileID,
                        applyTerrainMatrix: !1,
                        applyGlobeMatrix: !0
                    });
                    h.draw(o, a.TRIANGLES, n, ri.disabled, s, ii.backCCW, u, c, d, "terrain", t.vertexBuffer, t.indexBuffer, t.segments), i.coordsIndex.push(e1.tileID.key);
                }
                o.bindFramebuffer.set(null), o.viewport.set([
                    0,
                    0,
                    e1.width,
                    e1.height
                ]);
            }
        };
        class Xa {
            constructor(e1, i){
                this.drawFunctions = Ha, this.context = new ca(e1), this.transform = i, this._tileTextures = {}, this.terrainFacilitator = {
                    depthDirty: !0,
                    coordsDirty: !1,
                    matrix: t.ap(new Float64Array(16)),
                    renderTime: 0
                }, this.setup(), this.numSublayers = Fe.maxOverzooming + Fe.maxUnderzooming + 1, this.depthEpsilon = 1 / Math.pow(2, 16), this.crossTileSymbolIndex = new At;
            }
            resize(e1, t, i) {
                if (this.width = Math.floor(e1 * i), this.height = Math.floor(t * i), this.pixelRatio = i, this.context.viewport.set([
                    0,
                    0,
                    this.width,
                    this.height
                ]), this.style) for (const e1 of this.style._order)this.style._layers[e1].resize();
            }
            setup() {
                const e1 = this.context, i = new t.aU;
                i.emplaceBack(0, 0), i.emplaceBack(t.a6, 0), i.emplaceBack(0, t.a6), i.emplaceBack(t.a6, t.a6), this.tileExtentBuffer = e1.createVertexBuffer(i, Ot.members), this.tileExtentSegments = t.aV.simpleSegment(0, 0, 4, 2);
                const o = new t.aU;
                o.emplaceBack(0, 0), o.emplaceBack(t.a6, 0), o.emplaceBack(0, t.a6), o.emplaceBack(t.a6, t.a6), this.debugBuffer = e1.createVertexBuffer(o, Ot.members), this.debugSegments = t.aV.simpleSegment(0, 0, 4, 5);
                const a = new t.ch;
                a.emplaceBack(0, 0, 0, 0), a.emplaceBack(t.a6, 0, t.a6, 0), a.emplaceBack(0, t.a6, 0, t.a6), a.emplaceBack(t.a6, t.a6, t.a6, t.a6), this.rasterBoundsBuffer = e1.createVertexBuffer(a, Bi.members), this.rasterBoundsSegments = t.aV.simpleSegment(0, 0, 4, 2);
                const r = new t.aU;
                r.emplaceBack(0, 0), r.emplaceBack(t.a6, 0), r.emplaceBack(0, t.a6), r.emplaceBack(t.a6, t.a6), this.rasterBoundsBufferPosOnly = e1.createVertexBuffer(r, Ot.members), this.rasterBoundsSegmentsPosOnly = t.aV.simpleSegment(0, 0, 4, 5);
                const s = new t.aU;
                s.emplaceBack(0, 0), s.emplaceBack(1, 0), s.emplaceBack(0, 1), s.emplaceBack(1, 1), this.viewportBuffer = e1.createVertexBuffer(s, Ot.members), this.viewportSegments = t.aV.simpleSegment(0, 0, 4, 2);
                const n = new t.ci;
                n.emplaceBack(0), n.emplaceBack(1), n.emplaceBack(3), n.emplaceBack(2), n.emplaceBack(0), this.tileBorderIndexBuffer = e1.createIndexBuffer(n);
                const l = new t.aW;
                l.emplaceBack(1, 0, 2), l.emplaceBack(1, 2, 3), this.quadTriangleIndexBuffer = e1.createIndexBuffer(l);
                const c = this.context.gl;
                this.stencilClearMode = new ri({
                    func: c.ALWAYS,
                    mask: 0
                }, 0, 255, c.ZERO, c.ZERO, c.ZERO), this.tileExtentMesh = new Bt(this.tileExtentBuffer, this.quadTriangleIndexBuffer, this.tileExtentSegments);
            }
            clearStencil() {
                const e1 = this.context, i = e1.gl;
                this.nextStencilID = 1, this.currentStencilSource = void 0;
                const o = t.O();
                t.c7(o, 0, this.width, this.height, 0, 0, 1), t.S(o, o, [
                    i.drawingBufferWidth,
                    i.drawingBufferHeight,
                    0
                ]);
                const a = {
                    mainMatrix: o,
                    tileMercatorCoords: [
                        0,
                        0,
                        1,
                        1
                    ],
                    clippingPlane: [
                        0,
                        0,
                        0,
                        0
                    ],
                    projectionTransition: 0,
                    fallbackMatrix: o
                };
                this.useProgram("clippingMask", null, !0).draw(e1, i.TRIANGLES, oi.disabled, this.stencilClearMode, ei.disabled, ii.disabled, null, null, a, "$clipping", this.viewportBuffer, this.quadTriangleIndexBuffer, this.viewportSegments);
            }
            _renderTileClippingMasks(e1, t, i) {
                if (this.currentStencilSource === e1.source || !e1.isTileClipped() || !(null == t ? void 0 : t.length)) return;
                this.currentStencilSource = e1.source, this.nextStencilID + t.length > 256 && this.clearStencil();
                const o = this.context;
                o.setColorMode(ei.disabled), o.setDepthMode(oi.disabled);
                const a = {};
                for (const e1 of t)a[e1.key] = this.nextStencilID++;
                this._renderTileMasks(a, t, i, !0), this._renderTileMasks(a, t, i, !1), this._tileClippingMaskIDs = a;
            }
            _renderTileMasks(e1, t, i, o) {
                var a;
                const r = this.context, s = r.gl, n = this.style.projection, l = this.transform, c = this.useProgram("clippingMask");
                for (const h of t){
                    const t = e1[h.key], u = null === (a = this.style.map.terrain) || void 0 === a ? void 0 : a.getTerrainData(h), d = n.getMeshFromTileID(this.context, h.canonical, o, !0, "stencil"), _ = l.getProjectionData({
                        overscaledTileID: h,
                        applyGlobeMatrix: !i,
                        applyTerrainMatrix: !0
                    });
                    c.draw(r, s.TRIANGLES, oi.disabled, new ri({
                        func: s.ALWAYS,
                        mask: 0
                    }, t, 255, s.KEEP, s.KEEP, s.REPLACE), ei.disabled, i ? ii.disabled : ii.backCCW, null, u, _, "$clipping", d.vertexBuffer, d.indexBuffer, d.segments);
                }
            }
            _renderTilesDepthBuffer() {
                var e1;
                const t = this.context, i = t.gl, o = this.style.projection, a = this.transform, r = this.useProgram("depth"), s = this.getDepthModeFor3D(), n = Me(a, {
                    tileSize: a.tileSize
                });
                for (const l of n){
                    const n = null === (e1 = this.style.map.terrain) || void 0 === e1 ? void 0 : e1.getTerrainData(l), c = o.getMeshFromTileID(this.context, l.canonical, !0, !0, "raster"), h = a.getProjectionData({
                        overscaledTileID: l,
                        applyGlobeMatrix: !0,
                        applyTerrainMatrix: !0
                    });
                    r.draw(t, i.TRIANGLES, s, ri.disabled, ei.disabled, ii.backCCW, null, n, h, "$clipping", c.vertexBuffer, c.indexBuffer, c.segments);
                }
            }
            stencilModeFor3D() {
                this.currentStencilSource = void 0, this.nextStencilID + 1 > 256 && this.clearStencil();
                const e1 = this.nextStencilID++, t = this.context.gl;
                return new ri({
                    func: t.NOTEQUAL,
                    mask: 255
                }, e1, 255, t.KEEP, t.KEEP, t.REPLACE);
            }
            stencilModeForClipping(e1) {
                const t = this.context.gl;
                return new ri({
                    func: t.EQUAL,
                    mask: 255
                }, this._tileClippingMaskIDs[e1.key], 0, t.KEEP, t.KEEP, t.REPLACE);
            }
            getStencilConfigForOverlapAndUpdateStencilID(e1) {
                const t = this.context.gl, i = e1.sort((e1, t)=>t.overscaledZ - e1.overscaledZ), o = i[i.length - 1].overscaledZ, a = i[0].overscaledZ - o + 1;
                if (a > 1) {
                    this.currentStencilSource = void 0, this.nextStencilID + a > 256 && this.clearStencil();
                    const e1 = {};
                    for(let i = 0; i < a; i++)e1[i + o] = new ri({
                        func: t.GEQUAL,
                        mask: 255
                    }, i + this.nextStencilID, 255, t.KEEP, t.KEEP, t.REPLACE);
                    return this.nextStencilID += a, [
                        e1,
                        i
                    ];
                }
                return [
                    {
                        [o]: ri.disabled
                    },
                    i
                ];
            }
            stencilConfigForOverlapTwoPass(e1) {
                const t = this.context.gl, i = e1.sort((e1, t)=>t.overscaledZ - e1.overscaledZ), o = i[i.length - 1].overscaledZ, a = i[0].overscaledZ - o + 1;
                if (this.clearStencil(), a > 1) {
                    const e1 = {}, r = {};
                    for(let i = 0; i < a; i++)e1[i + o] = new ri({
                        func: t.GREATER,
                        mask: 255
                    }, a + 1 + i, 255, t.KEEP, t.KEEP, t.REPLACE), r[i + o] = new ri({
                        func: t.GREATER,
                        mask: 255
                    }, 1 + i, 255, t.KEEP, t.KEEP, t.REPLACE);
                    return this.nextStencilID = 2 * a + 1, [
                        e1,
                        r,
                        i
                    ];
                }
                return this.nextStencilID = 3, [
                    {
                        [o]: new ri({
                            func: t.GREATER,
                            mask: 255
                        }, 2, 255, t.KEEP, t.KEEP, t.REPLACE)
                    },
                    {
                        [o]: new ri({
                            func: t.GREATER,
                            mask: 255
                        }, 1, 255, t.KEEP, t.KEEP, t.REPLACE)
                    },
                    i
                ];
            }
            colorModeForRenderPass() {
                const e1 = this.context.gl;
                if (this._showOverdrawInspector) {
                    const i = 1 / 8;
                    return new ei([
                        e1.CONSTANT_COLOR,
                        e1.ONE
                    ], new t.bo(i, i, i, 0), [
                        !0,
                        !0,
                        !0,
                        !0
                    ]);
                }
                return "opaque" === this.renderPass ? ei.unblended : ei.alphaBlended;
            }
            getDepthModeForSublayer(e1, t, i) {
                if (!this.opaquePassEnabledForLayer()) return oi.disabled;
                const o = 1 - ((1 + this.currentLayer) * this.numSublayers + e1) * this.depthEpsilon;
                return new oi(i || this.context.gl.LEQUAL, t, [
                    o,
                    o
                ]);
            }
            getDepthModeFor3D() {
                return new oi(this.context.gl.LEQUAL, oi.ReadWrite, this.depthRangeFor3D);
            }
            opaquePassEnabledForLayer() {
                return this.currentLayer < this.opaquePassCutoff;
            }
            render(e1, i) {
                var o, a, r;
                this.style = e1, this.options = i, this.lineAtlas = e1.lineAtlas, this.imageManager = e1.imageManager, this.glyphManager = e1.glyphManager, this.symbolFadeChange = e1.placement.symbolFadeChange(c()), this.imageManager.beginFrame();
                const s = this.style._order, n = this.style.tileManagers, l = {}, h = {}, u = {}, d = {
                    isRenderingToTexture: !1,
                    isRenderingGlobe: (null === (o = e1.projection) || void 0 === o ? void 0 : o.transitionState) > 0
                };
                for(const e1 in n){
                    const t = n[e1];
                    t.used && t.prepare(this.context), l[e1] = t.getVisibleCoordinates(!1), h[e1] = l[e1].slice().reverse(), u[e1] = t.getVisibleCoordinates(!0).reverse();
                }
                this.opaquePassCutoff = 1 / 0;
                for(let e1 = 0; e1 < s.length; e1++)if (this.style._layers[s[e1]].is3D()) {
                    this.opaquePassCutoff = e1;
                    break;
                }
                this.maybeDrawDepth(!1), this.renderToTexture && (this.renderToTexture.prepareForRender(this.style, this.transform.zoom), this.opaquePassCutoff = 0), this.renderPass = "offscreen";
                for (const e1 of s){
                    const t = this.style._layers[e1];
                    if (!t.hasOffscreenPass() || t.isHidden(this.transform.zoom)) continue;
                    const i = h[t.source];
                    ("custom" === t.type || i.length) && this.renderLayer(this, n[t.source], t, i, d);
                }
                if (null === (a = this.style.projection) || void 0 === a || a.updateGPUdependent({
                    context: this.context,
                    useProgram: (e1)=>this.useProgram(e1)
                }), this.context.viewport.set([
                    0,
                    0,
                    this.width,
                    this.height
                ]), this.context.bindFramebuffer.set(null), this.context.clear({
                    color: i.showOverdrawInspector ? t.bo.black : t.bo.transparent,
                    depth: 1
                }), this.clearStencil(), this.style.sky && this.drawFunctions.sky(this, this.style.sky), this._showOverdrawInspector = i.showOverdrawInspector, this.depthRangeFor3D = [
                    0,
                    1 - (e1._order.length + 2) * this.numSublayers * this.depthEpsilon
                ], !this.renderToTexture) for(this.renderPass = "opaque", this.currentLayer = s.length - 1; this.currentLayer >= 0; this.currentLayer--){
                    const e1 = this.style._layers[s[this.currentLayer]], t = n[e1.source], i = l[e1.source];
                    this._renderTileClippingMasks(e1, i, !1), this.renderLayer(this, t, e1, i, d);
                }
                this.renderPass = "translucent";
                let _ = !1;
                for(this.currentLayer = 0; this.currentLayer < s.length; this.currentLayer++){
                    const e1 = this.style._layers[s[this.currentLayer]], t = n[e1.source];
                    if (null === (r = this.renderToTexture) || void 0 === r ? void 0 : r.renderLayer(e1, d)) continue;
                    this.opaquePassEnabledForLayer() || _ || (_ = !0, d.isRenderingGlobe && !this.style.map.terrain && this._renderTilesDepthBuffer());
                    const i = ("symbol" === e1.type ? u : h)[e1.source];
                    this._renderTileClippingMasks(e1, l[e1.source], !!this.renderToTexture), this.renderLayer(this, t, e1, i, d);
                }
                if (d.isRenderingGlobe && this.drawFunctions.atmosphere(this, this.style.sky, this.style.light), this.options.showTileBoundaries) {
                    const e1 = function(e1, t) {
                        let i = null;
                        const o = Object.values(e1._layers).flatMap((i)=>i.source && !i.isHidden(t) ? [
                                e1.tileManagers[i.source]
                            ] : []), a = o.filter((e1)=>"vector" === e1.getSource().type), r = o.filter((e1)=>"vector" !== e1.getSource().type), s = (e1)=>{
                            (!i || i.getSource().maxzoom < e1.getSource().maxzoom) && (i = e1);
                        };
                        for (const e1 of a)s(e1);
                        if (!i) for (const e1 of r)s(e1);
                        return i;
                    }(this.style, this.transform.zoom);
                    e1 && this.drawFunctions.debug(this, e1, e1.getVisibleCoordinates());
                }
                this.options.showPadding && this.drawFunctions.debugPadding(this), this.context.setDefault();
            }
            maybeDrawDepth(e1) {
                var i, o;
                if (!(null === (o = null === (i = this.style) || void 0 === i ? void 0 : i.map) || void 0 === o ? void 0 : o.terrain)) return;
                const a = this.terrainFacilitator.matrix, r = this.transform.modelViewProjectionMatrix;
                let s = this.terrainFacilitator.depthDirty;
                s || (s = e1 ? !t.cj(a, r) : !t.ck(a, r)), s || (s = this.style.map.terrain.tileManager.anyTilesAfterTime(this.terrainFacilitator.renderTime)), s && (t.cl(a, r), this.terrainFacilitator.renderTime = Date.now(), this.terrainFacilitator.depthDirty = !1, this.terrainFacilitator.coordsDirty = !0, this.drawFunctions.terrainDepth(this, this.style.map.terrain));
            }
            maybeDrawCoords() {
                var e1, t;
                (null === (t = null === (e1 = this.style) || void 0 === e1 ? void 0 : e1.map) || void 0 === t ? void 0 : t.terrain) && this.terrainFacilitator.coordsDirty && (this.terrainFacilitator.coordsDirty = !1, this.drawFunctions.terrainCoords(this, this.style.map.terrain));
            }
            renderLayer(e1, i, o, a, r) {
                if (o.isHidden(this.transform.zoom)) return;
                if ("background" !== o.type && "custom" !== o.type && !(a || []).length) return;
                this.id = o.id;
                const s = this.drawFunctions;
                t.aQ(o) ? s.symbol(e1, i, o, a, this.style.placement.variableOffsets, r) : t.cm(o) ? s.circle(e1, i, o, a, r) : t.cn(o) ? s.heatmap(e1, i, o, a, r) : t.co(o) ? s.line(e1, i, o, a, r) : t.cp(o) ? s.fill(e1, i, o, a, r) : t.cq(o) ? s.fillExtrusion(e1, i, o, a, r) : t.cr(o) ? s.hillshade(e1, i, o, a, r) : t.cs(o) ? s.colorRelief(e1, i, o, a, r) : t.bU(o) ? s.raster(e1, i, o, a, r) : t.ct(o) ? s.background(e1, i, o, a, r) : t.cu(o) && s.custom(e1, i, o, r);
            }
            saveTileTexture(e1) {
                const t = this._tileTextures[e1.size[0]];
                t ? t.length < Xa.MAX_TEXTURE_POOL_SIZE_PER_BUCKET ? t.push(e1) : e1.destroy() : this._tileTextures[e1.size[0]] = [
                    e1
                ];
            }
            getTileTexture(e1) {
                const t = this._tileTextures[e1];
                return t && t.length > 0 ? t.pop() : null;
            }
            isPatternMissing(e1) {
                if (!e1) return !1;
                if (!e1.from || !e1.to) return !0;
                const t = this.imageManager.getPattern(e1.from.toString()), i = this.imageManager.getPattern(e1.to.toString());
                return !t || !i;
            }
            useProgram(e1, t, i = !1, o = []) {
                var a;
                this.cache || (this.cache = {});
                const r = !!this.style.map.terrain, s = this.style.projection, n = i ? Ft.projectionMercator : s.shaderPreludeCode, l = i ? jt : s.shaderDefine, c = e1 + (t ? t.cacheKey : "") + `/${i ? Nt : s.shaderVariantName}` + (this._showOverdrawInspector ? "/overdraw" : "") + (r ? "/terrain" : "") + (o ? `/${o.join("/")}` : "");
                return (a = this.cache)[c] || (a[c] = new Ui(this.context, Ft[e1], t, yo[e1], this._showOverdrawInspector, r, n, l, o)), this.cache[c];
            }
            setCustomLayerDefaults() {
                this.context.unbindVAO(), this.context.cullFace.setDefault(), this.context.activeTexture.setDefault(), this.context.pixelStoreUnpack.setDefault(), this.context.pixelStoreUnpackPremultiplyAlpha.setDefault(), this.context.pixelStoreUnpackFlipY.setDefault();
            }
            setBaseState() {
                const e1 = this.context.gl;
                this.context.cullFace.set(!1), this.context.viewport.set([
                    0,
                    0,
                    this.width,
                    this.height
                ]), this.context.blendEquation.set(e1.FUNC_ADD);
            }
            initDebugOverlayCanvas() {
                null == this.debugOverlayCanvas && (this.debugOverlayCanvas = document.createElement("canvas"), this.debugOverlayCanvas.width = 512, this.debugOverlayCanvas.height = 512, this.debugOverlayTexture = new t.T(this.context, this.debugOverlayCanvas, this.context.gl.RGBA));
            }
            destroy() {
                var e1, t;
                if (this._tileTextures) {
                    for(const e1 in this._tileTextures){
                        const t = this._tileTextures[e1];
                        if (t) for (const e1 of t)e1.destroy();
                    }
                    this._tileTextures = {};
                }
                if (this.tileExtentBuffer && this.tileExtentBuffer.destroy(), this.debugBuffer && this.debugBuffer.destroy(), this.rasterBoundsBuffer && this.rasterBoundsBuffer.destroy(), this.rasterBoundsBufferPosOnly && this.rasterBoundsBufferPosOnly.destroy(), this.viewportBuffer && this.viewportBuffer.destroy(), this.tileBorderIndexBuffer && this.tileBorderIndexBuffer.destroy(), this.quadTriangleIndexBuffer && this.quadTriangleIndexBuffer.destroy(), this.tileExtentMesh && (null === (e1 = this.tileExtentMesh.vertexBuffer) || void 0 === e1 || e1.destroy()), this.tileExtentMesh && (null === (t = this.tileExtentMesh.indexBuffer) || void 0 === t || t.destroy()), this.debugOverlayTexture && this.debugOverlayTexture.destroy(), this.cache) {
                    for(const e1 in this.cache){
                        const t = this.cache[e1];
                        (null == t ? void 0 : t.program) && this.context.gl.deleteProgram(t.program);
                    }
                    this.cache = {};
                }
                this.context && this.context.setDefault();
            }
            overLimit() {
                const { drawingBufferWidth: e1, drawingBufferHeight: t } = this.context.gl;
                return this.width !== e1 || this.height !== t;
            }
        }
        function Ka(e1, t) {
            let i, o = !1, a = null;
            const r = ()=>{
                a = null, o && (e1(...i), a = setTimeout(r, t), o = !1);
            };
            return (...e1)=>(o = !0, i = e1, a || r(), a);
        }
        Xa.MAX_TEXTURE_POOL_SIZE_PER_BUCKET = 50;
        class Ya {
            constructor(e1){
                this._getCurrentHash = ()=>{
                    const e1 = window.location.hash.replace("#", "");
                    if (this._hashName) {
                        let t;
                        const i = e1.split("&").map((e1)=>e1.split("="));
                        for (const e1 of i)e1[0] === this._hashName && (t = e1);
                        return (t && t[1] || "").split("/");
                    }
                    return e1.split("/");
                }, this._onHashChange = ()=>{
                    const e1 = this._getCurrentHash();
                    if (!this._isValidHash(e1)) return !1;
                    const t = this._map.dragRotate.isEnabled() && this._map.touchZoomRotate.isEnabled() ? +(e1[3] || 0) : this._map.getBearing();
                    return this._map.jumpTo({
                        center: [
                            +e1[2],
                            +e1[1]
                        ],
                        zoom: +e1[0],
                        bearing: t,
                        pitch: +(e1[4] || 0)
                    }), !0;
                }, this._updateHashUnthrottled = ()=>{
                    const e1 = window.location.href.replace(/(#.*)?$/, this.getHashString());
                    window.history.replaceState(window.history.state, null, e1);
                }, this._removeHash = ()=>{
                    const e1 = this._getCurrentHash();
                    if (0 === e1.length) return;
                    const t = e1.join("/");
                    let i = t;
                    i.split("&").length > 0 && (i = i.split("&")[0]), this._hashName && (i = `${this._hashName}=${t}`);
                    let o = window.location.hash.replace(i, "");
                    o.startsWith("#&") ? o = o.slice(0, 1) + o.slice(2) : "#" === o && (o = "");
                    let a = window.location.href.replace(/(#.+)?$/, o);
                    a = a.replace("&&", "&"), window.history.replaceState(window.history.state, null, a);
                }, this._updateHash = Ka(this._updateHashUnthrottled, 300), this._hashName = e1 && encodeURIComponent(e1);
            }
            addTo(e1) {
                return this._map = e1, addEventListener("hashchange", this._onHashChange, !1), this._map.on("moveend", this._updateHash), this;
            }
            remove() {
                return removeEventListener("hashchange", this._onHashChange, !1), this._map.off("moveend", this._updateHash), clearTimeout(this._updateHash()), this._removeHash(), delete this._map, this;
            }
            getHashString(e1) {
                const t = this._map.getCenter(), i = Math.round(100 * this._map.getZoom()) / 100, o = Math.ceil((i * Math.LN2 + Math.log(512 / 360 / .5)) / Math.LN10), a = Math.pow(10, o), r = Math.round(t.lng * a) / a, s = Math.round(t.lat * a) / a, n = this._map.getBearing(), l = this._map.getPitch();
                let c = "";
                if (c += e1 ? `/${r}/${s}/${i}` : `${i}/${s}/${r}`, (n || l) && (c += "/" + Math.round(10 * n) / 10), l && (c += `/${Math.round(l)}`), this._hashName) {
                    const e1 = this._hashName;
                    let t = !1;
                    const i = window.location.hash.slice(1).split("&").map((i)=>{
                        const o = i.split("=")[0];
                        return o === e1 ? (t = !0, `${o}=${c}`) : i;
                    }).filter((e1)=>e1);
                    return t || i.push(`${e1}=${c}`), `#${i.join("&")}`;
                }
                return `#${c}`;
            }
            _isValidHash(e1) {
                if (e1.length < 3 || e1.some(isNaN)) return !1;
                try {
                    new t.W(+e1[2], +e1[1]);
                } catch (e1) {
                    return !1;
                }
                const i = +e1[0], o = +(e1[3] || 0), a = +(e1[4] || 0);
                return i >= this._map.getMinZoom() && i <= this._map.getMaxZoom() && o >= -180 && o <= 180 && a >= this._map.getMinPitch() && a <= this._map.getMaxPitch();
            }
        }
        const Qa = {
            linearity: .3,
            easing: t.cv(0, 0, .3, 1)
        }, Ja = t.e({
            deceleration: 2500,
            maxSpeed: 1400
        }, Qa), er = t.e({
            deceleration: 20,
            maxSpeed: 1400
        }, Qa), tr = t.e({
            deceleration: 1e3,
            maxSpeed: 360
        }, Qa), ir = t.e({
            deceleration: 1e3,
            maxSpeed: 90
        }, Qa), or = t.e({
            deceleration: 1e3,
            maxSpeed: 360
        }, Qa);
        class ar {
            constructor(e1){
                this._map = e1, this.clear();
            }
            clear() {
                this._inertiaBuffer = [];
            }
            record(e1) {
                this._drainInertiaBuffer(), this._inertiaBuffer.push({
                    time: c(),
                    settings: e1
                });
            }
            _drainInertiaBuffer() {
                const e1 = this._inertiaBuffer, t = c();
                for(; e1.length > 0 && t - e1[0].time > 160;)e1.shift();
            }
            _onMoveEnd(e1) {
                if (this._drainInertiaBuffer(), this._inertiaBuffer.length < 2) return;
                const i = {
                    zoom: 0,
                    bearing: 0,
                    pitch: 0,
                    roll: 0,
                    pan: new t.P(0, 0),
                    pinchAround: void 0,
                    around: void 0
                };
                for (const { settings: e1 } of this._inertiaBuffer)i.zoom += e1.zoomDelta || 0, i.bearing += e1.bearingDelta || 0, i.pitch += e1.pitchDelta || 0, i.roll += e1.rollDelta || 0, e1.panDelta && i.pan._add(e1.panDelta), e1.around && (i.around = e1.around), e1.pinchAround && (i.pinchAround = e1.pinchAround);
                const o = this._inertiaBuffer[this._inertiaBuffer.length - 1].time - this._inertiaBuffer[0].time, a = {};
                if (i.pan.mag()) {
                    const r = sr(i.pan.mag(), o, t.e({}, Ja, e1 || {})), s = i.pan.mult(r.amount / i.pan.mag()), n = this._map.cameraHelper.handlePanInertia(s, this._map.transform);
                    a.center = n.easingCenter, a.offset = n.easingOffset, rr(a, r);
                }
                if (i.zoom) {
                    const e1 = sr(i.zoom, o, er);
                    a.zoom = t.cw(this._map.transform.zoom + e1.amount, this._map.getZoomSnap(), e1.amount), rr(a, e1);
                }
                if (i.bearing) {
                    const e1 = sr(i.bearing, o, tr);
                    a.bearing = this._map.transform.bearing + t.al(e1.amount, -179, 179), rr(a, e1);
                }
                if (i.pitch) {
                    const e1 = sr(i.pitch, o, ir);
                    a.pitch = this._map.transform.pitch + e1.amount, rr(a, e1);
                }
                if (i.roll) {
                    const e1 = sr(i.roll, o, or);
                    a.roll = this._map.transform.roll + t.al(e1.amount, -179, 179), rr(a, e1);
                }
                if (a.zoom || a.bearing) {
                    const e1 = void 0 === i.pinchAround ? i.around : i.pinchAround;
                    a.around = e1 ? this._map.unproject(e1) : this._map.getCenter();
                }
                return this.clear(), t.e(a, {
                    noMoveStart: !0
                });
            }
        }
        function rr(e1, t) {
            (!e1.duration || e1.duration < t.duration) && (e1.duration = t.duration, e1.easing = t.easing);
        }
        function sr(e1, i, o) {
            const { maxSpeed: a, linearity: r, deceleration: s } = o, n = t.al(e1 * r / (i / 1e3), -a, a), l = Math.abs(n) / (s * r);
            return {
                easing: o.easing,
                duration: 1e3 * l,
                amount: n * (l / 2)
            };
        }
        class nr extends t.n {
            preventDefault() {
                this._defaultPrevented = !0;
            }
            get defaultPrevented() {
                return this._defaultPrevented;
            }
            constructor(e1, i, o, a = {}){
                o = o instanceof MouseEvent ? o : new MouseEvent(e1, o);
                const r = d.mousePos(i.getCanvas(), o), s = i.unproject(r);
                super(e1, t.e({
                    point: r,
                    lngLat: s,
                    originalEvent: o
                }, a)), this._defaultPrevented = !1, this.target = i;
            }
        }
        class lr extends t.n {
            preventDefault() {
                this._defaultPrevented = !0;
            }
            get defaultPrevented() {
                return this._defaultPrevented;
            }
            constructor(e1, i, o){
                const a = "touchend" === e1 ? o.changedTouches : o.touches, r = d.touchPos(i.getCanvasContainer(), a), s = r.map((e1)=>i.unproject(e1)), n = r.reduce((e1, t, i, o)=>e1.add(t.div(o.length)), new t.P(0, 0));
                super(e1, {
                    points: r,
                    point: n,
                    lngLats: s,
                    lngLat: i.unproject(n),
                    originalEvent: o
                }), this._defaultPrevented = !1;
            }
        }
        class cr extends t.n {
            preventDefault() {
                this._defaultPrevented = !0;
            }
            get defaultPrevented() {
                return this._defaultPrevented;
            }
            constructor(e1, t, i){
                super(e1, {
                    originalEvent: i
                }), this._defaultPrevented = !1;
            }
        }
        class hr {
            constructor(e1, t){
                this._map = e1, this._clickTolerance = t.clickTolerance;
            }
            reset() {
                delete this._mousedownPos;
            }
            wheel(e1) {
                return this._firePreventable(new cr(e1.type, this._map, e1));
            }
            mousedown(e1, t) {
                return this._mousedownPos = t, this._firePreventable(new nr(e1.type, this._map, e1));
            }
            mouseup(e1) {
                this._map.fire(new nr(e1.type, this._map, e1));
            }
            click(e1, t) {
                this._mousedownPos && this._mousedownPos.dist(t) >= this._clickTolerance || this._map.fire(new nr(e1.type, this._map, e1));
            }
            dblclick(e1) {
                return this._firePreventable(new nr(e1.type, this._map, e1));
            }
            mouseover(e1) {
                this._map.fire(new nr(e1.type, this._map, e1));
            }
            mouseout(e1) {
                this._map.fire(new nr(e1.type, this._map, e1));
            }
            touchstart(e1) {
                return this._firePreventable(new lr(e1.type, this._map, e1));
            }
            touchmove(e1) {
                this._map.fire(new lr(e1.type, this._map, e1));
            }
            touchend(e1) {
                this._map.fire(new lr(e1.type, this._map, e1));
            }
            touchcancel(e1) {
                this._map.fire(new lr(e1.type, this._map, e1));
            }
            _firePreventable(e1) {
                if (this._map.fire(e1), e1.defaultPrevented) return {};
            }
            isEnabled() {
                return !0;
            }
            isActive() {
                return !1;
            }
            enable() {}
            disable() {}
        }
        class ur {
            constructor(e1){
                this._map = e1;
            }
            reset() {
                this._delayContextMenu = !1, this._ignoreContextMenu = !0, delete this._contextMenuEvent;
            }
            mousemove(e1) {
                this._map.fire(new nr(e1.type, this._map, e1));
            }
            mousedown() {
                this._delayContextMenu = !0, this._ignoreContextMenu = !1;
            }
            mouseup() {
                this._delayContextMenu = !1, this._contextMenuEvent && (this._map.fire(new nr("contextmenu", this._map, this._contextMenuEvent)), delete this._contextMenuEvent);
            }
            contextmenu(e1) {
                this._delayContextMenu ? this._contextMenuEvent = e1 : this._ignoreContextMenu || this._map.fire(new nr(e1.type, this._map, e1)), this._map.listens("contextmenu") && e1.preventDefault();
            }
            isEnabled() {
                return !0;
            }
            isActive() {
                return !1;
            }
            enable() {}
            disable() {}
        }
        class dr {
            constructor(e1){
                this._map = e1;
            }
            get transform() {
                return this._map._requestedCameraState || this._map.transform;
            }
            get center() {
                return {
                    lng: this.transform.center.lng,
                    lat: this.transform.center.lat
                };
            }
            get zoom() {
                return this.transform.zoom;
            }
            get pitch() {
                return this.transform.pitch;
            }
            get bearing() {
                return this.transform.bearing;
            }
            unproject(e1) {
                return this.transform.screenPointToLocation(t.P.convert(e1), this._map.terrain);
            }
        }
        class _r {
            constructor(e1, t){
                this._map = e1, this._tr = new dr(e1), this._el = e1.getCanvasContainer(), this._container = e1.getContainer(), this._clickTolerance = t.clickTolerance || 1, t.boxZoom && "object" == typeof t.boxZoom && (this._boxZoomEnd = t.boxZoom.boxZoomEnd);
            }
            isEnabled() {
                return !!this._enabled;
            }
            isActive() {
                return !!this._active;
            }
            enable() {
                this.isEnabled() || (this._enabled = !0);
            }
            disable() {
                this.isEnabled() && (this._enabled = !1);
            }
            mousedown(e1, t) {
                this.isEnabled() && e1.shiftKey && 0 === e1.button && (d.disableDrag(), this._startPos = this._lastPos = t, this._active = !0);
            }
            mousemoveWindow(e1, t) {
                if (!this._active) return;
                const i = t;
                if (this._lastPos.equals(i) || !this._box && i.dist(this._startPos) < this._clickTolerance) return;
                const o = this._startPos;
                this._lastPos = i, this._box || (this._box = d.create("div", "maplibregl-boxzoom", this._container), this._container.classList.add("maplibregl-crosshair"), this._fireEvent("boxzoomstart", e1));
                const a = Math.min(o.x, i.x), r = Math.max(o.x, i.x), s = Math.min(o.y, i.y), n = Math.max(o.y, i.y);
                this._box.style.transform = `translate(${a}px,${s}px)`, this._box.style.width = r - a + "px", this._box.style.height = n - s + "px";
            }
            mouseupWindow(e1, i) {
                if (!this._active) return;
                if (0 !== e1.button) return;
                const o = this._startPos, a = i;
                if (this.reset(), d.suppressClick(), o.x !== a.x || o.y !== a.y) return this._map.fire(new t.n("boxzoomend", {
                    originalEvent: e1
                })), this._boxZoomEnd ? void this._boxZoomEnd(this._map, o, a, e1) : {
                    cameraAnimation: (e1)=>e1.fitScreenCoordinates(o, a, this._tr.bearing, {
                            linear: !0
                        })
                };
                this._fireEvent("boxzoomcancel", e1);
            }
            keydown(e1) {
                this._active && 27 === e1.keyCode && (this.reset(), this._fireEvent("boxzoomcancel", e1));
            }
            reset() {
                this._active = !1, this._container.classList.remove("maplibregl-crosshair"), this._box && (this._box.remove(), this._box = null), d.enableDrag(), delete this._startPos, delete this._lastPos;
            }
            _fireEvent(e1, i) {
                return this._map.fire(new t.n(e1, {
                    originalEvent: i
                }));
            }
        }
        function pr(e1, t) {
            if (e1.length !== t.length) throw new Error(`The number of touches and points are not equal - touches ${e1.length}, points ${t.length}`);
            const i = {};
            for(let o = 0; o < e1.length; o++)i[e1[o].identifier] = t[o];
            return i;
        }
        class mr {
            constructor(e1){
                this.reset(), this.numTouches = e1.numTouches;
            }
            reset() {
                delete this.centroid, delete this.startTime, delete this.touches, this.aborted = !1;
            }
            touchstart(e1, i, o) {
                (this.centroid || o.length > this.numTouches) && (this.aborted = !0), this.aborted || (void 0 === this.startTime && (this.startTime = e1.timeStamp), o.length === this.numTouches && (this.centroid = function(e1) {
                    const i = new t.P(0, 0);
                    for (const t of e1)i._add(t);
                    return i.div(e1.length);
                }(i), this.touches = pr(o, i)));
            }
            touchmove(e1, t, i) {
                if (this.aborted || !this.centroid) return;
                const o = pr(i, t);
                for(const e1 in this.touches){
                    const t = o[e1];
                    (!t || t.dist(this.touches[e1]) > 30) && (this.aborted = !0);
                }
            }
            touchend(e1, t, i) {
                if ((!this.centroid || e1.timeStamp - this.startTime > 500) && (this.aborted = !0), 0 === i.length) {
                    const e1 = !this.aborted && this.centroid;
                    if (this.reset(), e1) return e1;
                }
            }
        }
        class fr {
            constructor(e1){
                this.singleTap = new mr(e1), this.numTaps = e1.numTaps, this.reset();
            }
            reset() {
                this.lastTime = 1 / 0, delete this.lastTap, this.count = 0, this.singleTap.reset();
            }
            touchstart(e1, t, i) {
                this.singleTap.touchstart(e1, t, i);
            }
            touchmove(e1, t, i) {
                this.singleTap.touchmove(e1, t, i);
            }
            touchend(e1, t, i) {
                const o = this.singleTap.touchend(e1, t, i);
                if (o) {
                    const t = e1.timeStamp - this.lastTime < 500, i = !this.lastTap || this.lastTap.dist(o) < 30;
                    if (t && i || this.reset(), this.count++, this.lastTime = e1.timeStamp, this.lastTap = o, this.count === this.numTaps) return this.reset(), o;
                }
            }
        }
        class gr {
            constructor(e1){
                this._tr = new dr(e1), this._zoomIn = new fr({
                    numTouches: 1,
                    numTaps: 2
                }), this._zoomOut = new fr({
                    numTouches: 2,
                    numTaps: 1
                }), this.reset();
            }
            reset() {
                this._active = !1, this._zoomIn.reset(), this._zoomOut.reset();
            }
            touchstart(e1, t, i) {
                this._zoomIn.touchstart(e1, t, i), this._zoomOut.touchstart(e1, t, i);
            }
            touchmove(e1, t, i) {
                this._zoomIn.touchmove(e1, t, i), this._zoomOut.touchmove(e1, t, i);
            }
            touchend(e1, i, o) {
                const a = this._zoomIn.touchend(e1, i, o), r = this._zoomOut.touchend(e1, i, o), s = this._tr;
                return a ? (this._active = !0, e1.preventDefault(), setTimeout(()=>this.reset(), 0), {
                    cameraAnimation: (i)=>i.easeTo({
                            duration: 300,
                            zoom: t.cw(s.zoom + 1, i.getZoomSnap()),
                            around: s.unproject(a)
                        }, {
                            originalEvent: e1
                        })
                }) : r ? (this._active = !0, e1.preventDefault(), setTimeout(()=>this.reset(), 0), {
                    cameraAnimation: (i)=>i.easeTo({
                            duration: 300,
                            zoom: t.cw(s.zoom - 1, i.getZoomSnap()),
                            around: s.unproject(r)
                        }, {
                            originalEvent: e1
                        })
                }) : void 0;
            }
            touchcancel() {
                this.reset();
            }
            enable() {
                this._enabled = !0;
            }
            disable() {
                this._enabled = !1, this.reset();
            }
            isEnabled() {
                return this._enabled;
            }
            isActive() {
                return this._active;
            }
        }
        class vr {
            constructor(e1){
                this._enabled = !!e1.enable, this._moveStateManager = e1.moveStateManager, this._clickTolerance = e1.clickTolerance || 1, this._moveFunction = e1.move, this._activateOnStart = !!e1.activateOnStart, e1.assignEvents(this), this.reset();
            }
            reset(e1) {
                this._active = !1, this._moved = !1, delete this._lastPoint, this._moveStateManager.endMove(e1);
            }
            _move(...e1) {
                const t = this._moveFunction(...e1);
                if (t.bearingDelta || t.pitchDelta || t.rollDelta || t.around || t.panDelta) return this._active = !0, t;
            }
            dragStart(e1, t) {
                this.isEnabled() && !this._lastPoint && this._moveStateManager.isValidStartEvent(e1) && (this._moveStateManager.startMove(e1), this._lastPoint = Array.isArray(t) ? t[0] : t, this._activateOnStart && this._lastPoint && (this._active = !0));
            }
            dragMove(e1, t) {
                if (!this.isEnabled()) return;
                const i = this._lastPoint;
                if (!i) return;
                if (e1.preventDefault(), !this._moveStateManager.isValidMoveEvent(e1)) return void this.reset(e1);
                const o = Array.isArray(t) ? t[0] : t;
                return !this._moved && o.dist(i) < this._clickTolerance ? void 0 : (this._moved = !0, this._lastPoint = o, this._move(i, o));
            }
            dragEnd(e1) {
                this.isEnabled() && this._lastPoint && this._moveStateManager.isValidEndEvent(e1) && (this._moved && d.suppressClick(), this.reset(e1));
            }
            enable() {
                this._enabled = !0;
            }
            disable() {
                this._enabled = !1, this.reset();
            }
            isEnabled() {
                return this._enabled;
            }
            isActive() {
                return this._active;
            }
            getClickTolerance() {
                return this._clickTolerance;
            }
        }
        const xr = 0, br = 2, yr = {
            [xr]: 1,
            [br]: 2
        };
        class wr {
            constructor(e1){
                this._correctEvent = e1.checkCorrectEvent;
            }
            startMove(e1) {
                this._eventButton = e1.button;
            }
            endMove(e1) {
                delete this._eventButton;
            }
            isValidStartEvent(e1) {
                return this._correctEvent(e1);
            }
            isValidMoveEvent(e1) {
                return !function(e1, t) {
                    const i = yr[t];
                    return void 0 === e1.buttons || (e1.buttons & i) !== i;
                }(e1, this._eventButton);
            }
            isValidEndEvent(e1) {
                return e1.button === this._eventButton;
            }
        }
        class Tr {
            constructor(){
                this._firstTouch = void 0;
            }
            _isOneFingerTouch(e1) {
                return 1 === e1.targetTouches.length;
            }
            _isSameTouchEvent(e1) {
                return e1.targetTouches[0].identifier === this._firstTouch;
            }
            startMove(e1) {
                this._firstTouch = e1.targetTouches[0].identifier;
            }
            endMove(e1) {
                delete this._firstTouch;
            }
            isValidStartEvent(e1) {
                return this._isOneFingerTouch(e1);
            }
            isValidMoveEvent(e1) {
                return this._isOneFingerTouch(e1) && this._isSameTouchEvent(e1);
            }
            isValidEndEvent(e1) {
                return this._isOneFingerTouch(e1) && this._isSameTouchEvent(e1);
            }
        }
        class Pr {
            constructor(e1 = new wr({
                checkCorrectEvent: ()=>!0
            }), t = new Tr){
                this.mouseMoveStateManager = e1, this.oneFingerTouchMoveStateManager = t;
            }
            _executeRelevantHandler(e1, t, i) {
                return e1 instanceof MouseEvent ? t(e1) : "undefined" != typeof TouchEvent && e1 instanceof TouchEvent ? i(e1) : void 0;
            }
            startMove(e1) {
                this._executeRelevantHandler(e1, (e1)=>{
                    this.mouseMoveStateManager.startMove(e1);
                }, (e1)=>{
                    this.oneFingerTouchMoveStateManager.startMove(e1);
                });
            }
            endMove(e1) {
                this._executeRelevantHandler(e1, (e1)=>{
                    this.mouseMoveStateManager.endMove(e1);
                }, (e1)=>{
                    this.oneFingerTouchMoveStateManager.endMove(e1);
                });
            }
            isValidStartEvent(e1) {
                return this._executeRelevantHandler(e1, (e1)=>this.mouseMoveStateManager.isValidStartEvent(e1), (e1)=>this.oneFingerTouchMoveStateManager.isValidStartEvent(e1));
            }
            isValidMoveEvent(e1) {
                return this._executeRelevantHandler(e1, (e1)=>this.mouseMoveStateManager.isValidMoveEvent(e1), (e1)=>this.oneFingerTouchMoveStateManager.isValidMoveEvent(e1));
            }
            isValidEndEvent(e1) {
                return this._executeRelevantHandler(e1, (e1)=>this.mouseMoveStateManager.isValidEndEvent(e1), (e1)=>this.oneFingerTouchMoveStateManager.isValidEndEvent(e1));
            }
        }
        const Cr = (e1)=>{
            e1.mousedown = e1.dragStart, e1.mousemoveWindow = e1.dragMove, e1.mouseup = e1.dragEnd, e1.contextmenu = (e1)=>{
                e1.preventDefault();
            };
        };
        class Mr {
            constructor(e1, t){
                this._clickTolerance = e1.clickTolerance || 1, this._map = t, this.reset();
            }
            reset() {
                this._active = !1, this._touches = {}, this._sum = new t.P(0, 0);
            }
            _shouldBePrevented(e1) {
                return e1 < (this._map.cooperativeGestures.isEnabled() ? 2 : 1);
            }
            touchstart(e1, t, i) {
                return this._calculateTransform(e1, t, i);
            }
            touchmove(e1, t, i) {
                if (this._active) {
                    if (!this._shouldBePrevented(i.length)) return e1.preventDefault(), this._calculateTransform(e1, t, i);
                    this._map.cooperativeGestures.notifyGestureBlocked("touch_pan", e1);
                }
            }
            touchend(e1, t, i) {
                this._calculateTransform(e1, t, i), this._active && this._shouldBePrevented(i.length) && this.reset();
            }
            touchcancel() {
                this.reset();
            }
            _calculateTransform(e1, i, o) {
                o.length > 0 && (this._active = !0);
                const a = pr(o, i), r = new t.P(0, 0), s = new t.P(0, 0);
                let n = 0;
                for(const e1 in a){
                    const t = a[e1], i = this._touches[e1];
                    i && (r._add(t), s._add(t.sub(i)), n++, a[e1] = t);
                }
                if (this._touches = a, this._shouldBePrevented(n) || !s.mag()) return;
                const l = s.div(n);
                return this._sum._add(l), this._sum.mag() < this._clickTolerance ? void 0 : {
                    around: r.div(n),
                    panDelta: l
                };
            }
            enable() {
                this._enabled = !0;
            }
            disable() {
                this._enabled = !1, this.reset();
            }
            isEnabled() {
                return this._enabled;
            }
            isActive() {
                return this._active;
            }
        }
        class Ir {
            constructor(){
                this.reset();
            }
            reset() {
                this._active = !1, delete this._firstTwoTouches;
            }
            touchstart(e1, t, i) {
                this._firstTwoTouches || i.length < 2 || (this._firstTwoTouches = [
                    i[0].identifier,
                    i[1].identifier
                ], this._start([
                    t[0],
                    t[1]
                ]));
            }
            touchmove(e1, t, i) {
                if (!this._firstTwoTouches) return;
                e1.preventDefault();
                const [o, a] = this._firstTwoTouches, r = Er(i, t, o), s = Er(i, t, a);
                if (!r || !s) return;
                const n = this._aroundCenter ? null : r.add(s).div(2);
                return this._move([
                    r,
                    s
                ], n, e1);
            }
            touchend(e1, t, i) {
                if (!this._firstTwoTouches) return;
                const [o, a] = this._firstTwoTouches, r = Er(i, t, o), s = Er(i, t, a);
                r && s || (this._active && d.suppressClick(), this.reset());
            }
            touchcancel() {
                this.reset();
            }
            enable(e1) {
                this._enabled = !0, this._aroundCenter = !!e1 && "center" === e1.around;
            }
            disable() {
                this._enabled = !1, this.reset();
            }
            isEnabled() {
                return !!this._enabled;
            }
            isActive() {
                return !!this._active;
            }
        }
        function Er(e1, t, i) {
            for(let o = 0; o < e1.length; o++)if (e1[o].identifier === i) return t[o];
        }
        function Sr(e1, t) {
            return Math.log(e1 / t) / Math.LN2;
        }
        class zr extends Ir {
            constructor(){
                super(), this._zoomRate = 1, this._zoomThreshold = .1;
            }
            setZoomRate(e1) {
                this._zoomRate = null != e1 ? e1 : 1;
            }
            setZoomThreshold(e1) {
                this._zoomThreshold = null != e1 ? e1 : .1;
            }
            reset() {
                super.reset(), delete this._distance, delete this._startDistance;
            }
            _start(e1) {
                this._startDistance = this._distance = e1[0].dist(e1[1]);
            }
            _move(e1, t) {
                const i = this._distance;
                if (this._distance = e1[0].dist(e1[1]), this._active || !(Math.abs(Sr(this._distance, this._startDistance)) < this._zoomThreshold)) return this._active = !0, {
                    zoomDelta: Sr(this._distance, i) * this._zoomRate,
                    pinchAround: t
                };
            }
        }
        function Rr(e1, t) {
            return 180 * e1.angleWith(t) / Math.PI;
        }
        class Dr extends Ir {
            reset() {
                super.reset(), delete this._minDiameter, delete this._startVector, delete this._vector;
            }
            _start(e1) {
                this._startVector = this._vector = e1[0].sub(e1[1]), this._minDiameter = e1[0].dist(e1[1]);
            }
            _move(e1, t, i) {
                const o = this._vector;
                if (this._vector = e1[0].sub(e1[1]), this._active || !this._isBelowThreshold(this._vector)) return this._active = !0, {
                    bearingDelta: Rr(this._vector, o),
                    pinchAround: t
                };
            }
            _isBelowThreshold(e1) {
                this._minDiameter = Math.min(this._minDiameter, e1.mag());
                const t = 25 / (Math.PI * this._minDiameter) * 360, i = Rr(e1, this._startVector);
                return Math.abs(i) < t;
            }
        }
        function Ar(e1) {
            return Math.abs(e1.y) > Math.abs(e1.x);
        }
        class Lr extends Ir {
            constructor(e1){
                super(), this._currentTouchCount = 0, this._map = e1;
            }
            reset() {
                super.reset(), this._valid = void 0, delete this._firstMove, delete this._lastPoints;
            }
            touchstart(e1, t, i) {
                super.touchstart(e1, t, i), this._currentTouchCount = i.length;
            }
            _start(e1) {
                this._lastPoints = e1, Ar(e1[0].sub(e1[1])) && (this._valid = !1);
            }
            _move(e1, t, i) {
                if (this._map.cooperativeGestures.isEnabled() && this._currentTouchCount < 3) return;
                const o = e1[0].sub(this._lastPoints[0]), a = e1[1].sub(this._lastPoints[1]);
                return this._valid = this.gestureBeginsVertically(o, a, i.timeStamp), this._valid ? (this._lastPoints = e1, this._active = !0, {
                    pitchDelta: (o.y + a.y) / 2 * -0.5
                }) : void 0;
            }
            gestureBeginsVertically(e1, t, i) {
                if (void 0 !== this._valid) return this._valid;
                const o = e1.mag() >= 2, a = t.mag() >= 2;
                if (!o && !a) return;
                if (!o || !a) return void 0 === this._firstMove && (this._firstMove = i), i - this._firstMove < 100 && void 0;
                const r = e1.y > 0 == t.y > 0;
                return Ar(e1) && Ar(t) && r;
            }
        }
        const Fr = {
            panStep: 100,
            bearingStep: 15,
            pitchStep: 10
        };
        class kr {
            constructor(e1){
                this._tr = new dr(e1);
                const t = Fr;
                this._panStep = t.panStep, this._bearingStep = t.bearingStep, this._pitchStep = t.pitchStep, this._rotationDisabled = !1;
            }
            reset() {
                this._active = !1;
            }
            keydown(e1) {
                if (e1.altKey || e1.ctrlKey || e1.metaKey) return;
                let i = 0, o = 0, a = 0, r = 0, s = 0;
                switch(e1.keyCode){
                    case 61:
                    case 107:
                    case 171:
                    case 187:
                        i = 1;
                        break;
                    case 189:
                    case 109:
                    case 173:
                        i = -1;
                        break;
                    case 37:
                        e1.shiftKey ? o = -1 : (e1.preventDefault(), r = -1);
                        break;
                    case 39:
                        e1.shiftKey ? o = 1 : (e1.preventDefault(), r = 1);
                        break;
                    case 38:
                        e1.shiftKey ? a = 1 : (e1.preventDefault(), s = -1);
                        break;
                    case 40:
                        e1.shiftKey ? a = -1 : (e1.preventDefault(), s = 1);
                        break;
                    default:
                        return;
                }
                return this._rotationDisabled && (o = 0, a = 0), {
                    cameraAnimation: (n)=>{
                        const l = this._tr;
                        n.easeTo({
                            duration: 300,
                            easeId: "keyboardHandler",
                            easing: Br,
                            zoom: i ? t.cw(l.zoom + i * (e1.shiftKey ? 2 : 1), n.getZoomSnap()) : l.zoom,
                            bearing: l.bearing + o * this._bearingStep,
                            pitch: l.pitch + a * this._pitchStep,
                            offset: [
                                -r * this._panStep,
                                -s * this._panStep
                            ],
                            center: l.center
                        }, {
                            originalEvent: e1
                        });
                    }
                };
            }
            enable() {
                this._enabled = !0;
            }
            disable() {
                this._enabled = !1, this.reset();
            }
            isEnabled() {
                return this._enabled;
            }
            isActive() {
                return this._active;
            }
            disableRotation() {
                this._rotationDisabled = !0;
            }
            enableRotation() {
                this._rotationDisabled = !1;
            }
        }
        function Br(e1) {
            return e1 * (2 - e1);
        }
        const Or = 4.000244140625, jr = 1 / 450;
        class Nr {
            constructor(e1, t){
                this._onTimeout = (e1)=>{
                    this._type = "wheel", this._delta -= this._lastValue, this._active || this._start(e1);
                }, this._map = e1, this._tr = new dr(e1), this._triggerRenderFrame = t, this._delta = 0, this._defaultZoomRate = .01, this._wheelZoomRate = jr;
            }
            setZoomRate(e1) {
                this._defaultZoomRate = e1;
            }
            setWheelZoomRate(e1) {
                this._wheelZoomRate = e1;
            }
            isEnabled() {
                return !!this._enabled;
            }
            isActive() {
                return !!this._active || void 0 !== this._finishTimeout;
            }
            isZooming() {
                return !!this._zooming;
            }
            enable(e1) {
                this.isEnabled() || (this._enabled = !0, this._aroundCenter = !!e1 && "center" === e1.around);
            }
            disable() {
                this.isEnabled() && (this._enabled = !1);
            }
            _shouldBePrevented(e1) {
                return !!this._map.cooperativeGestures.isEnabled() && !(e1.ctrlKey || this._map.cooperativeGestures.isBypassed(e1));
            }
            wheel(e1) {
                if (!this.isEnabled()) return;
                if (this._shouldBePrevented(e1)) return void this._map.cooperativeGestures.notifyGestureBlocked("wheel_zoom", e1);
                let t = e1.deltaMode === WheelEvent.DOM_DELTA_LINE ? 40 * e1.deltaY : e1.deltaY;
                const i = c(), o = i - (this._lastWheelEventTime || 0);
                this._lastWheelEventTime = i, 0 !== t && t % Or == 0 ? this._type = "wheel" : 0 !== t && Math.abs(t) < 4 ? this._type = "trackpad" : o > 400 ? (this._type = null, this._lastValue = t, this._timeout = setTimeout(this._onTimeout, 40, e1)) : this._type || (this._type = Math.abs(o * t) < 200 ? "trackpad" : "wheel", this._timeout && (clearTimeout(this._timeout), this._timeout = null, t += this._lastValue)), e1.shiftKey && t && (t /= 4), this._type && (this._lastWheelEvent = e1, this._delta -= t, this._active || this._start(e1)), e1.preventDefault();
            }
            _start(e1) {
                if (!this._delta) return;
                this._needsRerender = !1, this._active = !0, this.isZooming() || (this._zooming = !0), this._finishTimeout && (clearTimeout(this._finishTimeout), delete this._finishTimeout);
                const i = d.mousePos(this._map.getCanvas(), e1), o = this._tr;
                this._aroundPoint = this._aroundCenter ? o.transform.locationToScreenPoint(t.W.convert(o.center)) : i, this._needsRerender || (this._needsRerender = !0, this._triggerRenderFrame());
            }
            renderFrame() {
                if (!this._needsRerender) return;
                if (this._needsRerender = !1, !this.isActive()) return;
                const e1 = this._tr.transform;
                if ("number" == typeof this._lastExpectedZoom) {
                    const t = e1.zoom - this._lastExpectedZoom;
                    "number" == typeof this._startZoom && (this._startZoom += t), "number" == typeof this._targetZoom && (this._targetZoom += t);
                }
                if (0 !== this._delta) {
                    const i = "wheel" === this._type && Math.abs(this._delta) > Or ? this._wheelZoomRate : this._defaultZoomRate;
                    let o = 2 / (1 + Math.exp(-Math.abs(this._delta * i)));
                    this._delta < 0 && 0 !== o && (o = 1 / o);
                    const a = "number" != typeof this._targetZoom ? e1.scale : t.ao(this._targetZoom), r = e1.applyConstrain(e1.getCameraLngLat(), t.ar(a * o)).zoom, s = this._map.getZoomSnap();
                    if ("wheel" === this._type && s > 0) {
                        const i = t.cw(e1.zoom, s);
                        this._targetZoom = t.cw(r, s, r - i);
                    } else this._targetZoom = r;
                    "wheel" === this._type && (this._startZoom = e1.zoom, this._easing = this._smoothOutEasing(200)), this._delta = 0;
                }
                const i = "number" != typeof this._targetZoom ? e1.zoom : this._targetZoom, o = this._startZoom, a = this._easing;
                let r, s = !1;
                if ("wheel" === this._type && o && a) {
                    const e1 = c() - this._lastWheelEventTime, n = Math.min((e1 + 5) / 200, 1), l = a(n);
                    r = t.H.number(o, i, l), n < 1 ? this._needsRerender = !0 : s = !0;
                } else r = i, s = !0;
                return this._active = !0, s && (this._active = !1, this._finishTimeout = setTimeout(()=>{
                    this._zooming = !1, this._triggerRenderFrame(), delete this._targetZoom, delete this._lastExpectedZoom, delete this._finishTimeout;
                }, 200)), this._lastExpectedZoom = r, {
                    noInertia: !0,
                    needsRenderFrame: !s,
                    zoomDelta: r - e1.zoom,
                    around: this._aroundPoint,
                    originalEvent: this._lastWheelEvent
                };
            }
            _smoothOutEasing(e1) {
                let i = t.cy;
                if (this._prevEase) {
                    const e1 = this._prevEase, o = (c() - e1.start) / e1.duration, a = e1.easing(o + .01) - e1.easing(o), r = .27 / Math.sqrt(a * a + 1e-4) * .01, s = Math.sqrt(.0729 - r * r);
                    i = t.cv(r, s, .25, 1);
                }
                return this._prevEase = {
                    start: c(),
                    duration: e1,
                    easing: i
                }, i;
            }
            reset() {
                this._active = !1, this._zooming = !1, delete this._targetZoom, delete this._lastExpectedZoom, this._finishTimeout && (clearTimeout(this._finishTimeout), delete this._finishTimeout);
            }
        }
        class Zr {
            constructor(e1, t){
                this._clickZoom = e1, this._tapZoom = t;
            }
            enable() {
                this._clickZoom.enable(), this._tapZoom.enable();
            }
            disable() {
                this._clickZoom.disable(), this._tapZoom.disable();
            }
            isEnabled() {
                return this._clickZoom.isEnabled() && this._tapZoom.isEnabled();
            }
            isActive() {
                return this._clickZoom.isActive() || this._tapZoom.isActive();
            }
        }
        class Ur {
            constructor(e1){
                this._tr = new dr(e1), this.reset();
            }
            reset() {
                this._active = !1;
            }
            dblclick(e1, i) {
                return e1.preventDefault(), {
                    cameraAnimation: (o)=>{
                        o.easeTo({
                            duration: 300,
                            zoom: t.cw(this._tr.zoom + (e1.shiftKey ? -1 : 1), o.getZoomSnap()),
                            around: this._tr.unproject(i)
                        }, {
                            originalEvent: e1
                        });
                    }
                };
            }
            enable() {
                this._enabled = !0;
            }
            disable() {
                this._enabled = !1, this.reset();
            }
            isEnabled() {
                return this._enabled;
            }
            isActive() {
                return this._active;
            }
        }
        class Gr {
            constructor(){
                this._tap = new fr({
                    numTouches: 1,
                    numTaps: 1
                }), this._zoomRate = 1, this.reset();
            }
            setZoomRate(e1) {
                this._zoomRate = null != e1 ? e1 : 1;
            }
            reset() {
                this._active = !1, delete this._swipePoint, delete this._swipeTouch, delete this._tapTime, delete this._tapPoint, this._tap.reset();
            }
            touchstart(e1, t, i) {
                if (!this._swipePoint) {
                    if (this._tapTime) {
                        const o = t[0], a = e1.timeStamp - this._tapTime < 500, r = this._tapPoint.dist(o) < 30;
                        a && r ? i.length > 0 && (this._swipePoint = o, this._swipeTouch = i[0].identifier) : this.reset();
                    } else this._tap.touchstart(e1, t, i);
                }
            }
            touchmove(e1, t, i) {
                if (this._tapTime) {
                    if (this._swipePoint) {
                        if (i[0].identifier !== this._swipeTouch) return;
                        const o = t[0], a = o.y - this._swipePoint.y;
                        return this._swipePoint = o, e1.preventDefault(), this._active = !0, {
                            zoomDelta: a / 128 * this._zoomRate
                        };
                    }
                } else this._tap.touchmove(e1, t, i);
            }
            touchend(e1, t, i) {
                if (this._tapTime) this._swipePoint && 0 === i.length && this.reset();
                else {
                    const o = this._tap.touchend(e1, t, i);
                    o && (this._tapTime = e1.timeStamp, this._tapPoint = o);
                }
            }
            touchcancel() {
                this.reset();
            }
            enable() {
                this._enabled = !0;
            }
            disable() {
                this._enabled = !1, this.reset();
            }
            isEnabled() {
                return this._enabled;
            }
            isActive() {
                return this._active;
            }
        }
        class Vr {
            constructor(e1, t, i){
                this._el = e1, this._mousePan = t, this._touchPan = i;
            }
            enable(e1) {
                this._inertiaOptions = e1 || {}, this._mousePan.enable(), this._touchPan.enable(), this._el.classList.add("maplibregl-touch-drag-pan");
            }
            disable() {
                this._mousePan.disable(), this._touchPan.disable(), this._el.classList.remove("maplibregl-touch-drag-pan");
            }
            isEnabled() {
                return this._mousePan.isEnabled() && this._touchPan.isEnabled();
            }
            isActive() {
                return this._mousePan.isActive() || this._touchPan.isActive();
            }
        }
        class Wr {
            constructor(e1, t, i, o){
                this._pitchWithRotate = e1.pitchWithRotate, this._rollEnabled = e1.rollEnabled, this._mouseRotate = t, this._mousePitch = i, this._mouseRoll = o;
            }
            enable() {
                this._mouseRotate.enable(), this._pitchWithRotate && this._mousePitch.enable(), this._rollEnabled && this._mouseRoll.enable();
            }
            disable() {
                this._mouseRotate.disable(), this._mousePitch.disable(), this._mouseRoll.disable();
            }
            isEnabled() {
                return this._mouseRotate.isEnabled() && (!this._pitchWithRotate || this._mousePitch.isEnabled()) && (!this._rollEnabled || this._mouseRoll.isEnabled());
            }
            isActive() {
                return this._mouseRotate.isActive() || this._mousePitch.isActive() || this._mouseRoll.isActive();
            }
        }
        class qr {
            constructor(e1, t, i, o){
                this._el = e1, this._touchZoom = t, this._touchRotate = i, this._tapDragZoom = o, this._rotationDisabled = !1, this._enabled = !0;
            }
            enable(e1) {
                this._touchZoom.enable(e1), this._rotationDisabled || this._touchRotate.enable(e1), this._tapDragZoom.enable(), this._el.classList.add("maplibregl-touch-zoom-rotate");
            }
            disable() {
                this._touchZoom.disable(), this._touchRotate.disable(), this._tapDragZoom.disable(), this._el.classList.remove("maplibregl-touch-zoom-rotate");
            }
            isEnabled() {
                return this._touchZoom.isEnabled() && (this._rotationDisabled || this._touchRotate.isEnabled()) && this._tapDragZoom.isEnabled();
            }
            isActive() {
                return this._touchZoom.isActive() || this._touchRotate.isActive() || this._tapDragZoom.isActive();
            }
            setZoomRate(e1) {
                this._touchZoom.setZoomRate(e1), this._tapDragZoom.setZoomRate(e1);
            }
            setZoomThreshold(e1) {
                this._touchZoom.setZoomThreshold(e1);
            }
            disableRotation() {
                this._rotationDisabled = !0, this._touchRotate.disable();
            }
            enableRotation() {
                this._rotationDisabled = !1, this._touchZoom.isEnabled() && this._touchRotate.enable();
            }
        }
        class $r {
            constructor(e1, t){
                this._bypassKey = navigator.userAgent.includes("Mac") ? "metaKey" : "ctrlKey", this._map = e1, this._options = t, this._enabled = !1;
            }
            isActive() {
                return !1;
            }
            reset() {}
            _setupUI() {
                if (this._container) return;
                const e1 = this._map.getCanvasContainer();
                e1.classList.add("maplibregl-cooperative-gestures"), this._container = d.create("div", "maplibregl-cooperative-gesture-screen", e1);
                let t = this._map._getUIString("CooperativeGesturesHandler.WindowsHelpText");
                "metaKey" === this._bypassKey && (t = this._map._getUIString("CooperativeGesturesHandler.MacHelpText"));
                const i = this._map._getUIString("CooperativeGesturesHandler.MobileHelpText"), o = document.createElement("div");
                o.className = "maplibregl-desktop-message", o.textContent = t, this._container.appendChild(o);
                const a = document.createElement("div");
                a.className = "maplibregl-mobile-message", a.textContent = i, this._container.appendChild(a), this._container.setAttribute("aria-hidden", "true");
            }
            _destroyUI() {
                this._container && (this._container.remove(), this._map.getCanvasContainer().classList.remove("maplibregl-cooperative-gestures")), delete this._container;
            }
            enable() {
                this._setupUI(), this._enabled = !0;
            }
            disable() {
                this._enabled = !1, this._destroyUI();
            }
            isEnabled() {
                return this._enabled;
            }
            isBypassed(e1) {
                return e1[this._bypassKey];
            }
            notifyGestureBlocked(e1, i) {
                this._enabled && (this._map.fire(new t.n("cooperativegestureprevented", {
                    gestureType: e1,
                    originalEvent: i
                })), this._container.classList.add("maplibregl-show"), setTimeout(()=>{
                    this._container.classList.remove("maplibregl-show");
                }, 100));
            }
        }
        const Hr = (e1)=>e1.zoom || e1.drag || e1.roll || e1.pitch || e1.rotate;
        class Xr extends t.n {
        }
        function Kr(e1) {
            var t;
            return (null === (t = e1.panDelta) || void 0 === t ? void 0 : t.mag()) || e1.zoomDelta || e1.bearingDelta || e1.pitchDelta || e1.rollDelta;
        }
        class Yr {
            get _ownerDocument() {
                var e1;
                return (null === (e1 = this._el) || void 0 === e1 ? void 0 : e1.ownerDocument) || document;
            }
            get _ownerWindow() {
                var e1, t;
                return (null === (t = null === (e1 = this._el) || void 0 === e1 ? void 0 : e1.ownerDocument) || void 0 === t ? void 0 : t.defaultView) || window;
            }
            constructor(e1, i){
                this.handleWindowEvent = (e1)=>{
                    this.handleEvent(e1, `${e1.type}Window`);
                }, this.handleEvent = (e1, i)=>{
                    if ("blur" === e1.type) return void this.stop(!0);
                    this._updatingCamera = !0;
                    const o = "renderFrame" === e1.type ? void 0 : e1, a = {
                        needsRenderFrame: !1
                    }, r = {}, s = {};
                    for (const { handlerName: n, handler: l, allowed: c } of this._handlers){
                        if (!l.isEnabled()) continue;
                        let h;
                        if (this._blockedByActive(s, c, n)) l.reset();
                        else if (l[i || e1.type]) {
                            if (t.cz(e1, i || e1.type)) {
                                const t = d.mousePos(this._map.getCanvas(), e1);
                                h = l[i || e1.type](e1, t);
                            } else if (t.cA(e1, i || e1.type)) {
                                const t = this._getMapTouches(e1.touches), o = d.touchPos(this._map.getCanvas(), t);
                                h = l[i || e1.type](e1, o, t);
                            } else t.cB(i || e1.type) || (h = l[i || e1.type](e1));
                            this.mergeHandlerResult(a, r, h, n, o), (null == h ? void 0 : h.needsRenderFrame) && this._triggerRenderFrame();
                        }
                        (h || l.isActive()) && (s[n] = l);
                    }
                    const n = {};
                    for(const e1 in this._previousActiveHandlers)s[e1] || (n[e1] = o);
                    this._previousActiveHandlers = s, (Object.keys(n).length || Kr(a)) && (this._changes.push([
                        a,
                        r,
                        n
                    ]), this._triggerRenderFrame()), (Object.keys(s).length || Kr(a)) && this._map._stop(!0), this._updatingCamera = !1;
                    const { cameraAnimation: l } = a;
                    l && (this._inertia.clear(), this._fireEvents({}, {}, !0), this._changes = [], l(this._map));
                }, this._map = e1, this._el = this._map.getCanvasContainer(), this._handlers = [], this._handlersById = {}, this._changes = [], this._inertia = new ar(e1), this._bearingSnap = i.bearingSnap, this._previousActiveHandlers = {}, this._eventsInProgress = {}, this._addDefaultHandlers(i);
                const o = this._el;
                this._listeners = [
                    [
                        o,
                        "touchstart",
                        {
                            passive: !0
                        }
                    ],
                    [
                        o,
                        "touchmove",
                        {
                            passive: !1
                        }
                    ],
                    [
                        o,
                        "touchend",
                        void 0
                    ],
                    [
                        o,
                        "touchcancel",
                        void 0
                    ],
                    [
                        o,
                        "mousedown",
                        void 0
                    ],
                    [
                        o,
                        "mousemove",
                        void 0
                    ],
                    [
                        o,
                        "mouseup",
                        void 0
                    ],
                    [
                        this._ownerDocument,
                        "mousemove",
                        {
                            capture: !0
                        }
                    ],
                    [
                        this._ownerDocument,
                        "mouseup",
                        void 0
                    ],
                    [
                        o,
                        "mouseover",
                        void 0
                    ],
                    [
                        o,
                        "mouseout",
                        void 0
                    ],
                    [
                        o,
                        "dblclick",
                        void 0
                    ],
                    [
                        o,
                        "click",
                        void 0
                    ],
                    [
                        o,
                        "keydown",
                        {
                            capture: !1
                        }
                    ],
                    [
                        o,
                        "keyup",
                        void 0
                    ],
                    [
                        o,
                        "wheel",
                        {
                            passive: !1
                        }
                    ],
                    [
                        o,
                        "contextmenu",
                        void 0
                    ],
                    [
                        this._ownerWindow,
                        "blur",
                        void 0
                    ]
                ];
                for (const [e1, t, i] of this._listeners)e1.addEventListener(t, e1 === this._ownerDocument ? this.handleWindowEvent : this.handleEvent, i);
            }
            destroy() {
                for (const [e1, t, i] of this._listeners)e1.removeEventListener(t, e1 === this._ownerDocument ? this.handleWindowEvent : this.handleEvent, i);
            }
            _addDefaultHandlers(e1) {
                const i = this._map, o = i.getCanvasContainer();
                this._add("mapEvent", new hr(i, e1));
                const a = i.boxZoom = new _r(i, e1);
                this._add("boxZoom", a), e1.interactive && e1.boxZoom && a.enable();
                const r = i.cooperativeGestures = new $r(i, e1.cooperativeGestures);
                this._add("cooperativeGestures", r), e1.cooperativeGestures && r.enable();
                const s = new gr(i), n = new Ur(i);
                i.doubleClickZoom = new Zr(n, s), this._add("tapZoom", s), this._add("clickZoom", n), e1.interactive && e1.doubleClickZoom && i.doubleClickZoom.enable();
                const l = new Gr;
                this._add("tapDragZoom", l);
                const c = i.touchPitch = new Lr(i);
                this._add("touchPitch", c), e1.interactive && e1.touchPitch && i.touchPitch.enable(e1.touchPitch);
                const h = ()=>i.project(i.getCenter()), u = function({ enable: e1, clickTolerance: i, aroundCenter: o = !0, minPixelCenterThreshold: a = 100, rotateDegreesPerPixelMoved: r = .8 }, s) {
                    const n = new wr({
                        checkCorrectEvent: (e1)=>0 === e1.button && e1.ctrlKey || 2 === e1.button && !e1.ctrlKey
                    });
                    return new vr({
                        clickTolerance: i,
                        move: (e1, i)=>{
                            const n = s();
                            if (o && Math.abs(n.y - e1.y) > a) return {
                                bearingDelta: t.cx(new t.P(e1.x, i.y), i, n)
                            };
                            let l = (i.x - e1.x) * r;
                            return o && i.y < n.y && (l = -l), {
                                bearingDelta: l
                            };
                        },
                        moveStateManager: n,
                        enable: e1,
                        assignEvents: Cr
                    });
                }(e1, h), d = function({ enable: e1, clickTolerance: t, pitchDegreesPerPixelMoved: i = -0.5 }) {
                    const o = new wr({
                        checkCorrectEvent: (e1)=>0 === e1.button && e1.ctrlKey || 2 === e1.button
                    });
                    return new vr({
                        clickTolerance: t,
                        move: (e1, t)=>({
                                pitchDelta: (t.y - e1.y) * i
                            }),
                        moveStateManager: o,
                        enable: e1,
                        assignEvents: Cr
                    });
                }(e1), _ = function({ enable: e1, clickTolerance: t, rollDegreesPerPixelMoved: i = .3 }, o) {
                    const a = new wr({
                        checkCorrectEvent: (e1)=>2 === e1.button && e1.ctrlKey
                    });
                    return new vr({
                        clickTolerance: t,
                        move: (e1, t)=>{
                            const a = o();
                            let r = (t.x - e1.x) * i;
                            return t.y < a.y && (r = -r), {
                                rollDelta: r
                            };
                        },
                        moveStateManager: a,
                        enable: e1,
                        assignEvents: Cr
                    });
                }(e1, h);
                i.dragRotate = new Wr(e1, u, d, _), this._add("mouseRotate", u, [
                    "mousePitch"
                ]), this._add("mousePitch", d, [
                    "mouseRotate",
                    "mouseRoll"
                ]), this._add("mouseRoll", _, [
                    "mousePitch"
                ]), e1.interactive && e1.dragRotate && i.dragRotate.enable();
                const p = function({ enable: e1, clickTolerance: t }) {
                    const i = new wr({
                        checkCorrectEvent: (e1)=>0 === e1.button && !e1.ctrlKey
                    });
                    return new vr({
                        clickTolerance: t,
                        move: (e1, t)=>({
                                around: t,
                                panDelta: t.sub(e1)
                            }),
                        activateOnStart: !0,
                        moveStateManager: i,
                        enable: e1,
                        assignEvents: Cr
                    });
                }(e1), m = new Mr(e1, i);
                i.dragPan = new Vr(o, p, m), this._add("mousePan", p), this._add("touchPan", m, [
                    "touchZoom",
                    "touchRotate"
                ]), e1.interactive && e1.dragPan && i.dragPan.enable(e1.dragPan);
                const f = new Dr, g = new zr;
                i.touchZoomRotate = new qr(o, g, f, l), this._add("touchRotate", f, [
                    "touchPan",
                    "touchZoom"
                ]), this._add("touchZoom", g, [
                    "touchPan",
                    "touchRotate"
                ]), e1.interactive && e1.touchZoomRotate && i.touchZoomRotate.enable(e1.touchZoomRotate), this._add("blockableMapEvent", new ur(i));
                const v = i.scrollZoom = new Nr(i, ()=>this._triggerRenderFrame());
                this._add("scrollZoom", v, [
                    "mousePan"
                ]), e1.interactive && e1.scrollZoom && i.scrollZoom.enable(e1.scrollZoom);
                const x = i.keyboard = new kr(i);
                this._add("keyboard", x), e1.interactive && e1.keyboard && i.keyboard.enable();
            }
            _add(e1, t, i) {
                this._handlers.push({
                    handlerName: e1,
                    handler: t,
                    allowed: i
                }), this._handlersById[e1] = t;
            }
            stop(e1) {
                if (!this._updatingCamera) {
                    for (const { handler: e1 } of this._handlers)e1.reset();
                    this._inertia.clear(), this._fireEvents({}, {}, e1), this._changes = [];
                }
            }
            isActive() {
                for (const { handler: e1 } of this._handlers)if (e1.isActive()) return !0;
                return !1;
            }
            isZooming() {
                return !!this._eventsInProgress.zoom || this._map.scrollZoom.isZooming();
            }
            isRotating() {
                return !!this._eventsInProgress.rotate;
            }
            isMoving() {
                return Boolean(Hr(this._eventsInProgress)) || this.isZooming();
            }
            _blockedByActive(e1, t, i) {
                for(const o in e1)if (o !== i && !(null == t ? void 0 : t.includes(o))) return !0;
                return !1;
            }
            _getMapTouches(e1) {
                const t = [];
                for (const i of e1)this._el.contains(i.target) && t.push(i);
                return t;
            }
            mergeHandlerResult(e1, i, o, a, r) {
                if (!o) return;
                t.e(e1, o);
                const s = {
                    handlerName: a,
                    originalEvent: o.originalEvent || r
                };
                void 0 !== o.zoomDelta && (i.zoom = s), void 0 !== o.panDelta && (i.drag = s), void 0 !== o.rollDelta && (i.roll = s), void 0 !== o.pitchDelta && (i.pitch = s), void 0 !== o.bearingDelta && (i.rotate = s);
            }
            _applyChanges() {
                const e1 = {}, i = {}, o = {};
                for (const [a, r, s] of this._changes)a.panDelta && (e1.panDelta = (e1.panDelta || new t.P(0, 0))._add(a.panDelta)), a.zoomDelta && (e1.zoomDelta = (e1.zoomDelta || 0) + a.zoomDelta), a.bearingDelta && (e1.bearingDelta = (e1.bearingDelta || 0) + a.bearingDelta), a.pitchDelta && (e1.pitchDelta = (e1.pitchDelta || 0) + a.pitchDelta), a.rollDelta && (e1.rollDelta = (e1.rollDelta || 0) + a.rollDelta), void 0 !== a.around && (e1.around = a.around), void 0 !== a.pinchAround && (e1.pinchAround = a.pinchAround), a.noInertia && (e1.noInertia = a.noInertia), t.e(i, r), t.e(o, s);
                this._updateMapTransform(e1, i, o), this._changes = [];
            }
            _updateMapTransform(e1, t, i) {
                const o = this._map, a = o._getTransformForUpdate(), r = o.terrain;
                if (!(Kr(e1) || r && this._terrainMovement)) return void this._fireEvents(t, i, !0);
                o._stop(!0);
                let { panDelta: s, zoomDelta: n, bearingDelta: l, pitchDelta: c, rollDelta: h, around: u, pinchAround: d } = e1;
                void 0 !== d && (u = d), u || (u = o.transform.centerPoint), r && !a.isPointOnMapSurface(u) && (u = a.centerPoint);
                const _ = {
                    panDelta: s,
                    zoomDelta: n,
                    rollDelta: h,
                    pitchDelta: c,
                    bearingDelta: l,
                    around: u
                };
                this._map.cameraHelper.useGlobeControls && !a.isPointOnMapSurface(u) && (u = a.centerPoint);
                const p = u.distSqr(a.centerPoint) < .01 ? a.center : a.screenPointToLocation(s ? u.sub(s) : u);
                this._handleMapControls({
                    terrain: r,
                    tr: a,
                    deltasForHelper: _,
                    preZoomAroundLoc: p,
                    combinedEventsInProgress: t,
                    panDelta: s
                }), o._applyUpdatedTransform(a), this._map._update(), e1.noInertia || this._inertia.record(e1), this._fireEvents(t, i, !0);
            }
            _handleMapControls({ terrain: e1, tr: t, deltasForHelper: i, preZoomAroundLoc: o, combinedEventsInProgress: a, panDelta: r }) {
                const s = this._map.cameraHelper;
                if (s.handleMapControlsRollPitchBearingZoom(i, t), e1) return s.useGlobeControls ? (this._terrainMovement || !a.drag && !a.zoom || (this._terrainMovement = !0, this._map._elevationFreeze = !0), void s.handleMapControlsPan(i, t, o)) : this._terrainMovement || !a.drag && !a.zoom ? void (a.drag && this._terrainMovement && r ? t.setCenter(t.screenPointToLocation(t.centerPoint.sub(r))) : s.handleMapControlsPan(i, t, o)) : (this._terrainMovement = !0, this._map._elevationFreeze = !0, void s.handleMapControlsPan(i, t, o));
                s.handleMapControlsPan(i, t, o);
            }
            _fireEvents(e1, i, o) {
                const a = Hr(this._eventsInProgress), r = Hr(e1), s = {};
                for(const t in e1){
                    const { originalEvent: i } = e1[t];
                    this._eventsInProgress[t] || (s[`${t}start`] = i), this._eventsInProgress[t] = e1[t];
                }
                !a && r && this._fireEvent("movestart", r.originalEvent);
                for(const e1 in s)this._fireEvent(e1, s[e1]);
                r && this._fireEvent("move", r.originalEvent);
                for(const t in e1){
                    const { originalEvent: i } = e1[t];
                    this._fireEvent(t, i);
                }
                const l = {};
                let c;
                for(const e1 in this._eventsInProgress){
                    const { handlerName: t, originalEvent: o } = this._eventsInProgress[e1];
                    this._handlersById[t].isActive() || (delete this._eventsInProgress[e1], c = i[t] || o, l[`${e1}end`] = c);
                }
                for(const e1 in l)this._fireEvent(e1, l[e1]);
                const h = Hr(this._eventsInProgress), u = (a || r) && !h;
                if (u && this._terrainMovement) {
                    this._map._elevationFreeze = !1, this._terrainMovement = !1;
                    const e1 = this._map._getTransformForUpdate();
                    this._map.getCenterClampedToGround() && e1.recalculateZoomAndCenter(this._map.terrain), this._map._applyUpdatedTransform(e1);
                }
                if (o && u) {
                    this._updatingCamera = !0;
                    const e1 = this._inertia._onMoveEnd(this._map.dragPan._inertiaOptions), i = (e1)=>0 !== e1 && -this._bearingSnap < e1 && e1 < this._bearingSnap;
                    !e1 || !e1.essential && n.prefersReducedMotion ? (this._map.fire(new t.n("moveend", {
                        originalEvent: c
                    })), i(this._map.getBearing()) && this._map.resetNorth()) : (i(e1.bearing || this._map.getBearing()) && (e1.bearing = 0), e1.freezeElevation = !0, this._map.easeTo(e1, {
                        originalEvent: c
                    })), this._updatingCamera = !1;
                }
            }
            _fireEvent(e1, i) {
                this._map.fire(new t.n(e1, i ? {
                    originalEvent: i
                } : {}));
            }
            _requestFrame() {
                return this._map.triggerRepaint(), this._map._renderTaskQueue.add((e1)=>{
                    delete this._frameId, this.handleEvent(new Xr("renderFrame", {
                        timeStamp: e1
                    })), this._applyChanges();
                });
            }
            _triggerRenderFrame() {
                void 0 === this._frameId && (this._frameId = this._requestFrame());
            }
        }
        class Qr extends t.E {
            constructor(e1, t, i){
                super(), this._renderFrameCallback = ()=>{
                    const e1 = Math.min((c() - this._easeStart) / this._easeOptions.duration, 1);
                    this._onEaseFrame(this._easeOptions.easing(e1)), e1 < 1 && this._easeFrameId ? this._easeFrameId = this._requestRenderFrame(this._renderFrameCallback) : this.stop();
                }, this._moving = !1, this._zooming = !1, this.transform = e1, this._bearingSnap = i.bearingSnap, this._zoomSnap = i.zoomSnap, this.cameraHelper = t, this.on("moveend", ()=>{
                    delete this._requestedCameraState;
                });
            }
            migrateProjection(e1, t) {
                e1.apply(this.transform, !0), this.transform = e1, this.cameraHelper = t;
            }
            getCenter() {
                return new t.W(this.transform.center.lng, this.transform.center.lat);
            }
            setCenter(e1, t) {
                return this.jumpTo({
                    center: e1
                }, t);
            }
            getCenterElevation() {
                return this.transform.elevation;
            }
            setCenterElevation(e1, t) {
                return this.jumpTo({
                    elevation: e1
                }, t), this;
            }
            getCenterClampedToGround() {
                return this._centerClampedToGround;
            }
            setCenterClampedToGround(e1) {
                this._centerClampedToGround = e1;
            }
            panBy(e1, i, o) {
                return e1 = t.P.convert(e1).mult(-1), this.panTo(this.transform.center, t.e({
                    offset: e1
                }, i), o);
            }
            panTo(e1, i, o) {
                return this.easeTo(t.e({
                    center: e1
                }, i), o);
            }
            getZoom() {
                return this.transform.zoom;
            }
            setZoom(e1, t) {
                return this.jumpTo({
                    zoom: e1
                }, t), this;
            }
            zoomTo(e1, i, o) {
                return this.easeTo(t.e({
                    zoom: e1
                }, i), o);
            }
            zoomIn(e1, i) {
                return this.zoomTo(t.cw(this.getZoom() + 1, this._zoomSnap), e1, i), this;
            }
            zoomOut(e1, i) {
                return this.zoomTo(t.cw(this.getZoom() - 1, this._zoomSnap), e1, i), this;
            }
            getVerticalFieldOfView() {
                return this.transform.fov;
            }
            setVerticalFieldOfView(e1, i) {
                return e1 != this.transform.fov && (this.transform.setFov(e1), this.fire(new t.n("movestart", i)).fire(new t.n("move", i)).fire(new t.n("moveend", i))), this;
            }
            getBearing() {
                return this.transform.bearing;
            }
            setZoomSnap(e1) {
                return this._zoomSnap = e1, this;
            }
            getZoomSnap() {
                return this._zoomSnap;
            }
            setBearing(e1, t) {
                return this.jumpTo({
                    bearing: e1
                }, t), this;
            }
            getPadding() {
                return this.transform.padding;
            }
            setPadding(e1, t) {
                return this.jumpTo({
                    padding: e1
                }, t), this;
            }
            rotateTo(e1, i, o) {
                return this.easeTo(t.e({
                    bearing: e1
                }, i), o);
            }
            resetNorth(e1, i) {
                return this.rotateTo(0, t.e({
                    duration: 1e3
                }, e1), i), this;
            }
            resetNorthPitch(e1, i) {
                return this.easeTo(t.e({
                    bearing: 0,
                    pitch: 0,
                    roll: 0,
                    duration: 1e3
                }, e1), i), this;
            }
            snapToNorth(e1, t) {
                return Math.abs(this.getBearing()) < this._bearingSnap ? this.resetNorth(e1, t) : this;
            }
            getPitch() {
                return this.transform.pitch;
            }
            setPitch(e1, t) {
                return this.jumpTo({
                    pitch: e1
                }, t), this;
            }
            getRoll() {
                return this.transform.roll;
            }
            setRoll(e1, t) {
                return this.jumpTo({
                    roll: e1
                }, t), this;
            }
            cameraForBounds(e1, t) {
                e1 = G.convert(e1).adjustAntiMeridian();
                const i = (null == t ? void 0 : t.bearing) || 0;
                return this._cameraForBoxAndBearing(e1.getNorthWest(), e1.getSouthEast(), i, t);
            }
            _cameraForBoxAndBearing(e1, i, o, a) {
                const r = {
                    top: 0,
                    bottom: 0,
                    right: 0,
                    left: 0
                };
                if ("number" == typeof (a = t.e({
                    padding: r,
                    offset: [
                        0,
                        0
                    ],
                    maxZoom: this.transform.maxZoom
                }, a)).padding) {
                    const e1 = a.padding;
                    a.padding = {
                        top: e1,
                        bottom: e1,
                        right: e1,
                        left: e1
                    };
                }
                const s = t.e(r, a.padding);
                a.padding = s;
                const n = this.transform, l = new G(e1, i), c = this.cameraHelper.cameraForBoxAndBearing(a, s, l, o, n);
                return c && this._zoomSnap && (c.zoom = t.cw(c.zoom, this._zoomSnap, -1)), c;
            }
            fitBounds(e1, t, i) {
                return this._fitInternal(this.cameraForBounds(e1, t), t, i);
            }
            fitScreenCoordinates(e1, i, o, a, r) {
                return this._fitInternal(this._cameraForBoxAndBearing(this.transform.screenPointToLocation(t.P.convert(e1)), this.transform.screenPointToLocation(t.P.convert(i)), o, a), a, r);
            }
            _fitInternal(e1, i, o) {
                return e1 ? (delete (i = t.e(e1, i)).padding, i.linear ? this.easeTo(i, o) : this.flyTo(i, o)) : this;
            }
            jumpTo(e1, i) {
                this.stop(), "zoom" in e1 && this._zoomSnap && (e1.zoom = t.cw(e1.zoom, this._zoomSnap));
                const o = this._getTransformForUpdate();
                let a = !1, r = !1, s = !1;
                const n = o.zoom;
                this.terrain && o.setElevation(this.terrain.getElevationForLngLatZoom(e1.center ? t.W.convert(e1.center) : o.center, e1.zoom || o.tileZoom)), this.cameraHelper.handleJumpToCenterZoom(o, e1);
                const l = o.zoom !== n;
                return "elevation" in e1 && o.elevation !== +e1.elevation && o.setElevation(+e1.elevation), "bearing" in e1 && o.bearing !== +e1.bearing && (a = !0, o.setBearing(+e1.bearing)), "pitch" in e1 && o.pitch !== +e1.pitch && (r = !0, o.setPitch(+e1.pitch)), "roll" in e1 && o.roll !== +e1.roll && (s = !0, o.setRoll(+e1.roll)), null == e1.padding || o.isPaddingEqual(e1.padding) || o.setPadding(e1.padding), this._applyUpdatedTransform(o), this.fire(new t.n("movestart", i)).fire(new t.n("move", i)), l && this.fire(new t.n("zoomstart", i)).fire(new t.n("zoom", i)).fire(new t.n("zoomend", i)), a && this.fire(new t.n("rotatestart", i)).fire(new t.n("rotate", i)).fire(new t.n("rotateend", i)), r && this.fire(new t.n("pitchstart", i)).fire(new t.n("pitch", i)).fire(new t.n("pitchend", i)), s && this.fire(new t.n("rollstart", i)).fire(new t.n("roll", i)).fire(new t.n("rollend", i)), this.fire(new t.n("moveend", i));
            }
            calculateCameraOptionsFromTo(e1, i, o, a = 0) {
                const r = t.a7.fromLngLat(e1, i), s = t.a7.fromLngLat(o, a), n = s.x - r.x, l = s.y - r.y, c = s.z - r.z, h = Math.hypot(n, l, c);
                if (0 === h) throw new Error("Can't calculate camera options with same From and To");
                const u = Math.hypot(n, l), d = t.ar(this.transform.cameraToCenterDistance / h / this.transform.tileSize), _ = 180 * Math.atan2(n, -l) / Math.PI;
                let p = 180 * Math.acos(u / h) / Math.PI;
                return p = c < 0 ? 90 - p : 90 + p, {
                    center: s.toLngLat(),
                    elevation: a,
                    zoom: d,
                    pitch: p,
                    bearing: _
                };
            }
            calculateCameraOptionsFromCameraLngLatAltRotation(e1, t, i, o, a) {
                const r = this.transform.calculateCenterFromCameraLngLatAlt(e1, t, i, o);
                return {
                    center: r.center,
                    elevation: r.elevation,
                    zoom: r.zoom,
                    bearing: i,
                    pitch: o,
                    roll: a
                };
            }
            easeTo(e1, i) {
                this._stop(!1, e1.easeId), "zoom" in (e1 = t.e({
                    offset: [
                        0,
                        0
                    ],
                    duration: 500,
                    easing: t.cy
                }, e1)) && this._zoomSnap && (e1.zoom = t.cw(e1.zoom, this._zoomSnap)), (!1 === e1.animate || !e1.essential && n.prefersReducedMotion) && (e1.duration = 0);
                const o = this._getTransformForUpdate(), a = this.getBearing(), r = o.pitch, s = o.roll, l = "bearing" in e1 ? this._normalizeBearing(e1.bearing, a) : a, c = "pitch" in e1 ? +e1.pitch : r, h = "roll" in e1 ? this._normalizeBearing(e1.roll, s) : s, u = "padding" in e1 ? e1.padding : o.padding, d = t.P.convert(e1.offset);
                let _, p;
                e1.around && (_ = t.W.convert(e1.around), p = o.locationToScreenPoint(_));
                const m = {
                    moving: this._moving,
                    zooming: this._zooming,
                    rotating: this._rotating,
                    pitching: this._pitching,
                    rolling: this._rolling
                }, f = this.cameraHelper.handleEaseTo(o, {
                    bearing: l,
                    pitch: c,
                    roll: h,
                    padding: u,
                    around: _,
                    aroundPoint: p,
                    offsetAsPoint: d,
                    offset: e1.offset,
                    zoom: e1.zoom,
                    center: e1.center
                });
                return this._rotating || (this._rotating = a !== l), this._pitching || (this._pitching = c !== r), this._rolling || (this._rolling = h !== s), this._padding = !o.isPaddingEqual(u), this._zooming || (this._zooming = f.isZooming), this._easeId = e1.easeId, this._prepareEase(i, e1.noMoveStart, m), this.terrain && this._prepareElevation(f.elevationCenter), this._ease((t)=>{
                    f.easeFunc(t), this.terrain && !e1.freezeElevation && this._updateElevation(t), this._applyUpdatedTransform(o), this._fireMoveEvents(i);
                }, (t)=>{
                    this.terrain && e1.freezeElevation && this._finalizeElevation(), this._afterEase(i, t);
                }, e1), this;
            }
            _prepareEase(e1, i, o = {}) {
                this._moving = !0, i || o.moving || this.fire(new t.n("movestart", e1)), this._zooming && !o.zooming && this.fire(new t.n("zoomstart", e1)), this._rotating && !o.rotating && this.fire(new t.n("rotatestart", e1)), this._pitching && !o.pitching && this.fire(new t.n("pitchstart", e1)), this._rolling && !o.rolling && this.fire(new t.n("rollstart", e1));
            }
            _prepareElevation(e1) {
                this._elevationCenter = e1, this._elevationStart = this.transform.elevation, this._elevationTarget = this.terrain.getElevationForLngLatZoom(e1, this.transform.tileZoom), this._elevationFreeze = !0;
            }
            _updateElevation(e1) {
                void 0 !== this._elevationStart && void 0 !== this._elevationCenter || this._prepareElevation(this.transform.center), this.transform.setMinElevationForCurrentTile(this.terrain.getMinTileElevationForLngLatZoom(this._elevationCenter, this.transform.tileZoom));
                const i = this.terrain.getElevationForLngLatZoom(this._elevationCenter, this.transform.tileZoom);
                if (e1 < 1 && i !== this._elevationTarget) {
                    const t = this._elevationTarget - this._elevationStart;
                    this._elevationStart += e1 * (t - (i - (t * e1 + this._elevationStart)) / (1 - e1)), this._elevationTarget = i;
                }
                this.transform.setElevation(t.H.number(this._elevationStart, this._elevationTarget, e1));
            }
            _finalizeElevation() {
                this._elevationFreeze = !1, this.getCenterClampedToGround() && this.transform.recalculateZoomAndCenter(this.terrain);
            }
            _getTransformForUpdate() {
                return this.transformCameraUpdate || this.terrain ? (this._requestedCameraState || (this._requestedCameraState = this.transform.clone()), this._requestedCameraState) : this.transform;
            }
            _elevateCameraIfInsideTerrain(e1) {
                if (!this.terrain && e1.elevation >= 0 && e1.pitch <= 90) return {};
                const t = e1.getCameraLngLat(), i = e1.getCameraAltitude(), o = this.terrain ? this.terrain.getElevationForLngLatZoom(t, e1.zoom) : 0;
                if (i < o) {
                    const i = this.calculateCameraOptionsFromTo(t, o, e1.center, e1.elevation);
                    return {
                        pitch: i.pitch,
                        zoom: i.zoom
                    };
                }
                return {};
            }
            _applyUpdatedTransform(e1) {
                const t = [];
                if (t.push((e1)=>this._elevateCameraIfInsideTerrain(e1)), this.transformCameraUpdate && t.push((e1)=>this.transformCameraUpdate(e1)), !t.length) return;
                const i = e1.clone();
                for (const e1 of t){
                    const t = i.clone(), { center: o, zoom: a, roll: r, pitch: s, bearing: n, elevation: l } = e1(t);
                    o && t.setCenter(o), void 0 !== l && t.setElevation(l), void 0 !== a && t.setZoom(a), void 0 !== r && t.setRoll(r), void 0 !== s && t.setPitch(s), void 0 !== n && t.setBearing(n), i.apply(t, !1);
                }
                this.transform.apply(i, !1);
            }
            _fireMoveEvents(e1) {
                this.fire(new t.n("move", e1)), this._zooming && this.fire(new t.n("zoom", e1)), this._rotating && this.fire(new t.n("rotate", e1)), this._pitching && this.fire(new t.n("pitch", e1)), this._rolling && this.fire(new t.n("roll", e1));
            }
            _afterEase(e1, i) {
                if (this._easeId && i && this._easeId === i) return;
                delete this._easeId;
                const o = this._zooming, a = this._rotating, r = this._pitching, s = this._rolling;
                this._moving = !1, this._zooming = !1, this._rotating = !1, this._pitching = !1, this._rolling = !1, this._padding = !1, o && this.fire(new t.n("zoomend", e1)), a && this.fire(new t.n("rotateend", e1)), r && this.fire(new t.n("pitchend", e1)), s && this.fire(new t.n("rollend", e1)), this.fire(new t.n("moveend", e1));
            }
            flyTo(e1, i) {
                if (!e1.essential && n.prefersReducedMotion) {
                    const o = t.V(e1, [
                        "center",
                        "zoom",
                        "bearing",
                        "pitch",
                        "roll",
                        "elevation",
                        "padding"
                    ]);
                    return this.jumpTo(o, i);
                }
                this.stop(), "zoom" in (e1 = t.e({
                    offset: [
                        0,
                        0
                    ],
                    speed: 1.2,
                    curve: 1.42,
                    easing: t.cy
                }, e1)) && this._zoomSnap && (e1.zoom = t.cw(e1.zoom, this._zoomSnap));
                const o = this._getTransformForUpdate(), a = o.bearing, r = o.pitch, s = o.roll, l = o.padding, c = "bearing" in e1 ? this._normalizeBearing(e1.bearing, a) : a, h = "pitch" in e1 ? +e1.pitch : r, u = "roll" in e1 ? this._normalizeBearing(e1.roll, s) : s, d = "padding" in e1 ? e1.padding : o.padding, _ = t.P.convert(e1.offset);
                let p = o.centerPoint.add(_);
                const m = o.screenPointToLocation(p), f = this.cameraHelper.handleFlyTo(o, {
                    bearing: c,
                    pitch: h,
                    roll: u,
                    padding: d,
                    locationAtOffset: m,
                    offsetAsPoint: _,
                    center: e1.center,
                    minZoom: e1.minZoom,
                    zoom: e1.zoom
                });
                let g = e1.curve;
                const v = Math.max(o.width, o.height), x = v / f.scaleOfZoom, b = f.pixelPathLength;
                "number" == typeof f.scaleOfMinZoom && (g = Math.sqrt(v / f.scaleOfMinZoom / b * 2));
                const y = g * g;
                function w(e1) {
                    const t = (x * x - v * v + (e1 ? -1 : 1) * y * y * b * b) / (2 * (e1 ? x : v) * y * b);
                    return Math.log(Math.sqrt(t * t + 1) - t);
                }
                function T(e1) {
                    return (Math.exp(e1) - Math.exp(-e1)) / 2;
                }
                function P(e1) {
                    return (Math.exp(e1) + Math.exp(-e1)) / 2;
                }
                const C = w(!1);
                let M = function(e1) {
                    return P(C) / P(C + g * e1);
                }, I = function(e1) {
                    var t;
                    return v * ((P(C) * (T(t = C + g * e1) / P(t)) - T(C)) / y) / b;
                }, E = (w(!0) - C) / g;
                if (Math.abs(b) < 2e-6 || !isFinite(E)) {
                    if (Math.abs(v - x) < 1e-6) return this.easeTo(e1, i);
                    const t = x < v ? -1 : 1;
                    E = Math.abs(Math.log(x / v)) / g, I = ()=>0, M = (e1)=>Math.exp(t * g * e1);
                }
                return e1.duration = "duration" in e1 ? +e1.duration : 1e3 * E / ("screenSpeed" in e1 ? +e1.screenSpeed / g : +e1.speed), e1.maxDuration && e1.duration > e1.maxDuration && (e1.duration = 0), this._zooming = !0, this._rotating = a !== c, this._pitching = h !== r, this._rolling = u !== s, this._padding = !o.isPaddingEqual(d), this._prepareEase(i, !1), this.terrain && this._prepareElevation(f.targetCenter), this._ease((n)=>{
                    const m = n * E, g = 1 / M(m), v = I(m);
                    this._rotating && o.setBearing(t.H.number(a, c, n)), this._pitching && o.setPitch(t.H.number(r, h, n)), this._rolling && o.setRoll(t.H.number(s, u, n)), this._padding && (o.interpolatePadding(l, d, n), p = o.centerPoint.add(_)), f.easeFunc(n, g, v, p), this.terrain && !e1.freezeElevation && this._updateElevation(n), this._applyUpdatedTransform(o), this._fireMoveEvents(i);
                }, ()=>{
                    this.terrain && e1.freezeElevation && this._finalizeElevation(), this._afterEase(i);
                }, e1), this;
            }
            isEasing() {
                return !!this._easeFrameId;
            }
            stop() {
                return this._stop();
            }
            _stop(e1, t) {
                var i;
                if (this._easeFrameId && (this._cancelRenderFrame(this._easeFrameId), delete this._easeFrameId, delete this._onEaseFrame), this._onEaseEnd) {
                    const e1 = this._onEaseEnd;
                    delete this._onEaseEnd, e1.call(this, t);
                }
                return e1 || null === (i = this.handlers) || void 0 === i || i.stop(!1), this;
            }
            _ease(e1, t, i) {
                !1 === i.animate || 0 === i.duration ? (e1(1), t()) : (this._easeStart = c(), this._easeOptions = i, this._onEaseFrame = e1, this._onEaseEnd = t, this._easeFrameId = this._requestRenderFrame(this._renderFrameCallback));
            }
            _normalizeBearing(e1, i) {
                e1 = t.X(e1, -180, 180);
                const o = Math.abs(e1 - i);
                return Math.abs(e1 - 360 - i) < o && (e1 -= 360), Math.abs(e1 + 360 - i) < o && (e1 += 360), e1;
            }
            queryTerrainElevation(e1) {
                return this.terrain ? this.terrain.getElevationForLngLat(t.W.convert(e1), this.transform) : null;
            }
        }
        const Jr = {
            compact: !0,
            customAttribution: '<a href="https://maplibre.org/" target="_blank">MapLibre</a>'
        };
        class es {
            constructor(e1 = Jr){
                this._toggleAttribution = ()=>{
                    this._container.classList.contains("maplibregl-compact") && (this._container.classList.contains("maplibregl-compact-show") ? (this._container.setAttribute("open", ""), this._container.classList.remove("maplibregl-compact-show")) : (this._container.classList.add("maplibregl-compact-show"), this._container.removeAttribute("open")));
                }, this._updateData = (e1)=>{
                    !e1 || "metadata" !== e1.sourceDataType && "visibility" !== e1.sourceDataType && "style" !== e1.dataType && "terrain" !== e1.type || this._updateAttributions();
                }, this._updateCompact = ()=>{
                    this._map.getCanvasContainer().offsetWidth <= 640 || this._compact ? !1 === this._compact ? this._container.setAttribute("open", "") : this._container.classList.contains("maplibregl-compact") || this._container.classList.contains("maplibregl-attrib-empty") || (this._container.setAttribute("open", ""), this._container.classList.add("maplibregl-compact", "maplibregl-compact-show")) : (this._container.setAttribute("open", ""), this._container.classList.contains("maplibregl-compact") && this._container.classList.remove("maplibregl-compact", "maplibregl-compact-show"));
                }, this._updateCompactMinimize = ()=>{
                    this._container.classList.contains("maplibregl-compact") && this._container.classList.contains("maplibregl-compact-show") && this._container.classList.remove("maplibregl-compact-show");
                }, this.options = e1;
            }
            getDefaultPosition() {
                return "bottom-right";
            }
            onAdd(e1) {
                return this._map = e1, this._compact = this.options.compact, this._container = d.create("details", "maplibregl-ctrl maplibregl-ctrl-attrib"), this._compactButton = d.create("summary", "maplibregl-ctrl-attrib-button", this._container), this._compactButton.addEventListener("click", this._toggleAttribution), this._setElementTitle(this._compactButton, "ToggleAttribution"), this._innerContainer = d.create("div", "maplibregl-ctrl-attrib-inner", this._container), this._updateAttributions(), this._updateCompact(), this._map.on("styledata", this._updateData), this._map.on("sourcedata", this._updateData), this._map.on("terrain", this._updateData), this._map.on("resize", this._updateCompact), this._map.on("drag", this._updateCompactMinimize), this._container;
            }
            onRemove() {
                this._container.remove(), this._map.off("styledata", this._updateData), this._map.off("sourcedata", this._updateData), this._map.off("terrain", this._updateData), this._map.off("resize", this._updateCompact), this._map.off("drag", this._updateCompactMinimize), this._map = void 0, this._compact = void 0, this._attribHTML = void 0;
            }
            _setElementTitle(e1, t) {
                const i = this._map._getUIString(`AttributionControl.${t}`);
                e1.title = i, e1.setAttribute("aria-label", i);
            }
            _updateAttributions() {
                if (!this._map.style) return;
                let e1 = [];
                if (this.options.customAttribution && (Array.isArray(this.options.customAttribution) ? e1 = e1.concat(this.options.customAttribution.map((e1)=>"string" != typeof e1 ? "" : e1)) : "string" == typeof this.options.customAttribution && e1.push(this.options.customAttribution)), this._map.style.stylesheet) {
                    const e1 = this._map.style.stylesheet;
                    this.styleOwner = e1.owner, this.styleId = e1.id;
                }
                const t = this._map.style.tileManagers;
                for(const i in t){
                    const o = t[i];
                    if (o.used || o.usedForTerrain) {
                        const t = o.getSource();
                        t.attribution && !e1.includes(t.attribution) && e1.push(t.attribution);
                    }
                }
                e1 = e1.filter((e1)=>String(e1).trim()), e1.sort((e1, t)=>e1.length - t.length), e1 = e1.filter((t, i)=>{
                    for(let o = i + 1; o < e1.length; o++)if (e1[o].includes(t)) return !1;
                    return !0;
                });
                const i = e1.join(" | ");
                i !== this._attribHTML && (this._attribHTML = i, e1.length ? (this._innerContainer.innerHTML = d.sanitize(i), this._container.classList.remove("maplibregl-attrib-empty")) : this._container.classList.add("maplibregl-attrib-empty"), this._updateCompact(), this._editLink = null);
            }
        }
        class ts {
            constructor(e1 = {}){
                this._updateCompact = ()=>{
                    const e1 = this._container.children;
                    if (e1.length) {
                        const t = e1[0];
                        this._map.getCanvasContainer().offsetWidth <= 640 || this._compact ? !1 !== this._compact && t.classList.add("maplibregl-compact") : t.classList.remove("maplibregl-compact");
                    }
                }, this.options = e1;
            }
            getDefaultPosition() {
                return "bottom-left";
            }
            onAdd(e1) {
                var t;
                this._map = e1, this._compact = null === (t = this.options) || void 0 === t ? void 0 : t.compact, this._container = d.create("div", "maplibregl-ctrl");
                const i = d.create("a", "maplibregl-ctrl-logo");
                return i.target = "_blank", i.rel = "noopener nofollow", i.href = "https://maplibre.org/", i.setAttribute("aria-label", this._map._getUIString("LogoControl.Title")), i.setAttribute("rel", "noopener nofollow"), this._container.appendChild(i), this._container.style.display = "block", this._map.on("resize", this._updateCompact), this._updateCompact(), this._container;
            }
            onRemove() {
                this._container.remove(), this._map.off("resize", this._updateCompact), this._map = void 0, this._compact = void 0;
            }
        }
        class is {
            constructor(){
                this._queue = [], this._id = 0, this._cleared = !1, this._currentlyRunning = !1;
            }
            add(e1) {
                const t = ++this._id;
                return this._queue.push({
                    callback: e1,
                    id: t,
                    cancelled: !1
                }), t;
            }
            remove(e1) {
                const t = this._currentlyRunning, i = t ? this._queue.concat(t) : this._queue;
                for (const t of i)if (t.id === e1) return void (t.cancelled = !0);
            }
            run(e1 = 0) {
                if (this._currentlyRunning) throw new Error("Attempting to run(), but is already running.");
                const t = this._currentlyRunning = this._queue;
                this._queue = [];
                for (const i of t)if (!i.cancelled && (i.callback(e1), this._cleared)) break;
                this._cleared = !1, this._currentlyRunning = !1;
            }
            clear() {
                this._currentlyRunning && (this._cleared = !0), this._queue = [];
            }
        }
        var os = t.aS([
            {
                name: "a_pos3d",
                type: "Int16",
                components: 3
            }
        ]);
        class as extends t.E {
            constructor(e1){
                super(), this._lastTilesetChange = c(), this.tileManager = e1, this._tiles = {}, this._renderableTilesKeys = [], this._sourceTileCache = {}, this.minzoom = 0, this.maxzoom = 22, this.deltaZoom = 1, this.tileSize = e1._source.tileSize * 2 ** this.deltaZoom, e1.usedForTerrain = !0, e1.tileSize = this.tileSize;
            }
            destruct() {
                this.tileManager.usedForTerrain = !1, this.tileManager.tileSize = null;
            }
            getSource() {
                return this.tileManager._source;
            }
            update(e1, i) {
                this.tileManager.update(e1, i), this._renderableTilesKeys = [];
                const o = {};
                for (const a of Me(e1, {
                    tileSize: this.tileSize,
                    minzoom: this.minzoom,
                    maxzoom: this.maxzoom,
                    reparseOverscaled: !1,
                    terrain: i,
                    calculateTileZoom: this.tileManager._source.calculateTileZoom
                }))o[a.key] = !0, this._renderableTilesKeys.push(a.key), this._tiles[a.key] || (a.terrainRttPosMatrix32f = new Float64Array(16), t.c7(a.terrainRttPosMatrix32f, 0, t.a6, t.a6, 0, 0, 1), this._tiles[a.key] = new de(a, this.tileSize), this._lastTilesetChange = c());
                for(const e1 in this._tiles)o[e1] || delete this._tiles[e1];
            }
            freeRtt(e1) {
                for(const t in this._tiles){
                    const i = this._tiles[t];
                    (!e1 || i.tileID.equals(e1) || i.tileID.isChildOf(e1) || e1.isChildOf(i.tileID)) && (i.rtt = []);
                }
            }
            getRenderableTiles() {
                return this._renderableTilesKeys.map((e1)=>this.getTileByID(e1));
            }
            getTileByID(e1) {
                return this._tiles[e1];
            }
            getTerrainCoords(e1, t) {
                return t ? this._getTerrainCoordsForTileRanges(e1, t) : this._getTerrainCoordsForRegularTile(e1);
            }
            _getTerrainCoordsForRegularTile(e1) {
                const i = {};
                for (const o of this._renderableTilesKeys){
                    const a = this._tiles[o].tileID, r = e1.clone(), s = t.bj();
                    if (a.canonical.equals(e1.canonical)) t.c7(s, 0, t.a6, t.a6, 0, 0, 1);
                    else if (a.canonical.isChildOf(e1.canonical)) {
                        const i = a.canonical.z - e1.canonical.z, o = a.canonical.x - (a.canonical.x >> i << i), r = a.canonical.y - (a.canonical.y >> i << i), n = t.a6 >> i;
                        t.c7(s, 0, n, n, 0, 0, 1), t.Q(s, s, [
                            -o * n,
                            -r * n,
                            0
                        ]);
                    } else {
                        if (!e1.canonical.isChildOf(a.canonical)) continue;
                        {
                            const i = e1.canonical.z - a.canonical.z, o = e1.canonical.x - (e1.canonical.x >> i << i), r = e1.canonical.y - (e1.canonical.y >> i << i), n = t.a6 >> i;
                            t.c7(s, 0, t.a6, t.a6, 0, 0, 1), t.Q(s, s, [
                                o * n,
                                r * n,
                                0
                            ]), t.S(s, s, [
                                1 / 2 ** i,
                                1 / 2 ** i,
                                0
                            ]);
                        }
                    }
                    r.terrainRttPosMatrix32f = new Float32Array(s), i[o] = r;
                }
                return i;
            }
            _getTerrainCoordsForTileRanges(e1, i) {
                const o = {};
                for (const a of this._renderableTilesKeys){
                    const r = this._tiles[a].tileID;
                    if (!this._isWithinTileRanges(r, i)) continue;
                    const s = e1.clone(), n = t.bj();
                    if (r.canonical.z === e1.canonical.z) {
                        const i = e1.canonical.x - r.canonical.x + e1.wrap * (1 << e1.canonical.z), o = e1.canonical.y - r.canonical.y;
                        t.c7(n, 0, t.a6, t.a6, 0, 0, 1), t.Q(n, n, [
                            i * t.a6,
                            o * t.a6,
                            0
                        ]);
                    } else if (r.canonical.z > e1.canonical.z) {
                        const i = r.canonical.z - e1.canonical.z, o = r.canonical.x - (r.canonical.x >> i << i) + e1.wrap * (1 << r.canonical.z), a = r.canonical.y - (r.canonical.y >> i << i), s = e1.canonical.x - (r.canonical.x >> i), l = e1.canonical.y - (r.canonical.y >> i), c = t.a6 >> i;
                        t.c7(n, 0, c, c, 0, 0, 1), t.Q(n, n, [
                            -o * c + s * t.a6,
                            -a * c + l * t.a6,
                            0
                        ]);
                    } else {
                        const i = e1.canonical.z - r.canonical.z, o = e1.canonical.x - (e1.canonical.x >> i << i) + e1.wrap * (1 << e1.canonical.z), a = e1.canonical.y - (e1.canonical.y >> i << i), s = (e1.canonical.x >> i) - r.canonical.x, l = (e1.canonical.y >> i) - r.canonical.y, c = t.a6 << i;
                        t.c7(n, 0, c, c, 0, 0, 1), t.Q(n, n, [
                            o * t.a6 + s * c,
                            a * t.a6 + l * c,
                            0
                        ]);
                    }
                    s.terrainRttPosMatrix32f = new Float32Array(n), o[a] = s;
                }
                return o;
            }
            getSourceTile(e1, t) {
                var i, o;
                const a = this.tileManager._source;
                let r = e1.overscaledZ - this.deltaZoom;
                if (r > a.maxzoom && (r = a.maxzoom), r < a.minzoom) return;
                (i = this._sourceTileCache)[o = e1.key] || (i[o] = e1.scaledTo(r).key);
                let s = this.findTileInCaches(this._sourceTileCache[e1.key]);
                if (!(null == s ? void 0 : s.dem) && t) for(; r >= a.minzoom && !(null == s ? void 0 : s.dem);)s = this.findTileInCaches(e1.scaledTo(r--).key);
                return s;
            }
            findTileInCaches(e1) {
                let t = this.tileManager.getTileByID(e1);
                return t || (t = this.tileManager._outOfViewCache.getByKey(e1), t);
            }
            anyTilesAfterTime(e1 = Date.now()) {
                return this._lastTilesetChange >= e1;
            }
            _isWithinTileRanges(e1, t) {
                const i = t[e1.canonical.z];
                return !!i && (e1.wrap > i.minWrap || e1.wrap < i.maxWrap || e1.canonical.x >= i.minTileXWrapped && e1.canonical.x <= i.maxTileXWrapped && e1.canonical.y >= i.minTileY && e1.canonical.y <= i.maxTileY);
            }
        }
        class rs {
            constructor(e1, t, i){
                this._meshCache = {}, this.painter = e1, this.tileManager = new as(t), this.options = i, this.exaggeration = "number" == typeof i.exaggeration ? i.exaggeration : 1, this.qualityFactor = 2, this.meshSize = 128, this._demMatrixCache = {}, this.coordsIndex = [], this._coordsTextureSize = 1024;
            }
            destroy() {
                this._fbo && (this._fbo.destroy(), this._fbo = null), this._fboCoordsTexture && (this._fboCoordsTexture.destroy(), this._fboCoordsTexture = null), this._fboDepthTexture && (this._fboDepthTexture.destroy(), this._fboDepthTexture = null), this._emptyDemTexture && (this._emptyDemTexture.destroy(), this._emptyDemTexture = null), this._emptyDepthTexture && (this._emptyDepthTexture.destroy(), this._emptyDepthTexture = null), this._coordsTexture && (this._coordsTexture.destroy(), this._coordsTexture = null);
                for(const e1 in this._meshCache)this._meshCache[e1].destroy();
                this._meshCache = {}, this.tileManager.destruct();
            }
            getDEMElevation(e1, i, o, a = t.a6) {
                var r;
                const s = e1.normalizeCoordinates(i, o, a);
                if (!s) return 0;
                const n = this.getTerrainData(s.tileID), l = null === (r = n.tile) || void 0 === r ? void 0 : r.dem;
                if (!l) return 0;
                const c = t.cC([], [
                    s.x / a * t.a6,
                    s.y / a * t.a6
                ], n.u_terrain_matrix), h = [
                    c[0] * l.dim,
                    c[1] * l.dim
                ], u = Math.floor(h[0]), d = Math.floor(h[1]), _ = h[0] - u, p = h[1] - d;
                return l.get(u, d) * (1 - _) * (1 - p) + l.get(u + 1, d) * _ * (1 - p) + l.get(u, d + 1) * (1 - _) * p + l.get(u + 1, d + 1) * _ * p;
            }
            getElevationForLngLatZoom(e1, i) {
                if (!t.cD(i, e1.wrap())) return 0;
                const { tileID: o, mercatorX: a, mercatorY: r } = this._getOverscaledTileIDFromLngLatZoom(e1, i);
                return this.getElevation(o, a % t.a6, r % t.a6, t.a6);
            }
            getElevationForLngLat(e1, t) {
                const i = Me(t, {
                    maxzoom: this.tileManager.maxzoom,
                    minzoom: this.tileManager.minzoom,
                    tileSize: 512,
                    terrain: this
                });
                let o = 0;
                for (const e1 of i)e1.canonical.z > o && (o = Math.min(e1.canonical.z, this.tileManager.maxzoom));
                return this.getElevationForLngLatZoom(e1, o);
            }
            getElevation(e1, i, o, a = t.a6) {
                return this.getDEMElevation(e1, i, o, a) * this.exaggeration;
            }
            getTerrainData(e1) {
                var i, o;
                if (!this._emptyDemTexture) {
                    const e1 = this.painter.context, i = new t.R({
                        width: 1,
                        height: 1
                    }, new Uint8Array(4));
                    this._emptyDepthTexture = new t.T(e1, i, e1.gl.RGBA, {
                        premultiply: !1
                    }), this._emptyDemUnpack = [
                        0,
                        0,
                        0,
                        0
                    ], this._emptyDemTexture = new t.T(e1, new t.R({
                        width: 1,
                        height: 1
                    }), e1.gl.RGBA, {
                        premultiply: !1
                    }), this._emptyDemTexture.bind(e1.gl.NEAREST, e1.gl.CLAMP_TO_EDGE), this._emptyDemMatrix = t.ap([]);
                }
                const a = this.tileManager.getSourceTile(e1, !0);
                if ((null == a ? void 0 : a.dem) && (!a.demTexture || a.needsTerrainPrepare)) {
                    const e1 = this.painter.context;
                    a.demTexture = this.painter.getTileTexture(a.dem.stride), a.demTexture ? a.demTexture.update(a.dem.getPixels(), {
                        premultiply: !1
                    }) : a.demTexture = new t.T(e1, a.dem.getPixels(), e1.gl.RGBA, {
                        premultiply: !1
                    }), a.demTexture.bind(e1.gl.NEAREST, e1.gl.CLAMP_TO_EDGE), a.needsTerrainPrepare = !1;
                }
                const r = a && a.toString() + a.tileID.key + e1.key;
                if (r && !this._demMatrixCache[r]) {
                    const i = this.tileManager.getSource().maxzoom;
                    let o = e1.canonical.z - a.tileID.canonical.z;
                    e1.overscaledZ > e1.canonical.z && (e1.canonical.z >= i ? o = e1.canonical.z - i : t.w("cannot calculate elevation if elevation maxzoom > source.maxzoom"));
                    const s = e1.canonical.x - (e1.canonical.x >> o << o), n = e1.canonical.y - (e1.canonical.y >> o << o), l = t.cE(new Float64Array(16), [
                        1 / (t.a6 << o),
                        1 / (t.a6 << o),
                        0
                    ]);
                    t.Q(l, l, [
                        s * t.a6,
                        n * t.a6,
                        0
                    ]), this._demMatrixCache[r] = {
                        matrix: l,
                        coord: e1
                    };
                }
                return {
                    u_depth: 2,
                    u_terrain: 3,
                    u_terrain_dim: (null === (i = null == a ? void 0 : a.dem) || void 0 === i ? void 0 : i.dim) || 1,
                    u_terrain_matrix: r ? this._demMatrixCache[r].matrix : this._emptyDemMatrix,
                    u_terrain_unpack: (null === (o = null == a ? void 0 : a.dem) || void 0 === o ? void 0 : o.getUnpackVector()) || this._emptyDemUnpack,
                    u_terrain_exaggeration: this.exaggeration,
                    texture: ((null == a ? void 0 : a.demTexture) || this._emptyDemTexture).texture,
                    depthTexture: (this._fboDepthTexture || this._emptyDepthTexture).texture,
                    tile: a
                };
            }
            getFramebuffer(e1) {
                const i = this.painter, o = i.width / devicePixelRatio, a = i.height / devicePixelRatio;
                return !this._fbo || this._fbo.width === o && this._fbo.height === a || (this._fbo.destroy(), this._fboCoordsTexture.destroy(), this._fboDepthTexture.destroy(), delete this._fbo, delete this._fboDepthTexture, delete this._fboCoordsTexture), this._fboCoordsTexture || (this._fboCoordsTexture = new t.T(i.context, {
                    width: o,
                    height: a,
                    data: null
                }, i.context.gl.RGBA, {
                    premultiply: !1
                }), this._fboCoordsTexture.bind(i.context.gl.NEAREST, i.context.gl.CLAMP_TO_EDGE)), this._fboDepthTexture || (this._fboDepthTexture = new t.T(i.context, {
                    width: o,
                    height: a,
                    data: null
                }, i.context.gl.RGBA, {
                    premultiply: !1
                }), this._fboDepthTexture.bind(i.context.gl.NEAREST, i.context.gl.CLAMP_TO_EDGE)), this._fbo || (this._fbo = i.context.createFramebuffer(o, a, !0, !1), this._fbo.depthAttachment.set(i.context.createRenderbuffer(i.context.gl.DEPTH_COMPONENT16, o, a))), this._fbo.colorAttachment.set("coords" === e1 ? this._fboCoordsTexture.texture : this._fboDepthTexture.texture), this._fbo;
            }
            getCoordsTexture() {
                const e1 = this.painter.context;
                if (this._coordsTexture) return this._coordsTexture;
                const i = new Uint8Array(this._coordsTextureSize * this._coordsTextureSize * 4);
                for(let e1 = 0, t = 0; e1 < this._coordsTextureSize; e1++)for(let o = 0; o < this._coordsTextureSize; o++, t += 4)i[t + 0] = 255 & o, i[t + 1] = 255 & e1, i[t + 2] = o >> 8 << 4 | e1 >> 8, i[t + 3] = 0;
                const o = new t.R({
                    width: this._coordsTextureSize,
                    height: this._coordsTextureSize
                }, new Uint8Array(i.buffer)), a = new t.T(e1, o, e1.gl.RGBA, {
                    premultiply: !1
                });
                return a.bind(e1.gl.NEAREST, e1.gl.CLAMP_TO_EDGE), this._coordsTexture = a, a;
            }
            pointCoordinate(e1) {
                this.painter.maybeDrawDepth(!0), this.painter.maybeDrawCoords();
                const i = new Uint8Array(4), o = this.painter.context, a = o.gl, r = Math.round(e1.x * this.painter.pixelRatio / devicePixelRatio), s = Math.round(e1.y * this.painter.pixelRatio / devicePixelRatio), n = Math.round(this.painter.height / devicePixelRatio);
                o.bindFramebuffer.set(this.getFramebuffer("coords").framebuffer), a.readPixels(r, n - s - 1, 1, 1, a.RGBA, a.UNSIGNED_BYTE, i), o.bindFramebuffer.set(null);
                const l = i[0] + (i[2] >> 4 << 8), c = i[1] + ((15 & i[2]) << 8), h = this.coordsIndex[255 - i[3]], u = h && this.tileManager.getTileByID(h);
                if (!u) return null;
                const d = this._coordsTextureSize, _ = (1 << u.tileID.canonical.z) * d;
                return new t.a7((u.tileID.canonical.x * d + l) / _ + u.tileID.wrap, (u.tileID.canonical.y * d + c) / _, this.getElevation(u.tileID, l, c, d));
            }
            depthAtPoint(e1) {
                const t = new Uint8Array(4), i = this.painter.context, o = i.gl;
                return i.bindFramebuffer.set(this.getFramebuffer("depth").framebuffer), o.readPixels(e1.x, this.painter.height / devicePixelRatio - e1.y - 1, 1, 1, o.RGBA, o.UNSIGNED_BYTE, t), i.bindFramebuffer.set(null), (t[0] / 16777216 + t[1] / 65536 + t[2] / 256 + t[3]) / 256;
            }
            getTerrainMesh(e1) {
                var i;
                const o = (null === (i = this.painter.style.projection) || void 0 === i ? void 0 : i.transitionState) > 0, a = o && 0 === e1.canonical.y, r = o && e1.canonical.y === (1 << e1.canonical.z) - 1, s = `m_${a ? "n" : ""}_${r ? "s" : ""}`;
                if (this._meshCache[s]) return this._meshCache[s];
                const n = this.painter.context, l = new t.cF, c = new t.aW, h = this.meshSize, u = t.a6 / h, d = h * h;
                for(let e1 = 0; e1 <= h; e1++)for(let t = 0; t <= h; t++)l.emplaceBack(t * u, e1 * u, 0);
                for(let e1 = 0; e1 < d; e1 += h + 1)for(let t = 0; t < h; t++)c.emplaceBack(t + e1, h + t + e1 + 1, h + t + e1 + 2), c.emplaceBack(t + e1, h + t + e1 + 2, t + e1 + 1);
                const _ = l.length, p = _ + (h + 1), m = (h + 1) * h, f = a ? t.bq : 0, g = a ? 0 : 1, v = r ? t.br : t.a6, x = r ? 0 : 1;
                for(let e1 = 0; e1 <= h; e1++)l.emplaceBack(e1 * u, f, g);
                for(let e1 = 0; e1 <= h; e1++)l.emplaceBack(e1 * u, v, x);
                for(let e1 = 0; e1 < h; e1++)c.emplaceBack(m + e1, p + e1, p + e1 + 1), c.emplaceBack(m + e1, p + e1 + 1, m + e1 + 1), c.emplaceBack(0 + e1, _ + e1 + 1, _ + e1), c.emplaceBack(0 + e1, 0 + e1 + 1, _ + e1 + 1);
                const b = l.length, y = b + 2 * (h + 1);
                for (const e1 of [
                    0,
                    1
                ])for(let i = 0; i <= h; i++)for (const o of [
                    0,
                    1
                ])l.emplaceBack(e1 * t.a6, i * u, o);
                for(let e1 = 0; e1 < 2 * h; e1 += 2)c.emplaceBack(b + e1, b + e1 + 1, b + e1 + 3), c.emplaceBack(b + e1, b + e1 + 3, b + e1 + 2), c.emplaceBack(y + e1, y + e1 + 3, y + e1 + 1), c.emplaceBack(y + e1, y + e1 + 2, y + e1 + 3);
                const w = new Bt(n.createVertexBuffer(l, os.members), n.createIndexBuffer(c), t.aV.simpleSegment(0, 0, l.length, c.length));
                return this._meshCache[s] = w, w;
            }
            getMeshFrameDelta(e1) {
                return 2 * Math.PI * t.bD / Math.pow(2, Math.max(e1, 0)) / 5;
            }
            getMinTileElevationForLngLatZoom(e1, i) {
                var o;
                if (!t.cD(i, e1.wrap())) return 0;
                const { tileID: a } = this._getOverscaledTileIDFromLngLatZoom(e1, i);
                return null !== (o = this.getMinMaxElevation(a).minElevation) && void 0 !== o ? o : 0;
            }
            getMinMaxElevation(e1) {
                const t = this.getTerrainData(e1).tile, i = {
                    minElevation: null,
                    maxElevation: null
                };
                return (null == t ? void 0 : t.dem) && (i.minElevation = t.dem.min * this.exaggeration, i.maxElevation = t.dem.max * this.exaggeration), i;
            }
            _getOverscaledTileIDFromLngLatZoom(e1, i) {
                const o = t.a7.fromLngLat(e1.wrap()), a = (1 << i) * t.a6, r = o.x * a, s = o.y * a, n = Math.floor(r / t.a6), l = Math.floor(s / t.a6);
                return {
                    tileID: new t.a3(i, 0, i, n, l),
                    mercatorX: r,
                    mercatorY: s
                };
            }
        }
        class ss {
            constructor(e1, t, i){
                this._context = e1, this._size = t, this._tileSize = i, this._objects = [], this._recentlyUsed = [], this._stamp = 0;
            }
            destruct() {
                for (const e1 of this._objects)e1.texture.destroy(), e1.fbo.destroy();
            }
            _createObject(e1) {
                const i = this._context.createFramebuffer(this._tileSize, this._tileSize, !0, !0), o = new t.T(this._context, {
                    width: this._tileSize,
                    height: this._tileSize,
                    data: null
                }, this._context.gl.RGBA);
                return o.bind(this._context.gl.LINEAR, this._context.gl.CLAMP_TO_EDGE), this._context.extTextureFilterAnisotropic && this._context.gl.texParameterf(this._context.gl.TEXTURE_2D, this._context.extTextureFilterAnisotropic.TEXTURE_MAX_ANISOTROPY_EXT, this._context.extTextureFilterAnisotropicMax), i.depthAttachment.set(this._context.createRenderbuffer(this._context.gl.DEPTH_STENCIL, this._tileSize, this._tileSize)), i.colorAttachment.set(o.texture), {
                    id: e1,
                    fbo: i,
                    texture: o,
                    stamp: -1,
                    inUse: !1
                };
            }
            getObjectForId(e1) {
                return this._objects[e1];
            }
            useObject(e1) {
                e1.inUse = !0, this._recentlyUsed = this._recentlyUsed.filter((t)=>e1.id !== t), this._recentlyUsed.push(e1.id);
            }
            stampObject(e1) {
                e1.stamp = ++this._stamp;
            }
            getOrCreateFreeObject() {
                for (const e1 of this._recentlyUsed)if (!this._objects[e1].inUse) return this._objects[e1];
                if (this._objects.length >= this._size) throw new Error("No free RenderPool available, call freeAllObjects() required!");
                const e1 = this._createObject(this._objects.length);
                return this._objects.push(e1), e1;
            }
            freeObject(e1) {
                e1.inUse = !1;
            }
            freeAllObjects() {
                for (const e1 of this._objects)this.freeObject(e1);
            }
            isFull() {
                return !(this._objects.length < this._size) && !1 === this._objects.some((e1)=>!e1.inUse);
            }
        }
        const ns = {
            background: !0,
            fill: !0,
            line: !0,
            raster: !0,
            hillshade: !0,
            "color-relief": !0
        };
        class ls {
            constructor(e1, t){
                this.painter = e1, this.terrain = t, this.pool = new ss(e1.context, 30, t.tileManager.tileSize * t.qualityFactor);
            }
            destruct() {
                this.pool.destruct();
            }
            getTexture(e1) {
                return this.pool.getObjectForId(e1.rtt[this._stacks.length - 1].id).texture;
            }
            prepareForRender(e1, t) {
                var i, o, a;
                this._stacks = [], this._prevType = null, this._rttTiles = [], this._renderableTiles = this.terrain.tileManager.getRenderableTiles(), this._renderableLayerIds = e1._order.filter((i)=>!e1._layers[i].isHidden(t)), this._coordsAscending = {};
                for(const t in e1.tileManagers){
                    this._coordsAscending[t] = {};
                    const i = e1.tileManagers[t].getVisibleCoordinates(), o = e1.tileManagers[t].getSource(), r = o instanceof te ? o.terrainTileRanges : null;
                    for (const e1 of i){
                        const i = this.terrain.tileManager.getTerrainCoords(e1, r);
                        for(const e1 in i)(a = this._coordsAscending[t])[e1] || (a[e1] = []), this._coordsAscending[t][e1].push(i[e1]);
                    }
                }
                this._rttFingerprints = {};
                for (const t of e1._order){
                    const a = e1._layers[t], r = a.source;
                    if (ns[a.type] && !this._rttFingerprints[r]) {
                        this._rttFingerprints[r] = {};
                        const t = null !== (o = null === (i = e1.tileManagers[r]) || void 0 === i ? void 0 : i.getState().revision) && void 0 !== o ? o : 0;
                        for(const e1 in this._coordsAscending[r])this._rttFingerprints[r][e1] = `${this._coordsAscending[r][e1].map((e1)=>e1.key).sort().join()}#${t}`;
                    }
                }
                for (const e1 of this._renderableTiles)for(const t in this._rttFingerprints){
                    const i = this._rttFingerprints[t][e1.tileID.key];
                    i && i !== e1.rttFingerprint[t] && (e1.rtt = []);
                }
            }
            renderLayer(e1, i) {
                if (e1.isHidden(this.painter.transform.zoom)) return !1;
                const o = Object.assign(Object.assign({}, i), {
                    isRenderingToTexture: !0
                }), a = e1.type, r = this.painter, s = this._renderableLayerIds[this._renderableLayerIds.length - 1] === e1.id;
                if (ns[a] && (this._prevType && ns[this._prevType] || this._stacks.push([]), this._prevType = a, this._stacks[this._stacks.length - 1].push(e1.id), !s)) return !0;
                if (ns[this._prevType] || ns[a] && s) {
                    this._prevType = a;
                    const e1 = this._stacks.length - 1, i = this._stacks[e1] || [];
                    for (const a of this._renderableTiles){
                        if (this.pool.isFull() && (qa(this.painter, this.terrain, this._rttTiles, o), this._rttTiles = [], this.pool.freeAllObjects()), this._rttTiles.push(a), a.rtt[e1]) {
                            const t = this.pool.getObjectForId(a.rtt[e1].id);
                            if (t.stamp === a.rtt[e1].stamp) {
                                this.pool.useObject(t);
                                continue;
                            }
                        }
                        const s = this.pool.getOrCreateFreeObject();
                        this.pool.useObject(s), this.pool.stampObject(s), a.rtt[e1] = {
                            id: s.id,
                            stamp: s.stamp
                        }, r.context.bindFramebuffer.set(s.fbo.framebuffer), r.context.clear({
                            color: t.bo.transparent,
                            stencil: 0
                        }), r.currentStencilSource = void 0;
                        for (const e1 of i){
                            const t = r.style._layers[e1], i = t.source ? this._coordsAscending[t.source][a.tileID.key] : [
                                a.tileID
                            ];
                            r.context.viewport.set([
                                0,
                                0,
                                s.fbo.width,
                                s.fbo.height
                            ]), r._renderTileClippingMasks(t, i, !0), r.renderLayer(r, r.style.tileManagers[t.source], t, i, o), t.source && (a.rttFingerprint[t.source] = this._rttFingerprints[t.source][a.tileID.key]);
                        }
                    }
                    return qa(this.painter, this.terrain, this._rttTiles, o), this._rttTiles = [], this.pool.freeAllObjects(), ns[a];
                }
                return !1;
            }
        }
        const cs = {
            "AttributionControl.ToggleAttribution": "Toggle attribution",
            "AttributionControl.MapFeedback": "Map feedback",
            "FullscreenControl.Enter": "Enter fullscreen",
            "FullscreenControl.Exit": "Exit fullscreen",
            "GeolocateControl.FindMyLocation": "Find my location",
            "GeolocateControl.LocationNotAvailable": "Location not available",
            "LogoControl.Title": "MapLibre logo",
            "Map.Title": "Map",
            "Marker.Title": "Map marker",
            "NavigationControl.ResetBearing": "Drag to rotate map, click to reset north",
            "NavigationControl.ZoomIn": "Zoom in",
            "NavigationControl.ZoomOut": "Zoom out",
            "Popup.Close": "Close popup",
            "ScaleControl.Feet": "ft",
            "ScaleControl.Meters": "m",
            "ScaleControl.Kilometers": "km",
            "ScaleControl.Miles": "mi",
            "ScaleControl.NauticalMiles": "nm",
            "GlobeControl.Enable": "Enable globe",
            "GlobeControl.Disable": "Disable globe",
            "TerrainControl.Enable": "Enable terrain",
            "TerrainControl.Disable": "Disable terrain",
            "CooperativeGesturesHandler.WindowsHelpText": "Use Ctrl + scroll to zoom the map",
            "CooperativeGesturesHandler.MacHelpText": "Use \u2318 + scroll to zoom the map",
            "CooperativeGesturesHandler.MobileHelpText": "Use two fingers to move the map"
        }, hs = i, us = {
            hash: !1,
            interactive: !0,
            bearingSnap: 7,
            zoomSnap: 0,
            attributionControl: Jr,
            maplibreLogo: !1,
            refreshExpiredTiles: !0,
            canvasContextAttributes: {
                antialias: !1,
                preserveDrawingBuffer: !1,
                powerPreference: "high-performance",
                failIfMajorPerformanceCaveat: !1,
                desynchronized: !1,
                contextType: void 0
            },
            scrollZoom: !0,
            minZoom: -2,
            maxZoom: 22,
            minPitch: 0,
            maxPitch: 60,
            boxZoom: !0,
            dragRotate: !0,
            dragPan: !0,
            keyboard: !0,
            doubleClickZoom: !0,
            touchZoomRotate: !0,
            touchPitch: !0,
            cooperativeGestures: !1,
            trackResize: !0,
            center: [
                0,
                0
            ],
            elevation: 0,
            zoom: 0,
            bearing: 0,
            pitch: 0,
            roll: 0,
            renderWorldCopies: !0,
            maxTileCacheSize: null,
            maxTileCacheZoomLevels: t.c.MAX_TILE_CACHE_ZOOM_LEVELS,
            transformRequest: null,
            transformCameraUpdate: null,
            transformConstrain: null,
            fadeDuration: 300,
            crossSourceCollisions: !0,
            clickTolerance: 3,
            localIdeographFontFamily: "sans-serif",
            pitchWithRotate: !0,
            rollEnabled: !1,
            reduceMotion: void 0,
            validateStyle: !0,
            maxCanvasSize: [
                4096,
                4096
            ],
            cancelPendingTileRequestsWhileZooming: !0,
            centerClampedToGround: !0,
            experimentalZoomLevelsToOverscale: void 0,
            anisotropicFilterPitch: 20
        };
        let ds = class extends Qr {
            get _ownerWindow() {
                var e1, t;
                return (null === (t = null === (e1 = this._container) || void 0 === e1 ? void 0 : e1.ownerDocument) || void 0 === t ? void 0 : t.defaultView) || window;
            }
            constructor(e1){
                var i, o, a;
                const r = Object.assign(Object.assign(Object.assign({}, us), e1), {
                    canvasContextAttributes: Object.assign(Object.assign({}, us.canvasContextAttributes), e1.canvasContextAttributes)
                });
                if (null != r.minZoom && null != r.maxZoom && r.minZoom > r.maxZoom) throw new Error("maxZoom must be greater than or equal to minZoom");
                if (null != r.minPitch && null != r.maxPitch && r.minPitch > r.maxPitch) throw new Error("maxPitch must be greater than or equal to minPitch");
                if (null != r.minPitch && r.minPitch < 0) throw new Error("minPitch must be greater than or equal to 0");
                if (null != r.maxPitch && r.maxPitch > 180) throw new Error("maxPitch must be less than or equal to 180");
                const s = new Xt, l = new Jt;
                void 0 !== r.minZoom && s.setMinZoom(r.minZoom), void 0 !== r.maxZoom && s.setMaxZoom(r.maxZoom), void 0 !== r.minPitch && s.setMinPitch(r.minPitch), void 0 !== r.maxPitch && s.setMaxPitch(r.maxPitch), void 0 !== r.renderWorldCopies && s.setRenderWorldCopies(r.renderWorldCopies), null !== r.transformConstrain && s.setConstrainOverride(r.transformConstrain), super(s, l, {
                    bearingSnap: r.bearingSnap,
                    zoomSnap: r.zoomSnap
                }), this._idleTriggered = !1, this._crossFadingFactor = 1, this._renderTaskQueue = new is, this._controls = [], this._mapId = t.ad(), this._lostContextStyle = {
                    style: null,
                    images: null
                }, this._contextLost = (e1)=>{
                    if (e1.preventDefault(), this._frameRequest && (this._frameRequest.abort(), this._frameRequest = null), this.painter.destroy(), this._lostContextStyle = this._getStyleAndImages(), this.style) {
                        for (const e1 of Object.values(this.style._layers))if ("custom" === e1.type && console.warn(`Custom layer with id '${e1.id}' cannot be restored after WebGL context loss. You will need to re-add it manually after context restoration.`), e1._listeners) for (const [t] of Object.entries(e1._listeners))console.warn(`Custom layer with id '${e1.id}' had event listeners for event '${t}' which cannot be restored after WebGL context loss. You will need to re-add them manually after context restoration.`);
                        this.style.destroy(), this.style = null, this.fire(new t.n("webglcontextlost", {
                            originalEvent: e1
                        }));
                    } else this.fire(new t.n("webglcontextlost", {
                        originalEvent: e1
                    }));
                }, this._contextRestored = (e1)=>{
                    this._lostContextStyle.style && this.setStyle(this._lostContextStyle.style, {
                        diff: !1
                    }), this._lostContextStyle.images && this.style && (this.style.imageManager.images = this._lostContextStyle.images), this._lostContextStyle = {
                        style: null,
                        images: null
                    }, this._setupPainter(), this.resize(), this._update(), this._resizeInternal(), this.fire(new t.n("webglcontextrestored", {
                        originalEvent: e1
                    }));
                }, this._onMapScroll = (e1)=>{
                    if (e1.target === this._container) return this._container.scrollTop = 0, this._container.scrollLeft = 0, !1;
                }, this._onWindowOnline = ()=>{
                    this._update();
                }, this._interactive = r.interactive, this._maxTileCacheSize = r.maxTileCacheSize, this._maxTileCacheZoomLevels = r.maxTileCacheZoomLevels, this._canvasContextAttributes = Object.assign({}, r.canvasContextAttributes), this._trackResize = !0 === r.trackResize, this._bearingSnap = r.bearingSnap, this._zoomSnap = r.zoomSnap, this._centerClampedToGround = r.centerClampedToGround, this._refreshExpiredTiles = !0 === r.refreshExpiredTiles, this._fadeDuration = r.fadeDuration, this._crossSourceCollisions = !0 === r.crossSourceCollisions, this._collectResourceTiming = !0 === r.collectResourceTiming, this._locale = Object.assign(Object.assign({}, cs), r.locale), this._clickTolerance = r.clickTolerance, this._overridePixelRatio = r.pixelRatio, this._maxCanvasSize = r.maxCanvasSize, this._zoomLevelsToOverscale = r.experimentalZoomLevelsToOverscale, this.transformCameraUpdate = r.transformCameraUpdate, this.transformConstrain = r.transformConstrain, this.cancelPendingTileRequestsWhileZooming = !0 === r.cancelPendingTileRequestsWhileZooming, this.setAnisotropicFilterPitch(r.anisotropicFilterPitch), void 0 !== r.reduceMotion && (n.prefersReducedMotion = r.reduceMotion), this._imageQueueHandle = u.addThrottleControl(()=>this.isMoving()), this._requestManager = new _(r.transformRequest), this._container = this._resolveContainer(r.container), r.maxBounds && this.setMaxBounds(r.maxBounds), this._setupContainer(), this._setupPainter(), this.on("move", ()=>this._update(!1)), this.on("moveend", ()=>this._update(!1)), this.on("zoom", ()=>this._update(!0)), this.on("terrain", ()=>{
                    this.painter.terrainFacilitator.depthDirty = !0, this._update(!0);
                }), this.once("idle", ()=>this._idleTriggered = !0), "undefined" != typeof window && (this._ownerWindow.addEventListener("online", this._onWindowOnline, !1), this._setupResizeObserver()), this.handlers = new Yr(this, r), this._hash = r.hash ? new Ya("string" == typeof r.hash && r.hash || void 0).addTo(this) : void 0, (null === (i = this._hash) || void 0 === i ? void 0 : i._onHashChange()) || (this.jumpTo({
                    center: r.center,
                    elevation: r.elevation,
                    zoom: r.zoom,
                    bearing: r.bearing,
                    pitch: r.pitch,
                    roll: r.roll
                }), r.bounds && (this.resize(), this.fitBounds(r.bounds, t.e({}, r.fitBoundsOptions, {
                    duration: 0
                }))));
                const c = "string" == typeof r.style || !("globe" === (null === (a = null === (o = r.style) || void 0 === o ? void 0 : o.projection) || void 0 === a ? void 0 : a.type));
                this.resize(null, c), this._localIdeographFontFamily = r.localIdeographFontFamily, this._validateStyle = r.validateStyle, r.style && this.setStyle(r.style, {
                    localIdeographFontFamily: r.localIdeographFontFamily
                }), r.attributionControl && this.addControl(new es("boolean" == typeof r.attributionControl ? void 0 : r.attributionControl)), r.maplibreLogo && this.addControl(new ts, r.logoPosition), this.on("style.load", ()=>{
                    if (c || this._resizeTransform(), this.transform.unmodified) {
                        const e1 = t.V(this.style.stylesheet, [
                            "center",
                            "zoom",
                            "bearing",
                            "pitch",
                            "roll"
                        ]);
                        this.jumpTo(e1);
                    }
                }), this.on("data", (e1)=>{
                    this._update("style" === e1.dataType), this.fire(new t.n(`${e1.dataType}data`, e1));
                }), this.on("dataloading", (e1)=>{
                    this.fire(new t.n(`${e1.dataType}dataloading`, e1));
                }), this.on("dataabort", (e1)=>{
                    this.fire(new t.n("sourcedataabort", e1));
                });
            }
            _getMapId() {
                return this._mapId;
            }
            setGlobalStateProperty(e1, t) {
                return this.style.setGlobalStateProperty(e1, t), this._update(!0);
            }
            getGlobalState() {
                return this.style.getGlobalState();
            }
            addControl(e1, i) {
                if (void 0 === i && (i = e1.getDefaultPosition ? e1.getDefaultPosition() : "top-right"), !(null == e1 ? void 0 : e1.onAdd)) return this.fire(new t.l(new Error("Invalid argument to map.addControl(). Argument must be a control with onAdd and onRemove methods.")));
                const o = e1.onAdd(this);
                this._controls.push(e1);
                const a = this._controlPositions[i];
                return i.includes("bottom") ? a.insertBefore(o, a.firstChild) : a.appendChild(o), this;
            }
            removeControl(e1) {
                if (!(null == e1 ? void 0 : e1.onRemove)) return this.fire(new t.l(new Error("Invalid argument to map.removeControl(). Argument must be a control with onAdd and onRemove methods.")));
                const i = this._controls.indexOf(e1);
                return i > -1 && this._controls.splice(i, 1), e1.onRemove(this), this;
            }
            hasControl(e1) {
                return this._controls.includes(e1);
            }
            coveringTiles(e1) {
                return Me(this.transform, e1);
            }
            calculateCameraOptionsFromTo(e1, t, i, o) {
                return null == o && this.terrain && (o = this.terrain.getElevationForLngLat(i, this.transform)), super.calculateCameraOptionsFromTo(e1, t, i, o);
            }
            resize(e1, i = !0) {
                if (null !== this._lostContextStyle.style) return this;
                this._resizeInternal(i);
                const o = !this._moving;
                return o && (this.stop(), this.fire(new t.n("movestart", e1)).fire(new t.n("move", e1))), this.fire(new t.n("resize", e1)), o && this.fire(new t.n("moveend", e1)), this;
            }
            _resizeInternal(e1 = !0) {
                const [t, i] = this._containerDimensions(), o = this._getClampedPixelRatio(t, i);
                if (this._resizeCanvas(t, i, o), this.painter.resize(t, i, o), this.painter.overLimit()) {
                    const e1 = this.painter.context.gl;
                    this._maxCanvasSize = [
                        e1.drawingBufferWidth,
                        e1.drawingBufferHeight
                    ];
                    const o = this._getClampedPixelRatio(t, i);
                    this._resizeCanvas(t, i, o), this.painter.resize(t, i, o);
                }
                this._resizeTransform(e1);
            }
            _resizeTransform(e1 = !0) {
                var t;
                const [i, o] = this._containerDimensions();
                this.transform.resize(i, o, e1), null === (t = this._requestedCameraState) || void 0 === t || t.resize(i, o, e1);
            }
            _getClampedPixelRatio(e1, t) {
                const { 0: i, 1: o } = this._maxCanvasSize, a = this.getPixelRatio(), r = e1 * a, s = t * a;
                return Math.min(r > i ? i / r : 1, s > o ? o / s : 1) * a;
            }
            getPixelRatio() {
                var e1;
                return null !== (e1 = this._overridePixelRatio) && void 0 !== e1 ? e1 : devicePixelRatio;
            }
            setPixelRatio(e1) {
                this._overridePixelRatio = e1, this.resize();
            }
            getBounds() {
                return this.transform.getBounds();
            }
            getMaxBounds() {
                return this.transform.getMaxBounds();
            }
            setMaxBounds(e1) {
                return this.transform.setMaxBounds(G.convert(e1)), this._update();
            }
            setMinZoom(e1) {
                if ((e1 = null == e1 ? -2 : e1) >= -2 && e1 <= this.transform.maxZoom) {
                    const i = this.transform.zoom, o = this._getTransformForUpdate();
                    return o.setMinZoom(e1), this._applyUpdatedTransform(o), this._update(), i !== this.transform.zoom && this.fire(new t.n("zoomstart")).fire(new t.n("zoom")).fire(new t.n("zoomend")).fire(new t.n("movestart")).fire(new t.n("move")).fire(new t.n("moveend")), this;
                }
                throw new Error("minZoom must be between -2 and the current maxZoom, inclusive");
            }
            getMinZoom() {
                return this.transform.minZoom;
            }
            setMaxZoom(e1) {
                if ((e1 = null == e1 ? 22 : e1) >= this.transform.minZoom) {
                    const i = this.transform.zoom, o = this._getTransformForUpdate();
                    return o.setMaxZoom(e1), this._applyUpdatedTransform(o), this._update(), i !== this.transform.zoom && this.fire(new t.n("zoomstart")).fire(new t.n("zoom")).fire(new t.n("zoomend")).fire(new t.n("movestart")).fire(new t.n("move")).fire(new t.n("moveend")), this;
                }
                throw new Error("maxZoom must be greater than the current minZoom");
            }
            getMaxZoom() {
                return this.transform.maxZoom;
            }
            setMinPitch(e1) {
                if ((e1 = null == e1 ? 0 : e1) < 0) throw new Error("minPitch must be greater than or equal to 0");
                if (e1 >= 0 && e1 <= this.transform.maxPitch) {
                    const i = this.transform.pitch, o = this._getTransformForUpdate();
                    return o.setMinPitch(e1), this._applyUpdatedTransform(o), this._update(), i !== this.transform.pitch && this.fire(new t.n("pitchstart")).fire(new t.n("pitch")).fire(new t.n("pitchend")).fire(new t.n("movestart")).fire(new t.n("move")).fire(new t.n("moveend")), this;
                }
                throw new Error("minPitch must be between 0 and the current maxPitch, inclusive");
            }
            getMinPitch() {
                return this.transform.minPitch;
            }
            setMaxPitch(e1) {
                if ((e1 = null == e1 ? 60 : e1) > 180) throw new Error("maxPitch must be less than or equal to 180");
                if (e1 >= this.transform.minPitch) {
                    const i = this.transform.pitch, o = this._getTransformForUpdate();
                    return o.setMaxPitch(e1), this._applyUpdatedTransform(o), this._update(), i !== this.transform.pitch && this.fire(new t.n("pitchstart")).fire(new t.n("pitch")).fire(new t.n("pitchend")).fire(new t.n("movestart")).fire(new t.n("move")).fire(new t.n("moveend")), this;
                }
                throw new Error("maxPitch must be greater than the current minPitch");
            }
            getMaxPitch() {
                return this.transform.maxPitch;
            }
            getAnisotropicFilterPitch() {
                return this._anisotropicFilterPitch;
            }
            setAnisotropicFilterPitch(e1) {
                if ((e1 = null == e1 ? 20 : e1) > 180) throw new Error("anisotropicFilterPitch must be less than or equal to 180");
                if (e1 < 0) throw new Error("anisotropicFilterPitch must be greater than or equal to 0");
                return this._anisotropicFilterPitch = e1, this._update();
            }
            getRenderWorldCopies() {
                return this.transform.renderWorldCopies;
            }
            setRenderWorldCopies(e1) {
                return this.transform.setRenderWorldCopies(e1), this._update();
            }
            setTransformConstrain(e1) {
                return this.transform.setConstrainOverride(e1), this._update();
            }
            project(e1) {
                return this.transform.locationToScreenPoint(t.W.convert(e1), this.style && this.terrain);
            }
            unproject(e1) {
                return this.transform.screenPointToLocation(t.P.convert(e1), this.terrain);
            }
            isMoving() {
                var e1;
                return this._moving || (null === (e1 = this.handlers) || void 0 === e1 ? void 0 : e1.isMoving());
            }
            isZooming() {
                var e1;
                return this._zooming || (null === (e1 = this.handlers) || void 0 === e1 ? void 0 : e1.isZooming());
            }
            isRotating() {
                var e1;
                return this._rotating || (null === (e1 = this.handlers) || void 0 === e1 ? void 0 : e1.isRotating());
            }
            _createDelegatedListener(e1, t, i) {
                if ("mouseenter" === e1 || "mouseover" === e1) {
                    let o = !1;
                    const a = (a)=>{
                        const r = t.filter((e1)=>this.getLayer(e1)), s = 0 !== r.length ? this.queryRenderedFeatures(a.point, {
                            layers: r
                        }) : [];
                        s.length ? o || (o = !0, i.call(this, new nr(e1, this, a.originalEvent, {
                            features: s
                        }))) : o = !1;
                    };
                    return {
                        layers: t,
                        listener: i,
                        delegates: {
                            mousemove: a,
                            mouseout: ()=>{
                                o = !1;
                            }
                        }
                    };
                }
                if ("mouseleave" === e1 || "mouseout" === e1) {
                    let o = !1;
                    const a = (a)=>{
                        const r = t.filter((e1)=>this.getLayer(e1));
                        (0 !== r.length ? this.queryRenderedFeatures(a.point, {
                            layers: r
                        }) : []).length ? o = !0 : o && (o = !1, i.call(this, new nr(e1, this, a.originalEvent)));
                    }, r = (t)=>{
                        o && (o = !1, i.call(this, new nr(e1, this, t.originalEvent)));
                    };
                    return {
                        layers: t,
                        listener: i,
                        delegates: {
                            mousemove: a,
                            mouseout: r
                        }
                    };
                }
                {
                    const o = (e1)=>{
                        const o = t.filter((e1)=>this.getLayer(e1)), a = 0 !== o.length ? this.queryRenderedFeatures(e1.point, {
                            layers: o
                        }) : [];
                        a.length && (e1.features = a, i.call(this, e1), delete e1.features);
                    };
                    return {
                        layers: t,
                        listener: i,
                        delegates: {
                            [e1]: o
                        }
                    };
                }
            }
            _saveDelegatedListener(e1, t) {
                var i;
                this._delegatedListeners || (this._delegatedListeners = {}), (i = this._delegatedListeners)[e1] || (i[e1] = []), this._delegatedListeners[e1].push(t);
            }
            _removeDelegatedListener(e1, t, i) {
                var o;
                if (!(null === (o = this._delegatedListeners) || void 0 === o ? void 0 : o[e1])) return;
                const a = this._delegatedListeners[e1];
                for(let e1 = 0; e1 < a.length; e1++){
                    const o = a[e1];
                    if (o.listener === i && o.layers.length === t.length && o.layers.every((e1)=>t.includes(e1))) {
                        for(const e1 in o.delegates)this.off(e1, o.delegates[e1]);
                        return void a.splice(e1, 1);
                    }
                }
            }
            on(e1, t, i) {
                if (void 0 === i) return super.on(e1, t);
                const o = "string" == typeof t ? [
                    t
                ] : t, a = this._createDelegatedListener(e1, o, i);
                this._saveDelegatedListener(e1, a);
                for(const e1 in a.delegates)this.on(e1, a.delegates[e1]);
                return {
                    unsubscribe: ()=>{
                        this._removeDelegatedListener(e1, o, i);
                    }
                };
            }
            once(e1, t, i) {
                if (void 0 === i) return super.once(e1, t);
                const o = "string" == typeof t ? [
                    t
                ] : t, a = this._createDelegatedListener(e1, o, i);
                for(const t in a.delegates){
                    const r = a.delegates[t];
                    a.delegates[t] = (...t)=>{
                        this._removeDelegatedListener(e1, o, i), r(...t);
                    };
                }
                this._saveDelegatedListener(e1, a);
                for(const e1 in a.delegates)this.once(e1, a.delegates[e1]);
                return this;
            }
            off(e1, t, i) {
                return void 0 === i ? super.off(e1, t) : (this._removeDelegatedListener(e1, "string" == typeof t ? [
                    t
                ] : t, i), this);
            }
            queryRenderedFeatures(e1, i) {
                if (!this.style) return [];
                let o;
                const a = e1 instanceof t.P || Array.isArray(e1), r = a ? e1 : [
                    [
                        0,
                        0
                    ],
                    [
                        this.transform.width,
                        this.transform.height
                    ]
                ];
                if (i || (i = (a ? {} : e1) || {}), r instanceof t.P || "number" == typeof r[0]) o = [
                    t.P.convert(r)
                ];
                else {
                    const e1 = t.P.convert(r[0]), i = t.P.convert(r[1]);
                    o = [
                        e1,
                        new t.P(i.x, e1.y),
                        i,
                        new t.P(e1.x, i.y),
                        e1
                    ];
                }
                return this.style.queryRenderedFeatures(o, i, this.transform);
            }
            querySourceFeatures(e1, t) {
                return this.style.querySourceFeatures(e1, t);
            }
            setStyle(e1, i) {
                return !1 !== (i = t.e({}, {
                    localIdeographFontFamily: this._localIdeographFontFamily,
                    validate: this._validateStyle
                }, i)).diff && i.localIdeographFontFamily === this._localIdeographFontFamily && this.style && e1 ? (this._diffStyle(e1, i), this) : (this._localIdeographFontFamily = i.localIdeographFontFamily, this._updateStyle(e1, i));
            }
            setTransformRequest(e1) {
                return this._requestManager.setTransformRequest(e1), this;
            }
            _getUIString(e1) {
                const t = this._locale[e1];
                if (null == t) throw new Error(`Missing UI string '${e1}'`);
                return t;
            }
            _updateStyle(e1, t) {
                var i, o, a;
                if (null === (i = this._diffStyleRequest) || void 0 === i || i.abort(), this._diffStyleRequest = null, t.transformStyle && this.style && !this.style._loaded) return void this.style.once("style.load", ()=>this._updateStyle(e1, t));
                const r = this.style && t.transformStyle ? this.style.serialize() : void 0;
                return this.style && (this.style.setEventedParent(null), this.style._remove(!e1)), e1 ? (this.style = new ki(this, t || {}), this.style.setEventedParent(this, {
                    style: this.style
                }), "string" == typeof e1 ? this.style.loadURL(e1, t, r) : this.style.loadJSON(e1, t, r), this) : (this._frameRequest && (this._frameRequest.abort(), this._frameRequest = null), null === (a = null === (o = this.style) || void 0 === o ? void 0 : o.projection) || void 0 === a || a.destroy(), delete this.style, this);
            }
            _lazyInitEmptyStyle() {
                this.style || (this.style = new ki(this, {}), this.style.setEventedParent(this, {
                    style: this.style
                }), this.style.loadEmpty());
            }
            _diffStyle(e1, i) {
                return t._(this, void 0, void 0, function*() {
                    var o;
                    if (null === (o = this._diffStyleRequest) || void 0 === o || o.abort(), "string" == typeof e1) {
                        const o = e1;
                        this._diffStyleRequest = new AbortController;
                        const a = this._diffStyleRequest;
                        try {
                            const e1 = yield this._requestManager.transformRequest(o, "Style");
                            if (a.signal.aborted) return void (this._diffStyleRequest = null);
                            const r = yield t.k(e1, a);
                            this._diffStyleRequest = null, this._updateDiff(r.data, i);
                        } catch (e1) {
                            this._diffStyleRequest = null, t.$(e1) || this.fire(new t.l(t.d(e1)));
                        }
                    } else "object" == typeof e1 && (this._diffStyleRequest = null, this._updateDiff(e1, i));
                });
            }
            _updateDiff(e1, i) {
                try {
                    this.style.setState(e1, i) && this._update(!0);
                } catch (o) {
                    t.w(`Unable to perform style diff: ${t.d(o).message}.  Rebuilding the style from scratch.`), this._updateStyle(e1, i);
                }
            }
            getStyle() {
                if (this.style) return this.style.serialize();
            }
            _getStyleAndImages() {
                return this.style ? {
                    style: this.style.serialize(),
                    images: this.style.imageManager.cloneImages()
                } : {
                    style: null,
                    images: {}
                };
            }
            isStyleLoaded() {
                if (this.style) return this.style.loaded();
                t.w("There is no style added to the map.");
            }
            addSource(e1, t) {
                return this._lazyInitEmptyStyle(), this.style.addSource(e1, t), this._update(!0);
            }
            isSourceLoaded(e1) {
                var i;
                const o = null === (i = this.style) || void 0 === i ? void 0 : i.tileManagers[e1];
                if (void 0 !== o) return o.loaded();
                this.fire(new t.l(new Error(`There is no tile manager with ID '${e1}'`)));
            }
            setTerrain(e1) {
                if (this.style._checkLoaded(), this._terrainDataCallback && this.style.off("data", this._terrainDataCallback), e1) {
                    const i = this.style.tileManagers[e1.source];
                    if (!i) throw new Error(`cannot load terrain, because there exists no source with ID: ${e1.source}`);
                    null === this.terrain && i.reload();
                    for(const i in this.style._layers){
                        const o = this.style._layers[i];
                        "hillshade" === o.type && o.source === e1.source && t.w("You are using the same source for a hillshade layer and for 3D terrain. Please consider using two separate sources to improve rendering quality."), "color-relief" === o.type && o.source === e1.source && t.w("You are using the same source for a color-relief layer and for 3D terrain. Please consider using two separate sources to improve rendering quality.");
                    }
                    this.terrain = new rs(this.painter, i, e1), this.painter.renderToTexture = new ls(this.painter, this.terrain), this.transform.setMinElevationForCurrentTile(this.terrain.getMinTileElevationForLngLatZoom(this.transform.center, this.transform.tileZoom)), this.transform.setElevation(this.terrain.getElevationForLngLatZoom(this.transform.center, this.transform.tileZoom)), this._terrainDataCallback = (t)=>{
                        var i;
                        "style" === t.dataType ? this.terrain.tileManager.freeRtt() : "source" === t.dataType && t.tile && (t.sourceId !== e1.source || this._elevationFreeze || (this.transform.setMinElevationForCurrentTile(this.terrain.getMinTileElevationForLngLatZoom(this.transform.center, this.transform.tileZoom)), this._centerClampedToGround && this.transform.setElevation(this.terrain.getElevationForLngLatZoom(this.transform.center, this.transform.tileZoom))), "image" === (null === (i = t.source) || void 0 === i ? void 0 : i.type) ? this.terrain.tileManager.freeRtt() : this.terrain.tileManager.freeRtt(t.tile.tileID));
                    }, this.style.on("data", this._terrainDataCallback);
                } else this.terrain && this.terrain.destroy(), this.terrain = null, this.painter.renderToTexture && this.painter.renderToTexture.destruct(), this.painter.renderToTexture = null, this.transform.setMinElevationForCurrentTile(0), this._centerClampedToGround && this.transform.setElevation(0);
                return this.fire(new t.n("terrain", {
                    terrain: e1
                })), this;
            }
            getTerrain() {
                var e1, t;
                return null !== (t = null === (e1 = this.terrain) || void 0 === e1 ? void 0 : e1.options) && void 0 !== t ? t : null;
            }
            areTilesLoaded() {
                var e1;
                const t = null === (e1 = this.style) || void 0 === e1 ? void 0 : e1.tileManagers;
                for (const e1 of Object.values(t))if (!e1.areTilesLoaded()) return !1;
                return !0;
            }
            removeSource(e1) {
                return this.style.removeSource(e1), this._update(!0);
            }
            getSource(e1) {
                return this.style.getSource(e1);
            }
            setSourceTileLodParams(e1, t, i) {
                if (i) {
                    const o = this.getSource(i);
                    if (!o) throw new Error(`There is no source with ID "${i}", cannot set LOD parameters`);
                    o.calculateTileZoom = Te(Math.max(1, e1), Math.max(1, t));
                } else for(const i in this.style.tileManagers)this.style.tileManagers[i].getSource().calculateTileZoom = Te(Math.max(1, e1), Math.max(1, t));
                return this._update(!0), this;
            }
            refreshTiles(e1, i) {
                const o = this.style.tileManagers[e1];
                if (!o) throw new Error(`There is no tile manager with ID "${e1}", cannot refresh tile`);
                void 0 === i ? o.reload(!0) : o.refreshTiles(i.map((e1)=>new t.aa(e1.z, e1.x, e1.y)));
            }
            addImage(e1, i, o = {}) {
                const { pixelRatio: a = 1, sdf: r = !1, stretchX: s, stretchY: l, content: c, textFitWidth: h, textFitHeight: u } = o;
                if (this._lazyInitEmptyStyle(), !(i instanceof HTMLImageElement || t.b(i))) {
                    if (void 0 === i.width || void 0 === i.height) return this.fire(new t.l(new Error("Invalid arguments to map.addImage(). The second argument must be an `HTMLImageElement`, `ImageData`, `ImageBitmap`, or object with `width`, `height`, and `data` properties with the same format as `ImageData`")));
                    {
                        const { width: o, height: n, data: d } = i, _ = i;
                        return this.style.addImage(e1, {
                            data: new t.R({
                                width: o,
                                height: n
                            }, new Uint8Array(d)),
                            pixelRatio: a,
                            stretchX: s,
                            stretchY: l,
                            content: c,
                            textFitWidth: h,
                            textFitHeight: u,
                            sdf: r,
                            version: 0,
                            userImage: _
                        }), _.onAdd && _.onAdd(this, e1), this;
                    }
                }
                {
                    const { width: o, height: d, data: _ } = n.getImageData(i);
                    this.style.addImage(e1, {
                        data: new t.R({
                            width: o,
                            height: d
                        }, _),
                        pixelRatio: a,
                        stretchX: s,
                        stretchY: l,
                        content: c,
                        textFitWidth: h,
                        textFitHeight: u,
                        sdf: r,
                        version: 0
                    });
                }
            }
            updateImage(e1, i) {
                const o = this.style.getImage(e1);
                if (!o) return this.fire(new t.l(new Error("The map has no image with that id. If you are adding a new image use `map.addImage(...)` instead.")));
                const a = i instanceof HTMLImageElement || t.b(i) ? n.getImageData(i) : i, { width: r, height: s, data: l } = a;
                if (void 0 === r || void 0 === s) return this.fire(new t.l(new Error("Invalid arguments to map.updateImage(). The second argument must be an `HTMLImageElement`, `ImageData`, `ImageBitmap`, or object with `width`, `height`, and `data` properties with the same format as `ImageData`")));
                if (r !== o.data.width || s !== o.data.height) return this.fire(new t.l(new Error("The width and height of the updated image must be that same as the previous version of the image")));
                const c = !(i instanceof HTMLImageElement || t.b(i));
                return o.data.replace(l, c), this.style.updateImage(e1, o), this;
            }
            getImage(e1) {
                return this.style.getImage(e1);
            }
            hasImage(e1) {
                return e1 ? !!this.style.getImage(e1) : (this.fire(new t.l(new Error("Missing required image id"))), !1);
            }
            removeImage(e1) {
                this.style.removeImage(e1);
            }
            loadImage(e1) {
                return t._(this, void 0, void 0, function*() {
                    return u.getImage((yield this._requestManager.transformRequest(e1, "Image")), new AbortController);
                });
            }
            listImages() {
                return this.style.listImages();
            }
            addLayer(e1, t) {
                return this._lazyInitEmptyStyle(), this.style.addLayer(e1, t), this._update(!0);
            }
            moveLayer(e1, t) {
                return this.style.moveLayer(e1, t), this._update(!0);
            }
            removeLayer(e1) {
                return this.style.removeLayer(e1), this._update(!0);
            }
            getLayer(e1) {
                return this.style.getLayer(e1);
            }
            getLayersOrder() {
                return this.style.getLayersOrder();
            }
            setLayerZoomRange(e1, t, i) {
                return this.style.setLayerZoomRange(e1, t, i), this._update(!0);
            }
            setFilter(e1, t, i = {}) {
                return this.style.setFilter(e1, t, i), this._update(!0);
            }
            getFilter(e1) {
                return this.style.getFilter(e1);
            }
            setPaintProperty(e1, t, i, o = {}) {
                return this.style.setPaintProperty(e1, t, i, o), this._update(!0);
            }
            getPaintProperty(e1, t) {
                return this.style.getPaintProperty(e1, t);
            }
            setLayoutProperty(e1, t, i, o = {}) {
                return this.style.setLayoutProperty(e1, t, i, o), this._update(!0);
            }
            getLayoutProperty(e1, t) {
                return this.style.getLayoutProperty(e1, t);
            }
            setGlyphs(e1, t = {}) {
                return this._lazyInitEmptyStyle(), this.style.setGlyphs(e1, t), this._update(!0);
            }
            getGlyphs() {
                return this.style.getGlyphsUrl();
            }
            addSprite(e1, t, i = {}) {
                return this._lazyInitEmptyStyle(), this.style.addSprite(e1, t, i, (e1)=>{
                    e1 || this._update(!0);
                }), this;
            }
            removeSprite(e1) {
                return this._lazyInitEmptyStyle(), this.style.removeSprite(e1), this._update(!0);
            }
            getSprite() {
                return this.style.getSprite();
            }
            setSprite(e1, t = {}) {
                return this._lazyInitEmptyStyle(), this.style.setSprite(e1, t, (e1)=>{
                    e1 || this._update(!0);
                }), this;
            }
            setLight(e1, t = {}) {
                return this._lazyInitEmptyStyle(), this.style.setLight(e1, t), this._update(!0);
            }
            getLight() {
                return this.style.getLight();
            }
            setSky(e1, t = {}) {
                return this._lazyInitEmptyStyle(), this.style.setSky(e1, t), this._update(!0);
            }
            getSky() {
                return this.style.getSky();
            }
            setFeatureState(e1, t) {
                return this.style.setFeatureState(e1, t), this._update();
            }
            removeFeatureState(e1, t) {
                return this.style.removeFeatureState(e1, t), this._update();
            }
            getFeatureState(e1) {
                return this.style.getFeatureState(e1);
            }
            getContainer() {
                return this._container;
            }
            getCanvasContainer() {
                return this._canvasContainer;
            }
            getCanvas() {
                return this._canvas;
            }
            _containerDimensions() {
                let e1 = 0, t = 0;
                return this._container && (e1 = this._container.clientWidth || 400, t = this._container.clientHeight || 300), [
                    e1,
                    t
                ];
            }
            _setupResizeObserver() {
                var e1;
                let t = !1;
                const i = Ka((e1)=>{
                    this._trackResize && !this._removed && (this.resize(e1), this.redraw());
                }, 50), o = null !== (e1 = this._ownerWindow.ResizeObserver) && void 0 !== e1 ? e1 : ResizeObserver;
                this._resizeObserver = new o((e1)=>{
                    t ? i(e1) : t = !0;
                }), this._resizeObserver.observe(this._container);
            }
            _resolveContainer(e1) {
                if ("string" == typeof e1) {
                    const t = document.getElementById(e1);
                    if (!t) throw new Error(`Container '${e1}' not found.`);
                    return t;
                }
                if (e1 instanceof HTMLElement) return e1;
                if (e1 && "object" == typeof e1 && 1 === e1.nodeType) return e1;
                throw new Error("Invalid type: 'container' must be a String or HTMLElement.");
            }
            _setupContainer() {
                const e1 = this._container;
                e1.classList.add("maplibregl-map");
                const t = this._canvasContainer = d.create("div", "maplibregl-canvas-container", e1);
                this._interactive && t.classList.add("maplibregl-interactive"), this._canvas = d.create("canvas", "maplibregl-canvas", t), this._canvas.addEventListener("webglcontextlost", this._contextLost, !1), this._canvas.addEventListener("webglcontextrestored", this._contextRestored, !1), this._canvas.setAttribute("tabindex", this._interactive ? "0" : "-1"), this._canvas.setAttribute("aria-label", this._getUIString("Map.Title")), this._canvas.setAttribute("role", "region");
                const i = this._containerDimensions(), o = this._getClampedPixelRatio(i[0], i[1]);
                this._resizeCanvas(i[0], i[1], o);
                const a = this._controlContainer = d.create("div", "maplibregl-control-container", e1), r = this._controlPositions = {};
                for (const e1 of [
                    "top-left",
                    "top-right",
                    "bottom-left",
                    "bottom-right"
                ])r[e1] = d.create("div", `maplibregl-ctrl-${e1} `, a);
                this._container.addEventListener("scroll", this._onMapScroll, !1);
            }
            _resizeCanvas(e1, t, i) {
                this._canvas.width = Math.floor(i * e1), this._canvas.height = Math.floor(i * t), this._canvas.style.width = `${e1}px`, this._canvas.style.height = `${t}px`;
            }
            _setupPainter() {
                const e1 = Object.assign(Object.assign({}, this._canvasContextAttributes), {
                    alpha: !0,
                    depth: !0,
                    stencil: !0,
                    premultipliedAlpha: !0
                });
                let t = null;
                this._canvas.addEventListener("webglcontextcreationerror", (i)=>{
                    t = {
                        requestedAttributes: e1
                    }, i && (t.statusMessage = i.statusMessage, t.type = i.type);
                }, {
                    once: !0
                });
                let i = null;
                if (i = this._canvasContextAttributes.contextType ? this._canvas.getContext(this._canvasContextAttributes.contextType, e1) : this._canvas.getContext("webgl2", e1) || this._canvas.getContext("webgl", e1), !i) {
                    const e1 = "Failed to initialize WebGL";
                    throw t ? (t.message = e1, new Error(JSON.stringify(t))) : new Error(e1);
                }
                this.painter = new Xa(i, this.transform);
            }
            migrateProjection(e1, i) {
                super.migrateProjection(e1, i), this.painter.transform = e1, this.fire(new t.n("projectiontransition", {
                    newProjection: this.style.projection.name
                }));
            }
            loaded() {
                return !this._styleDirty && !this._sourcesDirty && !!this.style && this.style.loaded();
            }
            _update(e1) {
                var t;
                return (null === (t = this.style) || void 0 === t ? void 0 : t._loaded) ? (this._styleDirty || (this._styleDirty = e1), this._sourcesDirty = !0, this.triggerRepaint(), this) : this;
            }
            _requestRenderFrame(e1) {
                return this._update(), this._renderTaskQueue.add(e1);
            }
            _cancelRenderFrame(e1) {
                this._renderTaskQueue.remove(e1);
            }
            _render(e1) {
                var i, o, a, r, s, n;
                const l = this._idleTriggered ? this._fadeDuration : 0, h = (null === (i = this.style.projection) || void 0 === i ? void 0 : i.transitionState) > 0;
                if (this.painter.context.setDirty(), this.painter.setBaseState(), this._renderTaskQueue.run(e1), this._removed) return;
                let u = !1;
                if (this.style && this._styleDirty) {
                    this._styleDirty = !1;
                    const e1 = this.transform.zoom, i = c();
                    this.style.zoomHistory.update(e1, i);
                    const o = new t.J(e1, {
                        now: i,
                        fadeDuration: l,
                        zoomHistory: this.style.zoomHistory,
                        transition: this.style.getTransition()
                    }), a = o.crossFadingFactor();
                    1 === a && a === this._crossFadingFactor || (u = !0, this._crossFadingFactor = a), this.style.update(o);
                }
                const d = (null === (o = this.style.projection) || void 0 === o ? void 0 : o.transitionState) > 0 !== h;
                null === (a = this.style.projection) || void 0 === a || a.setErrorQueryLatitudeDegrees(this.transform.center.lat), this.transform.setTransitionState(null === (r = this.style.projection) || void 0 === r ? void 0 : r.transitionState, null === (s = this.style.projection) || void 0 === s ? void 0 : s.latitudeErrorCorrectionRadians), this.style && (this._sourcesDirty || d) && (this._sourcesDirty = !1, this.style._updateSources(this.transform)), this.terrain ? (this.terrain.tileManager.update(this.transform, this.terrain), this.transform.setMinElevationForCurrentTile(this.terrain.getMinTileElevationForLngLatZoom(this.transform.center, this.transform.tileZoom)), !this._elevationFreeze && this._centerClampedToGround && this.transform.setElevation(this.terrain.getElevationForLngLatZoom(this.transform.center, this.transform.tileZoom))) : (this.transform.setMinElevationForCurrentTile(0), this._centerClampedToGround && this.transform.setElevation(0)), this._placementDirty = null === (n = this.style) || void 0 === n ? void 0 : n._updatePlacement(this.transform, this.showCollisionBoxes, l, this._crossSourceCollisions, d), this.painter.render(this.style, {
                    showTileBoundaries: this.showTileBoundaries,
                    showOverdrawInspector: this._showOverdrawInspector,
                    rotating: this.isRotating(),
                    zooming: this.isZooming(),
                    moving: this.isMoving(),
                    fadeDuration: l,
                    showPadding: this.showPadding,
                    anisotropicFilterPitch: this.getAnisotropicFilterPitch()
                }), this.fire(new t.n("render")), this.loaded() && !this._loaded && (this._loaded = !0, this.fire(new t.n("load"))), this.style && (this.style.hasTransitions() || u) && (this._styleDirty = !0), this.style && !this._placementDirty && this.style._releaseSymbolFadeTiles();
                const _ = this._sourcesDirty || this._styleDirty || this._placementDirty;
                return _ || this._repaint ? this.triggerRepaint() : !this.isMoving() && this.loaded() && this.fire(new t.n("idle")), !this._loaded || this._fullyLoaded || _ || (this._fullyLoaded = !0), this;
            }
            redraw() {
                return this.style && (this._frameRequest && (this._frameRequest.abort(), this._frameRequest = null), this._render(0)), this;
            }
            remove() {
                var e1, i;
                this._hash && this._hash.remove();
                for (const e1 of this._controls)e1.onRemove(this);
                this._controls = [], this._frameRequest && (this._frameRequest.abort(), this._frameRequest = null), this._renderTaskQueue.clear(), null === (e1 = this._diffStyleRequest) || void 0 === e1 || e1.abort(), this.painter.destroy(), this.handlers.destroy(), delete this.handlers, this.setStyle(null), "undefined" != typeof window && this._ownerWindow.removeEventListener("online", this._onWindowOnline, !1), u.removeThrottleControl(this._imageQueueHandle), null === (i = this._resizeObserver) || void 0 === i || i.disconnect();
                const o = this.painter.context.gl.getExtension("WEBGL_lose_context");
                (null == o ? void 0 : o.loseContext) && o.loseContext(), this._canvas.removeEventListener("webglcontextrestored", this._contextRestored, !1), this._canvas.removeEventListener("webglcontextlost", this._contextLost, !1), this._canvasContainer.remove(), this._controlContainer.remove(), this._container.removeEventListener("scroll", this._onMapScroll, !1), this._container.classList.remove("maplibregl-map"), this._removed = !0, this.fire(new t.n("remove"));
            }
            triggerRepaint() {
                this.style && !this._frameRequest && (this._frameRequest = new AbortController, n.frame(this._frameRequest, (e1)=>{
                    this._frameRequest = null;
                    try {
                        this._render(e1);
                    } catch (e1) {
                        if (!t.$(e1) && !function(e1) {
                            return e1.message === na;
                        }(e1)) throw e1;
                    }
                }, ()=>{}, this._ownerWindow));
            }
            get showTileBoundaries() {
                return !!this._showTileBoundaries;
            }
            set showTileBoundaries(e1) {
                this._showTileBoundaries !== e1 && (this._showTileBoundaries = e1, this._update());
            }
            get showPadding() {
                return !!this._showPadding;
            }
            set showPadding(e1) {
                this._showPadding !== e1 && (this._showPadding = e1, this._update());
            }
            get showCollisionBoxes() {
                return !!this._showCollisionBoxes;
            }
            set showCollisionBoxes(e1) {
                this._showCollisionBoxes !== e1 && (this._showCollisionBoxes = e1, e1 ? this.style._generateCollisionBoxes() : this._update());
            }
            get showOverdrawInspector() {
                return !!this._showOverdrawInspector;
            }
            set showOverdrawInspector(e1) {
                this._showOverdrawInspector !== e1 && (this._showOverdrawInspector = e1, this._update());
            }
            get repaint() {
                return !!this._repaint;
            }
            set repaint(e1) {
                this._repaint !== e1 && (this._repaint = e1, this.triggerRepaint());
            }
            get vertices() {
                return !!this._vertices;
            }
            set vertices(e1) {
                this._vertices = e1, this._update();
            }
            get version() {
                return hs;
            }
            getCameraTargetElevation() {
                return this.transform.elevation;
            }
            getProjection() {
                return this.style.getProjection();
            }
            setProjection(e1) {
                return this._lazyInitEmptyStyle(), this.style.setProjection(e1), this._update(!0);
            }
        };
        const _s = {
            showCompass: !0,
            showZoom: !0,
            visualizePitch: !1,
            visualizeRoll: !0
        };
        class ps {
            constructor(e1, i, o = !1){
                this.mousedown = (e1)=>{
                    this.startMove(e1, d.mousePos(this.element, e1)), window.addEventListener("mousemove", this.mousemove), window.addEventListener("mouseup", this.mouseup);
                }, this.mousemove = (e1)=>{
                    this.move(e1, d.mousePos(this.element, e1));
                }, this.mouseup = (e1)=>{
                    this._rotatePitchHandler.dragEnd(e1), this.offTemp();
                }, this.touchstart = (e1)=>{
                    1 !== e1.targetTouches.length ? this.reset() : (this._startPos = this._lastPos = d.touchPos(this.element, e1.targetTouches)[0], this.startMove(e1, this._startPos), window.addEventListener("touchmove", this.touchmove, {
                        passive: !1
                    }), window.addEventListener("touchend", this.touchend));
                }, this.touchmove = (e1)=>{
                    1 !== e1.targetTouches.length ? this.reset() : (this._lastPos = d.touchPos(this.element, e1.targetTouches)[0], this.move(e1, this._lastPos));
                }, this.touchend = (e1)=>{
                    0 === e1.targetTouches.length && this._startPos && this._lastPos && this._startPos.dist(this._lastPos) < this._clickTolerance && this.element.click(), delete this._startPos, delete this._lastPos, this.offTemp();
                }, this.reset = ()=>{
                    this._rotatePitchHandler.reset(), delete this._startPos, delete this._lastPos, this.offTemp();
                }, this._clickTolerance = 10, this.element = i;
                const a = new Pr;
                this._rotatePitchHandler = new vr({
                    clickTolerance: 3,
                    move: (e1, a)=>{
                        const r = i.getBoundingClientRect(), s = new t.P((r.bottom - r.top) / 2, (r.right - r.left) / 2);
                        return {
                            bearingDelta: t.cx(new t.P(e1.x, a.y), a, s),
                            pitchDelta: o ? -0.5 * (a.y - e1.y) : void 0
                        };
                    },
                    moveStateManager: a,
                    enable: !0,
                    assignEvents: ()=>{}
                }), this.map = e1, i.addEventListener("mousedown", this.mousedown), i.addEventListener("touchstart", this.touchstart, {
                    passive: !1
                }), i.addEventListener("touchcancel", this.reset);
            }
            startMove(e1, t) {
                this._rotatePitchHandler.dragStart(e1, t), d.disableDrag();
            }
            move(e1, t) {
                const i = this.map, { bearingDelta: o, pitchDelta: a } = this._rotatePitchHandler.dragMove(e1, t) || {};
                o && i.setBearing(i.getBearing() + o), a && i.setPitch(i.getPitch() + a);
            }
            off() {
                const e1 = this.element;
                e1.removeEventListener("mousedown", this.mousedown), e1.removeEventListener("touchstart", this.touchstart), window.removeEventListener("touchmove", this.touchmove), window.removeEventListener("touchend", this.touchend), e1.removeEventListener("touchcancel", this.reset), this.offTemp();
            }
            offTemp() {
                d.enableDrag(), window.removeEventListener("mousemove", this.mousemove), window.removeEventListener("mouseup", this.mouseup), window.removeEventListener("touchmove", this.touchmove), window.removeEventListener("touchend", this.touchend);
            }
        }
        let ms;
        function fs(e1, i, o, a = !1) {
            if (a || !o.getCoveringTilesDetailsProvider().allowWorldCopies()) return null == e1 ? void 0 : e1.wrap();
            const r = new t.W(e1.lng, e1.lat);
            if (e1 = new t.W(e1.lng, e1.lat), i) {
                const a = new t.W(e1.lng - 360, e1.lat), r = new t.W(e1.lng + 360, e1.lat), s = o.locationToScreenPoint(e1).distSqr(i);
                o.locationToScreenPoint(a).distSqr(i) < s ? e1 = a : o.locationToScreenPoint(r).distSqr(i) < s && (e1 = r);
            }
            for(; Math.abs(e1.lng - o.center.lng) > 180;){
                const t = o.locationToScreenPoint(e1);
                if (t.x >= 0 && t.y >= 0 && t.x <= o.width && t.y <= o.height) break;
                e1.lng > o.center.lng ? e1.lng -= 360 : e1.lng += 360;
            }
            return e1.lng !== r.lng && o.isPointOnMapSurface(o.locationToScreenPoint(e1)) ? e1 : r;
        }
        const gs = {
            center: "translate(-50%,-50%)",
            top: "translate(-50%,0)",
            "top-left": "translate(0,0)",
            "top-right": "translate(-100%,0)",
            bottom: "translate(-50%,-100%)",
            "bottom-left": "translate(0,-100%)",
            "bottom-right": "translate(-100%,-100%)",
            left: "translate(0,-50%)",
            right: "translate(-100%,-50%)"
        };
        function vs(e1, t, i) {
            const o = e1.classList;
            for(const e1 in gs)o.remove(`maplibregl-${i}-anchor-${e1}`);
            o.add(`maplibregl-${i}-anchor-${t}`);
        }
        class xs extends t.E {
            constructor(e1){
                if (super(), this._onClick = (e1)=>{
                    this.fire(new t.n("click", {
                        originalEvent: e1
                    }));
                }, this._onKeyPress = (e1)=>{
                    "Space" !== e1.code && "Enter" !== e1.code || this.togglePopup();
                }, this._onMapClick = (e1)=>{
                    const t = e1.originalEvent.target, i = this._element;
                    this._popup && (t === i || i.contains(t)) && this.togglePopup();
                }, this._update = (e1)=>{
                    if (!this._map) return;
                    const t = this._map.loaded() && !this._map.isMoving();
                    ("terrain" === (null == e1 ? void 0 : e1.type) || "render" === (null == e1 ? void 0 : e1.type) && !t) && this._map.once("render", this._update), this._lngLat = fs(this._lngLat, this._flatPos, this._map.transform), this._flatPos = this._pos = this._map.project(this._lngLat)._add(this._offset), this._map.terrain && (this._flatPos = this._map.transform.locationToScreenPoint(this._lngLat)._add(this._offset));
                    let i = "";
                    "viewport" === this._rotationAlignment || "auto" === this._rotationAlignment ? i = `rotateZ(${this._rotation}deg)` : "map" === this._rotationAlignment && (i = `rotateZ(${this._rotation - this._map.getBearing()}deg)`);
                    let o = "";
                    "viewport" === this._pitchAlignment || "auto" === this._pitchAlignment ? o = "rotateX(0deg)" : "map" === this._pitchAlignment && (o = `rotateX(${this._map.getPitch()}deg)`), this._subpixelPositioning || e1 && "moveend" !== e1.type || (this._pos = this._pos.round()), this._element.style.transform = `${gs[this._anchor]} translate(${this._pos.x}px, ${this._pos.y}px) ${o} ${i}`, n.frameAsync(new AbortController, this._map._ownerWindow).then(()=>{
                        this._updateOpacity("moveend" === (null == e1 ? void 0 : e1.type));
                    }).catch(()=>{});
                }, this._onMove = (e1)=>{
                    if (!this._isDragging) {
                        const t = this._clickTolerance || this._map._clickTolerance;
                        this._isDragging = e1.point.dist(this._pointerdownPos) >= t;
                    }
                    this._isDragging && (this._pos = e1.point.sub(this._positionDelta), this._lngLat = this._map.unproject(this._pos), this.setLngLat(this._lngLat), this._element.style.pointerEvents = "none", "pending" === this._state && (this._state = "active", this.fire(new t.n("dragstart"))), this.fire(new t.n("drag")));
                }, this._onUp = ()=>{
                    this._element.style.pointerEvents = "auto", this._positionDelta = null, this._pointerdownPos = null, this._isDragging = !1, this._map.off("mousemove", this._onMove), this._map.off("touchmove", this._onMove), "active" === this._state && this.fire(new t.n("dragend")), this._state = "inactive";
                }, this._addDragHandler = (e1)=>{
                    this._element.contains(e1.originalEvent.target) && (e1.preventDefault(), this._positionDelta = e1.point.sub(this._pos).add(this._offset), this._pointerdownPos = e1.point, this._state = "pending", this._map.on("mousemove", this._onMove), this._map.on("touchmove", this._onMove), this._map.once("mouseup", this._onUp), this._map.once("touchend", this._onUp));
                }, this._anchor = (null == e1 ? void 0 : e1.anchor) || "center", this._color = (null == e1 ? void 0 : e1.color) || "#3FB1CE", this._scale = (null == e1 ? void 0 : e1.scale) || 1, this._draggable = (null == e1 ? void 0 : e1.draggable) || !1, this._clickTolerance = (null == e1 ? void 0 : e1.clickTolerance) || 0, this._subpixelPositioning = (null == e1 ? void 0 : e1.subpixelPositioning) || !1, this._isDragging = !1, this._state = "inactive", this._rotation = (null == e1 ? void 0 : e1.rotation) || 0, this._rotationAlignment = (null == e1 ? void 0 : e1.rotationAlignment) || "auto", this._pitchAlignment = (null == e1 ? void 0 : e1.pitchAlignment) && "auto" !== e1.pitchAlignment ? e1.pitchAlignment : this._rotationAlignment, this.setOpacity(null == e1 ? void 0 : e1.opacity, null == e1 ? void 0 : e1.opacityWhenCovered), null == e1 ? void 0 : e1.element) this._element = e1.element, this._offset = t.P.convert((null == e1 ? void 0 : e1.offset) || [
                    0,
                    0
                ]);
                else {
                    this._defaultMarker = !0, this._element = d.create("div");
                    const i = d.createNS("http://www.w3.org/2000/svg", "svg"), o = 41, a = 27;
                    i.setAttributeNS(null, "display", "block"), i.setAttributeNS(null, "height", `${o}px`), i.setAttributeNS(null, "width", `${a}px`), i.setAttributeNS(null, "viewBox", `0 0 ${a} ${o}`);
                    const r = d.createNS("http://www.w3.org/2000/svg", "g");
                    r.setAttributeNS(null, "stroke", "none"), r.setAttributeNS(null, "stroke-width", "1"), r.setAttributeNS(null, "fill", "none"), r.setAttributeNS(null, "fill-rule", "evenodd");
                    const s = d.createNS("http://www.w3.org/2000/svg", "g");
                    s.setAttributeNS(null, "fill-rule", "nonzero");
                    const n = d.createNS("http://www.w3.org/2000/svg", "g");
                    n.setAttributeNS(null, "transform", "translate(3.0, 29.0)"), n.setAttributeNS(null, "fill", "#000000");
                    const l = [
                        {
                            rx: "10.5",
                            ry: "5.25002273"
                        },
                        {
                            rx: "10.5",
                            ry: "5.25002273"
                        },
                        {
                            rx: "9.5",
                            ry: "4.77275007"
                        },
                        {
                            rx: "8.5",
                            ry: "4.29549936"
                        },
                        {
                            rx: "7.5",
                            ry: "3.81822308"
                        },
                        {
                            rx: "6.5",
                            ry: "3.34094679"
                        },
                        {
                            rx: "5.5",
                            ry: "2.86367051"
                        },
                        {
                            rx: "4.5",
                            ry: "2.38636864"
                        }
                    ];
                    for (const e1 of l){
                        const t = d.createNS("http://www.w3.org/2000/svg", "ellipse");
                        t.setAttributeNS(null, "opacity", "0.04"), t.setAttributeNS(null, "cx", "10.5"), t.setAttributeNS(null, "cy", "5.80029008"), t.setAttributeNS(null, "rx", e1.rx), t.setAttributeNS(null, "ry", e1.ry), n.appendChild(t);
                    }
                    const c = d.createNS("http://www.w3.org/2000/svg", "g");
                    c.setAttributeNS(null, "fill", this._color);
                    const h = d.createNS("http://www.w3.org/2000/svg", "path");
                    h.setAttributeNS(null, "d", "M27,13.5 C27,19.074644 20.250001,27.000002 14.75,34.500002 C14.016665,35.500004 12.983335,35.500004 12.25,34.500002 C6.7499993,27.000002 0,19.222562 0,13.5 C0,6.0441559 6.0441559,0 13.5,0 C20.955844,0 27,6.0441559 27,13.5 Z"), c.appendChild(h);
                    const u = d.createNS("http://www.w3.org/2000/svg", "g");
                    u.setAttributeNS(null, "opacity", "0.25"), u.setAttributeNS(null, "fill", "#000000");
                    const _ = d.createNS("http://www.w3.org/2000/svg", "path");
                    _.setAttributeNS(null, "d", "M13.5,0 C6.0441559,0 0,6.0441559 0,13.5 C0,19.222562 6.7499993,27 12.25,34.5 C13,35.522727 14.016664,35.500004 14.75,34.5 C20.250001,27 27,19.074644 27,13.5 C27,6.0441559 20.955844,0 13.5,0 Z M13.5,1 C20.415404,1 26,6.584596 26,13.5 C26,15.898657 24.495584,19.181431 22.220703,22.738281 C19.945823,26.295132 16.705119,30.142167 13.943359,33.908203 C13.743445,34.180814 13.612715,34.322738 13.5,34.441406 C13.387285,34.322738 13.256555,34.180814 13.056641,33.908203 C10.284481,30.127985 7.4148684,26.314159 5.015625,22.773438 C2.6163816,19.232715 1,15.953538 1,13.5 C1,6.584596 6.584596,1 13.5,1 Z"), u.appendChild(_);
                    const p = d.createNS("http://www.w3.org/2000/svg", "g");
                    p.setAttributeNS(null, "transform", "translate(6.0, 7.0)"), p.setAttributeNS(null, "fill", "#FFFFFF");
                    const m = d.createNS("http://www.w3.org/2000/svg", "g");
                    m.setAttributeNS(null, "transform", "translate(8.0, 8.0)");
                    const f = d.createNS("http://www.w3.org/2000/svg", "circle");
                    f.setAttributeNS(null, "fill", "#000000"), f.setAttributeNS(null, "opacity", "0.25"), f.setAttributeNS(null, "cx", "5.5"), f.setAttributeNS(null, "cy", "5.5"), f.setAttributeNS(null, "r", "5.4999962");
                    const g = d.createNS("http://www.w3.org/2000/svg", "circle");
                    g.setAttributeNS(null, "fill", "#FFFFFF"), g.setAttributeNS(null, "cx", "5.5"), g.setAttributeNS(null, "cy", "5.5"), g.setAttributeNS(null, "r", "5.4999962"), m.appendChild(f), m.appendChild(g), s.appendChild(n), s.appendChild(c), s.appendChild(u), s.appendChild(p), s.appendChild(m), i.appendChild(s), i.setAttributeNS(null, "height", o * this._scale + "px"), i.setAttributeNS(null, "width", a * this._scale + "px"), this._element.appendChild(i), this._offset = t.P.convert((null == e1 ? void 0 : e1.offset) || [
                        0,
                        -14
                    ]);
                }
                if (this._element.classList.add("maplibregl-marker"), this._element.addEventListener("dragstart", (e1)=>{
                    e1.preventDefault();
                }), this._element.addEventListener("mousedown", (e1)=>{
                    e1.preventDefault();
                }), vs(this._element, this._anchor, "marker"), null == e1 ? void 0 : e1.className) for (const t of e1.className.split(" "))this._element.classList.add(t);
                this._popup = null;
            }
            addTo(e1) {
                return this.remove(), this._map = e1, this._element.hasAttribute("aria-label") || this._element.setAttribute("aria-label", e1._getUIString("Marker.Title")), this._element.hasAttribute("role") || this._element.setAttribute("role", "button"), e1.getCanvasContainer().appendChild(this._element), e1.on("move", this._update), e1.on("moveend", this._update), e1.on("terrain", this._update), e1.on("projectiontransition", this._update), this._element.addEventListener("click", this._onClick), this.setDraggable(this._draggable), this._update(), this._map.on("click", this._onMapClick), this;
            }
            remove() {
                return this._opacityTimeout && (clearTimeout(this._opacityTimeout), delete this._opacityTimeout), this._map && (this._map.off("click", this._onMapClick), this._map.off("move", this._update), this._map.off("moveend", this._update), this._map.off("terrain", this._update), this._map.off("projectiontransition", this._update), this._map.off("mousedown", this._addDragHandler), this._map.off("touchstart", this._addDragHandler), this._map.off("mouseup", this._onUp), this._map.off("touchend", this._onUp), this._map.off("mousemove", this._onMove), this._map.off("touchmove", this._onMove), delete this._map), this._element.removeEventListener("click", this._onClick), this._element.remove(), this._popup && this._popup.remove(), this;
            }
            getLngLat() {
                return this._lngLat;
            }
            setLngLat(e1) {
                return this._lngLat = t.W.convert(e1), this._pos = null, this._popup && this._popup.setLngLat(this._lngLat), this._update(), this;
            }
            getElement() {
                return this._element;
            }
            setPopup(e1) {
                if (this._popup && (this._popup.remove(), this._popup = null, this._element.removeEventListener("keypress", this._onKeyPress), this._originalTabIndex || this._element.removeAttribute("tabindex")), e1) {
                    if (!("offset" in e1.options)) {
                        const t = 38.1, i = 13.5, o = Math.abs(i) / Math.SQRT2;
                        e1.options.offset = this._defaultMarker ? {
                            top: [
                                0,
                                0
                            ],
                            "top-left": [
                                0,
                                0
                            ],
                            "top-right": [
                                0,
                                0
                            ],
                            bottom: [
                                0,
                                -t
                            ],
                            "bottom-left": [
                                o,
                                -1 * (t - i + o)
                            ],
                            "bottom-right": [
                                -o,
                                -1 * (t - i + o)
                            ],
                            left: [
                                i,
                                -1 * (t - i)
                            ],
                            right: [
                                -i,
                                -1 * (t - i)
                            ]
                        } : this._offset;
                    }
                    this._popup = e1, this._originalTabIndex = this._element.getAttribute("tabindex"), this._originalTabIndex || this._element.setAttribute("tabindex", "0"), this._element.addEventListener("keypress", this._onKeyPress);
                }
                return this;
            }
            setSubpixelPositioning(e1) {
                return this._subpixelPositioning = e1, this;
            }
            getPopup() {
                return this._popup;
            }
            togglePopup() {
                const e1 = this._popup;
                return this._element.style.opacity === this._opacityWhenCovered ? this : e1 ? (e1.isOpen() ? e1.remove() : (e1.setLngLat(this._lngLat), e1.addTo(this._map)), this) : this;
            }
            _updateOpacity(e1 = !1) {
                var i, o;
                const a = null === (i = this._map) || void 0 === i ? void 0 : i.terrain, r = this._map.transform.isLocationOccluded(this._lngLat);
                if (!a || r) {
                    const e1 = r ? this._opacityWhenCovered : this._opacity;
                    return void (this._element.style.opacity !== e1 && (this._element.style.opacity = e1, this._element.classList.toggle("maplibregl-marker-covered", r)));
                }
                if (e1) this._opacityTimeout = null;
                else {
                    if (this._opacityTimeout) return;
                    this._opacityTimeout = setTimeout(()=>{
                        this._opacityTimeout = null;
                    }, 100);
                }
                const s = this._map, n = s.terrain.depthAtPoint(this._pos), l = s.terrain.getElevationForLngLat(this._lngLat, s.transform);
                if (s.transform.lngLatToCameraDepth(this._lngLat, l) - n < .006) return this._element.style.opacity = this._opacity, void this._element.classList.remove("maplibregl-marker-covered");
                const c = -this._offset.y / s.transform.pixelsPerMeter, h = Math.sin(s.getPitch() * Math.PI / 180) * c, u = s.terrain.depthAtPoint(new t.P(this._pos.x, this._pos.y - this._offset.y)), d = s.transform.lngLatToCameraDepth(this._lngLat, l + h) - u > .006;
                (null === (o = this._popup) || void 0 === o ? void 0 : o.isOpen()) && d && this._popup.remove(), this._element.style.opacity = d ? this._opacityWhenCovered : this._opacity, this._element.classList.toggle("maplibregl-marker-covered", d);
            }
            getOffset() {
                return this._offset;
            }
            setOffset(e1) {
                return this._offset = t.P.convert(e1), this._update(), this;
            }
            addClassName(e1) {
                this._element.classList.add(e1);
            }
            removeClassName(e1) {
                this._element.classList.remove(e1);
            }
            toggleClassName(e1) {
                return this._element.classList.toggle(e1);
            }
            setDraggable(e1) {
                return this._draggable = !!e1, this._map && (e1 ? (this._map.on("mousedown", this._addDragHandler), this._map.on("touchstart", this._addDragHandler)) : (this._map.off("mousedown", this._addDragHandler), this._map.off("touchstart", this._addDragHandler))), this;
            }
            isDraggable() {
                return this._draggable;
            }
            setRotation(e1) {
                return this._rotation = e1 || 0, this._update(), this;
            }
            getRotation() {
                return this._rotation;
            }
            setRotationAlignment(e1) {
                return this._rotationAlignment = e1 || "auto", this._update(), this;
            }
            getRotationAlignment() {
                return this._rotationAlignment;
            }
            setPitchAlignment(e1) {
                return this._pitchAlignment = e1 && "auto" !== e1 ? e1 : this._rotationAlignment, this._update(), this;
            }
            getPitchAlignment() {
                return this._pitchAlignment;
            }
            setOpacity(e1, t) {
                return (void 0 === this._opacity || void 0 === e1 && void 0 === t) && (this._opacity = "1", this._opacityWhenCovered = "0.2"), void 0 !== e1 && (this._opacity = String(e1)), void 0 !== t && (this._opacityWhenCovered = String(t)), this._map && this._updateOpacity(!0), this;
            }
        }
        const bs = {
            positionOptions: {
                enableHighAccuracy: !1,
                maximumAge: 0,
                timeout: 6e3
            },
            fitBoundsOptions: {
                maxZoom: 15
            },
            trackUserLocation: !1,
            showAccuracyCircle: !0,
            showUserLocation: !0
        };
        let ys = 0, ws = !1;
        const Ts = {
            maxWidth: 100,
            unit: "metric"
        };
        function Ps(e1, t, i) {
            const o = (null == i ? void 0 : i.maxWidth) || 100, a = e1._container.clientHeight / 2, r = e1._container.clientWidth / 2, s = e1.unproject([
                r - o / 2,
                a
            ]), n = e1.unproject([
                r + o / 2,
                a
            ]), l = Math.round(e1.project(n).x - e1.project(s).x), c = Math.min(o, l, e1._container.clientWidth), h = s.distanceTo(n);
            if ("imperial" === (null == i ? void 0 : i.unit)) {
                const i = 3.2808 * h;
                i > 5280 ? Cs(t, c, i / 5280, e1._getUIString("ScaleControl.Miles")) : Cs(t, c, i, e1._getUIString("ScaleControl.Feet"));
            } else "nautical" === (null == i ? void 0 : i.unit) ? Cs(t, c, h / 1852, e1._getUIString("ScaleControl.NauticalMiles")) : h >= 1e3 ? Cs(t, c, h / 1e3, e1._getUIString("ScaleControl.Kilometers")) : Cs(t, c, h, e1._getUIString("ScaleControl.Meters"));
        }
        function Cs(e1, t, i, o) {
            const a = function(e1) {
                const t = Math.pow(10, `${Math.floor(e1)}`.length - 1);
                let i = e1 / t;
                return i = i >= 10 ? 10 : i >= 5 ? 5 : i >= 3 ? 3 : i >= 2 ? 2 : i >= 1 ? 1 : function(e1) {
                    const t = Math.pow(10, Math.ceil(-Math.log(e1) / Math.LN10));
                    return Math.round(e1 * t) / t;
                }(i), t * i;
            }(i);
            e1.style.width = t * (a / i) + "px", e1.innerHTML = `${a}&nbsp;${o}`;
        }
        const Ms = {
            closeButton: !0,
            closeOnClick: !0,
            focusAfterOpen: !0,
            className: "",
            maxWidth: "240px",
            subpixelPositioning: !1,
            locationOccludedOpacity: void 0,
            padding: void 0
        }, Is = [
            "a[href]",
            "[tabindex]:not([tabindex='-1'])",
            "[contenteditable]:not([contenteditable='false'])",
            "button:not([disabled])",
            "input:not([disabled])",
            "select:not([disabled])",
            "textarea:not([disabled])"
        ].join(", ");
        function Es(e1) {
            if (e1) {
                if ("number" == typeof e1) {
                    const i = Math.round(Math.abs(e1) / Math.SQRT2);
                    return {
                        center: new t.P(0, 0),
                        top: new t.P(0, e1),
                        "top-left": new t.P(i, i),
                        "top-right": new t.P(-i, i),
                        bottom: new t.P(0, -e1),
                        "bottom-left": new t.P(i, -i),
                        "bottom-right": new t.P(-i, -i),
                        left: new t.P(e1, 0),
                        right: new t.P(-e1, 0)
                    };
                }
                if (e1 instanceof t.P || Array.isArray(e1)) {
                    const i = t.P.convert(e1);
                    return {
                        center: i,
                        top: i,
                        "top-left": i,
                        "top-right": i,
                        bottom: i,
                        "bottom-left": i,
                        "bottom-right": i,
                        left: i,
                        right: i
                    };
                }
                return {
                    center: t.P.convert(e1.center || [
                        0,
                        0
                    ]),
                    top: t.P.convert(e1.top || [
                        0,
                        0
                    ]),
                    "top-left": t.P.convert(e1["top-left"] || [
                        0,
                        0
                    ]),
                    "top-right": t.P.convert(e1["top-right"] || [
                        0,
                        0
                    ]),
                    bottom: t.P.convert(e1.bottom || [
                        0,
                        0
                    ]),
                    "bottom-left": t.P.convert(e1["bottom-left"] || [
                        0,
                        0
                    ]),
                    "bottom-right": t.P.convert(e1["bottom-right"] || [
                        0,
                        0
                    ]),
                    left: t.P.convert(e1.left || [
                        0,
                        0
                    ]),
                    right: t.P.convert(e1.right || [
                        0,
                        0
                    ])
                };
            }
            return Es(new t.P(0, 0));
        }
        const Ss = i;
        e1.AJAXError = t.cG, e1.EXTENT = t.a6, e1.Event = t.n, e1.Evented = t.E, e1.LngLat = t.W, e1.MercatorCoordinate = t.a7, e1.Point = t.P, e1.addProtocol = t.cH, e1.config = t.c, e1.removeProtocol = t.cI, e1.AttributionControl = es, e1.BoxZoomHandler = _r, e1.CanvasSource = oe, e1.CooperativeGesturesHandler = $r, e1.DoubleClickZoomHandler = Zr, e1.DragPanHandler = Vr, e1.DragRotateHandler = Wr, e1.EdgeInsets = Ut, e1.FullscreenControl = class extends t.E {
            constructor(e1 = {}){
                var i;
                super(), this._onFullscreenChange = ()=>{
                    var e1;
                    let t = window.document.fullscreenElement || window.document.webkitFullscreenElement;
                    for(; null === (e1 = null == t ? void 0 : t.shadowRoot) || void 0 === e1 ? void 0 : e1.fullscreenElement;)t = t.shadowRoot.fullscreenElement;
                    t === this._container !== this._fullscreen && this._handleFullscreenChange();
                }, this._onClickFullscreen = ()=>{
                    this._isFullscreen() ? this._exitFullscreen() : this._requestFullscreen();
                }, this._fullscreen = !1, this._pseudo = null !== (i = e1.pseudo) && void 0 !== i && i, (null == e1 ? void 0 : e1.container) && (e1.container instanceof HTMLElement ? this._container = e1.container : t.w("Full screen control 'container' must be a DOM element.")), "onfullscreenchange" in document ? this._fullscreenchange = "fullscreenchange" : "onmozfullscreenchange" in document ? this._fullscreenchange = "mozfullscreenchange" : "onwebkitfullscreenchange" in document ? this._fullscreenchange = "webkitfullscreenchange" : "onmsfullscreenchange" in document && (this._fullscreenchange = "MSFullscreenChange");
            }
            onAdd(e1) {
                return this._map = e1, this._container || (this._container = this._map.getContainer()), this._controlContainer = d.create("div", "maplibregl-ctrl maplibregl-ctrl-group"), this._setupUI(), this._controlContainer;
            }
            onRemove() {
                this._controlContainer.remove(), this._map = null, window.document.removeEventListener(this._fullscreenchange, this._onFullscreenChange);
            }
            _setupUI() {
                const e1 = this._fullscreenButton = d.create("button", "maplibregl-ctrl-fullscreen", this._controlContainer);
                d.create("span", "maplibregl-ctrl-icon", e1).setAttribute("aria-hidden", "true"), e1.type = "button", this._updateTitle(), this._fullscreenButton.addEventListener("click", this._onClickFullscreen), window.document.addEventListener(this._fullscreenchange, this._onFullscreenChange);
            }
            _updateTitle() {
                const e1 = this._getTitle();
                this._fullscreenButton.setAttribute("aria-label", e1), this._fullscreenButton.title = e1;
            }
            _getTitle() {
                return this._map._getUIString(this._isFullscreen() ? "FullscreenControl.Exit" : "FullscreenControl.Enter");
            }
            _isFullscreen() {
                return this._fullscreen;
            }
            _handleFullscreenChange() {
                this._fullscreen = !this._fullscreen, this._fullscreenButton.classList.toggle("maplibregl-ctrl-shrink"), this._fullscreenButton.classList.toggle("maplibregl-ctrl-fullscreen"), this._updateTitle(), this._fullscreen ? (this.fire(new t.n("fullscreenstart")), this._prevCooperativeGesturesEnabled = this._map.cooperativeGestures.isEnabled(), this._map.cooperativeGestures.disable()) : (this.fire(new t.n("fullscreenend")), this._prevCooperativeGesturesEnabled && this._map.cooperativeGestures.enable());
            }
            _exitFullscreen() {
                this._pseudo ? this._togglePseudoFullScreen() : window.document.exitFullscreen ? window.document.exitFullscreen() : window.document.webkitCancelFullScreen ? window.document.webkitCancelFullScreen() : this._togglePseudoFullScreen();
            }
            _requestFullscreen() {
                this._pseudo ? this._togglePseudoFullScreen() : this._container.requestFullscreen ? this._container.requestFullscreen() : this._container.webkitRequestFullscreen ? this._container.webkitRequestFullscreen() : this._togglePseudoFullScreen();
            }
            _togglePseudoFullScreen() {
                this._container.classList.toggle("maplibregl-pseudo-fullscreen"), this._handleFullscreenChange(), this._map.resize();
            }
        }, e1.GeoJSONSource = ee, e1.GeolocateControl = class extends t.E {
            constructor(e1){
                super(), this._onSuccess = (e1)=>{
                    if (this._map) {
                        if (this._isOutOfMapMaxBounds(e1)) return this._setErrorState(), this.fire(new t.n("outofmaxbounds", e1)), this._updateMarker(), void this._finish();
                        if (this.options.trackUserLocation) switch(this._lastKnownPosition = e1, this._watchState){
                            case "WAITING_ACTIVE":
                            case "ACTIVE_LOCK":
                            case "ACTIVE_ERROR":
                                this._watchState = "ACTIVE_LOCK", this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-waiting"), this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-active-error"), this._geolocateButton.classList.add("maplibregl-ctrl-geolocate-active");
                                break;
                            case "BACKGROUND":
                            case "BACKGROUND_ERROR":
                                this._watchState = "BACKGROUND", this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-waiting"), this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-background-error"), this._geolocateButton.classList.add("maplibregl-ctrl-geolocate-background");
                                break;
                            default:
                                throw new Error(`Unexpected watchState ${this._watchState}`);
                        }
                        this.options.showUserLocation && "OFF" !== this._watchState && this._updateMarker(e1), this.options.trackUserLocation && "ACTIVE_LOCK" !== this._watchState || this._updateCamera(e1), this.options.showUserLocation && this._dotElement.classList.remove("maplibregl-user-location-dot-stale"), this.fire(new t.n("geolocate", e1)), this._finish();
                    }
                }, this._updateCamera = (e1)=>{
                    const i = new t.W(e1.coords.longitude, e1.coords.latitude), o = e1.coords.accuracy, a = this._map.getBearing(), r = t.e({
                        bearing: a
                    }, this.options.fitBoundsOptions), s = G.fromLngLat(i, o);
                    this._map.fitBounds(s, r, {
                        geolocateSource: !0
                    });
                }, this._updateMarker = (e1)=>{
                    if (e1) {
                        const i = new t.W(e1.coords.longitude, e1.coords.latitude);
                        this._accuracyCircleMarker.setLngLat(i).addTo(this._map), this._userLocationDotMarker.setLngLat(i).addTo(this._map), this._accuracy = e1.coords.accuracy, this._updateCircleRadiusIfNeeded();
                    } else this._userLocationDotMarker.remove(), this._accuracyCircleMarker.remove();
                }, this._onUpdate = ()=>{
                    this._updateCircleRadiusIfNeeded();
                }, this._onError = (e1)=>{
                    if (this._map) {
                        if (1 === e1.code) {
                            this._watchState = "OFF", this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-waiting"), this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-active"), this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-active-error"), this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-background"), this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-background-error"), this._geolocateButton.disabled = !0;
                            const e1 = this._map._getUIString("GeolocateControl.LocationNotAvailable");
                            this._geolocateButton.title = e1, this._geolocateButton.setAttribute("aria-label", e1), void 0 !== this._geolocationWatchID && this._clearWatch();
                        } else {
                            if (3 === e1.code && ws) return;
                            this._setErrorState();
                        }
                        "OFF" !== this._watchState && this.options.showUserLocation && this._dotElement.classList.add("maplibregl-user-location-dot-stale"), this.fire(new t.n("error", e1)), this._finish();
                    }
                }, this._finish = ()=>{
                    this._timeoutId && clearTimeout(this._timeoutId), this._timeoutId = void 0;
                }, this._onMoveStart = (e1)=>{
                    if (!this._map) return;
                    const i = (null == e1 ? void 0 : e1[0]) instanceof ResizeObserverEntry;
                    e1.geolocateSource || "ACTIVE_LOCK" !== this._watchState || i || this._map.isZooming() || (this._watchState = "BACKGROUND", this._geolocateButton.classList.add("maplibregl-ctrl-geolocate-background"), this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-active"), this.fire(new t.n("trackuserlocationend")), this.fire(new t.n("userlocationlostfocus")));
                }, this._setupUI = ()=>{
                    this._map && (this._container.addEventListener("contextmenu", (e1)=>{
                        e1.preventDefault();
                    }), this._geolocateButton = d.create("button", "maplibregl-ctrl-geolocate", this._container), d.create("span", "maplibregl-ctrl-icon", this._geolocateButton).setAttribute("aria-hidden", "true"), this._geolocateButton.type = "button", this._geolocateButton.disabled = !0);
                }, this._finishSetupUI = (e1)=>{
                    if (this._map) {
                        if (!1 === e1) {
                            t.w("Geolocation support is not available so the GeolocateControl will be disabled.");
                            const e1 = this._map._getUIString("GeolocateControl.LocationNotAvailable");
                            this._geolocateButton.disabled = !0, this._geolocateButton.title = e1, this._geolocateButton.setAttribute("aria-label", e1);
                        } else {
                            const e1 = this._map._getUIString("GeolocateControl.FindMyLocation");
                            this._geolocateButton.disabled = !1, this._geolocateButton.title = e1, this._geolocateButton.setAttribute("aria-label", e1);
                        }
                        this.options.trackUserLocation && (this._geolocateButton.setAttribute("aria-pressed", "false"), this._watchState = "OFF"), this.options.showUserLocation && (this._dotElement = d.create("div", "maplibregl-user-location-dot"), this._userLocationDotMarker = new xs({
                            element: this._dotElement
                        }), this._circleElement = d.create("div", "maplibregl-user-location-accuracy-circle"), this._accuracyCircleMarker = new xs({
                            element: this._circleElement,
                            pitchAlignment: "map"
                        }), this.options.trackUserLocation && (this._watchState = "OFF"), this._map.on("zoom", this._onUpdate), this._map.on("move", this._onUpdate), this._map.on("rotate", this._onUpdate), this._map.on("pitch", this._onUpdate)), this._geolocateButton.addEventListener("click", ()=>this.trigger()), this._setup = !0, this.options.trackUserLocation && this._map.on("movestart", this._onMoveStart);
                    }
                }, this.options = t.e({}, bs, e1);
            }
            onAdd(e1) {
                return this._map = e1, this._container = d.create("div", "maplibregl-ctrl maplibregl-ctrl-group"), this._setupUI(), (function() {
                    return t._(this, arguments, void 0, function*(e1 = !1) {
                        if (void 0 !== ms && !e1) return ms;
                        if (void 0 === window.navigator.permissions) return ms = !!window.navigator.geolocation, ms;
                        try {
                            const e1 = yield window.navigator.permissions.query({
                                name: "geolocation"
                            });
                            ms = "denied" !== e1.state;
                        } catch (e1) {
                            ms = !!window.navigator.geolocation;
                        }
                        return ms;
                    });
                })().then((e1)=>this._finishSetupUI(e1)), this._container;
            }
            onRemove() {
                void 0 !== this._geolocationWatchID && (window.navigator.geolocation.clearWatch(this._geolocationWatchID), this._geolocationWatchID = void 0), this.options.showUserLocation && this._userLocationDotMarker && this._userLocationDotMarker.remove(), this.options.showAccuracyCircle && this._accuracyCircleMarker && this._accuracyCircleMarker.remove(), this._container.remove(), this._map.off("movestart", this._onMoveStart), this._map.off("zoom", this._onUpdate), this._map.off("move", this._onUpdate), this._map.off("rotate", this._onUpdate), this._map.off("pitch", this._onUpdate), this._map = void 0, ys = 0, ws = !1;
            }
            _isOutOfMapMaxBounds(e1) {
                const t = this._map.getMaxBounds(), i = e1.coords;
                return t && (i.longitude < t.getWest() || i.longitude > t.getEast() || i.latitude < t.getSouth() || i.latitude > t.getNorth());
            }
            _setErrorState() {
                switch(this._watchState){
                    case "WAITING_ACTIVE":
                        this._watchState = "ACTIVE_ERROR", this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-active"), this._geolocateButton.classList.add("maplibregl-ctrl-geolocate-active-error");
                        break;
                    case "ACTIVE_LOCK":
                        this._watchState = "ACTIVE_ERROR", this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-active"), this._geolocateButton.classList.add("maplibregl-ctrl-geolocate-active-error"), this._geolocateButton.classList.add("maplibregl-ctrl-geolocate-waiting");
                        break;
                    case "BACKGROUND":
                        this._watchState = "BACKGROUND_ERROR", this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-background"), this._geolocateButton.classList.add("maplibregl-ctrl-geolocate-background-error"), this._geolocateButton.classList.add("maplibregl-ctrl-geolocate-waiting");
                        break;
                    case "ACTIVE_ERROR":
                    case "BACKGROUND_ERROR":
                    case "OFF":
                    case void 0:
                        break;
                    default:
                        throw new Error(`Unexpected watchState ${this._watchState}`);
                }
            }
            _updateCircleRadiusIfNeeded() {
                const e1 = this._userLocationDotMarker.getLngLat();
                if (!(this.options.showUserLocation && this.options.showAccuracyCircle && this._accuracy && e1)) return;
                const t = this._map.project(e1), i = this._map.unproject([
                    t.x + 100,
                    t.y
                ]), o = e1.distanceTo(i) / 100, a = 2 * this._accuracy / o;
                this._circleElement.style.width = `${a.toFixed(2)}px`, this._circleElement.style.height = `${a.toFixed(2)}px`;
            }
            trigger() {
                if (!this._setup) return t.w("Geolocate control triggered before added to a map"), !1;
                if (this.options.trackUserLocation) {
                    switch(this._watchState){
                        case "OFF":
                            this._watchState = "WAITING_ACTIVE", this.fire(new t.n("trackuserlocationstart"));
                            break;
                        case "WAITING_ACTIVE":
                        case "ACTIVE_LOCK":
                        case "ACTIVE_ERROR":
                        case "BACKGROUND_ERROR":
                            ys--, ws = !1, this._watchState = "OFF", this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-waiting"), this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-active"), this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-active-error"), this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-background"), this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-background-error"), this.fire(new t.n("trackuserlocationend"));
                            break;
                        case "BACKGROUND":
                            this._watchState = "ACTIVE_LOCK", this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-background"), this._lastKnownPosition && this._updateCamera(this._lastKnownPosition), this.fire(new t.n("trackuserlocationstart")), this.fire(new t.n("userlocationfocus"));
                            break;
                        default:
                            throw new Error(`Unexpected watchState ${this._watchState}`);
                    }
                    switch(this._watchState){
                        case "WAITING_ACTIVE":
                            this._geolocateButton.classList.add("maplibregl-ctrl-geolocate-waiting"), this._geolocateButton.classList.add("maplibregl-ctrl-geolocate-active");
                            break;
                        case "ACTIVE_LOCK":
                            this._geolocateButton.classList.add("maplibregl-ctrl-geolocate-active");
                            break;
                        case "OFF":
                            break;
                        default:
                            throw new Error(`Unexpected watchState ${this._watchState}`);
                    }
                    if ("OFF" === this._watchState && void 0 !== this._geolocationWatchID) this._clearWatch();
                    else if (void 0 === this._geolocationWatchID) {
                        let e1;
                        this._geolocateButton.classList.add("maplibregl-ctrl-geolocate-waiting"), this._geolocateButton.setAttribute("aria-pressed", "true"), ys++, ys > 1 ? (e1 = {
                            maximumAge: 6e5,
                            timeout: 0
                        }, ws = !0) : (e1 = this.options.positionOptions, ws = !1), this._geolocationWatchID = window.navigator.geolocation.watchPosition(this._onSuccess, this._onError, e1);
                    }
                } else window.navigator.geolocation.getCurrentPosition(this._onSuccess, this._onError, this.options.positionOptions), this._timeoutId = setTimeout(this._finish, 1e4);
                return !0;
            }
            _clearWatch() {
                window.navigator.geolocation.clearWatch(this._geolocationWatchID), this._geolocationWatchID = void 0, this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-waiting"), this._geolocateButton.setAttribute("aria-pressed", "false"), this.options.showUserLocation && this._updateMarker(null);
            }
        }, e1.GlobeControl = class {
            constructor(){
                this._toggleProjection = ()=>{
                    var e1;
                    const t = null === (e1 = this._map.getProjection()) || void 0 === e1 ? void 0 : e1.type;
                    this._map.setProjection("mercator" !== t && t ? {
                        type: "mercator"
                    } : {
                        type: "globe"
                    }), this._updateGlobeIcon();
                }, this._updateGlobeIcon = ()=>{
                    var e1;
                    this._globeButton.classList.remove("maplibregl-ctrl-globe"), this._globeButton.classList.remove("maplibregl-ctrl-globe-enabled"), "globe" === (null === (e1 = this._map.getProjection()) || void 0 === e1 ? void 0 : e1.type) ? (this._globeButton.classList.add("maplibregl-ctrl-globe-enabled"), this._globeButton.title = this._map._getUIString("GlobeControl.Disable")) : (this._globeButton.classList.add("maplibregl-ctrl-globe"), this._globeButton.title = this._map._getUIString("GlobeControl.Enable"));
                };
            }
            onAdd(e1) {
                return this._map = e1, this._container = d.create("div", "maplibregl-ctrl maplibregl-ctrl-group"), this._globeButton = d.create("button", "maplibregl-ctrl-globe", this._container), d.create("span", "maplibregl-ctrl-icon", this._globeButton).setAttribute("aria-hidden", "true"), this._globeButton.type = "button", this._globeButton.addEventListener("click", this._toggleProjection), this._updateGlobeIcon(), this._map.on("styledata", this._updateGlobeIcon), this._map.on("projectiontransition", this._updateGlobeIcon), this._container;
            }
            onRemove() {
                this._container.remove(), this._map.off("styledata", this._updateGlobeIcon), this._map.off("projectiontransition", this._updateGlobeIcon), this._globeButton.removeEventListener("click", this._toggleProjection), this._map = void 0;
            }
        }, e1.Hash = Ya, e1.ImageSource = te, e1.KeyboardHandler = kr, e1.LngLatBounds = G, e1.LogoControl = ts, e1.Map = ds, e1.MapLibreMap = ds, e1.MapMouseEvent = nr, e1.MapTouchEvent = lr, e1.MapWheelEvent = cr, e1.Marker = xs, e1.NavigationControl = class {
            constructor(e1){
                this._updateZoomButtons = ()=>{
                    const e1 = this._map.getZoom(), t = e1 === this._map.getMaxZoom(), i = e1 === this._map.getMinZoom();
                    this._zoomInButton.disabled = t, this._zoomOutButton.disabled = i, this._zoomInButton.setAttribute("aria-disabled", t.toString()), this._zoomOutButton.setAttribute("aria-disabled", i.toString());
                }, this._rotateCompassArrow = ()=>{
                    this._compassIcon.style.transform = this.options.visualizePitch && this.options.visualizeRoll ? `scale(${1 / Math.pow(Math.cos(this._map.transform.pitchInRadians), .5)}) rotateZ(${-this._map.transform.roll}deg) rotateX(${this._map.transform.pitch}deg) rotateZ(${-this._map.transform.bearing}deg)` : this.options.visualizePitch ? `scale(${1 / Math.pow(Math.cos(this._map.transform.pitchInRadians), .5)}) rotateX(${this._map.transform.pitch}deg) rotateZ(${-this._map.transform.bearing}deg)` : this.options.visualizeRoll ? `rotate(${-this._map.transform.bearing - this._map.transform.roll}deg)` : `rotate(${-this._map.transform.bearing}deg)`;
                }, this._setButtonTitle = (e1, t)=>{
                    const i = this._map._getUIString(`NavigationControl.${t}`);
                    e1.title = i, e1.setAttribute("aria-label", i);
                }, this.options = t.e({}, _s, e1), this._container = d.create("div", "maplibregl-ctrl maplibregl-ctrl-group"), this._container.addEventListener("contextmenu", (e1)=>e1.preventDefault()), this.options.showZoom && (this._zoomInButton = this._createButton("maplibregl-ctrl-zoom-in", (e1)=>this._map.zoomIn({}, {
                        originalEvent: e1
                    })), d.create("span", "maplibregl-ctrl-icon", this._zoomInButton).setAttribute("aria-hidden", "true"), this._zoomOutButton = this._createButton("maplibregl-ctrl-zoom-out", (e1)=>this._map.zoomOut({}, {
                        originalEvent: e1
                    })), d.create("span", "maplibregl-ctrl-icon", this._zoomOutButton).setAttribute("aria-hidden", "true")), this.options.showCompass && (this._compass = this._createButton("maplibregl-ctrl-compass", (e1)=>{
                    this.options.visualizePitch ? this._map.resetNorthPitch({}, {
                        originalEvent: e1
                    }) : this._map.resetNorth({}, {
                        originalEvent: e1
                    });
                }), this._compassIcon = d.create("span", "maplibregl-ctrl-icon", this._compass), this._compassIcon.setAttribute("aria-hidden", "true"));
            }
            onAdd(e1) {
                return this._map = e1, this.options.showZoom && (this._setButtonTitle(this._zoomInButton, "ZoomIn"), this._setButtonTitle(this._zoomOutButton, "ZoomOut"), this._map.on("zoom", this._updateZoomButtons), this._updateZoomButtons()), this.options.showCompass && (this._setButtonTitle(this._compass, "ResetBearing"), this.options.visualizePitch && this._map.on("pitch", this._rotateCompassArrow), this.options.visualizeRoll && this._map.on("roll", this._rotateCompassArrow), this._map.on("rotate", this._rotateCompassArrow), this._rotateCompassArrow(), this._handler = new ps(this._map, this._compass, this.options.visualizePitch)), this._container;
            }
            onRemove() {
                this._container.remove(), this.options.showZoom && this._map.off("zoom", this._updateZoomButtons), this.options.showCompass && (this.options.visualizePitch && this._map.off("pitch", this._rotateCompassArrow), this.options.visualizeRoll && this._map.off("roll", this._rotateCompassArrow), this._map.off("rotate", this._rotateCompassArrow), this._handler.off(), delete this._handler), delete this._map;
            }
            _createButton(e1, t) {
                const i = d.create("button", e1, this._container);
                return i.type = "button", i.addEventListener("click", t), i;
            }
        }, e1.Popup = class extends t.E {
            constructor(e1){
                super(), this._updateOpacity = ()=>{
                    void 0 !== this.options.locationOccludedOpacity && (this._container.style.opacity = this._map.transform.isLocationOccluded(this.getLngLat()) ? `${this.options.locationOccludedOpacity}` : "");
                }, this.remove = ()=>(this._content && this._content.remove(), this._container && (this._container.remove(), delete this._container), this._map && (this._map.off("move", this._update), this._map.off("move", this._onClose), this._map.off("click", this._onClose), this._map.off("remove", this.remove), this._map.off("terrain", this._update), this._map.off("projectiontransition", this._update), this._map.off("mousemove", this._update), this._map.off("mouseup", this._update), this._map.off("drag", this._update), this._map._canvasContainer.classList.remove("maplibregl-track-pointer"), delete this._map, this.fire(new t.n("close"))), this), this._update = (e1)=>{
                    if (!this._map || !this._lngLat && !this._trackPointer || !this._content) return;
                    if (!this._container) {
                        if (this._container = d.create("div", "maplibregl-popup", this._map.getContainer()), this._tip = d.create("div", "maplibregl-popup-tip", this._container), this._container.appendChild(this._content), this.options.className) for (const e1 of this.options.className.split(" "))this._container.classList.add(e1);
                        this._closeButton && this._closeButton.setAttribute("aria-label", this._map._getUIString("Popup.Close")), this._trackPointer && this._container.classList.add("maplibregl-popup-track-pointer");
                    }
                    let t;
                    if (this.options.maxWidth && this._container.style.maxWidth !== this.options.maxWidth && (this._container.style.maxWidth = this.options.maxWidth), this._lngLat = fs(this._lngLat, this._flatPos, this._map.transform, this._trackPointer), e1 && "point" in e1 && e1.point && (t = e1.point), this._trackPointer && !t) return;
                    const i = this._flatPos = this._pos = this._trackPointer && t ? t : this._map.project(this._lngLat);
                    this._map.terrain && (this._flatPos = this._trackPointer && t ? t : this._map.transform.locationToScreenPoint(this._lngLat));
                    let o = this.options.anchor;
                    const a = Es(this.options.offset);
                    if (!o) {
                        const e1 = this._container.offsetWidth, t = this._container.offsetHeight, r = function(e1) {
                            var t, i, o, a;
                            return e1 ? {
                                top: null !== (t = e1.top) && void 0 !== t ? t : 0,
                                right: null !== (i = e1.right) && void 0 !== i ? i : 0,
                                bottom: null !== (o = e1.bottom) && void 0 !== o ? o : 0,
                                left: null !== (a = e1.left) && void 0 !== a ? a : 0
                            } : {
                                top: 0,
                                right: 0,
                                bottom: 0,
                                left: 0
                            };
                        }(this.options.padding);
                        let s;
                        s = i.y + a.bottom.y < t + r.top ? [
                            "top"
                        ] : i.y > this._map.transform.height - t - r.bottom ? [
                            "bottom"
                        ] : [], i.x < e1 / 2 + r.left ? s.push("left") : i.x > this._map.transform.width - e1 / 2 - r.right && s.push("right"), o = 0 === s.length ? "bottom" : s.join("-");
                    }
                    let r = i.add(a[o]);
                    this.options.subpixelPositioning || (r = r.round()), this._container.style.transform = `${gs[o]} translate(${r.x}px,${r.y}px)`, vs(this._container, o, "popup"), this._updateOpacity();
                }, this._onClose = ()=>{
                    this.remove();
                }, this.options = t.e(Object.create(Ms), e1);
            }
            addTo(e1) {
                return this._map && this.remove(), this._map = e1, this.options.closeOnClick && this._map.on("click", this._onClose), this.options.closeOnMove && this._map.on("move", this._onClose), this._map.on("remove", this.remove), this._map.on("terrain", this._update), this._map.on("projectiontransition", this._update), this._update(), this._focusFirstElement(), this._trackPointer ? (this._map.on("mousemove", this._update), this._map.on("mouseup", this._update), this._container && this._container.classList.add("maplibregl-popup-track-pointer"), this._map._canvasContainer.classList.add("maplibregl-track-pointer")) : this._map.on("move", this._update), this.fire(new t.n("open")), this;
            }
            isOpen() {
                return !!this._map;
            }
            getLngLat() {
                return this._lngLat;
            }
            setLngLat(e1) {
                return this._lngLat = t.W.convert(e1), this._pos = null, this._flatPos = null, this._trackPointer = !1, this._update(), this._map && (this._map.on("move", this._update), this._map.off("mousemove", this._update), this._container && this._container.classList.remove("maplibregl-popup-track-pointer"), this._map._canvasContainer.classList.remove("maplibregl-track-pointer")), this;
            }
            trackPointer() {
                return this._trackPointer = !0, this._pos = null, this._flatPos = null, this._update(), this._map && (this._map.off("move", this._update), this._map.on("mousemove", this._update), this._map.on("drag", this._update), this._container && this._container.classList.add("maplibregl-popup-track-pointer"), this._map._canvasContainer.classList.add("maplibregl-track-pointer")), this;
            }
            getElement() {
                return this._container;
            }
            setText(e1) {
                return this.setDOMContent(document.createTextNode(e1));
            }
            setHTML(e1) {
                const t = document.createDocumentFragment(), i = document.createElement("body");
                let o;
                for(i.innerHTML = e1; o = i.firstChild, o;)t.appendChild(o);
                return this.setDOMContent(t);
            }
            getMaxWidth() {
                var e1;
                return null === (e1 = this._container) || void 0 === e1 ? void 0 : e1.style.maxWidth;
            }
            setMaxWidth(e1) {
                return this.options.maxWidth = e1, this._update(), this;
            }
            setDOMContent(e1) {
                if (this._content) for(; this._content.hasChildNodes();)this._content.firstChild && this._content.removeChild(this._content.firstChild);
                else this._content = d.create("div", "maplibregl-popup-content", this._container);
                return this._content.appendChild(e1), this._createCloseButton(), this._update(), this._focusFirstElement(), this;
            }
            addClassName(e1) {
                return this._container && this._container.classList.add(e1), this;
            }
            removeClassName(e1) {
                return this._container && this._container.classList.remove(e1), this;
            }
            setOffset(e1) {
                return this.options.offset = e1, this._update(), this;
            }
            toggleClassName(e1) {
                if (this._container) return this._container.classList.toggle(e1);
            }
            setSubpixelPositioning(e1) {
                this.options.subpixelPositioning = e1;
            }
            setPadding(e1) {
                this.options.padding = e1, this._update();
            }
            _createCloseButton() {
                this.options.closeButton && (this._closeButton = d.create("button", "maplibregl-popup-close-button", this._content), this._closeButton.type = "button", this._closeButton.innerHTML = "&#215;", this._closeButton.addEventListener("click", this._onClose));
            }
            _focusFirstElement() {
                if (!this.options.focusAfterOpen || !this._container) return;
                const e1 = this._container.querySelector(Is);
                e1 && e1.focus();
            }
        }, e1.RasterDEMTileSource = $, e1.RasterTileSource = q, e1.ScaleControl = class {
            constructor(e1){
                this._onMove = ()=>{
                    Ps(this._map, this._container, this.options);
                }, this.setUnit = (e1)=>{
                    this.options.unit = e1, Ps(this._map, this._container, this.options);
                }, this.options = Object.assign(Object.assign({}, Ts), e1);
            }
            getDefaultPosition() {
                return "bottom-left";
            }
            onAdd(e1) {
                return this._map = e1, this._container = d.create("div", "maplibregl-ctrl maplibregl-ctrl-scale", e1.getContainer()), this._map.on("move", this._onMove), this._onMove(), this._container;
            }
            onRemove() {
                this._container.remove(), this._map.off("move", this._onMove), this._map = void 0;
            }
        }, e1.ScrollZoomHandler = Nr, e1.Style = ki, e1.TerrainControl = class {
            constructor(e1){
                this._toggleTerrain = ()=>{
                    this._map.getTerrain() ? this._map.setTerrain(null) : this._map.setTerrain(this.options), this._updateTerrainIcon();
                }, this._updateTerrainIcon = ()=>{
                    this._terrainButton.classList.remove("maplibregl-ctrl-terrain"), this._terrainButton.classList.remove("maplibregl-ctrl-terrain-enabled"), this._map.terrain ? (this._terrainButton.classList.add("maplibregl-ctrl-terrain-enabled"), this._terrainButton.title = this._map._getUIString("TerrainControl.Disable")) : (this._terrainButton.classList.add("maplibregl-ctrl-terrain"), this._terrainButton.title = this._map._getUIString("TerrainControl.Enable"));
                }, this.options = e1;
            }
            onAdd(e1) {
                return this._map = e1, this._container = d.create("div", "maplibregl-ctrl maplibregl-ctrl-group"), this._terrainButton = d.create("button", "maplibregl-ctrl-terrain", this._container), d.create("span", "maplibregl-ctrl-icon", this._terrainButton).setAttribute("aria-hidden", "true"), this._terrainButton.type = "button", this._terrainButton.addEventListener("click", this._toggleTerrain), this._updateTerrainIcon(), this._map.on("terrain", this._updateTerrainIcon), this._container;
            }
            onRemove() {
                this._container.remove(), this._map.off("terrain", this._updateTerrainIcon), this._map = void 0;
            }
        }, e1.TwoFingersTouchPitchHandler = Lr, e1.TwoFingersTouchRotateHandler = Dr, e1.TwoFingersTouchZoomHandler = zr, e1.TwoFingersTouchZoomRotateHandler = qr, e1.VectorTileSource = W, e1.VideoSource = ie, e1.addSourceType = (e1, i)=>t._(void 0, void 0, void 0, function*() {
                if (re(e1)) throw new Error(`A source type called "${e1}" already exists.`);
                ((e1, t)=>{
                    ae[e1] = t;
                })(e1, i);
            }), e1.clearPrewarmedResources = function() {
            const e1 = A;
            e1 && (e1.isPreloaded() && 1 === e1.numActive() ? (e1.release(z), A = null) : console.warn("Could not clear WebWorkers since there are active Map instances that still reference it. The pre-warmed WebWorker pool can only be cleared when all map instances have been removed with map.remove()"));
        }, e1.createTileMesh = ci, e1.getGlobalDispatcher = B, e1.getMaxParallelImageRequests = function() {
            return t.c.MAX_PARALLEL_IMAGE_REQUESTS;
        }, e1.getRTLTextPluginStatus = function() {
            return ce().getRTLTextPluginStatus();
        }, e1.getVersion = function() {
            return Ss;
        }, e1.getWorkerCount = function() {
            return R.workerCount;
        }, e1.getWorkerUrl = function() {
            return t.c.WORKER_URL;
        }, e1.importScriptInWorkers = function(e1) {
            return B().broadcast("IS", e1);
        }, e1.isTimeFrozen = function() {
            return l.isFrozen();
        }, e1.now = c, e1.prewarm = function() {
            F().acquire(z);
        }, e1.restoreNow = function() {
            l.restoreNow();
        }, e1.setMaxParallelImageRequests = function(e1) {
            t.c.MAX_PARALLEL_IMAGE_REQUESTS = e1;
        }, e1.setNow = function(e1) {
            l.setNow(e1);
        }, e1.setRTLTextPlugin = function(e1, t) {
            return ce().setRTLTextPlugin(e1, t);
        }, e1.setWorkerCount = function(e1) {
            R.workerCount = e1;
        }, e1.setWorkerUrl = function(e1) {
            t.c.WORKER_URL = e1;
        };
    });
    //
    // Our custom intro provides a specialized "define()" function, called by the
    // AMD modules below, that sets up the worker blob URL and then executes the
    // main module, storing its exported value as 'maplibregl'
    var maplibregl$1 = maplibregl;
    return maplibregl$1;
});



// DEFLATE is a complex format; to read this code, you should probably check the RFC first:
// https://tools.ietf.org/html/rfc1951
// You may also wish to take a look at the guide I made about this program:
// https://gist.github.com/101arrowz/253f31eb5abc3d9275ab943003ffecad
// Some of the following code is similar to that of UZIP.js:
// https://github.com/photopea/UZIP.js
// However, the vast majority of the codebase has diverged from UZIP.js to increase performance and reduce bundle size.
// Sometimes 0 will appear where -1 would be more appropriate. This is because using a uint
// is better for memory in most engines (I *think*).
var $461bf5d8bd29e0d8$var$ch2 = {};
var $461bf5d8bd29e0d8$var$wk = function(c, id, msg, transfer, cb) {
    var w = new Worker($461bf5d8bd29e0d8$var$ch2[id] || ($461bf5d8bd29e0d8$var$ch2[id] = URL.createObjectURL(new Blob([
        c + ';addEventListener("error",function(e){e=e.error;postMessage({$e$:[e.message,e.code,e.stack]})})'
    ], {
        type: 'text/javascript'
    }))));
    w.onmessage = function(e) {
        var d = e.data, ed = d.$e$;
        if (ed) {
            var err = new Error(ed[0]);
            err['code'] = ed[1];
            err.stack = ed[2];
            cb(err, null);
        } else cb(null, d);
    };
    w.postMessage(msg, transfer);
    return w;
};
// aliases for shorter compressed code (most minifers don't do this)
var $461bf5d8bd29e0d8$var$u8 = Uint8Array, $461bf5d8bd29e0d8$var$u16 = Uint16Array, $461bf5d8bd29e0d8$var$i32 = Int32Array;
// fixed length extra bits
var $461bf5d8bd29e0d8$var$fleb = new $461bf5d8bd29e0d8$var$u8([
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    2,
    2,
    2,
    2,
    3,
    3,
    3,
    3,
    4,
    4,
    4,
    4,
    5,
    5,
    5,
    5,
    0,
    /* unused */ 0,
    0,
    /* impossible */ 0
]);
// fixed distance extra bits
var $461bf5d8bd29e0d8$var$fdeb = new $461bf5d8bd29e0d8$var$u8([
    0,
    0,
    0,
    0,
    1,
    1,
    2,
    2,
    3,
    3,
    4,
    4,
    5,
    5,
    6,
    6,
    7,
    7,
    8,
    8,
    9,
    9,
    10,
    10,
    11,
    11,
    12,
    12,
    13,
    13,
    /* unused */ 0,
    0
]);
// code length index map
var $461bf5d8bd29e0d8$var$clim = new $461bf5d8bd29e0d8$var$u8([
    16,
    17,
    18,
    0,
    8,
    7,
    9,
    6,
    10,
    5,
    11,
    4,
    12,
    3,
    13,
    2,
    14,
    1,
    15
]);
// get base, reverse index map from extra bits
var $461bf5d8bd29e0d8$var$freb = function(eb, start) {
    var b = new $461bf5d8bd29e0d8$var$u16(31);
    for(var i = 0; i < 31; ++i)b[i] = start += 1 << eb[i - 1];
    // numbers here are at max 18 bits
    var r = new $461bf5d8bd29e0d8$var$i32(b[30]);
    for(var i = 1; i < 30; ++i)for(var j = b[i]; j < b[i + 1]; ++j)r[j] = j - b[i] << 5 | i;
    return {
        b: b,
        r: r
    };
};
var $461bf5d8bd29e0d8$var$_a = $461bf5d8bd29e0d8$var$freb($461bf5d8bd29e0d8$var$fleb, 2), $461bf5d8bd29e0d8$var$fl = $461bf5d8bd29e0d8$var$_a.b, $461bf5d8bd29e0d8$var$revfl = $461bf5d8bd29e0d8$var$_a.r;
// we can ignore the fact that the other numbers are wrong; they never happen anyway
$461bf5d8bd29e0d8$var$fl[28] = 258, $461bf5d8bd29e0d8$var$revfl[258] = 28;
var $461bf5d8bd29e0d8$var$_b = $461bf5d8bd29e0d8$var$freb($461bf5d8bd29e0d8$var$fdeb, 0), $461bf5d8bd29e0d8$var$fd = $461bf5d8bd29e0d8$var$_b.b, $461bf5d8bd29e0d8$var$revfd = $461bf5d8bd29e0d8$var$_b.r;
// map of value to reverse (assuming 16 bits)
var $461bf5d8bd29e0d8$var$rev = new $461bf5d8bd29e0d8$var$u16(32768);
for(var $461bf5d8bd29e0d8$var$i = 0; $461bf5d8bd29e0d8$var$i < 32768; ++$461bf5d8bd29e0d8$var$i){
    // reverse table algorithm from SO
    var $461bf5d8bd29e0d8$var$x = ($461bf5d8bd29e0d8$var$i & 0xAAAA) >> 1 | ($461bf5d8bd29e0d8$var$i & 0x5555) << 1;
    $461bf5d8bd29e0d8$var$x = ($461bf5d8bd29e0d8$var$x & 0xCCCC) >> 2 | ($461bf5d8bd29e0d8$var$x & 0x3333) << 2;
    $461bf5d8bd29e0d8$var$x = ($461bf5d8bd29e0d8$var$x & 0xF0F0) >> 4 | ($461bf5d8bd29e0d8$var$x & 0x0F0F) << 4;
    $461bf5d8bd29e0d8$var$rev[$461bf5d8bd29e0d8$var$i] = (($461bf5d8bd29e0d8$var$x & 0xFF00) >> 8 | ($461bf5d8bd29e0d8$var$x & 0x00FF) << 8) >> 1;
}
// create huffman tree from u8 "map": index -> code length for code index
// mb (max bits) must be at most 15
// TODO: optimize/split up?
var $461bf5d8bd29e0d8$var$hMap = function(cd, mb, r) {
    var s = cd.length;
    // index
    var i = 0;
    // u16 "map": index -> # of codes with bit length = index
    var l = new $461bf5d8bd29e0d8$var$u16(mb);
    // length of cd must be 288 (total # of codes)
    for(; i < s; ++i)if (cd[i]) ++l[cd[i] - 1];
    // u16 "map": index -> minimum code for bit length = index
    var le = new $461bf5d8bd29e0d8$var$u16(mb);
    for(i = 1; i < mb; ++i)le[i] = le[i - 1] + l[i - 1] << 1;
    var co;
    if (r) {
        // u16 "map": index -> number of actual bits, symbol for code
        co = new $461bf5d8bd29e0d8$var$u16(1 << mb);
        // bits to remove for reverser
        var rvb = 15 - mb;
        for(i = 0; i < s; ++i)// ignore 0 lengths
        if (cd[i]) {
            // num encoding both symbol and bits read
            var sv = i << 4 | cd[i];
            // free bits
            var r_1 = mb - cd[i];
            // start value
            var v = le[cd[i] - 1]++ << r_1;
            // m is end value
            for(var m = v | (1 << r_1) - 1; v <= m; ++v)// every 16 bit value starting with the code yields the same result
            co[$461bf5d8bd29e0d8$var$rev[v] >> rvb] = sv;
        }
    } else {
        co = new $461bf5d8bd29e0d8$var$u16(s);
        for(i = 0; i < s; ++i)if (cd[i]) co[i] = $461bf5d8bd29e0d8$var$rev[le[cd[i] - 1]++] >> 15 - cd[i];
    }
    return co;
};
// fixed length tree
var $461bf5d8bd29e0d8$var$flt = new $461bf5d8bd29e0d8$var$u8(288);
for(var $461bf5d8bd29e0d8$var$i = 0; $461bf5d8bd29e0d8$var$i < 144; ++$461bf5d8bd29e0d8$var$i)$461bf5d8bd29e0d8$var$flt[$461bf5d8bd29e0d8$var$i] = 8;
for(var $461bf5d8bd29e0d8$var$i = 144; $461bf5d8bd29e0d8$var$i < 256; ++$461bf5d8bd29e0d8$var$i)$461bf5d8bd29e0d8$var$flt[$461bf5d8bd29e0d8$var$i] = 9;
for(var $461bf5d8bd29e0d8$var$i = 256; $461bf5d8bd29e0d8$var$i < 280; ++$461bf5d8bd29e0d8$var$i)$461bf5d8bd29e0d8$var$flt[$461bf5d8bd29e0d8$var$i] = 7;
for(var $461bf5d8bd29e0d8$var$i = 280; $461bf5d8bd29e0d8$var$i < 288; ++$461bf5d8bd29e0d8$var$i)$461bf5d8bd29e0d8$var$flt[$461bf5d8bd29e0d8$var$i] = 8;
// fixed distance tree
var $461bf5d8bd29e0d8$var$fdt = new $461bf5d8bd29e0d8$var$u8(32);
for(var $461bf5d8bd29e0d8$var$i = 0; $461bf5d8bd29e0d8$var$i < 32; ++$461bf5d8bd29e0d8$var$i)$461bf5d8bd29e0d8$var$fdt[$461bf5d8bd29e0d8$var$i] = 5;
// fixed length map
var $461bf5d8bd29e0d8$var$flm = /*#__PURE__*/ $461bf5d8bd29e0d8$var$hMap($461bf5d8bd29e0d8$var$flt, 9, 0), $461bf5d8bd29e0d8$var$flrm = /*#__PURE__*/ $461bf5d8bd29e0d8$var$hMap($461bf5d8bd29e0d8$var$flt, 9, 1);
// fixed distance map
var $461bf5d8bd29e0d8$var$fdm = /*#__PURE__*/ $461bf5d8bd29e0d8$var$hMap($461bf5d8bd29e0d8$var$fdt, 5, 0), $461bf5d8bd29e0d8$var$fdrm = /*#__PURE__*/ $461bf5d8bd29e0d8$var$hMap($461bf5d8bd29e0d8$var$fdt, 5, 1);
// find max of array
var $461bf5d8bd29e0d8$var$max = function(a) {
    var m = a[0];
    for(var i = 1; i < a.length; ++i)if (a[i] > m) m = a[i];
    return m;
};
// read d, starting at bit p and mask with m
var $461bf5d8bd29e0d8$var$bits = function(d, p, m) {
    var o = p / 8 | 0;
    return (d[o] | d[o + 1] << 8) >> (p & 7) & m;
};
// read d, starting at bit p continuing for at least 16 bits
var $461bf5d8bd29e0d8$var$bits16 = function(d, p) {
    var o = p / 8 | 0;
    return (d[o] | d[o + 1] << 8 | d[o + 2] << 16) >> (p & 7);
};
// get end of byte
var $461bf5d8bd29e0d8$var$shft = function(p) {
    return (p + 7) / 8 | 0;
};
// typed array slice - allows garbage collector to free original reference,
// while being more compatible than .slice
var $461bf5d8bd29e0d8$var$slc = function(v, s, e) {
    if (s == null || s < 0) s = 0;
    if (e == null || e > v.length) e = v.length;
    // can't use .constructor in case user-supplied
    return new $461bf5d8bd29e0d8$var$u8(v.subarray(s, e));
};
var $461bf5d8bd29e0d8$export$ae5516a5a74c19a8 = {
    UnexpectedEOF: 0,
    InvalidBlockType: 1,
    InvalidLengthLiteral: 2,
    InvalidDistance: 3,
    StreamFinished: 4,
    NoStreamHandler: 5,
    InvalidHeader: 6,
    NoCallback: 7,
    InvalidUTF8: 8,
    ExtraFieldTooLong: 9,
    InvalidDate: 10,
    FilenameTooLong: 11,
    StreamFinishing: 12,
    InvalidZipData: 13,
    UnknownCompressionMethod: 14
};
// error codes
var $461bf5d8bd29e0d8$var$ec = [
    'unexpected EOF',
    'invalid block type',
    'invalid length/literal',
    'invalid distance',
    'stream finished',
    'no stream handler',
    ,
    'no callback',
    'invalid UTF-8 data',
    'extra field too long',
    'date not in range 1980-2099',
    'filename too long',
    'stream finishing',
    'invalid zip data'
];
var $461bf5d8bd29e0d8$var$err = function(ind, msg, nt) {
    var e = new Error(msg || $461bf5d8bd29e0d8$var$ec[ind]);
    e.code = ind;
    if (Error.captureStackTrace) Error.captureStackTrace(e, $461bf5d8bd29e0d8$var$err);
    if (!nt) throw e;
    return e;
};
// expands raw DEFLATE data
var $461bf5d8bd29e0d8$var$inflt = function(dat, st, buf, dict) {
    // source length       dict length
    var sl = dat.length, dl = dict ? dict.length : 0;
    if (!sl || st.f && !st.l) return buf || new $461bf5d8bd29e0d8$var$u8(0);
    var noBuf = !buf;
    // have to estimate size
    var resize = noBuf || st.i != 2;
    // no state
    var noSt = st.i;
    // Assumes roughly 33% compression ratio average
    if (noBuf) buf = new $461bf5d8bd29e0d8$var$u8(sl * 3);
    // ensure buffer can fit at least l elements
    var cbuf = function(l) {
        var bl = buf.length;
        // need to increase size to fit
        if (l > bl) {
            // Double or set to necessary, whichever is greater
            var nbuf = new $461bf5d8bd29e0d8$var$u8(Math.max(bl * 2, l));
            nbuf.set(buf);
            buf = nbuf;
        }
    };
    //  last chunk         bitpos           bytes
    var final = st.f || 0, pos = st.p || 0, bt = st.b || 0, lm = st.l, dm = st.d, lbt = st.m, dbt = st.n;
    // total bits
    var tbts = sl * 8;
    do {
        if (!lm) {
            // BFINAL - this is only 1 when last chunk is next
            final = $461bf5d8bd29e0d8$var$bits(dat, pos, 1);
            // type: 0 = no compression, 1 = fixed huffman, 2 = dynamic huffman
            var type = $461bf5d8bd29e0d8$var$bits(dat, pos + 1, 3);
            pos += 3;
            if (!type) {
                // go to end of byte boundary
                var s = $461bf5d8bd29e0d8$var$shft(pos) + 4, l = dat[s - 4] | dat[s - 3] << 8, t = s + l;
                if (t > sl) {
                    if (noSt) $461bf5d8bd29e0d8$var$err(0);
                    break;
                }
                // ensure size
                if (resize) cbuf(bt + l);
                // Copy over uncompressed data
                buf.set(dat.subarray(s, t), bt);
                // Get new bitpos, update byte count
                st.b = bt += l, st.p = pos = t * 8, st.f = final;
                continue;
            } else if (type == 1) lm = $461bf5d8bd29e0d8$var$flrm, dm = $461bf5d8bd29e0d8$var$fdrm, lbt = 9, dbt = 5;
            else if (type == 2) {
                //  literal                            lengths
                var hLit = $461bf5d8bd29e0d8$var$bits(dat, pos, 31) + 257, hcLen = $461bf5d8bd29e0d8$var$bits(dat, pos + 10, 15) + 4;
                var tl = hLit + $461bf5d8bd29e0d8$var$bits(dat, pos + 5, 31) + 1;
                pos += 14;
                // length+distance tree
                var ldt = new $461bf5d8bd29e0d8$var$u8(tl);
                // code length tree
                var clt = new $461bf5d8bd29e0d8$var$u8(19);
                for(var i = 0; i < hcLen; ++i)// use index map to get real code
                clt[$461bf5d8bd29e0d8$var$clim[i]] = $461bf5d8bd29e0d8$var$bits(dat, pos + i * 3, 7);
                pos += hcLen * 3;
                // code lengths bits
                var clb = $461bf5d8bd29e0d8$var$max(clt), clbmsk = (1 << clb) - 1;
                // code lengths map
                var clm = $461bf5d8bd29e0d8$var$hMap(clt, clb, 1);
                for(var i = 0; i < tl;){
                    var r = clm[$461bf5d8bd29e0d8$var$bits(dat, pos, clbmsk)];
                    // bits read
                    pos += r & 15;
                    // symbol
                    var s = r >> 4;
                    // code length to copy
                    if (s < 16) ldt[i++] = s;
                    else {
                        //  copy   count
                        var c = 0, n = 0;
                        if (s == 16) n = 3 + $461bf5d8bd29e0d8$var$bits(dat, pos, 3), pos += 2, c = ldt[i - 1];
                        else if (s == 17) n = 3 + $461bf5d8bd29e0d8$var$bits(dat, pos, 7), pos += 3;
                        else if (s == 18) n = 11 + $461bf5d8bd29e0d8$var$bits(dat, pos, 127), pos += 7;
                        while(n--)ldt[i++] = c;
                    }
                }
                //    length tree                 distance tree
                var lt = ldt.subarray(0, hLit), dt = ldt.subarray(hLit);
                // max length bits
                lbt = $461bf5d8bd29e0d8$var$max(lt);
                // max dist bits
                dbt = $461bf5d8bd29e0d8$var$max(dt);
                lm = $461bf5d8bd29e0d8$var$hMap(lt, lbt, 1);
                dm = $461bf5d8bd29e0d8$var$hMap(dt, dbt, 1);
            } else $461bf5d8bd29e0d8$var$err(1);
            if (pos > tbts) {
                if (noSt) $461bf5d8bd29e0d8$var$err(0);
                break;
            }
        }
        // Make sure the buffer can hold this + the largest possible addition
        // Maximum chunk size (practically, theoretically infinite) is 2^17
        if (resize) cbuf(bt + 131072);
        var lms = (1 << lbt) - 1, dms = (1 << dbt) - 1;
        var lpos = pos;
        for(;; lpos = pos){
            // bits read, code
            var c = lm[$461bf5d8bd29e0d8$var$bits16(dat, pos) & lms], sym = c >> 4;
            pos += c & 15;
            if (pos > tbts) {
                if (noSt) $461bf5d8bd29e0d8$var$err(0);
                break;
            }
            if (!c) $461bf5d8bd29e0d8$var$err(2);
            if (sym < 256) buf[bt++] = sym;
            else if (sym == 256) {
                lpos = pos, lm = null;
                break;
            } else {
                var add = sym - 254;
                // no extra bits needed if less
                if (sym > 264) {
                    // index
                    var i = sym - 257, b = $461bf5d8bd29e0d8$var$fleb[i];
                    add = $461bf5d8bd29e0d8$var$bits(dat, pos, (1 << b) - 1) + $461bf5d8bd29e0d8$var$fl[i];
                    pos += b;
                }
                // dist
                var d = dm[$461bf5d8bd29e0d8$var$bits16(dat, pos) & dms], dsym = d >> 4;
                if (!d) $461bf5d8bd29e0d8$var$err(3);
                pos += d & 15;
                var dt = $461bf5d8bd29e0d8$var$fd[dsym];
                if (dsym > 3) {
                    var b = $461bf5d8bd29e0d8$var$fdeb[dsym];
                    dt += $461bf5d8bd29e0d8$var$bits16(dat, pos) & (1 << b) - 1, pos += b;
                }
                if (pos > tbts) {
                    if (noSt) $461bf5d8bd29e0d8$var$err(0);
                    break;
                }
                if (resize) cbuf(bt + 131072);
                var end = bt + add;
                if (bt < dt) {
                    var shift = dl - dt, dend = Math.min(dt, end);
                    if (shift + bt < 0) $461bf5d8bd29e0d8$var$err(3);
                    for(; bt < dend; ++bt)buf[bt] = dict[shift + bt];
                }
                for(; bt < end; ++bt)buf[bt] = buf[bt - dt];
            }
        }
        st.l = lm, st.p = lpos, st.b = bt, st.f = final;
        if (lm) final = 1, st.m = lbt, st.d = dm, st.n = dbt;
    }while (!final);
    // don't reallocate for streams or user buffers
    return bt != buf.length && noBuf ? $461bf5d8bd29e0d8$var$slc(buf, 0, bt) : buf.subarray(0, bt);
};
// starting at p, write the minimum number of bits that can hold v to d
var $461bf5d8bd29e0d8$var$wbits = function(d, p, v) {
    v <<= p & 7;
    var o = p / 8 | 0;
    d[o] |= v;
    d[o + 1] |= v >> 8;
};
// starting at p, write the minimum number of bits (>8) that can hold v to d
var $461bf5d8bd29e0d8$var$wbits16 = function(d, p, v) {
    v <<= p & 7;
    var o = p / 8 | 0;
    d[o] |= v;
    d[o + 1] |= v >> 8;
    d[o + 2] |= v >> 16;
};
// creates code lengths from a frequency table
var $461bf5d8bd29e0d8$var$hTree = function(d, mb) {
    // Need extra info to make a tree
    var t = [];
    for(var i = 0; i < d.length; ++i)if (d[i]) t.push({
        s: i,
        f: d[i]
    });
    var s = t.length;
    var t2 = t.slice();
    if (!s) return {
        t: $461bf5d8bd29e0d8$var$et,
        l: 0
    };
    if (s == 1) {
        var v = new $461bf5d8bd29e0d8$var$u8(t[0].s + 1);
        v[t[0].s] = 1;
        return {
            t: v,
            l: 1
        };
    }
    t.sort(function(a, b) {
        return a.f - b.f;
    });
    // after i2 reaches last ind, will be stopped
    // freq must be greater than largest possible number of symbols
    t.push({
        s: -1,
        f: 25001
    });
    var l = t[0], r = t[1], i0 = 0, i1 = 1, i2 = 2;
    t[0] = {
        s: -1,
        f: l.f + r.f,
        l: l,
        r: r
    };
    // efficient algorithm from UZIP.js
    // i0 is lookbehind, i2 is lookahead - after processing two low-freq
    // symbols that combined have high freq, will start processing i2 (high-freq,
    // non-composite) symbols instead
    // see https://reddit.com/r/photopea/comments/ikekht/uzipjs_questions/
    while(i1 != s - 1){
        l = t[t[i0].f < t[i2].f ? i0++ : i2++];
        r = t[i0 != i1 && t[i0].f < t[i2].f ? i0++ : i2++];
        t[i1++] = {
            s: -1,
            f: l.f + r.f,
            l: l,
            r: r
        };
    }
    var maxSym = t2[0].s;
    for(var i = 1; i < s; ++i)if (t2[i].s > maxSym) maxSym = t2[i].s;
    // code lengths
    var tr = new $461bf5d8bd29e0d8$var$u16(maxSym + 1);
    // max bits in tree
    var mbt = $461bf5d8bd29e0d8$var$ln(t[i1 - 1], tr, 0);
    if (mbt > mb) {
        // more algorithms from UZIP.js
        // TODO: find out how this code works (debt)
        //  ind    debt
        var i = 0, dt = 0;
        //    left            cost
        var lft = mbt - mb, cst = 1 << lft;
        t2.sort(function(a, b) {
            return tr[b.s] - tr[a.s] || a.f - b.f;
        });
        for(; i < s; ++i){
            var i2_1 = t2[i].s;
            if (tr[i2_1] > mb) {
                dt += cst - (1 << mbt - tr[i2_1]);
                tr[i2_1] = mb;
            } else break;
        }
        dt >>= lft;
        while(dt > 0){
            var i2_2 = t2[i].s;
            if (tr[i2_2] < mb) dt -= 1 << mb - tr[i2_2]++ - 1;
            else ++i;
        }
        for(; i >= 0 && dt; --i){
            var i2_3 = t2[i].s;
            if (tr[i2_3] == mb) {
                --tr[i2_3];
                ++dt;
            }
        }
        mbt = mb;
    }
    return {
        t: new $461bf5d8bd29e0d8$var$u8(tr),
        l: mbt
    };
};
// get the max length and assign length codes
var $461bf5d8bd29e0d8$var$ln = function(n, l, d) {
    return n.s == -1 ? Math.max($461bf5d8bd29e0d8$var$ln(n.l, l, d + 1), $461bf5d8bd29e0d8$var$ln(n.r, l, d + 1)) : l[n.s] = d;
};
// length codes generation
var $461bf5d8bd29e0d8$var$lc = function(c) {
    var s = c.length;
    // Note that the semicolon was intentional
    while(s && !c[--s]);
    var cl = new $461bf5d8bd29e0d8$var$u16(++s);
    //  ind      num         streak
    var cli = 0, cln = c[0], cls = 1;
    var w = function(v) {
        cl[cli++] = v;
    };
    for(var i = 1; i <= s; ++i)if (c[i] == cln && i != s) ++cls;
    else {
        if (!cln && cls > 2) {
            for(; cls > 138; cls -= 138)w(32754);
            if (cls > 2) {
                w(cls > 10 ? cls - 11 << 5 | 28690 : cls - 3 << 5 | 12305);
                cls = 0;
            }
        } else if (cls > 3) {
            w(cln), --cls;
            for(; cls > 6; cls -= 6)w(8304);
            if (cls > 2) w(cls - 3 << 5 | 8208), cls = 0;
        }
        while(cls--)w(cln);
        cls = 1;
        cln = c[i];
    }
    return {
        c: cl.subarray(0, cli),
        n: s
    };
};
// calculate the length of output from tree, code lengths
var $461bf5d8bd29e0d8$var$clen = function(cf, cl) {
    var l = 0;
    for(var i = 0; i < cl.length; ++i)l += cf[i] * cl[i];
    return l;
};
// writes a fixed block
// returns the new bit pos
var $461bf5d8bd29e0d8$var$wfblk = function(out, pos, dat) {
    // no need to write 00 as type: TypedArray defaults to 0
    var s = dat.length;
    var o = $461bf5d8bd29e0d8$var$shft(pos + 2);
    out[o] = s & 255;
    out[o + 1] = s >> 8;
    out[o + 2] = out[o] ^ 255;
    out[o + 3] = out[o + 1] ^ 255;
    for(var i = 0; i < s; ++i)out[o + i + 4] = dat[i];
    return (o + 4 + s) * 8;
};
// writes a block
var $461bf5d8bd29e0d8$var$wblk = function(dat, out, final, syms, lf, df, eb, li, bs, bl, p) {
    $461bf5d8bd29e0d8$var$wbits(out, p++, final);
    ++lf[256];
    var _a = $461bf5d8bd29e0d8$var$hTree(lf, 15), dlt = _a.t, mlb = _a.l;
    var _b = $461bf5d8bd29e0d8$var$hTree(df, 15), ddt = _b.t, mdb = _b.l;
    var _c = $461bf5d8bd29e0d8$var$lc(dlt), lclt = _c.c, nlc = _c.n;
    var _d = $461bf5d8bd29e0d8$var$lc(ddt), lcdt = _d.c, ndc = _d.n;
    var lcfreq = new $461bf5d8bd29e0d8$var$u16(19);
    for(var i = 0; i < lclt.length; ++i)++lcfreq[lclt[i] & 31];
    for(var i = 0; i < lcdt.length; ++i)++lcfreq[lcdt[i] & 31];
    var _e = $461bf5d8bd29e0d8$var$hTree(lcfreq, 7), lct = _e.t, mlcb = _e.l;
    var nlcc = 19;
    for(; nlcc > 4 && !lct[$461bf5d8bd29e0d8$var$clim[nlcc - 1]]; --nlcc);
    var flen = bl + 5 << 3;
    var ftlen = $461bf5d8bd29e0d8$var$clen(lf, $461bf5d8bd29e0d8$var$flt) + $461bf5d8bd29e0d8$var$clen(df, $461bf5d8bd29e0d8$var$fdt) + eb;
    var dtlen = $461bf5d8bd29e0d8$var$clen(lf, dlt) + $461bf5d8bd29e0d8$var$clen(df, ddt) + eb + 14 + 3 * nlcc + $461bf5d8bd29e0d8$var$clen(lcfreq, lct) + 2 * lcfreq[16] + 3 * lcfreq[17] + 7 * lcfreq[18];
    if (bs >= 0 && flen <= ftlen && flen <= dtlen) return $461bf5d8bd29e0d8$var$wfblk(out, p, dat.subarray(bs, bs + bl));
    var lm, ll, dm, dl;
    $461bf5d8bd29e0d8$var$wbits(out, p, 1 + (dtlen < ftlen)), p += 2;
    if (dtlen < ftlen) {
        lm = $461bf5d8bd29e0d8$var$hMap(dlt, mlb, 0), ll = dlt, dm = $461bf5d8bd29e0d8$var$hMap(ddt, mdb, 0), dl = ddt;
        var llm = $461bf5d8bd29e0d8$var$hMap(lct, mlcb, 0);
        $461bf5d8bd29e0d8$var$wbits(out, p, nlc - 257);
        $461bf5d8bd29e0d8$var$wbits(out, p + 5, ndc - 1);
        $461bf5d8bd29e0d8$var$wbits(out, p + 10, nlcc - 4);
        p += 14;
        for(var i = 0; i < nlcc; ++i)$461bf5d8bd29e0d8$var$wbits(out, p + 3 * i, lct[$461bf5d8bd29e0d8$var$clim[i]]);
        p += 3 * nlcc;
        var lcts = [
            lclt,
            lcdt
        ];
        for(var it = 0; it < 2; ++it){
            var clct = lcts[it];
            for(var i = 0; i < clct.length; ++i){
                var len = clct[i] & 31;
                $461bf5d8bd29e0d8$var$wbits(out, p, llm[len]), p += lct[len];
                if (len > 15) $461bf5d8bd29e0d8$var$wbits(out, p, clct[i] >> 5 & 127), p += clct[i] >> 12;
            }
        }
    } else lm = $461bf5d8bd29e0d8$var$flm, ll = $461bf5d8bd29e0d8$var$flt, dm = $461bf5d8bd29e0d8$var$fdm, dl = $461bf5d8bd29e0d8$var$fdt;
    for(var i = 0; i < li; ++i){
        var sym = syms[i];
        if (sym > 255) {
            var len = sym >> 18 & 31;
            $461bf5d8bd29e0d8$var$wbits16(out, p, lm[len + 257]), p += ll[len + 257];
            if (len > 7) $461bf5d8bd29e0d8$var$wbits(out, p, sym >> 23 & 31), p += $461bf5d8bd29e0d8$var$fleb[len];
            var dst = sym & 31;
            $461bf5d8bd29e0d8$var$wbits16(out, p, dm[dst]), p += dl[dst];
            if (dst > 3) $461bf5d8bd29e0d8$var$wbits16(out, p, sym >> 5 & 8191), p += $461bf5d8bd29e0d8$var$fdeb[dst];
        } else $461bf5d8bd29e0d8$var$wbits16(out, p, lm[sym]), p += ll[sym];
    }
    $461bf5d8bd29e0d8$var$wbits16(out, p, lm[256]);
    return p + ll[256];
};
// deflate options (nice << 13) | chain
var $461bf5d8bd29e0d8$var$deo = /*#__PURE__*/ new $461bf5d8bd29e0d8$var$i32([
    65540,
    131080,
    131088,
    131104,
    262176,
    1048704,
    1048832,
    2114560,
    2117632
]);
// empty
var $461bf5d8bd29e0d8$var$et = /*#__PURE__*/ new $461bf5d8bd29e0d8$var$u8(0);
// compresses data into a raw DEFLATE buffer
var $461bf5d8bd29e0d8$var$dflt = function(dat, lvl, plvl, pre, post, st) {
    var s = st.z || dat.length;
    var o = new $461bf5d8bd29e0d8$var$u8(pre + s + 5 * (1 + Math.ceil(s / 7000)) + post);
    // writing to this writes to the output buffer
    var w = o.subarray(pre, o.length - post);
    var lst = st.l;
    var pos = (st.r || 0) & 7;
    if (lvl) {
        if (pos) w[0] = st.r >> 3;
        var opt = $461bf5d8bd29e0d8$var$deo[lvl - 1];
        var n = opt >> 13, c = opt & 8191;
        var msk_1 = (1 << plvl) - 1;
        //    prev 2-byte val map    curr 2-byte val map
        var prev = st.p || new $461bf5d8bd29e0d8$var$u16(32768), head = st.h || new $461bf5d8bd29e0d8$var$u16(msk_1 + 1);
        var bs1_1 = Math.ceil(plvl / 3), bs2_1 = 2 * bs1_1;
        var hsh = function(i) {
            return (dat[i] ^ dat[i + 1] << bs1_1 ^ dat[i + 2] << bs2_1) & msk_1;
        };
        // 24576 is an arbitrary number of maximum symbols per block
        // 424 buffer for last block
        var syms = new $461bf5d8bd29e0d8$var$i32(25000);
        // length/literal freq   distance freq
        var lf = new $461bf5d8bd29e0d8$var$u16(288), df = new $461bf5d8bd29e0d8$var$u16(32);
        //  l/lcnt  exbits  index          l/lind  waitdx          blkpos
        var lc_1 = 0, eb = 0, i = st.i || 0, li = 0, wi = st.w || 0, bs = 0;
        for(; i + 2 < s; ++i){
            // hash value
            var hv = hsh(i);
            // index mod 32768    previous index mod
            var imod = i & 32767, pimod = head[hv];
            prev[imod] = pimod;
            head[hv] = imod;
            // We always should modify head and prev, but only add symbols if
            // this data is not yet processed ("wait" for wait index)
            if (wi <= i) {
                // bytes remaining
                var rem = s - i;
                if ((lc_1 > 7000 || li > 24576) && (rem > 423 || !lst)) {
                    pos = $461bf5d8bd29e0d8$var$wblk(dat, w, 0, syms, lf, df, eb, li, bs, i - bs, pos);
                    li = lc_1 = eb = 0, bs = i;
                    for(var j = 0; j < 286; ++j)lf[j] = 0;
                    for(var j = 0; j < 30; ++j)df[j] = 0;
                }
                //  len    dist   chain
                var l = 2, d = 0, ch_1 = c, dif = imod - pimod & 32767;
                if (rem > 2 && hv == hsh(i - dif)) {
                    var maxn = Math.min(n, rem) - 1;
                    var maxd = Math.min(32767, i);
                    // max possible length
                    // not capped at dif because decompressors implement "rolling" index population
                    var ml = Math.min(258, rem);
                    while(dif <= maxd && --ch_1 && imod != pimod){
                        if (dat[i + l] == dat[i + l - dif]) {
                            var nl = 0;
                            for(; nl < ml && dat[i + nl] == dat[i + nl - dif]; ++nl);
                            if (nl > l) {
                                l = nl, d = dif;
                                // break out early when we reach "nice" (we are satisfied enough)
                                if (nl > maxn) break;
                                // now, find the rarest 2-byte sequence within this
                                // length of literals and search for that instead.
                                // Much faster than just using the start
                                var mmd = Math.min(dif, nl - 2);
                                var md = 0;
                                for(var j = 0; j < mmd; ++j){
                                    var ti = i - dif + j & 32767;
                                    var pti = prev[ti];
                                    var cd = ti - pti & 32767;
                                    if (cd > md) md = cd, pimod = ti;
                                }
                            }
                        }
                        // check the previous match
                        imod = pimod, pimod = prev[imod];
                        dif += imod - pimod & 32767;
                    }
                }
                // d will be nonzero only when a match was found
                if (d) {
                    // store both dist and len data in one int32
                    // Make sure this is recognized as a len/dist with 28th bit (2^28)
                    syms[li++] = 268435456 | $461bf5d8bd29e0d8$var$revfl[l] << 18 | $461bf5d8bd29e0d8$var$revfd[d];
                    var lin = $461bf5d8bd29e0d8$var$revfl[l] & 31, din = $461bf5d8bd29e0d8$var$revfd[d] & 31;
                    eb += $461bf5d8bd29e0d8$var$fleb[lin] + $461bf5d8bd29e0d8$var$fdeb[din];
                    ++lf[257 + lin];
                    ++df[din];
                    wi = i + l;
                    ++lc_1;
                } else {
                    syms[li++] = dat[i];
                    ++lf[dat[i]];
                }
            }
        }
        for(i = Math.max(i, wi); i < s; ++i){
            syms[li++] = dat[i];
            ++lf[dat[i]];
        }
        pos = $461bf5d8bd29e0d8$var$wblk(dat, w, lst, syms, lf, df, eb, li, bs, i - bs, pos);
        if (!lst) {
            st.r = pos & 7 | w[pos / 8 | 0] << 3;
            // shft(pos) now 1 less if pos & 7 != 0
            pos -= 7;
            st.h = head, st.p = prev, st.i = i, st.w = wi;
        }
    } else {
        for(var i = st.w || 0; i < s + lst; i += 65535){
            // end
            var e = i + 65535;
            if (e >= s) {
                // write final block
                w[pos / 8 | 0] = lst;
                e = s;
            }
            pos = $461bf5d8bd29e0d8$var$wfblk(w, pos + 1, dat.subarray(i, e));
        }
        st.i = s;
    }
    return $461bf5d8bd29e0d8$var$slc(o, 0, pre + $461bf5d8bd29e0d8$var$shft(pos) + post);
};
// CRC32 table
var $461bf5d8bd29e0d8$var$crct = /*#__PURE__*/ function() {
    var t = new Int32Array(256);
    for(var i = 0; i < 256; ++i){
        var c = i, k = 9;
        while(--k)c = (c & 1 && -306674912) ^ c >>> 1;
        t[i] = c;
    }
    return t;
}();
// CRC32
var $461bf5d8bd29e0d8$var$crc = function() {
    var c = -1;
    return {
        p: function(d) {
            // closures have awful performance
            var cr = c;
            for(var i = 0; i < d.length; ++i)cr = $461bf5d8bd29e0d8$var$crct[cr & 255 ^ d[i]] ^ cr >>> 8;
            c = cr;
        },
        d: function() {
            return ~c;
        }
    };
};
// Adler32
var $461bf5d8bd29e0d8$var$adler = function() {
    var a = 1, b = 0;
    return {
        p: function(d) {
            // closures have awful performance
            var n = a, m = b;
            var l = d.length | 0;
            for(var i = 0; i != l;){
                var e = Math.min(i + 2655, l);
                for(; i < e; ++i)m += n += d[i];
                n = (n & 65535) + 15 * (n >> 16), m = (m & 65535) + 15 * (m >> 16);
            }
            a = n, b = m;
        },
        d: function() {
            a %= 65521, b %= 65521;
            return (a & 255) << 24 | (a & 0xFF00) << 8 | (b & 255) << 8 | b >> 8;
        }
    };
};
// deflate with opts
var $461bf5d8bd29e0d8$var$dopt = function(dat, opt, pre, post, st) {
    if (!st) {
        st = {
            l: 1
        };
        if (opt.dictionary) {
            var dict = opt.dictionary.subarray(-32768);
            var newDat = new $461bf5d8bd29e0d8$var$u8(dict.length + dat.length);
            newDat.set(dict);
            newDat.set(dat, dict.length);
            dat = newDat;
            st.w = dict.length;
        }
    }
    return $461bf5d8bd29e0d8$var$dflt(dat, opt.level == null ? 6 : opt.level, opt.mem == null ? st.l ? Math.ceil(Math.max(8, Math.min(13, Math.log(dat.length))) * 1.5) : 20 : 12 + opt.mem, pre, post, st);
};
// Walmart object spread
var $461bf5d8bd29e0d8$var$mrg = function(a, b) {
    var o = {};
    for(var k in a)o[k] = a[k];
    for(var k in b)o[k] = b[k];
    return o;
};
// worker clone
// This is possibly the craziest part of the entire codebase, despite how simple it may seem.
// The only parameter to this function is a closure that returns an array of variables outside of the function scope.
// We're going to try to figure out the variable names used in the closure as strings because that is crucial for workerization.
// We will return an object mapping of true variable name to value (basically, the current scope as a JS object).
// The reason we can't just use the original variable names is minifiers mangling the toplevel scope.
// This took me three weeks to figure out how to do.
var $461bf5d8bd29e0d8$var$wcln = function(fn, fnStr, td) {
    var dt = fn();
    var st = fn.toString();
    var ks = st.slice(st.indexOf('[') + 1, st.lastIndexOf(']')).replace(/\s+/g, '').split(',');
    for(var i = 0; i < dt.length; ++i){
        var v = dt[i], k = ks[i];
        if (typeof v == 'function') {
            fnStr += ';' + k + '=';
            var st_1 = v.toString();
            if (v.prototype) {
                // for global objects
                if (st_1.indexOf('[native code]') != -1) {
                    var spInd = st_1.indexOf(' ', 8) + 1;
                    fnStr += st_1.slice(spInd, st_1.indexOf('(', spInd));
                } else {
                    fnStr += st_1;
                    for(var t in v.prototype)fnStr += ';' + k + '.prototype.' + t + '=' + v.prototype[t].toString();
                }
            } else fnStr += st_1;
        } else td[k] = v;
    }
    return fnStr;
};
var $461bf5d8bd29e0d8$var$ch = [];
// clone bufs
var $461bf5d8bd29e0d8$var$cbfs = function(v) {
    var tl = [];
    for(var k in v)if (v[k].buffer) tl.push((v[k] = new v[k].constructor(v[k])).buffer);
    return tl;
};
// use a worker to execute code
var $461bf5d8bd29e0d8$var$wrkr = function(fns, init, id, cb) {
    if (!$461bf5d8bd29e0d8$var$ch[id]) {
        var fnStr = '', td_1 = {}, m = fns.length - 1;
        for(var i = 0; i < m; ++i)fnStr = $461bf5d8bd29e0d8$var$wcln(fns[i], fnStr, td_1);
        $461bf5d8bd29e0d8$var$ch[id] = {
            c: $461bf5d8bd29e0d8$var$wcln(fns[m], fnStr, td_1),
            e: td_1
        };
    }
    var td = $461bf5d8bd29e0d8$var$mrg({}, $461bf5d8bd29e0d8$var$ch[id].e);
    return $461bf5d8bd29e0d8$var$wk($461bf5d8bd29e0d8$var$ch[id].c + ';onmessage=function(e){for(var k in e.data)self[k]=e.data[k];onmessage=' + init.toString() + '}', id, td, $461bf5d8bd29e0d8$var$cbfs(td), cb);
};
// base async inflate fn
var $461bf5d8bd29e0d8$var$bInflt = function() {
    return [
        $461bf5d8bd29e0d8$var$u8,
        $461bf5d8bd29e0d8$var$u16,
        $461bf5d8bd29e0d8$var$i32,
        $461bf5d8bd29e0d8$var$fleb,
        $461bf5d8bd29e0d8$var$fdeb,
        $461bf5d8bd29e0d8$var$clim,
        $461bf5d8bd29e0d8$var$fl,
        $461bf5d8bd29e0d8$var$fd,
        $461bf5d8bd29e0d8$var$flrm,
        $461bf5d8bd29e0d8$var$fdrm,
        $461bf5d8bd29e0d8$var$rev,
        $461bf5d8bd29e0d8$var$ec,
        $461bf5d8bd29e0d8$var$hMap,
        $461bf5d8bd29e0d8$var$max,
        $461bf5d8bd29e0d8$var$bits,
        $461bf5d8bd29e0d8$var$bits16,
        $461bf5d8bd29e0d8$var$shft,
        $461bf5d8bd29e0d8$var$slc,
        $461bf5d8bd29e0d8$var$err,
        $461bf5d8bd29e0d8$var$inflt,
        $461bf5d8bd29e0d8$export$90366d8b308ba94a,
        $461bf5d8bd29e0d8$var$pbf,
        $461bf5d8bd29e0d8$var$gopt
    ];
};
var $461bf5d8bd29e0d8$var$bDflt = function() {
    return [
        $461bf5d8bd29e0d8$var$u8,
        $461bf5d8bd29e0d8$var$u16,
        $461bf5d8bd29e0d8$var$i32,
        $461bf5d8bd29e0d8$var$fleb,
        $461bf5d8bd29e0d8$var$fdeb,
        $461bf5d8bd29e0d8$var$clim,
        $461bf5d8bd29e0d8$var$revfl,
        $461bf5d8bd29e0d8$var$revfd,
        $461bf5d8bd29e0d8$var$flm,
        $461bf5d8bd29e0d8$var$flt,
        $461bf5d8bd29e0d8$var$fdm,
        $461bf5d8bd29e0d8$var$fdt,
        $461bf5d8bd29e0d8$var$rev,
        $461bf5d8bd29e0d8$var$deo,
        $461bf5d8bd29e0d8$var$et,
        $461bf5d8bd29e0d8$var$hMap,
        $461bf5d8bd29e0d8$var$wbits,
        $461bf5d8bd29e0d8$var$wbits16,
        $461bf5d8bd29e0d8$var$hTree,
        $461bf5d8bd29e0d8$var$ln,
        $461bf5d8bd29e0d8$var$lc,
        $461bf5d8bd29e0d8$var$clen,
        $461bf5d8bd29e0d8$var$wfblk,
        $461bf5d8bd29e0d8$var$wblk,
        $461bf5d8bd29e0d8$var$shft,
        $461bf5d8bd29e0d8$var$slc,
        $461bf5d8bd29e0d8$var$dflt,
        $461bf5d8bd29e0d8$var$dopt,
        $461bf5d8bd29e0d8$export$21533ff51b8a0b4a,
        $461bf5d8bd29e0d8$var$pbf
    ];
};
// gzip extra
var $461bf5d8bd29e0d8$var$gze = function() {
    return [
        $461bf5d8bd29e0d8$var$gzh,
        $461bf5d8bd29e0d8$var$gzhl,
        $461bf5d8bd29e0d8$var$wbytes,
        $461bf5d8bd29e0d8$var$crc,
        $461bf5d8bd29e0d8$var$crct
    ];
};
// gunzip extra
var $461bf5d8bd29e0d8$var$guze = function() {
    return [
        $461bf5d8bd29e0d8$var$gzs,
        $461bf5d8bd29e0d8$var$gzl
    ];
};
// zlib extra
var $461bf5d8bd29e0d8$var$zle = function() {
    return [
        $461bf5d8bd29e0d8$var$zlh,
        $461bf5d8bd29e0d8$var$wbytes,
        $461bf5d8bd29e0d8$var$adler
    ];
};
// unzlib extra
var $461bf5d8bd29e0d8$var$zule = function() {
    return [
        $461bf5d8bd29e0d8$var$zls
    ];
};
// post buf
var $461bf5d8bd29e0d8$var$pbf = function(msg) {
    return postMessage(msg, [
        msg.buffer
    ]);
};
// get opts
var $461bf5d8bd29e0d8$var$gopt = function(o) {
    return o && {
        out: o.size && new $461bf5d8bd29e0d8$var$u8(o.size),
        dictionary: o.dictionary
    };
};
// async helper
var $461bf5d8bd29e0d8$var$cbify = function(dat, opts, fns, init, id, cb) {
    var w = $461bf5d8bd29e0d8$var$wrkr(fns, init, id, function(err, dat) {
        w.terminate();
        cb(err, dat);
    });
    w.postMessage([
        dat,
        opts
    ], opts.consume ? [
        dat.buffer
    ] : []);
    return function() {
        w.terminate();
    };
};
// auto stream
var $461bf5d8bd29e0d8$var$astrm = function(strm) {
    strm.ondata = function(dat, final) {
        return postMessage([
            dat,
            final
        ], [
            dat.buffer
        ]);
    };
    return function(ev) {
        if (ev.data.length) {
            strm.push(ev.data[0], ev.data[1]);
            postMessage([
                ev.data[0].length
            ]);
        } else strm.flush();
    };
};
// async stream attach
var $461bf5d8bd29e0d8$var$astrmify = function(fns, strm, opts, init, id, flush, ext) {
    var t;
    var w = $461bf5d8bd29e0d8$var$wrkr(fns, init, id, function(err, dat) {
        if (err) w.terminate(), strm.ondata.call(strm, err);
        else if (!Array.isArray(dat)) ext(dat);
        else if (dat.length == 1) {
            strm.queuedSize -= dat[0];
            if (strm.ondrain) strm.ondrain(dat[0]);
        } else {
            if (dat[1]) w.terminate();
            strm.ondata.call(strm, err, dat[0], dat[1]);
        }
    });
    w.postMessage(opts);
    strm.queuedSize = 0;
    strm.push = function(d, f) {
        if (!strm.ondata) $461bf5d8bd29e0d8$var$err(5);
        if (t) strm.ondata($461bf5d8bd29e0d8$var$err(4, 0, 1), null, !!f);
        strm.queuedSize += d.length;
        w.postMessage([
            d,
            t = f
        ], [
            d.buffer
        ]);
    };
    strm.terminate = function() {
        w.terminate();
    };
    if (flush) strm.flush = function() {
        w.postMessage([]);
    };
};
// read 2 bytes
var $461bf5d8bd29e0d8$var$b2 = function(d, b) {
    return d[b] | d[b + 1] << 8;
};
// read 4 bytes
var $461bf5d8bd29e0d8$var$b4 = function(d, b) {
    return (d[b] | d[b + 1] << 8 | d[b + 2] << 16 | d[b + 3] << 24) >>> 0;
};
var $461bf5d8bd29e0d8$var$b8 = function(d, b) {
    return $461bf5d8bd29e0d8$var$b4(d, b) + $461bf5d8bd29e0d8$var$b4(d, b + 4) * 4294967296;
};
// write bytes
var $461bf5d8bd29e0d8$var$wbytes = function(d, b, v) {
    for(; v; ++b)d[b] = v, v >>>= 8;
};
// gzip header
var $461bf5d8bd29e0d8$var$gzh = function(c, o) {
    var fn = o.filename;
    c[0] = 31, c[1] = 139, c[2] = 8, c[8] = o.level < 2 ? 4 : o.level == 9 ? 2 : 0, c[9] = 3; // assume Unix
    if (o.mtime != 0) $461bf5d8bd29e0d8$var$wbytes(c, 4, Math.floor(new Date(o.mtime || Date.now()) / 1000));
    if (fn) {
        c[3] = 8;
        for(var i = 0; i <= fn.length; ++i)c[i + 10] = fn.charCodeAt(i);
    }
};
// gzip footer: -8 to -4 = CRC, -4 to -0 is length
// gzip start
var $461bf5d8bd29e0d8$var$gzs = function(d) {
    if (d[0] != 31 || d[1] != 139 || d[2] != 8) $461bf5d8bd29e0d8$var$err(6, 'invalid gzip data');
    var flg = d[3];
    var st = 10;
    if (flg & 4) st += (d[10] | d[11] << 8) + 2;
    for(var zs = (flg >> 3 & 1) + (flg >> 4 & 1); zs > 0; zs -= !d[st++]);
    return st + (flg & 2);
};
// gzip length
var $461bf5d8bd29e0d8$var$gzl = function(d) {
    var l = d.length;
    return (d[l - 4] | d[l - 3] << 8 | d[l - 2] << 16 | d[l - 1] << 24) >>> 0;
};
// gzip header length
var $461bf5d8bd29e0d8$var$gzhl = function(o) {
    return 10 + (o.filename ? o.filename.length + 1 : 0);
};
// zlib header
var $461bf5d8bd29e0d8$var$zlh = function(c, o) {
    var lv = o.level, fl = lv == 0 ? 0 : lv < 6 ? 1 : lv == 9 ? 3 : 2;
    c[0] = 120, c[1] = fl << 6 | (o.dictionary && 32);
    c[1] |= 31 - (c[0] << 8 | c[1]) % 31;
    if (o.dictionary) {
        var h = $461bf5d8bd29e0d8$var$adler();
        h.p(o.dictionary);
        $461bf5d8bd29e0d8$var$wbytes(c, 2, h.d());
    }
};
// zlib start
var $461bf5d8bd29e0d8$var$zls = function(d, dict) {
    if ((d[0] & 15) != 8 || d[0] >> 4 > 7 || (d[0] << 8 | d[1]) % 31) $461bf5d8bd29e0d8$var$err(6, 'invalid zlib data');
    if ((d[1] >> 5 & 1) == +!dict) $461bf5d8bd29e0d8$var$err(6, 'invalid zlib data: ' + (d[1] & 32 ? 'need' : 'unexpected') + ' dictionary');
    return (d[1] >> 3 & 4) + 2;
};
function $461bf5d8bd29e0d8$var$StrmOpt(opts, cb) {
    if (typeof opts == 'function') cb = opts, opts = {};
    this.ondata = cb;
    return opts;
}
/**
 * Streaming DEFLATE compression
 */ var $461bf5d8bd29e0d8$export$ae157b6234afe138 = /*#__PURE__*/ function() {
    function Deflate(opts, cb) {
        if (typeof opts == 'function') cb = opts, opts = {};
        this.ondata = cb;
        this.o = opts || {};
        this.s = {
            l: 0,
            i: 32768,
            w: 32768,
            z: 32768
        };
        // Buffer length must always be 0 mod 32768 for index calculations to be correct when modifying head and prev
        // 98304 = 32768 (lookback) + 65536 (common chunk size)
        this.b = new $461bf5d8bd29e0d8$var$u8(98304);
        if (this.o.dictionary) {
            var dict = this.o.dictionary.subarray(-32768);
            this.b.set(dict, 32768 - dict.length);
            this.s.i = 32768 - dict.length;
        }
    }
    Deflate.prototype.p = function(c, f) {
        this.ondata($461bf5d8bd29e0d8$var$dopt(c, this.o, 0, 0, this.s), f);
    };
    /**
     * Pushes a chunk to be deflated
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Deflate.prototype.push = function(chunk, final) {
        if (!this.ondata) $461bf5d8bd29e0d8$var$err(5);
        if (this.s.l) $461bf5d8bd29e0d8$var$err(4);
        var endLen = chunk.length + this.s.z;
        if (endLen > this.b.length) {
            if (endLen > 2 * this.b.length - 32768) {
                var newBuf = new $461bf5d8bd29e0d8$var$u8(endLen & -32768);
                newBuf.set(this.b.subarray(0, this.s.z));
                this.b = newBuf;
            }
            var split = this.b.length - this.s.z;
            this.b.set(chunk.subarray(0, split), this.s.z);
            this.s.z = this.b.length;
            this.p(this.b, false);
            this.b.set(this.b.subarray(-32768));
            this.b.set(chunk.subarray(split), 32768);
            this.s.z = chunk.length - split + 32768;
            this.s.i = 32766, this.s.w = 32768;
        } else {
            this.b.set(chunk, this.s.z);
            this.s.z += chunk.length;
        }
        this.s.l = final & 1;
        if (this.s.z > this.s.w + 8191 || final) {
            this.p(this.b, final || false);
            this.s.w = this.s.i, this.s.i -= 2;
        }
    };
    /**
     * Flushes buffered uncompressed data. Useful to immediately retrieve the
     * deflated output for small inputs.
     */ Deflate.prototype.flush = function() {
        if (!this.ondata) $461bf5d8bd29e0d8$var$err(5);
        if (this.s.l) $461bf5d8bd29e0d8$var$err(4);
        this.p(this.b, false);
        this.s.w = this.s.i, this.s.i -= 2;
    };
    return Deflate;
}();
/**
 * Asynchronous streaming DEFLATE compression
 */ var $461bf5d8bd29e0d8$export$84e526fabcba03e3 = /*#__PURE__*/ function() {
    function AsyncDeflate(opts, cb) {
        $461bf5d8bd29e0d8$var$astrmify([
            $461bf5d8bd29e0d8$var$bDflt,
            function() {
                return [
                    $461bf5d8bd29e0d8$var$astrm,
                    $461bf5d8bd29e0d8$export$ae157b6234afe138
                ];
            }
        ], this, $461bf5d8bd29e0d8$var$StrmOpt.call(this, opts, cb), function(ev) {
            var strm = new $461bf5d8bd29e0d8$export$ae157b6234afe138(ev.data);
            onmessage = $461bf5d8bd29e0d8$var$astrm(strm);
        }, 6, 1);
    }
    return AsyncDeflate;
}();
function $461bf5d8bd29e0d8$export$2316623ecd1285ab(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $461bf5d8bd29e0d8$var$err(7);
    return $461bf5d8bd29e0d8$var$cbify(data, opts, [
        $461bf5d8bd29e0d8$var$bDflt
    ], function(ev) {
        return $461bf5d8bd29e0d8$var$pbf($461bf5d8bd29e0d8$export$21533ff51b8a0b4a(ev.data[0], ev.data[1]));
    }, 0, cb);
}
function $461bf5d8bd29e0d8$export$21533ff51b8a0b4a(data, opts) {
    return $461bf5d8bd29e0d8$var$dopt(data, opts || {}, 0, 0);
}
/**
 * Streaming DEFLATE decompression
 */ var $461bf5d8bd29e0d8$export$d1de70a877d6e43c = /*#__PURE__*/ function() {
    function Inflate(opts, cb) {
        // no StrmOpt here to avoid adding to workerizer
        if (typeof opts == 'function') cb = opts, opts = {};
        this.ondata = cb;
        var dict = opts && opts.dictionary && opts.dictionary.subarray(-32768);
        this.s = {
            i: 0,
            b: dict ? dict.length : 0
        };
        this.o = new $461bf5d8bd29e0d8$var$u8(32768);
        this.p = new $461bf5d8bd29e0d8$var$u8(0);
        if (dict) this.o.set(dict);
    }
    Inflate.prototype.e = function(c) {
        if (!this.ondata) $461bf5d8bd29e0d8$var$err(5);
        if (this.d) $461bf5d8bd29e0d8$var$err(4);
        if (!this.p.length) this.p = c;
        else if (c.length) {
            var n = new $461bf5d8bd29e0d8$var$u8(this.p.length + c.length);
            n.set(this.p), n.set(c, this.p.length), this.p = n;
        }
    };
    Inflate.prototype.c = function(final) {
        this.s.i = +(this.d = final || false);
        var bts = this.s.b;
        var dt = $461bf5d8bd29e0d8$var$inflt(this.p, this.s, this.o);
        this.ondata($461bf5d8bd29e0d8$var$slc(dt, bts, this.s.b), this.d);
        this.o = $461bf5d8bd29e0d8$var$slc(dt, this.s.b - 32768), this.s.b = this.o.length;
        this.p = $461bf5d8bd29e0d8$var$slc(this.p, this.s.p / 8 | 0), this.s.p &= 7;
    };
    /**
     * Pushes a chunk to be inflated
     * @param chunk The chunk to push
     * @param final Whether this is the final chunk
     */ Inflate.prototype.push = function(chunk, final) {
        this.e(chunk), this.c(final);
    };
    return Inflate;
}();
/**
 * Asynchronous streaming DEFLATE decompression
 */ var $461bf5d8bd29e0d8$export$fff8358d6dbaa9cc = /*#__PURE__*/ function() {
    function AsyncInflate(opts, cb) {
        $461bf5d8bd29e0d8$var$astrmify([
            $461bf5d8bd29e0d8$var$bInflt,
            function() {
                return [
                    $461bf5d8bd29e0d8$var$astrm,
                    $461bf5d8bd29e0d8$export$d1de70a877d6e43c
                ];
            }
        ], this, $461bf5d8bd29e0d8$var$StrmOpt.call(this, opts, cb), function(ev) {
            var strm = new $461bf5d8bd29e0d8$export$d1de70a877d6e43c(ev.data);
            onmessage = $461bf5d8bd29e0d8$var$astrm(strm);
        }, 7, 0);
    }
    return AsyncInflate;
}();
function $461bf5d8bd29e0d8$export$cae1ce83fe4a1782(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $461bf5d8bd29e0d8$var$err(7);
    return $461bf5d8bd29e0d8$var$cbify(data, opts, [
        $461bf5d8bd29e0d8$var$bInflt
    ], function(ev) {
        return $461bf5d8bd29e0d8$var$pbf($461bf5d8bd29e0d8$export$90366d8b308ba94a(ev.data[0], $461bf5d8bd29e0d8$var$gopt(ev.data[1])));
    }, 1, cb);
}
function $461bf5d8bd29e0d8$export$90366d8b308ba94a(data, opts) {
    return $461bf5d8bd29e0d8$var$inflt(data, {
        i: 2
    }, opts && opts.out, opts && opts.dictionary);
}
// before you yell at me for not just using extends, my reason is that TS inheritance is hard to workerize.
/**
 * Streaming GZIP compression
 */ var $461bf5d8bd29e0d8$export$8e4b66d280bf8342 = /*#__PURE__*/ function() {
    function Gzip(opts, cb) {
        this.c = $461bf5d8bd29e0d8$var$crc();
        this.l = 0;
        this.v = 1;
        $461bf5d8bd29e0d8$export$ae157b6234afe138.call(this, opts, cb);
    }
    /**
     * Pushes a chunk to be GZIPped
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Gzip.prototype.push = function(chunk, final) {
        this.c.p(chunk);
        this.l += chunk.length;
        $461bf5d8bd29e0d8$export$ae157b6234afe138.prototype.push.call(this, chunk, final);
    };
    Gzip.prototype.p = function(c, f) {
        var raw = $461bf5d8bd29e0d8$var$dopt(c, this.o, this.v && $461bf5d8bd29e0d8$var$gzhl(this.o), f && 8, this.s);
        if (this.v) $461bf5d8bd29e0d8$var$gzh(raw, this.o), this.v = 0;
        if (f) $461bf5d8bd29e0d8$var$wbytes(raw, raw.length - 8, this.c.d()), $461bf5d8bd29e0d8$var$wbytes(raw, raw.length - 4, this.l);
        this.ondata(raw, f);
    };
    /**
     * Flushes buffered uncompressed data. Useful to immediately retrieve the
     * GZIPped output for small inputs.
     */ Gzip.prototype.flush = function() {
        $461bf5d8bd29e0d8$export$ae157b6234afe138.prototype.flush.call(this);
    };
    return Gzip;
}();
/**
 * Asynchronous streaming GZIP compression
 */ var $461bf5d8bd29e0d8$export$b4c75ae96cdf708b = /*#__PURE__*/ function() {
    function AsyncGzip(opts, cb) {
        $461bf5d8bd29e0d8$var$astrmify([
            $461bf5d8bd29e0d8$var$bDflt,
            $461bf5d8bd29e0d8$var$gze,
            function() {
                return [
                    $461bf5d8bd29e0d8$var$astrm,
                    $461bf5d8bd29e0d8$export$ae157b6234afe138,
                    $461bf5d8bd29e0d8$export$8e4b66d280bf8342
                ];
            }
        ], this, $461bf5d8bd29e0d8$var$StrmOpt.call(this, opts, cb), function(ev) {
            var strm = new $461bf5d8bd29e0d8$export$8e4b66d280bf8342(ev.data);
            onmessage = $461bf5d8bd29e0d8$var$astrm(strm);
        }, 8, 1);
    }
    return AsyncGzip;
}();
function $461bf5d8bd29e0d8$export$69f0ea7cf3a331a8(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $461bf5d8bd29e0d8$var$err(7);
    return $461bf5d8bd29e0d8$var$cbify(data, opts, [
        $461bf5d8bd29e0d8$var$bDflt,
        $461bf5d8bd29e0d8$var$gze,
        function() {
            return [
                $461bf5d8bd29e0d8$export$3d616c3fb3e15483
            ];
        }
    ], function(ev) {
        return $461bf5d8bd29e0d8$var$pbf($461bf5d8bd29e0d8$export$3d616c3fb3e15483(ev.data[0], ev.data[1]));
    }, 2, cb);
}
function $461bf5d8bd29e0d8$export$3d616c3fb3e15483(data, opts) {
    if (!opts) opts = {};
    var c = $461bf5d8bd29e0d8$var$crc(), l = data.length;
    c.p(data);
    var d = $461bf5d8bd29e0d8$var$dopt(data, opts, $461bf5d8bd29e0d8$var$gzhl(opts), 8), s = d.length;
    return $461bf5d8bd29e0d8$var$gzh(d, opts), $461bf5d8bd29e0d8$var$wbytes(d, s - 8, c.d()), $461bf5d8bd29e0d8$var$wbytes(d, s - 4, l), d;
}
/**
 * Streaming single or multi-member GZIP decompression
 */ var $461bf5d8bd29e0d8$export$4cb607de6db70415 = /*#__PURE__*/ function() {
    function Gunzip(opts, cb) {
        this.v = 1;
        this.r = 0;
        $461bf5d8bd29e0d8$export$d1de70a877d6e43c.call(this, opts, cb);
    }
    /**
     * Pushes a chunk to be GUNZIPped
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Gunzip.prototype.push = function(chunk, final) {
        $461bf5d8bd29e0d8$export$d1de70a877d6e43c.prototype.e.call(this, chunk);
        this.r += chunk.length;
        if (this.v) {
            var p = this.p.subarray(this.v - 1);
            var s = p.length > 3 ? $461bf5d8bd29e0d8$var$gzs(p) : 4;
            if (s > p.length) {
                if (!final) return;
            } else if (this.v > 1 && this.onmember) this.onmember(this.r - p.length);
            this.p = p.subarray(s), this.v = 0;
        }
        // necessary to prevent TS from using the closure value
        // This allows for workerization to function correctly
        $461bf5d8bd29e0d8$export$d1de70a877d6e43c.prototype.c.call(this, final);
        // process concatenated GZIP
        if (this.s.f && !this.s.l && !final) {
            this.v = $461bf5d8bd29e0d8$var$shft(this.s.p) + 9;
            this.s = {
                i: 0
            };
            this.o = new $461bf5d8bd29e0d8$var$u8(0);
            this.push(new $461bf5d8bd29e0d8$var$u8(0), final);
        }
    };
    return Gunzip;
}();
/**
 * Asynchronous streaming single or multi-member GZIP decompression
 */ var $461bf5d8bd29e0d8$export$d5adcdd968132151 = /*#__PURE__*/ function() {
    function AsyncGunzip(opts, cb) {
        var _this = this;
        $461bf5d8bd29e0d8$var$astrmify([
            $461bf5d8bd29e0d8$var$bInflt,
            $461bf5d8bd29e0d8$var$guze,
            function() {
                return [
                    $461bf5d8bd29e0d8$var$astrm,
                    $461bf5d8bd29e0d8$export$d1de70a877d6e43c,
                    $461bf5d8bd29e0d8$export$4cb607de6db70415
                ];
            }
        ], this, $461bf5d8bd29e0d8$var$StrmOpt.call(this, opts, cb), function(ev) {
            var strm = new $461bf5d8bd29e0d8$export$4cb607de6db70415(ev.data);
            strm.onmember = function(offset) {
                return postMessage(offset);
            };
            onmessage = $461bf5d8bd29e0d8$var$astrm(strm);
        }, 9, 0, function(offset) {
            return _this.onmember && _this.onmember(offset);
        });
    }
    return AsyncGunzip;
}();
function $461bf5d8bd29e0d8$export$b6df3e950734d697(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $461bf5d8bd29e0d8$var$err(7);
    return $461bf5d8bd29e0d8$var$cbify(data, opts, [
        $461bf5d8bd29e0d8$var$bInflt,
        $461bf5d8bd29e0d8$var$guze,
        function() {
            return [
                $461bf5d8bd29e0d8$export$c80456f7aaba691c
            ];
        }
    ], function(ev) {
        return $461bf5d8bd29e0d8$var$pbf($461bf5d8bd29e0d8$export$c80456f7aaba691c(ev.data[0], ev.data[1]));
    }, 3, cb);
}
function $461bf5d8bd29e0d8$export$c80456f7aaba691c(data, opts) {
    var st = $461bf5d8bd29e0d8$var$gzs(data);
    if (st + 8 > data.length) $461bf5d8bd29e0d8$var$err(6, 'invalid gzip data');
    return $461bf5d8bd29e0d8$var$inflt(data.subarray(st, -8), {
        i: 2
    }, opts && opts.out || new $461bf5d8bd29e0d8$var$u8($461bf5d8bd29e0d8$var$gzl(data)), opts && opts.dictionary);
}
/**
 * Streaming Zlib compression
 */ var $461bf5d8bd29e0d8$export$4187ccf2467013b9 = /*#__PURE__*/ function() {
    function Zlib(opts, cb) {
        this.c = $461bf5d8bd29e0d8$var$adler();
        this.v = 1;
        $461bf5d8bd29e0d8$export$ae157b6234afe138.call(this, opts, cb);
    }
    /**
     * Pushes a chunk to be zlibbed
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Zlib.prototype.push = function(chunk, final) {
        this.c.p(chunk);
        $461bf5d8bd29e0d8$export$ae157b6234afe138.prototype.push.call(this, chunk, final);
    };
    Zlib.prototype.p = function(c, f) {
        var raw = $461bf5d8bd29e0d8$var$dopt(c, this.o, this.v && (this.o.dictionary ? 6 : 2), f && 4, this.s);
        if (this.v) $461bf5d8bd29e0d8$var$zlh(raw, this.o), this.v = 0;
        if (f) $461bf5d8bd29e0d8$var$wbytes(raw, raw.length - 4, this.c.d());
        this.ondata(raw, f);
    };
    /**
     * Flushes buffered uncompressed data. Useful to immediately retrieve the
     * zlibbed output for small inputs.
     */ Zlib.prototype.flush = function() {
        $461bf5d8bd29e0d8$export$ae157b6234afe138.prototype.flush.call(this);
    };
    return Zlib;
}();
/**
 * Asynchronous streaming Zlib compression
 */ var $461bf5d8bd29e0d8$export$bedbe3a2c2136490 = /*#__PURE__*/ function() {
    function AsyncZlib(opts, cb) {
        $461bf5d8bd29e0d8$var$astrmify([
            $461bf5d8bd29e0d8$var$bDflt,
            $461bf5d8bd29e0d8$var$zle,
            function() {
                return [
                    $461bf5d8bd29e0d8$var$astrm,
                    $461bf5d8bd29e0d8$export$ae157b6234afe138,
                    $461bf5d8bd29e0d8$export$4187ccf2467013b9
                ];
            }
        ], this, $461bf5d8bd29e0d8$var$StrmOpt.call(this, opts, cb), function(ev) {
            var strm = new $461bf5d8bd29e0d8$export$4187ccf2467013b9(ev.data);
            onmessage = $461bf5d8bd29e0d8$var$astrm(strm);
        }, 10, 1);
    }
    return AsyncZlib;
}();
function $461bf5d8bd29e0d8$export$925212de7058410b(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $461bf5d8bd29e0d8$var$err(7);
    return $461bf5d8bd29e0d8$var$cbify(data, opts, [
        $461bf5d8bd29e0d8$var$bDflt,
        $461bf5d8bd29e0d8$var$zle,
        function() {
            return [
                $461bf5d8bd29e0d8$export$f87121a6d50aff25
            ];
        }
    ], function(ev) {
        return $461bf5d8bd29e0d8$var$pbf($461bf5d8bd29e0d8$export$f87121a6d50aff25(ev.data[0], ev.data[1]));
    }, 4, cb);
}
function $461bf5d8bd29e0d8$export$f87121a6d50aff25(data, opts) {
    if (!opts) opts = {};
    var a = $461bf5d8bd29e0d8$var$adler();
    a.p(data);
    var d = $461bf5d8bd29e0d8$var$dopt(data, opts, opts.dictionary ? 6 : 2, 4);
    return $461bf5d8bd29e0d8$var$zlh(d, opts), $461bf5d8bd29e0d8$var$wbytes(d, d.length - 4, a.d()), d;
}
/**
 * Streaming Zlib decompression
 */ var $461bf5d8bd29e0d8$export$af2424f875ff1b17 = /*#__PURE__*/ function() {
    function Unzlib(opts, cb) {
        $461bf5d8bd29e0d8$export$d1de70a877d6e43c.call(this, opts, cb);
        this.v = opts && opts.dictionary ? 2 : 1;
    }
    /**
     * Pushes a chunk to be unzlibbed
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Unzlib.prototype.push = function(chunk, final) {
        $461bf5d8bd29e0d8$export$d1de70a877d6e43c.prototype.e.call(this, chunk);
        if (this.v) {
            if (this.p.length < 6 && !final) return;
            this.p = this.p.subarray($461bf5d8bd29e0d8$var$zls(this.p, this.v - 1)), this.v = 0;
        }
        if (final) {
            if (this.p.length < 4) $461bf5d8bd29e0d8$var$err(6, 'invalid zlib data');
            this.p = this.p.subarray(0, -4);
        }
        // necessary to prevent TS from using the closure value
        // This allows for workerization to function correctly
        $461bf5d8bd29e0d8$export$d1de70a877d6e43c.prototype.c.call(this, final);
    };
    return Unzlib;
}();
/**
 * Asynchronous streaming Zlib decompression
 */ var $461bf5d8bd29e0d8$export$cf6668790220dcad = /*#__PURE__*/ function() {
    function AsyncUnzlib(opts, cb) {
        $461bf5d8bd29e0d8$var$astrmify([
            $461bf5d8bd29e0d8$var$bInflt,
            $461bf5d8bd29e0d8$var$zule,
            function() {
                return [
                    $461bf5d8bd29e0d8$var$astrm,
                    $461bf5d8bd29e0d8$export$d1de70a877d6e43c,
                    $461bf5d8bd29e0d8$export$af2424f875ff1b17
                ];
            }
        ], this, $461bf5d8bd29e0d8$var$StrmOpt.call(this, opts, cb), function(ev) {
            var strm = new $461bf5d8bd29e0d8$export$af2424f875ff1b17(ev.data);
            onmessage = $461bf5d8bd29e0d8$var$astrm(strm);
        }, 11, 0);
    }
    return AsyncUnzlib;
}();
function $461bf5d8bd29e0d8$export$ca7cbb494e731274(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $461bf5d8bd29e0d8$var$err(7);
    return $461bf5d8bd29e0d8$var$cbify(data, opts, [
        $461bf5d8bd29e0d8$var$bInflt,
        $461bf5d8bd29e0d8$var$zule,
        function() {
            return [
                $461bf5d8bd29e0d8$export$9ec8134f0f1b9fc6
            ];
        }
    ], function(ev) {
        return $461bf5d8bd29e0d8$var$pbf($461bf5d8bd29e0d8$export$9ec8134f0f1b9fc6(ev.data[0], $461bf5d8bd29e0d8$var$gopt(ev.data[1])));
    }, 5, cb);
}
function $461bf5d8bd29e0d8$export$9ec8134f0f1b9fc6(data, opts) {
    return $461bf5d8bd29e0d8$var$inflt(data.subarray($461bf5d8bd29e0d8$var$zls(data, opts && opts.dictionary), -4), {
        i: 2
    }, opts && opts.out, opts && opts.dictionary);
}
/**
 * Streaming GZIP, Zlib, or raw DEFLATE decompression
 */ var $461bf5d8bd29e0d8$export$578fe199ef655b76 = /*#__PURE__*/ function() {
    function Decompress(opts, cb) {
        this.o = $461bf5d8bd29e0d8$var$StrmOpt.call(this, opts, cb) || {};
        this.G = $461bf5d8bd29e0d8$export$4cb607de6db70415;
        this.I = $461bf5d8bd29e0d8$export$d1de70a877d6e43c;
        this.Z = $461bf5d8bd29e0d8$export$af2424f875ff1b17;
    }
    // init substream
    // overriden by AsyncDecompress
    Decompress.prototype.i = function() {
        var _this = this;
        this.s.ondata = function(dat, final) {
            _this.ondata(dat, final);
        };
    };
    /**
     * Pushes a chunk to be decompressed
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Decompress.prototype.push = function(chunk, final) {
        if (!this.ondata) $461bf5d8bd29e0d8$var$err(5);
        if (!this.s) {
            if (this.p && this.p.length) {
                var n = new $461bf5d8bd29e0d8$var$u8(this.p.length + chunk.length);
                n.set(this.p), n.set(chunk, this.p.length);
            } else this.p = chunk;
            if (this.p.length > 2) {
                this.s = this.p[0] == 31 && this.p[1] == 139 && this.p[2] == 8 ? new this.G(this.o) : (this.p[0] & 15) != 8 || this.p[0] >> 4 > 7 || (this.p[0] << 8 | this.p[1]) % 31 ? new this.I(this.o) : new this.Z(this.o);
                this.i();
                this.s.push(this.p, final);
                this.p = null;
            }
        } else this.s.push(chunk, final);
    };
    return Decompress;
}();
/**
 * Asynchronous streaming GZIP, Zlib, or raw DEFLATE decompression
 */ var $461bf5d8bd29e0d8$export$ae2c1d81988d4b43 = /*#__PURE__*/ function() {
    function AsyncDecompress(opts, cb) {
        $461bf5d8bd29e0d8$export$578fe199ef655b76.call(this, opts, cb);
        this.queuedSize = 0;
        this.G = $461bf5d8bd29e0d8$export$d5adcdd968132151;
        this.I = $461bf5d8bd29e0d8$export$fff8358d6dbaa9cc;
        this.Z = $461bf5d8bd29e0d8$export$cf6668790220dcad;
    }
    AsyncDecompress.prototype.i = function() {
        var _this = this;
        this.s.ondata = function(err, dat, final) {
            _this.ondata(err, dat, final);
        };
        this.s.ondrain = function(size) {
            _this.queuedSize -= size;
            if (_this.ondrain) _this.ondrain(size);
        };
    };
    /**
     * Pushes a chunk to be decompressed
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ AsyncDecompress.prototype.push = function(chunk, final) {
        this.queuedSize += chunk.length;
        $461bf5d8bd29e0d8$export$578fe199ef655b76.prototype.push.call(this, chunk, final);
    };
    return AsyncDecompress;
}();
function $461bf5d8bd29e0d8$export$678d868aab8fb3c7(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $461bf5d8bd29e0d8$var$err(7);
    return data[0] == 31 && data[1] == 139 && data[2] == 8 ? $461bf5d8bd29e0d8$export$b6df3e950734d697(data, opts, cb) : (data[0] & 15) != 8 || data[0] >> 4 > 7 || (data[0] << 8 | data[1]) % 31 ? $461bf5d8bd29e0d8$export$cae1ce83fe4a1782(data, opts, cb) : $461bf5d8bd29e0d8$export$ca7cbb494e731274(data, opts, cb);
}
function $461bf5d8bd29e0d8$export$c4bdbbbc9a4faabe(data, opts) {
    return data[0] == 31 && data[1] == 139 && data[2] == 8 ? $461bf5d8bd29e0d8$export$c80456f7aaba691c(data, opts) : (data[0] & 15) != 8 || data[0] >> 4 > 7 || (data[0] << 8 | data[1]) % 31 ? $461bf5d8bd29e0d8$export$90366d8b308ba94a(data, opts) : $461bf5d8bd29e0d8$export$9ec8134f0f1b9fc6(data, opts);
}
// flatten a directory structure
var $461bf5d8bd29e0d8$var$fltn = function(d, p, t, o) {
    for(var k in d){
        var val = d[k], n = p + k, op = o;
        if (Array.isArray(val)) op = $461bf5d8bd29e0d8$var$mrg(o, val[1]), val = val[0];
        if (val instanceof $461bf5d8bd29e0d8$var$u8) t[n] = [
            val,
            op
        ];
        else {
            t[n += '/'] = [
                new $461bf5d8bd29e0d8$var$u8(0),
                op
            ];
            $461bf5d8bd29e0d8$var$fltn(val, n, t, o);
        }
    }
};
// text encoder
var $461bf5d8bd29e0d8$var$te = typeof TextEncoder != 'undefined' && /*#__PURE__*/ new TextEncoder();
// text decoder
var $461bf5d8bd29e0d8$var$td = typeof TextDecoder != 'undefined' && /*#__PURE__*/ new TextDecoder();
// text decoder stream
var $461bf5d8bd29e0d8$var$tds = 0;
try {
    $461bf5d8bd29e0d8$var$td.decode($461bf5d8bd29e0d8$var$et, {
        stream: true
    });
    $461bf5d8bd29e0d8$var$tds = 1;
} catch (e) {}
// decode UTF8
var $461bf5d8bd29e0d8$var$dutf8 = function(d) {
    for(var r = '', i = 0;;){
        var c = d[i++];
        var eb = (c > 127) + (c > 223) + (c > 239);
        if (i + eb > d.length) return {
            s: r,
            r: $461bf5d8bd29e0d8$var$slc(d, i - 1)
        };
        if (!eb) r += String.fromCharCode(c);
        else if (eb == 3) c = ((c & 15) << 18 | (d[i++] & 63) << 12 | (d[i++] & 63) << 6 | d[i++] & 63) - 65536, r += String.fromCharCode(55296 | c >> 10, 56320 | c & 1023);
        else if (eb & 1) r += String.fromCharCode((c & 31) << 6 | d[i++] & 63);
        else r += String.fromCharCode((c & 15) << 12 | (d[i++] & 63) << 6 | d[i++] & 63);
    }
};
/**
 * Streaming UTF-8 decoding
 */ var $461bf5d8bd29e0d8$export$ba46860a31c72e94 = /*#__PURE__*/ function() {
    /**
     * Creates a UTF-8 decoding stream
     * @param cb The callback to call whenever data is decoded
     */ function DecodeUTF8(cb) {
        this.ondata = cb;
        if ($461bf5d8bd29e0d8$var$tds) this.t = new TextDecoder();
        else this.p = $461bf5d8bd29e0d8$var$et;
    }
    /**
     * Pushes a chunk to be decoded from UTF-8 binary
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ DecodeUTF8.prototype.push = function(chunk, final) {
        if (!this.ondata) $461bf5d8bd29e0d8$var$err(5);
        final = !!final;
        if (this.t) {
            this.ondata(this.t.decode(chunk, {
                stream: true
            }), final);
            if (final) {
                if (this.t.decode().length) $461bf5d8bd29e0d8$var$err(8);
                this.t = null;
            }
            return;
        }
        if (!this.p) $461bf5d8bd29e0d8$var$err(4);
        var dat = new $461bf5d8bd29e0d8$var$u8(this.p.length + chunk.length);
        dat.set(this.p);
        dat.set(chunk, this.p.length);
        var _a = $461bf5d8bd29e0d8$var$dutf8(dat), s = _a.s, r = _a.r;
        if (final) {
            if (r.length) $461bf5d8bd29e0d8$var$err(8);
            this.p = null;
        } else this.p = r;
        this.ondata(s, final);
    };
    return DecodeUTF8;
}();
/**
 * Streaming UTF-8 encoding
 */ var $461bf5d8bd29e0d8$export$283f13d12b1b210e = /*#__PURE__*/ function() {
    /**
     * Creates a UTF-8 decoding stream
     * @param cb The callback to call whenever data is encoded
     */ function EncodeUTF8(cb) {
        this.ondata = cb;
    }
    /**
     * Pushes a chunk to be encoded to UTF-8
     * @param chunk The string data to push
     * @param final Whether this is the last chunk
     */ EncodeUTF8.prototype.push = function(chunk, final) {
        if (!this.ondata) $461bf5d8bd29e0d8$var$err(5);
        if (this.d) $461bf5d8bd29e0d8$var$err(4);
        this.ondata($461bf5d8bd29e0d8$export$366b39a6daa8ed7a(chunk), this.d = final || false);
    };
    return EncodeUTF8;
}();
function $461bf5d8bd29e0d8$export$366b39a6daa8ed7a(str, latin1) {
    if (latin1) {
        var ar_1 = new $461bf5d8bd29e0d8$var$u8(str.length);
        for(var i = 0; i < str.length; ++i)ar_1[i] = str.charCodeAt(i);
        return ar_1;
    }
    if ($461bf5d8bd29e0d8$var$te) return $461bf5d8bd29e0d8$var$te.encode(str);
    var l = str.length;
    var ar = new $461bf5d8bd29e0d8$var$u8(str.length + (str.length >> 1));
    var ai = 0;
    var w = function(v) {
        ar[ai++] = v;
    };
    for(var i = 0; i < l; ++i){
        if (ai + 5 > ar.length) {
            var n = new $461bf5d8bd29e0d8$var$u8(ai + 8 + (l - i << 1));
            n.set(ar);
            ar = n;
        }
        var c = str.charCodeAt(i);
        if (c < 128 || latin1) w(c);
        else if (c < 2048) w(192 | c >> 6), w(128 | c & 63);
        else if (c > 55295 && c < 57344) c = 65536 + (c & 1047552) | str.charCodeAt(++i) & 1023, w(240 | c >> 18), w(128 | c >> 12 & 63), w(128 | c >> 6 & 63), w(128 | c & 63);
        else w(224 | c >> 12), w(128 | c >> 6 & 63), w(128 | c & 63);
    }
    return $461bf5d8bd29e0d8$var$slc(ar, 0, ai);
}
function $461bf5d8bd29e0d8$export$adb211f8cb999894(dat, latin1) {
    if (latin1) {
        var r = '';
        for(var i = 0; i < dat.length; i += 16384)r += String.fromCharCode.apply(null, dat.subarray(i, i + 16384));
        return r;
    } else if ($461bf5d8bd29e0d8$var$td) return $461bf5d8bd29e0d8$var$td.decode(dat);
    else {
        var _a = $461bf5d8bd29e0d8$var$dutf8(dat), s = _a.s, r = _a.r;
        if (r.length) $461bf5d8bd29e0d8$var$err(8);
        return s;
    }
}
// deflate bit flag
var $461bf5d8bd29e0d8$var$dbf = function(l) {
    return l == 1 ? 3 : l < 6 ? 2 : l == 9 ? 1 : 0;
};
// skip local zip header
var $461bf5d8bd29e0d8$var$slzh = function(d, b) {
    return b + 30 + $461bf5d8bd29e0d8$var$b2(d, b + 26) + $461bf5d8bd29e0d8$var$b2(d, b + 28);
};
// read zip header
var $461bf5d8bd29e0d8$var$zh = function(d, b, z) {
    var fnl = $461bf5d8bd29e0d8$var$b2(d, b + 28), fn = $461bf5d8bd29e0d8$export$adb211f8cb999894(d.subarray(b + 46, b + 46 + fnl), !($461bf5d8bd29e0d8$var$b2(d, b + 8) & 2048)), es = b + 46 + fnl, bs = $461bf5d8bd29e0d8$var$b4(d, b + 20);
    var _a = z && bs == 4294967295 ? $461bf5d8bd29e0d8$var$z64e(d, es) : [
        bs,
        $461bf5d8bd29e0d8$var$b4(d, b + 24),
        $461bf5d8bd29e0d8$var$b4(d, b + 42)
    ], sc = _a[0], su = _a[1], off = _a[2];
    return [
        $461bf5d8bd29e0d8$var$b2(d, b + 10),
        sc,
        su,
        fn,
        es + $461bf5d8bd29e0d8$var$b2(d, b + 30) + $461bf5d8bd29e0d8$var$b2(d, b + 32),
        off
    ];
};
// read zip64 extra field
var $461bf5d8bd29e0d8$var$z64e = function(d, b) {
    for(; $461bf5d8bd29e0d8$var$b2(d, b) != 1; b += 4 + $461bf5d8bd29e0d8$var$b2(d, b + 2));
    return [
        $461bf5d8bd29e0d8$var$b8(d, b + 12),
        $461bf5d8bd29e0d8$var$b8(d, b + 4),
        $461bf5d8bd29e0d8$var$b8(d, b + 20)
    ];
};
// extra field length
var $461bf5d8bd29e0d8$var$exfl = function(ex) {
    var le = 0;
    if (ex) for(var k in ex){
        var l = ex[k].length;
        if (l > 65535) $461bf5d8bd29e0d8$var$err(9);
        le += l + 4;
    }
    return le;
};
// write zip header
var $461bf5d8bd29e0d8$var$wzh = function(d, b, f, fn, u, c, ce, co) {
    var fl = fn.length, ex = f.extra, col = co && co.length;
    var exl = $461bf5d8bd29e0d8$var$exfl(ex);
    $461bf5d8bd29e0d8$var$wbytes(d, b, ce != null ? 0x2014B50 : 0x4034B50), b += 4;
    if (ce != null) d[b++] = 20, d[b++] = f.os;
    d[b] = 20, b += 2; // spec compliance? what's that?
    d[b++] = f.flag << 1 | (c < 0 && 8), d[b++] = u && 8;
    d[b++] = f.compression & 255, d[b++] = f.compression >> 8;
    var dt = new Date(f.mtime == null ? Date.now() : f.mtime), y = dt.getFullYear() - 1980;
    if (y < 0 || y > 119) $461bf5d8bd29e0d8$var$err(10);
    $461bf5d8bd29e0d8$var$wbytes(d, b, y << 25 | dt.getMonth() + 1 << 21 | dt.getDate() << 16 | dt.getHours() << 11 | dt.getMinutes() << 5 | dt.getSeconds() >> 1), b += 4;
    if (c != -1) {
        $461bf5d8bd29e0d8$var$wbytes(d, b, f.crc);
        $461bf5d8bd29e0d8$var$wbytes(d, b + 4, c < 0 ? -c - 2 : c);
        $461bf5d8bd29e0d8$var$wbytes(d, b + 8, f.size);
    }
    $461bf5d8bd29e0d8$var$wbytes(d, b + 12, fl);
    $461bf5d8bd29e0d8$var$wbytes(d, b + 14, exl), b += 16;
    if (ce != null) {
        $461bf5d8bd29e0d8$var$wbytes(d, b, col);
        $461bf5d8bd29e0d8$var$wbytes(d, b + 6, f.attrs);
        $461bf5d8bd29e0d8$var$wbytes(d, b + 10, ce), b += 14;
    }
    d.set(fn, b);
    b += fl;
    if (exl) for(var k in ex){
        var exf = ex[k], l = exf.length;
        $461bf5d8bd29e0d8$var$wbytes(d, b, +k);
        $461bf5d8bd29e0d8$var$wbytes(d, b + 2, l);
        d.set(exf, b + 4), b += 4 + l;
    }
    if (col) d.set(co, b), b += col;
    return b;
};
// write zip footer (end of central directory)
var $461bf5d8bd29e0d8$var$wzf = function(o, b, c, d, e) {
    $461bf5d8bd29e0d8$var$wbytes(o, b, 0x6054B50); // skip disk
    $461bf5d8bd29e0d8$var$wbytes(o, b + 8, c);
    $461bf5d8bd29e0d8$var$wbytes(o, b + 10, c);
    $461bf5d8bd29e0d8$var$wbytes(o, b + 12, d);
    $461bf5d8bd29e0d8$var$wbytes(o, b + 16, e);
};
/**
 * A pass-through stream to keep data uncompressed in a ZIP archive.
 */ var $461bf5d8bd29e0d8$export$2b25194e1767ea06 = /*#__PURE__*/ function() {
    /**
     * Creates a pass-through stream that can be added to ZIP archives
     * @param filename The filename to associate with this data stream
     */ function ZipPassThrough(filename) {
        this.filename = filename;
        this.c = $461bf5d8bd29e0d8$var$crc();
        this.size = 0;
        this.compression = 0;
    }
    /**
     * Processes a chunk and pushes to the output stream. You can override this
     * method in a subclass for custom behavior, but by default this passes
     * the data through. You must call this.ondata(err, chunk, final) at some
     * point in this method.
     * @param chunk The chunk to process
     * @param final Whether this is the last chunk
     */ ZipPassThrough.prototype.process = function(chunk, final) {
        this.ondata(null, chunk, final);
    };
    /**
     * Pushes a chunk to be added. If you are subclassing this with a custom
     * compression algorithm, note that you must push data from the source
     * file only, pre-compression.
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ ZipPassThrough.prototype.push = function(chunk, final) {
        if (!this.ondata) $461bf5d8bd29e0d8$var$err(5);
        this.c.p(chunk);
        this.size += chunk.length;
        if (final) this.crc = this.c.d();
        this.process(chunk, final || false);
    };
    return ZipPassThrough;
}();
// I don't extend because TypeScript extension adds 1kB of runtime bloat
/**
 * Streaming DEFLATE compression for ZIP archives. Prefer using AsyncZipDeflate
 * for better performance
 */ var $461bf5d8bd29e0d8$export$f7e481ca646388b6 = /*#__PURE__*/ function() {
    /**
     * Creates a DEFLATE stream that can be added to ZIP archives
     * @param filename The filename to associate with this data stream
     * @param opts The compression options
     */ function ZipDeflate(filename, opts) {
        var _this = this;
        if (!opts) opts = {};
        $461bf5d8bd29e0d8$export$2b25194e1767ea06.call(this, filename);
        this.d = new $461bf5d8bd29e0d8$export$ae157b6234afe138(opts, function(dat, final) {
            _this.ondata(null, dat, final);
        });
        this.compression = 8;
        this.flag = $461bf5d8bd29e0d8$var$dbf(opts.level);
    }
    ZipDeflate.prototype.process = function(chunk, final) {
        try {
            this.d.push(chunk, final);
        } catch (e) {
            this.ondata(e, null, final);
        }
    };
    /**
     * Pushes a chunk to be deflated
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ ZipDeflate.prototype.push = function(chunk, final) {
        $461bf5d8bd29e0d8$export$2b25194e1767ea06.prototype.push.call(this, chunk, final);
    };
    return ZipDeflate;
}();
/**
 * Asynchronous streaming DEFLATE compression for ZIP archives
 */ var $461bf5d8bd29e0d8$export$ffb5e59e179924b2 = /*#__PURE__*/ function() {
    /**
     * Creates an asynchronous DEFLATE stream that can be added to ZIP archives
     * @param filename The filename to associate with this data stream
     * @param opts The compression options
     */ function AsyncZipDeflate(filename, opts) {
        var _this = this;
        if (!opts) opts = {};
        $461bf5d8bd29e0d8$export$2b25194e1767ea06.call(this, filename);
        this.d = new $461bf5d8bd29e0d8$export$84e526fabcba03e3(opts, function(err, dat, final) {
            _this.ondata(err, dat, final);
        });
        this.compression = 8;
        this.flag = $461bf5d8bd29e0d8$var$dbf(opts.level);
        this.terminate = this.d.terminate;
    }
    AsyncZipDeflate.prototype.process = function(chunk, final) {
        this.d.push(chunk, final);
    };
    /**
     * Pushes a chunk to be deflated
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ AsyncZipDeflate.prototype.push = function(chunk, final) {
        $461bf5d8bd29e0d8$export$2b25194e1767ea06.prototype.push.call(this, chunk, final);
    };
    return AsyncZipDeflate;
}();
// TODO: Better tree shaking
/**
 * A zippable archive to which files can incrementally be added
 */ var $461bf5d8bd29e0d8$export$9a4d4a7c32a75d2f = /*#__PURE__*/ function() {
    /**
     * Creates an empty ZIP archive to which files can be added
     * @param cb The callback to call whenever data for the generated ZIP archive
     *           is available
     */ function Zip(cb) {
        this.ondata = cb;
        this.u = [];
        this.d = 1;
    }
    /**
     * Adds a file to the ZIP archive
     * @param file The file stream to add
     */ Zip.prototype.add = function(file) {
        var _this = this;
        if (!this.ondata) $461bf5d8bd29e0d8$var$err(5);
        // finishing or finished
        if (this.d & 2) this.ondata($461bf5d8bd29e0d8$var$err(4 + (this.d & 1) * 8, 0, 1), null, false);
        else {
            var f = $461bf5d8bd29e0d8$export$366b39a6daa8ed7a(file.filename), fl_1 = f.length;
            var com = file.comment, o = com && $461bf5d8bd29e0d8$export$366b39a6daa8ed7a(com);
            var u = fl_1 != file.filename.length || o && com.length != o.length;
            var hl_1 = fl_1 + $461bf5d8bd29e0d8$var$exfl(file.extra) + 30;
            if (fl_1 > 65535) this.ondata($461bf5d8bd29e0d8$var$err(11, 0, 1), null, false);
            var header = new $461bf5d8bd29e0d8$var$u8(hl_1);
            $461bf5d8bd29e0d8$var$wzh(header, 0, file, f, u, -1);
            var chks_1 = [
                header
            ];
            var pAll_1 = function() {
                for(var _i = 0, chks_2 = chks_1; _i < chks_2.length; _i++){
                    var chk = chks_2[_i];
                    _this.ondata(null, chk, false);
                }
                chks_1 = [];
            };
            var tr_1 = this.d;
            this.d = 0;
            var ind_1 = this.u.length;
            var uf_1 = $461bf5d8bd29e0d8$var$mrg(file, {
                f: f,
                u: u,
                o: o,
                t: function() {
                    if (file.terminate) file.terminate();
                },
                r: function() {
                    pAll_1();
                    if (tr_1) {
                        var nxt = _this.u[ind_1 + 1];
                        if (nxt) nxt.r();
                        else _this.d = 1;
                    }
                    tr_1 = 1;
                }
            });
            var cl_1 = 0;
            file.ondata = function(err, dat, final) {
                if (err) {
                    _this.ondata(err, dat, final);
                    _this.terminate();
                } else {
                    cl_1 += dat.length;
                    chks_1.push(dat);
                    if (final) {
                        var dd = new $461bf5d8bd29e0d8$var$u8(16);
                        $461bf5d8bd29e0d8$var$wbytes(dd, 0, 0x8074B50);
                        $461bf5d8bd29e0d8$var$wbytes(dd, 4, file.crc);
                        $461bf5d8bd29e0d8$var$wbytes(dd, 8, cl_1);
                        $461bf5d8bd29e0d8$var$wbytes(dd, 12, file.size);
                        chks_1.push(dd);
                        uf_1.c = cl_1, uf_1.b = hl_1 + cl_1 + 16, uf_1.crc = file.crc, uf_1.size = file.size;
                        if (tr_1) uf_1.r();
                        tr_1 = 1;
                    } else if (tr_1) pAll_1();
                }
            };
            this.u.push(uf_1);
        }
    };
    /**
     * Ends the process of adding files and prepares to emit the final chunks.
     * This *must* be called after adding all desired files for the resulting
     * ZIP file to work properly.
     */ Zip.prototype.end = function() {
        var _this = this;
        if (this.d & 2) {
            this.ondata($461bf5d8bd29e0d8$var$err(4 + (this.d & 1) * 8, 0, 1), null, true);
            return;
        }
        if (this.d) this.e();
        else this.u.push({
            r: function() {
                if (!(_this.d & 1)) return;
                _this.u.splice(-1, 1);
                _this.e();
            },
            t: function() {}
        });
        this.d = 3;
    };
    Zip.prototype.e = function() {
        var bt = 0, l = 0, tl = 0;
        for(var _i = 0, _a = this.u; _i < _a.length; _i++){
            var f = _a[_i];
            tl += 46 + f.f.length + $461bf5d8bd29e0d8$var$exfl(f.extra) + (f.o ? f.o.length : 0);
        }
        var out = new $461bf5d8bd29e0d8$var$u8(tl + 22);
        for(var _b = 0, _c = this.u; _b < _c.length; _b++){
            var f = _c[_b];
            $461bf5d8bd29e0d8$var$wzh(out, bt, f, f.f, f.u, -f.c - 2, l, f.o);
            bt += 46 + f.f.length + $461bf5d8bd29e0d8$var$exfl(f.extra) + (f.o ? f.o.length : 0), l += f.b;
        }
        $461bf5d8bd29e0d8$var$wzf(out, bt, this.u.length, tl, l);
        this.ondata(null, out, true);
        this.d = 2;
    };
    /**
     * A method to terminate any internal workers used by the stream. Subsequent
     * calls to add() will fail.
     */ Zip.prototype.terminate = function() {
        for(var _i = 0, _a = this.u; _i < _a.length; _i++){
            var f = _a[_i];
            f.t();
        }
        this.d = 2;
    };
    return Zip;
}();
function $461bf5d8bd29e0d8$export$8901015135f2fb22(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $461bf5d8bd29e0d8$var$err(7);
    var r = {};
    $461bf5d8bd29e0d8$var$fltn(data, '', r, opts);
    var k = Object.keys(r);
    var lft = k.length, o = 0, tot = 0;
    var slft = lft, files = new Array(lft);
    var term = [];
    var tAll = function() {
        for(var i = 0; i < term.length; ++i)term[i]();
    };
    var cbd = function(a, b) {
        $461bf5d8bd29e0d8$var$mt(function() {
            cb(a, b);
        });
    };
    $461bf5d8bd29e0d8$var$mt(function() {
        cbd = cb;
    });
    var cbf = function() {
        var out = new $461bf5d8bd29e0d8$var$u8(tot + 22), oe = o, cdl = tot - o;
        tot = 0;
        for(var i = 0; i < slft; ++i){
            var f = files[i];
            try {
                var l = f.c.length;
                $461bf5d8bd29e0d8$var$wzh(out, tot, f, f.f, f.u, l);
                var badd = 30 + f.f.length + $461bf5d8bd29e0d8$var$exfl(f.extra);
                var loc = tot + badd;
                out.set(f.c, loc);
                $461bf5d8bd29e0d8$var$wzh(out, o, f, f.f, f.u, l, tot, f.m), o += 16 + badd + (f.m ? f.m.length : 0), tot = loc + l;
            } catch (e) {
                return cbd(e, null);
            }
        }
        $461bf5d8bd29e0d8$var$wzf(out, o, files.length, cdl, oe);
        cbd(null, out);
    };
    if (!lft) cbf();
    var _loop_1 = function(i) {
        var fn = k[i];
        var _a = r[fn], file = _a[0], p = _a[1];
        var c = $461bf5d8bd29e0d8$var$crc(), size = file.length;
        c.p(file);
        var f = $461bf5d8bd29e0d8$export$366b39a6daa8ed7a(fn), s = f.length;
        var com = p.comment, m = com && $461bf5d8bd29e0d8$export$366b39a6daa8ed7a(com), ms = m && m.length;
        var exl = $461bf5d8bd29e0d8$var$exfl(p.extra);
        var compression = p.level == 0 ? 0 : 8;
        var cbl = function(e, d) {
            if (e) {
                tAll();
                cbd(e, null);
            } else {
                var l = d.length;
                files[i] = $461bf5d8bd29e0d8$var$mrg(p, {
                    size: size,
                    crc: c.d(),
                    c: d,
                    f: f,
                    m: m,
                    u: s != fn.length || m && com.length != ms,
                    compression: compression
                });
                o += 30 + s + exl + l;
                tot += 76 + 2 * (s + exl) + (ms || 0) + l;
                if (!--lft) cbf();
            }
        };
        if (s > 65535) cbl($461bf5d8bd29e0d8$var$err(11, 0, 1), null);
        if (!compression) cbl(null, file);
        else if (size < 160000) try {
            cbl(null, $461bf5d8bd29e0d8$export$21533ff51b8a0b4a(file, p));
        } catch (e) {
            cbl(e, null);
        }
        else term.push($461bf5d8bd29e0d8$export$2316623ecd1285ab(file, p, cbl));
    };
    // Cannot use lft because it can decrease
    for(var i = 0; i < slft; ++i)_loop_1(i);
    return tAll;
}
function $461bf5d8bd29e0d8$export$eb1654f146d54eb3(data, opts) {
    if (!opts) opts = {};
    var r = {};
    var files = [];
    $461bf5d8bd29e0d8$var$fltn(data, '', r, opts);
    var o = 0;
    var tot = 0;
    for(var fn in r){
        var _a = r[fn], file = _a[0], p = _a[1];
        var compression = p.level == 0 ? 0 : 8;
        var f = $461bf5d8bd29e0d8$export$366b39a6daa8ed7a(fn), s = f.length;
        var com = p.comment, m = com && $461bf5d8bd29e0d8$export$366b39a6daa8ed7a(com), ms = m && m.length;
        var exl = $461bf5d8bd29e0d8$var$exfl(p.extra);
        if (s > 65535) $461bf5d8bd29e0d8$var$err(11);
        var d = compression ? $461bf5d8bd29e0d8$export$21533ff51b8a0b4a(file, p) : file, l = d.length;
        var c = $461bf5d8bd29e0d8$var$crc();
        c.p(file);
        files.push($461bf5d8bd29e0d8$var$mrg(p, {
            size: file.length,
            crc: c.d(),
            c: d,
            f: f,
            m: m,
            u: s != fn.length || m && com.length != ms,
            o: o,
            compression: compression
        }));
        o += 30 + s + exl + l;
        tot += 76 + 2 * (s + exl) + (ms || 0) + l;
    }
    var out = new $461bf5d8bd29e0d8$var$u8(tot + 22), oe = o, cdl = tot - o;
    for(var i = 0; i < files.length; ++i){
        var f = files[i];
        $461bf5d8bd29e0d8$var$wzh(out, f.o, f, f.f, f.u, f.c.length);
        var badd = 30 + f.f.length + $461bf5d8bd29e0d8$var$exfl(f.extra);
        out.set(f.c, f.o + badd);
        $461bf5d8bd29e0d8$var$wzh(out, o, f, f.f, f.u, f.c.length, f.o, f.m), o += 16 + badd + (f.m ? f.m.length : 0);
    }
    $461bf5d8bd29e0d8$var$wzf(out, o, files.length, cdl, oe);
    return out;
}
/**
 * Streaming pass-through decompression for ZIP archives
 */ var $461bf5d8bd29e0d8$export$93f81d5bbbb7c6bf = /*#__PURE__*/ function() {
    function UnzipPassThrough() {}
    UnzipPassThrough.prototype.push = function(data, final) {
        this.ondata(null, data, final);
    };
    UnzipPassThrough.compression = 0;
    return UnzipPassThrough;
}();
/**
 * Streaming DEFLATE decompression for ZIP archives. Prefer AsyncZipInflate for
 * better performance.
 */ var $461bf5d8bd29e0d8$export$eb188945cc39e642 = /*#__PURE__*/ function() {
    /**
     * Creates a DEFLATE decompression that can be used in ZIP archives
     */ function UnzipInflate() {
        var _this = this;
        this.i = new $461bf5d8bd29e0d8$export$d1de70a877d6e43c(function(dat, final) {
            _this.ondata(null, dat, final);
        });
    }
    UnzipInflate.prototype.push = function(data, final) {
        try {
            this.i.push(data, final);
        } catch (e) {
            this.ondata(e, null, final);
        }
    };
    UnzipInflate.compression = 8;
    return UnzipInflate;
}();
/**
 * Asynchronous streaming DEFLATE decompression for ZIP archives
 */ var $461bf5d8bd29e0d8$export$6235d84645dad4f9 = /*#__PURE__*/ function() {
    /**
     * Creates a DEFLATE decompression that can be used in ZIP archives
     */ function AsyncUnzipInflate(_, sz) {
        var _this = this;
        if (sz < 320000) this.i = new $461bf5d8bd29e0d8$export$d1de70a877d6e43c(function(dat, final) {
            _this.ondata(null, dat, final);
        });
        else {
            this.i = new $461bf5d8bd29e0d8$export$fff8358d6dbaa9cc(function(err, dat, final) {
                _this.ondata(err, dat, final);
            });
            this.terminate = this.i.terminate;
        }
    }
    AsyncUnzipInflate.prototype.push = function(data, final) {
        if (this.i.terminate) data = $461bf5d8bd29e0d8$var$slc(data, 0);
        this.i.push(data, final);
    };
    AsyncUnzipInflate.compression = 8;
    return AsyncUnzipInflate;
}();
/**
 * A ZIP archive decompression stream that emits files as they are discovered
 */ var $461bf5d8bd29e0d8$export$9b7485f84cbaaa56 = /*#__PURE__*/ function() {
    /**
     * Creates a ZIP decompression stream
     * @param cb The callback to call whenever a file in the ZIP archive is found
     */ function Unzip(cb) {
        this.onfile = cb;
        this.k = [];
        this.o = {
            0: $461bf5d8bd29e0d8$export$93f81d5bbbb7c6bf
        };
        this.p = $461bf5d8bd29e0d8$var$et;
    }
    /**
     * Pushes a chunk to be unzipped
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Unzip.prototype.push = function(chunk, final) {
        var _this = this;
        if (!this.onfile) $461bf5d8bd29e0d8$var$err(5);
        if (!this.p) $461bf5d8bd29e0d8$var$err(4);
        if (this.c > 0) {
            var len = Math.min(this.c, chunk.length);
            var toAdd = chunk.subarray(0, len);
            this.c -= len;
            if (this.d) this.d.push(toAdd, !this.c);
            else this.k[0].push(toAdd);
            chunk = chunk.subarray(len);
            if (chunk.length) return this.push(chunk, final);
        } else {
            var f = 0, i = 0, is = void 0, buf = void 0;
            if (!this.p.length) buf = chunk;
            else if (!chunk.length) buf = this.p;
            else {
                buf = new $461bf5d8bd29e0d8$var$u8(this.p.length + chunk.length);
                buf.set(this.p), buf.set(chunk, this.p.length);
            }
            var l = buf.length, oc = this.c, add = oc && this.d;
            var _loop_2 = function() {
                var _a;
                var sig = $461bf5d8bd29e0d8$var$b4(buf, i);
                if (sig == 0x4034B50) {
                    f = 1, is = i;
                    this_1.d = null;
                    this_1.c = 0;
                    var bf = $461bf5d8bd29e0d8$var$b2(buf, i + 6), cmp_1 = $461bf5d8bd29e0d8$var$b2(buf, i + 8), u = bf & 2048, dd = bf & 8, fnl = $461bf5d8bd29e0d8$var$b2(buf, i + 26), es = $461bf5d8bd29e0d8$var$b2(buf, i + 28);
                    if (l > i + 30 + fnl + es) {
                        var chks_3 = [];
                        this_1.k.unshift(chks_3);
                        f = 2;
                        var sc_1 = $461bf5d8bd29e0d8$var$b4(buf, i + 18), su_1 = $461bf5d8bd29e0d8$var$b4(buf, i + 22);
                        var fn_1 = $461bf5d8bd29e0d8$export$adb211f8cb999894(buf.subarray(i + 30, i += 30 + fnl), !u);
                        if (sc_1 == 4294967295) _a = dd ? [
                            -2
                        ] : $461bf5d8bd29e0d8$var$z64e(buf, i), sc_1 = _a[0], su_1 = _a[1];
                        else if (dd) sc_1 = -1;
                        i += es;
                        this_1.c = sc_1;
                        var d_1;
                        var file_1 = {
                            name: fn_1,
                            compression: cmp_1,
                            start: function() {
                                if (!file_1.ondata) $461bf5d8bd29e0d8$var$err(5);
                                if (!sc_1) file_1.ondata(null, $461bf5d8bd29e0d8$var$et, true);
                                else {
                                    var ctr = _this.o[cmp_1];
                                    if (!ctr) file_1.ondata($461bf5d8bd29e0d8$var$err(14, 'unknown compression type ' + cmp_1, 1), null, false);
                                    d_1 = sc_1 < 0 ? new ctr(fn_1) : new ctr(fn_1, sc_1, su_1);
                                    d_1.ondata = function(err, dat, final) {
                                        file_1.ondata(err, dat, final);
                                    };
                                    for(var _i = 0, chks_4 = chks_3; _i < chks_4.length; _i++){
                                        var dat = chks_4[_i];
                                        d_1.push(dat, false);
                                    }
                                    if (_this.k[0] == chks_3 && _this.c) _this.d = d_1;
                                    else d_1.push($461bf5d8bd29e0d8$var$et, true);
                                }
                            },
                            terminate: function() {
                                if (d_1 && d_1.terminate) d_1.terminate();
                            }
                        };
                        if (sc_1 >= 0) file_1.size = sc_1, file_1.originalSize = su_1;
                        this_1.onfile(file_1);
                    }
                    return "break";
                } else if (oc) {
                    if (sig == 0x8074B50) {
                        is = i += 12 + (oc == -2 && 8), f = 3, this_1.c = 0;
                        return "break";
                    } else if (sig == 0x2014B50) {
                        is = i -= 4, f = 3, this_1.c = 0;
                        return "break";
                    }
                }
            };
            var this_1 = this;
            for(; i < l - 4; ++i){
                var state_1 = _loop_2();
                if (state_1 === "break") break;
            }
            this.p = $461bf5d8bd29e0d8$var$et;
            if (oc < 0) {
                var dat = f ? buf.subarray(0, is - 12 - (oc == -2 && 8) - ($461bf5d8bd29e0d8$var$b4(buf, is - 16) == 0x8074B50 && 4)) : buf.subarray(0, i);
                if (add) add.push(dat, !!f);
                else this.k[+(f == 2)].push(dat);
            }
            if (f & 2) return this.push(buf.subarray(i), final);
            this.p = buf.subarray(i);
        }
        if (final) {
            if (this.c) $461bf5d8bd29e0d8$var$err(13);
            this.p = null;
        }
    };
    /**
     * Registers a decoder with the stream, allowing for files compressed with
     * the compression type provided to be expanded correctly
     * @param decoder The decoder constructor
     */ Unzip.prototype.register = function(decoder) {
        this.o[decoder.compression] = decoder;
    };
    return Unzip;
}();
var $461bf5d8bd29e0d8$var$mt = typeof queueMicrotask == 'function' ? queueMicrotask : typeof setTimeout == 'function' ? setTimeout : function(fn) {
    fn();
};
function $461bf5d8bd29e0d8$export$23c8d3f8757cab88(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $461bf5d8bd29e0d8$var$err(7);
    var term = [];
    var tAll = function() {
        for(var i = 0; i < term.length; ++i)term[i]();
    };
    var files = {};
    var cbd = function(a, b) {
        $461bf5d8bd29e0d8$var$mt(function() {
            cb(a, b);
        });
    };
    $461bf5d8bd29e0d8$var$mt(function() {
        cbd = cb;
    });
    var e = data.length - 22;
    for(; $461bf5d8bd29e0d8$var$b4(data, e) != 0x6054B50; --e)if (!e || data.length - e > 65558) {
        cbd($461bf5d8bd29e0d8$var$err(13, 0, 1), null);
        return tAll;
    }
    var lft = $461bf5d8bd29e0d8$var$b2(data, e + 8);
    if (lft) {
        var c = lft;
        var o = $461bf5d8bd29e0d8$var$b4(data, e + 16);
        var z = o == 4294967295 || c == 65535;
        if (z) {
            var ze = $461bf5d8bd29e0d8$var$b4(data, e - 12);
            z = $461bf5d8bd29e0d8$var$b4(data, ze) == 0x6064B50;
            if (z) {
                c = lft = $461bf5d8bd29e0d8$var$b4(data, ze + 32);
                o = $461bf5d8bd29e0d8$var$b4(data, ze + 48);
            }
        }
        var fltr = opts && opts.filter;
        var _loop_3 = function(i) {
            var _a = $461bf5d8bd29e0d8$var$zh(data, o, z), c_1 = _a[0], sc = _a[1], su = _a[2], fn = _a[3], no = _a[4], off = _a[5], b = $461bf5d8bd29e0d8$var$slzh(data, off);
            o = no;
            var cbl = function(e, d) {
                if (e) {
                    tAll();
                    cbd(e, null);
                } else {
                    if (d) files[fn] = d;
                    if (!--lft) cbd(null, files);
                }
            };
            if (!fltr || fltr({
                name: fn,
                size: sc,
                originalSize: su,
                compression: c_1
            })) {
                if (!c_1) cbl(null, $461bf5d8bd29e0d8$var$slc(data, b, b + sc));
                else if (c_1 == 8) {
                    var infl = data.subarray(b, b + sc);
                    // Synchronously decompress under 512KB, or barely-compressed data
                    if (su < 524288 || sc > 0.8 * su) try {
                        cbl(null, $461bf5d8bd29e0d8$export$90366d8b308ba94a(infl, {
                            out: new $461bf5d8bd29e0d8$var$u8(su)
                        }));
                    } catch (e) {
                        cbl(e, null);
                    }
                    else term.push($461bf5d8bd29e0d8$export$cae1ce83fe4a1782(infl, {
                        size: su
                    }, cbl));
                } else cbl($461bf5d8bd29e0d8$var$err(14, 'unknown compression type ' + c_1, 1), null);
            } else cbl(null, null);
        };
        for(var i = 0; i < c; ++i)_loop_3(i);
    } else cbd(null, {});
    return tAll;
}
function $461bf5d8bd29e0d8$export$c757709326bb5901(data, opts) {
    var files = {};
    var e = data.length - 22;
    for(; $461bf5d8bd29e0d8$var$b4(data, e) != 0x6054B50; --e)if (!e || data.length - e > 65558) $461bf5d8bd29e0d8$var$err(13);
    var c = $461bf5d8bd29e0d8$var$b2(data, e + 8);
    if (!c) return {};
    var o = $461bf5d8bd29e0d8$var$b4(data, e + 16);
    var z = o == 4294967295 || c == 65535;
    if (z) {
        var ze = $461bf5d8bd29e0d8$var$b4(data, e - 12);
        z = $461bf5d8bd29e0d8$var$b4(data, ze) == 0x6064B50;
        if (z) {
            c = $461bf5d8bd29e0d8$var$b4(data, ze + 32);
            o = $461bf5d8bd29e0d8$var$b4(data, ze + 48);
        }
    }
    var fltr = opts && opts.filter;
    for(var i = 0; i < c; ++i){
        var _a = $461bf5d8bd29e0d8$var$zh(data, o, z), c_2 = _a[0], sc = _a[1], su = _a[2], fn = _a[3], no = _a[4], off = _a[5], b = $461bf5d8bd29e0d8$var$slzh(data, off);
        o = no;
        if (!fltr || fltr({
            name: fn,
            size: sc,
            originalSize: su,
            compression: c_2
        })) {
            if (!c_2) files[fn] = $461bf5d8bd29e0d8$var$slc(data, b, b + sc);
            else if (c_2 == 8) files[fn] = $461bf5d8bd29e0d8$export$90366d8b308ba94a(data.subarray(b, b + sc), {
                out: new $461bf5d8bd29e0d8$var$u8(su)
            });
            else $461bf5d8bd29e0d8$var$err(14, 'unknown compression type ' + c_2);
        }
    }
    return files;
}


var $a08b940ba6c63fcd$var$z = Object.defineProperty;
var $a08b940ba6c63fcd$var$B = Math.pow;
var $a08b940ba6c63fcd$var$d = (i, t)=>$a08b940ba6c63fcd$var$z(i, "name", {
        value: t,
        configurable: !0
    });
var $a08b940ba6c63fcd$var$m = (i, t, e)=>new Promise((r, n)=>{
        var s = (c)=>{
            try {
                a(e.next(c));
            } catch (u) {
                n(u);
            }
        }, o = (c)=>{
            try {
                a(e.throw(c));
            } catch (u) {
                n(u);
            }
        }, a = (c)=>c.done ? r(c.value) : Promise.resolve(c.value).then(s, o);
        a((e = e.apply(i, t)).next());
    });
var $a08b940ba6c63fcd$export$e27b8fc6d70762a3 = $a08b940ba6c63fcd$var$d((i, t)=>{
    let e = !1, r = "", n = L.GridLayer.extend({
        createTile: $a08b940ba6c63fcd$var$d((s, o)=>{
            let a = document.createElement("img"), c = new AbortController, u = c.signal;
            return a.cancel = ()=>{
                c.abort();
            }, e || (i.getHeader().then((l)=>{
                l.tileType === 1 || l.tileType === 6 ? console.error("Error: archive contains vector tiles, but leafletRasterLayer is for displaying raster tiles. See https://github.com/protomaps/PMTiles/tree/main/js for details.") : l.tileType === 2 ? r = "image/png" : l.tileType === 3 ? r = "image/jpeg" : l.tileType === 4 ? r = "image/webp" : l.tileType === 5 && (r = "image/avif");
            }), e = !0), i.getZxy(s.z, s.x, s.y, u).then((l)=>{
                if (l) {
                    let f = new Blob([
                        l.data
                    ], {
                        type: r
                    }), y = window.URL.createObjectURL(f);
                    a.src = y;
                } else a.style.display = "none";
                a.cancel = void 0, o(void 0, a);
            }).catch((l)=>{
                if (l.name !== "AbortError") throw l;
            }), a;
        }, "createTile"),
        _removeTile: $a08b940ba6c63fcd$var$d(function(s) {
            let o = this._tiles[s];
            o && (o.el.cancel && o.el.cancel(), o.el.src && window.URL.revokeObjectURL(o.el.src), o.el.width = 0, o.el.height = 0, o.el.deleted = !0, L.DomUtil.remove(o.el), delete this._tiles[s], this.fire("tileunload", {
                tile: o.el,
                coords: this._keyToTileCoords(s)
            }));
        }, "_removeTile")
    });
    return new n(t);
}, "leafletRasterLayer"), $a08b940ba6c63fcd$var$W = $a08b940ba6c63fcd$var$d((i)=>(t, e)=>{
        if (e instanceof AbortController) return i(t, e);
        let r = new AbortController;
        return i(t, r).then((n)=>e(void 0, n.data, n.cacheControl || "", n.expires || ""), (n)=>e(n)).catch((n)=>e(n)), {
            cancel: $a08b940ba6c63fcd$var$d(()=>r.abort(), "cancel")
        };
    }, "v3compat"), $a08b940ba6c63fcd$var$E = class E {
    constructor(t){
        this.tilev4 = $a08b940ba6c63fcd$var$d((t, e)=>$a08b940ba6c63fcd$var$m(this, null, function*() {
                if (t.type === "json") {
                    let y = t.url.substr(10), p = this.tiles.get(y);
                    if (p || (p = new $a08b940ba6c63fcd$export$f5df01c0ebe55344(y), this.tiles.set(y, p)), this.metadata) {
                        let j = yield p.getTileJson(t.url);
                        return e.signal.throwIfAborted(), {
                            data: j
                        };
                    }
                    let h = yield p.getHeader();
                    return e.signal.throwIfAborted(), (h.minLon >= h.maxLon || h.minLat >= h.maxLat) && console.error(`Bounds of PMTiles archive ${h.minLon},${h.minLat},${h.maxLon},${h.maxLat} are not valid.`), {
                        data: {
                            tiles: [
                                `${t.url}/{z}/{x}/{y}`
                            ],
                            minzoom: h.minZoom,
                            maxzoom: h.maxZoom,
                            bounds: [
                                h.minLon,
                                h.minLat,
                                h.maxLon,
                                h.maxLat
                            ]
                        }
                    };
                }
                let r = new RegExp(/pmtiles:\/\/(.+)\/(\d+)\/(\d+)\/(\d+)/), n = t.url.match(r);
                if (!n) throw new Error("Invalid PMTiles protocol URL");
                let s = n[1], o = this.tiles.get(s);
                o || (o = new $a08b940ba6c63fcd$export$f5df01c0ebe55344(s), this.tiles.set(s, o));
                let a = n[2], c = n[3], u = n[4], l = yield o == null ? void 0 : o.getZxy(+a, +c, +u, e.signal);
                if (e.signal.throwIfAborted(), l) return {
                    data: new Uint8Array(l.data),
                    cacheControl: l.cacheControl,
                    expires: l.expires
                };
                let f = yield o.getHeader();
                if (f.tileType === 1 || f.tileType === 6) {
                    if (this.errorOnMissingTile) throw new Error("Tile not found.");
                    return {
                        data: new Uint8Array
                    };
                }
                return {
                    data: null
                };
            }), "tilev4");
        this.tile = $a08b940ba6c63fcd$var$W(this.tilev4);
        this.tiles = new Map, this.metadata = (t == null ? void 0 : t.metadata) || !1, this.errorOnMissingTile = (t == null ? void 0 : t.errorOnMissingTile) || !1;
    }
    add(t) {
        this.tiles.set(t.source.getKey(), t);
    }
    get(t) {
        return this.tiles.get(t);
    }
};
$a08b940ba6c63fcd$var$d($a08b940ba6c63fcd$var$E, "Protocol");
var $a08b940ba6c63fcd$export$377bbedb5576dfa8 = $a08b940ba6c63fcd$var$E;
function $a08b940ba6c63fcd$var$b(i, t) {
    return (t >>> 0) * 4294967296 + (i >>> 0);
}
$a08b940ba6c63fcd$var$d($a08b940ba6c63fcd$var$b, "toNum");
function $a08b940ba6c63fcd$var$N(i, t) {
    let e = t.buf, r = e[t.pos++], n = (r & 112) >> 4;
    if (r < 128 || (r = e[t.pos++], n |= (r & 127) << 3, r < 128) || (r = e[t.pos++], n |= (r & 127) << 10, r < 128) || (r = e[t.pos++], n |= (r & 127) << 17, r < 128) || (r = e[t.pos++], n |= (r & 127) << 24, r < 128) || (r = e[t.pos++], n |= (r & 1) << 31, r < 128)) return $a08b940ba6c63fcd$var$b(i, n);
    throw new Error("Expected varint not more than 10 bytes");
}
$a08b940ba6c63fcd$var$d($a08b940ba6c63fcd$var$N, "readVarintRemainder");
function $a08b940ba6c63fcd$export$6669f4ec4862dba6(i) {
    let t = i.buf, e = t[i.pos++], r = e & 127;
    return e < 128 || (e = t[i.pos++], r |= (e & 127) << 7, e < 128) || (e = t[i.pos++], r |= (e & 127) << 14, e < 128) || (e = t[i.pos++], r |= (e & 127) << 21, e < 128) ? r : (e = t[i.pos], r |= (e & 15) << 28, $a08b940ba6c63fcd$var$N(r, i));
}
$a08b940ba6c63fcd$var$d($a08b940ba6c63fcd$export$6669f4ec4862dba6, "readVarint");
function $a08b940ba6c63fcd$var$Z(i, t, e, r, n) {
    return n === 0 ? r !== 0 ? [
        i - 1 - e,
        i - 1 - t
    ] : [
        e,
        t
    ] : [
        t,
        e
    ];
}
$a08b940ba6c63fcd$var$d($a08b940ba6c63fcd$var$Z, "rotate");
function $a08b940ba6c63fcd$export$188cd6f16dbcbc(i, t, e) {
    if (i > 26) throw new Error("Tile zoom level exceeds max safe number limit (26)");
    if (t >= 1 << i || e >= 1 << i) throw new Error("tile x/y outside zoom level bounds");
    let r = ((1 << i) * (1 << i) - 1) / 3, n = i - 1, [s, o] = [
        t,
        e
    ];
    for(let a = 1 << n; a > 0; a >>= 1){
        let c = s & a, u = o & a;
        r += (3 * c ^ u) * (1 << n), [s, o] = $a08b940ba6c63fcd$var$Z(a, s, o, c, u), n--;
    }
    return r;
}
$a08b940ba6c63fcd$var$d($a08b940ba6c63fcd$export$188cd6f16dbcbc, "zxyToTileId");
function $a08b940ba6c63fcd$var$G(i) {
    let t = 3 * i + 1;
    return t < 4294967296 ? 31 - Math.clz32(t) : 63 - Math.clz32(t / 4294967296);
}
$a08b940ba6c63fcd$var$d($a08b940ba6c63fcd$var$G, "tileIdToZ");
function $a08b940ba6c63fcd$export$5bc688871d8d5aab(i) {
    let t = $a08b940ba6c63fcd$var$G(i) >> 1;
    if (t > 26) throw new Error("Tile zoom level exceeds max safe number limit (26)");
    let e = ((1 << t) * (1 << t) - 1) / 3, r = i - e, n = 0, s = 0, o = 1 << t;
    for(let a = 1; a < o; a <<= 1){
        let c = a & r / 2, u = a & (r ^ c);
        [n, s] = $a08b940ba6c63fcd$var$Z(a, n, s, c, u), r = r / 2, n += c, s += u;
    }
    return [
        t,
        n,
        s
    ];
}
$a08b940ba6c63fcd$var$d($a08b940ba6c63fcd$export$5bc688871d8d5aab, "tileIdToZxy");
var $a08b940ba6c63fcd$export$6a00d17b5aff0af = ((s)=>(s[s.Unknown = 0] = "Unknown", s[s.None = 1] = "None", s[s.Gzip = 2] = "Gzip", s[s.Brotli = 3] = "Brotli", s[s.Zstd = 4] = "Zstd", s))($a08b940ba6c63fcd$export$6a00d17b5aff0af || {});
function $a08b940ba6c63fcd$var$D(i, t) {
    return $a08b940ba6c63fcd$var$m(this, null, function*() {
        if (t === 1 || t === 0) return i;
        if (t === 2) {
            if (typeof globalThis.DecompressionStream == "undefined") return (0, $461bf5d8bd29e0d8$export$c4bdbbbc9a4faabe)(new Uint8Array(i));
            let e = new Response(i).body;
            if (!e) throw new Error("Failed to read response stream");
            let r = e.pipeThrough(new globalThis.DecompressionStream("gzip"));
            return new Response(r).arrayBuffer();
        }
        throw new Error("Compression method not supported");
    });
}
$a08b940ba6c63fcd$var$d($a08b940ba6c63fcd$var$D, "defaultDecompress");
var $a08b940ba6c63fcd$export$b58a0cc33096f1fb = ((a)=>(a[a.Unknown = 0] = "Unknown", a[a.Mvt = 1] = "Mvt", a[a.Png = 2] = "Png", a[a.Jpeg = 3] = "Jpeg", a[a.Webp = 4] = "Webp", a[a.Avif = 5] = "Avif", a[a.Mlt = 6] = "Mlt", a))($a08b940ba6c63fcd$export$b58a0cc33096f1fb || {});
function $a08b940ba6c63fcd$export$157cb7d798fb2ba5(i) {
    return i === 1 ? ".mvt" : i === 2 ? ".png" : i === 3 ? ".jpg" : i === 4 ? ".webp" : i === 5 ? ".avif" : i === 6 ? ".mlt" : "";
}
$a08b940ba6c63fcd$var$d($a08b940ba6c63fcd$export$157cb7d798fb2ba5, "tileTypeExt");
var $a08b940ba6c63fcd$var$Y = 127;
function $a08b940ba6c63fcd$export$5675963e3644b4b5(i, t) {
    let e = 0, r = i.length - 1;
    for(; e <= r;){
        let n = r + e >> 1, s = t - i[n].tileId;
        if (s > 0) e = n + 1;
        else if (s < 0) r = n - 1;
        else return i[n];
    }
    return r >= 0 && (i[r].runLength === 0 || t - i[r].tileId < i[r].runLength) ? i[r] : null;
}
$a08b940ba6c63fcd$var$d($a08b940ba6c63fcd$export$5675963e3644b4b5, "findTile");
var $a08b940ba6c63fcd$var$A = class A {
    constructor(t){
        this.file = t;
    }
    getKey() {
        return this.file.name;
    }
    getBytes(t, e) {
        return $a08b940ba6c63fcd$var$m(this, null, function*() {
            return {
                data: yield this.file.slice(t, t + e).arrayBuffer()
            };
        });
    }
};
$a08b940ba6c63fcd$var$d($a08b940ba6c63fcd$var$A, "FileSource");
var $a08b940ba6c63fcd$export$27a4864e1e35718c = $a08b940ba6c63fcd$var$A, $a08b940ba6c63fcd$var$P = class P {
    constructor(t, e = new Headers, r){
        var a, c;
        this.url = t, this.customHeaders = e, this.credentials = r, this.mustReload = !1;
        let n = "";
        "navigator" in globalThis && (n = (c = (a = globalThis.navigator) == null ? void 0 : a.userAgent) != null ? c : "");
        let s = n.indexOf("Windows") > -1, o = /Chrome|Chromium|Edg|OPR|Brave/.test(n);
        this.chromeWindowsNoCache = !1, s && o && (this.chromeWindowsNoCache = !0);
    }
    getKey() {
        return this.url;
    }
    setHeaders(t) {
        this.customHeaders = t;
    }
    getBytes(t, e, r, n) {
        return $a08b940ba6c63fcd$var$m(this, null, function*() {
            let s, o;
            r ? o = r : (s = new AbortController, o = s.signal);
            let a = new Headers(this.customHeaders);
            a.set("range", `bytes=${t}-${t + e - 1}`);
            let c;
            this.mustReload ? c = "reload" : this.chromeWindowsNoCache && (c = "no-store");
            let u = yield fetch(this.url, {
                signal: o,
                cache: c,
                headers: a,
                credentials: this.credentials
            });
            if (t === 0 && u.status === 416) {
                let p = u.headers.get("Content-Range");
                if (!p || !p.startsWith("bytes */")) throw new Error("Missing content-length on 416 response");
                let h = +p.substr(8);
                a.set("range", `bytes=0-${h - 1}`), u = yield fetch(this.url, {
                    signal: o,
                    cache: "reload",
                    headers: a,
                    credentials: this.credentials
                });
            }
            let l = u.headers.get("Etag");
            if (l != null && l.startsWith("W/") && (l = null), u.status === 416 || n && l && l !== n) throw this.mustReload = !0, new $a08b940ba6c63fcd$export$6c82150b8b13aae7(`Server returned non-matching ETag ${n} after one retry. Check browser extensions and servers for issues that may affect correct ETag headers.`);
            if (u.status >= 300) throw new Error(`Bad response code: ${u.status}`);
            let f = u.headers.get("Content-Length");
            if (u.status === 200 && (!f || +f > e)) throw s && s.abort(), new Error("Server returned no content-length header or content-length exceeding request. Check that your storage backend supports HTTP Byte Serving.");
            return {
                data: yield u.arrayBuffer(),
                etag: l || void 0,
                cacheControl: u.headers.get("Cache-Control") || void 0,
                expires: u.headers.get("Expires") || void 0
            };
        });
    }
};
$a08b940ba6c63fcd$var$d($a08b940ba6c63fcd$var$P, "FetchSource");
var $a08b940ba6c63fcd$export$da55bbd2ae5caa76 = $a08b940ba6c63fcd$var$P;
function $a08b940ba6c63fcd$export$59a2dbf579ff9568(i, t) {
    let e = i.getUint32(t + 4, !0), r = i.getUint32(t + 0, !0);
    return e * $a08b940ba6c63fcd$var$B(2, 32) + r;
}
$a08b940ba6c63fcd$var$d($a08b940ba6c63fcd$export$59a2dbf579ff9568, "getUint64");
function $a08b940ba6c63fcd$export$47afd0f2e060142c(i, t) {
    let e = new DataView(i), r = e.getUint8(7);
    if (r > 3) throw new Error(`Archive is spec version ${r} but this library supports up to spec version 3`);
    return {
        specVersion: r,
        rootDirectoryOffset: $a08b940ba6c63fcd$export$59a2dbf579ff9568(e, 8),
        rootDirectoryLength: $a08b940ba6c63fcd$export$59a2dbf579ff9568(e, 16),
        jsonMetadataOffset: $a08b940ba6c63fcd$export$59a2dbf579ff9568(e, 24),
        jsonMetadataLength: $a08b940ba6c63fcd$export$59a2dbf579ff9568(e, 32),
        leafDirectoryOffset: $a08b940ba6c63fcd$export$59a2dbf579ff9568(e, 40),
        leafDirectoryLength: $a08b940ba6c63fcd$export$59a2dbf579ff9568(e, 48),
        tileDataOffset: $a08b940ba6c63fcd$export$59a2dbf579ff9568(e, 56),
        tileDataLength: $a08b940ba6c63fcd$export$59a2dbf579ff9568(e, 64),
        numAddressedTiles: $a08b940ba6c63fcd$export$59a2dbf579ff9568(e, 72),
        numTileEntries: $a08b940ba6c63fcd$export$59a2dbf579ff9568(e, 80),
        numTileContents: $a08b940ba6c63fcd$export$59a2dbf579ff9568(e, 88),
        clustered: e.getUint8(96) === 1,
        internalCompression: e.getUint8(97),
        tileCompression: e.getUint8(98),
        tileType: e.getUint8(99),
        minZoom: e.getUint8(100),
        maxZoom: e.getUint8(101),
        minLon: e.getInt32(102, !0) / 1e7,
        minLat: e.getInt32(106, !0) / 1e7,
        maxLon: e.getInt32(110, !0) / 1e7,
        maxLat: e.getInt32(114, !0) / 1e7,
        centerZoom: e.getUint8(118),
        centerLon: e.getInt32(119, !0) / 1e7,
        centerLat: e.getInt32(123, !0) / 1e7,
        etag: t
    };
}
$a08b940ba6c63fcd$var$d($a08b940ba6c63fcd$export$47afd0f2e060142c, "bytesToHeader");
function $a08b940ba6c63fcd$var$I(i) {
    let t = {
        buf: new Uint8Array(i),
        pos: 0
    }, e = $a08b940ba6c63fcd$export$6669f4ec4862dba6(t), r = [], n = 0;
    for(let s = 0; s < e; s++){
        let o = $a08b940ba6c63fcd$export$6669f4ec4862dba6(t);
        r.push({
            tileId: n + o,
            offset: 0,
            length: 0,
            runLength: 1
        }), n += o;
    }
    for(let s = 0; s < e; s++)r[s].runLength = $a08b940ba6c63fcd$export$6669f4ec4862dba6(t);
    for(let s = 0; s < e; s++)r[s].length = $a08b940ba6c63fcd$export$6669f4ec4862dba6(t);
    for(let s = 0; s < e; s++){
        let o = $a08b940ba6c63fcd$export$6669f4ec4862dba6(t);
        o === 0 && s > 0 ? r[s].offset = r[s - 1].offset + r[s - 1].length : r[s].offset = o - 1;
    }
    return r;
}
$a08b940ba6c63fcd$var$d($a08b940ba6c63fcd$var$I, "deserializeIndex");
var $a08b940ba6c63fcd$var$R = class R extends Error {
};
$a08b940ba6c63fcd$var$d($a08b940ba6c63fcd$var$R, "EtagMismatch");
var $a08b940ba6c63fcd$export$6c82150b8b13aae7 = $a08b940ba6c63fcd$var$R;
function $a08b940ba6c63fcd$var$V(i, t) {
    return $a08b940ba6c63fcd$var$m(this, null, function*() {
        let e = yield i.getBytes(0, 16384);
        if (new DataView(e.data).getUint16(0, !0) !== 19792) throw new Error("Wrong magic number for PMTiles archive");
        let n = e.data.slice(0, $a08b940ba6c63fcd$var$Y), s = $a08b940ba6c63fcd$export$47afd0f2e060142c(n, e.etag), o = e.data.slice(s.rootDirectoryOffset, s.rootDirectoryOffset + s.rootDirectoryLength), a = `${i.getKey()}|${s.etag || ""}|${s.rootDirectoryOffset}|${s.rootDirectoryLength}`, c = $a08b940ba6c63fcd$var$I((yield t(o, s.internalCompression)));
        return [
            s,
            [
                a,
                c.length,
                c
            ]
        ];
    });
}
$a08b940ba6c63fcd$var$d($a08b940ba6c63fcd$var$V, "getHeaderAndRoot");
function $a08b940ba6c63fcd$var$K(i, t, e, r, n) {
    return $a08b940ba6c63fcd$var$m(this, null, function*() {
        let s = yield i.getBytes(e, r, void 0, n.etag), o = yield t(s.data, n.internalCompression), a = $a08b940ba6c63fcd$var$I(o);
        if (a.length === 0) throw new Error("Empty directory is invalid");
        return a;
    });
}
$a08b940ba6c63fcd$var$d($a08b940ba6c63fcd$var$K, "getDirectory");
var $a08b940ba6c63fcd$var$U = class U {
    constructor(t = 100, e = !0, r = $a08b940ba6c63fcd$var$D){
        this.cache = new Map, this.maxCacheEntries = t, this.counter = 1, this.decompress = r;
    }
    getHeader(t) {
        return $a08b940ba6c63fcd$var$m(this, null, function*() {
            let e = t.getKey(), r = this.cache.get(e);
            if (r) return r.lastUsed = this.counter++, r.data;
            let n = yield $a08b940ba6c63fcd$var$V(t, this.decompress);
            return n[1] && this.cache.set(n[1][0], {
                lastUsed: this.counter++,
                data: n[1][2]
            }), this.cache.set(e, {
                lastUsed: this.counter++,
                data: n[0]
            }), this.prune(), n[0];
        });
    }
    getDirectory(t, e, r, n) {
        return $a08b940ba6c63fcd$var$m(this, null, function*() {
            let s = `${t.getKey()}|${n.etag || ""}|${e}|${r}`, o = this.cache.get(s);
            if (o) return o.lastUsed = this.counter++, o.data;
            let a = yield $a08b940ba6c63fcd$var$K(t, this.decompress, e, r, n);
            return this.cache.set(s, {
                lastUsed: this.counter++,
                data: a
            }), this.prune(), a;
        });
    }
    prune() {
        if (this.cache.size > this.maxCacheEntries) {
            let t = 1 / 0, e;
            this.cache.forEach((r, n)=>{
                r.lastUsed < t && (t = r.lastUsed, e = n);
            }), e && this.cache.delete(e);
        }
    }
    invalidate(t) {
        return $a08b940ba6c63fcd$var$m(this, null, function*() {
            this.cache.delete(t.getKey());
        });
    }
};
$a08b940ba6c63fcd$var$d($a08b940ba6c63fcd$var$U, "ResolvedValueCache");
var $a08b940ba6c63fcd$export$85b5382c5bd98023 = $a08b940ba6c63fcd$var$U, $a08b940ba6c63fcd$var$M = class M {
    constructor(t = 100, e = !0, r = $a08b940ba6c63fcd$var$D){
        this.cache = new Map, this.invalidations = new Map, this.maxCacheEntries = t, this.counter = 1, this.decompress = r;
    }
    getHeader(t) {
        return $a08b940ba6c63fcd$var$m(this, null, function*() {
            let e = t.getKey(), r = this.cache.get(e);
            if (r) return r.lastUsed = this.counter++, yield r.data;
            let n = new Promise((s, o)=>{
                $a08b940ba6c63fcd$var$V(t, this.decompress).then((a)=>{
                    a[1] && this.cache.set(a[1][0], {
                        lastUsed: this.counter++,
                        data: Promise.resolve(a[1][2])
                    }), s(a[0]), this.prune();
                }).catch((a)=>{
                    o(a);
                });
            });
            return this.cache.set(e, {
                lastUsed: this.counter++,
                data: n
            }), n;
        });
    }
    getDirectory(t, e, r, n) {
        return $a08b940ba6c63fcd$var$m(this, null, function*() {
            let s = `${t.getKey()}|${n.etag || ""}|${e}|${r}`, o = this.cache.get(s);
            if (o) return o.lastUsed = this.counter++, yield o.data;
            let a = new Promise((c, u)=>{
                $a08b940ba6c63fcd$var$K(t, this.decompress, e, r, n).then((l)=>{
                    c(l), this.prune();
                }).catch((l)=>{
                    u(l);
                });
            });
            return this.cache.set(s, {
                lastUsed: this.counter++,
                data: a
            }), a;
        });
    }
    prune() {
        if (this.cache.size >= this.maxCacheEntries) {
            let t = 1 / 0, e;
            this.cache.forEach((r, n)=>{
                r.lastUsed < t && (t = r.lastUsed, e = n);
            }), e && this.cache.delete(e);
        }
    }
    invalidate(t) {
        return $a08b940ba6c63fcd$var$m(this, null, function*() {
            let e = t.getKey();
            if (this.invalidations.get(e)) return yield this.invalidations.get(e);
            this.cache.delete(t.getKey());
            let r = new Promise((n, s)=>{
                this.getHeader(t).then((o)=>{
                    n(), this.invalidations.delete(e);
                }).catch((o)=>{
                    s(o);
                });
            });
            this.invalidations.set(e, r);
        });
    }
};
$a08b940ba6c63fcd$var$d($a08b940ba6c63fcd$var$M, "SharedPromiseCache");
var $a08b940ba6c63fcd$export$a73e3869eeeadfd6 = $a08b940ba6c63fcd$var$M, $a08b940ba6c63fcd$var$H = class H {
    constructor(t, e, r){
        typeof t == "string" ? this.source = new $a08b940ba6c63fcd$export$da55bbd2ae5caa76(t) : this.source = t, r ? this.decompress = r : this.decompress = $a08b940ba6c63fcd$var$D, e ? this.cache = e : this.cache = new $a08b940ba6c63fcd$export$a73e3869eeeadfd6;
    }
    getHeader() {
        return $a08b940ba6c63fcd$var$m(this, null, function*() {
            return yield this.cache.getHeader(this.source);
        });
    }
    getZxyAttempt(t, e, r, n) {
        return $a08b940ba6c63fcd$var$m(this, null, function*() {
            let s = $a08b940ba6c63fcd$export$188cd6f16dbcbc(t, e, r), o = yield this.cache.getHeader(this.source);
            if (t < o.minZoom || t > o.maxZoom) return;
            let a = o.rootDirectoryOffset, c = o.rootDirectoryLength;
            for(let u = 0; u <= 3; u++){
                let l = yield this.cache.getDirectory(this.source, a, c, o), f = $a08b940ba6c63fcd$export$5675963e3644b4b5(l, s);
                if (f) {
                    if (f.runLength > 0) {
                        let y = yield this.source.getBytes(o.tileDataOffset + f.offset, f.length, n, o.etag);
                        return {
                            data: yield this.decompress(y.data, o.tileCompression),
                            cacheControl: y.cacheControl,
                            expires: y.expires
                        };
                    }
                    a = o.leafDirectoryOffset + f.offset, c = f.length;
                } else return;
            }
            throw new Error("Maximum directory depth exceeded");
        });
    }
    getZxy(t, e, r, n) {
        return $a08b940ba6c63fcd$var$m(this, null, function*() {
            try {
                return yield this.getZxyAttempt(t, e, r, n);
            } catch (s) {
                if (s instanceof $a08b940ba6c63fcd$export$6c82150b8b13aae7) return this.cache.invalidate(this.source), yield this.getZxyAttempt(t, e, r, n);
                throw s;
            }
        });
    }
    getMetadataAttempt() {
        return $a08b940ba6c63fcd$var$m(this, null, function*() {
            let t = yield this.cache.getHeader(this.source), e = yield this.source.getBytes(t.jsonMetadataOffset, t.jsonMetadataLength, void 0, t.etag), r = yield this.decompress(e.data, t.internalCompression), n = new TextDecoder("utf-8");
            return JSON.parse(n.decode(r));
        });
    }
    getMetadata() {
        return $a08b940ba6c63fcd$var$m(this, null, function*() {
            try {
                return yield this.getMetadataAttempt();
            } catch (t) {
                if (t instanceof $a08b940ba6c63fcd$export$6c82150b8b13aae7) return this.cache.invalidate(this.source), yield this.getMetadataAttempt();
                throw t;
            }
        });
    }
    getTileJson(t) {
        return $a08b940ba6c63fcd$var$m(this, null, function*() {
            let e = yield this.getHeader(), r = yield this.getMetadata(), n = $a08b940ba6c63fcd$export$157cb7d798fb2ba5(e.tileType);
            return {
                tilejson: "3.0.0",
                scheme: "xyz",
                tiles: [
                    `${t}/{z}/{x}/{y}${n}`
                ],
                vector_layers: r.vector_layers,
                attribution: r.attribution,
                description: r.description,
                name: r.name,
                version: r.version,
                bounds: [
                    e.minLon,
                    e.minLat,
                    e.maxLon,
                    e.maxLat
                ],
                center: [
                    e.centerLon,
                    e.centerLat,
                    e.centerZoom
                ],
                minzoom: e.minZoom,
                maxzoom: e.maxZoom
            };
        });
    }
};
$a08b940ba6c63fcd$var$d($a08b940ba6c63fcd$var$H, "PMTiles");
var $a08b940ba6c63fcd$export$f5df01c0ebe55344 = $a08b940ba6c63fcd$var$H;


class $558f07a06722158f$var$InfoWindow extends HTMLElement {
    constructor(){
        super(), this._data = {};
    //this.render();
    }
    set data(value) {
        this._data = value;
        this.render();
    }
    get data() {
        return this._data;
    }
    render() {
        const { address: address, ownername: ownername, lotArea: lotArea, zolaLink: zolaLink, bbl: bbl, numPermits: numPermits, latestPermitDate: latestPermitDate, numStalledComplaints: numStalledComplaints, vacantSince: vacantSince } = this._data;
        this.innerHTML = `
      <div>
        <h3 style="margin-top: 0">${address || ''}</h3>
        <p>Owner: ${ownername || ''}</p>
        <p>${lotArea || ''} square feet</p>
        ${numPermits > 0 ? `<p>${numPermits} DOB permit${numPermits > 1 ? 's' : ''}${latestPermitDate ? ` (latest: ${latestPermitDate})` : ''}</p>` : ''}
        ${numStalledComplaints > 0 ? `<p>${numStalledComplaints} stalled construction complaint${numStalledComplaints > 1 ? 's' : ''}</p>` : ''}
        ${zolaLink ? `<p><a href="${zolaLink}" target="_blank">ZoLa \u{2934}</a></p>` : ''}
        ${vacantSince ? `<p>vacant since ${vacantSince.getFullYear()}</p>` : ''}
      </div>
    `;
    }
}
customElements.define('info-window', $558f07a06722158f$var$InfoWindow);


async function $bac6ded6121119eb$export$b08464e47b7a3a8() {
    let protocol = new (0, $a08b940ba6c63fcd$export$377bbedb5576dfa8)();
    (0, (/*@__PURE__*/$parcel$interopDefault($0a06c4d6833722ed$exports))).addProtocol("pmtiles", protocol.tile);
    var center = [
        -73.979736,
        40.7565749
    ];
    var zoom = 13;
    const params = new URLSearchParams(window.location.search);
    if (params.size >= 2) {
        center = [
            params.get("lng"),
            params.get("lat")
        ];
        console.log(`setting center to ${center}`);
        zoom = 16;
    }
    const map = new (0, (/*@__PURE__*/$parcel$interopDefault($0a06c4d6833722ed$exports))).Map({
        container: 'map',
        style: 'https://tiles.openfreemap.org/styles/positron',
        center: center,
        zoom: zoom
    });
    map.on('load', async ()=>{
        // Add geolocate control to the map.
        map.addControl(new (0, (/*@__PURE__*/$parcel$interopDefault($0a06c4d6833722ed$exports))).GeolocateControl({
            positionOptions: {
                enableHighAccuracy: true
            },
            trackUserLocation: true
        }));
        const tileBaseUrl = "https://cdn.empty.nyc/main";
        map.addSource('vacant', {
            type: 'vector',
            url: `pmtiles://${tileBaseUrl}/lots.pmtiles`,
            promoteId: 'bbl'
        });
        map.addLayer({
            'id': 'parkinglots',
            'source-layer': 'parking',
            'type': 'fill',
            'source': 'vacant',
            'paint': {
                'fill-color': '#777777'
            }
        });
        map.addLayer({
            'id': 'lotpolygons',
            'type': 'fill',
            'source': 'vacant',
            'source-layer': 'lots',
            'layout': {},
            'paint': {
                'fill-color': [
                    'case',
                    [
                        'boolean',
                        [
                            'feature-state',
                            'selected'
                        ],
                        false
                    ],
                    '#ffff00',
                    '#00ff00'
                ]
            }
        });
        var hovered = [];
        map.on('mousemove', [
            'lotpolygons',
            'parkinglots'
        ], (e)=>{
            map.getCanvas().style.cursor = "pointer";
            if (e.features && e.features.length > 0) {
                map.setFeatureState({
                    source: 'vacant',
                    sourceLayer: 'lots',
                    id: e.features[0].properties.bbl
                }, {
                    hover: true
                });
                e.features[0].id && hovered.push(e.features[0].properties.bbl);
            }
        });
        map.on('mouseleave', [
            'parkinglots',
            'lotpolygons'
        ], (e)=>{
            map.getCanvas().style.cursor = "default";
            while(hovered.length > 0)map.setFeatureState({
                source: 'vacant',
                sourceLayer: 'vacant',
                id: hovered.pop()
            }, {
                hover: false
            });
        });
        map.on('click', [
            'lotpolygons',
            'parkinglots'
        ], (e)=>{
            const { lng: lng, lat: lat } = e.lngLat;
            if (!e.features || e.features.length === 0) return;
            const props = e.features[0].properties;
            map.removeFeatureState({
                source: 'vacant',
                sourceLayer: 'lots'
            });
            map.setFeatureState({
                source: 'vacant',
                sourceLayer: 'lots',
                id: props.bbl
            }, {
                selected: true
            });
            const lotinfowindow = document.createElement("info-window");
            lotinfowindow.data = {
                bbl: props.bbl,
                address: props.address,
                ownername: props.ownername,
                lotArea: Number(props.lotarea).toLocaleString(),
                zolaLink: `https://zola.planning.nyc.gov/l/lot/${props.borocode}/${props.block}/${props.lot}`,
                numPermits: Number(props.num_permits) || 0,
                latestPermitDate: props.latest_permit_date,
                numStalledComplaints: Number(props.num_stalled_complaints) || 0,
                vacantSince: props.vacant_since ? new Date(`${props.vacant_since}T00:00:00`) : null
            };
            map.easeTo({
                center: [
                    lng,
                    lat
                ]
            });
            const url = new URL(window.location);
            url.searchParams.set("lat", lat);
            url.searchParams.set("lng", lng);
            history.pushState({}, "", url);
            new (0, (/*@__PURE__*/$parcel$interopDefault($0a06c4d6833722ed$exports))).Popup({
                offset: {
                    'bottom': [
                        0,
                        -5
                    ]
                }
            }).setLngLat([
                lng,
                lat
            ]).setDOMContent(lotinfowindow).addTo(map);
        });
    });
    return map;
}


function $b4e14b6b8da86996$var$markerClickHandler(e) {
    if (!e.features || e.features.length == 0) return;
    e.features[0] && (0, $cade000a6c8a1b2e$export$c8e0d6368aa03249)([
        e.features[0].properties.longitude,
        e.features[0].properties.latitude
    ]);
}
async function $b4e14b6b8da86996$var$init() {
    const libremap = (0, $bac6ded6121119eb$export$b08464e47b7a3a8)();
    libremap.then((m)=>{
        m.on('load', ()=>{
            const params = new URLSearchParams(window.location.search);
            if (params.size >= 2) (0, $cade000a6c8a1b2e$export$c8e0d6368aa03249)([
                params.get("lng"),
                params.get("lat")
            ]);
        });
        m.on('click', [
            'parkinglots',
            'lotpolygons'
        ], $b4e14b6b8da86996$var$markerClickHandler);
    });
    await google.maps.importLibrary("streetView");
    (0, $cade000a6c8a1b2e$export$6ff3b2c795cc1f8f)();
}
$b4e14b6b8da86996$var$init();


//# sourceMappingURL=emptylots.f4621354.js.map
